var C_ = Object.defineProperty;
var x_ = (e, t, n) => t in e ? C_(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Ge = (e, t, n) => x_(e, typeof t != "symbol" ? t + "" : t, n);
import * as y from "react";
import Nt, { forwardRef as vs, useContext as p0, Children as y_, isValidElement as id, cloneElement as sd, useState as Ae, createContext as h0, useRef as St, useEffect as mt, useCallback as pr, Fragment as ws, createElement as Yl, useMemo as tn, Suspense as v_, memo as t4, useReducer as w_, useDebugValue as Ty, useLayoutEffect as S_ } from "react";
import * as M_ from "react-dom";
import B2, { createPortal as T_, flushSync as k_ } from "react-dom";
var J0 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ky(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Vi(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function o() {
      return this instanceof o ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(o) {
    var r = Object.getOwnPropertyDescriptor(e, o);
    Object.defineProperty(n, o, r.get ? r : {
      enumerable: !0,
      get: function() {
        return e[o];
      }
    });
  }), n;
}
var wp = { exports: {} }, y2 = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Q8;
function E_() {
  if (Q8) return y2;
  Q8 = 1;
  var e = Nt, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(a, c, d) {
    var u, p = {}, h = null, g = null;
    d !== void 0 && (h = "" + d), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (g = c.ref);
    for (u in c) o.call(c, u) && !i.hasOwnProperty(u) && (p[u] = c[u]);
    if (a && a.defaultProps) for (u in c = a.defaultProps, c) p[u] === void 0 && (p[u] = c[u]);
    return { $$typeof: t, type: a, key: h, ref: g, props: p, _owner: r.current };
  }
  return y2.Fragment = n, y2.jsx = s, y2.jsxs = s, y2;
}
var v2 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e9;
function R_() {
  return e9 || (e9 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Nt, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), a = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), m = Symbol.iterator, b = "@@iterator";
    function C(Y) {
      if (Y === null || typeof Y != "object")
        return null;
      var ke = m && Y[m] || Y[b];
      return typeof ke == "function" ? ke : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(Y) {
      {
        for (var ke = arguments.length, He = new Array(ke > 1 ? ke - 1 : 0), st = 1; st < ke; st++)
          He[st - 1] = arguments[st];
        S("error", Y, He);
      }
    }
    function S(Y, ke, He) {
      {
        var st = x.ReactDebugCurrentFrame, ce = st.getStackAddendum();
        ce !== "" && (ke += "%s", He = He.concat([ce]));
        var ee = He.map(function(we) {
          return String(we);
        });
        ee.unshift("Warning: " + ke), Function.prototype.apply.call(console[Y], console, ee);
      }
    }
    var M = !1, w = !1, k = !1, E = !1, R = !1, O;
    O = Symbol.for("react.module.reference");
    function P(Y) {
      return !!(typeof Y == "string" || typeof Y == "function" || Y === o || Y === i || R || Y === r || Y === d || Y === u || E || Y === g || M || w || k || typeof Y == "object" && Y !== null && (Y.$$typeof === h || Y.$$typeof === p || Y.$$typeof === s || Y.$$typeof === a || Y.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Y.$$typeof === O || Y.getModuleId !== void 0));
    }
    function _(Y, ke, He) {
      var st = Y.displayName;
      if (st)
        return st;
      var ce = ke.displayName || ke.name || "";
      return ce !== "" ? He + "(" + ce + ")" : He;
    }
    function L(Y) {
      return Y.displayName || "Context";
    }
    function V(Y) {
      if (Y == null)
        return null;
      if (typeof Y.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Y == "function")
        return Y.displayName || Y.name || null;
      if (typeof Y == "string")
        return Y;
      switch (Y) {
        case o:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case r:
          return "StrictMode";
        case d:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof Y == "object")
        switch (Y.$$typeof) {
          case a:
            var ke = Y;
            return L(ke) + ".Consumer";
          case s:
            var He = Y;
            return L(He._context) + ".Provider";
          case c:
            return _(Y, Y.render, "ForwardRef");
          case p:
            var st = Y.displayName || null;
            return st !== null ? st : V(Y.type) || "Memo";
          case h: {
            var ce = Y, ee = ce._payload, we = ce._init;
            try {
              return V(we(ee));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var j = Object.assign, I = 0, F, $, A, H, N, z, se;
    function ne() {
    }
    ne.__reactDisabledLog = !0;
    function Z() {
      {
        if (I === 0) {
          F = console.log, $ = console.info, A = console.warn, H = console.error, N = console.group, z = console.groupCollapsed, se = console.groupEnd;
          var Y = {
            configurable: !0,
            enumerable: !0,
            value: ne,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Y,
            log: Y,
            warn: Y,
            error: Y,
            group: Y,
            groupCollapsed: Y,
            groupEnd: Y
          });
        }
        I++;
      }
    }
    function q() {
      {
        if (I--, I === 0) {
          var Y = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: j({}, Y, {
              value: F
            }),
            info: j({}, Y, {
              value: $
            }),
            warn: j({}, Y, {
              value: A
            }),
            error: j({}, Y, {
              value: H
            }),
            group: j({}, Y, {
              value: N
            }),
            groupCollapsed: j({}, Y, {
              value: z
            }),
            groupEnd: j({}, Y, {
              value: se
            })
          });
        }
        I < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var G = x.ReactCurrentDispatcher, K;
    function Q(Y, ke, He) {
      {
        if (K === void 0)
          try {
            throw Error();
          } catch (ce) {
            var st = ce.stack.trim().match(/\n( *(at )?)/);
            K = st && st[1] || "";
          }
        return `
` + K + Y;
      }
    }
    var re = !1, U;
    {
      var W = typeof WeakMap == "function" ? WeakMap : Map;
      U = new W();
    }
    function D(Y, ke) {
      if (!Y || re)
        return "";
      {
        var He = U.get(Y);
        if (He !== void 0)
          return He;
      }
      var st;
      re = !0;
      var ce = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ee;
      ee = G.current, G.current = null, Z();
      try {
        if (ke) {
          var we = function() {
            throw Error();
          };
          if (Object.defineProperty(we.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(we, []);
            } catch (ko) {
              st = ko;
            }
            Reflect.construct(Y, [], we);
          } else {
            try {
              we.call();
            } catch (ko) {
              st = ko;
            }
            Y.call(we.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ko) {
            st = ko;
          }
          Y();
        }
      } catch (ko) {
        if (ko && st && typeof ko.stack == "string") {
          for (var De = ko.stack.split(`
`), nt = st.stack.split(`
`), ze = De.length - 1, lt = nt.length - 1; ze >= 1 && lt >= 0 && De[ze] !== nt[lt]; )
            lt--;
          for (; ze >= 1 && lt >= 0; ze--, lt--)
            if (De[ze] !== nt[lt]) {
              if (ze !== 1 || lt !== 1)
                do
                  if (ze--, lt--, lt < 0 || De[ze] !== nt[lt]) {
                    var cn = `
` + De[ze].replace(" at new ", " at ");
                    return Y.displayName && cn.includes("<anonymous>") && (cn = cn.replace("<anonymous>", Y.displayName)), typeof Y == "function" && U.set(Y, cn), cn;
                  }
                while (ze >= 1 && lt >= 0);
              break;
            }
        }
      } finally {
        re = !1, G.current = ee, q(), Error.prepareStackTrace = ce;
      }
      var kr = Y ? Y.displayName || Y.name : "", js = kr ? Q(kr) : "";
      return typeof Y == "function" && U.set(Y, js), js;
    }
    function X(Y, ke, He) {
      return D(Y, !1);
    }
    function de(Y) {
      var ke = Y.prototype;
      return !!(ke && ke.isReactComponent);
    }
    function ue(Y, ke, He) {
      if (Y == null)
        return "";
      if (typeof Y == "function")
        return D(Y, de(Y));
      if (typeof Y == "string")
        return Q(Y);
      switch (Y) {
        case d:
          return Q("Suspense");
        case u:
          return Q("SuspenseList");
      }
      if (typeof Y == "object")
        switch (Y.$$typeof) {
          case c:
            return X(Y.render);
          case p:
            return ue(Y.type, ke, He);
          case h: {
            var st = Y, ce = st._payload, ee = st._init;
            try {
              return ue(ee(ce), ke, He);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ue = {}, me = x.ReactDebugCurrentFrame;
    function Ie(Y) {
      if (Y) {
        var ke = Y._owner, He = ue(Y.type, Y._source, ke ? ke.type : null);
        me.setExtraStackFrame(He);
      } else
        me.setExtraStackFrame(null);
    }
    function te(Y, ke, He, st, ce) {
      {
        var ee = Function.call.bind(he);
        for (var we in Y)
          if (ee(Y, we)) {
            var De = void 0;
            try {
              if (typeof Y[we] != "function") {
                var nt = Error((st || "React class") + ": " + He + " type `" + we + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Y[we] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw nt.name = "Invariant Violation", nt;
              }
              De = Y[we](ke, we, st, He, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ze) {
              De = ze;
            }
            De && !(De instanceof Error) && (Ie(ce), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", st || "React class", He, we, typeof De), Ie(null)), De instanceof Error && !(De.message in Ue) && (Ue[De.message] = !0, Ie(ce), v("Failed %s type: %s", He, De.message), Ie(null));
          }
      }
    }
    var ie = Array.isArray;
    function ye(Y) {
      return ie(Y);
    }
    function Ne(Y) {
      {
        var ke = typeof Symbol == "function" && Symbol.toStringTag, He = ke && Y[Symbol.toStringTag] || Y.constructor.name || "Object";
        return He;
      }
    }
    function We(Y) {
      try {
        return qe(Y), !1;
      } catch {
        return !0;
      }
    }
    function qe(Y) {
      return "" + Y;
    }
    function Me(Y) {
      if (We(Y))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ne(Y)), qe(Y);
    }
    var Pe = x.ReactCurrentOwner, fe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ae, Te;
    function tt(Y) {
      if (he.call(Y, "ref")) {
        var ke = Object.getOwnPropertyDescriptor(Y, "ref").get;
        if (ke && ke.isReactWarning)
          return !1;
      }
      return Y.ref !== void 0;
    }
    function Ye(Y) {
      if (he.call(Y, "key")) {
        var ke = Object.getOwnPropertyDescriptor(Y, "key").get;
        if (ke && ke.isReactWarning)
          return !1;
      }
      return Y.key !== void 0;
    }
    function Le(Y, ke) {
      typeof Y.ref == "string" && Pe.current;
    }
    function Ve(Y, ke) {
      {
        var He = function() {
          ae || (ae = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ke));
        };
        He.isReactWarning = !0, Object.defineProperty(Y, "key", {
          get: He,
          configurable: !0
        });
      }
    }
    function Ce(Y, ke) {
      {
        var He = function() {
          Te || (Te = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ke));
        };
        He.isReactWarning = !0, Object.defineProperty(Y, "ref", {
          get: He,
          configurable: !0
        });
      }
    }
    var Se = function(Y, ke, He, st, ce, ee, we) {
      var De = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: Y,
        key: ke,
        ref: He,
        props: we,
        // Record the component responsible for creating this element.
        _owner: ee
      };
      return De._store = {}, Object.defineProperty(De._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(De, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: st
      }), Object.defineProperty(De, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ce
      }), Object.freeze && (Object.freeze(De.props), Object.freeze(De)), De;
    };
    function ve(Y, ke, He, st, ce) {
      {
        var ee, we = {}, De = null, nt = null;
        He !== void 0 && (Me(He), De = "" + He), Ye(ke) && (Me(ke.key), De = "" + ke.key), tt(ke) && (nt = ke.ref, Le(ke, ce));
        for (ee in ke)
          he.call(ke, ee) && !fe.hasOwnProperty(ee) && (we[ee] = ke[ee]);
        if (Y && Y.defaultProps) {
          var ze = Y.defaultProps;
          for (ee in ze)
            we[ee] === void 0 && (we[ee] = ze[ee]);
        }
        if (De || nt) {
          var lt = typeof Y == "function" ? Y.displayName || Y.name || "Unknown" : Y;
          De && Ve(we, lt), nt && Ce(we, lt);
        }
        return Se(Y, De, nt, ce, st, Pe.current, we);
      }
    }
    var Be = x.ReactCurrentOwner, rt = x.ReactDebugCurrentFrame;
    function pt(Y) {
      if (Y) {
        var ke = Y._owner, He = ue(Y.type, Y._source, ke ? ke.type : null);
        rt.setExtraStackFrame(He);
      } else
        rt.setExtraStackFrame(null);
    }
    var Je;
    Je = !1;
    function At(Y) {
      return typeof Y == "object" && Y !== null && Y.$$typeof === t;
    }
    function Ht() {
      {
        if (Be.current) {
          var Y = V(Be.current.type);
          if (Y)
            return `

Check the render method of \`` + Y + "`.";
        }
        return "";
      }
    }
    function Ct(Y) {
      return "";
    }
    var qt = {};
    function Bn(Y) {
      {
        var ke = Ht();
        if (!ke) {
          var He = typeof Y == "string" ? Y : Y.displayName || Y.name;
          He && (ke = `

Check the top-level render call using <` + He + ">.");
        }
        return ke;
      }
    }
    function xn(Y, ke) {
      {
        if (!Y._store || Y._store.validated || Y.key != null)
          return;
        Y._store.validated = !0;
        var He = Bn(ke);
        if (qt[He])
          return;
        qt[He] = !0;
        var st = "";
        Y && Y._owner && Y._owner !== Be.current && (st = " It was passed a child from " + V(Y._owner.type) + "."), pt(Y), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', He, st), pt(null);
      }
    }
    function $o(Y, ke) {
      {
        if (typeof Y != "object")
          return;
        if (ye(Y))
          for (var He = 0; He < Y.length; He++) {
            var st = Y[He];
            At(st) && xn(st, ke);
          }
        else if (At(Y))
          Y._store && (Y._store.validated = !0);
        else if (Y) {
          var ce = C(Y);
          if (typeof ce == "function" && ce !== Y.entries)
            for (var ee = ce.call(Y), we; !(we = ee.next()).done; )
              At(we.value) && xn(we.value, ke);
        }
      }
    }
    function zn(Y) {
      {
        var ke = Y.type;
        if (ke == null || typeof ke == "string")
          return;
        var He;
        if (typeof ke == "function")
          He = ke.propTypes;
        else if (typeof ke == "object" && (ke.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ke.$$typeof === p))
          He = ke.propTypes;
        else
          return;
        if (He) {
          var st = V(ke);
          te(He, Y.props, "prop", st, Y);
        } else if (ke.PropTypes !== void 0 && !Je) {
          Je = !0;
          var ce = V(ke);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ce || "Unknown");
        }
        typeof ke.getDefaultProps == "function" && !ke.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function bn(Y) {
      {
        for (var ke = Object.keys(Y.props), He = 0; He < ke.length; He++) {
          var st = ke[He];
          if (st !== "children" && st !== "key") {
            pt(Y), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", st), pt(null);
            break;
          }
        }
        Y.ref !== null && (pt(Y), v("Invalid attribute `ref` supplied to `React.Fragment`."), pt(null));
      }
    }
    var Zt = {};
    function vn(Y, ke, He, st, ce, ee) {
      {
        var we = P(Y);
        if (!we) {
          var De = "";
          (Y === void 0 || typeof Y == "object" && Y !== null && Object.keys(Y).length === 0) && (De += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var nt = Ct();
          nt ? De += nt : De += Ht();
          var ze;
          Y === null ? ze = "null" : ye(Y) ? ze = "array" : Y !== void 0 && Y.$$typeof === t ? (ze = "<" + (V(Y.type) || "Unknown") + " />", De = " Did you accidentally export a JSX literal instead of a component?") : ze = typeof Y, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ze, De);
        }
        var lt = ve(Y, ke, He, ce, ee);
        if (lt == null)
          return lt;
        if (we) {
          var cn = ke.children;
          if (cn !== void 0)
            if (st)
              if (ye(cn)) {
                for (var kr = 0; kr < cn.length; kr++)
                  $o(cn[kr], Y);
                Object.freeze && Object.freeze(cn);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              $o(cn, Y);
        }
        if (he.call(ke, "key")) {
          var js = V(Y), ko = Object.keys(ke).filter(function(b_) {
            return b_ !== "key";
          }), Ef = ko.length > 0 ? "{key: someKey, " + ko.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Zt[js + Ef]) {
            var m_ = ko.length > 0 ? "{" + ko.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ef, js, m_, js), Zt[js + Ef] = !0;
          }
        }
        return Y === o ? bn(lt) : zn(lt), lt;
      }
    }
    function Qe(Y, ke, He) {
      return vn(Y, ke, He, !0);
    }
    function oo(Y, ke, He) {
      return vn(Y, ke, He, !1);
    }
    var Kt = oo, Wt = Qe;
    v2.Fragment = o, v2.jsx = Kt, v2.jsxs = Wt;
  }()), v2;
}
process.env.NODE_ENV === "production" ? wp.exports = E_() : wp.exports = R_();
var f = wp.exports;
const Oc = {
  black: "#000",
  white: "#fff"
}, za = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, Za = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, Wa = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, Ua = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, Ga = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, w2 = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, O_ = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
function Pi(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let n = 1; n < arguments.length; n += 1)
    t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
const __ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Pi
}, Symbol.toStringTag, { value: "Module" })), ma = "$$material";
function T() {
  return T = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n) ({}).hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, T.apply(null, arguments);
}
function le(e, t) {
  if (e == null) return {};
  var n = {};
  for (var o in e) if ({}.hasOwnProperty.call(e, o)) {
    if (t.includes(o)) continue;
    n[o] = e[o];
  }
  return n;
}
function P_(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function L_(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var I_ = /* @__PURE__ */ function() {
  function e(n) {
    var o = this;
    this._insertTag = function(r) {
      var i;
      o.tags.length === 0 ? o.insertionPoint ? i = o.insertionPoint.nextSibling : o.prepend ? i = o.container.firstChild : i = o.before : i = o.tags[o.tags.length - 1].nextSibling, o.container.insertBefore(r, i), o.tags.push(r);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(o) {
    o.forEach(this._insertTag);
  }, t.insert = function(o) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(L_(this));
    var r = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = P_(r);
      try {
        i.insertRule(o, i.cssRules.length);
      } catch {
      }
    } else
      r.appendChild(document.createTextNode(o));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(o) {
      var r;
      return (r = o.parentNode) == null ? void 0 : r.removeChild(o);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), io = "-ms-", Hd = "-moz-", Ut = "-webkit-", Ey = "comm", n4 = "rule", o4 = "decl", j_ = "@import", Ry = "@keyframes", V_ = "@layer", D_ = Math.abs, t3 = String.fromCharCode, A_ = Object.assign;
function H_(e, t) {
  return Jn(e, 0) ^ 45 ? (((t << 2 ^ Jn(e, 0)) << 2 ^ Jn(e, 1)) << 2 ^ Jn(e, 2)) << 2 ^ Jn(e, 3) : 0;
}
function Oy(e) {
  return e.trim();
}
function F_(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function Gt(e, t, n) {
  return e.replace(t, n);
}
function Sp(e, t) {
  return e.indexOf(t);
}
function Jn(e, t) {
  return e.charCodeAt(t) | 0;
}
function _c(e, t, n) {
  return e.slice(t, n);
}
function Gr(e) {
  return e.length;
}
function r4(e) {
  return e.length;
}
function Q0(e, t) {
  return t.push(e), e;
}
function N_(e, t) {
  return e.map(t).join("");
}
var n3 = 1, _l = 1, _y = 0, Ho = 0, Vn = 0, Xl = "";
function o3(e, t, n, o, r, i, s) {
  return { value: e, root: t, parent: n, type: o, props: r, children: i, line: n3, column: _l, length: s, return: "" };
}
function S2(e, t) {
  return A_(o3("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function $_() {
  return Vn;
}
function B_() {
  return Vn = Ho > 0 ? Jn(Xl, --Ho) : 0, _l--, Vn === 10 && (_l = 1, n3--), Vn;
}
function Xo() {
  return Vn = Ho < _y ? Jn(Xl, Ho++) : 0, _l++, Vn === 10 && (_l = 1, n3++), Vn;
}
function Jr() {
  return Jn(Xl, Ho);
}
function ad() {
  return Ho;
}
function g0(e, t) {
  return _c(Xl, e, t);
}
function Pc(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Py(e) {
  return n3 = _l = 1, _y = Gr(Xl = e), Ho = 0, [];
}
function Ly(e) {
  return Xl = "", e;
}
function ld(e) {
  return Oy(g0(Ho - 1, Mp(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function z_(e) {
  for (; (Vn = Jr()) && Vn < 33; )
    Xo();
  return Pc(e) > 2 || Pc(Vn) > 3 ? "" : " ";
}
function Z_(e, t) {
  for (; --t && Xo() && !(Vn < 48 || Vn > 102 || Vn > 57 && Vn < 65 || Vn > 70 && Vn < 97); )
    ;
  return g0(e, ad() + (t < 6 && Jr() == 32 && Xo() == 32));
}
function Mp(e) {
  for (; Xo(); )
    switch (Vn) {
      case e:
        return Ho;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Mp(Vn);
        break;
      case 40:
        e === 41 && Mp(e);
        break;
      case 92:
        Xo();
        break;
    }
  return Ho;
}
function W_(e, t) {
  for (; Xo() && e + Vn !== 57; )
    if (e + Vn === 84 && Jr() === 47)
      break;
  return "/*" + g0(t, Ho - 1) + "*" + t3(e === 47 ? e : Xo());
}
function U_(e) {
  for (; !Pc(Jr()); )
    Xo();
  return g0(e, Ho);
}
function G_(e) {
  return Ly(cd("", null, null, null, [""], e = Py(e), 0, [0], e));
}
function cd(e, t, n, o, r, i, s, a, c) {
  for (var d = 0, u = 0, p = s, h = 0, g = 0, m = 0, b = 1, C = 1, x = 1, v = 0, S = "", M = r, w = i, k = o, E = S; C; )
    switch (m = v, v = Xo()) {
      case 40:
        if (m != 108 && Jn(E, p - 1) == 58) {
          Sp(E += Gt(ld(v), "&", "&\f"), "&\f") != -1 && (x = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        E += ld(v);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        E += z_(m);
        break;
      case 92:
        E += Z_(ad() - 1, 7);
        continue;
      case 47:
        switch (Jr()) {
          case 42:
          case 47:
            Q0(q_(W_(Xo(), ad()), t, n), c);
            break;
          default:
            E += "/";
        }
        break;
      case 123 * b:
        a[d++] = Gr(E) * x;
      case 125 * b:
      case 59:
      case 0:
        switch (v) {
          case 0:
          case 125:
            C = 0;
          case 59 + u:
            x == -1 && (E = Gt(E, /\f/g, "")), g > 0 && Gr(E) - p && Q0(g > 32 ? n9(E + ";", o, n, p - 1) : n9(Gt(E, " ", "") + ";", o, n, p - 2), c);
            break;
          case 59:
            E += ";";
          default:
            if (Q0(k = t9(E, t, n, d, u, r, a, S, M = [], w = [], p), i), v === 123)
              if (u === 0)
                cd(E, t, k, k, M, i, p, a, w);
              else
                switch (h === 99 && Jn(E, 3) === 110 ? 100 : h) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    cd(e, k, k, o && Q0(t9(e, k, k, 0, 0, r, a, S, r, M = [], p), w), r, w, p, a, o ? M : w);
                    break;
                  default:
                    cd(E, k, k, k, [""], w, 0, a, w);
                }
        }
        d = u = g = 0, b = x = 1, S = E = "", p = s;
        break;
      case 58:
        p = 1 + Gr(E), g = m;
      default:
        if (b < 1) {
          if (v == 123)
            --b;
          else if (v == 125 && b++ == 0 && B_() == 125)
            continue;
        }
        switch (E += t3(v), v * b) {
          case 38:
            x = u > 0 ? 1 : (E += "\f", -1);
            break;
          case 44:
            a[d++] = (Gr(E) - 1) * x, x = 1;
            break;
          case 64:
            Jr() === 45 && (E += ld(Xo())), h = Jr(), u = p = Gr(S = E += U_(ad())), v++;
            break;
          case 45:
            m === 45 && Gr(E) == 2 && (b = 0);
        }
    }
  return i;
}
function t9(e, t, n, o, r, i, s, a, c, d, u) {
  for (var p = r - 1, h = r === 0 ? i : [""], g = r4(h), m = 0, b = 0, C = 0; m < o; ++m)
    for (var x = 0, v = _c(e, p + 1, p = D_(b = s[m])), S = e; x < g; ++x)
      (S = Oy(b > 0 ? h[x] + " " + v : Gt(v, /&\f/g, h[x]))) && (c[C++] = S);
  return o3(e, t, n, r === 0 ? n4 : a, c, d, u);
}
function q_(e, t, n) {
  return o3(e, t, n, Ey, t3($_()), _c(e, 2, -2), 0);
}
function n9(e, t, n, o) {
  return o3(e, t, n, o4, _c(e, 0, o), _c(e, o + 1, -1), o);
}
function ml(e, t) {
  for (var n = "", o = r4(e), r = 0; r < o; r++)
    n += t(e[r], r, e, t) || "";
  return n;
}
function K_(e, t, n, o) {
  switch (e.type) {
    case V_:
      if (e.children.length) break;
    case j_:
    case o4:
      return e.return = e.return || e.value;
    case Ey:
      return "";
    case Ry:
      return e.return = e.value + "{" + ml(e.children, o) + "}";
    case n4:
      e.value = e.props.join(",");
  }
  return Gr(n = ml(e.children, o)) ? e.return = e.value + "{" + n + "}" : "";
}
function Y_(e) {
  var t = r4(e);
  return function(n, o, r, i) {
    for (var s = "", a = 0; a < t; a++)
      s += e[a](n, o, r, i) || "";
    return s;
  };
}
function X_(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function Iy(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var J_ = function(t, n, o) {
  for (var r = 0, i = 0; r = i, i = Jr(), r === 38 && i === 12 && (n[o] = 1), !Pc(i); )
    Xo();
  return g0(t, Ho);
}, Q_ = function(t, n) {
  var o = -1, r = 44;
  do
    switch (Pc(r)) {
      case 0:
        r === 38 && Jr() === 12 && (n[o] = 1), t[o] += J_(Ho - 1, n, o);
        break;
      case 2:
        t[o] += ld(r);
        break;
      case 4:
        if (r === 44) {
          t[++o] = Jr() === 58 ? "&\f" : "", n[o] = t[o].length;
          break;
        }
      default:
        t[o] += t3(r);
    }
  while (r = Xo());
  return t;
}, eP = function(t, n) {
  return Ly(Q_(Py(t), n));
}, o9 = /* @__PURE__ */ new WeakMap(), tP = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, o = t.parent, r = t.column === o.column && t.line === o.line; o.type !== "rule"; )
      if (o = o.parent, !o) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !o9.get(o)) && !r) {
      o9.set(t, !0);
      for (var i = [], s = eP(n, i), a = o.props, c = 0, d = 0; c < s.length; c++)
        for (var u = 0; u < a.length; u++, d++)
          t.props[d] = i[c] ? s[c].replace(/&\f/g, a[u]) : a[u] + " " + s[c];
    }
  }
}, nP = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function jy(e, t) {
  switch (H_(e, t)) {
    case 5103:
      return Ut + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Ut + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Ut + e + Hd + e + io + e + e;
    case 6828:
    case 4268:
      return Ut + e + io + e + e;
    case 6165:
      return Ut + e + io + "flex-" + e + e;
    case 5187:
      return Ut + e + Gt(e, /(\w+).+(:[^]+)/, Ut + "box-$1$2" + io + "flex-$1$2") + e;
    case 5443:
      return Ut + e + io + "flex-item-" + Gt(e, /flex-|-self/, "") + e;
    case 4675:
      return Ut + e + io + "flex-line-pack" + Gt(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return Ut + e + io + Gt(e, "shrink", "negative") + e;
    case 5292:
      return Ut + e + io + Gt(e, "basis", "preferred-size") + e;
    case 6060:
      return Ut + "box-" + Gt(e, "-grow", "") + Ut + e + io + Gt(e, "grow", "positive") + e;
    case 4554:
      return Ut + Gt(e, /([^-])(transform)/g, "$1" + Ut + "$2") + e;
    case 6187:
      return Gt(Gt(Gt(e, /(zoom-|grab)/, Ut + "$1"), /(image-set)/, Ut + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Gt(e, /(image-set\([^]*)/, Ut + "$1$`$1");
    case 4968:
      return Gt(Gt(e, /(.+:)(flex-)?(.*)/, Ut + "box-pack:$3" + io + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Ut + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Gt(e, /(.+)-inline(.+)/, Ut + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Gr(e) - 1 - t > 6) switch (Jn(e, t + 1)) {
        case 109:
          if (Jn(e, t + 4) !== 45) break;
        case 102:
          return Gt(e, /(.+:)(.+)-([^]+)/, "$1" + Ut + "$2-$3$1" + Hd + (Jn(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~Sp(e, "stretch") ? jy(Gt(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (Jn(e, t + 1) !== 115) break;
    case 6444:
      switch (Jn(e, Gr(e) - 3 - (~Sp(e, "!important") && 10))) {
        case 107:
          return Gt(e, ":", ":" + Ut) + e;
        case 101:
          return Gt(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Ut + (Jn(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Ut + "$2$3$1" + io + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Jn(e, t + 11)) {
        case 114:
          return Ut + e + io + Gt(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return Ut + e + io + Gt(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return Ut + e + io + Gt(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Ut + e + io + e + e;
  }
  return e;
}
var oP = function(t, n, o, r) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case o4:
      t.return = jy(t.value, t.length);
      break;
    case Ry:
      return ml([S2(t, {
        value: Gt(t.value, "@", "@" + Ut)
      })], r);
    case n4:
      if (t.length) return N_(t.props, function(i) {
        switch (F_(i, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return ml([S2(t, {
              props: [Gt(i, /:(read-\w+)/, ":" + Hd + "$1")]
            })], r);
          case "::placeholder":
            return ml([S2(t, {
              props: [Gt(i, /:(plac\w+)/, ":" + Ut + "input-$1")]
            }), S2(t, {
              props: [Gt(i, /:(plac\w+)/, ":" + Hd + "$1")]
            }), S2(t, {
              props: [Gt(i, /:(plac\w+)/, io + "input-$1")]
            })], r);
        }
        return "";
      });
  }
}, rP = [oP], Vy = function(t) {
  var n = t.key;
  if (n === "css") {
    var o = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(o, function(b) {
      var C = b.getAttribute("data-emotion");
      C.indexOf(" ") !== -1 && (document.head.appendChild(b), b.setAttribute("data-s", ""));
    });
  }
  var r = t.stylisPlugins || rP, i = {}, s, a = [];
  s = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(b) {
      for (var C = b.getAttribute("data-emotion").split(" "), x = 1; x < C.length; x++)
        i[C[x]] = !0;
      a.push(b);
    }
  );
  var c, d = [tP, nP];
  {
    var u, p = [K_, X_(function(b) {
      u.insert(b);
    })], h = Y_(d.concat(r, p)), g = function(C) {
      return ml(G_(C), h);
    };
    c = function(C, x, v, S) {
      u = v, g(C ? C + "{" + x.styles + "}" : x.styles), S && (m.inserted[x.name] = !0);
    };
  }
  var m = {
    key: n,
    sheet: new I_({
      key: n,
      container: s,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: i,
    registered: {},
    insert: c
  };
  return m.sheet.hydrate(a), m;
}, Tp = { exports: {} }, Yt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var r9;
function iP() {
  if (r9) return Yt;
  r9 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, C = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
  function S(w) {
    if (typeof w == "object" && w !== null) {
      var k = w.$$typeof;
      switch (k) {
        case t:
          switch (w = w.type, w) {
            case c:
            case d:
            case o:
            case i:
            case r:
            case p:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case a:
                case u:
                case m:
                case g:
                case s:
                  return w;
                default:
                  return k;
              }
          }
        case n:
          return k;
      }
    }
  }
  function M(w) {
    return S(w) === d;
  }
  return Yt.AsyncMode = c, Yt.ConcurrentMode = d, Yt.ContextConsumer = a, Yt.ContextProvider = s, Yt.Element = t, Yt.ForwardRef = u, Yt.Fragment = o, Yt.Lazy = m, Yt.Memo = g, Yt.Portal = n, Yt.Profiler = i, Yt.StrictMode = r, Yt.Suspense = p, Yt.isAsyncMode = function(w) {
    return M(w) || S(w) === c;
  }, Yt.isConcurrentMode = M, Yt.isContextConsumer = function(w) {
    return S(w) === a;
  }, Yt.isContextProvider = function(w) {
    return S(w) === s;
  }, Yt.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === t;
  }, Yt.isForwardRef = function(w) {
    return S(w) === u;
  }, Yt.isFragment = function(w) {
    return S(w) === o;
  }, Yt.isLazy = function(w) {
    return S(w) === m;
  }, Yt.isMemo = function(w) {
    return S(w) === g;
  }, Yt.isPortal = function(w) {
    return S(w) === n;
  }, Yt.isProfiler = function(w) {
    return S(w) === i;
  }, Yt.isStrictMode = function(w) {
    return S(w) === r;
  }, Yt.isSuspense = function(w) {
    return S(w) === p;
  }, Yt.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === o || w === d || w === i || w === r || w === p || w === h || typeof w == "object" && w !== null && (w.$$typeof === m || w.$$typeof === g || w.$$typeof === s || w.$$typeof === a || w.$$typeof === u || w.$$typeof === C || w.$$typeof === x || w.$$typeof === v || w.$$typeof === b);
  }, Yt.typeOf = S, Yt;
}
var Xt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var i9;
function sP() {
  return i9 || (i9 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, C = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
    function S(D) {
      return typeof D == "string" || typeof D == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      D === o || D === d || D === i || D === r || D === p || D === h || typeof D == "object" && D !== null && (D.$$typeof === m || D.$$typeof === g || D.$$typeof === s || D.$$typeof === a || D.$$typeof === u || D.$$typeof === C || D.$$typeof === x || D.$$typeof === v || D.$$typeof === b);
    }
    function M(D) {
      if (typeof D == "object" && D !== null) {
        var X = D.$$typeof;
        switch (X) {
          case t:
            var de = D.type;
            switch (de) {
              case c:
              case d:
              case o:
              case i:
              case r:
              case p:
                return de;
              default:
                var ue = de && de.$$typeof;
                switch (ue) {
                  case a:
                  case u:
                  case m:
                  case g:
                  case s:
                    return ue;
                  default:
                    return X;
                }
            }
          case n:
            return X;
        }
      }
    }
    var w = c, k = d, E = a, R = s, O = t, P = u, _ = o, L = m, V = g, j = n, I = i, F = r, $ = p, A = !1;
    function H(D) {
      return A || (A = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), N(D) || M(D) === c;
    }
    function N(D) {
      return M(D) === d;
    }
    function z(D) {
      return M(D) === a;
    }
    function se(D) {
      return M(D) === s;
    }
    function ne(D) {
      return typeof D == "object" && D !== null && D.$$typeof === t;
    }
    function Z(D) {
      return M(D) === u;
    }
    function q(D) {
      return M(D) === o;
    }
    function G(D) {
      return M(D) === m;
    }
    function K(D) {
      return M(D) === g;
    }
    function Q(D) {
      return M(D) === n;
    }
    function re(D) {
      return M(D) === i;
    }
    function U(D) {
      return M(D) === r;
    }
    function W(D) {
      return M(D) === p;
    }
    Xt.AsyncMode = w, Xt.ConcurrentMode = k, Xt.ContextConsumer = E, Xt.ContextProvider = R, Xt.Element = O, Xt.ForwardRef = P, Xt.Fragment = _, Xt.Lazy = L, Xt.Memo = V, Xt.Portal = j, Xt.Profiler = I, Xt.StrictMode = F, Xt.Suspense = $, Xt.isAsyncMode = H, Xt.isConcurrentMode = N, Xt.isContextConsumer = z, Xt.isContextProvider = se, Xt.isElement = ne, Xt.isForwardRef = Z, Xt.isFragment = q, Xt.isLazy = G, Xt.isMemo = K, Xt.isPortal = Q, Xt.isProfiler = re, Xt.isStrictMode = U, Xt.isSuspense = W, Xt.isValidElementType = S, Xt.typeOf = M;
  }()), Xt;
}
process.env.NODE_ENV === "production" ? Tp.exports = iP() : Tp.exports = sP();
var aP = Tp.exports, Dy = aP, lP = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, cP = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Ay = {};
Ay[Dy.ForwardRef] = lP;
Ay[Dy.Memo] = cP;
var dP = !0;
function Hy(e, t, n) {
  var o = "";
  return n.split(" ").forEach(function(r) {
    e[r] !== void 0 ? t.push(e[r] + ";") : r && (o += r + " ");
  }), o;
}
var i4 = function(t, n, o) {
  var r = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (o === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  dP === !1) && t.registered[r] === void 0 && (t.registered[r] = n.styles);
}, s4 = function(t, n, o) {
  i4(t, n, o);
  var r = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var i = n;
    do
      t.insert(n === i ? "." + r : "", i, t.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function uP(e) {
  for (var t = 0, n, o = 0, r = e.length; r >= 4; ++o, r -= 4)
    n = e.charCodeAt(o) & 255 | (e.charCodeAt(++o) & 255) << 8 | (e.charCodeAt(++o) & 255) << 16 | (e.charCodeAt(++o) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (r) {
    case 3:
      t ^= (e.charCodeAt(o + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(o + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(o) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var fP = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, pP = /[A-Z]|^ms/g, hP = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Fy = function(t) {
  return t.charCodeAt(1) === 45;
}, s9 = function(t) {
  return t != null && typeof t != "boolean";
}, Rf = /* @__PURE__ */ Iy(function(e) {
  return Fy(e) ? e : e.replace(pP, "-$&").toLowerCase();
}), a9 = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(hP, function(o, r, i) {
          return qr = {
            name: r,
            styles: i,
            next: qr
          }, r;
        });
  }
  return fP[t] !== 1 && !Fy(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
function Lc(e, t, n) {
  if (n == null)
    return "";
  var o = n;
  if (o.__emotion_styles !== void 0)
    return o;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var r = n;
      if (r.anim === 1)
        return qr = {
          name: r.name,
          styles: r.styles,
          next: qr
        }, r.name;
      var i = n;
      if (i.styles !== void 0) {
        var s = i.next;
        if (s !== void 0)
          for (; s !== void 0; )
            qr = {
              name: s.name,
              styles: s.styles,
              next: qr
            }, s = s.next;
        var a = i.styles + ";";
        return a;
      }
      return gP(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var c = qr, d = n(e);
        return qr = c, Lc(e, t, d);
      }
      break;
    }
  }
  var u = n;
  if (t == null)
    return u;
  var p = t[u];
  return p !== void 0 ? p : u;
}
function gP(e, t, n) {
  var o = "";
  if (Array.isArray(n))
    for (var r = 0; r < n.length; r++)
      o += Lc(e, t, n[r]) + ";";
  else
    for (var i in n) {
      var s = n[i];
      if (typeof s != "object") {
        var a = s;
        t != null && t[a] !== void 0 ? o += i + "{" + t[a] + "}" : s9(a) && (o += Rf(i) + ":" + a9(i, a) + ";");
      } else if (Array.isArray(s) && typeof s[0] == "string" && (t == null || t[s[0]] === void 0))
        for (var c = 0; c < s.length; c++)
          s9(s[c]) && (o += Rf(i) + ":" + a9(i, s[c]) + ";");
      else {
        var d = Lc(e, t, s);
        switch (i) {
          case "animation":
          case "animationName": {
            o += Rf(i) + ":" + d + ";";
            break;
          }
          default:
            o += i + "{" + d + "}";
        }
      }
    }
  return o;
}
var l9 = /label:\s*([^\s;{]+)\s*(;|$)/g, qr;
function r3(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var o = !0, r = "";
  qr = void 0;
  var i = e[0];
  if (i == null || i.raw === void 0)
    o = !1, r += Lc(n, t, i);
  else {
    var s = i;
    r += s[0];
  }
  for (var a = 1; a < e.length; a++)
    if (r += Lc(n, t, e[a]), o) {
      var c = i;
      r += c[a];
    }
  l9.lastIndex = 0;
  for (var d = "", u; (u = l9.exec(r)) !== null; )
    d += "-" + u[1];
  var p = uP(r) + d;
  return {
    name: p,
    styles: r,
    next: qr
  };
}
var mP = function(t) {
  return t();
}, Ny = y.useInsertionEffect ? y.useInsertionEffect : !1, $y = Ny || mP, c9 = Ny || y.useLayoutEffect, By = /* @__PURE__ */ y.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Vy({
    key: "css"
  }) : null
), bP = By.Provider, a4 = function(t) {
  return /* @__PURE__ */ vs(function(n, o) {
    var r = p0(By);
    return t(n, r, o);
  });
}, Jl = /* @__PURE__ */ y.createContext({}), l4 = {}.hasOwnProperty, kp = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", CP = function(t, n) {
  var o = {};
  for (var r in n)
    l4.call(n, r) && (o[r] = n[r]);
  return o[kp] = t, o;
}, xP = function(t) {
  var n = t.cache, o = t.serialized, r = t.isStringTag;
  return i4(n, o, r), $y(function() {
    return s4(n, o, r);
  }), null;
}, yP = /* @__PURE__ */ a4(function(e, t, n) {
  var o = e.css;
  typeof o == "string" && t.registered[o] !== void 0 && (o = t.registered[o]);
  var r = e[kp], i = [o], s = "";
  typeof e.className == "string" ? s = Hy(t.registered, i, e.className) : e.className != null && (s = e.className + " ");
  var a = r3(i, void 0, y.useContext(Jl));
  s += t.key + "-" + a.name;
  var c = {};
  for (var d in e)
    l4.call(e, d) && d !== "css" && d !== kp && (c[d] = e[d]);
  return c.className = s, n && (c.ref = n), /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement(xP, {
    cache: t,
    serialized: a,
    isStringTag: typeof r == "string"
  }), /* @__PURE__ */ y.createElement(r, c));
}), vP = yP, Of = { exports: {} }, d9;
function zy() {
  return d9 || (d9 = 1, function(e) {
    function t() {
      return e.exports = t = Object.assign ? Object.assign.bind() : function(n) {
        for (var o = 1; o < arguments.length; o++) {
          var r = arguments[o];
          for (var i in r) ({}).hasOwnProperty.call(r, i) && (n[i] = r[i]);
        }
        return n;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t.apply(null, arguments);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Of)), Of.exports;
}
zy();
var wP = function(t, n) {
  var o = arguments;
  if (n == null || !l4.call(n, "css"))
    return y.createElement.apply(void 0, o);
  var r = o.length, i = new Array(r);
  i[0] = vP, i[1] = CP(t, n);
  for (var s = 2; s < r; s++)
    i[s] = o[s];
  return y.createElement.apply(null, i);
};
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(wP);
var SP = /* @__PURE__ */ a4(function(e, t) {
  var n = e.styles, o = r3([n], void 0, y.useContext(Jl)), r = y.useRef();
  return c9(function() {
    var i = t.key + "-global", s = new t.sheet.constructor({
      key: i,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), a = !1, c = document.querySelector('style[data-emotion="' + i + " " + o.name + '"]');
    return t.sheet.tags.length && (s.before = t.sheet.tags[0]), c !== null && (a = !0, c.setAttribute("data-emotion", i), s.hydrate([c])), r.current = [s, a], function() {
      s.flush();
    };
  }, [t]), c9(function() {
    var i = r.current, s = i[0], a = i[1];
    if (a) {
      i[1] = !1;
      return;
    }
    if (o.next !== void 0 && s4(t, o.next, !0), s.tags.length) {
      var c = s.tags[s.tags.length - 1].nextElementSibling;
      s.before = c, s.flush();
    }
    t.insert("", o, s, !1);
  }, [t, o.name]), null;
});
function Li() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return r3(t);
}
function Dr() {
  var e = Li.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var MP = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, TP = /* @__PURE__ */ Iy(
  function(e) {
    return MP.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), kP = TP, EP = function(t) {
  return t !== "theme";
}, u9 = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? kP : EP;
}, f9 = function(t, n, o) {
  var r;
  if (n) {
    var i = n.shouldForwardProp;
    r = t.__emotion_forwardProp && i ? function(s) {
      return t.__emotion_forwardProp(s) && i(s);
    } : i;
  }
  return typeof r != "function" && o && (r = t.__emotion_forwardProp), r;
}, RP = function(t) {
  var n = t.cache, o = t.serialized, r = t.isStringTag;
  return i4(n, o, r), $y(function() {
    return s4(n, o, r);
  }), null;
}, OP = function e(t, n) {
  var o = t.__emotion_real === t, r = o && t.__emotion_base || t, i, s;
  n !== void 0 && (i = n.label, s = n.target);
  var a = f9(t, n, o), c = a || u9(r), d = !c("as");
  return function() {
    var u = arguments, p = o && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (i !== void 0 && p.push("label:" + i + ";"), u[0] == null || u[0].raw === void 0)
      p.push.apply(p, u);
    else {
      var h = u[0];
      p.push(h[0]);
      for (var g = u.length, m = 1; m < g; m++)
        p.push(u[m], h[m]);
    }
    var b = a4(function(C, x, v) {
      var S = d && C.as || r, M = "", w = [], k = C;
      if (C.theme == null) {
        k = {};
        for (var E in C)
          k[E] = C[E];
        k.theme = y.useContext(Jl);
      }
      typeof C.className == "string" ? M = Hy(x.registered, w, C.className) : C.className != null && (M = C.className + " ");
      var R = r3(p.concat(w), x.registered, k);
      M += x.key + "-" + R.name, s !== void 0 && (M += " " + s);
      var O = d && a === void 0 ? u9(S) : c, P = {};
      for (var _ in C)
        d && _ === "as" || O(_) && (P[_] = C[_]);
      return P.className = M, v && (P.ref = v), /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement(RP, {
        cache: x,
        serialized: R,
        isStringTag: typeof S == "string"
      }), /* @__PURE__ */ y.createElement(S, P));
    });
    return b.displayName = i !== void 0 ? i : "Styled(" + (typeof r == "string" ? r : r.displayName || r.name || "Component") + ")", b.defaultProps = t.defaultProps, b.__emotion_real = b, b.__emotion_base = r, b.__emotion_styles = p, b.__emotion_forwardProp = a, Object.defineProperty(b, "toString", {
      value: function() {
        return "." + s;
      }
    }), b.withComponent = function(C, x) {
      var v = e(C, T({}, n, x, {
        shouldForwardProp: f9(b, x, !0)
      }));
      return v.apply(void 0, p);
    }, b;
  };
}, _P = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], ba = OP.bind(null);
_P.forEach(function(e) {
  ba[e] = ba(e);
});
var Ep = { exports: {} }, e1 = { exports: {} }, Jt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var p9;
function PP() {
  if (p9) return Jt;
  p9 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, C = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
  function S(w) {
    if (typeof w == "object" && w !== null) {
      var k = w.$$typeof;
      switch (k) {
        case t:
          switch (w = w.type, w) {
            case c:
            case d:
            case o:
            case i:
            case r:
            case p:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case a:
                case u:
                case m:
                case g:
                case s:
                  return w;
                default:
                  return k;
              }
          }
        case n:
          return k;
      }
    }
  }
  function M(w) {
    return S(w) === d;
  }
  return Jt.AsyncMode = c, Jt.ConcurrentMode = d, Jt.ContextConsumer = a, Jt.ContextProvider = s, Jt.Element = t, Jt.ForwardRef = u, Jt.Fragment = o, Jt.Lazy = m, Jt.Memo = g, Jt.Portal = n, Jt.Profiler = i, Jt.StrictMode = r, Jt.Suspense = p, Jt.isAsyncMode = function(w) {
    return M(w) || S(w) === c;
  }, Jt.isConcurrentMode = M, Jt.isContextConsumer = function(w) {
    return S(w) === a;
  }, Jt.isContextProvider = function(w) {
    return S(w) === s;
  }, Jt.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === t;
  }, Jt.isForwardRef = function(w) {
    return S(w) === u;
  }, Jt.isFragment = function(w) {
    return S(w) === o;
  }, Jt.isLazy = function(w) {
    return S(w) === m;
  }, Jt.isMemo = function(w) {
    return S(w) === g;
  }, Jt.isPortal = function(w) {
    return S(w) === n;
  }, Jt.isProfiler = function(w) {
    return S(w) === i;
  }, Jt.isStrictMode = function(w) {
    return S(w) === r;
  }, Jt.isSuspense = function(w) {
    return S(w) === p;
  }, Jt.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === o || w === d || w === i || w === r || w === p || w === h || typeof w == "object" && w !== null && (w.$$typeof === m || w.$$typeof === g || w.$$typeof === s || w.$$typeof === a || w.$$typeof === u || w.$$typeof === C || w.$$typeof === x || w.$$typeof === v || w.$$typeof === b);
  }, Jt.typeOf = S, Jt;
}
var Qt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h9;
function LP() {
  return h9 || (h9 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, C = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
    function S(D) {
      return typeof D == "string" || typeof D == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      D === o || D === d || D === i || D === r || D === p || D === h || typeof D == "object" && D !== null && (D.$$typeof === m || D.$$typeof === g || D.$$typeof === s || D.$$typeof === a || D.$$typeof === u || D.$$typeof === C || D.$$typeof === x || D.$$typeof === v || D.$$typeof === b);
    }
    function M(D) {
      if (typeof D == "object" && D !== null) {
        var X = D.$$typeof;
        switch (X) {
          case t:
            var de = D.type;
            switch (de) {
              case c:
              case d:
              case o:
              case i:
              case r:
              case p:
                return de;
              default:
                var ue = de && de.$$typeof;
                switch (ue) {
                  case a:
                  case u:
                  case m:
                  case g:
                  case s:
                    return ue;
                  default:
                    return X;
                }
            }
          case n:
            return X;
        }
      }
    }
    var w = c, k = d, E = a, R = s, O = t, P = u, _ = o, L = m, V = g, j = n, I = i, F = r, $ = p, A = !1;
    function H(D) {
      return A || (A = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), N(D) || M(D) === c;
    }
    function N(D) {
      return M(D) === d;
    }
    function z(D) {
      return M(D) === a;
    }
    function se(D) {
      return M(D) === s;
    }
    function ne(D) {
      return typeof D == "object" && D !== null && D.$$typeof === t;
    }
    function Z(D) {
      return M(D) === u;
    }
    function q(D) {
      return M(D) === o;
    }
    function G(D) {
      return M(D) === m;
    }
    function K(D) {
      return M(D) === g;
    }
    function Q(D) {
      return M(D) === n;
    }
    function re(D) {
      return M(D) === i;
    }
    function U(D) {
      return M(D) === r;
    }
    function W(D) {
      return M(D) === p;
    }
    Qt.AsyncMode = w, Qt.ConcurrentMode = k, Qt.ContextConsumer = E, Qt.ContextProvider = R, Qt.Element = O, Qt.ForwardRef = P, Qt.Fragment = _, Qt.Lazy = L, Qt.Memo = V, Qt.Portal = j, Qt.Profiler = I, Qt.StrictMode = F, Qt.Suspense = $, Qt.isAsyncMode = H, Qt.isConcurrentMode = N, Qt.isContextConsumer = z, Qt.isContextProvider = se, Qt.isElement = ne, Qt.isForwardRef = Z, Qt.isFragment = q, Qt.isLazy = G, Qt.isMemo = K, Qt.isPortal = Q, Qt.isProfiler = re, Qt.isStrictMode = U, Qt.isSuspense = W, Qt.isValidElementType = S, Qt.typeOf = M;
  }()), Qt;
}
var g9;
function Zy() {
  return g9 || (g9 = 1, process.env.NODE_ENV === "production" ? e1.exports = PP() : e1.exports = LP()), e1.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var _f, m9;
function IP() {
  if (m9) return _f;
  m9 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function o(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function r() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var c = Object.getOwnPropertyNames(s).map(function(u) {
        return s[u];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        d[u] = u;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return _f = r() ? Object.assign : function(i, s) {
    for (var a, c = o(i), d, u = 1; u < arguments.length; u++) {
      a = Object(arguments[u]);
      for (var p in a)
        t.call(a, p) && (c[p] = a[p]);
      if (e) {
        d = e(a);
        for (var h = 0; h < d.length; h++)
          n.call(a, d[h]) && (c[d[h]] = a[d[h]]);
      }
    }
    return c;
  }, _f;
}
var Pf, b9;
function c4() {
  if (b9) return Pf;
  b9 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Pf = e, Pf;
}
var Lf, C9;
function Wy() {
  return C9 || (C9 = 1, Lf = Function.call.bind(Object.prototype.hasOwnProperty)), Lf;
}
var If, x9;
function jP() {
  if (x9) return If;
  x9 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = c4(), n = {}, o = Wy();
    e = function(i) {
      var s = "Warning: " + i;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function r(i, s, a, c, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (o(i, u)) {
          var p;
          try {
            if (typeof i[u] != "function") {
              var h = Error(
                (c || "React class") + ": " + a + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            p = i[u](s, u, c, a, null, t);
          } catch (m) {
            p = m;
          }
          if (p && !(p instanceof Error) && e(
            (c || "React class") + ": type specification of " + a + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof p + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), p instanceof Error && !(p.message in n)) {
            n[p.message] = !0;
            var g = d ? d() : "";
            e(
              "Failed " + a + " type: " + p.message + (g ?? "")
            );
          }
        }
    }
  }
  return r.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, If = r, If;
}
var jf, y9;
function VP() {
  if (y9) return jf;
  y9 = 1;
  var e = Zy(), t = IP(), n = c4(), o = Wy(), r = jP(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(a) {
    var c = "Warning: " + a;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return jf = function(a, c) {
    var d = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function p(N) {
      var z = N && (d && N[d] || N[u]);
      if (typeof z == "function")
        return z;
    }
    var h = "<<anonymous>>", g = {
      array: x("array"),
      bigint: x("bigint"),
      bool: x("boolean"),
      func: x("function"),
      number: x("number"),
      object: x("object"),
      string: x("string"),
      symbol: x("symbol"),
      any: v(),
      arrayOf: S,
      element: M(),
      elementType: w(),
      instanceOf: k,
      node: P(),
      objectOf: R,
      oneOf: E,
      oneOfType: O,
      shape: L,
      exact: V
    };
    function m(N, z) {
      return N === z ? N !== 0 || 1 / N === 1 / z : N !== N && z !== z;
    }
    function b(N, z) {
      this.message = N, this.data = z && typeof z == "object" ? z : {}, this.stack = "";
    }
    b.prototype = Error.prototype;
    function C(N) {
      if (process.env.NODE_ENV !== "production")
        var z = {}, se = 0;
      function ne(q, G, K, Q, re, U, W) {
        if (Q = Q || h, U = U || K, W !== n) {
          if (c) {
            var D = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw D.name = "Invariant Violation", D;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var X = Q + ":" + K;
            !z[X] && // Avoid spamming the console because they are often not actionable except for lib authors
            se < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + U + "` prop on `" + Q + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), z[X] = !0, se++);
          }
        }
        return G[K] == null ? q ? G[K] === null ? new b("The " + re + " `" + U + "` is marked as required " + ("in `" + Q + "`, but its value is `null`.")) : new b("The " + re + " `" + U + "` is marked as required in " + ("`" + Q + "`, but its value is `undefined`.")) : null : N(G, K, Q, re, U);
      }
      var Z = ne.bind(null, !1);
      return Z.isRequired = ne.bind(null, !0), Z;
    }
    function x(N) {
      function z(se, ne, Z, q, G, K) {
        var Q = se[ne], re = F(Q);
        if (re !== N) {
          var U = $(Q);
          return new b(
            "Invalid " + q + " `" + G + "` of type " + ("`" + U + "` supplied to `" + Z + "`, expected ") + ("`" + N + "`."),
            { expectedType: N }
          );
        }
        return null;
      }
      return C(z);
    }
    function v() {
      return C(s);
    }
    function S(N) {
      function z(se, ne, Z, q, G) {
        if (typeof N != "function")
          return new b("Property `" + G + "` of component `" + Z + "` has invalid PropType notation inside arrayOf.");
        var K = se[ne];
        if (!Array.isArray(K)) {
          var Q = F(K);
          return new b("Invalid " + q + " `" + G + "` of type " + ("`" + Q + "` supplied to `" + Z + "`, expected an array."));
        }
        for (var re = 0; re < K.length; re++) {
          var U = N(K, re, Z, q, G + "[" + re + "]", n);
          if (U instanceof Error)
            return U;
        }
        return null;
      }
      return C(z);
    }
    function M() {
      function N(z, se, ne, Z, q) {
        var G = z[se];
        if (!a(G)) {
          var K = F(G);
          return new b("Invalid " + Z + " `" + q + "` of type " + ("`" + K + "` supplied to `" + ne + "`, expected a single ReactElement."));
        }
        return null;
      }
      return C(N);
    }
    function w() {
      function N(z, se, ne, Z, q) {
        var G = z[se];
        if (!e.isValidElementType(G)) {
          var K = F(G);
          return new b("Invalid " + Z + " `" + q + "` of type " + ("`" + K + "` supplied to `" + ne + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return C(N);
    }
    function k(N) {
      function z(se, ne, Z, q, G) {
        if (!(se[ne] instanceof N)) {
          var K = N.name || h, Q = H(se[ne]);
          return new b("Invalid " + q + " `" + G + "` of type " + ("`" + Q + "` supplied to `" + Z + "`, expected ") + ("instance of `" + K + "`."));
        }
        return null;
      }
      return C(z);
    }
    function E(N) {
      if (!Array.isArray(N))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), s;
      function z(se, ne, Z, q, G) {
        for (var K = se[ne], Q = 0; Q < N.length; Q++)
          if (m(K, N[Q]))
            return null;
        var re = JSON.stringify(N, function(W, D) {
          var X = $(D);
          return X === "symbol" ? String(D) : D;
        });
        return new b("Invalid " + q + " `" + G + "` of value `" + String(K) + "` " + ("supplied to `" + Z + "`, expected one of " + re + "."));
      }
      return C(z);
    }
    function R(N) {
      function z(se, ne, Z, q, G) {
        if (typeof N != "function")
          return new b("Property `" + G + "` of component `" + Z + "` has invalid PropType notation inside objectOf.");
        var K = se[ne], Q = F(K);
        if (Q !== "object")
          return new b("Invalid " + q + " `" + G + "` of type " + ("`" + Q + "` supplied to `" + Z + "`, expected an object."));
        for (var re in K)
          if (o(K, re)) {
            var U = N(K, re, Z, q, G + "." + re, n);
            if (U instanceof Error)
              return U;
          }
        return null;
      }
      return C(z);
    }
    function O(N) {
      if (!Array.isArray(N))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var z = 0; z < N.length; z++) {
        var se = N[z];
        if (typeof se != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + A(se) + " at index " + z + "."
          ), s;
      }
      function ne(Z, q, G, K, Q) {
        for (var re = [], U = 0; U < N.length; U++) {
          var W = N[U], D = W(Z, q, G, K, Q, n);
          if (D == null)
            return null;
          D.data && o(D.data, "expectedType") && re.push(D.data.expectedType);
        }
        var X = re.length > 0 ? ", expected one of type [" + re.join(", ") + "]" : "";
        return new b("Invalid " + K + " `" + Q + "` supplied to " + ("`" + G + "`" + X + "."));
      }
      return C(ne);
    }
    function P() {
      function N(z, se, ne, Z, q) {
        return j(z[se]) ? null : new b("Invalid " + Z + " `" + q + "` supplied to " + ("`" + ne + "`, expected a ReactNode."));
      }
      return C(N);
    }
    function _(N, z, se, ne, Z) {
      return new b(
        (N || "React class") + ": " + z + " type `" + se + "." + ne + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Z + "`."
      );
    }
    function L(N) {
      function z(se, ne, Z, q, G) {
        var K = se[ne], Q = F(K);
        if (Q !== "object")
          return new b("Invalid " + q + " `" + G + "` of type `" + Q + "` " + ("supplied to `" + Z + "`, expected `object`."));
        for (var re in N) {
          var U = N[re];
          if (typeof U != "function")
            return _(Z, q, G, re, $(U));
          var W = U(K, re, Z, q, G + "." + re, n);
          if (W)
            return W;
        }
        return null;
      }
      return C(z);
    }
    function V(N) {
      function z(se, ne, Z, q, G) {
        var K = se[ne], Q = F(K);
        if (Q !== "object")
          return new b("Invalid " + q + " `" + G + "` of type `" + Q + "` " + ("supplied to `" + Z + "`, expected `object`."));
        var re = t({}, se[ne], N);
        for (var U in re) {
          var W = N[U];
          if (o(N, U) && typeof W != "function")
            return _(Z, q, G, U, $(W));
          if (!W)
            return new b(
              "Invalid " + q + " `" + G + "` key `" + U + "` supplied to `" + Z + "`.\nBad object: " + JSON.stringify(se[ne], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(N), null, "  ")
            );
          var D = W(K, U, Z, q, G + "." + U, n);
          if (D)
            return D;
        }
        return null;
      }
      return C(z);
    }
    function j(N) {
      switch (typeof N) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !N;
        case "object":
          if (Array.isArray(N))
            return N.every(j);
          if (N === null || a(N))
            return !0;
          var z = p(N);
          if (z) {
            var se = z.call(N), ne;
            if (z !== N.entries) {
              for (; !(ne = se.next()).done; )
                if (!j(ne.value))
                  return !1;
            } else
              for (; !(ne = se.next()).done; ) {
                var Z = ne.value;
                if (Z && !j(Z[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function I(N, z) {
      return N === "symbol" ? !0 : z ? z["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && z instanceof Symbol : !1;
    }
    function F(N) {
      var z = typeof N;
      return Array.isArray(N) ? "array" : N instanceof RegExp ? "object" : I(z, N) ? "symbol" : z;
    }
    function $(N) {
      if (typeof N > "u" || N === null)
        return "" + N;
      var z = F(N);
      if (z === "object") {
        if (N instanceof Date)
          return "date";
        if (N instanceof RegExp)
          return "regexp";
      }
      return z;
    }
    function A(N) {
      var z = $(N);
      switch (z) {
        case "array":
        case "object":
          return "an " + z;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + z;
        default:
          return z;
      }
    }
    function H(N) {
      return !N.constructor || !N.constructor.name ? h : N.constructor.name;
    }
    return g.checkPropTypes = r, g.resetWarningCache = r.resetWarningCache, g.PropTypes = g, g;
  }, jf;
}
var Vf, v9;
function DP() {
  if (v9) return Vf;
  v9 = 1;
  var e = c4();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Vf = function() {
    function o(s, a, c, d, u, p) {
      if (p !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    o.isRequired = o;
    function r() {
      return o;
    }
    var i = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: r,
      element: o,
      elementType: o,
      instanceOf: r,
      node: o,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Vf;
}
if (process.env.NODE_ENV !== "production") {
  var AP = Zy(), HP = !0;
  Ep.exports = VP()(AP.isElement, HP);
} else
  Ep.exports = DP()();
var FP = Ep.exports;
const l = /* @__PURE__ */ ky(FP);
let Rp;
typeof document == "object" && (Rp = Vy({
  key: "css",
  prepend: !0
}));
function Uy(e) {
  const {
    injectFirst: t,
    children: n
  } = e;
  return t && Rp ? /* @__PURE__ */ f.jsx(bP, {
    value: Rp,
    children: n
  }) : n;
}
process.env.NODE_ENV !== "production" && (Uy.propTypes = {
  /**
   * Your component tree.
   */
  children: l.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: l.bool
});
function NP(e) {
  return e == null || Object.keys(e).length === 0;
}
function d4(e) {
  const {
    styles: t,
    defaultTheme: n = {}
  } = e, o = typeof t == "function" ? (r) => t(NP(r) ? n : r) : t;
  return /* @__PURE__ */ f.jsx(SP, {
    styles: o
  });
}
process.env.NODE_ENV !== "production" && (d4.propTypes = {
  defaultTheme: l.object,
  styles: l.oneOfType([l.array, l.string, l.object, l.func])
});
/**
 * @mui/styled-engine v5.16.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function u4(e, t) {
  const n = ba(e, t);
  return process.env.NODE_ENV !== "production" ? (...o) => {
    const r = typeof e == "string" ? `"${e}"` : "component";
    return o.length === 0 ? console.error([`MUI: Seems like you called \`styled(${r})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : o.some((i) => i === void 0) && console.error(`MUI: the styled(${r})(...args) API requires all its args to be defined.`), n(...o);
  } : n;
}
const Gy = (e, t) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}, $P = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: d4,
  StyledEngineProvider: Uy,
  ThemeContext: Jl,
  css: Li,
  default: u4,
  internal_processStyles: Gy,
  keyframes: Dr
}, Symbol.toStringTag, { value: "Module" }));
function Mi(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function qy(e) {
  if (/* @__PURE__ */ y.isValidElement(e) || !Mi(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = qy(e[n]);
  }), t;
}
function yo(e, t, n = {
  clone: !0
}) {
  const o = n.clone ? T({}, e) : e;
  return Mi(e) && Mi(t) && Object.keys(t).forEach((r) => {
    /* @__PURE__ */ y.isValidElement(t[r]) ? o[r] = t[r] : Mi(t[r]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, r) && Mi(e[r]) ? o[r] = yo(e[r], t[r], n) : n.clone ? o[r] = Mi(t[r]) ? qy(t[r]) : t[r] : o[r] = t[r];
  }), o;
}
const BP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yo,
  isPlainObject: Mi
}, Symbol.toStringTag, { value: "Module" })), zP = ["values", "unit", "step"], ZP = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, o) => n.val - o.val), t.reduce((n, o) => T({}, n, {
    [o.key]: o.val
  }), {});
};
function Ky(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: o = 5
  } = e, r = le(e, zP), i = ZP(t), s = Object.keys(i);
  function a(h) {
    return `@media (min-width:${typeof t[h] == "number" ? t[h] : h}${n})`;
  }
  function c(h) {
    return `@media (max-width:${(typeof t[h] == "number" ? t[h] : h) - o / 100}${n})`;
  }
  function d(h, g) {
    const m = s.indexOf(g);
    return `@media (min-width:${typeof t[h] == "number" ? t[h] : h}${n}) and (max-width:${(m !== -1 && typeof t[s[m]] == "number" ? t[s[m]] : g) - o / 100}${n})`;
  }
  function u(h) {
    return s.indexOf(h) + 1 < s.length ? d(h, s[s.indexOf(h) + 1]) : a(h);
  }
  function p(h) {
    const g = s.indexOf(h);
    return g === 0 ? a(s[1]) : g === s.length - 1 ? c(s[g]) : d(h, s[s.indexOf(h) + 1]).replace("@media", "@media not all and");
  }
  return T({
    keys: s,
    values: i,
    up: a,
    down: c,
    between: d,
    only: u,
    not: p,
    unit: n
  }, r);
}
const WP = {
  borderRadius: 4
}, Ss = process.env.NODE_ENV !== "production" ? l.oneOfType([l.number, l.string, l.object, l.array]) : {};
function ec(e, t) {
  return t ? yo(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const f4 = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, w9 = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${f4[e]}px)`
};
function Fo(e, t, n) {
  const o = e.theme || {};
  if (Array.isArray(t)) {
    const i = o.breakpoints || w9;
    return t.reduce((s, a, c) => (s[i.up(i.keys[c])] = n(t[c]), s), {});
  }
  if (typeof t == "object") {
    const i = o.breakpoints || w9;
    return Object.keys(t).reduce((s, a) => {
      if (Object.keys(i.values || f4).indexOf(a) !== -1) {
        const c = i.up(a);
        s[c] = n(t[a], a);
      } else {
        const c = a;
        s[c] = t[c];
      }
      return s;
    }, {});
  }
  return n(t);
}
function Yy(e = {}) {
  var t;
  return ((t = e.keys) == null ? void 0 : t.reduce((o, r) => {
    const i = e.up(r);
    return o[i] = {}, o;
  }, {})) || {};
}
function Xy(e, t) {
  return e.reduce((n, o) => {
    const r = n[o];
    return (!r || Object.keys(r).length === 0) && delete n[o], n;
  }, t);
}
function UP(e, ...t) {
  const n = Yy(e), o = [n, ...t].reduce((r, i) => yo(r, i), {});
  return Xy(Object.keys(n), o);
}
function GP(e, t) {
  if (typeof e != "object")
    return {};
  const n = {}, o = Object.keys(t);
  return Array.isArray(e) ? o.forEach((r, i) => {
    i < e.length && (n[r] = !0);
  }) : o.forEach((r) => {
    e[r] != null && (n[r] = !0);
  }), n;
}
function ra({
  values: e,
  breakpoints: t,
  base: n
}) {
  const o = n || GP(e, t), r = Object.keys(o);
  if (r.length === 0)
    return e;
  let i;
  return r.reduce((s, a, c) => (Array.isArray(e) ? (s[a] = e[c] != null ? e[c] : e[i], i = c) : typeof e == "object" ? (s[a] = e[a] != null ? e[a] : e[i], i = a) : s[a] = e, s), {});
}
function pe(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : Pi(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const qP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pe
}, Symbol.toStringTag, { value: "Module" }));
function Pl(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const o = `vars.${t}`.split(".").reduce((r, i) => r && r[i] ? r[i] : null, e);
    if (o != null)
      return o;
  }
  return t.split(".").reduce((o, r) => o && o[r] != null ? o[r] : null, e);
}
function Fd(e, t, n, o = n) {
  let r;
  return typeof e == "function" ? r = e(n) : Array.isArray(e) ? r = e[n] || o : r = Pl(e, n) || o, t && (r = t(r, o, e)), r;
}
function Pn(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: o,
    transform: r
  } = e, i = (s) => {
    if (s[t] == null)
      return null;
    const a = s[t], c = s.theme, d = Pl(c, o) || {};
    return Fo(s, a, (p) => {
      let h = Fd(d, r, p);
      return p === h && typeof p == "string" && (h = Fd(d, r, `${t}${p === "default" ? "" : pe(p)}`, p)), n === !1 ? h : {
        [n]: h
      };
    });
  };
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: Ss
  } : {}, i.filterProps = [t], i;
}
function KP(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const YP = {
  m: "margin",
  p: "padding"
}, XP = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, S9 = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, JP = KP((e) => {
  if (e.length > 2)
    if (S9[e])
      e = S9[e];
    else
      return [e];
  const [t, n] = e.split(""), o = YP[t], r = XP[n] || "";
  return Array.isArray(r) ? r.map((i) => o + i) : [o + r];
}), i3 = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], s3 = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], QP = [...i3, ...s3];
function m0(e, t, n, o) {
  var r;
  const i = (r = Pl(e, t, !1)) != null ? r : n;
  return typeof i == "number" ? (s) => typeof s == "string" ? s : (process.env.NODE_ENV !== "production" && typeof s != "number" && console.error(`MUI: Expected ${o} argument to be a number or a string, got ${s}.`), i * s) : Array.isArray(i) ? (s) => typeof s == "string" ? s : (process.env.NODE_ENV !== "production" && (Number.isInteger(s) ? s > i.length - 1 && console.error([`MUI: The value provided (${s}) overflows.`, `The supported values are: ${JSON.stringify(i)}.`, `${s} > ${i.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`))), i[s]) : typeof i == "function" ? i : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${i}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function p4(e) {
  return m0(e, "spacing", 8, "spacing");
}
function Ca(e, t) {
  if (typeof t == "string" || t == null)
    return t;
  const n = Math.abs(t), o = e(n);
  return t >= 0 ? o : typeof o == "number" ? -o : `-${o}`;
}
function eL(e, t) {
  return (n) => e.reduce((o, r) => (o[r] = Ca(t, n), o), {});
}
function tL(e, t, n, o) {
  if (t.indexOf(n) === -1)
    return null;
  const r = JP(n), i = eL(r, o), s = e[n];
  return Fo(e, s, i);
}
function Jy(e, t) {
  const n = p4(e.theme);
  return Object.keys(e).map((o) => tL(e, t, o, n)).reduce(ec, {});
}
function Sn(e) {
  return Jy(e, i3);
}
Sn.propTypes = process.env.NODE_ENV !== "production" ? i3.reduce((e, t) => (e[t] = Ss, e), {}) : {};
Sn.filterProps = i3;
function Mn(e) {
  return Jy(e, s3);
}
Mn.propTypes = process.env.NODE_ENV !== "production" ? s3.reduce((e, t) => (e[t] = Ss, e), {}) : {};
Mn.filterProps = s3;
process.env.NODE_ENV !== "production" && QP.reduce((e, t) => (e[t] = Ss, e), {});
function nL(e = 8) {
  if (e.mui)
    return e;
  const t = p4({
    spacing: e
  }), n = (...o) => (process.env.NODE_ENV !== "production" && (o.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${o.length}`)), (o.length === 0 ? [1] : o).map((i) => {
    const s = t(i);
    return typeof s == "number" ? `${s}px` : s;
  }).join(" "));
  return n.mui = !0, n;
}
function a3(...e) {
  const t = e.reduce((o, r) => (r.filterProps.forEach((i) => {
    o[i] = r;
  }), o), {}), n = (o) => Object.keys(o).reduce((r, i) => t[i] ? ec(r, t[i](o)) : r, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((o, r) => Object.assign(o, r.propTypes), {}) : {}, n.filterProps = e.reduce((o, r) => o.concat(r.filterProps), []), n;
}
function ur(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function Mr(e, t) {
  return Pn({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const oL = Mr("border", ur), rL = Mr("borderTop", ur), iL = Mr("borderRight", ur), sL = Mr("borderBottom", ur), aL = Mr("borderLeft", ur), lL = Mr("borderColor"), cL = Mr("borderTopColor"), dL = Mr("borderRightColor"), uL = Mr("borderBottomColor"), fL = Mr("borderLeftColor"), pL = Mr("outline", ur), hL = Mr("outlineColor"), l3 = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = m0(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (o) => ({
      borderRadius: Ca(t, o)
    });
    return Fo(e, e.borderRadius, n);
  }
  return null;
};
l3.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: Ss
} : {};
l3.filterProps = ["borderRadius"];
a3(oL, rL, iL, sL, aL, lL, cL, dL, uL, fL, l3, pL, hL);
const c3 = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = m0(e.theme, "spacing", 8, "gap"), n = (o) => ({
      gap: Ca(t, o)
    });
    return Fo(e, e.gap, n);
  }
  return null;
};
c3.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: Ss
} : {};
c3.filterProps = ["gap"];
const d3 = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = m0(e.theme, "spacing", 8, "columnGap"), n = (o) => ({
      columnGap: Ca(t, o)
    });
    return Fo(e, e.columnGap, n);
  }
  return null;
};
d3.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: Ss
} : {};
d3.filterProps = ["columnGap"];
const u3 = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = m0(e.theme, "spacing", 8, "rowGap"), n = (o) => ({
      rowGap: Ca(t, o)
    });
    return Fo(e, e.rowGap, n);
  }
  return null;
};
u3.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: Ss
} : {};
u3.filterProps = ["rowGap"];
const gL = Pn({
  prop: "gridColumn"
}), mL = Pn({
  prop: "gridRow"
}), bL = Pn({
  prop: "gridAutoFlow"
}), CL = Pn({
  prop: "gridAutoColumns"
}), xL = Pn({
  prop: "gridAutoRows"
}), yL = Pn({
  prop: "gridTemplateColumns"
}), vL = Pn({
  prop: "gridTemplateRows"
}), wL = Pn({
  prop: "gridTemplateAreas"
}), SL = Pn({
  prop: "gridArea"
});
a3(c3, d3, u3, gL, mL, bL, CL, xL, yL, vL, wL, SL);
function bl(e, t) {
  return t === "grey" ? t : e;
}
const ML = Pn({
  prop: "color",
  themeKey: "palette",
  transform: bl
}), TL = Pn({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: bl
}), kL = Pn({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: bl
});
a3(ML, TL, kL);
function qo(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const EL = Pn({
  prop: "width",
  transform: qo
}), h4 = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var o, r;
      const i = ((o = e.theme) == null || (o = o.breakpoints) == null || (o = o.values) == null ? void 0 : o[n]) || f4[n];
      return i ? ((r = e.theme) == null || (r = r.breakpoints) == null ? void 0 : r.unit) !== "px" ? {
        maxWidth: `${i}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: i
      } : {
        maxWidth: qo(n)
      };
    };
    return Fo(e, e.maxWidth, t);
  }
  return null;
};
h4.filterProps = ["maxWidth"];
const RL = Pn({
  prop: "minWidth",
  transform: qo
}), OL = Pn({
  prop: "height",
  transform: qo
}), _L = Pn({
  prop: "maxHeight",
  transform: qo
}), PL = Pn({
  prop: "minHeight",
  transform: qo
});
Pn({
  prop: "size",
  cssProperty: "width",
  transform: qo
});
Pn({
  prop: "size",
  cssProperty: "height",
  transform: qo
});
const LL = Pn({
  prop: "boxSizing"
});
a3(EL, h4, RL, OL, _L, PL, LL);
const b0 = {
  // borders
  border: {
    themeKey: "borders",
    transform: ur
  },
  borderTop: {
    themeKey: "borders",
    transform: ur
  },
  borderRight: {
    themeKey: "borders",
    transform: ur
  },
  borderBottom: {
    themeKey: "borders",
    transform: ur
  },
  borderLeft: {
    themeKey: "borders",
    transform: ur
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: ur
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: l3
  },
  // palette
  color: {
    themeKey: "palette",
    transform: bl
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: bl
  },
  backgroundColor: {
    themeKey: "palette",
    transform: bl
  },
  // spacing
  p: {
    style: Mn
  },
  pt: {
    style: Mn
  },
  pr: {
    style: Mn
  },
  pb: {
    style: Mn
  },
  pl: {
    style: Mn
  },
  px: {
    style: Mn
  },
  py: {
    style: Mn
  },
  padding: {
    style: Mn
  },
  paddingTop: {
    style: Mn
  },
  paddingRight: {
    style: Mn
  },
  paddingBottom: {
    style: Mn
  },
  paddingLeft: {
    style: Mn
  },
  paddingX: {
    style: Mn
  },
  paddingY: {
    style: Mn
  },
  paddingInline: {
    style: Mn
  },
  paddingInlineStart: {
    style: Mn
  },
  paddingInlineEnd: {
    style: Mn
  },
  paddingBlock: {
    style: Mn
  },
  paddingBlockStart: {
    style: Mn
  },
  paddingBlockEnd: {
    style: Mn
  },
  m: {
    style: Sn
  },
  mt: {
    style: Sn
  },
  mr: {
    style: Sn
  },
  mb: {
    style: Sn
  },
  ml: {
    style: Sn
  },
  mx: {
    style: Sn
  },
  my: {
    style: Sn
  },
  margin: {
    style: Sn
  },
  marginTop: {
    style: Sn
  },
  marginRight: {
    style: Sn
  },
  marginBottom: {
    style: Sn
  },
  marginLeft: {
    style: Sn
  },
  marginX: {
    style: Sn
  },
  marginY: {
    style: Sn
  },
  marginInline: {
    style: Sn
  },
  marginInlineStart: {
    style: Sn
  },
  marginInlineEnd: {
    style: Sn
  },
  marginBlock: {
    style: Sn
  },
  marginBlockStart: {
    style: Sn
  },
  marginBlockEnd: {
    style: Sn
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: c3
  },
  rowGap: {
    style: u3
  },
  columnGap: {
    style: d3
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: qo
  },
  maxWidth: {
    style: h4
  },
  minWidth: {
    transform: qo
  },
  height: {
    transform: qo
  },
  maxHeight: {
    transform: qo
  },
  minHeight: {
    transform: qo
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function IL(...e) {
  const t = e.reduce((o, r) => o.concat(Object.keys(r)), []), n = new Set(t);
  return e.every((o) => n.size === Object.keys(o).length);
}
function jL(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Qy() {
  function e(n, o, r, i) {
    const s = {
      [n]: o,
      theme: r
    }, a = i[n];
    if (!a)
      return {
        [n]: o
      };
    const {
      cssProperty: c = n,
      themeKey: d,
      transform: u,
      style: p
    } = a;
    if (o == null)
      return null;
    if (d === "typography" && o === "inherit")
      return {
        [n]: o
      };
    const h = Pl(r, d) || {};
    return p ? p(s) : Fo(s, o, (m) => {
      let b = Fd(h, u, m);
      return m === b && typeof m == "string" && (b = Fd(h, u, `${n}${m === "default" ? "" : pe(m)}`, m)), c === !1 ? b : {
        [c]: b
      };
    });
  }
  function t(n) {
    var o;
    const {
      sx: r,
      theme: i = {}
    } = n || {};
    if (!r)
      return null;
    const s = (o = i.unstable_sxConfig) != null ? o : b0;
    function a(c) {
      let d = c;
      if (typeof c == "function")
        d = c(i);
      else if (typeof c != "object")
        return c;
      if (!d)
        return null;
      const u = Yy(i.breakpoints), p = Object.keys(u);
      let h = u;
      return Object.keys(d).forEach((g) => {
        const m = jL(d[g], i);
        if (m != null)
          if (typeof m == "object")
            if (s[g])
              h = ec(h, e(g, m, i, s));
            else {
              const b = Fo({
                theme: i
              }, m, (C) => ({
                [g]: C
              }));
              IL(b, m) ? h[g] = t({
                sx: m,
                theme: i
              }) : h = ec(h, b);
            }
          else
            h = ec(h, e(g, m, i, s));
      }), Xy(p, h);
    }
    return Array.isArray(r) ? r.map(a) : a(r);
  }
  return t;
}
const Ql = Qy();
Ql.filterProps = ["sx"];
function ev(e, t) {
  const n = this;
  return n.vars && typeof n.getColorSchemeSelector == "function" ? {
    [n.getColorSchemeSelector(e).replace(/(\[[^\]]+\])/, "*:where($1)")]: t
  } : n.palette.mode === e ? t : {};
}
const VL = ["breakpoints", "palette", "spacing", "shape"];
function C0(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: o = {},
    spacing: r,
    shape: i = {}
  } = e, s = le(e, VL), a = Ky(n), c = nL(r);
  let d = yo({
    breakpoints: a,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: T({
      mode: "light"
    }, o),
    spacing: c,
    shape: T({}, WP, i)
  }, s);
  return d.applyStyles = ev, d = t.reduce((u, p) => yo(u, p), d), d.unstable_sxConfig = T({}, b0, s == null ? void 0 : s.unstable_sxConfig), d.unstable_sx = function(p) {
    return Ql({
      sx: p,
      theme: this
    });
  }, d;
}
const DL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: C0,
  private_createBreakpoints: Ky,
  unstable_applyStyles: ev
}, Symbol.toStringTag, { value: "Module" }));
function AL(e) {
  return Object.keys(e).length === 0;
}
function g4(e = null) {
  const t = y.useContext(Jl);
  return !t || AL(t) ? e : t;
}
const HL = C0();
function e2(e = HL) {
  return g4(e);
}
function tv({
  styles: e,
  themeId: t,
  defaultTheme: n = {}
}) {
  const o = e2(n), r = typeof e == "function" ? e(t && o[t] || o) : e;
  return /* @__PURE__ */ f.jsx(d4, {
    styles: r
  });
}
process.env.NODE_ENV !== "production" && (tv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: l.object,
  /**
   * @ignore
   */
  styles: l.oneOfType([l.array, l.func, l.number, l.object, l.string, l.bool]),
  /**
   * @ignore
   */
  themeId: l.string
});
const FL = ["sx"], NL = (e) => {
  var t, n;
  const o = {
    systemProps: {},
    otherProps: {}
  }, r = (t = e == null || (n = e.theme) == null ? void 0 : n.unstable_sxConfig) != null ? t : b0;
  return Object.keys(e).forEach((i) => {
    r[i] ? o.systemProps[i] = e[i] : o.otherProps[i] = e[i];
  }), o;
};
function x0(e) {
  const {
    sx: t
  } = e, n = le(e, FL), {
    systemProps: o,
    otherProps: r
  } = NL(n);
  let i;
  return Array.isArray(t) ? i = [o, ...t] : typeof t == "function" ? i = (...s) => {
    const a = t(...s);
    return Mi(a) ? T({}, o, a) : o;
  } : i = T({}, o, t), T({}, r, {
    sx: i
  });
}
const $L = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ql,
  extendSxProp: x0,
  unstable_createStyleFunctionSx: Qy,
  unstable_defaultSxConfig: b0
}, Symbol.toStringTag, { value: "Module" })), M9 = (e) => e, BL = () => {
  let e = M9;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = M9;
    }
  };
}, f3 = BL();
function nv(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = nv(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function xe() {
  for (var e, t, n = 0, o = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = nv(e)) && (o && (o += " "), o += t);
  return o;
}
const zL = ["className", "component"];
function ov(e = {}) {
  const {
    themeId: t,
    defaultTheme: n,
    defaultClassName: o = "MuiBox-root",
    generateClassName: r
  } = e, i = u4("div", {
    shouldForwardProp: (a) => a !== "theme" && a !== "sx" && a !== "as"
  })(Ql);
  return /* @__PURE__ */ y.forwardRef(function(c, d) {
    const u = e2(n), p = x0(c), {
      className: h,
      component: g = "div"
    } = p, m = le(p, zL);
    return /* @__PURE__ */ f.jsx(i, T({
      as: g,
      ref: d,
      className: xe(h, r ? r(o) : o),
      theme: t && u[t] || u
    }, m));
  });
}
const ZL = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function _e(e, t, n = "Mui") {
  const o = ZL[t];
  return o ? `${n}-${o}` : `${f3.generate(e)}-${t}`;
}
function Re(e, t, n = "Mui") {
  const o = {};
  return t.forEach((r) => {
    o[r] = _e(e, r, n);
  }), o;
}
const WL = Re("MuiBox", ["root"]), Op = ov({
  defaultClassName: WL.root,
  generateClassName: f3.generate
});
process.env.NODE_ENV !== "production" && (Op.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: l.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
var _p = { exports: {} }, nn = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var T9;
function UL() {
  if (T9) return nn;
  T9 = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), i = Symbol.for("react.consumer"), s = Symbol.for("react.context"), a = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), g = Symbol.for("react.client.reference");
  function m(b) {
    if (typeof b == "object" && b !== null) {
      var C = b.$$typeof;
      switch (C) {
        case e:
          switch (b = b.type, b) {
            case n:
            case r:
            case o:
            case c:
            case d:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case a:
                case p:
                case u:
                  return b;
                case i:
                  return b;
                default:
                  return C;
              }
          }
        case t:
          return C;
      }
    }
  }
  return nn.ContextConsumer = i, nn.ContextProvider = s, nn.Element = e, nn.ForwardRef = a, nn.Fragment = n, nn.Lazy = p, nn.Memo = u, nn.Portal = t, nn.Profiler = r, nn.StrictMode = o, nn.Suspense = c, nn.SuspenseList = d, nn.isContextConsumer = function(b) {
    return m(b) === i;
  }, nn.isContextProvider = function(b) {
    return m(b) === s;
  }, nn.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === e;
  }, nn.isForwardRef = function(b) {
    return m(b) === a;
  }, nn.isFragment = function(b) {
    return m(b) === n;
  }, nn.isLazy = function(b) {
    return m(b) === p;
  }, nn.isMemo = function(b) {
    return m(b) === u;
  }, nn.isPortal = function(b) {
    return m(b) === t;
  }, nn.isProfiler = function(b) {
    return m(b) === r;
  }, nn.isStrictMode = function(b) {
    return m(b) === o;
  }, nn.isSuspense = function(b) {
    return m(b) === c;
  }, nn.isSuspenseList = function(b) {
    return m(b) === d;
  }, nn.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === n || b === r || b === o || b === c || b === d || b === h || typeof b == "object" && b !== null && (b.$$typeof === p || b.$$typeof === u || b.$$typeof === s || b.$$typeof === i || b.$$typeof === a || b.$$typeof === g || b.getModuleId !== void 0);
  }, nn.typeOf = m, nn;
}
var on = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var k9;
function GL() {
  return k9 || (k9 = 1, process.env.NODE_ENV !== "production" && function() {
    function e(b) {
      if (typeof b == "object" && b !== null) {
        var C = b.$$typeof;
        switch (C) {
          case t:
            switch (b = b.type, b) {
              case o:
              case i:
              case r:
              case d:
              case u:
                return b;
              default:
                switch (b = b && b.$$typeof, b) {
                  case a:
                  case c:
                  case h:
                  case p:
                    return b;
                  case s:
                    return b;
                  default:
                    return C;
                }
            }
          case n:
            return C;
        }
      }
    }
    var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.consumer"), a = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), m = Symbol.for("react.client.reference");
    on.ContextConsumer = s, on.ContextProvider = a, on.Element = t, on.ForwardRef = c, on.Fragment = o, on.Lazy = h, on.Memo = p, on.Portal = n, on.Profiler = i, on.StrictMode = r, on.Suspense = d, on.SuspenseList = u, on.isContextConsumer = function(b) {
      return e(b) === s;
    }, on.isContextProvider = function(b) {
      return e(b) === a;
    }, on.isElement = function(b) {
      return typeof b == "object" && b !== null && b.$$typeof === t;
    }, on.isForwardRef = function(b) {
      return e(b) === c;
    }, on.isFragment = function(b) {
      return e(b) === o;
    }, on.isLazy = function(b) {
      return e(b) === h;
    }, on.isMemo = function(b) {
      return e(b) === p;
    }, on.isPortal = function(b) {
      return e(b) === n;
    }, on.isProfiler = function(b) {
      return e(b) === i;
    }, on.isStrictMode = function(b) {
      return e(b) === r;
    }, on.isSuspense = function(b) {
      return e(b) === d;
    }, on.isSuspenseList = function(b) {
      return e(b) === u;
    }, on.isValidElementType = function(b) {
      return typeof b == "string" || typeof b == "function" || b === o || b === i || b === r || b === d || b === u || b === g || typeof b == "object" && b !== null && (b.$$typeof === h || b.$$typeof === p || b.$$typeof === a || b.$$typeof === s || b.$$typeof === c || b.$$typeof === m || b.getModuleId !== void 0);
    }, on.typeOf = e;
  }()), on;
}
process.env.NODE_ENV === "production" ? _p.exports = UL() : _p.exports = GL();
var xa = _p.exports;
const qL = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function rv(e) {
  const t = `${e}`.match(qL);
  return t && t[1] || "";
}
function iv(e, t = "") {
  return e.displayName || e.name || rv(e) || t;
}
function E9(e, t, n) {
  const o = iv(t);
  return e.displayName || (o !== "" ? `${n}(${o})` : n);
}
function sv(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return iv(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case xa.ForwardRef:
          return E9(e, e.render, "ForwardRef");
        case xa.Memo:
          return E9(e, e.type, "memo");
        default:
          return;
      }
  }
}
const KL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sv,
  getFunctionName: rv
}, Symbol.toStringTag, { value: "Module" })), YL = ["ownerState"], XL = ["variants"], JL = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function QL(e) {
  return Object.keys(e).length === 0;
}
function eI(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function dd(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const tI = C0(), R9 = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function t1({
  defaultTheme: e,
  theme: t,
  themeId: n
}) {
  return QL(t) ? e : t[n] || t;
}
function nI(e) {
  return e ? (t, n) => n[e] : null;
}
function ud(e, t) {
  let {
    ownerState: n
  } = t, o = le(t, YL);
  const r = typeof e == "function" ? e(T({
    ownerState: n
  }, o)) : e;
  if (Array.isArray(r))
    return r.flatMap((i) => ud(i, T({
      ownerState: n
    }, o)));
  if (r && typeof r == "object" && Array.isArray(r.variants)) {
    const {
      variants: i = []
    } = r;
    let a = le(r, XL);
    return i.forEach((c) => {
      let d = !0;
      typeof c.props == "function" ? d = c.props(T({
        ownerState: n
      }, o, n)) : Object.keys(c.props).forEach((u) => {
        (n == null ? void 0 : n[u]) !== c.props[u] && o[u] !== c.props[u] && (d = !1);
      }), d && (Array.isArray(a) || (a = [a]), a.push(typeof c.style == "function" ? c.style(T({
        ownerState: n
      }, o, n)) : c.style));
    }), a;
  }
  return r;
}
function oI(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = tI,
    rootShouldForwardProp: o = dd,
    slotShouldForwardProp: r = dd
  } = e, i = (s) => Ql(T({}, s, {
    theme: t1(T({}, s, {
      defaultTheme: n,
      themeId: t
    }))
  }));
  return i.__mui_systemSx = !0, (s, a = {}) => {
    Gy(s, (w) => w.filter((k) => !(k != null && k.__mui_systemSx)));
    const {
      name: c,
      slot: d,
      skipVariantsResolver: u,
      skipSx: p,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: h = nI(R9(d))
    } = a, g = le(a, JL), m = u !== void 0 ? u : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      d && d !== "Root" && d !== "root" || !1
    ), b = p || !1;
    let C;
    process.env.NODE_ENV !== "production" && c && (C = `${c}-${R9(d || "Root")}`);
    let x = dd;
    d === "Root" || d === "root" ? x = o : d ? x = r : eI(s) && (x = void 0);
    const v = u4(s, T({
      shouldForwardProp: x,
      label: C
    }, g)), S = (w) => typeof w == "function" && w.__emotion_real !== w || Mi(w) ? (k) => ud(w, T({}, k, {
      theme: t1({
        theme: k.theme,
        defaultTheme: n,
        themeId: t
      })
    })) : w, M = (w, ...k) => {
      let E = S(w);
      const R = k ? k.map(S) : [];
      c && h && R.push((_) => {
        const L = t1(T({}, _, {
          defaultTheme: n,
          themeId: t
        }));
        if (!L.components || !L.components[c] || !L.components[c].styleOverrides)
          return null;
        const V = L.components[c].styleOverrides, j = {};
        return Object.entries(V).forEach(([I, F]) => {
          j[I] = ud(F, T({}, _, {
            theme: L
          }));
        }), h(_, j);
      }), c && !m && R.push((_) => {
        var L;
        const V = t1(T({}, _, {
          defaultTheme: n,
          themeId: t
        })), j = V == null || (L = V.components) == null || (L = L[c]) == null ? void 0 : L.variants;
        return ud({
          variants: j
        }, T({}, _, {
          theme: V
        }));
      }), b || R.push(i);
      const O = R.length - k.length;
      if (Array.isArray(w) && O > 0) {
        const _ = new Array(O).fill("");
        E = [...w, ..._], E.raw = [...w.raw, ..._];
      }
      const P = v(E, ...R);
      if (process.env.NODE_ENV !== "production") {
        let _;
        c && (_ = `${c}${pe(d || "")}`), _ === void 0 && (_ = `Styled(${sv(s)})`), P.displayName = _;
      }
      return s.muiName && (P.muiName = s.muiName), P;
    };
    return v.withConfig && (M.withConfig = v.withConfig), M;
  };
}
const rI = oI();
function Ll(e, t) {
  const n = T({}, t);
  return Object.keys(e).forEach((o) => {
    if (o.toString().match(/^(components|slots)$/))
      n[o] = T({}, e[o], n[o]);
    else if (o.toString().match(/^(componentsProps|slotProps)$/)) {
      const r = e[o] || {}, i = t[o];
      n[o] = {}, !i || !Object.keys(i) ? n[o] = r : !r || !Object.keys(r) ? n[o] = i : (n[o] = T({}, i), Object.keys(r).forEach((s) => {
        n[o][s] = Ll(r[s], i[s]);
      }));
    } else n[o] === void 0 && (n[o] = e[o]);
  }), n;
}
function av(e) {
  const {
    theme: t,
    name: n,
    props: o
  } = e;
  return !t || !t.components || !t.components[n] || !t.components[n].defaultProps ? o : Ll(t.components[n].defaultProps, o);
}
function lv({
  props: e,
  name: t,
  defaultTheme: n,
  themeId: o
}) {
  let r = e2(n);
  return o && (r = r[o] || r), av({
    theme: r,
    name: t,
    props: e
  });
}
const En = typeof window < "u" ? y.useLayoutEffect : y.useEffect;
function iI(e, t, n, o, r) {
  const [i, s] = y.useState(() => r && n ? n(e).matches : o ? o(e).matches : t);
  return En(() => {
    let a = !0;
    if (!n)
      return;
    const c = n(e), d = () => {
      a && s(c.matches);
    };
    return d(), c.addListener(d), () => {
      a = !1, c.removeListener(d);
    };
  }, [e, n]), i;
}
const cv = y.useSyncExternalStore;
function sI(e, t, n, o, r) {
  const i = y.useCallback(() => t, [t]), s = y.useMemo(() => {
    if (r && n)
      return () => n(e).matches;
    if (o !== null) {
      const {
        matches: u
      } = o(e);
      return () => u;
    }
    return i;
  }, [i, e, o, r, n]), [a, c] = y.useMemo(() => {
    if (n === null)
      return [i, () => () => {
      }];
    const u = n(e);
    return [() => u.matches, (p) => (u.addListener(p), () => {
      u.removeListener(p);
    })];
  }, [i, n, e]);
  return cv(c, a, s);
}
function y0(e, t = {}) {
  const n = g4(), o = typeof window < "u" && typeof window.matchMedia < "u", {
    defaultMatches: r = !1,
    matchMedia: i = o ? window.matchMedia : null,
    ssrMatchMedia: s = null,
    noSsr: a = !1
  } = av({
    name: "MuiUseMediaQuery",
    props: t,
    theme: n
  });
  process.env.NODE_ENV !== "production" && typeof e == "function" && n === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
  let c = typeof e == "function" ? e(n) : e;
  c = c.replace(/^@media( ?)/m, "");
  const u = (cv !== void 0 ? sI : iI)(c, r, i, s, a);
  return process.env.NODE_ENV !== "production" && y.useDebugValue({
    query: c,
    match: u
  }), u;
}
function Gs(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
const aI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gs
}, Symbol.toStringTag, { value: "Module" }));
function m4(e, t = 0, n = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > n) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${n}].`), Gs(e, t, n);
}
function lI(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((o) => o + o)), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((o, r) => r < 3 ? parseInt(o, 16) : Math.round(parseInt(o, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function p3(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return p3(lI(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(n) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : Pi(9, e));
  let o = e.substring(t + 1, e.length - 1), r;
  if (n === "color") {
    if (o = o.split(" "), r = o.shift(), o.length === 4 && o[3].charAt(0) === "/" && (o[3] = o[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(r) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${r}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : Pi(10, r));
  } else
    o = o.split(",");
  return o = o.map((i) => parseFloat(i)), {
    type: n,
    values: o,
    colorSpace: r
  };
}
function b4(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: o
  } = e;
  return t.indexOf("rgb") !== -1 ? o = o.map((r, i) => i < 3 ? parseInt(r, 10) : r) : t.indexOf("hsl") !== -1 && (o[1] = `${o[1]}%`, o[2] = `${o[2]}%`), t.indexOf("color") !== -1 ? o = `${n} ${o.join(" ")}` : o = `${o.join(", ")}`, `${t}(${o})`;
}
function $t(e, t) {
  return e = p3(e), t = m4(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, b4(e);
}
function C4(e, t) {
  if (e = p3(e), t = m4(t), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - t;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return b4(e);
}
function fd(e, t) {
  if (e = p3(e), t = m4(t), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.indexOf("rgb") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.indexOf("color") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return b4(e);
}
function vo(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...o) {
    return e(...o) || t(...o);
  };
}
function cI(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function dv(e, t, n, o, r) {
  const i = e[t], s = r || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let a;
  const c = i.type;
  return typeof c == "function" && !cI(c) && (a = "Did you accidentally use a plain function component for an element instead?"), a !== void 0 ? new Error(`Invalid ${o} \`${s}\` supplied to \`${n}\`. Expected an element that can hold a ref. ${a} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const t2 = vo(l.element, dv);
t2.isRequired = vo(l.element.isRequired, dv);
function dI(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function uI(e, t, n, o, r) {
  const i = e[t], s = r || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let a;
  return typeof i == "function" && !dI(i) && (a = "Did you accidentally provide a plain function component instead?"), a !== void 0 ? new Error(`Invalid ${o} \`${s}\` supplied to \`${n}\`. Expected an element type that can hold a ref. ${a} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Pa = vo(l.elementType, uI), fI = "exact-prop: ​";
function h3(e) {
  return process.env.NODE_ENV === "production" ? e : T({}, e, {
    [fI]: (t) => {
      const n = Object.keys(t).filter((o) => !e.hasOwnProperty(o));
      return n.length > 0 ? new Error(`The following props are not supported: ${n.map((o) => `\`${o}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function Ii(e, t, n, o, r) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = e[t], s = r || t;
  return i == null ? null : i && i.nodeType !== 1 ? new Error(`Invalid ${o} \`${s}\` supplied to \`${n}\`. Expected an HTMLElement.`) : null;
}
const sn = l.oneOfType([l.func, l.object]);
function Nd(...e) {
  return e.reduce((t, n) => n == null ? t : function(...r) {
    t.apply(this, r), n.apply(this, r);
  }, () => {
  });
}
function n2(e, t = 166) {
  let n;
  function o(...r) {
    const i = () => {
      e.apply(this, r);
    };
    clearTimeout(n), n = setTimeout(i, t);
  }
  return o.clear = () => {
    clearTimeout(n);
  }, o;
}
function pI(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : (n, o, r, i, s) => {
    const a = r || "<<anonymous>>", c = s || o;
    return typeof n[o] < "u" ? new Error(`The ${i} \`${c}\` of \`${a}\` is deprecated. ${t}`) : null;
  };
}
function Cl(e, t) {
  var n, o;
  return /* @__PURE__ */ y.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (n = e.type.muiName) != null ? n : (o = e.type) == null || (o = o._payload) == null || (o = o.value) == null ? void 0 : o.muiName
  ) !== -1;
}
function gn(e) {
  return e && e.ownerDocument || document;
}
function ri(e) {
  return gn(e).defaultView || window;
}
function uv(e, t) {
  if (process.env.NODE_ENV === "production")
    return () => null;
  const n = t ? T({}, t.propTypes) : null;
  return (r) => (i, s, a, c, d, ...u) => {
    const p = d || s, h = n == null ? void 0 : n[p];
    if (h) {
      const g = h(i, s, a, c, d, ...u);
      if (g)
        return g;
    }
    return typeof i[s] < "u" && !i[r] ? new Error(`The prop \`${p}\` of \`${e}\` can only be used together with the \`${r}\` prop.`) : null;
  };
}
function Ic(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
let O9 = 0;
function hI(e) {
  const [t, n] = y.useState(e), o = e || t;
  return y.useEffect(() => {
    t == null && (O9 += 1, n(`mui-${O9}`));
  }, [t]), o;
}
const _9 = y.useId;
function di(e) {
  if (_9 !== void 0) {
    const t = _9();
    return e ?? t;
  }
  return hI(e);
}
function v0(e, t, n, o, r) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = r || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${i}\` is not supported. Please remove it.`) : null;
}
function Fn({
  controlled: e,
  default: t,
  name: n,
  state: o = "value"
}) {
  const {
    current: r
  } = y.useRef(e !== void 0), [i, s] = y.useState(t), a = r ? e : i;
  if (process.env.NODE_ENV !== "production") {
    y.useEffect(() => {
      r !== (e !== void 0) && console.error([`MUI: A component is changing the ${r ? "" : "un"}controlled ${o} state of ${n} to be ${r ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [o, n, e]);
    const {
      current: d
    } = y.useRef(t);
    y.useEffect(() => {
      !r && !Object.is(d, t) && console.error([`MUI: A component is changing the default ${o} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const c = y.useCallback((d) => {
    r || s(d);
  }, []);
  return [a, c];
}
function Ke(e) {
  const t = y.useRef(e);
  return En(() => {
    t.current = e;
  }), y.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function Tt(...e) {
  return y.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      Ic(n, t);
    });
  }, e);
}
const P9 = {};
function gI(e, t) {
  const n = y.useRef(P9);
  return n.current === P9 && (n.current = e(t)), n;
}
const mI = [];
function bI(e) {
  y.useEffect(e, mI);
}
class w0 {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new w0();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
}
function Xs() {
  const e = gI(w0.create).current;
  return bI(e.disposeEffect), e;
}
let g3 = !0, Pp = !1;
const CI = new w0(), xI = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function yI(e) {
  const {
    type: t,
    tagName: n
  } = e;
  return !!(n === "INPUT" && xI[t] && !e.readOnly || n === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function vI(e) {
  e.metaKey || e.altKey || e.ctrlKey || (g3 = !0);
}
function Df() {
  g3 = !1;
}
function wI() {
  this.visibilityState === "hidden" && Pp && (g3 = !0);
}
function SI(e) {
  e.addEventListener("keydown", vI, !0), e.addEventListener("mousedown", Df, !0), e.addEventListener("pointerdown", Df, !0), e.addEventListener("touchstart", Df, !0), e.addEventListener("visibilitychange", wI, !0);
}
function MI(e) {
  const {
    target: t
  } = e;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return g3 || yI(t);
}
function S0() {
  const e = y.useCallback((r) => {
    r != null && SI(r.ownerDocument);
  }, []), t = y.useRef(!1);
  function n() {
    return t.current ? (Pp = !0, CI.start(100, () => {
      Pp = !1;
    }), t.current = !1, !0) : !1;
  }
  function o(r) {
    return MI(r) ? (t.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: t,
    onFocus: o,
    onBlur: n,
    ref: e
  };
}
function fv(e) {
  const t = e.documentElement.clientWidth;
  return Math.abs(window.innerWidth - t);
}
let qa;
function pv() {
  if (qa)
    return qa;
  const e = document.createElement("div"), t = document.createElement("div");
  return t.style.width = "10px", t.style.height = "1px", e.appendChild(t), e.dir = "rtl", e.style.fontSize = "14px", e.style.width = "4px", e.style.height = "1px", e.style.position = "absolute", e.style.top = "-1000px", e.style.overflow = "scroll", document.body.appendChild(e), qa = "reverse", e.scrollLeft > 0 ? qa = "default" : (e.scrollLeft = 1, e.scrollLeft === 0 && (qa = "negative")), document.body.removeChild(e), qa;
}
function TI(e, t) {
  const n = e.scrollLeft;
  if (t !== "rtl")
    return n;
  switch (pv()) {
    case "negative":
      return e.scrollWidth - e.clientWidth + n;
    case "reverse":
      return e.scrollWidth - e.clientWidth - n;
    default:
      return n;
  }
}
const x4 = (e) => {
  const t = y.useRef({});
  return y.useEffect(() => {
    t.current = e;
  }), t.current;
};
function kI(e) {
  return y.Children.toArray(e).filter((t) => /* @__PURE__ */ y.isValidElement(t));
}
const EI = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
function RI(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function OI(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
const _I = Number.isInteger || OI;
function hv(e, t, n, o) {
  const r = e[t];
  if (r == null || !_I(r)) {
    const i = RI(r);
    return new RangeError(`Invalid ${o} \`${t}\` of type \`${i}\` supplied to \`${n}\`, expected \`integer\`.`);
  }
  return null;
}
function gv(e, t, ...n) {
  return e[t] === void 0 ? null : hv(e, t, ...n);
}
function Lp() {
  return null;
}
gv.isRequired = hv;
Lp.isRequired = Lp;
const Gi = process.env.NODE_ENV === "production" ? Lp : gv;
function Oe(e, t, n = void 0) {
  const o = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (r) => {
      o[r] = e[r].reduce((i, s) => {
        if (s) {
          const a = t(s);
          a !== "" && i.push(a), n && n[s] && i.push(n[s]);
        }
        return i;
      }, []).join(" ");
    }
  ), o;
}
function Qr(e) {
  return typeof e == "string";
}
function dl(e, t, n) {
  return e === void 0 || Qr(e) ? t : T({}, t, {
    ownerState: T({}, t.ownerState, n)
  });
}
function lo(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((o) => o.match(/^on[A-Z]/) && typeof e[o] == "function" && !t.includes(o)).forEach((o) => {
    n[o] = e[o];
  }), n;
}
function L9(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function mv(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: o,
    externalForwardedProps: r,
    className: i
  } = e;
  if (!t) {
    const g = xe(n == null ? void 0 : n.className, i, r == null ? void 0 : r.className, o == null ? void 0 : o.className), m = T({}, n == null ? void 0 : n.style, r == null ? void 0 : r.style, o == null ? void 0 : o.style), b = T({}, n, r, o);
    return g.length > 0 && (b.className = g), Object.keys(m).length > 0 && (b.style = m), {
      props: b,
      internalRef: void 0
    };
  }
  const s = lo(T({}, r, o)), a = L9(o), c = L9(r), d = t(s), u = xe(d == null ? void 0 : d.className, n == null ? void 0 : n.className, i, r == null ? void 0 : r.className, o == null ? void 0 : o.className), p = T({}, d == null ? void 0 : d.style, n == null ? void 0 : n.style, r == null ? void 0 : r.style, o == null ? void 0 : o.style), h = T({}, d, n, c, a);
  return u.length > 0 && (h.className = u), Object.keys(p).length > 0 && (h.style = p), {
    props: h,
    internalRef: d.ref
  };
}
function Kr(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
const PI = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function Ft(e) {
  var t;
  const {
    elementType: n,
    externalSlotProps: o,
    ownerState: r,
    skipResolvingSlotProps: i = !1
  } = e, s = le(e, PI), a = i ? {} : Kr(o, r), {
    props: c,
    internalRef: d
  } = mv(T({}, s, {
    externalSlotProps: a
  })), u = Tt(d, a == null ? void 0 : a.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return dl(n, T({}, c, {
    ref: u
  }), r);
}
function o2(e) {
  if (parseInt(y.version, 10) >= 19) {
    var t;
    return (e == null || (t = e.props) == null ? void 0 : t.ref) || null;
  }
  return (e == null ? void 0 : e.ref) || null;
}
const y4 = /* @__PURE__ */ y.createContext(null);
process.env.NODE_ENV !== "production" && (y4.displayName = "ThemeContext");
function bv() {
  const e = y.useContext(y4);
  return process.env.NODE_ENV !== "production" && y.useDebugValue(e), e;
}
const LI = typeof Symbol == "function" && Symbol.for, II = LI ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function jI(e, t) {
  if (typeof t == "function") {
    const n = t(e);
    return process.env.NODE_ENV !== "production" && (n || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), n;
  }
  return T({}, e, t);
}
function $d(e) {
  const {
    children: t,
    theme: n
  } = e, o = bv();
  process.env.NODE_ENV !== "production" && o === null && typeof n == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const r = y.useMemo(() => {
    const i = o === null ? n : jI(o, n);
    return i != null && (i[II] = o !== null), i;
  }, [n, o]);
  return /* @__PURE__ */ f.jsx(y4.Provider, {
    value: r,
    children: t
  });
}
process.env.NODE_ENV !== "production" && ($d.propTypes = {
  /**
   * Your component tree.
   */
  children: l.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: l.oneOfType([l.object, l.func]).isRequired
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && ($d.propTypes = h3($d.propTypes));
const VI = ["value"], Cv = /* @__PURE__ */ y.createContext();
function xv(e) {
  let {
    value: t
  } = e, n = le(e, VI);
  return /* @__PURE__ */ f.jsx(Cv.Provider, T({
    value: t ?? !0
  }, n));
}
process.env.NODE_ENV !== "production" && (xv.propTypes = {
  children: l.node,
  value: l.bool
});
const Ms = () => {
  const e = y.useContext(Cv);
  return e ?? !1;
}, yv = /* @__PURE__ */ y.createContext(void 0);
function vv({
  value: e,
  children: t
}) {
  return /* @__PURE__ */ f.jsx(yv.Provider, {
    value: e,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (vv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: l.node,
  /**
   * @ignore
   */
  value: l.object
});
function DI(e) {
  const {
    theme: t,
    name: n,
    props: o
  } = e;
  if (!t || !t.components || !t.components[n])
    return o;
  const r = t.components[n];
  return r.defaultProps ? Ll(r.defaultProps, o) : !r.styleOverrides && !r.variants ? Ll(r, o) : o;
}
function AI({
  props: e,
  name: t
}) {
  const n = y.useContext(yv);
  return DI({
    props: e,
    name: t,
    theme: {
      components: n
    }
  });
}
const I9 = {};
function j9(e, t, n, o = !1) {
  return y.useMemo(() => {
    const r = e && t[e] || t;
    if (typeof n == "function") {
      const i = n(r), s = e ? T({}, t, {
        [e]: i
      }) : i;
      return o ? () => s : s;
    }
    return e ? T({}, t, {
      [e]: n
    }) : T({}, t, n);
  }, [e, t, n, o]);
}
function Bd(e) {
  const {
    children: t,
    theme: n,
    themeId: o
  } = e, r = g4(I9), i = bv() || I9;
  process.env.NODE_ENV !== "production" && (r === null && typeof n == "function" || o && r && !r[o] && typeof n == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const s = j9(o, r, n), a = j9(o, i, n, !0), c = s.direction === "rtl";
  return /* @__PURE__ */ f.jsx($d, {
    theme: a,
    children: /* @__PURE__ */ f.jsx(Jl.Provider, {
      value: s,
      children: /* @__PURE__ */ f.jsx(xv, {
        value: c,
        children: /* @__PURE__ */ f.jsx(vv, {
          value: s == null ? void 0 : s.components,
          children: t
        })
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (Bd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: l.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: l.oneOfType([l.func, l.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: l.string
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Bd.propTypes = h3(Bd.propTypes));
const HI = ["component", "direction", "spacing", "divider", "children", "className", "useFlexGap"], FI = C0(), NI = rI("div", {
  name: "MuiStack",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function $I(e) {
  return lv({
    props: e,
    name: "MuiStack",
    defaultTheme: FI
  });
}
function BI(e, t) {
  const n = y.Children.toArray(e).filter(Boolean);
  return n.reduce((o, r, i) => (o.push(r), i < n.length - 1 && o.push(/* @__PURE__ */ y.cloneElement(t, {
    key: `separator-${i}`
  })), o), []);
}
const zI = (e) => ({
  row: "Left",
  "row-reverse": "Right",
  column: "Top",
  "column-reverse": "Bottom"
})[e], ZI = ({
  ownerState: e,
  theme: t
}) => {
  let n = T({
    display: "flex",
    flexDirection: "column"
  }, Fo({
    theme: t
  }, ra({
    values: e.direction,
    breakpoints: t.breakpoints.values
  }), (o) => ({
    flexDirection: o
  })));
  if (e.spacing) {
    const o = p4(t), r = Object.keys(t.breakpoints.values).reduce((c, d) => ((typeof e.spacing == "object" && e.spacing[d] != null || typeof e.direction == "object" && e.direction[d] != null) && (c[d] = !0), c), {}), i = ra({
      values: e.direction,
      base: r
    }), s = ra({
      values: e.spacing,
      base: r
    });
    typeof i == "object" && Object.keys(i).forEach((c, d, u) => {
      if (!i[c]) {
        const h = d > 0 ? i[u[d - 1]] : "column";
        i[c] = h;
      }
    }), n = yo(n, Fo({
      theme: t
    }, s, (c, d) => e.useFlexGap ? {
      gap: Ca(o, c)
    } : {
      // The useFlexGap={false} implement relies on each child to give up control of the margin.
      // We need to reset the margin to avoid double spacing.
      "& > :not(style):not(style)": {
        margin: 0
      },
      "& > :not(style) ~ :not(style)": {
        [`margin${zI(d ? i[d] : e.direction)}`]: Ca(o, c)
      }
    }));
  }
  return n = UP(t.breakpoints, n), n;
};
function WI(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = NI,
    useThemeProps: n = $I,
    componentName: o = "MuiStack"
  } = e, r = () => Oe({
    root: ["root"]
  }, (c) => _e(o, c), {}), i = t(ZI), s = /* @__PURE__ */ y.forwardRef(function(c, d) {
    const u = n(c), p = x0(u), {
      component: h = "div",
      direction: g = "column",
      spacing: m = 0,
      divider: b,
      children: C,
      className: x,
      useFlexGap: v = !1
    } = p, S = le(p, HI), M = {
      direction: g,
      spacing: m,
      useFlexGap: v
    }, w = r();
    return /* @__PURE__ */ f.jsx(i, T({
      as: h,
      ownerState: M,
      ref: d,
      className: xe(w.root, x)
    }, S, {
      children: b ? BI(C, b) : C
    }));
  });
  return process.env.NODE_ENV !== "production" && (s.propTypes = {
    children: l.node,
    direction: l.oneOfType([l.oneOf(["column-reverse", "column", "row-reverse", "row"]), l.arrayOf(l.oneOf(["column-reverse", "column", "row-reverse", "row"])), l.object]),
    divider: l.node,
    spacing: l.oneOfType([l.arrayOf(l.oneOfType([l.number, l.string])), l.number, l.object, l.string]),
    sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
  }), s;
}
function UI(e, t) {
  return T({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, t);
}
var Ln = {}, wv = { exports: {} };
(function(e) {
  function t(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(wv);
var ht = wv.exports;
const GI = /* @__PURE__ */ Vi(__), qI = /* @__PURE__ */ Vi(aI);
var Sv = ht;
Object.defineProperty(Ln, "__esModule", {
  value: !0
});
var gt = Ln.alpha = Ev;
Ln.blend = rj;
Ln.colorChannel = void 0;
var ya = Ln.darken = w4;
Ln.decomposeColor = yr;
Ln.emphasize = Rv;
var V9 = Ln.getContrastRatio = QI;
Ln.getLuminance = zd;
Ln.hexToRgb = Mv;
Ln.hslToRgb = kv;
var va = Ln.lighten = S4;
Ln.private_safeAlpha = ej;
Ln.private_safeColorChannel = void 0;
Ln.private_safeDarken = tj;
Ln.private_safeEmphasize = oj;
Ln.private_safeLighten = nj;
Ln.recomposeColor = r2;
Ln.rgbToHex = JI;
var D9 = Sv(GI), KI = Sv(qI);
function v4(e, t = 0, n = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > n) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${n}].`), (0, KI.default)(e, t, n);
}
function Mv(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((o) => o + o)), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((o, r) => r < 3 ? parseInt(o, 16) : Math.round(parseInt(o, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function YI(e) {
  const t = e.toString(16);
  return t.length === 1 ? `0${t}` : t;
}
function yr(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return yr(Mv(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(n) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, D9.default)(9, e));
  let o = e.substring(t + 1, e.length - 1), r;
  if (n === "color") {
    if (o = o.split(" "), r = o.shift(), o.length === 4 && o[3].charAt(0) === "/" && (o[3] = o[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(r) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${r}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, D9.default)(10, r));
  } else
    o = o.split(",");
  return o = o.map((i) => parseFloat(i)), {
    type: n,
    values: o,
    colorSpace: r
  };
}
const Tv = (e) => {
  const t = yr(e);
  return t.values.slice(0, 3).map((n, o) => t.type.indexOf("hsl") !== -1 && o !== 0 ? `${n}%` : n).join(" ");
};
Ln.colorChannel = Tv;
const XI = (e, t) => {
  try {
    return Tv(e);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
};
Ln.private_safeColorChannel = XI;
function r2(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: o
  } = e;
  return t.indexOf("rgb") !== -1 ? o = o.map((r, i) => i < 3 ? parseInt(r, 10) : r) : t.indexOf("hsl") !== -1 && (o[1] = `${o[1]}%`, o[2] = `${o[2]}%`), t.indexOf("color") !== -1 ? o = `${n} ${o.join(" ")}` : o = `${o.join(", ")}`, `${t}(${o})`;
}
function JI(e) {
  if (e.indexOf("#") === 0)
    return e;
  const {
    values: t
  } = yr(e);
  return `#${t.map((n, o) => YI(o === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function kv(e) {
  e = yr(e);
  const {
    values: t
  } = e, n = t[0], o = t[1] / 100, r = t[2] / 100, i = o * Math.min(r, 1 - r), s = (d, u = (d + n / 30) % 12) => r - i * Math.max(Math.min(u - 3, 9 - u, 1), -1);
  let a = "rgb";
  const c = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return e.type === "hsla" && (a += "a", c.push(t[3])), r2({
    type: a,
    values: c
  });
}
function zd(e) {
  e = yr(e);
  let t = e.type === "hsl" || e.type === "hsla" ? yr(kv(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function QI(e, t) {
  const n = zd(e), o = zd(t);
  return (Math.max(n, o) + 0.05) / (Math.min(n, o) + 0.05);
}
function Ev(e, t) {
  return e = yr(e), t = v4(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, r2(e);
}
function ej(e, t, n) {
  try {
    return Ev(e, t);
  } catch {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
}
function w4(e, t) {
  if (e = yr(e), t = v4(t), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - t;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return r2(e);
}
function tj(e, t, n) {
  try {
    return w4(e, t);
  } catch {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
}
function S4(e, t) {
  if (e = yr(e), t = v4(t), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.indexOf("rgb") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.indexOf("color") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return r2(e);
}
function nj(e, t, n) {
  try {
    return S4(e, t);
  } catch {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
}
function Rv(e, t = 0.15) {
  return zd(e) > 0.5 ? w4(e, t) : S4(e, t);
}
function oj(e, t, n) {
  try {
    return Rv(e, t);
  } catch {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
}
function rj(e, t, n, o = 1) {
  const r = (c, d) => Math.round((c ** (1 / o) * (1 - n) + d ** (1 / o) * n) ** o), i = yr(e), s = yr(t), a = [r(i.values[0], s.values[0]), r(i.values[1], s.values[1]), r(i.values[2], s.values[2])];
  return r2({
    type: "rgb",
    values: a
  });
}
const ij = ["mode", "contrastThreshold", "tonalOffset"], A9 = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: Oc.white,
    default: Oc.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, Af = {
  text: {
    primary: Oc.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: Oc.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function H9(e, t, n, o) {
  const r = o.light || o, i = o.dark || o * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = va(e.main, r) : t === "dark" && (e.dark = ya(e.main, i)));
}
function sj(e = "light") {
  return e === "dark" ? {
    main: Wa[200],
    light: Wa[50],
    dark: Wa[400]
  } : {
    main: Wa[700],
    light: Wa[400],
    dark: Wa[800]
  };
}
function aj(e = "light") {
  return e === "dark" ? {
    main: Za[200],
    light: Za[50],
    dark: Za[400]
  } : {
    main: Za[500],
    light: Za[300],
    dark: Za[700]
  };
}
function lj(e = "light") {
  return e === "dark" ? {
    main: za[500],
    light: za[300],
    dark: za[700]
  } : {
    main: za[700],
    light: za[400],
    dark: za[800]
  };
}
function cj(e = "light") {
  return e === "dark" ? {
    main: Ua[400],
    light: Ua[300],
    dark: Ua[700]
  } : {
    main: Ua[700],
    light: Ua[500],
    dark: Ua[900]
  };
}
function dj(e = "light") {
  return e === "dark" ? {
    main: Ga[400],
    light: Ga[300],
    dark: Ga[700]
  } : {
    main: Ga[800],
    light: Ga[500],
    dark: Ga[900]
  };
}
function uj(e = "light") {
  return e === "dark" ? {
    main: w2[400],
    light: w2[300],
    dark: w2[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: w2[500],
    dark: w2[900]
  };
}
function fj(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: o = 0.2
  } = e, r = le(e, ij), i = e.primary || sj(t), s = e.secondary || aj(t), a = e.error || lj(t), c = e.info || cj(t), d = e.success || dj(t), u = e.warning || uj(t);
  function p(b) {
    const C = V9(b, Af.text.primary) >= n ? Af.text.primary : A9.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const x = V9(b, C);
      x < 3 && console.error([`MUI: The contrast ratio of ${x}:1 for ${C} on ${b}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return C;
  }
  const h = ({
    color: b,
    name: C,
    mainShade: x = 500,
    lightShade: v = 300,
    darkShade: S = 700
  }) => {
    if (b = T({}, b), !b.main && b[x] && (b.main = b[x]), !b.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${C ? ` (${C})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${x}\` property.` : Pi(11, C ? ` (${C})` : "", x));
    if (typeof b.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${C ? ` (${C})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(b.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : Pi(12, C ? ` (${C})` : "", JSON.stringify(b.main)));
    return H9(b, "light", v, o), H9(b, "dark", S, o), b.contrastText || (b.contrastText = p(b.main)), b;
  }, g = {
    dark: Af,
    light: A9
  };
  return process.env.NODE_ENV !== "production" && (g[t] || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), yo(T({
    // A collection of common colors.
    common: T({}, Oc),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: h({
      color: i,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: h({
      color: s,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: h({
      color: a,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: h({
      color: u,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: h({
      color: c,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: h({
      color: d,
      name: "success"
    }),
    // The grey colors.
    grey: O_,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: p,
    // Generate a rich color object.
    augmentColor: h,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: o
  }, g[t]), r);
}
const pj = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function hj(e) {
  return Math.round(e * 1e5) / 1e5;
}
const F9 = {
  textTransform: "uppercase"
}, N9 = '"Roboto", "Helvetica", "Arial", sans-serif';
function gj(e, t) {
  const n = typeof t == "function" ? t(e) : t, {
    fontFamily: o = N9,
    // The default font size of the Material Specification.
    fontSize: r = 14,
    // px
    fontWeightLight: i = 300,
    fontWeightRegular: s = 400,
    fontWeightMedium: a = 500,
    fontWeightBold: c = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: d = 16,
    // Apply the CSS properties to all the variants.
    allVariants: u,
    pxToRem: p
  } = n, h = le(n, pj);
  process.env.NODE_ENV !== "production" && (typeof r != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof d != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const g = r / 14, m = p || ((x) => `${x / d * g}rem`), b = (x, v, S, M, w) => T({
    fontFamily: o,
    fontWeight: x,
    fontSize: m(v),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: S
  }, o === N9 ? {
    letterSpacing: `${hj(M / v)}em`
  } : {}, w, u), C = {
    h1: b(i, 96, 1.167, -1.5),
    h2: b(i, 60, 1.2, -0.5),
    h3: b(s, 48, 1.167, 0),
    h4: b(s, 34, 1.235, 0.25),
    h5: b(s, 24, 1.334, 0),
    h6: b(a, 20, 1.6, 0.15),
    subtitle1: b(s, 16, 1.75, 0.15),
    subtitle2: b(a, 14, 1.57, 0.1),
    body1: b(s, 16, 1.5, 0.15),
    body2: b(s, 14, 1.43, 0.15),
    button: b(a, 14, 1.75, 0.4, F9),
    caption: b(s, 12, 1.66, 0.4),
    overline: b(s, 12, 2.66, 1, F9),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return yo(T({
    htmlFontSize: d,
    pxToRem: m,
    fontFamily: o,
    fontSize: r,
    fontWeightLight: i,
    fontWeightRegular: s,
    fontWeightMedium: a,
    fontWeightBold: c
  }, C), h, {
    clone: !1
    // No need to clone deep
  });
}
const mj = 0.2, bj = 0.14, Cj = 0.12;
function Cn(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${mj})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${bj})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${Cj})`].join(",");
}
const xj = ["none", Cn(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), Cn(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), Cn(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), Cn(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), Cn(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), Cn(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), Cn(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), Cn(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), Cn(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), Cn(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), Cn(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), Cn(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), Cn(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), Cn(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), Cn(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), Cn(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), Cn(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), Cn(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), Cn(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), Cn(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), Cn(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), Cn(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), Cn(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), Cn(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], yj = ["duration", "easing", "delay"], vj = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, Ov = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function $9(e) {
  return `${Math.round(e)}ms`;
}
function wj(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
}
function Sj(e) {
  const t = T({}, vj, e.easing), n = T({}, Ov, e.duration);
  return T({
    getAutoHeightDuration: wj,
    create: (r = ["all"], i = {}) => {
      const {
        duration: s = n.standard,
        easing: a = t.easeInOut,
        delay: c = 0
      } = i, d = le(i, yj);
      if (process.env.NODE_ENV !== "production") {
        const u = (h) => typeof h == "string", p = (h) => !isNaN(parseFloat(h));
        !u(r) && !Array.isArray(r) && console.error('MUI: Argument "props" must be a string or Array.'), !p(s) && !u(s) && console.error(`MUI: Argument "duration" must be a number or a string but found ${s}.`), u(a) || console.error('MUI: Argument "easing" must be a string.'), !p(c) && !u(c) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof i != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(d).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(d).join(",")}].`);
      }
      return (Array.isArray(r) ? r : [r]).map((u) => `${u} ${typeof s == "string" ? s : $9(s)} ${a} ${typeof c == "string" ? c : $9(c)}`).join(",");
    }
  }, e, {
    easing: t,
    duration: n
  });
}
const Mj = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, Tj = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function La(e = {}, ...t) {
  const {
    mixins: n = {},
    palette: o = {},
    transitions: r = {},
    typography: i = {}
  } = e, s = le(e, Tj);
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : Pi(18));
  const a = fj(o), c = C0(e);
  let d = yo(c, {
    mixins: UI(c.breakpoints, n),
    palette: a,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: xj.slice(),
    typography: gj(a, i),
    transitions: Sj(r),
    zIndex: T({}, Mj)
  });
  if (d = yo(d, s), d = t.reduce((u, p) => yo(u, p), d), process.env.NODE_ENV !== "production") {
    const u = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], p = (h, g) => {
      let m;
      for (m in h) {
        const b = h[m];
        if (u.indexOf(m) !== -1 && Object.keys(b).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const C = _e("", m);
            console.error([`MUI: The \`${g}\` component increases the CSS specificity of the \`${m}\` internal state.`, "You can not override it like this: ", JSON.stringify(h, null, 2), "", `Instead, you need to use the '&.${C}' syntax:`, JSON.stringify({
              root: {
                [`&.${C}`]: b
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          h[m] = {};
        }
      }
    };
    Object.keys(d.components).forEach((h) => {
      const g = d.components[h].styleOverrides;
      g && h.indexOf("Mui") === 0 && p(g, h);
    });
  }
  return d.unstable_sxConfig = T({}, b0, s == null ? void 0 : s.unstable_sxConfig), d.unstable_sx = function(p) {
    return Ql({
      sx: p,
      theme: this
    });
  }, d;
}
function kj(e) {
  return String(e).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function Ej(e) {
  return parseFloat(e);
}
const m3 = La();
function ge() {
  const e = e2(m3);
  return process.env.NODE_ENV !== "production" && y.useDebugValue(e), e[ma] || e;
}
function jt({
  props: e,
  name: t
}) {
  return lv({
    props: e,
    name: t,
    defaultTheme: m3,
    themeId: ma
  });
}
var M0 = {}, Hf = { exports: {} }, B9;
function Rj() {
  return B9 || (B9 = 1, function(e) {
    function t(n, o) {
      if (n == null) return {};
      var r = {};
      for (var i in n) if ({}.hasOwnProperty.call(n, i)) {
        if (o.includes(i)) continue;
        r[i] = n[i];
      }
      return r;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Hf)), Hf.exports;
}
const _v = /* @__PURE__ */ Vi($P), Oj = /* @__PURE__ */ Vi(BP), _j = /* @__PURE__ */ Vi(qP), Pj = /* @__PURE__ */ Vi(KL), Lj = /* @__PURE__ */ Vi(DL), Ij = /* @__PURE__ */ Vi($L);
var i2 = ht;
Object.defineProperty(M0, "__esModule", {
  value: !0
});
var jj = M0.default = qj, T0 = M0.shouldForwardProp = pd;
M0.systemDefaultTheme = void 0;
var lr = i2(zy()), Ip = i2(Rj()), z9 = zj(_v), Vj = Oj, Dj = i2(_j), Aj = i2(Pj), Hj = i2(Lj), Fj = i2(Ij);
const Nj = ["ownerState"], $j = ["variants"], Bj = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function Pv(e) {
  if (typeof WeakMap != "function") return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (Pv = function(o) {
    return o ? n : t;
  })(e);
}
function zj(e, t) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var n = Pv(t);
  if (n && n.has(e)) return n.get(e);
  var o = { __proto__: null }, r = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e) if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
    var s = r ? Object.getOwnPropertyDescriptor(e, i) : null;
    s && (s.get || s.set) ? Object.defineProperty(o, i, s) : o[i] = e[i];
  }
  return o.default = e, n && n.set(e, o), o;
}
function Zj(e) {
  return Object.keys(e).length === 0;
}
function Wj(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function pd(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Uj = M0.systemDefaultTheme = (0, Hj.default)(), Z9 = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function n1({
  defaultTheme: e,
  theme: t,
  themeId: n
}) {
  return Zj(t) ? e : t[n] || t;
}
function Gj(e) {
  return e ? (t, n) => n[e] : null;
}
function hd(e, t) {
  let {
    ownerState: n
  } = t, o = (0, Ip.default)(t, Nj);
  const r = typeof e == "function" ? e((0, lr.default)({
    ownerState: n
  }, o)) : e;
  if (Array.isArray(r))
    return r.flatMap((i) => hd(i, (0, lr.default)({
      ownerState: n
    }, o)));
  if (r && typeof r == "object" && Array.isArray(r.variants)) {
    const {
      variants: i = []
    } = r;
    let a = (0, Ip.default)(r, $j);
    return i.forEach((c) => {
      let d = !0;
      typeof c.props == "function" ? d = c.props((0, lr.default)({
        ownerState: n
      }, o, n)) : Object.keys(c.props).forEach((u) => {
        (n == null ? void 0 : n[u]) !== c.props[u] && o[u] !== c.props[u] && (d = !1);
      }), d && (Array.isArray(a) || (a = [a]), a.push(typeof c.style == "function" ? c.style((0, lr.default)({
        ownerState: n
      }, o, n)) : c.style));
    }), a;
  }
  return r;
}
function qj(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = Uj,
    rootShouldForwardProp: o = pd,
    slotShouldForwardProp: r = pd
  } = e, i = (s) => (0, Fj.default)((0, lr.default)({}, s, {
    theme: n1((0, lr.default)({}, s, {
      defaultTheme: n,
      themeId: t
    }))
  }));
  return i.__mui_systemSx = !0, (s, a = {}) => {
    (0, z9.internal_processStyles)(s, (w) => w.filter((k) => !(k != null && k.__mui_systemSx)));
    const {
      name: c,
      slot: d,
      skipVariantsResolver: u,
      skipSx: p,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: h = Gj(Z9(d))
    } = a, g = (0, Ip.default)(a, Bj), m = u !== void 0 ? u : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      d && d !== "Root" && d !== "root" || !1
    ), b = p || !1;
    let C;
    process.env.NODE_ENV !== "production" && c && (C = `${c}-${Z9(d || "Root")}`);
    let x = pd;
    d === "Root" || d === "root" ? x = o : d ? x = r : Wj(s) && (x = void 0);
    const v = (0, z9.default)(s, (0, lr.default)({
      shouldForwardProp: x,
      label: C
    }, g)), S = (w) => typeof w == "function" && w.__emotion_real !== w || (0, Vj.isPlainObject)(w) ? (k) => hd(w, (0, lr.default)({}, k, {
      theme: n1({
        theme: k.theme,
        defaultTheme: n,
        themeId: t
      })
    })) : w, M = (w, ...k) => {
      let E = S(w);
      const R = k ? k.map(S) : [];
      c && h && R.push((_) => {
        const L = n1((0, lr.default)({}, _, {
          defaultTheme: n,
          themeId: t
        }));
        if (!L.components || !L.components[c] || !L.components[c].styleOverrides)
          return null;
        const V = L.components[c].styleOverrides, j = {};
        return Object.entries(V).forEach(([I, F]) => {
          j[I] = hd(F, (0, lr.default)({}, _, {
            theme: L
          }));
        }), h(_, j);
      }), c && !m && R.push((_) => {
        var L;
        const V = n1((0, lr.default)({}, _, {
          defaultTheme: n,
          themeId: t
        })), j = V == null || (L = V.components) == null || (L = L[c]) == null ? void 0 : L.variants;
        return hd({
          variants: j
        }, (0, lr.default)({}, _, {
          theme: V
        }));
      }), b || R.push(i);
      const O = R.length - k.length;
      if (Array.isArray(w) && O > 0) {
        const _ = new Array(O).fill("");
        E = [...w, ..._], E.raw = [...w.raw, ..._];
      }
      const P = v(E, ...R);
      if (process.env.NODE_ENV !== "production") {
        let _;
        c && (_ = `${c}${(0, Dj.default)(d || "")}`), _ === void 0 && (_ = `Styled(${(0, Aj.default)(s)})`), P.displayName = _;
      }
      return s.muiName && (P.muiName = s.muiName), P;
    };
    return v.withConfig && (M.withConfig = v.withConfig), M;
  };
}
function b3(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const bo = (e) => b3(e) && e !== "classes", B = jj({
  themeId: ma,
  defaultTheme: m3,
  rootShouldForwardProp: bo
}), Kj = ["theme"];
function M4(e) {
  let {
    theme: t
  } = e, n = le(e, Kj);
  const o = t[ma];
  return /* @__PURE__ */ f.jsx(Bd, T({}, n, {
    themeId: o ? ma : void 0,
    theme: o || t
  }));
}
process.env.NODE_ENV !== "production" && (M4.propTypes = {
  /**
   * Your component tree.
   */
  children: l.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: l.oneOfType([l.object, l.func]).isRequired
});
const W9 = (e) => {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, (t / 100).toFixed(2);
};
process.env.NODE_ENV !== "production" && (l.node, l.object.isRequired);
function Xe(e) {
  return AI(e);
}
function Yj(e) {
  return _e("MuiSvgIcon", e);
}
Re("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const Xj = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], Jj = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: o
  } = e, r = {
    root: ["root", t !== "inherit" && `color${pe(t)}`, `fontSize${pe(n)}`]
  };
  return Oe(r, Yj, o);
}, Qj = B("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${pe(n.color)}`], t[`fontSize${pe(n.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n, o, r, i, s, a, c, d, u, p, h, g, m;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // for example heroicons uses fill="none" and stroke="currentColor"
    fill: t.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (n = e.transitions) == null || (o = n.create) == null ? void 0 : o.call(n, "fill", {
      duration: (r = e.transitions) == null || (r = r.duration) == null ? void 0 : r.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((i = e.typography) == null || (s = i.pxToRem) == null ? void 0 : s.call(i, 20)) || "1.25rem",
      medium: ((a = e.typography) == null || (c = a.pxToRem) == null ? void 0 : c.call(a, 24)) || "1.5rem",
      large: ((d = e.typography) == null || (u = d.pxToRem) == null ? void 0 : u.call(d, 35)) || "2.1875rem"
    }[t.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (p = (h = (e.vars || e).palette) == null || (h = h[t.color]) == null ? void 0 : h.main) != null ? p : {
      action: (g = (e.vars || e).palette) == null || (g = g.action) == null ? void 0 : g.active,
      disabled: (m = (e.vars || e).palette) == null || (m = m.action) == null ? void 0 : m.disabled,
      inherit: void 0
    }[t.color]
  };
}), ps = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: r,
    className: i,
    color: s = "inherit",
    component: a = "svg",
    fontSize: c = "medium",
    htmlColor: d,
    inheritViewBox: u = !1,
    titleAccess: p,
    viewBox: h = "0 0 24 24"
  } = o, g = le(o, Xj), m = /* @__PURE__ */ y.isValidElement(r) && r.type === "svg", b = T({}, o, {
    color: s,
    component: a,
    fontSize: c,
    instanceFontSize: t.fontSize,
    inheritViewBox: u,
    viewBox: h,
    hasSvgAsChild: m
  }), C = {};
  u || (C.viewBox = h);
  const x = Jj(b);
  return /* @__PURE__ */ f.jsxs(Qj, T({
    as: a,
    className: xe(x.root, i),
    focusable: "false",
    color: d,
    "aria-hidden": p ? void 0 : !0,
    role: p ? "img" : void 0,
    ref: n
  }, C, g, m && r.props, {
    ownerState: b,
    children: [m ? r.props.children : r, p ? /* @__PURE__ */ f.jsx("title", {
      children: p
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (ps.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: l.oneOfType([l.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: l.oneOfType([l.oneOf(["inherit", "large", "medium", "small"]), l.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: l.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: l.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: l.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: l.string
});
ps.muiName = "SvgIcon";
function ft(e, t) {
  function n(o, r) {
    return /* @__PURE__ */ f.jsx(ps, T({
      "data-testid": `${t}Icon`,
      ref: r
    }, o, {
      children: e
    }));
  }
  return process.env.NODE_ENV !== "production" && (n.displayName = `${t}Icon`), n.muiName = ps.muiName, /* @__PURE__ */ y.memo(/* @__PURE__ */ y.forwardRef(n));
}
const eV = {
  configure: (e) => {
    process.env.NODE_ENV !== "production" && console.warn(["MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.", "", "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead", "", "The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401", "", "The updated documentation: https://mui.com/guides/classname-generator/"].join(`
`)), f3.configure(e);
  }
}, tV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: pe,
  createChainedFunction: Nd,
  createSvgIcon: ft,
  debounce: n2,
  deprecatedPropType: pI,
  isMuiElement: Cl,
  ownerDocument: gn,
  ownerWindow: ri,
  requirePropFactory: uv,
  setRef: Ic,
  unstable_ClassNameGenerator: eV,
  unstable_useEnhancedEffect: En,
  unstable_useId: di,
  unsupportedProp: v0,
  useControlled: Fn,
  useEventCallback: Ke,
  useForkRef: Tt,
  useIsFocusVisible: S0
}, Symbol.toStringTag, { value: "Module" }));
function jp(e, t) {
  return jp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, jp(e, t);
}
function T4(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, jp(e, t);
}
function nV(e, t) {
  return e.classList ? !!t && e.classList.contains(t) : (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ") !== -1;
}
function oV(e, t) {
  e.classList ? e.classList.add(t) : nV(e, t) || (typeof e.className == "string" ? e.className = e.className + " " + t : e.setAttribute("class", (e.className && e.className.baseVal || "") + " " + t));
}
function U9(e, t) {
  return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function rV(e, t) {
  e.classList ? e.classList.remove(t) : typeof e.className == "string" ? e.className = U9(e.className, t) : e.setAttribute("class", U9(e.className && e.className.baseVal || "", t));
}
const G9 = {
  disabled: !1
};
var iV = process.env.NODE_ENV !== "production" ? l.oneOfType([l.number, l.shape({
  enter: l.number,
  exit: l.number,
  appear: l.number
}).isRequired]) : null, sV = process.env.NODE_ENV !== "production" ? l.oneOfType([l.string, l.shape({
  enter: l.string,
  exit: l.string,
  active: l.string
}), l.shape({
  enter: l.string,
  enterDone: l.string,
  enterActive: l.string,
  exit: l.string,
  exitDone: l.string,
  exitActive: l.string
})]) : null;
const Zd = Nt.createContext(null);
var Lv = function(t) {
  return t.scrollTop;
}, z2 = "unmounted", zs = "exited", Zs = "entering", rl = "entered", Vp = "exiting", nr = /* @__PURE__ */ function(e) {
  T4(t, e);
  function t(o, r) {
    var i;
    i = e.call(this, o, r) || this;
    var s = r, a = s && !s.isMounting ? o.enter : o.appear, c;
    return i.appearStatus = null, o.in ? a ? (c = zs, i.appearStatus = Zs) : c = rl : o.unmountOnExit || o.mountOnEnter ? c = z2 : c = zs, i.state = {
      status: c
    }, i.nextCallback = null, i;
  }
  t.getDerivedStateFromProps = function(r, i) {
    var s = r.in;
    return s && i.status === z2 ? {
      status: zs
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(r) {
    var i = null;
    if (r !== this.props) {
      var s = this.state.status;
      this.props.in ? s !== Zs && s !== rl && (i = Zs) : (s === Zs || s === rl) && (i = Vp);
    }
    this.updateStatus(!1, i);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var r = this.props.timeout, i, s, a;
    return i = s = a = r, r != null && typeof r != "number" && (i = r.exit, s = r.enter, a = r.appear !== void 0 ? r.appear : s), {
      exit: i,
      enter: s,
      appear: a
    };
  }, n.updateStatus = function(r, i) {
    if (r === void 0 && (r = !1), i !== null)
      if (this.cancelNextCallback(), i === Zs) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var s = this.props.nodeRef ? this.props.nodeRef.current : B2.findDOMNode(this);
          s && Lv(s);
        }
        this.performEnter(r);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === zs && this.setState({
      status: z2
    });
  }, n.performEnter = function(r) {
    var i = this, s = this.props.enter, a = this.context ? this.context.isMounting : r, c = this.props.nodeRef ? [a] : [B2.findDOMNode(this), a], d = c[0], u = c[1], p = this.getTimeouts(), h = a ? p.appear : p.enter;
    if (!r && !s || G9.disabled) {
      this.safeSetState({
        status: rl
      }, function() {
        i.props.onEntered(d);
      });
      return;
    }
    this.props.onEnter(d, u), this.safeSetState({
      status: Zs
    }, function() {
      i.props.onEntering(d, u), i.onTransitionEnd(h, function() {
        i.safeSetState({
          status: rl
        }, function() {
          i.props.onEntered(d, u);
        });
      });
    });
  }, n.performExit = function() {
    var r = this, i = this.props.exit, s = this.getTimeouts(), a = this.props.nodeRef ? void 0 : B2.findDOMNode(this);
    if (!i || G9.disabled) {
      this.safeSetState({
        status: zs
      }, function() {
        r.props.onExited(a);
      });
      return;
    }
    this.props.onExit(a), this.safeSetState({
      status: Vp
    }, function() {
      r.props.onExiting(a), r.onTransitionEnd(s.exit, function() {
        r.safeSetState({
          status: zs
        }, function() {
          r.props.onExited(a);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(r, i) {
    i = this.setNextCallback(i), this.setState(r, i);
  }, n.setNextCallback = function(r) {
    var i = this, s = !0;
    return this.nextCallback = function(a) {
      s && (s = !1, i.nextCallback = null, r(a));
    }, this.nextCallback.cancel = function() {
      s = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(r, i) {
    this.setNextCallback(i);
    var s = this.props.nodeRef ? this.props.nodeRef.current : B2.findDOMNode(this), a = r == null && !this.props.addEndListener;
    if (!s || a) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var c = this.props.nodeRef ? [this.nextCallback] : [s, this.nextCallback], d = c[0], u = c[1];
      this.props.addEndListener(d, u);
    }
    r != null && setTimeout(this.nextCallback, r);
  }, n.render = function() {
    var r = this.state.status;
    if (r === z2)
      return null;
    var i = this.props, s = i.children;
    i.in, i.mountOnEnter, i.unmountOnExit, i.appear, i.enter, i.exit, i.timeout, i.addEndListener, i.onEnter, i.onEntering, i.onEntered, i.onExit, i.onExiting, i.onExited, i.nodeRef;
    var a = le(i, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ Nt.createElement(Zd.Provider, {
        value: null
      }, typeof s == "function" ? s(r, a) : Nt.cloneElement(Nt.Children.only(s), a))
    );
  }, t;
}(Nt.Component);
nr.contextType = Zd;
nr.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: l.shape({
    current: typeof Element > "u" ? l.any : function(e, t, n, o, r, i) {
      var s = e[t];
      return l.instanceOf(s && "ownerDocument" in s ? s.ownerDocument.defaultView.Element : Element)(e, t, n, o, r, i);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: l.oneOfType([l.func.isRequired, l.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: l.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: l.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: l.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: l.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: l.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: l.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var n = iV;
    t.addEndListener || (n = n.isRequired);
    for (var o = arguments.length, r = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++)
      r[i - 1] = arguments[i];
    return n.apply(void 0, [t].concat(r));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: l.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: l.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: l.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: l.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: l.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: l.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: l.func
} : {};
function Ka() {
}
nr.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Ka,
  onEntering: Ka,
  onEntered: Ka,
  onExit: Ka,
  onExiting: Ka,
  onExited: Ka
};
nr.UNMOUNTED = z2;
nr.EXITED = zs;
nr.ENTERING = Zs;
nr.ENTERED = rl;
nr.EXITING = Vp;
var aV = function(t, n) {
  return t && n && n.split(" ").forEach(function(o) {
    return oV(t, o);
  });
}, Ff = function(t, n) {
  return t && n && n.split(" ").forEach(function(o) {
    return rV(t, o);
  });
}, k4 = /* @__PURE__ */ function(e) {
  T4(t, e);
  function t() {
    for (var o, r = arguments.length, i = new Array(r), s = 0; s < r; s++)
      i[s] = arguments[s];
    return o = e.call.apply(e, [this].concat(i)) || this, o.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, o.onEnter = function(a, c) {
      var d = o.resolveArguments(a, c), u = d[0], p = d[1];
      o.removeClasses(u, "exit"), o.addClass(u, p ? "appear" : "enter", "base"), o.props.onEnter && o.props.onEnter(a, c);
    }, o.onEntering = function(a, c) {
      var d = o.resolveArguments(a, c), u = d[0], p = d[1], h = p ? "appear" : "enter";
      o.addClass(u, h, "active"), o.props.onEntering && o.props.onEntering(a, c);
    }, o.onEntered = function(a, c) {
      var d = o.resolveArguments(a, c), u = d[0], p = d[1], h = p ? "appear" : "enter";
      o.removeClasses(u, h), o.addClass(u, h, "done"), o.props.onEntered && o.props.onEntered(a, c);
    }, o.onExit = function(a) {
      var c = o.resolveArguments(a), d = c[0];
      o.removeClasses(d, "appear"), o.removeClasses(d, "enter"), o.addClass(d, "exit", "base"), o.props.onExit && o.props.onExit(a);
    }, o.onExiting = function(a) {
      var c = o.resolveArguments(a), d = c[0];
      o.addClass(d, "exit", "active"), o.props.onExiting && o.props.onExiting(a);
    }, o.onExited = function(a) {
      var c = o.resolveArguments(a), d = c[0];
      o.removeClasses(d, "exit"), o.addClass(d, "exit", "done"), o.props.onExited && o.props.onExited(a);
    }, o.resolveArguments = function(a, c) {
      return o.props.nodeRef ? [o.props.nodeRef.current, a] : [a, c];
    }, o.getClassNames = function(a) {
      var c = o.props.classNames, d = typeof c == "string", u = d && c ? c + "-" : "", p = d ? "" + u + a : c[a], h = d ? p + "-active" : c[a + "Active"], g = d ? p + "-done" : c[a + "Done"];
      return {
        baseClassName: p,
        activeClassName: h,
        doneClassName: g
      };
    }, o;
  }
  var n = t.prototype;
  return n.addClass = function(r, i, s) {
    var a = this.getClassNames(i)[s + "ClassName"], c = this.getClassNames("enter"), d = c.doneClassName;
    i === "appear" && s === "done" && d && (a += " " + d), s === "active" && r && Lv(r), a && (this.appliedClasses[i][s] = a, aV(r, a));
  }, n.removeClasses = function(r, i) {
    var s = this.appliedClasses[i], a = s.base, c = s.active, d = s.done;
    this.appliedClasses[i] = {}, a && Ff(r, a), c && Ff(r, c), d && Ff(r, d);
  }, n.render = function() {
    var r = this.props;
    r.classNames;
    var i = le(r, ["classNames"]);
    return /* @__PURE__ */ Nt.createElement(nr, T({}, i, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, t;
}(Nt.Component);
k4.defaultProps = {
  classNames: ""
};
k4.propTypes = process.env.NODE_ENV !== "production" ? T({}, nr.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: sV,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: l.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: l.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: l.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: l.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: l.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: l.func
}) : {};
function lV(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function E4(e, t) {
  var n = function(i) {
    return t && id(i) ? t(i) : i;
  }, o = /* @__PURE__ */ Object.create(null);
  return e && y_.map(e, function(r) {
    return r;
  }).forEach(function(r) {
    o[r.key] = n(r);
  }), o;
}
function cV(e, t) {
  e = e || {}, t = t || {};
  function n(u) {
    return u in t ? t[u] : e[u];
  }
  var o = /* @__PURE__ */ Object.create(null), r = [];
  for (var i in e)
    i in t ? r.length && (o[i] = r, r = []) : r.push(i);
  var s, a = {};
  for (var c in t) {
    if (o[c])
      for (s = 0; s < o[c].length; s++) {
        var d = o[c][s];
        a[o[c][s]] = n(d);
      }
    a[c] = n(c);
  }
  for (s = 0; s < r.length; s++)
    a[r[s]] = n(r[s]);
  return a;
}
function Js(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function dV(e, t) {
  return E4(e.children, function(n) {
    return sd(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: Js(n, "appear", e),
      enter: Js(n, "enter", e),
      exit: Js(n, "exit", e)
    });
  });
}
function uV(e, t, n) {
  var o = E4(e.children), r = cV(t, o);
  return Object.keys(r).forEach(function(i) {
    var s = r[i];
    if (id(s)) {
      var a = i in t, c = i in o, d = t[i], u = id(d) && !d.props.in;
      c && (!a || u) ? r[i] = sd(s, {
        onExited: n.bind(null, s),
        in: !0,
        exit: Js(s, "exit", e),
        enter: Js(s, "enter", e)
      }) : !c && a && !u ? r[i] = sd(s, {
        in: !1
      }) : c && a && id(d) && (r[i] = sd(s, {
        onExited: n.bind(null, s),
        in: d.props.in,
        exit: Js(s, "exit", e),
        enter: Js(s, "enter", e)
      }));
    }
  }), r;
}
var fV = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, pV = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, k0 = /* @__PURE__ */ function(e) {
  T4(t, e);
  function t(o, r) {
    var i;
    i = e.call(this, o, r) || this;
    var s = i.handleExited.bind(lV(i));
    return i.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: s,
      firstRender: !0
    }, i;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(r, i) {
    var s = i.children, a = i.handleExited, c = i.firstRender;
    return {
      children: c ? dV(r, a) : uV(r, s, a),
      firstRender: !1
    };
  }, n.handleExited = function(r, i) {
    var s = E4(this.props.children);
    r.key in s || (r.props.onExited && r.props.onExited(i), this.mounted && this.setState(function(a) {
      var c = T({}, a.children);
      return delete c[r.key], {
        children: c
      };
    }));
  }, n.render = function() {
    var r = this.props, i = r.component, s = r.childFactory, a = le(r, ["component", "childFactory"]), c = this.state.contextValue, d = fV(this.state.children).map(s);
    return delete a.appear, delete a.enter, delete a.exit, i === null ? /* @__PURE__ */ Nt.createElement(Zd.Provider, {
      value: c
    }, d) : /* @__PURE__ */ Nt.createElement(Zd.Provider, {
      value: c
    }, /* @__PURE__ */ Nt.createElement(i, a, d));
  }, t;
}(Nt.Component);
k0.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: l.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: l.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: l.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: l.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: l.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: l.func
} : {};
k0.defaultProps = pV;
const Iv = (e) => e.scrollTop;
function Il(e, t) {
  var n, o;
  const {
    timeout: r,
    easing: i,
    style: s = {}
  } = e;
  return {
    duration: (n = s.transitionDuration) != null ? n : typeof r == "number" ? r : r[t.mode] || 0,
    easing: (o = s.transitionTimingFunction) != null ? o : typeof i == "object" ? i[t.mode] : i,
    delay: s.transitionDelay
  };
}
function hV(e) {
  return _e("MuiCollapse", e);
}
const gV = Re("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]), mV = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"], bV = (e) => {
  const {
    orientation: t,
    classes: n
  } = e, o = {
    root: ["root", `${t}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${t}`],
    wrapperInner: ["wrapperInner", `${t}`]
  };
  return Oe(o, hV, n);
}, CV = B("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation], n.state === "entered" && t.entered, n.state === "exited" && !n.in && n.collapsedSize === "0px" && t.hidden];
  }
})(({
  theme: e,
  ownerState: t
}) => T({
  height: 0,
  overflow: "hidden",
  transition: e.transitions.create("height")
}, t.orientation === "horizontal" && {
  height: "auto",
  width: 0,
  transition: e.transitions.create("width")
}, t.state === "entered" && T({
  height: "auto",
  overflow: "visible"
}, t.orientation === "horizontal" && {
  width: "auto"
}), t.state === "exited" && !t.in && t.collapsedSize === "0px" && {
  visibility: "hidden"
})), xV = B("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})(({
  ownerState: e
}) => T({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%"
}, e.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), yV = B("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (e, t) => t.wrapperInner
})(({
  ownerState: e
}) => T({
  width: "100%"
}, e.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), Ts = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiCollapse"
  }), {
    addEndListener: r,
    children: i,
    className: s,
    collapsedSize: a = "0px",
    component: c,
    easing: d,
    in: u,
    onEnter: p,
    onEntered: h,
    onEntering: g,
    onExit: m,
    onExited: b,
    onExiting: C,
    orientation: x = "vertical",
    style: v,
    timeout: S = Ov.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: M = nr
  } = o, w = le(o, mV), k = T({}, o, {
    orientation: x,
    collapsedSize: a
  }), E = bV(k), R = ge(), O = Xs(), P = y.useRef(null), _ = y.useRef(), L = typeof a == "number" ? `${a}px` : a, V = x === "horizontal", j = V ? "width" : "height", I = y.useRef(null), F = Tt(n, I), $ = (G) => (K) => {
    if (G) {
      const Q = I.current;
      K === void 0 ? G(Q) : G(Q, K);
    }
  }, A = () => P.current ? P.current[V ? "clientWidth" : "clientHeight"] : 0, H = $((G, K) => {
    P.current && V && (P.current.style.position = "absolute"), G.style[j] = L, p && p(G, K);
  }), N = $((G, K) => {
    const Q = A();
    P.current && V && (P.current.style.position = "");
    const {
      duration: re,
      easing: U
    } = Il({
      style: v,
      timeout: S,
      easing: d
    }, {
      mode: "enter"
    });
    if (S === "auto") {
      const W = R.transitions.getAutoHeightDuration(Q);
      G.style.transitionDuration = `${W}ms`, _.current = W;
    } else
      G.style.transitionDuration = typeof re == "string" ? re : `${re}ms`;
    G.style[j] = `${Q}px`, G.style.transitionTimingFunction = U, g && g(G, K);
  }), z = $((G, K) => {
    G.style[j] = "auto", h && h(G, K);
  }), se = $((G) => {
    G.style[j] = `${A()}px`, m && m(G);
  }), ne = $(b), Z = $((G) => {
    const K = A(), {
      duration: Q,
      easing: re
    } = Il({
      style: v,
      timeout: S,
      easing: d
    }, {
      mode: "exit"
    });
    if (S === "auto") {
      const U = R.transitions.getAutoHeightDuration(K);
      G.style.transitionDuration = `${U}ms`, _.current = U;
    } else
      G.style.transitionDuration = typeof Q == "string" ? Q : `${Q}ms`;
    G.style[j] = L, G.style.transitionTimingFunction = re, C && C(G);
  }), q = (G) => {
    S === "auto" && O.start(_.current || 0, G), r && r(I.current, G);
  };
  return /* @__PURE__ */ f.jsx(M, T({
    in: u,
    onEnter: H,
    onEntered: z,
    onEntering: N,
    onExit: se,
    onExited: ne,
    onExiting: Z,
    addEndListener: q,
    nodeRef: I,
    timeout: S === "auto" ? null : S
  }, w, {
    children: (G, K) => /* @__PURE__ */ f.jsx(CV, T({
      as: c,
      className: xe(E.root, s, {
        entered: E.entered,
        exited: !u && L === "0px" && E.hidden
      }[G]),
      style: T({
        [V ? "minWidth" : "minHeight"]: L
      }, v),
      ref: F
    }, K, {
      // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
      // that might have been forwarded from the Transition component.
      ownerState: T({}, k, {
        state: G
      }),
      children: /* @__PURE__ */ f.jsx(xV, {
        ownerState: T({}, k, {
          state: G
        }),
        className: E.wrapper,
        ref: P,
        children: /* @__PURE__ */ f.jsx(yV, {
          ownerState: T({}, k, {
            state: G
          }),
          className: E.wrapperInner,
          children: i
        })
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" && (Ts.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: l.func,
  /**
   * The content node to be collapsed.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: l.oneOfType([l.number, l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Pa,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: l.oneOfType([l.shape({
    enter: l.string,
    exit: l.string
  }), l.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: l.bool,
  /**
   * @ignore
   */
  onEnter: l.func,
  /**
   * @ignore
   */
  onEntered: l.func,
  /**
   * @ignore
   */
  onEntering: l.func,
  /**
   * @ignore
   */
  onExit: l.func,
  /**
   * @ignore
   */
  onExited: l.func,
  /**
   * @ignore
   */
  onExiting: l.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: l.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  style: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: l.oneOfType([l.oneOf(["auto"]), l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })])
});
Ts.muiSupportAuto = !0;
function vV(e) {
  return _e("MuiPaper", e);
}
Re("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const wV = ["className", "component", "elevation", "square", "variant"], SV = (e) => {
  const {
    square: t,
    elevation: n,
    variant: o,
    classes: r
  } = e, i = {
    root: ["root", o, !t && "rounded", o === "elevation" && `elevation${n}`]
  };
  return Oe(i, vV, r);
}, MV = B("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], !n.square && t.rounded, n.variant === "elevation" && t[`elevation${n.elevation}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n;
  return T({
    backgroundColor: (e.vars || e).palette.background.paper,
    color: (e.vars || e).palette.text.primary,
    transition: e.transitions.create("box-shadow")
  }, !t.square && {
    borderRadius: e.shape.borderRadius
  }, t.variant === "outlined" && {
    border: `1px solid ${(e.vars || e).palette.divider}`
  }, t.variant === "elevation" && T({
    boxShadow: (e.vars || e).shadows[t.elevation]
  }, !e.vars && e.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${gt("#fff", W9(t.elevation))}, ${gt("#fff", W9(t.elevation))})`
  }, e.vars && {
    backgroundImage: (n = e.vars.overlays) == null ? void 0 : n[t.elevation]
  }));
}), Tr = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiPaper"
  }), {
    className: r,
    component: i = "div",
    elevation: s = 1,
    square: a = !1,
    variant: c = "elevation"
  } = o, d = le(o, wV), u = T({}, o, {
    component: i,
    elevation: s,
    square: a,
    variant: c
  }), p = SV(u);
  return process.env.NODE_ENV !== "production" && ge().shadows[s] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${s}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${s}]\` is defined.`].join(`
`)), /* @__PURE__ */ f.jsx(MV, T({
    as: i,
    ownerState: u,
    className: xe(p.root, r),
    ref: n
  }, d));
});
process.env.NODE_ENV !== "production" && (Tr.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: vo(Gi, (e) => {
    const {
      elevation: t,
      variant: n
    } = e;
    return t > 0 && n === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${n}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: l.oneOfType([l.oneOf(["elevation", "outlined"]), l.string])
});
const R4 = /* @__PURE__ */ y.createContext({});
process.env.NODE_ENV !== "production" && (R4.displayName = "AccordionContext");
const TV = ["className", "elementType", "ownerState", "externalForwardedProps", "getSlotOwnerState", "internalForwardedProps"], kV = ["component", "slots", "slotProps"], EV = ["component"];
function Wd(e, t) {
  const {
    className: n,
    elementType: o,
    ownerState: r,
    externalForwardedProps: i,
    getSlotOwnerState: s,
    internalForwardedProps: a
  } = t, c = le(t, TV), {
    component: d,
    slots: u = {
      [e]: void 0
    },
    slotProps: p = {
      [e]: void 0
    }
  } = i, h = le(i, kV), g = u[e] || o, m = Kr(p[e], r), b = mv(T({
    className: n
  }, c, {
    externalForwardedProps: e === "root" ? h : void 0,
    externalSlotProps: m
  })), {
    props: {
      component: C
    },
    internalRef: x
  } = b, v = le(b.props, EV), S = Tt(x, m == null ? void 0 : m.ref, t.ref), M = s ? s(v) : {}, w = T({}, r, M), k = e === "root" ? C || d : C, E = dl(g, T({}, e === "root" && !d && !u[e] && a, e !== "root" && !u[e] && a, v, k && {
    as: k
  }, {
    ref: S
  }), w);
  return Object.keys(M).forEach((R) => {
    delete E[R];
  }), [g, E];
}
function RV(e) {
  return _e("MuiAccordion", e);
}
const o1 = Re("MuiAccordion", ["root", "rounded", "expanded", "disabled", "gutters", "region"]), OV = ["children", "className", "defaultExpanded", "disabled", "disableGutters", "expanded", "onChange", "square", "slots", "slotProps", "TransitionComponent", "TransitionProps"], _V = (e) => {
  const {
    classes: t,
    square: n,
    expanded: o,
    disabled: r,
    disableGutters: i
  } = e;
  return Oe({
    root: ["root", !n && "rounded", o && "expanded", r && "disabled", !i && "gutters"],
    region: ["region"]
  }, RV, t);
}, PV = B(Tr, {
  name: "MuiAccordion",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${o1.region}`]: t.region
    }, t.root, !n.square && t.rounded, !n.disableGutters && t.gutters];
  }
})(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    position: "relative",
    transition: e.transitions.create(["margin"], t),
    overflowAnchor: "none",
    // Keep the same scrolling position
    "&::before": {
      position: "absolute",
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: (e.vars || e).palette.divider,
      transition: e.transitions.create(["opacity", "background-color"], t)
    },
    "&:first-of-type": {
      "&::before": {
        display: "none"
      }
    },
    [`&.${o1.expanded}`]: {
      "&::before": {
        opacity: 0
      },
      "&:first-of-type": {
        marginTop: 0
      },
      "&:last-of-type": {
        marginBottom: 0
      },
      "& + &": {
        "&::before": {
          display: "none"
        }
      }
    },
    [`&.${o1.disabled}`]: {
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    }
  };
}, ({
  theme: e
}) => ({
  variants: [{
    props: (t) => !t.square,
    style: {
      borderRadius: 0,
      "&:first-of-type": {
        borderTopLeftRadius: (e.vars || e).shape.borderRadius,
        borderTopRightRadius: (e.vars || e).shape.borderRadius
      },
      "&:last-of-type": {
        borderBottomLeftRadius: (e.vars || e).shape.borderRadius,
        borderBottomRightRadius: (e.vars || e).shape.borderRadius,
        // Fix a rendering issue on Edge
        "@supports (-ms-ime-align: auto)": {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    }
  }, {
    props: (t) => !t.disableGutters,
    style: {
      [`&.${o1.expanded}`]: {
        margin: "16px 0"
      }
    }
  }]
})), O4 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiAccordion"
  }), {
    children: r,
    className: i,
    defaultExpanded: s = !1,
    disabled: a = !1,
    disableGutters: c = !1,
    expanded: d,
    onChange: u,
    square: p = !1,
    slots: h = {},
    slotProps: g = {},
    TransitionComponent: m,
    TransitionProps: b
  } = o, C = le(o, OV), [x, v] = Fn({
    controlled: d,
    default: s,
    name: "Accordion",
    state: "expanded"
  }), S = y.useCallback((V) => {
    v(!x), u && u(V, !x);
  }, [x, u, v]), [M, ...w] = y.Children.toArray(r), k = y.useMemo(() => ({
    expanded: x,
    disabled: a,
    disableGutters: c,
    toggle: S
  }), [x, a, c, S]), E = T({}, o, {
    square: p,
    disabled: a,
    disableGutters: c,
    expanded: x
  }), R = _V(E), O = T({
    transition: m
  }, h), P = T({
    transition: b
  }, g), [_, L] = Wd("transition", {
    elementType: Ts,
    externalForwardedProps: {
      slots: O,
      slotProps: P
    },
    ownerState: E
  });
  return /* @__PURE__ */ f.jsxs(PV, T({
    className: xe(R.root, i),
    ref: n,
    ownerState: E,
    square: p
  }, C, {
    children: [/* @__PURE__ */ f.jsx(R4.Provider, {
      value: k,
      children: M
    }), /* @__PURE__ */ f.jsx(_, T({
      in: x,
      timeout: "auto"
    }, L, {
      children: /* @__PURE__ */ f.jsx("div", {
        "aria-labelledby": M.props.id,
        id: M.props["aria-controls"],
        role: "region",
        className: R.region,
        children: w
      })
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (O4.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: vo(l.node.isRequired, (e) => {
    const t = y.Children.toArray(e.children)[0];
    return xa.isFragment(t) ? new Error("MUI: The Accordion doesn't accept a Fragment as a child. Consider providing an array instead.") : /* @__PURE__ */ y.isValidElement(t) ? null : new Error("MUI: Expected the first child of Accordion to be a valid element.");
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, expands the accordion by default.
   * @default false
   */
  defaultExpanded: l.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, it removes the margin between two expanded accordion items and the increase of height.
   * @default false
   */
  disableGutters: l.bool,
  /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */
  expanded: l.bool,
  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */
  onChange: l.func,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: l.shape({
    transition: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: l.shape({
    transition: l.elementType
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */
  TransitionComponent: l.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */
  TransitionProps: l.object
});
function LV(e) {
  return _e("MuiAccordionDetails", e);
}
Re("MuiAccordionDetails", ["root"]);
const IV = ["className"], jV = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"]
  }, LV, t);
}, VV = B("div", {
  name: "MuiAccordionDetails",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  padding: e.spacing(1, 2, 2)
})), _4 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiAccordionDetails"
  }), {
    className: r
  } = o, i = le(o, IV), s = o, a = jV(s);
  return /* @__PURE__ */ f.jsx(VV, T({
    className: xe(a.root, r),
    ref: n,
    ownerState: s
  }, i));
});
process.env.NODE_ENV !== "production" && (_4.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function jv(e) {
  const {
    className: t,
    classes: n,
    pulsate: o = !1,
    rippleX: r,
    rippleY: i,
    rippleSize: s,
    in: a,
    onExited: c,
    timeout: d
  } = e, [u, p] = y.useState(!1), h = xe(t, n.ripple, n.rippleVisible, o && n.ripplePulsate), g = {
    width: s,
    height: s,
    top: -(s / 2) + i,
    left: -(s / 2) + r
  }, m = xe(n.child, u && n.childLeaving, o && n.childPulsate);
  return !a && !u && p(!0), y.useEffect(() => {
    if (!a && c != null) {
      const b = setTimeout(c, d);
      return () => {
        clearTimeout(b);
      };
    }
  }, [c, a, d]), /* @__PURE__ */ f.jsx("span", {
    className: h,
    style: g,
    children: /* @__PURE__ */ f.jsx("span", {
      className: m
    })
  });
}
process.env.NODE_ENV !== "production" && (jv.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object.isRequired,
  className: l.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: l.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: l.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: l.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: l.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: l.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: l.number,
  /**
   * exit delay
   */
  timeout: l.number.isRequired
});
const cr = Re("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), DV = ["center", "classes", "className"];
let C3 = (e) => e, q9, K9, Y9, X9;
const Dp = 550, AV = 80, HV = Dr(q9 || (q9 = C3`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), FV = Dr(K9 || (K9 = C3`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), NV = Dr(Y9 || (Y9 = C3`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), $V = B("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), BV = B(jv, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(X9 || (X9 = C3`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), cr.rippleVisible, HV, Dp, ({
  theme: e
}) => e.transitions.easing.easeInOut, cr.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, cr.child, cr.childLeaving, FV, Dp, ({
  theme: e
}) => e.transitions.easing.easeInOut, cr.childPulsate, NV, ({
  theme: e
}) => e.transitions.easing.easeInOut), Vv = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: r = !1,
    classes: i = {},
    className: s
  } = o, a = le(o, DV), [c, d] = y.useState([]), u = y.useRef(0), p = y.useRef(null);
  y.useEffect(() => {
    p.current && (p.current(), p.current = null);
  }, [c]);
  const h = y.useRef(!1), g = Xs(), m = y.useRef(null), b = y.useRef(null), C = y.useCallback((M) => {
    const {
      pulsate: w,
      rippleX: k,
      rippleY: E,
      rippleSize: R,
      cb: O
    } = M;
    d((P) => [...P, /* @__PURE__ */ f.jsx(BV, {
      classes: {
        ripple: xe(i.ripple, cr.ripple),
        rippleVisible: xe(i.rippleVisible, cr.rippleVisible),
        ripplePulsate: xe(i.ripplePulsate, cr.ripplePulsate),
        child: xe(i.child, cr.child),
        childLeaving: xe(i.childLeaving, cr.childLeaving),
        childPulsate: xe(i.childPulsate, cr.childPulsate)
      },
      timeout: Dp,
      pulsate: w,
      rippleX: k,
      rippleY: E,
      rippleSize: R
    }, u.current)]), u.current += 1, p.current = O;
  }, [i]), x = y.useCallback((M = {}, w = {}, k = () => {
  }) => {
    const {
      pulsate: E = !1,
      center: R = r || w.pulsate,
      fakeElement: O = !1
      // For test purposes
    } = w;
    if ((M == null ? void 0 : M.type) === "mousedown" && h.current) {
      h.current = !1;
      return;
    }
    (M == null ? void 0 : M.type) === "touchstart" && (h.current = !0);
    const P = O ? null : b.current, _ = P ? P.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let L, V, j;
    if (R || M === void 0 || M.clientX === 0 && M.clientY === 0 || !M.clientX && !M.touches)
      L = Math.round(_.width / 2), V = Math.round(_.height / 2);
    else {
      const {
        clientX: I,
        clientY: F
      } = M.touches && M.touches.length > 0 ? M.touches[0] : M;
      L = Math.round(I - _.left), V = Math.round(F - _.top);
    }
    if (R)
      j = Math.sqrt((2 * _.width ** 2 + _.height ** 2) / 3), j % 2 === 0 && (j += 1);
    else {
      const I = Math.max(Math.abs((P ? P.clientWidth : 0) - L), L) * 2 + 2, F = Math.max(Math.abs((P ? P.clientHeight : 0) - V), V) * 2 + 2;
      j = Math.sqrt(I ** 2 + F ** 2);
    }
    M != null && M.touches ? m.current === null && (m.current = () => {
      C({
        pulsate: E,
        rippleX: L,
        rippleY: V,
        rippleSize: j,
        cb: k
      });
    }, g.start(AV, () => {
      m.current && (m.current(), m.current = null);
    })) : C({
      pulsate: E,
      rippleX: L,
      rippleY: V,
      rippleSize: j,
      cb: k
    });
  }, [r, C, g]), v = y.useCallback(() => {
    x({}, {
      pulsate: !0
    });
  }, [x]), S = y.useCallback((M, w) => {
    if (g.clear(), (M == null ? void 0 : M.type) === "touchend" && m.current) {
      m.current(), m.current = null, g.start(0, () => {
        S(M, w);
      });
      return;
    }
    m.current = null, d((k) => k.length > 0 ? k.slice(1) : k), p.current = w;
  }, [g]);
  return y.useImperativeHandle(n, () => ({
    pulsate: v,
    start: x,
    stop: S
  }), [v, x, S]), /* @__PURE__ */ f.jsx($V, T({
    className: xe(cr.root, i.root, s),
    ref: b
  }, a, {
    children: /* @__PURE__ */ f.jsx(k0, {
      component: null,
      exit: !0,
      children: c
    })
  }));
});
process.env.NODE_ENV !== "production" && (Vv.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string
});
function zV(e) {
  return _e("MuiButtonBase", e);
}
const ZV = Re("MuiButtonBase", ["root", "disabled", "focusVisible"]), WV = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], UV = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: o,
    classes: r
  } = e, s = Oe({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, zV, r);
  return n && o && (s.root += ` ${o}`), s;
}, GV = B("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${ZV.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), wo = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: r,
    centerRipple: i = !1,
    children: s,
    className: a,
    component: c = "button",
    disabled: d = !1,
    disableRipple: u = !1,
    disableTouchRipple: p = !1,
    focusRipple: h = !1,
    LinkComponent: g = "a",
    onBlur: m,
    onClick: b,
    onContextMenu: C,
    onDragLeave: x,
    onFocus: v,
    onFocusVisible: S,
    onKeyDown: M,
    onKeyUp: w,
    onMouseDown: k,
    onMouseLeave: E,
    onMouseUp: R,
    onTouchEnd: O,
    onTouchMove: P,
    onTouchStart: _,
    tabIndex: L = 0,
    TouchRippleProps: V,
    touchRippleRef: j,
    type: I
  } = o, F = le(o, WV), $ = y.useRef(null), A = y.useRef(null), H = Tt(A, j), {
    isFocusVisibleRef: N,
    onFocus: z,
    onBlur: se,
    ref: ne
  } = S0(), [Z, q] = y.useState(!1);
  d && Z && q(!1), y.useImperativeHandle(r, () => ({
    focusVisible: () => {
      q(!0), $.current.focus();
    }
  }), []);
  const [G, K] = y.useState(!1);
  y.useEffect(() => {
    K(!0);
  }, []);
  const Q = G && !u && !d;
  y.useEffect(() => {
    Z && h && !u && G && A.current.pulsate();
  }, [u, h, Z, G]);
  function re(ae, Te, tt = p) {
    return Ke((Ye) => (Te && Te(Ye), !tt && A.current && A.current[ae](Ye), !0));
  }
  const U = re("start", k), W = re("stop", C), D = re("stop", x), X = re("stop", R), de = re("stop", (ae) => {
    Z && ae.preventDefault(), E && E(ae);
  }), ue = re("start", _), he = re("stop", O), Ue = re("stop", P), me = re("stop", (ae) => {
    se(ae), N.current === !1 && q(!1), m && m(ae);
  }, !1), Ie = Ke((ae) => {
    $.current || ($.current = ae.currentTarget), z(ae), N.current === !0 && (q(!0), S && S(ae)), v && v(ae);
  }), te = () => {
    const ae = $.current;
    return c && c !== "button" && !(ae.tagName === "A" && ae.href);
  }, ie = y.useRef(!1), ye = Ke((ae) => {
    h && !ie.current && Z && A.current && ae.key === " " && (ie.current = !0, A.current.stop(ae, () => {
      A.current.start(ae);
    })), ae.target === ae.currentTarget && te() && ae.key === " " && ae.preventDefault(), M && M(ae), ae.target === ae.currentTarget && te() && ae.key === "Enter" && !d && (ae.preventDefault(), b && b(ae));
  }), Ne = Ke((ae) => {
    h && ae.key === " " && A.current && Z && !ae.defaultPrevented && (ie.current = !1, A.current.stop(ae, () => {
      A.current.pulsate(ae);
    })), w && w(ae), b && ae.target === ae.currentTarget && te() && ae.key === " " && !ae.defaultPrevented && b(ae);
  });
  let We = c;
  We === "button" && (F.href || F.to) && (We = g);
  const qe = {};
  We === "button" ? (qe.type = I === void 0 ? "button" : I, qe.disabled = d) : (!F.href && !F.to && (qe.role = "button"), d && (qe["aria-disabled"] = d));
  const Me = Tt(n, ne, $);
  process.env.NODE_ENV !== "production" && y.useEffect(() => {
    Q && !A.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [Q]);
  const Pe = T({}, o, {
    centerRipple: i,
    component: c,
    disabled: d,
    disableRipple: u,
    disableTouchRipple: p,
    focusRipple: h,
    tabIndex: L,
    focusVisible: Z
  }), fe = UV(Pe);
  return /* @__PURE__ */ f.jsxs(GV, T({
    as: We,
    className: xe(fe.root, a),
    ownerState: Pe,
    onBlur: me,
    onClick: b,
    onContextMenu: W,
    onFocus: Ie,
    onKeyDown: ye,
    onKeyUp: Ne,
    onMouseDown: U,
    onMouseLeave: de,
    onMouseUp: X,
    onDragLeave: D,
    onTouchEnd: he,
    onTouchMove: Ue,
    onTouchStart: ue,
    ref: Me,
    tabIndex: d ? -1 : L,
    type: I
  }, qe, F, {
    children: [s, Q ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ f.jsx(Vv, T({
        ref: H,
        center: i
      }, V))
    ) : null]
  }));
});
process.env.NODE_ENV !== "production" && (wo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: sn,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: l.bool,
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Pa,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: l.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: l.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: l.string,
  /**
   * @ignore
   */
  href: l.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: l.elementType,
  /**
   * @ignore
   */
  onBlur: l.func,
  /**
   * @ignore
   */
  onClick: l.func,
  /**
   * @ignore
   */
  onContextMenu: l.func,
  /**
   * @ignore
   */
  onDragLeave: l.func,
  /**
   * @ignore
   */
  onFocus: l.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: l.func,
  /**
   * @ignore
   */
  onKeyDown: l.func,
  /**
   * @ignore
   */
  onKeyUp: l.func,
  /**
   * @ignore
   */
  onMouseDown: l.func,
  /**
   * @ignore
   */
  onMouseLeave: l.func,
  /**
   * @ignore
   */
  onMouseUp: l.func,
  /**
   * @ignore
   */
  onTouchEnd: l.func,
  /**
   * @ignore
   */
  onTouchMove: l.func,
  /**
   * @ignore
   */
  onTouchStart: l.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * @default 0
   */
  tabIndex: l.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: l.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: l.oneOfType([l.func, l.shape({
    current: l.shape({
      pulsate: l.func.isRequired,
      start: l.func.isRequired,
      stop: l.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: l.oneOfType([l.oneOf(["button", "reset", "submit"]), l.string])
});
function qV(e) {
  return _e("MuiAccordionSummary", e);
}
const ul = Re("MuiAccordionSummary", ["root", "expanded", "focusVisible", "disabled", "gutters", "contentGutters", "content", "expandIconWrapper"]), KV = ["children", "className", "expandIcon", "focusVisibleClassName", "onClick"], YV = (e) => {
  const {
    classes: t,
    expanded: n,
    disabled: o,
    disableGutters: r
  } = e;
  return Oe({
    root: ["root", n && "expanded", o && "disabled", !r && "gutters"],
    focusVisible: ["focusVisible"],
    content: ["content", n && "expanded", !r && "contentGutters"],
    expandIconWrapper: ["expandIconWrapper", n && "expanded"]
  }, qV, t);
}, XV = B(wo, {
  name: "MuiAccordionSummary",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    display: "flex",
    minHeight: 48,
    padding: e.spacing(0, 2),
    transition: e.transitions.create(["min-height", "background-color"], t),
    [`&.${ul.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    [`&.${ul.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity
    },
    [`&:hover:not(.${ul.disabled})`]: {
      cursor: "pointer"
    },
    variants: [{
      props: (n) => !n.disableGutters,
      style: {
        [`&.${ul.expanded}`]: {
          minHeight: 64
        }
      }
    }]
  };
}), JV = B("div", {
  name: "MuiAccordionSummary",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})(({
  theme: e
}) => ({
  display: "flex",
  flexGrow: 1,
  margin: "12px 0",
  variants: [{
    props: (t) => !t.disableGutters,
    style: {
      transition: e.transitions.create(["margin"], {
        duration: e.transitions.duration.shortest
      }),
      [`&.${ul.expanded}`]: {
        margin: "20px 0"
      }
    }
  }]
})), QV = B("div", {
  name: "MuiAccordionSummary",
  slot: "ExpandIconWrapper",
  overridesResolver: (e, t) => t.expandIconWrapper
})(({
  theme: e
}) => ({
  display: "flex",
  color: (e.vars || e).palette.action.active,
  transform: "rotate(0deg)",
  transition: e.transitions.create("transform", {
    duration: e.transitions.duration.shortest
  }),
  [`&.${ul.expanded}`]: {
    transform: "rotate(180deg)"
  }
})), P4 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiAccordionSummary"
  }), {
    children: r,
    className: i,
    expandIcon: s,
    focusVisibleClassName: a,
    onClick: c
  } = o, d = le(o, KV), {
    disabled: u = !1,
    disableGutters: p,
    expanded: h,
    toggle: g
  } = y.useContext(R4), m = (x) => {
    g && g(x), c && c(x);
  }, b = T({}, o, {
    expanded: h,
    disabled: u,
    disableGutters: p
  }), C = YV(b);
  return /* @__PURE__ */ f.jsxs(XV, T({
    focusRipple: !1,
    disableRipple: !0,
    disabled: u,
    component: "div",
    "aria-expanded": h,
    className: xe(C.root, i),
    focusVisibleClassName: xe(C.focusVisible, a),
    onClick: m,
    ref: n,
    ownerState: b
  }, d, {
    children: [/* @__PURE__ */ f.jsx(JV, {
      className: C.content,
      ownerState: b,
      children: r
    }), s && /* @__PURE__ */ f.jsx(QV, {
      className: C.expandIconWrapper,
      ownerState: b,
      children: s
    })]
  }));
});
process.env.NODE_ENV !== "production" && (P4.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: l.node,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: l.string,
  /**
   * @ignore
   */
  onClick: l.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function eD(e) {
  return _e("MuiAlert", e);
}
const J9 = Re("MuiAlert", ["root", "action", "icon", "message", "filled", "colorSuccess", "colorInfo", "colorWarning", "colorError", "filledSuccess", "filledInfo", "filledWarning", "filledError", "outlined", "outlinedSuccess", "outlinedInfo", "outlinedWarning", "outlinedError", "standard", "standardSuccess", "standardInfo", "standardWarning", "standardError"]);
function tD(e) {
  return _e("MuiIconButton", e);
}
const nD = Re("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), oD = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"], rD = (e) => {
  const {
    classes: t,
    disabled: n,
    color: o,
    edge: r,
    size: i
  } = e, s = {
    root: ["root", n && "disabled", o !== "default" && `color${pe(o)}`, r && `edge${pe(r)}`, `size${pe(i)}`]
  };
  return Oe(s, tD, t);
}, iD = B(wo, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${pe(n.color)}`], n.edge && t[`edge${pe(n.edge)}`], t[`size${pe(n.size)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => T({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  overflow: "visible",
  // Explicitly set the default value to solve a bug on IE11.
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  })
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : gt(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.edge === "start" && {
  marginLeft: t.size === "small" ? -3 : -12
}, t.edge === "end" && {
  marginRight: t.size === "small" ? -3 : -12
}), ({
  theme: e,
  ownerState: t
}) => {
  var n;
  const o = (n = (e.vars || e).palette) == null ? void 0 : n[t.color];
  return T({}, t.color === "inherit" && {
    color: "inherit"
  }, t.color !== "inherit" && t.color !== "default" && T({
    color: o == null ? void 0 : o.main
  }, !t.disableRipple && {
    "&:hover": T({}, o && {
      backgroundColor: e.vars ? `rgba(${o.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : gt(o.main, e.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    })
  }), t.size === "small" && {
    padding: 5,
    fontSize: e.typography.pxToRem(18)
  }, t.size === "large" && {
    padding: 12,
    fontSize: e.typography.pxToRem(28)
  }, {
    [`&.${nD.disabled}`]: {
      backgroundColor: "transparent",
      color: (e.vars || e).palette.action.disabled
    }
  });
}), Bt = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: r = !1,
    children: i,
    className: s,
    color: a = "default",
    disabled: c = !1,
    disableFocusRipple: d = !1,
    size: u = "medium"
  } = o, p = le(o, oD), h = T({}, o, {
    edge: r,
    color: a,
    disabled: c,
    disableFocusRipple: d,
    size: u
  }), g = rD(h);
  return /* @__PURE__ */ f.jsx(iD, T({
    className: xe(g.root, s),
    centerRipple: !0,
    focusRipple: !d,
    disabled: c,
    ref: n
  }, p, {
    ownerState: h,
    children: i
  }));
});
process.env.NODE_ENV !== "production" && (Bt.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: vo(l.node, (e) => y.Children.toArray(e.children).some((n) => /* @__PURE__ */ y.isValidElement(n) && n.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: l.oneOfType([l.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: l.oneOf(["end", "start", !1]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["small", "medium", "large"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const sD = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined"), aD = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined"), lD = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline"), cD = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined"), Dv = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), dD = ["action", "children", "className", "closeText", "color", "components", "componentsProps", "icon", "iconMapping", "onClose", "role", "severity", "slotProps", "slots", "variant"], uD = (e) => {
  const {
    variant: t,
    color: n,
    severity: o,
    classes: r
  } = e, i = {
    root: ["root", `color${pe(n || o)}`, `${t}${pe(n || o)}`, `${t}`],
    icon: ["icon"],
    message: ["message"],
    action: ["action"]
  };
  return Oe(i, eD, r);
}, fD = B(Tr, {
  name: "MuiAlert",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${pe(n.color || n.severity)}`]];
  }
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? ya : va, n = e.palette.mode === "light" ? va : ya;
  return T({}, e.typography.body2, {
    backgroundColor: "transparent",
    display: "flex",
    padding: "6px 16px",
    variants: [...Object.entries(e.palette).filter(([, o]) => o.main && o.light).map(([o]) => ({
      props: {
        colorSeverity: o,
        variant: "standard"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${o}Color`] : t(e.palette[o].light, 0.6),
        backgroundColor: e.vars ? e.vars.palette.Alert[`${o}StandardBg`] : n(e.palette[o].light, 0.9),
        [`& .${J9.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${o}IconColor`]
        } : {
          color: e.palette[o].main
        }
      }
    })), ...Object.entries(e.palette).filter(([, o]) => o.main && o.light).map(([o]) => ({
      props: {
        colorSeverity: o,
        variant: "outlined"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${o}Color`] : t(e.palette[o].light, 0.6),
        border: `1px solid ${(e.vars || e).palette[o].light}`,
        [`& .${J9.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${o}IconColor`]
        } : {
          color: e.palette[o].main
        }
      }
    })), ...Object.entries(e.palette).filter(([, o]) => o.main && o.dark).map(([o]) => ({
      props: {
        colorSeverity: o,
        variant: "filled"
      },
      style: T({
        fontWeight: e.typography.fontWeightMedium
      }, e.vars ? {
        color: e.vars.palette.Alert[`${o}FilledColor`],
        backgroundColor: e.vars.palette.Alert[`${o}FilledBg`]
      } : {
        backgroundColor: e.palette.mode === "dark" ? e.palette[o].dark : e.palette[o].main,
        color: e.palette.getContrastText(e.palette[o].main)
      })
    }))]
  });
}), pD = B("div", {
  name: "MuiAlert",
  slot: "Icon",
  overridesResolver: (e, t) => t.icon
})({
  marginRight: 12,
  padding: "7px 0",
  display: "flex",
  fontSize: 22,
  opacity: 0.9
}), hD = B("div", {
  name: "MuiAlert",
  slot: "Message",
  overridesResolver: (e, t) => t.message
})({
  padding: "8px 0",
  minWidth: 0,
  overflow: "auto"
}), Q9 = B("div", {
  name: "MuiAlert",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  display: "flex",
  alignItems: "flex-start",
  padding: "4px 0 0 16px",
  marginLeft: "auto",
  marginRight: -8
}), eg = {
  success: /* @__PURE__ */ f.jsx(sD, {
    fontSize: "inherit"
  }),
  warning: /* @__PURE__ */ f.jsx(aD, {
    fontSize: "inherit"
  }),
  error: /* @__PURE__ */ f.jsx(lD, {
    fontSize: "inherit"
  }),
  info: /* @__PURE__ */ f.jsx(cD, {
    fontSize: "inherit"
  })
}, Av = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiAlert"
  }), {
    action: r,
    children: i,
    className: s,
    closeText: a = "Close",
    color: c,
    components: d = {},
    componentsProps: u = {},
    icon: p,
    iconMapping: h = eg,
    onClose: g,
    role: m = "alert",
    severity: b = "success",
    slotProps: C = {},
    slots: x = {},
    variant: v = "standard"
  } = o, S = le(o, dD), M = T({}, o, {
    color: c,
    severity: b,
    variant: v,
    colorSeverity: c || b
  }), w = uD(M), k = {
    slots: T({
      closeButton: d.CloseButton,
      closeIcon: d.CloseIcon
    }, x),
    slotProps: T({}, u, C)
  }, [E, R] = Wd("closeButton", {
    elementType: Bt,
    externalForwardedProps: k,
    ownerState: M
  }), [O, P] = Wd("closeIcon", {
    elementType: Dv,
    externalForwardedProps: k,
    ownerState: M
  });
  return /* @__PURE__ */ f.jsxs(fD, T({
    role: m,
    elevation: 0,
    ownerState: M,
    className: xe(w.root, s),
    ref: n
  }, S, {
    children: [p !== !1 ? /* @__PURE__ */ f.jsx(pD, {
      ownerState: M,
      className: w.icon,
      children: p || h[b] || eg[b]
    }) : null, /* @__PURE__ */ f.jsx(hD, {
      ownerState: M,
      className: w.message,
      children: i
    }), r != null ? /* @__PURE__ */ f.jsx(Q9, {
      ownerState: M,
      className: w.action,
      children: r
    }) : null, r == null && g ? /* @__PURE__ */ f.jsx(Q9, {
      ownerState: M,
      className: w.action,
      children: /* @__PURE__ */ f.jsx(E, T({
        size: "small",
        "aria-label": a,
        title: a,
        color: "inherit",
        onClick: g
      }, R, {
        children: /* @__PURE__ */ f.jsx(O, T({
          fontSize: "small"
        }, P))
      }))
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (Av.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: l.node,
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: l.string,
  /**
   * The color of the component. Unless provided, the value is taken from the `severity` prop.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: l.oneOfType([l.oneOf(["error", "info", "success", "warning"]), l.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */
  components: l.shape({
    CloseButton: l.elementType,
    CloseIcon: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */
  componentsProps: l.shape({
    closeButton: l.object,
    closeIcon: l.object
  }),
  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   * Set to `false` to remove the `icon`.
   */
  icon: l.node,
  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: l.shape({
    error: l.node,
    info: l.node,
    success: l.node,
    warning: l.node
  }),
  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: l.func,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: l.string,
  /**
   * The severity of the alert. This defines the color and icon used.
   * @default 'success'
   */
  severity: l.oneOfType([l.oneOf(["error", "info", "success", "warning"]), l.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: l.shape({
    closeButton: l.oneOfType([l.func, l.object]),
    closeIcon: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: l.shape({
    closeButton: l.elementType,
    closeIcon: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: l.oneOfType([l.oneOf(["filled", "outlined", "standard"]), l.string])
});
function gD(e) {
  return _e("MuiTypography", e);
}
Re("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const mD = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"], bD = (e) => {
  const {
    align: t,
    gutterBottom: n,
    noWrap: o,
    paragraph: r,
    variant: i,
    classes: s
  } = e, a = {
    root: ["root", i, e.align !== "inherit" && `align${pe(t)}`, n && "gutterBottom", o && "noWrap", r && "paragraph"]
  };
  return Oe(a, gD, s);
}, CD = B("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.variant && t[n.variant], n.align !== "inherit" && t[`align${pe(n.align)}`], n.noWrap && t.noWrap, n.gutterBottom && t.gutterBottom, n.paragraph && t.paragraph];
  }
})(({
  theme: e,
  ownerState: t
}) => T({
  margin: 0
}, t.variant === "inherit" && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: "inherit"
}, t.variant !== "inherit" && e.typography[t.variant], t.align !== "inherit" && {
  textAlign: t.align
}, t.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, t.gutterBottom && {
  marginBottom: "0.35em"
}, t.paragraph && {
  marginBottom: 16
})), tg = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, xD = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, yD = (e) => xD[e] || e, oe = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiTypography"
  }), r = yD(o.color), i = x0(T({}, o, {
    color: r
  })), {
    align: s = "inherit",
    className: a,
    component: c,
    gutterBottom: d = !1,
    noWrap: u = !1,
    paragraph: p = !1,
    variant: h = "body1",
    variantMapping: g = tg
  } = i, m = le(i, mD), b = T({}, i, {
    align: s,
    color: r,
    className: a,
    component: c,
    gutterBottom: d,
    noWrap: u,
    paragraph: p,
    variant: h,
    variantMapping: g
  }), C = c || (p ? "p" : g[h] || tg[h]) || "span", x = bD(b);
  return /* @__PURE__ */ f.jsx(CD, T({
    as: C,
    ref: n,
    ownerState: b,
    className: xe(x.root, a)
  }, m));
});
process.env.NODE_ENV !== "production" && (oe.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: l.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: l.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: l.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: l.oneOfType([l.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), l.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: l.object
});
function vD(e) {
  return _e("MuiAlertTitle", e);
}
Re("MuiAlertTitle", ["root"]);
const wD = ["className"], SD = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"]
  }, vD, t);
}, MD = B(oe, {
  name: "MuiAlertTitle",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  fontWeight: e.typography.fontWeightMedium,
  marginTop: -2
})), Hv = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiAlertTitle"
  }), {
    className: r
  } = o, i = le(o, wD), s = o, a = SD(s);
  return /* @__PURE__ */ f.jsx(MD, T({
    gutterBottom: !0,
    component: "div",
    ownerState: s,
    ref: n,
    className: xe(a.root, r)
  }, i));
});
process.env.NODE_ENV !== "production" && (Hv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function ng(e) {
  return typeof e.normalize < "u" ? e.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : e;
}
function TD(e = {}) {
  const {
    ignoreAccents: t = !0,
    ignoreCase: n = !0,
    limit: o,
    matchFrom: r = "any",
    stringify: i,
    trim: s = !1
  } = e;
  return (a, {
    inputValue: c,
    getOptionLabel: d
  }) => {
    let u = s ? c.trim() : c;
    n && (u = u.toLowerCase()), t && (u = ng(u));
    const p = u ? a.filter((h) => {
      let g = (i || d)(h);
      return n && (g = g.toLowerCase()), t && (g = ng(g)), r === "start" ? g.indexOf(u) === 0 : g.indexOf(u) > -1;
    }) : a;
    return typeof o == "number" ? p.slice(0, o) : p;
  };
}
function r1(e, t) {
  for (let n = 0; n < e.length; n += 1)
    if (t(e[n]))
      return n;
  return -1;
}
const kD = TD(), ED = 5, RD = (e) => {
  var t;
  return e.current !== null && ((t = e.current.parentElement) == null ? void 0 : t.contains(document.activeElement));
}, OD = [];
function Fv(e) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: t = RD,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: n = "Mui",
    autoComplete: o = !1,
    autoHighlight: r = !1,
    autoSelect: i = !1,
    blurOnSelect: s = !1,
    clearOnBlur: a = !e.freeSolo,
    clearOnEscape: c = !1,
    componentName: d = "useAutocomplete",
    defaultValue: u = e.multiple ? OD : null,
    disableClearable: p = !1,
    disableCloseOnSelect: h = !1,
    disabled: g,
    disabledItemsFocusable: m = !1,
    disableListWrap: b = !1,
    filterOptions: C = kD,
    filterSelectedOptions: x = !1,
    freeSolo: v = !1,
    getOptionDisabled: S,
    getOptionKey: M,
    getOptionLabel: w = (ce) => {
      var ee;
      return (ee = ce.label) != null ? ee : ce;
    },
    groupBy: k,
    handleHomeEndKeys: E = !e.freeSolo,
    id: R,
    includeInputInList: O = !1,
    inputValue: P,
    isOptionEqualToValue: _ = (ce, ee) => ce === ee,
    multiple: L = !1,
    onChange: V,
    onClose: j,
    onHighlightChange: I,
    onInputChange: F,
    onOpen: $,
    open: A,
    openOnFocus: H = !1,
    options: N,
    readOnly: z = !1,
    selectOnFocus: se = !e.freeSolo,
    value: ne
  } = e, Z = di(R);
  let q = w;
  q = (ce) => {
    const ee = w(ce);
    if (typeof ee != "string") {
      if (process.env.NODE_ENV !== "production") {
        const we = ee === void 0 ? "undefined" : `${typeof ee} (${ee})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${d} returned ${we} instead of a string for ${JSON.stringify(ce)}.`);
      }
      return String(ee);
    }
    return ee;
  };
  const G = y.useRef(!1), K = y.useRef(!0), Q = y.useRef(null), re = y.useRef(null), [U, W] = y.useState(null), [D, X] = y.useState(-1), de = r ? 0 : -1, ue = y.useRef(de), [he, Ue] = Fn({
    controlled: ne,
    default: u,
    name: d
  }), [me, Ie] = Fn({
    controlled: P,
    default: "",
    name: d,
    state: "inputValue"
  }), [te, ie] = y.useState(!1), ye = y.useCallback((ce, ee) => {
    if (!(L ? he.length < ee.length : ee !== null) && !a)
      return;
    let De;
    if (L)
      De = "";
    else if (ee == null)
      De = "";
    else {
      const nt = q(ee);
      De = typeof nt == "string" ? nt : "";
    }
    me !== De && (Ie(De), F && F(ce, De, "reset"));
  }, [q, me, L, F, Ie, a, he]), [Ne, We] = Fn({
    controlled: A,
    default: !1,
    name: d,
    state: "open"
  }), [qe, Me] = y.useState(!0), Pe = !L && he != null && me === q(he), fe = Ne && !z, ae = fe ? C(
    N.filter((ce) => !(x && (L ? he : [he]).some((ee) => ee !== null && _(ce, ee)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: Pe && qe ? "" : me,
      getOptionLabel: q
    }
  ) : [], Te = x4({
    filteredOptions: ae,
    value: he,
    inputValue: me
  });
  y.useEffect(() => {
    const ce = he !== Te.value;
    te && !ce || v && !ce || ye(null, he);
  }, [he, ye, te, Te.value, v]);
  const tt = Ne && ae.length > 0 && !z;
  if (process.env.NODE_ENV !== "production" && he !== null && !v && N.length > 0) {
    const ce = (L ? he : [he]).filter((ee) => !N.some((we) => _(we, ee)));
    ce.length > 0 && console.warn([`MUI: The value provided to ${d} is invalid.`, `None of the options match with \`${ce.length > 1 ? JSON.stringify(ce) : JSON.stringify(ce[0])}\`.`, "You can use the `isOptionEqualToValue` prop to customize the equality test."].join(`
`));
  }
  const Ye = Ke((ce) => {
    ce === -1 ? Q.current.focus() : U.querySelector(`[data-tag-index="${ce}"]`).focus();
  });
  y.useEffect(() => {
    L && D > he.length - 1 && (X(-1), Ye(-1));
  }, [he, L, D, Ye]);
  function Le(ce, ee) {
    if (!re.current || ce < 0 || ce >= ae.length)
      return -1;
    let we = ce;
    for (; ; ) {
      const De = re.current.querySelector(`[data-option-index="${we}"]`), nt = m ? !1 : !De || De.disabled || De.getAttribute("aria-disabled") === "true";
      if (De && De.hasAttribute("tabindex") && !nt)
        return we;
      if (ee === "next" ? we = (we + 1) % ae.length : we = (we - 1 + ae.length) % ae.length, we === ce)
        return -1;
    }
  }
  const Ve = Ke(({
    event: ce,
    index: ee,
    reason: we = "auto"
  }) => {
    if (ue.current = ee, ee === -1 ? Q.current.removeAttribute("aria-activedescendant") : Q.current.setAttribute("aria-activedescendant", `${Z}-option-${ee}`), I && I(ce, ee === -1 ? null : ae[ee], we), !re.current)
      return;
    const De = re.current.querySelector(`[role="option"].${n}-focused`);
    De && (De.classList.remove(`${n}-focused`), De.classList.remove(`${n}-focusVisible`));
    let nt = re.current;
    if (re.current.getAttribute("role") !== "listbox" && (nt = re.current.parentElement.querySelector('[role="listbox"]')), !nt)
      return;
    if (ee === -1) {
      nt.scrollTop = 0;
      return;
    }
    const ze = re.current.querySelector(`[data-option-index="${ee}"]`);
    if (ze && (ze.classList.add(`${n}-focused`), we === "keyboard" && ze.classList.add(`${n}-focusVisible`), nt.scrollHeight > nt.clientHeight && we !== "mouse" && we !== "touch")) {
      const lt = ze, cn = nt.clientHeight + nt.scrollTop, kr = lt.offsetTop + lt.offsetHeight;
      kr > cn ? nt.scrollTop = kr - nt.clientHeight : lt.offsetTop - lt.offsetHeight * (k ? 1.3 : 0) < nt.scrollTop && (nt.scrollTop = lt.offsetTop - lt.offsetHeight * (k ? 1.3 : 0));
    }
  }), Ce = Ke(({
    event: ce,
    diff: ee,
    direction: we = "next",
    reason: De = "auto"
  }) => {
    if (!fe)
      return;
    const ze = Le((() => {
      const lt = ae.length - 1;
      if (ee === "reset")
        return de;
      if (ee === "start")
        return 0;
      if (ee === "end")
        return lt;
      const cn = ue.current + ee;
      return cn < 0 ? cn === -1 && O ? -1 : b && ue.current !== -1 || Math.abs(ee) > 1 ? 0 : lt : cn > lt ? cn === lt + 1 && O ? -1 : b || Math.abs(ee) > 1 ? lt : 0 : cn;
    })(), we);
    if (Ve({
      index: ze,
      reason: De,
      event: ce
    }), o && ee !== "reset")
      if (ze === -1)
        Q.current.value = me;
      else {
        const lt = q(ae[ze]);
        Q.current.value = lt, lt.toLowerCase().indexOf(me.toLowerCase()) === 0 && me.length > 0 && Q.current.setSelectionRange(me.length, lt.length);
      }
  }), Se = () => {
    const ce = (ee, we) => {
      const De = ee ? q(ee) : "", nt = we ? q(we) : "";
      return De === nt;
    };
    if (ue.current !== -1 && Te.filteredOptions && Te.filteredOptions.length !== ae.length && Te.inputValue === me && (L ? he.length === Te.value.length && Te.value.every((ee, we) => q(he[we]) === q(ee)) : ce(Te.value, he))) {
      const ee = Te.filteredOptions[ue.current];
      if (ee)
        return r1(ae, (we) => q(we) === q(ee));
    }
    return -1;
  }, ve = y.useCallback(() => {
    if (!fe)
      return;
    const ce = Se();
    if (ce !== -1) {
      ue.current = ce;
      return;
    }
    const ee = L ? he[0] : he;
    if (ae.length === 0 || ee == null) {
      Ce({
        diff: "reset"
      });
      return;
    }
    if (re.current) {
      if (ee != null) {
        const we = ae[ue.current];
        if (L && we && r1(he, (nt) => _(we, nt)) !== -1)
          return;
        const De = r1(ae, (nt) => _(nt, ee));
        De === -1 ? Ce({
          diff: "reset"
        }) : Ve({
          index: De
        });
        return;
      }
      if (ue.current >= ae.length - 1) {
        Ve({
          index: ae.length - 1
        });
        return;
      }
      Ve({
        index: ue.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    ae.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    L ? !1 : he,
    x,
    Ce,
    Ve,
    fe,
    me,
    L
  ]), Be = Ke((ce) => {
    Ic(re, ce), ce && ve();
  });
  process.env.NODE_ENV !== "production" && y.useEffect(() => {
    (!Q.current || Q.current.nodeName !== "INPUT") && (Q.current && Q.current.nodeName === "TEXTAREA" ? console.warn([`A textarea element was provided to ${d} where input was expected.`, "This is not a supported scenario but it may work under certain conditions.", "A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).", "Make sure to test keyboard navigation and add custom event handlers if necessary."].join(`
`)) : console.error([`MUI: Unable to find the input element. It was resolved to ${Q.current} while an HTMLInputElement was expected.`, `Instead, ${d} expects an input element.`, "", d === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join(`
`)));
  }, [d]), y.useEffect(() => {
    ve();
  }, [ve]);
  const rt = (ce) => {
    Ne || (We(!0), Me(!0), $ && $(ce));
  }, pt = (ce, ee) => {
    Ne && (We(!1), j && j(ce, ee));
  }, Je = (ce, ee, we, De) => {
    if (L) {
      if (he.length === ee.length && he.every((nt, ze) => nt === ee[ze]))
        return;
    } else if (he === ee)
      return;
    V && V(ce, ee, we, De), Ue(ee);
  }, At = y.useRef(!1), Ht = (ce, ee, we = "selectOption", De = "options") => {
    let nt = we, ze = ee;
    if (L) {
      if (ze = Array.isArray(he) ? he.slice() : [], process.env.NODE_ENV !== "production") {
        const cn = ze.filter((kr) => _(ee, kr));
        cn.length > 1 && console.error([`MUI: The \`isOptionEqualToValue\` method of ${d} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${cn.length} matches.`].join(`
`));
      }
      const lt = r1(ze, (cn) => _(ee, cn));
      lt === -1 ? ze.push(ee) : De !== "freeSolo" && (ze.splice(lt, 1), nt = "removeOption");
    }
    ye(ce, ze), Je(ce, ze, nt, {
      option: ee
    }), !h && (!ce || !ce.ctrlKey && !ce.metaKey) && pt(ce, nt), (s === !0 || s === "touch" && At.current || s === "mouse" && !At.current) && Q.current.blur();
  };
  function Ct(ce, ee) {
    if (ce === -1)
      return -1;
    let we = ce;
    for (; ; ) {
      if (ee === "next" && we === he.length || ee === "previous" && we === -1)
        return -1;
      const De = U.querySelector(`[data-tag-index="${we}"]`);
      if (!De || !De.hasAttribute("tabindex") || De.disabled || De.getAttribute("aria-disabled") === "true")
        we += ee === "next" ? 1 : -1;
      else
        return we;
    }
  }
  const qt = (ce, ee) => {
    if (!L)
      return;
    me === "" && pt(ce, "toggleInput");
    let we = D;
    D === -1 ? me === "" && ee === "previous" && (we = he.length - 1) : (we += ee === "next" ? 1 : -1, we < 0 && (we = 0), we === he.length && (we = -1)), we = Ct(we, ee), X(we), Ye(we);
  }, Bn = (ce) => {
    G.current = !0, Ie(""), F && F(ce, "", "clear"), Je(ce, L ? [] : null, "clear");
  }, xn = (ce) => (ee) => {
    if (ce.onKeyDown && ce.onKeyDown(ee), !ee.defaultMuiPrevented && (D !== -1 && ["ArrowLeft", "ArrowRight"].indexOf(ee.key) === -1 && (X(-1), Ye(-1)), ee.which !== 229))
      switch (ee.key) {
        case "Home":
          fe && E && (ee.preventDefault(), Ce({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: ee
          }));
          break;
        case "End":
          fe && E && (ee.preventDefault(), Ce({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: ee
          }));
          break;
        case "PageUp":
          ee.preventDefault(), Ce({
            diff: -5,
            direction: "previous",
            reason: "keyboard",
            event: ee
          }), rt(ee);
          break;
        case "PageDown":
          ee.preventDefault(), Ce({
            diff: ED,
            direction: "next",
            reason: "keyboard",
            event: ee
          }), rt(ee);
          break;
        case "ArrowDown":
          ee.preventDefault(), Ce({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: ee
          }), rt(ee);
          break;
        case "ArrowUp":
          ee.preventDefault(), Ce({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: ee
          }), rt(ee);
          break;
        case "ArrowLeft":
          qt(ee, "previous");
          break;
        case "ArrowRight":
          qt(ee, "next");
          break;
        case "Enter":
          if (ue.current !== -1 && fe) {
            const we = ae[ue.current], De = S ? S(we) : !1;
            if (ee.preventDefault(), De)
              return;
            Ht(ee, we, "selectOption"), o && Q.current.setSelectionRange(Q.current.value.length, Q.current.value.length);
          } else v && me !== "" && Pe === !1 && (L && ee.preventDefault(), Ht(ee, me, "createOption", "freeSolo"));
          break;
        case "Escape":
          fe ? (ee.preventDefault(), ee.stopPropagation(), pt(ee, "escape")) : c && (me !== "" || L && he.length > 0) && (ee.preventDefault(), ee.stopPropagation(), Bn(ee));
          break;
        case "Backspace":
          if (L && !z && me === "" && he.length > 0) {
            const we = D === -1 ? he.length - 1 : D, De = he.slice();
            De.splice(we, 1), Je(ee, De, "removeOption", {
              option: he[we]
            });
          }
          break;
        case "Delete":
          if (L && !z && me === "" && he.length > 0 && D !== -1) {
            const we = D, De = he.slice();
            De.splice(we, 1), Je(ee, De, "removeOption", {
              option: he[we]
            });
          }
          break;
      }
  }, $o = (ce) => {
    ie(!0), H && !G.current && rt(ce);
  }, zn = (ce) => {
    if (t(re)) {
      Q.current.focus();
      return;
    }
    ie(!1), K.current = !0, G.current = !1, i && ue.current !== -1 && fe ? Ht(ce, ae[ue.current], "blur") : i && v && me !== "" ? Ht(ce, me, "blur", "freeSolo") : a && ye(ce, he), pt(ce, "blur");
  }, bn = (ce) => {
    const ee = ce.target.value;
    me !== ee && (Ie(ee), Me(!1), F && F(ce, ee, "input")), ee === "" ? !p && !L && Je(ce, null, "clear") : rt(ce);
  }, Zt = (ce) => {
    const ee = Number(ce.currentTarget.getAttribute("data-option-index"));
    ue.current !== ee && Ve({
      event: ce,
      index: ee,
      reason: "mouse"
    });
  }, vn = (ce) => {
    Ve({
      event: ce,
      index: Number(ce.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), At.current = !0;
  }, Qe = (ce) => {
    const ee = Number(ce.currentTarget.getAttribute("data-option-index"));
    Ht(ce, ae[ee], "selectOption"), At.current = !1;
  }, oo = (ce) => (ee) => {
    const we = he.slice();
    we.splice(ce, 1), Je(ee, we, "removeOption", {
      option: he[ce]
    });
  }, Kt = (ce) => {
    Ne ? pt(ce, "toggleInput") : rt(ce);
  }, Wt = (ce) => {
    ce.currentTarget.contains(ce.target) && ce.target.getAttribute("id") !== Z && ce.preventDefault();
  }, Y = (ce) => {
    ce.currentTarget.contains(ce.target) && (Q.current.focus(), se && K.current && Q.current.selectionEnd - Q.current.selectionStart === 0 && Q.current.select(), K.current = !1);
  }, ke = (ce) => {
    !g && (me === "" || !Ne) && Kt(ce);
  };
  let He = v && me.length > 0;
  He = He || (L ? he.length > 0 : he !== null);
  let st = ae;
  if (k) {
    const ce = /* @__PURE__ */ new Map();
    let ee = !1;
    st = ae.reduce((we, De, nt) => {
      const ze = k(De);
      return we.length > 0 && we[we.length - 1].group === ze ? we[we.length - 1].options.push(De) : (process.env.NODE_ENV !== "production" && (ce.get(ze) && !ee && (console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${d} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`."), ee = !0), ce.set(ze, !0)), we.push({
        key: nt,
        index: nt,
        group: ze,
        options: [De]
      })), we;
    }, []);
  }
  return g && te && zn(), {
    getRootProps: (ce = {}) => T({
      "aria-owns": tt ? `${Z}-listbox` : null
    }, ce, {
      onKeyDown: xn(ce),
      onMouseDown: Wt,
      onClick: Y
    }),
    getInputLabelProps: () => ({
      id: `${Z}-label`,
      htmlFor: Z
    }),
    getInputProps: () => ({
      id: Z,
      value: me,
      onBlur: zn,
      onFocus: $o,
      onChange: bn,
      onMouseDown: ke,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": fe ? "" : null,
      "aria-autocomplete": o ? "both" : "list",
      "aria-controls": tt ? `${Z}-listbox` : void 0,
      "aria-expanded": tt,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: Q,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: g
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Bn
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Kt
    }),
    getTagProps: ({
      index: ce
    }) => T({
      key: ce,
      "data-tag-index": ce,
      tabIndex: -1
    }, !z && {
      onDelete: oo(ce)
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${Z}-listbox`,
      "aria-labelledby": `${Z}-label`,
      ref: Be,
      onMouseDown: (ce) => {
        ce.preventDefault();
      }
    }),
    getOptionProps: ({
      index: ce,
      option: ee
    }) => {
      var we;
      const De = (L ? he : [he]).some((ze) => ze != null && _(ee, ze)), nt = S ? S(ee) : !1;
      return {
        key: (we = M == null ? void 0 : M(ee)) != null ? we : q(ee),
        tabIndex: -1,
        role: "option",
        id: `${Z}-option-${ce}`,
        onMouseMove: Zt,
        onClick: Qe,
        onTouchStart: vn,
        "data-option-index": ce,
        "aria-disabled": nt,
        "aria-selected": De
      };
    },
    id: Z,
    inputValue: me,
    value: he,
    dirty: He,
    expanded: fe && U,
    popupOpen: fe,
    focused: te || D !== -1,
    anchorEl: U,
    setAnchorEl: W,
    focusedTag: D,
    groupedOptions: st
  };
}
var L4 = {};
Object.defineProperty(L4, "__esModule", {
  value: !0
});
var Nv = L4.default = void 0, _D = LD(Nt), PD = _v;
function $v(e) {
  if (typeof WeakMap != "function") return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return ($v = function(o) {
    return o ? n : t;
  })(e);
}
function LD(e, t) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var n = $v(t);
  if (n && n.has(e)) return n.get(e);
  var o = { __proto__: null }, r = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e) if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
    var s = r ? Object.getOwnPropertyDescriptor(e, i) : null;
    s && (s.get || s.set) ? Object.defineProperty(o, i, s) : o[i] = e[i];
  }
  return o.default = e, n && n.set(e, o), o;
}
function ID(e) {
  return Object.keys(e).length === 0;
}
function jD(e = null) {
  const t = _D.useContext(PD.ThemeContext);
  return !t || ID(t) ? e : t;
}
Nv = L4.default = jD;
var jo = "top", vr = "bottom", wr = "right", Vo = "left", I4 = "auto", E0 = [jo, vr, wr, Vo], jl = "start", jc = "end", VD = "clippingParents", Bv = "viewport", M2 = "popper", DD = "reference", og = /* @__PURE__ */ E0.reduce(function(e, t) {
  return e.concat([t + "-" + jl, t + "-" + jc]);
}, []), zv = /* @__PURE__ */ [].concat(E0, [I4]).reduce(function(e, t) {
  return e.concat([t, t + "-" + jl, t + "-" + jc]);
}, []), AD = "beforeRead", HD = "read", FD = "afterRead", ND = "beforeMain", $D = "main", BD = "afterMain", zD = "beforeWrite", ZD = "write", WD = "afterWrite", UD = [AD, HD, FD, ND, $D, BD, zD, ZD, WD];
function ii(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function er(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function wa(e) {
  var t = er(e).Element;
  return e instanceof t || e instanceof Element;
}
function gr(e) {
  var t = er(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function j4(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = er(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function GD(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var o = t.styles[n] || {}, r = t.attributes[n] || {}, i = t.elements[n];
    !gr(i) || !ii(i) || (Object.assign(i.style, o), Object.keys(r).forEach(function(s) {
      var a = r[s];
      a === !1 ? i.removeAttribute(s) : i.setAttribute(s, a === !0 ? "" : a);
    }));
  });
}
function qD(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(o) {
      var r = t.elements[o], i = t.attributes[o] || {}, s = Object.keys(t.styles.hasOwnProperty(o) ? t.styles[o] : n[o]), a = s.reduce(function(c, d) {
        return c[d] = "", c;
      }, {});
      !gr(r) || !ii(r) || (Object.assign(r.style, a), Object.keys(i).forEach(function(c) {
        r.removeAttribute(c);
      }));
    });
  };
}
const KD = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: GD,
  effect: qD,
  requires: ["computeStyles"]
};
function ei(e) {
  return e.split("-")[0];
}
var ia = Math.max, Ud = Math.min, Vl = Math.round;
function Ap() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Zv() {
  return !/^((?!chrome|android).)*safari/i.test(Ap());
}
function Dl(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var o = e.getBoundingClientRect(), r = 1, i = 1;
  t && gr(e) && (r = e.offsetWidth > 0 && Vl(o.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && Vl(o.height) / e.offsetHeight || 1);
  var s = wa(e) ? er(e) : window, a = s.visualViewport, c = !Zv() && n, d = (o.left + (c && a ? a.offsetLeft : 0)) / r, u = (o.top + (c && a ? a.offsetTop : 0)) / i, p = o.width / r, h = o.height / i;
  return {
    width: p,
    height: h,
    top: u,
    right: d + p,
    bottom: u + h,
    left: d,
    x: d,
    y: u
  };
}
function V4(e) {
  var t = Dl(e), n = e.offsetWidth, o = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - o) <= 1 && (o = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: o
  };
}
function Wv(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && j4(n)) {
    var o = t;
    do {
      if (o && e.isSameNode(o))
        return !0;
      o = o.parentNode || o.host;
    } while (o);
  }
  return !1;
}
function ji(e) {
  return er(e).getComputedStyle(e);
}
function YD(e) {
  return ["table", "td", "th"].indexOf(ii(e)) >= 0;
}
function ks(e) {
  return ((wa(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function x3(e) {
  return ii(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (j4(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    ks(e)
  );
}
function rg(e) {
  return !gr(e) || // https://github.com/popperjs/popper-core/issues/837
  ji(e).position === "fixed" ? null : e.offsetParent;
}
function XD(e) {
  var t = /firefox/i.test(Ap()), n = /Trident/i.test(Ap());
  if (n && gr(e)) {
    var o = ji(e);
    if (o.position === "fixed")
      return null;
  }
  var r = x3(e);
  for (j4(r) && (r = r.host); gr(r) && ["html", "body"].indexOf(ii(r)) < 0; ) {
    var i = ji(r);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
function R0(e) {
  for (var t = er(e), n = rg(e); n && YD(n) && ji(n).position === "static"; )
    n = rg(n);
  return n && (ii(n) === "html" || ii(n) === "body" && ji(n).position === "static") ? t : n || XD(e) || t;
}
function D4(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function tc(e, t, n) {
  return ia(e, Ud(t, n));
}
function JD(e, t, n) {
  var o = tc(e, t, n);
  return o > n ? n : o;
}
function Uv() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Gv(e) {
  return Object.assign({}, Uv(), e);
}
function qv(e, t) {
  return t.reduce(function(n, o) {
    return n[o] = e, n;
  }, {});
}
var QD = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, Gv(typeof t != "number" ? t : qv(t, E0));
};
function eA(e) {
  var t, n = e.state, o = e.name, r = e.options, i = n.elements.arrow, s = n.modifiersData.popperOffsets, a = ei(n.placement), c = D4(a), d = [Vo, wr].indexOf(a) >= 0, u = d ? "height" : "width";
  if (!(!i || !s)) {
    var p = QD(r.padding, n), h = V4(i), g = c === "y" ? jo : Vo, m = c === "y" ? vr : wr, b = n.rects.reference[u] + n.rects.reference[c] - s[c] - n.rects.popper[u], C = s[c] - n.rects.reference[c], x = R0(i), v = x ? c === "y" ? x.clientHeight || 0 : x.clientWidth || 0 : 0, S = b / 2 - C / 2, M = p[g], w = v - h[u] - p[m], k = v / 2 - h[u] / 2 + S, E = tc(M, k, w), R = c;
    n.modifiersData[o] = (t = {}, t[R] = E, t.centerOffset = E - k, t);
  }
}
function tA(e) {
  var t = e.state, n = e.options, o = n.element, r = o === void 0 ? "[data-popper-arrow]" : o;
  r != null && (typeof r == "string" && (r = t.elements.popper.querySelector(r), !r) || Wv(t.elements.popper, r) && (t.elements.arrow = r));
}
const nA = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: eA,
  effect: tA,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Al(e) {
  return e.split("-")[1];
}
var oA = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function rA(e, t) {
  var n = e.x, o = e.y, r = t.devicePixelRatio || 1;
  return {
    x: Vl(n * r) / r || 0,
    y: Vl(o * r) / r || 0
  };
}
function ig(e) {
  var t, n = e.popper, o = e.popperRect, r = e.placement, i = e.variation, s = e.offsets, a = e.position, c = e.gpuAcceleration, d = e.adaptive, u = e.roundOffsets, p = e.isFixed, h = s.x, g = h === void 0 ? 0 : h, m = s.y, b = m === void 0 ? 0 : m, C = typeof u == "function" ? u({
    x: g,
    y: b
  }) : {
    x: g,
    y: b
  };
  g = C.x, b = C.y;
  var x = s.hasOwnProperty("x"), v = s.hasOwnProperty("y"), S = Vo, M = jo, w = window;
  if (d) {
    var k = R0(n), E = "clientHeight", R = "clientWidth";
    if (k === er(n) && (k = ks(n), ji(k).position !== "static" && a === "absolute" && (E = "scrollHeight", R = "scrollWidth")), k = k, r === jo || (r === Vo || r === wr) && i === jc) {
      M = vr;
      var O = p && k === w && w.visualViewport ? w.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        k[E]
      );
      b -= O - o.height, b *= c ? 1 : -1;
    }
    if (r === Vo || (r === jo || r === vr) && i === jc) {
      S = wr;
      var P = p && k === w && w.visualViewport ? w.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        k[R]
      );
      g -= P - o.width, g *= c ? 1 : -1;
    }
  }
  var _ = Object.assign({
    position: a
  }, d && oA), L = u === !0 ? rA({
    x: g,
    y: b
  }, er(n)) : {
    x: g,
    y: b
  };
  if (g = L.x, b = L.y, c) {
    var V;
    return Object.assign({}, _, (V = {}, V[M] = v ? "0" : "", V[S] = x ? "0" : "", V.transform = (w.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + b + "px)" : "translate3d(" + g + "px, " + b + "px, 0)", V));
  }
  return Object.assign({}, _, (t = {}, t[M] = v ? b + "px" : "", t[S] = x ? g + "px" : "", t.transform = "", t));
}
function iA(e) {
  var t = e.state, n = e.options, o = n.gpuAcceleration, r = o === void 0 ? !0 : o, i = n.adaptive, s = i === void 0 ? !0 : i, a = n.roundOffsets, c = a === void 0 ? !0 : a, d = {
    placement: ei(t.placement),
    variation: Al(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: r,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, ig(Object.assign({}, d, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: s,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, ig(Object.assign({}, d, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const sA = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: iA,
  data: {}
};
var i1 = {
  passive: !0
};
function aA(e) {
  var t = e.state, n = e.instance, o = e.options, r = o.scroll, i = r === void 0 ? !0 : r, s = o.resize, a = s === void 0 ? !0 : s, c = er(t.elements.popper), d = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && d.forEach(function(u) {
    u.addEventListener("scroll", n.update, i1);
  }), a && c.addEventListener("resize", n.update, i1), function() {
    i && d.forEach(function(u) {
      u.removeEventListener("scroll", n.update, i1);
    }), a && c.removeEventListener("resize", n.update, i1);
  };
}
const lA = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: aA,
  data: {}
};
var cA = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function gd(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return cA[t];
  });
}
var dA = {
  start: "end",
  end: "start"
};
function sg(e) {
  return e.replace(/start|end/g, function(t) {
    return dA[t];
  });
}
function A4(e) {
  var t = er(e), n = t.pageXOffset, o = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: o
  };
}
function H4(e) {
  return Dl(ks(e)).left + A4(e).scrollLeft;
}
function uA(e, t) {
  var n = er(e), o = ks(e), r = n.visualViewport, i = o.clientWidth, s = o.clientHeight, a = 0, c = 0;
  if (r) {
    i = r.width, s = r.height;
    var d = Zv();
    (d || !d && t === "fixed") && (a = r.offsetLeft, c = r.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: a + H4(e),
    y: c
  };
}
function fA(e) {
  var t, n = ks(e), o = A4(e), r = (t = e.ownerDocument) == null ? void 0 : t.body, i = ia(n.scrollWidth, n.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), s = ia(n.scrollHeight, n.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), a = -o.scrollLeft + H4(e), c = -o.scrollTop;
  return ji(r || n).direction === "rtl" && (a += ia(n.clientWidth, r ? r.clientWidth : 0) - i), {
    width: i,
    height: s,
    x: a,
    y: c
  };
}
function F4(e) {
  var t = ji(e), n = t.overflow, o = t.overflowX, r = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + r + o);
}
function Kv(e) {
  return ["html", "body", "#document"].indexOf(ii(e)) >= 0 ? e.ownerDocument.body : gr(e) && F4(e) ? e : Kv(x3(e));
}
function nc(e, t) {
  var n;
  t === void 0 && (t = []);
  var o = Kv(e), r = o === ((n = e.ownerDocument) == null ? void 0 : n.body), i = er(o), s = r ? [i].concat(i.visualViewport || [], F4(o) ? o : []) : o, a = t.concat(s);
  return r ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(nc(x3(s)))
  );
}
function Hp(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function pA(e, t) {
  var n = Dl(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function ag(e, t, n) {
  return t === Bv ? Hp(uA(e, n)) : wa(t) ? pA(t, n) : Hp(fA(ks(e)));
}
function hA(e) {
  var t = nc(x3(e)), n = ["absolute", "fixed"].indexOf(ji(e).position) >= 0, o = n && gr(e) ? R0(e) : e;
  return wa(o) ? t.filter(function(r) {
    return wa(r) && Wv(r, o) && ii(r) !== "body";
  }) : [];
}
function gA(e, t, n, o) {
  var r = t === "clippingParents" ? hA(e) : [].concat(t), i = [].concat(r, [n]), s = i[0], a = i.reduce(function(c, d) {
    var u = ag(e, d, o);
    return c.top = ia(u.top, c.top), c.right = Ud(u.right, c.right), c.bottom = Ud(u.bottom, c.bottom), c.left = ia(u.left, c.left), c;
  }, ag(e, s, o));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function Yv(e) {
  var t = e.reference, n = e.element, o = e.placement, r = o ? ei(o) : null, i = o ? Al(o) : null, s = t.x + t.width / 2 - n.width / 2, a = t.y + t.height / 2 - n.height / 2, c;
  switch (r) {
    case jo:
      c = {
        x: s,
        y: t.y - n.height
      };
      break;
    case vr:
      c = {
        x: s,
        y: t.y + t.height
      };
      break;
    case wr:
      c = {
        x: t.x + t.width,
        y: a
      };
      break;
    case Vo:
      c = {
        x: t.x - n.width,
        y: a
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var d = r ? D4(r) : null;
  if (d != null) {
    var u = d === "y" ? "height" : "width";
    switch (i) {
      case jl:
        c[d] = c[d] - (t[u] / 2 - n[u] / 2);
        break;
      case jc:
        c[d] = c[d] + (t[u] / 2 - n[u] / 2);
        break;
    }
  }
  return c;
}
function Vc(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.placement, r = o === void 0 ? e.placement : o, i = n.strategy, s = i === void 0 ? e.strategy : i, a = n.boundary, c = a === void 0 ? VD : a, d = n.rootBoundary, u = d === void 0 ? Bv : d, p = n.elementContext, h = p === void 0 ? M2 : p, g = n.altBoundary, m = g === void 0 ? !1 : g, b = n.padding, C = b === void 0 ? 0 : b, x = Gv(typeof C != "number" ? C : qv(C, E0)), v = h === M2 ? DD : M2, S = e.rects.popper, M = e.elements[m ? v : h], w = gA(wa(M) ? M : M.contextElement || ks(e.elements.popper), c, u, s), k = Dl(e.elements.reference), E = Yv({
    reference: k,
    element: S,
    strategy: "absolute",
    placement: r
  }), R = Hp(Object.assign({}, S, E)), O = h === M2 ? R : k, P = {
    top: w.top - O.top + x.top,
    bottom: O.bottom - w.bottom + x.bottom,
    left: w.left - O.left + x.left,
    right: O.right - w.right + x.right
  }, _ = e.modifiersData.offset;
  if (h === M2 && _) {
    var L = _[r];
    Object.keys(P).forEach(function(V) {
      var j = [wr, vr].indexOf(V) >= 0 ? 1 : -1, I = [jo, vr].indexOf(V) >= 0 ? "y" : "x";
      P[V] += L[I] * j;
    });
  }
  return P;
}
function mA(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.placement, r = n.boundary, i = n.rootBoundary, s = n.padding, a = n.flipVariations, c = n.allowedAutoPlacements, d = c === void 0 ? zv : c, u = Al(o), p = u ? a ? og : og.filter(function(m) {
    return Al(m) === u;
  }) : E0, h = p.filter(function(m) {
    return d.indexOf(m) >= 0;
  });
  h.length === 0 && (h = p);
  var g = h.reduce(function(m, b) {
    return m[b] = Vc(e, {
      placement: b,
      boundary: r,
      rootBoundary: i,
      padding: s
    })[ei(b)], m;
  }, {});
  return Object.keys(g).sort(function(m, b) {
    return g[m] - g[b];
  });
}
function bA(e) {
  if (ei(e) === I4)
    return [];
  var t = gd(e);
  return [sg(e), t, sg(t)];
}
function CA(e) {
  var t = e.state, n = e.options, o = e.name;
  if (!t.modifiersData[o]._skip) {
    for (var r = n.mainAxis, i = r === void 0 ? !0 : r, s = n.altAxis, a = s === void 0 ? !0 : s, c = n.fallbackPlacements, d = n.padding, u = n.boundary, p = n.rootBoundary, h = n.altBoundary, g = n.flipVariations, m = g === void 0 ? !0 : g, b = n.allowedAutoPlacements, C = t.options.placement, x = ei(C), v = x === C, S = c || (v || !m ? [gd(C)] : bA(C)), M = [C].concat(S).reduce(function(Z, q) {
      return Z.concat(ei(q) === I4 ? mA(t, {
        placement: q,
        boundary: u,
        rootBoundary: p,
        padding: d,
        flipVariations: m,
        allowedAutoPlacements: b
      }) : q);
    }, []), w = t.rects.reference, k = t.rects.popper, E = /* @__PURE__ */ new Map(), R = !0, O = M[0], P = 0; P < M.length; P++) {
      var _ = M[P], L = ei(_), V = Al(_) === jl, j = [jo, vr].indexOf(L) >= 0, I = j ? "width" : "height", F = Vc(t, {
        placement: _,
        boundary: u,
        rootBoundary: p,
        altBoundary: h,
        padding: d
      }), $ = j ? V ? wr : Vo : V ? vr : jo;
      w[I] > k[I] && ($ = gd($));
      var A = gd($), H = [];
      if (i && H.push(F[L] <= 0), a && H.push(F[$] <= 0, F[A] <= 0), H.every(function(Z) {
        return Z;
      })) {
        O = _, R = !1;
        break;
      }
      E.set(_, H);
    }
    if (R)
      for (var N = m ? 3 : 1, z = function(q) {
        var G = M.find(function(K) {
          var Q = E.get(K);
          if (Q)
            return Q.slice(0, q).every(function(re) {
              return re;
            });
        });
        if (G)
          return O = G, "break";
      }, se = N; se > 0; se--) {
        var ne = z(se);
        if (ne === "break") break;
      }
    t.placement !== O && (t.modifiersData[o]._skip = !0, t.placement = O, t.reset = !0);
  }
}
const xA = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: CA,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function lg(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function cg(e) {
  return [jo, wr, vr, Vo].some(function(t) {
    return e[t] >= 0;
  });
}
function yA(e) {
  var t = e.state, n = e.name, o = t.rects.reference, r = t.rects.popper, i = t.modifiersData.preventOverflow, s = Vc(t, {
    elementContext: "reference"
  }), a = Vc(t, {
    altBoundary: !0
  }), c = lg(s, o), d = lg(a, r, i), u = cg(c), p = cg(d);
  t.modifiersData[n] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: d,
    isReferenceHidden: u,
    hasPopperEscaped: p
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": p
  });
}
const vA = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: yA
};
function wA(e, t, n) {
  var o = ei(e), r = [Vo, jo].indexOf(o) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, s = i[0], a = i[1];
  return s = s || 0, a = (a || 0) * r, [Vo, wr].indexOf(o) >= 0 ? {
    x: a,
    y: s
  } : {
    x: s,
    y: a
  };
}
function SA(e) {
  var t = e.state, n = e.options, o = e.name, r = n.offset, i = r === void 0 ? [0, 0] : r, s = zv.reduce(function(u, p) {
    return u[p] = wA(p, t.rects, i), u;
  }, {}), a = s[t.placement], c = a.x, d = a.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += d), t.modifiersData[o] = s;
}
const MA = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: SA
};
function TA(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Yv({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const kA = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: TA,
  data: {}
};
function EA(e) {
  return e === "x" ? "y" : "x";
}
function RA(e) {
  var t = e.state, n = e.options, o = e.name, r = n.mainAxis, i = r === void 0 ? !0 : r, s = n.altAxis, a = s === void 0 ? !1 : s, c = n.boundary, d = n.rootBoundary, u = n.altBoundary, p = n.padding, h = n.tether, g = h === void 0 ? !0 : h, m = n.tetherOffset, b = m === void 0 ? 0 : m, C = Vc(t, {
    boundary: c,
    rootBoundary: d,
    padding: p,
    altBoundary: u
  }), x = ei(t.placement), v = Al(t.placement), S = !v, M = D4(x), w = EA(M), k = t.modifiersData.popperOffsets, E = t.rects.reference, R = t.rects.popper, O = typeof b == "function" ? b(Object.assign({}, t.rects, {
    placement: t.placement
  })) : b, P = typeof O == "number" ? {
    mainAxis: O,
    altAxis: O
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, O), _ = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, L = {
    x: 0,
    y: 0
  };
  if (k) {
    if (i) {
      var V, j = M === "y" ? jo : Vo, I = M === "y" ? vr : wr, F = M === "y" ? "height" : "width", $ = k[M], A = $ + C[j], H = $ - C[I], N = g ? -R[F] / 2 : 0, z = v === jl ? E[F] : R[F], se = v === jl ? -R[F] : -E[F], ne = t.elements.arrow, Z = g && ne ? V4(ne) : {
        width: 0,
        height: 0
      }, q = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Uv(), G = q[j], K = q[I], Q = tc(0, E[F], Z[F]), re = S ? E[F] / 2 - N - Q - G - P.mainAxis : z - Q - G - P.mainAxis, U = S ? -E[F] / 2 + N + Q + K + P.mainAxis : se + Q + K + P.mainAxis, W = t.elements.arrow && R0(t.elements.arrow), D = W ? M === "y" ? W.clientTop || 0 : W.clientLeft || 0 : 0, X = (V = _ == null ? void 0 : _[M]) != null ? V : 0, de = $ + re - X - D, ue = $ + U - X, he = tc(g ? Ud(A, de) : A, $, g ? ia(H, ue) : H);
      k[M] = he, L[M] = he - $;
    }
    if (a) {
      var Ue, me = M === "x" ? jo : Vo, Ie = M === "x" ? vr : wr, te = k[w], ie = w === "y" ? "height" : "width", ye = te + C[me], Ne = te - C[Ie], We = [jo, Vo].indexOf(x) !== -1, qe = (Ue = _ == null ? void 0 : _[w]) != null ? Ue : 0, Me = We ? ye : te - E[ie] - R[ie] - qe + P.altAxis, Pe = We ? te + E[ie] + R[ie] - qe - P.altAxis : Ne, fe = g && We ? JD(Me, te, Pe) : tc(g ? Me : ye, te, g ? Pe : Ne);
      k[w] = fe, L[w] = fe - te;
    }
    t.modifiersData[o] = L;
  }
}
const OA = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: RA,
  requiresIfExists: ["offset"]
};
function _A(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function PA(e) {
  return e === er(e) || !gr(e) ? A4(e) : _A(e);
}
function LA(e) {
  var t = e.getBoundingClientRect(), n = Vl(t.width) / e.offsetWidth || 1, o = Vl(t.height) / e.offsetHeight || 1;
  return n !== 1 || o !== 1;
}
function IA(e, t, n) {
  n === void 0 && (n = !1);
  var o = gr(t), r = gr(t) && LA(t), i = ks(t), s = Dl(e, r, n), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (o || !o && !n) && ((ii(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  F4(i)) && (a = PA(t)), gr(t) ? (c = Dl(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : i && (c.x = H4(i))), {
    x: s.left + a.scrollLeft - c.x,
    y: s.top + a.scrollTop - c.y,
    width: s.width,
    height: s.height
  };
}
function jA(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), o = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function r(i) {
    n.add(i.name);
    var s = [].concat(i.requires || [], i.requiresIfExists || []);
    s.forEach(function(a) {
      if (!n.has(a)) {
        var c = t.get(a);
        c && r(c);
      }
    }), o.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || r(i);
  }), o;
}
function VA(e) {
  var t = jA(e);
  return UD.reduce(function(n, o) {
    return n.concat(t.filter(function(r) {
      return r.phase === o;
    }));
  }, []);
}
function DA(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function AA(e) {
  var t = e.reduce(function(n, o) {
    var r = n[o.name];
    return n[o.name] = r ? Object.assign({}, r, o, {
      options: Object.assign({}, r.options, o.options),
      data: Object.assign({}, r.data, o.data)
    }) : o, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var dg = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function ug() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(o) {
    return !(o && typeof o.getBoundingClientRect == "function");
  });
}
function HA(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, o = n === void 0 ? [] : n, r = t.defaultOptions, i = r === void 0 ? dg : r;
  return function(a, c, d) {
    d === void 0 && (d = i);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, dg, i),
      modifiersData: {},
      elements: {
        reference: a,
        popper: c
      },
      attributes: {},
      styles: {}
    }, p = [], h = !1, g = {
      state: u,
      setOptions: function(x) {
        var v = typeof x == "function" ? x(u.options) : x;
        b(), u.options = Object.assign({}, i, u.options, v), u.scrollParents = {
          reference: wa(a) ? nc(a) : a.contextElement ? nc(a.contextElement) : [],
          popper: nc(c)
        };
        var S = VA(AA([].concat(o, u.options.modifiers)));
        return u.orderedModifiers = S.filter(function(M) {
          return M.enabled;
        }), m(), g.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var x = u.elements, v = x.reference, S = x.popper;
          if (ug(v, S)) {
            u.rects = {
              reference: IA(v, R0(S), u.options.strategy === "fixed"),
              popper: V4(S)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(P) {
              return u.modifiersData[P.name] = Object.assign({}, P.data);
            });
            for (var M = 0; M < u.orderedModifiers.length; M++) {
              if (u.reset === !0) {
                u.reset = !1, M = -1;
                continue;
              }
              var w = u.orderedModifiers[M], k = w.fn, E = w.options, R = E === void 0 ? {} : E, O = w.name;
              typeof k == "function" && (u = k({
                state: u,
                options: R,
                name: O,
                instance: g
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: DA(function() {
        return new Promise(function(C) {
          g.forceUpdate(), C(u);
        });
      }),
      destroy: function() {
        b(), h = !0;
      }
    };
    if (!ug(a, c))
      return g;
    g.setOptions(d).then(function(C) {
      !h && d.onFirstUpdate && d.onFirstUpdate(C);
    });
    function m() {
      u.orderedModifiers.forEach(function(C) {
        var x = C.name, v = C.options, S = v === void 0 ? {} : v, M = C.effect;
        if (typeof M == "function") {
          var w = M({
            state: u,
            name: x,
            instance: g,
            options: S
          }), k = function() {
          };
          p.push(w || k);
        }
      });
    }
    function b() {
      p.forEach(function(C) {
        return C();
      }), p = [];
    }
    return g;
  };
}
var FA = [lA, kA, sA, KD, MA, xA, OA, nA, vA], NA = /* @__PURE__ */ HA({
  defaultModifiers: FA
});
function $A(e) {
  return typeof e == "function" ? e() : e;
}
const Dc = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const {
    children: o,
    container: r,
    disablePortal: i = !1
  } = t, [s, a] = y.useState(null), c = Tt(/* @__PURE__ */ y.isValidElement(o) ? o2(o) : null, n);
  if (En(() => {
    i || a($A(r) || document.body);
  }, [r, i]), En(() => {
    if (s && !i)
      return Ic(n, s), () => {
        Ic(n, null);
      };
  }, [n, s, i]), i) {
    if (/* @__PURE__ */ y.isValidElement(o)) {
      const d = {
        ref: c
      };
      return /* @__PURE__ */ y.cloneElement(o, d);
    }
    return /* @__PURE__ */ f.jsx(y.Fragment, {
      children: o
    });
  }
  return /* @__PURE__ */ f.jsx(y.Fragment, {
    children: s && /* @__PURE__ */ M_.createPortal(o, s)
  });
});
process.env.NODE_ENV !== "production" && (Dc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: l.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: l.oneOfType([Ii, l.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: l.bool
});
process.env.NODE_ENV !== "production" && (Dc.propTypes = h3(Dc.propTypes));
function BA(e) {
  return _e("MuiPopper", e);
}
Re("MuiPopper", ["root"]);
const zA = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], ZA = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function WA(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function Gd(e) {
  return typeof e == "function" ? e() : e;
}
function y3(e) {
  return e.nodeType !== void 0;
}
function UA(e) {
  return !y3(e);
}
const GA = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"]
  }, BA, t);
}, qA = {}, KA = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o;
  const {
    anchorEl: r,
    children: i,
    direction: s,
    disablePortal: a,
    modifiers: c,
    open: d,
    placement: u,
    popperOptions: p,
    popperRef: h,
    slotProps: g = {},
    slots: m = {},
    TransitionProps: b
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = t, C = le(t, zA), x = y.useRef(null), v = Tt(x, n), S = y.useRef(null), M = Tt(S, h), w = y.useRef(M);
  En(() => {
    w.current = M;
  }, [M]), y.useImperativeHandle(h, () => S.current, []);
  const k = WA(u, s), [E, R] = y.useState(k), [O, P] = y.useState(Gd(r));
  y.useEffect(() => {
    S.current && S.current.forceUpdate();
  }), y.useEffect(() => {
    r && P(Gd(r));
  }, [r]), En(() => {
    if (!O || !d)
      return;
    const I = (A) => {
      R(A.placement);
    };
    if (process.env.NODE_ENV !== "production" && O && y3(O) && O.nodeType === 1) {
      const A = O.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && A.top === 0 && A.left === 0 && A.right === 0 && A.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let F = [{
      name: "preventOverflow",
      options: {
        altBoundary: a
      }
    }, {
      name: "flip",
      options: {
        altBoundary: a
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: A
      }) => {
        I(A);
      }
    }];
    c != null && (F = F.concat(c)), p && p.modifiers != null && (F = F.concat(p.modifiers));
    const $ = NA(O, x.current, T({
      placement: k
    }, p, {
      modifiers: F
    }));
    return w.current($), () => {
      $.destroy(), w.current(null);
    };
  }, [O, a, c, d, p, k]);
  const _ = {
    placement: E
  };
  b !== null && (_.TransitionProps = b);
  const L = GA(t), V = (o = m.root) != null ? o : "div", j = Ft({
    elementType: V,
    externalSlotProps: g.root,
    externalForwardedProps: C,
    additionalProps: {
      role: "tooltip",
      ref: v
    },
    ownerState: t,
    className: L.root
  });
  return /* @__PURE__ */ f.jsx(V, T({}, j, {
    children: typeof i == "function" ? i(_) : i
  }));
}), Xv = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const {
    anchorEl: o,
    children: r,
    container: i,
    direction: s = "ltr",
    disablePortal: a = !1,
    keepMounted: c = !1,
    modifiers: d,
    open: u,
    placement: p = "bottom",
    popperOptions: h = qA,
    popperRef: g,
    style: m,
    transition: b = !1,
    slotProps: C = {},
    slots: x = {}
  } = t, v = le(t, ZA), [S, M] = y.useState(!0), w = () => {
    M(!1);
  }, k = () => {
    M(!0);
  };
  if (!c && !u && (!b || S))
    return null;
  let E;
  if (i)
    E = i;
  else if (o) {
    const P = Gd(o);
    E = P && y3(P) ? gn(P).body : gn(null).body;
  }
  const R = !u && c && (!b || S) ? "none" : void 0, O = b ? {
    in: u,
    onEnter: w,
    onExited: k
  } : void 0;
  return /* @__PURE__ */ f.jsx(Dc, {
    disablePortal: a,
    container: E,
    children: /* @__PURE__ */ f.jsx(KA, T({
      anchorEl: o,
      direction: s,
      disablePortal: a,
      modifiers: d,
      ref: n,
      open: b ? !S : u,
      placement: p,
      popperOptions: h,
      popperRef: g,
      slotProps: C,
      slots: x
    }, v, {
      style: T({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: R
      }, m),
      TransitionProps: O,
      children: r
    }))
  });
});
process.env.NODE_ENV !== "production" && (Xv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: vo(l.oneOfType([Ii, l.object, l.func]), (e) => {
    if (e.open) {
      const t = Gd(e.anchorEl);
      if (t && y3(t) && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || UA(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: l.oneOfType([l.node, l.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: l.oneOfType([Ii, l.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: l.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: l.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: l.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: l.arrayOf(l.shape({
    data: l.object,
    effect: l.func,
    enabled: l.bool,
    fn: l.func,
    name: l.any,
    options: l.object,
    phase: l.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: l.arrayOf(l.string),
    requiresIfExists: l.arrayOf(l.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: l.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: l.shape({
    modifiers: l.array,
    onFirstUpdate: l.func,
    placement: l.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: l.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: sn,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: l.shape({
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: l.shape({
    root: l.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: l.bool
});
const YA = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"], XA = B(Xv, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), s2 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o;
  const r = Nv(), i = Xe({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: s,
    component: a,
    components: c,
    componentsProps: d,
    container: u,
    disablePortal: p,
    keepMounted: h,
    modifiers: g,
    open: m,
    placement: b,
    popperOptions: C,
    popperRef: x,
    transition: v,
    slots: S,
    slotProps: M
  } = i, w = le(i, YA), k = (o = S == null ? void 0 : S.root) != null ? o : c == null ? void 0 : c.Root, E = T({
    anchorEl: s,
    container: u,
    disablePortal: p,
    keepMounted: h,
    modifiers: g,
    open: m,
    placement: b,
    popperOptions: C,
    popperRef: x,
    transition: v
  }, w);
  return /* @__PURE__ */ f.jsx(XA, T({
    as: a,
    direction: r == null ? void 0 : r.direction,
    slots: {
      root: k
    },
    slotProps: M ?? d
  }, E, {
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (s2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: l.oneOfType([Ii, l.object, l.func]),
  /**
   * Popper render function or node.
   */
  children: l.oneOfType([l.node, l.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: l.shape({
    Root: l.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  componentsProps: l.shape({
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: l.oneOfType([Ii, l.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: l.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: l.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: l.arrayOf(l.shape({
    data: l.object,
    effect: l.func,
    enabled: l.bool,
    fn: l.func,
    name: l.any,
    options: l.object,
    phase: l.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: l.arrayOf(l.string),
    requiresIfExists: l.arrayOf(l.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: l.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: l.shape({
    modifiers: l.array,
    onFirstUpdate: l.func,
    placement: l.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: l.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: sn,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: l.shape({
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: l.shape({
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: l.bool
});
function JA(e) {
  return _e("MuiListSubheader", e);
}
Re("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
const QA = ["className", "color", "component", "disableGutters", "disableSticky", "inset"], eH = (e) => {
  const {
    classes: t,
    color: n,
    disableGutters: o,
    inset: r,
    disableSticky: i
  } = e, s = {
    root: ["root", n !== "default" && `color${pe(n)}`, !o && "gutters", r && "inset", !i && "sticky"]
  };
  return Oe(s, JA, t);
}, tH = B("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${pe(n.color)}`], !n.disableGutters && t.gutters, n.inset && t.inset, !n.disableSticky && t.sticky];
  }
})(({
  theme: e,
  ownerState: t
}) => T({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (e.vars || e).palette.text.secondary,
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(14)
}, t.color === "primary" && {
  color: (e.vars || e).palette.primary.main
}, t.color === "inherit" && {
  color: "inherit"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.inset && {
  paddingLeft: 72
}, !t.disableSticky && {
  position: "sticky",
  top: 0,
  zIndex: 1,
  backgroundColor: (e.vars || e).palette.background.paper
})), N4 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiListSubheader"
  }), {
    className: r,
    color: i = "default",
    component: s = "li",
    disableGutters: a = !1,
    disableSticky: c = !1,
    inset: d = !1
  } = o, u = le(o, QA), p = T({}, o, {
    color: i,
    component: s,
    disableGutters: a,
    disableSticky: c,
    inset: d
  }), h = eH(p);
  return /* @__PURE__ */ f.jsx(tH, T({
    as: s,
    className: xe(h.root, r),
    ref: n,
    ownerState: p
  }, u));
});
N4.muiSkipListHighlight = !0;
process.env.NODE_ENV !== "production" && (N4.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: l.oneOf(["default", "inherit", "primary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: l.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: l.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const nH = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function oH(e) {
  return _e("MuiChip", e);
}
const zt = Re("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), rH = ["avatar", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant", "tabIndex", "skipFocusWhenDisabled"], iH = (e) => {
  const {
    classes: t,
    disabled: n,
    size: o,
    color: r,
    iconColor: i,
    onDelete: s,
    clickable: a,
    variant: c
  } = e, d = {
    root: ["root", c, n && "disabled", `size${pe(o)}`, `color${pe(r)}`, a && "clickable", a && `clickableColor${pe(r)}`, s && "deletable", s && `deletableColor${pe(r)}`, `${c}${pe(r)}`],
    label: ["label", `label${pe(o)}`],
    avatar: ["avatar", `avatar${pe(o)}`, `avatarColor${pe(r)}`],
    icon: ["icon", `icon${pe(o)}`, `iconColor${pe(i)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${pe(o)}`, `deleteIconColor${pe(r)}`, `deleteIcon${pe(c)}Color${pe(r)}`]
  };
  return Oe(d, oH, t);
}, sH = B("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      color: o,
      iconColor: r,
      clickable: i,
      onDelete: s,
      size: a,
      variant: c
    } = n;
    return [{
      [`& .${zt.avatar}`]: t.avatar
    }, {
      [`& .${zt.avatar}`]: t[`avatar${pe(a)}`]
    }, {
      [`& .${zt.avatar}`]: t[`avatarColor${pe(o)}`]
    }, {
      [`& .${zt.icon}`]: t.icon
    }, {
      [`& .${zt.icon}`]: t[`icon${pe(a)}`]
    }, {
      [`& .${zt.icon}`]: t[`iconColor${pe(r)}`]
    }, {
      [`& .${zt.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${zt.deleteIcon}`]: t[`deleteIcon${pe(a)}`]
    }, {
      [`& .${zt.deleteIcon}`]: t[`deleteIconColor${pe(o)}`]
    }, {
      [`& .${zt.deleteIcon}`]: t[`deleteIcon${pe(c)}Color${pe(o)}`]
    }, t.root, t[`size${pe(a)}`], t[`color${pe(o)}`], i && t.clickable, i && o !== "default" && t[`clickableColor${pe(o)})`], s && t.deletable, s && o !== "default" && t[`deletableColor${pe(o)}`], t[c], t[`${c}${pe(o)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  const n = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return T({
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${zt.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${zt.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : n,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${zt.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${zt.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${zt.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${zt.icon}`]: T({
      marginLeft: 5,
      marginRight: -6
    }, t.size === "small" && {
      fontSize: 18,
      marginLeft: 4,
      marginRight: -4
    }, t.iconColor === t.color && T({
      color: e.vars ? e.vars.palette.Chip.defaultIconColor : n
    }, t.color !== "default" && {
      color: "inherit"
    })),
    [`& .${zt.deleteIcon}`]: T({
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : gt(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : gt(e.palette.text.primary, 0.4)
      }
    }, t.size === "small" && {
      fontSize: 16,
      marginRight: 4,
      marginLeft: -4
    }, t.color !== "default" && {
      color: e.vars ? `rgba(${e.vars.palette[t.color].contrastTextChannel} / 0.7)` : gt(e.palette[t.color].contrastText, 0.7),
      "&:hover, &:active": {
        color: (e.vars || e).palette[t.color].contrastText
      }
    })
  }, t.size === "small" && {
    height: 24
  }, t.color !== "default" && {
    backgroundColor: (e.vars || e).palette[t.color].main,
    color: (e.vars || e).palette[t.color].contrastText
  }, t.onDelete && {
    [`&.${zt.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : gt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  }, t.onDelete && t.color !== "default" && {
    [`&.${zt.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette[t.color].dark
    }
  });
}, ({
  theme: e,
  ownerState: t
}) => T({}, t.clickable && {
  userSelect: "none",
  WebkitTapHighlightColor: "transparent",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : gt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
  },
  [`&.${zt.focusVisible}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : gt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
  },
  "&:active": {
    boxShadow: (e.vars || e).shadows[1]
  }
}, t.clickable && t.color !== "default" && {
  [`&:hover, &.${zt.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette[t.color].dark
  }
}), ({
  theme: e,
  ownerState: t
}) => T({}, t.variant === "outlined" && {
  backgroundColor: "transparent",
  border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
  [`&.${zt.clickable}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${zt.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`& .${zt.avatar}`]: {
    marginLeft: 4
  },
  [`& .${zt.avatarSmall}`]: {
    marginLeft: 2
  },
  [`& .${zt.icon}`]: {
    marginLeft: 4
  },
  [`& .${zt.iconSmall}`]: {
    marginLeft: 2
  },
  [`& .${zt.deleteIcon}`]: {
    marginRight: 5
  },
  [`& .${zt.deleteIconSmall}`]: {
    marginRight: 3
  }
}, t.variant === "outlined" && t.color !== "default" && {
  color: (e.vars || e).palette[t.color].main,
  border: `1px solid ${e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.7)` : gt(e.palette[t.color].main, 0.7)}`,
  [`&.${zt.clickable}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : gt(e.palette[t.color].main, e.palette.action.hoverOpacity)
  },
  [`&.${zt.focusVisible}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.focusOpacity})` : gt(e.palette[t.color].main, e.palette.action.focusOpacity)
  },
  [`& .${zt.deleteIcon}`]: {
    color: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.7)` : gt(e.palette[t.color].main, 0.7),
    "&:hover, &:active": {
      color: (e.vars || e).palette[t.color].main
    }
  }
})), aH = B("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      size: o
    } = n;
    return [t.label, t[`label${pe(o)}`]];
  }
})(({
  ownerState: e
}) => T({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap"
}, e.variant === "outlined" && {
  paddingLeft: 11,
  paddingRight: 11
}, e.size === "small" && {
  paddingLeft: 8,
  paddingRight: 8
}, e.size === "small" && e.variant === "outlined" && {
  paddingLeft: 7,
  paddingRight: 7
}));
function fg(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const hs = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiChip"
  }), {
    avatar: r,
    className: i,
    clickable: s,
    color: a = "default",
    component: c,
    deleteIcon: d,
    disabled: u = !1,
    icon: p,
    label: h,
    onClick: g,
    onDelete: m,
    onKeyDown: b,
    onKeyUp: C,
    size: x = "medium",
    variant: v = "filled",
    tabIndex: S,
    skipFocusWhenDisabled: M = !1
    // TODO v6: Rename to `focusableWhenDisabled`.
  } = o, w = le(o, rH), k = y.useRef(null), E = Tt(k, n), R = (H) => {
    H.stopPropagation(), m && m(H);
  }, O = (H) => {
    H.currentTarget === H.target && fg(H) && H.preventDefault(), b && b(H);
  }, P = (H) => {
    H.currentTarget === H.target && (m && fg(H) ? m(H) : H.key === "Escape" && k.current && k.current.blur()), C && C(H);
  }, _ = s !== !1 && g ? !0 : s, L = _ || m ? wo : c || "div", V = T({}, o, {
    component: L,
    disabled: u,
    size: x,
    color: a,
    iconColor: /* @__PURE__ */ y.isValidElement(p) && p.props.color || a,
    onDelete: !!m,
    clickable: _,
    variant: v
  }), j = iH(V), I = L === wo ? T({
    component: c || "div",
    focusVisibleClassName: j.focusVisible
  }, m && {
    disableRipple: !0
  }) : {};
  let F = null;
  m && (F = d && /* @__PURE__ */ y.isValidElement(d) ? /* @__PURE__ */ y.cloneElement(d, {
    className: xe(d.props.className, j.deleteIcon),
    onClick: R
  }) : /* @__PURE__ */ f.jsx(nH, {
    className: xe(j.deleteIcon),
    onClick: R
  }));
  let $ = null;
  r && /* @__PURE__ */ y.isValidElement(r) && ($ = /* @__PURE__ */ y.cloneElement(r, {
    className: xe(j.avatar, r.props.className)
  }));
  let A = null;
  return p && /* @__PURE__ */ y.isValidElement(p) && (A = /* @__PURE__ */ y.cloneElement(p, {
    className: xe(j.icon, p.props.className)
  })), process.env.NODE_ENV !== "production" && $ && A && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ f.jsxs(sH, T({
    as: L,
    className: xe(j.root, i),
    disabled: _ && u ? !0 : void 0,
    onClick: g,
    onKeyDown: O,
    onKeyUp: P,
    ref: E,
    tabIndex: M && u ? -1 : S,
    ownerState: V
  }, I, w, {
    children: [$ || A, /* @__PURE__ */ f.jsx(aH, {
      className: xe(j.label),
      ownerState: V,
      children: h
    }), F]
  }));
});
process.env.NODE_ENV !== "production" && (hs.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: l.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: v0,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: l.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: l.oneOfType([l.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: l.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * Icon element.
   */
  icon: l.element,
  /**
   * The content of the component.
   */
  label: l.node,
  /**
   * @ignore
   */
  onClick: l.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: l.func,
  /**
   * @ignore
   */
  onKeyDown: l.func,
  /**
   * @ignore
   */
  onKeyUp: l.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * @ignore
   */
  tabIndex: l.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: l.oneOfType([l.oneOf(["filled", "outlined"]), l.string])
});
const lH = ["onChange", "maxRows", "minRows", "style", "value"];
function s1(e) {
  return parseInt(e, 10) || 0;
}
const cH = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function dH(e) {
  return e == null || Object.keys(e).length === 0 || e.outerHeightStyle === 0 && !e.overflowing;
}
const $4 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const {
    onChange: o,
    maxRows: r,
    minRows: i = 1,
    style: s,
    value: a
  } = t, c = le(t, lH), {
    current: d
  } = y.useRef(a != null), u = y.useRef(null), p = Tt(n, u), h = y.useRef(null), g = y.useRef(null), m = y.useCallback(() => {
    const x = u.current, S = ri(x).getComputedStyle(x);
    if (S.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    const M = g.current;
    M.style.width = S.width, M.value = x.value || t.placeholder || "x", M.value.slice(-1) === `
` && (M.value += " ");
    const w = S.boxSizing, k = s1(S.paddingBottom) + s1(S.paddingTop), E = s1(S.borderBottomWidth) + s1(S.borderTopWidth), R = M.scrollHeight;
    M.value = "x";
    const O = M.scrollHeight;
    let P = R;
    i && (P = Math.max(Number(i) * O, P)), r && (P = Math.min(Number(r) * O, P)), P = Math.max(P, O);
    const _ = P + (w === "border-box" ? k + E : 0), L = Math.abs(P - R) <= 1;
    return {
      outerHeightStyle: _,
      overflowing: L
    };
  }, [r, i, t.placeholder]), b = y.useCallback(() => {
    const x = m();
    if (dH(x))
      return;
    const v = x.outerHeightStyle, S = u.current;
    h.current !== v && (h.current = v, S.style.height = `${v}px`), S.style.overflow = x.overflowing ? "hidden" : "";
  }, [m]);
  En(() => {
    const x = () => {
      b();
    };
    let v;
    const S = () => {
      cancelAnimationFrame(v), v = requestAnimationFrame(() => {
        x();
      });
    }, M = n2(x), w = u.current, k = ri(w);
    k.addEventListener("resize", M);
    let E;
    return typeof ResizeObserver < "u" && (E = new ResizeObserver(process.env.NODE_ENV === "test" ? S : x), E.observe(w)), () => {
      M.clear(), cancelAnimationFrame(v), k.removeEventListener("resize", M), E && E.disconnect();
    };
  }, [m, b]), En(() => {
    b();
  });
  const C = (x) => {
    d || b(), o && o(x);
  };
  return /* @__PURE__ */ f.jsxs(y.Fragment, {
    children: [/* @__PURE__ */ f.jsx("textarea", T({
      value: a,
      onChange: C,
      ref: p,
      rows: i,
      style: s
    }, c)), /* @__PURE__ */ f.jsx("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: g,
      tabIndex: -1,
      style: T({}, cH.shadow, s, {
        paddingTop: 0,
        paddingBottom: 0
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && ($4.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: l.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: l.oneOfType([l.number, l.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: l.oneOfType([l.number, l.string]),
  /**
   * @ignore
   */
  onChange: l.func,
  /**
   * @ignore
   */
  placeholder: l.string,
  /**
   * @ignore
   */
  style: l.object,
  /**
   * @ignore
   */
  value: l.oneOfType([l.arrayOf(l.string), l.number, l.string])
});
function Es({
  props: e,
  states: t,
  muiFormControl: n
}) {
  return t.reduce((o, r) => (o[r] = e[r], n && typeof e[r] > "u" && (o[r] = n[r]), o), {});
}
const O0 = /* @__PURE__ */ y.createContext(void 0);
process.env.NODE_ENV !== "production" && (O0.displayName = "FormControlContext");
function ui() {
  return y.useContext(O0);
}
function Jv(e) {
  return /* @__PURE__ */ f.jsx(tv, T({}, e, {
    defaultTheme: m3,
    themeId: ma
  }));
}
process.env.NODE_ENV !== "production" && (Jv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: l.oneOfType([l.array, l.func, l.number, l.object, l.string, l.bool])
});
function pg(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function qd(e, t = !1) {
  return e && (pg(e.value) && e.value !== "" || t && pg(e.defaultValue) && e.defaultValue !== "");
}
function uH(e) {
  return e.startAdornment;
}
function fH(e) {
  return _e("MuiInputBase", e);
}
const Wo = Re("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]), pH = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "disableInjectingGlobalStyles", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "slotProps", "slots", "startAdornment", "type", "value"], v3 = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.formControl && t.formControl, n.startAdornment && t.adornedStart, n.endAdornment && t.adornedEnd, n.error && t.error, n.size === "small" && t.sizeSmall, n.multiline && t.multiline, n.color && t[`color${pe(n.color)}`], n.fullWidth && t.fullWidth, n.hiddenLabel && t.hiddenLabel];
}, w3 = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.input, n.size === "small" && t.inputSizeSmall, n.multiline && t.inputMultiline, n.type === "search" && t.inputTypeSearch, n.startAdornment && t.inputAdornedStart, n.endAdornment && t.inputAdornedEnd, n.hiddenLabel && t.inputHiddenLabel];
}, hH = (e) => {
  const {
    classes: t,
    color: n,
    disabled: o,
    error: r,
    endAdornment: i,
    focused: s,
    formControl: a,
    fullWidth: c,
    hiddenLabel: d,
    multiline: u,
    readOnly: p,
    size: h,
    startAdornment: g,
    type: m
  } = e, b = {
    root: ["root", `color${pe(n)}`, o && "disabled", r && "error", c && "fullWidth", s && "focused", a && "formControl", h && h !== "medium" && `size${pe(h)}`, u && "multiline", g && "adornedStart", i && "adornedEnd", d && "hiddenLabel", p && "readOnly"],
    input: ["input", o && "disabled", m === "search" && "inputTypeSearch", u && "inputMultiline", h === "small" && "inputSizeSmall", d && "inputHiddenLabel", g && "inputAdornedStart", i && "inputAdornedEnd", p && "readOnly"]
  };
  return Oe(b, fH, t);
}, S3 = B("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: v3
})(({
  theme: e,
  ownerState: t
}) => T({}, e.typography.body1, {
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${Wo.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  }
}, t.multiline && T({
  padding: "4px 0 5px"
}, t.size === "small" && {
  paddingTop: 1
}), t.fullWidth && {
  width: "100%"
})), M3 = B("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: w3
})(({
  theme: e,
  ownerState: t
}) => {
  const n = e.palette.mode === "light", o = T({
    color: "currentColor"
  }, e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: n ? 0.42 : 0.5
  }, {
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }), r = {
    opacity: "0 !important"
  }, i = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: n ? 0.42 : 0.5
  };
  return T({
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    // Fix IE11 width issue
    animationName: "mui-auto-fill-cancel",
    animationDuration: "10ms",
    "&::-webkit-input-placeholder": o,
    "&::-moz-placeholder": o,
    // Firefox 19+
    "&:-ms-input-placeholder": o,
    // IE11
    "&::-ms-input-placeholder": o,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${Wo.formControl} &`]: {
      "&::-webkit-input-placeholder": r,
      "&::-moz-placeholder": r,
      // Firefox 19+
      "&:-ms-input-placeholder": r,
      // IE11
      "&::-ms-input-placeholder": r,
      // Edge
      "&:focus::-webkit-input-placeholder": i,
      "&:focus::-moz-placeholder": i,
      // Firefox 19+
      "&:focus:-ms-input-placeholder": i,
      // IE11
      "&:focus::-ms-input-placeholder": i
      // Edge
    },
    [`&.${Wo.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    "&:-webkit-autofill": {
      animationDuration: "5000s",
      animationName: "mui-auto-fill"
    }
  }, t.size === "small" && {
    paddingTop: 1
  }, t.multiline && {
    height: "auto",
    resize: "none",
    padding: 0,
    paddingTop: 0
  }, t.type === "search" && {
    // Improve type search style.
    MozAppearance: "textfield"
  });
}), gH = /* @__PURE__ */ f.jsx(Jv, {
  styles: {
    "@keyframes mui-auto-fill": {
      from: {
        display: "block"
      }
    },
    "@keyframes mui-auto-fill-cancel": {
      from: {
        display: "block"
      }
    }
  }
}), a2 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o;
  const r = Xe({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": i,
    autoComplete: s,
    autoFocus: a,
    className: c,
    components: d = {},
    componentsProps: u = {},
    defaultValue: p,
    disabled: h,
    disableInjectingGlobalStyles: g,
    endAdornment: m,
    fullWidth: b = !1,
    id: C,
    inputComponent: x = "input",
    inputProps: v = {},
    inputRef: S,
    maxRows: M,
    minRows: w,
    multiline: k = !1,
    name: E,
    onBlur: R,
    onChange: O,
    onClick: P,
    onFocus: _,
    onKeyDown: L,
    onKeyUp: V,
    placeholder: j,
    readOnly: I,
    renderSuffix: F,
    rows: $,
    slotProps: A = {},
    slots: H = {},
    startAdornment: N,
    type: z = "text",
    value: se
  } = r, ne = le(r, pH), Z = v.value != null ? v.value : se, {
    current: q
  } = y.useRef(Z != null), G = y.useRef(), K = y.useCallback((fe) => {
    process.env.NODE_ENV !== "production" && fe && fe.nodeName !== "INPUT" && !fe.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), Q = Tt(G, S, v.ref, K), [re, U] = y.useState(!1), W = ui();
  process.env.NODE_ENV !== "production" && y.useEffect(() => {
    if (W)
      return W.registerEffect();
  }, [W]);
  const D = Es({
    props: r,
    muiFormControl: W,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  D.focused = W ? W.focused : re, y.useEffect(() => {
    !W && h && re && (U(!1), R && R());
  }, [W, h, re, R]);
  const X = W && W.onFilled, de = W && W.onEmpty, ue = y.useCallback((fe) => {
    qd(fe) ? X && X() : de && de();
  }, [X, de]);
  En(() => {
    q && ue({
      value: Z
    });
  }, [Z, ue, q]);
  const he = (fe) => {
    if (D.disabled) {
      fe.stopPropagation();
      return;
    }
    _ && _(fe), v.onFocus && v.onFocus(fe), W && W.onFocus ? W.onFocus(fe) : U(!0);
  }, Ue = (fe) => {
    R && R(fe), v.onBlur && v.onBlur(fe), W && W.onBlur ? W.onBlur(fe) : U(!1);
  }, me = (fe, ...ae) => {
    if (!q) {
      const Te = fe.target || G.current;
      if (Te == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : Pi(1));
      ue({
        value: Te.value
      });
    }
    v.onChange && v.onChange(fe, ...ae), O && O(fe, ...ae);
  };
  y.useEffect(() => {
    ue(G.current);
  }, []);
  const Ie = (fe) => {
    G.current && fe.currentTarget === fe.target && G.current.focus(), P && P(fe);
  };
  let te = x, ie = v;
  k && te === "input" && ($ ? (process.env.NODE_ENV !== "production" && (w || M) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), ie = T({
    type: void 0,
    minRows: $,
    maxRows: $
  }, ie)) : ie = T({
    type: void 0,
    maxRows: M,
    minRows: w
  }, ie), te = $4);
  const ye = (fe) => {
    ue(fe.animationName === "mui-auto-fill-cancel" ? G.current : {
      value: "x"
    });
  };
  y.useEffect(() => {
    W && W.setAdornedStart(!!N);
  }, [W, N]);
  const Ne = T({}, r, {
    color: D.color || "primary",
    disabled: D.disabled,
    endAdornment: m,
    error: D.error,
    focused: D.focused,
    formControl: W,
    fullWidth: b,
    hiddenLabel: D.hiddenLabel,
    multiline: k,
    size: D.size,
    startAdornment: N,
    type: z
  }), We = hH(Ne), qe = H.root || d.Root || S3, Me = A.root || u.root || {}, Pe = H.input || d.Input || M3;
  return ie = T({}, ie, (o = A.input) != null ? o : u.input), /* @__PURE__ */ f.jsxs(y.Fragment, {
    children: [!g && gH, /* @__PURE__ */ f.jsxs(qe, T({}, Me, !Qr(qe) && {
      ownerState: T({}, Ne, Me.ownerState)
    }, {
      ref: n,
      onClick: Ie
    }, ne, {
      className: xe(We.root, Me.className, c, I && "MuiInputBase-readOnly"),
      children: [N, /* @__PURE__ */ f.jsx(O0.Provider, {
        value: null,
        children: /* @__PURE__ */ f.jsx(Pe, T({
          ownerState: Ne,
          "aria-invalid": D.error,
          "aria-describedby": i,
          autoComplete: s,
          autoFocus: a,
          defaultValue: p,
          disabled: D.disabled,
          id: C,
          onAnimationStart: ye,
          name: E,
          placeholder: j,
          readOnly: I,
          required: D.required,
          rows: $,
          value: Z,
          onKeyDown: L,
          onKeyUp: V,
          type: z
        }, ie, !Qr(Pe) && {
          as: te,
          ownerState: T({}, Ne, ie.ownerState)
        }, {
          ref: Q,
          className: xe(We.input, ie.className, I && "MuiInputBase-readOnly"),
          onBlur: Ue,
          onChange: me,
          onFocus: he
        }))
      }), m, F ? F(T({}, D, {
        startAdornment: N
      })) : null]
    }))]
  });
});
process.env.NODE_ENV !== "production" && (a2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": l.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: l.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Input: l.elementType,
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    input: l.object,
    root: l.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: l.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: l.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: l.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: l.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: Pa,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: l.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: l.oneOfType([l.number, l.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: l.oneOfType([l.number, l.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: l.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: l.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: l.func,
  /**
   * @ignore
   */
  onClick: l.func,
  /**
   * @ignore
   */
  onFocus: l.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: l.func,
  /**
   * @ignore
   */
  onKeyDown: l.func,
  /**
   * @ignore
   */
  onKeyUp: l.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: l.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: l.bool,
  /**
   * @ignore
   */
  renderSuffix: l.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: l.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: l.oneOfType([l.number, l.string]),
  /**
   * The size of the component.
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: l.shape({
    input: l.object,
    root: l.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    input: l.elementType,
    root: l.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: l.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: l.any
});
function mH(e) {
  return _e("MuiInput", e);
}
const qi = T({}, Wo, Re("MuiInput", ["root", "underline", "input"]));
function bH(e) {
  return _e("MuiOutlinedInput", e);
}
const $r = T({}, Wo, Re("MuiOutlinedInput", ["root", "notchedOutline", "input"]));
function CH(e) {
  return _e("MuiFilledInput", e);
}
const Uo = T({}, Wo, Re("MuiFilledInput", ["root", "underline", "input"])), Qv = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function xH(e) {
  return _e("MuiAutocomplete", e);
}
const Rt = Re("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
var hg, gg;
const yH = ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "className", "clearIcon", "clearOnBlur", "clearOnEscape", "clearText", "closeText", "componentsProps", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionKey", "getOptionLabel", "isOptionEqualToValue", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "readOnly", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "slotProps", "value"], vH = ["ref"], wH = ["key"], SH = ["key"], MH = (e) => {
  const {
    classes: t,
    disablePortal: n,
    expanded: o,
    focused: r,
    fullWidth: i,
    hasClearIcon: s,
    hasPopupIcon: a,
    inputFocused: c,
    popupOpen: d,
    size: u
  } = e, p = {
    root: ["root", o && "expanded", r && "focused", i && "fullWidth", s && "hasClearIcon", a && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", c && "inputFocused"],
    tag: ["tag", `tagSize${pe(u)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", d && "popupIndicatorOpen"],
    popper: ["popper", n && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return Oe(p, xH, t);
}, TH = B("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      fullWidth: o,
      hasClearIcon: r,
      hasPopupIcon: i,
      inputFocused: s,
      size: a
    } = n;
    return [{
      [`& .${Rt.tag}`]: t.tag
    }, {
      [`& .${Rt.tag}`]: t[`tagSize${pe(a)}`]
    }, {
      [`& .${Rt.inputRoot}`]: t.inputRoot
    }, {
      [`& .${Rt.input}`]: t.input
    }, {
      [`& .${Rt.input}`]: s && t.inputFocused
    }, t.root, o && t.fullWidth, i && t.hasPopupIcon, r && t.hasClearIcon];
  }
})({
  [`&.${Rt.focused} .${Rt.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${Rt.clearIndicator}`]: {
      visibility: "visible"
    }
  },
  [`& .${Rt.tag}`]: {
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  },
  [`& .${Rt.inputRoot}`]: {
    [`.${Rt.hasPopupIcon}&, .${Rt.hasClearIcon}&`]: {
      paddingRight: 30
    },
    [`.${Rt.hasPopupIcon}.${Rt.hasClearIcon}&`]: {
      paddingRight: 56
    },
    [`& .${Rt.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${qi.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${qi.root}.${Wo.sizeSmall}`]: {
    [`& .${qi.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${$r.root}`]: {
    padding: 9,
    [`.${Rt.hasPopupIcon}&, .${Rt.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${Rt.hasPopupIcon}.${Rt.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${Rt.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${Rt.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${$r.root}.${Wo.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${Rt.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${Uo.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${Rt.hasPopupIcon}&, .${Rt.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${Rt.hasPopupIcon}.${Rt.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${Uo.input}`]: {
      padding: "7px 4px"
    },
    [`& .${Rt.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${Uo.root}.${Wo.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${Uo.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${Wo.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${Uo.root}.${Wo.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${Rt.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${Uo.root}.${Wo.hiddenLabel}.${Wo.sizeSmall}`]: {
    [`& .${Rt.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${Rt.input}`]: {
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      [`& .${Rt.tag}`]: {
        margin: 2,
        maxWidth: "calc(100% - 4px)"
      }
    }
  }, {
    props: {
      inputFocused: !0
    },
    style: {
      [`& .${Rt.input}`]: {
        opacity: 1
      }
    }
  }, {
    props: {
      multiple: !0
    },
    style: {
      [`& .${Rt.inputRoot}`]: {
        flexWrap: "wrap"
      }
    }
  }]
}), kH = B("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment",
  overridesResolver: (e, t) => t.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translate(0, -50%)"
}), EH = B(Bt, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator",
  overridesResolver: (e, t) => t.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), RH = B(Bt, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: ({
    ownerState: e
  }, t) => T({}, t.popupIndicator, e.popupOpen && t.popupIndicatorOpen)
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: !0
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}), OH = B(s2, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${Rt.option}`]: t.option
    }, t.popper, n.disablePortal && t.popperDisablePortal];
  }
})(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.modal,
  variants: [{
    props: {
      disablePortal: !0
    },
    style: {
      position: "absolute"
    }
  }]
})), _H = B(Tr, {
  name: "MuiAutocomplete",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(({
  theme: e
}) => T({}, e.typography.body1, {
  overflow: "auto"
})), PH = B("div", {
  name: "MuiAutocomplete",
  slot: "Loading",
  overridesResolver: (e, t) => t.loading
})(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
})), LH = B("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions",
  overridesResolver: (e, t) => t.noOptions
})(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
})), IH = B("div", {
  name: "MuiAutocomplete",
  slot: "Listbox",
  overridesResolver: (e, t) => t.listbox
})(({
  theme: e
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${Rt.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [e.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${Rt.focused}`]: {
      backgroundColor: (e.vars || e).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${Rt.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : gt(e.palette.primary.main, e.palette.action.selectedOpacity),
      [`&.${Rt.focused}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : gt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette.action.selected
        }
      },
      [`&.${Rt.focusVisible}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : gt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
      }
    }
  }
})), jH = B(N4, {
  name: "MuiAutocomplete",
  slot: "GroupLabel",
  overridesResolver: (e, t) => t.groupLabel
})(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  top: -8
})), VH = B("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl",
  overridesResolver: (e, t) => t.groupUl
})({
  padding: 0,
  [`& .${Rt.option}`]: {
    paddingLeft: 24
  }
}), ew = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i, s;
  const a = Xe({
    props: t,
    name: "MuiAutocomplete"
  }), {
    autoComplete: c = !1,
    autoHighlight: d = !1,
    autoSelect: u = !1,
    blurOnSelect: p = !1,
    ChipProps: h,
    className: g,
    clearIcon: m = hg || (hg = /* @__PURE__ */ f.jsx(Dv, {
      fontSize: "small"
    })),
    clearOnBlur: b = !a.freeSolo,
    clearOnEscape: C = !1,
    clearText: x = "Clear",
    closeText: v = "Close",
    componentsProps: S = {},
    defaultValue: M = a.multiple ? [] : null,
    disableClearable: w = !1,
    disableCloseOnSelect: k = !1,
    disabled: E = !1,
    disabledItemsFocusable: R = !1,
    disableListWrap: O = !1,
    disablePortal: P = !1,
    filterSelectedOptions: _ = !1,
    forcePopupIcon: L = "auto",
    freeSolo: V = !1,
    fullWidth: j = !1,
    getLimitTagsText: I = (ee) => `+${ee}`,
    getOptionLabel: F,
    groupBy: $,
    handleHomeEndKeys: A = !a.freeSolo,
    includeInputInList: H = !1,
    limitTags: N = -1,
    ListboxComponent: z = "ul",
    ListboxProps: se,
    loading: ne = !1,
    loadingText: Z = "Loading…",
    multiple: q = !1,
    noOptionsText: G = "No options",
    openOnFocus: K = !1,
    openText: Q = "Open",
    PaperComponent: re = Tr,
    PopperComponent: U = s2,
    popupIcon: W = gg || (gg = /* @__PURE__ */ f.jsx(Qv, {})),
    readOnly: D = !1,
    renderGroup: X,
    renderInput: de,
    renderOption: ue,
    renderTags: he,
    selectOnFocus: Ue = !a.freeSolo,
    size: me = "medium",
    slotProps: Ie = {}
  } = a, te = le(a, yH), {
    getRootProps: ie,
    getInputProps: ye,
    getInputLabelProps: Ne,
    getPopupIndicatorProps: We,
    getClearProps: qe,
    getTagProps: Me,
    getListboxProps: Pe,
    getOptionProps: fe,
    value: ae,
    dirty: Te,
    expanded: tt,
    id: Ye,
    popupOpen: Le,
    focused: Ve,
    focusedTag: Ce,
    anchorEl: Se,
    setAnchorEl: ve,
    inputValue: Be,
    groupedOptions: rt
  } = Fv(T({}, a, {
    componentName: "Autocomplete"
  })), pt = !w && !E && Te && !D, Je = (!V || L === !0) && L !== !1, {
    onMouseDown: At
  } = ye(), {
    ref: Ht
  } = se ?? {}, Ct = Pe(), {
    ref: qt
  } = Ct, Bn = le(Ct, vH), xn = Tt(qt, Ht), zn = F || ((ee) => {
    var we;
    return (we = ee.label) != null ? we : ee;
  }), bn = T({}, a, {
    disablePortal: P,
    expanded: tt,
    focused: Ve,
    fullWidth: j,
    getOptionLabel: zn,
    hasClearIcon: pt,
    hasPopupIcon: Je,
    inputFocused: Ce === -1,
    popupOpen: Le,
    size: me
  }), Zt = MH(bn);
  let vn;
  if (q && ae.length > 0) {
    const ee = (we) => T({
      className: Zt.tag,
      disabled: E
    }, Me(we));
    he ? vn = he(ae, ee, bn) : vn = ae.map((we, De) => {
      const nt = ee({
        index: De
      }), {
        key: ze
      } = nt, lt = le(nt, wH);
      return /* @__PURE__ */ f.jsx(hs, T({
        label: zn(we),
        size: me
      }, lt, h), ze);
    });
  }
  if (N > -1 && Array.isArray(vn)) {
    const ee = vn.length - N;
    !Ve && ee > 0 && (vn = vn.splice(0, N), vn.push(/* @__PURE__ */ f.jsx("span", {
      className: Zt.tag,
      children: I(ee)
    }, vn.length)));
  }
  const oo = X || ((ee) => /* @__PURE__ */ f.jsxs("li", {
    children: [/* @__PURE__ */ f.jsx(jH, {
      className: Zt.groupLabel,
      ownerState: bn,
      component: "div",
      children: ee.group
    }), /* @__PURE__ */ f.jsx(VH, {
      className: Zt.groupUl,
      ownerState: bn,
      children: ee.children
    })]
  }, ee.key)), Wt = ue || ((ee, we) => {
    const {
      key: De
    } = ee, nt = le(ee, SH);
    return /* @__PURE__ */ f.jsx("li", T({}, nt, {
      children: zn(we)
    }), De);
  }), Y = (ee, we) => {
    const De = fe({
      option: ee,
      index: we
    });
    return Wt(T({}, De, {
      className: Zt.option
    }), ee, {
      selected: De["aria-selected"],
      index: we,
      inputValue: Be
    }, bn);
  }, ke = (o = Ie.clearIndicator) != null ? o : S.clearIndicator, He = (r = Ie.paper) != null ? r : S.paper, st = (i = Ie.popper) != null ? i : S.popper, ce = (s = Ie.popupIndicator) != null ? s : S.popupIndicator;
  return /* @__PURE__ */ f.jsxs(y.Fragment, {
    children: [/* @__PURE__ */ f.jsx(TH, T({
      ref: n,
      className: xe(Zt.root, g),
      ownerState: bn
    }, ie(te), {
      children: de({
        id: Ye,
        disabled: E,
        fullWidth: !0,
        size: me === "small" ? "small" : void 0,
        InputLabelProps: Ne(),
        InputProps: T({
          ref: ve,
          className: Zt.inputRoot,
          startAdornment: vn,
          onClick: (ee) => {
            ee.target === ee.currentTarget && At(ee);
          }
        }, (pt || Je) && {
          endAdornment: /* @__PURE__ */ f.jsxs(kH, {
            className: Zt.endAdornment,
            ownerState: bn,
            children: [pt ? /* @__PURE__ */ f.jsx(EH, T({}, qe(), {
              "aria-label": x,
              title: x,
              ownerState: bn
            }, ke, {
              className: xe(Zt.clearIndicator, ke == null ? void 0 : ke.className),
              children: m
            })) : null, Je ? /* @__PURE__ */ f.jsx(RH, T({}, We(), {
              disabled: E,
              "aria-label": Le ? v : Q,
              title: Le ? v : Q,
              ownerState: bn
            }, ce, {
              className: xe(Zt.popupIndicator, ce == null ? void 0 : ce.className),
              children: W
            })) : null]
          })
        }),
        inputProps: T({
          className: Zt.input,
          disabled: E,
          readOnly: D
        }, ye())
      })
    })), Se ? /* @__PURE__ */ f.jsx(OH, T({
      as: U,
      disablePortal: P,
      style: {
        width: Se ? Se.clientWidth : null
      },
      ownerState: bn,
      role: "presentation",
      anchorEl: Se,
      open: Le
    }, st, {
      className: xe(Zt.popper, st == null ? void 0 : st.className),
      children: /* @__PURE__ */ f.jsxs(_H, T({
        ownerState: bn,
        as: re
      }, He, {
        className: xe(Zt.paper, He == null ? void 0 : He.className),
        children: [ne && rt.length === 0 ? /* @__PURE__ */ f.jsx(PH, {
          className: Zt.loading,
          ownerState: bn,
          children: Z
        }) : null, rt.length === 0 && !V && !ne ? /* @__PURE__ */ f.jsx(LH, {
          className: Zt.noOptions,
          ownerState: bn,
          role: "presentation",
          onMouseDown: (ee) => {
            ee.preventDefault();
          },
          children: G
        }) : null, rt.length > 0 ? /* @__PURE__ */ f.jsx(IH, T({
          as: z,
          className: Zt.listbox,
          ownerState: bn
        }, Bn, se, {
          ref: xn,
          children: rt.map((ee, we) => $ ? oo({
            key: ee.key,
            group: ee.group,
            children: ee.options.map((De, nt) => Y(De, ee.index + nt))
          }) : Y(ee, we))
        })) : null]
      }))
    })) : null]
  });
});
process.env.NODE_ENV !== "production" && (ew.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: l.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: l.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: l.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: l.oneOfType([l.oneOf(["mouse", "touch"]), l.bool]),
  /**
   * Props applied to the [`Chip`](/material-ui/api/chip/) element.
   */
  ChipProps: l.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: l.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: l.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: l.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: l.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: l.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: l.shape({
    clearIndicator: l.object,
    paper: l.object,
    popper: l.object,
    popupIndicator: l.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: vo(l.any, (e) => e.multiple && e.defaultValue !== void 0 && !Array.isArray(e.defaultValue) ? new Error(["MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.", `However, ${e.defaultValue} was provided.`].join(`
`)) : null),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: l.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: l.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: l.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: l.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: l.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: l.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: l.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: l.oneOfType([l.oneOf(["auto"]), l.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: l.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: l.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: l.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: l.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: l.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} options The options to group.
   * @returns {string}
   */
  groupBy: l.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: l.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: l.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: l.bool,
  /**
   * The input value.
   */
  inputValue: l.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: l.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: Gi,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   */
  ListboxComponent: l.elementType,
  /**
   * Props applied to the Listbox element.
   */
  ListboxProps: l.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */
  loading: l.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: l.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: l.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: l.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: l.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: l.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
   */
  onInputChange: l.func,
  /**
   * @ignore
   */
  onKeyDown: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: l.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: l.string,
  /**
   * Array of options.
   */
  options: l.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   */
  PaperComponent: l.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   */
  PopperComponent: l.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: l.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: l.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: l.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: l.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: l.func,
  /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: l.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: l.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["small", "medium"]), l.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: l.shape({
    clearIndicator: l.object,
    paper: l.object,
    popper: l.object,
    popupIndicator: l.object
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: vo(l.any, (e) => e.multiple && e.value !== void 0 && !Array.isArray(e.value) ? new Error(["MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.", `However, ${e.value} was provided.`].join(`
`)) : null)
});
const DH = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");
function AH(e) {
  return _e("MuiAvatar", e);
}
Re("MuiAvatar", ["root", "colorDefault", "circular", "rounded", "square", "img", "fallback"]);
const HH = ["alt", "children", "className", "component", "slots", "slotProps", "imgProps", "sizes", "src", "srcSet", "variant"], FH = (e) => {
  const {
    classes: t,
    variant: n,
    colorDefault: o
  } = e;
  return Oe({
    root: ["root", n, o && "colorDefault"],
    img: ["img"],
    fallback: ["fallback"]
  }, AH, t);
}, NH = B("div", {
  name: "MuiAvatar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], n.colorDefault && t.colorDefault];
  }
})(({
  theme: e
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: 40,
  height: 40,
  fontFamily: e.typography.fontFamily,
  fontSize: e.typography.pxToRem(20),
  lineHeight: 1,
  borderRadius: "50%",
  overflow: "hidden",
  userSelect: "none",
  variants: [{
    props: {
      variant: "rounded"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius
    }
  }, {
    props: {
      variant: "square"
    },
    style: {
      borderRadius: 0
    }
  }, {
    props: {
      colorDefault: !0
    },
    style: T({
      color: (e.vars || e).palette.background.default
    }, e.vars ? {
      backgroundColor: e.vars.palette.Avatar.defaultBg
    } : T({
      backgroundColor: e.palette.grey[400]
    }, e.applyStyles("dark", {
      backgroundColor: e.palette.grey[600]
    })))
  }]
})), $H = B("img", {
  name: "MuiAvatar",
  slot: "Img",
  overridesResolver: (e, t) => t.img
})({
  width: "100%",
  height: "100%",
  textAlign: "center",
  // Handle non-square image. The property isn't supported by IE11.
  objectFit: "cover",
  // Hide alt text.
  color: "transparent",
  // Hide the image broken icon, only works on Chrome.
  textIndent: 1e4
}), BH = B(DH, {
  name: "MuiAvatar",
  slot: "Fallback",
  overridesResolver: (e, t) => t.fallback
})({
  width: "75%",
  height: "75%"
});
function zH({
  crossOrigin: e,
  referrerPolicy: t,
  src: n,
  srcSet: o
}) {
  const [r, i] = y.useState(!1);
  return y.useEffect(() => {
    if (!n && !o)
      return;
    i(!1);
    let s = !0;
    const a = new Image();
    return a.onload = () => {
      s && i("loaded");
    }, a.onerror = () => {
      s && i("error");
    }, a.crossOrigin = e, a.referrerPolicy = t, a.src = n, o && (a.srcset = o), () => {
      s = !1;
    };
  }, [e, t, n, o]), r;
}
const l2 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiAvatar"
  }), {
    alt: r,
    children: i,
    className: s,
    component: a = "div",
    slots: c = {},
    slotProps: d = {},
    imgProps: u,
    sizes: p,
    src: h,
    srcSet: g,
    variant: m = "circular"
  } = o, b = le(o, HH);
  let C = null;
  const x = zH(T({}, u, {
    src: h,
    srcSet: g
  })), v = h || g, S = v && x !== "error", M = T({}, o, {
    colorDefault: !S,
    component: a,
    variant: m
  }), w = FH(M), [k, E] = Wd("img", {
    className: w.img,
    elementType: $H,
    externalForwardedProps: {
      slots: c,
      slotProps: {
        img: T({}, u, d.img)
      }
    },
    additionalProps: {
      alt: r,
      src: h,
      srcSet: g,
      sizes: p
    },
    ownerState: M
  });
  return S ? C = /* @__PURE__ */ f.jsx(k, T({}, E)) : i || i === 0 ? C = i : v && r ? C = r[0] : C = /* @__PURE__ */ f.jsx(BH, {
    ownerState: M,
    className: w.fallback
  }), /* @__PURE__ */ f.jsx(NH, T({
    as: a,
    ownerState: M,
    className: xe(w.root, s),
    ref: n
  }, b, {
    children: C
  }));
});
process.env.NODE_ENV !== "production" && (l2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: l.string,
  /**
   * Used to render icon or text elements inside the Avatar if `src` is not set.
   * This can be an element, or just a string.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attributes) applied to the `img` element if the component is used to display an image.
   * It can be used to listen for the loading error event.
   * @deprecated Use `slotProps.img` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */
  imgProps: l.object,
  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: l.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: l.shape({
    img: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: l.shape({
    img: l.elementType
  }),
  /**
   * The `src` attribute for the `img` element.
   */
  src: l.string,
  /**
   * The `srcSet` attribute for the `img` element.
   * Use this attribute for responsive image display.
   */
  srcSet: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The shape of the avatar.
   * @default 'circular'
   */
  variant: l.oneOfType([l.oneOf(["circular", "rounded", "square"]), l.string])
});
const ZH = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], WH = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, Ia = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = ge(), r = {
    enter: o.transitions.duration.enteringScreen,
    exit: o.transitions.duration.leavingScreen
  }, {
    addEndListener: i,
    appear: s = !0,
    children: a,
    easing: c,
    in: d,
    onEnter: u,
    onEntered: p,
    onEntering: h,
    onExit: g,
    onExited: m,
    onExiting: b,
    style: C,
    timeout: x = r,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: v = nr
  } = t, S = le(t, ZH), M = y.useRef(null), w = Tt(M, o2(a), n), k = (j) => (I) => {
    if (j) {
      const F = M.current;
      I === void 0 ? j(F) : j(F, I);
    }
  }, E = k(h), R = k((j, I) => {
    Iv(j);
    const F = Il({
      style: C,
      timeout: x,
      easing: c
    }, {
      mode: "enter"
    });
    j.style.webkitTransition = o.transitions.create("opacity", F), j.style.transition = o.transitions.create("opacity", F), u && u(j, I);
  }), O = k(p), P = k(b), _ = k((j) => {
    const I = Il({
      style: C,
      timeout: x,
      easing: c
    }, {
      mode: "exit"
    });
    j.style.webkitTransition = o.transitions.create("opacity", I), j.style.transition = o.transitions.create("opacity", I), g && g(j);
  }), L = k(m), V = (j) => {
    i && i(M.current, j);
  };
  return /* @__PURE__ */ f.jsx(v, T({
    appear: s,
    in: d,
    nodeRef: M,
    onEnter: R,
    onEntered: O,
    onEntering: E,
    onExit: _,
    onExited: L,
    onExiting: P,
    addEndListener: V,
    timeout: x
  }, S, {
    children: (j, I) => /* @__PURE__ */ y.cloneElement(a, T({
      style: T({
        opacity: 0,
        visibility: j === "exited" && !d ? "hidden" : void 0
      }, WH[j], C, a.props.style),
      ref: w
    }, I))
  }));
});
process.env.NODE_ENV !== "production" && (Ia.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: l.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: l.bool,
  /**
   * A single child content element.
   */
  children: t2.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: l.oneOfType([l.shape({
    enter: l.string,
    exit: l.string
  }), l.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: l.bool,
  /**
   * @ignore
   */
  onEnter: l.func,
  /**
   * @ignore
   */
  onEntered: l.func,
  /**
   * @ignore
   */
  onEntering: l.func,
  /**
   * @ignore
   */
  onExit: l.func,
  /**
   * @ignore
   */
  onExited: l.func,
  /**
   * @ignore
   */
  onExiting: l.func,
  /**
   * @ignore
   */
  style: l.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: l.oneOfType([l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })])
});
function UH(e) {
  return _e("MuiBackdrop", e);
}
Re("MuiBackdrop", ["root", "invisible"]);
const GH = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"], qH = (e) => {
  const {
    classes: t,
    invisible: n
  } = e;
  return Oe({
    root: ["root", n && "invisible"]
  }, UH, t);
}, KH = B("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.invisible && t.invisible];
  }
})(({
  ownerState: e
}) => T({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, e.invisible && {
  backgroundColor: "transparent"
})), B4 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i;
  const s = Xe({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: a,
    className: c,
    component: d = "div",
    components: u = {},
    componentsProps: p = {},
    invisible: h = !1,
    open: g,
    slotProps: m = {},
    slots: b = {},
    TransitionComponent: C = Ia,
    transitionDuration: x
  } = s, v = le(s, GH), S = T({}, s, {
    component: d,
    invisible: h
  }), M = qH(S), w = (o = m.root) != null ? o : p.root;
  return /* @__PURE__ */ f.jsx(C, T({
    in: g,
    timeout: x
  }, v, {
    children: /* @__PURE__ */ f.jsx(KH, T({
      "aria-hidden": !0
    }, w, {
      as: (r = (i = b.root) != null ? i : u.Root) != null ? r : d,
      className: xe(M.root, c, w == null ? void 0 : w.className),
      ownerState: T({}, S, w == null ? void 0 : w.ownerState),
      classes: M,
      ref: n,
      children: a
    }))
  }));
});
process.env.NODE_ENV !== "production" && (B4.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    root: l.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: l.bool,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: l.shape({
    root: l.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: l.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: l.oneOfType([l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })])
});
function YH(e) {
  const {
    badgeContent: t,
    invisible: n = !1,
    max: o = 99,
    showZero: r = !1
  } = e, i = x4({
    badgeContent: t,
    max: o
  });
  let s = n;
  n === !1 && t === 0 && !r && (s = !0);
  const {
    badgeContent: a,
    max: c = o
  } = s ? i : e, d = a && Number(a) > c ? `${c}+` : a;
  return {
    badgeContent: a,
    invisible: s,
    max: c,
    displayValue: d
  };
}
function XH(e) {
  return _e("MuiBadge", e);
}
const Ai = Re("MuiBadge", [
  "root",
  "badge",
  "dot",
  "standard",
  "anchorOriginTopRight",
  "anchorOriginBottomRight",
  "anchorOriginTopLeft",
  "anchorOriginBottomLeft",
  "invisible",
  "colorError",
  "colorInfo",
  "colorPrimary",
  "colorSecondary",
  "colorSuccess",
  "colorWarning",
  "overlapRectangular",
  "overlapCircular",
  // TODO: v6 remove the overlap value from these class keys
  "anchorOriginTopLeftCircular",
  "anchorOriginTopLeftRectangular",
  "anchorOriginTopRightCircular",
  "anchorOriginTopRightRectangular",
  "anchorOriginBottomLeftCircular",
  "anchorOriginBottomLeftRectangular",
  "anchorOriginBottomRightCircular",
  "anchorOriginBottomRightRectangular"
]), JH = ["anchorOrigin", "className", "classes", "component", "components", "componentsProps", "children", "overlap", "color", "invisible", "max", "badgeContent", "slots", "slotProps", "showZero", "variant"], Nf = 10, $f = 4, QH = (e) => {
  const {
    color: t,
    anchorOrigin: n,
    invisible: o,
    overlap: r,
    variant: i,
    classes: s = {}
  } = e, a = {
    root: ["root"],
    badge: ["badge", i, o && "invisible", `anchorOrigin${pe(n.vertical)}${pe(n.horizontal)}`, `anchorOrigin${pe(n.vertical)}${pe(n.horizontal)}${pe(r)}`, `overlap${pe(r)}`, t !== "default" && `color${pe(t)}`]
  };
  return Oe(a, XH, s);
}, eF = B("span", {
  name: "MuiBadge",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  position: "relative",
  display: "inline-flex",
  // For correct alignment with the text.
  verticalAlign: "middle",
  flexShrink: 0
}), tF = B("span", {
  name: "MuiBadge",
  slot: "Badge",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.badge, t[n.variant], t[`anchorOrigin${pe(n.anchorOrigin.vertical)}${pe(n.anchorOrigin.horizontal)}${pe(n.overlap)}`], n.color !== "default" && t[`color${pe(n.color)}`], n.invisible && t.invisible];
  }
})(({
  theme: e
}) => {
  var t;
  return {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    position: "absolute",
    boxSizing: "border-box",
    fontFamily: e.typography.fontFamily,
    fontWeight: e.typography.fontWeightMedium,
    fontSize: e.typography.pxToRem(12),
    minWidth: Nf * 2,
    lineHeight: 1,
    padding: "0 6px",
    height: Nf * 2,
    borderRadius: Nf,
    zIndex: 1,
    // Render the badge on top of potential ripples.
    transition: e.transitions.create("transform", {
      easing: e.transitions.easing.easeInOut,
      duration: e.transitions.duration.enteringScreen
    }),
    variants: [...Object.keys(((t = e.vars) != null ? t : e).palette).filter((n) => {
      var o, r;
      return ((o = e.vars) != null ? o : e).palette[n].main && ((r = e.vars) != null ? r : e).palette[n].contrastText;
    }).map((n) => ({
      props: {
        color: n
      },
      style: {
        backgroundColor: (e.vars || e).palette[n].main,
        color: (e.vars || e).palette[n].contrastText
      }
    })), {
      props: {
        variant: "dot"
      },
      style: {
        borderRadius: $f,
        height: $f * 2,
        minWidth: $f * 2,
        padding: 0
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "top" && n.anchorOrigin.horizontal === "right" && n.overlap === "rectangular",
      style: {
        top: 0,
        right: 0,
        transform: "scale(1) translate(50%, -50%)",
        transformOrigin: "100% 0%",
        [`&.${Ai.invisible}`]: {
          transform: "scale(0) translate(50%, -50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "bottom" && n.anchorOrigin.horizontal === "right" && n.overlap === "rectangular",
      style: {
        bottom: 0,
        right: 0,
        transform: "scale(1) translate(50%, 50%)",
        transformOrigin: "100% 100%",
        [`&.${Ai.invisible}`]: {
          transform: "scale(0) translate(50%, 50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "top" && n.anchorOrigin.horizontal === "left" && n.overlap === "rectangular",
      style: {
        top: 0,
        left: 0,
        transform: "scale(1) translate(-50%, -50%)",
        transformOrigin: "0% 0%",
        [`&.${Ai.invisible}`]: {
          transform: "scale(0) translate(-50%, -50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "bottom" && n.anchorOrigin.horizontal === "left" && n.overlap === "rectangular",
      style: {
        bottom: 0,
        left: 0,
        transform: "scale(1) translate(-50%, 50%)",
        transformOrigin: "0% 100%",
        [`&.${Ai.invisible}`]: {
          transform: "scale(0) translate(-50%, 50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "top" && n.anchorOrigin.horizontal === "right" && n.overlap === "circular",
      style: {
        top: "14%",
        right: "14%",
        transform: "scale(1) translate(50%, -50%)",
        transformOrigin: "100% 0%",
        [`&.${Ai.invisible}`]: {
          transform: "scale(0) translate(50%, -50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "bottom" && n.anchorOrigin.horizontal === "right" && n.overlap === "circular",
      style: {
        bottom: "14%",
        right: "14%",
        transform: "scale(1) translate(50%, 50%)",
        transformOrigin: "100% 100%",
        [`&.${Ai.invisible}`]: {
          transform: "scale(0) translate(50%, 50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "top" && n.anchorOrigin.horizontal === "left" && n.overlap === "circular",
      style: {
        top: "14%",
        left: "14%",
        transform: "scale(1) translate(-50%, -50%)",
        transformOrigin: "0% 0%",
        [`&.${Ai.invisible}`]: {
          transform: "scale(0) translate(-50%, -50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "bottom" && n.anchorOrigin.horizontal === "left" && n.overlap === "circular",
      style: {
        bottom: "14%",
        left: "14%",
        transform: "scale(1) translate(-50%, 50%)",
        transformOrigin: "0% 100%",
        [`&.${Ai.invisible}`]: {
          transform: "scale(0) translate(-50%, 50%)"
        }
      }
    }, {
      props: {
        invisible: !0
      },
      style: {
        transition: e.transitions.create("transform", {
          easing: e.transitions.easing.easeInOut,
          duration: e.transitions.duration.leavingScreen
        })
      }
    }]
  };
}), tw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i, s, a, c;
  const d = Xe({
    props: t,
    name: "MuiBadge"
  }), {
    anchorOrigin: u = {
      vertical: "top",
      horizontal: "right"
    },
    className: p,
    component: h,
    components: g = {},
    componentsProps: m = {},
    children: b,
    overlap: C = "rectangular",
    color: x = "default",
    invisible: v = !1,
    max: S = 99,
    badgeContent: M,
    slots: w,
    slotProps: k,
    showZero: E = !1,
    variant: R = "standard"
  } = d, O = le(d, JH), {
    badgeContent: P,
    invisible: _,
    max: L,
    displayValue: V
  } = YH({
    max: S,
    invisible: v,
    badgeContent: M,
    showZero: E
  }), j = x4({
    anchorOrigin: u,
    color: x,
    overlap: C,
    variant: R,
    badgeContent: M
  }), I = _ || P == null && R !== "dot", {
    color: F = x,
    overlap: $ = C,
    anchorOrigin: A = u,
    variant: H = R
  } = I ? j : d, N = H !== "dot" ? V : void 0, z = T({}, d, {
    badgeContent: P,
    invisible: I,
    max: L,
    displayValue: N,
    showZero: E,
    anchorOrigin: A,
    color: F,
    overlap: $,
    variant: H
  }), se = QH(z), ne = (o = (r = w == null ? void 0 : w.root) != null ? r : g.Root) != null ? o : eF, Z = (i = (s = w == null ? void 0 : w.badge) != null ? s : g.Badge) != null ? i : tF, q = (a = k == null ? void 0 : k.root) != null ? a : m.root, G = (c = k == null ? void 0 : k.badge) != null ? c : m.badge, K = Ft({
    elementType: ne,
    externalSlotProps: q,
    externalForwardedProps: O,
    additionalProps: {
      ref: n,
      as: h
    },
    ownerState: z,
    className: xe(q == null ? void 0 : q.className, se.root, p)
  }), Q = Ft({
    elementType: Z,
    externalSlotProps: G,
    ownerState: z,
    className: xe(se.badge, G == null ? void 0 : G.className)
  });
  return /* @__PURE__ */ f.jsxs(ne, T({}, K, {
    children: [b, /* @__PURE__ */ f.jsx(Z, T({}, Q, {
      children: N
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (tw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
   */
  anchorOrigin: l.shape({
    horizontal: l.oneOf(["left", "right"]).isRequired,
    vertical: l.oneOf(["bottom", "top"]).isRequired
  }),
  /**
   * The content rendered within the badge.
   */
  badgeContent: l.node,
  /**
   * The badge will be added relative to this node.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: l.oneOfType([l.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Badge: l.elementType,
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    badge: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * If `true`, the badge is invisible.
   * @default false
   */
  invisible: l.bool,
  /**
   * Max count to show.
   * @default 99
   */
  max: l.number,
  /**
   * Wrapped shape the badge should overlap.
   * @default 'rectangular'
   */
  overlap: l.oneOf(["circular", "rectangular"]),
  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */
  showZero: l.bool,
  /**
   * The props used for each slot inside the Badge.
   * @default {}
   */
  slotProps: l.shape({
    badge: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside the Badge.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: l.shape({
    badge: l.elementType,
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: l.oneOfType([l.oneOf(["dot", "standard"]), l.string])
});
const nF = Re("MuiBox", ["root"]), oF = La(), J = ov({
  themeId: ma,
  defaultTheme: oF,
  defaultClassName: nF.root,
  generateClassName: f3.generate
});
process.env.NODE_ENV !== "production" && (J.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: l.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function rF(e) {
  return _e("MuiButton", e);
}
const a1 = Re("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]), z4 = /* @__PURE__ */ y.createContext({});
process.env.NODE_ENV !== "production" && (z4.displayName = "ButtonGroupContext");
const Z4 = /* @__PURE__ */ y.createContext(void 0);
process.env.NODE_ENV !== "production" && (Z4.displayName = "ButtonGroupButtonContext");
const iF = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"], sF = (e) => {
  const {
    color: t,
    disableElevation: n,
    fullWidth: o,
    size: r,
    variant: i,
    classes: s
  } = e, a = {
    root: ["root", i, `${i}${pe(t)}`, `size${pe(r)}`, `${i}Size${pe(r)}`, `color${pe(t)}`, n && "disableElevation", o && "fullWidth"],
    label: ["label"],
    startIcon: ["icon", "startIcon", `iconSize${pe(r)}`],
    endIcon: ["icon", "endIcon", `iconSize${pe(r)}`]
  }, c = Oe(a, rF, s);
  return T({}, s, c);
}, nw = (e) => T({}, e.size === "small" && {
  "& > *:nth-of-type(1)": {
    fontSize: 18
  }
}, e.size === "medium" && {
  "& > *:nth-of-type(1)": {
    fontSize: 20
  }
}, e.size === "large" && {
  "& > *:nth-of-type(1)": {
    fontSize: 22
  }
}), aF = B(wo, {
  shouldForwardProp: (e) => bo(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${pe(n.color)}`], t[`size${pe(n.size)}`], t[`${n.variant}Size${pe(n.size)}`], n.color === "inherit" && t.colorInherit, n.disableElevation && t.disableElevation, n.fullWidth && t.fullWidth];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n, o;
  const r = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], i = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return T({}, e.typography.button, {
    minWidth: 64,
    padding: "6px 16px",
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": T({
      textDecoration: "none",
      backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : gt(e.palette.text.primary, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "text" && t.color !== "inherit" && {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : gt(e.palette[t.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "outlined" && t.color !== "inherit" && {
      border: `1px solid ${(e.vars || e).palette[t.color].main}`,
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : gt(e.palette[t.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "contained" && {
      backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedHoverBg : i,
      boxShadow: (e.vars || e).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: (e.vars || e).shadows[2],
        backgroundColor: (e.vars || e).palette.grey[300]
      }
    }, t.variant === "contained" && t.color !== "inherit" && {
      backgroundColor: (e.vars || e).palette[t.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette[t.color].main
      }
    }),
    "&:active": T({}, t.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[8]
    }),
    [`&.${a1.focusVisible}`]: T({}, t.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[6]
    }),
    [`&.${a1.disabled}`]: T({
      color: (e.vars || e).palette.action.disabled
    }, t.variant === "outlined" && {
      border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
    }, t.variant === "contained" && {
      color: (e.vars || e).palette.action.disabled,
      boxShadow: (e.vars || e).shadows[0],
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    })
  }, t.variant === "text" && {
    padding: "6px 8px"
  }, t.variant === "text" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].main
  }, t.variant === "outlined" && {
    padding: "5px 15px",
    border: "1px solid currentColor"
  }, t.variant === "outlined" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].main,
    border: e.vars ? `1px solid rgba(${e.vars.palette[t.color].mainChannel} / 0.5)` : `1px solid ${gt(e.palette[t.color].main, 0.5)}`
  }, t.variant === "contained" && {
    color: e.vars ? (
      // this is safe because grey does not change between default light/dark mode
      e.vars.palette.text.primary
    ) : (n = (o = e.palette).getContrastText) == null ? void 0 : n.call(o, e.palette.grey[300]),
    backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedBg : r,
    boxShadow: (e.vars || e).shadows[2]
  }, t.variant === "contained" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].contrastText,
    backgroundColor: (e.vars || e).palette[t.color].main
  }, t.color === "inherit" && {
    color: "inherit",
    borderColor: "currentColor"
  }, t.size === "small" && t.variant === "text" && {
    padding: "4px 5px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "text" && {
    padding: "8px 11px",
    fontSize: e.typography.pxToRem(15)
  }, t.size === "small" && t.variant === "outlined" && {
    padding: "3px 9px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "outlined" && {
    padding: "7px 21px",
    fontSize: e.typography.pxToRem(15)
  }, t.size === "small" && t.variant === "contained" && {
    padding: "4px 10px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "contained" && {
    padding: "8px 22px",
    fontSize: e.typography.pxToRem(15)
  }, t.fullWidth && {
    width: "100%"
  });
}, ({
  ownerState: e
}) => e.disableElevation && {
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none"
  },
  [`&.${a1.focusVisible}`]: {
    boxShadow: "none"
  },
  "&:active": {
    boxShadow: "none"
  },
  [`&.${a1.disabled}`]: {
    boxShadow: "none"
  }
}), lF = B("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.startIcon, t[`iconSize${pe(n.size)}`]];
  }
})(({
  ownerState: e
}) => T({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4
}, e.size === "small" && {
  marginLeft: -2
}, nw(e))), cF = B("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.endIcon, t[`iconSize${pe(n.size)}`]];
  }
})(({
  ownerState: e
}) => T({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8
}, e.size === "small" && {
  marginRight: -2
}, nw(e))), at = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = y.useContext(z4), r = y.useContext(Z4), i = Ll(o, t), s = Xe({
    props: i,
    name: "MuiButton"
  }), {
    children: a,
    color: c = "primary",
    component: d = "button",
    className: u,
    disabled: p = !1,
    disableElevation: h = !1,
    disableFocusRipple: g = !1,
    endIcon: m,
    focusVisibleClassName: b,
    fullWidth: C = !1,
    size: x = "medium",
    startIcon: v,
    type: S,
    variant: M = "text"
  } = s, w = le(s, iF), k = T({}, s, {
    color: c,
    component: d,
    disabled: p,
    disableElevation: h,
    disableFocusRipple: g,
    fullWidth: C,
    size: x,
    type: S,
    variant: M
  }), E = sF(k), R = v && /* @__PURE__ */ f.jsx(lF, {
    className: E.startIcon,
    ownerState: k,
    children: v
  }), O = m && /* @__PURE__ */ f.jsx(cF, {
    className: E.endIcon,
    ownerState: k,
    children: m
  }), P = r || "";
  return /* @__PURE__ */ f.jsxs(aF, T({
    ownerState: k,
    className: xe(o.className, E.root, u, P),
    component: d,
    disabled: p,
    focusRipple: !g,
    focusVisibleClassName: xe(E.focusVisible, b),
    ref: n,
    type: S
  }, w, {
    classes: E,
    children: [R, a, O]
  }));
});
process.env.NODE_ENV !== "production" && (at.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: l.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * Element placed after the children.
   */
  endIcon: l.node,
  /**
   * @ignore
   */
  focusVisibleClassName: l.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: l.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["small", "medium", "large"]), l.string]),
  /**
   * Element placed before the children.
   */
  startIcon: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * @ignore
   */
  type: l.oneOfType([l.oneOf(["button", "reset", "submit"]), l.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: l.oneOfType([l.oneOf(["contained", "outlined", "text"]), l.string])
});
function dF(e) {
  return _e("MuiButtonGroup", e);
}
const Xn = Re("MuiButtonGroup", ["root", "contained", "outlined", "text", "disableElevation", "disabled", "firstButton", "fullWidth", "vertical", "grouped", "groupedHorizontal", "groupedVertical", "groupedText", "groupedTextHorizontal", "groupedTextVertical", "groupedTextPrimary", "groupedTextSecondary", "groupedOutlined", "groupedOutlinedHorizontal", "groupedOutlinedVertical", "groupedOutlinedPrimary", "groupedOutlinedSecondary", "groupedContained", "groupedContainedHorizontal", "groupedContainedVertical", "groupedContainedPrimary", "groupedContainedSecondary", "lastButton", "middleButton"]), uF = ["children", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "disableRipple", "fullWidth", "orientation", "size", "variant"], fF = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [{
    [`& .${Xn.grouped}`]: t.grouped
  }, {
    [`& .${Xn.grouped}`]: t[`grouped${pe(n.orientation)}`]
  }, {
    [`& .${Xn.grouped}`]: t[`grouped${pe(n.variant)}`]
  }, {
    [`& .${Xn.grouped}`]: t[`grouped${pe(n.variant)}${pe(n.orientation)}`]
  }, {
    [`& .${Xn.grouped}`]: t[`grouped${pe(n.variant)}${pe(n.color)}`]
  }, {
    [`& .${Xn.firstButton}`]: t.firstButton
  }, {
    [`& .${Xn.lastButton}`]: t.lastButton
  }, {
    [`& .${Xn.middleButton}`]: t.middleButton
  }, t.root, t[n.variant], n.disableElevation === !0 && t.disableElevation, n.fullWidth && t.fullWidth, n.orientation === "vertical" && t.vertical];
}, pF = (e) => {
  const {
    classes: t,
    color: n,
    disabled: o,
    disableElevation: r,
    fullWidth: i,
    orientation: s,
    variant: a
  } = e, c = {
    root: ["root", a, s === "vertical" && "vertical", i && "fullWidth", r && "disableElevation"],
    grouped: ["grouped", `grouped${pe(s)}`, `grouped${pe(a)}`, `grouped${pe(a)}${pe(s)}`, `grouped${pe(a)}${pe(n)}`, o && "disabled"],
    firstButton: ["firstButton"],
    lastButton: ["lastButton"],
    middleButton: ["middleButton"]
  };
  return Oe(c, dF, t);
}, hF = B("div", {
  name: "MuiButtonGroup",
  slot: "Root",
  overridesResolver: fF
})(({
  theme: e,
  ownerState: t
}) => T({
  display: "inline-flex",
  borderRadius: (e.vars || e).shape.borderRadius
}, t.variant === "contained" && {
  boxShadow: (e.vars || e).shadows[2]
}, t.disableElevation && {
  boxShadow: "none"
}, t.fullWidth && {
  width: "100%"
}, t.orientation === "vertical" && {
  flexDirection: "column"
}, {
  [`& .${Xn.grouped}`]: T({
    minWidth: 40,
    "&:hover": T({}, t.variant === "contained" && {
      boxShadow: "none"
    })
  }, t.variant === "contained" && {
    boxShadow: "none"
  }),
  [`& .${Xn.firstButton},& .${Xn.middleButton}`]: T({}, t.orientation === "horizontal" && {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  }, t.orientation === "vertical" && {
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0
  }, t.variant === "text" && t.orientation === "horizontal" && {
    borderRight: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
    [`&.${Xn.disabled}`]: {
      borderRight: `1px solid ${(e.vars || e).palette.action.disabled}`
    }
  }, t.variant === "text" && t.orientation === "vertical" && {
    borderBottom: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
    [`&.${Xn.disabled}`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.action.disabled}`
    }
  }, t.variant === "text" && t.color !== "inherit" && {
    borderColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.5)` : gt(e.palette[t.color].main, 0.5)
  }, t.variant === "outlined" && t.orientation === "horizontal" && {
    borderRightColor: "transparent"
  }, t.variant === "outlined" && t.orientation === "vertical" && {
    borderBottomColor: "transparent"
  }, t.variant === "contained" && t.orientation === "horizontal" && {
    borderRight: `1px solid ${(e.vars || e).palette.grey[400]}`,
    [`&.${Xn.disabled}`]: {
      borderRight: `1px solid ${(e.vars || e).palette.action.disabled}`
    }
  }, t.variant === "contained" && t.orientation === "vertical" && {
    borderBottom: `1px solid ${(e.vars || e).palette.grey[400]}`,
    [`&.${Xn.disabled}`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.action.disabled}`
    }
  }, t.variant === "contained" && t.color !== "inherit" && {
    borderColor: (e.vars || e).palette[t.color].dark
  }, {
    "&:hover": T({}, t.variant === "outlined" && t.orientation === "horizontal" && {
      borderRightColor: "currentColor"
    }, t.variant === "outlined" && t.orientation === "vertical" && {
      borderBottomColor: "currentColor"
    })
  }),
  [`& .${Xn.lastButton},& .${Xn.middleButton}`]: T({}, t.orientation === "horizontal" && {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  }, t.orientation === "vertical" && {
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0
  }, t.variant === "outlined" && t.orientation === "horizontal" && {
    marginLeft: -1
  }, t.variant === "outlined" && t.orientation === "vertical" && {
    marginTop: -1
  })
})), c2 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiButtonGroup"
  }), {
    children: r,
    className: i,
    color: s = "primary",
    component: a = "div",
    disabled: c = !1,
    disableElevation: d = !1,
    disableFocusRipple: u = !1,
    disableRipple: p = !1,
    fullWidth: h = !1,
    orientation: g = "horizontal",
    size: m = "medium",
    variant: b = "outlined"
  } = o, C = le(o, uF), x = T({}, o, {
    color: s,
    component: a,
    disabled: c,
    disableElevation: d,
    disableFocusRipple: u,
    disableRipple: p,
    fullWidth: h,
    orientation: g,
    size: m,
    variant: b
  }), v = pF(x), S = y.useMemo(() => ({
    className: v.grouped,
    color: s,
    disabled: c,
    disableElevation: d,
    disableFocusRipple: u,
    disableRipple: p,
    fullWidth: h,
    size: m,
    variant: b
  }), [s, c, d, u, p, h, m, b, v.grouped]), M = kI(r), w = M.length, k = (E) => {
    const R = E === 0, O = E === w - 1;
    return R && O ? "" : R ? v.firstButton : O ? v.lastButton : v.middleButton;
  };
  return /* @__PURE__ */ f.jsx(hF, T({
    as: a,
    role: "group",
    className: xe(v.root, i),
    ref: n,
    ownerState: x
  }, C, {
    children: /* @__PURE__ */ f.jsx(z4.Provider, {
      value: S,
      children: M.map((E, R) => /* @__PURE__ */ f.jsx(Z4.Provider, {
        value: k(R),
        children: E
      }, R))
    })
  }));
});
process.env.NODE_ENV !== "production" && (c2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: l.bool,
  /**
   * If `true`, the button keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: l.bool,
  /**
   * If `true`, the button ripple effect is disabled.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * If `true`, the buttons will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: l.oneOf(["horizontal", "vertical"]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["small", "medium", "large"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: l.oneOfType([l.oneOf(["contained", "outlined", "text"]), l.string])
});
function gF(e) {
  return _e("MuiCard", e);
}
Re("MuiCard", ["root"]);
const mF = ["className", "raised"], bF = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"]
  }, gF, t);
}, CF = B(Tr, {
  name: "MuiCard",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(() => ({
  overflow: "hidden"
})), W4 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiCard"
  }), {
    className: r,
    raised: i = !1
  } = o, s = le(o, mF), a = T({}, o, {
    raised: i
  }), c = bF(a);
  return /* @__PURE__ */ f.jsx(CF, T({
    className: xe(c.root, r),
    elevation: i ? 8 : void 0,
    ref: n,
    ownerState: a
  }, s));
});
process.env.NODE_ENV !== "production" && (W4.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, the card will use raised styling.
   * @default false
   */
  raised: vo(l.bool, (e) => e.raised && e.variant === "outlined" ? new Error('MUI: Combining `raised={true}` with `variant="outlined"` has no effect.') : null),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function xF(e) {
  return _e("MuiCardActions", e);
}
Re("MuiCardActions", ["root", "spacing"]);
const yF = ["disableSpacing", "className"], vF = (e) => {
  const {
    classes: t,
    disableSpacing: n
  } = e;
  return Oe({
    root: ["root", !n && "spacing"]
  }, xF, t);
}, wF = B("div", {
  name: "MuiCardActions",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disableSpacing && t.spacing];
  }
})(({
  ownerState: e
}) => T({
  display: "flex",
  alignItems: "center",
  padding: 8
}, !e.disableSpacing && {
  "& > :not(style) ~ :not(style)": {
    marginLeft: 8
  }
})), ow = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiCardActions"
  }), {
    disableSpacing: r = !1,
    className: i
  } = o, s = le(o, yF), a = T({}, o, {
    disableSpacing: r
  }), c = vF(a);
  return /* @__PURE__ */ f.jsx(wF, T({
    className: xe(c.root, i),
    ownerState: a,
    ref: n
  }, s));
});
process.env.NODE_ENV !== "production" && (ow.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function SF(e) {
  return _e("MuiCardContent", e);
}
Re("MuiCardContent", ["root"]);
const MF = ["className", "component"], TF = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"]
  }, SF, t);
}, kF = B("div", {
  name: "MuiCardContent",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(() => ({
  padding: 16,
  "&:last-child": {
    paddingBottom: 24
  }
})), U4 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiCardContent"
  }), {
    className: r,
    component: i = "div"
  } = o, s = le(o, MF), a = T({}, o, {
    component: i
  }), c = TF(a);
  return /* @__PURE__ */ f.jsx(kF, T({
    as: i,
    className: xe(c.root, r),
    ownerState: a,
    ref: n
  }, s));
});
process.env.NODE_ENV !== "production" && (U4.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function EF(e) {
  return _e("PrivateSwitchBase", e);
}
Re("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const RF = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"], OF = (e) => {
  const {
    classes: t,
    checked: n,
    disabled: o,
    edge: r
  } = e, i = {
    root: ["root", n && "checked", o && "disabled", r && `edge${pe(r)}`],
    input: ["input"]
  };
  return Oe(i, EF, t);
}, _F = B(wo)(({
  ownerState: e
}) => T({
  padding: 9,
  borderRadius: "50%"
}, e.edge === "start" && {
  marginLeft: e.size === "small" ? -3 : -12
}, e.edge === "end" && {
  marginRight: e.size === "small" ? -3 : -12
})), PF = B("input", {
  shouldForwardProp: bo
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), G4 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const {
    autoFocus: o,
    checked: r,
    checkedIcon: i,
    className: s,
    defaultChecked: a,
    disabled: c,
    disableFocusRipple: d = !1,
    edge: u = !1,
    icon: p,
    id: h,
    inputProps: g,
    inputRef: m,
    name: b,
    onBlur: C,
    onChange: x,
    onFocus: v,
    readOnly: S,
    required: M = !1,
    tabIndex: w,
    type: k,
    value: E
  } = t, R = le(t, RF), [O, P] = Fn({
    controlled: r,
    default: !!a,
    name: "SwitchBase",
    state: "checked"
  }), _ = ui(), L = (H) => {
    v && v(H), _ && _.onFocus && _.onFocus(H);
  }, V = (H) => {
    C && C(H), _ && _.onBlur && _.onBlur(H);
  }, j = (H) => {
    if (H.nativeEvent.defaultPrevented)
      return;
    const N = H.target.checked;
    P(N), x && x(H, N);
  };
  let I = c;
  _ && typeof I > "u" && (I = _.disabled);
  const F = k === "checkbox" || k === "radio", $ = T({}, t, {
    checked: O,
    disabled: I,
    disableFocusRipple: d,
    edge: u
  }), A = OF($);
  return /* @__PURE__ */ f.jsxs(_F, T({
    component: "span",
    className: xe(A.root, s),
    centerRipple: !0,
    focusRipple: !d,
    disabled: I,
    tabIndex: null,
    role: void 0,
    onFocus: L,
    onBlur: V,
    ownerState: $,
    ref: n
  }, R, {
    children: [/* @__PURE__ */ f.jsx(PF, T({
      autoFocus: o,
      checked: r,
      defaultChecked: a,
      className: A.input,
      disabled: I,
      id: F ? h : void 0,
      name: b,
      onChange: j,
      readOnly: S,
      ref: m,
      required: M,
      ownerState: $,
      tabIndex: w,
      type: k
    }, k === "checkbox" && E === void 0 ? {} : {
      value: E
    }, g)), O ? i : p]
  }));
});
process.env.NODE_ENV !== "production" && (G4.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: l.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: l.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: l.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * @ignore
   */
  defaultChecked: l.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: l.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: l.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: l.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: l.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /*
   * @ignore
   */
  name: l.string,
  /**
   * @ignore
   */
  onBlur: l.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: l.func,
  /**
   * @ignore
   */
  onFocus: l.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: l.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.object,
  /**
   * @ignore
   */
  tabIndex: l.oneOfType([l.number, l.string]),
  /**
   * The input component prop `type`.
   */
  type: l.string.isRequired,
  /**
   * The value of the component.
   */
  value: l.any
});
const LF = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), IF = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), jF = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function VF(e) {
  return _e("MuiCheckbox", e);
}
const Bf = Re("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), DF = ["checkedIcon", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size", "className"], AF = (e) => {
  const {
    classes: t,
    indeterminate: n,
    color: o,
    size: r
  } = e, i = {
    root: ["root", n && "indeterminate", `color${pe(o)}`, `size${pe(r)}`]
  }, s = Oe(i, VF, t);
  return T({}, t, s);
}, HF = B(G4, {
  shouldForwardProp: (e) => bo(e) || e === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.indeterminate && t.indeterminate, t[`size${pe(n.size)}`], n.color !== "default" && t[`color${pe(n.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => T({
  color: (e.vars || e).palette.text.secondary
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${t.color === "default" ? e.vars.palette.action.activeChannel : e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : gt(t.color === "default" ? e.palette.action.active : e.palette[t.color].main, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.color !== "default" && {
  [`&.${Bf.checked}, &.${Bf.indeterminate}`]: {
    color: (e.vars || e).palette[t.color].main
  },
  [`&.${Bf.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  }
})), FF = /* @__PURE__ */ f.jsx(IF, {}), NF = /* @__PURE__ */ f.jsx(LF, {}), $F = /* @__PURE__ */ f.jsx(jF, {}), si = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r;
  const i = Xe({
    props: t,
    name: "MuiCheckbox"
  }), {
    checkedIcon: s = FF,
    color: a = "primary",
    icon: c = NF,
    indeterminate: d = !1,
    indeterminateIcon: u = $F,
    inputProps: p,
    size: h = "medium",
    className: g
  } = i, m = le(i, DF), b = d ? u : c, C = d ? u : s, x = T({}, i, {
    color: a,
    indeterminate: d,
    size: h
  }), v = AF(x);
  return /* @__PURE__ */ f.jsx(HF, T({
    type: "checkbox",
    inputProps: T({
      "data-indeterminate": d
    }, p),
    icon: /* @__PURE__ */ y.cloneElement(b, {
      fontSize: (o = b.props.fontSize) != null ? o : h
    }),
    checkedIcon: /* @__PURE__ */ y.cloneElement(C, {
      fontSize: (r = C.props.fontSize) != null ? r : h
    }),
    ownerState: x,
    ref: n,
    className: xe(v.root, g)
  }, m, {
    classes: v
  }));
});
process.env.NODE_ENV !== "production" && (si.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: l.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: l.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: l.node,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: l.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: l.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: l.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: l.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: l.any
});
function BF(e) {
  return _e("MuiCircularProgress", e);
}
Re("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const zF = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];
let T3 = (e) => e, mg, bg, Cg, xg;
const Hi = 44, ZF = Dr(mg || (mg = T3`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`)), WF = Dr(bg || (bg = T3`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`)), UF = (e) => {
  const {
    classes: t,
    variant: n,
    color: o,
    disableShrink: r
  } = e, i = {
    root: ["root", n, `color${pe(o)}`],
    svg: ["svg"],
    circle: ["circle", `circle${pe(n)}`, r && "circleDisableShrink"]
  };
  return Oe(i, BF, t);
}, GF = B("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`color${pe(n.color)}`]];
  }
})(({
  ownerState: e,
  theme: t
}) => T({
  display: "inline-block"
}, e.variant === "determinate" && {
  transition: t.transitions.create("transform")
}, e.color !== "inherit" && {
  color: (t.vars || t).palette[e.color].main
}), ({
  ownerState: e
}) => e.variant === "indeterminate" && Li(Cg || (Cg = T3`
      animation: ${0} 1.4s linear infinite;
    `), ZF)), qF = B("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (e, t) => t.svg
})({
  display: "block"
  // Keeps the progress centered
}), KF = B("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.circle, t[`circle${pe(n.variant)}`], n.disableShrink && t.circleDisableShrink];
  }
})(({
  ownerState: e,
  theme: t
}) => T({
  stroke: "currentColor"
}, e.variant === "determinate" && {
  transition: t.transitions.create("stroke-dashoffset")
}, e.variant === "indeterminate" && {
  // Some default value that looks fine waiting for the animation to kicks in.
  strokeDasharray: "80px, 200px",
  strokeDashoffset: 0
  // Add the unit to fix a Edge 16 and below bug.
}), ({
  ownerState: e
}) => e.variant === "indeterminate" && !e.disableShrink && Li(xg || (xg = T3`
      animation: ${0} 1.4s ease-in-out infinite;
    `), WF)), Sa = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: r,
    color: i = "primary",
    disableShrink: s = !1,
    size: a = 40,
    style: c,
    thickness: d = 3.6,
    value: u = 0,
    variant: p = "indeterminate"
  } = o, h = le(o, zF), g = T({}, o, {
    color: i,
    disableShrink: s,
    size: a,
    thickness: d,
    value: u,
    variant: p
  }), m = UF(g), b = {}, C = {}, x = {};
  if (p === "determinate") {
    const v = 2 * Math.PI * ((Hi - d) / 2);
    b.strokeDasharray = v.toFixed(3), x["aria-valuenow"] = Math.round(u), b.strokeDashoffset = `${((100 - u) / 100 * v).toFixed(3)}px`, C.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ f.jsx(GF, T({
    className: xe(m.root, r),
    style: T({
      width: a,
      height: a
    }, C, c),
    ownerState: g,
    ref: n,
    role: "progressbar"
  }, x, h, {
    children: /* @__PURE__ */ f.jsx(qF, {
      className: m.svg,
      ownerState: g,
      viewBox: `${Hi / 2} ${Hi / 2} ${Hi} ${Hi}`,
      children: /* @__PURE__ */ f.jsx(KF, {
        className: m.circle,
        style: b,
        ownerState: g,
        cx: Hi,
        cy: Hi,
        r: (Hi - d) / 2,
        fill: "none",
        strokeWidth: d
      })
    })
  }));
});
process.env.NODE_ENV !== "production" && (Sa.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: vo(l.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: l.oneOfType([l.number, l.string]),
  /**
   * @ignore
   */
  style: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: l.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: l.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: l.oneOf(["determinate", "indeterminate"])
});
function YF(e) {
  const t = gn(e);
  return t.body === e ? ri(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function oc(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function yg(e) {
  return parseInt(ri(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function XF(e) {
  const n = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].indexOf(e.tagName) !== -1, o = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return n || o;
}
function vg(e, t, n, o, r) {
  const i = [t, n, ...o];
  [].forEach.call(e.children, (s) => {
    const a = i.indexOf(s) === -1, c = !XF(s);
    a && c && oc(s, r);
  });
}
function zf(e, t) {
  let n = -1;
  return e.some((o, r) => t(o) ? (n = r, !0) : !1), n;
}
function JF(e, t) {
  const n = [], o = e.container;
  if (!t.disableScrollLock) {
    if (YF(o)) {
      const s = fv(gn(o));
      n.push({
        value: o.style.paddingRight,
        property: "padding-right",
        el: o
      }), o.style.paddingRight = `${yg(o) + s}px`;
      const a = gn(o).querySelectorAll(".mui-fixed");
      [].forEach.call(a, (c) => {
        n.push({
          value: c.style.paddingRight,
          property: "padding-right",
          el: c
        }), c.style.paddingRight = `${yg(c) + s}px`;
      });
    }
    let i;
    if (o.parentNode instanceof DocumentFragment)
      i = gn(o).body;
    else {
      const s = o.parentElement, a = ri(o);
      i = (s == null ? void 0 : s.nodeName) === "HTML" && a.getComputedStyle(s).overflowY === "scroll" ? s : o;
    }
    n.push({
      value: i.style.overflow,
      property: "overflow",
      el: i
    }, {
      value: i.style.overflowX,
      property: "overflow-x",
      el: i
    }, {
      value: i.style.overflowY,
      property: "overflow-y",
      el: i
    }), i.style.overflow = "hidden";
  }
  return () => {
    n.forEach(({
      value: i,
      el: s,
      property: a
    }) => {
      i ? s.style.setProperty(a, i) : s.style.removeProperty(a);
    });
  };
}
function QF(e) {
  const t = [];
  return [].forEach.call(e.children, (n) => {
    n.getAttribute("aria-hidden") === "true" && t.push(n);
  }), t;
}
class eN {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(t, n) {
    let o = this.modals.indexOf(t);
    if (o !== -1)
      return o;
    o = this.modals.length, this.modals.push(t), t.modalRef && oc(t.modalRef, !1);
    const r = QF(n);
    vg(n, t.mount, t.modalRef, r, !0);
    const i = zf(this.containers, (s) => s.container === n);
    return i !== -1 ? (this.containers[i].modals.push(t), o) : (this.containers.push({
      modals: [t],
      container: n,
      restore: null,
      hiddenSiblings: r
    }), o);
  }
  mount(t, n) {
    const o = zf(this.containers, (i) => i.modals.indexOf(t) !== -1), r = this.containers[o];
    r.restore || (r.restore = JF(r, n));
  }
  remove(t, n = !0) {
    const o = this.modals.indexOf(t);
    if (o === -1)
      return o;
    const r = zf(this.containers, (s) => s.modals.indexOf(t) !== -1), i = this.containers[r];
    if (i.modals.splice(i.modals.indexOf(t), 1), this.modals.splice(o, 1), i.modals.length === 0)
      i.restore && i.restore(), t.modalRef && oc(t.modalRef, n), vg(i.container, t.mount, t.modalRef, i.hiddenSiblings, !1), this.containers.splice(r, 1);
    else {
      const s = i.modals[i.modals.length - 1];
      s.modalRef && oc(s.modalRef, !1);
    }
    return o;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
const tN = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function nN(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function oN(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (o) => e.ownerDocument.querySelector(`input[type="radio"]${o}`);
  let n = t(`[name="${e.name}"]:checked`);
  return n || (n = t(`[name="${e.name}"]`)), n !== e;
}
function rN(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || oN(e));
}
function iN(e) {
  const t = [], n = [];
  return Array.from(e.querySelectorAll(tN)).forEach((o, r) => {
    const i = nN(o);
    i === -1 || !rN(o) || (i === 0 ? t.push(o) : n.push({
      documentOrder: r,
      tabIndex: i,
      node: o
    }));
  }), n.sort((o, r) => o.tabIndex === r.tabIndex ? o.documentOrder - r.documentOrder : o.tabIndex - r.tabIndex).map((o) => o.node).concat(t);
}
function sN() {
  return !0;
}
function Ac(e) {
  const {
    children: t,
    disableAutoFocus: n = !1,
    disableEnforceFocus: o = !1,
    disableRestoreFocus: r = !1,
    getTabbable: i = iN,
    isEnabled: s = sN,
    open: a
  } = e, c = y.useRef(!1), d = y.useRef(null), u = y.useRef(null), p = y.useRef(null), h = y.useRef(null), g = y.useRef(!1), m = y.useRef(null), b = Tt(o2(t), m), C = y.useRef(null);
  y.useEffect(() => {
    !a || !m.current || (g.current = !n);
  }, [n, a]), y.useEffect(() => {
    if (!a || !m.current)
      return;
    const S = gn(m.current);
    return m.current.contains(S.activeElement) || (m.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), m.current.setAttribute("tabIndex", "-1")), g.current && m.current.focus()), () => {
      r || (p.current && p.current.focus && (c.current = !0, p.current.focus()), p.current = null);
    };
  }, [a]), y.useEffect(() => {
    if (!a || !m.current)
      return;
    const S = gn(m.current), M = (E) => {
      C.current = E, !(o || !s() || E.key !== "Tab") && S.activeElement === m.current && E.shiftKey && (c.current = !0, u.current && u.current.focus());
    }, w = () => {
      const E = m.current;
      if (E === null)
        return;
      if (!S.hasFocus() || !s() || c.current) {
        c.current = !1;
        return;
      }
      if (E.contains(S.activeElement) || o && S.activeElement !== d.current && S.activeElement !== u.current)
        return;
      if (S.activeElement !== h.current)
        h.current = null;
      else if (h.current !== null)
        return;
      if (!g.current)
        return;
      let R = [];
      if ((S.activeElement === d.current || S.activeElement === u.current) && (R = i(m.current)), R.length > 0) {
        var O, P;
        const _ = !!((O = C.current) != null && O.shiftKey && ((P = C.current) == null ? void 0 : P.key) === "Tab"), L = R[0], V = R[R.length - 1];
        typeof L != "string" && typeof V != "string" && (_ ? V.focus() : L.focus());
      } else
        E.focus();
    };
    S.addEventListener("focusin", w), S.addEventListener("keydown", M, !0);
    const k = setInterval(() => {
      S.activeElement && S.activeElement.tagName === "BODY" && w();
    }, 50);
    return () => {
      clearInterval(k), S.removeEventListener("focusin", w), S.removeEventListener("keydown", M, !0);
    };
  }, [n, o, r, s, a, i]);
  const x = (S) => {
    p.current === null && (p.current = S.relatedTarget), g.current = !0, h.current = S.target;
    const M = t.props.onFocus;
    M && M(S);
  }, v = (S) => {
    p.current === null && (p.current = S.relatedTarget), g.current = !0;
  };
  return /* @__PURE__ */ f.jsxs(y.Fragment, {
    children: [/* @__PURE__ */ f.jsx("div", {
      tabIndex: a ? 0 : -1,
      onFocus: v,
      ref: d,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ y.cloneElement(t, {
      ref: b,
      onFocus: x
    }), /* @__PURE__ */ f.jsx("div", {
      tabIndex: a ? 0 : -1,
      onFocus: v,
      ref: u,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (Ac.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: t2,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: l.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: l.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: l.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: l.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: l.func,
  /**
   * If `true`, focus is locked.
   */
  open: l.bool.isRequired
});
process.env.NODE_ENV !== "production" && (Ac.propTypes = h3(Ac.propTypes));
function aN(e) {
  return typeof e == "function" ? e() : e;
}
function lN(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const cN = new eN();
function dN(e) {
  const {
    container: t,
    disableEscapeKeyDown: n = !1,
    disableScrollLock: o = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: r = cN,
    closeAfterTransition: i = !1,
    onTransitionEnter: s,
    onTransitionExited: a,
    children: c,
    onClose: d,
    open: u,
    rootRef: p
  } = e, h = y.useRef({}), g = y.useRef(null), m = y.useRef(null), b = Tt(m, p), [C, x] = y.useState(!u), v = lN(c);
  let S = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (S = !1);
  const M = () => gn(g.current), w = () => (h.current.modalRef = m.current, h.current.mount = g.current, h.current), k = () => {
    r.mount(w(), {
      disableScrollLock: o
    }), m.current && (m.current.scrollTop = 0);
  }, E = Ke(() => {
    const F = aN(t) || M().body;
    r.add(w(), F), m.current && k();
  }), R = y.useCallback(() => r.isTopModal(w()), [r]), O = Ke((F) => {
    g.current = F, F && (u && R() ? k() : m.current && oc(m.current, S));
  }), P = y.useCallback(() => {
    r.remove(w(), S);
  }, [S, r]);
  y.useEffect(() => () => {
    P();
  }, [P]), y.useEffect(() => {
    u ? E() : (!v || !i) && P();
  }, [u, P, v, i, E]);
  const _ = (F) => ($) => {
    var A;
    (A = F.onKeyDown) == null || A.call(F, $), !($.key !== "Escape" || $.which === 229 || // Wait until IME is settled.
    !R()) && (n || ($.stopPropagation(), d && d($, "escapeKeyDown")));
  }, L = (F) => ($) => {
    var A;
    (A = F.onClick) == null || A.call(F, $), $.target === $.currentTarget && d && d($, "backdropClick");
  };
  return {
    getRootProps: (F = {}) => {
      const $ = lo(e);
      delete $.onTransitionEnter, delete $.onTransitionExited;
      const A = T({}, $, F);
      return T({
        role: "presentation"
      }, A, {
        onKeyDown: _(A),
        ref: b
      });
    },
    getBackdropProps: (F = {}) => {
      const $ = F;
      return T({
        "aria-hidden": !0
      }, $, {
        onClick: L($),
        open: u
      });
    },
    getTransitionProps: () => {
      const F = () => {
        x(!1), s && s();
      }, $ = () => {
        x(!0), a && a(), i && P();
      };
      return {
        onEnter: Nd(F, c == null ? void 0 : c.props.onEnter),
        onExited: Nd($, c == null ? void 0 : c.props.onExited)
      };
    },
    rootRef: b,
    portalRef: O,
    isTopModal: R,
    exited: C,
    hasTransition: v
  };
}
function uN(e) {
  return _e("MuiModal", e);
}
Re("MuiModal", ["root", "hidden", "backdrop"]);
const fN = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"], pN = (e) => {
  const {
    open: t,
    exited: n,
    classes: o
  } = e;
  return Oe({
    root: ["root", !t && n && "hidden"],
    backdrop: ["backdrop"]
  }, uN, o);
}, hN = B("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.open && n.exited && t.hidden];
  }
})(({
  theme: e,
  ownerState: t
}) => T({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !t.open && t.exited && {
  visibility: "hidden"
})), gN = B(B4, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), q4 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i, s, a, c;
  const d = Xe({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: u = gN,
    BackdropProps: p,
    className: h,
    closeAfterTransition: g = !1,
    children: m,
    container: b,
    component: C,
    components: x = {},
    componentsProps: v = {},
    disableAutoFocus: S = !1,
    disableEnforceFocus: M = !1,
    disableEscapeKeyDown: w = !1,
    disablePortal: k = !1,
    disableRestoreFocus: E = !1,
    disableScrollLock: R = !1,
    hideBackdrop: O = !1,
    keepMounted: P = !1,
    onBackdropClick: _,
    open: L,
    slotProps: V,
    slots: j
    // eslint-disable-next-line react/prop-types
  } = d, I = le(d, fN), F = T({}, d, {
    closeAfterTransition: g,
    disableAutoFocus: S,
    disableEnforceFocus: M,
    disableEscapeKeyDown: w,
    disablePortal: k,
    disableRestoreFocus: E,
    disableScrollLock: R,
    hideBackdrop: O,
    keepMounted: P
  }), {
    getRootProps: $,
    getBackdropProps: A,
    getTransitionProps: H,
    portalRef: N,
    isTopModal: z,
    exited: se,
    hasTransition: ne
  } = dN(T({}, F, {
    rootRef: n
  })), Z = T({}, F, {
    exited: se
  }), q = pN(Z), G = {};
  if (m.props.tabIndex === void 0 && (G.tabIndex = "-1"), ne) {
    const {
      onEnter: X,
      onExited: de
    } = H();
    G.onEnter = X, G.onExited = de;
  }
  const K = (o = (r = j == null ? void 0 : j.root) != null ? r : x.Root) != null ? o : hN, Q = (i = (s = j == null ? void 0 : j.backdrop) != null ? s : x.Backdrop) != null ? i : u, re = (a = V == null ? void 0 : V.root) != null ? a : v.root, U = (c = V == null ? void 0 : V.backdrop) != null ? c : v.backdrop, W = Ft({
    elementType: K,
    externalSlotProps: re,
    externalForwardedProps: I,
    getSlotProps: $,
    additionalProps: {
      ref: n,
      as: C
    },
    ownerState: Z,
    className: xe(h, re == null ? void 0 : re.className, q == null ? void 0 : q.root, !Z.open && Z.exited && (q == null ? void 0 : q.hidden))
  }), D = Ft({
    elementType: Q,
    externalSlotProps: U,
    additionalProps: p,
    getSlotProps: (X) => A(T({}, X, {
      onClick: (de) => {
        _ && _(de), X != null && X.onClick && X.onClick(de);
      }
    })),
    className: xe(U == null ? void 0 : U.className, p == null ? void 0 : p.className, q == null ? void 0 : q.backdrop),
    ownerState: Z
  });
  return !P && !L && (!ne || se) ? null : /* @__PURE__ */ f.jsx(Dc, {
    ref: N,
    container: b,
    disablePortal: k,
    children: /* @__PURE__ */ f.jsxs(K, T({}, W, {
      children: [!O && u ? /* @__PURE__ */ f.jsx(Q, T({}, D)) : null, /* @__PURE__ */ f.jsx(Ac, {
        disableEnforceFocus: M,
        disableAutoFocus: S,
        disableRestoreFocus: E,
        isEnabled: z,
        open: L,
        children: /* @__PURE__ */ y.cloneElement(m, G)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (q4.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: l.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: l.object,
  /**
   * A single child content element.
   */
  children: t2.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: l.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Backdrop: l.elementType,
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    backdrop: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: l.oneOfType([Ii, l.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: l.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: l.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: l.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: l.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: l.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: l.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: l.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: l.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: l.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: l.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: l.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: l.shape({
    backdrop: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: l.shape({
    backdrop: l.elementType,
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function mN(e) {
  return _e("MuiDialog", e);
}
const rc = Re("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]), K4 = /* @__PURE__ */ y.createContext({});
process.env.NODE_ENV !== "production" && (K4.displayName = "DialogContext");
const bN = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"], CN = B(B4, {
  name: "MuiDialog",
  slot: "Backdrop",
  overrides: (e, t) => t.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
}), xN = (e) => {
  const {
    classes: t,
    scroll: n,
    maxWidth: o,
    fullWidth: r,
    fullScreen: i
  } = e, s = {
    root: ["root"],
    container: ["container", `scroll${pe(n)}`],
    paper: ["paper", `paperScroll${pe(n)}`, `paperWidth${pe(String(o))}`, r && "paperFullWidth", i && "paperFullScreen"]
  };
  return Oe(s, mN, t);
}, yN = B(q4, {
  name: "MuiDialog",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  "@media print": {
    // Use !important to override the Modal inline-style.
    position: "absolute !important"
  }
}), vN = B("div", {
  name: "MuiDialog",
  slot: "Container",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.container, t[`scroll${pe(n.scroll)}`]];
  }
})(({
  ownerState: e
}) => T({
  height: "100%",
  "@media print": {
    height: "auto"
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, e.scroll === "paper" && {
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}, e.scroll === "body" && {
  overflowY: "auto",
  overflowX: "hidden",
  textAlign: "center",
  "&::after": {
    content: '""',
    display: "inline-block",
    verticalAlign: "middle",
    height: "100%",
    width: "0"
  }
})), wN = B(Tr, {
  name: "MuiDialog",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.paper, t[`scrollPaper${pe(n.scroll)}`], t[`paperWidth${pe(String(n.maxWidth))}`], n.fullWidth && t.paperFullWidth, n.fullScreen && t.paperFullScreen];
  }
})(({
  theme: e,
  ownerState: t
}) => T({
  margin: 32,
  position: "relative",
  overflowY: "auto",
  // Fix IE11 issue, to remove at some point.
  "@media print": {
    overflowY: "visible",
    boxShadow: "none"
  }
}, t.scroll === "paper" && {
  display: "flex",
  flexDirection: "column",
  maxHeight: "calc(100% - 64px)"
}, t.scroll === "body" && {
  display: "inline-block",
  verticalAlign: "middle",
  textAlign: "left"
  // 'initial' doesn't work on IE11
}, !t.maxWidth && {
  maxWidth: "calc(100% - 64px)"
}, t.maxWidth === "xs" && {
  maxWidth: e.breakpoints.unit === "px" ? Math.max(e.breakpoints.values.xs, 444) : `max(${e.breakpoints.values.xs}${e.breakpoints.unit}, 444px)`,
  [`&.${rc.paperScrollBody}`]: {
    [e.breakpoints.down(Math.max(e.breakpoints.values.xs, 444) + 32 * 2)]: {
      maxWidth: "calc(100% - 64px)"
    }
  }
}, t.maxWidth && t.maxWidth !== "xs" && {
  maxWidth: `${e.breakpoints.values[t.maxWidth]}${e.breakpoints.unit}`,
  [`&.${rc.paperScrollBody}`]: {
    [e.breakpoints.down(e.breakpoints.values[t.maxWidth] + 32 * 2)]: {
      maxWidth: "calc(100% - 64px)"
    }
  }
}, t.fullWidth && {
  width: "calc(100% - 64px)"
}, t.fullScreen && {
  margin: 0,
  width: "100%",
  maxWidth: "100%",
  height: "100%",
  maxHeight: "none",
  borderRadius: 0,
  [`&.${rc.paperScrollBody}`]: {
    margin: 0,
    maxWidth: "100%"
  }
})), d2 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiDialog"
  }), r = ge(), i = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  }, {
    "aria-describedby": s,
    "aria-labelledby": a,
    BackdropComponent: c,
    BackdropProps: d,
    children: u,
    className: p,
    disableEscapeKeyDown: h = !1,
    fullScreen: g = !1,
    fullWidth: m = !1,
    maxWidth: b = "sm",
    onBackdropClick: C,
    onClick: x,
    onClose: v,
    open: S,
    PaperComponent: M = Tr,
    PaperProps: w = {},
    scroll: k = "paper",
    TransitionComponent: E = Ia,
    transitionDuration: R = i,
    TransitionProps: O
  } = o, P = le(o, bN), _ = T({}, o, {
    disableEscapeKeyDown: h,
    fullScreen: g,
    fullWidth: m,
    maxWidth: b,
    scroll: k
  }), L = xN(_), V = y.useRef(), j = (A) => {
    V.current = A.target === A.currentTarget;
  }, I = (A) => {
    x && x(A), V.current && (V.current = null, C && C(A), v && v(A, "backdropClick"));
  }, F = di(a), $ = y.useMemo(() => ({
    titleId: F
  }), [F]);
  return /* @__PURE__ */ f.jsx(yN, T({
    className: xe(L.root, p),
    closeAfterTransition: !0,
    components: {
      Backdrop: CN
    },
    componentsProps: {
      backdrop: T({
        transitionDuration: R,
        as: c
      }, d)
    },
    disableEscapeKeyDown: h,
    onClose: v,
    open: S,
    ref: n,
    onClick: I,
    ownerState: _
  }, P, {
    children: /* @__PURE__ */ f.jsx(E, T({
      appear: !0,
      in: S,
      timeout: R,
      role: "presentation"
    }, O, {
      children: /* @__PURE__ */ f.jsx(vN, {
        className: xe(L.container),
        onMouseDown: j,
        ownerState: _,
        children: /* @__PURE__ */ f.jsx(wN, T({
          as: M,
          elevation: 24,
          role: "dialog",
          "aria-describedby": s,
          "aria-labelledby": F
        }, w, {
          className: xe(L.paper, w.className),
          ownerState: _,
          children: /* @__PURE__ */ f.jsx(K4.Provider, {
            value: $,
            children: u
          })
        }))
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" && (d2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  "aria-describedby": l.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  "aria-labelledby": l.string,
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: l.elementType,
  /**
   * @ignore
   */
  BackdropProps: l.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: l.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: l.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: l.oneOfType([l.oneOf(["xs", "sm", "md", "lg", "xl", !1]), l.string]),
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: l.func,
  /**
   * @ignore
   */
  onClick: l.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: l.elementType,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: l.object,
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: l.oneOf(["body", "paper"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: l.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: l.oneOfType([l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: l.object
});
function SN(e) {
  return _e("MuiDialogActions", e);
}
Re("MuiDialogActions", ["root", "spacing"]);
const MN = ["className", "disableSpacing"], TN = (e) => {
  const {
    classes: t,
    disableSpacing: n
  } = e;
  return Oe({
    root: ["root", !n && "spacing"]
  }, SN, t);
}, kN = B("div", {
  name: "MuiDialogActions",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disableSpacing && t.spacing];
  }
})(({
  ownerState: e
}) => T({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end",
  flex: "0 0 auto"
}, !e.disableSpacing && {
  "& > :not(style) ~ :not(style)": {
    marginLeft: 8
  }
})), k3 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiDialogActions"
  }), {
    className: r,
    disableSpacing: i = !1
  } = o, s = le(o, MN), a = T({}, o, {
    disableSpacing: i
  }), c = TN(a);
  return /* @__PURE__ */ f.jsx(kN, T({
    className: xe(c.root, r),
    ownerState: a,
    ref: n
  }, s));
});
process.env.NODE_ENV !== "production" && (k3.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function EN(e) {
  return _e("MuiDialogContent", e);
}
Re("MuiDialogContent", ["root", "dividers"]);
function RN(e) {
  return _e("MuiDialogTitle", e);
}
const ON = Re("MuiDialogTitle", ["root"]), _N = ["className", "dividers"], PN = (e) => {
  const {
    classes: t,
    dividers: n
  } = e;
  return Oe({
    root: ["root", n && "dividers"]
  }, EN, t);
}, LN = B("div", {
  name: "MuiDialogContent",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.dividers && t.dividers];
  }
})(({
  theme: e,
  ownerState: t
}) => T({
  flex: "1 1 auto",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  overflowY: "auto",
  padding: "20px 24px"
}, t.dividers ? {
  padding: "16px 24px",
  borderTop: `1px solid ${(e.vars || e).palette.divider}`,
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`
} : {
  [`.${ON.root} + &`]: {
    paddingTop: 0
  }
})), Y4 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiDialogContent"
  }), {
    className: r,
    dividers: i = !1
  } = o, s = le(o, _N), a = T({}, o, {
    dividers: i
  }), c = PN(a);
  return /* @__PURE__ */ f.jsx(LN, T({
    className: xe(c.root, r),
    ownerState: a,
    ref: n
  }, s));
});
process.env.NODE_ENV !== "production" && (Y4.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * Display the top and bottom dividers.
   * @default false
   */
  dividers: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const IN = ["className", "id"], jN = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"]
  }, RN, t);
}, VN = B(oe, {
  name: "MuiDialogTitle",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: "16px 24px",
  flex: "0 0 auto"
}), _0 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiDialogTitle"
  }), {
    className: r,
    id: i
  } = o, s = le(o, IN), a = o, c = jN(a), {
    titleId: d = i
  } = y.useContext(K4);
  return /* @__PURE__ */ f.jsx(VN, T({
    component: "h2",
    className: xe(c.root, r),
    ownerState: a,
    ref: n,
    variant: "h6",
    id: i ?? d
  }, s));
});
process.env.NODE_ENV !== "production" && (_0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * @ignore
   */
  id: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function DN(e) {
  return _e("MuiDivider", e);
}
const wg = Re("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), AN = ["absolute", "children", "className", "component", "flexItem", "light", "orientation", "role", "textAlign", "variant"], HN = (e) => {
  const {
    absolute: t,
    children: n,
    classes: o,
    flexItem: r,
    light: i,
    orientation: s,
    textAlign: a,
    variant: c
  } = e;
  return Oe({
    root: ["root", t && "absolute", c, i && "light", s === "vertical" && "vertical", r && "flexItem", n && "withChildren", n && s === "vertical" && "withChildrenVertical", a === "right" && s !== "vertical" && "textAlignRight", a === "left" && s !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", s === "vertical" && "wrapperVertical"]
  }, DN, o);
}, FN = B("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.absolute && t.absolute, t[n.variant], n.light && t.light, n.orientation === "vertical" && t.vertical, n.flexItem && t.flexItem, n.children && t.withChildren, n.children && n.orientation === "vertical" && t.withChildrenVertical, n.textAlign === "right" && n.orientation !== "vertical" && t.textAlignRight, n.textAlign === "left" && n.orientation !== "vertical" && t.textAlignLeft];
  }
})(({
  theme: e,
  ownerState: t
}) => T({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (e.vars || e).palette.divider,
  borderBottomWidth: "thin"
}, t.absolute && {
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%"
}, t.light && {
  borderColor: e.vars ? `rgba(${e.vars.palette.dividerChannel} / 0.08)` : gt(e.palette.divider, 0.08)
}, t.variant === "inset" && {
  marginLeft: 72
}, t.variant === "middle" && t.orientation === "horizontal" && {
  marginLeft: e.spacing(2),
  marginRight: e.spacing(2)
}, t.variant === "middle" && t.orientation === "vertical" && {
  marginTop: e.spacing(1),
  marginBottom: e.spacing(1)
}, t.orientation === "vertical" && {
  height: "100%",
  borderBottomWidth: 0,
  borderRightWidth: "thin"
}, t.flexItem && {
  alignSelf: "stretch",
  height: "auto"
}), ({
  ownerState: e
}) => T({}, e.children && {
  display: "flex",
  whiteSpace: "nowrap",
  textAlign: "center",
  border: 0,
  borderTopStyle: "solid",
  borderLeftStyle: "solid",
  "&::before, &::after": {
    content: '""',
    alignSelf: "center"
  }
}), ({
  theme: e,
  ownerState: t
}) => T({}, t.children && t.orientation !== "vertical" && {
  "&::before, &::after": {
    width: "100%",
    borderTop: `thin solid ${(e.vars || e).palette.divider}`,
    borderTopStyle: "inherit"
  }
}), ({
  theme: e,
  ownerState: t
}) => T({}, t.children && t.orientation === "vertical" && {
  flexDirection: "column",
  "&::before, &::after": {
    height: "100%",
    borderLeft: `thin solid ${(e.vars || e).palette.divider}`,
    borderLeftStyle: "inherit"
  }
}), ({
  ownerState: e
}) => T({}, e.textAlign === "right" && e.orientation !== "vertical" && {
  "&::before": {
    width: "90%"
  },
  "&::after": {
    width: "10%"
  }
}, e.textAlign === "left" && e.orientation !== "vertical" && {
  "&::before": {
    width: "10%"
  },
  "&::after": {
    width: "90%"
  }
})), NN = B("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.wrapper, n.orientation === "vertical" && t.wrapperVertical];
  }
})(({
  theme: e,
  ownerState: t
}) => T({
  display: "inline-block",
  paddingLeft: `calc(${e.spacing(1)} * 1.2)`,
  paddingRight: `calc(${e.spacing(1)} * 1.2)`
}, t.orientation === "vertical" && {
  paddingTop: `calc(${e.spacing(1)} * 1.2)`,
  paddingBottom: `calc(${e.spacing(1)} * 1.2)`
})), ho = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiDivider"
  }), {
    absolute: r = !1,
    children: i,
    className: s,
    component: a = i ? "div" : "hr",
    flexItem: c = !1,
    light: d = !1,
    orientation: u = "horizontal",
    role: p = a !== "hr" ? "separator" : void 0,
    textAlign: h = "center",
    variant: g = "fullWidth"
  } = o, m = le(o, AN), b = T({}, o, {
    absolute: r,
    component: a,
    flexItem: c,
    light: d,
    orientation: u,
    role: p,
    textAlign: h,
    variant: g
  }), C = HN(b);
  return /* @__PURE__ */ f.jsx(FN, T({
    as: a,
    className: xe(C.root, s),
    role: p,
    ref: n,
    ownerState: b
  }, m, {
    children: i ? /* @__PURE__ */ f.jsx(NN, {
      className: C.wrapper,
      ownerState: b,
      children: i
    }) : null
  }));
});
ho.muiSkipListHighlight = !0;
process.env.NODE_ENV !== "production" && (ho.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: l.bool,
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: l.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/)
   */
  light: l.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: l.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: l.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: l.oneOfType([l.oneOf(["fullWidth", "inset", "middle"]), l.string])
});
const $N = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "slotProps", "slots", "type"], BN = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, r = Oe({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, CH, t);
  return T({}, t, r);
}, zN = B(S3, {
  shouldForwardProp: (e) => bo(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...v3(e, t), !n.disableUnderline && t.underline];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n;
  const o = e.palette.mode === "light", r = o ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", i = o ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", s = o ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", a = o ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return T({
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : i,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : s,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : i
      }
    },
    [`&.${Uo.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : i
    },
    [`&.${Uo.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : a
    }
  }, !t.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(n = (e.vars || e).palette[t.color || "primary"]) == null ? void 0 : n.main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${Uo.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${Uo.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : r}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${Uo.disabled}, .${Uo.error}):before`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
    },
    [`&.${Uo.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  }, t.startAdornment && {
    paddingLeft: 12
  }, t.endAdornment && {
    paddingRight: 12
  }, t.multiline && T({
    padding: "25px 12px 8px"
  }, t.size === "small" && {
    paddingTop: 21,
    paddingBottom: 4
  }, t.hiddenLabel && {
    paddingTop: 16,
    paddingBottom: 17
  }, t.hiddenLabel && t.size === "small" && {
    paddingTop: 8,
    paddingBottom: 9
  }));
}), ZN = B(M3, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: w3
})(({
  theme: e,
  ownerState: t
}) => T({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, t.size === "small" && {
  paddingTop: 21,
  paddingBottom: 4
}, t.hiddenLabel && {
  paddingTop: 16,
  paddingBottom: 17
}, t.startAdornment && {
  paddingLeft: 0
}, t.endAdornment && {
  paddingRight: 0
}, t.hiddenLabel && t.size === "small" && {
  paddingTop: 8,
  paddingBottom: 9
}, t.multiline && {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
})), E3 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i, s;
  const a = Xe({
    props: t,
    name: "MuiFilledInput"
  }), {
    components: c = {},
    componentsProps: d,
    fullWidth: u = !1,
    // declare here to prevent spreading to DOM
    inputComponent: p = "input",
    multiline: h = !1,
    slotProps: g,
    slots: m = {},
    type: b = "text"
  } = a, C = le(a, $N), x = T({}, a, {
    fullWidth: u,
    inputComponent: p,
    multiline: h,
    type: b
  }), v = BN(a), S = {
    root: {
      ownerState: x
    },
    input: {
      ownerState: x
    }
  }, M = g ?? d ? yo(S, g ?? d) : S, w = (o = (r = m.root) != null ? r : c.Root) != null ? o : zN, k = (i = (s = m.input) != null ? s : c.Input) != null ? i : ZN;
  return /* @__PURE__ */ f.jsx(a2, T({
    slots: {
      root: w,
      input: k
    },
    componentsProps: M,
    fullWidth: u,
    inputComponent: p,
    multiline: h,
    ref: n,
    type: b
  }, C, {
    classes: v
  }));
});
process.env.NODE_ENV !== "production" && (E3.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: l.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary"]), l.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Input: l.elementType,
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    input: l.object,
    root: l.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: l.bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: l.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: l.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: l.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: l.bool,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: l.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: l.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: l.oneOfType([l.number, l.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: l.oneOfType([l.number, l.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: l.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: l.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: l.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: l.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: l.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: l.oneOfType([l.number, l.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: l.shape({
    input: l.object,
    root: l.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    input: l.elementType,
    root: l.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: l.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: l.any
});
E3.muiName = "Input";
function WN(e) {
  return _e("MuiFormControl", e);
}
Re("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const UN = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"], GN = (e) => {
  const {
    classes: t,
    margin: n,
    fullWidth: o
  } = e, r = {
    root: ["root", n !== "none" && `margin${pe(n)}`, o && "fullWidth"]
  };
  return Oe(r, WN, t);
}, qN = B("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, t) => T({}, t.root, t[`margin${pe(e.margin)}`], e.fullWidth && t.fullWidth)
})(({
  ownerState: e
}) => T({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top"
}, e.margin === "normal" && {
  marginTop: 16,
  marginBottom: 8
}, e.margin === "dense" && {
  marginTop: 8,
  marginBottom: 4
}, e.fullWidth && {
  width: "100%"
})), R3 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiFormControl"
  }), {
    children: r,
    className: i,
    color: s = "primary",
    component: a = "div",
    disabled: c = !1,
    error: d = !1,
    focused: u,
    fullWidth: p = !1,
    hiddenLabel: h = !1,
    margin: g = "none",
    required: m = !1,
    size: b = "medium",
    variant: C = "outlined"
  } = o, x = le(o, UN), v = T({}, o, {
    color: s,
    component: a,
    disabled: c,
    error: d,
    fullWidth: p,
    hiddenLabel: h,
    margin: g,
    required: m,
    size: b,
    variant: C
  }), S = GN(v), [M, w] = y.useState(() => {
    let V = !1;
    return r && y.Children.forEach(r, (j) => {
      if (!Cl(j, ["Input", "Select"]))
        return;
      const I = Cl(j, ["Select"]) ? j.props.input : j;
      I && uH(I.props) && (V = !0);
    }), V;
  }), [k, E] = y.useState(() => {
    let V = !1;
    return r && y.Children.forEach(r, (j) => {
      Cl(j, ["Input", "Select"]) && (qd(j.props, !0) || qd(j.props.inputProps, !0)) && (V = !0);
    }), V;
  }), [R, O] = y.useState(!1);
  c && R && O(!1);
  const P = u !== void 0 && !c ? u : R;
  let _;
  if (process.env.NODE_ENV !== "production") {
    const V = y.useRef(!1);
    _ = () => (V.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), V.current = !0, () => {
      V.current = !1;
    });
  }
  const L = y.useMemo(() => ({
    adornedStart: M,
    setAdornedStart: w,
    color: s,
    disabled: c,
    error: d,
    filled: k,
    focused: P,
    fullWidth: p,
    hiddenLabel: h,
    size: b,
    onBlur: () => {
      O(!1);
    },
    onEmpty: () => {
      E(!1);
    },
    onFilled: () => {
      E(!0);
    },
    onFocus: () => {
      O(!0);
    },
    registerEffect: _,
    required: m,
    variant: C
  }), [M, s, c, d, k, P, p, h, _, m, b, C]);
  return /* @__PURE__ */ f.jsx(O0.Provider, {
    value: L,
    children: /* @__PURE__ */ f.jsx(qN, T({
      as: a,
      ownerState: v,
      className: xe(S.root, i),
      ref: n
    }, x, {
      children: r
    }))
  });
});
process.env.NODE_ENV !== "production" && (R3.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: l.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: l.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: l.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: l.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: l.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: l.oneOf(["filled", "outlined", "standard"])
});
const be = WI({
  createStyledComponent: B("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (e, t) => t.root
  }),
  useThemeProps: (e) => Xe({
    props: e,
    name: "MuiStack"
  })
});
process.env.NODE_ENV !== "production" && (be.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: l.oneOfType([l.oneOf(["column-reverse", "column", "row-reverse", "row"]), l.arrayOf(l.oneOf(["column-reverse", "column", "row-reverse", "row"])), l.object]),
  /**
   * Add an element between each child.
   */
  divider: l.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: l.oneOfType([l.arrayOf(l.oneOfType([l.number, l.string])), l.number, l.object, l.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: l.bool
});
function KN(e) {
  return _e("MuiFormControlLabel", e);
}
const Z2 = Re("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error", "required", "asterisk"]), YN = ["checked", "className", "componentsProps", "control", "disabled", "disableTypography", "inputRef", "label", "labelPlacement", "name", "onChange", "required", "slotProps", "value"], XN = (e) => {
  const {
    classes: t,
    disabled: n,
    labelPlacement: o,
    error: r,
    required: i
  } = e, s = {
    root: ["root", n && "disabled", `labelPlacement${pe(o)}`, r && "error", i && "required"],
    label: ["label", n && "disabled"],
    asterisk: ["asterisk", r && "error"]
  };
  return Oe(s, KN, t);
}, JN = B("label", {
  name: "MuiFormControlLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${Z2.label}`]: t.label
    }, t.root, t[`labelPlacement${pe(n.labelPlacement)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => T({
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  // For correct alignment with the text.
  verticalAlign: "middle",
  WebkitTapHighlightColor: "transparent",
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${Z2.disabled}`]: {
    cursor: "default"
  }
}, t.labelPlacement === "start" && {
  flexDirection: "row-reverse",
  marginLeft: 16,
  // used for row presentation of radio/checkbox
  marginRight: -11
}, t.labelPlacement === "top" && {
  flexDirection: "column-reverse",
  marginLeft: 16
}, t.labelPlacement === "bottom" && {
  flexDirection: "column",
  marginLeft: 16
}, {
  [`& .${Z2.label}`]: {
    [`&.${Z2.disabled}`]: {
      color: (e.vars || e).palette.text.disabled
    }
  }
})), QN = B("span", {
  name: "MuiFormControlLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(({
  theme: e
}) => ({
  [`&.${Z2.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), u2 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r;
  const i = Xe({
    props: t,
    name: "MuiFormControlLabel"
  }), {
    className: s,
    componentsProps: a = {},
    control: c,
    disabled: d,
    disableTypography: u,
    label: p,
    labelPlacement: h = "end",
    required: g,
    slotProps: m = {}
  } = i, b = le(i, YN), C = ui(), x = (o = d ?? c.props.disabled) != null ? o : C == null ? void 0 : C.disabled, v = g ?? c.props.required, S = {
    disabled: x,
    required: v
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach((O) => {
    typeof c.props[O] > "u" && typeof i[O] < "u" && (S[O] = i[O]);
  });
  const M = Es({
    props: i,
    muiFormControl: C,
    states: ["error"]
  }), w = T({}, i, {
    disabled: x,
    labelPlacement: h,
    required: v,
    error: M.error
  }), k = XN(w), E = (r = m.typography) != null ? r : a.typography;
  let R = p;
  return R != null && R.type !== oe && !u && (R = /* @__PURE__ */ f.jsx(oe, T({
    component: "span"
  }, E, {
    className: xe(k.label, E == null ? void 0 : E.className),
    children: R
  }))), /* @__PURE__ */ f.jsxs(JN, T({
    className: xe(k.root, s),
    ownerState: w,
    ref: n
  }, b, {
    children: [/* @__PURE__ */ y.cloneElement(c, S), v ? /* @__PURE__ */ f.jsxs(be, {
      display: "block",
      children: [R, /* @__PURE__ */ f.jsxs(QN, {
        ownerState: w,
        "aria-hidden": !0,
        className: k.asterisk,
        children: [" ", "*"]
      })]
    }) : R]
  }));
});
process.env.NODE_ENV !== "production" && (u2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component appears selected.
   */
  checked: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: l.shape({
    typography: l.object
  }),
  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: l.element.isRequired,
  /**
   * If `true`, the control is disabled.
   */
  disabled: l.bool,
  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: l.bool,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: l.node,
  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: l.oneOf(["bottom", "end", "start", "top"]),
  /**
   * @ignore
   */
  name: l.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: l.func,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: l.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: l.shape({
    typography: l.object
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The value of the component.
   */
  value: l.any
});
function e$(e) {
  return _e("MuiFormGroup", e);
}
Re("MuiFormGroup", ["root", "row", "error"]);
const t$ = ["className", "row"], n$ = (e) => {
  const {
    classes: t,
    row: n,
    error: o
  } = e;
  return Oe({
    root: ["root", n && "row", o && "error"]
  }, e$, t);
}, o$ = B("div", {
  name: "MuiFormGroup",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.row && t.row];
  }
})(({
  ownerState: e
}) => T({
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap"
}, e.row && {
  flexDirection: "row"
})), X4 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiFormGroup"
  }), {
    className: r,
    row: i = !1
  } = o, s = le(o, t$), a = ui(), c = Es({
    props: o,
    muiFormControl: a,
    states: ["error"]
  }), d = T({}, o, {
    row: i,
    error: c.error
  }), u = n$(d);
  return /* @__PURE__ */ f.jsx(o$, T({
    className: xe(u.root, r),
    ownerState: d,
    ref: n
  }, s));
});
process.env.NODE_ENV !== "production" && (X4.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * Display group of elements in a compact row.
   * @default false
   */
  row: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function r$(e) {
  return _e("MuiFormHelperText", e);
}
const Sg = Re("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var Mg;
const i$ = ["children", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"], s$ = (e) => {
  const {
    classes: t,
    contained: n,
    size: o,
    disabled: r,
    error: i,
    filled: s,
    focused: a,
    required: c
  } = e, d = {
    root: ["root", r && "disabled", i && "error", o && `size${pe(o)}`, n && "contained", a && "focused", s && "filled", c && "required"]
  };
  return Oe(d, r$, t);
}, a$ = B("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size && t[`size${pe(n.size)}`], n.contained && t.contained, n.filled && t.filled];
  }
})(({
  theme: e,
  ownerState: t
}) => T({
  color: (e.vars || e).palette.text.secondary
}, e.typography.caption, {
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${Sg.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${Sg.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}, t.size === "small" && {
  marginTop: 4
}, t.contained && {
  marginLeft: 14,
  marginRight: 14
})), J4 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiFormHelperText"
  }), {
    children: r,
    className: i,
    component: s = "p"
  } = o, a = le(o, i$), c = ui(), d = Es({
    props: o,
    muiFormControl: c,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), u = T({}, o, {
    component: s,
    contained: d.variant === "filled" || d.variant === "outlined",
    variant: d.variant,
    size: d.size,
    disabled: d.disabled,
    error: d.error,
    filled: d.filled,
    focused: d.focused,
    required: d.required
  }), p = s$(u);
  return /* @__PURE__ */ f.jsx(a$, T({
    as: s,
    ownerState: u,
    className: xe(p.root, i),
    ref: n
  }, a, {
    children: r === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      Mg || (Mg = /* @__PURE__ */ f.jsx("span", {
        className: "notranslate",
        children: "​"
      }))
    ) : r
  }));
});
process.env.NODE_ENV !== "production" && (J4.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: l.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: l.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: l.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: l.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: l.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   */
  variant: l.oneOfType([l.oneOf(["filled", "outlined", "standard"]), l.string])
});
function l$(e) {
  return _e("MuiFormLabel", e);
}
const ic = Re("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), c$ = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"], d$ = (e) => {
  const {
    classes: t,
    color: n,
    focused: o,
    disabled: r,
    error: i,
    filled: s,
    required: a
  } = e, c = {
    root: ["root", `color${pe(n)}`, r && "disabled", i && "error", s && "filled", o && "focused", a && "required"],
    asterisk: ["asterisk", i && "error"]
  };
  return Oe(c, l$, t);
}, u$ = B("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, t) => T({}, t.root, e.color === "secondary" && t.colorSecondary, e.filled && t.filled)
})(({
  theme: e,
  ownerState: t
}) => T({
  color: (e.vars || e).palette.text.secondary
}, e.typography.body1, {
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  [`&.${ic.focused}`]: {
    color: (e.vars || e).palette[t.color].main
  },
  [`&.${ic.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${ic.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), f$ = B("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(({
  theme: e
}) => ({
  [`&.${ic.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), rw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiFormLabel"
  }), {
    children: r,
    className: i,
    component: s = "label"
  } = o, a = le(o, c$), c = ui(), d = Es({
    props: o,
    muiFormControl: c,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), u = T({}, o, {
    color: d.color || "primary",
    component: s,
    disabled: d.disabled,
    error: d.error,
    filled: d.filled,
    focused: d.focused,
    required: d.required
  }), p = d$(u);
  return /* @__PURE__ */ f.jsxs(u$, T({
    as: s,
    ownerState: u,
    className: xe(p.root, i),
    ref: n
  }, a, {
    children: [r, d.required && /* @__PURE__ */ f.jsxs(f$, {
      ownerState: u,
      "aria-hidden": !0,
      className: p.asterisk,
      children: [" ", "*"]
    })]
  }));
});
process.env.NODE_ENV !== "production" && (rw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: l.oneOfType([l.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: l.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: l.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: l.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: l.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const Fp = /* @__PURE__ */ y.createContext();
process.env.NODE_ENV !== "production" && (Fp.displayName = "GridContext");
function p$(e) {
  return _e("MuiGrid", e);
}
const h$ = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], g$ = ["column-reverse", "column", "row-reverse", "row"], m$ = ["nowrap", "wrap-reverse", "wrap"], T2 = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], Hc = Re("MuiGrid", [
  "root",
  "container",
  "item",
  "zeroMinWidth",
  // spacings
  ...h$.map((e) => `spacing-xs-${e}`),
  // direction values
  ...g$.map((e) => `direction-xs-${e}`),
  // wrap values
  ...m$.map((e) => `wrap-xs-${e}`),
  // grid sizes for all breakpoints
  ...T2.map((e) => `grid-xs-${e}`),
  ...T2.map((e) => `grid-sm-${e}`),
  ...T2.map((e) => `grid-md-${e}`),
  ...T2.map((e) => `grid-lg-${e}`),
  ...T2.map((e) => `grid-xl-${e}`)
]), b$ = ["className", "columns", "columnSpacing", "component", "container", "direction", "item", "rowSpacing", "spacing", "wrap", "zeroMinWidth"];
function xl(e) {
  const t = parseFloat(e);
  return `${t}${String(e).replace(String(t), "") || "px"}`;
}
function C$({
  theme: e,
  ownerState: t
}) {
  let n;
  return e.breakpoints.keys.reduce((o, r) => {
    let i = {};
    if (t[r] && (n = t[r]), !n)
      return o;
    if (n === !0)
      i = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: "100%"
      };
    else if (n === "auto")
      i = {
        flexBasis: "auto",
        flexGrow: 0,
        flexShrink: 0,
        maxWidth: "none",
        width: "auto"
      };
    else {
      const s = ra({
        values: t.columns,
        breakpoints: e.breakpoints.values
      }), a = typeof s == "object" ? s[r] : s;
      if (a == null)
        return o;
      const c = `${Math.round(n / a * 1e8) / 1e6}%`;
      let d = {};
      if (t.container && t.item && t.columnSpacing !== 0) {
        const u = e.spacing(t.columnSpacing);
        if (u !== "0px") {
          const p = `calc(${c} + ${xl(u)})`;
          d = {
            flexBasis: p,
            maxWidth: p
          };
        }
      }
      i = T({
        flexBasis: c,
        flexGrow: 0,
        maxWidth: c
      }, d);
    }
    return e.breakpoints.values[r] === 0 ? Object.assign(o, i) : o[e.breakpoints.up(r)] = i, o;
  }, {});
}
function x$({
  theme: e,
  ownerState: t
}) {
  const n = ra({
    values: t.direction,
    breakpoints: e.breakpoints.values
  });
  return Fo({
    theme: e
  }, n, (o) => {
    const r = {
      flexDirection: o
    };
    return o.indexOf("column") === 0 && (r[`& > .${Hc.item}`] = {
      maxWidth: "none"
    }), r;
  });
}
function iw({
  breakpoints: e,
  values: t
}) {
  let n = "";
  Object.keys(t).forEach((r) => {
    n === "" && t[r] !== 0 && (n = r);
  });
  const o = Object.keys(e).sort((r, i) => e[r] - e[i]);
  return o.slice(0, o.indexOf(n));
}
function y$({
  theme: e,
  ownerState: t
}) {
  const {
    container: n,
    rowSpacing: o
  } = t;
  let r = {};
  if (n && o !== 0) {
    const i = ra({
      values: o,
      breakpoints: e.breakpoints.values
    });
    let s;
    typeof i == "object" && (s = iw({
      breakpoints: e.breakpoints.values,
      values: i
    })), r = Fo({
      theme: e
    }, i, (a, c) => {
      var d;
      const u = e.spacing(a);
      return u !== "0px" ? {
        marginTop: `-${xl(u)}`,
        [`& > .${Hc.item}`]: {
          paddingTop: xl(u)
        }
      } : (d = s) != null && d.includes(c) ? {} : {
        marginTop: 0,
        [`& > .${Hc.item}`]: {
          paddingTop: 0
        }
      };
    });
  }
  return r;
}
function v$({
  theme: e,
  ownerState: t
}) {
  const {
    container: n,
    columnSpacing: o
  } = t;
  let r = {};
  if (n && o !== 0) {
    const i = ra({
      values: o,
      breakpoints: e.breakpoints.values
    });
    let s;
    typeof i == "object" && (s = iw({
      breakpoints: e.breakpoints.values,
      values: i
    })), r = Fo({
      theme: e
    }, i, (a, c) => {
      var d;
      const u = e.spacing(a);
      return u !== "0px" ? {
        width: `calc(100% + ${xl(u)})`,
        marginLeft: `-${xl(u)}`,
        [`& > .${Hc.item}`]: {
          paddingLeft: xl(u)
        }
      } : (d = s) != null && d.includes(c) ? {} : {
        width: "100%",
        marginLeft: 0,
        [`& > .${Hc.item}`]: {
          paddingLeft: 0
        }
      };
    });
  }
  return r;
}
function w$(e, t, n = {}) {
  if (!e || e <= 0)
    return [];
  if (typeof e == "string" && !Number.isNaN(Number(e)) || typeof e == "number")
    return [n[`spacing-xs-${String(e)}`]];
  const o = [];
  return t.forEach((r) => {
    const i = e[r];
    Number(i) > 0 && o.push(n[`spacing-${r}-${String(i)}`]);
  }), o;
}
const S$ = B("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      container: o,
      direction: r,
      item: i,
      spacing: s,
      wrap: a,
      zeroMinWidth: c,
      breakpoints: d
    } = n;
    let u = [];
    o && (u = w$(s, d, t));
    const p = [];
    return d.forEach((h) => {
      const g = n[h];
      g && p.push(t[`grid-${h}-${String(g)}`]);
    }), [t.root, o && t.container, i && t.item, c && t.zeroMinWidth, ...u, r !== "row" && t[`direction-xs-${String(r)}`], a !== "wrap" && t[`wrap-xs-${String(a)}`], ...p];
  }
})(({
  ownerState: e
}) => T({
  boxSizing: "border-box"
}, e.container && {
  display: "flex",
  flexWrap: "wrap",
  width: "100%"
}, e.item && {
  margin: 0
  // For instance, it's useful when used with a `figure` element.
}, e.zeroMinWidth && {
  minWidth: 0
}, e.wrap !== "wrap" && {
  flexWrap: e.wrap
}), x$, y$, v$, C$);
function M$(e, t) {
  if (!e || e <= 0)
    return [];
  if (typeof e == "string" && !Number.isNaN(Number(e)) || typeof e == "number")
    return [`spacing-xs-${String(e)}`];
  const n = [];
  return t.forEach((o) => {
    const r = e[o];
    if (Number(r) > 0) {
      const i = `spacing-${o}-${String(r)}`;
      n.push(i);
    }
  }), n;
}
const T$ = (e) => {
  const {
    classes: t,
    container: n,
    direction: o,
    item: r,
    spacing: i,
    wrap: s,
    zeroMinWidth: a,
    breakpoints: c
  } = e;
  let d = [];
  n && (d = M$(i, c));
  const u = [];
  c.forEach((h) => {
    const g = e[h];
    g && u.push(`grid-${h}-${String(g)}`);
  });
  const p = {
    root: ["root", n && "container", r && "item", a && "zeroMinWidth", ...d, o !== "row" && `direction-xs-${String(o)}`, s !== "wrap" && `wrap-xs-${String(s)}`, ...u]
  };
  return Oe(p, p$, t);
}, to = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiGrid"
  }), {
    breakpoints: r
  } = ge(), i = x0(o), {
    className: s,
    columns: a,
    columnSpacing: c,
    component: d = "div",
    container: u = !1,
    direction: p = "row",
    item: h = !1,
    rowSpacing: g,
    spacing: m = 0,
    wrap: b = "wrap",
    zeroMinWidth: C = !1
  } = i, x = le(i, b$), v = g || m, S = c || m, M = y.useContext(Fp), w = u ? a || 12 : M, k = {}, E = T({}, x);
  r.keys.forEach((P) => {
    x[P] != null && (k[P] = x[P], delete E[P]);
  });
  const R = T({}, i, {
    columns: w,
    container: u,
    direction: p,
    item: h,
    rowSpacing: v,
    columnSpacing: S,
    wrap: b,
    zeroMinWidth: C,
    spacing: m
  }, k, {
    breakpoints: r.keys
  }), O = T$(R);
  return /* @__PURE__ */ f.jsx(Fp.Provider, {
    value: w,
    children: /* @__PURE__ */ f.jsx(S$, T({
      ownerState: R,
      className: xe(O.root, s),
      as: d,
      ref: n
    }, E))
  });
});
process.env.NODE_ENV !== "production" && (to.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The number of columns.
   * @default 12
   */
  columns: l.oneOfType([l.arrayOf(l.number), l.number, l.object]),
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: l.oneOfType([l.arrayOf(l.oneOfType([l.number, l.string])), l.number, l.object, l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: l.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: l.oneOfType([l.oneOf(["column-reverse", "column", "row-reverse", "row"]), l.arrayOf(l.oneOf(["column-reverse", "column", "row-reverse", "row"])), l.object]),
  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  item: l.bool,
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `lg` breakpoint and wider screens if not overridden.
   * @default false
   */
  lg: l.oneOfType([l.oneOf(["auto"]), l.number, l.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `md` breakpoint and wider screens if not overridden.
   * @default false
   */
  md: l.oneOfType([l.oneOf(["auto"]), l.number, l.bool]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: l.oneOfType([l.arrayOf(l.oneOfType([l.number, l.string])), l.number, l.object, l.string]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `sm` breakpoint and wider screens if not overridden.
   * @default false
   */
  sm: l.oneOfType([l.oneOf(["auto"]), l.number, l.bool]),
  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: l.oneOfType([l.arrayOf(l.oneOfType([l.number, l.string])), l.number, l.object, l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: l.oneOf(["nowrap", "wrap-reverse", "wrap"]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `xl` breakpoint and wider screens if not overridden.
   * @default false
   */
  xl: l.oneOfType([l.oneOf(["auto"]), l.number, l.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for all the screen sizes with the lowest priority.
   * @default false
   */
  xs: l.oneOfType([l.oneOf(["auto"]), l.number, l.bool]),
  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   * @default false
   */
  zeroMinWidth: l.bool
});
if (process.env.NODE_ENV !== "production") {
  const e = uv("Grid", to);
  to.propTypes = T({}, to.propTypes, {
    direction: e("container"),
    lg: e("item"),
    md: e("item"),
    sm: e("item"),
    spacing: e("container"),
    wrap: e("container"),
    xs: e("item"),
    zeroMinWidth: e("item")
  });
}
const k$ = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function Np(e) {
  return `scale(${e}, ${e ** 2})`;
}
const E$ = {
  entering: {
    opacity: 1,
    transform: Np(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, Zf = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), gs = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const {
    addEndListener: o,
    appear: r = !0,
    children: i,
    easing: s,
    in: a,
    onEnter: c,
    onEntered: d,
    onEntering: u,
    onExit: p,
    onExited: h,
    onExiting: g,
    style: m,
    timeout: b = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: C = nr
  } = t, x = le(t, k$), v = Xs(), S = y.useRef(), M = ge(), w = y.useRef(null), k = Tt(w, o2(i), n), E = (I) => (F) => {
    if (I) {
      const $ = w.current;
      F === void 0 ? I($) : I($, F);
    }
  }, R = E(u), O = E((I, F) => {
    Iv(I);
    const {
      duration: $,
      delay: A,
      easing: H
    } = Il({
      style: m,
      timeout: b,
      easing: s
    }, {
      mode: "enter"
    });
    let N;
    b === "auto" ? (N = M.transitions.getAutoHeightDuration(I.clientHeight), S.current = N) : N = $, I.style.transition = [M.transitions.create("opacity", {
      duration: N,
      delay: A
    }), M.transitions.create("transform", {
      duration: Zf ? N : N * 0.666,
      delay: A,
      easing: H
    })].join(","), c && c(I, F);
  }), P = E(d), _ = E(g), L = E((I) => {
    const {
      duration: F,
      delay: $,
      easing: A
    } = Il({
      style: m,
      timeout: b,
      easing: s
    }, {
      mode: "exit"
    });
    let H;
    b === "auto" ? (H = M.transitions.getAutoHeightDuration(I.clientHeight), S.current = H) : H = F, I.style.transition = [M.transitions.create("opacity", {
      duration: H,
      delay: $
    }), M.transitions.create("transform", {
      duration: Zf ? H : H * 0.666,
      delay: Zf ? $ : $ || H * 0.333,
      easing: A
    })].join(","), I.style.opacity = 0, I.style.transform = Np(0.75), p && p(I);
  }), V = E(h), j = (I) => {
    b === "auto" && v.start(S.current || 0, I), o && o(w.current, I);
  };
  return /* @__PURE__ */ f.jsx(C, T({
    appear: r,
    in: a,
    nodeRef: w,
    onEnter: O,
    onEntered: P,
    onEntering: R,
    onExit: L,
    onExited: V,
    onExiting: _,
    addEndListener: j,
    timeout: b === "auto" ? null : b
  }, x, {
    children: (I, F) => /* @__PURE__ */ y.cloneElement(i, T({
      style: T({
        opacity: 0,
        transform: Np(0.75),
        visibility: I === "exited" && !a ? "hidden" : void 0
      }, E$[I], m, i.props.style),
      ref: k
    }, F))
  }));
});
process.env.NODE_ENV !== "production" && (gs.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: l.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: l.bool,
  /**
   * A single child content element.
   */
  children: t2.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: l.oneOfType([l.shape({
    enter: l.string,
    exit: l.string
  }), l.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: l.bool,
  /**
   * @ignore
   */
  onEnter: l.func,
  /**
   * @ignore
   */
  onEntered: l.func,
  /**
   * @ignore
   */
  onEntering: l.func,
  /**
   * @ignore
   */
  onExit: l.func,
  /**
   * @ignore
   */
  onExited: l.func,
  /**
   * @ignore
   */
  onExiting: l.func,
  /**
   * @ignore
   */
  style: l.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: l.oneOfType([l.oneOf(["auto"]), l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })])
});
gs.muiSupportAuto = !0;
const R$ = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "slotProps", "slots", "type"], O$ = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, r = Oe({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, mH, t);
  return T({}, t, r);
}, _$ = B(S3, {
  shouldForwardProp: (e) => bo(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...v3(e, t), !n.disableUnderline && t.underline];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  let o = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (o = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), T({
    position: "relative"
  }, t.formControl && {
    "label + &": {
      marginTop: 16
    }
  }, !t.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(e.vars || e).palette[t.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${qi.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${qi.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${o}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${qi.disabled}, .${qi.error}):before`]: {
      borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        borderBottom: `1px solid ${o}`
      }
    },
    [`&.${qi.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  });
}), P$ = B(M3, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: w3
})({}), O3 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i, s;
  const a = Xe({
    props: t,
    name: "MuiInput"
  }), {
    disableUnderline: c,
    components: d = {},
    componentsProps: u,
    fullWidth: p = !1,
    inputComponent: h = "input",
    multiline: g = !1,
    slotProps: m,
    slots: b = {},
    type: C = "text"
  } = a, x = le(a, R$), v = O$(a), M = {
    root: {
      ownerState: {
        disableUnderline: c
      }
    }
  }, w = m ?? u ? yo(m ?? u, M) : M, k = (o = (r = b.root) != null ? r : d.Root) != null ? o : _$, E = (i = (s = b.input) != null ? s : d.Input) != null ? i : P$;
  return /* @__PURE__ */ f.jsx(a2, T({
    slots: {
      root: k,
      input: E
    },
    slotProps: w,
    fullWidth: p,
    inputComponent: h,
    multiline: g,
    ref: n,
    type: C
  }, x, {
    classes: v
  }));
});
process.env.NODE_ENV !== "production" && (O3.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: l.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary"]), l.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Input: l.elementType,
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    input: l.object,
    root: l.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: l.bool,
  /**
   * If `true`, the `input` will not have an underline.
   */
  disableUnderline: l.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: l.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: l.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: l.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: l.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: l.oneOfType([l.number, l.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: l.oneOfType([l.number, l.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: l.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: l.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: l.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: l.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: l.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: l.oneOfType([l.number, l.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: l.shape({
    input: l.object,
    root: l.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    input: l.elementType,
    root: l.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: l.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: l.any
});
O3.muiName = "Input";
function L$(e) {
  return _e("MuiInputAdornment", e);
}
const Tg = Re("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var kg;
const I$ = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"], j$ = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, t[`position${pe(n.position)}`], n.disablePointerEvents === !0 && t.disablePointerEvents, t[n.variant]];
}, V$ = (e) => {
  const {
    classes: t,
    disablePointerEvents: n,
    hiddenLabel: o,
    position: r,
    size: i,
    variant: s
  } = e, a = {
    root: ["root", n && "disablePointerEvents", r && `position${pe(r)}`, s, o && "hiddenLabel", i && `size${pe(i)}`]
  };
  return Oe(a, L$, t);
}, D$ = B("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: j$
})(({
  theme: e,
  ownerState: t
}) => T({
  display: "flex",
  height: "0.01em",
  // Fix IE11 flexbox alignment. To remove at some point.
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (e.vars || e).palette.action.active
}, t.variant === "filled" && {
  // Styles applied to the root element if `variant="filled"`.
  [`&.${Tg.positionStart}&:not(.${Tg.hiddenLabel})`]: {
    marginTop: 16
  }
}, t.position === "start" && {
  // Styles applied to the root element if `position="start"`.
  marginRight: 8
}, t.position === "end" && {
  // Styles applied to the root element if `position="end"`.
  marginLeft: 8
}, t.disablePointerEvents === !0 && {
  // Styles applied to the root element if `disablePointerEvents={true}`.
  pointerEvents: "none"
})), Fc = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiInputAdornment"
  }), {
    children: r,
    className: i,
    component: s = "div",
    disablePointerEvents: a = !1,
    disableTypography: c = !1,
    position: d,
    variant: u
  } = o, p = le(o, I$), h = ui() || {};
  let g = u;
  u && h.variant && process.env.NODE_ENV !== "production" && u === h.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), g || (g = h.variant);
  const m = T({}, o, {
    hiddenLabel: h.hiddenLabel,
    size: h.size,
    disablePointerEvents: a,
    position: d,
    variant: g
  }), b = V$(m);
  return /* @__PURE__ */ f.jsx(O0.Provider, {
    value: null,
    children: /* @__PURE__ */ f.jsx(D$, T({
      as: s,
      ownerState: m,
      className: xe(b.root, i),
      ref: n
    }, p, {
      children: typeof r == "string" && !c ? /* @__PURE__ */ f.jsx(oe, {
        color: "text.secondary",
        children: r
      }) : /* @__PURE__ */ f.jsxs(y.Fragment, {
        children: [d === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          kg || (kg = /* @__PURE__ */ f.jsx("span", {
            className: "notranslate",
            children: "​"
          }))
        ) : null, r]
      })
    }))
  });
});
process.env.NODE_ENV !== "production" && (Fc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: l.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: l.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: l.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: l.oneOf(["filled", "outlined", "standard"])
});
function A$(e) {
  return _e("MuiInputLabel", e);
}
Re("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const H$ = ["disableAnimation", "margin", "shrink", "variant", "className"], F$ = (e) => {
  const {
    classes: t,
    formControl: n,
    size: o,
    shrink: r,
    disableAnimation: i,
    variant: s,
    required: a
  } = e, c = {
    root: ["root", n && "formControl", !i && "animated", r && "shrink", o && o !== "normal" && `size${pe(o)}`, s],
    asterisk: [a && "asterisk"]
  }, d = Oe(c, A$, t);
  return T({}, t, d);
}, N$ = B(rw, {
  shouldForwardProp: (e) => bo(e) || e === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${ic.asterisk}`]: t.asterisk
    }, t.root, n.formControl && t.formControl, n.size === "small" && t.sizeSmall, n.shrink && t.shrink, !n.disableAnimation && t.animated, n.focused && t.focused, t[n.variant]];
  }
})(({
  theme: e,
  ownerState: t
}) => T({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%"
}, t.formControl && {
  position: "absolute",
  left: 0,
  top: 0,
  // slight alteration to spec spacing to match visual spec result
  transform: "translate(0, 20px) scale(1)"
}, t.size === "small" && {
  // Compensation for the `Input.inputSizeSmall` style.
  transform: "translate(0, 17px) scale(1)"
}, t.shrink && {
  transform: "translate(0, -1.5px) scale(0.75)",
  transformOrigin: "top left",
  maxWidth: "133%"
}, !t.disableAnimation && {
  transition: e.transitions.create(["color", "transform", "max-width"], {
    duration: e.transitions.duration.shorter,
    easing: e.transitions.easing.easeOut
  })
}, t.variant === "filled" && T({
  // Chrome's autofill feature gives the input field a yellow background.
  // Since the input field is behind the label in the HTML tree,
  // the input field is drawn last and hides the label with an opaque background color.
  // zIndex: 1 will raise the label above opaque background-colors of input.
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(12px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, t.size === "small" && {
  transform: "translate(12px, 13px) scale(1)"
}, t.shrink && T({
  userSelect: "none",
  pointerEvents: "auto",
  transform: "translate(12px, 7px) scale(0.75)",
  maxWidth: "calc(133% - 24px)"
}, t.size === "small" && {
  transform: "translate(12px, 4px) scale(0.75)"
})), t.variant === "outlined" && T({
  // see comment above on filled.zIndex
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(14px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, t.size === "small" && {
  transform: "translate(14px, 9px) scale(1)"
}, t.shrink && {
  userSelect: "none",
  pointerEvents: "auto",
  // Theoretically, we should have (8+5)*2/0.75 = 34px
  // but it feels a better when it bleeds a bit on the left, so 32px.
  maxWidth: "calc(133% - 32px)",
  transform: "translate(14px, -9px) scale(0.75)"
}))), Q4 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    name: "MuiInputLabel",
    props: t
  }), {
    disableAnimation: r = !1,
    shrink: i,
    className: s
  } = o, a = le(o, H$), c = ui();
  let d = i;
  typeof d > "u" && c && (d = c.filled || c.focused || c.adornedStart);
  const u = Es({
    props: o,
    muiFormControl: c,
    states: ["size", "variant", "required", "focused"]
  }), p = T({}, o, {
    disableAnimation: r,
    formControl: c,
    shrink: d,
    size: u.size,
    variant: u.variant,
    required: u.required,
    focused: u.focused
  }), h = F$(p);
  return /* @__PURE__ */ f.jsx(N$, T({
    "data-shrink": d,
    ownerState: p,
    ref: n,
    className: xe(h.root, s)
  }, a, {
    classes: h
  }));
});
process.env.NODE_ENV !== "production" && (Q4.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: l.oneOfType([l.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), l.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: l.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: l.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: l.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: l.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: l.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: l.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: l.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: l.oneOfType([l.oneOf(["normal", "small"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   */
  variant: l.oneOf(["filled", "outlined", "standard"])
});
function $$(e) {
  return _e("MuiLinearProgress", e);
}
Re("MuiLinearProgress", ["root", "colorPrimary", "colorSecondary", "determinate", "indeterminate", "buffer", "query", "dashed", "dashedColorPrimary", "dashedColorSecondary", "bar", "barColorPrimary", "barColorSecondary", "bar1Indeterminate", "bar1Determinate", "bar1Buffer", "bar2Indeterminate", "bar2Buffer"]);
const B$ = ["className", "color", "value", "valueBuffer", "variant"];
let f2 = (e) => e, Eg, Rg, Og, _g, Pg, Lg;
const $p = 4, z$ = Dr(Eg || (Eg = f2`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`)), Z$ = Dr(Rg || (Rg = f2`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`)), W$ = Dr(Og || (Og = f2`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`)), U$ = (e) => {
  const {
    classes: t,
    variant: n,
    color: o
  } = e, r = {
    root: ["root", `color${pe(o)}`, n],
    dashed: ["dashed", `dashedColor${pe(o)}`],
    bar1: ["bar", `barColor${pe(o)}`, (n === "indeterminate" || n === "query") && "bar1Indeterminate", n === "determinate" && "bar1Determinate", n === "buffer" && "bar1Buffer"],
    bar2: ["bar", n !== "buffer" && `barColor${pe(o)}`, n === "buffer" && `color${pe(o)}`, (n === "indeterminate" || n === "query") && "bar2Indeterminate", n === "buffer" && "bar2Buffer"]
  };
  return Oe(r, $$, t);
}, e7 = (e, t) => t === "inherit" ? "currentColor" : e.vars ? e.vars.palette.LinearProgress[`${t}Bg`] : e.palette.mode === "light" ? va(e.palette[t].main, 0.62) : ya(e.palette[t].main, 0.5), G$ = B("span", {
  name: "MuiLinearProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`color${pe(n.color)}`], t[n.variant]];
  }
})(({
  ownerState: e,
  theme: t
}) => T({
  position: "relative",
  overflow: "hidden",
  display: "block",
  height: 4,
  zIndex: 0,
  // Fix Safari's bug during composition of different paint.
  "@media print": {
    colorAdjust: "exact"
  },
  backgroundColor: e7(t, e.color)
}, e.color === "inherit" && e.variant !== "buffer" && {
  backgroundColor: "none",
  "&::before": {
    content: '""',
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "currentColor",
    opacity: 0.3
  }
}, e.variant === "buffer" && {
  backgroundColor: "transparent"
}, e.variant === "query" && {
  transform: "rotate(180deg)"
})), q$ = B("span", {
  name: "MuiLinearProgress",
  slot: "Dashed",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.dashed, t[`dashedColor${pe(n.color)}`]];
  }
})(({
  ownerState: e,
  theme: t
}) => {
  const n = e7(t, e.color);
  return T({
    position: "absolute",
    marginTop: 0,
    height: "100%",
    width: "100%"
  }, e.color === "inherit" && {
    opacity: 0.3
  }, {
    backgroundImage: `radial-gradient(${n} 0%, ${n} 16%, transparent 42%)`,
    backgroundSize: "10px 10px",
    backgroundPosition: "0 -23px"
  });
}, Li(_g || (_g = f2`
    animation: ${0} 3s infinite linear;
  `), W$)), K$ = B("span", {
  name: "MuiLinearProgress",
  slot: "Bar1",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.bar, t[`barColor${pe(n.color)}`], (n.variant === "indeterminate" || n.variant === "query") && t.bar1Indeterminate, n.variant === "determinate" && t.bar1Determinate, n.variant === "buffer" && t.bar1Buffer];
  }
})(({
  ownerState: e,
  theme: t
}) => T({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  backgroundColor: e.color === "inherit" ? "currentColor" : (t.vars || t).palette[e.color].main
}, e.variant === "determinate" && {
  transition: `transform .${$p}s linear`
}, e.variant === "buffer" && {
  zIndex: 1,
  transition: `transform .${$p}s linear`
}), ({
  ownerState: e
}) => (e.variant === "indeterminate" || e.variant === "query") && Li(Pg || (Pg = f2`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), z$)), Y$ = B("span", {
  name: "MuiLinearProgress",
  slot: "Bar2",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.bar, t[`barColor${pe(n.color)}`], (n.variant === "indeterminate" || n.variant === "query") && t.bar2Indeterminate, n.variant === "buffer" && t.bar2Buffer];
  }
})(({
  ownerState: e,
  theme: t
}) => T({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left"
}, e.variant !== "buffer" && {
  backgroundColor: e.color === "inherit" ? "currentColor" : (t.vars || t).palette[e.color].main
}, e.color === "inherit" && {
  opacity: 0.3
}, e.variant === "buffer" && {
  backgroundColor: e7(t, e.color),
  transition: `transform .${$p}s linear`
}), ({
  ownerState: e
}) => (e.variant === "indeterminate" || e.variant === "query") && Li(Lg || (Lg = f2`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), Z$)), sw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiLinearProgress"
  }), {
    className: r,
    color: i = "primary",
    value: s,
    valueBuffer: a,
    variant: c = "indeterminate"
  } = o, d = le(o, B$), u = T({}, o, {
    color: i,
    variant: c
  }), p = U$(u), h = Ms(), g = {}, m = {
    bar1: {},
    bar2: {}
  };
  if (c === "determinate" || c === "buffer")
    if (s !== void 0) {
      g["aria-valuenow"] = Math.round(s), g["aria-valuemin"] = 0, g["aria-valuemax"] = 100;
      let b = s - 100;
      h && (b = -b), m.bar1.transform = `translateX(${b}%)`;
    } else process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a value prop when using the determinate or buffer variant of LinearProgress .");
  if (c === "buffer")
    if (a !== void 0) {
      let b = (a || 0) - 100;
      h && (b = -b), m.bar2.transform = `translateX(${b}%)`;
    } else process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a valueBuffer prop when using the buffer variant of LinearProgress.");
  return /* @__PURE__ */ f.jsxs(G$, T({
    className: xe(p.root, r),
    ownerState: u,
    role: "progressbar"
  }, g, {
    ref: n
  }, d, {
    children: [c === "buffer" ? /* @__PURE__ */ f.jsx(q$, {
      className: p.dashed,
      ownerState: u
    }) : null, /* @__PURE__ */ f.jsx(K$, {
      className: p.bar1,
      ownerState: u,
      style: m.bar1
    }), c === "determinate" ? null : /* @__PURE__ */ f.jsx(Y$, {
      className: p.bar2,
      ownerState: u,
      style: m.bar2
    })]
  }));
});
process.env.NODE_ENV !== "production" && (sw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["inherit", "primary", "secondary"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: l.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: l.number,
  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */
  variant: l.oneOf(["buffer", "determinate", "indeterminate", "query"])
});
function X$(e) {
  return _e("MuiLink", e);
}
const J$ = Re("MuiLink", ["root", "underlineNone", "underlineHover", "underlineAlways", "button", "focusVisible"]), aw = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, Q$ = (e) => aw[e] || e, eB = ({
  theme: e,
  ownerState: t
}) => {
  const n = Q$(t.color), o = Pl(e, `palette.${n}`, !1) || t.color, r = Pl(e, `palette.${n}Channel`);
  return "vars" in e && r ? `rgba(${r} / 0.4)` : gt(o, 0.4);
}, tB = ["className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant", "sx"], nB = (e) => {
  const {
    classes: t,
    component: n,
    focusVisible: o,
    underline: r
  } = e, i = {
    root: ["root", `underline${pe(r)}`, n === "button" && "button", o && "focusVisible"]
  };
  return Oe(i, X$, t);
}, oB = B(oe, {
  name: "MuiLink",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`underline${pe(n.underline)}`], n.component === "button" && t.button];
  }
})(({
  theme: e,
  ownerState: t
}) => T({}, t.underline === "none" && {
  textDecoration: "none"
}, t.underline === "hover" && {
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline"
  }
}, t.underline === "always" && T({
  textDecoration: "underline"
}, t.color !== "inherit" && {
  textDecorationColor: eB({
    theme: e,
    ownerState: t
  })
}, {
  "&:hover": {
    textDecorationColor: "inherit"
  }
}), t.component === "button" && {
  position: "relative",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${J$.focusVisible}`]: {
    outline: "auto"
  }
})), t7 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiLink"
  }), {
    className: r,
    color: i = "primary",
    component: s = "a",
    onBlur: a,
    onFocus: c,
    TypographyClasses: d,
    underline: u = "always",
    variant: p = "inherit",
    sx: h
  } = o, g = le(o, tB), {
    isFocusVisibleRef: m,
    onBlur: b,
    onFocus: C,
    ref: x
  } = S0(), [v, S] = y.useState(!1), M = Tt(n, x), w = (O) => {
    b(O), m.current === !1 && S(!1), a && a(O);
  }, k = (O) => {
    C(O), m.current === !0 && S(!0), c && c(O);
  }, E = T({}, o, {
    color: i,
    component: s,
    focusVisible: v,
    underline: u,
    variant: p
  }), R = nB(E);
  return /* @__PURE__ */ f.jsx(oB, T({
    color: i,
    className: xe(R.root, r),
    classes: d,
    component: s,
    onBlur: w,
    onFocus: k,
    ref: M,
    ownerState: E,
    variant: p,
    sx: [...Object.keys(aw).includes(i) ? [] : [{
      color: i
    }], ...Array.isArray(h) ? h : [h]]
  }, g));
});
process.env.NODE_ENV !== "production" && (t7.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the link.
   * @default 'primary'
   */
  color: l.any,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Pa,
  /**
   * @ignore
   */
  onBlur: l.func,
  /**
   * @ignore
   */
  onFocus: l.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * `classes` prop applied to the [`Typography`](/material-ui/api/typography/) element.
   */
  TypographyClasses: l.object,
  /**
   * Controls when the link should have an underline.
   * @default 'always'
   */
  underline: l.oneOf(["always", "hover", "none"]),
  /**
   * Applies the theme typography styles.
   * @default 'inherit'
   */
  variant: l.oneOfType([l.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), l.string])
});
const ti = /* @__PURE__ */ y.createContext({});
process.env.NODE_ENV !== "production" && (ti.displayName = "ListContext");
function rB(e) {
  return _e("MuiList", e);
}
Re("MuiList", ["root", "padding", "dense", "subheader"]);
const iB = ["children", "className", "component", "dense", "disablePadding", "subheader"], sB = (e) => {
  const {
    classes: t,
    disablePadding: n,
    dense: o,
    subheader: r
  } = e;
  return Oe({
    root: ["root", !n && "padding", o && "dense", r && "subheader"]
  }, rB, t);
}, aB = B("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disablePadding && t.padding, n.dense && t.dense, n.subheader && t.subheader];
  }
})(({
  ownerState: e
}) => T({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !e.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, e.subheader && {
  paddingTop: 0
})), n7 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiList"
  }), {
    children: r,
    className: i,
    component: s = "ul",
    dense: a = !1,
    disablePadding: c = !1,
    subheader: d
  } = o, u = le(o, iB), p = y.useMemo(() => ({
    dense: a
  }), [a]), h = T({}, o, {
    component: s,
    dense: a,
    disablePadding: c
  }), g = sB(h);
  return /* @__PURE__ */ f.jsx(ti.Provider, {
    value: p,
    children: /* @__PURE__ */ f.jsxs(aB, T({
      as: s,
      className: xe(g.root, i),
      ref: n,
      ownerState: h
    }, u, {
      children: [d, r]
    }))
  });
});
process.env.NODE_ENV !== "production" && (n7.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: l.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: l.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function lB(e) {
  return _e("MuiListItem", e);
}
const il = Re("MuiListItem", ["root", "container", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "padding", "button", "secondaryAction", "selected"]), cB = Re("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]);
function dB(e) {
  return _e("MuiListItemSecondaryAction", e);
}
Re("MuiListItemSecondaryAction", ["root", "disableGutters"]);
const uB = ["className"], fB = (e) => {
  const {
    disableGutters: t,
    classes: n
  } = e;
  return Oe({
    root: ["root", t && "disableGutters"]
  }, dB, n);
}, pB = B("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.disableGutters && t.disableGutters];
  }
})(({
  ownerState: e
}) => T({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)"
}, e.disableGutters && {
  right: 0
})), o7 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiListItemSecondaryAction"
  }), {
    className: r
  } = o, i = le(o, uB), s = y.useContext(ti), a = T({}, o, {
    disableGutters: s.disableGutters
  }), c = fB(a);
  return /* @__PURE__ */ f.jsx(pB, T({
    className: xe(c.root, r),
    ownerState: a,
    ref: n
  }, i));
});
process.env.NODE_ENV !== "production" && (o7.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
o7.muiName = "ListItemSecondaryAction";
const hB = ["className"], gB = ["alignItems", "autoFocus", "button", "children", "className", "component", "components", "componentsProps", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "disablePadding", "divider", "focusVisibleClassName", "secondaryAction", "selected", "slotProps", "slots"], mB = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.alignItems === "flex-start" && t.alignItemsFlexStart, n.divider && t.divider, !n.disableGutters && t.gutters, !n.disablePadding && t.padding, n.button && t.button, n.hasSecondaryAction && t.secondaryAction];
}, bB = (e) => {
  const {
    alignItems: t,
    button: n,
    classes: o,
    dense: r,
    disabled: i,
    disableGutters: s,
    disablePadding: a,
    divider: c,
    hasSecondaryAction: d,
    selected: u
  } = e;
  return Oe({
    root: ["root", r && "dense", !s && "gutters", !a && "padding", c && "divider", i && "disabled", n && "button", t === "flex-start" && "alignItemsFlexStart", d && "secondaryAction", u && "selected"],
    container: ["container"]
  }, lB, o);
}, CB = B("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: mB
})(({
  theme: e,
  ownerState: t
}) => T({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left"
}, !t.disablePadding && T({
  paddingTop: 8,
  paddingBottom: 8
}, t.dense && {
  paddingTop: 4,
  paddingBottom: 4
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, !!t.secondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}), !!t.secondaryAction && {
  [`& > .${cB.root}`]: {
    paddingRight: 48
  }
}, {
  [`&.${il.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${il.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : gt(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${il.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : gt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${il.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.alignItems === "flex-start" && {
  alignItems: "flex-start"
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, t.button && {
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${il.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : gt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : gt(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  }
}, t.hasSecondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
})), xB = B("li", {
  name: "MuiListItem",
  slot: "Container",
  overridesResolver: (e, t) => t.container
})({
  position: "relative"
}), lw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiListItem"
  }), {
    alignItems: r = "center",
    autoFocus: i = !1,
    button: s = !1,
    children: a,
    className: c,
    component: d,
    components: u = {},
    componentsProps: p = {},
    ContainerComponent: h = "li",
    ContainerProps: {
      className: g
    } = {},
    dense: m = !1,
    disabled: b = !1,
    disableGutters: C = !1,
    disablePadding: x = !1,
    divider: v = !1,
    focusVisibleClassName: S,
    secondaryAction: M,
    selected: w = !1,
    slotProps: k = {},
    slots: E = {}
  } = o, R = le(o.ContainerProps, hB), O = le(o, gB), P = y.useContext(ti), _ = y.useMemo(() => ({
    dense: m || P.dense || !1,
    alignItems: r,
    disableGutters: C
  }), [r, P.dense, m, C]), L = y.useRef(null);
  En(() => {
    i && (L.current ? L.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a ListItem whose component has not been rendered."));
  }, [i]);
  const V = y.Children.toArray(a), j = V.length && Cl(V[V.length - 1], ["ListItemSecondaryAction"]), I = T({}, o, {
    alignItems: r,
    autoFocus: i,
    button: s,
    dense: _.dense,
    disabled: b,
    disableGutters: C,
    disablePadding: x,
    divider: v,
    hasSecondaryAction: j,
    selected: w
  }), F = bB(I), $ = Tt(L, n), A = E.root || u.Root || CB, H = k.root || p.root || {}, N = T({
    className: xe(F.root, H.className, c),
    disabled: b
  }, O);
  let z = d || "li";
  return s && (N.component = d || "div", N.focusVisibleClassName = xe(il.focusVisible, S), z = wo), j ? (z = !N.component && !d ? "div" : z, h === "li" && (z === "li" ? z = "div" : N.component === "li" && (N.component = "div")), /* @__PURE__ */ f.jsx(ti.Provider, {
    value: _,
    children: /* @__PURE__ */ f.jsxs(xB, T({
      as: h,
      className: xe(F.container, g),
      ref: $,
      ownerState: I
    }, R, {
      children: [/* @__PURE__ */ f.jsx(A, T({}, H, !Qr(A) && {
        as: z,
        ownerState: T({}, I, H.ownerState)
      }, N, {
        children: V
      })), V.pop()]
    }))
  })) : /* @__PURE__ */ f.jsx(ti.Provider, {
    value: _,
    children: /* @__PURE__ */ f.jsxs(A, T({}, H, {
      as: z,
      ref: $
    }, !Qr(A) && {
      ownerState: T({}, I, H.ownerState)
    }, N, {
      children: [V, M && /* @__PURE__ */ f.jsx(o7, {
        children: M
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (lw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: l.oneOf(["center", "flex-start"]),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  autoFocus: l.bool,
  /**
   * If `true`, the list item is a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  button: l.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: vo(l.node, (e) => {
    const t = y.Children.toArray(e.children);
    let n = -1;
    for (let o = t.length - 1; o >= 0; o -= 1) {
      const r = t[o];
      if (Cl(r, ["ListItemSecondaryAction"])) {
        n = o;
        break;
      }
    }
    return n !== -1 && n !== t.length - 1 ? new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    root: l.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated
   */
  ContainerComponent: Pa,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated
   */
  ContainerProps: l.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: l.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  disabled: l.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: l.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: l.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: l.bool,
  /**
   * @ignore
   */
  focusVisibleClassName: l.string,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: l.node,
  /**
   * Use to apply selected styling.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  selected: l.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: l.shape({
    root: l.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function yB(e) {
  return _e("MuiListItemIcon", e);
}
const Ig = Re("MuiListItemIcon", ["root", "alignItemsFlexStart"]), vB = ["className"], wB = (e) => {
  const {
    alignItems: t,
    classes: n
  } = e;
  return Oe({
    root: ["root", t === "flex-start" && "alignItemsFlexStart"]
  }, yB, n);
}, SB = B("div", {
  name: "MuiListItemIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.alignItems === "flex-start" && t.alignItemsFlexStart];
  }
})(({
  theme: e,
  ownerState: t
}) => T({
  minWidth: 56,
  color: (e.vars || e).palette.action.active,
  flexShrink: 0,
  display: "inline-flex"
}, t.alignItems === "flex-start" && {
  marginTop: 8
})), r7 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiListItemIcon"
  }), {
    className: r
  } = o, i = le(o, vB), s = y.useContext(ti), a = T({}, o, {
    alignItems: s.alignItems
  }), c = wB(a);
  return /* @__PURE__ */ f.jsx(SB, T({
    className: xe(c.root, r),
    ownerState: a,
    ref: n
  }, i));
});
process.env.NODE_ENV !== "production" && (r7.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@mui/icons-material` SVG icon element.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function MB(e) {
  return _e("MuiListItemText", e);
}
const Kd = Re("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), TB = ["children", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"], kB = (e) => {
  const {
    classes: t,
    inset: n,
    primary: o,
    secondary: r,
    dense: i
  } = e;
  return Oe({
    root: ["root", n && "inset", i && "dense", o && r && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  }, MB, t);
}, EB = B("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${Kd.primary}`]: t.primary
    }, {
      [`& .${Kd.secondary}`]: t.secondary
    }, t.root, n.inset && t.inset, n.primary && n.secondary && t.multiline, n.dense && t.dense];
  }
})(({
  ownerState: e
}) => T({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4
}, e.primary && e.secondary && {
  marginTop: 6,
  marginBottom: 6
}, e.inset && {
  paddingLeft: 56
})), Bp = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiListItemText"
  }), {
    children: r,
    className: i,
    disableTypography: s = !1,
    inset: a = !1,
    primary: c,
    primaryTypographyProps: d,
    secondary: u,
    secondaryTypographyProps: p
  } = o, h = le(o, TB), {
    dense: g
  } = y.useContext(ti);
  let m = c ?? r, b = u;
  const C = T({}, o, {
    disableTypography: s,
    inset: a,
    primary: !!m,
    secondary: !!b,
    dense: g
  }), x = kB(C);
  return m != null && m.type !== oe && !s && (m = /* @__PURE__ */ f.jsx(oe, T({
    variant: g ? "body2" : "body1",
    className: x.primary,
    component: d != null && d.variant ? void 0 : "span",
    display: "block"
  }, d, {
    children: m
  }))), b != null && b.type !== oe && !s && (b = /* @__PURE__ */ f.jsx(oe, T({
    variant: "body2",
    className: x.secondary,
    color: "text.secondary",
    display: "block"
  }, p, {
    children: b
  }))), /* @__PURE__ */ f.jsxs(EB, T({
    className: xe(x.root, i),
    ownerState: C,
    ref: n
  }, h, {
    children: [m, b]
  }));
});
process.env.NODE_ENV !== "production" && (Bp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Alias for the `primary` prop.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */
  disableTypography: l.bool,
  /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */
  inset: l.bool,
  /**
   * The main content element.
   */
  primary: l.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: l.object,
  /**
   * The secondary content element.
   */
  secondary: l.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const RB = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function Wf(e, t, n) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild;
}
function jg(e, t, n) {
  return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild;
}
function cw(e, t) {
  if (t === void 0)
    return !0;
  let n = e.innerText;
  return n === void 0 && (n = e.textContent), n = n.trim().toLowerCase(), n.length === 0 ? !1 : t.repeating ? n[0] === t.keys[0] : n.indexOf(t.keys.join("")) === 0;
}
function k2(e, t, n, o, r, i) {
  let s = !1, a = r(e, t, t ? n : !1);
  for (; a; ) {
    if (a === e.firstChild) {
      if (s)
        return !1;
      s = !0;
    }
    const c = o ? !1 : a.disabled || a.getAttribute("aria-disabled") === "true";
    if (!a.hasAttribute("tabindex") || !cw(a, i) || c)
      a = r(e, a, n);
    else
      return a.focus(), !0;
  }
  return !1;
}
const P0 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: o,
    autoFocus: r = !1,
    autoFocusItem: i = !1,
    children: s,
    className: a,
    disabledItemsFocusable: c = !1,
    disableListWrap: d = !1,
    onKeyDown: u,
    variant: p = "selectedMenu"
  } = t, h = le(t, RB), g = y.useRef(null), m = y.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  En(() => {
    r && g.current.focus();
  }, [r]), y.useImperativeHandle(o, () => ({
    adjustStyleForScrollbar: (S, {
      direction: M
    }) => {
      const w = !g.current.style.width;
      if (S.clientHeight < g.current.clientHeight && w) {
        const k = `${fv(gn(S))}px`;
        g.current.style[M === "rtl" ? "paddingLeft" : "paddingRight"] = k, g.current.style.width = `calc(100% + ${k})`;
      }
      return g.current;
    }
  }), []);
  const b = (S) => {
    const M = g.current, w = S.key, k = gn(M).activeElement;
    if (w === "ArrowDown")
      S.preventDefault(), k2(M, k, d, c, Wf);
    else if (w === "ArrowUp")
      S.preventDefault(), k2(M, k, d, c, jg);
    else if (w === "Home")
      S.preventDefault(), k2(M, null, d, c, Wf);
    else if (w === "End")
      S.preventDefault(), k2(M, null, d, c, jg);
    else if (w.length === 1) {
      const E = m.current, R = w.toLowerCase(), O = performance.now();
      E.keys.length > 0 && (O - E.lastTime > 500 ? (E.keys = [], E.repeating = !0, E.previousKeyMatched = !0) : E.repeating && R !== E.keys[0] && (E.repeating = !1)), E.lastTime = O, E.keys.push(R);
      const P = k && !E.repeating && cw(k, E);
      E.previousKeyMatched && (P || k2(M, k, !1, c, Wf, E)) ? S.preventDefault() : E.previousKeyMatched = !1;
    }
    u && u(S);
  }, C = Tt(g, n);
  let x = -1;
  y.Children.forEach(s, (S, M) => {
    if (!/* @__PURE__ */ y.isValidElement(S)) {
      x === M && (x += 1, x >= s.length && (x = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && xa.isFragment(S) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), S.props.disabled || (p === "selectedMenu" && S.props.selected || x === -1) && (x = M), x === M && (S.props.disabled || S.props.muiSkipListHighlight || S.type.muiSkipListHighlight) && (x += 1, x >= s.length && (x = -1));
  });
  const v = y.Children.map(s, (S, M) => {
    if (M === x) {
      const w = {};
      return i && (w.autoFocus = !0), S.props.tabIndex === void 0 && p === "selectedMenu" && (w.tabIndex = 0), /* @__PURE__ */ y.cloneElement(S, w);
    }
    return S;
  });
  return /* @__PURE__ */ f.jsx(n7, T({
    role: "menu",
    ref: C,
    className: a,
    onKeyDown: b,
    tabIndex: r ? 0 : -1
  }, h, {
    children: v
  }));
});
process.env.NODE_ENV !== "production" && (P0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: l.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: l.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: l.node,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: l.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: l.bool,
  /**
   * @ignore
   */
  onKeyDown: l.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: l.oneOf(["menu", "selectedMenu"])
});
function OB(e) {
  return _e("MuiPopover", e);
}
Re("MuiPopover", ["root", "paper"]);
const _B = ["onEntering"], PB = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"], LB = ["slotProps"];
function Vg(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.height / 2 : t === "bottom" && (n = e.height), n;
}
function Dg(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.width / 2 : t === "right" && (n = e.width), n;
}
function Ag(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function md(e) {
  return typeof e == "function" ? e() : e;
}
const IB = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"],
    paper: ["paper"]
  }, OB, t);
}, jB = B(q4, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), dw = B(Tr, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Ar = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i;
  const s = Xe({
    props: t,
    name: "MuiPopover"
  }), {
    action: a,
    anchorEl: c,
    anchorOrigin: d = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: u,
    anchorReference: p = "anchorEl",
    children: h,
    className: g,
    container: m,
    elevation: b = 8,
    marginThreshold: C = 16,
    open: x,
    PaperProps: v = {},
    slots: S,
    slotProps: M,
    transformOrigin: w = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: k = gs,
    transitionDuration: E = "auto",
    TransitionProps: {
      onEntering: R
    } = {},
    disableScrollLock: O = !1
  } = s, P = le(s.TransitionProps, _B), _ = le(s, PB), L = (o = M == null ? void 0 : M.paper) != null ? o : v, V = y.useRef(), j = Tt(V, L.ref), I = T({}, s, {
    anchorOrigin: d,
    anchorReference: p,
    elevation: b,
    marginThreshold: C,
    externalPaperSlotProps: L,
    transformOrigin: w,
    TransitionComponent: k,
    transitionDuration: E,
    TransitionProps: P
  }), F = IB(I), $ = y.useCallback(() => {
    if (p === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (u || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), u;
    const X = md(c), de = X && X.nodeType === 1 ? X : gn(V.current).body, ue = de.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const he = de.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && he.top === 0 && he.left === 0 && he.right === 0 && he.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: ue.top + Vg(ue, d.vertical),
      left: ue.left + Dg(ue, d.horizontal)
    };
  }, [c, d.horizontal, d.vertical, u, p]), A = y.useCallback((X) => ({
    vertical: Vg(X, w.vertical),
    horizontal: Dg(X, w.horizontal)
  }), [w.horizontal, w.vertical]), H = y.useCallback((X) => {
    const de = {
      width: X.offsetWidth,
      height: X.offsetHeight
    }, ue = A(de);
    if (p === "none")
      return {
        top: null,
        left: null,
        transformOrigin: Ag(ue)
      };
    const he = $();
    let Ue = he.top - ue.vertical, me = he.left - ue.horizontal;
    const Ie = Ue + de.height, te = me + de.width, ie = ri(md(c)), ye = ie.innerHeight - C, Ne = ie.innerWidth - C;
    if (C !== null && Ue < C) {
      const We = Ue - C;
      Ue -= We, ue.vertical += We;
    } else if (C !== null && Ie > ye) {
      const We = Ie - ye;
      Ue -= We, ue.vertical += We;
    }
    if (process.env.NODE_ENV !== "production" && de.height > ye && de.height && ye && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${de.height - ye}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), C !== null && me < C) {
      const We = me - C;
      me -= We, ue.horizontal += We;
    } else if (te > Ne) {
      const We = te - Ne;
      me -= We, ue.horizontal += We;
    }
    return {
      top: `${Math.round(Ue)}px`,
      left: `${Math.round(me)}px`,
      transformOrigin: Ag(ue)
    };
  }, [c, p, $, A, C]), [N, z] = y.useState(x), se = y.useCallback(() => {
    const X = V.current;
    if (!X)
      return;
    const de = H(X);
    de.top !== null && (X.style.top = de.top), de.left !== null && (X.style.left = de.left), X.style.transformOrigin = de.transformOrigin, z(!0);
  }, [H]);
  y.useEffect(() => (O && window.addEventListener("scroll", se), () => window.removeEventListener("scroll", se)), [c, O, se]);
  const ne = (X, de) => {
    R && R(X, de), se();
  }, Z = () => {
    z(!1);
  };
  y.useEffect(() => {
    x && se();
  }), y.useImperativeHandle(a, () => x ? {
    updatePosition: () => {
      se();
    }
  } : null, [x, se]), y.useEffect(() => {
    if (!x)
      return;
    const X = n2(() => {
      se();
    }), de = ri(c);
    return de.addEventListener("resize", X), () => {
      X.clear(), de.removeEventListener("resize", X);
    };
  }, [c, x, se]);
  let q = E;
  E === "auto" && !k.muiSupportAuto && (q = void 0);
  const G = m || (c ? gn(md(c)).body : void 0), K = (r = S == null ? void 0 : S.root) != null ? r : jB, Q = (i = S == null ? void 0 : S.paper) != null ? i : dw, re = Ft({
    elementType: Q,
    externalSlotProps: T({}, L, {
      style: N ? L.style : T({}, L.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation: b,
      ref: j
    },
    ownerState: I,
    className: xe(F.paper, L == null ? void 0 : L.className)
  }), U = Ft({
    elementType: K,
    externalSlotProps: (M == null ? void 0 : M.root) || {},
    externalForwardedProps: _,
    additionalProps: {
      ref: n,
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: G,
      open: x
    },
    ownerState: I,
    className: xe(F.root, g)
  }), {
    slotProps: W
  } = U, D = le(U, LB);
  return /* @__PURE__ */ f.jsx(K, T({}, D, !Qr(K) && {
    slotProps: W,
    disableScrollLock: O
  }, {
    children: /* @__PURE__ */ f.jsx(k, T({
      appear: !0,
      in: x,
      onEntering: ne,
      onExited: Z,
      timeout: q
    }, P, {
      children: /* @__PURE__ */ f.jsx(Q, T({}, re, {
        children: h
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" && (Ar.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: sn,
  /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: vo(l.oneOfType([Ii, l.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = md(e.anchorEl);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: l.shape({
    horizontal: l.oneOfType([l.oneOf(["center", "left", "right"]), l.number]).isRequired,
    vertical: l.oneOfType([l.oneOf(["bottom", "center", "top"]), l.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: l.shape({
    left: l.number.isRequired,
    top: l.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: l.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: l.oneOfType([Ii, l.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: l.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: Gi,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: l.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: l.shape({
    component: Pa
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: l.shape({
    paper: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: l.shape({
    paper: l.elementType,
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: l.shape({
    horizontal: l.oneOfType([l.oneOf(["center", "left", "right"]), l.number]).isRequired,
    vertical: l.oneOfType([l.oneOf(["bottom", "center", "top"]), l.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: l.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: l.oneOfType([l.oneOf(["auto"]), l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: l.object
});
function VB(e) {
  return _e("MuiMenu", e);
}
Re("MuiMenu", ["root", "paper", "list"]);
const DB = ["onEntering"], AB = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"], HB = {
  vertical: "top",
  horizontal: "right"
}, FB = {
  vertical: "top",
  horizontal: "left"
}, NB = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, VB, t);
}, $B = B(Ar, {
  shouldForwardProp: (e) => bo(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), BB = B(dw, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), zB = B(P0, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), p2 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r;
  const i = Xe({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: s = !0,
    children: a,
    className: c,
    disableAutoFocusItem: d = !1,
    MenuListProps: u = {},
    onClose: p,
    open: h,
    PaperProps: g = {},
    PopoverClasses: m,
    transitionDuration: b = "auto",
    TransitionProps: {
      onEntering: C
    } = {},
    variant: x = "selectedMenu",
    slots: v = {},
    slotProps: S = {}
  } = i, M = le(i.TransitionProps, DB), w = le(i, AB), k = Ms(), E = T({}, i, {
    autoFocus: s,
    disableAutoFocusItem: d,
    MenuListProps: u,
    onEntering: C,
    PaperProps: g,
    transitionDuration: b,
    TransitionProps: M,
    variant: x
  }), R = NB(E), O = s && !d && h, P = y.useRef(null), _ = (A, H) => {
    P.current && P.current.adjustStyleForScrollbar(A, {
      direction: k ? "rtl" : "ltr"
    }), C && C(A, H);
  }, L = (A) => {
    A.key === "Tab" && (A.preventDefault(), p && p(A, "tabKeyDown"));
  };
  let V = -1;
  y.Children.map(a, (A, H) => {
    /* @__PURE__ */ y.isValidElement(A) && (process.env.NODE_ENV !== "production" && xa.isFragment(A) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), A.props.disabled || (x === "selectedMenu" && A.props.selected || V === -1) && (V = H));
  });
  const j = (o = v.paper) != null ? o : BB, I = (r = S.paper) != null ? r : g, F = Ft({
    elementType: v.root,
    externalSlotProps: S.root,
    ownerState: E,
    className: [R.root, c]
  }), $ = Ft({
    elementType: j,
    externalSlotProps: I,
    ownerState: E,
    className: R.paper
  });
  return /* @__PURE__ */ f.jsx($B, T({
    onClose: p,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: k ? "right" : "left"
    },
    transformOrigin: k ? HB : FB,
    slots: {
      paper: j,
      root: v.root
    },
    slotProps: {
      root: F,
      paper: $
    },
    open: h,
    ref: n,
    transitionDuration: b,
    TransitionProps: T({
      onEntering: _
    }, M),
    ownerState: E
  }, w, {
    classes: m,
    children: /* @__PURE__ */ f.jsx(zB, T({
      onKeyDown: L,
      actions: P,
      autoFocus: s && (V === -1 || d),
      autoFocusItem: O,
      variant: x
    }, u, {
      className: xe(R.list, u.className),
      children: a
    }))
  }));
});
process.env.NODE_ENV !== "production" && (p2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: l.oneOfType([Ii, l.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: l.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: l.bool,
  /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: l.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: l.object,
  /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */
  PopoverClasses: l.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: l.shape({
    paper: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: l.shape({
    paper: l.elementType,
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: l.oneOfType([l.oneOf(["auto"]), l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: l.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: l.oneOf(["menu", "selectedMenu"])
});
function ZB(e) {
  return _e("MuiMenuItem", e);
}
const E2 = Re("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), WB = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"], UB = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.divider && t.divider, !n.disableGutters && t.gutters];
}, GB = (e) => {
  const {
    disabled: t,
    dense: n,
    divider: o,
    disableGutters: r,
    selected: i,
    classes: s
  } = e, c = Oe({
    root: ["root", n && "dense", t && "disabled", !r && "gutters", o && "divider", i && "selected"]
  }, ZB, s);
  return T({}, s, c);
}, qB = B(wo, {
  shouldForwardProp: (e) => bo(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: UB
})(({
  theme: e,
  ownerState: t
}) => T({}, e.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${E2.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : gt(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${E2.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : gt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${E2.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : gt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : gt(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${E2.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${E2.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${wg.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${wg.inset}`]: {
    marginLeft: 52
  },
  [`& .${Kd.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${Kd.inset}`]: {
    paddingLeft: 36
  },
  [`& .${Ig.root}`]: {
    minWidth: 36
  }
}, !t.dense && {
  [e.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, t.dense && T({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, e.typography.body2, {
  [`& .${Ig.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), Jo = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: r = !1,
    component: i = "li",
    dense: s = !1,
    divider: a = !1,
    disableGutters: c = !1,
    focusVisibleClassName: d,
    role: u = "menuitem",
    tabIndex: p,
    className: h
  } = o, g = le(o, WB), m = y.useContext(ti), b = y.useMemo(() => ({
    dense: s || m.dense || !1,
    disableGutters: c
  }), [m.dense, s, c]), C = y.useRef(null);
  En(() => {
    r && (C.current ? C.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [r]);
  const x = T({}, o, {
    dense: b.dense,
    divider: a,
    disableGutters: c
  }), v = GB(o), S = Tt(C, n);
  let M;
  return o.disabled || (M = p !== void 0 ? p : -1), /* @__PURE__ */ f.jsx(ti.Provider, {
    value: b,
    children: /* @__PURE__ */ f.jsx(qB, T({
      ref: S,
      role: u,
      tabIndex: M,
      component: i,
      focusVisibleClassName: xe(v.focusVisible, d),
      className: xe(v.root, h)
    }, g, {
      ownerState: x,
      classes: v
    }))
  });
});
process.env.NODE_ENV !== "production" && (Jo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: l.bool,
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: l.bool,
  /**
   * @ignore
   */
  disabled: l.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: l.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: l.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: l.string,
  /**
   * @ignore
   */
  role: l.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * @default 0
   */
  tabIndex: l.number
});
function KB(e) {
  return _e("MuiNativeSelect", e);
}
const i7 = Re("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), YB = ["className", "disabled", "error", "IconComponent", "inputRef", "variant"], XB = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: o,
    multiple: r,
    open: i,
    error: s
  } = e, a = {
    select: ["select", n, o && "disabled", r && "multiple", s && "error"],
    icon: ["icon", `icon${pe(n)}`, i && "iconOpen", o && "disabled"]
  };
  return Oe(a, KB, t);
}, uw = ({
  ownerState: e,
  theme: t
}) => T({
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  borderRadius: 0,
  // Reset
  cursor: "pointer",
  "&:focus": T({}, t.vars ? {
    backgroundColor: `rgba(${t.vars.palette.common.onBackgroundChannel} / 0.05)`
  } : {
    backgroundColor: t.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
  }, {
    borderRadius: 0
    // Reset Chrome style
  }),
  // Remove IE11 arrow
  "&::-ms-expand": {
    display: "none"
  },
  [`&.${i7.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (t.vars || t).palette.background.paper
  },
  // Bump specificity to allow extending custom inputs
  "&&&": {
    paddingRight: 24,
    minWidth: 16
    // So it doesn't collapse.
  }
}, e.variant === "filled" && {
  "&&&": {
    paddingRight: 32
  }
}, e.variant === "outlined" && {
  borderRadius: (t.vars || t).shape.borderRadius,
  "&:focus": {
    borderRadius: (t.vars || t).shape.borderRadius
    // Reset the reset for Chrome style
  },
  "&&&": {
    paddingRight: 32
  }
}), JB = B("select", {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: bo,
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.select, t[n.variant], n.error && t.error, {
      [`&.${i7.multiple}`]: t.multiple
    }];
  }
})(uw), fw = ({
  ownerState: e,
  theme: t
}) => T({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  top: "calc(50% - .5em)",
  // Center vertically, height is 1em
  pointerEvents: "none",
  // Don't block pointer events on the select under the icon.
  color: (t.vars || t).palette.action.active,
  [`&.${i7.disabled}`]: {
    color: (t.vars || t).palette.action.disabled
  }
}, e.open && {
  transform: "rotate(180deg)"
}, e.variant === "filled" && {
  right: 7
}, e.variant === "outlined" && {
  right: 7
}), QB = B("svg", {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${pe(n.variant)}`], n.open && t.iconOpen];
  }
})(fw), pw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const {
    className: o,
    disabled: r,
    error: i,
    IconComponent: s,
    inputRef: a,
    variant: c = "standard"
  } = t, d = le(t, YB), u = T({}, t, {
    disabled: r,
    variant: c,
    error: i
  }), p = XB(u);
  return /* @__PURE__ */ f.jsxs(y.Fragment, {
    children: [/* @__PURE__ */ f.jsx(JB, T({
      ownerState: u,
      className: xe(p.select, o),
      disabled: r,
      ref: a || n
    }, d)), t.multiple ? null : /* @__PURE__ */ f.jsx(QB, {
      as: s,
      ownerState: u,
      className: p.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (pw.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * The CSS class name of the select element.
   */
  className: l.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: l.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: l.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: l.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: sn,
  /**
   * @ignore
   */
  multiple: l.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: l.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: l.func,
  /**
   * The input value.
   */
  value: l.any,
  /**
   * The variant to use.
   */
  variant: l.oneOf(["standard", "outlined", "filled"])
});
var Hg;
const ez = ["children", "classes", "className", "label", "notched"], tz = B("fieldset", {
  shouldForwardProp: bo
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), nz = B("legend", {
  shouldForwardProp: bo
})(({
  ownerState: e,
  theme: t
}) => T({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden"
}, !e.withLabel && {
  padding: 0,
  lineHeight: "11px",
  // sync with `height` in `legend` styles
  transition: t.transitions.create("width", {
    duration: 150,
    easing: t.transitions.easing.easeOut
  })
}, e.withLabel && T({
  display: "block",
  // Fix conflict with normalize.css and sanitize.css
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: "0.75em",
  visibility: "hidden",
  maxWidth: 0.01,
  transition: t.transitions.create("max-width", {
    duration: 50,
    easing: t.transitions.easing.easeOut
  }),
  whiteSpace: "nowrap",
  "& > span": {
    paddingLeft: 5,
    paddingRight: 5,
    display: "inline-block",
    opacity: 0,
    visibility: "visible"
  }
}, e.notched && {
  maxWidth: "100%",
  transition: t.transitions.create("max-width", {
    duration: 100,
    easing: t.transitions.easing.easeOut,
    delay: 50
  })
})));
function hw(e) {
  const {
    className: t,
    label: n,
    notched: o
  } = e, r = le(e, ez), i = n != null && n !== "", s = T({}, e, {
    notched: o,
    withLabel: i
  });
  return /* @__PURE__ */ f.jsx(tz, T({
    "aria-hidden": !0,
    className: t,
    ownerState: s
  }, r, {
    children: /* @__PURE__ */ f.jsx(nz, {
      ownerState: s,
      children: i ? /* @__PURE__ */ f.jsx("span", {
        children: n
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        Hg || (Hg = /* @__PURE__ */ f.jsx("span", {
          className: "notranslate",
          children: "​"
        }))
      )
    })
  }));
}
process.env.NODE_ENV !== "production" && (hw.propTypes = {
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The label.
   */
  label: l.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: l.bool.isRequired,
  /**
   * @ignore
   */
  style: l.object
});
const oz = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "slots", "type"], rz = (e) => {
  const {
    classes: t
  } = e, o = Oe({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, bH, t);
  return T({}, t, o);
}, iz = B(S3, {
  shouldForwardProp: (e) => bo(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: v3
})(({
  theme: e,
  ownerState: t
}) => {
  const n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return T({
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${$r.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${$r.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : n
      }
    },
    [`&.${$r.focused} .${$r.notchedOutline}`]: {
      borderColor: (e.vars || e).palette[t.color].main,
      borderWidth: 2
    },
    [`&.${$r.error} .${$r.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.error.main
    },
    [`&.${$r.disabled} .${$r.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.action.disabled
    }
  }, t.startAdornment && {
    paddingLeft: 14
  }, t.endAdornment && {
    paddingRight: 14
  }, t.multiline && T({
    padding: "16.5px 14px"
  }, t.size === "small" && {
    padding: "8.5px 14px"
  }));
}), sz = B(hw, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
}), az = B(M3, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: w3
})(({
  theme: e,
  ownerState: t
}) => T({
  padding: "16.5px 14px"
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, t.size === "small" && {
  padding: "8.5px 14px"
}, t.multiline && {
  padding: 0
}, t.startAdornment && {
  paddingLeft: 0
}, t.endAdornment && {
  paddingRight: 0
})), _3 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i, s, a;
  const c = Xe({
    props: t,
    name: "MuiOutlinedInput"
  }), {
    components: d = {},
    fullWidth: u = !1,
    inputComponent: p = "input",
    label: h,
    multiline: g = !1,
    notched: m,
    slots: b = {},
    type: C = "text"
  } = c, x = le(c, oz), v = rz(c), S = ui(), M = Es({
    props: c,
    muiFormControl: S,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), w = T({}, c, {
    color: M.color || "primary",
    disabled: M.disabled,
    error: M.error,
    focused: M.focused,
    formControl: S,
    fullWidth: u,
    hiddenLabel: M.hiddenLabel,
    multiline: g,
    size: M.size,
    type: C
  }), k = (o = (r = b.root) != null ? r : d.Root) != null ? o : iz, E = (i = (s = b.input) != null ? s : d.Input) != null ? i : az;
  return /* @__PURE__ */ f.jsx(a2, T({
    slots: {
      root: k,
      input: E
    },
    renderSuffix: (R) => /* @__PURE__ */ f.jsx(sz, {
      ownerState: w,
      className: v.notchedOutline,
      label: h != null && h !== "" && M.required ? a || (a = /* @__PURE__ */ f.jsxs(y.Fragment, {
        children: [h, " ", "*"]
      })) : h,
      notched: typeof m < "u" ? m : !!(R.startAdornment || R.filled || R.focused)
    }),
    fullWidth: u,
    inputComponent: p,
    multiline: g,
    ref: n,
    type: C
  }, x, {
    classes: T({}, v, {
      notchedOutline: null
    })
  }));
});
process.env.NODE_ENV !== "production" && (_3.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: l.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary"]), l.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Input: l.elementType,
    Root: l.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: l.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: l.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: l.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: l.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: l.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: l.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: l.oneOfType([l.number, l.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: l.oneOfType([l.number, l.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: l.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: l.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: l.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: l.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: l.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: l.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: l.oneOfType([l.number, l.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    input: l.elementType,
    root: l.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: l.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: l.any
});
_3.muiName = "Input";
function lz(e) {
  return _e("MuiPagination", e);
}
Re("MuiPagination", ["root", "ul", "outlined", "text"]);
const cz = ["boundaryCount", "componentName", "count", "defaultPage", "disabled", "hideNextButton", "hidePrevButton", "onChange", "page", "showFirstButton", "showLastButton", "siblingCount"];
function dz(e = {}) {
  const {
    boundaryCount: t = 1,
    componentName: n = "usePagination",
    count: o = 1,
    defaultPage: r = 1,
    disabled: i = !1,
    hideNextButton: s = !1,
    hidePrevButton: a = !1,
    onChange: c,
    page: d,
    showFirstButton: u = !1,
    showLastButton: p = !1,
    siblingCount: h = 1
  } = e, g = le(e, cz), [m, b] = Fn({
    controlled: d,
    default: r,
    name: n,
    state: "page"
  }), C = (O, P) => {
    d || b(P), c && c(O, P);
  }, x = (O, P) => {
    const _ = P - O + 1;
    return Array.from({
      length: _
    }, (L, V) => O + V);
  }, v = x(1, Math.min(t, o)), S = x(Math.max(o - t + 1, t + 1), o), M = Math.max(
    Math.min(
      // Natural start
      m - h,
      // Lower boundary when page is high
      o - t - h * 2 - 1
    ),
    // Greater than startPages
    t + 2
  ), w = Math.min(
    Math.max(
      // Natural end
      m + h,
      // Upper boundary when page is low
      t + h * 2 + 2
    ),
    // Less than endPages
    S.length > 0 ? S[0] - 2 : o - 1
  ), k = [
    ...u ? ["first"] : [],
    ...a ? [] : ["previous"],
    ...v,
    // Start ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...M > t + 2 ? ["start-ellipsis"] : t + 1 < o - t ? [t + 1] : [],
    // Sibling pages
    ...x(M, w),
    // End ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...w < o - t - 1 ? ["end-ellipsis"] : o - t > t ? [o - t] : [],
    ...S,
    ...s ? [] : ["next"],
    ...p ? ["last"] : []
  ], E = (O) => {
    switch (O) {
      case "first":
        return 1;
      case "previous":
        return m - 1;
      case "next":
        return m + 1;
      case "last":
        return o;
      default:
        return null;
    }
  }, R = k.map((O) => typeof O == "number" ? {
    onClick: (P) => {
      C(P, O);
    },
    type: "page",
    page: O,
    selected: O === m,
    disabled: i,
    "aria-current": O === m ? "true" : void 0
  } : {
    onClick: (P) => {
      C(P, E(O));
    },
    type: O,
    page: E(O),
    selected: !1,
    disabled: i || O.indexOf("ellipsis") === -1 && (O === "next" || O === "last" ? m >= o : m <= 1)
  });
  return T({
    items: R
  }, g);
}
function uz(e) {
  return _e("MuiPaginationItem", e);
}
const sr = Re("MuiPaginationItem", ["root", "page", "sizeSmall", "sizeLarge", "text", "textPrimary", "textSecondary", "outlined", "outlinedPrimary", "outlinedSecondary", "rounded", "ellipsis", "firstLast", "previousNext", "focusVisible", "disabled", "selected", "icon", "colorPrimary", "colorSecondary"]), Fg = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage"), Ng = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage"), $g = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore"), Bg = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext"), fz = ["className", "color", "component", "components", "disabled", "page", "selected", "shape", "size", "slots", "type", "variant"], gw = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, t[n.variant], t[`size${pe(n.size)}`], n.variant === "text" && t[`text${pe(n.color)}`], n.variant === "outlined" && t[`outlined${pe(n.color)}`], n.shape === "rounded" && t.rounded, n.type === "page" && t.page, (n.type === "start-ellipsis" || n.type === "end-ellipsis") && t.ellipsis, (n.type === "previous" || n.type === "next") && t.previousNext, (n.type === "first" || n.type === "last") && t.firstLast];
}, pz = (e) => {
  const {
    classes: t,
    color: n,
    disabled: o,
    selected: r,
    size: i,
    shape: s,
    type: a,
    variant: c
  } = e, d = {
    root: ["root", `size${pe(i)}`, c, s, n !== "standard" && `color${pe(n)}`, n !== "standard" && `${c}${pe(n)}`, o && "disabled", r && "selected", {
      page: "page",
      first: "firstLast",
      last: "firstLast",
      "start-ellipsis": "ellipsis",
      "end-ellipsis": "ellipsis",
      previous: "previousNext",
      next: "previousNext"
    }[a]],
    icon: ["icon"]
  };
  return Oe(d, uz, t);
}, hz = B("div", {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: gw
})(({
  theme: e,
  ownerState: t
}) => T({}, e.typography.body2, {
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (e.vars || e).palette.text.primary,
  height: "auto",
  [`&.${sr.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.size === "small" && {
  minWidth: 26,
  borderRadius: 26 / 2,
  margin: "0 1px",
  padding: "0 4px"
}, t.size === "large" && {
  minWidth: 40,
  borderRadius: 40 / 2,
  padding: "0 10px",
  fontSize: e.typography.pxToRem(15)
})), gz = B(wo, {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: gw
})(({
  theme: e,
  ownerState: t
}) => T({}, e.typography.body2, {
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  height: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (e.vars || e).palette.text.primary,
  [`&.${sr.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${sr.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  transition: e.transitions.create(["color", "background-color"], {
    duration: e.transitions.duration.short
  }),
  "&:hover": {
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${sr.selected}`]: {
    backgroundColor: (e.vars || e).palette.action.selected,
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : gt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette.action.selected
      }
    },
    [`&.${sr.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : gt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    },
    [`&.${sr.disabled}`]: {
      opacity: 1,
      color: (e.vars || e).palette.action.disabled,
      backgroundColor: (e.vars || e).palette.action.selected
    }
  }
}, t.size === "small" && {
  minWidth: 26,
  height: 26,
  borderRadius: 26 / 2,
  margin: "0 1px",
  padding: "0 4px"
}, t.size === "large" && {
  minWidth: 40,
  height: 40,
  borderRadius: 40 / 2,
  padding: "0 10px",
  fontSize: e.typography.pxToRem(15)
}, t.shape === "rounded" && {
  borderRadius: (e.vars || e).shape.borderRadius
}), ({
  theme: e,
  ownerState: t
}) => T({}, t.variant === "text" && {
  [`&.${sr.selected}`]: T({}, t.color !== "standard" && {
    color: (e.vars || e).palette[t.color].contrastText,
    backgroundColor: (e.vars || e).palette[t.color].main,
    "&:hover": {
      backgroundColor: (e.vars || e).palette[t.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette[t.color].main
      }
    },
    [`&.${sr.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette[t.color].dark
    }
  }, {
    [`&.${sr.disabled}`]: {
      color: (e.vars || e).palette.action.disabled
    }
  })
}, t.variant === "outlined" && {
  border: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
  [`&.${sr.selected}`]: T({}, t.color !== "standard" && {
    color: (e.vars || e).palette[t.color].main,
    border: `1px solid ${e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.5)` : gt(e.palette[t.color].main, 0.5)}`,
    backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.activatedOpacity})` : gt(e.palette[t.color].main, e.palette.action.activatedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / calc(${e.vars.palette.action.activatedOpacity} + ${e.vars.palette.action.focusOpacity}))` : gt(e.palette[t.color].main, e.palette.action.activatedOpacity + e.palette.action.focusOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    [`&.${sr.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / calc(${e.vars.palette.action.activatedOpacity} + ${e.vars.palette.action.focusOpacity}))` : gt(e.palette[t.color].main, e.palette.action.activatedOpacity + e.palette.action.focusOpacity)
    }
  }, {
    [`&.${sr.disabled}`]: {
      borderColor: (e.vars || e).palette.action.disabledBackground,
      color: (e.vars || e).palette.action.disabled
    }
  })
})), mz = B("div", {
  name: "MuiPaginationItem",
  slot: "Icon",
  overridesResolver: (e, t) => t.icon
})(({
  theme: e,
  ownerState: t
}) => T({
  fontSize: e.typography.pxToRem(20),
  margin: "0 -8px"
}, t.size === "small" && {
  fontSize: e.typography.pxToRem(18)
}, t.size === "large" && {
  fontSize: e.typography.pxToRem(22)
})), s7 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiPaginationItem"
  }), {
    className: r,
    color: i = "standard",
    component: s,
    components: a = {},
    disabled: c = !1,
    page: d,
    selected: u = !1,
    shape: p = "circular",
    size: h = "medium",
    slots: g = {},
    type: m = "page",
    variant: b = "text"
  } = o, C = le(o, fz), x = T({}, o, {
    color: i,
    disabled: c,
    selected: u,
    shape: p,
    size: h,
    type: m,
    variant: b
  }), v = Ms(), S = pz(x), w = (v ? {
    previous: g.next || a.next || Bg,
    next: g.previous || a.previous || $g,
    last: g.first || a.first || Fg,
    first: g.last || a.last || Ng
  } : {
    previous: g.previous || a.previous || $g,
    next: g.next || a.next || Bg,
    first: g.first || a.first || Fg,
    last: g.last || a.last || Ng
  })[m];
  return m === "start-ellipsis" || m === "end-ellipsis" ? /* @__PURE__ */ f.jsx(hz, {
    ref: n,
    ownerState: x,
    className: xe(S.root, r),
    children: "…"
  }) : /* @__PURE__ */ f.jsxs(gz, T({
    ref: n,
    ownerState: x,
    component: s,
    disabled: c,
    className: xe(S.root, r)
  }, C, {
    children: [m === "page" && d, w ? /* @__PURE__ */ f.jsx(mz, {
      as: w,
      ownerState: x,
      className: S.icon
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (s7.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary", "standard"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    first: l.elementType,
    last: l.elementType,
    next: l.elementType,
    previous: l.elementType
  }),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * The current page number.
   */
  page: l.node,
  /**
   * If `true` the pagination item is selected.
   * @default false
   */
  selected: l.bool,
  /**
   * The shape of the pagination item.
   * @default 'circular'
   */
  shape: l.oneOf(["circular", "rounded"]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["small", "medium", "large"]), l.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    first: l.elementType,
    last: l.elementType,
    next: l.elementType,
    previous: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The type of pagination item.
   * @default 'page'
   */
  type: l.oneOf(["end-ellipsis", "first", "last", "next", "page", "previous", "start-ellipsis"]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: l.oneOfType([l.oneOf(["outlined", "text"]), l.string])
});
const bz = ["boundaryCount", "className", "color", "count", "defaultPage", "disabled", "getItemAriaLabel", "hideNextButton", "hidePrevButton", "onChange", "page", "renderItem", "shape", "showFirstButton", "showLastButton", "siblingCount", "size", "variant"], Cz = (e) => {
  const {
    classes: t,
    variant: n
  } = e;
  return Oe({
    root: ["root", n],
    ul: ["ul"]
  }, lz, t);
}, xz = B("nav", {
  name: "MuiPagination",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant]];
  }
})({}), yz = B("ul", {
  name: "MuiPagination",
  slot: "Ul",
  overridesResolver: (e, t) => t.ul
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
});
function vz(e, t, n) {
  return e === "page" ? `${n ? "" : "Go to "}page ${t}` : `Go to ${e} page`;
}
const mw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiPagination"
  }), {
    boundaryCount: r = 1,
    className: i,
    color: s = "standard",
    count: a = 1,
    defaultPage: c = 1,
    disabled: d = !1,
    getItemAriaLabel: u = vz,
    hideNextButton: p = !1,
    hidePrevButton: h = !1,
    renderItem: g = (R) => /* @__PURE__ */ f.jsx(s7, T({}, R)),
    shape: m = "circular",
    showFirstButton: b = !1,
    showLastButton: C = !1,
    siblingCount: x = 1,
    size: v = "medium",
    variant: S = "text"
  } = o, M = le(o, bz), {
    items: w
  } = dz(T({}, o, {
    componentName: "Pagination"
  })), k = T({}, o, {
    boundaryCount: r,
    color: s,
    count: a,
    defaultPage: c,
    disabled: d,
    getItemAriaLabel: u,
    hideNextButton: p,
    hidePrevButton: h,
    renderItem: g,
    shape: m,
    showFirstButton: b,
    showLastButton: C,
    siblingCount: x,
    size: v,
    variant: S
  }), E = Cz(k);
  return /* @__PURE__ */ f.jsx(xz, T({
    "aria-label": "pagination navigation",
    className: xe(E.root, i),
    ownerState: k,
    ref: n
  }, M, {
    children: /* @__PURE__ */ f.jsx(yz, {
      className: E.ul,
      ownerState: k,
      children: w.map((R, O) => /* @__PURE__ */ f.jsx("li", {
        children: g(T({}, R, {
          color: s,
          "aria-label": u(R.type, R.page, R.selected),
          shape: m,
          size: v,
          variant: S
        }))
      }, O))
    })
  }));
});
process.env.NODE_ENV !== "production" && (mw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Number of always visible pages at the beginning and end.
   * @default 1
   */
  boundaryCount: Gi,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary", "standard"]), l.string]),
  /**
   * The total number of pages.
   * @default 1
   */
  count: Gi,
  /**
   * The page selected by default when the component is uncontrolled.
   * @default 1
   */
  defaultPage: Gi,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous' | 'start-ellipsis' | 'end-ellipsis'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @param {bool} selected If true, the current page is selected.
   * @returns {string}
   */
  getItemAriaLabel: l.func,
  /**
   * If `true`, hide the next-page button.
   * @default false
   */
  hideNextButton: l.bool,
  /**
   * If `true`, hide the previous-page button.
   * @default false
   */
  hidePrevButton: l.bool,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.ChangeEvent<unknown>} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChange: l.func,
  /**
   * The current page. Unlike `TablePagination`, which starts numbering from `0`, this pagination starts from `1`.
   */
  page: Gi,
  /**
   * Render the item.
   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   * @default (item) => <PaginationItem {...item} />
   */
  renderItem: l.func,
  /**
   * The shape of the pagination items.
   * @default 'circular'
   */
  shape: l.oneOf(["circular", "rounded"]),
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: l.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: l.bool,
  /**
   * Number of always visible pages before and after the current page.
   * @default 1
   */
  siblingCount: Gi,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["small", "medium", "large"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: l.oneOfType([l.oneOf(["outlined", "text"]), l.string])
});
const wz = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked"), Sz = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked"), Mz = B("span", {
  shouldForwardProp: bo
})({
  position: "relative",
  display: "flex"
}), Tz = B(wz)({
  // Scale applied to prevent dot misalignment in Safari
  transform: "scale(1)"
}), kz = B(Sz)(({
  theme: e,
  ownerState: t
}) => T({
  left: 0,
  position: "absolute",
  transform: "scale(0)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeIn,
    duration: e.transitions.duration.shortest
  })
}, t.checked && {
  transform: "scale(1)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeOut,
    duration: e.transitions.duration.shortest
  })
}));
function a7(e) {
  const {
    checked: t = !1,
    classes: n = {},
    fontSize: o
  } = e, r = T({}, e, {
    checked: t
  });
  return /* @__PURE__ */ f.jsxs(Mz, {
    className: n.root,
    ownerState: r,
    children: [/* @__PURE__ */ f.jsx(Tz, {
      fontSize: o,
      className: n.background,
      ownerState: r
    }), /* @__PURE__ */ f.jsx(kz, {
      fontSize: o,
      className: n.dot,
      ownerState: r
    })]
  });
}
process.env.NODE_ENV !== "production" && (a7.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: l.oneOf(["small", "medium"])
});
const bw = /* @__PURE__ */ y.createContext(void 0);
process.env.NODE_ENV !== "production" && (bw.displayName = "RadioGroupContext");
function Ez() {
  return y.useContext(bw);
}
function Rz(e) {
  return _e("MuiRadio", e);
}
const zg = Re("MuiRadio", ["root", "checked", "disabled", "colorPrimary", "colorSecondary", "sizeSmall"]), Oz = ["checked", "checkedIcon", "color", "icon", "name", "onChange", "size", "className"], _z = (e) => {
  const {
    classes: t,
    color: n,
    size: o
  } = e, r = {
    root: ["root", `color${pe(n)}`, o !== "medium" && `size${pe(o)}`]
  };
  return T({}, t, Oe(r, Rz, t));
}, Pz = B(G4, {
  shouldForwardProp: (e) => bo(e) || e === "classes",
  name: "MuiRadio",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size !== "medium" && t[`size${pe(n.size)}`], t[`color${pe(n.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => T({
  color: (e.vars || e).palette.text.secondary
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${t.color === "default" ? e.vars.palette.action.activeChannel : e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : gt(t.color === "default" ? e.palette.action.active : e.palette[t.color].main, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.color !== "default" && {
  [`&.${zg.checked}`]: {
    color: (e.vars || e).palette[t.color].main
  }
}, {
  [`&.${zg.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  }
}));
function Lz(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
const Zg = /* @__PURE__ */ f.jsx(a7, {
  checked: !0
}), Wg = /* @__PURE__ */ f.jsx(a7, {}), P3 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r;
  const i = Xe({
    props: t,
    name: "MuiRadio"
  }), {
    checked: s,
    checkedIcon: a = Zg,
    color: c = "primary",
    icon: d = Wg,
    name: u,
    onChange: p,
    size: h = "medium",
    className: g
  } = i, m = le(i, Oz), b = T({}, i, {
    color: c,
    size: h
  }), C = _z(b), x = Ez();
  let v = s;
  const S = Nd(p, x && x.onChange);
  let M = u;
  return x && (typeof v > "u" && (v = Lz(x.value, i.value)), typeof M > "u" && (M = x.name)), /* @__PURE__ */ f.jsx(Pz, T({
    type: "radio",
    icon: /* @__PURE__ */ y.cloneElement(d, {
      fontSize: (o = Wg.props.fontSize) != null ? o : h
    }),
    checkedIcon: /* @__PURE__ */ y.cloneElement(a, {
      fontSize: (r = Zg.props.fontSize) != null ? r : h
    }),
    ownerState: b,
    classes: C,
    name: M,
    checked: v,
    onChange: S,
    ref: n,
    className: xe(C.root, g)
  }, m));
});
process.env.NODE_ENV !== "production" && (P3.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: l.bool,
  /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */
  checkedIcon: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * If `true`, the component is disabled.
   */
  disabled: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */
  icon: l.node,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: l.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: l.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: l.any
});
function Iz(e) {
  return _e("MuiSelect", e);
}
const R2 = Re("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var Ug;
const jz = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "error", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"], Vz = B("div", {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${R2.select}`]: t.select
      },
      {
        [`&.${R2.select}`]: t[n.variant]
      },
      {
        [`&.${R2.error}`]: t.error
      },
      {
        [`&.${R2.multiple}`]: t.multiple
      }
    ];
  }
})(uw, {
  // Win specificity over the input base
  [`&.${R2.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), Dz = B("svg", {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${pe(n.variant)}`], n.open && t.iconOpen];
  }
})(fw), Az = B("input", {
  shouldForwardProp: (e) => b3(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, t) => t.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function Gg(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function Hz(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const Fz = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: o,
    multiple: r,
    open: i,
    error: s
  } = e, a = {
    select: ["select", n, o && "disabled", r && "multiple", s && "error"],
    icon: ["icon", `icon${pe(n)}`, i && "iconOpen", o && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return Oe(a, Iz, t);
}, Cw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o;
  const {
    "aria-describedby": r,
    "aria-label": i,
    autoFocus: s,
    autoWidth: a,
    children: c,
    className: d,
    defaultOpen: u,
    defaultValue: p,
    disabled: h,
    displayEmpty: g,
    error: m = !1,
    IconComponent: b,
    inputRef: C,
    labelId: x,
    MenuProps: v = {},
    multiple: S,
    name: M,
    onBlur: w,
    onChange: k,
    onClose: E,
    onFocus: R,
    onOpen: O,
    open: P,
    readOnly: _,
    renderValue: L,
    SelectDisplayProps: V = {},
    tabIndex: j,
    value: I,
    variant: F = "standard"
  } = t, $ = le(t, jz), [A, H] = Fn({
    controlled: I,
    default: p,
    name: "Select"
  }), [N, z] = Fn({
    controlled: P,
    default: u,
    name: "Select"
  }), se = y.useRef(null), ne = y.useRef(null), [Z, q] = y.useState(null), {
    current: G
  } = y.useRef(P != null), [K, Q] = y.useState(), re = Tt(n, C), U = y.useCallback((Ve) => {
    ne.current = Ve, Ve && q(Ve);
  }, []), W = Z == null ? void 0 : Z.parentNode;
  y.useImperativeHandle(re, () => ({
    focus: () => {
      ne.current.focus();
    },
    node: se.current,
    value: A
  }), [A]), y.useEffect(() => {
    u && N && Z && !G && (Q(a ? null : W.clientWidth), ne.current.focus());
  }, [Z, a]), y.useEffect(() => {
    s && ne.current.focus();
  }, [s]), y.useEffect(() => {
    if (!x)
      return;
    const Ve = gn(ne.current).getElementById(x);
    if (Ve) {
      const Ce = () => {
        getSelection().isCollapsed && ne.current.focus();
      };
      return Ve.addEventListener("click", Ce), () => {
        Ve.removeEventListener("click", Ce);
      };
    }
  }, [x]);
  const D = (Ve, Ce) => {
    Ve ? O && O(Ce) : E && E(Ce), G || (Q(a ? null : W.clientWidth), z(Ve));
  }, X = (Ve) => {
    Ve.button === 0 && (Ve.preventDefault(), ne.current.focus(), D(!0, Ve));
  }, de = (Ve) => {
    D(!1, Ve);
  }, ue = y.Children.toArray(c), he = (Ve) => {
    const Ce = ue.find((Se) => Se.props.value === Ve.target.value);
    Ce !== void 0 && (H(Ce.props.value), k && k(Ve, Ce));
  }, Ue = (Ve) => (Ce) => {
    let Se;
    if (Ce.currentTarget.hasAttribute("tabindex")) {
      if (S) {
        Se = Array.isArray(A) ? A.slice() : [];
        const ve = A.indexOf(Ve.props.value);
        ve === -1 ? Se.push(Ve.props.value) : Se.splice(ve, 1);
      } else
        Se = Ve.props.value;
      if (Ve.props.onClick && Ve.props.onClick(Ce), A !== Se && (H(Se), k)) {
        const ve = Ce.nativeEvent || Ce, Be = new ve.constructor(ve.type, ve);
        Object.defineProperty(Be, "target", {
          writable: !0,
          value: {
            value: Se,
            name: M
          }
        }), k(Be, Ve);
      }
      S || D(!1, Ce);
    }
  }, me = (Ve) => {
    _ || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].indexOf(Ve.key) !== -1 && (Ve.preventDefault(), D(!0, Ve));
  }, Ie = Z !== null && N, te = (Ve) => {
    !Ie && w && (Object.defineProperty(Ve, "target", {
      writable: !0,
      value: {
        value: A,
        name: M
      }
    }), w(Ve));
  };
  delete $["aria-invalid"];
  let ie, ye;
  const Ne = [];
  let We = !1, qe = !1;
  (qd({
    value: A
  }) || g) && (L ? ie = L(A) : We = !0);
  const Me = ue.map((Ve) => {
    if (!/* @__PURE__ */ y.isValidElement(Ve))
      return null;
    process.env.NODE_ENV !== "production" && xa.isFragment(Ve) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let Ce;
    if (S) {
      if (!Array.isArray(A))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : Pi(2));
      Ce = A.some((Se) => Gg(Se, Ve.props.value)), Ce && We && Ne.push(Ve.props.children);
    } else
      Ce = Gg(A, Ve.props.value), Ce && We && (ye = Ve.props.children);
    return Ce && (qe = !0), /* @__PURE__ */ y.cloneElement(Ve, {
      "aria-selected": Ce ? "true" : "false",
      onClick: Ue(Ve),
      onKeyUp: (Se) => {
        Se.key === " " && Se.preventDefault(), Ve.props.onKeyUp && Ve.props.onKeyUp(Se);
      },
      role: "option",
      selected: Ce,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": Ve.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && y.useEffect(() => {
    if (!qe && !S && A !== "") {
      const Ve = ue.map((Ce) => Ce.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${A}\` for the select ${M ? `(name="${M}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${Ve.filter((Ce) => Ce != null).map((Ce) => `\`${Ce}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [qe, ue, S, M, A]), We && (S ? Ne.length === 0 ? ie = null : ie = Ne.reduce((Ve, Ce, Se) => (Ve.push(Ce), Se < Ne.length - 1 && Ve.push(", "), Ve), []) : ie = ye);
  let Pe = K;
  !a && G && Z && (Pe = W.clientWidth);
  let fe;
  typeof j < "u" ? fe = j : fe = h ? null : 0;
  const ae = V.id || (M ? `mui-component-select-${M}` : void 0), Te = T({}, t, {
    variant: F,
    value: A,
    open: Ie,
    error: m
  }), tt = Fz(Te), Ye = T({}, v.PaperProps, (o = v.slotProps) == null ? void 0 : o.paper), Le = di();
  return /* @__PURE__ */ f.jsxs(y.Fragment, {
    children: [/* @__PURE__ */ f.jsx(Vz, T({
      ref: U,
      tabIndex: fe,
      role: "combobox",
      "aria-controls": Le,
      "aria-disabled": h ? "true" : void 0,
      "aria-expanded": Ie ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": i,
      "aria-labelledby": [x, ae].filter(Boolean).join(" ") || void 0,
      "aria-describedby": r,
      onKeyDown: me,
      onMouseDown: h || _ ? null : X,
      onBlur: te,
      onFocus: R
    }, V, {
      ownerState: Te,
      className: xe(V.className, tt.select, d),
      id: ae,
      children: Hz(ie) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        Ug || (Ug = /* @__PURE__ */ f.jsx("span", {
          className: "notranslate",
          children: "​"
        }))
      ) : ie
    })), /* @__PURE__ */ f.jsx(Az, T({
      "aria-invalid": m,
      value: Array.isArray(A) ? A.join(",") : A,
      name: M,
      ref: se,
      "aria-hidden": !0,
      onChange: he,
      tabIndex: -1,
      disabled: h,
      className: tt.nativeInput,
      autoFocus: s,
      ownerState: Te
    }, $)), /* @__PURE__ */ f.jsx(Dz, {
      as: b,
      className: tt.icon,
      ownerState: Te
    }), /* @__PURE__ */ f.jsx(p2, T({
      id: `menu-${M || ""}`,
      anchorEl: W,
      open: Ie,
      onClose: de,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    }, v, {
      MenuListProps: T({
        "aria-labelledby": x,
        role: "listbox",
        "aria-multiselectable": S ? "true" : void 0,
        disableListWrap: !0,
        id: Le
      }, v.MenuListProps),
      slotProps: T({}, v.slotProps, {
        paper: T({}, Ye, {
          style: T({
            minWidth: Pe
          }, Ye != null ? Ye.style : null)
        })
      }),
      children: Me
    }))]
  });
});
process.env.NODE_ENV !== "production" && (Cw.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": l.string,
  /**
   * @ignore
   */
  "aria-label": l.string,
  /**
   * @ignore
   */
  autoFocus: l.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: l.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * The CSS class name of the select element.
   */
  className: l.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: l.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: l.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: l.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: l.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: l.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: sn,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: l.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: l.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: l.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: l.string,
  /**
   * @ignore
   */
  onBlur: l.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: l.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: l.func,
  /**
   * @ignore
   */
  onFocus: l.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool,
  /**
   * @ignore
   */
  readOnly: l.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: l.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: l.object,
  /**
   * @ignore
   */
  tabIndex: l.oneOfType([l.number, l.string]),
  /**
   * @ignore
   */
  type: l.any,
  /**
   * The input value.
   */
  value: l.any,
  /**
   * The variant to use.
   */
  variant: l.oneOf(["standard", "outlined", "filled"])
});
const Nz = ["autoWidth", "children", "classes", "className", "defaultOpen", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"], $z = ["root"], Bz = (e) => {
  const {
    classes: t
  } = e;
  return t;
}, l7 = {
  name: "MuiSelect",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => bo(e) && e !== "variant",
  slot: "Root"
}, zz = B(O3, l7)(""), Zz = B(_3, l7)(""), Wz = B(E3, l7)(""), L0 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    name: "MuiSelect",
    props: t
  }), {
    autoWidth: r = !1,
    children: i,
    classes: s = {},
    className: a,
    defaultOpen: c = !1,
    displayEmpty: d = !1,
    IconComponent: u = Qv,
    id: p,
    input: h,
    inputProps: g,
    label: m,
    labelId: b,
    MenuProps: C,
    multiple: x = !1,
    native: v = !1,
    onClose: S,
    onOpen: M,
    open: w,
    renderValue: k,
    SelectDisplayProps: E,
    variant: R = "outlined"
  } = o, O = le(o, Nz), P = v ? pw : Cw, _ = ui(), L = Es({
    props: o,
    muiFormControl: _,
    states: ["variant", "error"]
  }), V = L.variant || R, j = T({}, o, {
    variant: V,
    classes: s
  }), I = Bz(j), F = le(I, $z), $ = h || {
    standard: /* @__PURE__ */ f.jsx(zz, {
      ownerState: j
    }),
    outlined: /* @__PURE__ */ f.jsx(Zz, {
      label: m,
      ownerState: j
    }),
    filled: /* @__PURE__ */ f.jsx(Wz, {
      ownerState: j
    })
  }[V], A = Tt(n, o2($));
  return /* @__PURE__ */ f.jsx(y.Fragment, {
    children: /* @__PURE__ */ y.cloneElement($, T({
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: P,
      inputProps: T({
        children: i,
        error: L.error,
        IconComponent: u,
        variant: V,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: x
      }, v ? {
        id: p
      } : {
        autoWidth: r,
        defaultOpen: c,
        displayEmpty: d,
        labelId: b,
        MenuProps: C,
        onClose: S,
        onOpen: M,
        open: w,
        renderValue: k,
        SelectDisplayProps: T({
          id: p
        }, E)
      }, g, {
        classes: g ? yo(F, g.classes) : F
      }, h ? h.props.inputProps : {})
    }, (x && v || d) && V === "outlined" ? {
      notched: !0
    } : {}, {
      ref: A,
      className: xe($.props.className, a, I.root)
    }, !h && {
      variant: V
    }, O))
  });
});
process.env.NODE_ENV !== "production" && (L0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: l.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: l.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: l.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: l.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: l.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: l.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: l.object,
  /**
   * See [OutlinedInput#label](/material-ui/api/outlined-input/#props)
   */
  label: l.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: l.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: l.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: l.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: l.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: l.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: l.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: l.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: l.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: l.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: l.oneOfType([l.oneOf([""]), l.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: l.oneOf(["filled", "outlined", "standard"])
});
L0.muiName = "Select";
function Uz(e) {
  return _e("MuiSkeleton", e);
}
Re("MuiSkeleton", ["root", "text", "rectangular", "rounded", "circular", "pulse", "wave", "withChildren", "fitContent", "heightAuto"]);
const Gz = ["animation", "className", "component", "height", "style", "variant", "width"];
let Yd = (e) => e, qg, Kg, Yg, Xg;
const qz = (e) => {
  const {
    classes: t,
    variant: n,
    animation: o,
    hasChildren: r,
    width: i,
    height: s
  } = e;
  return Oe({
    root: ["root", n, o, r && "withChildren", r && !i && "fitContent", r && !s && "heightAuto"]
  }, Uz, t);
}, Kz = Dr(qg || (qg = Yd`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`)), Yz = Dr(Kg || (Kg = Yd`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`)), Xz = B("span", {
  name: "MuiSkeleton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], n.animation !== !1 && t[n.animation], n.hasChildren && t.withChildren, n.hasChildren && !n.width && t.fitContent, n.hasChildren && !n.height && t.heightAuto];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  const n = kj(e.shape.borderRadius) || "px", o = Ej(e.shape.borderRadius);
  return T({
    display: "block",
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: e.vars ? e.vars.palette.Skeleton.bg : $t(e.palette.text.primary, e.palette.mode === "light" ? 0.11 : 0.13),
    height: "1.2em"
  }, t.variant === "text" && {
    marginTop: 0,
    marginBottom: 0,
    height: "auto",
    transformOrigin: "0 55%",
    transform: "scale(1, 0.60)",
    borderRadius: `${o}${n}/${Math.round(o / 0.6 * 10) / 10}${n}`,
    "&:empty:before": {
      content: '"\\00a0"'
    }
  }, t.variant === "circular" && {
    borderRadius: "50%"
  }, t.variant === "rounded" && {
    borderRadius: (e.vars || e).shape.borderRadius
  }, t.hasChildren && {
    "& > *": {
      visibility: "hidden"
    }
  }, t.hasChildren && !t.width && {
    maxWidth: "fit-content"
  }, t.hasChildren && !t.height && {
    height: "auto"
  });
}, ({
  ownerState: e
}) => e.animation === "pulse" && Li(Yg || (Yg = Yd`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), Kz), ({
  ownerState: e,
  theme: t
}) => e.animation === "wave" && Li(Xg || (Xg = Yd`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), Yz, (t.vars || t).palette.action.hover)), xw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiSkeleton"
  }), {
    animation: r = "pulse",
    className: i,
    component: s = "span",
    height: a,
    style: c,
    variant: d = "text",
    width: u
  } = o, p = le(o, Gz), h = T({}, o, {
    animation: r,
    component: s,
    variant: d,
    hasChildren: !!p.children
  }), g = qz(h);
  return /* @__PURE__ */ f.jsx(Xz, T({
    as: s,
    ref: n,
    className: xe(g.root, i),
    ownerState: h
  }, p, {
    style: T({
      width: u,
      height: a
    }, c)
  }));
});
process.env.NODE_ENV !== "production" && (xw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The animation.
   * If `false` the animation effect is disabled.
   * @default 'pulse'
   */
  animation: l.oneOf(["pulse", "wave", !1]),
  /**
   * Optional children to infer width and height from.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */
  height: l.oneOfType([l.number, l.string]),
  /**
   * @ignore
   */
  style: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The type of content that will be rendered.
   * @default 'text'
   */
  variant: l.oneOfType([l.oneOf(["circular", "rectangular", "rounded", "text"]), l.string]),
  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: l.oneOfType([l.number, l.string])
});
function Jz(e, t, n = (o, r) => o === r) {
  return e.length === t.length && e.every((o, r) => n(o, t[r]));
}
const Qz = 2;
function yw(e, t) {
  return e - t;
}
function Jg(e, t) {
  var n;
  const {
    index: o
  } = (n = e.reduce((r, i, s) => {
    const a = Math.abs(t - i);
    return r === null || a < r.distance || a === r.distance ? {
      distance: a,
      index: s
    } : r;
  }, null)) != null ? n : {};
  return o;
}
function l1(e, t) {
  if (t.current !== void 0 && e.changedTouches) {
    const n = e;
    for (let o = 0; o < n.changedTouches.length; o += 1) {
      const r = n.changedTouches[o];
      if (r.identifier === t.current)
        return {
          x: r.clientX,
          y: r.clientY
        };
    }
    return !1;
  }
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function Xd(e, t, n) {
  return (e - t) * 100 / (n - t);
}
function eZ(e, t, n) {
  return (n - t) * e + t;
}
function tZ(e) {
  if (Math.abs(e) < 1) {
    const n = e.toExponential().split("e-"), o = n[0].split(".")[1];
    return (o ? o.length : 0) + parseInt(n[1], 10);
  }
  const t = e.toString().split(".")[1];
  return t ? t.length : 0;
}
function nZ(e, t, n) {
  const o = Math.round((e - n) / t) * t + n;
  return Number(o.toFixed(tZ(t)));
}
function Qg({
  values: e,
  newValue: t,
  index: n
}) {
  const o = e.slice();
  return o[n] = t, o.sort(yw);
}
function c1({
  sliderRef: e,
  activeIndex: t,
  setActive: n
}) {
  var o, r;
  const i = gn(e.current);
  if (!((o = e.current) != null && o.contains(i.activeElement)) || Number(i == null || (r = i.activeElement) == null ? void 0 : r.getAttribute("data-index")) !== t) {
    var s;
    (s = e.current) == null || s.querySelector(`[type="range"][data-index="${t}"]`).focus();
  }
  n && n(t);
}
function d1(e, t) {
  return typeof e == "number" && typeof t == "number" ? e === t : typeof e == "object" && typeof t == "object" ? Jz(e, t) : !1;
}
const oZ = {
  horizontal: {
    offset: (e) => ({
      left: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  "horizontal-reverse": {
    offset: (e) => ({
      right: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  vertical: {
    offset: (e) => ({
      bottom: `${e}%`
    }),
    leap: (e) => ({
      height: `${e}%`
    })
  }
}, rZ = (e) => e;
let u1;
function em() {
  return u1 === void 0 && (typeof CSS < "u" && typeof CSS.supports == "function" ? u1 = CSS.supports("touch-action", "none") : u1 = !0), u1;
}
function iZ(e) {
  const {
    "aria-labelledby": t,
    defaultValue: n,
    disabled: o = !1,
    disableSwap: r = !1,
    isRtl: i = !1,
    marks: s = !1,
    max: a = 100,
    min: c = 0,
    name: d,
    onChange: u,
    onChangeCommitted: p,
    orientation: h = "horizontal",
    rootRef: g,
    scale: m = rZ,
    step: b = 1,
    shiftStep: C = 10,
    tabIndex: x,
    value: v
  } = e, S = y.useRef(void 0), [M, w] = y.useState(-1), [k, E] = y.useState(-1), [R, O] = y.useState(!1), P = y.useRef(0), [_, L] = Fn({
    controlled: v,
    default: n ?? c,
    name: "Slider"
  }), V = u && ((fe, ae, Te) => {
    const tt = fe.nativeEvent || fe, Ye = new tt.constructor(tt.type, tt);
    Object.defineProperty(Ye, "target", {
      writable: !0,
      value: {
        value: ae,
        name: d
      }
    }), u(Ye, ae, Te);
  }), j = Array.isArray(_);
  let I = j ? _.slice().sort(yw) : [_];
  I = I.map((fe) => fe == null ? c : Gs(fe, c, a));
  const F = s === !0 && b !== null ? [...Array(Math.floor((a - c) / b) + 1)].map((fe, ae) => ({
    value: c + b * ae
  })) : s || [], $ = F.map((fe) => fe.value), {
    isFocusVisibleRef: A,
    onBlur: H,
    onFocus: N,
    ref: z
  } = S0(), [se, ne] = y.useState(-1), Z = y.useRef(null), q = Tt(z, Z), G = Tt(g, q), K = (fe) => (ae) => {
    var Te;
    const tt = Number(ae.currentTarget.getAttribute("data-index"));
    N(ae), A.current === !0 && ne(tt), E(tt), fe == null || (Te = fe.onFocus) == null || Te.call(fe, ae);
  }, Q = (fe) => (ae) => {
    var Te;
    H(ae), A.current === !1 && ne(-1), E(-1), fe == null || (Te = fe.onBlur) == null || Te.call(fe, ae);
  }, re = (fe, ae) => {
    const Te = Number(fe.currentTarget.getAttribute("data-index")), tt = I[Te], Ye = $.indexOf(tt);
    let Le = ae;
    if (F && b == null) {
      const Ve = $[$.length - 1];
      Le > Ve ? Le = Ve : Le < $[0] ? Le = $[0] : Le = Le < tt ? $[Ye - 1] : $[Ye + 1];
    }
    if (Le = Gs(Le, c, a), j) {
      r && (Le = Gs(Le, I[Te - 1] || -1 / 0, I[Te + 1] || 1 / 0));
      const Ve = Le;
      Le = Qg({
        values: I,
        newValue: Le,
        index: Te
      });
      let Ce = Te;
      r || (Ce = Le.indexOf(Ve)), c1({
        sliderRef: Z,
        activeIndex: Ce
      });
    }
    L(Le), ne(Te), V && !d1(Le, _) && V(fe, Le, Te), p && p(fe, Le);
  }, U = (fe) => (ae) => {
    var Te;
    if (b !== null) {
      const tt = Number(ae.currentTarget.getAttribute("data-index")), Ye = I[tt];
      let Le = null;
      (ae.key === "ArrowLeft" || ae.key === "ArrowDown") && ae.shiftKey || ae.key === "PageDown" ? Le = Math.max(Ye - C, c) : ((ae.key === "ArrowRight" || ae.key === "ArrowUp") && ae.shiftKey || ae.key === "PageUp") && (Le = Math.min(Ye + C, a)), Le !== null && (re(ae, Le), ae.preventDefault());
    }
    fe == null || (Te = fe.onKeyDown) == null || Te.call(fe, ae);
  };
  En(() => {
    if (o && Z.current.contains(document.activeElement)) {
      var fe;
      (fe = document.activeElement) == null || fe.blur();
    }
  }, [o]), o && M !== -1 && w(-1), o && se !== -1 && ne(-1);
  const W = (fe) => (ae) => {
    var Te;
    (Te = fe.onChange) == null || Te.call(fe, ae), re(ae, ae.target.valueAsNumber);
  }, D = y.useRef(void 0);
  let X = h;
  i && h === "horizontal" && (X += "-reverse");
  const de = ({
    finger: fe,
    move: ae = !1
  }) => {
    const {
      current: Te
    } = Z, {
      width: tt,
      height: Ye,
      bottom: Le,
      left: Ve
    } = Te.getBoundingClientRect();
    let Ce;
    X.indexOf("vertical") === 0 ? Ce = (Le - fe.y) / Ye : Ce = (fe.x - Ve) / tt, X.indexOf("-reverse") !== -1 && (Ce = 1 - Ce);
    let Se;
    if (Se = eZ(Ce, c, a), b)
      Se = nZ(Se, b, c);
    else {
      const Be = Jg($, Se);
      Se = $[Be];
    }
    Se = Gs(Se, c, a);
    let ve = 0;
    if (j) {
      ae ? ve = D.current : ve = Jg(I, Se), r && (Se = Gs(Se, I[ve - 1] || -1 / 0, I[ve + 1] || 1 / 0));
      const Be = Se;
      Se = Qg({
        values: I,
        newValue: Se,
        index: ve
      }), r && ae || (ve = Se.indexOf(Be), D.current = ve);
    }
    return {
      newValue: Se,
      activeIndex: ve
    };
  }, ue = Ke((fe) => {
    const ae = l1(fe, S);
    if (!ae)
      return;
    if (P.current += 1, fe.type === "mousemove" && fe.buttons === 0) {
      he(fe);
      return;
    }
    const {
      newValue: Te,
      activeIndex: tt
    } = de({
      finger: ae,
      move: !0
    });
    c1({
      sliderRef: Z,
      activeIndex: tt,
      setActive: w
    }), L(Te), !R && P.current > Qz && O(!0), V && !d1(Te, _) && V(fe, Te, tt);
  }), he = Ke((fe) => {
    const ae = l1(fe, S);
    if (O(!1), !ae)
      return;
    const {
      newValue: Te
    } = de({
      finger: ae,
      move: !0
    });
    w(-1), fe.type === "touchend" && E(-1), p && p(fe, Te), S.current = void 0, me();
  }), Ue = Ke((fe) => {
    if (o)
      return;
    em() || fe.preventDefault();
    const ae = fe.changedTouches[0];
    ae != null && (S.current = ae.identifier);
    const Te = l1(fe, S);
    if (Te !== !1) {
      const {
        newValue: Ye,
        activeIndex: Le
      } = de({
        finger: Te
      });
      c1({
        sliderRef: Z,
        activeIndex: Le,
        setActive: w
      }), L(Ye), V && !d1(Ye, _) && V(fe, Ye, Le);
    }
    P.current = 0;
    const tt = gn(Z.current);
    tt.addEventListener("touchmove", ue, {
      passive: !0
    }), tt.addEventListener("touchend", he, {
      passive: !0
    });
  }), me = y.useCallback(() => {
    const fe = gn(Z.current);
    fe.removeEventListener("mousemove", ue), fe.removeEventListener("mouseup", he), fe.removeEventListener("touchmove", ue), fe.removeEventListener("touchend", he);
  }, [he, ue]);
  y.useEffect(() => {
    const {
      current: fe
    } = Z;
    return fe.addEventListener("touchstart", Ue, {
      passive: em()
    }), () => {
      fe.removeEventListener("touchstart", Ue), me();
    };
  }, [me, Ue]), y.useEffect(() => {
    o && me();
  }, [o, me]);
  const Ie = (fe) => (ae) => {
    var Te;
    if ((Te = fe.onMouseDown) == null || Te.call(fe, ae), o || ae.defaultPrevented || ae.button !== 0)
      return;
    ae.preventDefault();
    const tt = l1(ae, S);
    if (tt !== !1) {
      const {
        newValue: Le,
        activeIndex: Ve
      } = de({
        finger: tt
      });
      c1({
        sliderRef: Z,
        activeIndex: Ve,
        setActive: w
      }), L(Le), V && !d1(Le, _) && V(ae, Le, Ve);
    }
    P.current = 0;
    const Ye = gn(Z.current);
    Ye.addEventListener("mousemove", ue, {
      passive: !0
    }), Ye.addEventListener("mouseup", he);
  }, te = Xd(j ? I[0] : c, c, a), ie = Xd(I[I.length - 1], c, a) - te, ye = (fe = {}) => {
    const ae = lo(fe), Te = {
      onMouseDown: Ie(ae || {})
    }, tt = T({}, ae, Te);
    return T({}, fe, {
      ref: G
    }, tt);
  }, Ne = (fe) => (ae) => {
    var Te;
    (Te = fe.onMouseOver) == null || Te.call(fe, ae);
    const tt = Number(ae.currentTarget.getAttribute("data-index"));
    E(tt);
  }, We = (fe) => (ae) => {
    var Te;
    (Te = fe.onMouseLeave) == null || Te.call(fe, ae), E(-1);
  };
  return {
    active: M,
    axis: X,
    axisProps: oZ,
    dragging: R,
    focusedThumbIndex: se,
    getHiddenInputProps: (fe = {}) => {
      var ae;
      const Te = lo(fe), tt = {
        onChange: W(Te || {}),
        onFocus: K(Te || {}),
        onBlur: Q(Te || {}),
        onKeyDown: U(Te || {})
      }, Ye = T({}, Te, tt);
      return T({
        tabIndex: x,
        "aria-labelledby": t,
        "aria-orientation": h,
        "aria-valuemax": m(a),
        "aria-valuemin": m(c),
        name: d,
        type: "range",
        min: e.min,
        max: e.max,
        step: e.step === null && e.marks ? "any" : (ae = e.step) != null ? ae : void 0,
        disabled: o
      }, fe, Ye, {
        style: T({}, EI, {
          direction: i ? "rtl" : "ltr",
          // So that VoiceOver's focus indicator matches the thumb's dimensions
          width: "100%",
          height: "100%"
        })
      });
    },
    getRootProps: ye,
    getThumbProps: (fe = {}) => {
      const ae = lo(fe), Te = {
        onMouseOver: Ne(ae || {}),
        onMouseLeave: We(ae || {})
      };
      return T({}, fe, ae, Te);
    },
    marks: F,
    open: k,
    range: j,
    rootRef: G,
    trackLeap: ie,
    trackOffset: te,
    values: I,
    getThumbStyle: (fe) => ({
      // So the non active thumb doesn't show its label on hover.
      pointerEvents: M !== -1 && M !== fe ? "none" : void 0
    })
  };
}
const sZ = (e) => !e || !Qr(e);
function aZ(e) {
  return _e("MuiSlider", e);
}
const hr = Re("MuiSlider", ["root", "active", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "disabled", "dragging", "focusVisible", "mark", "markActive", "marked", "markLabel", "markLabelActive", "rail", "sizeSmall", "thumb", "thumbColorPrimary", "thumbColorSecondary", "thumbColorError", "thumbColorSuccess", "thumbColorInfo", "thumbColorWarning", "track", "trackInverted", "trackFalse", "thumbSizeSmall", "valueLabel", "valueLabelOpen", "valueLabelCircle", "valueLabelLabel", "vertical"]), lZ = (e) => {
  const {
    open: t
  } = e;
  return {
    offset: xe(t && hr.valueLabelOpen),
    circle: hr.valueLabelCircle,
    label: hr.valueLabelLabel
  };
};
function vw(e) {
  const {
    children: t,
    className: n,
    value: o
  } = e, r = lZ(e);
  return t ? /* @__PURE__ */ y.cloneElement(t, {
    className: xe(t.props.className)
  }, /* @__PURE__ */ f.jsxs(y.Fragment, {
    children: [t.props.children, /* @__PURE__ */ f.jsx("span", {
      className: xe(r.offset, n),
      "aria-hidden": !0,
      children: /* @__PURE__ */ f.jsx("span", {
        className: r.circle,
        children: /* @__PURE__ */ f.jsx("span", {
          className: r.label,
          children: o
        })
      })
    })]
  })) : null;
}
process.env.NODE_ENV !== "production" && (vw.propTypes = {
  children: l.element.isRequired,
  className: l.string,
  value: l.node
});
const cZ = ["aria-label", "aria-valuetext", "aria-labelledby", "component", "components", "componentsProps", "color", "classes", "className", "disableSwap", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "orientation", "shiftStep", "size", "step", "scale", "slotProps", "slots", "tabIndex", "track", "value", "valueLabelDisplay", "valueLabelFormat"];
function tm(e) {
  return e;
}
const dZ = B("span", {
  name: "MuiSlider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`color${pe(n.color)}`], n.size !== "medium" && t[`size${pe(n.size)}`], n.marked && t.marked, n.orientation === "vertical" && t.vertical, n.track === "inverted" && t.trackInverted, n.track === !1 && t.trackFalse];
  }
})(({
  theme: e
}) => {
  var t;
  return {
    borderRadius: 12,
    boxSizing: "content-box",
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    touchAction: "none",
    WebkitTapHighlightColor: "transparent",
    "@media print": {
      colorAdjust: "exact"
    },
    [`&.${hr.disabled}`]: {
      pointerEvents: "none",
      cursor: "default",
      color: (e.vars || e).palette.grey[400]
    },
    [`&.${hr.dragging}`]: {
      [`& .${hr.thumb}, & .${hr.track}`]: {
        transition: "none"
      }
    },
    variants: [...Object.keys(((t = e.vars) != null ? t : e).palette).filter((n) => {
      var o;
      return ((o = e.vars) != null ? o : e).palette[n].main;
    }).map((n) => ({
      props: {
        color: n
      },
      style: {
        color: (e.vars || e).palette[n].main
      }
    })), {
      props: {
        orientation: "horizontal"
      },
      style: {
        height: 4,
        width: "100%",
        padding: "13px 0",
        // The primary input mechanism of the device includes a pointing device of limited accuracy.
        "@media (pointer: coarse)": {
          // Reach 42px touch target, about ~8mm on screen.
          padding: "20px 0"
        }
      }
    }, {
      props: {
        orientation: "horizontal",
        size: "small"
      },
      style: {
        height: 2
      }
    }, {
      props: {
        orientation: "horizontal",
        marked: !0
      },
      style: {
        marginBottom: 20
      }
    }, {
      props: {
        orientation: "vertical"
      },
      style: {
        height: "100%",
        width: 4,
        padding: "0 13px",
        // The primary input mechanism of the device includes a pointing device of limited accuracy.
        "@media (pointer: coarse)": {
          // Reach 42px touch target, about ~8mm on screen.
          padding: "0 20px"
        }
      }
    }, {
      props: {
        orientation: "vertical",
        size: "small"
      },
      style: {
        width: 2
      }
    }, {
      props: {
        orientation: "vertical",
        marked: !0
      },
      style: {
        marginRight: 44
      }
    }]
  };
}), uZ = B("span", {
  name: "MuiSlider",
  slot: "Rail",
  overridesResolver: (e, t) => t.rail
})({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  backgroundColor: "currentColor",
  opacity: 0.38,
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "100%",
      height: "inherit",
      top: "50%",
      transform: "translateY(-50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      width: "inherit",
      left: "50%",
      transform: "translateX(-50%)"
    }
  }, {
    props: {
      track: "inverted"
    },
    style: {
      opacity: 1
    }
  }]
}), fZ = B("span", {
  name: "MuiSlider",
  slot: "Track",
  overridesResolver: (e, t) => t.track
})(({
  theme: e
}) => {
  var t;
  return {
    display: "block",
    position: "absolute",
    borderRadius: "inherit",
    border: "1px solid currentColor",
    backgroundColor: "currentColor",
    transition: e.transitions.create(["left", "width", "bottom", "height"], {
      duration: e.transitions.duration.shortest
    }),
    variants: [{
      props: {
        size: "small"
      },
      style: {
        border: "none"
      }
    }, {
      props: {
        orientation: "horizontal"
      },
      style: {
        height: "inherit",
        top: "50%",
        transform: "translateY(-50%)"
      }
    }, {
      props: {
        orientation: "vertical"
      },
      style: {
        width: "inherit",
        left: "50%",
        transform: "translateX(-50%)"
      }
    }, {
      props: {
        track: !1
      },
      style: {
        display: "none"
      }
    }, ...Object.keys(((t = e.vars) != null ? t : e).palette).filter((n) => {
      var o;
      return ((o = e.vars) != null ? o : e).palette[n].main;
    }).map((n) => ({
      props: {
        color: n,
        track: "inverted"
      },
      style: T({}, e.vars ? {
        backgroundColor: e.vars.palette.Slider[`${n}Track`],
        borderColor: e.vars.palette.Slider[`${n}Track`]
      } : T({
        backgroundColor: va(e.palette[n].main, 0.62),
        borderColor: va(e.palette[n].main, 0.62)
      }, e.applyStyles("dark", {
        backgroundColor: ya(e.palette[n].main, 0.5)
      }), e.applyStyles("dark", {
        borderColor: ya(e.palette[n].main, 0.5)
      })))
    }))]
  };
}), pZ = B("span", {
  name: "MuiSlider",
  slot: "Thumb",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.thumb, t[`thumbColor${pe(n.color)}`], n.size !== "medium" && t[`thumbSize${pe(n.size)}`]];
  }
})(({
  theme: e
}) => {
  var t;
  return {
    position: "absolute",
    width: 20,
    height: 20,
    boxSizing: "border-box",
    borderRadius: "50%",
    outline: 0,
    backgroundColor: "currentColor",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: e.transitions.create(["box-shadow", "left", "bottom"], {
      duration: e.transitions.duration.shortest
    }),
    "&::before": {
      position: "absolute",
      content: '""',
      borderRadius: "inherit",
      width: "100%",
      height: "100%",
      boxShadow: (e.vars || e).shadows[2]
    },
    "&::after": {
      position: "absolute",
      content: '""',
      borderRadius: "50%",
      // 42px is the hit target
      width: 42,
      height: 42,
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    },
    [`&.${hr.disabled}`]: {
      "&:hover": {
        boxShadow: "none"
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        width: 12,
        height: 12,
        "&::before": {
          boxShadow: "none"
        }
      }
    }, {
      props: {
        orientation: "horizontal"
      },
      style: {
        top: "50%",
        transform: "translate(-50%, -50%)"
      }
    }, {
      props: {
        orientation: "vertical"
      },
      style: {
        left: "50%",
        transform: "translate(-50%, 50%)"
      }
    }, ...Object.keys(((t = e.vars) != null ? t : e).palette).filter((n) => {
      var o;
      return ((o = e.vars) != null ? o : e).palette[n].main;
    }).map((n) => ({
      props: {
        color: n
      },
      style: {
        [`&:hover, &.${hr.focusVisible}`]: T({}, e.vars ? {
          boxShadow: `0px 0px 0px 8px rgba(${e.vars.palette[n].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 8px ${gt(e.palette[n].main, 0.16)}`
        }, {
          "@media (hover: none)": {
            boxShadow: "none"
          }
        }),
        [`&.${hr.active}`]: T({}, e.vars ? {
          boxShadow: `0px 0px 0px 14px rgba(${e.vars.palette[n].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 14px ${gt(e.palette[n].main, 0.16)}`
        })
      }
    }))]
  };
}), hZ = B(vw, {
  name: "MuiSlider",
  slot: "ValueLabel",
  overridesResolver: (e, t) => t.valueLabel
})(({
  theme: e
}) => T({
  zIndex: 1,
  whiteSpace: "nowrap"
}, e.typography.body2, {
  fontWeight: 500,
  transition: e.transitions.create(["transform"], {
    duration: e.transitions.duration.shortest
  }),
  position: "absolute",
  backgroundColor: (e.vars || e).palette.grey[600],
  borderRadius: 2,
  color: (e.vars || e).palette.common.white,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0.25rem 0.75rem",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      transform: "translateY(-100%) scale(0)",
      top: "-10px",
      transformOrigin: "bottom center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, 50%) rotate(45deg)",
        backgroundColor: "inherit",
        bottom: 0,
        left: "50%"
      },
      [`&.${hr.valueLabelOpen}`]: {
        transform: "translateY(-100%) scale(1)"
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      transform: "translateY(-50%) scale(0)",
      right: "30px",
      top: "50%",
      transformOrigin: "right center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, -50%) rotate(45deg)",
        backgroundColor: "inherit",
        right: -8,
        top: "50%"
      },
      [`&.${hr.valueLabelOpen}`]: {
        transform: "translateY(-50%) scale(1)"
      }
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      fontSize: e.typography.pxToRem(12),
      padding: "0.25rem 0.5rem"
    }
  }, {
    props: {
      orientation: "vertical",
      size: "small"
    },
    style: {
      right: "20px"
    }
  }]
})), gZ = B("span", {
  name: "MuiSlider",
  slot: "Mark",
  shouldForwardProp: (e) => b3(e) && e !== "markActive",
  overridesResolver: (e, t) => {
    const {
      markActive: n
    } = e;
    return [t.mark, n && t.markActive];
  }
})(({
  theme: e
}) => ({
  position: "absolute",
  width: 2,
  height: 2,
  borderRadius: 1,
  backgroundColor: "currentColor",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: "50%",
      transform: "translate(-1px, -50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: "50%",
      transform: "translate(-50%, 1px)"
    }
  }, {
    props: {
      markActive: !0
    },
    style: {
      backgroundColor: (e.vars || e).palette.background.paper,
      opacity: 0.8
    }
  }]
})), mZ = B("span", {
  name: "MuiSlider",
  slot: "MarkLabel",
  shouldForwardProp: (e) => b3(e) && e !== "markLabelActive",
  overridesResolver: (e, t) => t.markLabel
})(({
  theme: e
}) => T({}, e.typography.body2, {
  color: (e.vars || e).palette.text.secondary,
  position: "absolute",
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: 30,
      transform: "translateX(-50%)",
      "@media (pointer: coarse)": {
        top: 40
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: 36,
      transform: "translateY(50%)",
      "@media (pointer: coarse)": {
        left: 44
      }
    }
  }, {
    props: {
      markLabelActive: !0
    },
    style: {
      color: (e.vars || e).palette.text.primary
    }
  }]
})), bZ = (e) => {
  const {
    disabled: t,
    dragging: n,
    marked: o,
    orientation: r,
    track: i,
    classes: s,
    color: a,
    size: c
  } = e, d = {
    root: ["root", t && "disabled", n && "dragging", o && "marked", r === "vertical" && "vertical", i === "inverted" && "trackInverted", i === !1 && "trackFalse", a && `color${pe(a)}`, c && `size${pe(c)}`],
    rail: ["rail"],
    track: ["track"],
    mark: ["mark"],
    markActive: ["markActive"],
    markLabel: ["markLabel"],
    markLabelActive: ["markLabelActive"],
    valueLabel: ["valueLabel"],
    thumb: ["thumb", t && "disabled", c && `thumbSize${pe(c)}`, a && `thumbColor${pe(a)}`],
    active: ["active"],
    disabled: ["disabled"],
    focusVisible: ["focusVisible"]
  };
  return Oe(d, aZ, s);
}, CZ = ({
  children: e
}) => e, c7 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i, s, a, c, d, u, p, h, g, m, b, C, x, v, S, M, w, k, E, R, O, P;
  const _ = Xe({
    props: t,
    name: "MuiSlider"
  }), L = Ms(), {
    "aria-label": V,
    "aria-valuetext": j,
    "aria-labelledby": I,
    // eslint-disable-next-line react/prop-types
    component: F = "span",
    components: $ = {},
    componentsProps: A = {},
    color: H = "primary",
    classes: N,
    className: z,
    disableSwap: se = !1,
    disabled: ne = !1,
    getAriaLabel: Z,
    getAriaValueText: q,
    marks: G = !1,
    max: K = 100,
    min: Q = 0,
    orientation: re = "horizontal",
    shiftStep: U = 10,
    size: W = "medium",
    step: D = 1,
    scale: X = tm,
    slotProps: de,
    slots: ue,
    track: he = "normal",
    valueLabelDisplay: Ue = "off",
    valueLabelFormat: me = tm
  } = _, Ie = le(_, cZ), te = T({}, _, {
    isRtl: L,
    max: K,
    min: Q,
    classes: N,
    disabled: ne,
    disableSwap: se,
    orientation: re,
    marks: G,
    color: H,
    size: W,
    step: D,
    shiftStep: U,
    scale: X,
    track: he,
    valueLabelDisplay: Ue,
    valueLabelFormat: me
  }), {
    axisProps: ie,
    getRootProps: ye,
    getHiddenInputProps: Ne,
    getThumbProps: We,
    open: qe,
    active: Me,
    axis: Pe,
    focusedThumbIndex: fe,
    range: ae,
    dragging: Te,
    marks: tt,
    values: Ye,
    trackOffset: Le,
    trackLeap: Ve,
    getThumbStyle: Ce
  } = iZ(T({}, te, {
    rootRef: n
  }));
  te.marked = tt.length > 0 && tt.some((ce) => ce.label), te.dragging = Te, te.focusedThumbIndex = fe;
  const Se = bZ(te), ve = (o = (r = ue == null ? void 0 : ue.root) != null ? r : $.Root) != null ? o : dZ, Be = (i = (s = ue == null ? void 0 : ue.rail) != null ? s : $.Rail) != null ? i : uZ, rt = (a = (c = ue == null ? void 0 : ue.track) != null ? c : $.Track) != null ? a : fZ, pt = (d = (u = ue == null ? void 0 : ue.thumb) != null ? u : $.Thumb) != null ? d : pZ, Je = (p = (h = ue == null ? void 0 : ue.valueLabel) != null ? h : $.ValueLabel) != null ? p : hZ, At = (g = (m = ue == null ? void 0 : ue.mark) != null ? m : $.Mark) != null ? g : gZ, Ht = (b = (C = ue == null ? void 0 : ue.markLabel) != null ? C : $.MarkLabel) != null ? b : mZ, Ct = (x = (v = ue == null ? void 0 : ue.input) != null ? v : $.Input) != null ? x : "input", qt = (S = de == null ? void 0 : de.root) != null ? S : A.root, Bn = (M = de == null ? void 0 : de.rail) != null ? M : A.rail, xn = (w = de == null ? void 0 : de.track) != null ? w : A.track, $o = (k = de == null ? void 0 : de.thumb) != null ? k : A.thumb, zn = (E = de == null ? void 0 : de.valueLabel) != null ? E : A.valueLabel, bn = (R = de == null ? void 0 : de.mark) != null ? R : A.mark, Zt = (O = de == null ? void 0 : de.markLabel) != null ? O : A.markLabel, vn = (P = de == null ? void 0 : de.input) != null ? P : A.input, Qe = Ft({
    elementType: ve,
    getSlotProps: ye,
    externalSlotProps: qt,
    externalForwardedProps: Ie,
    additionalProps: T({}, sZ(ve) && {
      as: F
    }),
    ownerState: T({}, te, qt == null ? void 0 : qt.ownerState),
    className: [Se.root, z]
  }), oo = Ft({
    elementType: Be,
    externalSlotProps: Bn,
    ownerState: te,
    className: Se.rail
  }), Kt = Ft({
    elementType: rt,
    externalSlotProps: xn,
    additionalProps: {
      style: T({}, ie[Pe].offset(Le), ie[Pe].leap(Ve))
    },
    ownerState: T({}, te, xn == null ? void 0 : xn.ownerState),
    className: Se.track
  }), Wt = Ft({
    elementType: pt,
    getSlotProps: We,
    externalSlotProps: $o,
    ownerState: T({}, te, $o == null ? void 0 : $o.ownerState),
    className: Se.thumb
  }), Y = Ft({
    elementType: Je,
    externalSlotProps: zn,
    ownerState: T({}, te, zn == null ? void 0 : zn.ownerState),
    className: Se.valueLabel
  }), ke = Ft({
    elementType: At,
    externalSlotProps: bn,
    ownerState: te,
    className: Se.mark
  }), He = Ft({
    elementType: Ht,
    externalSlotProps: Zt,
    ownerState: te,
    className: Se.markLabel
  }), st = Ft({
    elementType: Ct,
    getSlotProps: Ne,
    externalSlotProps: vn,
    ownerState: te
  });
  return /* @__PURE__ */ f.jsxs(ve, T({}, Qe, {
    children: [/* @__PURE__ */ f.jsx(Be, T({}, oo)), /* @__PURE__ */ f.jsx(rt, T({}, Kt)), tt.filter((ce) => ce.value >= Q && ce.value <= K).map((ce, ee) => {
      const we = Xd(ce.value, Q, K), De = ie[Pe].offset(we);
      let nt;
      return he === !1 ? nt = Ye.indexOf(ce.value) !== -1 : nt = he === "normal" && (ae ? ce.value >= Ye[0] && ce.value <= Ye[Ye.length - 1] : ce.value <= Ye[0]) || he === "inverted" && (ae ? ce.value <= Ye[0] || ce.value >= Ye[Ye.length - 1] : ce.value >= Ye[0]), /* @__PURE__ */ f.jsxs(y.Fragment, {
        children: [/* @__PURE__ */ f.jsx(At, T({
          "data-index": ee
        }, ke, !Qr(At) && {
          markActive: nt
        }, {
          style: T({}, De, ke.style),
          className: xe(ke.className, nt && Se.markActive)
        })), ce.label != null ? /* @__PURE__ */ f.jsx(Ht, T({
          "aria-hidden": !0,
          "data-index": ee
        }, He, !Qr(Ht) && {
          markLabelActive: nt
        }, {
          style: T({}, De, He.style),
          className: xe(Se.markLabel, He.className, nt && Se.markLabelActive),
          children: ce.label
        })) : null]
      }, ee);
    }), Ye.map((ce, ee) => {
      const we = Xd(ce, Q, K), De = ie[Pe].offset(we), nt = Ue === "off" ? CZ : Je;
      return (
        /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */
        /* @__PURE__ */ f.jsx(nt, T({}, !Qr(nt) && {
          valueLabelFormat: me,
          valueLabelDisplay: Ue,
          value: typeof me == "function" ? me(X(ce), ee) : me,
          index: ee,
          open: qe === ee || Me === ee || Ue === "on",
          disabled: ne
        }, Y, {
          children: /* @__PURE__ */ f.jsx(pt, T({
            "data-index": ee
          }, Wt, {
            className: xe(Se.thumb, Wt.className, Me === ee && Se.active, fe === ee && Se.focusVisible),
            style: T({}, De, Ce(ee), Wt.style),
            children: /* @__PURE__ */ f.jsx(Ct, T({
              "data-index": ee,
              "aria-label": Z ? Z(ee) : V,
              "aria-valuenow": X(ce),
              "aria-labelledby": I,
              "aria-valuetext": q ? q(X(ce), ee) : j,
              value: Ye[ee]
            }, st))
          }))
        }), ee)
      );
    })]
  }));
});
process.env.NODE_ENV !== "production" && (c7.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The label of the slider.
   */
  "aria-label": vo(l.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-label"] != null ? new Error("MUI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.") : null),
  /**
   * The id of the element containing a label for the slider.
   */
  "aria-labelledby": l.string,
  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  "aria-valuetext": vo(l.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-valuetext"] != null ? new Error("MUI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.") : null),
  /**
   * @ignore
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */
  components: l.shape({
    Input: l.elementType,
    Mark: l.elementType,
    MarkLabel: l.elementType,
    Rail: l.elementType,
    Root: l.elementType,
    Thumb: l.elementType,
    Track: l.elementType,
    ValueLabel: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */
  componentsProps: l.shape({
    input: l.oneOfType([l.func, l.object]),
    mark: l.oneOfType([l.func, l.object]),
    markLabel: l.oneOfType([l.func, l.object]),
    rail: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object]),
    thumb: l.oneOfType([l.func, l.object]),
    track: l.oneOfType([l.func, l.object]),
    valueLabel: l.oneOfType([l.func, l.shape({
      children: l.element,
      className: l.string,
      open: l.bool,
      style: l.object,
      value: l.number,
      valueLabelDisplay: l.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.oneOfType([l.arrayOf(l.number), l.number]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, the active thumb doesn't swap when moving pointer over a thumb while dragging another thumb.
   * @default false
   */
  disableSwap: l.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   * This is important for screen reader users.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: l.func,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   * This is important for screen reader users.
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: l.func,
  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks are spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   * @default false
   */
  marks: l.oneOfType([l.arrayOf(l.shape({
    label: l.node,
    value: l.number.isRequired
  })), l.bool]),
  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   * @default 100
   */
  max: l.number,
  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   * @default 0
   */
  min: l.number,
  /**
   * Name attribute of the hidden `input` element.
   */
  name: l.string,
  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {Event} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   * @param {number} activeThumb Index of the currently moved thumb.
   */
  onChange: l.func,
  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {React.SyntheticEvent | Event} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   */
  onChangeCommitted: l.func,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: l.oneOf(["horizontal", "vertical"]),
  /**
   * A transformation function, to change the scale of the slider.
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  scale: l.func,
  /**
   * The granularity with which the slider can step through values when using Page Up/Page Down or Shift + Arrow Up/Arrow Down.
   * @default 10
   */
  shiftStep: l.number,
  /**
   * The size of the slider.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["small", "medium"]), l.string]),
  /**
   * The props used for each slot inside the Slider.
   * @default {}
   */
  slotProps: l.shape({
    input: l.oneOfType([l.func, l.object]),
    mark: l.oneOfType([l.func, l.object]),
    markLabel: l.oneOfType([l.func, l.object]),
    rail: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object]),
    thumb: l.oneOfType([l.func, l.object]),
    track: l.oneOfType([l.func, l.object]),
    valueLabel: l.oneOfType([l.func, l.shape({
      children: l.element,
      className: l.string,
      open: l.bool,
      style: l.object,
      value: l.number,
      valueLabelDisplay: l.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The components used for each slot inside the Slider.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: l.shape({
    input: l.elementType,
    mark: l.elementType,
    markLabel: l.elementType,
    rail: l.elementType,
    root: l.elementType,
    thumb: l.elementType,
    track: l.elementType,
    valueLabel: l.elementType
  }),
  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   * @default 1
   */
  step: l.number,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Tab index attribute of the hidden `input` element.
   */
  tabIndex: l.number,
  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   * @default 'normal'
   */
  track: l.oneOf(["inverted", "normal", !1]),
  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: l.oneOfType([l.arrayOf(l.number), l.number]),
  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   * @default 'off'
   */
  valueLabelDisplay: l.oneOf(["auto", "off", "on"]),
  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  valueLabelFormat: l.oneOfType([l.func, l.string])
});
function xZ(e) {
  return _e("MuiTooltip", e);
}
const Io = Re("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]), yZ = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "slotProps", "slots", "title", "TransitionComponent", "TransitionProps"];
function vZ(e) {
  return Math.round(e * 1e5) / 1e5;
}
const wZ = (e) => {
  const {
    classes: t,
    disableInteractive: n,
    arrow: o,
    touch: r,
    placement: i
  } = e, s = {
    popper: ["popper", !n && "popperInteractive", o && "popperArrow"],
    tooltip: ["tooltip", o && "tooltipArrow", r && "touch", `tooltipPlacement${pe(i.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return Oe(s, xZ, t);
}, SZ = B(s2, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popper, !n.disableInteractive && t.popperInteractive, n.arrow && t.popperArrow, !n.open && t.popperClose];
  }
})(({
  theme: e,
  ownerState: t,
  open: n
}) => T({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none"
}, !t.disableInteractive && {
  pointerEvents: "auto"
}, !n && {
  pointerEvents: "none"
}, t.arrow && {
  [`&[data-popper-placement*="bottom"] .${Io.arrow}`]: {
    top: 0,
    marginTop: "-0.71em",
    "&::before": {
      transformOrigin: "0 100%"
    }
  },
  [`&[data-popper-placement*="top"] .${Io.arrow}`]: {
    bottom: 0,
    marginBottom: "-0.71em",
    "&::before": {
      transformOrigin: "100% 0"
    }
  },
  [`&[data-popper-placement*="right"] .${Io.arrow}`]: T({}, t.isRtl ? {
    right: 0,
    marginRight: "-0.71em"
  } : {
    left: 0,
    marginLeft: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "100% 100%"
    }
  }),
  [`&[data-popper-placement*="left"] .${Io.arrow}`]: T({}, t.isRtl ? {
    left: 0,
    marginLeft: "-0.71em"
  } : {
    right: 0,
    marginRight: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "0 0"
    }
  })
})), MZ = B("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.tooltip, n.touch && t.touch, n.arrow && t.tooltipArrow, t[`tooltipPlacement${pe(n.placement.split("-")[0])}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => T({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : gt(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium
}, t.arrow && {
  position: "relative",
  margin: 0
}, t.touch && {
  padding: "8px 16px",
  fontSize: e.typography.pxToRem(14),
  lineHeight: `${vZ(16 / 14)}em`,
  fontWeight: e.typography.fontWeightRegular
}, {
  [`.${Io.popper}[data-popper-placement*="left"] &`]: T({
    transformOrigin: "right center"
  }, t.isRtl ? T({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  }) : T({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  })),
  [`.${Io.popper}[data-popper-placement*="right"] &`]: T({
    transformOrigin: "left center"
  }, t.isRtl ? T({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  }) : T({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  })),
  [`.${Io.popper}[data-popper-placement*="top"] &`]: T({
    transformOrigin: "center bottom",
    marginBottom: "14px"
  }, t.touch && {
    marginBottom: "24px"
  }),
  [`.${Io.popper}[data-popper-placement*="bottom"] &`]: T({
    transformOrigin: "center top",
    marginTop: "14px"
  }, t.touch && {
    marginTop: "24px"
  })
})), TZ = B("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (e, t) => t.arrow
})(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : gt(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
}));
let f1 = !1;
const nm = new w0();
let O2 = {
  x: 0,
  y: 0
};
function p1(e, t) {
  return (n, ...o) => {
    t && t(n, ...o), e(n, ...o);
  };
}
const ln = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i, s, a, c, d, u, p, h, g, m, b, C, x, v, S, M, w;
  const k = Xe({
    props: t,
    name: "MuiTooltip"
  }), {
    arrow: E = !1,
    children: R,
    components: O = {},
    componentsProps: P = {},
    describeChild: _ = !1,
    disableFocusListener: L = !1,
    disableHoverListener: V = !1,
    disableInteractive: j = !1,
    disableTouchListener: I = !1,
    enterDelay: F = 100,
    enterNextDelay: $ = 0,
    enterTouchDelay: A = 700,
    followCursor: H = !1,
    id: N,
    leaveDelay: z = 0,
    leaveTouchDelay: se = 1500,
    onClose: ne,
    onOpen: Z,
    open: q,
    placement: G = "bottom",
    PopperComponent: K,
    PopperProps: Q = {},
    slotProps: re = {},
    slots: U = {},
    title: W,
    TransitionComponent: D = gs,
    TransitionProps: X
  } = k, de = le(k, yZ), ue = /* @__PURE__ */ y.isValidElement(R) ? R : /* @__PURE__ */ f.jsx("span", {
    children: R
  }), he = ge(), Ue = Ms(), [me, Ie] = y.useState(), [te, ie] = y.useState(null), ye = y.useRef(!1), Ne = j || H, We = Xs(), qe = Xs(), Me = Xs(), Pe = Xs(), [fe, ae] = Fn({
    controlled: q,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let Te = fe;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: ze
    } = y.useRef(q !== void 0);
    y.useEffect(() => {
      me && me.disabled && !ze && W !== "" && me.tagName.toLowerCase() === "button" && console.error(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [W, me, ze]);
  }
  const tt = di(N), Ye = y.useRef(), Le = Ke(() => {
    Ye.current !== void 0 && (document.body.style.WebkitUserSelect = Ye.current, Ye.current = void 0), Pe.clear();
  });
  y.useEffect(() => Le, [Le]);
  const Ve = (ze) => {
    nm.clear(), f1 = !0, ae(!0), Z && !Te && Z(ze);
  }, Ce = Ke(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (ze) => {
      nm.start(800 + z, () => {
        f1 = !1;
      }), ae(!1), ne && Te && ne(ze), We.start(he.transitions.duration.shortest, () => {
        ye.current = !1;
      });
    }
  ), Se = (ze) => {
    ye.current && ze.type !== "touchstart" || (me && me.removeAttribute("title"), qe.clear(), Me.clear(), F || f1 && $ ? qe.start(f1 ? $ : F, () => {
      Ve(ze);
    }) : Ve(ze));
  }, ve = (ze) => {
    qe.clear(), Me.start(z, () => {
      Ce(ze);
    });
  }, {
    isFocusVisibleRef: Be,
    onBlur: rt,
    onFocus: pt,
    ref: Je
  } = S0(), [, At] = y.useState(!1), Ht = (ze) => {
    rt(ze), Be.current === !1 && (At(!1), ve(ze));
  }, Ct = (ze) => {
    me || Ie(ze.currentTarget), pt(ze), Be.current === !0 && (At(!0), Se(ze));
  }, qt = (ze) => {
    ye.current = !0;
    const lt = ue.props;
    lt.onTouchStart && lt.onTouchStart(ze);
  }, Bn = (ze) => {
    qt(ze), Me.clear(), We.clear(), Le(), Ye.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", Pe.start(A, () => {
      document.body.style.WebkitUserSelect = Ye.current, Se(ze);
    });
  }, xn = (ze) => {
    ue.props.onTouchEnd && ue.props.onTouchEnd(ze), Le(), Me.start(se, () => {
      Ce(ze);
    });
  };
  y.useEffect(() => {
    if (!Te)
      return;
    function ze(lt) {
      (lt.key === "Escape" || lt.key === "Esc") && Ce(lt);
    }
    return document.addEventListener("keydown", ze), () => {
      document.removeEventListener("keydown", ze);
    };
  }, [Ce, Te]);
  const $o = Tt(o2(ue), Je, Ie, n);
  !W && W !== 0 && (Te = !1);
  const zn = y.useRef(), bn = (ze) => {
    const lt = ue.props;
    lt.onMouseMove && lt.onMouseMove(ze), O2 = {
      x: ze.clientX,
      y: ze.clientY
    }, zn.current && zn.current.update();
  }, Zt = {}, vn = typeof W == "string";
  _ ? (Zt.title = !Te && vn && !V ? W : null, Zt["aria-describedby"] = Te ? tt : null) : (Zt["aria-label"] = vn ? W : null, Zt["aria-labelledby"] = Te && !vn ? tt : null);
  const Qe = T({}, Zt, de, ue.props, {
    className: xe(de.className, ue.props.className),
    onTouchStart: qt,
    ref: $o
  }, H ? {
    onMouseMove: bn
  } : {});
  process.env.NODE_ENV !== "production" && (Qe["data-mui-internal-clone-element"] = !0, y.useEffect(() => {
    me && !me.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [me]));
  const oo = {};
  I || (Qe.onTouchStart = Bn, Qe.onTouchEnd = xn), V || (Qe.onMouseOver = p1(Se, Qe.onMouseOver), Qe.onMouseLeave = p1(ve, Qe.onMouseLeave), Ne || (oo.onMouseOver = Se, oo.onMouseLeave = ve)), L || (Qe.onFocus = p1(Ct, Qe.onFocus), Qe.onBlur = p1(Ht, Qe.onBlur), Ne || (oo.onFocus = Ct, oo.onBlur = Ht)), process.env.NODE_ENV !== "production" && ue.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${ue.props.title}\` or the Tooltip component.`].join(`
`));
  const Kt = y.useMemo(() => {
    var ze;
    let lt = [{
      name: "arrow",
      enabled: !!te,
      options: {
        element: te,
        padding: 4
      }
    }];
    return (ze = Q.popperOptions) != null && ze.modifiers && (lt = lt.concat(Q.popperOptions.modifiers)), T({}, Q.popperOptions, {
      modifiers: lt
    });
  }, [te, Q]), Wt = T({}, k, {
    isRtl: Ue,
    arrow: E,
    disableInteractive: Ne,
    placement: G,
    PopperComponentProp: K,
    touch: ye.current
  }), Y = wZ(Wt), ke = (o = (r = U.popper) != null ? r : O.Popper) != null ? o : SZ, He = (i = (s = (a = U.transition) != null ? a : O.Transition) != null ? s : D) != null ? i : gs, st = (c = (d = U.tooltip) != null ? d : O.Tooltip) != null ? c : MZ, ce = (u = (p = U.arrow) != null ? p : O.Arrow) != null ? u : TZ, ee = dl(ke, T({}, Q, (h = re.popper) != null ? h : P.popper, {
    className: xe(Y.popper, Q == null ? void 0 : Q.className, (g = (m = re.popper) != null ? m : P.popper) == null ? void 0 : g.className)
  }), Wt), we = dl(He, T({}, X, (b = re.transition) != null ? b : P.transition), Wt), De = dl(st, T({}, (C = re.tooltip) != null ? C : P.tooltip, {
    className: xe(Y.tooltip, (x = (v = re.tooltip) != null ? v : P.tooltip) == null ? void 0 : x.className)
  }), Wt), nt = dl(ce, T({}, (S = re.arrow) != null ? S : P.arrow, {
    className: xe(Y.arrow, (M = (w = re.arrow) != null ? w : P.arrow) == null ? void 0 : M.className)
  }), Wt);
  return /* @__PURE__ */ f.jsxs(y.Fragment, {
    children: [/* @__PURE__ */ y.cloneElement(ue, Qe), /* @__PURE__ */ f.jsx(ke, T({
      as: K ?? s2,
      placement: G,
      anchorEl: H ? {
        getBoundingClientRect: () => ({
          top: O2.y,
          left: O2.x,
          right: O2.x,
          bottom: O2.y,
          width: 0,
          height: 0
        })
      } : me,
      popperRef: zn,
      open: me ? Te : !1,
      id: tt,
      transition: !0
    }, oo, ee, {
      popperOptions: Kt,
      children: ({
        TransitionProps: ze
      }) => /* @__PURE__ */ f.jsx(He, T({
        timeout: he.transitions.duration.shorter
      }, ze, we, {
        children: /* @__PURE__ */ f.jsxs(st, T({}, De, {
          children: [W, E ? /* @__PURE__ */ f.jsx(ce, T({}, nt, {
            ref: ie
          })) : null]
        }))
      }))
    }))]
  });
});
process.env.NODE_ENV !== "production" && (ln.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: l.bool,
  /**
   * Tooltip reference element.
   */
  children: t2.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Arrow: l.elementType,
    Popper: l.elementType,
    Tooltip: l.elementType,
    Transition: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    arrow: l.object,
    popper: l.object,
    tooltip: l.object,
    transition: l.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: l.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: l.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: l.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: l.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: l.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: l.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: l.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: l.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: l.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: l.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: l.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: l.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: l.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: l.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @default Popper
   */
  PopperComponent: l.elementType,
  /**
   * Props applied to the [`Popper`](/material-ui/api/popper/) element.
   * @default {}
   */
  PopperProps: l.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: l.shape({
    arrow: l.object,
    popper: l.object,
    tooltip: l.object,
    transition: l.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    arrow: l.elementType,
    popper: l.elementType,
    tooltip: l.elementType,
    transition: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: l.node,
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: l.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: l.object
});
function kZ(e) {
  return _e("MuiTab", e);
}
const Fi = Re("MuiTab", ["root", "labelIcon", "textColorInherit", "textColorPrimary", "textColorSecondary", "selected", "disabled", "fullWidth", "wrapped", "iconWrapper"]), EZ = ["className", "disabled", "disableFocusRipple", "fullWidth", "icon", "iconPosition", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"], RZ = (e) => {
  const {
    classes: t,
    textColor: n,
    fullWidth: o,
    wrapped: r,
    icon: i,
    label: s,
    selected: a,
    disabled: c
  } = e, d = {
    root: ["root", i && s && "labelIcon", `textColor${pe(n)}`, o && "fullWidth", r && "wrapped", a && "selected", c && "disabled"],
    iconWrapper: ["iconWrapper"]
  };
  return Oe(d, kZ, t);
}, OZ = B(wo, {
  name: "MuiTab",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.label && n.icon && t.labelIcon, t[`textColor${pe(n.textColor)}`], n.fullWidth && t.fullWidth, n.wrapped && t.wrapped, {
      [`& .${Fi.iconWrapper}`]: t.iconWrapper
    }];
  }
})(({
  theme: e,
  ownerState: t
}) => T({}, e.typography.button, {
  maxWidth: 360,
  minWidth: 90,
  position: "relative",
  minHeight: 48,
  flexShrink: 0,
  padding: "12px 16px",
  overflow: "hidden",
  whiteSpace: "normal",
  textAlign: "center"
}, t.label && {
  flexDirection: t.iconPosition === "top" || t.iconPosition === "bottom" ? "column" : "row"
}, {
  lineHeight: 1.25
}, t.icon && t.label && {
  minHeight: 72,
  paddingTop: 9,
  paddingBottom: 9,
  [`& > .${Fi.iconWrapper}`]: T({}, t.iconPosition === "top" && {
    marginBottom: 6
  }, t.iconPosition === "bottom" && {
    marginTop: 6
  }, t.iconPosition === "start" && {
    marginRight: e.spacing(1)
  }, t.iconPosition === "end" && {
    marginLeft: e.spacing(1)
  })
}, t.textColor === "inherit" && {
  color: "inherit",
  opacity: 0.6,
  // same opacity as theme.palette.text.secondary
  [`&.${Fi.selected}`]: {
    opacity: 1
  },
  [`&.${Fi.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.textColor === "primary" && {
  color: (e.vars || e).palette.text.secondary,
  [`&.${Fi.selected}`]: {
    color: (e.vars || e).palette.primary.main
  },
  [`&.${Fi.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  }
}, t.textColor === "secondary" && {
  color: (e.vars || e).palette.text.secondary,
  [`&.${Fi.selected}`]: {
    color: (e.vars || e).palette.secondary.main
  },
  [`&.${Fi.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  }
}, t.fullWidth && {
  flexShrink: 1,
  flexGrow: 1,
  flexBasis: 0,
  maxWidth: "none"
}, t.wrapped && {
  fontSize: e.typography.pxToRem(12)
})), Nc = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiTab"
  }), {
    className: r,
    disabled: i = !1,
    disableFocusRipple: s = !1,
    // eslint-disable-next-line react/prop-types
    fullWidth: a,
    icon: c,
    iconPosition: d = "top",
    // eslint-disable-next-line react/prop-types
    indicator: u,
    label: p,
    onChange: h,
    onClick: g,
    onFocus: m,
    // eslint-disable-next-line react/prop-types
    selected: b,
    // eslint-disable-next-line react/prop-types
    selectionFollowsFocus: C,
    // eslint-disable-next-line react/prop-types
    textColor: x = "inherit",
    value: v,
    wrapped: S = !1
  } = o, M = le(o, EZ), w = T({}, o, {
    disabled: i,
    disableFocusRipple: s,
    selected: b,
    icon: !!c,
    iconPosition: d,
    label: !!p,
    fullWidth: a,
    textColor: x,
    wrapped: S
  }), k = RZ(w), E = c && p && /* @__PURE__ */ y.isValidElement(c) ? /* @__PURE__ */ y.cloneElement(c, {
    className: xe(k.iconWrapper, c.props.className)
  }) : c, R = (P) => {
    !b && h && h(P, v), g && g(P);
  }, O = (P) => {
    C && !b && h && h(P, v), m && m(P);
  };
  return /* @__PURE__ */ f.jsxs(OZ, T({
    focusRipple: !s,
    className: xe(k.root, r),
    ref: n,
    role: "tab",
    "aria-selected": b,
    disabled: i,
    onClick: R,
    onFocus: O,
    ownerState: w,
    tabIndex: b ? 0 : -1
  }, M, {
    children: [d === "top" || d === "start" ? /* @__PURE__ */ f.jsxs(y.Fragment, {
      children: [E, p]
    }) : /* @__PURE__ */ f.jsxs(y.Fragment, {
      children: [p, E]
    }), u]
  }));
});
process.env.NODE_ENV !== "production" && (Nc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: v0,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * The icon to display.
   */
  icon: l.oneOfType([l.element, l.string]),
  /**
   * The position of the icon relative to the label.
   * @default 'top'
   */
  iconPosition: l.oneOf(["bottom", "end", "start", "top"]),
  /**
   * The label element.
   */
  label: l.node,
  /**
   * @ignore
   */
  onChange: l.func,
  /**
   * @ignore
   */
  onClick: l.func,
  /**
   * @ignore
   */
  onFocus: l.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: l.any,
  /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */
  wrapped: l.bool
});
const d7 = /* @__PURE__ */ y.createContext();
process.env.NODE_ENV !== "production" && (d7.displayName = "TableContext");
function _Z(e) {
  return _e("MuiTable", e);
}
Re("MuiTable", ["root", "stickyHeader"]);
const PZ = ["className", "component", "padding", "size", "stickyHeader"], LZ = (e) => {
  const {
    classes: t,
    stickyHeader: n
  } = e;
  return Oe({
    root: ["root", n && "stickyHeader"]
  }, _Z, t);
}, IZ = B("table", {
  name: "MuiTable",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.stickyHeader && t.stickyHeader];
  }
})(({
  theme: e,
  ownerState: t
}) => T({
  display: "table",
  width: "100%",
  borderCollapse: "collapse",
  borderSpacing: 0,
  "& caption": T({}, e.typography.body2, {
    padding: e.spacing(2),
    color: (e.vars || e).palette.text.secondary,
    textAlign: "left",
    captionSide: "bottom"
  })
}, t.stickyHeader && {
  borderCollapse: "separate"
})), om = "table", ww = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiTable"
  }), {
    className: r,
    component: i = om,
    padding: s = "normal",
    size: a = "medium",
    stickyHeader: c = !1
  } = o, d = le(o, PZ), u = T({}, o, {
    component: i,
    padding: s,
    size: a,
    stickyHeader: c
  }), p = LZ(u), h = y.useMemo(() => ({
    padding: s,
    size: a,
    stickyHeader: c
  }), [s, a, c]);
  return /* @__PURE__ */ f.jsx(d7.Provider, {
    value: h,
    children: /* @__PURE__ */ f.jsx(IZ, T({
      as: i,
      role: i === om ? null : "table",
      ref: n,
      className: xe(p.root, r),
      ownerState: u
    }, d))
  });
});
process.env.NODE_ENV !== "production" && (ww.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Allows TableCells to inherit padding of the Table.
   * @default 'normal'
   */
  padding: l.oneOf(["checkbox", "none", "normal"]),
  /**
   * Allows TableCells to inherit size of the Table.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE11.
   * @default false
   */
  stickyHeader: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const h2 = /* @__PURE__ */ y.createContext();
process.env.NODE_ENV !== "production" && (h2.displayName = "Tablelvl2Context");
function jZ(e) {
  return _e("MuiTableBody", e);
}
Re("MuiTableBody", ["root"]);
const VZ = ["className", "component"], DZ = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"]
  }, jZ, t);
}, AZ = B("tbody", {
  name: "MuiTableBody",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-row-group"
}), HZ = {
  variant: "body"
}, rm = "tbody", bd = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiTableBody"
  }), {
    className: r,
    component: i = rm
  } = o, s = le(o, VZ), a = T({}, o, {
    component: i
  }), c = DZ(a);
  return /* @__PURE__ */ f.jsx(h2.Provider, {
    value: HZ,
    children: /* @__PURE__ */ f.jsx(AZ, T({
      className: xe(c.root, r),
      as: i,
      ref: n,
      role: i === rm ? null : "rowgroup",
      ownerState: a
    }, s))
  });
});
process.env.NODE_ENV !== "production" && (bd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function FZ(e) {
  return _e("MuiTableCell", e);
}
const NZ = Re("MuiTableCell", ["root", "head", "body", "footer", "sizeSmall", "sizeMedium", "paddingCheckbox", "paddingNone", "alignLeft", "alignCenter", "alignRight", "alignJustify", "stickyHeader"]), $Z = ["align", "className", "component", "padding", "scope", "size", "sortDirection", "variant"], BZ = (e) => {
  const {
    classes: t,
    variant: n,
    align: o,
    padding: r,
    size: i,
    stickyHeader: s
  } = e, a = {
    root: ["root", n, s && "stickyHeader", o !== "inherit" && `align${pe(o)}`, r !== "normal" && `padding${pe(r)}`, `size${pe(i)}`]
  };
  return Oe(a, FZ, t);
}, zZ = B("td", {
  name: "MuiTableCell",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`size${pe(n.size)}`], n.padding !== "normal" && t[`padding${pe(n.padding)}`], n.align !== "inherit" && t[`align${pe(n.align)}`], n.stickyHeader && t.stickyHeader];
  }
})(({
  theme: e,
  ownerState: t
}) => T({}, e.typography.body2, {
  display: "table-cell",
  verticalAlign: "inherit",
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: e.vars ? `1px solid ${e.vars.palette.TableCell.border}` : `1px solid
    ${e.palette.mode === "light" ? va(gt(e.palette.divider, 1), 0.88) : ya(gt(e.palette.divider, 1), 0.68)}`,
  textAlign: "left",
  padding: 16
}, t.variant === "head" && {
  color: (e.vars || e).palette.text.primary,
  lineHeight: e.typography.pxToRem(24),
  fontWeight: e.typography.fontWeightMedium
}, t.variant === "body" && {
  color: (e.vars || e).palette.text.primary
}, t.variant === "footer" && {
  color: (e.vars || e).palette.text.secondary,
  lineHeight: e.typography.pxToRem(21),
  fontSize: e.typography.pxToRem(12)
}, t.size === "small" && {
  padding: "6px 16px",
  [`&.${NZ.paddingCheckbox}`]: {
    width: 24,
    // prevent the checkbox column from growing
    padding: "0 12px 0 16px",
    "& > *": {
      padding: 0
    }
  }
}, t.padding === "checkbox" && {
  width: 48,
  // prevent the checkbox column from growing
  padding: "0 0 0 4px"
}, t.padding === "none" && {
  padding: 0
}, t.align === "left" && {
  textAlign: "left"
}, t.align === "center" && {
  textAlign: "center"
}, t.align === "right" && {
  textAlign: "right",
  flexDirection: "row-reverse"
}, t.align === "justify" && {
  textAlign: "justify"
}, t.stickyHeader && {
  position: "sticky",
  top: 0,
  zIndex: 2,
  backgroundColor: (e.vars || e).palette.background.default
})), I0 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiTableCell"
  }), {
    align: r = "inherit",
    className: i,
    component: s,
    padding: a,
    scope: c,
    size: d,
    sortDirection: u,
    variant: p
  } = o, h = le(o, $Z), g = y.useContext(d7), m = y.useContext(h2), b = m && m.variant === "head";
  let C;
  s ? C = s : C = b ? "th" : "td";
  let x = c;
  C === "td" ? x = void 0 : !x && b && (x = "col");
  const v = p || m && m.variant, S = T({}, o, {
    align: r,
    component: C,
    padding: a || (g && g.padding ? g.padding : "normal"),
    size: d || (g && g.size ? g.size : "medium"),
    sortDirection: u,
    stickyHeader: v === "head" && g && g.stickyHeader,
    variant: v
  }), M = BZ(S);
  let w = null;
  return u && (w = u === "asc" ? "ascending" : "descending"), /* @__PURE__ */ f.jsx(zZ, T({
    as: C,
    ref: n,
    className: xe(M.root, i),
    "aria-sort": w,
    scope: x,
    ownerState: S
  }, h));
});
process.env.NODE_ENV !== "production" && (I0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */
  align: l.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */
  padding: l.oneOf(["checkbox", "none", "normal"]),
  /**
   * Set scope attribute.
   */
  scope: l.string,
  /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * Set aria-sort direction.
   */
  sortDirection: l.oneOf(["asc", "desc", !1]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */
  variant: l.oneOfType([l.oneOf(["body", "footer", "head"]), l.string])
});
function ZZ(e) {
  return _e("MuiTableFooter", e);
}
Re("MuiTableFooter", ["root"]);
const WZ = ["className", "component"], UZ = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"]
  }, ZZ, t);
}, GZ = B("tfoot", {
  name: "MuiTableFooter",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-footer-group"
}), qZ = {
  variant: "footer"
}, im = "tfoot", Sw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiTableFooter"
  }), {
    className: r,
    component: i = im
  } = o, s = le(o, WZ), a = T({}, o, {
    component: i
  }), c = UZ(a);
  return /* @__PURE__ */ f.jsx(h2.Provider, {
    value: qZ,
    children: /* @__PURE__ */ f.jsx(GZ, T({
      as: i,
      className: xe(c.root, r),
      ref: n,
      role: i === im ? null : "rowgroup",
      ownerState: a
    }, s))
  });
});
process.env.NODE_ENV !== "production" && (Sw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function KZ(e) {
  return _e("MuiTableHead", e);
}
Re("MuiTableHead", ["root"]);
const YZ = ["className", "component"], XZ = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"]
  }, KZ, t);
}, JZ = B("thead", {
  name: "MuiTableHead",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-header-group"
}), QZ = {
  variant: "head"
}, sm = "thead", Mw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiTableHead"
  }), {
    className: r,
    component: i = sm
  } = o, s = le(o, YZ), a = T({}, o, {
    component: i
  }), c = XZ(a);
  return /* @__PURE__ */ f.jsx(h2.Provider, {
    value: QZ,
    children: /* @__PURE__ */ f.jsx(JZ, T({
      as: i,
      className: xe(c.root, r),
      ref: n,
      role: i === sm ? null : "rowgroup",
      ownerState: a
    }, s))
  });
});
process.env.NODE_ENV !== "production" && (Mw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const eW = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft"), tW = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");
function nW(e) {
  return _e("MuiTableRow", e);
}
const am = Re("MuiTableRow", ["root", "selected", "hover", "head", "footer"]), oW = ["className", "component", "hover", "selected"], rW = (e) => {
  const {
    classes: t,
    selected: n,
    hover: o,
    head: r,
    footer: i
  } = e;
  return Oe({
    root: ["root", n && "selected", o && "hover", r && "head", i && "footer"]
  }, nW, t);
}, iW = B("tr", {
  name: "MuiTableRow",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.head && t.head, n.footer && t.footer];
  }
})(({
  theme: e
}) => ({
  color: "inherit",
  display: "table-row",
  verticalAlign: "middle",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  [`&.${am.hover}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${am.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : gt(e.palette.primary.main, e.palette.action.selectedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : gt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
    }
  }
})), lm = "tr", j0 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiTableRow"
  }), {
    className: r,
    component: i = lm,
    hover: s = !1,
    selected: a = !1
  } = o, c = le(o, oW), d = y.useContext(h2), u = T({}, o, {
    component: i,
    hover: s,
    selected: a,
    head: d && d.variant === "head",
    footer: d && d.variant === "footer"
  }), p = rW(u);
  return /* @__PURE__ */ f.jsx(iW, T({
    as: i,
    ref: n,
    className: xe(p.root, r),
    role: i === lm ? null : "row",
    ownerState: u
  }, c));
});
process.env.NODE_ENV !== "production" && (j0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Should be valid `<tr>` children such as `TableCell`.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the table row will shade on hover.
   * @default false
   */
  hover: l.bool,
  /**
   * If `true`, the table row will have the selected shading.
   * @default false
   */
  selected: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const sW = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), "ArrowDownward");
function aW(e) {
  return _e("MuiTableSortLabel", e);
}
const Uf = Re("MuiTableSortLabel", ["root", "active", "icon", "iconDirectionDesc", "iconDirectionAsc"]), lW = ["active", "children", "className", "direction", "hideSortIcon", "IconComponent"], cW = (e) => {
  const {
    classes: t,
    direction: n,
    active: o
  } = e, r = {
    root: ["root", o && "active"],
    icon: ["icon", `iconDirection${pe(n)}`]
  };
  return Oe(r, aW, t);
}, dW = B(wo, {
  name: "MuiTableSortLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.active && t.active];
  }
})(({
  theme: e
}) => ({
  cursor: "pointer",
  display: "inline-flex",
  justifyContent: "flex-start",
  flexDirection: "inherit",
  alignItems: "center",
  "&:focus": {
    color: (e.vars || e).palette.text.secondary
  },
  "&:hover": {
    color: (e.vars || e).palette.text.secondary,
    [`& .${Uf.icon}`]: {
      opacity: 0.5
    }
  },
  [`&.${Uf.active}`]: {
    color: (e.vars || e).palette.text.primary,
    [`& .${Uf.icon}`]: {
      opacity: 1,
      color: (e.vars || e).palette.text.secondary
    }
  }
})), uW = B("span", {
  name: "MuiTableSortLabel",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, t[`iconDirection${pe(n.direction)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => T({
  fontSize: 18,
  marginRight: 4,
  marginLeft: 4,
  opacity: 0,
  transition: e.transitions.create(["opacity", "transform"], {
    duration: e.transitions.duration.shorter
  }),
  userSelect: "none"
}, t.direction === "desc" && {
  transform: "rotate(0deg)"
}, t.direction === "asc" && {
  transform: "rotate(180deg)"
})), Tw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiTableSortLabel"
  }), {
    active: r = !1,
    children: i,
    className: s,
    direction: a = "asc",
    hideSortIcon: c = !1,
    IconComponent: d = sW
  } = o, u = le(o, lW), p = T({}, o, {
    active: r,
    direction: a,
    hideSortIcon: c,
    IconComponent: d
  }), h = cW(p);
  return /* @__PURE__ */ f.jsxs(dW, T({
    className: xe(h.root, s),
    component: "span",
    disableRipple: !0,
    ownerState: p,
    ref: n
  }, u, {
    children: [i, c && !r ? null : /* @__PURE__ */ f.jsx(uW, {
      as: d,
      className: xe(h.icon),
      ownerState: p
    })]
  }));
});
process.env.NODE_ENV !== "production" && (Tw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   * @default false
   */
  active: l.bool,
  /**
   * Label contents, the arrow will be appended automatically.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The current sort direction.
   * @default 'asc'
   */
  direction: l.oneOf(["asc", "desc"]),
  /**
   * Hide sort icon when active is false.
   * @default false
   */
  hideSortIcon: l.bool,
  /**
   * Sort icon to use.
   * @default ArrowDownwardIcon
   */
  IconComponent: l.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function fW(e) {
  return (1 + Math.sin(Math.PI * e - Math.PI / 2)) / 2;
}
function pW(e, t, n, o = {}, r = () => {
}) {
  const {
    ease: i = fW,
    duration: s = 300
    // standard
  } = o;
  let a = null;
  const c = t[e];
  let d = !1;
  const u = () => {
    d = !0;
  }, p = (h) => {
    if (d) {
      r(new Error("Animation cancelled"));
      return;
    }
    a === null && (a = h);
    const g = Math.min(1, (h - a) / s);
    if (t[e] = i(g) * (n - c) + c, g >= 1) {
      requestAnimationFrame(() => {
        r(null);
      });
      return;
    }
    requestAnimationFrame(p);
  };
  return c === n ? (r(new Error("Element already at target position")), u) : (requestAnimationFrame(p), u);
}
const hW = ["onChange"], gW = {
  width: 99,
  height: 99,
  position: "absolute",
  top: -9999,
  overflow: "scroll"
};
function kw(e) {
  const {
    onChange: t
  } = e, n = le(e, hW), o = y.useRef(), r = y.useRef(null), i = () => {
    o.current = r.current.offsetHeight - r.current.clientHeight;
  };
  return En(() => {
    const s = n2(() => {
      const c = o.current;
      i(), c !== o.current && t(o.current);
    }), a = ri(r.current);
    return a.addEventListener("resize", s), () => {
      s.clear(), a.removeEventListener("resize", s);
    };
  }, [t]), y.useEffect(() => {
    i(), t(o.current);
  }, [t]), /* @__PURE__ */ f.jsx("div", T({
    style: gW
  }, n, {
    ref: r
  }));
}
process.env.NODE_ENV !== "production" && (kw.propTypes = {
  onChange: l.func.isRequired
});
function mW(e) {
  return _e("MuiTabScrollButton", e);
}
const bW = Re("MuiTabScrollButton", ["root", "vertical", "horizontal", "disabled"]), CW = ["className", "slots", "slotProps", "direction", "orientation", "disabled"], xW = (e) => {
  const {
    classes: t,
    orientation: n,
    disabled: o
  } = e;
  return Oe({
    root: ["root", n, o && "disabled"]
  }, mW, t);
}, yW = B(wo, {
  name: "MuiTabScrollButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.orientation && t[n.orientation]];
  }
})(({
  ownerState: e
}) => T({
  width: 40,
  flexShrink: 0,
  opacity: 0.8,
  [`&.${bW.disabled}`]: {
    opacity: 0
  }
}, e.orientation === "vertical" && {
  width: "100%",
  height: 40,
  "& svg": {
    transform: `rotate(${e.isRtl ? -90 : 90}deg)`
  }
})), Ew = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r;
  const i = Xe({
    props: t,
    name: "MuiTabScrollButton"
  }), {
    className: s,
    slots: a = {},
    slotProps: c = {},
    direction: d
  } = i, u = le(i, CW), p = Ms(), h = T({
    isRtl: p
  }, i), g = xW(h), m = (o = a.StartScrollButtonIcon) != null ? o : eW, b = (r = a.EndScrollButtonIcon) != null ? r : tW, C = Ft({
    elementType: m,
    externalSlotProps: c.startScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: h
  }), x = Ft({
    elementType: b,
    externalSlotProps: c.endScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: h
  });
  return /* @__PURE__ */ f.jsx(yW, T({
    component: "div",
    className: xe(g.root, s),
    ref: n,
    role: null,
    ownerState: h,
    tabIndex: null
  }, u, {
    children: d === "left" ? /* @__PURE__ */ f.jsx(m, T({}, C)) : /* @__PURE__ */ f.jsx(b, T({}, x))
  }));
});
process.env.NODE_ENV !== "production" && (Ew.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The direction the button should indicate.
   */
  direction: l.oneOf(["left", "right"]).isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * The component orientation (layout flow direction).
   */
  orientation: l.oneOf(["horizontal", "vertical"]).isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: l.shape({
    endScrollButtonIcon: l.oneOfType([l.func, l.object]),
    startScrollButtonIcon: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: l.shape({
    EndScrollButtonIcon: l.elementType,
    StartScrollButtonIcon: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function vW(e) {
  return _e("MuiTabs", e);
}
const Cd = Re("MuiTabs", ["root", "vertical", "flexContainer", "flexContainerVertical", "centered", "scroller", "fixed", "scrollableX", "scrollableY", "hideScrollbar", "scrollButtons", "scrollButtonsHideMobile", "indicator"]), wW = ["aria-label", "aria-labelledby", "action", "centered", "children", "className", "component", "allowScrollButtonsMobile", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "selectionFollowsFocus", "slots", "slotProps", "TabIndicatorProps", "TabScrollButtonProps", "textColor", "value", "variant", "visibleScrollbar"], cm = (e, t) => e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : e.firstChild, dm = (e, t) => e === t ? e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : e.lastChild, h1 = (e, t, n) => {
  let o = !1, r = n(e, t);
  for (; r; ) {
    if (r === e.firstChild) {
      if (o)
        return;
      o = !0;
    }
    const i = r.disabled || r.getAttribute("aria-disabled") === "true";
    if (!r.hasAttribute("tabindex") || i)
      r = n(e, r);
    else {
      r.focus();
      return;
    }
  }
}, SW = (e) => {
  const {
    vertical: t,
    fixed: n,
    hideScrollbar: o,
    scrollableX: r,
    scrollableY: i,
    centered: s,
    scrollButtonsHideMobile: a,
    classes: c
  } = e;
  return Oe({
    root: ["root", t && "vertical"],
    scroller: ["scroller", n && "fixed", o && "hideScrollbar", r && "scrollableX", i && "scrollableY"],
    flexContainer: ["flexContainer", t && "flexContainerVertical", s && "centered"],
    indicator: ["indicator"],
    scrollButtons: ["scrollButtons", a && "scrollButtonsHideMobile"],
    scrollableX: [r && "scrollableX"],
    hideScrollbar: [o && "hideScrollbar"]
  }, vW, c);
}, MW = B("div", {
  name: "MuiTabs",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${Cd.scrollButtons}`]: t.scrollButtons
    }, {
      [`& .${Cd.scrollButtons}`]: n.scrollButtonsHideMobile && t.scrollButtonsHideMobile
    }, t.root, n.vertical && t.vertical];
  }
})(({
  ownerState: e,
  theme: t
}) => T({
  overflow: "hidden",
  minHeight: 48,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  display: "flex"
}, e.vertical && {
  flexDirection: "column"
}, e.scrollButtonsHideMobile && {
  [`& .${Cd.scrollButtons}`]: {
    [t.breakpoints.down("sm")]: {
      display: "none"
    }
  }
})), TW = B("div", {
  name: "MuiTabs",
  slot: "Scroller",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.scroller, n.fixed && t.fixed, n.hideScrollbar && t.hideScrollbar, n.scrollableX && t.scrollableX, n.scrollableY && t.scrollableY];
  }
})(({
  ownerState: e
}) => T({
  position: "relative",
  display: "inline-block",
  flex: "1 1 auto",
  whiteSpace: "nowrap"
}, e.fixed && {
  overflowX: "hidden",
  width: "100%"
}, e.hideScrollbar && {
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}, e.scrollableX && {
  overflowX: "auto",
  overflowY: "hidden"
}, e.scrollableY && {
  overflowY: "auto",
  overflowX: "hidden"
})), kW = B("div", {
  name: "MuiTabs",
  slot: "FlexContainer",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.flexContainer, n.vertical && t.flexContainerVertical, n.centered && t.centered];
  }
})(({
  ownerState: e
}) => T({
  display: "flex"
}, e.vertical && {
  flexDirection: "column"
}, e.centered && {
  justifyContent: "center"
})), EW = B("span", {
  name: "MuiTabs",
  slot: "Indicator",
  overridesResolver: (e, t) => t.indicator
})(({
  ownerState: e,
  theme: t
}) => T({
  position: "absolute",
  height: 2,
  bottom: 0,
  width: "100%",
  transition: t.transitions.create()
}, e.indicatorColor === "primary" && {
  backgroundColor: (t.vars || t).palette.primary.main
}, e.indicatorColor === "secondary" && {
  backgroundColor: (t.vars || t).palette.secondary.main
}, e.vertical && {
  height: "100%",
  width: 2,
  right: 0
})), RW = B(kw)({
  overflowX: "auto",
  overflowY: "hidden",
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}), um = {};
let fm = !1;
const L3 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiTabs"
  }), r = ge(), i = Ms(), {
    "aria-label": s,
    "aria-labelledby": a,
    action: c,
    centered: d = !1,
    children: u,
    className: p,
    component: h = "div",
    allowScrollButtonsMobile: g = !1,
    indicatorColor: m = "primary",
    onChange: b,
    orientation: C = "horizontal",
    ScrollButtonComponent: x = Ew,
    scrollButtons: v = "auto",
    selectionFollowsFocus: S,
    slots: M = {},
    slotProps: w = {},
    TabIndicatorProps: k = {},
    TabScrollButtonProps: E = {},
    textColor: R = "primary",
    value: O,
    variant: P = "standard",
    visibleScrollbar: _ = !1
  } = o, L = le(o, wW), V = P === "scrollable", j = C === "vertical", I = j ? "scrollTop" : "scrollLeft", F = j ? "top" : "left", $ = j ? "bottom" : "right", A = j ? "clientHeight" : "clientWidth", H = j ? "height" : "width", N = T({}, o, {
    component: h,
    allowScrollButtonsMobile: g,
    indicatorColor: m,
    orientation: C,
    vertical: j,
    scrollButtons: v,
    textColor: R,
    variant: P,
    visibleScrollbar: _,
    fixed: !V,
    hideScrollbar: V && !_,
    scrollableX: V && !j,
    scrollableY: V && j,
    centered: d && !V,
    scrollButtonsHideMobile: !g
  }), z = SW(N), se = Ft({
    elementType: M.StartScrollButtonIcon,
    externalSlotProps: w.startScrollButtonIcon,
    ownerState: N
  }), ne = Ft({
    elementType: M.EndScrollButtonIcon,
    externalSlotProps: w.endScrollButtonIcon,
    ownerState: N
  });
  process.env.NODE_ENV !== "production" && d && V && console.error('MUI: You can not use the `centered={true}` and `variant="scrollable"` properties at the same time on a `Tabs` component.');
  const [Z, q] = y.useState(!1), [G, K] = y.useState(um), [Q, re] = y.useState(!1), [U, W] = y.useState(!1), [D, X] = y.useState(!1), [de, ue] = y.useState({
    overflow: "hidden",
    scrollbarWidth: 0
  }), he = /* @__PURE__ */ new Map(), Ue = y.useRef(null), me = y.useRef(null), Ie = () => {
    const Ce = Ue.current;
    let Se;
    if (Ce) {
      const Be = Ce.getBoundingClientRect();
      Se = {
        clientWidth: Ce.clientWidth,
        scrollLeft: Ce.scrollLeft,
        scrollTop: Ce.scrollTop,
        scrollLeftNormalized: TI(Ce, i ? "rtl" : "ltr"),
        scrollWidth: Ce.scrollWidth,
        top: Be.top,
        bottom: Be.bottom,
        left: Be.left,
        right: Be.right
      };
    }
    let ve;
    if (Ce && O !== !1) {
      const Be = me.current.children;
      if (Be.length > 0) {
        const rt = Be[he.get(O)];
        process.env.NODE_ENV !== "production" && (rt || console.error(["MUI: The `value` provided to the Tabs component is invalid.", `None of the Tabs' children match with "${O}".`, he.keys ? `You can provide one of the following values: ${Array.from(he.keys()).join(", ")}.` : null].join(`
`))), ve = rt ? rt.getBoundingClientRect() : null, process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && !fm && ve && ve.width === 0 && ve.height === 0 && // if the whole Tabs component is hidden, don't warn
        Se.clientWidth !== 0 && (Se = null, console.error(["MUI: The `value` provided to the Tabs component is invalid.", `The Tab with this \`value\` ("${O}") is not part of the document layout.`, "Make sure the tab item is present in the document or that it's not `display: none`."].join(`
`)), fm = !0);
      }
    }
    return {
      tabsMeta: Se,
      tabMeta: ve
    };
  }, te = Ke(() => {
    const {
      tabsMeta: Ce,
      tabMeta: Se
    } = Ie();
    let ve = 0, Be;
    if (j)
      Be = "top", Se && Ce && (ve = Se.top - Ce.top + Ce.scrollTop);
    else if (Be = i ? "right" : "left", Se && Ce) {
      const pt = i ? Ce.scrollLeftNormalized + Ce.clientWidth - Ce.scrollWidth : Ce.scrollLeft;
      ve = (i ? -1 : 1) * (Se[Be] - Ce[Be] + pt);
    }
    const rt = {
      [Be]: ve,
      // May be wrong until the font is loaded.
      [H]: Se ? Se[H] : 0
    };
    if (isNaN(G[Be]) || isNaN(G[H]))
      K(rt);
    else {
      const pt = Math.abs(G[Be] - rt[Be]), Je = Math.abs(G[H] - rt[H]);
      (pt >= 1 || Je >= 1) && K(rt);
    }
  }), ie = (Ce, {
    animation: Se = !0
  } = {}) => {
    Se ? pW(I, Ue.current, Ce, {
      duration: r.transitions.duration.standard
    }) : Ue.current[I] = Ce;
  }, ye = (Ce) => {
    let Se = Ue.current[I];
    j ? Se += Ce : (Se += Ce * (i ? -1 : 1), Se *= i && pv() === "reverse" ? -1 : 1), ie(Se);
  }, Ne = () => {
    const Ce = Ue.current[A];
    let Se = 0;
    const ve = Array.from(me.current.children);
    for (let Be = 0; Be < ve.length; Be += 1) {
      const rt = ve[Be];
      if (Se + rt[A] > Ce) {
        Be === 0 && (Se = Ce);
        break;
      }
      Se += rt[A];
    }
    return Se;
  }, We = () => {
    ye(-1 * Ne());
  }, qe = () => {
    ye(Ne());
  }, Me = y.useCallback((Ce) => {
    ue({
      overflow: null,
      scrollbarWidth: Ce
    });
  }, []), Pe = () => {
    const Ce = {};
    Ce.scrollbarSizeListener = V ? /* @__PURE__ */ f.jsx(RW, {
      onChange: Me,
      className: xe(z.scrollableX, z.hideScrollbar)
    }) : null;
    const ve = V && (v === "auto" && (Q || U) || v === !0);
    return Ce.scrollButtonStart = ve ? /* @__PURE__ */ f.jsx(x, T({
      slots: {
        StartScrollButtonIcon: M.StartScrollButtonIcon
      },
      slotProps: {
        startScrollButtonIcon: se
      },
      orientation: C,
      direction: i ? "right" : "left",
      onClick: We,
      disabled: !Q
    }, E, {
      className: xe(z.scrollButtons, E.className)
    })) : null, Ce.scrollButtonEnd = ve ? /* @__PURE__ */ f.jsx(x, T({
      slots: {
        EndScrollButtonIcon: M.EndScrollButtonIcon
      },
      slotProps: {
        endScrollButtonIcon: ne
      },
      orientation: C,
      direction: i ? "left" : "right",
      onClick: qe,
      disabled: !U
    }, E, {
      className: xe(z.scrollButtons, E.className)
    })) : null, Ce;
  }, fe = Ke((Ce) => {
    const {
      tabsMeta: Se,
      tabMeta: ve
    } = Ie();
    if (!(!ve || !Se)) {
      if (ve[F] < Se[F]) {
        const Be = Se[I] + (ve[F] - Se[F]);
        ie(Be, {
          animation: Ce
        });
      } else if (ve[$] > Se[$]) {
        const Be = Se[I] + (ve[$] - Se[$]);
        ie(Be, {
          animation: Ce
        });
      }
    }
  }), ae = Ke(() => {
    V && v !== !1 && X(!D);
  });
  y.useEffect(() => {
    const Ce = n2(() => {
      Ue.current && te();
    });
    let Se;
    const ve = (pt) => {
      pt.forEach((Je) => {
        Je.removedNodes.forEach((At) => {
          var Ht;
          (Ht = Se) == null || Ht.unobserve(At);
        }), Je.addedNodes.forEach((At) => {
          var Ht;
          (Ht = Se) == null || Ht.observe(At);
        });
      }), Ce(), ae();
    }, Be = ri(Ue.current);
    Be.addEventListener("resize", Ce);
    let rt;
    return typeof ResizeObserver < "u" && (Se = new ResizeObserver(Ce), Array.from(me.current.children).forEach((pt) => {
      Se.observe(pt);
    })), typeof MutationObserver < "u" && (rt = new MutationObserver(ve), rt.observe(me.current, {
      childList: !0
    })), () => {
      var pt, Je;
      Ce.clear(), Be.removeEventListener("resize", Ce), (pt = rt) == null || pt.disconnect(), (Je = Se) == null || Je.disconnect();
    };
  }, [te, ae]), y.useEffect(() => {
    const Ce = Array.from(me.current.children), Se = Ce.length;
    if (typeof IntersectionObserver < "u" && Se > 0 && V && v !== !1) {
      const ve = Ce[0], Be = Ce[Se - 1], rt = {
        root: Ue.current,
        threshold: 0.99
      }, pt = (Ct) => {
        re(!Ct[0].isIntersecting);
      }, Je = new IntersectionObserver(pt, rt);
      Je.observe(ve);
      const At = (Ct) => {
        W(!Ct[0].isIntersecting);
      }, Ht = new IntersectionObserver(At, rt);
      return Ht.observe(Be), () => {
        Je.disconnect(), Ht.disconnect();
      };
    }
  }, [V, v, D, u == null ? void 0 : u.length]), y.useEffect(() => {
    q(!0);
  }, []), y.useEffect(() => {
    te();
  }), y.useEffect(() => {
    fe(um !== G);
  }, [fe, G]), y.useImperativeHandle(c, () => ({
    updateIndicator: te,
    updateScrollButtons: ae
  }), [te, ae]);
  const Te = /* @__PURE__ */ f.jsx(EW, T({}, k, {
    className: xe(z.indicator, k.className),
    ownerState: N,
    style: T({}, G, k.style)
  }));
  let tt = 0;
  const Ye = y.Children.map(u, (Ce) => {
    if (!/* @__PURE__ */ y.isValidElement(Ce))
      return null;
    process.env.NODE_ENV !== "production" && xa.isFragment(Ce) && console.error(["MUI: The Tabs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    const Se = Ce.props.value === void 0 ? tt : Ce.props.value;
    he.set(Se, tt);
    const ve = Se === O;
    return tt += 1, /* @__PURE__ */ y.cloneElement(Ce, T({
      fullWidth: P === "fullWidth",
      indicator: ve && !Z && Te,
      selected: ve,
      selectionFollowsFocus: S,
      onChange: b,
      textColor: R,
      value: Se
    }, tt === 1 && O === !1 && !Ce.props.tabIndex ? {
      tabIndex: 0
    } : {}));
  }), Le = (Ce) => {
    const Se = me.current, ve = gn(Se).activeElement;
    if (ve.getAttribute("role") !== "tab")
      return;
    let rt = C === "horizontal" ? "ArrowLeft" : "ArrowUp", pt = C === "horizontal" ? "ArrowRight" : "ArrowDown";
    switch (C === "horizontal" && i && (rt = "ArrowRight", pt = "ArrowLeft"), Ce.key) {
      case rt:
        Ce.preventDefault(), h1(Se, ve, dm);
        break;
      case pt:
        Ce.preventDefault(), h1(Se, ve, cm);
        break;
      case "Home":
        Ce.preventDefault(), h1(Se, null, cm);
        break;
      case "End":
        Ce.preventDefault(), h1(Se, null, dm);
        break;
    }
  }, Ve = Pe();
  return /* @__PURE__ */ f.jsxs(MW, T({
    className: xe(z.root, p),
    ownerState: N,
    ref: n,
    as: h
  }, L, {
    children: [Ve.scrollButtonStart, Ve.scrollbarSizeListener, /* @__PURE__ */ f.jsxs(TW, {
      className: z.scroller,
      ownerState: N,
      style: {
        overflow: de.overflow,
        [j ? `margin${i ? "Left" : "Right"}` : "marginBottom"]: _ ? void 0 : -de.scrollbarWidth
      },
      ref: Ue,
      children: [/* @__PURE__ */ f.jsx(kW, {
        "aria-label": s,
        "aria-labelledby": a,
        "aria-orientation": C === "vertical" ? "vertical" : null,
        className: z.flexContainer,
        ownerState: N,
        onKeyDown: Le,
        ref: me,
        role: "tablist",
        children: Ye
      }), Z && Te]
    }), Ve.scrollButtonEnd]
  }));
});
process.env.NODE_ENV !== "production" && (L3.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: sn,
  /**
   * If `true`, the scroll buttons aren't forced hidden on mobile.
   * By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
   * @default false
   */
  allowScrollButtonsMobile: l.bool,
  /**
   * The label for the Tabs as a string.
   */
  "aria-label": l.string,
  /**
   * An id or list of ids separated by a space that label the Tabs.
   */
  "aria-labelledby": l.string,
  /**
   * If `true`, the tabs are centered.
   * This prop is intended for large views.
   * @default false
   */
  centered: l.bool,
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Determines the color of the indicator.
   * @default 'primary'
   */
  indicatorColor: l.oneOfType([l.oneOf(["primary", "secondary"]), l.string]),
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child (number)
   */
  onChange: l.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: l.oneOf(["horizontal", "vertical"]),
  /**
   * The component used to render the scroll buttons.
   * @default TabScrollButton
   */
  ScrollButtonComponent: l.elementType,
  /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `true` will always present them.
   * - `false` will never present them.
   *
   * By default the scroll buttons are hidden on mobile.
   * This behavior can be disabled with `allowScrollButtonsMobile`.
   * @default 'auto'
   */
  scrollButtons: l.oneOf(["auto", !1, !0]),
  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: l.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: l.shape({
    endScrollButtonIcon: l.oneOfType([l.func, l.object]),
    startScrollButtonIcon: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: l.shape({
    EndScrollButtonIcon: l.elementType,
    StartScrollButtonIcon: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Props applied to the tab indicator element.
   * @default  {}
   */
  TabIndicatorProps: l.object,
  /**
   * Props applied to the [`TabScrollButton`](/material-ui/api/tab-scroll-button/) element.
   * @default {}
   */
  TabScrollButtonProps: l.object,
  /**
   * Determines the color of the `Tab`.
   * @default 'primary'
   */
  textColor: l.oneOf(["inherit", "primary", "secondary"]),
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `false`.
   */
  value: l.any,
  /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  - `fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   * @default 'standard'
   */
  variant: l.oneOf(["fullWidth", "scrollable", "standard"]),
  /**
   * If `true`, the scrollbar is visible. It can be useful when displaying
   * a long vertical list of tabs.
   * @default false
   */
  visibleScrollbar: l.bool
});
function OW(e) {
  return _e("MuiTextField", e);
}
Re("MuiTextField", ["root"]);
const _W = ["autoComplete", "autoFocus", "children", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "select", "SelectProps", "type", "value", "variant"], PW = {
  standard: O3,
  filled: E3,
  outlined: _3
}, LW = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"]
  }, OW, t);
}, IW = B(R3, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Ir = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xe({
    props: t,
    name: "MuiTextField"
  }), {
    autoComplete: r,
    autoFocus: i = !1,
    children: s,
    className: a,
    color: c = "primary",
    defaultValue: d,
    disabled: u = !1,
    error: p = !1,
    FormHelperTextProps: h,
    fullWidth: g = !1,
    helperText: m,
    id: b,
    InputLabelProps: C,
    inputProps: x,
    InputProps: v,
    inputRef: S,
    label: M,
    maxRows: w,
    minRows: k,
    multiline: E = !1,
    name: R,
    onBlur: O,
    onChange: P,
    onFocus: _,
    placeholder: L,
    required: V = !1,
    rows: j,
    select: I = !1,
    SelectProps: F,
    type: $,
    value: A,
    variant: H = "outlined"
  } = o, N = le(o, _W), z = T({}, o, {
    autoFocus: i,
    color: c,
    disabled: u,
    error: p,
    fullWidth: g,
    multiline: E,
    required: V,
    select: I,
    variant: H
  }), se = LW(z);
  process.env.NODE_ENV !== "production" && I && !s && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const ne = {};
  H === "outlined" && (C && typeof C.shrink < "u" && (ne.notched = C.shrink), ne.label = M), I && ((!F || !F.native) && (ne.id = void 0), ne["aria-describedby"] = void 0);
  const Z = di(b), q = m && Z ? `${Z}-helper-text` : void 0, G = M && Z ? `${Z}-label` : void 0, K = PW[H], Q = /* @__PURE__ */ f.jsx(K, T({
    "aria-describedby": q,
    autoComplete: r,
    autoFocus: i,
    defaultValue: d,
    fullWidth: g,
    multiline: E,
    name: R,
    rows: j,
    maxRows: w,
    minRows: k,
    type: $,
    value: A,
    id: Z,
    inputRef: S,
    onBlur: O,
    onChange: P,
    onFocus: _,
    placeholder: L,
    inputProps: x
  }, ne, v));
  return /* @__PURE__ */ f.jsxs(IW, T({
    className: xe(se.root, a),
    disabled: u,
    error: p,
    fullWidth: g,
    ref: n,
    required: V,
    color: c,
    variant: H,
    ownerState: z
  }, N, {
    children: [M != null && M !== "" && /* @__PURE__ */ f.jsx(Q4, T({
      htmlFor: Z,
      id: G
    }, C, {
      children: M
    })), I ? /* @__PURE__ */ f.jsx(L0, T({
      "aria-describedby": q,
      id: Z,
      labelId: G,
      value: A,
      input: Q
    }, F, {
      children: s
    })) : Q, m && /* @__PURE__ */ f.jsx(J4, T({
      id: q
    }, h, {
      children: m
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (Ir.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: l.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: l.bool,
  /**
   * @ignore
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: l.bool,
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: l.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The helper text content.
   */
  helperText: l.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: l.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: l.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: l.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: l.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: l.oneOfType([l.number, l.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: l.oneOfType([l.number, l.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: l.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  /**
   * @ignore
   */
  onBlur: l.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: l.func,
  /**
   * @ignore
   */
  onFocus: l.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: l.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: l.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: l.oneOfType([l.number, l.string]),
  /**
   * Render a [`Select`](/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: l.bool,
  /**
   * Props applied to the [`Select`](/material-ui/api/select/) element.
   */
  SelectProps: l.object,
  /**
   * The size of the component.
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: l.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: l.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: l.oneOf(["filled", "outlined", "standard"])
});
function jW(e) {
  return _e("MuiToggleButton", e);
}
const pm = Re("MuiToggleButton", ["root", "disabled", "selected", "standard", "primary", "secondary", "sizeSmall", "sizeMedium", "sizeLarge", "fullWidth"]), Rw = /* @__PURE__ */ y.createContext({});
process.env.NODE_ENV !== "production" && (Rw.displayName = "ToggleButtonGroupContext");
const Ow = /* @__PURE__ */ y.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ow.displayName = "ToggleButtonGroupButtonContext");
function VW(e, t) {
  return t === void 0 || e === void 0 ? !1 : Array.isArray(t) ? t.indexOf(e) >= 0 : e === t;
}
const DW = ["value"], AW = ["children", "className", "color", "disabled", "disableFocusRipple", "fullWidth", "onChange", "onClick", "selected", "size", "value"], HW = (e) => {
  const {
    classes: t,
    fullWidth: n,
    selected: o,
    disabled: r,
    size: i,
    color: s
  } = e, a = {
    root: ["root", o && "selected", r && "disabled", n && "fullWidth", `size${pe(i)}`, s]
  };
  return Oe(a, jW, t);
}, FW = B(wo, {
  name: "MuiToggleButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`size${pe(n.size)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  let n = t.color === "standard" ? e.palette.text.primary : e.palette[t.color].main, o;
  return e.vars && (n = t.color === "standard" ? e.vars.palette.text.primary : e.vars.palette[t.color].main, o = t.color === "standard" ? e.vars.palette.text.primaryChannel : e.vars.palette[t.color].mainChannel), T({}, e.typography.button, {
    borderRadius: (e.vars || e).shape.borderRadius,
    padding: 11,
    border: `1px solid ${(e.vars || e).palette.divider}`,
    color: (e.vars || e).palette.action.active
  }, t.fullWidth && {
    width: "100%"
  }, {
    [`&.${pm.disabled}`]: {
      color: (e.vars || e).palette.action.disabled,
      border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
    },
    "&:hover": {
      textDecoration: "none",
      // Reset on mouse devices
      backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : $t(e.palette.text.primary, e.palette.action.hoverOpacity),
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    [`&.${pm.selected}`]: {
      color: n,
      backgroundColor: e.vars ? `rgba(${o} / ${e.vars.palette.action.selectedOpacity})` : $t(n, e.palette.action.selectedOpacity),
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${o} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : $t(n, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: e.vars ? `rgba(${o} / ${e.vars.palette.action.selectedOpacity})` : $t(n, e.palette.action.selectedOpacity)
        }
      }
    }
  }, t.size === "small" && {
    padding: 7,
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && {
    padding: 15,
    fontSize: e.typography.pxToRem(15)
  });
}), I3 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = y.useContext(Rw), {
    value: r
  } = o, i = le(o, DW), s = y.useContext(Ow), a = Ll(T({}, i, {
    selected: VW(t.value, r)
  }), t), c = Xe({
    props: a,
    name: "MuiToggleButton"
  }), {
    children: d,
    className: u,
    color: p = "standard",
    disabled: h = !1,
    disableFocusRipple: g = !1,
    fullWidth: m = !1,
    onChange: b,
    onClick: C,
    selected: x,
    size: v = "medium",
    value: S
  } = c, M = le(c, AW), w = T({}, c, {
    color: p,
    disabled: h,
    disableFocusRipple: g,
    fullWidth: m,
    size: v
  }), k = HW(w), E = (O) => {
    C && (C(O, S), O.defaultPrevented) || b && b(O, S);
  }, R = s || "";
  return /* @__PURE__ */ f.jsx(FW, T({
    className: xe(i.className, k.root, u, R),
    disabled: h,
    focusRipple: !g,
    ref: n,
    onClick: E,
    onChange: b,
    value: S,
    ownerState: w,
    "aria-pressed": x
  }, M, {
    children: d
  }));
});
process.env.NODE_ENV !== "production" && (I3.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the button when it is in an active state.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: l.oneOfType([l.oneOf(["standard", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * Callback fired when the state changes.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected button.
   */
  onChange: l.func,
  /**
   * Callback fired when the button is clicked.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected button.
   */
  onClick: l.func,
  /**
   * If `true`, the button is rendered in an active state.
   */
  selected: l.bool,
  /**
   * The size of the component.
   * The prop defaults to the value inherited from the parent ToggleButtonGroup component.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["small", "medium", "large"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The value to associate with the button when selected in a
   * ToggleButtonGroup.
   */
  value: l.any.isRequired
});
const ms = (e) => {
  const t = ge(), { value: n, unit: o, size: r = "small", position: i = "default-side", colorOverride: s } = e, a = `number-${r}`, c = () => r === "micro" || r === "small";
  let d = 0;
  return r === "small" || r === "micro" ? d = -1 : (r === "inter" || r === "big") && (d = -2), /* @__PURE__ */ f.jsxs(
    be,
    {
      display: "inline-flex",
      direction: i == "default-side" ? "row" : "column",
      spacing: c() ? 0.5 : 1,
      alignItems: i === "below-center-aligned" ? "center" : "baseline",
      children: [
        /* @__PURE__ */ f.jsx(oe, { variant: a, color: s, children: n }),
        /* @__PURE__ */ f.jsx(
          oe,
          {
            sx: {
              marginTop: `${d}px !important`
            },
            variant: c() ? "small-medium" : "body-medium",
            color: t.custom.grey[1400],
            children: o
          }
        )
      ]
    }
  );
}, NW = {
  A: "#1e8f4e",
  B: "#37cb78",
  C: "#ebc22c",
  D: "#ec7f2a",
  E: "#d7392e"
}, gxe = (e) => {
  const { score: t, value: n, size: o = 14, direction: r = "row" } = e;
  return /* @__PURE__ */ f.jsxs(be, { direction: r, alignItems: "center", width: "fit-content", spacing: 1, children: [
    /* @__PURE__ */ f.jsx(hs, { color: "primary", label: t, style: { backgroundColor: NW[t], fontWeight: 700 } }),
    /* @__PURE__ */ f.jsxs(oe, { fontSize: o, fontWeight: "bold", children: [
      n,
      " / 100"
    ] })
  ] });
}, u7 = (e) => {
  const t = ge(), { value: n, unit: o, ...r } = e;
  return /* @__PURE__ */ f.jsx(
    J,
    {
      display: "inline-flex",
      bgcolor: t.custom.grey[200],
      border: `1px solid ${t.custom.grey[500]}`,
      borderRadius: "4px",
      padding: "4px 8px",
      position: "relative",
      ...r,
      children: /* @__PURE__ */ f.jsx(ms, { value: n, unit: o })
    }
  );
}, $W = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 6L6 34C6 34 30.9529 34 34 34L34 6H6ZM10.5482 8.625H29.5192L20.2061 17.938L10.5482 8.625ZM8.625 10.4172V29.5189L18.3496 19.7944L8.625 10.4172ZM20.2395 21.6168L10.4812 31.375H30.3592L20.2395 21.6168ZM31.375 28.7079V10.4815L22.096 19.7604L31.375 28.7079Z", fill: "currentColor" })), BW = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M4.9443 16.3611V13.5833H12.0554C12.8269 13.5833 13.4874 13.8542 14.0368 14.3958C14.5863 14.9375 14.9073 15.5926 14.9998 16.3611H4.9443ZM9.7188 31.8889C11.1839 31.8889 12.4304 31.3761 13.4582 30.3505C14.4859 29.3249 14.9998 28.0795 14.9998 26.6144C14.9998 25.1492 14.487 23.9028 13.4614 22.875C12.4358 21.8472 11.1905 21.3333 9.72534 21.3333C8.26017 21.3333 7.0137 21.8461 5.98592 22.8717C4.95814 23.8973 4.44425 25.1427 4.44425 26.6078C4.44425 28.073 4.95706 29.3195 5.98267 30.3472C7.00828 31.375 8.25366 31.8889 9.7188 31.8889ZM32.6338 31.8889C33.4427 31.8889 34.1318 31.6058 34.7013 31.0396C35.2707 30.4735 35.5554 29.786 35.5554 28.9771C35.5554 28.1683 35.2723 27.4792 34.7061 26.9097C34.14 26.3403 33.4525 26.0555 32.6436 26.0555C31.8348 26.0555 31.1457 26.3386 30.5762 26.9048C30.0068 27.471 29.722 28.1585 29.722 28.9673C29.722 29.7762 30.0051 30.4653 30.5713 31.0347C31.1375 31.6042 31.825 31.8889 32.6338 31.8889ZM9.72534 29.3889C8.95462 29.3889 8.29842 29.1192 7.75675 28.5797C7.21509 28.0402 6.94425 27.3851 6.94425 26.6144C6.94425 25.8437 7.214 25.1875 7.7535 24.6458C8.293 24.1042 8.9481 23.8333 9.7188 23.8333C10.4895 23.8333 11.1457 24.1031 11.6873 24.6426C12.229 25.1821 12.4998 25.8371 12.4998 26.6078C12.4998 27.3786 12.2301 28.0347 11.6906 28.5764C11.1511 29.1181 10.496 29.3889 9.72534 29.3889ZM33.611 23.3473C34.2035 23.4861 34.6943 23.6505 35.0832 23.8403C35.4721 24.0301 35.9072 24.3241 36.3887 24.7222V11.3611H22.5554L20.6109 9.38888L23.1109 6.88888L22.222 6L16.3332 11.8889L17.2498 12.8055L19.722 10.3333L21.6665 12.24V16.4167C21.6665 17.4938 21.2938 18.4158 20.5485 19.1828C19.8031 19.9498 18.8887 20.3333 17.8054 20.3333H14.7637C15.2915 20.75 15.7082 21.162 16.0137 21.5695C16.3193 21.9769 16.648 22.4908 16.9998 23.1111H17.8054C19.6202 23.1111 21.1804 22.4491 22.4859 21.125C23.7915 19.8009 24.4443 18.2315 24.4443 16.4167V14.1389H33.611V23.3473ZM27.0415 28C27.2082 27.3426 27.391 26.8218 27.5901 26.4375C27.7892 26.0532 28.0832 25.6389 28.472 25.1945H17.6665C17.7406 25.7408 17.7776 26.2084 17.7776 26.5973C17.7776 26.9861 17.7406 27.4537 17.6665 28H27.0415ZM32.6526 34.6667C31.0693 34.6667 29.7221 34.1189 28.611 33.0234C27.4999 31.9279 26.9443 30.6053 26.9443 29.0555C26.9443 27.4598 27.5083 26.0979 28.6363 24.9698C29.7644 23.8418 31.1263 23.2778 32.722 23.2778C34.2718 23.2778 35.5944 23.8337 36.6899 24.9455C37.7854 26.0572 38.3332 27.3995 38.3332 28.9722C38.3332 30.5648 37.7822 31.912 36.6804 33.0139C35.5785 34.1157 34.236 34.6667 32.6526 34.6667ZM9.6665 34.6667C7.43503 34.6667 5.54382 33.8813 3.99288 32.3104C2.44196 30.7396 1.6665 28.8398 1.6665 26.6111C1.6665 24.3824 2.45123 22.4827 4.02067 20.9118C5.59012 19.341 7.48959 18.5556 9.71909 18.5556C11.9486 18.5556 13.8491 19.3413 15.4205 20.9127C16.9919 22.4841 17.7776 24.3846 17.7776 26.6141C17.7776 28.8436 16.9929 30.7431 15.4234 32.3125C13.854 33.8819 11.935 34.6667 9.6665 34.6667Z", fill: "currentColor" })), zW = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M20.5555 7.2222C20.5555 8.06478 20.2569 8.78469 19.6597 9.38191C19.0625 9.97913 18.3426 10.2777 17.5 10.2777C17.1389 10.2777 16.8009 10.2199 16.4861 10.1042C16.1713 9.98841 15.8704 9.81942 15.5833 9.5972C14.8611 9.96756 14.2662 10.4814 13.7986 11.1389C13.331 11.7963 13.0879 12.5278 13.0694 13.3333H35L33.3333 25H25.7778V22.2222H31.0139C31.1713 21.2037 31.3171 20.1852 31.4514 19.1667C31.5857 18.1481 31.7315 17.1296 31.8889 16.1111H8.11108C8.2685 17.1296 8.41433 18.1481 8.54858 19.1667C8.68286 20.1852 8.82869 21.2037 8.98608 22.2222H14.2222V25H6.66667L5 13.3333H10.2778C10.2963 11.9722 10.6852 10.7361 11.4445 9.62499C12.2037 8.51388 13.2037 7.65739 14.4445 7.05553C14.4907 6.23148 14.8055 5.54398 15.3889 4.99303C15.9722 4.44212 16.6759 4.16666 17.5 4.16666C18.3426 4.16666 19.0625 4.46527 19.6597 5.06249C20.2569 5.65971 20.5555 6.37962 20.5555 7.2222ZM15.8194 32.2222H24.1806L25.2778 21.1111H14.7222L15.8194 32.2222ZM13.3333 35L12 21.3889C11.9259 20.5833 12.1667 19.8727 12.7222 19.2569C13.2778 18.6412 13.9583 18.3333 14.7639 18.3333H25.2361C26.0417 18.3333 26.7222 18.6412 27.2778 19.2569C27.8333 19.8727 28.0741 20.5833 28 21.3889L26.6667 35H13.3333Z", fill: "currentColor" })), ZW = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M15.1252 27.0834L20.0002 24.125L24.8752 27.0834L23.5835 21.5417L27.9169 17.7917L22.2085 17.3334L20.0002 12.0834L17.7919 17.3334L12.0835 17.7917L16.4169 21.5417L15.1252 27.0834ZM20.028 38.8056L14.4169 33.3334H6.66687V25.5834L1.11133 20L6.66687 14.4167V6.66669H14.4169L20.028 1.11115L25.5835 6.66669H33.3335V14.4167L38.8891 20L33.3335 25.5834V33.3334H25.5835L20.028 38.8056ZM20.028 34.9167L24.4146 30.5556H30.5558V24.4167L34.9725 20L30.5558 15.5834V9.44444H24.4169L20.028 5.02777L15.5835 9.44444H9.44462V15.5834L5.02795 20L9.44462 24.4167V30.5556H15.5557L20.028 34.9167Z", fill: "currentColor" })), WW = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M6.11125 35C5.36125 35 4.71079 34.7246 4.15987 34.1737C3.60895 33.6227 3.3335 32.9723 3.3335 32.2223V12.7778C3.3335 12.0278 3.60895 11.3773 4.15987 10.8264C4.71079 10.2755 5.36125 10 6.11125 10H13.3335V6.11112C13.3335 5.36112 13.609 4.71067 14.1599 4.15975C14.7108 3.60883 15.3612 3.33337 16.1112 3.33337H23.8891C24.6391 3.33337 25.2895 3.60883 25.8405 4.15975C26.3914 4.71067 26.6668 5.36112 26.6668 6.11112V10H33.8891C34.6391 10 35.2895 10.2755 35.8405 10.8264C36.3914 11.3773 36.6668 12.0278 36.6668 12.7778V32.2223C36.6668 32.9723 36.3914 33.6227 35.8405 34.1737C35.2895 34.7246 34.6391 35 33.8891 35H6.11125ZM16.1112 10H23.8891V6.11112H16.1112V10ZM33.8891 24.6945H24.1946V27.4722H15.8613V24.6945H6.11125V32.2223H33.8891V24.6945ZM18.6391 24.6945H21.4168V21.9167H18.6391V24.6945ZM6.11125 21.9167H15.8613V19.139H24.1946V21.9167H33.8891V12.7778H6.11125V21.9167Z", fill: "currentColor" })), UW = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M16.8332 24.8333V15.1667H24.8332V24.8333H16.8332ZM18.9998 22.6667H22.6665V17.3333H18.9998V22.6667ZM5.1665 24.8333V15.1667H13.1665V18.1667H10.9998V17.3333H7.33317V22.6667H10.9998V21.8333H13.1665V24.8333H5.1665ZM28.4998 29.8333V24.3333H33.4998V22.3333H28.4998V20.1667H35.6665V25.6667H30.6665V27.6667H35.6665V29.8333H28.4998Z", fill: "currentColor" })), GW = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M18.6111 34.7222V21.7083H18.0555C16.2778 21.7083 14.5926 21.3681 13 20.6875C11.4074 20.0069 9.99537 19.0417 8.76387 17.7917C7.5324 16.5417 6.59722 15.0972 5.95833 13.4583C5.31944 11.8194 5 10.1111 5 8.33333V5H8.28671C10.0122 5 11.6759 5.34028 13.2778 6.02083C14.8796 6.70139 16.3055 7.66667 17.5555 8.91667C18.4537 9.83333 19.1968 10.8518 19.7847 11.9722C20.3727 13.0926 20.8009 14.2824 21.0695 15.5417C21.2573 15.2565 21.464 14.9815 21.6895 14.7167C21.915 14.4519 22.1528 14.1852 22.4028 13.9167C23.6528 12.6667 25.0787 11.7014 26.6805 11.0208C28.2824 10.3403 29.9599 10 31.713 10H35V13.3333C35 15.1111 34.6646 16.8194 33.9937 18.4583C33.3228 20.0972 32.3712 21.5417 31.1389 22.7917C29.8889 24.0417 28.4693 25 26.8802 25.6667C25.2912 26.3333 23.6274 26.6667 21.8889 26.6667H21.3889V34.7222H18.6111ZM18.6389 18.8889C18.6389 17.3148 18.3681 15.8403 17.8264 14.4653C17.2847 13.0903 16.5324 11.9074 15.5695 10.9167C14.6065 9.92592 13.4514 9.15508 12.1042 8.60417C10.7569 8.05322 9.31481 7.77775 7.77775 7.77775C7.77775 9.38889 8.03239 10.8843 8.54167 12.2639C9.05092 13.6435 9.78703 14.8333 10.75 15.8333C11.8426 16.9815 13.0417 17.7778 14.3472 18.2222C15.6528 18.6667 17.0833 18.8889 18.6389 18.8889ZM21.3889 23.8889C22.9444 23.8889 24.3958 23.625 25.743 23.0973C27.0903 22.5695 28.2454 21.8102 29.2083 20.8195C30.1713 19.8287 30.9144 18.6435 31.4375 17.2639C31.9607 15.8843 32.2222 14.3889 32.2222 12.7778C30.6667 12.7778 29.213 13.0532 27.8611 13.6042C26.5093 14.1551 25.3518 14.9213 24.3889 15.9028C23.2778 17.0509 22.5 18.2801 22.0555 19.5903C21.6111 20.9005 21.3889 22.3333 21.3889 23.8889Z", fill: "currentColor" })), qW = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M9.83333 38.3333C8.49075 38.3333 7.34954 37.8634 6.40971 36.9236C5.4699 35.9838 5 34.8426 5 33.5C5 32.1574 5.4699 31.0162 6.40971 30.0764C7.34954 29.1366 8.49075 28.6667 9.83333 28.6667C10.2222 28.6667 10.5694 28.7037 10.875 28.7778C11.1806 28.8519 11.4861 28.9584 11.7917 29.0972L14.9445 25.1667C14.3333 24.4537 13.8843 23.6435 13.5973 22.7361C13.3102 21.8287 13.2408 20.8982 13.3889 19.9445L8.90275 18.4305C8.46758 19.125 7.90278 19.6713 7.20833 20.0695C6.51389 20.4676 5.72222 20.6667 4.83333 20.6667C3.49075 20.6667 2.34954 20.1968 1.40971 19.257C0.469903 18.3171 0 17.1759 0 15.8333C0 14.4908 0.469903 13.3495 1.40971 12.4097C2.34954 11.4699 3.49075 11 4.83333 11C6.17592 11 7.31711 11.4699 8.25692 12.4097C9.19675 13.3495 9.66667 14.4908 9.66667 15.8333V16.0555L14.1806 17.6111C14.6991 16.6852 15.3496 15.9491 16.132 15.4028C16.9144 14.8565 17.7871 14.4862 18.75 14.2917V9.5C17.6667 9.19444 16.7986 8.59953 16.1458 7.71525C15.4931 6.831 15.1667 5.87036 15.1667 4.83333C15.1667 3.49075 15.6366 2.34954 16.5764 1.40971C17.5162 0.469903 18.6574 0 20 0C21.3426 0 22.4838 0.469903 23.4236 1.40971C24.3634 2.34954 24.8333 3.49075 24.8333 4.83333C24.8333 5.87036 24.5 6.831 23.8333 7.71525C23.1667 8.59953 22.3056 9.19444 21.25 9.5V14.2917C22.2129 14.4862 23.0903 14.8565 23.8819 15.4028C24.6736 15.9491 25.3287 16.6852 25.8472 17.6111L30.3333 16.0555V15.8333C30.3333 14.4908 30.8033 13.3495 31.7431 12.4097C32.6829 11.4699 33.8241 11 35.1667 11C36.5093 11 37.6505 11.4699 38.5903 12.4097C39.5301 13.3495 40 14.4908 40 15.8333C40 17.1759 39.5301 18.3171 38.5903 19.257C37.6505 20.1968 36.5093 20.6667 35.1667 20.6667C34.2778 20.6667 33.4792 20.4676 32.7708 20.0695C32.0625 19.6713 31.5046 19.125 31.0972 18.4305L26.6111 19.9445C26.7592 20.8982 26.6944 21.8264 26.4166 22.7292C26.1388 23.6319 25.6852 24.4444 25.0555 25.1667L28.2083 29.0833C28.5139 28.9444 28.8194 28.8403 29.125 28.7708C29.4306 28.7014 29.7737 28.6667 30.1545 28.6667C31.5145 28.6667 32.662 29.1366 33.5972 30.0764C34.5324 31.0162 35 32.1574 35 33.5C35 34.8426 34.5301 35.9838 33.5903 36.9236C32.6505 37.8634 31.5093 38.3333 30.1667 38.3333C28.8241 38.3333 27.6829 37.8634 26.7431 36.9236C25.8033 35.9838 25.3333 34.8426 25.3333 33.5C25.3333 32.9444 25.4144 32.4329 25.5764 31.9653C25.7384 31.4977 25.963 31.0556 26.25 30.6389L23.0972 26.7083C22.1227 27.2361 21.0827 27.5 19.9774 27.5C18.8721 27.5 17.8333 27.2361 16.8611 26.7083L13.75 30.6667C14.037 31.0833 14.2616 31.5208 14.4236 31.9792C14.5856 32.4375 14.6667 32.9444 14.6667 33.5C14.6667 34.8426 14.1967 35.9838 13.2569 36.9236C12.3171 37.8634 11.1759 38.3333 9.83333 38.3333ZM4.83429 17.8889C5.41699 17.8889 5.9051 17.6918 6.29863 17.2976C6.69213 16.9035 6.88888 16.415 6.88888 15.8324C6.88888 15.2497 6.69179 14.7616 6.29763 14.368C5.90346 13.9745 5.41503 13.7778 4.83233 13.7778C4.24967 13.7778 3.76157 13.9748 3.36804 14.369C2.97451 14.7632 2.77775 15.2516 2.77775 15.8343C2.77775 16.417 2.97483 16.9051 3.369 17.2986C3.76317 17.6922 4.2516 17.8889 4.83429 17.8889ZM9.83429 35.5556C10.417 35.5556 10.9051 35.3585 11.2986 34.9643C11.6921 34.5701 11.8889 34.0817 11.8889 33.499C11.8889 32.9163 11.6918 32.4282 11.2976 32.0347C10.9035 31.6412 10.415 31.4445 9.83233 31.4445C9.24967 31.4445 8.76157 31.6415 8.36804 32.0357C7.97451 32.4299 7.77775 32.9183 7.77775 33.501C7.77775 34.0837 7.97483 34.5718 8.369 34.9653C8.7632 35.3588 9.25163 35.5556 9.83429 35.5556ZM20.001 6.88888C20.5837 6.88888 21.0718 6.69179 21.4653 6.29763C21.8588 5.90346 22.0556 5.41504 22.0556 4.83237C22.0556 4.24968 21.8585 3.76157 21.4643 3.36804C21.0701 2.97451 20.5817 2.77775 19.999 2.77775C19.4163 2.77775 18.9282 2.97483 18.5347 3.369C18.1412 3.7632 17.9444 4.25163 17.9444 4.83429C17.9444 5.41699 18.1415 5.9051 18.5357 6.29862C18.9299 6.69212 19.4183 6.88888 20.001 6.88888ZM20.0139 24.7222C21.0972 24.7222 22.0139 24.3426 22.7639 23.5833C23.5139 22.8241 23.8889 21.9028 23.8889 20.8195C23.8889 19.7361 23.5129 18.8195 22.7611 18.0695C22.0093 17.3195 21.0889 16.9445 20 16.9445C18.9259 16.9445 18.0093 17.3204 17.25 18.0722C16.4907 18.8241 16.1111 19.7444 16.1111 20.8333C16.1111 21.9074 16.4907 22.8241 17.25 23.5833C18.0093 24.3426 18.9305 24.7222 20.0139 24.7222ZM30.1676 35.5556C30.7503 35.5556 31.2384 35.3585 31.632 34.9643C32.0255 34.5701 32.2223 34.0817 32.2223 33.499C32.2223 32.9163 32.0252 32.4282 31.631 32.0347C31.2368 31.6412 30.7484 31.4445 30.1657 31.4445C29.583 31.4445 29.0949 31.6415 28.7014 32.0357C28.3079 32.4299 28.1111 32.9183 28.1111 33.501C28.1111 34.0837 28.3082 34.5718 28.7024 34.9653C29.0965 35.3588 29.585 35.5556 30.1676 35.5556ZM35.1676 17.8889C35.7503 17.8889 36.2384 17.6918 36.632 17.2976C37.0255 16.9035 37.2223 16.415 37.2223 15.8324C37.2223 15.2497 37.0252 14.7616 36.631 14.368C36.2368 13.9745 35.7484 13.7778 35.1657 13.7778C34.583 13.7778 34.0949 13.9748 33.7014 14.369C33.3079 14.7632 33.1111 15.2516 33.1111 15.8343C33.1111 16.417 33.3082 16.9051 33.7024 17.2986C34.0965 17.6922 34.585 17.8889 35.1676 17.8889Z", fill: "currentColor" })), KW = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M30.278 21.3889V18.6111H36.6668V21.3889H30.278ZM32.3335 33.3333L27.1946 29.5L28.8613 27.2778L34.0002 31.1111L32.3335 33.3333ZM28.9446 12.6944L27.278 10.4722L32.3335 6.66666L34.0002 8.88887L28.9446 12.6944ZM8.61129 31.6667V25H6.11125C5.34736 25 4.69343 24.728 4.14945 24.184C3.60548 23.6401 3.3335 22.9861 3.3335 22.2222V17.7777C3.3335 17.0139 3.60548 16.3599 4.14945 15.8159C4.69343 15.272 5.34736 15 6.11125 15H13.3335L21.6668 9.99999V30L13.3335 25H11.389V31.6667H8.61129ZM18.8891 25.0834V14.9166L14.0835 17.7777H6.11125V22.2222H14.0835L18.8891 25.0834ZM23.3335 25.5833V14.4167C24.0835 15.0833 24.6877 15.8958 25.146 16.8542C25.6043 17.8125 25.8335 18.8611 25.8335 20C25.8335 21.1389 25.6043 22.1875 25.146 23.1458C24.6877 24.1042 24.0835 24.9167 23.3335 25.5833Z", fill: "currentColor" })), YW = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M11.8054 36.6667V21.3612C10.3702 21.0278 9.15493 20.2825 8.15955 19.125C7.16418 17.9676 6.6665 16.5926 6.6665 15V3.33337H9.44425V15H11.8054V3.33337H14.5832V15H16.9443V3.33337H19.722V15C19.722 16.5926 19.2244 17.9676 18.229 19.125C17.2336 20.2825 16.0183 21.0278 14.5832 21.3612V36.6667H11.8054ZM28.8888 36.6667V23.3334H24.0276V10.9723C24.0276 8.74078 24.7429 6.90976 26.1735 5.47921C27.604 4.04865 29.435 3.33337 31.6665 3.33337V36.6667H28.8888Z", fill: "currentColor" })), XW = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M3.3335 35V5H19.7224V11.8055H36.6668V35H3.3335ZM6.11125 32.2222H16.9446V28.1945H6.11125V32.2222ZM6.11125 25.4167H16.9446V21.3889H6.11125V25.4167ZM6.11125 18.6111H16.9446V14.5833H6.11125V18.6111ZM6.11125 11.8055H16.9446V7.77775H6.11125V11.8055ZM19.7224 32.2222H33.8891V14.5833H19.7224V32.2222ZM23.0557 21.3889V18.6111H29.8613V21.3889H23.0557ZM23.0557 28.1945V25.4167H29.8613V28.1945H23.0557Z", fill: "currentColor" })), JW = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M36.3888 38.3333L31.5554 33.5C30.9629 33.9353 30.3194 34.2478 29.625 34.4375C28.9306 34.6272 28.2222 34.7221 27.5 34.7221C25.4939 34.7221 23.7886 34.0196 22.3842 32.6146C20.98 31.2099 20.2779 29.5039 20.2779 27.4967C20.2779 25.4897 20.9804 23.7849 22.3854 22.3821C23.7901 20.9793 25.4961 20.2779 27.5033 20.2779C29.5103 20.2779 31.2151 20.98 32.6179 22.3842C34.0207 23.7886 34.7221 25.4939 34.7221 27.5C34.7221 28.2222 34.6272 28.9351 34.4375 29.6387C34.2478 30.3426 33.9353 30.9815 33.5 31.5554L38.3333 36.3887L36.3888 38.3333ZM27.4963 31.9446C28.7396 31.9446 29.7918 31.5153 30.6529 30.6567C31.514 29.798 31.9446 28.7471 31.9446 27.5037C31.9446 26.2604 31.5153 25.2082 30.6567 24.3471C29.7981 23.486 28.7471 23.0554 27.5038 23.0554C26.2604 23.0554 25.2082 23.4847 24.3471 24.3433C23.486 25.2019 23.0554 26.2529 23.0554 27.4962C23.0554 28.7396 23.4847 29.7918 24.3433 30.6529C25.2019 31.514 26.2529 31.9446 27.4963 31.9446ZM35 16.3054H32.2221V7.77791H29.4446V11.9446H10.5554V7.77791H7.77792V32.2221H17.5V35H5V4.99999H15.7083C15.9397 4.02777 16.4582 3.22916 17.2638 2.60416C18.0693 1.97916 18.9814 1.66666 20 1.66666C21.0369 1.66666 21.956 1.97916 22.7571 2.60416C23.5579 3.22916 24.074 4.02777 24.3054 4.99999H35V16.3054ZM20 7.77791C20.4722 7.77791 20.8681 7.61818 21.1875 7.29874C21.5069 6.97929 21.6667 6.58346 21.6667 6.11124C21.6667 5.63902 21.5069 5.24318 21.1875 4.92374C20.8681 4.60429 20.4722 4.44457 20 4.44457C19.5278 4.44457 19.1319 4.60429 18.8125 4.92374C18.4931 5.24318 18.3333 5.63902 18.3333 6.11124C18.3333 6.58346 18.4931 6.97929 18.8125 7.29874C19.1319 7.61818 19.5278 7.77791 20 7.77791Z", fill: "currentColor" })), QW = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M35.2285 18.3889V35H4.74716V18.3889C4.00461 17.75 3.49001 16.9537 3.20335 16C2.91667 15.0463 2.93311 14.0648 3.25267 13.0555L5.83273 5H34.1147L36.7512 13.0555C37.0707 14.0648 37.0825 15.0417 36.7864 15.9861C36.4904 16.9306 35.971 17.7315 35.2285 18.3889ZM23.7804 16.9445C24.5793 16.9445 25.2325 16.6829 25.7401 16.1597C26.2476 15.6366 26.4497 15.0185 26.3464 14.3055L25.3313 7.77775H21.4118V14.4167C21.4118 15.0926 21.6374 15.6829 22.0885 16.1875C22.5397 16.6921 23.1037 16.9445 23.7804 16.9445ZM15.9697 16.9445C16.7122 16.9445 17.3349 16.6968 17.8378 16.2014C18.3406 15.706 18.5921 15.1111 18.5921 14.4167V7.77775H14.6726L13.6575 14.3055C13.5447 15.0093 13.7256 15.625 14.2003 16.1528C14.675 16.6806 15.2648 16.9445 15.9697 16.9445ZM8.3282 16.9445C8.94854 16.9445 9.48664 16.7315 9.94251 16.3055C10.3984 15.8796 10.6686 15.3518 10.7532 14.7222L11.7965 7.77775H7.87702L6.016 13.6945C5.77164 14.4537 5.87738 15.1852 6.33322 15.8889C6.78909 16.5926 7.45408 16.9445 8.3282 16.9445ZM31.6475 16.9445C32.5216 16.9445 33.1936 16.5972 33.6636 15.9028C34.1335 15.2083 34.2416 14.4722 33.9878 13.6945L32.0986 7.77775H28.2073L29.2507 14.7222C29.3353 15.3518 29.6055 15.8796 30.0614 16.3055C30.5172 16.7315 31.0459 16.9445 31.6475 16.9445ZM7.56687 32.2222H32.4088V19.6667C32.3806 19.7037 32.2889 19.7222 32.1339 19.7222H31.6475C30.9237 19.7222 30.254 19.5833 29.6384 19.3055C29.0227 19.0278 28.4141 18.5926 27.8126 18C27.3426 18.537 26.774 18.9583 26.1067 19.2639C25.4393 19.5694 24.7109 19.7222 23.9214 19.7222C23.1036 19.7222 22.3822 19.5972 21.7572 19.3472C21.1322 19.0972 20.5471 18.7037 20.0019 18.1667C19.5602 18.6667 19.0174 19.0509 18.3735 19.3194C17.7297 19.5879 17.013 19.7222 16.2235 19.7222C15.3682 19.7222 14.6045 19.5741 13.9324 19.2778C13.2604 18.9815 12.68 18.5556 12.1913 18C11.5427 18.5833 10.9059 19.0162 10.2809 19.2986C9.65583 19.581 9.00493 19.7222 8.3282 19.7222H7.88409C7.73839 19.7222 7.63265 19.7037 7.56687 19.6667V32.2222Z", fill: "currentColor" })), eU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M19.9998 36.6667C19.2591 36.6667 18.6017 36.4885 18.0276 36.132C17.4535 35.7755 17.0554 35.2871 16.8332 34.6667H13.6665V25.9445C11.898 24.7871 10.4975 23.2917 9.46513 21.4584C8.43271 19.625 7.9165 17.6112 7.9165 15.4167C7.9165 12.0556 9.09012 9.20143 11.4373 6.85421C13.7846 4.50699 16.6387 3.33337 19.9998 3.33337C23.3609 3.33337 26.2151 4.50699 28.5623 6.85421C30.9096 9.20143 32.0832 12.0556 32.0832 15.4167C32.0832 17.6297 31.567 19.6482 30.5345 21.4723C29.5022 23.2963 28.1017 24.7871 26.3332 25.9445V34.6667H23.1665C22.9443 35.2871 22.5461 35.7755 21.972 36.132C21.398 36.4885 20.7406 36.6667 19.9998 36.6667ZM16.4443 31.889H23.5554V30.1667H16.4443V31.889ZM16.4443 28.5H23.5554V26.8612H16.4443V28.5ZM16.0832 24.0834H18.9443V18.7778L15.1665 15L16.611 13.5556L19.9998 16.9445L23.3887 13.5556L24.8332 15L21.0554 18.7778V24.0834H23.9165C25.5276 23.3241 26.8285 22.1644 27.8193 20.6042C28.81 19.044 29.3054 17.3148 29.3054 15.4167C29.3054 12.8056 28.4073 10.6019 26.611 8.80558C24.8147 7.00928 22.6109 6.11112 19.9998 6.11112C17.3887 6.11112 15.185 7.00928 13.3887 8.80558C11.5924 10.6019 10.6943 12.8056 10.6943 15.4167C10.6943 17.3148 11.1896 19.044 12.1804 20.6042C13.1711 22.1644 14.4721 23.3241 16.0832 24.0834Z", fill: "currentColor" })), tU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M9.1665 28.3334C8.47206 28.3334 7.88178 28.0903 7.39567 27.6042C6.90956 27.1181 6.6665 26.5278 6.6665 25.8334C6.6665 25.1389 6.90956 24.5486 7.39567 24.0625C7.88178 23.5764 8.47206 23.3334 9.1665 23.3334H30.8332C31.5276 23.3334 32.1179 23.5764 32.604 24.0625C33.0901 24.5486 33.3332 25.1389 33.3332 25.8334C33.3332 26.5278 33.0901 27.1181 32.604 27.6042C32.1179 28.0903 31.5276 28.3334 30.8332 28.3334H9.1665ZM9.1665 16.6667C8.47206 16.6667 7.88178 16.4236 7.39567 15.9375C6.90956 15.4514 6.6665 14.8611 6.6665 14.1667C6.6665 13.4722 6.90956 12.882 7.39567 12.3959C7.88178 11.9097 8.47206 11.6667 9.1665 11.6667H30.8332C31.5276 11.6667 32.1179 11.9097 32.604 12.3959C33.0901 12.882 33.3332 13.4722 33.3332 14.1667C33.3332 14.8611 33.0901 15.4514 32.604 15.9375C32.1179 16.4236 31.5276 16.6667 30.8332 16.6667H9.1665Z", fill: "currentColor" })), nU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M24.8905 35.279C21.6528 35.279 18.6958 34.3566 16.0195 32.5116C13.3433 30.6667 11.4975 28.1632 10.482 25.0012H4.76758V21.8448H9.86541C9.77019 21.1683 9.72843 20.543 9.74012 19.9691C9.75179 19.3951 9.79355 18.7905 9.86541 18.1552H4.76758V14.9922H10.482C11.513 11.8811 13.3627 9.39032 16.0312 7.51993C18.6997 5.64957 21.6528 4.71439 24.8905 4.71439C26.8802 4.71439 28.7432 5.06257 30.4795 5.75893C32.2159 6.45529 33.8002 7.44689 35.2326 8.73372L32.9708 10.9538C31.8446 9.96869 30.5918 9.20968 29.2123 8.67676C27.8329 8.14387 26.3923 7.87743 24.8905 7.87743C22.4668 7.87743 20.2542 8.5369 18.2529 9.85584C16.2516 11.1748 14.8128 12.8869 13.9364 14.9922H25.1529V18.1552H13.0535C12.9372 18.8454 12.8814 19.4801 12.8862 20.0593C12.8911 20.6385 12.9468 21.2337 13.0535 21.8448H25.1529V25.0012H13.8998C14.7984 27.1508 16.2488 28.8751 18.2513 30.1741C20.2537 31.4731 22.4668 32.1226 24.8905 32.1226C26.3694 32.1226 27.7996 31.8648 29.1812 31.3493C30.5629 30.8338 31.8353 30.0661 32.9986 29.0462L35.2326 31.2563C33.9113 32.4921 32.3594 33.4714 30.5768 34.1945C28.7942 34.9175 26.8987 35.279 24.8905 35.279Z", fill: "currentColor" })), oU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M14.8005 27.2222C13.6557 27.2222 12.6898 26.827 11.9028 26.0366C11.1157 25.2462 10.7222 24.2786 10.7222 23.1338C10.7222 21.9891 11.1174 21.0232 11.9079 20.2361C12.6983 19.4491 13.6659 19.0556 14.8106 19.0556C15.9554 19.0556 16.9213 19.4508 17.7083 20.2412C18.4954 21.0316 18.8889 21.9992 18.8889 23.144C18.8889 24.2887 18.4937 25.2547 17.7032 26.0417C16.9128 26.8287 15.9452 27.2222 14.8005 27.2222ZM7.77775 36.6667C7.02775 36.6667 6.37729 36.3912 5.82637 35.8403C5.27546 35.2894 5 34.6389 5 33.8889V8.88889C5 8.13889 5.27546 7.48843 5.82637 6.93751C6.37729 6.38657 7.02775 6.11109 7.77775 6.11109H10.1389V3.33334H13.0555V6.11109H26.9445V3.33334H29.8611V6.11109H32.2222C32.9722 6.11109 33.6227 6.38657 34.1736 6.93751C34.7245 7.48843 35 8.13889 35 8.88889V33.8889C35 34.6389 34.7245 35.2894 34.1736 35.8403C33.6227 36.3912 32.9722 36.6667 32.2222 36.6667H7.77775ZM7.77775 33.8889H32.2222V16.3889H7.77775V33.8889ZM7.77775 13.6111H32.2222V8.88889H7.77775V13.6111Z", fill: "currentColor" })), rU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M12.3056 36.6667V30.3056H0L7.38892 19.3611H3.72225L15 3.33337L20 10.4445L25 3.33337L36.2778 19.3611H32.6389L40 30.3056H27.7222V36.6667H22.3056V30.3056H17.7222V36.6667H12.3056ZM28.1806 27.5278H34.7778L27.375 16.5834H30.7778L25 8.36113L21.7917 12.9584L26.2778 19.3611H22.6389L28.1806 27.5278ZM5.24996 27.5278H24.7778L17.375 16.5834H20.7778L15 8.36113L9.22221 16.5834H12.6528L5.24996 27.5278ZM5.24996 27.5278H12.6528H9.22221H20.7778H17.375H24.7778H5.24996ZM28.1806 27.5278H22.6389H26.2778H21.7917H30.7778H27.375H34.7778H28.1806Z", fill: "currentColor" })), iU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M8.61113 33.3333V26.3888H5V23.6111H8.61113V19.7222H5V16.9444H8.61113V11.3888L13.3333 6.66663L16.6667 9.99996L20.0417 6.66663L23.375 9.99996L26.7083 6.66663L31.4305 11.3888V16.9444H35V19.7222H31.4305V23.6111H35V26.3888H31.4305V33.3333H8.61113ZM11.3889 16.9444H15.2778V12.5416L13.3333 10.5972L11.3889 12.5416V16.9444ZM18.0555 16.9444H21.9445V12.5416L20 10.5972L18.0555 12.5416V16.9444ZM24.7639 16.9444H28.6111V12.5416L26.6667 10.5972L24.7639 12.5V16.9444ZM11.3889 23.6111H15.2778V19.7222H11.3889V23.6111ZM18.0555 23.6111H21.9445V19.7222H18.0555V23.6111ZM24.7639 23.6111H28.6111V19.7222H24.7639V23.6111ZM11.3889 30.5555H15.2778V26.3888H11.3889V30.5555ZM18.0555 30.5555H21.9445V26.3888H18.0555V30.5555ZM24.7639 30.5555H28.6111V26.3888H24.7639V30.5555Z", fill: "currentColor" })), sU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M26.8335 36.6667C24.0557 36.6667 21.7224 35.7222 19.8335 33.8333C17.9446 31.9445 17.0002 29.6111 17.0002 26.8333C17.0002 24.0556 17.9446 21.7222 19.8335 19.8333C21.7224 17.9445 24.0557 17 26.8335 17C29.6113 17 31.9446 17.9445 33.8335 19.8333C35.7224 21.7222 36.6668 24.0556 36.6668 26.8333C36.6668 29.6111 35.7224 31.9445 33.8335 33.8333C31.9446 35.7222 29.6113 36.6667 26.8335 36.6667ZM26.8335 33.8889C28.7779 33.8889 30.44 33.1991 31.8196 31.8195C33.1993 30.4398 33.8891 28.7778 33.8891 26.8333C33.8891 24.8889 33.1993 23.2269 31.8196 21.8472C30.44 20.4676 28.7779 19.7778 26.8335 19.7778C24.8891 19.7778 23.227 20.4676 21.8474 21.8472C20.4678 23.2269 19.778 24.8889 19.778 26.8333C19.778 28.7778 20.4678 30.4398 21.8474 31.8195C23.227 33.1991 24.8891 33.8889 26.8335 33.8889ZM3.3335 33.3333V16.2778L7.30575 7.49997H5.11129V3.33334H19.2501V7.49997H17.0557L20.639 15.7778C20.2409 15.9815 19.8428 16.2176 19.4446 16.4861C19.0465 16.7547 18.6761 17.0371 18.3335 17.3334L13.9724 7.49997H10.3613L6.11125 16.9167V30.5556H14.6946C14.7965 31.0278 14.9516 31.507 15.1599 31.9931C15.3682 32.4792 15.602 32.9259 15.8613 33.3333H3.3335ZM26.8335 15.0556C25.7779 15.0556 24.8937 14.6991 24.1807 13.9861C23.4678 13.2732 23.1113 12.3889 23.1113 11.3333C23.1113 10.2778 23.4678 9.39354 24.1807 8.68059C24.8937 7.96762 25.7779 7.61114 26.8335 7.61114V15.0556C26.8335 14 27.19 13.1157 27.903 12.4028C28.6159 11.6898 29.5002 11.3333 30.5557 11.3333C31.6113 11.3333 32.4955 11.6898 33.2085 12.4028C33.9214 13.1157 34.2779 14 34.2779 15.0556H26.8335Z", fill: "currentColor" })), aU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.79101 35C6.58373 35 5.74635 34.4005 5.27886 33.2014C4.81139 32.0023 4.93166 30.9815 5.63967 30.1389L15.416 18.6111V7.77775H12.0937V5H27.8883V7.77775H24.566V18.6111L34.3423 30.1389C35.0685 31 35.1933 32.0255 34.7168 33.2153C34.2402 34.4051 33.3983 35 32.191 35H7.79101ZM7.46423 32.2222H32.5178L21.8428 19.6111V7.77775H18.1392V19.6111L7.46423 32.2222Z", fill: "currentColor" })), lU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M8.3335 35V7.6389C8.3335 6.8889 8.60895 6.23844 9.15987 5.68752C9.71079 5.1366 10.3612 4.86115 11.1112 4.86115H28.8891C29.6391 4.86115 30.2895 5.1366 30.8405 5.68752C31.3914 6.23844 31.6668 6.8889 31.6668 7.6389V35L20.0002 30L8.3335 35ZM11.1112 30.7778L20.0002 27L28.8891 30.7778V7.6389H11.1112V30.7778Z", fill: "currentColor" })), cU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M6.66646 9.44444V6.66669H33.3887V9.44444H6.66646ZM6.80534 33.3334V22.8334H4.88867V20.0556L6.66646 11.6667H33.3609L35.1387 20.0556V22.8334H33.222V33.3334H30.4443V22.8334H22.972V33.3334H6.80534ZM9.58313 30.5556H20.1943V22.8334H9.58313V30.5556ZM7.66642 20.0556H32.3609L31.1665 14.4444H8.86088L7.66642 20.0556Z", fill: "currentColor" })), dU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M16.1111 16.8611L20 14.9167L23.8889 16.8611V7.77775H16.1111V16.8611ZM11.6667 28.3333V25H20V28.3333H11.6667ZM7.77775 35C7.02775 35 6.37729 34.7245 5.82637 34.1736C5.27546 33.6227 5 32.9722 5 32.2222V7.77775C5 7.02775 5.27546 6.37729 5.82637 5.82638C6.37729 5.27546 7.02775 5 7.77775 5H32.2222C32.9722 5 33.6227 5.27546 34.1736 5.82638C34.7245 6.37729 35 7.02775 35 7.77775V32.2222C35 32.9722 34.7245 33.6227 34.1736 34.1736C33.6227 34.7245 32.9722 35 32.2222 35H7.77775ZM7.77775 32.2222H32.2222V7.77775H26.6667V21.3611L20 18.0278L13.3333 21.3611V7.77775H7.77775V32.2222Z", fill: "currentColor" })), uU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M4.13135 35.8334V17.186L14.1243 12.9329V16.2342L22.4519 12.9008V17.5001H35.776V35.8334H4.13135ZM6.62957 33.3334H33.2777V20.0001H19.9537V16.5834L11.6261 19.9167V16.6667L6.62957 18.8751V33.3334ZM18.4803 29.6154H21.427V23.718H18.4803V29.6154ZM11.8183 29.6154H14.7649V23.718H11.8183V29.6154ZM25.1424 29.6154H28.089V23.718H25.1424V29.6154ZM35.776 17.5001H29.0179L30.6835 4.80786H34.2065L35.776 17.5001Z", fill: "currentColor" })), fU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M6.81962 35V30.7222H12.0696L7.7085 16.0278C6.86591 15.6111 6.19693 15.0324 5.70154 14.2917C5.20618 13.5509 4.9585 12.6389 4.9585 11.5555C4.9585 10.2222 5.43998 9.07407 6.40295 8.11112C7.3659 7.14815 8.51404 6.66666 9.84737 6.66666C11.0233 6.66666 12.021 6.98843 12.8405 7.63196C13.6599 8.27546 14.2178 9.12036 14.514 10.1667H20.3474V7.97221C20.3474 7.5926 20.484 7.26621 20.7571 6.99304C21.0303 6.7199 21.3566 6.58333 21.7363 6.58333C22.0233 6.58333 22.2756 6.68055 22.4932 6.875C22.7108 7.06944 22.8474 7.30555 22.903 7.58333L25.9307 4.69446C26.1622 4.46296 26.4516 4.31248 26.7988 4.24304C27.146 4.1736 27.4955 4.22221 27.8474 4.38887L34.403 7.5C34.6807 7.64814 34.8729 7.85879 34.9793 8.13196C35.0858 8.40509 35.0696 8.68518 34.9307 8.97221C34.7826 9.26851 34.5673 9.45139 34.2849 9.52083C34.0025 9.59028 33.727 9.55555 33.4585 9.41666L27.153 6.41666L23.1252 10.3889V12.6111L27.153 16.6667L33.4585 13.6389C33.7455 13.5 34.0279 13.4722 34.3057 13.5555C34.5835 13.6389 34.7918 13.8241 34.9307 14.1111C35.0789 14.4074 35.0974 14.6991 34.9863 14.9861C34.8752 15.2731 34.6715 15.4907 34.3752 15.6389L27.9585 18.6667C27.5881 18.8518 27.2247 18.9282 26.8682 18.8958C26.5117 18.8634 26.1992 18.713 25.9307 18.4445L22.903 15.5555C22.8474 15.8704 22.7108 16.1157 22.4932 16.2917C22.2756 16.4676 22.0233 16.5555 21.7363 16.5555C21.3566 16.5555 21.0303 16.419 20.7571 16.1458C20.484 15.8727 20.3474 15.5463 20.3474 15.1667V12.9444H14.4585C14.4307 13.2407 14.3404 13.537 14.1877 13.8333C14.0349 14.1296 13.8474 14.3889 13.6252 14.6111L22.0974 30.7222H28.4863V35H6.81962ZM9.84737 13.6667C10.4492 13.6667 10.9516 13.4653 11.3543 13.0625C11.7571 12.6597 11.9585 12.1574 11.9585 11.5555C11.9585 10.9537 11.7571 10.4514 11.3543 10.0486C10.9516 9.6458 10.4492 9.44442 9.84737 9.44442C9.24551 9.44442 8.74319 9.6458 8.34041 10.0486C7.93763 10.4514 7.73625 10.9537 7.73625 11.5555C7.73625 12.1574 7.93763 12.6597 8.34041 13.0625C8.74319 13.4653 9.24551 13.6667 9.84737 13.6667ZM15.0418 30.7222H18.9585L11.3196 16.0833C11.2641 16.1204 11.1622 16.1574 11.014 16.1944L10.6807 16.2777L15.0418 30.7222Z", fill: "currentColor" })), pU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.33333 27.8889V6.77775H4V4H10.1111V25.1111H35.6667V27.8889H7.33333ZM10.0865 35.6667C9.31586 35.6667 8.66435 35.3942 8.13196 34.8493C7.59954 34.3043 7.33333 33.6492 7.33333 32.884C7.33333 32.1188 7.59954 31.4653 8.13196 30.9236C8.66435 30.382 9.31586 30.1111 10.0865 30.1111C10.8571 30.1111 11.5169 30.3836 12.0657 30.9285C12.6145 31.4735 12.8889 32.1286 12.8889 32.8938C12.8889 33.6591 12.6145 34.3125 12.0657 34.8542C11.5169 35.3958 10.8571 35.6667 10.0865 35.6667ZM12.6111 22.6111V13.1667H22.0555V22.6111H12.6111ZM15.3889 19.8334H19.2778V15.9445H15.3889V19.8334ZM24.2778 22.6111V13.1667H33.7222V22.6111H24.2778ZM27.0555 19.8334H30.9445V15.9445H27.0555V19.8334ZM32.884 35.6667C32.1188 35.6667 31.4653 35.3942 30.9236 34.8493C30.382 34.3043 30.1111 33.6492 30.1111 32.884C30.1111 32.1188 30.3836 31.4653 30.9285 30.9236C31.4735 30.382 32.1286 30.1111 32.8938 30.1111C33.6591 30.1111 34.3125 30.3836 34.8542 30.9285C35.3958 31.4735 35.6667 32.1286 35.6667 32.8938C35.6667 33.6591 35.3942 34.3125 34.8493 34.8542C34.3043 35.3958 33.6492 35.6667 32.884 35.6667Z", fill: "currentColor" })), hU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M20 23.2175C21.733 23.2175 23.1379 21.7789 23.1379 20.0044C23.1379 18.2299 21.733 16.7914 20 16.7914C18.267 16.7914 16.8621 18.2299 16.8621 20.0044C16.8621 21.7789 18.267 23.2175 20 23.2175Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 5H33V7.61123H32.1034V32.3976H33V35H7V32.3976H7.89655V7.61123H7V5ZM29.5931 32.3976H10.4069V28.7256H29.5931V32.3976ZM29.5931 7.61123H10.4069V11.2833H29.5931V7.61123ZM10.4069 26.1551V13.8537H29.5931V26.1551H10.4069Z", fill: "currentColor" })), gU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M18.3335 35V32.2222H32.2224V19.8333C32.2224 16.4595 31.0366 13.5976 28.6649 11.2474C26.2932 8.89728 23.4049 7.72221 20.0002 7.72221C16.5954 7.72221 13.7071 8.89728 11.3355 11.2474C8.96376 13.5976 7.77791 16.4595 7.77791 19.8333V30H6.66683C5.75016 30 4.96544 29.6736 4.31266 29.0208C3.65989 28.3681 3.3335 27.5833 3.3335 26.6667V23.3333C3.3335 22.75 3.47933 22.2014 3.771 21.6875C4.06266 21.1736 4.47239 20.7639 5.00016 20.4583L5.12516 18.25C5.34739 16.3611 5.896 14.6111 6.771 13C7.646 11.3889 8.74322 9.98611 10.0627 8.79167C11.3821 7.59722 12.896 6.66667 14.6043 6C16.3127 5.33333 18.1113 5 20.0002 5C21.8891 5 23.6807 5.33333 25.3752 6C27.0696 6.66667 28.5835 7.59028 29.9168 8.77083C31.2502 9.95139 32.3474 11.3472 33.2085 12.9583C34.0696 14.5694 34.6252 16.3194 34.8752 18.2083L35.0002 20.375C35.5279 20.625 35.9377 21 36.2293 21.5C36.521 22 36.6668 22.5278 36.6668 23.0833V26.9167C36.6668 27.4722 36.521 28 36.2293 28.5C35.9377 29 35.5279 29.375 35.0002 29.625V32.2222C35.0002 32.9861 34.7282 33.6401 34.1842 34.184C33.6402 34.728 32.9863 35 32.2224 35H18.3335ZM14.9953 23.0555C14.6004 23.0555 14.271 22.922 14.0071 22.6548C13.7432 22.3877 13.6113 22.0567 13.6113 21.6618C13.6113 21.2669 13.7449 20.9375 14.012 20.6736C14.2791 20.4097 14.6102 20.2778 15.005 20.2778C15.3999 20.2778 15.7293 20.4114 15.9932 20.6785C16.2571 20.9456 16.389 21.2767 16.389 21.6715C16.389 22.0664 16.2555 22.3958 15.9883 22.6597C15.7212 22.9236 15.3902 23.0555 14.9953 23.0555ZM24.9953 23.0555C24.6004 23.0555 24.271 22.922 24.0071 22.6548C23.7432 22.3877 23.6113 22.0567 23.6113 21.6618C23.6113 21.2669 23.7449 20.9375 24.012 20.6736C24.2791 20.4097 24.6102 20.2778 25.005 20.2778C25.3999 20.2778 25.7293 20.4114 25.9932 20.6785C26.2571 20.9456 26.389 21.2767 26.389 21.6715C26.389 22.0664 26.2555 22.3958 25.9883 22.6597C25.7212 22.9236 25.3902 23.0555 24.9953 23.0555ZM10.0418 20.75C9.84739 17.8056 10.7363 15.2778 12.7085 13.1667C14.6807 11.0556 17.1391 10 20.0835 10C22.5187 10 24.6414 10.794 26.4515 12.382C28.2617 13.9699 29.3613 15.9676 29.7502 18.375C27.2594 18.3472 24.9793 17.6574 22.9099 16.3055C20.8404 14.9537 19.2429 13.1574 18.1174 10.9167C17.6781 13.1389 16.7432 15.1181 15.3127 16.8542C13.8821 18.5903 12.1252 19.8889 10.0418 20.75Z", fill: "currentColor" })), mU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.17934 34.1666C6.33745 34.1666 5.62484 33.8749 5.0415 33.2916C4.45817 32.7083 4.1665 31.9957 4.1665 31.1538V12.5H6.66646V31.1538C6.66646 31.282 6.71988 31.3995 6.82671 31.5064C6.93357 31.6132 7.05112 31.6666 7.17934 31.6666H30.8331V34.1666H7.17934ZM13.846 27.4999C13.0041 27.4999 12.2915 27.2083 11.7082 26.6249C11.1248 26.0416 10.8332 25.329 10.8332 24.4871V5.83334H37.4998V24.4871C37.4998 25.329 37.2081 26.0416 36.6248 26.6249C36.0414 27.2083 35.3288 27.4999 34.4869 27.4999H13.846ZM13.846 25H34.4869C34.6151 25 34.7327 24.9466 34.8396 24.8397C34.9464 24.7329 34.9998 24.6153 34.9998 24.4871V8.3333H13.3331V24.4871C13.3331 24.6153 13.3865 24.7329 13.4934 24.8397C13.6002 24.9466 13.7178 25 13.846 25ZM16.6665 20H23.3331V11.6666H16.6665V20ZM24.9998 20H31.6665V16.6666H24.9998V20ZM24.9998 15H31.6665V11.6666H24.9998V15Z", fill: "currentColor" })), bU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M10.8611 18.1666L20.0278 3.33331L29.1945 18.1666H10.8611ZM29.3333 36.6666C27.2685 36.6666 25.5301 35.9606 24.118 34.5486C22.706 33.1366 22 31.3981 22 29.3333C22 27.2685 22.706 25.5301 24.118 24.1181C25.5301 22.706 27.2685 22 29.3333 22C31.3981 22 33.1366 22.706 34.5486 24.1181C35.9607 25.5301 36.6667 27.2685 36.6667 29.3333C36.6667 31.3981 35.9607 33.1366 34.5486 34.5486C33.1366 35.9606 31.3981 36.6666 29.3333 36.6666ZM5 35.6944V22.8056H17.8889V35.6944H5ZM29.3357 33.8889C30.6119 33.8889 31.6898 33.4483 32.5695 32.5671C33.4491 31.6859 33.8889 30.6072 33.8889 29.331C33.8889 28.0548 33.4483 26.9768 32.5671 26.0972C31.6859 25.2176 30.6072 24.7778 29.331 24.7778C28.0548 24.7778 26.9768 25.2184 26.0972 26.0996C25.2176 26.9808 24.7778 28.0595 24.7778 29.3357C24.7778 30.6119 25.2184 31.6898 26.0996 32.5694C26.9808 33.4491 28.0595 33.8889 29.3357 33.8889ZM7.77775 32.9167H15.1111V25.5833H7.77775V32.9167ZM15.8333 15.3889H24.2222L20.0278 8.61106L15.8333 15.3889Z", fill: "currentColor" })), CU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M5 12.8055H35V29.1667C35 30.3241 34.5949 31.3079 33.7847 32.1181C32.9745 32.9283 31.9908 33.3333 30.8334 33.3333H9.16663C8.00924 33.3333 7.02544 32.9283 6.21525 32.1181C5.40508 31.3079 5 30.3241 5 29.1667V12.8055ZM7.77775 15.5833V29.1667C7.77775 29.5602 7.91086 29.8901 8.17708 30.1562C8.44328 30.4225 8.77312 30.5556 9.16663 30.5556H30.8334C31.2269 30.5556 31.5567 30.4225 31.8229 30.1562C32.0891 29.8901 32.2222 29.5602 32.2222 29.1667V15.5833H7.77775ZM5 11.1389V8.33333H15.2778V6.38888C15.2778 5.99538 15.4109 5.66551 15.6771 5.39929C15.9433 5.1331 16.2731 5 16.6667 5H23.3333C23.7269 5 24.0567 5.1331 24.3229 5.39929C24.5891 5.66551 24.7222 5.99538 24.7222 6.38888V8.33333H35V11.1389H5Z", fill: "currentColor" })), xU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M28.1412 33.9743C26.537 33.9743 25.1638 33.4032 24.0214 32.2608C22.8791 31.1185 22.3079 29.7452 22.3079 28.1411C22.3079 26.5369 22.8791 25.1637 24.0214 24.0213C25.1638 22.879 26.537 22.3078 28.1412 22.3078C29.7453 22.3078 31.1186 22.879 32.2609 24.0213C33.4033 25.1637 33.9745 26.5369 33.9745 28.1411C33.9745 29.7452 33.4033 31.1185 32.2609 32.2608C31.1186 33.4032 29.7453 33.9743 28.1412 33.9743ZM28.1412 31.4744C29.0578 31.4744 29.8426 31.148 30.4953 30.4952C31.1481 29.8424 31.4745 29.0577 31.4745 28.1411C31.4745 27.2244 31.1481 26.4397 30.4953 25.7869C29.8426 25.1341 29.0578 24.8077 28.1412 24.8077C27.2245 24.8077 26.4398 25.1341 25.787 25.7869C25.1342 26.4397 24.8078 27.2244 24.8078 28.1411C24.8078 29.0577 25.1342 29.8424 25.787 30.4952C26.4398 31.148 27.2245 31.4744 28.1412 31.4744ZM11.8592 28.9743C10.255 28.9743 8.88175 28.4032 7.73942 27.2608C6.59706 26.1185 6.02588 24.7452 6.02588 23.1411C6.02588 21.5369 6.59706 20.1637 7.73942 19.0213C8.88175 17.879 10.255 17.3078 11.8592 17.3078C13.4633 17.3078 14.8366 17.879 15.9789 19.0213C17.1213 20.1637 17.6924 21.5369 17.6924 23.1411C17.6924 24.7452 17.1213 26.1185 15.9789 27.2608C14.8366 28.4032 13.4633 28.9743 11.8592 28.9743ZM11.8592 26.4744C12.7758 26.4744 13.5606 26.148 14.2133 25.4952C14.8661 24.8424 15.1925 24.0577 15.1925 23.1411C15.1925 22.2244 14.8661 21.4397 14.2133 20.7869C13.5606 20.1341 12.7758 19.8077 11.8592 19.8077C10.9425 19.8077 10.1578 20.1341 9.505 20.7869C8.85223 21.4397 8.52584 22.2244 8.52584 23.1411C8.52584 24.0577 8.85223 24.8424 9.505 25.4952C10.1578 26.148 10.9425 26.4744 11.8592 26.4744ZM18.3335 16.1538C16.7294 16.1538 15.3561 15.5827 14.2138 14.4403C13.0714 13.298 12.5002 11.9247 12.5002 10.3206C12.5002 8.71643 13.0714 7.34318 14.2138 6.20085C15.3561 5.05849 16.7294 4.4873 18.3335 4.4873C19.9376 4.4873 21.3109 5.05849 22.4533 6.20085C23.5956 7.34318 24.1668 8.71643 24.1668 10.3206C24.1668 11.9247 23.5956 13.298 22.4533 14.4403C21.3109 15.5827 19.9376 16.1538 18.3335 16.1538ZM18.3335 13.6539C19.2502 13.6539 20.0349 13.3275 20.6877 12.6748C21.3404 12.022 21.6668 11.2373 21.6668 10.3206C21.6668 9.40393 21.3404 8.61921 20.6877 7.96643C20.0349 7.31365 19.2502 6.98726 18.3335 6.98726C17.4168 6.98726 16.6321 7.31365 15.9793 7.96643C15.3266 8.61921 15.0002 9.40393 15.0002 10.3206C15.0002 11.2373 15.3266 12.022 15.9793 12.6748C16.6321 13.3275 17.4168 13.6539 18.3335 13.6539Z", fill: "currentColor" })), yU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M30.1945 36.6667C28.8518 36.6667 27.7106 36.1959 26.7708 35.2543C25.831 34.3127 25.3611 33.1693 25.3611 31.8242C25.3611 31.6358 25.3796 31.4177 25.4167 31.1697C25.4537 30.9217 25.5093 30.6984 25.5833 30.5L13.25 23.3333C12.8148 23.787 12.2963 24.1505 11.6945 24.4236C11.0926 24.6968 10.4722 24.8333 9.83333 24.8333C8.49075 24.8333 7.34954 24.3634 6.40971 23.4236C5.4699 22.4838 5 21.3426 5 20C5 18.6574 5.4699 17.5162 6.40971 16.5764C7.34954 15.6366 8.49075 15.1667 9.83333 15.1667C10.4722 15.1667 11.0833 15.2894 11.6667 15.5347C12.25 15.7801 12.7778 16.1297 13.25 16.5833L25.5833 9.47222C25.5093 9.28572 25.4537 9.0759 25.4167 8.84276C25.3796 8.60962 25.3611 8.38426 25.3611 8.16668C25.3611 6.82409 25.831 5.68289 26.7708 4.74305C27.7106 3.80325 28.8518 3.33334 30.1945 3.33334C31.537 3.33334 32.6782 3.80325 33.618 4.74305C34.5579 5.68289 35.0278 6.82409 35.0278 8.16668C35.0278 9.50926 34.5579 10.6505 33.618 11.5903C32.6782 12.5301 31.537 13 30.1945 13C29.549 13 28.9316 12.8912 28.3423 12.6736C27.753 12.456 27.2407 12.1204 26.8055 11.6667L14.4722 18.6111C14.5278 18.8148 14.5741 19.0486 14.6111 19.3125C14.6481 19.5764 14.6667 19.8078 14.6667 20.0067C14.6667 20.2056 14.6481 20.4116 14.6111 20.6248C14.5741 20.8379 14.5278 21.0463 14.4722 21.25L26.8055 28.3056C27.2407 27.9074 27.7407 27.5903 28.3055 27.3542C28.8704 27.1181 29.5 27 30.1945 27C31.537 27 32.6782 27.4699 33.618 28.4098C34.5579 29.3496 35.0278 30.4908 35.0278 31.8333C35.0278 33.1759 34.5579 34.3171 33.618 35.257C32.6782 36.1968 31.537 36.6667 30.1945 36.6667ZM30.1954 10.2222C30.7781 10.2222 31.2662 10.0251 31.6597 9.63097C32.0532 9.2368 32.25 8.74839 32.25 8.16572C32.25 7.58302 32.0529 7.09491 31.6588 6.70139C31.2646 6.30786 30.7762 6.11109 30.1935 6.11109C29.6108 6.11109 29.1227 6.30818 28.7292 6.70234C28.3356 7.09654 28.1389 7.58497 28.1389 8.16764C28.1389 8.75033 28.336 9.23844 28.7301 9.63197C29.1243 10.0255 29.6128 10.2222 30.1954 10.2222ZM9.83429 22.0556C10.417 22.0556 10.9051 21.8585 11.2986 21.4643C11.6921 21.0701 11.8889 20.5817 11.8889 19.9991C11.8889 19.4164 11.6918 18.9282 11.2976 18.5347C10.9035 18.1412 10.415 17.9444 9.83233 17.9444C9.24967 17.9444 8.76157 18.1415 8.36804 18.5357C7.97451 18.9299 7.77775 19.4183 7.77775 20.001C7.77775 20.5837 7.97483 21.0718 8.369 21.4653C8.76319 21.8588 9.25162 22.0556 9.83429 22.0556ZM30.1954 33.8889C30.7781 33.8889 31.2662 33.6918 31.6597 33.2977C32.0532 32.9035 32.25 32.4151 32.25 31.8324C32.25 31.2497 32.0529 30.7616 31.6588 30.3681C31.2646 29.9746 30.7762 29.7778 30.1935 29.7778C29.6108 29.7778 29.1227 29.9749 28.7292 30.3691C28.3356 30.7632 28.1389 31.2517 28.1389 31.8343C28.1389 32.417 28.336 32.9051 28.7301 33.2986C29.1243 33.6922 29.6128 33.8889 30.1954 33.8889Z", fill: "currentColor" })), vU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M8.97457 32.6922H31.0257V29.9199C31.0257 29.7703 30.9777 29.6474 30.8815 29.5512C30.7853 29.4551 30.6625 29.407 30.5129 29.407H9.4874C9.33782 29.407 9.21496 29.4551 9.11882 29.5512C9.02265 29.6474 8.97457 29.7703 8.97457 29.9199V32.6922ZM13.9617 26.9071H26.0386L24.9841 19.5833H15.0162L13.9617 26.9071ZM6.47461 35.1922V29.9199C6.47461 29.0913 6.76961 28.3821 7.35961 27.7921C7.94964 27.2021 8.6589 26.9071 9.4874 26.9071H11.4618L12.4906 19.5833H8.14128V17.0834H31.859V19.5833H27.5097L28.5385 26.9071H30.5091C31.3428 26.9071 32.054 27.2021 32.6427 27.7921C33.2314 28.3821 33.5257 29.0913 33.5257 29.9199V35.1922H6.47461ZM12.3977 17.0834L9.67973 4.80778C10.5323 5.40606 11.3729 5.92795 12.2016 6.37345C13.0302 6.81895 13.9417 7.04169 14.9361 7.04169C15.9511 7.04169 16.8784 6.82376 17.7181 6.3879C18.5579 5.95201 19.3185 5.41997 20.0002 4.79178C20.6818 5.41997 21.4427 5.95201 22.2829 6.3879C23.1232 6.82376 24.0449 7.04169 25.0482 7.04169C26.0119 7.04169 26.9023 6.82163 27.7196 6.38149C28.5369 5.94132 29.4092 5.41675 30.3366 4.80778L27.6027 17.0834H25.0354L26.7886 9.31407C26.6283 9.36749 26.4013 9.41878 26.1075 9.46795C25.8137 9.51709 25.4392 9.54165 24.9841 9.54165C24.0976 9.54165 23.2297 9.41558 22.3802 9.16344C21.5307 8.91131 20.7373 8.55021 20.0002 8.08015C19.2801 8.55021 18.5021 8.91131 17.6663 9.16344C16.8305 9.41558 15.976 9.54165 15.1028 9.54165C14.6241 9.54165 14.232 9.52242 13.9265 9.48394C13.6209 9.4455 13.388 9.39956 13.2277 9.34611L14.9649 17.0834H12.3977Z", fill: "currentColor" })), wU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.43119 34.5812C6.16071 34.5812 5.07973 34.1352 4.18827 33.2431C3.29681 32.351 2.85107 31.2693 2.85107 29.9979C2.85107 29.3078 2.99253 28.655 3.27545 28.0396C3.55839 27.4242 3.9721 26.8964 4.51658 26.4563V18.748H8.08785V9.16463H19.8264L27.366 26.8858C27.5219 27.2533 27.6441 27.6235 27.7327 27.9963C27.8213 28.3692 27.8656 28.7586 27.8656 29.1646C27.8656 30.6689 27.3393 31.9477 26.2866 33.0011C25.2339 34.0545 23.956 34.5812 22.4528 34.5812C21.3467 34.5812 20.3388 34.2799 19.4292 33.6774C18.5196 33.0748 17.8609 32.265 17.4531 31.2479H11.8159C11.5405 32.2372 10.9965 33.0401 10.1841 33.6566C9.3716 34.273 8.45397 34.5812 7.43119 34.5812ZM29.5311 32.9146V7.0813H32.0294V30.4146H37.0579V32.9146H29.5311ZM7.43119 32.0813C8.00987 32.0813 8.50153 31.8788 8.90616 31.4739C9.3108 31.069 9.51311 30.577 9.51311 29.9979C9.51311 29.4189 9.3108 28.9269 8.90616 28.5219C8.50153 28.117 8.00987 27.9146 7.43119 27.9146C6.85253 27.9146 6.36089 28.117 5.95625 28.5219C5.55159 28.9269 5.34926 29.4189 5.34926 29.9979C5.34926 30.577 5.55159 31.069 5.95625 31.4739C6.36089 31.8788 6.85253 32.0813 7.43119 32.0813ZM22.4528 32.0813C23.2535 32.0813 23.9394 31.7955 24.5107 31.2239C25.0818 30.6523 25.3674 29.9659 25.3674 29.1646C25.3674 28.3633 25.0818 27.6769 24.5107 27.1053C23.9394 26.5337 23.2535 26.2479 22.4528 26.2479C21.652 26.2479 20.9661 26.5337 20.3948 27.1053C19.8237 27.6769 19.5381 28.3633 19.5381 29.1646C19.5381 29.9659 19.8237 30.6523 20.3948 31.2239C20.9661 31.7955 21.652 32.0813 22.4528 32.0813ZM11.8159 28.748H17.0655C17.0783 28.2821 17.1621 27.8371 17.3169 27.413C17.4718 26.9888 17.6986 26.6005 17.9976 26.2479H14.3943L9.52269 21.2479H7.01477V25.4787C7.07883 25.4574 7.14556 25.4413 7.21496 25.4306C7.28438 25.42 7.35646 25.4146 7.43119 25.4146C8.45397 25.4146 9.3716 25.7229 10.1841 26.3393C10.9965 26.9557 11.5405 27.7586 11.8159 28.748ZM15.4577 23.748H22.6065C22.7453 23.748 22.8814 23.764 23.0149 23.7961C23.1484 23.8281 23.2792 23.8762 23.4073 23.9403L18.1801 11.6646H10.586V18.748L15.4577 23.748ZM14.3943 26.2479L13.624 25.4562C13.1105 24.9284 12.5553 24.3521 11.9585 23.7271C11.3617 23.1021 10.8065 22.5326 10.293 22.0187L9.52269 21.2479L14.3943 26.2479Z", fill: "currentColor" })), SU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M25.3333 35L14.6944 31.25L5 35.0694V8.3611L14.6944 4.99998L25.3333 8.72219L35 4.90277V31.6111L25.3333 35ZM23.8333 31.5556V11.0277L16.1667 8.41665V28.9444L23.8333 31.5556ZM26.6111 31.5556L32.2222 29.6944V8.88885L26.6111 11.0277V31.5556ZM7.77775 31.0833L13.3889 28.9444V8.41665L7.77775 10.2777V31.0833Z", fill: "currentColor" })), MU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M27.8286 35.1083L25.8842 33.1639L28.5092 30.4972L25.8842 27.8722L27.8286 25.8861L30.4953 28.5527L33.1203 25.8861L35.1064 27.8722L32.4397 30.4972L35.1064 33.1639L33.1203 35.1083L30.4953 32.4833L27.8286 35.1083ZM9.79595 32.3305C10.3455 32.3305 10.8078 32.1447 11.1828 31.7729C11.5578 31.4012 11.7453 30.9405 11.7453 30.391C11.7453 29.8414 11.5594 29.3791 11.1877 29.0041C10.8159 28.6291 10.3553 28.4416 9.8057 28.4416C9.25614 28.4416 8.79386 28.6275 8.41886 28.9992C8.04386 29.371 7.85636 29.8316 7.85636 30.3812C7.85636 30.9308 8.04224 31.393 8.41399 31.768C8.78574 32.143 9.24639 32.3305 9.79595 32.3305ZM9.81145 35.1083C8.48956 35.1083 7.37028 34.6489 6.45361 33.73C5.53695 32.8112 5.07861 31.6954 5.07861 30.3828C5.07861 29.0702 5.53771 27.9555 6.4559 27.0389C7.37413 26.1222 8.4891 25.6639 9.80082 25.6639C10.8471 25.6639 11.78 25.9671 12.5994 26.5736C13.4189 27.18 13.986 27.9787 14.3008 28.9694C15.5508 28.8305 16.5948 28.2889 17.4328 27.3444C18.2708 26.4 18.6897 25.2935 18.6897 24.025V16.775C18.6897 14.5463 19.4752 12.6465 21.046 11.0757C22.6168 9.50483 24.5166 8.71941 26.7453 8.71941H29.7175L26.8147 5.81662L28.8009 3.83054L35.0786 10.1083L28.8009 16.386L26.8147 14.4416L29.7175 11.4972H26.7453C25.2792 11.4972 24.0331 12.0103 23.0069 13.0365C21.9806 14.0628 21.4675 15.3089 21.4675 16.775V24.025C21.4675 26.0527 20.7823 27.8097 19.4119 29.2958C18.0416 30.7819 16.3471 31.6037 14.3286 31.7611C14.0138 32.7518 13.44 33.5574 12.6072 34.1777C11.7744 34.7981 10.8425 35.1083 9.81145 35.1083ZM7.02303 14.3305L5.07861 12.386L7.70361 9.71937L5.07861 7.09437L7.02303 5.10829L9.6897 7.77495L12.3147 5.10829L14.3008 7.09437L11.6342 9.71937L14.3008 12.386L12.3147 14.3305L9.6897 11.7055L7.02303 14.3305Z", fill: "currentColor" })), TU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M15.9168 36.6667L15.139 31.3889C14.6668 31.213 14.183 30.9815 13.6876 30.6945C13.1922 30.4074 12.7455 30.1065 12.3473 29.7917L7.41679 31.9861L3.30566 24.7917L7.73625 21.514C7.68994 21.2825 7.66216 21.0301 7.65291 20.757C7.64364 20.4838 7.639 20.2315 7.639 20C7.639 19.7686 7.64364 19.5163 7.65291 19.2431C7.66216 18.9699 7.68994 18.7176 7.73625 18.4861L3.30566 15.2084L7.41679 8.01396L12.3473 10.2084C12.7455 9.89357 13.1946 9.59264 13.6946 9.30558C14.1946 9.01856 14.6761 8.79633 15.139 8.63892L15.9168 3.33337H24.0835L24.8612 8.61117C25.3335 8.78708 25.8219 9.01393 26.3265 9.29171C26.8311 9.56949 27.2733 9.87504 27.6529 10.2084L32.5835 8.01396L36.6946 15.2084L32.264 18.4306C32.3103 18.6806 32.3381 18.9422 32.3473 19.2153C32.3566 19.4885 32.3612 19.75 32.3612 20C32.3612 20.25 32.3566 20.507 32.3473 20.7709C32.3381 21.0348 32.3057 21.2917 32.2501 21.5417L36.6807 24.7917L32.5696 31.9861L27.6529 29.7917C27.2548 30.1065 26.8103 30.4121 26.3196 30.7084C25.8288 31.0047 25.3427 31.2315 24.8612 31.3889L24.0835 36.6667H15.9168ZM20.0279 25.5556C21.5649 25.5556 22.8751 25.0139 23.9585 23.9306C25.0418 22.8473 25.5835 21.5371 25.5835 20C25.5835 18.463 25.0418 17.1528 23.9585 16.0695C22.8751 14.9862 21.5649 14.4445 20.0279 14.4445C18.4816 14.4445 17.1691 14.9862 16.0904 16.0695C15.0117 17.1528 14.4723 18.463 14.4723 20C14.4723 21.5371 15.0117 22.8473 16.0904 23.9306C17.1691 25.0139 18.4816 25.5556 20.0279 25.5556ZM20.0279 22.7778C19.2594 22.7778 18.6043 22.507 18.0626 21.9653C17.521 21.4237 17.2501 20.7686 17.2501 20C17.2501 19.2315 17.521 18.5764 18.0626 18.0348C18.6043 17.4931 19.2594 17.2223 20.0279 17.2223C20.7964 17.2223 21.4515 17.4931 21.9932 18.0348C22.5348 18.5764 22.8057 19.2315 22.8057 20C22.8057 20.7686 22.5348 21.4237 21.9932 21.9653C21.4515 22.507 20.7964 22.7778 20.0279 22.7778ZM18.2223 33.889H21.764L22.3473 29.3056C23.2455 29.0834 24.0904 28.7431 24.8821 28.2848C25.6737 27.8265 26.3937 27.2732 27.0418 26.625L31.3612 28.4723L33.014 25.5278L29.2085 22.7084C29.3288 22.2639 29.4214 21.8172 29.4862 21.3681C29.5511 20.919 29.5835 20.463 29.5835 20C29.5835 19.5371 29.5557 19.0811 29.5001 18.632C29.4446 18.1829 29.3473 17.7362 29.2085 17.2917L33.014 14.4723L31.3612 11.5278L27.0418 13.3889C26.4122 12.6945 25.7062 12.1135 24.9237 11.6459C24.1413 11.1783 23.2825 10.8611 22.3473 10.6945L21.7779 6.11112H18.2362L17.6529 10.6945C16.7362 10.8982 15.8821 11.2292 15.0904 11.6875C14.2987 12.1459 13.5881 12.7084 12.9585 13.375L8.639 11.5278L6.98621 14.4723L10.7918 17.2778C10.6714 17.7315 10.5788 18.1806 10.514 18.625C10.4492 19.0695 10.4168 19.5278 10.4168 20C10.4168 20.463 10.4492 20.9167 10.514 21.3612C10.5788 21.8056 10.6714 22.2547 10.7918 22.7084L6.98621 25.5278L8.639 28.4723L12.9585 26.6112C13.6066 27.2686 14.3265 27.8265 15.1182 28.2848C15.9098 28.7431 16.7547 29.0834 17.6529 29.3056L18.2223 33.889Z", fill: "currentColor" })), kU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M9.55863 33.3055C8.1861 33.3055 7.01835 32.8248 6.05538 31.8634C5.09241 30.902 4.61092 29.7345 4.61092 28.3611H1.6665V6.66663H28.3054V13.5278H32.8887L38.3332 20.7778V28.3611H35.2498C35.2498 29.7345 34.7694 30.902 33.8087 31.8634C32.8479 32.8248 31.6812 33.3055 30.3087 33.3055C28.9361 33.3055 27.7684 32.8248 26.8054 31.8634C25.8424 30.902 25.361 29.7345 25.361 28.3611H14.4998C14.4998 29.7314 14.0194 30.8981 13.0586 31.8611C12.0979 32.824 10.9312 33.3055 9.55863 33.3055ZM9.55538 30.5278C10.1572 30.5278 10.6688 30.3171 11.0901 29.8958C11.5114 29.4745 11.722 28.9629 11.722 28.3611C11.722 27.7592 11.5114 27.2476 11.0901 26.8263C10.6688 26.405 10.1572 26.1944 9.55538 26.1944C8.95352 26.1944 8.44193 26.405 8.02063 26.8263C7.59935 27.2476 7.38871 27.7592 7.38871 28.3611C7.38871 28.9629 7.59935 29.4745 8.02063 29.8958C8.44193 30.3171 8.95352 30.5278 9.55538 30.5278ZM4.44425 25.5833H5.4998C5.97202 24.9166 6.5511 24.3842 7.23705 23.9861C7.92299 23.5879 8.68689 23.3888 9.52875 23.3888C10.3706 23.3888 11.1387 23.5925 11.8332 24C12.5276 24.4074 13.1109 24.9352 13.5832 25.5833H25.5276V9.44438H4.44425V25.5833ZM30.3054 30.5278C30.9073 30.5278 31.4188 30.3171 31.8401 29.8958C32.2614 29.4745 32.4721 28.9629 32.4721 28.3611C32.4721 27.7592 32.2614 27.2476 31.8401 26.8263C31.4188 26.405 30.9073 26.1944 30.3054 26.1944C29.7036 26.1944 29.192 26.405 28.7707 26.8263C28.3494 27.2476 28.1387 27.7592 28.1387 28.3611C28.1387 28.9629 28.3494 29.4745 28.7707 29.8958C29.192 30.3171 29.7036 30.5278 30.3054 30.5278ZM28.3054 22.0833H35.8332L31.4998 16.3055H28.3054V22.0833Z", fill: "currentColor" })), EU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M1.61133 33.3333V29.1667C1.61133 28.2037 1.85901 27.3264 2.35437 26.5348C2.84973 25.7431 3.52797 25.1482 4.38908 24.75C6.31502 23.8704 8.11595 23.2292 9.79187 22.8264C11.4678 22.4236 13.1854 22.2223 14.9447 22.2223C16.7039 22.2223 18.4169 22.4236 20.0835 22.8264C21.7502 23.2292 23.5465 23.8704 25.4724 24.75C26.3335 25.1482 27.0164 25.7431 27.521 26.5348C28.0257 27.3264 28.278 28.2037 28.278 29.1667V33.3333H1.61133ZM31.0557 33.3333V29.0556C31.0557 27.4815 30.646 26.132 29.8266 25.007C29.0071 23.882 27.9076 22.9537 26.528 22.2223C28.278 22.4259 29.9261 22.7384 31.4724 23.1598C33.0187 23.581 34.3243 24.0741 35.3891 24.6389C36.3335 25.1759 37.0696 25.8171 37.5974 26.5625C38.1252 27.3079 38.3891 28.1389 38.3891 29.0556V33.3333H31.0557ZM14.9447 19.9722C13.1113 19.9722 11.5882 19.3657 10.3752 18.1528C9.16223 16.9398 8.55574 15.4167 8.55574 13.5833C8.55574 11.75 9.16223 10.2269 10.3752 9.01392C11.5882 7.80094 13.1113 7.19446 14.9447 7.19446C16.778 7.19446 18.3011 7.80094 19.5141 9.01392C20.7271 10.2269 21.3335 11.75 21.3335 13.5833C21.3335 15.4167 20.7271 16.9398 19.5141 18.1528C18.3011 19.3657 16.778 19.9722 14.9447 19.9722ZM30.5002 13.5833C30.5002 15.4167 29.8937 16.9398 28.6807 18.1528C27.4678 19.3657 25.9446 19.9722 24.1113 19.9722C23.8057 19.9722 23.4492 19.9468 23.0418 19.8958C22.6344 19.8449 22.278 19.7685 21.9724 19.6667C22.6669 18.9074 23.1969 18.0093 23.5627 16.9722C23.9284 15.9352 24.1113 14.8056 24.1113 13.5833C24.1113 12.3611 23.9284 11.25 23.5627 10.25C23.1969 9.25 22.6669 8.33333 21.9724 7.5C22.3057 7.39817 22.6622 7.32178 23.0418 7.27083C23.4215 7.21992 23.778 7.19446 24.1113 7.19446C25.9446 7.19446 27.4678 7.80094 28.6807 9.01392C29.8937 10.2269 30.5002 11.75 30.5002 13.5833ZM4.38908 30.5556H25.5002V29.1667C25.5002 28.7685 25.3868 28.3889 25.16 28.0278C24.9331 27.6667 24.6484 27.4074 24.3057 27.25C22.4724 26.4074 20.8474 25.8218 19.4307 25.493C18.0141 25.1643 16.5187 25 14.9447 25C13.3706 25 11.8706 25.1643 10.4447 25.493C9.01872 25.8218 7.38908 26.4074 5.55574 27.25C5.21316 27.4074 4.93306 27.6667 4.71545 28.0278C4.49787 28.3889 4.38908 28.7685 4.38908 29.1667V30.5556ZM14.9447 17.1945C15.9724 17.1945 16.8312 16.8496 17.521 16.1597C18.2108 15.4699 18.5557 14.6111 18.5557 13.5833C18.5557 12.5556 18.2108 11.6968 17.521 11.007C16.8312 10.3171 15.9724 9.97221 14.9447 9.97221C13.9169 9.97221 13.0581 10.3171 12.3682 11.007C11.6784 11.6968 11.3335 12.5556 11.3335 13.5833C11.3335 14.6111 11.6784 15.4699 12.3682 16.1597C13.0581 16.8496 13.9169 17.1945 14.9447 17.1945Z", fill: "currentColor" })), RU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M21.25 2H18.75V11H21.25V2Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.64 17.6521C23.64 17.1663 23.5454 16.7026 23.3737 16.2786C22.8327 14.9423 21.5259 14 19.9999 14C18.474 14 17.1673 14.942 16.6262 16.2782C16.4544 16.7023 16.3598 17.1661 16.3598 17.6521C16.3598 18.1381 16.4544 18.6019 16.6262 19.026C16.8065 19.4714 17.072 19.873 17.4023 20.2105C17.8781 20.6967 18.4885 21.0499 19.1729 21.2094C19.4386 21.2714 19.7154 21.3041 19.9999 21.3041C20.2844 21.3041 20.5614 21.2713 20.8271 21.2094C21.5114 21.0498 22.1216 20.6967 22.5973 20.2106C22.9278 19.873 23.1933 19.4712 23.3737 19.0256C23.5454 18.6016 23.64 18.138 23.64 17.6521Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.72 17.6521C25.72 17.1663 25.8145 16.7026 25.9862 16.2785C26.5272 14.9422 27.8339 14 29.3599 14C31.3704 14 33 15.6351 33 17.6521C33 19.669 31.3703 21.3041 29.3599 21.3041C29.0754 21.3041 28.7985 21.2713 28.5327 21.2094C27.8485 21.0498 27.2383 20.6967 26.7625 20.2106C26.4321 19.873 26.1666 19.4712 25.9862 19.0256C25.8145 18.6016 25.72 18.138 25.72 17.6521Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.5072 22.4427C26.1915 22.6022 26.8017 22.9554 27.2774 23.4415C27.9223 24.1004 28.32 25.0036 28.32 26.0001C28.32 28.017 26.6903 29.652 24.6799 29.652C24.3954 29.652 24.1186 29.6193 23.8529 29.5574C23.1685 29.3979 22.5581 29.0446 22.0823 28.5584C21.7521 28.221 21.4867 27.8195 21.3063 27.3742C21.1345 26.9501 21.0398 26.4862 21.0398 26.0001C21.0398 25.514 21.1345 25.05 21.3063 24.6258C21.4867 24.1805 21.7522 23.7789 22.0824 23.4414C22.5582 22.9554 23.1684 22.6022 23.8526 22.4427C24.1184 22.3807 24.3953 22.348 24.6799 22.348C24.9645 22.348 25.2415 22.3807 25.5072 22.4427Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.8271 30.7906C21.5115 30.9501 22.1219 31.3033 22.5977 31.7895C23.2425 32.4484 23.6402 33.3516 23.6402 34.3479C23.6402 36.365 22.0104 38 20.0001 38C17.9899 38 16.36 36.3649 16.36 34.3479C16.36 33.3515 16.7578 32.4483 17.4027 31.7894C17.8784 31.3033 18.4886 30.9502 19.1728 30.7906C19.4386 30.7287 19.7156 30.6959 20.0001 30.6959C20.2846 30.6959 20.5614 30.7286 20.8271 30.7906Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.9176 28.5585C17.4418 29.0446 16.8316 29.3978 16.1474 29.5573C15.8816 29.6193 15.6047 29.652 15.3201 29.652C13.3096 29.652 11.68 28.017 11.68 26.0001C11.68 25.0036 12.0777 24.1004 12.7226 23.4415C13.1983 22.9554 13.8085 22.6022 14.4928 22.4427C14.7586 22.3807 15.0355 22.348 15.3201 22.348C15.6046 22.348 15.8814 22.3807 16.147 22.4426C16.8315 22.6021 17.4418 22.9553 17.9177 23.4416C18.2479 23.779 18.5133 24.1805 18.6937 24.6258C18.8655 25.05 18.9602 25.514 18.9602 26.0001C18.9602 26.4862 18.8655 26.9501 18.6937 27.3742C18.5133 27.8196 18.2478 28.2211 17.9176 28.5585Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.6401 21.3041C10.9246 21.3041 11.2015 21.2713 11.4673 21.2094C12.1515 21.0498 12.7617 20.6967 13.2375 20.2106C13.5678 19.8731 13.8332 19.4715 14.0136 19.026C14.1854 18.6019 14.28 18.1381 14.28 17.6521C14.28 17.1661 14.1854 16.7023 14.0136 16.2781C13.4726 14.942 12.166 14 10.6401 14C8.62967 14 7 15.635 7 17.6521C7 19.669 8.62961 21.3041 10.6401 21.3041Z", fill: "currentColor" })), OU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M15.0974 32.2222H24.903L23.9307 28.3333H16.0696L15.0974 32.2222ZM15.0002 25.5556H25.0002C27.4594 25.5556 29.5557 24.6895 31.2891 22.9573C33.0224 21.2251 33.8891 19.1302 33.8891 16.6725C33.8891 14.2149 33.0224 12.1181 31.2891 10.3819C29.5557 8.64581 27.4594 7.77775 25.0002 7.77775H15.0002C12.5409 7.77775 10.4446 8.64385 8.71125 10.376C6.97791 12.1082 6.11125 14.2032 6.11125 16.6608C6.11125 19.1184 6.97791 21.2153 8.71125 22.9514C10.4446 24.6875 12.5409 25.5556 15.0002 25.5556ZM20.0002 20.5556C18.9168 20.5556 17.9978 20.1783 17.2432 19.4236C16.4886 18.669 16.1112 17.75 16.1112 16.6667C16.1112 15.5833 16.4886 14.6643 17.2432 13.9097C17.9978 13.1551 18.9168 12.7778 20.0002 12.7778C21.0835 12.7778 22.0025 13.1551 22.7571 13.9097C23.5118 14.6643 23.8891 15.5833 23.8891 16.6667C23.8891 17.75 23.5118 18.669 22.7571 19.4236C22.0025 20.1783 21.0835 20.5556 20.0002 20.5556ZM10.7502 14.6389C11.1298 14.6389 11.4562 14.5023 11.7293 14.2292C12.0025 13.956 12.139 13.625 12.139 13.2361C12.139 12.8472 12.0025 12.5208 11.7293 12.257C11.4562 11.9931 11.1252 11.8611 10.7363 11.8611C10.3474 11.8611 10.021 11.9942 9.75712 12.2604C9.49323 12.5266 9.36129 12.8565 9.36129 13.25C9.36129 13.6296 9.49439 13.956 9.76058 14.2292C10.0268 14.5023 10.3566 14.6389 10.7502 14.6389ZM6.66683 35V32.2222H12.264L13.278 28.2222C10.4539 27.8055 8.09044 26.5116 6.18766 24.3403C4.28489 22.169 3.3335 19.6111 3.3335 16.6667C3.3335 13.4167 4.46544 10.6597 6.72933 8.39583C8.99322 6.13194 11.7502 5 15.0002 5H25.0002C28.2502 5 31.0071 6.13194 33.271 8.39583C35.5349 10.6597 36.6668 13.4167 36.6668 16.6667C36.6668 19.6111 35.7154 22.169 33.8127 24.3403C31.9099 26.5116 29.5465 27.8055 26.7224 28.2222L27.7363 32.2222H33.3335V35H6.66683ZM20.0002 23.3333C21.8335 23.3333 23.4029 22.6806 24.7085 21.375C26.0141 20.0694 26.6668 18.5 26.6668 16.6667C26.6668 14.8333 26.0141 13.2639 24.7085 11.9583C23.4029 10.6528 21.8335 10 20.0002 10C18.1668 10 16.5974 10.6528 15.2918 11.9583C13.9863 13.2639 13.3335 14.8333 13.3335 16.6667C13.3335 18.5 13.9863 20.0694 15.2918 21.375C16.5974 22.6806 18.1668 23.3333 20.0002 23.3333Z", fill: "currentColor" })), _U = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M4 36.6667V33.889H7.27779V28.1945C6.30557 27.8982 5.51621 27.345 4.90971 26.5348C4.30324 25.7246 4 24.7871 4 23.7223V10H13.3333V23.7223C13.3333 24.7315 13.0301 25.6552 12.4236 26.4931C11.8171 27.3311 11.0278 27.8982 10.0555 28.1945V33.889H13.3333V36.6667H4ZM6.77775 18.9167H10.5555V12.7778H6.77775V18.9167ZM8.66667 25.6112C9.17592 25.6112 9.61804 25.4237 9.99304 25.0487C10.368 24.6737 10.5555 24.2315 10.5555 23.7223V21.6945H6.77775V23.7223C6.77775 24.2315 6.96525 24.6737 7.34025 25.0487C7.71525 25.4237 8.15739 25.6112 8.66667 25.6112ZM17.8889 36.6667V15.5278L23.0556 13.3334V3.33337H30.3889V13.2778L35.6667 15.5V36.6667H17.8889ZM25.8333 7.88892H27.6111V6.11112H25.8333V7.88892ZM20.6667 20.4167H32.8889V17.25L27.6111 15V10.6667H25.8333V15L20.6667 17.2485V20.4167ZM20.6667 33.889H32.8889V29.9167H20.6667V33.889ZM20.6667 27.139H32.8889V23.1945H20.6667V27.139Z", fill: "currentColor" })), PU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M6.66683 33.3333C5.75016 33.3333 4.96544 33.0069 4.31266 32.3541C3.65988 31.7013 3.3335 30.9166 3.3335 30V13.3333C3.3335 12.4166 3.65988 11.6319 4.31266 10.9791C4.96544 10.3263 5.75016 9.99996 6.66683 9.99996H16.6668L20.0002 6.66663H33.3335C34.2502 6.66663 35.0349 6.99301 35.6877 7.64579C36.3404 8.29857 36.6668 9.08329 36.6668 9.99996V30C36.6668 30.9166 36.3404 31.7013 35.6877 32.3541C35.0349 33.0069 34.2502 33.3333 33.3335 33.3333H6.66683ZM9.7085 21.6666H18.3335V13.0416L9.7085 21.6666ZM6.66683 20L13.3335 13.3333H6.66683V20ZM6.66683 25V30H33.3335V9.99996H21.6668V21.6666C21.6668 22.5833 21.3404 23.368 20.6877 24.0208C20.0349 24.6736 19.2502 25 18.3335 25H6.66683Z", fill: "currentColor" })), LU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M5 18.3333V5H18.3333V18.3333H5ZM5 35V21.6667H18.3333V35H5ZM21.6667 18.3333V5H35V18.3333H21.6667ZM21.6667 35V21.6667H35V35H21.6667ZM8.33333 15H15V8.33333H8.33333V15ZM25 15H31.6667V8.33333H25V15ZM25 31.6667H31.6667V25H25V31.6667ZM8.33333 31.6667H15V25H8.33333V31.6667Z", fill: "currentColor" })), IU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M17.0209 30.8333L16.5875 27.3666C16.3528 27.2763 16.1316 27.168 15.924 27.0416C15.7164 26.9152 15.5132 26.7798 15.3146 26.6354L12.0917 27.9895L9.11255 22.8437L11.9021 20.7312C11.8841 20.6048 11.875 20.4829 11.875 20.3656V19.6343C11.875 19.517 11.8841 19.3951 11.9021 19.2687L9.11255 17.1562L12.0917 12.0104L15.3146 13.3645C15.5132 13.2201 15.7209 13.0847 15.9375 12.9583C16.1542 12.8319 16.3709 12.7236 16.5875 12.6333L17.0209 9.16663H22.9792L23.4125 12.6333C23.6473 12.7236 23.8685 12.8319 24.0761 12.9583C24.2837 13.0847 24.4869 13.2201 24.6855 13.3645L27.9084 12.0104L30.8875 17.1562L28.098 19.2687C28.116 19.3951 28.125 19.517 28.125 19.6343V20.3656C28.125 20.4829 28.107 20.6048 28.0709 20.7312L30.8605 22.8437L27.8813 27.9895L24.6855 26.6354C24.4869 26.7798 24.2792 26.9152 24.0625 27.0416C23.8459 27.168 23.6292 27.2763 23.4125 27.3666L22.9792 30.8333H17.0209ZM18.9167 28.6666H21.0563L21.4355 25.7958C21.9952 25.6513 22.5143 25.4392 22.9928 25.1593C23.4712 24.8795 23.9091 24.5409 24.3063 24.1437L26.9875 25.2541L28.0438 23.4125L25.7146 21.652C25.8049 21.3993 25.8681 21.1329 25.9042 20.8531C25.9403 20.5732 25.9584 20.2888 25.9584 20C25.9584 19.7111 25.9403 19.4267 25.9042 19.1468C25.8681 18.867 25.8049 18.6007 25.7146 18.3479L28.0438 16.5875L26.9875 14.7458L24.3063 15.8833C23.9091 15.468 23.4712 15.1204 22.9928 14.8406C22.5143 14.5607 21.9952 14.3486 21.4355 14.2041L21.0834 11.3333H18.9438L18.5646 14.2041C18.0049 14.3486 17.4858 14.5607 17.0073 14.8406C16.5289 15.1204 16.091 15.459 15.6938 15.8562L13.0125 14.7458L11.9563 16.5875L14.2855 18.3208C14.1952 18.5916 14.132 18.8625 14.0959 19.1333C14.0598 19.4041 14.0417 19.693 14.0417 20C14.0417 20.2888 14.0598 20.5687 14.0959 20.8395C14.132 21.1104 14.1952 21.3812 14.2855 21.652L11.9563 23.4125L13.0125 25.2541L15.6938 24.1166C16.091 24.5319 16.5289 24.8795 17.0073 25.1593C17.4858 25.4392 18.0049 25.6513 18.5646 25.7958L18.9167 28.6666ZM20.0542 23.7916C21.1014 23.7916 21.9952 23.4215 22.7355 22.6812C23.4757 21.9409 23.8459 21.0472 23.8459 20C23.8459 18.9527 23.4757 18.059 22.7355 17.3187C21.9952 16.5784 21.1014 16.2083 20.0542 16.2083C18.9889 16.2083 18.0907 16.5784 17.3594 17.3187C16.6282 18.059 16.2625 18.9527 16.2625 20C16.2625 21.0472 16.6282 21.9409 17.3594 22.6812C18.0907 23.4215 18.9889 23.7916 20.0542 23.7916Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.5 3C4.11929 3 3 4.11929 3 5.5C3 6.88071 4.11929 8 5.5 8C6.88071 8 8 6.88071 8 5.5C8 4.11929 6.88071 3 5.5 3ZM1 5.5C1 3.01472 3.01472 1 5.5 1C7.98528 1 10 3.01472 10 5.5C10 7.98528 7.98528 10 5.5 10C3.01472 10 1 7.98528 1 5.5Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 29H11V38H2V29ZM4 31V36H9V31H4Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30 4C30 2.34315 31.3431 1 33 1H36C37.6569 1 39 2.34315 39 4V7C39 8.65685 37.6569 10 36 10H33C31.3431 10 30 8.65685 30 7V4ZM33 3C32.4477 3 32 3.44772 32 4V7C32 7.55228 32.4477 8 33 8H36C36.5523 8 37 7.55228 37 7V4C37 3.44772 36.5523 3 36 3H33Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32.5001 27L38.9953 38.25H26.0049L32.5001 27ZM29.469 36.25H35.5312L32.5001 31L29.469 36.25Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.793 14.7071L7.29297 9.20706L8.70718 7.79285L14.2072 13.2928L12.793 14.7071Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.793 33.2071L23.293 26.7071L24.7072 25.2928L31.2072 31.7928L29.793 33.2071Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.7072 26.7072L10.7072 31.7072L9.29297 30.2929L14.293 25.2929L15.7072 26.7072Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32.2475 9.66431L28.2475 14.1643L26.7527 12.8356L30.7527 8.33558L32.2475 9.66431Z", fill: "currentColor" })), jU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M8.33333 35C7.41667 35 6.63194 34.6736 5.97917 34.0208C5.32639 33.3681 5 32.5833 5 31.6667V8.33333C5 7.41667 5.32639 6.63194 5.97917 5.97917C6.63194 5.32639 7.41667 5 8.33333 5H31.6667C32.5833 5 33.3681 5.32639 34.0208 5.97917C34.6736 6.63194 35 7.41667 35 8.33333V31.6667C35 32.5833 34.6736 33.3681 34.0208 34.0208C33.3681 34.6736 32.5833 35 31.6667 35H8.33333ZM18.3333 25H8.33333V31.6667H18.3333V25ZM21.6667 25V31.6667H31.6667V25H21.6667ZM18.3333 21.6667V15H8.33333V21.6667H18.3333ZM21.6667 21.6667H31.6667V15H21.6667V21.6667ZM8.33333 11.6667H31.6667V8.33333H8.33333V11.6667Z", fill: "currentColor" })), VU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M18.6665 31.6113H21.4444V23.7084L24.6111 26.875L26.5553 24.9167L19.9998 18.4721L13.4998 24.9721L15.4582 26.9167L18.6665 23.7084V31.6113ZM9.44442 36.6667C8.69442 36.6667 8.04387 36.3913 7.49275 35.8405C6.94192 35.2894 6.6665 34.6388 6.6665 33.8888V6.11129C6.6665 5.36129 6.94192 4.71074 7.49275 4.15962C8.04387 3.60879 8.69442 3.33337 9.44442 3.33337H23.9165L33.3332 12.75V33.8888C33.3332 34.6388 33.0578 35.2894 32.5069 35.8405C31.9558 36.3913 31.3053 36.6667 30.5553 36.6667H9.44442ZM22.5278 14.0555V6.11129H9.44442V33.8888H30.5553V14.0555H22.5278Z", fill: "currentColor" })), DU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M19.7642 5.27954H11.2622C7.24731 5.27954 4 8.31194 4 12.0611V28.3258C4 30.3657 5.00371 32.2402 6.59785 33.5083L19.7642 5.27954Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { d: "M17.9346 21.3236L25.4328 5.27954H28.6802C32.695 5.27954 35.9424 8.36707 35.9424 12.0611V21.3236H17.9346Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { d: "M15.6895 26.1746H36V28.3248C36 32.074 32.6936 35.1063 28.7378 35.1063H11.4976L15.6895 26.1746Z", fill: "currentColor" })), AU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M9.25016 31.2778L3.3335 25.3611L5.27791 23.4167L9.23629 27.3473L16.5696 20.0139L18.514 22L9.25016 31.2778ZM9.25016 17.9444L3.3335 12.0278L5.27791 10.0833L9.23629 14.0139L16.5696 6.68054L18.514 8.66667L9.25016 17.9444ZM21.6668 28.0555V25.2778H36.6668V28.0555H21.6668ZM21.6668 14.7222V11.9445H36.6668V14.7222H21.6668Z", fill: "currentColor" })), HU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M9.107 22.4444C8.4337 22.4444 7.85862 22.2046 7.38175 21.7252C6.90492 21.2457 6.6665 20.6693 6.6665 19.996C6.6665 19.3227 6.90624 18.7477 7.38571 18.2708C7.86518 17.794 8.44156 17.5555 9.11484 17.5555C9.78814 17.5555 10.3632 17.7953 10.8401 18.2747C11.3169 18.7542 11.5553 19.3306 11.5553 20.0039C11.5553 20.6772 11.3156 21.2523 10.8361 21.7291C10.3567 22.206 9.78028 22.4444 9.107 22.4444ZM19.9959 22.4444C19.3226 22.4444 18.7475 22.2046 18.2707 21.7252C17.7938 21.2457 17.5554 20.6693 17.5554 19.996C17.5554 19.3227 17.7952 18.7477 18.2746 18.2708C18.7541 17.794 19.3305 17.5555 20.0038 17.5555C20.6771 17.5555 21.2521 17.7953 21.729 18.2747C22.2058 18.7542 22.4443 19.3306 22.4443 20.0039C22.4443 20.6772 22.2045 21.2523 21.725 21.7291C21.2456 22.206 20.6692 22.4444 19.9959 22.4444ZM30.8848 22.4444C30.2115 22.4444 29.6364 22.2046 29.1596 21.7252C28.6828 21.2457 28.4443 20.6693 28.4443 19.996C28.4443 19.3227 28.6841 18.7477 29.1635 18.2708C29.643 17.794 30.2194 17.5555 30.8927 17.5555C31.566 17.5555 32.141 17.7953 32.6179 18.2747C33.0947 18.7542 33.3332 19.3306 33.3332 20.0039C33.3332 20.6772 33.0934 21.2523 32.614 21.7291C32.1345 22.206 31.5581 22.4444 30.8848 22.4444Z", fill: "currentColor" })), FU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M14.7385 34.7045C11.6092 33.5409 9.04042 31.5818 7.03203 28.8273C5.02363 26.0728 4.01943 22.9227 4.01943 19.3773C4.01943 18.5591 4.0789 17.7454 4.19784 16.9363C4.31681 16.1273 4.50438 15.3318 4.76057 14.55L2.37246 15.9273L1 13.5955L8.37015 9.3682L12.6248 16.65L10.2367 18.0136L7.90352 14.0318C7.54668 14.8772 7.27448 15.75 7.08691 16.65C6.89932 17.55 6.80553 18.4682 6.80553 19.4045C6.80553 22.3955 7.67477 25.0614 9.41326 27.4023C11.1517 29.7432 13.3935 31.3773 16.1384 32.3046L14.7385 34.7045ZM26.8437 13.9091V11.1818H31.4964C30.1971 9.46364 28.5867 8.125 26.6653 7.1659C24.7438 6.2068 22.6988 5.72725 20.5303 5.72725C18.7644 5.72725 17.1128 6.0318 15.5756 6.64091C14.0385 7.24999 12.6614 8.09545 11.4445 9.17727L10.0446 6.75001C11.4902 5.57729 13.0937 4.6591 14.8551 3.99544C16.6164 3.33181 18.4945 3 20.4891 3C22.8223 3 25.0343 3.45682 27.1251 4.37045C29.2158 5.28409 31.0435 6.58636 32.6081 8.27727V5.45455H35.353V13.9091H26.8437ZM25.2516 39L17.8814 34.7727L22.1361 27.4909L24.483 28.8545L22.1086 32.9455C25.5673 32.5546 28.4563 31.075 30.7759 28.5068C33.0953 25.9387 34.2551 22.9046 34.2551 19.4045C34.2551 18.9227 34.2299 18.4545 34.1796 18C34.1293 17.5454 34.0492 17.0909 33.9394 16.6364H36.753C36.8353 17.0909 36.8971 17.5432 36.9382 17.9932C36.9794 18.4432 37 18.9 37 19.3636C37 23.1909 35.8128 26.5886 33.4384 29.5568C31.064 32.525 28.0149 34.4409 24.2909 35.3046L26.6241 36.6682L25.2516 39Z", fill: "currentColor" })), NU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M23.6388 26.4446H26.4167V21.3334H31.5V18.5554H26.4167V13.4721H23.6388V18.5554H18.5279V21.3334H23.6388V26.4446ZM9.80542 34.0554C6.85181 32.926 4.47917 31.0834 2.6875 28.5275C0.895833 25.972 0 23.1224 0 19.9788C0 16.8354 0.900417 13.9884 2.70125 11.4375C4.50236 8.88669 6.87042 7.04641 9.80542 5.91669V9.02794C7.65736 10.0185 5.94903 11.5018 4.68042 13.4779C3.41208 15.4538 2.77792 17.6185 2.77792 19.9721C2.77792 22.3518 3.41208 24.5232 4.68042 26.4863C5.94903 28.4491 7.65736 29.9352 9.80542 30.9446V34.0554ZM25 34.9721C22.9167 34.9721 20.9653 34.5763 19.1458 33.7846C17.3264 32.9929 15.7431 31.9235 14.3958 30.5763C13.0486 29.2291 11.9792 27.6457 11.1875 25.8263C10.3958 24.0068 10 22.0554 10 19.9721C10 17.8888 10.3958 15.9374 11.1875 14.1179C11.9792 12.2985 13.0486 10.7152 14.3958 9.36794C15.7431 8.02072 17.3264 6.95127 19.1458 6.15961C20.9653 5.36794 22.9167 4.97211 25 4.97211C27.0833 4.97211 29.0347 5.36794 30.8542 6.15961C32.6736 6.95127 34.2569 8.02072 35.6042 9.36794C36.9514 10.7152 38.0208 12.2985 38.8125 14.1179C39.6042 15.9374 40 17.8888 40 19.9721C40 22.0554 39.6042 24.0068 38.8125 25.8263C38.0208 27.6457 36.9514 29.2291 35.6042 30.5763C34.2569 31.9235 32.6736 32.9929 30.8542 33.7846C29.0347 34.5763 27.0833 34.9721 25 34.9721ZM25.0138 32.1946C28.4026 32.1946 31.2846 31.0088 33.6596 28.6371C36.0346 26.2652 37.2221 23.3768 37.2221 19.9721C37.2221 16.5927 36.0363 13.7107 33.6646 11.3263C31.2929 8.94211 28.4047 7.75002 25 7.75002C21.6203 7.75002 18.7383 8.94211 16.3542 11.3263C13.97 13.7107 12.7779 16.5927 12.7779 19.9721C12.7779 23.3768 13.97 26.2652 16.3542 28.6371C18.7383 31.0088 21.6249 32.1946 25.0138 32.1946Z", fill: "currentColor" })), $U = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M30.2776 23.3333V18.0555H24.9998V15.2778H30.2776V10H33.0554V15.2778H38.3332V18.0555H33.0554V23.3333H30.2776ZM14.9998 19.9722C13.1665 19.9722 11.6434 19.3657 10.4304 18.1528C9.21743 16.9398 8.61096 15.4167 8.61096 13.5833C8.61096 11.75 9.21743 10.2269 10.4304 9.01392C11.6434 7.80094 13.1665 7.19446 14.9998 7.19446C16.8332 7.19446 18.3563 7.80094 19.5693 9.01392C20.7822 10.2269 21.3887 11.75 21.3887 13.5833C21.3887 15.4167 20.7822 16.9398 19.5693 18.1528C18.3563 19.3657 16.8332 19.9722 14.9998 19.9722ZM1.6665 33.3333V29.1667C1.6665 28.2037 1.90956 27.3264 2.39567 26.5348C2.88178 25.7431 3.56466 25.1482 4.4443 24.75C6.40727 23.8519 8.22521 23.206 9.89813 22.8125C11.5711 22.419 13.2701 22.2223 14.9953 22.2223C16.7206 22.2223 18.4165 22.419 20.0832 22.8125C21.7498 23.206 23.5647 23.8519 25.5276 24.75C26.4072 25.1667 27.0947 25.7662 27.5901 26.5486C28.0855 27.331 28.3332 28.2037 28.3332 29.1667V33.3333H1.6665ZM4.44425 30.5556H25.5554V29.1667C25.5554 28.7685 25.4466 28.3935 25.229 28.0417C25.0114 27.6898 24.7221 27.4259 24.361 27.25C22.5461 26.3889 20.9304 25.7986 19.5137 25.4792C18.097 25.1597 16.5924 25 14.9998 25C13.4073 25 11.898 25.1597 10.472 25.4792C9.04613 25.7986 7.42577 26.3889 5.61096 27.25C5.24982 27.4259 4.96509 27.6898 4.75675 28.0417C4.54842 28.3935 4.44425 28.7685 4.44425 29.1667V30.5556ZM14.9998 17.1945C16.0276 17.1945 16.8864 16.8496 17.5762 16.1597C18.266 15.4699 18.611 14.6111 18.611 13.5833C18.611 12.5556 18.266 11.6968 17.5762 11.007C16.8864 10.3171 16.0276 9.97221 14.9998 9.97221C13.9721 9.97221 13.1133 10.3171 12.4235 11.007C11.7336 11.6968 11.3887 12.5556 11.3887 13.5833C11.3887 14.6111 11.7336 15.4699 12.4235 16.1597C13.1133 16.8496 13.9721 17.1945 14.9998 17.1945Z", fill: "currentColor" })), BU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M18.6946 28.3333H21.4724V21.5H28.3335V18.7222H21.4724V11.6666H18.6946V18.7222H11.6668V21.5H18.6946V28.3333ZM20.0075 36.6666C17.7069 36.6666 15.5449 36.2291 13.5215 35.3541C11.498 34.4791 9.73165 33.287 8.22237 31.7778C6.71312 30.2685 5.521 28.5015 4.646 26.4766C3.771 24.4518 3.3335 22.2883 3.3335 19.9861C3.3335 17.6839 3.771 15.5204 4.646 13.4956C5.521 11.4707 6.71312 9.70831 8.22237 8.20831C9.73165 6.70831 11.4987 5.52081 13.5235 4.64581C15.5483 3.77081 17.7118 3.33331 20.014 3.33331C22.3163 3.33331 24.4798 3.77081 26.5046 4.64581C28.5294 5.52081 30.2918 6.70831 31.7918 8.20831C33.2918 9.70831 34.4793 11.4722 35.3543 13.5C36.2293 15.5278 36.6668 17.692 36.6668 19.9926C36.6668 22.2932 36.2293 24.4552 35.3543 26.4787C34.4793 28.5021 33.2918 30.2668 31.7918 31.7726C30.2918 33.2785 28.5279 34.4706 26.5002 35.349C24.4724 36.2274 22.3082 36.6666 20.0075 36.6666ZM20.014 33.8889C23.8752 33.8889 27.1529 32.537 29.8474 29.8333C32.5419 27.1296 33.8891 23.8472 33.8891 19.9861C33.8891 16.125 32.5436 12.8472 29.8526 10.1527C27.1616 7.45829 23.8775 6.11106 20.0002 6.11106C16.1483 6.11106 12.8705 7.45655 10.1668 10.1475C7.46311 12.8385 6.11125 16.1227 6.11125 20C6.11125 23.8518 7.46311 27.1296 10.1668 29.8333C12.8705 32.537 16.1529 33.8889 20.014 33.8889Z", fill: "currentColor" })), zU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M5 35V31.7778L7.77775 29V35H5ZM11.8055 35V25.1111L14.5833 22.3333V35H11.8055ZM18.6111 35V22.3333L21.3889 25.1528V35H18.6111ZM25.4167 35V25.1528L28.1945 22.375V35H25.4167ZM32.2222 35V18.4445L35 15.6667V35H32.2222ZM5 25.5694V21.6389L16.6667 10.0278L23.3333 16.6945L35 5V8.93054L23.3333 20.625L16.6667 13.9583L5 25.5694Z", fill: "currentColor" })), ZU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M24.9977 31.6666L22.6227 29.3333L30.2894 21.6666H3.33105V18.3333H30.2894L22.6644 10.6666L24.9977 8.33325L36.6644 19.9999L24.9977 31.6666Z", fill: "currentColor" })), WU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M20 27L10 16.9768L11.9722 15L20 23.0743L28.0278 15.0279L30 17.0046L20 27Z", fill: "currentColor" })), UU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M18.611 6.66663V28.0417L8.61092 18.0416L6.6665 20L19.9998 33.3333L33.3332 20L31.3888 18.0416L21.3887 28.0417V6.66663H18.611Z", fill: "currentColor" })), GU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M23.3614 30L13.3335 19.9721L23.3614 9.94458L25.3335 11.9167L17.2781 19.9721L25.3335 28.0279L23.3614 30Z", fill: "currentColor" })), qU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M11.9581 21.3888L21.9582 31.3889L19.9998 33.3333L6.6665 20L19.9998 6.66663L21.9582 8.61104L11.9581 18.6111H33.3332V21.3888H11.9581Z", fill: "currentColor" })), KU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M21.7219 19.9721L13.6665 11.9167L15.6386 9.94458L25.6665 19.9721L15.6386 30L13.6665 28.0279L21.7219 19.9721Z", fill: "currentColor" })), YU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M28.0415 21.3888H6.6665V18.6111H28.0415L18.0415 8.61104L19.9998 6.66663L33.3332 20L19.9998 33.3333L18.0415 31.3889L28.0415 21.3888Z", fill: "currentColor" })), XU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M11.9722 25L10 23.0232L20 13L30 22.9954L28.0278 24.9721L20 16.9257L11.9722 25Z", fill: "currentColor" })), JU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M18.611 33.3333V11.9583L8.61092 21.9583L6.6665 20L19.9998 6.66663L33.3332 20L31.3888 21.9583L21.3887 11.9583V33.3333H18.611Z", fill: "currentColor" })), QU = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M5 36.6666V6.11106H10.1389V3.33331H13.0555V6.11106H26.9445V3.33331H29.8611V6.11106H35V36.6666H5ZM7.77775 33.8889H32.2222V16.3889H7.77775V33.8889ZM7.77775 13.6111H32.2222V8.88886H7.77775V13.6111Z", fill: "currentColor" })), eG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M32.75 35C29.5926 35 26.3634 34.2268 23.0625 32.6805C19.7616 31.1342 16.7037 28.9537 13.8889 26.1389C11.0555 23.324 8.86574 20.2685 7.31946 16.9722C5.77315 13.6759 5 10.4352 5 7.24998V4.99998H14.25L15.875 13.0416L11.0417 17.9444C11.7639 19.1389 12.5231 20.2546 13.3194 21.2916C14.1157 22.3287 14.9537 23.2824 15.8333 24.1528C16.7685 25.088 17.7755 25.9699 18.8542 26.7986C19.9329 27.6273 21.0926 28.3889 22.3333 29.0834L27.1945 24.1111L35 25.7639V35H32.75ZM9.70833 15.3333L12.875 12.1389L12 7.77773H7.79167C7.83794 8.89809 8.01386 10.0763 8.31942 11.3125C8.62497 12.5486 9.08794 13.8889 9.70833 15.3333ZM24.9305 30.3889C26.0602 30.8981 27.2569 31.3102 28.5208 31.625C29.7847 31.9398 31.0185 32.1296 32.2222 32.1944V28L28.0556 27.1528L24.9305 30.3889ZM21.5278 18.4166V8.49998H24.3055V13.6944L33.6667 4.33331L35.6389 6.30552L26.3055 15.6389H31.4445V18.4166H21.5278Z", fill: "currentColor" })), tG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M13.8335 28.1111L20.0002 21.9444L26.1668 28.1111L28.1113 26.1666L21.9446 20L28.1113 13.8333L26.1668 11.8889L20.0002 18.0556L13.8335 11.8889L11.889 13.8333L18.0557 20L11.889 26.1666L13.8335 28.1111ZM20.0002 36.6666C17.7131 36.6666 15.5557 36.2291 13.528 35.3541C11.5002 34.4791 9.73165 33.287 8.22237 31.7778C6.71312 30.2685 5.521 28.5 4.646 26.4722C3.771 24.4444 3.3335 22.287 3.3335 20C3.3335 17.6944 3.771 15.5278 4.646 13.5C5.521 11.4722 6.71312 9.70831 8.22237 8.20831C9.73165 6.70831 11.5002 5.52081 13.528 4.64581C15.5557 3.77081 17.7131 3.33331 20.0002 3.33331C22.3057 3.33331 24.4724 3.77081 26.5002 4.64581C28.5279 5.52081 30.2918 6.70831 31.7918 8.20831C33.2918 9.70831 34.4793 11.4722 35.3543 13.5C36.2293 15.5278 36.6668 17.6944 36.6668 20C36.6668 22.287 36.2293 24.4444 35.3543 26.4722C34.4793 28.5 33.2918 30.2685 31.7918 31.7778C30.2918 33.287 28.5279 34.4791 26.5002 35.3541C24.4724 36.2291 22.3057 36.6666 20.0002 36.6666ZM20.0002 33.8889C23.8705 33.8889 27.1529 32.537 29.8474 29.8333C32.5419 27.1296 33.8891 23.8518 33.8891 20C33.8891 16.1296 32.5419 12.8472 29.8474 10.1527C27.1529 7.45829 23.8705 6.11106 20.0002 6.11106C16.1483 6.11106 12.8705 7.45829 10.1668 10.1527C7.46311 12.8472 6.11125 16.1296 6.11125 20C6.11125 23.8518 7.46311 27.1296 10.1668 29.8333C12.8705 32.537 16.1483 33.8889 20.0002 33.8889Z", fill: "currentColor" })), nG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M15.8054 29.8333L6.4165 20.4444L8.40259 18.4583L15.8054 25.8611L31.5693 10.0972L33.5554 12.0833L15.8054 29.8333Z", fill: "currentColor" })), oG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.85995 13.3202C10.8754 13.3202 13.32 10.8757 13.32 7.8602C13.32 4.84472 10.8754 2.4002 7.85995 2.4002C4.84448 2.4002 2.39995 4.84472 2.39995 7.8602C2.39995 10.8757 4.84448 13.3202 7.85995 13.3202ZM7.85995 14.5202C11.5382 14.5202 14.52 11.5384 14.52 7.8602C14.52 4.18198 11.5382 1.2002 7.85995 1.2002C4.18173 1.2002 1.19995 4.18198 1.19995 7.8602C1.19995 11.5384 4.18173 14.5202 7.85995 14.5202Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.6486 6.04872L7.01376 10.6835L4.40002 8.06978L5.24855 7.22125L7.01376 8.98646L10.8 5.2002L11.6486 6.04872Z", fill: "currentColor" })), rG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M4.47217 20.1945V17.4167H9.63883V20.1945H4.47217ZM9.52771 29.6945L7.63883 27.7778L11.25 24.1667L13.1666 26.0556L9.52771 29.6945ZM11.25 13.3611L7.63883 9.75L9.52771 7.83333L13.1666 11.4722L11.25 13.3611ZM30.5555 33.3611L22.6944 25.5L20.7777 31.3611L16.2222 15.8056L31.5555 20.5556L25.6666 22.6389L33.4721 30.4445L30.5555 33.3611ZM17.6944 10.1667V5H20.4722V10.1667H17.6944ZM26.9166 13.3611L25 11.4722L28.6388 7.83333L30.5277 9.72221L26.9166 13.3611Z", fill: "currentColor" })), iG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M27.5833 26V14L21.5834 20L27.5833 26ZM7.77775 32.2222H13.5278V7.77775H7.77775V32.2222ZM16.3055 32.2222H32.2222V7.77775H16.3055V32.2222ZM5 35V5H35V35H5Z", fill: "currentColor" })), sG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M10.4722 31.4722L8.52783 29.5278L18.0556 20L8.52783 10.4722L10.4722 8.52783L20 18.0556L29.5278 8.52783L31.4722 10.4722L21.9445 20L31.4722 29.5278L29.5278 31.4722L20 21.9445L10.4722 31.4722Z", fill: "currentColor" })), aG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M5.01367 31.6666V8.33331H34.9998V31.6666H5.01367ZM7.77755 28.8889H14.0693V11.1111H7.77755V28.8889ZM16.847 28.8889H23.1387V11.1111H16.847V28.8889ZM25.9165 28.8889H32.2081V11.1111H25.9165V28.8889Z", fill: "currentColor" })), lG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M20.0002 36.6666C17.6946 36.6666 15.5279 36.2291 13.5002 35.3541C11.4724 34.4791 9.7085 33.2916 8.2085 31.7916C6.7085 30.2916 5.521 28.5278 4.646 26.5C3.771 24.4722 3.3335 22.3055 3.3335 20C3.3335 17.6944 3.771 15.5278 4.646 13.5C5.521 11.4722 6.7085 9.70831 8.2085 8.20831C9.7085 6.70831 11.4724 5.52081 13.5002 4.64581C15.5279 3.77081 17.6946 3.33331 20.0002 3.33331C22.3057 3.33331 24.4724 3.77081 26.5002 4.64581C28.5279 5.52081 30.2918 6.70831 31.7918 8.20831C33.2918 9.70831 34.4793 11.4722 35.3543 13.5C36.2293 15.5278 36.6668 17.6944 36.6668 20C36.6668 22.3055 36.2293 24.4722 35.3543 26.5C34.4793 28.5278 33.2918 30.2916 31.7918 31.7916C30.2918 33.2916 28.5279 34.4791 26.5002 35.3541C24.4724 36.2291 22.3057 36.6666 20.0002 36.6666ZM18.6114 33.8333V6.16665C15.0464 6.5647 12.0718 8.07859 9.68766 10.7083C7.3035 13.338 6.11141 16.4353 6.11141 20C6.11141 23.5647 7.3035 26.6573 9.68766 29.2779C12.0718 31.8982 15.0464 33.4167 18.6114 33.8333ZM21.3889 33.8333C22.3706 33.713 23.3289 33.5023 24.2639 33.2012C25.1992 32.9004 26.102 32.5 26.9722 32H21.3889V33.8333ZM21.3889 29.2221H30.3889C30.7222 28.824 31.0417 28.4212 31.3472 28.0137C31.6528 27.6065 31.9353 27.1668 32.1947 26.6946H21.3889V29.2221ZM21.3889 23.9166H33.3056C33.4722 23.5091 33.5834 23.0925 33.6389 22.6666C33.6945 22.2408 33.7409 21.8148 33.7781 21.3887H21.3889V23.9166ZM21.3889 18.6112H33.7781C33.7409 18.1851 33.6945 17.7591 33.6389 17.3333C33.5834 16.9075 33.4722 16.4908 33.3056 16.0833H21.3889V18.6112ZM21.3889 13.3054H32.1947C31.9539 12.8332 31.6761 12.3935 31.3614 11.9862C31.0464 11.5787 30.7222 11.176 30.3889 10.7779H21.3889V13.3054ZM21.3889 7.99998H26.9722C26.102 7.49998 25.1992 7.09484 24.2639 6.78456C23.3289 6.47456 22.3706 6.26859 21.3889 6.16665V7.99998Z", fill: "currentColor" })), cG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M13.2502 33.3334L11.3057 31.375L16.0974 26.5834H3.3335V23.8056H16.0974L11.3057 19.0139L13.2502 17.0556L21.389 25.1945L13.2502 33.3334ZM26.7502 22.9444L18.6113 14.8056L26.7502 6.66669L28.6946 8.62502L23.9029 13.4167H36.6668V16.1944H23.9029L28.6946 20.9861L26.7502 22.9444Z", fill: "currentColor" })), dG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M11.4446 35V13.5556L23.0557 1.66669L25.6945 3.97223L23.5279 13.5556H38.1946V20.75L32.0557 35H11.4446ZM14.2223 32.2223H30.2501L35.4168 20.0278V16.3334H20.0557L22.2779 6.3611L14.2223 14.7222V32.2223ZM3.30566 35V13.5556H11.4446V16.3334H6.08346V32.2223H11.4446V35H3.30566Z", fill: "currentColor" })), uG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M5 35V5H35V35H5ZM7.77775 32.2222H18.6111V7.77775H7.77775V32.2222ZM21.3889 32.2222H32.2222V19.9722H21.3889V32.2222ZM21.3889 17.1945H32.2222V7.77775H21.3889V17.1945Z", fill: "currentColor" })), fG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M8.36096 35V9.16663H6.6665V6.38888H14.6665V5H25.3332V6.38888H33.3332V9.16663H31.6387V35H8.36096ZM11.1387 32.2222H28.861V9.16663H11.1387V32.2222ZM15.1943 28.7222H17.972V12.6389H15.1943V28.7222ZM22.0276 28.7222H24.8054V12.6389H22.0276V28.7222Z", fill: "currentColor" })), pG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M10 36.6667C8.61111 36.6667 7.43056 36.1806 6.45833 35.2083C5.48611 34.2361 5 33.0556 5 31.6667V8.33334C5 6.94446 5.48611 5.7639 6.45833 4.79168C7.43056 3.81945 8.61111 3.33334 10 3.33334H27.7778V29.4444H10C9.37036 29.4444 8.84258 29.6574 8.41667 30.0833C7.99072 30.5093 7.77775 31.037 7.77775 31.6667C7.77775 32.2963 7.99072 32.8241 8.41667 33.25C8.84258 33.676 9.37036 33.8889 10 33.8889H32.2222V6.66668H35V36.6667H10ZM14.4444 26.6667H25V6.11109H14.4444V26.6667ZM11.6667 26.6667V6.11109H10C9.36111 6.11109 8.83101 6.32407 8.40971 6.75001C7.9884 7.17593 7.77775 7.7037 7.77775 8.33334V27.2361C8.11108 27.0602 8.45954 26.9213 8.82313 26.8195C9.18671 26.7176 9.579 26.6667 10 26.6667H11.6667Z", fill: "currentColor" })), hG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M14.7196 33.3334C13.8786 33.3334 13.1596 33.0339 12.5623 32.4351C11.9651 31.8362 11.6665 31.1163 11.6665 30.2754C11.6665 29.4344 11.9659 28.7153 12.5648 28.1181C13.1637 27.5209 13.8836 27.2223 14.7245 27.2223C15.5654 27.2223 16.2845 27.5217 16.8818 28.1206C17.479 28.7194 17.7776 29.4393 17.7776 30.2803C17.7776 31.1212 17.4782 31.8403 16.8793 32.4375C16.2804 33.0347 15.5605 33.3334 14.7196 33.3334ZM25.2752 33.3334C24.4342 33.3334 23.7151 33.0339 23.1179 32.4351C22.5207 31.8362 22.2221 31.1163 22.2221 30.2754C22.2221 29.4344 22.5215 28.7153 23.1204 28.1181C23.7192 27.5209 24.4391 27.2223 25.2801 27.2223C26.121 27.2223 26.8401 27.5217 27.4373 28.1206C28.0346 28.7194 28.3332 29.4393 28.3332 30.2803C28.3332 31.1212 28.0337 31.8403 27.4349 32.4375C26.836 33.0347 26.1161 33.3334 25.2752 33.3334ZM14.7196 23.0556C13.8786 23.0556 13.1596 22.7561 12.5623 22.1573C11.9651 21.5584 11.6665 20.8385 11.6665 19.9976C11.6665 19.1566 11.9659 18.4375 12.5648 17.8403C13.1637 17.2431 13.8836 16.9445 14.7245 16.9445C15.5654 16.9445 16.2845 17.2439 16.8818 17.8428C17.479 18.4416 17.7776 19.1615 17.7776 20.0025C17.7776 20.8434 17.4782 21.5625 16.8793 22.1597C16.2804 22.757 15.5605 23.0556 14.7196 23.0556ZM25.2752 23.0556C24.4342 23.0556 23.7151 22.7561 23.1179 22.1573C22.5207 21.5584 22.2221 20.8385 22.2221 19.9976C22.2221 19.1566 22.5215 18.4375 23.1204 17.8403C23.7192 17.2431 24.4391 16.9445 25.2801 16.9445C26.121 16.9445 26.8401 17.2439 27.4373 17.8428C28.0346 18.4416 28.3332 19.1615 28.3332 20.0025C28.3332 20.8434 28.0337 21.5625 27.4349 22.1597C26.836 22.757 26.1161 23.0556 25.2752 23.0556ZM14.7196 12.7778C13.8786 12.7778 13.1596 12.4783 12.5623 11.8795C11.9651 11.2806 11.6665 10.5607 11.6665 9.71977C11.6665 8.87883 11.9659 8.15974 12.5648 7.56252C13.1637 6.9653 13.8836 6.66669 14.7245 6.66669C15.5654 6.66669 16.2845 6.96612 16.8818 7.56498C17.479 8.16384 17.7776 8.88374 17.7776 9.72469C17.7776 10.5656 17.4782 11.2847 16.8793 11.8819C16.2804 12.4792 15.5605 12.7778 14.7196 12.7778ZM25.2752 12.7778C24.4342 12.7778 23.7151 12.4783 23.1179 11.8795C22.5207 11.2806 22.2221 10.5607 22.2221 9.71977C22.2221 8.87883 22.5215 8.15974 23.1204 7.56252C23.7192 6.9653 24.4391 6.66669 25.2801 6.66669C26.121 6.66669 26.8401 6.96612 27.4373 7.56498C28.0346 8.16384 28.3332 8.88374 28.3332 9.72469C28.3332 10.5656 28.0337 11.2847 27.4349 11.8819C26.836 12.4792 26.1161 12.7778 25.2752 12.7778Z", fill: "currentColor" })), gG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M10.5555 31.1111V3.33331H33.3333V31.1111H10.5555ZM13.3333 28.3334H30.5556V6.11106H13.3333V28.3334ZM5 36.6666V8.88886H7.77775V33.8889H27.7778V36.6666H5Z", fill: "currentColor" })), mG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.77775 32.2222H9.79163L28.3334 13.7083L26.3195 11.6944L7.77775 30.2084V32.2222ZM5 35V29.0834L30.2639 3.875L36.1389 9.80554L10.9166 35H5ZM27.3195 12.7083L26.3195 11.6944L28.3334 13.7083L27.3195 12.7083Z", fill: "currentColor" })), bG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32.5393 9.46856L37 5.00786L34.9921 3L30.5315 7.46069C27.6845 5.06705 24.0106 3.62518 20 3.62518C10.9565 3.62518 3.62533 10.9564 3.62533 19.9999C3.62533 24.0105 5.06719 27.6843 7.46083 30.5313L3 34.9921L5.00786 37L9.4687 32.5392C12.3157 34.9327 15.9895 36.3745 20 36.3745C29.0435 36.3745 36.3747 29.0433 36.3747 19.9999C36.3747 15.9893 34.9329 12.3155 32.5393 9.46856ZM28.5145 9.47769C26.1889 7.59351 23.2263 6.46472 20 6.46472C12.5248 6.46472 6.46487 12.5246 6.46487 19.9999C6.46487 23.2261 7.59365 26.1887 9.47783 28.5143L28.5145 9.47769ZM11.4857 30.5222L30.5223 11.4856C32.4064 13.8111 33.5351 16.7737 33.5351 19.9999C33.5351 27.4751 27.4753 33.535 20 33.535C16.7738 33.535 13.8113 32.4063 11.4857 30.5222Z", fill: "currentColor" })), CG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M5.30558 30L3.3335 28.0279L15.5556 15.8054L22.4168 22.6666L32.0002 13.1112H27.0281V10.3333H36.6668V19.9721H33.9168V15.1112L22.3889 26.6387L15.5281 19.7779L5.30558 30Z", fill: "currentColor" })), xG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M19.9998 26.8611L11.861 18.7223L13.8332 16.7223L18.611 21.5001V6.66669H21.3887V21.5001L26.1665 16.7223L28.1387 18.7223L19.9998 26.8611ZM6.6665 33.3334V24.9167H9.44425V30.5556H30.5554V24.9167H33.3332V33.3334H6.6665Z", fill: "currentColor" })), yG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M9.7085 35.6667L12.4168 23.9583L3.3335 16.0833L15.3335 15.0417L20.0002 4L24.6668 15.0417L36.6668 16.0833L27.5835 23.9583L30.2918 35.6667L20.0002 29.4583L9.7085 35.6667Z", fill: "currentColor" })), vG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M13.889 29.875L20.0002 26.2083L26.1113 29.9167L24.4863 22.9722L29.8613 18.3055L22.778 17.6805L20.0002 11.125L17.2224 17.6389L10.139 18.2639L15.514 22.9445L13.889 29.875ZM9.7085 35.6667L12.4168 23.9583L3.3335 16.0833L15.3335 15.0417L20.0002 4L24.6668 15.0417L36.6668 16.0833L27.5835 23.9583L30.2918 35.6667L20.0002 29.4583L9.7085 35.6667Z", fill: "currentColor" })), wG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M16.6667 30V27.2223H23.3333V30H16.6667ZM10 21.3889V18.6111H30V21.3889H10ZM5 12.7778V10H35V12.7778H5Z", fill: "currentColor" })), SG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M5 30V27.2223H35V30H5ZM5 21.3889V18.6111H35V21.3889H5ZM5 12.7778V10H35V12.7778H5Z", fill: "currentColor" })), MG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M26.4165 22.4166L24.3887 20.3889C24.9535 18.6389 24.5785 17.1389 23.2637 15.8889C21.9489 14.6389 20.4535 14.2685 18.7776 14.7778L16.7498 12.75C17.2221 12.4722 17.7336 12.2685 18.2845 12.1389C18.8355 12.0093 19.4073 11.9444 19.9998 11.9444C22.0091 11.9444 23.7151 12.6458 25.1179 14.0486C26.5207 15.4514 27.222 17.1574 27.222 19.1666C27.222 19.7592 27.1526 20.3356 27.0137 20.8958C26.8748 21.456 26.6758 21.963 26.4165 22.4166ZM31.7776 27.75L29.861 25.8611C31.1202 24.9259 32.2244 23.8866 33.1735 22.7431C34.1225 21.5995 34.8517 20.4074 35.361 19.1666C33.9721 16.1759 31.9188 13.8078 29.2013 12.0625C26.4836 10.3171 23.5091 9.4444 20.2776 9.4444C19.2313 9.4444 18.1711 9.53699 17.097 9.72219C16.023 9.90738 15.1294 10.1389 14.4165 10.4166L12.2776 8.24998C13.3054 7.79629 14.523 7.41897 15.9304 7.11802C17.3378 6.81711 18.7406 6.66665 20.1387 6.66665C24.185 6.66665 27.8517 7.80785 31.1387 10.0903C34.4258 12.3727 36.8239 15.3981 38.3332 19.1666C37.6387 20.8981 36.7383 22.4884 35.6318 23.9375C34.5253 25.3866 33.2406 26.6574 31.7776 27.75ZM33.6665 37.4444L26.6665 30.5555C25.6943 30.9166 24.6364 31.1921 23.4929 31.3819C22.3494 31.5717 21.185 31.6666 19.9998 31.6666C15.898 31.6666 12.1989 30.5254 8.90263 28.243C5.60632 25.9606 3.19428 22.9352 1.6665 19.1666C2.23131 17.713 2.99057 16.3171 3.9443 14.9791C4.89799 13.6412 6.03688 12.3889 7.36096 11.2222L2.33317 6.16661L4.27759 4.1944L35.5276 35.4444L33.6665 37.4444ZM9.27763 13.1666C8.32391 13.9074 7.41649 14.8287 6.55538 15.9306C5.69427 17.0324 5.04612 18.1111 4.61092 19.1666C6.01834 22.1574 8.10399 24.5255 10.8679 26.2708C13.6318 28.0162 16.7498 28.8889 20.222 28.8889C21.0184 28.8889 21.8008 28.8403 22.5693 28.7431C23.3378 28.6458 23.9628 28.5093 24.4443 28.3333L22.1665 26.0277C21.8609 26.1481 21.5137 26.2384 21.1248 26.2986C20.7359 26.3588 20.3609 26.3889 19.9998 26.3889C18.0091 26.3889 16.3077 25.6921 14.8957 24.2986C13.4836 22.9051 12.7776 21.1944 12.7776 19.1666C12.7776 18.787 12.8077 18.412 12.8679 18.0416C12.9281 17.6713 13.0184 17.324 13.1388 17L9.27763 13.1666Z", fill: "currentColor" })), TG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("mask", { id: "mask0_3026_2741", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 40, height: 40 }, /* @__PURE__ */ y.createElement("rect", { width: 40, height: 40, fill: "#D9D9D9" })), /* @__PURE__ */ y.createElement("g", { mask: "url(#mask0_3026_2741)" }, /* @__PURE__ */ y.createElement("path", { d: "M9.59996 32.3364H15.4V21.7843H24.6V32.3364H30.4V16.3545L20 8.32947L9.59996 16.3545V32.3364ZM7 35V15.0228L20 5L33 15.0228V35H22V24.4478H18V35H7Z", fill: "currentColor" }))), kG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M18.611 26.8611V12.0278L13.8332 16.8056L11.861 14.8056L19.9998 6.66669L28.1387 14.8056L26.1665 16.8056L21.3887 12.0278V26.8611H18.611ZM6.6665 33.3334V24.9167H9.44425V30.5556H30.5554V24.9167H33.3332V33.3334H6.6665Z", fill: "currentColor" })), EG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M18.6946 28.3333H21.4724V18.3333H18.6946V28.3333ZM19.9997 15.1666C20.4167 15.1666 20.7664 15.0282 21.0488 14.7514C21.3312 14.4745 21.4724 14.1315 21.4724 13.7222C21.4724 13.2972 21.3313 12.941 21.0492 12.6535C20.7672 12.366 20.4176 12.2222 20.0007 12.2222C19.5837 12.2222 19.234 12.366 18.9515 12.6535C18.6692 12.941 18.528 13.2972 18.528 13.7222C18.528 14.1315 18.669 14.4745 18.9511 14.7514C19.2332 15.0282 19.5827 15.1666 19.9997 15.1666ZM20.0075 36.6666C17.7069 36.6666 15.5449 36.2291 13.5215 35.3541C11.498 34.4791 9.73165 33.287 8.22237 31.7778C6.71312 30.2685 5.521 28.5015 4.646 26.4766C3.771 24.4518 3.3335 22.2883 3.3335 19.9861C3.3335 17.6839 3.771 15.5204 4.646 13.4956C5.521 11.4707 6.71312 9.70831 8.22237 8.20831C9.73165 6.70831 11.4987 5.52081 13.5235 4.64581C15.5483 3.77081 17.7118 3.33331 20.014 3.33331C22.3163 3.33331 24.4798 3.77081 26.5046 4.64581C28.5294 5.52081 30.2918 6.70831 31.7918 8.20831C33.2918 9.70831 34.4793 11.4722 35.3543 13.5C36.2293 15.5278 36.6668 17.692 36.6668 19.9926C36.6668 22.2932 36.2293 24.4552 35.3543 26.4787C34.4793 28.5021 33.2918 30.2668 31.7918 31.7726C30.2918 33.2785 28.5279 34.4706 26.5002 35.349C24.4724 36.2274 22.3082 36.6666 20.0075 36.6666ZM20.014 33.8889C23.8752 33.8889 27.1529 32.537 29.8474 29.8333C32.5419 27.1296 33.8891 23.8472 33.8891 19.9861C33.8891 16.125 32.5436 12.8472 29.8526 10.1527C27.1616 7.45829 23.8775 6.11106 20.0002 6.11106C16.1483 6.11106 12.8705 7.45655 10.1668 10.1475C7.46311 12.8385 6.11125 16.1227 6.11125 20C6.11125 23.8518 7.46311 27.1296 10.1668 29.8333C12.8705 32.537 16.1529 33.8889 20.014 33.8889Z", fill: "currentColor" })), RG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M13.3054 29.7222H26.6943V26.9445H13.3054V29.7222ZM13.3054 22.7778H26.6943V20H13.3054V22.7778ZM6.6665 36.6667V3.33334H23.9165L33.3332 12.75V36.6667H6.6665ZM22.5276 14.0556V6.11109H9.44425V33.8889H30.5554V14.0556H22.5276Z", fill: "currentColor" })), OG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M12.2117 15.0961V12.5962H34.1667V15.0961H12.2117ZM12.2117 21.2499V18.75H34.1667V21.2499H12.2117ZM12.2117 27.4038V24.9038H34.1667V27.4038H12.2117ZM7.17966 15.1923C6.79825 15.1923 6.47854 15.0617 6.22054 14.8007C5.96251 14.5396 5.8335 14.2161 5.8335 13.8301C5.8335 13.4533 5.96251 13.1374 6.22054 12.8824C6.47854 12.6275 6.79825 12.5 7.17966 12.5C7.56105 12.5 7.88075 12.6275 8.13875 12.8824C8.39677 13.1374 8.52579 13.4533 8.52579 13.8301C8.52579 14.2161 8.39677 14.5396 8.13875 14.8007C7.88075 15.0617 7.56105 15.1923 7.17966 15.1923ZM7.17966 21.33C6.79825 21.33 6.47854 21.2026 6.22054 20.9477C5.96251 20.6927 5.8335 20.3768 5.8335 20C5.8335 19.6025 5.96251 19.2762 6.22054 19.0208C6.47854 18.7655 6.79825 18.6378 7.17966 18.6378C7.56105 18.6378 7.88075 18.7655 8.13875 19.0208C8.39677 19.2762 8.52579 19.6025 8.52579 20C8.52579 20.3768 8.39677 20.6927 8.13875 20.9477C7.88075 21.2026 7.56105 21.33 7.17966 21.33ZM7.17966 27.4999C6.79825 27.4999 6.47854 27.3694 6.22054 27.1083C5.96251 26.8472 5.8335 26.5237 5.8335 26.1378C5.8335 25.7609 5.96251 25.445 6.22054 25.19C6.47854 24.9351 6.79825 24.8076 7.17966 24.8076C7.56105 24.8076 7.88075 24.9351 8.13875 25.19C8.39677 25.445 8.52579 25.7609 8.52579 26.1378C8.52579 26.5237 8.39677 26.8472 8.13875 27.1083C7.88075 27.3694 7.56105 27.4999 7.17966 27.4999Z", fill: "currentColor" })), _G = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M5 35V5H19.9722V7.77775H7.77775V32.2222H19.9722V35H5ZM27.3889 27.6389L25.4306 25.6389L29.6806 21.3889H15V18.6111H29.625L25.375 14.3611L27.3333 12.3611L35 20.0278L27.3889 27.6389Z", fill: "currentColor" })), PG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M3.3335 33.3333V6.66666H36.6668V33.3333H3.3335ZM20.0002 21.0555L6.11125 12.0833V30.5556H33.8891V12.0833L20.0002 21.0555ZM20.0002 18.2778L33.778 9.44441H6.25016L20.0002 18.2778ZM6.11125 12.0833V9.44441V30.5556V12.0833Z", fill: "currentColor" })), LG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M8.3335 21.3889V18.6111H31.6668V21.3889H8.3335Z", fill: "currentColor" })), IG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M5 35V5H19.4167V7.77775H7.77775V32.2222H32.2222V20.5833H35V35H5ZM16 25.9722L14.0555 24L30.2778 7.77775H22.1944V5H35V17.8056H32.2222V9.74996L16 25.9722Z", fill: "currentColor" })), jG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M21.5834 14V26L27.5833 20L21.5834 14ZM7.77775 32.2222H13.5278V7.77775H7.77775V32.2222ZM16.3055 32.2222H32.2222V7.77775H16.3055V32.2222ZM5 35V5H35V35H5Z", fill: "currentColor" })), VG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M18.6113 21.3889H8.3335V18.6112H18.6113V8.33337H21.389V18.6112H31.6668V21.3889H21.389V31.6667H18.6113V21.3889Z", fill: "currentColor" })), DG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 5.00002V35H20.6529C20.4407 34.5806 20.2581 34.1378 20.105 33.6717C19.9517 33.2053 19.824 32.7221 19.7221 32.2221H7.77792V7.77794H32.2221V19.7084C32.6943 19.7917 33.1665 19.9097 33.6388 20.0625C34.111 20.2153 34.5647 20.4074 35 20.6388V5.00002H24.1946C23.9815 4.01863 23.4838 3.21766 22.7013 2.5971C21.919 1.97683 21.0186 1.66669 20 1.66669C18.9814 1.66669 18.081 1.97683 17.2988 2.5971C16.5163 3.21766 16.0185 4.01863 15.8054 5.00002H5ZM20.9792 6.47919C20.7061 6.75224 20.3797 6.88877 20 6.88877C19.6203 6.88877 19.2939 6.75224 19.0208 6.47919C18.7478 6.20613 18.6113 5.87974 18.6113 5.50002C18.6113 5.1203 18.7478 4.79391 19.0208 4.52085C19.2939 4.2478 19.6203 4.11127 20 4.11127C20.3797 4.11127 20.7061 4.2478 20.9792 4.52085C21.2522 4.79391 21.3888 5.1203 21.3888 5.50002C21.3888 5.87974 21.2522 6.20613 20.9792 6.47919Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { d: "M19.7917 28.3334H11.6667V25.5554H20.7363C20.514 25.9907 20.3265 26.4399 20.1738 26.9029C20.021 27.3657 19.8936 27.8425 19.7917 28.3334Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { d: "M24.6113 21.3888H11.6667V18.6113H28.3333V19.7638C27.6203 19.9027 26.9606 20.1064 26.3542 20.375C25.7478 20.6436 25.1668 20.9815 24.6113 21.3888Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { d: "M28.3333 14.4446H11.6667V11.6667H28.3333V14.4446Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.7273 35.9715C26.2929 37.5368 28.1861 38.3194 30.4069 38.3194C32.628 38.3194 34.5213 37.5368 36.0869 35.9715C37.6522 34.4059 38.4348 32.5126 38.4348 30.2915C38.4348 28.0706 37.6522 26.1774 36.0869 24.6119C34.5213 23.0466 32.628 22.264 30.4069 22.264C28.1861 22.264 26.2929 23.0466 24.7273 24.6119C23.162 26.1774 22.3794 28.0706 22.3794 30.2915C22.3794 32.5126 23.162 34.4059 24.7273 35.9715ZM34.1153 33.2498L32.9557 34.4165L29.3516 30.736V25.4581H30.9903V30.1248L34.1153 33.2498Z", fill: "currentColor" })), AG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M18.4167 26.0791C18.428 24.3162 18.6586 22.9498 19.1084 21.9797C19.5582 21.0096 20.4469 19.9352 21.7746 18.7564C22.8679 17.7764 23.6975 16.8556 24.2634 15.9941C24.8292 15.1327 25.1122 14.1877 25.1122 13.1592C25.1122 11.7895 24.6483 10.652 23.7206 9.74676C22.7929 8.84148 21.5149 8.38884 19.8867 8.38884C18.4408 8.38884 17.3119 8.76099 16.4999 9.5053C15.688 10.2496 15.0608 11.0929 14.6185 12.0352L11.9658 10.8397C12.6247 9.3148 13.6158 8.05645 14.9391 7.06467C16.2624 6.07287 17.9116 5.57697 19.8867 5.57697C22.5078 5.57697 24.5282 6.3154 25.9481 7.79226C27.3679 9.26909 28.0779 11.0239 28.0779 13.0566C28.0779 14.3372 27.801 15.4977 27.2472 16.5379C26.6935 17.5782 25.851 18.6264 24.72 19.6827C23.2734 21.0096 22.3804 22.0589 22.041 22.8306C21.7016 23.6024 21.5262 24.6852 21.5149 26.0791H18.4167ZM19.8867 35.8333C19.2578 35.8333 18.7177 35.6077 18.2665 35.1565C17.8153 34.7053 17.5897 34.1652 17.5897 33.5363C17.5897 32.9074 17.8153 32.3674 18.2665 31.9162C18.7177 31.465 19.2578 31.2394 19.8867 31.2394C20.5156 31.2394 21.0556 31.465 21.5068 31.9162C21.958 32.3674 22.1837 32.9074 22.1837 33.5363C22.1837 34.1652 21.958 34.7053 21.5068 35.1565C21.0556 35.6077 20.5156 35.8333 19.8867 35.8333Z", fill: "currentColor" })), HG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M5 35V4.99999H15.8056C16.0185 4.01852 16.5162 3.21759 17.2986 2.5972C18.081 1.97684 18.9815 1.66666 20 1.66666C21.0185 1.66666 21.919 1.97684 22.7014 2.5972C23.4838 3.21759 23.9815 4.01852 24.1944 4.99999H35V35H5ZM7.77775 32.2222H32.2222V7.77774H7.77775V32.2222ZM11.6667 28.3333H23.1389V25.5556H11.6667V28.3333ZM11.6667 21.3889H28.3333V18.6111H11.6667V21.3889ZM11.6667 14.4444H28.3333V11.6667H11.6667V14.4444ZM20 6.88887C20.3796 6.88887 20.706 6.7523 20.9792 6.47916C21.2523 6.20599 21.3889 5.8796 21.3889 5.49999C21.3889 5.12035 21.2523 4.79396 20.9792 4.52082C20.706 4.24766 20.3796 4.11107 20 4.11107C19.6204 4.11107 19.294 4.24766 19.0208 4.52082C18.7477 4.79396 18.6111 5.12035 18.6111 5.49999C18.6111 5.8796 18.7477 6.20599 19.0208 6.47916C19.294 6.7523 19.6204 6.88887 20 6.88887Z", fill: "currentColor" })), FG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M4.44434 16.5C4.44434 13.9074 5.02073 11.5301 6.1735 9.36806C7.32628 7.20601 8.87027 5.4074 10.8055 3.97223L12.4582 6.19444C10.8656 7.3796 9.59479 8.86108 8.64571 10.6389C7.69666 12.4166 7.22213 14.3703 7.22213 16.5H4.44434ZM32.7776 16.5C32.7776 14.3703 32.3031 12.4166 31.354 10.6389C30.405 8.86108 29.1341 7.3796 27.5415 6.19444L29.1943 3.97223C31.1295 5.4074 32.6735 7.20601 33.8263 9.36806C34.979 11.5301 35.5554 13.9074 35.5554 16.5H32.7776ZM6.66654 31.6666V28.8889H9.99988V16.5555C9.99988 14.2315 10.6897 12.1551 12.0693 10.3264C13.4489 8.49766 15.2591 7.33331 17.4999 6.83331V5.83331C17.4999 5.13887 17.7429 4.54859 18.229 4.06248C18.7152 3.57637 19.3054 3.33331 19.9999 3.33331C20.6943 3.33331 21.2846 3.57637 21.7707 4.06248C22.2568 4.54859 22.4999 5.13887 22.4999 5.83331V6.83331C24.7406 7.33331 26.5508 8.49766 27.9304 10.3264C29.3101 12.1551 29.9999 14.2315 29.9999 16.5555V28.8889H33.3332V31.6666H6.66654ZM19.9999 36.6666C19.0832 36.6666 18.2985 36.3403 17.6457 35.6875C16.9929 35.0347 16.6665 34.25 16.6665 33.3333H23.3332C23.3332 34.25 23.0068 35.0347 22.354 35.6875C21.7013 36.3403 20.9165 36.6666 19.9999 36.6666ZM12.7776 28.8889H27.2221V16.5555C27.2221 14.5555 26.5184 12.8518 25.111 11.4444C23.7036 10.037 21.9999 9.33331 19.9999 9.33331C17.9999 9.33331 16.2962 10.037 14.8888 11.4444C13.4813 12.8518 12.7776 14.5555 12.7776 16.5555V28.8889Z", fill: "currentColor" })), NG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M26.8887 17.7222V14.9445H36.6665V17.7222H26.8887ZM14.9998 19.9722C13.1665 19.9722 11.6434 19.3657 10.4304 18.1528C9.21743 16.9398 8.61096 15.4167 8.61096 13.5833C8.61096 11.75 9.21743 10.2269 10.4304 9.01392C11.6434 7.80094 13.1665 7.19446 14.9998 7.19446C16.8332 7.19446 18.3563 7.80094 19.5693 9.01392C20.7822 10.2269 21.3887 11.75 21.3887 13.5833C21.3887 15.4167 20.7822 16.9398 19.5693 18.1528C18.3563 19.3657 16.8332 19.9722 14.9998 19.9722ZM1.6665 33.3333V29.1667C1.6665 28.2037 1.90956 27.3264 2.39567 26.5348C2.88178 25.7431 3.56466 25.1482 4.4443 24.75C6.40727 23.8519 8.22521 23.206 9.89813 22.8125C11.5711 22.419 13.2701 22.2223 14.9953 22.2223C16.7206 22.2223 18.4165 22.419 20.0832 22.8125C21.7498 23.206 23.5647 23.8519 25.5276 24.75C26.4072 25.1667 27.0947 25.7662 27.5901 26.5486C28.0855 27.331 28.3332 28.2037 28.3332 29.1667V33.3333H1.6665ZM4.44425 30.5556H25.5554V29.1667C25.5554 28.7685 25.4466 28.3935 25.229 28.0417C25.0114 27.6898 24.7221 27.4259 24.361 27.25C22.5461 26.3889 20.9304 25.7986 19.5137 25.4792C18.097 25.1597 16.5924 25 14.9998 25C13.4073 25 11.898 25.1597 10.472 25.4792C9.04613 25.7986 7.42577 26.3889 5.61096 27.25C5.24982 27.4259 4.96509 27.6898 4.75675 28.0417C4.54842 28.3935 4.44425 28.7685 4.44425 29.1667V30.5556ZM14.9998 17.1945C16.0276 17.1945 16.8864 16.8496 17.5762 16.1597C18.266 15.4699 18.611 14.6111 18.611 13.5833C18.611 12.5556 18.266 11.6968 17.5762 11.007C16.8864 10.3171 16.0276 9.97221 14.9998 9.97221C13.9721 9.97221 13.1133 10.3171 12.4235 11.007C11.7336 11.6968 11.3887 12.5556 11.3887 13.5833C11.3887 14.6111 11.7336 15.4699 12.4235 16.1597C13.1133 16.8496 13.9721 17.1945 14.9998 17.1945Z", fill: "currentColor" })), $G = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M11.6668 21.3056H28.3335V18.5278H11.6668V21.3056ZM20.0002 36.6667C17.7131 36.6667 15.5557 36.2292 13.528 35.3542C11.5002 34.4792 9.73165 33.2871 8.22237 31.7778C6.71312 30.2686 5.521 28.5 4.646 26.4723C3.771 24.4445 3.3335 22.2871 3.3335 20C3.3335 17.6945 3.771 15.5278 4.646 13.5C5.521 11.4723 6.71312 9.70837 8.22237 8.20837C9.73165 6.70837 11.5002 5.52087 13.528 4.64587C15.5557 3.77087 17.7131 3.33337 20.0002 3.33337C22.3057 3.33337 24.4724 3.77087 26.5002 4.64587C28.5279 5.52087 30.2918 6.70837 31.7918 8.20837C33.2918 9.70837 34.4793 11.4723 35.3543 13.5C36.2293 15.5278 36.6668 17.6945 36.6668 20C36.6668 22.2871 36.2293 24.4445 35.3543 26.4723C34.4793 28.5 33.2918 30.2686 31.7918 31.7778C30.2918 33.2871 28.5279 34.4792 26.5002 35.3542C24.4724 36.2292 22.3057 36.6667 20.0002 36.6667ZM20.0002 33.889C23.8705 33.889 27.1529 32.5371 29.8474 29.8334C32.5419 27.1297 33.8891 23.8519 33.8891 20C33.8891 16.1297 32.5419 12.8473 29.8474 10.1528C27.1529 7.45835 23.8705 6.11112 20.0002 6.11112C16.1483 6.11112 12.8705 7.45835 10.1668 10.1528C7.46311 12.8473 6.11125 16.1297 6.11125 20C6.11125 23.8519 7.46311 27.1297 10.1668 29.8334C12.8705 32.5371 16.1483 33.889 20.0002 33.889Z", fill: "currentColor" })), BG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M18.6804 36.5554C14.3287 36.1943 10.6899 34.4352 7.76375 31.2779C4.83792 28.1204 3.375 24.3611 3.375 20C3.375 15.6389 4.83792 11.8796 7.76375 8.7221C10.6899 5.56488 14.3287 3.80571 18.6804 3.4446V7.9446C15.5879 8.27794 13.0093 9.59266 10.9446 11.8888C8.87958 14.1852 7.85639 16.8889 7.875 20C7.89361 23.1111 8.92597 25.8149 10.9721 28.1113C13.0185 30.4074 15.5879 31.7221 18.6804 32.0554V36.5554ZM21.4583 36.5554V32.0554C24.2917 31.7777 26.6851 30.6388 28.6388 28.6388C30.5926 26.6388 31.7547 24.2221 32.125 21.3888H36.625C36.2917 25.4721 34.7014 28.9421 31.8542 31.7988C29.0069 34.6552 25.5417 36.2407 21.4583 36.5554ZM32.125 18.6113C31.7731 15.7779 30.6157 13.3613 28.6529 11.3613C26.6899 9.36127 24.2917 8.21308 21.4583 7.91669V3.41669C25.5231 3.75002 28.9837 5.34488 31.8404 8.20127C34.6968 11.0579 36.2917 14.5279 36.625 18.6113H32.125Z", fill: "currentColor" })), zG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M3.3335 33.3333V6.66666H17.2502L20.028 9.44441H36.6668V12.2222H18.8474L16.0696 9.44441H6.11125V30.5556L10.2779 14.9999H39.1668L34.1946 33.3333H3.3335ZM9.02791 30.5556H32.0835L35.4169 17.7777H12.3612L9.02791 30.5556Z", fill: "currentColor" })), ZG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M11.0832 31.6667V28.8889H23.6387C25.5184 28.8889 27.141 28.2732 28.5068 27.0417C29.8725 25.8102 30.5554 24.2778 30.5554 22.4445C30.5554 20.6111 29.8725 19.0787 28.5068 17.8472C27.141 16.6158 25.5184 16 23.6387 16H11.9443L16.5554 20.6111L14.6109 22.5556L6.6665 14.6111L14.6109 6.66669L16.5554 8.6111L11.9443 13.2222H23.611C26.2684 13.2222 28.5531 14.1065 30.4651 15.875C32.3772 17.6435 33.3332 19.8334 33.3332 22.4445C33.3332 25.0556 32.3772 27.2454 30.4651 29.0139C28.5531 30.7824 26.2684 31.6667 23.611 31.6667H11.0832Z", fill: "currentColor" })), WG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M35 11.5833V35H5V5H28.4167L35 11.5833ZM32.2222 12.8055L27.1945 7.77775H7.77775V32.2222H32.2222V12.8055ZM19.9935 29.8611C21.2571 29.8611 22.3333 29.4189 23.2222 28.5343C24.1111 27.6498 24.5555 26.5757 24.5555 25.3121C24.5555 24.0485 24.1133 22.9722 23.2288 22.0833C22.3442 21.1945 21.2702 20.75 20.0065 20.75C18.7429 20.75 17.6667 21.1923 16.7778 22.0768C15.8889 22.9614 15.4445 24.0354 15.4445 25.299C15.4445 26.5627 15.8867 27.6389 16.7713 28.5278C17.6558 29.4167 18.7298 29.8611 19.9935 29.8611ZM9.80554 16H24.75V9.80554H9.80554V16Z", fill: "currentColor" })), UG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M17.1943 28.3611L26.722 18.8333L24.8054 16.9167L17.2082 24.5139L13.2637 20.5695L11.3332 22.5L17.1943 28.3611ZM10.5832 33.3333C8.11095 33.3333 6.00678 32.4722 4.27067 30.75C2.53456 29.0278 1.6665 26.9306 1.6665 24.4583C1.6665 22.2917 2.34706 20.3796 3.70817 18.7222C5.06928 17.0648 6.81466 16.0463 8.9443 15.6667C9.54613 13.0185 10.8795 10.8611 12.9443 9.19446C15.0091 7.52779 17.3795 6.69446 20.0554 6.69446C23.2128 6.69446 25.8818 7.8264 28.0623 10.0903C30.2429 12.3542 31.3332 15.0833 31.3332 18.2778V18.9445C33.3054 18.9815 34.9651 19.6875 36.3123 21.0625C37.6596 22.4375 38.3332 24.1296 38.3332 26.1389C38.3332 28.1111 37.6272 29.8032 36.2151 31.2153C34.8031 32.6273 33.1109 33.3333 31.1388 33.3333H10.5832ZM10.5832 30.5556H31.1388C32.361 30.5556 33.4026 30.125 34.2638 29.2639C35.1249 28.4028 35.5554 27.3611 35.5554 26.1389C35.5554 24.9167 35.1249 23.875 34.2638 23.0139C33.4026 22.1528 32.361 21.7222 31.1388 21.7222H28.5554V18.2778C28.5554 15.8241 27.7197 13.743 26.0485 12.0347C24.3772 10.3264 22.3424 9.47221 19.9443 9.47221C17.5461 9.47221 15.5068 10.3264 13.8262 12.0347C12.1457 13.743 11.3054 15.8241 11.3054 18.2778H10.4998C8.81464 18.2778 7.38409 18.8704 6.20817 20.0555C5.03223 21.2407 4.44425 22.6944 4.44425 24.4167C4.44425 26.1204 5.04148 27.5695 6.23592 28.7639C7.43037 29.9584 8.87945 30.5556 10.5832 30.5556Z", fill: "currentColor" })), GG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M17.1112 26.25C17.7594 26.8982 18.6622 27.206 19.8196 27.1736C20.977 27.1412 21.8242 26.713 22.3613 25.8889L31.4724 11.8055L17.5002 21C16.6946 21.537 16.2664 22.3843 16.2154 23.5417C16.1645 24.6991 16.4631 25.6019 17.1112 26.25ZM19.9446 6.69446C21.5465 6.69446 23.1738 6.94214 24.8265 7.4375C26.4793 7.93286 28.0557 8.75 29.5557 9.88892L27.0557 11.5833C25.9169 10.8704 24.7062 10.3403 23.4238 9.99304C22.1414 9.64582 20.9814 9.47221 19.944 9.47221C16.1112 9.47221 12.8475 10.833 10.153 13.5546C7.4585 16.2762 6.11125 19.5726 6.11125 23.444C6.11125 24.6665 6.28023 25.8935 6.6182 27.125C6.95618 28.3565 7.43534 29.5 8.0557 30.5556H31.8057C32.4261 29.5371 32.9053 28.3935 33.2432 27.125C33.5812 25.8565 33.7502 24.5926 33.7502 23.3333C33.7502 22.2222 33.5951 21.0602 33.2849 19.8472C32.9747 18.6342 32.4446 17.5 31.6946 16.4444L33.4446 13.9444C34.4261 15.4167 35.1738 16.9213 35.6877 18.4583C36.2016 19.9954 36.4817 21.5555 36.528 23.1389C36.5742 24.7778 36.4029 26.3287 36.014 27.7917C35.6252 29.2546 35.0557 30.6204 34.3057 31.8889C33.9817 32.4815 33.6067 32.8704 33.1807 33.0555C32.7548 33.2407 32.2594 33.3333 31.6946 33.3333H8.16683C7.65758 33.3333 7.1622 33.2083 6.6807 32.9583C6.19923 32.7083 5.8335 32.3518 5.5835 31.8889C4.86127 30.5833 4.30572 29.2384 3.91683 27.8542C3.52794 26.4699 3.3335 25 3.3335 23.4445C3.3335 21.1389 3.771 18.9699 4.646 16.9375C5.521 14.9051 6.71082 13.1319 8.21546 11.618C9.72007 10.1042 11.4833 8.90508 13.5052 8.02083C15.527 7.13658 17.6735 6.69446 19.9446 6.69446Z", fill: "currentColor" })), qG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M33 35L22.1945 24.1945C21.3611 24.8982 20.3939 25.4491 19.2928 25.8472C18.1917 26.2454 17.02 26.4445 15.7778 26.4445C12.7655 26.4445 10.2162 25.4005 8.12971 23.3125C6.04324 21.2246 5 18.6945 5 15.7222C5 12.75 6.04399 10.2199 8.13196 8.13196C10.2199 6.04399 12.7546 5 15.7361 5C18.7176 5 21.2477 6.04399 23.3264 8.13196C25.4051 10.2199 26.4445 12.7514 26.4445 15.7264C26.4445 16.9273 26.25 18.0787 25.8611 19.1806C25.4722 20.2824 24.9074 21.2963 24.1667 22.2222L35 33L33 35ZM15.75 23.6667C17.9491 23.6667 19.8183 22.8912 21.3576 21.3403C22.897 19.7894 23.6667 17.9167 23.6667 15.7222C23.6667 13.5278 22.897 11.6551 21.3576 10.1042C19.8183 8.55325 17.9491 7.77779 15.75 7.77779C13.5355 7.77779 11.6532 8.55325 10.103 10.1042C8.55283 11.6551 7.77775 13.5278 7.77775 15.7222C7.77775 17.9167 8.55283 19.7894 10.103 21.3403C11.6532 22.8912 13.5355 23.6667 15.75 23.6667Z", fill: "currentColor" })), KG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M5 33.3333V6.66666L36.6667 20L5 33.3333ZM7.77775 29.0834L29.4722 20L7.77775 10.8333V17.4444L17.8333 20L7.77775 22.5V29.0834Z", fill: "currentColor" })), YG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M17.9722 35V25.4167H20.75V28.8333H35V31.6111H20.75V35H17.9722ZM5 31.6111V28.8333H15.1945V31.6111H5ZM12.4167 24.7778V21.3889H5V18.6111H12.4167V15.1667H15.1945V24.7778H12.4167ZM17.9722 21.3889V18.6111H35V21.3889H17.9722ZM24.8055 14.5833V5H27.5833V8.38888H35V11.1667H27.5833V14.5833H24.8055ZM5 11.1667V8.38888H22.0278V11.1667H5Z", fill: "currentColor" })), XG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M18.6849 32V13.3333L13.9452 18.1388L12 16.1666L20.0548 8L28 16.0555L26.0548 18.0278L21.4247 13.3333V32H18.6849Z", fill: "currentColor" })), JG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M20.0548 32L12 23.8334L13.9452 21.8612L18.6849 26.6667V8H21.4247V26.6667L26.0548 21.9723L28 23.9445L20.0548 32Z", fill: "currentColor" })), QG = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M13.4165 21.3889L13.4165 8.62494L8.62484 13.4166L6.6665 11.4722L14.8054 3.33331L22.9443 11.4722L20.986 13.4166L16.1943 8.62494L16.1943 21.3889H13.4165ZM25.1943 36.6666L17.0554 28.5278L19.0137 26.5833L23.8054 31.375L23.8054 18.6111H26.5832L26.5832 31.375L31.3748 26.5833L33.3332 28.5278L25.1943 36.6666Z", fill: "currentColor" })), eq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M6.86096 33.3333V30.5555H11.9999L11.361 30.0278C9.6943 28.6574 8.49521 27.1435 7.76371 25.4861C7.03224 23.8287 6.6665 22.037 6.6665 20.1111C6.6665 17.1203 7.55307 14.4421 9.32621 12.0763C11.0994 9.71061 13.4258 8.10182 16.3054 7.24996V10.1388C14.2498 10.9166 12.5924 12.2199 11.3332 14.0486C10.0739 15.8773 9.44425 17.8981 9.44425 20.1111C9.44425 21.6944 9.74056 23.1134 10.3332 24.368C10.9258 25.6227 11.7591 26.7315 12.8332 27.6944L13.8054 28.4167V23.6111H16.5832V33.3333H6.86096ZM23.7221 32.7778V29.8611C25.7961 29.0833 27.4535 27.7801 28.6943 25.9513C29.935 24.1226 30.5554 22.1018 30.5554 19.8888C30.5554 18.5833 30.2591 17.2754 29.6665 15.9652C29.0739 14.655 28.2591 13.4814 27.222 12.4444L26.2776 11.5833V16.3888H23.4998V6.66663H33.222V9.44438H28.0554L28.6943 10.0277C30.2591 11.5185 31.4234 13.1226 32.1873 14.8403C32.9512 16.5578 33.3332 18.2407 33.3332 19.8888C33.3332 22.8796 32.4512 25.5625 30.6873 27.9375C28.9234 30.3125 26.6017 31.9259 23.7221 32.7778Z", fill: "currentColor" })), tq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M15 5.27775V2.5H25V5.27775H15ZM18.6111 23.8055H21.3889V14.0833H18.6111V23.8055ZM20 37.4722C17.9444 37.4722 16.0069 37.0764 14.1875 36.2847C12.3681 35.493 10.7778 34.4167 9.41667 33.0555C8.05556 31.6944 6.97917 30.1042 6.1875 28.2847C5.39583 26.4653 5 24.5278 5 22.4722C5 20.4167 5.39583 18.4792 6.1875 16.6597C6.97917 14.8403 8.05556 13.25 9.41667 11.8889C10.7778 10.5278 12.3681 9.45138 14.1875 8.65971C16.0069 7.86804 17.9444 7.47221 20 7.47221C21.8148 7.47221 23.5324 7.77314 25.1528 8.375C26.7732 8.97686 28.2407 9.82408 29.5555 10.9167L31.75 8.72225L33.6944 10.6667L31.5 12.8611C32.5185 14.0648 33.3565 15.4583 34.0139 17.0417C34.6713 18.625 35 20.4352 35 22.4722C35 24.5278 34.6042 26.4653 33.8125 28.2847C33.0208 30.1042 31.9444 31.6944 30.5833 33.0555C29.2222 34.4167 27.6319 35.493 25.8125 36.2847C23.9931 37.0764 22.0556 37.4722 20 37.4722ZM20 34.6945C23.3889 34.6945 26.2732 33.5046 28.6528 31.125C31.0324 28.7454 32.2222 25.8611 32.2222 22.4722C32.2222 19.0833 31.0324 16.1991 28.6528 13.8194C26.2732 11.4398 23.3889 10.25 20 10.25C16.6111 10.25 13.7268 11.4398 11.3472 13.8194C8.96757 16.1991 7.77775 19.0833 7.77775 22.4722C7.77775 25.8611 8.96757 28.7454 11.3472 31.125C13.7268 33.5046 16.6111 34.6945 20 34.6945Z", fill: "currentColor" })), nq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M9.41683 29.0833C11.0557 27.9074 12.7409 26.9977 14.4724 26.3542C16.2039 25.7107 18.0465 25.3889 20.0002 25.3889C21.9539 25.3889 23.8011 25.7107 25.5418 26.3542C27.2826 26.9977 28.9724 27.9074 30.6113 29.0833C31.7502 27.7037 32.5812 26.2639 33.1043 24.7639C33.6275 23.2639 33.8891 21.6759 33.8891 20C33.8891 16.0833 32.5534 12.7894 29.8821 10.1181C27.2108 7.44675 23.9168 6.11109 20.0002 6.11109C16.0835 6.11109 12.7895 7.44675 10.1182 10.1181C7.4469 12.7894 6.11125 16.0833 6.11125 20C6.11125 21.6759 6.37745 23.2639 6.90987 24.7639C7.44229 26.2639 8.27794 27.7037 9.41683 29.0833ZM19.995 21.3889C18.3781 21.3889 17.0164 20.8339 15.9099 19.724C14.8034 18.6141 14.2502 17.2507 14.2502 15.6337C14.2502 14.0168 14.8051 12.6551 15.915 11.5486C17.025 10.4421 18.3884 9.88889 20.0053 9.88889C21.6222 9.88889 22.984 10.4439 24.0905 11.5538C25.1969 12.6637 25.7502 14.0271 25.7502 15.6441C25.7502 17.261 25.1952 18.6227 24.0853 19.7292C22.9753 20.8357 21.6119 21.3889 19.995 21.3889ZM20.0132 36.6667C17.7175 36.6667 15.5557 36.2292 13.528 35.3542C11.5002 34.4792 9.73165 33.2871 8.22237 31.7778C6.71312 30.2685 5.521 28.5022 4.646 26.4787C3.771 24.4553 3.3335 22.2932 3.3335 19.9926C3.3335 17.692 3.771 15.5324 4.646 13.5139C5.521 11.4954 6.71312 9.7315 8.22237 8.22222C9.73165 6.71297 11.498 5.52084 13.5215 4.64584C15.5449 3.77084 17.7069 3.33334 20.0075 3.33334C22.3082 3.33334 24.4678 3.77084 26.4863 4.64584C28.5048 5.52084 30.2687 6.71297 31.778 8.22222C33.2872 9.7315 34.4793 11.4957 35.3543 13.5148C36.2293 15.5339 36.6668 17.6913 36.6668 19.987C36.6668 22.2827 36.2293 24.4444 35.3543 26.4722C34.4793 28.5 33.2872 30.2685 31.778 31.7778C30.2687 33.2871 28.5045 34.4792 26.4854 35.3542C24.4663 36.2292 22.3089 36.6667 20.0132 36.6667ZM20.0002 33.8889C21.5094 33.8889 22.9677 33.669 24.3752 33.2292C25.7826 32.7894 27.1391 32.0648 28.4446 31.0556C27.1391 30.1204 25.778 29.4051 24.3613 28.9097C22.9446 28.4144 21.4909 28.1667 20.0002 28.1667C18.5094 28.1667 17.0557 28.4144 15.639 28.9097C14.2224 29.4051 12.8613 30.1204 11.5557 31.0556C12.8613 32.0648 14.2177 32.7894 15.6252 33.2292C17.0326 33.669 18.4909 33.8889 20.0002 33.8889ZM20.0002 18.6111C20.8705 18.6111 21.5835 18.3334 22.1391 17.7778C22.6946 17.2222 22.9724 16.5093 22.9724 15.6389C22.9724 14.7685 22.6946 14.0556 22.1391 13.5C21.5835 12.9445 20.8705 12.6667 20.0002 12.6667C19.1298 12.6667 18.4168 12.9445 17.8612 13.5C17.3057 14.0556 17.0279 14.7685 17.0279 15.6389C17.0279 16.5093 17.3057 17.2222 17.8612 17.7778C18.4168 18.3334 19.1298 18.6111 20.0002 18.6111Z", fill: "currentColor" })), oq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M20.0031 27.2222C22.0102 27.2222 23.7151 26.5197 25.1179 25.1148C26.5207 23.7098 27.222 22.0038 27.222 19.9967C27.222 17.9897 26.5196 16.2847 25.1146 14.882C23.7097 13.4792 22.0036 12.7778 19.9966 12.7778C17.9895 12.7778 16.2846 13.4803 14.8818 14.8852C13.479 16.2902 12.7776 17.9962 12.7776 20.0033C12.7776 22.0103 13.4801 23.7153 14.885 25.118C16.29 26.5208 17.996 27.2222 20.0031 27.2222ZM19.9933 24.6111C18.7106 24.6111 17.6225 24.1622 16.729 23.2643C15.8355 22.3664 15.3887 21.2762 15.3887 19.9935C15.3887 18.7108 15.8377 17.6227 16.7355 16.7292C17.6334 15.8356 18.7237 15.3889 20.0064 15.3889C21.289 15.3889 22.3771 15.8378 23.2707 16.7357C24.1642 17.6336 24.611 18.7238 24.611 20.0065C24.611 21.2892 24.162 22.3773 23.2641 23.2708C22.3663 24.1644 21.276 24.6111 19.9933 24.6111ZM19.9998 32.5C15.9443 32.5 12.2684 31.3542 8.97205 29.0625C5.67577 26.7708 3.24059 23.75 1.6665 20C3.24059 16.25 5.67577 13.2292 8.97205 10.9375C12.2684 8.64583 15.9443 7.5 19.9998 7.5C24.0554 7.5 27.7313 8.64583 31.0276 10.9375C34.3239 13.2292 36.7591 16.25 38.3332 20C36.7591 23.75 34.3239 26.7708 31.0276 29.0625C27.7313 31.3542 24.0554 32.5 19.9998 32.5ZM19.9952 29.7222C23.2853 29.7222 26.3077 28.8403 29.0623 27.0764C31.817 25.3125 33.9165 22.9537 35.361 20C33.9165 17.0463 31.8185 14.6875 29.067 12.9236C26.3155 11.1597 23.2947 10.2778 20.0045 10.2778C16.7144 10.2778 13.692 11.1597 10.9373 12.9236C8.1827 14.6875 6.07389 17.0463 4.61092 20C6.07389 22.9537 8.18113 25.3125 10.9326 27.0764C13.6842 28.8403 16.705 29.7222 19.9952 29.7222Z", fill: "currentColor" })), rq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M3.3335 33.3334V6.66669H30.0002V17.9167L36.6668 11.25V28.75L30.0002 22.0834V33.3334H3.3335ZM6.11125 30.5556H27.2224V9.44444H6.11125V30.5556Z", fill: "currentColor" })), iq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M1.6665 35L19.9998 3.33334L38.3332 35H1.6665ZM6.47205 32.2223H33.5276L19.9998 8.88889L6.47205 32.2223ZM20.1158 30.0833C20.5107 30.0833 20.8401 29.9498 21.104 29.6826C21.3679 29.4155 21.4998 29.0845 21.4998 28.6896C21.4998 28.2947 21.3663 27.9653 21.0991 27.7014C20.832 27.4375 20.501 27.3056 20.1061 27.3056C19.7112 27.3056 19.3818 27.4392 19.1179 27.7063C18.854 27.9734 18.7221 28.3045 18.7221 28.6993C18.7221 29.0942 18.8557 29.4236 19.1228 29.6875C19.3899 29.9514 19.7209 30.0833 20.1158 30.0833ZM18.7221 25.3333H21.4998V16.3333H18.7221V25.3333Z", fill: "currentColor" })), sq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("mask", { id: "mask0_9411_108", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 40, height: 40 }, /* @__PURE__ */ y.createElement("rect", { width: 40, height: 40, fill: "#D9D9D9" })), /* @__PURE__ */ y.createElement("g", { mask: "url(#mask0_9411_108)" }, /* @__PURE__ */ y.createElement("path", { d: "M11.6665 33.8888V14.4305C11.6665 13.6608 11.9397 13.0077 12.4861 12.4713C13.0322 11.9349 13.6896 11.6667 14.4582 11.6667H33.8886C34.6525 11.6667 35.3065 11.9387 35.8507 12.4826C36.3946 13.0267 36.6665 13.6808 36.6665 14.4447V28.3334L28.3332 36.6667H14.4444C13.6805 36.6667 13.0265 36.3948 12.4823 35.8509C11.9384 35.3067 11.6665 34.6527 11.6665 33.8888ZM3.37483 10.0001C3.22678 9.23146 3.37497 8.54396 3.81941 7.93757C4.26386 7.33118 4.87025 6.95382 5.63858 6.80549L24.8052 3.40299C25.5739 3.25465 26.2614 3.39813 26.8677 3.8334C27.4744 4.26868 27.8518 4.87049 27.9998 5.63882L28.5832 8.88882H25.7777L25.2915 6.13882L6.13858 9.51382L8.88858 25.153V31.3334C8.37025 31.2131 7.91886 30.9631 7.53441 30.5834C7.15025 30.2037 6.90719 29.7315 6.80525 29.1667L3.37483 10.0001ZM14.4444 14.4447V33.8888H26.8886L33.8886 26.8888V14.4447H14.4444ZM22.7777 30.5555H25.5552V25.5555H30.5552V22.778H25.5552V17.778H22.7777V22.778H17.7777V25.5555H22.7777V30.5555Z", fill: "currentColor" }))), aq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("mask", { id: "mask0_9391_9969", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 40, height: 40 }, /* @__PURE__ */ y.createElement("rect", { width: 40, height: 40, fill: "#D9D9D9" })), /* @__PURE__ */ y.createElement("g", { mask: "url(#mask0_9391_9969)" }, /* @__PURE__ */ y.createElement("path", { d: "M18.6111 30.1666H21.3886V24.9166H26.6665V22.1387H21.3886V16.8612H18.6111V22.1387H13.3332V24.9166H18.6111V30.1666ZM9.44442 36.6666C8.69442 36.6666 8.04387 36.3912 7.49275 35.8403C6.94192 35.2892 6.6665 34.6387 6.6665 33.8887V6.11117C6.6665 5.36117 6.94192 4.71061 7.49275 4.1595C8.04387 3.60867 8.69442 3.33325 9.44442 3.33325H23.9165L33.3332 12.7499V33.8887C33.3332 34.6387 33.0578 35.2892 32.5069 35.8403C31.9558 36.3912 31.3053 36.6666 30.5553 36.6666H9.44442ZM22.5278 14.0553V6.11117H9.44442V33.8887H30.5553V14.0553H22.5278Z", fill: "currentColor" }))), lq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M8.33333 35C7.41667 35 6.63194 34.6736 5.97917 34.0208C5.32639 33.3681 5 32.5833 5 31.6667V8.33333C5 7.41667 5.32639 6.63194 5.97917 5.97917C6.63194 5.32639 7.41667 5 8.33333 5H31.6667C32.5833 5 33.3681 5.32639 34.0208 5.97917C34.6736 6.63194 35 7.41667 35 8.33333V19.5C34.4722 19.25 33.9306 19.0347 33.375 18.8542C32.8194 18.6736 32.25 18.5417 31.6667 18.4583V8.33333H8.33333V31.6667H18.4167C18.5 32.2778 18.6319 32.8611 18.8125 33.4167C18.9931 33.9722 19.2083 34.5 19.4583 35H8.33333ZM8.33333 30V31.6667V8.33333V18.4583V18.3333V30ZM11.6667 28.3333H18.4583C18.5417 27.75 18.6736 27.1806 18.8542 26.625C19.0347 26.0694 19.2361 25.5278 19.4583 25H11.6667V28.3333ZM11.6667 21.6667H21.8333C22.7222 20.8333 23.7153 20.1389 24.8125 19.5833C25.9097 19.0278 27.0833 18.6528 28.3333 18.4583V18.3333H11.6667V21.6667ZM11.6667 15H28.3333V11.6667H11.6667V15ZM30 38.3333C27.6944 38.3333 25.7292 37.5208 24.1042 35.8958C22.4792 34.2708 21.6667 32.3056 21.6667 30C21.6667 27.6944 22.4792 25.7292 24.1042 24.1042C25.7292 22.4792 27.6944 21.6667 30 21.6667C32.3056 21.6667 34.2708 22.4792 35.8958 24.1042C37.5208 25.7292 38.3333 27.6944 38.3333 30C38.3333 32.3056 37.5208 34.2708 35.8958 35.8958C34.2708 37.5208 32.3056 38.3333 30 38.3333ZM29.1667 35H30.8333V30.8333H35V29.1667H30.8333V25H29.1667V29.1667H25V30.8333H29.1667V35Z", fill: "currentColor" })), cq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M9.61133 33.3334C8.78716 33.3334 8.09036 33.0487 7.52091 32.4792C6.95147 31.9098 6.66675 31.213 6.66675 30.3888C6.66675 29.5649 6.95147 28.8683 7.52091 28.2988C8.09036 27.7294 8.78716 27.4447 9.61133 27.4447C10.4352 27.4447 11.1319 27.7294 11.7013 28.2988C12.2708 28.8683 12.5555 29.5649 12.5555 30.3888C12.5555 31.213 12.2708 31.9098 11.7013 32.4792C11.1319 33.0487 10.4352 33.3334 9.61133 33.3334ZM20.0001 33.3334C19.1759 33.3334 18.4791 33.0487 17.9097 32.4792C17.3402 31.9098 17.0555 31.213 17.0555 30.3888C17.0555 29.5649 17.3402 28.8683 17.9097 28.2988C18.4791 27.7294 19.1759 27.4447 20.0001 27.4447C20.8242 27.4447 21.5211 27.7294 22.0905 28.2988C22.6599 28.8683 22.9447 29.5649 22.9447 30.3888C22.9447 31.213 22.6599 31.9098 22.0905 32.4792C21.5211 33.0487 20.8242 33.3334 20.0001 33.3334ZM30.3888 33.3334C29.5649 33.3334 28.8683 33.0487 28.2988 32.4792C27.7294 31.9098 27.4447 31.213 27.4447 30.3888C27.4447 29.5649 27.7294 28.8683 28.2988 28.2988C28.8683 27.7294 29.5649 27.4447 30.3888 27.4447C31.213 27.4447 31.9098 27.7294 32.4792 28.2988C33.0487 28.8683 33.3334 29.5649 33.3334 30.3888C33.3334 31.213 33.0487 31.9098 32.4792 32.4792C31.9098 33.0487 31.213 33.3334 30.3888 33.3334ZM9.61133 22.9447C8.78716 22.9447 8.09036 22.6599 7.52091 22.0905C6.95147 21.5211 6.66675 20.8242 6.66675 20.0001C6.66675 19.1759 6.95147 18.4791 7.52091 17.9097C8.09036 17.3402 8.78716 17.0555 9.61133 17.0555C10.4352 17.0555 11.1319 17.3402 11.7013 17.9097C12.2708 18.4791 12.5555 19.1759 12.5555 20.0001C12.5555 20.8242 12.2708 21.5211 11.7013 22.0905C11.1319 22.6599 10.4352 22.9447 9.61133 22.9447ZM20.0001 22.9447C19.1759 22.9447 18.4791 22.6599 17.9097 22.0905C17.3402 21.5211 17.0555 20.8242 17.0555 20.0001C17.0555 19.1759 17.3402 18.4791 17.9097 17.9097C18.4791 17.3402 19.1759 17.0555 20.0001 17.0555C20.8242 17.0555 21.5211 17.3402 22.0905 17.9097C22.6599 18.4791 22.9447 19.1759 22.9447 20.0001C22.9447 20.8242 22.6599 21.5211 22.0905 22.0905C21.5211 22.6599 20.8242 22.9447 20.0001 22.9447ZM30.3888 22.9447C29.5649 22.9447 28.8683 22.6599 28.2988 22.0905C27.7294 21.5211 27.4447 20.8242 27.4447 20.0001C27.4447 19.1759 27.7294 18.4791 28.2988 17.9097C28.8683 17.3402 29.5649 17.0555 30.3888 17.0555C31.213 17.0555 31.9098 17.3402 32.4792 17.9097C33.0487 18.4791 33.3334 19.1759 33.3334 20.0001C33.3334 20.8242 33.0487 21.5211 32.4792 22.0905C31.9098 22.6599 31.213 22.9447 30.3888 22.9447ZM9.61133 12.5555C8.78716 12.5555 8.09036 12.2708 7.52091 11.7013C6.95147 11.1319 6.66675 10.4352 6.66675 9.61133C6.66675 8.78716 6.95147 8.09036 7.52091 7.52091C8.09036 6.95147 8.78716 6.66675 9.61133 6.66675C10.4352 6.66675 11.1319 6.95147 11.7013 7.52091C12.2708 8.09036 12.5555 8.78716 12.5555 9.61133C12.5555 10.4352 12.2708 11.1319 11.7013 11.7013C11.1319 12.2708 10.4352 12.5555 9.61133 12.5555ZM20.0001 12.5555C19.1759 12.5555 18.4791 12.2708 17.9097 11.7013C17.3402 11.1319 17.0555 10.4352 17.0555 9.61133C17.0555 8.78716 17.3402 8.09036 17.9097 7.52091C18.4791 6.95147 19.1759 6.66675 20.0001 6.66675C20.8242 6.66675 21.5211 6.95147 22.0905 7.52091C22.6599 8.09036 22.9447 8.78716 22.9447 9.61133C22.9447 10.4352 22.6599 11.1319 22.0905 11.7013C21.5211 12.2708 20.8242 12.5555 20.0001 12.5555ZM30.3888 12.5555C29.5649 12.5555 28.8683 12.2708 28.2988 11.7013C27.7294 11.1319 27.4447 10.4352 27.4447 9.61133C27.4447 8.78716 27.7294 8.09036 28.2988 7.52091C28.8683 6.95147 29.5649 6.66675 30.3888 6.66675C31.213 6.66675 31.9098 6.95147 32.4792 7.52091C33.0487 8.09036 33.3334 8.78716 33.3334 9.61133C33.3334 10.4352 33.0487 11.1319 32.4792 11.7013C31.9098 12.2708 31.213 12.5555 30.3888 12.5555Z", fill: "currentColor" })), dq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M32.5 15.8333H29.1667V26.8167L9.85 7.5L7.5 9.85L26.8167 29.1667H15.8333V32.5H32.5V15.8333Z", fill: "currentColor" })), uq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M15.8333 7.5V10.8333H26.8167L7.5 30.15L9.85 32.5L29.1667 13.1833V24.1667H32.5V7.5H15.8333Z", fill: "currentColor" })), fq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M27.5 33.3333H29.1667V26.6666H27.5V33.3333ZM28.3333 24.9999C28.5556 24.9999 28.75 24.9166 28.9167 24.7499C29.0833 24.5833 29.1667 24.3888 29.1667 24.1666C29.1667 23.9444 29.0833 23.7499 28.9167 23.5833C28.75 23.4166 28.5556 23.3333 28.3333 23.3333C28.1111 23.3333 27.9167 23.4166 27.75 23.5833C27.5833 23.7499 27.5 23.9444 27.5 24.1666C27.5 24.3888 27.5833 24.5833 27.75 24.7499C27.9167 24.9166 28.1111 24.9999 28.3333 24.9999ZM11.6667 23.3333H17.7917C18.0972 22.6944 18.4514 22.0971 18.8542 21.5416C19.2569 20.986 19.7083 20.4721 20.2083 19.9999H11.6667V23.3333ZM11.6667 29.9999H16.7917C16.7083 29.4444 16.6667 28.8888 16.6667 28.3333C16.6667 27.7777 16.7083 27.2221 16.7917 26.6666H11.6667V29.9999ZM8.33333 36.6666C7.41667 36.6666 6.63194 36.3402 5.97917 35.6874C5.32639 35.0346 5 34.2499 5 33.3333V6.66658C5 5.74992 5.32639 4.9652 5.97917 4.31242C6.63194 3.65964 7.41667 3.33325 8.33333 3.33325H21.6667L31.6667 13.3333V17.1666C31.1389 16.9999 30.5972 16.8749 30.0417 16.7916C29.4861 16.7083 28.9167 16.6666 28.3333 16.6666V14.9999H20V6.66658H8.33333V33.3333H17.7917C18.0972 33.9721 18.4514 34.5694 18.8542 35.1249C19.2569 35.6805 19.7083 36.1944 20.2083 36.6666H8.33333ZM28.3333 19.9999C30.6389 19.9999 32.6042 20.8124 34.2292 22.4374C35.8542 24.0624 36.6667 26.0277 36.6667 28.3333C36.6667 30.6388 35.8542 32.6041 34.2292 34.2291C32.6042 35.8541 30.6389 36.6666 28.3333 36.6666C26.0278 36.6666 24.0625 35.8541 22.4375 34.2291C20.8125 32.6041 20 30.6388 20 28.3333C20 26.0277 20.8125 24.0624 22.4375 22.4374C24.0625 20.8124 26.0278 19.9999 28.3333 19.9999Z", fill: "currentColor" })), pq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.65 33.3C27.1887 33.3 33.3 27.1887 33.3 19.65C33.3 12.1113 27.1887 6 19.65 6C12.1113 6 6 12.1113 6 19.65C6 27.1887 12.1113 33.3 19.65 33.3ZM19.65 36.3C28.8455 36.3 36.3 28.8455 36.3 19.65C36.3 10.4545 28.8455 3 19.65 3C10.4545 3 3 10.4545 3 19.65C3 28.8455 10.4545 36.3 19.65 36.3Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.1213 15.1213L17.5343 26.7083L11 20.174L13.1213 18.0526L17.5343 22.4657L27 13L29.1213 15.1213Z", fill: "currentColor" })), hq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M5 37V24.625H11.1875V37H5ZM17.375 37V14.3125H23.5625V37H17.375ZM29.75 37V4H35.9375V37H29.75Z", fill: "currentColor" })), gq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M9.3835 32.8166C11.8502 34.8333 14.9002 36.1666 18.2502 36.5V33.1333C15.8168 32.8333 13.6002 31.8666 11.7502 30.4333L9.3835 32.8166ZM6.70016 21.5833H3.3335C3.66683 24.9333 5.00016 27.9833 7.01683 30.45L9.40016 28.0833C7.96683 26.2333 7.00016 24.0166 6.70016 21.5833ZM9.40016 11.75L7.01683 9.36665C5.00016 11.8333 3.66683 14.9 3.3335 18.2333H6.70016C7.00016 15.8166 7.96683 13.6 9.40016 11.75ZM18.2502 6.69998L18.2502 3.33331C14.9002 3.66664 11.8502 4.99998 9.3835 7.01665L11.7668 9.39998C13.6002 7.96665 15.8168 6.99998 18.2502 6.69998ZM21.5835 6.69998V3.33331C30.0002 4.16665 36.5835 11.2667 36.5835 19.9167C36.5835 28.5667 30.0002 35.6666 21.5835 36.5V33.1333C28.1668 32.3166 33.2502 26.7167 33.2502 19.9167C33.2502 13.1166 28.1668 7.51665 21.5835 6.69998Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.0611 15.0606L17.4742 26.6476L10.9398 20.1133L13.0611 17.992L17.4742 22.405L26.9398 12.9393L29.0611 15.0606Z", fill: "currentColor" })), mq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("mask", { id: "mask0_9411_150", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 40, height: 40 }, /* @__PURE__ */ y.createElement("rect", { width: 40, height: 40, fill: "currentColor" })), /* @__PURE__ */ y.createElement("g", { mask: "url(#mask0_9411_150)" }, /* @__PURE__ */ y.createElement("path", { d: "M11.6665 33.8888V14.4305C11.6665 13.6608 11.9397 13.0077 12.4861 12.4713C13.0322 11.9349 13.6896 11.6667 14.4582 11.6667H33.8886C34.6525 11.6667 35.3065 11.9387 35.8507 12.4826C36.3946 13.0267 36.6665 13.6808 36.6665 14.4447V28.3334L28.3332 36.6667H14.4444C13.6805 36.6667 13.0265 36.3948 12.4823 35.8509C11.9384 35.3067 11.6665 34.6527 11.6665 33.8888ZM3.37483 10.0001C3.22678 9.23146 3.37497 8.54396 3.81941 7.93757C4.26386 7.33118 4.87025 6.95382 5.63858 6.80549L24.8052 3.40299C25.5739 3.25465 26.2614 3.39813 26.8677 3.8334C27.4744 4.26868 27.8518 4.87049 27.9998 5.63882L28.5832 8.88882H25.7777L25.2915 6.13882L6.13858 9.51382L8.88858 25.153V31.3334C8.37025 31.2131 7.91886 30.9631 7.53441 30.5834C7.15025 30.2037 6.90719 29.7315 6.80525 29.1667L3.37483 10.0001ZM14.4444 14.4447V33.8888H26.8886V26.8888H33.8886V14.4447H14.4444Z", fill: "currentColor" }))), bq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.66667 33.3333H24.1667V24.1667H33.3333V7.66667H7.66667V33.3333ZM7.66667 37C6.65833 37 5.79483 36.6413 5.07617 35.9238C4.35872 35.2052 4 34.3417 4 33.3333V7.66667C4 6.65833 4.35872 5.79483 5.07617 5.07617C5.79483 4.35872 6.65833 4 7.66667 4H33.3333C34.3417 4 35.2052 4.35872 35.9238 5.07617C36.6413 5.79483 37 6.65833 37 7.66667V26L26 37H7.66667ZM11.3333 24.1667V20.5H20.5V24.1667H11.3333ZM11.3333 16.8333V13.1667H29.6667V16.8333H11.3333Z", fill: "currentColor" })), Cq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 32.222656 16 L 35 16 L 35 5.300781 L 24.304688 5.300781 C 24.074219 4.335938 23.558594 3.546875 22.757812 2.925781 C 21.957031 2.308594 21.035156 2 20 2 C 18.980469 2 18.070312 2.308594 17.265625 2.925781 C 16.457031 3.546875 15.941406 4.335938 15.707031 5.300781 L 5 5.300781 L 5 35 L 17 35 L 17 32.25 L 7.777344 32.25 L 7.777344 8.050781 L 10.554688 8.050781 L 10.554688 12.175781 L 29.445312 12.175781 L 29.445312 8.050781 L 32.222656 8.050781 Z M 21.1875 7.574219 C 20.867188 7.890625 20.472656 8.050781 20 8.050781 C 19.527344 8.050781 19.132812 7.890625 18.8125 7.574219 C 18.492188 7.257812 18.332031 6.867188 18.332031 6.398438 C 18.332031 5.933594 18.492188 5.539062 18.8125 5.222656 C 19.132812 4.90625 19.527344 4.75 20 4.75 C 20.472656 4.75 20.867188 4.90625 21.1875 5.222656 C 21.507812 5.539062 21.667969 5.933594 21.667969 6.398438 C 21.667969 6.867188 21.507812 7.257812 21.1875 7.574219 Z M 21.1875 7.574219 " }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 21 32.25 L 21 38 L 26.746094 38 L 39 25.703125 L 33.285156 20 Z M 25.59375 35.234375 L 23.8125 35.234375 L 23.8125 33.453125 L 29.53125 27.78125 L 30.421875 28.625 L 31.265625 29.515625 Z M 25.59375 35.234375 " })), xq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M6.6665 35V32.2221H26.6665V35H6.6665ZM15.9719 26.4167L6.6665 17.1113L9.77775 13.9167L19.1665 23.2221L15.9719 26.4167ZM26.5553 15.8333L17.2498 6.44459L20.4444 3.33334L29.7498 12.6388L26.5553 15.8333ZM34.7219 33.3333L12.5832 11.1946L14.5278 9.25L36.6665 31.3888L34.7219 33.3333Z", fill: "currentColor" })), yq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M19.9998 36.6666C19.259 36.6666 18.6016 36.4885 18.0278 36.1321C17.4536 35.7754 17.0554 35.2869 16.8332 34.6667H13.6665V25.9446C11.8979 24.7871 10.4975 23.2916 9.46525 21.4583C8.43275 19.625 7.9165 17.6111 7.9165 15.4166C7.9165 12.0555 9.09012 9.20137 11.4373 6.85415C13.7846 4.50692 16.6387 3.33331 19.9998 3.33331C23.3609 3.33331 26.2151 4.50692 28.5623 6.85415C30.9096 9.20137 32.0832 12.0555 32.0832 15.4166C32.0832 17.6297 31.5669 19.6482 30.5344 21.4721C29.5022 23.2962 28.1018 24.7871 26.3332 25.9446V34.6667H23.1665C22.9443 35.2869 22.5461 35.7754 21.9719 36.1321C21.398 36.4885 20.7407 36.6666 19.9998 36.6666ZM16.4444 31.8887H23.5553V30.1666H16.4444V31.8887ZM16.4444 28.5H23.5553V26.8612H16.4444V28.5ZM16.0832 24.0833H18.9444V18.7779L15.1665 15L16.6111 13.5554L19.9998 16.9446L23.3886 13.5554L24.8332 15L21.0553 18.7779V24.0833H23.9165C25.5276 23.3241 26.8286 22.1644 27.8194 20.6041C28.81 19.0439 29.3053 17.3147 29.3053 15.4166C29.3053 12.8055 28.4072 10.6018 26.6111 8.8054C24.8147 7.00929 22.6109 6.11123 19.9998 6.11123C17.3887 6.11123 15.185 7.00929 13.3886 8.8054C11.5925 10.6018 10.6944 12.8055 10.6944 15.4166C10.6944 17.3147 11.1897 19.0439 12.1803 20.6041C13.1711 22.1644 14.4721 23.3241 16.0832 24.0833Z", fill: "currentColor" })), vq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M27.0003 2.92986L9 2.92986V15.8988H11.6V5.52986H24.4003V19.0482L27.0003 20.0125V13.0193H31.6871V24.0723H34.2871V10.4193H27.0003V2.92986Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { d: "M13.8726 9.37341H15.5392V7.70674H13.8726V9.37341Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { d: "M17.2059 9.37341H18.8726V7.70674H17.2059V9.37341Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { d: "M18.8726 12.7067H17.2059V11.0401H18.8726V12.7067Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { d: "M13.8726 12.7067H15.5392V11.0401H13.8726V12.7067Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.8054 33.1986L24.3333 36.7541L37.5 32.6986V26.6707H28.8333V23.532L15.5 18.532H2.5V35.5874H11.8054V33.1986ZM9 32.8095H5.27792V21.3095H9V32.8095ZM34.6113 30.6707L24.1946 33.8653L11.8054 30.3095V21.3095H15.0279L25.9446 25.4207V26.6707H22.8196L18 25.0874L17.0554 27.7541L22.375 29.4486H34.6113V30.6707Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { d: "M20.5717 9.37341H22.2384V7.70674H20.5717V9.37341Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { d: "M22.2384 12.7067H20.5717V11.0401H22.2384V12.7067Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { d: "M18.8726 15.8988H17.2059V14.2321H18.8726V15.8988Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { d: "M13.8726 15.8988H15.5392V14.2321H13.8726V15.8988Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { d: "M22.2384 15.8988H20.5717V14.2321H22.2384V15.8988Z", fill: "currentColor" })), wq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M19.0311 38C16.8135 38 14.7295 37.5792 12.779 36.7376C10.8285 35.8959 9.13191 34.7537 7.68911 33.3109C6.24631 31.8681 5.10409 30.1715 4.26245 28.221C3.42082 26.2706 3 24.1865 3 21.9689C3 19.7512 3.42082 17.6672 4.26245 15.7167C5.10409 13.7663 6.24631 12.0697 7.68911 10.6269C9.13191 9.18405 10.8285 8.04183 12.779 7.2002C14.7295 6.35856 16.8135 5.93774 19.0311 5.93774C21.2488 5.93774 23.3328 6.35856 25.2833 7.2002C27.2337 8.04183 28.9304 9.18405 30.3732 10.6269C31.816 12.0697 32.9582 13.7663 33.7998 15.7167C34.6415 17.6672 35.0623 19.7512 35.0623 21.9689C35.0623 24.1865 34.6415 26.2706 33.7998 28.221C32.9582 30.1715 31.816 31.8681 30.3732 33.3109C28.9304 34.7537 27.2337 35.8959 25.2833 36.7376C23.3328 37.5792 21.2488 38 19.0311 38ZM19.0311 34.7938C22.6114 34.7938 25.644 33.5514 28.1288 31.0666C30.6136 28.5817 31.8561 25.5492 31.8561 21.9689C31.8561 18.3886 30.6136 15.356 28.1288 12.8712C25.644 10.3864 22.6114 9.14397 19.0311 9.14397C15.4509 9.14397 12.4183 10.3864 9.93347 12.8712C7.44864 15.356 6.20623 18.3886 6.20623 21.9689C6.20623 25.5492 7.44864 28.5817 9.93347 31.0666C12.4183 33.5514 15.4509 34.7938 19.0311 34.7938ZM19.0311 31.5876C16.3593 31.5876 14.0882 30.6524 12.2179 28.7821C10.3476 26.9118 9.41246 24.6407 9.41246 21.9689C9.41246 19.297 10.3476 17.026 12.2179 15.1557C14.0882 13.2854 16.3593 12.3502 19.0311 12.3502C21.703 12.3502 23.9741 13.2854 25.8444 15.1557C27.7147 17.026 28.6498 19.297 28.6498 21.9689C28.6498 24.6407 27.7147 26.9118 25.8444 28.7821C23.9741 30.6524 21.703 31.5876 19.0311 31.5876ZM19.0311 28.3813C20.7946 28.3813 22.3042 27.7535 23.5599 26.4977C24.8157 25.2419 25.4436 23.7323 25.4436 21.9689C25.4436 20.2055 24.8157 18.6959 23.5599 17.4401C22.3042 16.1843 20.7946 15.5564 19.0311 15.5564C17.2677 15.5564 15.7581 16.1843 14.5023 17.4401C13.2466 18.6959 12.6187 20.2055 12.6187 21.9689C12.6187 23.7323 13.2466 25.2419 14.5023 26.4977C15.7581 27.7535 17.2677 28.3813 19.0311 28.3813ZM19.0311 25.1751C18.1494 25.1751 17.3946 24.8612 16.7667 24.2333C16.1389 23.6054 15.8249 22.8506 15.8249 21.9689C15.8249 21.0872 16.1389 20.3324 16.7667 19.7045C17.3946 19.0766 18.1494 18.7627 19.0311 18.7627C19.9129 18.7627 20.6677 19.0766 21.2955 19.7045C21.9234 20.3324 22.2374 21.0872 22.2374 21.9689C22.2374 22.8506 21.9234 23.6054 21.2955 24.2333C20.6677 24.8612 19.9129 25.1751 19.0311 25.1751Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("line", { x1: 19.2474, y1: 21.4734, x2: 32.0723, y2: 5.90033, stroke: "currentColor", strokeWidth: 3 }), /* @__PURE__ */ y.createElement("path", { d: "M31.3671 1.00008L32.8145 5.10599L28.7231 10.0436L27.2758 5.93772L31.3671 1.00008Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { d: "M32.7721 10.5182L28.7233 10.0438L32.8147 5.10617L36.8635 5.58054L32.7721 10.5182Z", fill: "currentColor" })), Sq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 5.00008V35.0001H20.6529C20.4407 34.5806 20.2581 34.1379 20.105 33.6717C19.9517 33.2054 19.824 32.7222 19.7221 32.2222H7.77792V7.778H32.2221V19.7084C32.6943 19.7917 33.1665 19.9098 33.6388 20.0626C34.111 20.2154 34.5647 20.4074 35 20.6388V5.00008H24.1946C23.9815 4.01869 23.4838 3.21772 22.7013 2.59717C21.919 1.97689 21.0186 1.66675 20 1.66675C18.9814 1.66675 18.081 1.97689 17.2988 2.59717C16.5163 3.21772 16.0185 4.01869 15.8054 5.00008H5ZM20.9792 6.47925C20.7061 6.7523 20.3797 6.88883 20 6.88883C19.6203 6.88883 19.2939 6.7523 19.0208 6.47925C18.7478 6.20619 18.6113 5.8798 18.6113 5.50008C18.6113 5.12036 18.7478 4.79397 19.0208 4.52091C19.2939 4.24786 19.6203 4.11133 20 4.11133C20.3797 4.11133 20.7061 4.24786 20.9792 4.52091C21.2522 4.79397 21.3888 5.12036 21.3888 5.50008C21.3888 5.8798 21.2522 6.20619 20.9792 6.47925Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { d: "M19.7917 28.3334H11.6667V25.5555H20.7363C20.514 25.9908 20.3265 26.4399 20.1738 26.903C20.021 27.3658 19.8936 27.8426 19.7917 28.3334Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { d: "M24.6113 21.3888H11.6667V18.6113H28.3333V19.7638C27.6203 19.9027 26.9606 20.1065 26.3542 20.3751C25.7478 20.6437 25.1668 20.9816 24.6113 21.3888Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { d: "M28.3333 14.4447H11.6667V11.6667H28.3333V14.4447Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.7013 35.9513C26.2616 37.5208 28.1436 38.3055 30.3472 38.3055C32.5511 38.3055 34.4377 37.5208 36.0072 35.9513C37.5766 34.3819 38.3613 32.5092 38.3613 30.3334C38.3613 28.1123 37.5766 26.2191 36.0072 24.6538C34.4377 23.0883 32.5558 22.3055 30.3613 22.3055C28.148 22.3055 26.2613 23.0883 24.7013 24.6538C23.1413 26.2191 22.3613 28.1123 22.3613 30.3334C22.3613 32.5092 23.1413 34.3819 24.7013 35.9513ZM27.26 34.5311L26.2191 33.4902L29.3619 30.3474L26.2191 27.2046L27.26 26.1637L30.4028 29.3065L33.5456 26.1637L34.5865 27.2046L31.4438 30.3474L34.5865 33.4902L33.5456 34.5311L30.4028 31.3883L27.26 34.5311Z", fill: "currentColor" })), Mq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M5 38V3H13.0162V38H5ZM28.798 38V16.5484H36V38H28.798Z", fill: "currentColor" }), /* @__PURE__ */ y.createElement("path", { d: "M17.3374 16.5484V3H25.5414V16.5484H17.3374Z", fill: "currentColor" })), Tq = {
  // Default icon -- can be used as placeholder
  default: $W,
  // Objects and Concepts
  agriculture: BW,
  animation: zW,
  brand: ZW,
  businessTrips: WW,
  carbonEmission: UW,
  carbonNeutrality: GW,
  collective: qW,
  communication: KW,
  consumption: YW,
  corporate: XW,
  diagnostic: JW,
  distribution: QW,
  energy: eU,
  equal: tU,
  euros: nU,
  events: oU,
  forestWoods: rU,
  hedgesPlantCovers: iU,
  ingredients: sU,
  inputsChemicals: aU,
  labels: lU,
  organization: cU,
  packaging: dU,
  productionSite: uU,
  production: fU,
  productsBying: pU,
  products: hU,
  projectManager: gU,
  publications: mU,
  rangesSectors: bU,
  recipe: CU,
  sectors: xU,
  socialMedia: yU,
  strategy: vU,
  supplier: wU,
  territories: SU,
  trajectory: MU,
  transformationSteps: TU,
  transportation: kU,
  users: EU,
  vineyard: RU,
  webinard: OU,
  wineTourism: _U,
  documentSpace: PU,
  gridView: LU,
  simulation: IU,
  tableView: jU,
  uploadFile: VU,
  askor: DU,
  // Pages and Functions
  actionPlan: AU,
  actions: HU,
  activityData: FU,
  addRemove: NU,
  addUser: $U,
  add: BU,
  analytics: zU,
  arrowTrajectory: ZU,
  arrowDownShort: WU,
  arrowDown: UU,
  arrowLeftShort: GU,
  arrowLeft: qU,
  arrowRightShort: KU,
  arrowRight: YU,
  arrowUpShort: XU,
  arrowUp: JU,
  calendar: QU,
  callback: eG,
  cancel: tG,
  check: nG,
  circleCheck: oG,
  clickIndicator: rG,
  closePanel: iG,
  close: sG,
  comparison: lG,
  columns: aG,
  compare: cG,
  congrats: dG,
  dashboard: uG,
  delete: fG,
  documentation: pG,
  drag: hG,
  duplicate: gG,
  edit: mG,
  evolution: CG,
  empty: bG,
  exportDownload: xG,
  favAdded: yG,
  favNonAdded: vG,
  filter: wG,
  hamburgerMenu: SG,
  hidePwd: MG,
  home: TG,
  importUpload: kG,
  information: EG,
  informations: RG,
  list: OG,
  logout: _G,
  mail: PG,
  minus: LG,
  openNewTab: IG,
  openPanel: jG,
  previousCampaign: DG,
  questionMark: AG,
  plus: VG,
  questionnaires: HG,
  reminder: FG,
  removeUser: NG,
  remove: $G,
  repartition: BG,
  repositories: zG,
  reset: ZG,
  save: WG,
  savedOnline: UG,
  scoresIndicators: GG,
  search: qG,
  sendMessage: KG,
  settings: YG,
  sortAscending: XG,
  sortDescending: JG,
  sortNoSorting: QG,
  sync: eq,
  timer: tq,
  userAccount: nq,
  viewPwd: oq,
  visio: rq,
  warning: iq,
  addANote: sq,
  addFile: aq,
  addNotes: lq,
  allFeatures: cq,
  arrowDownRight: dq,
  arrowUpRight: uq,
  details: fq,
  done: pq,
  graph: hq,
  inProgress: gq,
  note: mq,
  notes: bq,
  questionnaireAnswer: Cq,
  rules: xq,
  suggestions: yq,
  support: vq,
  target: wq,
  uncompleteQuestionnaire: Sq,
  waterfall: Mq
}, _w = (e) => {
  const o = 12 + 4 * e;
  return {
    width: o,
    height: o
  };
}, _t = (e) => {
  const {
    icon: t,
    size: n
  } = e, o = Tq[t], r = typeof n == "number" ? _w(n) : n;
  return /* @__PURE__ */ f.jsx(o, { width: r.width, height: r.height });
}, kq = (e) => {
  const t = ge(), n = e.width / 2, o = e.width / 2, r = e.width / 2;
  return /* @__PURE__ */ f.jsx("circle", { cx: n, cy: o, r, fill: t.palette.primary[50] });
}, Eq = (e) => {
  const t = ge(), { width: n, height: o } = e;
  return /* @__PURE__ */ f.jsx("rect", { width: n, height: o, rx: "4", fill: t.palette.primary[50] });
}, Rq = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs("svg", { width: e.width, height: e.height, viewBox: "0 0 112 112", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    e.backgroundShape,
    /* @__PURE__ */ f.jsx("path", { d: "M39 50H44L34.0004 40L24 50L29 50C29 56.312 30.6388 61.1158 33.4184 64.8717C36.1061 68.5034 39.5909 70.7682 42.4552 72.4618C43.1618 72.8796 43.8103 73.2541 44.4085 73.5995C46.4936 74.8034 47.9687 75.6552 49.1738 76.766C50.3397 77.8406 51 78.9529 51 81H61C61 75.8232 58.9103 72.1404 55.9512 69.413C53.8403 67.4673 51.1052 65.9009 48.9042 64.6403C48.4214 64.3637 47.9641 64.1018 47.5448 63.8539C44.9091 62.2954 42.8939 60.8652 41.4566 58.923C40.1112 57.1049 39 54.4557 39 50Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { d: "M83 50H88L78.0004 40L68 50L73 50C73 54.4557 71.8888 57.1049 70.5434 58.923C69.1061 60.8652 67.0909 62.2954 64.4552 63.8539C64.0359 64.1018 63.5787 64.3637 63.0958 64.6403C60.8948 65.9008 58.1597 67.4673 56.0488 69.413C53.0897 72.1404 51 75.8232 51 81H61C61 78.9529 61.6603 77.8406 62.8262 76.766C64.0313 75.6552 65.5064 74.8035 67.5915 73.5995C68.1897 73.2541 68.8382 72.8796 69.5448 72.4618C72.4091 70.7682 75.8939 68.5034 78.5816 64.8717C81.3612 61.1158 83 56.312 83 50Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M48 81L64 81L64 34L48 34L48 81Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M48 87L64 87L64 83L48 83L48 87Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M48 93L64 93L64 89L48 89L48 93Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M72 36L40 36L56.0006 20L72 36Z", fill: t.palette.primary[800] })
  ] });
}, Oq = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs("svg", { width: e.width, height: e.height, viewBox: "0 0 112 112", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    e.backgroundShape,
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M29.2162 36.5C29.4482 36.5 29.677 36.5132 29.9023 36.538C29.9023 36.5253 29.9019 36.5127 29.9019 36.5C29.9019 29.5965 35.4682 24 42.3344 24C47.4254 24 51.8009 27.0771 53.7236 31.4819C54.2112 31.3975 54.7125 31.3529 55.2241 31.3529C60.0709 31.3529 64 35.3034 64 40.1765C64 45.0495 60.0709 49 55.2241 49H29.2162C25.7831 49 23 46.2018 23 42.75C23 39.2982 25.7831 36.5 29.2162 36.5Z", fill: t.palette.primary[600] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M81.4771 56C81.0472 56 80.623 56.0243 80.2054 56.0701C80.2054 56.0467 80.2062 56.0234 80.2062 56C80.2062 43.2974 69.8883 33 57.1605 33C47.7236 33 39.6128 38.6618 36.0489 46.7668C35.145 46.6114 34.2159 46.5294 33.2676 46.5294C24.2832 46.5294 17 53.7982 17 62.7647C17 71.7312 24.2832 79 33.2676 79H81.4771C87.8411 79 93 73.8513 93 67.5C93 61.1487 87.8411 56 81.4771 56Z", fill: t.palette.primary[200] }),
    /* @__PURE__ */ f.jsx("path", { d: "M58 60H73V64H58V60Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { d: "M73 66H58V74H52L65.4995 88L79 74H73V66Z", fill: t.palette.primary[800] })
  ] });
}, _q = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs("svg", { width: e.width, height: e.height, viewBox: "0 0 112 112", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    e.backgroundShape,
    /* @__PURE__ */ f.jsx("rect", { x: "58.7986", y: "33.3568", width: "1.12164", height: "42.8455", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("rect", { x: "56.5554", y: "40.6187", width: "1.12164", height: "35.5836", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("rect", { x: "54.3123", y: "47.8806", width: "1.12164", height: "28.3216", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("rect", { x: "52.0688", y: "57.3212", width: "1.12164", height: "18.8811", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M39.745 65.0222C39.745 65.0222 39.1604 60.3917 45.4739 58.308C51.7874 56.2243 53.1904 57.324 53.1904 57.324L52.6058 59.1762C52.6058 59.1762 51.6121 63.8067 47.0523 64.4434C42.4925 65.0801 40.7388 64.154 39.745 65.0222Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M33.0034 43.496C33.0034 43.496 36.8158 37.8224 45.8985 41.4174C54.981 45.0123 55.4363 47.8829 55.4363 47.8829L53.05 49.0458C53.05 49.0458 47.4696 53.244 41.7474 49.6863C36.0254 46.1286 34.9543 43.4637 33.0034 43.496Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M46.1151 43.3525C50.181 46.3337 54.3213 48.428 54.3213 48.428L53.0447 49.0479C53.0447 49.0479 47.4376 53.1279 41.8085 49.7494C36.1795 46.3709 34.9191 43.4635 33 43.4943C33 43.4943 39.8024 38.7238 46.1151 43.3525Z", fill: t.palette.primary[700] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M67.4008 55.187C73.456 52.7904 75.9975 56.5728 75.9975 56.5728C75.3295 56.5617 74.8162 57.0251 73.9579 57.7999C73.1453 58.5334 72.0235 59.5462 70.1682 60.6997C66.3534 63.0714 62.6332 60.2727 62.6332 60.2727L62.1636 60.0438V76.2023H61.042V59.4998H61.0472L61.0423 59.4974C61.0423 59.4974 61.3458 57.5836 67.4008 55.187Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M40.4838 22.2086C40.4838 22.2086 43.9608 17.2252 52.1967 22.2298C60.493 27.2712 59.917 33.8846 59.917 33.8846L57.2658 34.1516C57.2658 34.1516 50.536 36.1446 46.453 30.9082C42.37 25.6719 42.322 22.8408 40.4838 22.2086Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M40.4739 22.2291C40.4739 22.2291 44.7063 19.9987 47.9823 23.7577C49.6586 25.6812 52.6243 27.1315 53.8987 28.2459C57.2093 31.1412 58.7982 33.9954 58.7982 33.9954C58.7982 33.9954 50.7858 36.4075 46.5816 31.2324C42.3775 26.0573 42.3285 22.9339 40.4739 22.2291Z", fill: t.palette.primary[700] }),
    /* @__PURE__ */ f.jsx("path", { d: "M69.8839 80.9781C70.0508 80.9601 70.2203 80.9505 70.3921 80.9505C72.9352 80.9505 74.9968 82.9763 74.9968 85.4753C74.9968 87.9742 72.9352 90 70.3921 90H51.1269C51.1179 90 51.109 90 51.1 90H41.9199C39.836 90 38.1467 88.3353 38.1467 86.2817C38.1467 84.2282 39.836 82.5635 41.9199 82.5635C42.0607 82.5635 42.1996 82.5714 42.3363 82.5862L42.3361 82.5635C42.3361 78.4564 45.7147 75.127 49.8824 75.127C51.0267 75.127 52.1115 75.3781 53.0831 75.8273C54.7434 73.4559 57.5242 71.901 60.6748 71.901C65.761 71.901 69.8842 75.9526 69.8842 80.9505C69.8842 80.9597 69.8839 80.9689 69.8839 80.9781Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M78.9892 36.2257C78.9892 36.2257 75.1768 30.5521 66.0941 34.1471C57.0115 37.742 56.5563 40.6126 56.5563 40.6126L58.9426 41.7755C58.9426 41.7755 64.523 45.9737 70.2452 42.416C75.9672 38.8583 77.0383 36.1934 78.9892 36.2257Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M78.9999 36.2459C78.9999 36.2459 73.4379 32.3814 66.8998 37.0101C62.6887 39.9913 57.6743 41.1516 57.6743 41.1516C57.6743 41.1516 65.3581 46.5382 71.1882 43.1597C77.0182 39.7812 77.0123 36.2152 78.9999 36.2459Z", fill: t.palette.primary[700] })
  ] });
}, Pq = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs("svg", { width: e.width, height: e.height, viewBox: "0 0 112 112", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    e.backgroundShape,
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M65.0308 45.1014H64.9367V22H47.0753V45.1014H46.9691L23.6038 81.2361C21.9939 83.7257 23.7919 87 26.769 87H47.0753H64.9367H85.231C88.208 87 90.0061 83.7257 88.3962 81.2361L65.0308 45.1014Z", fill: t.palette.primary[200] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M65.9628 25H46.0372C44.9121 25 44 24.0799 44 22.9449V18.0551C44 16.9201 44.9121 16 46.0372 16H65.9628C67.0879 16 68 16.9201 68 18.0551V22.9449C68 24.0799 67.0879 25 65.9628 25Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M73 71C73 73.7614 70.7614 76 68 76C65.2386 76 63 73.7614 63 71C63 68.2385 65.2386 66 68 66C70.7614 66 73 68.2385 73 71Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M50 75C50 78.3137 47.3137 81 44 81C40.6863 81 38 78.3137 38 75C38 71.6863 40.6863 69 44 69C47.3137 69 50 71.6863 50 75Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M58 63.5001C58 64.8807 56.8807 66 55.4999 66C54.1193 66 53 64.8807 53 63.5001C53 62.1193 54.1193 61 55.4999 61C56.8807 61 58 62.1193 58 63.5001Z", fill: t.palette.primary[500] })
  ] });
}, Lq = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs("svg", { width: e.width, height: e.height, viewBox: "0 0 112 112", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    e.backgroundShape,
    /* @__PURE__ */ f.jsx("path", { d: "M79.4258 70.0742L41.9258 32.5742C41.6445 32.293 41.2461 32.1758 40.8594 32.2578C40.4727 32.3399 40.1562 32.6094 40.0039 32.9844L20.4102 83.6914C20.1406 84.3945 20 85.1328 20 85.8945C20 89.2695 22.7422 92 26.1055 92C26.8555 92 27.6055 91.8594 28.3086 91.5899L79.0156 71.9961C79.3906 71.8555 79.6602 71.5274 79.7422 71.1406C79.8242 70.7539 79.707 70.3555 79.4258 70.0742Z", fill: t.palette.primary[200] }),
    /* @__PURE__ */ f.jsx("path", { d: "M79.4258 70.0742L41.9258 32.5742C41.6445 32.293 41.2461 32.1758 40.8594 32.2578C40.4727 32.3399 40.1562 32.6094 40.0039 32.9844L20.4102 83.6914C20.1406 84.3945 20 85.1328 20 85.8945C20 89.2695 22.7422 92 26.1055 92C26.8555 92 27.6055 91.8594 28.3086 91.5899L79.0156 71.9961C79.3906 71.8555 79.6602 71.5274 79.7422 71.1406C79.8242 70.7539 79.707 70.3555 79.4258 70.0742Z", fill: t.palette.primary[200] }),
    /* @__PURE__ */ f.jsx("path", { d: "M78.7343 60.1133C76.3554 55.168 72.289 49.6954 67.2968 44.7032C62.3046 39.711 56.8319 35.6446 51.8866 33.2657C46.5312 30.6875 42.4062 30.4414 40.2616 32.586C38.1171 34.7188 38.3632 38.8555 40.9413 44.211C43.3202 49.1563 47.3866 54.6289 52.3788 59.6211C57.371 64.6133 62.8437 68.6797 67.789 71.0586C70.7304 72.4766 73.2968 73.1914 75.371 73.1914C77.0702 73.1914 78.4413 72.711 79.4023 71.75C81.5468 69.6172 81.3007 65.4805 78.7226 60.125L78.7343 60.1133Z", fill: t.palette.primary[400] }),
    /* @__PURE__ */ f.jsx("path", { d: "M55.1563 45.125C54.9805 45.125 54.8047 45.0899 54.6289 44.9961C54.0547 44.7032 53.8203 44 54.1016 43.4258L55.1328 41.375C58.1328 35.3867 58.9766 28.4844 57.5234 21.9453C57.3828 21.3125 57.7812 20.6914 58.4141 20.5508C59.0469 20.4102 59.668 20.8086 59.8086 21.4414C61.3789 28.5078 60.4648 35.961 57.2305 42.4297L56.1992 44.4805C55.9883 44.8907 55.5781 45.125 55.1445 45.125H55.1563Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { d: "M46.9531 29.8906C46.3086 29.8906 45.7812 29.3633 45.7812 28.7188V26.2812C45.3945 26.3516 45.0078 26.375 44.6094 26.375C42.6758 26.375 41.0938 24.793 41.0938 22.8594C41.0938 20.9258 42.6758 19.3438 44.6094 19.3438C46.4141 19.3438 47.9023 20.7148 48.1016 22.4609C48.8398 21.6289 49.2969 20.5391 49.2969 19.3438V18.1719C49.2969 17.5273 49.8242 17 50.4688 17C51.1133 17 51.6406 17.5273 51.6406 18.1719V19.3438C51.6406 21.9453 50.2227 24.2188 48.125 25.4258V28.7188C48.125 29.3633 47.5977 29.8906 46.9531 29.8906ZM44.6094 21.6875C43.9648 21.6875 43.4375 22.2148 43.4375 22.8594C43.4375 23.5039 43.9648 24.0312 44.6094 24.0312C45.0195 24.0312 45.4062 23.9844 45.7812 23.8789V22.8594C45.7812 22.2148 45.2539 21.6875 44.6094 21.6875Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { d: "M68.0468 58.0157C67.6132 58.0157 67.203 57.7813 66.9921 57.3711C66.6991 56.7969 66.9335 56.0938 67.5194 55.8008L69.5702 54.7696C76.039 51.5352 83.4921 50.6211 90.5585 52.1915C91.1913 52.3321 91.5898 52.9532 91.4491 53.586C91.3085 54.2188 90.6874 54.6172 90.0546 54.4766C83.5155 53.0235 76.6132 53.8672 70.6249 56.8672L68.5741 57.8985C68.4101 57.9805 68.2226 58.0274 68.0468 58.0274V58.0157Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { d: "M89.1406 70.9062C87.207 70.9062 85.625 69.3242 85.625 67.3906C85.625 66.9922 85.6602 66.6055 85.7188 66.2188H83.2812C82.6367 66.2188 82.1094 65.6914 82.1094 65.0469C82.1094 64.4023 82.6367 63.875 83.2812 63.875H86.5742C87.793 61.7773 90.0664 60.3594 92.6562 60.3594H93.8281C94.4727 60.3594 95 60.8867 95 61.5312C95 62.1758 94.4727 62.7031 93.8281 62.7031H92.6562C91.4609 62.7031 90.3594 63.1602 89.5391 63.8984C91.2969 64.0977 92.6562 65.5859 92.6562 67.3906C92.6562 69.3242 91.0742 70.9062 89.1406 70.9062ZM88.1211 66.2188C88.0273 66.5938 87.9688 66.9805 87.9688 67.3906C87.9688 68.0352 88.4961 68.5625 89.1406 68.5625C89.7852 68.5625 90.3125 68.0352 90.3125 67.3906C90.3125 66.7461 89.7852 66.2188 89.1406 66.2188H88.1211Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { d: "M62.1875 50.9844C61.8828 50.9844 61.5898 50.8672 61.3555 50.6445C60.8984 50.1875 60.8984 49.4492 61.3555 48.9922L78.3477 32C78.8047 31.543 79.543 31.543 80 32C80.457 32.457 80.457 33.1953 80 33.6523L63.0078 50.6445C62.7734 50.8789 62.4805 50.9844 62.1758 50.9844H62.1875Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { d: "M54.9219 80.75C44.0586 76.0156 35.5859 49.7656 35.2344 48.6406L34.6602 46.8242L29.1055 61.1914L29.375 63.8867C29.4336 64.4727 30.7578 76.625 39.6172 87.2305L55.6602 81.0312C55.4141 80.9492 55.168 80.8555 54.9219 80.75Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { d: "M33.5469 34.7773L33.1133 34.4844C31.3437 33.3008 29.9961 31.543 29.3164 29.5156C29.1523 29.0352 28.707 28.7188 28.2031 28.7188C27.6992 28.7188 27.2539 29.0469 27.0898 29.5156C26.4219 31.5313 25.0742 33.3008 23.293 34.4844L22.8594 34.7773C22.5313 35 22.3438 35.3633 22.3438 35.75C22.3438 36.1367 22.543 36.5117 22.8594 36.7227L23.293 37.0156C25.0625 38.1992 26.4102 39.957 27.0898 41.9844C27.2539 42.4648 27.6992 42.7812 28.2031 42.7812C28.707 42.7812 29.1523 42.4531 29.3164 41.9844C29.9844 39.9688 31.332 38.1992 33.1133 37.0156L33.5469 36.7227C33.875 36.5 34.0625 36.1367 34.0625 35.75C34.0625 35.3633 33.8633 34.9883 33.5469 34.7773Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { d: "M82.5974 15.3745L77.6255 10.4027C77.1679 9.94503 76.4259 9.94503 75.9682 10.4027L70.9964 15.3745C70.5387 15.8322 70.5387 16.5742 70.9964 17.0318L75.9682 22.0036C76.4259 22.4613 77.1679 22.4613 77.6255 22.0036L82.5974 17.0318C83.055 16.5742 83.055 15.8322 82.5974 15.3745Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { d: "M66.875 33.4063C66.6641 33.4063 66.4649 33.3477 66.2774 33.2422C65.7266 32.9141 65.5391 32.1875 65.8789 31.6368L69.3946 25.7774C69.7227 25.2266 70.4493 25.0391 71 25.3789C71.5508 25.7071 71.7383 26.4336 71.3985 26.9844L67.8829 32.8438C67.6602 33.2071 67.2735 33.418 66.875 33.418V33.4063Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { d: "M79.7656 46.2969C79.3671 46.2969 78.9804 46.0977 78.7578 45.7227C78.4296 45.1719 78.6054 44.4453 79.1562 44.1172L85.0156 40.6016C85.5664 40.2735 86.2929 40.4492 86.6211 41C86.9492 41.5508 86.7734 42.2774 86.2226 42.6055L80.3632 46.1211C80.1757 46.2383 79.9648 46.2852 79.7656 46.2852V46.2969Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { d: "M70.2031 93.0586L69.7695 92.7656C68 91.582 66.6523 89.8242 65.9727 87.7969C65.8086 87.3164 65.3633 87 64.8594 87C64.3555 87 63.9102 87.3281 63.7461 87.7969C63.0781 89.8125 61.7305 91.582 59.9492 92.7656L59.5156 93.0586C59.1875 93.2812 59 93.6445 59 94.0312C59 94.418 59.1992 94.793 59.5156 95.0039L59.9492 95.2969C61.7188 96.4805 63.0664 98.2383 63.7461 100.266C63.9102 100.746 64.3555 101.062 64.8594 101.062C65.3633 101.062 65.8086 100.734 65.9727 100.266C66.6406 98.25 67.9883 96.4805 69.7695 95.2969L70.2031 95.0039C70.5313 94.7813 70.7188 94.418 70.7188 94.0312C70.7188 93.6445 70.5195 93.2695 70.2031 93.0586Z", fill: t.palette.primary[800] })
  ] });
}, Iq = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs("svg", { width: e.width, height: e.height, viewBox: "0 0 112 112", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_9570_134)", children: [
      e.backgroundShape,
      /* @__PURE__ */ f.jsx("path", { d: "M3 49C3 40.7157 9.71573 34 18 34H105C106.105 34 107 34.8954 107 36V48C107 56.8366 99.8366 64 91 64H18C9.71573 64 3 57.2843 3 49Z", fill: t.palette.primary[500] }),
      /* @__PURE__ */ f.jsx("rect", { x: "11.5", y: "40.5", width: "17", height: "17", rx: "8.5", stroke: "white" }),
      /* @__PURE__ */ f.jsx("path", { d: "M19.5315 51.1277C19.5349 50.5107 19.6032 50.0325 19.7364 49.6929C19.8696 49.3534 20.1328 48.9773 20.526 48.5648C20.8498 48.2218 21.0955 47.8995 21.2631 47.598C21.4306 47.2965 21.5144 46.9657 21.5144 46.6057C21.5144 46.1264 21.3771 45.7282 21.1023 45.4114C20.8276 45.0945 20.4491 44.9361 19.9669 44.9361C19.5387 44.9361 19.2044 45.0664 18.9639 45.3269C18.7234 45.5874 18.5377 45.8825 18.4067 46.2123L17.6211 45.7939C17.8162 45.2602 18.1097 44.8198 18.5016 44.4727C18.8936 44.1255 19.382 43.952 19.9669 43.952C20.7431 43.952 21.3415 44.2104 21.762 44.7273C22.1825 45.2442 22.3927 45.8584 22.3927 46.5698C22.3927 47.0181 22.3107 47.4242 22.1467 47.7883C21.9827 48.1524 21.7333 48.5193 21.3983 48.889C20.9699 49.3534 20.7054 49.7206 20.6049 49.9907C20.5044 50.2609 20.4525 50.6398 20.4491 51.1277H19.5315ZM19.9669 54.5417C19.7806 54.5417 19.6207 54.4627 19.4871 54.3048C19.3534 54.1469 19.2866 53.9579 19.2866 53.7377C19.2866 53.5176 19.3534 53.3286 19.4871 53.1707C19.6207 53.0128 19.7806 52.9338 19.9669 52.9338C20.1531 52.9338 20.3131 53.0128 20.4467 53.1707C20.5803 53.3286 20.6471 53.5176 20.6471 53.7377C20.6471 53.9579 20.5803 54.1469 20.4467 54.3048C20.3131 54.4627 20.1531 54.5417 19.9669 54.5417Z", fill: "white" }),
      /* @__PURE__ */ f.jsx("path", { d: "M33.0045 53L36.7845 44.6H38.3205L42.1125 53H40.4805L37.2285 45.428H37.8525L34.6125 53H33.0045ZM34.7445 51.056L35.1645 49.832H39.7005L40.1205 51.056H34.7445ZM44.9581 53.084C44.4221 53.084 43.9061 53.016 43.4101 52.88C42.9221 52.736 42.5341 52.564 42.2461 52.364L42.8221 51.224C43.1101 51.408 43.4541 51.56 43.8541 51.68C44.2541 51.8 44.6541 51.86 45.0541 51.86C45.5261 51.86 45.8661 51.796 46.0741 51.668C46.2901 51.54 46.3981 51.368 46.3981 51.152C46.3981 50.976 46.3261 50.844 46.1821 50.756C46.0381 50.66 45.8501 50.588 45.6181 50.54C45.3861 50.492 45.1261 50.448 44.8381 50.408C44.5581 50.368 44.2741 50.316 43.9861 50.252C43.7061 50.18 43.4501 50.08 43.2181 49.952C42.9861 49.816 42.7981 49.636 42.6541 49.412C42.5101 49.188 42.4381 48.892 42.4381 48.524C42.4381 48.116 42.5541 47.764 42.7861 47.468C43.0181 47.164 43.3421 46.932 43.7581 46.772C44.1821 46.604 44.6821 46.52 45.2581 46.52C45.6901 46.52 46.1261 46.568 46.5661 46.664C47.0061 46.76 47.3701 46.896 47.6581 47.072L47.0821 48.212C46.7781 48.028 46.4701 47.904 46.1581 47.84C45.8541 47.768 45.5501 47.732 45.2461 47.732C44.7901 47.732 44.4501 47.8 44.2261 47.936C44.0101 48.072 43.9021 48.244 43.9021 48.452C43.9021 48.644 43.9741 48.788 44.1181 48.884C44.2621 48.98 44.4501 49.056 44.6821 49.112C44.9141 49.168 45.1701 49.216 45.4501 49.256C45.7381 49.288 46.0221 49.34 46.3021 49.412C46.5821 49.484 46.8381 49.584 47.0701 49.712C47.3101 49.832 47.5021 50.004 47.6461 50.228C47.7901 50.452 47.8621 50.744 47.8621 51.104C47.8621 51.504 47.7421 51.852 47.5021 52.148C47.2701 52.444 46.9381 52.676 46.5061 52.844C46.0741 53.004 45.5581 53.084 44.9581 53.084ZM51.1339 53.084C50.5979 53.084 50.0819 53.016 49.5859 52.88C49.0979 52.736 48.7099 52.564 48.4219 52.364L48.9979 51.224C49.2859 51.408 49.6299 51.56 50.0299 51.68C50.4299 51.8 50.8299 51.86 51.2299 51.86C51.7019 51.86 52.0419 51.796 52.2499 51.668C52.4659 51.54 52.5739 51.368 52.5739 51.152C52.5739 50.976 52.5019 50.844 52.3579 50.756C52.2139 50.66 52.0259 50.588 51.7939 50.54C51.5619 50.492 51.3019 50.448 51.0139 50.408C50.7339 50.368 50.4499 50.316 50.1619 50.252C49.8819 50.18 49.6259 50.08 49.3939 49.952C49.1619 49.816 48.9739 49.636 48.8299 49.412C48.6859 49.188 48.6139 48.892 48.6139 48.524C48.6139 48.116 48.7299 47.764 48.9619 47.468C49.1939 47.164 49.5179 46.932 49.9339 46.772C50.3579 46.604 50.8579 46.52 51.4339 46.52C51.8659 46.52 52.3019 46.568 52.7419 46.664C53.1819 46.76 53.5459 46.896 53.8339 47.072L53.2579 48.212C52.9539 48.028 52.6459 47.904 52.3339 47.84C52.0299 47.768 51.7259 47.732 51.4219 47.732C50.9659 47.732 50.6259 47.8 50.4019 47.936C50.1859 48.072 50.0779 48.244 50.0779 48.452C50.0779 48.644 50.1499 48.788 50.2939 48.884C50.4379 48.98 50.6259 49.056 50.8579 49.112C51.0899 49.168 51.3459 49.216 51.6259 49.256C51.9139 49.288 52.1979 49.34 52.4779 49.412C52.7579 49.484 53.0139 49.584 53.2459 49.712C53.4859 49.832 53.6779 50.004 53.8219 50.228C53.9659 50.452 54.0379 50.744 54.0379 51.104C54.0379 51.504 53.9179 51.852 53.6779 52.148C53.4459 52.444 53.1139 52.676 52.6819 52.844C52.2499 53.004 51.7339 53.084 51.1339 53.084ZM55.3297 53V46.592H56.8297V53H55.3297ZM56.0857 45.536C55.8057 45.536 55.5737 45.448 55.3897 45.272C55.2137 45.096 55.1257 44.884 55.1257 44.636C55.1257 44.38 55.2137 44.168 55.3897 44C55.5737 43.824 55.8057 43.736 56.0857 43.736C56.3657 43.736 56.5937 43.82 56.7697 43.988C56.9537 44.148 57.0457 44.352 57.0457 44.6C57.0457 44.864 56.9577 45.088 56.7817 45.272C56.6057 45.448 56.3737 45.536 56.0857 45.536ZM60.7785 53.084C60.2425 53.084 59.7265 53.016 59.2305 52.88C58.7425 52.736 58.3545 52.564 58.0665 52.364L58.6425 51.224C58.9305 51.408 59.2745 51.56 59.6745 51.68C60.0745 51.8 60.4745 51.86 60.8745 51.86C61.3465 51.86 61.6865 51.796 61.8945 51.668C62.1105 51.54 62.2185 51.368 62.2185 51.152C62.2185 50.976 62.1465 50.844 62.0025 50.756C61.8585 50.66 61.6705 50.588 61.4385 50.54C61.2065 50.492 60.9465 50.448 60.6585 50.408C60.3785 50.368 60.0945 50.316 59.8065 50.252C59.5265 50.18 59.2705 50.08 59.0385 49.952C58.8065 49.816 58.6185 49.636 58.4745 49.412C58.3305 49.188 58.2585 48.892 58.2585 48.524C58.2585 48.116 58.3745 47.764 58.6065 47.468C58.8385 47.164 59.1625 46.932 59.5785 46.772C60.0025 46.604 60.5025 46.52 61.0785 46.52C61.5105 46.52 61.9465 46.568 62.3865 46.664C62.8265 46.76 63.1905 46.896 63.4785 47.072L62.9025 48.212C62.5985 48.028 62.2905 47.904 61.9785 47.84C61.6745 47.768 61.3705 47.732 61.0665 47.732C60.6105 47.732 60.2705 47.8 60.0465 47.936C59.8305 48.072 59.7225 48.244 59.7225 48.452C59.7225 48.644 59.7945 48.788 59.9385 48.884C60.0825 48.98 60.2705 49.056 60.5025 49.112C60.7345 49.168 60.9905 49.216 61.2705 49.256C61.5585 49.288 61.8425 49.34 62.1225 49.412C62.4025 49.484 62.6585 49.584 62.8905 49.712C63.1305 49.832 63.3225 50.004 63.4665 50.228C63.6105 50.452 63.6825 50.744 63.6825 51.104C63.6825 51.504 63.5625 51.852 63.3225 52.148C63.0905 52.444 62.7585 52.676 62.3265 52.844C61.8945 53.004 61.3785 53.084 60.7785 53.084ZM67.3862 53.084C66.6822 53.084 66.1382 52.904 65.7542 52.544C65.3702 52.176 65.1782 51.636 65.1782 50.924V45.176H66.6782V50.888C66.6782 51.192 66.7542 51.428 66.9062 51.596C67.0662 51.764 67.2862 51.848 67.5662 51.848C67.9022 51.848 68.1822 51.76 68.4062 51.584L68.8262 52.652C68.6502 52.796 68.4342 52.904 68.1782 52.976C67.9222 53.048 67.6582 53.084 67.3862 53.084ZM64.1222 47.84V46.64H68.3942V47.84H64.1222ZM74.0082 53V51.704L73.9242 51.428V49.16C73.9242 48.72 73.7922 48.38 73.5282 48.14C73.2642 47.892 72.8642 47.768 72.3282 47.768C71.9682 47.768 71.6122 47.824 71.2602 47.936C70.9162 48.048 70.6242 48.204 70.3842 48.404L69.7962 47.312C70.1402 47.048 70.5482 46.852 71.0202 46.724C71.5002 46.588 71.9962 46.52 72.5082 46.52C73.4362 46.52 74.1522 46.744 74.6562 47.192C75.1682 47.632 75.4242 48.316 75.4242 49.244V53H74.0082ZM71.9922 53.084C71.5122 53.084 71.0922 53.004 70.7322 52.844C70.3722 52.676 70.0922 52.448 69.8922 52.16C69.7002 51.864 69.6042 51.532 69.6042 51.164C69.6042 50.804 69.6882 50.48 69.8562 50.192C70.0322 49.904 70.3162 49.676 70.7082 49.508C71.1002 49.34 71.6202 49.256 72.2682 49.256H74.1282V50.252H72.3762C71.8642 50.252 71.5202 50.336 71.3442 50.504C71.1682 50.664 71.0802 50.864 71.0802 51.104C71.0802 51.376 71.1882 51.592 71.4042 51.752C71.6202 51.912 71.9202 51.992 72.3042 51.992C72.6722 51.992 73.0002 51.908 73.2882 51.74C73.5842 51.572 73.7962 51.324 73.9242 50.996L74.1762 51.896C74.0322 52.272 73.7722 52.564 73.3962 52.772C73.0282 52.98 72.5602 53.084 71.9922 53.084ZM80.9852 46.52C81.4972 46.52 81.9532 46.62 82.3532 46.82C82.7612 47.02 83.0812 47.328 83.3132 47.744C83.5452 48.152 83.6612 48.68 83.6612 49.328V53H82.1612V49.52C82.1612 48.952 82.0252 48.528 81.7532 48.248C81.4892 47.968 81.1172 47.828 80.6372 47.828C80.2852 47.828 79.9732 47.9 79.7012 48.044C79.4292 48.188 79.2172 48.404 79.0652 48.692C78.9212 48.972 78.8492 49.328 78.8492 49.76V53H77.3492V46.592H78.7772V48.32L78.5252 47.792C78.7492 47.384 79.0732 47.072 79.4972 46.856C79.9292 46.632 80.4252 46.52 80.9852 46.52ZM88.5158 53.084C87.8438 53.084 87.2438 52.944 86.7158 52.664C86.1958 52.376 85.7878 51.984 85.4918 51.488C85.1958 50.992 85.0478 50.428 85.0478 49.796C85.0478 49.156 85.1958 48.592 85.4918 48.104C85.7878 47.608 86.1958 47.22 86.7158 46.94C87.2438 46.66 87.8438 46.52 88.5158 46.52C89.1398 46.52 89.6878 46.648 90.1598 46.904C90.6398 47.152 91.0038 47.52 91.2518 48.008L90.0998 48.68C89.9078 48.376 89.6718 48.152 89.3918 48.008C89.1198 47.864 88.8238 47.792 88.5038 47.792C88.1358 47.792 87.8038 47.872 87.5078 48.032C87.2118 48.192 86.9798 48.424 86.8118 48.728C86.6438 49.024 86.5598 49.38 86.5598 49.796C86.5598 50.212 86.6438 50.572 86.8118 50.876C86.9798 51.172 87.2118 51.4 87.5078 51.56C87.8038 51.72 88.1358 51.8 88.5038 51.8C88.8238 51.8 89.1198 51.728 89.3918 51.584C89.6718 51.44 89.9078 51.216 90.0998 50.912L91.2518 51.584C91.0038 52.064 90.6398 52.436 90.1598 52.7C89.6878 52.956 89.1398 53.084 88.5158 53.084ZM95.4667 53.084C94.7547 53.084 94.1307 52.944 93.5947 52.664C93.0667 52.376 92.6547 51.984 92.3587 51.488C92.0707 50.992 91.9267 50.428 91.9267 49.796C91.9267 49.156 92.0667 48.592 92.3467 48.104C92.6347 47.608 93.0267 47.22 93.5227 46.94C94.0267 46.66 94.5987 46.52 95.2387 46.52C95.8627 46.52 96.4187 46.656 96.9067 46.928C97.3947 47.2 97.7787 47.584 98.0587 48.08C98.3387 48.576 98.4787 49.16 98.4787 49.832C98.4787 49.896 98.4747 49.968 98.4667 50.048C98.4667 50.128 98.4627 50.204 98.4547 50.276H93.1147V49.28H97.6627L97.0747 49.592C97.0827 49.224 97.0067 48.9 96.8467 48.62C96.6867 48.34 96.4667 48.12 96.1867 47.96C95.9147 47.8 95.5987 47.72 95.2387 47.72C94.8707 47.72 94.5467 47.8 94.2667 47.96C93.9947 48.12 93.7787 48.344 93.6187 48.632C93.4667 48.912 93.3907 49.244 93.3907 49.628V49.868C93.3907 50.252 93.4787 50.592 93.6547 50.888C93.8307 51.184 94.0787 51.412 94.3987 51.572C94.7187 51.732 95.0867 51.812 95.5027 51.812C95.8627 51.812 96.1867 51.756 96.4747 51.644C96.7627 51.532 97.0187 51.356 97.2427 51.116L98.0467 52.04C97.7587 52.376 97.3947 52.636 96.9547 52.82C96.5227 52.996 96.0267 53.084 95.4667 53.084Z", fill: "white" }),
      /* @__PURE__ */ f.jsx("path", { d: "M50.4853 73.9182C51.3963 72.0223 53.6686 71.2249 55.5646 72.1359C56.4975 72.5842 57.1823 73.3947 57.4805 74.3159C57.8233 75.2215 57.7952 76.2822 57.3469 77.2152L56.5227 78.9306C56.9709 77.9977 57.7815 77.3129 58.7027 77.0146C59.6083 76.6718 60.669 76.6999 61.602 77.1482C62.5349 77.5965 63.2197 78.4071 63.5179 79.3283C63.8607 80.2338 63.8326 81.2946 63.3843 82.2275L62.5601 83.9429C63.0084 83.01 63.8189 82.3252 64.7401 82.027C65.6457 81.6842 66.7064 81.7123 67.6394 82.1605C69.5354 83.0715 70.3327 85.3439 69.4217 87.2398L63.6522 99.2477C60.7023 105.387 53.2303 107.909 46.9405 104.887L38.2731 100.722C34.0297 98.6834 30.7333 95.1362 29.0072 90.7878C28.2615 88.9478 27.5157 87.1078 27.0213 86.0552C23.9186 79.6378 20.3924 75.7209 18.623 74.3151C20.7565 71.3396 24.1001 71.2422 26.3873 72.3411C26.9591 72.6159 27.5477 73.0098 28.0629 73.4796C30.1547 75.4478 30.2243 76.0739 31.962 78.3165C34.2641 81.3118 38.8264 80.8368 40.417 77.5264L51.9417 53.5407C52.8527 51.6447 55.125 50.8474 57.021 51.7583C57.9539 52.2066 58.6387 53.0172 58.937 53.9384C59.2797 54.8439 59.2516 55.9047 58.8034 56.8376L50.5756 73.9616L50.4853 73.9182Z", fill: t.palette.primary[700] })
    ] }),
    /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_9570_134", children: /* @__PURE__ */ f.jsx("rect", { width: "112", height: "112", fill: "white" }) }) })
  ] });
}, jq = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs("svg", { width: e.width, height: e.height, viewBox: "0 0 112 112", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    e.backgroundShape,
    /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_9177_567)", children: [
      /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.7266 24.1094C43.1016 28.7305 67.9844 28.6289 93.375 24.1094C94.1875 23.9571 94.8984 24.7188 94.8984 25.5313V80.7813C94.8984 81.543 94.1875 82 93.375 82.2032C68.4922 88.6016 43.6094 89.0079 18.7266 82.2032C17.9141 82 17.2031 81.5938 17.2031 80.7813V25.5313C17.2031 24.7696 17.9141 23.9571 18.7266 24.1094Z", fill: "#B18651" }),
      /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M27.918 53.7657C27.9688 51.4297 28.2734 49.9063 28.5781 48.5352C28.8828 47.1641 29.1367 45.9453 29.1367 44.2188C29.1367 42.4922 26.0898 40.7149 22.6367 38.6836C20.707 37.5157 18.625 36.2969 17.1523 35.2813V39.1407C18.3711 39.9532 19.7422 40.7149 21.0117 41.4766C23.6016 43 25.8867 44.1172 25.8867 44.2188C25.8867 45.6407 25.6328 46.6563 25.3789 47.8242C25.0234 49.3477 24.668 51.0235 24.6172 53.7149C24.6172 54.6797 24.4141 55.1367 24.3125 55.3907C23.9062 56.4063 23.7031 56.8633 24.7695 57.7266C25.125 58.0313 25.4805 58.1328 26.1406 58.336C27.0039 58.5899 28.6289 59.0977 31.5742 60.3672C30.4062 61.1797 29.3906 62.043 28.6289 63.1094C27.3594 64.9883 26.9531 67.1719 28.2227 70.0156C30.5586 75.3477 30.5078 75.4492 30.1523 75.8047C29.2891 76.7696 27.8672 78.293 27.4609 84.2344L30.6602 84.8438V84.5899C30.9648 79.6133 31.9297 78.5977 32.4883 77.9375C33.9609 76.3633 34.3672 75.9571 31.168 68.6446C30.457 67.0196 30.6094 65.8516 31.2695 64.8867C32.0312 63.7696 33.4531 62.8555 35.0781 61.8906C38.0234 63.211 40.4102 63.8711 44.0664 61.5352C44.7773 61.0781 45.1836 61.1797 45.3867 61.5352C46.4531 63.1602 46.6055 66.9688 46.707 68.9492V69.5078C46.7578 70.7266 47.5195 72.4024 48.4844 73.7227C49.4492 74.9922 50.7695 75.9571 52.0391 76.0078C53.0547 76.0586 54.375 75.6016 55.8984 74.8906C57.0664 74.3321 58.3867 73.6719 59.6562 73.0117C61.0781 72.25 62.4492 71.5391 63.5156 71.0821C63.7695 70.9805 63.9219 70.9297 64.0234 70.8789C65.8008 70.0664 68.4922 68.5938 70.5234 66.7149C72.8594 64.5821 74.3828 61.9414 73.2148 59.0977C73.1641 58.9453 73.1641 58.9961 73.1641 58.9453C72.25 56.9141 71.793 55.6446 71.5898 54.7813C72.3516 54.8828 73.1133 54.9844 73.8242 54.9844C75.5 55.0352 77.1758 54.6797 79.1562 53.8672C80.375 53.3594 81.2891 54.6289 82.3047 56.1016C83.9805 58.4375 85.8594 61.0781 89.7695 60.9766C91.6992 60.9258 93.3242 61.4844 94.8477 62.3477V58.6914C93.375 58.0313 91.6992 57.6758 89.7188 57.7266C87.4844 57.7774 86.1641 55.8985 84.9453 54.2227C83.1172 51.6836 81.4922 49.3985 77.9375 50.8711C76.3633 51.5313 75.1445 51.7344 73.875 51.7344C72.8086 51.7344 71.6406 51.5313 70.2695 51.2266C69.6602 50.4649 68.5938 49.5 66.5117 47.5196L66.1562 47.1641L65.4453 46.5039C64.2773 45.3867 63.668 44.168 63.5664 42.8985C63.5156 41.5274 64.0234 40.0547 65.1406 38.6328C65.1914 38.5821 65.6484 38.6836 66.7148 38.3282C68.1367 37.8711 69.9648 37.4141 71.6914 37.211C73.1641 37.0586 74.5352 37.1094 75.1953 37.6172C75.3477 37.7188 75.4492 37.8711 75.5 38.0742C76.4141 40.918 78.2422 43.2032 80.5781 44.5742C82.8633 45.9453 85.6562 46.4024 88.5 45.6407C89.9219 45.2852 90.3281 45.1328 90.6836 45.0313C92.3594 44.5742 93.5273 44.2696 94.7969 44.0157V40.7149C93.1719 41.0196 91.8516 41.375 89.8203 41.9336C88.9062 42.1875 87.8906 42.4414 87.6367 42.543C85.707 43.0508 83.7773 42.7461 82.2031 41.7813C80.5273 40.8164 79.2578 39.1407 78.5977 37.1094C78.3438 36.2461 77.8359 35.5352 77.125 35.0274C75.7031 33.961 73.5195 33.7578 71.3359 33.961C69.3555 34.1641 67.2734 34.7227 65.6992 35.1797C63.9727 35.7383 62.6016 36.5 62.5 36.6016C60.9258 38.6328 60.1641 40.8164 60.2656 42.9492C60.3672 45.0821 61.2812 47.0625 63.1602 48.7891L63.8711 49.4492L64.2266 49.8047C66.7656 52.1914 67.6289 53.0039 67.9336 53.461C67.9844 53.5625 68.0352 53.7657 68.0859 54.0703C68.2383 55.0352 68.543 56.5586 70.168 60.2149C70.2188 60.3164 70.168 60.2149 70.2188 60.2656C70.7266 61.4844 69.7617 62.9063 68.3398 64.2266C66.6133 65.8008 64.2266 67.1211 62.7031 67.8321C62.4492 67.9336 62.3477 67.9844 62.2969 68.0352C61.0781 68.543 59.6562 69.3047 58.1836 70.0664C57.4219 70.4727 56.6602 70.8789 55.9492 71.2344C54.2734 72.0977 52.8516 72.7071 52.1914 72.7071C51.9883 72.7071 51.5312 72.25 51.0742 71.6914C50.4648 70.8789 49.957 69.9141 49.957 69.3047V68.7461C49.8555 66.5117 49.6523 62.043 48.1289 59.7071C46.8594 57.7774 45.0312 57.0157 42.3398 58.7422C39.75 60.418 37.9219 59.5547 35.332 58.336C34.875 58.1328 34.418 57.8789 33.9609 57.7266C30.8125 56.3047 28.8828 55.6446 27.7656 55.2891C27.8672 54.8321 27.918 54.3242 27.918 53.6133V53.7657Z", fill: t.palette.primary[600] }),
      /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M68.0352 53.7149C67.7812 53.2579 66.8672 52.3946 64.3281 50.0586L63.9727 49.7032L63.2617 49.043C61.4336 47.3165 60.4688 45.336 60.3672 43.2032C60.2656 41.0704 61.0273 38.8868 62.6016 36.8555C62.7031 36.7032 64.0742 35.9414 65.8008 35.4336C67.375 34.9258 69.4062 34.418 71.4375 34.2149C73.6719 33.961 75.8047 34.1641 77.2266 35.2813C77.8867 35.7891 78.3945 36.4493 78.6992 37.3633C79.3594 39.4454 80.6797 41.0704 82.3047 42.0352C83.8789 42.9493 85.8086 43.3047 87.7383 42.7969C87.9922 42.7461 89.0078 42.4415 89.9219 42.1875C91.9531 41.629 93.2227 41.2735 94.8984 40.9688V25.5313C94.8984 24.7696 94.1875 24.0079 93.375 24.1094C67.9844 28.6289 43.1016 28.7305 18.7266 24.1094C17.9141 23.9571 17.2031 24.7188 17.2031 25.5313V35.2813C18.6758 36.3477 20.7578 37.5664 22.6875 38.6836C26.1406 40.7149 29.1875 42.543 29.1875 44.2188C29.1875 45.9454 28.9336 47.1641 28.6289 48.5352C28.3242 49.9063 27.9688 51.4297 27.9688 53.7657C27.9688 54.4766 27.8672 54.9844 27.8164 55.4415C28.9336 55.7969 30.8633 56.4571 34.0117 57.879L35.3828 58.4883C37.9727 59.7071 39.8516 60.5704 42.3906 58.8946C45.082 57.1172 46.9609 57.879 48.1797 59.8594C49.7031 62.1954 49.9062 66.6641 50.0078 68.8985V69.4571C50.0586 70.0665 50.5156 71.0313 51.125 71.8438C51.582 72.4024 51.9883 72.8594 52.2422 72.8594C52.9023 72.8594 54.3242 72.25 56 71.3868C56.7109 71.0313 57.4727 70.625 58.2344 70.2188C59.707 69.4571 61.1289 68.6954 62.3477 68.1875C62.3984 68.1875 62.5508 68.086 62.7539 67.9844C64.3281 67.2735 66.6641 65.9532 68.3906 64.379C69.8125 63.1094 70.7773 61.6368 70.2695 60.418C70.2188 60.3672 70.2695 60.4688 70.2188 60.3672C68.5938 56.711 68.2891 55.1875 68.1367 54.2227C68.0859 53.918 68.0352 53.7657 67.9844 53.6133L68.0352 53.7149Z", fill: t.palette.primary[200] }),
      /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M28.2734 70.0664C27.0547 67.2227 27.4102 65.0391 28.6797 63.1602C29.3906 62.0938 30.4062 61.2305 31.625 60.418C28.6797 59.1484 27.0547 58.6406 26.1914 58.3867C25.5312 58.1836 25.1758 58.082 24.8203 57.7773C23.7539 56.9141 23.957 56.457 24.3633 55.4414C24.4648 55.1875 24.668 54.7305 24.668 53.7656C24.7188 51.0742 25.0742 49.3984 25.4297 47.875C25.6836 46.707 25.9375 45.6914 25.9375 44.2695C25.9375 44.1172 23.6523 43.0508 21.0625 41.5273C19.793 40.7656 18.4727 40.0039 17.2031 39.1914V80.832C17.2031 81.5938 17.9141 82 18.7266 82.2539C21.6719 83.0664 24.5664 83.7773 27.5117 84.3867C27.918 78.4453 29.3398 76.9219 30.2031 75.957C30.5078 75.6016 30.6094 75.5 28.2734 70.168V70.0664Z", fill: "#9B6B3C" }),
      /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M52.1406 76.1602C50.8203 76.1094 49.5508 75.1445 48.5859 73.875C47.6211 72.6055 46.8594 70.8789 46.8086 69.6602V69.1016C46.707 67.1719 46.5547 63.3125 45.4883 61.6875C45.2344 61.332 44.8281 61.2305 44.168 61.6875C40.5625 64.0235 38.1758 63.3633 35.1797 62.043C33.5547 62.957 32.1836 63.9219 31.3711 65.0391C30.7109 66.0039 30.5586 67.1719 31.2695 68.7969C34.4688 76.0586 34.0625 76.5156 32.5898 78.0899C31.9805 78.75 31.0664 79.7656 30.7617 84.7422V84.9961C51.6328 88.8047 72.5039 87.6367 93.375 82.2539C94.1875 82.0508 94.8984 81.6445 94.8984 80.832V62.6016C93.375 61.7383 91.8008 61.1797 89.8203 61.2305C85.9102 61.332 84.0312 58.6914 82.3555 56.3555C81.3398 54.8828 80.4258 53.6133 79.207 54.1211C77.2266 54.9336 75.5508 55.2383 73.875 55.2383C73.1133 55.2383 72.4023 55.1367 71.6406 55.0352C71.8945 55.8985 72.3008 57.168 73.2148 59.1992C73.2148 59.25 73.2148 59.1992 73.2656 59.3516C74.4844 62.1953 72.9102 64.836 70.5742 66.9688C68.543 68.7969 65.8516 70.3203 64.0742 71.1328C63.9727 71.1836 63.8203 71.2344 63.5664 71.336C62.5 71.793 61.1289 72.5039 59.707 73.2656C58.4375 73.9258 57.168 74.586 55.9492 75.1445C54.4258 75.8047 53.1055 76.3125 52.0898 76.2617L52.1406 76.1602Z", fill: t.palette.primary[100] }),
      /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M94.8985 58.8438V44.2188C93.6289 44.4727 92.461 44.7773 90.7852 45.2344C90.4297 45.3359 89.9727 45.4375 88.6016 45.8438C85.7579 46.6055 82.9649 46.0977 80.6797 44.7773C78.3438 43.4063 76.5157 41.1211 75.6016 38.2773C75.5508 38.0742 75.4493 37.9219 75.2969 37.8203C74.6368 37.3125 73.2657 37.2617 71.793 37.4141C70.0664 37.6172 68.2383 38.0742 66.8164 38.5313C65.6993 38.8867 65.293 38.7852 65.2422 38.8359C64.125 40.2578 63.6172 41.7305 63.668 43.1016C63.7188 44.3711 64.3282 45.5898 65.5469 46.707L66.2579 47.3672L66.6133 47.7227C68.6954 49.6523 69.7618 50.668 70.3711 51.4297C71.7422 51.7344 72.9102 51.9375 73.9766 51.9375C75.2461 51.9375 76.5157 51.7344 78.0391 51.0742C81.5938 49.6016 83.2188 51.8867 85.0469 54.4258C86.2657 56.1016 87.586 57.9805 89.8204 57.9297C91.8008 57.8789 93.4766 58.2344 94.9493 58.8945L94.8985 58.8438Z", fill: t.palette.primary[300] }),
      /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M30 31.0664C28.6289 31.0664 27.5625 32.1328 27.5625 33.5039L30 38.9883L32.4375 33.5039C32.4375 32.1328 31.3711 31.0664 30 31.0664Z", fill: "#3C2517" }),
      /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M47.5195 41.7305C46.1484 41.7305 45.082 42.7969 45.082 44.168L47.5195 49.6523L49.957 44.168C49.957 42.7969 48.8906 41.7305 47.5195 41.7305Z", fill: "#82000A" }),
      /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M86.3672 62.5508C87.7383 62.5508 88.8047 63.6172 88.8047 64.9883L86.3672 70.4727L83.9297 64.9883C83.9297 63.6172 84.9961 62.5508 86.3672 62.5508Z", fill: t.palette.primary[200] }),
      /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M68.8477 73.2148C70.2188 73.2148 71.2852 74.2812 71.2852 75.6523L68.8477 81.1367L66.4102 75.6523C66.4102 74.2812 67.4766 73.2148 68.8477 73.2148Z", fill: t.palette.primary[800] }),
      /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M83.5742 32.5898C84.9453 32.5898 86.0117 33.6562 86.0117 35.0273L83.5742 40.5117L81.1367 35.0273C81.1367 33.6562 82.2031 32.5898 83.5742 32.5898Z", fill: t.palette.primary[900] }),
      /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M23.6523 60.0117C25.0234 60.0117 26.0898 61.0781 26.0898 62.4492L23.6523 67.9336L21.2148 62.4492C21.2148 61.0781 22.2812 60.0117 23.6523 60.0117Z", fill: "#FAC227" }),
      /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.7266 24.1094C31.0156 26.4453 43.457 27.5625 56.0508 27.5117V87.0781C43.6094 87.1289 31.168 85.5547 18.7266 82.1016C17.9141 81.8985 17.2031 81.4922 17.2031 80.6797V25.4297C17.2031 24.668 17.9141 23.8555 18.7266 24.0078V24.1094Z", fill: "#A67D4C" }),
      /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M27.918 53.7656C27.9688 51.4297 28.2734 49.9062 28.5781 48.5352C28.8828 47.1641 29.1367 45.9453 29.1367 44.2188C29.1367 42.4922 26.0898 40.7148 22.6367 38.6836C20.707 37.5156 18.625 36.2969 17.1523 35.2812V39.1406C18.3711 39.9531 19.7422 40.7148 21.0117 41.4766C23.6016 43 25.8867 44.1172 25.8867 44.2188C25.8867 45.6406 25.6328 46.6562 25.3789 47.8242C25.0234 49.3477 24.668 51.0234 24.6172 53.7148C24.6172 54.6797 24.4141 55.1367 24.3125 55.3906C23.9062 56.4062 23.7031 56.8633 24.7695 57.7266C25.125 58.0312 25.4805 58.1328 26.1406 58.3359C27.0039 58.5898 28.6289 59.0977 31.5742 60.3672C30.4062 61.1797 29.3906 62.043 28.6289 63.1094C27.3594 64.9883 26.9531 67.1719 28.2227 70.0156C30.5586 75.3477 30.5078 75.4492 30.1523 75.8047C29.2891 76.7695 27.8672 78.293 27.4609 84.2344L30.6602 84.8438V84.5898C30.9648 79.6133 31.9297 78.5977 32.4883 77.9375C33.9609 76.3633 34.3672 75.957 31.168 68.6445C30.457 67.0195 30.6094 65.8516 31.2695 64.8867C32.0312 63.7695 33.4531 62.8555 35.0781 61.8906C38.0234 63.2109 40.4102 63.8711 44.0664 61.5352C44.7773 61.0781 45.1836 61.1797 45.3867 61.5352C46.4531 63.1602 46.6055 66.9688 46.707 68.9492V69.5078C46.7578 70.7266 47.5195 72.4023 48.4844 73.7227C49.4492 74.9922 50.7695 75.957 52.0391 76.0078C53.0547 76.0586 54.375 75.6016 55.8984 74.8906L55.9492 74.8398V71.2344L55.8984 71.2852C54.2227 72.1484 52.8008 72.7578 52.1406 72.7578C51.9375 72.7578 51.4805 72.3008 51.0234 71.7422C50.4141 70.9297 49.9062 69.9648 49.9062 69.3555V68.7969C49.8047 66.5625 49.6016 62.0938 48.0781 59.7578C46.8086 57.8281 44.9805 57.0664 42.2891 58.793C39.6992 60.4688 37.8711 59.6055 35.2812 58.3867C34.8242 58.1836 34.3672 57.9297 33.9102 57.7773C30.7617 56.3555 28.832 55.6953 27.7148 55.3398C27.8164 54.8828 27.8672 54.375 27.8672 53.6641L27.918 53.7656Z", fill: t.palette.primary[600] }),
      /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M56.0508 27.5118C43.457 27.5625 31.0156 26.4454 18.7266 24.1094C17.9141 23.9571 17.2031 24.7188 17.2031 25.5313V35.2813C18.6758 36.3477 20.7578 37.5664 22.6875 38.6836C26.1406 40.7149 29.1875 42.543 29.1875 44.2188C29.1875 45.9454 28.9336 47.1641 28.6289 48.5352C28.3242 49.9063 27.9688 51.4297 27.9688 53.7657C27.9688 54.4766 27.8672 54.9844 27.8164 55.4415C28.9336 55.7969 30.8633 56.4571 34.0117 57.879L35.3828 58.4883C37.9727 59.7071 39.8516 60.5704 42.3906 58.8946C45.082 57.1172 46.9609 57.879 48.1797 59.8594C49.7031 62.1954 49.9062 66.6641 50.0078 68.8985V69.4571C50.0586 70.0665 50.5156 71.0313 51.125 71.8438C51.582 72.4024 51.9883 72.8594 52.2422 72.8594C52.9023 72.8594 54.3242 72.25 56 71.3868L56.0508 71.336V27.461V27.5118Z", fill: t.palette.primary[300] }),
      /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M28.2734 70.0664C27.0547 67.2227 27.4102 65.0391 28.6797 63.1602C29.3906 62.0938 30.4062 61.2305 31.625 60.418C28.6797 59.1484 27.0547 58.6406 26.1914 58.3867C25.5312 58.1836 25.1758 58.082 24.8203 57.7773C23.7539 56.9141 23.957 56.457 24.3633 55.4414C24.4648 55.1875 24.668 54.7305 24.668 53.7656C24.7188 51.0742 25.0742 49.3984 25.4297 47.875C25.6836 46.707 25.9375 45.6914 25.9375 44.2695C25.9375 44.1172 23.6523 43.0508 21.0625 41.5273C19.793 40.7656 18.4727 40.0039 17.2031 39.1914V80.832C17.2031 81.5938 17.9141 82 18.7266 82.2539C21.6719 83.0664 24.5664 83.7773 27.5117 84.3867C27.918 78.4453 29.3398 76.9219 30.2031 75.957C30.5078 75.6016 30.6094 75.5 28.2734 70.168V70.0664Z", fill: t.palette.primary[500] }),
      /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M52.1406 76.1601C50.8203 76.1093 49.5508 75.1445 48.5859 73.875C47.6211 72.6054 46.8594 70.8789 46.8086 69.6601V69.1015C46.707 67.1718 46.5547 63.3125 45.4883 61.6875C45.2344 61.332 44.8281 61.2304 44.168 61.6875C40.5625 64.0234 38.1758 63.3632 35.1797 62.0429C33.5547 62.957 32.1836 63.9218 31.3711 65.039C30.7109 66.0039 30.5586 67.1718 31.2695 68.7968C34.4688 76.0586 34.0625 76.5156 32.5898 78.0898C31.9805 78.75 31.0664 79.7656 30.7617 84.7421V84.9961C39.1914 86.5195 47.6211 87.2304 56.0508 87.2304V75.0937L56 75.1445C54.4766 75.8046 53.1562 76.3125 52.1406 76.2617V76.1601Z", fill: t.palette.primary[200] }),
      /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M30 31.0664C28.6289 31.0664 27.5625 32.1328 27.5625 33.5039L30 38.9883L32.4375 33.5039C32.4375 32.1328 31.3711 31.0664 30 31.0664Z", fill: t.palette.primary[500] }),
      /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M47.5195 41.7305C46.1484 41.7305 45.082 42.7969 45.082 44.168L47.5195 49.6523L49.957 44.168C49.957 42.7969 48.8906 41.7305 47.5195 41.7305Z", fill: t.palette.primary[100] }),
      /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M23.6523 60.0117C25.0234 60.0117 26.0898 61.0781 26.0898 62.4492L23.6523 67.9336L21.2148 62.4492C21.2148 61.0781 22.2812 60.0117 23.6523 60.0117Z", fill: t.palette.primary[700] })
    ] }),
    /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_9177_567", children: /* @__PURE__ */ f.jsx("rect", { width: "104", height: "104", fill: "white", transform: "translate(4 4)" }) }) })
  ] });
}, Vq = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs("svg", { width: e.width, height: e.height, viewBox: "0 0 112 112", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    e.backgroundShape,
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M88 32.0879H24V26.281C24 25.0213 25.0086 24 26.2526 24H85.7474C86.9915 24 88 25.0213 88 26.281V32.0879Z", fill: t.palette.primary[700] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M85.7474 88H26.2526C25.0086 88 24 86.9788 24 85.7191V31.4078H88V85.7191C88 86.9788 86.9915 88 85.7474 88Z", fill: t.palette.primary[200] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M29.2011 27.764C29.2011 28.5545 28.5681 29.1955 27.7874 29.1955C27.0067 29.1955 26.3738 28.5545 26.3738 27.764C26.3738 26.9734 27.0067 26.3325 27.7874 26.3325C28.5681 26.3325 29.2011 26.9734 29.2011 27.764Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M34.4803 27.764C34.4803 28.5545 33.8474 29.1955 33.0666 29.1955C32.286 29.1955 31.6531 28.5545 31.6531 27.764C31.6531 26.9734 32.286 26.3325 33.0666 26.3325C33.8474 26.3325 34.4803 26.9734 34.4803 27.764Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M39.7599 27.764C39.7599 28.5545 39.127 29.1955 38.3462 29.1955C37.5655 29.1955 36.9326 28.5545 36.9326 27.764C36.9326 26.9734 37.5655 26.3325 38.3462 26.3325C39.127 26.3325 39.7599 26.9734 39.7599 27.764Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M45.9646 39.756H31.1059C30.4976 39.756 30 39.2521 30 38.6361C30 38.0201 30.4976 37.5162 31.1059 37.5162H45.9646C46.5729 37.5162 47.0705 38.0201 47.0705 38.6361C47.0705 39.2521 46.5729 39.756 45.9646 39.756Z", fill: t.palette.primary[400] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M37.3738 45.0378H31.8438C31.2331 45.0378 30.7378 44.5364 30.7378 43.9179C30.7378 43.2994 31.2331 42.798 31.8438 42.798H37.3738C37.9846 42.798 38.4797 43.2994 38.4797 43.9179C38.4797 44.5364 37.9846 45.0378 37.3738 45.0378Z", fill: t.palette.primary[400] }),
    /* @__PURE__ */ f.jsx("path", { d: "M55.5222 44.1157C46.3972 44.1157 39 51.6063 39 60.8463C39 70.0863 46.3972 77.5769 55.5222 77.5769C64.6471 77.5769 72.0443 70.0863 72.0443 60.8463C72.0443 51.6063 64.6471 44.1157 55.5222 44.1157ZM55.5222 49.3544C61.7899 49.3544 66.8709 54.4995 66.8709 60.8463C66.8709 67.1931 61.7899 72.3382 55.5222 72.3382C49.2544 72.3382 44.1734 67.1931 44.1734 60.8463C44.1734 54.4995 49.2544 49.3544 55.5222 49.3544Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { d: "M67.1233 52.598C68.4223 51.9959 69.9573 52.5742 70.5519 53.8895C71.5308 56.055 72.0444 58.4166 72.0444 60.8463C72.0444 62.8361 71.7 64.782 71.0351 66.6149C70.5425 67.9728 69.0561 68.6692 67.7151 68.1705C66.3876 67.6766 65.7002 66.1965 66.1645 64.8494L66.1789 64.8086C66.6348 63.552 66.871 62.2175 66.871 60.8463C66.871 59.207 66.5332 57.6207 65.8886 56.161L65.8479 56.0699C65.2533 54.7545 65.8243 53.2001 67.1233 52.598Z", fill: t.palette.primary[800] })
  ] });
}, Dq = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs("svg", { width: e.width, height: e.height, viewBox: "0 0 112 112", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    e.backgroundShape,
    /* @__PURE__ */ f.jsx("path", { d: "M32 36C32 33.7909 33.7909 32 36 32H76C78.2091 32 80 33.7909 80 36V76C80 78.2091 78.2091 80 76 80H36C33.7909 80 32 78.2091 32 76V36Z", fill: t.palette.primary[200] }),
    /* @__PURE__ */ f.jsx("path", { d: "M67.4978 46.9265C68.1673 46.257 68.1673 45.1716 67.4978 44.5021C66.8284 43.8326 65.743 43.8326 65.0735 44.5021L56 53.5756L46.9265 44.5021C46.257 43.8326 45.1716 43.8326 44.5022 44.5021C43.8327 45.1716 43.8327 46.257 44.5022 46.9265L53.5756 56L44.5021 65.0735C43.8326 65.743 43.8326 66.8284 44.5021 67.4979C45.1716 68.1674 46.257 68.1674 46.9265 67.4979L56 58.4243L65.0735 67.4979C65.743 68.1674 66.8284 68.1674 67.4979 67.4979C68.1674 66.8284 68.1674 65.743 67.4979 65.0735L58.4244 56L67.4978 46.9265Z", fill: t.palette.primary[800] })
  ] });
}, Aq = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs("svg", { width: e.width, height: e.height, viewBox: "0 0 112 112", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    e.backgroundShape,
    /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_9177_451)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M54.8574 45.3127C54.877 39.566 54.8991 28.2928 57.4513 25.4644L59.6253 27.6602C58.467 28.8439 57.8365 37.4678 57.9108 45.3038C57.9124 45.5064 57.8737 45.7072 57.7969 45.8947C57.7202 46.0821 57.607 46.2524 57.4639 46.3955C57.3208 46.5386 57.1507 46.6518 56.9635 46.7284C56.7763 46.805 56.5757 46.8435 56.3735 46.8416C55.9701 46.8401 55.5839 46.6782 55.2996 46.3915C55.0154 46.1048 54.8563 45.7168 54.8574 45.3127Z", fill: t.palette.primary[800] }),
      /* @__PURE__ */ f.jsx("path", { d: "M57.5255 28.078C57.3783 28.0414 57.2398 27.976 57.1178 27.8858C56.9959 27.7955 56.8928 27.682 56.8147 27.5519C56.7365 27.4217 56.6847 27.2773 56.6622 27.1271C56.6397 26.9769 56.647 26.8236 56.6836 26.6762C57.7319 22.4529 60.4118 18.8198 64.1339 16.576C67.8561 14.3322 72.3155 13.6616 76.5311 14.7117C76.6783 14.7483 76.8168 14.8136 76.9387 14.9039C77.0607 14.9941 77.1637 15.1076 77.2418 15.2377C77.32 15.3679 77.3719 15.5122 77.3944 15.6624C77.4169 15.8126 77.4096 15.9658 77.373 16.1132C76.3248 20.3365 73.6449 23.9697 69.9228 26.2136C66.2006 28.4574 61.7412 29.1281 57.5255 28.078Z", fill: t.palette.primary[700] }),
      /* @__PURE__ */ f.jsx("path", { d: "M35.4693 14.4849C37.5568 13.9649 39.726 13.8619 41.8531 14.1818C43.9802 14.5016 46.0237 15.2381 47.8667 16.3491C49.7098 17.4601 51.3163 18.9239 52.5947 20.6569C53.873 22.39 54.7981 24.3583 55.3171 26.4494C55.3538 26.5969 55.3611 26.7501 55.3386 26.9003C55.3161 27.0505 55.2643 27.1949 55.1861 27.3251C55.1079 27.4552 55.0049 27.5687 54.8829 27.659C54.761 27.7493 54.6224 27.8146 54.4753 27.8512C52.3878 28.3712 50.2186 28.4742 48.0915 28.1543C45.9643 27.8345 43.9209 27.098 42.0779 25.987C40.2348 24.876 38.6283 23.4122 37.3499 21.6792C36.0716 19.9461 35.1465 17.9779 34.6275 15.8867C34.5908 15.7392 34.5835 15.586 34.606 15.4358C34.6285 15.2856 34.6803 15.1412 34.7585 15.011C34.8367 14.8809 34.9397 14.7674 35.0617 14.6771C35.1836 14.5868 35.3222 14.5215 35.4693 14.4849Z", fill: t.palette.primary[600] }),
      /* @__PURE__ */ f.jsx("path", { d: "M56.3889 46.8416H56.3532C56.1529 46.8409 55.9548 46.8006 55.7701 46.723C55.5855 46.6455 55.4179 46.5321 55.2771 46.3895C55.1362 46.247 55.0248 46.0779 54.9493 45.8921C54.8738 45.7063 54.8357 45.5074 54.8371 45.3068C54.8676 41.5053 54.7069 31.6051 52.3564 27.3054L55.0641 25.8191C57.8013 30.8261 57.9676 41.3824 57.9271 45.3362C57.9221 45.7401 57.7573 46.1255 57.4689 46.4077C57.1805 46.6899 56.7921 46.846 56.3889 46.8416Z", fill: t.palette.primary[700] }),
      /* @__PURE__ */ f.jsx("path", { d: "M77.4037 15.8332C77.4036 15.9268 77.3933 16.0201 77.373 16.1115C76.8547 18.2028 75.9304 20.1713 74.6527 21.9047C73.375 23.6381 71.769 25.1024 69.9264 26.214C68.0838 27.3256 66.0407 28.0626 63.9138 28.3831C61.7868 28.7036 59.6177 28.6013 57.5302 28.0819C57.279 28.0214 57.0557 27.8773 56.8968 27.6732C56.7379 27.4691 56.6528 27.217 56.6553 26.9582C56.6555 26.8646 56.6658 26.7713 56.6861 26.6799C56.7479 26.4427 56.8096 26.2159 56.8714 25.9891C57.0231 26.2031 57.2455 26.3565 57.4992 26.422C65.9798 28.5781 74.563 23.4112 76.8693 14.8534C77.0321 14.9599 77.166 15.1051 77.2593 15.2761C77.3525 15.447 77.4021 15.6384 77.4037 15.8332Z", fill: t.palette.primary[800] }),
      /* @__PURE__ */ f.jsx("path", { d: "M55.3495 26.7314C55.3497 26.9885 55.2636 27.2382 55.1048 27.4402C54.9461 27.6422 54.7241 27.7848 54.4746 27.845C52.3877 28.3664 50.2188 28.4705 48.0917 28.1515C45.9646 27.8325 43.9212 27.0965 42.0783 25.9857C40.2354 24.8748 38.6291 23.411 37.3514 21.6777C36.0737 19.9445 35.1495 17.976 34.6318 15.8846C34.6115 15.7933 34.6012 15.6999 34.6011 15.6063C34.6016 15.4098 34.6507 15.2165 34.7442 15.0438C34.8376 14.871 34.9723 14.7242 35.1363 14.6165C37.4314 23.174 46.025 28.3501 54.5064 26.1951C54.7602 26.1296 54.9825 25.9762 55.1342 25.7622C55.196 25.989 55.2578 26.2158 55.3195 26.453C55.3396 26.5444 55.3496 26.6378 55.3495 26.7314Z", fill: t.palette.primary[700] }),
      /* @__PURE__ */ f.jsx("path", { d: "M56 98C73.1208 98 87 84.0957 87 66.944C87 49.7922 73.1208 35.8879 56 35.8879C38.8792 35.8879 25 49.7922 25 66.944C25 84.0957 38.8792 98 56 98Z", fill: t.palette.primary[300] }),
      /* @__PURE__ */ f.jsx("path", { d: "M79.0542 65.2645C78.0177 80.3837 65.1781 92.3014 50.0507 92.2659C49.9246 92.2659 49.7987 92.2648 49.6731 92.2628C47.0478 92.2298 44.4556 91.6717 42.0485 90.6213C39.6415 89.5708 37.4682 88.0492 35.6562 86.1458C32.8739 83.1972 30.7659 79.677 29.4784 75.83C28.1909 71.9829 27.755 67.9012 28.2008 63.8683C29.6106 50.6555 40.4115 40.1148 53.6307 39.0242C59.9852 38.4771 66.3347 40.1311 71.6183 43.7099C71.6197 43.7099 71.621 43.7101 71.6222 43.7106C71.6235 43.7111 71.6246 43.7119 71.6255 43.7128C71.6265 43.7138 71.6272 43.7149 71.6277 43.7161C71.6282 43.7174 71.6284 43.7187 71.6284 43.72C74.2573 46.6206 76.271 50.0258 77.5474 53.7291C78.8238 57.4324 79.3364 61.3568 79.0542 65.2645Z", fill: t.palette.primary[200] }),
      /* @__PURE__ */ f.jsx("path", { d: "M33.22 45.8867C36.8676 41.9276 41.4806 38.9872 46.6057 37.3543C51.7308 35.7214 57.1917 35.4523 62.4521 36.5733C67.7124 37.6943 72.5912 40.1669 76.6091 43.7482C80.627 47.3295 83.6459 51.8963 85.3692 57C83.2962 58.3569 80.9101 59.1579 78.4395 59.3261C73.1847 59.6596 68.2894 57.2761 63.9455 54.5686C61.7852 53.2246 60.3281 51.5688 57.7124 51.7125C54.9763 51.8575 52.2958 52.5245 49.6066 53.0319C46.1144 53.6726 42.4198 54.068 39.0783 52.8597C36.0668 51.7671 33.4626 49.0235 33.22 45.8867ZM72.0013 81.6367C72.6685 79.2739 72.0572 76.3578 69.9488 75.1061C68.7833 74.4139 67.3622 74.3257 66.0077 74.3691C64.0352 74.4321 61.9968 74.7651 60.3647 75.8767C59.4264 76.5332 58.6663 77.4137 58.1531 78.4385C57.64 79.4634 57.3899 80.6002 57.4256 81.7462C57.4847 82.891 57.821 84.0043 58.4056 84.9898C58.9903 85.9752 59.8056 86.8033 60.7812 87.4025C65.7481 90.4003 70.6253 86.5081 72.0013 81.6367ZM25.0068 67.2298C26.6912 66.1788 28.6906 65.7542 30.6558 66.03C33.5906 66.5035 35.9902 68.5423 38.2132 70.5066C40.9459 72.9187 43.6776 75.3162 46.4104 77.7279C48.1227 79.2305 49.9059 80.8361 50.6928 82.9819C52.0012 86.5151 50.1774 90.6003 47.3054 93.0384C46.1931 93.9606 44.9932 94.7713 43.7229 95.4588C38.209 93.0754 33.5049 89.1388 30.1823 84.1274C26.8597 79.116 25.0617 73.2457 25.0068 67.2298Z", fill: t.palette.primary[600] }),
      /* @__PURE__ */ f.jsx("path", { d: "M85.3682 57.004C83.2948 58.3566 80.9104 59.1552 78.4419 59.3236C73.1826 59.6641 68.2939 57.272 63.9406 54.5706C61.7883 53.2198 60.3282 51.5703 57.7139 51.7145C54.9764 51.859 52.3003 52.529 49.6039 53.0342C46.115 53.6735 42.4205 54.0655 39.0753 52.8589C36.0703 51.7668 33.4663 49.0227 33.2192 45.889C33.281 45.8271 33.3324 45.7653 33.3942 45.7034C34.3823 47.8069 36.3892 49.5287 38.6225 50.3329C41.957 51.5495 45.6519 51.1474 49.1407 50.5082C51.8372 50.0041 54.5132 49.3321 57.2508 49.1884C59.865 49.0442 61.3263 50.7042 63.4878 52.0446C67.8308 54.7563 72.7194 57.1381 77.9787 56.7979H78.0506C80.8912 56.6019 82.8582 54.2203 82.9806 51.6425C83.9435 53.3502 84.7429 55.1454 85.3682 57.004ZM71.9991 81.6359C70.6295 86.5126 65.7518 90.4004 60.781 87.3995C60.0107 86.9292 59.3394 86.3128 58.8048 85.585C58.9596 85.7042 59.1211 85.8144 59.2887 85.9148C64.2595 88.9048 69.1381 85.0188 70.5068 80.1409C70.98 78.4809 70.8143 76.5424 69.9509 75.1093C72.0609 76.3567 72.668 79.2748 71.9991 81.6359ZM47.3088 93.0393C46.1958 93.9609 44.9963 94.7723 43.7272 95.4622C41.6888 94.584 39.7527 93.4846 37.9536 92.1835C40.259 93.3179 43.1612 92.9258 45.2402 91.1421L45.2712 91.1114C48.2661 88.5234 50.2934 84.3579 49.3982 80.7183C49.9422 81.4044 50.3794 82.1691 50.6948 82.9864C52.0029 86.5126 50.1802 90.5958 47.3088 93.0393Z", fill: t.palette.primary[700] })
    ] }),
    /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_9177_451", children: /* @__PURE__ */ f.jsx("rect", { width: "62", height: "84", fill: "white", transform: "translate(25 14)" }) }) })
  ] });
}, Hq = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs("svg", { width: e.width, height: e.height, viewBox: "0 0 112 112", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    e.backgroundShape,
    /* @__PURE__ */ f.jsx("path", { d: "M34.8374 65.6186L19.5067 60.2378L26.2254 53.5191L46.9216 53.5345L34.8374 65.6186ZM46.3817 77.1628L51.7624 92.4936L58.4812 85.7748L58.4658 65.0787L46.3817 77.1628ZM78.9583 44.5862C85.0157 38.5288 87.0421 32.6352 87.6737 28.7452C87.772 28.1428 87.7256 27.5255 87.5384 26.9445C87.3511 26.3634 87.0283 25.8353 86.5966 25.4036C86.165 24.972 85.6368 24.6492 85.0558 24.4619C84.4747 24.2746 83.8575 24.2282 83.255 24.3265C79.365 24.9582 73.4715 26.9846 67.414 33.042L78.9583 44.5862Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { d: "M67.4136 33.0419L78.9583 44.5866L69.4294 54.1156L57.8846 42.5708L67.4136 33.0419ZM50.933 49.5224L62.4778 61.0672L46.3817 77.1632L34.837 65.6185L50.933 49.5224Z", fill: t.palette.primary[200] }),
    /* @__PURE__ */ f.jsx("path", { d: "M44.0821 74.8636C44.0821 74.8636 41.9078 87.9628 25.4034 86.5961C24.0351 70.088 37.1359 67.9174 37.1359 67.9174L44.0821 74.8636Z", fill: t.palette.primary[600] }),
    /* @__PURE__ */ f.jsx("path", { d: "M69.4295 54.1145C67.6856 54.3921 66.0741 55.214 64.8255 56.4626C63.5768 57.7113 62.755 59.3227 62.4774 61.0666L50.9332 49.5224C52.6771 49.2448 54.2885 48.423 55.5372 47.1743C56.7858 45.9257 57.6077 44.3142 57.8853 42.5703L69.4295 54.1145Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { d: "M72.2578 37.886L74.114 39.7421L64.585 49.2711L62.7288 47.415L72.2578 37.886Z", fill: t.palette.primary[500] })
  ] });
}, Fq = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs("svg", { width: e.width, height: e.height, viewBox: "0 0 112 112", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    e.backgroundShape,
    /* @__PURE__ */ f.jsx("path", { d: "M30 30C30 27.7909 31.7909 26 34 26H78C80.2091 26 82 27.7909 82 30V82C82 84.2091 80.2091 86 78 86H34C31.7909 86 30 84.2091 30 82V30Z", fill: t.palette.primary[200] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M72.5604 43H39.4396C38.6478 43 38 42.3522 38 41.5605V41.4397C38 40.6478 38.6478 40 39.4396 40H72.5604C73.3522 40 74 40.6478 74 41.4397V41.5605C74 42.3522 73.3522 43 72.5604 43Z", fill: t.palette.primary[600] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M72.5604 51H39.4396C38.6478 51 38 50.3522 38 49.5605V49.4397C38 48.6478 38.6478 48 39.4396 48H72.5604C73.3522 48 74 48.6478 74 49.4397V49.5605C74 50.3522 73.3522 51 72.5604 51Z", fill: t.palette.primary[600] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M72.5604 59H39.4396C38.6478 59 38 58.3522 38 57.5605V57.4397C38 56.6478 38.6478 56 39.4396 56H72.5604C73.3522 56 74 56.6478 74 57.4397V57.5605C74 58.3522 73.3522 59 72.5604 59Z", fill: t.palette.primary[600] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M72.5604 67H39.4396C38.6478 67 38 66.3522 38 65.5605V65.4397C38 64.6478 38.6478 64 39.4396 64H72.5604C73.3522 64 74 64.6478 74 65.4397V65.5605C74 66.3522 73.3522 67 72.5604 67Z", fill: t.palette.primary[600] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M56.5604 75H39.4396C38.6478 75 38 74.3522 38 73.5605V73.4397C38 72.6478 38.6478 72 39.4396 72H56.5604C57.3522 72 58 72.6478 58 73.4397V73.5605C58 74.3522 57.3522 75 56.5604 75Z", fill: t.palette.primary[600] }),
    /* @__PURE__ */ f.jsx("path", { d: "M61 23C61 20.2386 58.7614 18 56 18C53.2386 18 51 20.2386 51 23H44.2526C43.0086 23 42 24.0102 42 25.2562V31H70V25.2562C70 24.0102 68.9915 23 67.7474 23H61Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M58 23C58 24.1045 57.1045 25 55.9999 25C54.8954 25 54 24.1045 54 23C54 21.8955 54.8954 21 55.9999 21C57.1045 21 58 21.8955 58 23Z", fill: t.palette.primary[500] })
  ] });
}, Nq = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs("svg", { width: e.width, height: e.height, viewBox: "0 0 112 112", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    e.backgroundShape,
    /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_9177_515)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M41.877 73.0648H15.3945C13.4529 73.0648 11.8789 71.4909 11.8789 69.5492V59.767C11.8789 54.9129 15.8139 50.9779 20.668 50.9779H36.6036C41.4576 50.9779 45.3927 54.9129 45.3927 59.767V69.5492C45.3927 71.4909 43.8184 73.0648 41.877 73.0648Z", fill: t.palette.primary[800] }),
      /* @__PURE__ */ f.jsx("path", { d: "M41.8771 52.7357C42.9807 54.2045 43.6349 56.0306 43.6349 58.0092V67.7914C43.6349 69.7331 42.061 71.307 40.1193 71.307H13.6368C13.1384 71.3068 12.6458 71.2001 12.1919 70.9941C12.7435 72.2144 13.9683 73.0648 15.3946 73.0648H41.8771C43.8188 73.0648 45.3928 71.4909 45.3928 69.5492V59.767C45.3928 56.8915 44.0115 54.3392 41.8771 52.7357Z", fill: t.palette.primary[900] }),
      /* @__PURE__ */ f.jsx("path", { d: "M28.6357 54.5301C34.1923 54.5301 38.6967 50.0256 38.6967 44.4691C38.6967 38.9126 34.1923 34.4081 28.6357 34.4081C23.0792 34.4081 18.5747 38.9126 18.5747 44.4691C18.5747 50.0256 23.0792 54.5301 28.6357 54.5301Z", fill: t.palette.primary[200] }),
      /* @__PURE__ */ f.jsx("path", { d: "M34.8147 36.5322C36.1936 38.2965 36.9415 40.4721 36.9388 42.7113C36.9388 48.2677 32.4342 52.7723 26.8778 52.7723C24.6386 52.775 22.463 52.0271 20.6987 50.6482C22.5399 53.0096 25.4093 54.5301 28.6356 54.5301C34.1921 54.5301 38.6966 50.0255 38.6966 44.4691C38.6966 41.2428 37.1761 38.3734 34.8147 36.5322Z", fill: t.palette.primary[300] }),
      /* @__PURE__ */ f.jsx("path", { d: "M96.6055 73.0648H70.123C68.1814 73.0648 66.6074 71.4909 66.6074 69.5492V59.767C66.6074 54.9129 70.5425 50.9779 75.3965 50.9779H91.3321C96.1861 50.9779 100.121 54.9129 100.121 59.767V69.5492C100.121 71.4909 98.5472 73.0648 96.6055 73.0648Z", fill: t.palette.primary[400] }),
      /* @__PURE__ */ f.jsx("path", { d: "M96.6056 52.7357C97.7092 54.2045 98.3635 56.0306 98.3635 58.0092V67.7914C98.3635 69.7331 96.7895 71.307 94.8478 71.307H68.3653C67.8669 71.3068 67.3743 71.2001 66.9204 70.9941C67.472 72.2144 68.6969 73.0648 70.1231 73.0648H96.6056C98.5473 73.0648 100.121 71.4909 100.121 69.5492V59.767C100.121 56.8915 98.7403 54.3392 96.6056 52.7357Z", fill: t.palette.primary[500] }),
      /* @__PURE__ */ f.jsx("path", { d: "M83.3642 54.5301C88.9208 54.5301 93.4253 50.0256 93.4253 44.4691C93.4253 38.9126 88.9208 34.4081 83.3642 34.4081C77.8077 34.4081 73.3032 38.9126 73.3032 44.4691C73.3032 50.0256 77.8077 54.5301 83.3642 54.5301Z", fill: t.palette.primary[200] }),
      /* @__PURE__ */ f.jsx("path", { d: "M89.5432 36.5322C90.9221 38.2965 91.67 40.4721 91.6673 42.7113C91.6673 48.2677 87.1628 52.7723 81.6063 52.7723C79.3671 52.775 77.1915 52.0271 75.4272 50.6482C77.2684 53.0096 80.1378 54.5301 83.3641 54.5301C88.9206 54.5301 93.4251 50.0255 93.4251 44.4691C93.4251 41.2428 91.9046 38.3734 89.5432 36.5322Z", fill: t.palette.primary[300] }),
      /* @__PURE__ */ f.jsx("path", { d: "M66.8411 54.3441H45.1589C36.5843 54.3441 29.6328 61.2956 29.6328 69.8705V80.416C29.6328 82.3577 31.2068 83.9316 33.1484 83.9316H78.8516C80.7932 83.9316 82.3672 82.3577 82.3672 80.416V69.8705C82.3672 61.2956 75.4157 54.3441 66.8411 54.3441Z", fill: t.palette.primary[600] }),
      /* @__PURE__ */ f.jsx("path", { d: "M76.903 58.0507C79.2124 60.7609 80.6095 64.2726 80.6095 68.1127V78.6582C80.6095 80.5999 79.0355 82.1738 77.0938 82.1738H31.3907C30.8923 82.1736 30.3997 82.0669 29.9458 81.8609C30.4974 83.0812 31.7222 83.9316 33.1485 83.9316H78.8517C80.7933 83.9316 82.3673 82.3577 82.3673 80.416V69.8705C82.3673 65.1353 80.2453 60.8983 76.903 58.0507Z", fill: t.palette.primary[700] }),
      /* @__PURE__ */ f.jsx("path", { d: "M55.9121 58.0742C63.9213 58.0742 70.4141 51.5815 70.4141 43.5723C70.4141 35.5631 63.9213 29.0703 55.9121 29.0703C47.9029 29.0703 41.4102 35.5631 41.4102 43.5723C41.4102 51.5815 47.9029 58.0742 55.9121 58.0742Z", fill: t.palette.primary[200] }),
      /* @__PURE__ */ f.jsx("path", { d: "M64.8028 32.0586C66.796 34.6089 67.877 37.7535 67.8732 40.9903C67.8732 49.0221 61.3619 55.5333 53.3302 55.5333C50.0934 55.5372 46.9487 54.4561 44.3984 52.4629C47.0598 55.8763 51.2075 58.0742 55.871 58.0742C63.9028 58.0742 70.4141 51.5629 70.4141 43.5312C70.4141 38.8677 68.2162 34.7199 64.8028 32.0586Z", fill: t.palette.primary[300] })
    ] }),
    /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_9177_515", children: /* @__PURE__ */ f.jsx("rect", { width: "90", height: "55", fill: "white", transform: "translate(11 29)" }) }) })
  ] });
}, $q = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs("svg", { width: e.width, height: e.height, viewBox: "0 0 112 112", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    e.backgroundShape,
    /* @__PURE__ */ f.jsx("path", { d: "M83.5741 23.2969H36.1888C33.1908 23.2969 30.7605 25.7347 30.7605 28.742V90.5573C30.7605 93.5645 33.1908 96.0024 36.1888 96.0024H83.5741C86.572 96.0024 89.0024 93.5645 89.0024 90.5573V28.742C89.0024 25.7347 86.572 23.2969 83.5741 23.2969Z", fill: t.palette.primary[400] }),
    /* @__PURE__ */ f.jsx("path", { d: "M78.3133 17.8873H30.9281C27.9301 17.8873 25.4998 20.3251 25.4998 23.3324V85.1477C25.4998 88.1549 27.9301 90.5928 30.9281 90.5928H78.3133C81.3113 90.5928 83.7417 88.1549 83.7417 85.1477V23.3324C83.7417 20.3251 81.3113 17.8873 78.3133 17.8873Z", fill: t.palette.primary[200] }),
    /* @__PURE__ */ f.jsx("path", { d: "M70.856 36.1937C71.5101 36.1937 72.0403 35.6619 72.0403 35.0058C72.0403 34.3497 71.5101 33.8179 70.856 33.8179H56.9231C56.269 33.8179 55.7388 34.3497 55.7388 35.0058C55.7388 35.6619 56.269 36.1937 56.9231 36.1937H70.856Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M70.856 42.2186C71.5101 42.2186 72.0403 41.6868 72.0403 41.0307C72.0403 40.3746 71.5101 39.8428 70.856 39.8428H56.9231C56.269 39.8428 55.7388 40.3746 55.7388 41.0307C55.7388 41.6868 56.269 42.2186 56.9231 42.2186H70.856Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M41.6925 45.6902C46.0781 45.6902 49.6333 42.124 49.6333 37.7249C49.6333 33.3257 46.0781 29.7595 41.6925 29.7595C37.3069 29.7595 33.7517 33.3257 33.7517 37.7249C33.7517 42.124 37.3069 45.6902 41.6925 45.6902Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { d: "M40.4492 41.5442C40.2416 41.5442 40.0317 41.4638 39.8736 41.3052L37.5003 38.9246C37.1819 38.6051 37.1819 38.0893 37.5003 37.7698C37.8188 37.4503 38.3331 37.4503 38.6516 37.7698L40.4492 39.573L45.4246 34.5823C45.7431 34.2628 46.2574 34.2628 46.5759 34.5823C46.8943 34.9017 46.8943 35.4176 46.5759 35.7371L41.0249 41.3052C40.8668 41.4638 40.6568 41.5442 40.4492 41.5442Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M70.8582 55.1156C71.5123 55.1156 72.0425 54.5837 72.0425 53.9276C72.0425 53.2715 71.5123 52.7397 70.8582 52.7397H56.9253C56.2712 52.7397 55.741 53.2715 55.741 53.9276C55.741 54.5837 56.2712 55.1156 56.9253 55.1156H70.8582Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M70.8582 61.1405C71.5123 61.1405 72.0425 60.6086 72.0425 59.9525C72.0425 59.2964 71.5123 58.7646 70.8582 58.7646H56.9253C56.2712 58.7646 55.741 59.2964 55.741 59.9525C55.741 60.6086 56.2712 61.1405 56.9253 61.1405H70.8582Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M41.6925 64.6096C46.0781 64.6096 49.6333 61.0434 49.6333 56.6443C49.6333 52.2452 46.0781 48.679 41.6925 48.679C37.3069 48.679 33.7517 52.2452 33.7517 56.6443C33.7517 61.0434 37.3069 64.6096 41.6925 64.6096Z", fill: t.palette.primary[700] }),
    /* @__PURE__ */ f.jsx("ellipse", { cx: "42.0307", cy: "75.3164", rx: "6.55385", ry: "6.53165", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M70.856 74.035C71.5101 74.035 72.0403 73.5031 72.0403 72.8471C72.0403 72.191 71.5101 71.6591 70.856 71.6591H56.9231C56.269 71.6591 55.7388 72.191 55.7388 72.8471C55.7388 73.5031 56.269 74.035 56.9231 74.035H70.856Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M70.8584 80.0623C71.5125 80.0623 72.0427 79.5304 72.0427 78.8743C72.0427 78.2183 71.5125 77.6864 70.8584 77.6864H56.9255C56.2714 77.6864 55.7412 78.2183 55.7412 78.8743C55.7412 79.5304 56.2714 80.0623 56.9255 80.0623H70.8584Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M41.6925 69.7305C44.9009 69.7305 47.5101 72.3477 47.5101 75.566C47.5101 78.7844 44.9009 81.4016 41.6925 81.4016C38.4841 81.4016 35.8749 78.7844 35.8749 75.566C35.8749 72.3477 38.4841 69.7305 41.6925 69.7305ZM41.6925 67.6007C37.3069 67.6007 33.7517 71.1669 33.7517 75.566C33.7517 79.9652 37.3069 83.5314 41.6925 83.5314C46.0781 83.5314 49.6333 79.9652 49.6333 75.566C49.6333 71.1669 46.0781 67.6007 41.6925 67.6007Z", fill: t.palette.primary[600] }),
    /* @__PURE__ */ f.jsx("path", { d: "M63.2408 13.5472V21.3422H46.0027V13.5472H51.0866C51.0866 11.5879 52.6719 10 54.6229 10C56.5739 10 58.1569 11.5879 58.1569 13.5472H63.2408Z", fill: t.palette.primary[400] }),
    /* @__PURE__ */ f.jsx("path", { d: "M46.038 55.6504H42.6834V52.2853C42.6834 51.7363 42.2398 51.2891 41.6902 51.2891C41.1405 51.2891 40.697 51.7339 40.697 52.2853V55.6504H37.3423C36.795 55.6504 36.3491 56.0952 36.3491 56.6466C36.3491 57.198 36.7926 57.6429 37.3423 57.6429H40.697V61.0079C40.697 61.5569 41.1405 62.0042 41.6902 62.0042C42.2398 62.0042 42.6834 61.5593 42.6834 61.0079V57.6429H46.038C46.5853 57.6429 47.0312 57.198 47.0312 56.6466C47.0312 56.0952 46.5877 55.6504 46.038 55.6504Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M26.0676 75.7789L37.634 57.9229C37.8615 57.5715 37.861 57.1163 37.629 56.7679C37.3971 56.4196 36.982 56.2408 36.5707 56.3165L15.8877 60.0492C15.4896 60.1212 15.1684 60.4142 15.06 60.8042C14.9493 61.1935 15.0752 61.6128 15.3775 61.8777L19.4944 65.4905L11.0232 71.1356C10.5389 71.4587 10.4069 72.1126 10.7261 72.5938L12.6592 75.5135C12.9801 75.9976 13.6298 76.1271 14.1134 75.8062L18.5762 72.8314L22.5824 70.1604L24.1773 75.5106C24.2939 75.9026 24.6286 76.1915 25.0339 76.2494C25.4391 76.3073 25.8421 76.1235 26.0653 75.7782L26.0676 75.7789Z", fill: t.palette.primary[500] })
  ] });
}, Bq = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs("svg", { width: e.width, height: e.height, viewBox: "0 0 112 112", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    e.backgroundShape,
    /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_6928_3670)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M80.5413 22.0267H31.4587C28.9962 22.0267 27 24.0181 27 26.4745V68.5523C27 71.0087 28.9962 73 31.4587 73H80.5413C83.0038 73 85 71.0087 85 68.5523V26.4745C85 24.0181 83.0038 22.0267 80.5413 22.0267Z", fill: t.palette.primary[200] }),
      /* @__PURE__ */ f.jsx("path", { d: "M85 35.1407H27V37.0689H85V35.1407Z", fill: t.palette.primary[50] }),
      /* @__PURE__ */ f.jsx("path", { d: "M40.8959 16H39.139C37.7263 16 36.5811 17.1424 36.5811 18.5517V25.5018C36.5811 26.911 37.7263 28.0534 39.139 28.0534H40.8959C42.3086 28.0534 43.4539 26.911 43.4539 25.5018V18.5517C43.4539 17.1424 42.3086 16 40.8959 16Z", fill: t.palette.primary[800] }),
      /* @__PURE__ */ f.jsx("path", { d: "M71.1063 28.0535H72.8632C74.2759 28.0535 75.4211 26.911 75.4211 25.5018V18.5517C75.4211 17.1424 74.2759 16 72.8632 16H71.1063C69.6936 16 68.5483 17.1424 68.5483 18.5517V25.5018C68.5483 26.911 69.6936 28.0535 71.1063 28.0535Z", fill: t.palette.primary[800] }),
      /* @__PURE__ */ f.jsx("path", { d: "M66.926 52.5433L50.2119 42.3054C48.7798 41.4377 47 42.5223 47 44.2575V64.7334C47 66.4687 48.7798 67.5749 50.2119 66.6856L66.926 56.4476C68.358 55.58 68.358 53.3893 66.926 52.5216V52.5433Z", fill: t.palette.primary[800] })
    ] }),
    /* @__PURE__ */ f.jsx("path", { d: "M47.485 70.9182C48.396 69.0223 50.6683 68.2249 52.5643 69.1359C53.4973 69.5842 54.182 70.3947 54.4802 71.3159C54.823 72.2215 54.7949 73.2822 54.3467 74.2152L53.5224 75.9306C53.9707 74.9977 54.7813 74.3129 55.7025 74.0146C56.608 73.6718 57.6688 73.6999 58.6017 74.1482C59.5347 74.5965 60.2194 75.4071 60.5177 76.3283C60.8605 77.2338 60.8323 78.2946 60.3841 79.2275L59.5599 80.9429C60.0081 80.01 60.8187 79.3252 61.7399 79.027C62.6455 78.6842 63.7062 78.7123 64.6391 79.1605C66.5351 80.0715 67.3325 82.3439 66.4215 84.2398L60.6519 96.2477C57.702 102.387 50.2301 104.909 43.9402 101.887L35.2729 97.7223C31.0295 95.6834 27.7331 92.1362 26.007 87.7878C25.2612 85.9478 24.5155 84.1078 24.021 83.0552C20.9184 76.6378 17.3921 72.7209 15.6227 71.3151C17.7562 68.3396 21.0999 68.2422 23.3871 69.3411C23.9589 69.6159 24.5475 70.0098 25.0626 70.4796C27.1545 72.4478 27.224 73.0739 28.9618 75.3165C31.2639 78.3118 35.8261 77.8368 37.4167 74.5264L48.9415 50.5407C49.8525 48.6447 52.1248 47.8474 54.0208 48.7583C54.9537 49.2066 55.6385 50.0172 55.9367 50.9384C56.2795 51.8439 56.2514 52.9047 55.8031 53.8376L47.5753 70.9616L47.485 70.9182Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_6928_3670", children: /* @__PURE__ */ f.jsx("rect", { width: "58", height: "57", fill: "white", transform: "translate(27 16)" }) }) })
  ] });
}, zq = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs("svg", { width: e.width, height: e.height, viewBox: "0 0 112 112", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    e.backgroundShape,
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M90 59.5577C90 39.0935 74.7776 24.9039 56 24.9039C37.2224 24.9039 22 38.5411 22 59.5577C22 65.2158 23.4674 72.7126 28.8329 79.5951C29.544 80.5073 30.6551 81 31.8117 81H80.2702C81.4229 81 82.5317 80.5114 83.2366 79.5993C87.8522 73.6274 90 66.1794 90 59.5577Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M86.7138 58.9257C86.7138 41.963 72.9627 28.212 56 28.212C39.0372 28.212 25.2861 41.963 25.2861 58.9257C25.2861 66.054 27.7147 72.6147 31.7892 77.8266H80.2107C84.2852 72.6147 86.7138 66.054 86.7138 58.9257Z", fill: "#E4EBF7" }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M86.7138 58.9257C86.7138 41.963 72.9627 28.212 56 28.212C39.0372 28.212 25.2861 41.963 25.2861 58.9257C25.2861 66.054 27.7147 72.6147 31.7892 77.8266H80.2107C84.2852 72.6147 86.7138 66.054 86.7138 58.9257Z", fill: t.palette.primary[200] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M56.0264 37.0369C55.3042 37.0369 54.7188 36.4514 54.7188 35.7292V33.1138C54.7188 32.3917 55.3042 31.8062 56.0264 31.8062C56.7487 31.8062 57.3341 32.3917 57.3341 33.1138V35.7292C57.3341 36.4514 56.7487 37.0369 56.0264 37.0369Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M38.925 44.096C38.4143 44.6067 37.5863 44.6067 37.0757 44.096L35.2263 42.2467C34.7156 41.7359 34.7156 40.908 35.2263 40.3973C35.737 39.8866 36.5649 39.8866 37.0757 40.3973L38.925 42.2467C39.4356 42.7573 39.4356 43.5853 38.925 44.096Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M32.8687 59.5577C32.8687 60.2799 32.2833 60.8654 31.561 60.8654H28.9456C28.2234 60.8654 27.6379 60.2799 27.6379 59.5577C27.6379 58.8355 28.2234 58.25 28.9456 58.25H31.561C32.2833 58.25 32.8687 58.8355 32.8687 59.5577Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M79.1313 59.5577C79.1313 58.8355 79.7168 58.25 80.439 58.25H83.0544C83.7766 58.25 84.3621 58.8355 84.3621 59.5577C84.3621 60.2799 83.7766 60.8654 83.0544 60.8654H80.439C79.7168 60.8654 79.1313 60.2799 79.1313 59.5577Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M73.0751 42.2467L74.9245 40.3973C75.4352 39.8866 76.2631 39.8866 76.7739 40.3973C77.2845 40.908 77.2845 41.7359 76.7739 42.2467L74.9245 44.096C74.4138 44.6067 73.5858 44.6067 73.0751 44.096C72.5645 43.5853 72.5645 42.7573 73.0751 42.2467Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { d: "M58.191 62.2056C59.9856 63.0345 61.2308 64.8503 61.2308 66.9568C61.2308 69.8457 58.8889 72.1876 56.0001 72.1876C53.1112 72.1876 50.7693 69.8457 50.7693 66.9568C50.7693 64.8086 52.0643 62.9628 53.9163 62.1576L55.5272 48.4303C55.5668 48.0475 56.1202 48.0358 56.1758 48.4167L58.191 62.2056Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M58.6155 66.9568C58.6155 68.4012 57.4446 69.5721 56.0002 69.5721C54.5557 69.5721 53.3848 68.4012 53.3848 66.9568C53.3848 65.5123 54.5557 64.3414 56.0002 64.3414C57.4446 64.3414 58.6155 65.5123 58.6155 66.9568Z", fill: t.palette.primary[500] })
  ] });
}, Zq = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs("svg", { width: e.width, height: e.height, viewBox: "0 0 112 112", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    e.backgroundShape,
    /* @__PURE__ */ f.jsx("path", { d: "M19 25C19 22.7909 20.7909 21 23 21H58L71 35V83C71 85.2091 69.2091 87 67 87H23C20.7909 87 19 85.2091 19 83V25Z", fill: t.palette.primary[200] }),
    /* @__PURE__ */ f.jsx("path", { d: "M71 35L58 21V35H71Z", fill: t.palette.primary[400] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M62.5604 44H40.4396C39.6478 44 39 43.3522 39 42.5605V42.4397C39 41.6478 39.6478 41 40.4396 41H62.5604C63.3522 41 64 41.6478 64 42.4397V42.5605C64 43.3522 63.3522 44 62.5604 44Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M62.5604 55H40.4396C39.6478 55 39 54.3522 39 53.5605V53.4397C39 52.6478 39.6478 52 40.4396 52H62.5604C63.3522 52 64 52.6478 64 53.4397V53.5605C64 54.3522 63.3522 55 62.5604 55Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M62.5604 66H40.4396C39.6478 66 39 65.3522 39 64.5605V64.4397C39 63.6478 39.6478 63 40.4396 63H62.5604C63.3522 63 64 63.6478 64 64.4397V64.5605C64 65.3522 63.3522 66 62.5604 66Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M62.5604 77H40.4396C39.6478 77 39 76.3522 39 75.5605V75.4397C39 74.6478 39.6478 74 40.4396 74H62.5604C63.3522 74 64 74.6478 64 75.4397V75.5605C64 76.3522 63.3522 77 62.5604 77Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M29.87 44.57L33.0425 41.3975L32.4125 40.7675L29.87 43.31L28.5875 42.0275L27.9575 42.6575L29.87 44.57ZM30.5 47C29.8775 47 29.2925 46.8819 28.745 46.6456C28.1975 46.4094 27.7212 46.0887 27.3162 45.6838C26.9112 45.2787 26.5906 44.8025 26.3544 44.255C26.1181 43.7075 26 43.1225 26 42.5C26 41.8775 26.1181 41.2925 26.3544 40.745C26.5906 40.1975 26.9112 39.7212 27.3162 39.3162C27.7212 38.9112 28.1975 38.5906 28.745 38.3544C29.2925 38.1181 29.8775 38 30.5 38C31.1225 38 31.7075 38.1181 32.255 38.3544C32.8025 38.5906 33.2787 38.9112 33.6838 39.3162C34.0887 39.7212 34.4094 40.1975 34.6456 40.745C34.8819 41.2925 35 41.8775 35 42.5C35 43.1225 34.8819 43.7075 34.6456 44.255C34.4094 44.8025 34.0887 45.2787 33.6838 45.6838C33.2787 46.0887 32.8025 46.4094 32.255 46.6456C31.7075 46.8819 31.1225 47 30.5 47Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { d: "M29.87 55.57L33.0425 52.3975L32.4125 51.7675L29.87 54.31L28.5875 53.0275L27.9575 53.6575L29.87 55.57ZM30.5 58C29.8775 58 29.2925 57.8819 28.745 57.6456C28.1975 57.4094 27.7212 57.0887 27.3162 56.6838C26.9112 56.2787 26.5906 55.8025 26.3544 55.255C26.1181 54.7075 26 54.1225 26 53.5C26 52.8775 26.1181 52.2925 26.3544 51.745C26.5906 51.1975 26.9112 50.7212 27.3162 50.3162C27.7212 49.9112 28.1975 49.5906 28.745 49.3544C29.2925 49.1181 29.8775 49 30.5 49C31.1225 49 31.7075 49.1181 32.255 49.3544C32.8025 49.5906 33.2787 49.9112 33.6838 50.3162C34.0887 50.7212 34.4094 51.1975 34.6456 51.745C34.8819 52.2925 35 52.8775 35 53.5C35 54.1225 34.8819 54.7075 34.6456 55.255C34.4094 55.8025 34.0887 56.2787 33.6838 56.6838C33.2787 57.0887 32.8025 57.4094 32.255 57.6456C31.7075 57.8819 31.1225 58 30.5 58Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { d: "M29.87 66.57L33.0425 63.3975L32.4125 62.7675L29.87 65.31L28.5875 64.0275L27.9575 64.6575L29.87 66.57ZM30.5 69C29.8775 69 29.2925 68.8819 28.745 68.6456C28.1975 68.4094 27.7212 68.0887 27.3162 67.6838C26.9112 67.2787 26.5906 66.8025 26.3544 66.255C26.1181 65.7075 26 65.1225 26 64.5C26 63.8775 26.1181 63.2925 26.3544 62.745C26.5906 62.1975 26.9112 61.7212 27.3162 61.3162C27.7212 60.9112 28.1975 60.5906 28.745 60.3544C29.2925 60.1181 29.8775 60 30.5 60C31.1225 60 31.7075 60.1181 32.255 60.3544C32.8025 60.5906 33.2787 60.9112 33.6838 61.3162C34.0887 61.7212 34.4094 62.1975 34.6456 62.745C34.8819 63.2925 35 63.8775 35 64.5C35 65.1225 34.8819 65.7075 34.6456 66.255C34.4094 66.8025 34.0887 67.2787 33.6838 67.6838C33.2787 68.0887 32.8025 68.4094 32.255 68.6456C31.7075 68.8819 31.1225 69 30.5 69Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { d: "M29.87 77.57L33.0425 74.3975L32.4125 73.7675L29.87 76.31L28.5875 75.0275L27.9575 75.6575L29.87 77.57ZM30.5 80C29.8775 80 29.2925 79.8819 28.745 79.6456C28.1975 79.4094 27.7212 79.0887 27.3162 78.6838C26.9112 78.2787 26.5906 77.8025 26.3544 77.255C26.1181 76.7075 26 76.1225 26 75.5C26 74.8775 26.1181 74.2925 26.3544 73.745C26.5906 73.1975 26.9112 72.7212 27.3162 72.3162C27.7212 71.9112 28.1975 71.5906 28.745 71.3544C29.2925 71.1181 29.8775 71 30.5 71C31.1225 71 31.7075 71.1181 32.255 71.3544C32.8025 71.5906 33.2787 71.9112 33.6838 72.3162C34.0887 72.7212 34.4094 73.1975 34.6456 73.745C34.8819 74.2925 35 74.8775 35 75.5C35 76.1225 34.8819 76.7075 34.6456 77.255C34.4094 77.8025 34.0887 78.2787 33.6838 78.6838C33.2787 79.0887 32.8025 79.4094 32.255 79.6456C31.7075 79.8819 31.1225 80 30.5 80Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { d: "M79.0183 84.2922C91.4475 84.2922 101.523 74.2163 101.523 61.7871C101.523 49.3579 91.4475 39.282 79.0183 39.282C66.589 39.282 56.5132 49.3579 56.5132 61.7871C56.5132 74.2163 66.589 84.2922 79.0183 84.2922Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { d: "M79.0062 79.3897C88.6069 79.3897 96.3899 71.6068 96.3899 62.0061C96.3899 52.4054 88.6069 44.6224 79.0062 44.6224C69.4055 44.6224 61.6226 52.4054 61.6226 62.0061C61.6226 71.6068 69.4055 79.3897 79.0062 79.3897Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M79.0062 73.2586C85.2208 73.2586 90.2587 68.2207 90.2587 62.0061C90.2587 55.7915 85.2208 50.7535 79.0062 50.7535C72.7916 50.7535 67.7537 55.7915 67.7537 62.0061C67.7537 68.2207 72.7916 73.2586 79.0062 73.2586Z", fill: t.palette.primary[500] }),
    /* @__PURE__ */ f.jsx("path", { d: "M79.006 67.1153C81.8278 67.1153 84.1152 64.8278 84.1152 62.0061C84.1152 59.1843 81.8278 56.8968 79.006 56.8968C76.1842 56.8968 73.8967 59.1843 73.8967 62.0061C73.8967 64.8278 76.1842 67.1153 79.006 67.1153Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M98.6524 42.3476V35.4136L94.7231 39.3429V46.2769H101.657L105.599 42.3476H98.6524Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { d: "M92.1077 48.8923V41.9583L88.1785 45.8876V52.8216H95.1125L99.0417 48.8923H92.1077Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { d: "M79.006 62.4075C78.8965 62.4075 78.7992 62.371 78.7141 62.2859C78.5559 62.1277 78.5559 61.8723 78.7141 61.702L102.034 38.394C102.192 38.2359 102.448 38.2359 102.618 38.394C102.776 38.5521 102.776 38.8076 102.618 38.9779L79.298 62.298C79.2128 62.3832 79.1155 62.4197 79.006 62.4197V62.4075Z", fill: t.palette.primary[800] })
  ] });
}, Wq = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs("svg", { width: e.width, height: e.height, viewBox: "0 0 112 112", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    e.backgroundShape,
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M42.6779 51.0369C39.2407 51.0369 36.4543 48.2354 36.4543 44.7795C36.4543 41.3237 39.2407 38.5221 42.6779 38.5221C46.115 38.5221 48.9014 41.3237 48.9014 44.7795C48.9014 48.2354 46.115 51.0369 42.6779 51.0369ZM61.3557 47.6101V41.9489L56.9181 40.8152C56.5927 39.6306 56.125 38.5055 55.5346 37.4595L57.8757 33.5019L53.8944 29.4989L49.9582 31.8527C48.9178 31.2591 47.7988 30.789 46.6207 30.4617L45.4931 26H39.8626L38.735 30.4617C37.5568 30.789 36.4378 31.2591 35.3975 31.8527L31.4613 29.4989L27.4799 33.5019L29.821 37.4595C29.2307 38.5055 28.763 39.6307 28.4376 40.8152L24 41.9489V47.6101L28.4376 48.7438C28.763 49.9283 29.2307 51.0535 29.821 52.0995L27.4799 56.0571L31.4613 60.0602L35.3975 57.7063C36.4378 58.2999 37.5568 58.7701 38.735 59.0973L39.8626 63.5591H45.4931L46.6207 59.0973C47.7988 58.7701 48.9178 58.2999 49.9582 57.7063L53.8944 60.0602L57.8757 56.0571L55.5346 52.0995C56.125 51.0535 56.5927 49.9283 56.9181 48.7438L61.3557 47.6101Z", fill: t.palette.primary[700] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M70.6474 74.3663C67.4542 74.3663 64.8655 71.7636 64.8655 68.5529C64.8655 65.3423 67.4542 62.7395 70.6474 62.7395C73.8407 62.7395 76.4294 65.3423 76.4294 68.5529C76.4294 71.7636 73.8407 74.3663 70.6474 74.3663ZM88 71.1826V65.9232L83.8773 64.8699C83.5749 63.7694 83.1405 62.7241 82.592 61.7524L84.767 58.0756L81.0681 54.3565L77.4113 56.5434C76.4447 55.9919 75.405 55.5551 74.3105 55.2511L73.2629 51.106H68.0319L66.9844 55.2511C65.8898 55.5551 64.8502 55.9919 63.8836 56.5434L60.2268 54.3565L56.5279 58.0756L58.7029 61.7524C58.1543 62.7241 57.72 63.7694 57.4176 64.8699L53.2949 65.9232V71.1826L57.4176 72.236C57.72 73.3365 58.1543 74.3817 58.7029 75.3536L56.5279 79.0304L60.2268 82.7493L63.8836 80.5625C64.8502 81.114 65.8898 81.5508 66.9844 81.8548L68.0319 86H73.2629L74.3105 81.8548C75.405 81.5508 76.4447 81.114 77.4113 80.5625L81.0681 82.7493L84.767 79.0304L82.592 75.3536C83.1405 74.3817 83.5749 73.3365 83.8773 72.236L88 71.1826Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M72.5198 43.0874L65.6617 41.7562L72.9167 33.4841C72.2699 33.38 71.6068 33.3251 70.9308 33.3251C64.0463 33.3251 58.4653 38.9365 58.4653 45.8585C58.4653 52.7805 64.0463 58.3918 70.9308 58.3918C77.8153 58.3918 83.3963 52.7805 83.3963 45.8585C83.3963 45.3712 83.3677 44.8908 83.3139 44.418L72.5198 43.0874Z", fill: t.palette.primary[600] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M72.5199 43.0873L59.6211 40.5836C58.88 42.187 58.4654 43.9738 58.4654 45.8583C58.4654 47.5549 58.8014 49.1723 59.409 50.6482L31.7454 76.451C30.0588 81.7925 35.1475 86.7844 40.4169 84.9575L40.7845 84.83L66.2582 57.4804C67.7013 58.0676 69.2784 58.3917 70.9309 58.3917C77.8154 58.3917 83.3964 52.7803 83.3964 45.8583C83.3964 42.0987 81.7496 38.7262 79.1421 36.429L72.5199 43.0873Z", fill: t.palette.primary[200] }),
    /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M59.3846 60.0929L56.6724 57.3659L59.3846 54.6389L62.0969 57.3659L59.3846 60.0929Z", fill: t.palette.primary[600] })
  ] });
}, Uq = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs("svg", { width: e.width, height: e.height, viewBox: "0 0 112 112", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    e.backgroundShape,
    /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_6702_10521)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M40.4622 10.2194C40.5778 8.09803 42.0048 7.37378 43.3307 7.55973C44.6623 7.69186 45.1385 8.79455 45.1648 10.9184C45.1955 13.3387 43.131 13.065 43.131 13.065C40.5632 13.5854 40.4622 10.2194 40.4622 10.2194Z", fill: t.palette.primary[200] }),
      /* @__PURE__ */ f.jsx("path", { d: "M39.9052 10.0375C38.6246 9.12567 39.8895 5.30581 40.4627 5.7915C40.812 6.08838 40.2796 7.87331 40.7675 6.68906C41.5259 4.84663 43.5265 3.72028 43.5265 4.44127C43.5265 5.02647 42.5474 6.39015 42.5474 6.39015C44.0274 4.3956 45.1665 3.90012 45.7074 4.11911C46.6396 4.49918 44.2392 7.72243 44.9155 7.08259C45.3675 6.65562 46.4108 6.20215 46.5729 6.42236C46.8846 6.85014 45.3675 10.0485 44.8706 10.0379C43.9146 8.9446 42.6626 7.52954 39.9052 10.0379V10.0375Z", fill: t.palette.primary[500] }),
      /* @__PURE__ */ f.jsx("path", { d: "M29.9985 14.247L30.5451 43.1563C30.5451 43.1563 53.042 41.9998 59.7376 43.1563L56.2562 14.2319L29.9985 14.247Z", fill: t.palette.primary[700] }),
      /* @__PURE__ */ f.jsx("path", { d: "M62.8848 10.0374C62.8848 10.0374 57.5014 7.67138 54.3689 7.11963C54.3689 7.11963 57.7327 8.98898 57.957 13.2378L62.4531 18.4626L62.8848 10.0374Z", fill: t.palette.primary[200] }),
      /* @__PURE__ */ f.jsx("path", { d: "M23.7837 10.8127C23.7837 10.8127 28.7374 7.67138 31.8671 7.11963C31.8671 7.11963 28.5033 8.98898 28.279 13.2378L23.7837 18.4626V10.8123V10.8127Z", fill: t.palette.primary[200] }),
      /* @__PURE__ */ f.jsx("path", { d: "M63.9229 78.8952L59.5327 87.3318L60.6319 88.4125H56.7927L59.3286 75.9175L63.9229 78.8952Z", fill: t.palette.primary[200] }),
      /* @__PURE__ */ f.jsx("path", { d: "M32.8154 87.073L33.9146 95.848L32.8154 96.9283H36.655L37.4097 84.0952L32.8154 87.073Z", fill: t.palette.primary[200] }),
      /* @__PURE__ */ f.jsx("path", { d: "M26.7295 47.4747C26.7295 47.4747 24.1217 65.0493 28.2713 89.0939C28.2713 89.0939 35.3663 89.2293 42.5971 87.6075C42.5971 87.6075 38.7143 60.3208 46.3182 57.5996C53.0159 55.203 59.6739 58.1595 59.6739 63.0225C59.6739 67.0377 55.6952 78.963 55.6952 78.963C55.6952 78.963 66.7187 79.3679 70.6092 81.3943C71.8256 77.7135 73.2478 74.1053 74.8688 70.5872C77.4564 64.964 81.4537 55.8636 76.7438 51.5405C73.0311 48.1325 62.6754 43.8873 56.3897 43.6382V40.835L28.7378 42.2394L26.7295 47.4747Z", fill: t.palette.primary[500] }),
      /* @__PURE__ */ f.jsx("path", { d: "M31.867 14.2552L25.4956 16.8182C25.4956 16.8182 24.2521 12.7712 23.7836 10.8154C23.7836 10.8154 -0.253121 23.3781 4.09864 34.1848C8.44999 44.9911 26.7298 34.1848 26.7298 34.1848C26.7298 34.1848 27.0512 41.4563 25.8016 47.4701C25.781 47.5684 25.7972 47.6707 25.8477 47.7576C25.8978 47.8444 25.9787 47.9089 26.0737 47.9386C27.9907 48.5361 37.7662 52.0162 39.2175 48.0981C41.5864 41.7062 37.0928 30.3352 36.8918 19.5281C36.8918 19.5252 33.2762 15.2698 31.8674 14.2556L31.867 14.2552Z", fill: t.palette.primary[300] }),
      /* @__PURE__ */ f.jsx("path", { d: "M34.622 47.5857C32.7584 47.5857 30.2484 46.7603 27.9648 46.0095C27.3289 45.7999 26.7278 45.6025 26.1456 45.4231C26.1169 45.4141 26.0931 45.3941 26.0789 45.3676C26.0648 45.3407 26.062 45.3093 26.0704 45.2808C26.0793 45.2518 26.0992 45.2274 26.1258 45.2135C26.1521 45.1992 26.1832 45.196 26.2119 45.2049C26.7957 45.3852 27.3976 45.585 28.0347 45.7926C30.305 46.5392 32.802 47.3597 34.6195 47.3597C35.2295 47.3597 35.7624 47.268 36.1856 47.049C37.0495 46.6008 37.4275 44.9313 37.3094 42.0849C37.1918 39.2837 36.6012 35.8863 36.1258 33.5292C34.535 25.6403 34.4522 20.323 34.4522 20.2696C34.4522 20.2545 34.455 20.2399 34.4603 20.226C34.4659 20.2121 34.474 20.1995 34.4841 20.1885C34.4946 20.1779 34.5072 20.1693 34.5205 20.1632C34.5342 20.1571 34.5488 20.1542 34.5637 20.1538C34.5937 20.1538 34.622 20.1656 34.643 20.1868C34.6644 20.208 34.6765 20.2366 34.6769 20.2664C34.6769 20.3186 34.7618 25.6171 36.3481 33.4876C37.4925 39.1613 38.4106 46.1559 36.2895 47.2545C35.8343 47.4866 35.2663 47.5853 34.622 47.5853V47.5857Z", fill: "white" }),
      /* @__PURE__ */ f.jsx("path", { d: "M55.9882 14.2318L60.3772 16.7561C60.3772 16.7561 62.622 12.026 62.9433 10.0376C62.9433 10.0376 87.2356 20.589 83.6984 31.6934C80.1612 42.7977 61.1311 33.4037 61.1311 33.4037C61.1311 33.4037 61.0749 38.5501 62.7671 44.4522C62.7954 44.5484 62.7869 44.652 62.7432 44.7425C62.6992 44.8331 62.6236 44.9036 62.5306 44.9407C60.665 45.6813 53.9003 50.4334 51.1631 48.0286C47.4719 44.7862 49.5606 30.4806 46.8809 18.6842C46.8809 18.6842 55.5755 17.7034 55.9882 14.2322V14.2318Z", fill: t.palette.primary[300] }),
      /* @__PURE__ */ f.jsx("path", { d: "M54.0539 46.1906C53.7155 46.1971 53.3796 46.1355 53.0655 46.0087C51.2908 45.2489 51.1622 41.1298 51.0131 36.3548C50.9811 35.3398 50.9488 34.2897 50.8991 33.2486C50.4795 24.4862 49.065 19.0682 49.05 19.0144C49.046 19.0001 49.0452 18.985 49.0472 18.9699C49.0492 18.9553 49.0541 18.941 49.0614 18.9279C49.069 18.9149 49.0787 18.9035 49.0905 18.8945C49.1026 18.8855 49.1159 18.8786 49.1301 18.8749C49.1446 18.8713 49.1596 18.87 49.1741 18.8721C49.1891 18.8741 49.2032 18.879 49.2158 18.8863C49.2287 18.8937 49.24 18.9039 49.2489 18.9157C49.2582 18.9275 49.2647 18.941 49.2683 18.9557C49.2829 19.0087 50.7042 24.4479 51.1242 33.234C51.1748 34.2771 51.2071 35.328 51.2391 36.3446C51.3797 40.8451 51.5115 45.0968 53.1528 45.795C55.4615 46.7782 60.57 43.0762 62.0811 41.9197C62.1049 41.9025 62.1344 41.896 62.1635 41.9005C62.1922 41.905 62.2185 41.9205 62.2359 41.9441C62.2537 41.9678 62.2618 41.9972 62.2581 42.0265C62.2545 42.0559 62.2399 42.0828 62.2173 42.1011C60.4964 43.4187 56.5824 46.1901 54.0539 46.1901V46.1906Z", fill: "white" }),
      /* @__PURE__ */ f.jsx("path", { d: "M28.4937 14.7329C28.4812 14.9091 28.4747 15.0865 28.4739 15.2647C28.4739 19.4059 31.9391 22.7621 36.2165 22.7621C39.2649 22.7621 41.9019 21.0554 43.1643 18.5752C44.4224 21.0554 47.048 22.7621 50.0851 22.7621C54.3439 22.7621 57.7962 19.4059 57.7962 15.2647V15.1211L28.4937 14.7329Z", fill: t.palette.primary[900] }),
      /* @__PURE__ */ f.jsx("path", { d: "M35.7027 21.0827C39.8074 21.0827 43.1352 17.7261 43.1352 13.5853C43.1352 9.44449 39.8074 6.08789 35.7027 6.08789C31.5979 6.08789 28.2705 9.44449 28.2705 13.5853C28.2705 17.7261 31.5983 21.0827 35.7027 21.0827Z", fill: t.palette.primary[800] }),
      /* @__PURE__ */ f.jsx("path", { d: "M35.703 21.2537C34.1992 21.2537 32.7297 20.8039 31.4794 19.9614C30.2295 19.1189 29.2552 17.9212 28.68 16.52C28.1043 15.1188 27.9539 13.5769 28.247 12.0892C28.5405 10.6016 29.2645 9.23545 30.3277 8.16294C31.3909 7.09043 32.7451 6.36006 34.2198 6.0644C35.6945 5.76834 37.223 5.92045 38.612 6.50075C40.001 7.08105 41.1883 8.06425 42.0235 9.32517C42.8586 10.5861 43.3045 12.0688 43.3045 13.5854C43.3029 15.6187 42.5013 17.5684 41.0763 19.0059C39.6509 20.4438 37.7186 21.2521 35.703 21.2537ZM35.703 6.25974C34.2663 6.25974 32.8619 6.68875 31.6674 7.49374C30.4728 8.29874 29.5418 9.44261 28.9916 10.7814C28.4419 12.1202 28.2979 13.5936 28.5781 15.0148C28.8582 16.436 29.5499 17.7417 30.5654 18.7665C31.5813 19.7913 32.8753 20.4891 34.2845 20.7717C35.6933 21.0543 37.1535 20.9091 38.4806 20.3549C39.8078 19.8003 40.9421 18.8612 41.7405 17.6561C42.5385 16.4511 42.9642 15.0344 42.9642 13.5854C42.9617 11.6435 42.1961 9.7815 40.835 8.40803C39.4734 7.03456 37.628 6.26219 35.703 6.25974Z", fill: t.palette.primary[900] }),
      /* @__PURE__ */ f.jsx("path", { d: "M35.7026 18.4884C38.3872 18.4884 40.5633 16.2932 40.5633 13.585C40.5633 10.8768 38.3872 8.68164 35.7026 8.68164C33.018 8.68164 30.8423 10.8768 30.8423 13.585C30.8423 16.2932 33.0184 18.4884 35.7026 18.4884Z", fill: "white" }),
      /* @__PURE__ */ f.jsx("path", { d: "M50.5673 21.0827C54.6717 21.0827 57.9995 17.7261 57.9995 13.5853C57.9995 9.44449 54.6717 6.08789 50.5673 6.08789C46.463 6.08789 43.1348 9.44449 43.1348 13.5853C43.1348 17.7261 46.4626 21.0827 50.5673 21.0827Z", fill: t.palette.primary[800] }),
      /* @__PURE__ */ f.jsx("path", { d: "M50.5674 21.2536C49.0636 21.2536 47.5941 20.8042 46.3438 19.9617C45.0934 19.1192 44.1192 17.9215 43.5435 16.5203C42.9683 15.1191 42.8175 13.5772 43.111 12.0896C43.4041 10.6019 44.1281 9.23537 45.1908 8.16286C46.254 7.09035 47.6087 6.35998 49.0834 6.06392C50.5577 5.76785 52.0861 5.91996 53.4751 6.50026C54.8646 7.08056 56.0518 8.06336 56.887 9.32468C57.7222 10.5856 58.1681 12.0684 58.1681 13.585C58.1665 15.6182 57.3652 17.5675 55.9403 19.0054C54.5153 20.4433 52.5826 21.2516 50.5674 21.2536ZM50.5674 6.25966C49.1307 6.25966 47.7263 6.68907 46.5321 7.49407C45.3376 8.29906 44.4066 9.44335 43.8568 10.7822C43.307 12.121 43.1631 13.5939 43.4433 15.0155C43.7234 16.4367 44.4151 17.7421 45.431 18.7669C46.4468 19.7917 47.7409 20.4894 49.1497 20.772C50.5585 21.0546 52.019 20.9094 53.3462 20.3548C54.6733 19.8002 55.8077 18.8611 56.6057 17.656C57.4037 16.451 57.8293 15.0343 57.8293 13.5854C57.8269 11.643 57.0613 9.78101 55.6997 8.40754C54.3382 7.03407 52.4924 6.2617 50.5674 6.25966Z", fill: t.palette.primary[900] }),
      /* @__PURE__ */ f.jsx("path", { d: "M50.5673 18.4884C53.2515 18.4884 55.4276 16.2932 55.4276 13.585C55.4276 10.8768 53.2515 8.68164 50.5673 8.68164C47.883 8.68164 45.7065 10.8768 45.7065 13.585C45.7065 16.2932 47.8826 18.4884 50.5673 18.4884Z", fill: "white" }),
      /* @__PURE__ */ f.jsx("path", { d: "M25.8332 26.8434C25.813 26.8434 25.7928 26.8377 25.7754 26.8271C25.758 26.8169 25.7435 26.8018 25.7338 26.7839C22.9873 21.741 20.5129 12.7572 20.4882 12.6683C20.4838 12.6536 20.4822 12.6385 20.4838 12.623C20.4854 12.6079 20.4898 12.5932 20.4971 12.5798C20.5044 12.5663 20.5141 12.5545 20.5262 12.5451C20.5379 12.5357 20.5517 12.5288 20.5662 12.5247C20.5808 12.5207 20.5961 12.5194 20.6111 12.5215C20.6261 12.5235 20.6406 12.5284 20.6536 12.5362C20.6665 12.5439 20.6782 12.5541 20.6871 12.5663C20.696 12.5786 20.7029 12.5924 20.7061 12.6075C20.7308 12.6972 23.1987 21.655 25.9323 26.6737C25.9456 26.6998 25.9484 26.7304 25.9399 26.7586C25.9319 26.7871 25.9133 26.8112 25.8878 26.8259C25.8716 26.8365 25.8526 26.8422 25.8336 26.8434H25.8332Z", fill: "white" }),
      /* @__PURE__ */ f.jsx("path", { d: "M59.7377 25.2866C59.7142 25.2866 59.6916 25.2797 59.6722 25.2662C59.6479 25.2487 59.6314 25.2222 59.6265 25.1924C59.6217 25.1626 59.6285 25.1321 59.6459 25.1076C63.9354 19.0073 65.9029 11.7942 65.9227 11.722C65.9255 11.7065 65.9316 11.6922 65.9405 11.6792C65.9494 11.6665 65.9607 11.6555 65.9737 11.6473C65.987 11.6392 66.0015 11.6339 66.0169 11.6314C66.0323 11.6294 66.048 11.6302 66.0626 11.6343C66.0775 11.6384 66.0917 11.6453 66.1038 11.6551C66.1159 11.6649 66.1257 11.6771 66.1329 11.6906C66.1402 11.7044 66.1447 11.7195 66.1459 11.735C66.1471 11.7505 66.1451 11.7664 66.1402 11.7811C66.1216 11.8533 64.1432 19.1052 59.8295 25.2389C59.8193 25.2536 59.8056 25.2658 59.7894 25.2744C59.7737 25.2825 59.7559 25.287 59.7377 25.2866Z", fill: "white" }),
      /* @__PURE__ */ f.jsx("path", { d: "M32.5851 28.2897C33.0124 28.2897 33.3588 27.9406 33.3588 27.5095C33.3588 27.0785 33.0124 26.729 32.5851 26.729C32.1578 26.729 31.8118 27.0785 31.8118 27.5095C31.8118 27.9406 32.1578 28.2897 32.5851 28.2897Z", fill: "white" }),
      /* @__PURE__ */ f.jsx("path", { d: "M33.4821 34.652C33.9094 34.652 34.2558 34.3025 34.2558 33.8714C34.2558 33.4404 33.9094 33.0913 33.4821 33.0913C33.0548 33.0913 32.7087 33.4404 32.7087 33.8714C32.7087 34.3025 33.0552 34.652 33.4821 34.652Z", fill: "white" }),
      /* @__PURE__ */ f.jsx("path", { d: "M34.1248 40.8341C34.5521 40.8341 34.8981 40.485 34.8981 40.054C34.8981 39.6229 34.5521 39.2734 34.1248 39.2734C33.6975 39.2734 33.3511 39.6229 33.3511 40.054C33.3511 40.485 33.6975 40.8341 34.1248 40.8341Z", fill: "white" }),
      /* @__PURE__ */ f.jsx("path", { d: "M33.8414 95.2645L33.917 95.848L32.8179 96.9283H36.6595L36.7092 96.0842C36.5713 95.2645 34.5962 94.9019 33.8414 95.2645Z", fill: t.palette.primary[900] }),
      /* @__PURE__ */ f.jsx("path", { d: "M59.8064 86.8062L59.5327 87.3315L60.6319 88.4121H56.7903L56.9742 87.5093C57.1088 86.69 59.0509 86.4441 59.8064 86.8062Z", fill: t.palette.primary[900] }),
      /* @__PURE__ */ f.jsx("path", { d: "M62.2122 88.4121H54.5856C54.1773 88.4121 53.8462 88.7461 53.8462 89.158V96.1489C53.8462 96.5608 54.1773 96.8947 54.5856 96.8947H62.2122C62.6209 96.8947 62.9519 96.5608 62.9519 96.1489V89.158C62.9519 88.7461 62.6209 88.4121 62.2122 88.4121Z", fill: t.palette.primary[700] }),
      /* @__PURE__ */ f.jsx("path", { d: "M78.9504 84.0952H71.3238C70.9156 84.0952 70.5845 84.4292 70.5845 84.8415V96.1481C70.5845 96.56 70.9156 96.894 71.3238 96.894H78.9504C79.3591 96.894 79.6902 96.56 79.6902 96.1481V84.8415C79.6902 84.4292 79.3591 84.0952 78.9504 84.0952Z", fill: t.palette.primary[300] }),
      /* @__PURE__ */ f.jsx("path", { d: "M95.689 69.2441H88.0624C87.6541 69.2441 87.323 69.5781 87.323 69.9904V96.1483C87.323 96.5602 87.6541 96.8946 88.0624 96.8946H95.689C96.0977 96.8946 96.4287 96.5602 96.4287 96.1483V69.9904C96.4287 69.5781 96.0977 69.2441 95.689 69.2441Z", fill: t.palette.primary[900] })
    ] }),
    /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_6702_10521", children: /* @__PURE__ */ f.jsx("rect", { width: "92.8571", height: "92.8571", fill: "white", transform: "translate(3.57153 4.07129)" }) }) })
  ] });
}, Gq = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs("svg", { width: e.width, height: e.height, viewBox: "0 0 112 112", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ f.jsx("circle", { cx: "56", cy: "56", r: "56", fill: t.palette.primary[50] }),
    /* @__PURE__ */ f.jsx("path", { d: "M36.5184 97.2306L91.3076 87.0291C91.9681 86.9061 92.553 86.5273 92.9336 85.9762C93.3142 85.425 93.4594 84.7465 93.3371 84.09L82.2757 24.6823L67.5191 14.6242L22.6916 22.9709C22.0311 23.0938 21.4462 23.4726 21.0656 24.0238C20.685 24.5749 20.5398 25.2534 20.6621 25.9099L33.5671 95.219C33.6894 95.8755 34.069 96.4562 34.6225 96.8335C35.1759 97.2107 35.8579 97.3536 36.5184 97.2306Z", fill: t.palette.primary[300] }),
    /* @__PURE__ */ f.jsx("path", { d: "M72.3144 26.5372L82.2761 24.6824L67.5195 14.6243L69.3631 24.5256C69.4853 25.1821 69.865 25.7628 70.4184 26.1401C70.9719 26.5173 71.6539 26.6602 72.3144 26.5372Z", fill: t.palette.primary[600] }),
    /* @__PURE__ */ f.jsx("path", { d: "M75.9081 52.7598L38.5518 59.7154C38.2216 59.7769 37.8806 59.7055 37.6038 59.5168C37.3271 59.3282 37.1373 59.0378 37.0762 58.7096C37.015 58.3813 37.0876 58.0421 37.2779 57.7665C37.4682 57.4909 37.7607 57.3016 38.0909 57.2401L75.4472 50.2845C75.7774 50.223 76.1184 50.2944 76.3952 50.483C76.6719 50.6717 76.8617 50.9621 76.9228 51.2903C76.9839 51.6185 76.9114 51.9578 76.7211 52.2334C76.5308 52.509 76.2383 52.6983 75.9081 52.7598Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M56.3528 65.3649L40.1651 68.379C39.8348 68.4405 39.4938 68.369 39.2171 68.1804C38.9404 67.9918 38.7506 67.7014 38.6894 67.3732C38.6283 67.0449 38.7009 66.7057 38.8912 66.4301C39.0815 66.1545 39.3739 65.9651 39.7042 65.9036L55.8919 62.8896C56.2222 62.8281 56.5632 62.8995 56.8399 63.0881C57.1166 63.2767 57.3064 63.5671 57.3676 63.8954C57.4287 64.2236 57.3561 64.5629 57.1658 64.8384C56.9755 65.114 56.6831 65.3034 56.3528 65.3649Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M73.187 62.0264L62.7061 63.7213C62.3759 63.7827 62.0349 63.7113 61.7581 63.5227C61.4814 63.3341 61.2916 63.0437 61.2304 62.7154C61.1693 62.3872 61.2419 62.048 61.4322 61.7724C61.6225 61.4968 61.915 61.3074 62.2452 61.2459L72.7261 59.5511C73.0564 59.4896 73.3974 59.561 73.6741 59.7496C73.9508 59.9382 74.1406 60.2286 74.2018 60.5569C74.2629 60.8851 74.1903 61.2244 74 61.4999C73.8097 61.7755 73.5173 61.9649 73.187 62.0264Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M69.187 72.5263L41.7784 77.0425C41.4481 77.104 41.1071 77.0326 40.8304 76.844C40.5536 76.6554 40.3638 76.365 40.3027 76.0367C40.2416 75.7085 40.3142 75.3693 40.5045 75.0937C40.6948 74.8181 40.9872 74.6287 41.3175 74.5672L68.7261 70.051C69.0564 69.9895 69.3974 70.0609 69.6741 70.2496C69.9508 70.4382 70.1406 70.7286 70.2018 71.0568C70.2629 71.3851 70.1903 71.7243 70 71.9999C69.8097 72.2755 69.5173 72.4648 69.187 72.5263Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M74.598 80.6197L43.3912 85.7064C43.0609 85.7679 42.7199 85.6964 42.4432 85.5078C42.1664 85.3192 41.9766 85.0288 41.9155 84.7006C41.8544 84.3723 41.927 84.0331 42.1173 83.7575C42.3076 83.4819 42.6 83.2925 42.9303 83.231L74.1371 78.1444C74.4674 78.0829 74.8084 78.1543 75.0851 78.3429C75.3619 78.5315 75.5517 78.8219 75.6128 79.1502C75.6739 79.4784 75.6013 79.8177 75.411 80.0932C75.2207 80.3688 74.9283 80.5582 74.598 80.6197Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M74.2949 44.0962L55.6167 47.574C55.2865 47.6355 54.9455 47.5641 54.6688 47.3755C54.392 47.1869 54.2022 46.8965 54.1411 46.5682C54.08 46.24 54.1525 45.9007 54.3429 45.6252C54.5332 45.3496 54.8256 45.1602 55.1559 45.0987L73.834 41.6209C74.1642 41.5594 74.5052 41.6309 74.782 41.8195C75.0587 42.0081 75.2485 42.2985 75.3096 42.6267C75.3708 42.955 75.2982 43.2942 75.1079 43.5698C74.9176 43.8454 74.6251 44.0348 74.2949 44.0962Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M48.1459 48.9651L36.939 51.0518C36.6088 51.1133 36.2678 51.0419 35.991 50.8533C35.7143 50.6646 35.5245 50.3743 35.4634 50.046C35.4022 49.7178 35.4748 49.3785 35.6651 49.1029C35.8554 48.8274 36.1479 48.638 36.4781 48.5765L47.685 46.4898C48.0152 46.4283 48.3562 46.4998 48.633 46.6884C48.9097 46.877 49.0995 47.1674 49.1607 47.4956C49.2218 47.8239 49.1492 48.1631 48.9589 48.4387C48.7686 48.7143 48.4761 48.9037 48.1459 48.9651Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M72.682 35.4327L35.3257 42.3882C34.9955 42.4497 34.6545 42.3783 34.3777 42.1897C34.101 42.0011 33.9112 41.7107 33.8501 41.3824C33.789 41.0542 33.8615 40.715 34.0518 40.4394C34.2421 40.1638 34.5346 39.9744 34.8648 39.9129L72.2211 32.9573C72.5513 32.8959 72.8923 32.9673 73.1691 33.1559C73.4458 33.3445 73.6356 33.6349 73.6968 33.9632C73.7579 34.2914 73.6853 34.6306 73.495 34.9062C73.3047 35.1818 73.0122 35.3712 72.682 35.4327Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M53.6363 30.0148L33.7129 33.7244C33.3827 33.7859 33.0417 33.7145 32.7649 33.5259C32.4882 33.3372 32.2984 33.0469 32.2373 32.7186C32.1762 32.3904 32.2487 32.0511 32.439 31.7756C32.6294 31.5 32.9218 31.3106 33.252 31.2491L53.1754 27.5395C53.5056 27.478 53.8466 27.5494 54.1234 27.738C54.4001 27.9266 54.5899 28.217 54.651 28.5453C54.7122 28.8735 54.6396 29.2127 54.4493 29.4883C54.259 29.7639 53.9665 29.9533 53.6363 30.0148Z", fill: "white" }),
    /* @__PURE__ */ f.jsx("path", { d: "M87.6488 78.6572C93.1505 77.6329 96.7851 72.3695 95.7669 66.9011C94.7487 61.4328 89.4633 57.8303 83.9617 58.8547C78.46 59.879 74.8254 65.1424 75.8436 70.6108C76.8618 76.0791 82.1472 79.6816 87.6488 78.6572Z", fill: t.palette.primary[800] }),
    /* @__PURE__ */ f.jsx("path", { d: "M85.5168 74.6105C85.1899 74.67 84.8528 74.5994 84.5783 74.4139L80.2422 71.4692C80.1046 71.3754 79.987 71.2556 79.8961 71.1165C79.8052 70.9774 79.7428 70.8218 79.7124 70.6586C79.682 70.4954 79.6842 70.3278 79.719 70.1654C79.7538 70.0029 79.8204 69.8487 79.915 69.7117C80.0096 69.5747 80.1304 69.4575 80.2704 69.3668C80.4105 69.2761 80.5671 69.2137 80.7313 69.1831C80.8955 69.1525 81.0641 69.1544 81.2274 69.1886C81.3907 69.2228 81.5456 69.2887 81.6832 69.3825L84.9614 71.6278L89.3858 65.2207C89.4799 65.0831 89.6005 64.9654 89.7406 64.8743C89.8806 64.7832 90.0373 64.7206 90.2017 64.69C90.3661 64.6594 90.5349 64.6614 90.6983 64.696C90.8618 64.7306 91.0166 64.797 91.154 64.8914C91.4291 65.0802 91.6177 65.3696 91.6785 65.6966C91.7394 66.0235 91.6677 66.3615 91.4789 66.6365L86.3341 74.087C86.2391 74.2234 86.118 74.3398 85.9777 74.4296C85.8375 74.5195 85.6809 74.581 85.5168 74.6105Z", fill: "white" })
  ] });
}, qq = {
  actions: Rq,
  carbonEmissions: Oq,
  carbonNeutrality: _q,
  chemicals: Pq,
  congratulations: Lq,
  contactSupport: Iq,
  communities: jq,
  dataAnalysis: Vq,
  defaultIllustration: Dq,
  environement: Aq,
  filliere: Hq,
  questionnaire: Fq,
  relationships: Nq,
  selectAction: $q,
  selectStartingYear: Bq,
  scoresIndicators: zq,
  trajectoryActions: Zq,
  underConstruction: Wq,
  notEnoughData: Uq,
  consents: Gq
}, Pw = (e) => {
  const {
    illustration: n,
    // Those are the default values originally saved for the files
    // from Figma.
    backgroundShape: o = "circle",
    width: r = 112,
    height: i = 112
  } = e, s = o === "circle" ? /* @__PURE__ */ f.jsx(kq, { width: 112, height: 112 }) : /* @__PURE__ */ f.jsx(Eq, { width: 112, height: 112 }), a = qq[n];
  return /* @__PURE__ */ f.jsx(a, { width: r, height: i, backgroundShape: s });
}, Kq = ba(O4)(() => ({
  background: "transparent",
  borderTop: `1px solid ${ge().custom.grey[500]}`,
  borderRadius: "0 !important",
  boxShadow: "none",
  ":before": {
    height: 0
  },
  ":last-of-type": {
    borderBottom: `1px solid ${ge().custom.grey[500]}`
  },
  "&.Mui-expanded": {
    margin: 0
  }
})), Yq = ba(P4)(() => ({
  minHeight: "84px",
  borderRadius: 0,
  padding: 0,
  "&.Mui-expanded": {
    minHeight: "84px"
  },
  ">.MuiAccordionSummary-content": {
    margin: "20px 0"
  },
  ">.MuiAccordionSummary-expandIconWrapper": {
    width: "44px",
    height: "44px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "12px",
    color: ge().custom.grey[2800]
  }
})), Xq = ba(_4)(() => ({
  padding: "8px 0 28px 0"
})), mxe = (e) => {
  const [t, n] = Ae(null), o = (r) => {
    if (r === t) {
      n(null);
      return;
    }
    n(r);
  };
  return /* @__PURE__ */ f.jsx(be, { direction: "column", children: e.pages.map((r, i) => /* @__PURE__ */ f.jsxs(Kq, { expanded: t === i, children: [
    /* @__PURE__ */ f.jsx(
      Yq,
      {
        expandIcon: /* @__PURE__ */ f.jsx(_t, { size: 4, icon: "arrowDownShort" }),
        onClick: () => o(i),
        children: /* @__PURE__ */ f.jsxs(be, { direction: "row", alignItems: "center", gap: "28px", flex: 1, children: [
          /* @__PURE__ */ f.jsx(oe, { variant: "h3", flex: 1, children: r.title }),
          r.indicator && /* @__PURE__ */ f.jsx(u7, { value: r.indicator.value, unit: r.indicator.unit })
        ] })
      }
    ),
    /* @__PURE__ */ f.jsx(Xq, { children: r.content })
  ] }, `form-accordion-${i}`)) });
}, Jq = (e) => /* @__PURE__ */ y.createElement("svg", { width: 26, height: 26, viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M13.0004 16.5796L6.63672 10.216L7.89176 8.96094L13.0004 14.0872L18.1089 8.97862L19.364 10.2337L13.0004 16.5796Z", fill: "#393A36" })), Ee = {
  gradientDark: "linear-gradient(180deg, #484945 0%, #2A2B27 100%)",
  gradientLight: "linear-gradient(180deg, #FFFFFF 0%, #FAFAFA 100%)",
  100: "#FFFFFF",
  200: "#FEFCFB",
  300: "#F6F5F3",
  400: "#EFEDEC",
  500: "#E7E6E4",
  600: "#E0DEDD",
  700: "#D8D7D5",
  800: "#D1CFCE",
  900: "#C9C8C6",
  1e3: "#C1C0BE",
  1100: "#BAB9B7",
  1200: "#B2B1AF",
  1300: "#ABAAA8",
  1400: "#A3A2A0",
  1500: "#9C9B99",
  1600: "#949491",
  1700: "#8C8C89",
  1800: "#858582",
  1900: "#7D7D7A",
  2e3: "#767673",
  2100: "#6E6E6B",
  2200: "#676764",
  2300: "#5F5F5C",
  2400: "#575854",
  2500: "#50504D",
  2600: "#484945",
  2700: "#41413E",
  2800: "#393A36",
  2900: "#32322F",
  3e3: "#2A2B27"
}, Qo = {
  100: "#FFF0ED",
  200: "#FCCCC2",
  300: "#F8A897",
  400: "#F5846B",
  500: "#F16040",
  600: "#EE3C15",
  700: "#D03210",
  800: "#B2290B",
  900: "#931F05",
  1e3: "#751500"
}, Qq = {
  100: "#DFFFE6",
  200: "#B7F2C4",
  300: "#8FE5A2",
  400: "#67D980",
  500: "#3FCC5E",
  600: "#17BF3C",
  700: "#12A332",
  800: "#0D8728",
  900: "#086A1D",
  1e3: "#034E13"
}, eK = {
  50: "#FFF2E9",
  100: "#FFE5D3",
  200: "#FFCCA7",
  300: "#FFB27B",
  400: "#FF994F",
  500: "#FF8024",
  600: "#CC661C",
  700: "#994C15",
  800: "#66330E",
  900: "#331907"
}, tK = {
  50: "#FFFEEA",
  100: "#FFF9C5",
  200: "#FFF285",
  300: "#FFE546",
  400: "#FFD51B",
  500: "#FFB400",
  600: "#E28A00",
  700: "#BB6002",
  800: "#984A08",
  900: "#7C3D0B"
}, nK = {
  grey: "0px 2px 8px 0px #2A2B270A"
}, Lw = {
  1: {
    main: "#FF8024",
    lv1: {
      max: "#FF3243",
      middle: "#FF8024",
      min: "#FFEDA6"
    },
    lv2: {
      max: "#A57100",
      middle: "#FF9243",
      min: "#FFD4CB"
    }
  },
  2: {
    main: "#4DCDF0",
    lv1: {
      max: "#007F70",
      middle: "#4DCDF0",
      min: "#DDEBFF"
    },
    lv2: {
      max: "#001B93",
      middle: "#4DCDF0",
      min: "#D5FBF2"
    }
  },
  3: {
    main: "#F98CC0",
    lv1: {
      max: "#720098",
      middle: "#F98CC0",
      min: "#FFDED9"
    },
    lv2: {
      max: "#9D0101",
      middle: "#F98CC0",
      min: "#EFDDFF"
    }
  },
  4: {
    main: "#2B59A4",
    lv1: {
      max: "#03684B",
      middle: "#2B59A4",
      min: "#CFC9FF"
    },
    lv2: {
      max: "#3F027D",
      middle: "#2B59A4",
      min: "#C5FFF7"
    }
  },
  5: {
    main: "#FFB400",
    lv1: {
      max: "#803202",
      middle: "#FFB400",
      min: "#F8F66E"
    },
    lv2: {
      max: "#97B408",
      middle: "#FFB400",
      min: "#FFE4D5"
    }
  },
  6: {
    main: "#DB3D53",
    lv1: {
      max: "#730359",
      middle: "#DB3D53",
      min: "#FFD2BC"
    },
    lv2: {
      max: "#5A1800",
      middle: "#DB3D53",
      min: "#FFCFF5"
    }
  },
  7: {
    main: "#47CD56",
    lv1: {
      max: "#6D7502",
      middle: "#47CD56",
      min: "#C5FCFF"
    },
    lv2: {
      max: "#01907A",
      middle: "#47CD56",
      min: "#F1F5B1"
    }
  },
  8: {
    main: "#B2B4FF",
    lv1: {
      max: "#210191",
      middle: "#B2B4FF",
      min: "#F6D0FF"
    },
    lv2: {
      max: "#60017C",
      middle: "#B2B4FF",
      min: "#C5FCFF"
    }
  }
}, Iw = {
  9: { main: "#BB7600" },
  10: { main: "#B249C6" },
  11: { main: "#30C7A3" },
  12: { main: "#FF816C" },
  13: { main: "#5268FF" },
  14: { main: "#C8E25D" },
  15: { main: "#EFB8FF" },
  16: { main: "#A0B1AC" }
}, jw = {
  ...Iw,
  ...Lw
}, oK = Object.values(jw).map((e) => e.main), rK = ba(O4)(() => ({
  ".Mui-disabled": {
    background: Ee[500]
  },
  // This avoids some border being redrawn.
  ":before": {
    height: "0px"
  },
  border: `1px solid ${Ee[500]}`,
  boxShadow: "0px 2px 8px 0px #2A2B270A"
})), bxe = (e) => {
  const { defaultIndex: t } = e, [n, o] = Nt.useState(t), r = (i) => {
    if (i === n) {
      o(void 0);
      return;
    }
    o(i);
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        marginBlock: "1rem"
      },
      children: e.pages.map((i, s) => {
        const a = n === s;
        return /* @__PURE__ */ f.jsxs(rK, { expanded: a, disableGutters: !0, children: [
          /* @__PURE__ */ f.jsx(
            P4,
            {
              sx: { minHeight: "80px" },
              expandIcon: /* @__PURE__ */ f.jsx(Jq, {}),
              "aria-controls": "panel1a-content",
              onClick: () => {
                r(s), i.onOpenAction && i.onOpenAction();
              },
              children: i.title
            }
          ),
          /* @__PURE__ */ f.jsx(
            _4,
            {
              sx: {
                borderTop: `1px solid ${Ee[500]}`
              },
              children: i.content
            }
          )
        ] }, `accordion-prod-ing-${s}`);
      })
    }
  );
}, iK = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), "Add"), sK = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), "ArrowBack"), aK = ft(/* @__PURE__ */ f.jsx("path", {
  d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), "ArrowForward"), lK = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check"), f7 = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), Vw = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "CloseOutlined"), Dw = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96M19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3m-9-3.82-2.09-2.09L6.5 13.5 10 17l6.01-6.01-1.41-1.41z"
}), "CloudDoneOutlined"), cK = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM5.92 19H5v-.92l9.06-9.06.92.92zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41"
}), "CreateOutlined"), dK = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2m-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "DragIndicator"), uK = ft(/* @__PURE__ */ f.jsx("path", {
  d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), "ExpandLess"), fK = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore"), pK = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5m0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5m0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5M7 19h14v-2H7zm0-6h14v-2H7zm0-8v2h14V5z"
}), "FormatListBulleted"), hK = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M2 17h2v.5H3v1h1v.5H2v1h3v-4H2zm1-9h1V4H2v1h1zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2zm5-6v2h14V5zm0 14h14v-2H7zm0-6h14v-2H7z"
}), "FormatListNumbered"), gK = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1M8 13h8v-2H8zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5"
}), "InsertLink"), mK = ft(/* @__PURE__ */ f.jsx("path", {
  d: "m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4z"
}), "Logout"), Aw = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8m0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4z"
}), "LoopOutlined"), bK = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M19 19h2v2h-2zm0-2h2v-2h-2zM3 13h2v-2H3zm0 4h2v-2H3zm0-8h2V7H3zm0-4h2V3H3zm4 0h2V3H7zm8 16h2v-2h-2zm-4 0h2v-2h-2zm4 0h2v-2h-2zm-8 0h2v-2H7zm-4 0h2v-2H3zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2z"
}), "RoundedCorner"), CK = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), "SearchOutlined"), xK = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6"
}), "Settings"), yK = ft([/* @__PURE__ */ f.jsx("path", {
  d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22z"
}, "0"), /* @__PURE__ */ f.jsx("path", {
  d: "M13 16h-2v2h2zm0-6h-2v5h2z"
}, "1")], "WarningAmber");
function vK() {
  if (console && console.warn) {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    sa(t[0]) && (t[0] = `react-i18next:: ${t[0]}`), console.warn(...t);
  }
}
const hm = {};
function zp() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  sa(t[0]) && hm[t[0]] || (sa(t[0]) && (hm[t[0]] = /* @__PURE__ */ new Date()), vK(...t));
}
const Hw = (e, t) => () => {
  if (e.isInitialized)
    t();
  else {
    const n = () => {
      setTimeout(() => {
        e.off("initialized", n);
      }, 0), t();
    };
    e.on("initialized", n);
  }
}, gm = (e, t, n) => {
  e.loadNamespaces(t, Hw(e, n));
}, mm = (e, t, n, o) => {
  sa(n) && (n = [n]), n.forEach((r) => {
    e.options.ns.indexOf(r) < 0 && e.options.ns.push(r);
  }), e.loadLanguages(t, Hw(e, o));
}, wK = function(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const o = t.languages[0], r = t.options ? t.options.fallbackLng : !1, i = t.languages[t.languages.length - 1];
  if (o.toLowerCase() === "cimode") return !0;
  const s = (a, c) => {
    const d = t.services.backendConnector.state[`${a}|${c}`];
    return d === -1 || d === 2;
  };
  return n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !s(t.isLanguageChangingTo, e) ? !1 : !!(t.hasResourceBundle(o, e) || !t.services.backendConnector.backend || t.options.resources && !t.options.partialBundledLanguages || s(o, e) && (!r || s(i, e)));
}, SK = function(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return !t.languages || !t.languages.length ? (zp("i18n.languages were undefined or empty", t.languages), !0) : t.options.ignoreJSONStructure !== void 0 ? t.hasLoadedNamespace(e, {
    lng: n.lng,
    precheck: (r, i) => {
      if (n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && r.services.backendConnector.backend && r.isLanguageChangingTo && !i(r.isLanguageChangingTo, e)) return !1;
    }
  }) : wK(e, t, n);
}, sa = (e) => typeof e == "string", MK = (e) => typeof e == "object" && e !== null, TK = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, kK = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, EK = (e) => kK[e], RK = (e) => e.replace(TK, EK);
let OK = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: RK
};
const _K = () => OK;
let PK;
const LK = () => PK, IK = h0();
class jK {
  constructor() {
    Ge(this, "getUsedNamespaces", () => Object.keys(this.usedNamespaces));
    this.usedNamespaces = {};
  }
  addUsedNamespaces(t) {
    t.forEach((n) => {
      this.usedNamespaces[n] || (this.usedNamespaces[n] = !0);
    });
  }
}
const VK = (e, t) => {
  const n = St();
  return mt(() => {
    n.current = e;
  }, [e, t]), n.current;
}, Fw = (e, t, n, o) => e.getFixedT(t, n, o), DK = (e, t, n, o) => pr(Fw(e, t, n, o), [e, t, n, o]), ja = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    i18n: n
  } = t, {
    i18n: o,
    defaultNS: r
  } = p0(IK) || {}, i = n || o || LK();
  if (i && !i.reportNamespaces && (i.reportNamespaces = new jK()), !i) {
    zp("You will need to pass in an i18next instance by using initReactI18next");
    const M = (k, E) => sa(E) ? E : MK(E) && sa(E.defaultValue) ? E.defaultValue : Array.isArray(k) ? k[k.length - 1] : k, w = [M, {}, !1];
    return w.t = M, w.i18n = {}, w.ready = !1, w;
  }
  i.options.react && i.options.react.wait !== void 0 && zp("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const s = {
    ..._K(),
    ...i.options.react,
    ...t
  }, {
    useSuspense: a,
    keyPrefix: c
  } = s;
  let d = r || i.options && i.options.defaultNS;
  d = sa(d) ? [d] : d || ["translation"], i.reportNamespaces.addUsedNamespaces && i.reportNamespaces.addUsedNamespaces(d);
  const u = (i.isInitialized || i.initializedStoreOnce) && d.every((M) => SK(M, i, s)), p = DK(i, t.lng || null, s.nsMode === "fallback" ? d : d[0], c), h = () => p, g = () => Fw(i, t.lng || null, s.nsMode === "fallback" ? d : d[0], c), [m, b] = Ae(h);
  let C = d.join();
  t.lng && (C = `${t.lng}${C}`);
  const x = VK(C), v = St(!0);
  mt(() => {
    const {
      bindI18n: M,
      bindI18nStore: w
    } = s;
    v.current = !0, !u && !a && (t.lng ? mm(i, t.lng, d, () => {
      v.current && b(g);
    }) : gm(i, d, () => {
      v.current && b(g);
    })), u && x && x !== C && v.current && b(g);
    const k = () => {
      v.current && b(g);
    };
    return M && i && i.on(M, k), w && i && i.store.on(w, k), () => {
      v.current = !1, M && i && M.split(" ").forEach((E) => i.off(E, k)), w && i && w.split(" ").forEach((E) => i.store.off(E, k));
    };
  }, [i, C]), mt(() => {
    v.current && u && b(h);
  }, [i, c, u]);
  const S = [m, i, u];
  if (S.t = m, S.i18n = i, S.ready = u, u || !u && !a) return S;
  throw new Promise((M) => {
    t.lng ? mm(i, t.lng, d, () => M()) : gm(i, d, () => M());
  });
};
function Cxe(e) {
  const t = ge(), { t: n } = ja(), [o, r] = Ae(!1);
  return /* @__PURE__ */ f.jsxs(
    J,
    {
      component: "div",
      sx: {
        borderRadius: "8px",
        background: "#FFF",
        boxShadow: " 0px 2px 8px 0px rgba(42, 43, 39, 0.04)",
        border: `1px solid ${t.custom.grey[500]}`
      },
      children: [
        /* @__PURE__ */ f.jsxs(
          be,
          {
            direction: "row",
            justifyContent: "space-between",
            alignItems: "center",
            sx: { width: "100%", padding: "30px 24px" },
            children: [
              /* @__PURE__ */ f.jsxs(be, { direction: "row", useFlexGap: !0, gap: "12px", alignItems: "center", children: [
                e.headerIcon,
                /* @__PURE__ */ f.jsx(oe, { variant: "h3", children: e.headerText })
              ] }),
              /* @__PURE__ */ f.jsxs(be, { direction: "row", useFlexGap: !0, gap: "24px", alignItems: "center", children: [
                e.controls,
                !e.controls && /* @__PURE__ */ f.jsx(
                  at,
                  {
                    disabled: !0,
                    variant: "white-filled",
                    startIcon: /* @__PURE__ */ f.jsx(cK, {}),
                    sx: { marginRight: "24px", borderRadius: "44px" },
                    children: n("Modifier")
                  }
                ),
                /* @__PURE__ */ f.jsx(Bt, { onClick: (i) => r(!o), children: o === !0 ? /* @__PURE__ */ f.jsx(uK, {}) : /* @__PURE__ */ f.jsx(fK, {}) })
              ] })
            ]
          }
        ),
        o && /* @__PURE__ */ f.jsx(gs, { in: o, timeout: 300, children: /* @__PURE__ */ f.jsxs("div", { children: [
          /* @__PURE__ */ f.jsx(ho, {}),
          /* @__PURE__ */ f.jsx(J, { component: "div", sx: { padding: "44px" }, children: e.children })
        ] }) })
      ]
    }
  );
}
const bm = 100, AK = "202px", Ma = B(({ className: e, title: t, arrow: n = !0, ...o }) => {
  const r = typeof t == "string" && t.length > bm ? `${t.slice(0, bm)}...` : t;
  return /* @__PURE__ */ f.jsx(ln, { ...o, title: r, arrow: n, classes: { popper: e } });
})(({ theme: e, align: t = "center", width: n = AK, padding: o = "12px 16px 12px 16px" }) => {
  const r = {
    display: "flex",
    justifyContent: t,
    width: n,
    padding: o,
    borderRadius: "0.5rem",
    border: `1px solid ${e.custom.grey[500]}`,
    backgroundColor: e.custom.grey[100],
    boxShadow: `0px 4px 20px 0px ${e.custom.grey[500]}`,
    fontSize: "0.75rem",
    fontWeight: 600,
    color: e.custom.grey[2800],
    webkitLineBreak: "auto",
    wordBreak: "break-word",
    whiteSpace: "pre-line"
  };
  return {
    [`& .${Io.arrow}`]: {
      color: e.custom.grey[100],
      "&:before": {
        border: `1px solid ${e.custom.grey[500]}`,
        boxSizing: "border-box"
      }
    },
    [`& .${Io.tooltip}`]: {
      ...r,
      "&.MuiTooltip-tooltip": {
        margin: "8px"
      }
    }
  };
}), HK = (e) => {
  const { children: t, tooltip: n } = e;
  return n ? /* @__PURE__ */ f.jsx(
    Ma,
    {
      title: n,
      placement: "bottom",
      arrow: !0,
      enterDelay: 100,
      children: t
    }
  ) : /* @__PURE__ */ f.jsx(f.Fragment, { children: t });
}, p7 = (e) => {
  const t = ge(), { children: n, size: o = "small", tooltip: r, ...i } = e;
  let s = "28px", a = "h5";
  switch (o) {
    case "medium":
      s = "36px", a = "h4";
      break;
    case "big":
      s = "40px", a = "h3";
      break;
  }
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx(HK, { tooltip: r, children: /* @__PURE__ */ f.jsx(
    J,
    {
      width: s,
      height: s,
      minWidth: s,
      minHeight: s,
      bgcolor: t.custom.grey[2800],
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "100%",
      ...i,
      children: /* @__PURE__ */ f.jsx(
        oe,
        {
          variant: a,
          color: "inherit",
          sx: {
            display: "inline-flex",
            transform: typeof n == "number" && n >= 100 ? "scale(0.8)" : "none",
            userSelect: "none"
          },
          children: n
        }
      )
    }
  ) }) });
}, V0 = (e) => {
  const {
    icon: t,
    size: n,
    boxProps: o = {}
  } = e, r = _w(n);
  return /* @__PURE__ */ f.jsx(J, { ...o, sx: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: `${r.width + 10}px`,
    height: `${r.height + 10}px`,
    ...o.sx
  }, children: /* @__PURE__ */ f.jsx(
    _t,
    {
      size: r,
      icon: t
    }
  ) });
}, FK = (e) => {
  const { soonAvailableText: t } = e, n = ge();
  return /* @__PURE__ */ f.jsx(
    be,
    {
      alignItems: "center",
      border: `1px solid ${n.custom.grey[500]}`,
      borderRadius: "4px",
      padding: "2px 8px",
      children: /* @__PURE__ */ f.jsx(oe, { noWrap: !0, variant: "caption", fontWeight: 600, children: t })
    }
  );
}, NK = (e) => {
  const t = ge(), { children: n, boxProps: o = {} } = e;
  return /* @__PURE__ */ f.jsx(
    J,
    {
      ...o,
      sx: {
        border: `1px solid ${t.custom.grey[500]}`,
        background: t.custom.grey[200],
        borderRadius: "4px",
        padding: "1rem",
        ...o.sx
      },
      children: n
    }
  );
}, xxe = (e) => {
  const { orientation: t = "vertical", type: n = "default" } = e, o = ge();
  return /* @__PURE__ */ f.jsxs(
    Hr,
    {
      borderRadius: "12px",
      sx: {
        background: n === "default" ? "#FFF" : o.palette.primary[50],
        display: "flex",
        alignItems: "flex-start",
        gap: "20px",
        padding: t === "vertical" ? "24px" : "20px 32px 20px 24px"
      },
      children: [
        /* @__PURE__ */ f.jsx(
          be,
          {
            alignItems: "center",
            justifyContent: "center",
            sx: {
              width: "36px",
              height: "36px"
            },
            children: e.icon
          }
        ),
        /* @__PURE__ */ f.jsxs(
          be,
          {
            direction: e.orientation === "horizontal" ? "row" : "column",
            gap: "16px",
            flex: 1,
            children: [
              /* @__PURE__ */ f.jsxs(be, { flex: 1, gap: "8px", children: [
                /* @__PURE__ */ f.jsx(oe, { variant: "h4", children: e.title }),
                /* @__PURE__ */ f.jsx(oe, { variant: "caption", children: e.children })
              ] }),
              e.cta && /* @__PURE__ */ f.jsx(
                be,
                {
                  direction: e.orientation === "horizontal" ? "row" : "column",
                  alignItems: e.orientation === "horizontal" ? "center" : "flex-start",
                  gap: e.orientation === "horizontal" ? "24px" : "",
                  children: e.cta
                }
              )
            ]
          }
        )
      ]
    }
  );
}, $K = (e) => /* @__PURE__ */ y.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M4.36204 12.3802L3.61963 11.6378L7.25751 7.99993L3.61963 4.36204L4.36204 3.61963L7.99993 7.25751L11.6378 3.61963L12.3802 4.36204L8.74234 7.99993L12.3802 11.6378L11.6378 12.3802L7.99993 8.74234L4.36204 12.3802Z", fill: "#50504D" })), yxe = (e) => {
  const { text: t, action: n } = e;
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      style: {
        backgroundColor: "#EFEDEC",
        height: "fit-content",
        paddingBlock: "0.25rem",
        paddingRight: n ? "0.25rem" : "0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "fit-content",
        borderRadius: "5px"
      },
      children: [
        /* @__PURE__ */ f.jsx(oe, { variant: "body", style: { marginInline: "10px" }, children: t }),
        n && /* @__PURE__ */ f.jsx($K, { onClick: n })
      ]
    }
  );
}, BK = (e) => /* @__PURE__ */ y.createElement("svg", { width: "100%", height: "100%", preserveAspectRatio: "none", viewBox: "0 0 1232 229", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { opacity: 0.48, d: "M0 228.999C192.752 13.1805 946.143 143.331 1232 0.000137329L1232 229L0 228.999Z", fill: "inherit" })), zK = (e) => {
  const { size: t = "big" } = e, n = ge();
  return /* @__PURE__ */ f.jsx(Hr, { borderRadius: "12px", padding: "12px", children: /* @__PURE__ */ f.jsxs(
    be,
    {
      bgcolor: n.palette.primary[50],
      borderRadius: "4px",
      padding: t === "big" ? "36px" : "32px",
      gap: "32px",
      position: "relative",
      overflow: "hidden",
      children: [
        /* @__PURE__ */ f.jsx(
          J,
          {
            position: "absolute",
            sx: {
              inset: 0,
              color: n.custom.grey[200],
              objectFit: "cover",
              zIndex: 0
            },
            children: /* @__PURE__ */ f.jsx(BK, {})
          }
        ),
        /* @__PURE__ */ f.jsxs(be, { flex: 1, gap: t === "big" ? "12px" : "16px", position: "relative", children: [
          e.title && /* @__PURE__ */ f.jsx(oe, { variant: "h4", children: e.title }),
          /* @__PURE__ */ f.jsx(oe, { variant: "caption", children: e.children })
        ] }),
        e.cta && /* @__PURE__ */ f.jsx(
          be,
          {
            direction: "row",
            alignItems: "center",
            gap: "24px",
            sx: {
              maxHeight: e.size === "big" ? "100%" : "20px"
            },
            children: e.cta
          }
        )
      ]
    }
  ) });
}, vxe = (e) => /* @__PURE__ */ f.jsx(
  "div",
  {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: "5px",
      border: `2px dashed ${Ee[800]}`,
      borderRadius: "8px",
      background: Ee[200]
    },
    children: e.children
  }
), Hr = (e) => {
  const t = ge(), {
    borderRadius: n = "16px",
    boxShadow: o = "0 2px 8px 0 rgba(42, 43, 39, 0.04)",
    ...r
  } = e;
  return /* @__PURE__ */ f.jsx(
    J,
    {
      bgcolor: "#FFF",
      border: `1px solid ${t.custom.grey[500]}`,
      borderRadius: n,
      boxShadow: o,
      ...r
    }
  );
}, ZK = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M18.6946 28.3333H21.4724V18.3333H18.6946V28.3333ZM19.9997 15.1666C20.4167 15.1666 20.7664 15.0282 21.0488 14.7514C21.3312 14.4745 21.4724 14.1315 21.4724 13.7222C21.4724 13.2972 21.3313 12.941 21.0492 12.6535C20.7672 12.366 20.4176 12.2222 20.0007 12.2222C19.5837 12.2222 19.234 12.366 18.9515 12.6535C18.6692 12.941 18.528 13.2972 18.528 13.7222C18.528 14.1315 18.669 14.4745 18.9511 14.7514C19.2332 15.0282 19.5827 15.1666 19.9997 15.1666ZM20.0075 36.6666C17.7069 36.6666 15.5449 36.2291 13.5215 35.3541C11.498 34.4791 9.73165 33.287 8.22237 31.7778C6.71312 30.2685 5.521 28.5015 4.646 26.4766C3.771 24.4518 3.3335 22.2883 3.3335 19.9861C3.3335 17.6839 3.771 15.5204 4.646 13.4956C5.521 11.4707 6.71312 9.70831 8.22237 8.20831C9.73165 6.70831 11.4987 5.52081 13.5235 4.64581C15.5483 3.77081 17.7118 3.33331 20.014 3.33331C22.3163 3.33331 24.4798 3.77081 26.5046 4.64581C28.5294 5.52081 30.2918 6.70831 31.7918 8.20831C33.2918 9.70831 34.4793 11.4722 35.3543 13.5C36.2293 15.5278 36.6668 17.692 36.6668 19.9926C36.6668 22.2932 36.2293 24.4552 35.3543 26.4787C34.4793 28.5021 33.2918 30.2668 31.7918 31.7726C30.2918 33.2785 28.5279 34.4706 26.5002 35.349C24.4724 36.2274 22.3082 36.6666 20.0075 36.6666ZM20.014 33.8889C23.8752 33.8889 27.1529 32.537 29.8474 29.8333C32.5419 27.1296 33.8891 23.8472 33.8891 19.9861C33.8891 16.125 32.5436 12.8472 29.8526 10.1527C27.1616 7.45829 23.8775 6.11106 20.0002 6.11106C16.1483 6.11106 12.8705 7.45655 10.1668 10.1475C7.46311 12.8385 6.11125 16.1227 6.11125 20C6.11125 23.8518 7.46311 27.1296 10.1668 29.8333C12.8705 32.537 16.1529 33.8889 20.014 33.8889Z", fill: "inherit" })), WK = (e) => {
  const t = ge(), { children: n, ...o } = e;
  return /* @__PURE__ */ f.jsx(
    Hr,
    {
      borderRadius: "4px",
      boxShadow: "none",
      padding: "16px",
      ...o,
      children: /* @__PURE__ */ f.jsxs(be, { direction: "row", alignItems: "center", gap: "12px", children: [
        /* @__PURE__ */ f.jsx(be, { sx: { minWidth: "24px" }, children: /* @__PURE__ */ f.jsx(
          ZK,
          {
            width: "24px",
            height: "24px",
            color: t.custom.grey[2800]
          }
        ) }),
        /* @__PURE__ */ f.jsx(oe, { variant: "caption", color: t.custom.grey[2500], children: n })
      ] })
    }
  );
}, wxe = (e) => /* @__PURE__ */ f.jsx(f.Fragment, {}), Sxe = (e) => {
  const { isFirst: t = !1, isLast: n = !1 } = e;
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      style: {
        // display: "flex",
        // alignItems: "center",
        // paddingInline: "1rem",
        border: `1px solid ${Ee[500]}`,
        borderTopLeftRadius: t ? "8px" : "0px",
        borderTopRightRadius: t ? "8px" : "0px",
        borderBottomLeftRadius: n ? "8px" : "0px",
        borderBottomRightRadius: n ? "8px" : "0px",
        boxShadow: "0px 2px 8px 0px #2A2B270A"
      },
      children: e.children
    }
  );
}, Mxe = (e) => /* @__PURE__ */ f.jsx(
  "div",
  {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: "5px",
      borderLeft: `1px solid ${Ee[500]}`,
      paddingLeft: "2rem"
    },
    children: e.data
  }
), Txe = (e) => {
  const t = ge(), {
    size: n = "big",
    header: o,
    footer: r,
    ...i
  } = e;
  return /* @__PURE__ */ f.jsxs(
    Hr,
    {
      borderRadius: n === "small" ? "8px" : "16px",
      boxShadow: n === "small" ? "none" : void 0,
      ...i,
      children: [
        /* @__PURE__ */ f.jsx(
          J,
          {
            sx: {
              padding: n === "small" ? "16px 20px" : "28px 32px",
              background: n === "small" ? t.custom.grey[200] : "white",
              borderTopLeftRadius: n === "small" ? "8px" : "16px",
              borderTopRightRadius: n === "small" ? "8px" : "16px"
            },
            children: o
          }
        ),
        /* @__PURE__ */ f.jsx(
          J,
          {
            sx: {
              borderTop: `1px solid ${t.custom.grey[500]}`,
              padding: n === "small" ? "20px" : "28px",
              borderBottomLeftRadius: r ? void 0 : n === "small" ? "8px" : "16px",
              borderBottomRightRadius: r ? void 0 : n === "small" ? "8px" : "16px"
            },
            children: e.children
          }
        ),
        r && /* @__PURE__ */ f.jsx(
          J,
          {
            sx: {
              background: "white",
              borderTop: `1px solid ${t.custom.grey[500]}`,
              padding: n === "small" ? "20px" : "28px",
              borderBottomLeftRadius: n === "small" ? "8px" : "16px",
              borderBottomRightRadius: n === "small" ? "8px" : "16px"
            },
            children: r
          }
        )
      ]
    }
  );
}, kxe = (e) => /* @__PURE__ */ f.jsx(
  J,
  {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: "5px",
      height: "fit-content",
      padding: "1rem",
      border: `1px solid ${Ee[800]}`,
      borderRadius: "8px",
      background: Ee[200]
    },
    children: e.children
  }
), j3 = (e) => /* @__PURE__ */ y.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M1.72408 17.7605L0.239258 16.2756L7.51503 8.99985L0.239258 1.72409L1.72408 0.239258L8.99986 7.51503L16.2756 0.239258L17.7605 1.72409L10.4847 8.99985L17.7605 16.2756L16.2756 17.7605L8.99986 10.4847L1.72408 17.7605Z", fill: "#393A36" })), Exe = (e) => {
  const { children: t } = e, [n, o] = Ae(!0), r = Array.isArray(t) ? t : [t];
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      style: {
        display: n ? "flex" : "none",
        flexDirection: "row",
        gap: "10px",
        alignItems: "center",
        backgroundColor: "#FFF6E8",
        padding: "1rem 0 1rem 1rem",
        border: "1px solid #FBD68B",
        borderRadius: "16px"
      },
      children: [
        /* @__PURE__ */ f.jsx(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              width: "100%"
            },
            children: r.map((i) => /* @__PURE__ */ f.jsx(ws, { children: /* @__PURE__ */ f.jsx(
              "div",
              {
                style: {
                  width: "100%"
                },
                children: i
              }
            ) }, `infobox-${i.key}`))
          }
        ),
        /* @__PURE__ */ f.jsx("div", { style: { minWidth: "40px" }, children: /* @__PURE__ */ f.jsx(at, { variant: "text", startIcon: /* @__PURE__ */ f.jsx(j3, {}), onClick: () => o(!1), disableRipple: !0 }) })
      ]
    }
  );
}, Nw = B(I3)(() => ({
  textTransform: "capitalize",
  border: `1px solid ${Ee[500]}`,
  background: Ee.gradientLight,
  color: Ee[2800],
  "&.Mui-selected": {
    color: "#FFF",
    fill: "#FFF",
    background: Ee.gradientDark,
    border: `1px solid ${Ee[2800]}`,
    "&:hover": {
      color: "#FFF",
      background: Ee.gradientDark,
      border: `1px solid ${Ee[2800]}`
    }
  },
  "&:disabled": {
    border: `1px solid ${Ee[100]}`,
    background: Ee[500]
  },
  "&:hover": {
    border: `1px solid ${Ee[500]}`,
    background: Ee[400]
  }
})), Rxe = (e) => {
  const { choices: t, onClick: n, currentIndexSelected: o, ...r } = e, [i, s] = Ae(o ?? null), a = (c) => {
    if (n == null || n(c), c === i) {
      s(null);
      return;
    }
    s(c);
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: "1rem"
      },
      children: t.map((c, d) => /* @__PURE__ */ Yl(
        Nw,
        {
          ...r,
          key: `${d}-button-toggle-${c}`,
          value: d,
          onClick: () => a(d),
          selected: d === i
        },
        /* @__PURE__ */ f.jsx(oe, { variant: "big-bold", color: "inherit", children: c })
      ))
    }
  );
}, V3 = {
  MuiAvatar: {
    defaultProps: {
      children: []
    },
    styleOverrides: {
      root: ({ theme: e, ownerState: { alt: t = "" } }) => {
        const n = t.split(" ").map((o) => o.charAt(0).toUpperCase()).join("");
        return {
          background: e.palette.primary[100],
          color: e.palette.primary[700],
          fontWeight: 600,
          ".MuiAvatar-img": {
            zIndex: 1
          },
          ":empty::before": {
            content: `"${n}"`
          }
        };
      }
    },
    variants: [
      {
        props: { variant: "small" },
        style: {
          width: "24px",
          height: "24px",
          fontSize: "10px"
        }
      },
      {
        props: { variant: "medium" },
        style: {
          width: "36px",
          height: "36px",
          fontSize: "13px"
        }
      },
      {
        props: { variant: "big" },
        style: {
          width: "40px",
          height: "40px",
          fontSize: "16px"
        }
      }
    ]
  },
  MuiAvatarGroup: {
    defaultProps: {
      variant: "small",
      spacing: 6,
      sx: {
        justifyContent: "flex-end"
      },
      slotProps: {
        additionalAvatar: {
          sx: {
            color: (e) => e.custom.grey[2800],
            background: (e) => e.custom.grey[400]
          }
        }
      }
    },
    styleOverrides: {
      root: ({ ownerState: { max: e = 0 } }) => ({
        ...[...Array(e)].reduce(
          (t, n, o) => ({
            ...t,
            [`& > .MuiAvatar-root:nth-of-type(${o + 1})`]: {
              zIndex: e - o
            }
          }),
          {}
        )
      })
    }
  },
  // Changes default arguments for Buttons in the entire app.
  MuiButtonGroup: {
    defaultProps: {
      disableRipple: !0
    }
  },
  MuiButton: {
    defaultProps: {
      // Changes default arguments for Buttons in the entire app.
      disableRipple: !0
    },
    styleOverrides: {
      // Modifications here affect all <Button /> in our app.
      root: ({ theme: e, ownerState: t }) => ({
        textTransform: "none",
        fontSize: "0.75rem",
        borderRadius: "25px",
        height: "40px",
        ...t.variant === "primary" && {
          transition: "none",
          background: `linear-gradient(${e.palette.primary[400]}, ${e.palette.primary[600]})`,
          color: e.custom.grey[100],
          boxShadow: "0px 4px 8px 0px #2A2B2714"
        },
        ...t.variant === "secondary" && {
          border: `2px solid ${e.palette.primary[600]}`,
          color: e.palette.primary[600]
        },
        ...t.variant === "ternary" && {
          border: `1px solid ${e.custom.grey[500]}`,
          background: e.custom.grey.gradientLight
        },
        ...t.variant === "text" && {
          transition: "none",
          paddingInline: "0",
          color: e.palette.primary[700],
          fontWeight: "700"
        },
        ...t.variant === "selected-menu" && {
          color: "white",
          background: `linear-gradient(${e.palette.primary[400]}, ${e.palette.primary[600]})`,
          borderRadius: "8px",
          padding: 0
        },
        ...t.variant === "selected-submenu" && {
          color: e.palette.primary[400],
          background: "inherit",
          borderRadius: "8px",
          padding: 0
        },
        ...t.variant === "default-menu" && {
          color: e.custom.grey[100],
          background: "inherit",
          borderRadius: "8px",
          padding: 0
        },
        ...t.variant === "black-text" && {
          color: e.custom.grey[2800],
          background: "none",
          fontWeight: "600"
        },
        ...t.variant === "black-filled" && {
          borderRadius: "8px",
          background: `linear-gradient(180deg, ${e.custom.grey[2600]} 0%, ${e.custom.grey[3e3]} 100%)`,
          boxShadow: "0px 4px 8px 0px rgba(42, 43, 39, 0.08)",
          color: e.custom.grey[100]
        },
        ...t.variant === "white-filled" && {
          borderRadius: "8px",
          border: "1px solid " + e.custom.grey[500],
          background: `linear-gradient(180deg, ${e.custom.grey[100]} 0%, ${e.custom.grey[200]} 100%)`,
          boxShadow: " 0px 2px 8px 0px rgba(42, 43, 39, 0.04)"
        },
        ...t.variant === "white-filled-no-shadow" && {
          borderRadius: "44px",
          border: `1px solid ${e.custom.grey[500]}`,
          background: `linear-gradient(180deg, ${e.custom.grey[100]} 0%, ${e.custom.grey[200]} 100%)`
        },
        ...t.variant === "select" && {
          backgroundColor: e.custom.grey[100],
          borderRadius: "24px",
          border: `1px solid ${e.custom.grey[500]}`
        },
        ...t.variant === "validate" && {
          borderRadius: "44px",
          color: "#FFFFFF",
          transition: "none",
          background: `linear-gradient(180deg, ${e.custom.green[500]} 0%, ${e.custom.green[700]} 100%)`
        },
        ":hover": {
          ...t.variant === "primary" && {
            background: e.palette.primary[600]
          },
          ...t.variant === "secondary" && {
            color: "#FFFFFF",
            border: "none",
            background: e.palette.primary[600]
          },
          ...t.variant === "ternary" && {
            border: `1px solid ${e.custom.grey[500]}`,
            background: e.custom.grey[400]
          },
          ...t.variant === "text" && {
            background: "none",
            textDecoration: "underline"
          },
          ...t.variant === "select" && {
            backgroundColor: e.custom.grey[300]
          },
          ...t.variant === "default-menu" && {
            backgroundColor: e.custom.grey[2300],
            borderRadius: "8px"
            // padding: 0,
          },
          ...t.variant === "selected-menu" && {
            borderRadius: "8px"
            // padding: 0,
          },
          ...t.variant === "selected-submenu" && {
            borderRadius: "8px"
            // padding: 0,
          },
          ...t.variant === "validate" && {
            background: e.custom.green[600]
          }
        },
        ":disabled": {
          ...t.variant === "primary" && {
            color: e.custom.grey[100],
            background: $t(e.palette.primary[600] ?? "", 0.36)
          },
          ...t.variant === "secondary" && {
            color: $t(e.palette.primary[600] ?? "", 0.36),
            border: `2px solid ${$t(e.palette.primary[600] ?? "", 0.36)}`,
            background: e.custom.grey[100]
          },
          ...t.variant === "ternary" && {
            border: `1px solid ${e.custom.grey[100]}`,
            background: e.custom.grey[500]
          },
          ...t.variant === "select" && {
            backgroundColor: e.custom.grey[500]
          },
          ...t.variant === "default-menu" && {
            color: e.custom.grey[2300],
            borderRadius: "8px"
          },
          ...t.variant === "selected-menu" && {
            color: e.custom.grey[2300],
            borderRadius: "8px"
          },
          ...t.variant === "selected-submenu" && {
            color: e.custom.grey[2300],
            borderRadius: "8px"
          },
          ...t.variant === "validate" && {
            background: $t(e.custom.green[500], 0.36),
            color: "#FFFFFF"
          }
        },
        ":active": {
          ...t.variant === "primary" && {
            background: e.palette.primary[800]
          },
          ...t.variant === "secondary" && {
            color: e.custom.grey[100],
            border: "none",
            background: e.palette.primary[800]
          },
          ...t.variant === "secondary" && {
            background: e.custom.grey[600]
          },
          ...t.variant === "default-menu" && {
            backgroundColor: e.custom.grey[2700],
            borderRadius: "8px"
          },
          ...t.variant === "selected-menu" && {
            backgroundColor: e.custom.grey[2700],
            borderRadius: "8px"
          },
          ...t.variant === "selected-submenu" && {
            backgroundColor: e.custom.grey[2700],
            borderRadius: "8px"
          },
          ...t.variant === "validate" && {
            background: e.custom.green[800]
          }
        },
        ...t.variant === "tags-grey" && {
          padding: e.spacing(0, 1),
          border: `1px solid ${e.custom.grey[400]}`,
          borderRadius: "4px",
          backgroundColor: e.custom.grey[400],
          color: e.custom.grey[2800],
          height: "24px",
          /* This is because of a small curser `pointer` show
              In case action is not specified
              @ts-expect-error */
          cursor: "default",
          ...t.onClick !== void 0 ? {
            cursor: "pointer",
            ":hover": {
              border: `1px solid ${e.custom.grey[500]}`,
              backgroundColor: e.custom.grey[300]
            },
            ":active": {
              border: `1px solid ${e.custom.grey[500]}`,
              backgroundColor: e.custom.grey[500]
            },
            ":disabled": {
              border: `1px solid ${e.custom.grey[500]}`,
              backgroundColor: e.custom.grey[100],
              color: e.custom.grey[1400]
            }
          } : {
            ":hover": {
              // cursor: "default",
              backgroundColor: e.custom.grey[400]
            }
          }
        },
        ...t.variant === "tags-black" && {
          padding: e.spacing(0, 1),
          border: `1px solid ${e.custom.grey[400]}`,
          borderRadius: "4px",
          background: "linear-gradient(180deg, #484945 0%, #2A2B27 100%)",
          color: e.custom.grey[100],
          height: "24px",
          /* This is because of a small curser `pointer` show
              In case action is not specified
              @ts-expect-error */
          cursor: "default",
          ...t.onClick !== void 0 ? {
            cursor: "pointer",
            ":hover": {
              border: `1px solid ${e.custom.grey[500]}`,
              backgroundColor: e.custom.grey[300]
            },
            ":active": {
              border: `1px solid ${e.custom.grey[500]}`,
              backgroundColor: e.custom.grey[500]
            },
            ":disabled": {
              border: `1px solid ${e.custom.grey[500]}`,
              backgroundColor: e.custom.grey[100],
              color: e.custom.grey[1400]
            }
          } : {
            ":hover": {
              cursor: "default",
              backgroundColor: e.custom.grey[400]
            }
          }
        },
        ...t.variant === "tags-white" && {
          padding: e.spacing(0, 1),
          border: `1px solid ${e.custom.grey[400]}`,
          borderRadius: "4px",
          backgroundColor: e.custom.grey[100],
          color: e.custom.grey[2800],
          height: "24px",
          /* This is because of a small curser `pointer` show
              In case action is not specified
              @ts-expect-error */
          cursor: "default",
          ...t.onClick !== void 0 ? {
            cursor: "pointer",
            ":hover": {
              border: `1px solid ${e.custom.grey[500]}`,
              backgroundColor: e.custom.grey[300]
            },
            ":active": {
              border: `1px solid ${e.custom.grey[500]}`,
              backgroundColor: e.custom.grey[500]
            },
            ":disabled": {
              border: `1px solid ${e.custom.grey[500]}`,
              backgroundColor: e.custom.grey[100],
              color: e.custom.grey[1400]
            }
          } : {
            ":hover": {
              cursor: "default",
              backgroundColor: e.custom.grey[400]
            }
          }
        },
        ...t.variant === "tags-red" && {
          padding: e.spacing(0, 1),
          border: `1px solid ${e.custom.grey[400]}`,
          borderRadius: "4px",
          backgroundColor: e.custom.red[100],
          color: e.custom.red[600],
          height: "24px",
          /* This is because of a small curser `pointer` show
              In case action is not specified
              @ts-expect-error */
          cursor: "default",
          ...t.onClick !== void 0 ? {
            cursor: "pointer",
            ":hover": {
              border: `1px solid ${e.custom.grey[500]}`,
              backgroundColor: e.custom.grey[300]
            },
            ":active": {
              border: `1px solid ${e.custom.grey[500]}`,
              backgroundColor: e.custom.grey[500]
            },
            ":disabled": {
              border: `1px solid ${e.custom.grey[500]}`,
              backgroundColor: e.custom.grey[100],
              color: e.custom.grey[1400]
            }
          } : {
            ":hover": {
              cursor: "default",
              backgroundColor: e.custom.grey[400]
            }
          }
        },
        ...t.variant === "tags-green" && {
          padding: e.spacing(0, 1),
          borderRadius: "4px",
          height: "24px",
          border: `1px solid ${e.custom.grey[400]}`,
          backgroundColor: e.custom.green[100],
          color: e.custom.green[600],
          /* This is because of a small curser `pointer` show
              In case action is not specified
              @ts-expect-error */
          cursor: "default",
          ...t.onClick !== void 0 ? {
            cursor: "pointer",
            ":hover": {
              border: `1px solid ${e.custom.grey[400]}`,
              backgroundColor: e.custom.green[100],
              color: e.custom.green[600]
            },
            ":active": {
              border: `1px solid ${e.custom.grey[500]}`,
              backgroundColor: e.custom.grey[500]
            },
            ":disabled": {
              border: `1px solid ${e.custom.grey[500]}`,
              backgroundColor: e.custom.grey[100],
              color: e.custom.grey[1400]
            }
          } : {
            ":hover": {
              cursor: "default",
              backgroundColor: e.custom.grey[400]
            }
          }
        },
        ...t.variant === "icon-xs-nobackground" && {
          padding: e.spacing(0.5),
          minWidth: "auto",
          width: "24px",
          height: "24px",
          color: e.custom.grey[2800],
          backgroundColor: "inherit",
          ":hover": {
            backgroundColor: e.custom.grey[600]
          },
          ":active": {
            backgroundColor: e.custom.grey[1e3]
          },
          ":disabled": {
            backgroundColor: "inherit",
            color: e.custom.grey[1400]
          }
        },
        ...t.variant === "icon-s-nobackground" && {
          padding: e.spacing(1),
          minWidth: "auto",
          width: "36px",
          height: "36px",
          color: e.custom.grey[2800],
          backgroundColor: "inherit",
          ":hover": {
            backgroundColor: e.custom.grey[600]
          },
          ":active": {
            backgroundColor: e.custom.grey[1e3]
          },
          ":disabled": {
            backgroundColor: "inherit",
            color: e.custom.grey[1400]
          }
        },
        ...t.variant === "icon-m-nobackground" && {
          padding: e.spacing(1),
          minWidth: "auto",
          width: "44px",
          height: "44px",
          color: e.custom.grey[2800],
          backgroundColor: "inherit",
          ":hover": {
            backgroundColor: e.custom.grey[600]
          },
          ":active": {
            backgroundColor: e.custom.grey[1e3]
          },
          ":disabled": {
            backgroundColor: "inherit",
            color: e.custom.grey[1400]
          }
        },
        ...t.variant === "icon-xs-withbackground" && {
          padding: e.spacing(0.5),
          minWidth: "auto",
          width: "24px",
          height: "24px",
          color: e.custom.grey[2800],
          background: "linear-gradient(180deg, #FFFFFF 0%, #F6F5F3 154.5%)",
          border: `1px solid ${e.custom.grey[500]}`,
          ":hover": {
            background: "none",
            backgroundColor: e.custom.grey[400]
          },
          ":active": {
            background: "none",
            backgroundColor: e.custom.grey[600],
            border: "none"
          },
          ":disabled": {
            background: "none",
            backgroundColor: e.custom.grey[100],
            color: e.custom.grey[1400]
          }
        },
        ...t.variant === "icon-s-withbackground" && {
          padding: e.spacing(1),
          minWidth: "auto",
          width: "36px",
          height: "36px",
          color: e.custom.grey[2800],
          background: "linear-gradient(180deg, #FFFFFF 0%, #F6F5F3 154.5%)",
          border: `1px solid ${e.custom.grey[500]}`,
          ":hover": {
            background: "none",
            backgroundColor: e.custom.grey[400]
          },
          ":active": {
            background: "none",
            backgroundColor: e.custom.grey[600],
            border: "none"
          },
          ":disabled": {
            background: "none",
            backgroundColor: e.custom.grey[100],
            color: e.custom.grey[1400]
          }
        },
        ...t.variant === "icon-m-withbackground" && {
          padding: e.spacing(1),
          minWidth: "auto",
          width: "44px",
          height: "44px",
          color: e.custom.grey[2800],
          background: "linear-gradient(180deg, #FFFFFF 0%, #F6F5F3 154.5%)",
          border: `1px solid ${e.custom.grey[500]}`,
          ":hover": {
            background: "none",
            backgroundColor: e.custom.grey[400]
          },
          ":active": {
            background: "none",
            backgroundColor: e.custom.grey[600],
            border: "none"
          },
          ":disabled": {
            background: "none",
            backgroundColor: e.custom.grey[100],
            color: e.custom.grey[1400]
          }
        }
      })
    }
  },
  MuiButtonBase: {
    styleOverrides: {
      root: {
        borderRadius: "15px"
      }
    }
  },
  MuiCircularProgress: {
    styleOverrides: {
      root: ({ theme: e }) => ({
        color: e.custom.grey[800]
      })
    }
  },
  MuiIconButton: {
    styleOverrides: {
      root: ({ theme: e }) => ({
        height: "44px",
        width: "44px",
        color: e.custom.grey[2800],
        backgroundColor: "inherit",
        ":hover": {
          backgroundColor: e.custom.grey[600]
        },
        ":focus": {
          backgroundColor: e.custom.grey[1e3]
        },
        ":disabled": {
          backgroundColor: "inherit",
          color: e.custom.grey[1400]
        }
      })
    }
  },
  MuiInputBase: {
    styleOverrides: {}
  }
}, D3 = {
  fontFamily: ["Montserrat", "serif"].join(","),
  h1: {
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "2rem",
    lineHeight: "3.2rem",
    color: Ee[2800]
  },
  h2: {
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "1.5rem",
    lineHeight: "2.4rem",
    color: Ee[2800]
  },
  h3: {
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "1.125rem",
    lineHeight: "1.8rem",
    color: Ee[2800]
  },
  h4: {
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "0.875rem",
    lineHeight: "1.4rem",
    color: Ee[2800]
  },
  h5: {
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "0.75rem",
    lineHeight: "1.2rem",
    color: Ee[2800]
  },
  h6: {
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "0.625rem",
    lineHeight: "1rem",
    color: Ee[2800]
  },
  "huge-bold": {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "1.125rem",
    lineHeight: "2.025rem",
    color: Ee[2800]
  },
  "huge-medium": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "1.125rem",
    lineHeight: "2.025rem",
    color: Ee[2800]
  },
  huge: {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1.125rem",
    lineHeight: "2.025rem",
    color: Ee[2800]
  },
  "big-bold": {
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "0.875rem",
    lineHeight: "1.575rem",
    color: Ee[2800]
  },
  "big-medium": {
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "0.875rem",
    lineHeight: "1.575rem",
    color: Ee[2800]
  },
  big: {
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "0.875rem",
    lineHeight: "1.575rem",
    color: Ee[2800]
  },
  "body-bold": {
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "0.75rem",
    lineHeight: "1.35rem",
    color: Ee[2800]
  },
  "body-medium": {
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "0.75rem",
    lineHeight: "1.35rem",
    color: Ee[2800]
  },
  body: {
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "0.75rem",
    lineHeight: "1.35rem",
    color: Ee[2800]
  },
  "small-bold": {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "0.625rem",
    lineHeight: "1.125rem",
    color: Ee[2800]
  },
  "small-medium": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "0.625rem",
    lineHeight: "1.125rem",
    color: Ee[2800]
  },
  small: {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "0.625rem",
    lineHeight: "1.125rem",
    color: Ee[2800]
  },
  "number-big": {
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "2rem",
    lineHeight: "3.2rem",
    color: Ee[2800]
  },
  "number-inter": {
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "1.5rem",
    lineHeight: "2.4rem",
    color: Ee[2800]
  },
  "number-small": {
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "0.875rem",
    lineHeight: "1.4rem",
    color: Ee[2800]
  },
  "number-micro": {
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "0.625rem",
    lineHeight: "1rem",
    color: Ee[2800]
  }
}, A3 = (e) => `${8 * e}px`, H3 = {
  grey: Ee,
  red: Qo,
  green: Qq,
  orange: eK,
  yellow: tK,
  shadows: nK,
  dataviz: {
    colors: Lw,
    extra: Iw,
    colorsWithExtra: jw,
    onlyMainFromAll: oK
  },
  searchBox: {
    borderRadius: "24px",
    border: (e) => "1px solid " + e.custom.grey[500],
    background: "white",
    boxShadow: (e) => "0px 2px 8px 0px " + e.custom.grey[500]
  },
  rowMenuElement: {
    marginLeft: "12px",
    paddingRight: "8px",
    fontSize: "12px",
    fontWeight: "600",
    lineHeight: "20px"
  }
}, $w = {
  palette: {
    primary: {
      50: "#F2F6FB",
      100: "#C4DCFA",
      200: "#95C3F8",
      300: "#67A9F7",
      400: "#388FF5",
      500: "#317FDB",
      600: "#2A6FC1",
      700: "#2360A6",
      800: "#1C508C",
      900: "#154072"
      // main: "linear-gradient(180deg, #388FF5 0%, #2A6FC1 100%)",
    },
    grey: Ee,
    text: { primary: "#393a36" },
    error: {
      light: Qo[100],
      main: Qo[600],
      dark: Qo[800]
    }
  },
  spacing: A3,
  typography: D3,
  custom: H3,
  components: V3
}, UK = La($w), Bw = {
  palette: {
    primary: {
      50: "#EDF9FA",
      100: "#BEEEF0",
      200: "#8EE2E7",
      300: "#5FD7DD",
      400: "#2FCBD4",
      500: "#00C0CA",
      600: "#01A4AD",
      700: "#018990",
      800: "#026D72",
      900: "#025155"
      // main: "linear-gradient(180deg, #2FCBD4 0%, #01A4AD 100%)",
    },
    grey: Ee,
    text: { primary: "#393a36" },
    error: {
      light: Qo[100],
      main: Qo[600],
      dark: Qo[800]
    }
  },
  spacing: A3,
  typography: D3,
  custom: H3,
  components: V3
}, zw = La(Bw), Zw = {
  palette: {
    primary: {
      50: "#FFF6E8",
      100: "#FDE6BA",
      200: "#FBD68B",
      300: "#FAC55D",
      400: "#F8B52E",
      500: "#F6A500",
      600: "#D38702",
      700: "#B06803",
      800: "#8D4A05",
      900: "#6A2B06"
      // main: "linear-gradient(180deg, #F8B52E 0%, #D38702 100%)",
    },
    grey: Ee,
    text: { primary: Ee[2800] },
    error: {
      light: Qo[100],
      main: Qo[600],
      dark: Qo[800]
    }
  },
  spacing: A3,
  typography: D3,
  custom: H3,
  components: V3
}, GK = La(Zw), Ww = {
  palette: {
    primary: {
      50: "#FFEDED",
      100: "#FCCBCB",
      200: "#F9A8A8",
      300: "#F58686",
      400: "#F26363",
      500: "#EF4141",
      600: "#CD2436",
      700: "#AA072B",
      800: "#900524",
      900: "#76031D"
      // main: "linear-gradient(180deg, #F26363 0%, #CD2436 100%)",
    },
    grey: Ee,
    text: { primary: "#393a36" },
    error: {
      light: Qo[100],
      main: Qo[600],
      dark: Qo[800]
    }
  },
  spacing: A3,
  typography: D3,
  custom: H3,
  components: V3
}, qK = La(Ww), Oxe = (e) => {
  const { theme: t = "foodpilot" } = e, o = { ...YK[t] };
  return e.typographyOverride !== void 0 && (o.typography = e.typographyOverride), /* @__PURE__ */ f.jsx(M4, { theme: o, children: e.children });
}, _xe = (e) => {
  const { theme: t = "foodpilot", themeOverride: n = {} } = e, o = XK[t], r = La(o, n);
  return /* @__PURE__ */ f.jsx(M4, { theme: r, children: e.children });
}, KK = ["foodpilot", "winepilot", "collective", "bred"], Pxe = (e) => KK.includes(e), YK = {
  foodpilot: GK,
  winepilot: qK,
  collective: zw,
  bred: UK
}, XK = {
  foodpilot: Zw,
  winepilot: Ww,
  collective: Bw,
  bred: $w
}, JK = B(I3)((e) => ({
  textTransform: "capitalize",
  border: `1px solid ${Ee[500]}`,
  background: Ee.gradientLight,
  color: Ee[2800],
  borderRadius: "8px",
  "&.Mui-selected": {
    border: `2px solid ${e.theme.palette.primary[600]}`,
    background: Ee.gradientLight,
    "&:hover": {
      border: `2px solid ${e.theme.palette.primary[600]}`,
      background: Ee.gradientLight
    }
  },
  "&:disabled": {
    border: `1px solid ${Ee[100]}`,
    background: Ee[500]
  },
  "&:hover": {
    border: `1px solid ${Ee[500]}`,
    background: Ee[400]
  }
})), Lxe = (e) => {
  const { choices: t, onClick: n, currentIndexSelected: o, ...r } = e, [i, s] = Ae(o ?? null), a = (c) => {
    if (n == null || n(c), c === i) {
      s(null);
      return;
    }
    s(c);
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: "1rem"
      },
      children: t.map((c, d) => /* @__PURE__ */ Yl(
        JK,
        {
          ...r,
          key: `${d}-button-toggle`,
          value: d,
          onClick: () => a(d),
          selected: d === i
        },
        /* @__PURE__ */ f.jsx(oe, { variant: "big-bold", color: "inherit", children: c })
      ))
    }
  );
}, QK = B(I3)(({ theme: e }) => ({
  textTransform: "none",
  background: e.custom.grey.gradientLight,
  color: e.custom.grey[2800],
  fontSize: "0.75rem",
  padding: "8px 14px",
  fontWeight: 700,
  borderRadius: "8px",
  "&.Mui-selected": {
    color: "#FFF",
    background: e.custom.grey.gradientDark,
    "&:hover": {
      color: "#FFF",
      background: e.custom.grey.gradientDark
    }
  },
  "&:disabled": {
    background: "linear-gradient(180deg, #FFFFFF 0%, #FEFCFB 100%)",
    color: "rgba(0, 0, 0, 0.26)"
  },
  "&:hover": {
    background: e.custom.grey[400]
  }
})), Ixe = vs((e, t) => {
  const { buttons: n, initialSelected: o, ToggleButtonProps: r, buttonGroup: i = !1, unselectable: s = !1, className: a } = e, [c, d] = Ae(o || null), u = ge(), p = (h) => (c == null ? void 0 : c.id) === h.id;
  return /* @__PURE__ */ f.jsx(
    J,
    {
      ref: t,
      display: "flex",
      sx: i ? {
        "& .MuiButtonBase-root": {
          borderRadius: 0,
          borderRight: "0 none",
          "&:hover": {
            borderRight: "0 none"
          }
        },
        "& .MuiButtonBase-root:first-child": {
          borderTopLeftRadius: "8px",
          borderBottomLeftRadius: "8px"
        },
        "& .MuiButtonBase-root:last-child": {
          borderTopRightRadius: "8px",
          borderBottomRightRadius: "8px",
          border: "1px solid",
          borderColor: Ee[500]
        }
      } : {
        gap: "8px"
      },
      className: a,
      children: n.map((h) => /* @__PURE__ */ Yl(
        QK,
        {
          ...r,
          key: `${h.id}-button-toggle`,
          value: h.id,
          onClick: () => {
            if (h.onClick && h.onClick(), s && (c == null ? void 0 : c.id) === h.id) {
              d(null);
              return;
            }
            d(h);
          },
          selected: p(h),
          disabled: h.disabled
        },
        /* @__PURE__ */ f.jsxs(be, { flexDirection: "row", justifyContent: "center", alignItems: "center", gap: u.spacing(0.5), children: [
          h.startIcon && /* @__PURE__ */ f.jsx(_t, { size: 2, icon: h.startIcon }),
          h.label,
          h.endIcon && /* @__PURE__ */ f.jsx(_t, { size: 2, icon: h.endIcon })
        ] })
      ))
    }
  );
}), eY = B(({ className: e, ...t }) => /* @__PURE__ */ f.jsx(ln, { ...t, arrow: !0, classes: { popper: e } })), tY = eY((e) => ({
  [`& .${Io.arrow}`]: {
    color: e.theme.custom.grey[200]
  },
  [`& .${Io.tooltip}`]: {
    color: e.theme.custom.grey[2800],
    padding: "12px 16px 12px 16px",
    borderRadius: "8px",
    border: `1px solid ${e.theme.custom.grey[500]}`,
    backgroundColor: e.theme.custom.grey[200]
  }
})), nY = (e) => {
  const {
    buttonProps: t,
    tooltip: n,
    icon: o,
    size: r,
    withBackground: i = !1
  } = e, a = `icon-${r}-${i ? "withbackground" : "nobackground"}`, c = {
    xs: 1,
    s: 2,
    m: 4
  }, d = (n == null ? void 0 : n.props) || {};
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx(
    tY,
    {
      title: n == null ? void 0 : n.text,
      arrow: !0,
      ...d,
      children: /* @__PURE__ */ f.jsx(at, { variant: a, ...t, children: /* @__PURE__ */ f.jsx(
        _t,
        {
          icon: o,
          size: c[r]
        }
      ) })
    }
  ) });
}, oY = (e) => /* @__PURE__ */ y.createElement("svg", { width: 192, height: 40, viewBox: "0 0 192 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("g", { clipPath: "url(#clip0_133_2544)" }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M98.6073 40H103.902L103.965 39.9911C104.112 39.9911 104.253 39.9328 104.357 39.8289C104.461 39.7251 104.519 39.5843 104.519 39.4375V32.3839C104.519 32.3029 104.537 32.2229 104.571 32.1496C104.606 32.0762 104.656 32.0112 104.718 31.9593C104.78 31.9074 104.853 31.8697 104.932 31.849C105.01 31.8282 105.092 31.8249 105.172 31.8393C106.577 32.0995 108.001 32.2398 109.429 32.2589C117.229 32.2589 121.951 27.8214 121.951 21.3304C121.951 14.2768 116.996 10.4018 110.628 10.4018C107.498 10.4018 104.734 11.6607 103.473 13.3929V11.4643C103.473 11.3175 103.414 11.1767 103.31 11.0729C103.206 10.969 103.065 10.9107 102.918 10.9107H98.6073C98.4602 10.9107 98.3191 10.969 98.2152 11.0729C98.1112 11.1767 98.0527 11.3175 98.0527 11.4643V39.4464C98.0527 39.5933 98.1112 39.7341 98.2152 39.8379C98.3191 39.9417 98.4602 40 98.6073 40ZM109.573 15.8036C112.9 15.8036 115.145 17.5804 115.145 21.0357L115.136 21.0268C115.136 24.9018 112.399 26.8661 108.821 26.8661C107.485 26.8838 106.155 26.694 104.877 26.3036C104.77 26.2632 104.679 26.1909 104.615 26.0966C104.551 26.0024 104.517 25.8907 104.519 25.7768V20.5179C104.519 17.7679 106.245 15.8036 109.573 15.8036Z", fill: "black" }), /* @__PURE__ */ y.createElement("path", { d: "M191.799 11.0755C191.693 10.97 191.55 10.9107 191.401 10.9107L173.021 10.9018C172.871 10.9018 172.728 10.9611 172.622 11.0665C172.517 11.172 172.457 11.3151 172.457 11.4643V15.4375C172.457 15.5852 172.515 15.7269 172.619 15.8321C172.723 15.9374 172.864 15.9977 173.012 16H176.169C176.317 16 176.459 16.058 176.564 16.1616C176.67 16.2652 176.73 16.406 176.733 16.5536V23.0179C176.733 30.4018 180.382 32.2679 186.75 32.2679C188.381 32.2337 190.002 32.0059 191.58 31.5893C191.699 31.5574 191.805 31.4865 191.879 31.3878C191.954 31.289 191.993 31.1683 191.991 31.0447V26.8482C191.993 26.7625 191.974 26.6776 191.937 26.6003C191.9 26.5229 191.846 26.4551 191.778 26.4023C191.711 26.3495 191.632 26.3131 191.547 26.296C191.463 26.2788 191.376 26.2814 191.293 26.3036C190.159 26.6002 188.995 26.7679 187.823 26.8036C184.827 26.8036 183.145 25.9197 183.145 22.9732V16.5714C183.145 16.4223 183.205 16.2792 183.31 16.1737C183.416 16.0682 183.559 16.0089 183.709 16.0089H191.401C191.55 16.0089 191.693 15.9497 191.799 15.8442C191.905 15.7387 191.964 15.5956 191.964 15.4464V11.4732C191.964 11.324 191.905 11.181 191.799 11.0755Z", fill: "black" }), /* @__PURE__ */ y.createElement("path", { d: "M146.967 26.2946C145.833 26.5907 144.669 26.7585 143.497 26.7946C140.501 26.7946 138.819 25.9018 138.819 22.9643V11.4643C138.819 11.3175 138.761 11.1767 138.657 11.0728C138.553 10.969 138.412 10.9107 138.265 10.9107H132.97C132.823 10.9107 132.682 10.969 132.578 11.0728C132.474 11.1767 132.415 11.3175 132.415 11.4643V23.0089C132.415 30.3929 136.064 32.2589 142.433 32.2589C144.064 32.2247 145.685 31.9969 147.262 31.5803C147.38 31.5468 147.484 31.4751 147.557 31.3766C147.629 31.278 147.667 31.1581 147.665 31.0357V26.8303C147.665 26.7454 147.645 26.6616 147.608 26.5853C147.57 26.5091 147.516 26.4425 147.448 26.3907C147.381 26.3389 147.302 26.3033 147.219 26.2866C147.136 26.27 147.049 26.2727 146.967 26.2946Z", fill: "black" }), /* @__PURE__ */ y.createElement("path", { d: "M123.552 11.4643V31.1786C123.552 31.3278 123.611 31.4708 123.717 31.5763C123.823 31.6818 123.966 31.7411 124.115 31.7411H129.357C129.506 31.7411 129.649 31.6818 129.755 31.5763C129.861 31.4708 129.92 31.3278 129.92 31.1786V11.4643C129.92 11.3151 129.861 11.172 129.755 11.0665C129.649 10.9611 129.506 10.9018 129.357 10.9018H124.115C123.966 10.9018 123.823 10.9611 123.717 11.0665C123.611 11.172 123.552 11.3151 123.552 11.4643Z", fill: "black" }), /* @__PURE__ */ y.createElement("path", { d: "M163.33 1.66074C163.44 1.47156 163.491 1.25407 163.478 1.03572H163.469C163.45 0.743503 163.317 0.470473 163.097 0.276369C162.878 0.0822657 162.59 -0.017105 162.297 7.09086e-07C162.079 0.0145412 161.869 0.0934282 161.695 0.226704C161.521 0.35998 161.391 0.541669 161.321 0.748836C161.25 0.956003 161.243 1.17936 161.299 1.39071C161.356 1.60206 161.474 1.79193 161.639 1.93634C161.803 2.08076 162.007 2.17325 162.224 2.20214C162.442 2.23103 162.663 2.19503 162.859 2.09867C163.056 2.00231 163.22 1.84993 163.33 1.66074Z", fill: "#AC0027" }), /* @__PURE__ */ y.createElement("path", { d: "M175.534 3.68749C175.561 4.13836 175.454 4.5872 175.226 4.97736C174.998 5.36752 174.66 5.68149 174.253 5.87964C173.846 6.0778 173.39 6.15124 172.942 6.09071C172.493 6.03018 172.073 5.83838 171.734 5.53953C171.394 5.24068 171.151 4.84818 171.035 4.41159C170.919 3.97499 170.936 3.51387 171.082 3.08645C171.228 2.65903 171.498 2.28447 171.858 2.01006C172.217 1.73565 172.65 1.57369 173.101 1.54463C173.708 1.50795 174.305 1.71285 174.761 2.11447C175.217 2.5161 175.495 3.08172 175.534 3.68749Z", fill: "#AC0027" }), /* @__PURE__ */ y.createElement("path", { d: "M169.238 4.66965C169.258 5.00289 169.179 5.33474 169.011 5.62322C168.843 5.91171 168.592 6.14385 168.292 6.29028C167.991 6.43671 167.654 6.49085 167.323 6.44584C166.991 6.40083 166.681 6.2587 166.43 6.03744C166.18 5.81617 166.001 5.52571 165.916 5.20281C165.831 4.87992 165.843 4.53909 165.952 4.22347C166.062 3.90785 166.262 3.63162 166.528 3.42973C166.795 3.22784 167.115 3.10936 167.449 3.0893C167.896 3.06242 168.335 3.21375 168.671 3.51006C169.006 3.80636 169.21 4.22341 169.238 4.66965Z", fill: "#AC0027" }), /* @__PURE__ */ y.createElement("path", { d: "M159.059 4.69642C159.068 4.87191 159.024 5.04597 158.934 5.19678C158.843 5.3476 158.711 5.46848 158.552 5.54428C158.393 5.62008 158.215 5.64744 158.041 5.62293C157.867 5.59842 157.704 5.52312 157.572 5.40648C157.441 5.28983 157.346 5.13702 157.301 4.96718C157.256 4.79733 157.262 4.618 157.319 4.45165C157.376 4.28529 157.48 4.1393 157.62 4.03196C157.759 3.92463 157.927 3.86071 158.102 3.84821C158.221 3.83974 158.341 3.8551 158.454 3.89339C158.567 3.93167 158.671 3.9921 158.76 4.07113C158.849 4.15016 158.921 4.24619 158.973 4.35357C159.024 4.46096 159.054 4.57753 159.059 4.69642Z", fill: "#AC0027" }), /* @__PURE__ */ y.createElement("path", { d: "M169.857 1.40694C169.917 1.30242 169.944 1.18253 169.935 1.06249C169.924 0.902954 169.85 0.754387 169.729 0.649063C169.609 0.543739 169.451 0.490168 169.291 0.499987C169.171 0.507376 169.056 0.550296 168.96 0.623297C168.864 0.696299 168.792 0.796088 168.753 0.909992C168.714 1.0239 168.71 1.14678 168.741 1.26303C168.772 1.37928 168.837 1.48366 168.928 1.56291C169.019 1.64216 169.131 1.6927 169.251 1.70812C169.37 1.72354 169.492 1.70315 169.6 1.64952C169.708 1.5959 169.797 1.51146 169.857 1.40694Z", fill: "#AC0027" }), /* @__PURE__ */ y.createElement("path", { d: "M164.426 3.97321C164.431 4.05106 164.413 4.1287 164.374 4.19624C164.335 4.26378 164.276 4.31816 164.206 4.35244C164.136 4.38673 164.057 4.39937 163.979 4.38875C163.902 4.37813 163.83 4.34474 163.771 4.29282C163.713 4.24091 163.671 4.17282 163.652 4.09725C163.632 4.02168 163.636 3.94204 163.662 3.86849C163.688 3.79493 163.736 3.73079 163.798 3.68425C163.861 3.6377 163.936 3.61086 164.014 3.60714C164.117 3.60223 164.218 3.63783 164.295 3.70627C164.372 3.77472 164.419 3.87057 164.426 3.97321Z", fill: "#AC0027" }), /* @__PURE__ */ y.createElement("path", { d: "M169.143 14.7018C169.496 14.5619 169.8 14.3208 170.016 14.0089C170.16 13.8005 170.261 13.5657 170.314 13.318C170.367 13.0702 170.37 12.8145 170.324 12.5655C170.277 12.3165 170.182 12.0792 170.043 11.8672C169.904 11.6552 169.725 11.4728 169.515 11.3303C169.201 11.1172 168.831 11.0016 168.451 10.9982C168.071 10.9948 167.699 11.1037 167.381 11.3111C167.063 11.5186 166.814 11.8153 166.665 12.1639C166.516 12.5125 166.474 12.8974 166.543 13.27C166.613 13.6427 166.792 13.9864 167.057 14.2578C167.322 14.5292 167.661 14.7162 168.033 14.7952C168.404 14.8743 168.791 14.8418 169.143 14.7018Z", fill: "#AC0027" }), /* @__PURE__ */ y.createElement("path", { d: "M174.693 7.7143C174.7 7.8341 174.671 7.95323 174.61 8.05667C174.549 8.1601 174.459 8.24319 174.351 8.29545C174.243 8.3477 174.122 8.36678 174.002 8.35027C173.883 8.33376 173.772 8.28241 173.682 8.20269C173.592 8.12297 173.528 8.01846 173.498 7.90237C173.467 7.78627 173.472 7.66379 173.511 7.5504C173.551 7.437 173.623 7.33777 173.719 7.26524C173.814 7.19271 173.929 7.15012 174.049 7.14287C174.209 7.13305 174.367 7.18662 174.487 7.29195C174.608 7.39727 174.682 7.54584 174.693 7.70537V7.7143Z", fill: "#AC0027" }), /* @__PURE__ */ y.createElement("path", { d: "M170.715 9.54951C170.809 9.37601 170.849 9.17846 170.83 8.98214C170.805 8.72551 170.68 8.4887 170.483 8.322C170.286 8.15529 170.032 8.07181 169.774 8.08929C169.577 8.10265 169.388 8.17443 169.232 8.29545C169.076 8.41646 168.96 8.5812 168.898 8.76858C168.837 8.95596 168.832 9.15746 168.886 9.34729C168.94 9.53712 169.049 9.70664 169.2 9.83416C169.35 9.96169 169.536 10.0414 169.732 10.0631C169.928 10.0848 170.127 10.0476 170.302 9.95607C170.477 9.86457 170.621 9.72301 170.715 9.54951Z", fill: "#AC0027" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M170.74 15.3125C170.166 15.8523 169.417 16.1691 168.629 16.2054C168.079 16.2364 167.529 16.1301 167.029 15.8961C166.529 15.6621 166.096 15.3077 165.768 14.8649C165.439 14.4221 165.227 13.9048 165.149 13.3594C165.071 12.8141 165.129 12.258 165.32 11.7411C165.451 11.3826 165.527 11.0062 165.544 10.625C165.57 9.72516 165.237 8.85183 164.618 8.19712C164.311 7.87295 163.944 7.6122 163.537 7.42978C163.129 7.24736 162.69 7.14683 162.243 7.13393C161.797 7.12103 161.353 7.19602 160.935 7.35461C160.518 7.5132 160.136 7.75229 159.811 8.05823C159.156 8.67609 158.772 9.52873 158.746 10.4286C152.19 10.8929 147.361 15.1071 147.361 21.4107C147.361 28.2321 152.933 32.25 159.999 32.25C167.064 32.25 172.618 28.2411 172.618 21.4286C172.65 19.2505 172.003 17.1164 170.767 15.3214L170.74 15.3125ZM165.231 23.6339H162.485C162.438 23.6339 162.392 23.6527 162.358 23.6862C162.325 23.7197 162.306 23.7651 162.306 23.8125V26.7143C162.306 27.033 162.24 27.3481 162.111 27.6398C161.982 27.9314 161.794 28.1931 161.559 28.4081C161.323 28.6231 161.045 28.7868 160.743 28.8887C160.44 28.9906 160.12 29.0285 159.802 29C159.212 28.9229 158.671 28.6301 158.284 28.1783C157.898 27.7264 157.693 27.1476 157.709 26.5536V23.7857C157.709 23.7422 157.692 23.7004 157.662 23.6688C157.632 23.6372 157.591 23.6184 157.548 23.6161H154.623C154.304 23.6161 153.988 23.5498 153.696 23.4213C153.404 23.2928 153.142 23.105 152.927 22.8698C152.711 22.6346 152.547 22.3572 152.445 22.0553C152.343 21.7533 152.305 21.4335 152.334 21.1161C152.41 20.5362 152.695 20.004 153.137 19.6193C153.578 19.2347 154.145 19.024 154.731 19.0268H157.485C157.508 19.0268 157.53 19.0224 157.55 19.0139C157.571 19.0053 157.59 18.9929 157.605 18.9771C157.621 18.9613 157.634 18.9426 157.642 18.9221C157.651 18.9015 157.655 18.8794 157.655 18.8571V15.9464C157.655 15.6278 157.722 15.3126 157.85 15.021C157.979 14.7293 158.167 14.4677 158.403 14.2526C158.638 14.0376 158.916 13.8739 159.219 13.772C159.521 13.6701 159.842 13.6322 160.16 13.6607C160.746 13.735 161.285 14.0214 161.674 14.4657C162.063 14.91 162.275 15.4813 162.27 16.0714V18.8304C162.27 18.873 162.287 18.9139 162.317 18.944C162.348 18.9741 162.389 18.9911 162.431 18.9911H165.356C165.675 18.991 165.991 19.0574 166.283 19.1859C166.575 19.3144 166.837 19.5022 167.053 19.7374C167.268 19.9725 167.432 20.25 167.534 20.5519C167.636 20.8538 167.674 21.1737 167.646 21.4911C167.567 22.0794 167.273 22.618 166.82 23.0035C166.368 23.389 165.789 23.5944 165.195 23.5804L165.231 23.6339Z", fill: "#AC0027" }), /* @__PURE__ */ y.createElement("path", { d: "M71.337 19.4911V31.1786C71.337 31.3301 71.2766 31.4755 71.1693 31.5826C71.062 31.6898 70.9164 31.75 70.7645 31.75H65.4876C65.3358 31.75 65.1902 31.6898 65.0828 31.5826C64.9755 31.4755 64.9152 31.3301 64.9152 31.1786V20.5357C64.9152 17.4554 63.1264 15.8214 59.9066 15.8214C56.9104 15.8214 54.7101 17.6072 54.7101 20.7232V31.1786C54.7101 31.3301 54.6498 31.4755 54.5425 31.5826C54.4351 31.6898 54.2895 31.75 54.1377 31.75H48.8787C48.7269 31.75 48.5813 31.6898 48.4739 31.5826C48.3666 31.4755 48.3063 31.3301 48.3063 31.1786V11.4732C48.3063 11.3217 48.3666 11.1763 48.4739 11.0692C48.5813 10.962 48.7269 10.9018 48.8787 10.9018H53.1718C53.3236 10.9018 53.4692 10.962 53.5765 11.0692C53.6839 11.1763 53.7442 11.3217 53.7442 11.4732V13.3304C55.1931 11.5982 57.7242 10.3839 61.1319 10.3839C67.0796 10.3839 71.337 13.0625 71.337 19.4911Z", fill: "#AC0027" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M80.6029 23.7857C80.4956 23.756 80.382 23.7581 80.2759 23.7919C80.1698 23.8257 80.0759 23.8896 80.0057 23.9758C79.9354 24.062 79.8919 24.1668 79.8804 24.2774C79.8689 24.3879 79.89 24.4994 79.941 24.5982C80.9159 26.5179 83.4113 27.4911 86.5864 27.4911C89.3501 27.5159 92.0954 27.0409 94.6896 26.0893C94.7763 26.0543 94.8702 26.041 94.9632 26.0506C95.0562 26.0602 95.1454 26.0924 95.223 26.1444C95.3007 26.1964 95.3644 26.2665 95.4086 26.3487C95.4528 26.431 95.4762 26.5227 95.4767 26.6161V30.2768C95.4779 30.3916 95.4444 30.5042 95.3806 30.5997C95.3167 30.6953 95.2256 30.7694 95.1189 30.8125C92.1725 31.8556 89.0584 32.346 85.9335 32.2589C78.9661 32.2589 72.7411 28.6875 72.7411 21.2768C72.7411 15.25 77.7945 10.3929 85.4237 10.3929C91.9706 10.3929 96.3711 13.0714 96.3711 17.7768C96.3711 21.5625 92.6772 24.3661 85.048 24.3661C83.5395 24.3599 82.0375 24.168 80.576 23.7946L80.6029 23.7857ZM79.6816 18.6161C79.6521 18.7484 79.6722 18.8869 79.7381 19.0054C79.8041 19.1239 79.9113 19.2141 80.0394 19.2589C81.5466 19.7167 83.1149 19.9425 84.6903 19.9286C88.6703 19.9286 90.164 18.9018 90.164 17.3125C90.164 15.8661 88.6167 14.6964 85.4863 14.6964C82.5169 14.6964 80.2362 16.4107 79.6816 18.6161Z", fill: "#AC0027" }), /* @__PURE__ */ y.createElement("path", { d: "M39.2281 31.1875V11.4643C39.2281 11.3151 39.2875 11.172 39.3932 11.0665C39.4988 10.9611 39.6422 10.9018 39.7916 10.9018H45.0328C45.1822 10.9018 45.3255 10.9611 45.4312 11.0665C45.5369 11.172 45.5962 11.3151 45.5962 11.4643V31.1875C45.5962 31.3367 45.5369 31.4798 45.4312 31.5853C45.3255 31.6907 45.1822 31.75 45.0328 31.75H39.7916C39.6422 31.75 39.4988 31.6907 39.3932 31.5853C39.2875 31.4798 39.2281 31.3367 39.2281 31.1875Z", fill: "#AC0027" }), /* @__PURE__ */ y.createElement("path", { d: "M31.2055 11.2857L26.9481 23.7857C26.9079 23.893 26.8358 23.9855 26.7415 24.0507C26.6472 24.116 26.5352 24.151 26.4204 24.151C26.3057 24.151 26.1937 24.116 26.0994 24.0507C26.0051 23.9855 25.933 23.893 25.8927 23.7857L21.5639 11.2857C21.5264 11.1759 21.4553 11.0806 21.3606 11.0133C21.2659 10.946 21.1524 10.9101 21.0362 10.9107H16.8772C16.7613 10.9114 16.6484 10.9479 16.554 11.015C16.4596 11.0821 16.3882 11.1766 16.3495 11.2857L11.9402 23.7857C11.8999 23.893 11.8278 23.9855 11.7335 24.0507C11.6392 24.116 11.5272 24.151 11.4125 24.151C11.2977 24.151 11.1857 24.116 11.0914 24.0507C10.9971 23.9855 10.925 23.893 10.8848 23.7857L6.66323 11.2857C6.62459 11.1766 6.55319 11.0821 6.45876 11.015C6.36432 10.9479 6.25145 10.9114 6.13554 10.9107H0.56345C0.472531 10.9101 0.382853 10.9318 0.302315 10.9739C0.221777 11.016 0.152849 11.0773 0.101603 11.1523C0.0503558 11.2272 0.0183622 11.3136 0.00843937 11.4039C-0.00148343 11.4941 0.010969 11.5854 0.0447 11.6696L7.61129 31.3839C7.65228 31.4883 7.72355 31.578 7.81598 31.6417C7.90841 31.7053 8.01777 31.7399 8.13004 31.7411H14.3908C14.5013 31.7426 14.6097 31.711 14.7021 31.6506C14.7946 31.5901 14.8668 31.5035 14.9096 31.4018L18.4871 23.0625C18.5316 22.9634 18.6038 22.8793 18.695 22.8203C18.7863 22.7613 18.8927 22.7299 19.0014 22.7299C19.1102 22.7299 19.2166 22.7613 19.3078 22.8203C19.3991 22.8793 19.4713 22.9634 19.5157 23.0625L23.1469 31.4018C23.1891 31.5021 23.26 31.5878 23.3507 31.6481C23.4413 31.7084 23.5478 31.7408 23.6568 31.7411H29.9175C30.0313 31.7417 30.1426 31.7079 30.2368 31.6442C30.331 31.5804 30.4037 31.4897 30.4452 31.3839L37.976 11.6696C38.0075 11.5853 38.0183 11.4946 38.0074 11.4053C37.9965 11.3159 37.9643 11.2305 37.9135 11.1561C37.8627 11.0817 37.7947 11.0206 37.7153 10.9779C37.6359 10.9352 37.5475 10.9122 37.4573 10.9107H31.7332C31.6169 10.9101 31.5035 10.946 31.4088 11.0133C31.3141 11.0806 31.243 11.1759 31.2055 11.2857Z", fill: "#AC0027" })), /* @__PURE__ */ y.createElement("defs", null, /* @__PURE__ */ y.createElement("clipPath", { id: "clip0_133_2544" }, /* @__PURE__ */ y.createElement("rect", { width: 192, height: 40, fill: "white" })))), rY = (e) => /* @__PURE__ */ y.createElement("svg", { width: 60, height: 32, viewBox: "0 0 60 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...e }, /* @__PURE__ */ y.createElement("rect", { width: 60, height: 32, fill: "url(#pattern0)" }), /* @__PURE__ */ y.createElement("defs", null, /* @__PURE__ */ y.createElement("pattern", { id: "pattern0", patternContentUnits: "objectBoundingBox", width: 1, height: 1 }, /* @__PURE__ */ y.createElement("use", { xlinkHref: "#image0_920_5256", transform: "translate(0 -0.00675676) scale(0.00337838 0.00633446)" })), /* @__PURE__ */ y.createElement("image", { id: "image0_920_5256", width: 296, height: 160, xlinkHref: "data:image/png;base64,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" }))), jxe = (e) => {
  const { t } = ja();
  return /* @__PURE__ */ f.jsxs(to, { container: !0, children: [
    /* @__PURE__ */ f.jsx(to, { item: !0, xs: 12, md: 6, children: /* @__PURE__ */ f.jsxs(
      J,
      {
        sx: {
          mx: "5rem",
          my: "3rem",
          display: "flex",
          flexDirection: "column"
        },
        children: [
          /* @__PURE__ */ f.jsx(J, { sx: { width: "120px" }, children: /* @__PURE__ */ f.jsx(ps, { component: oY, inheritViewBox: !0, sx: { width: "192px", height: "40px" } }) }),
          /* @__PURE__ */ f.jsxs(
            J,
            {
              sx: {
                flexDirection: "row",
                display: "flex",
                alignItems: "center"
              },
              children: [
                /* @__PURE__ */ f.jsx(oe, { variant: "body2", sx: { mr: "1rem" }, children: t("En partenariat avec") }),
                /* @__PURE__ */ f.jsx(ps, { component: rY, inheritViewBox: !0, sx: { width: "60px", height: "32px" } })
              ]
            }
          ),
          /* @__PURE__ */ f.jsx(oe, { component: "h1", variant: "h1", sx: { mt: "3rem" }, children: e.title }),
          /* @__PURE__ */ f.jsx(oe, { variant: "body2", sx: { mt: "2rem" }, children: e.introduction }),
          /* @__PURE__ */ f.jsx(
            at,
            {
              variant: "contained",
              sx: {
                mt: "2rem",
                borderBottomLeftRadius: "20px",
                borderBottomRightRadius: "20px",
                borderTopLeftRadius: "20px",
                borderTopRightRadius: "20px",
                textTransform: "none",
                fontWeight: "700"
              },
              href: "/login",
              children: t("Commencer à réduire mon empreinte carbone")
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ f.jsx(
      to,
      {
        item: !0,
        xs: !1,
        md: 6,
        sx: {
          backgroundImage: "url('/images/vigneron.jpg')",
          backgroundRepeat: "no-repeat",
          backgroundColor: (n) => n.palette.mode === "light" ? n.palette.grey[50] : n.custom.grey[900],
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative"
        },
        children: /* @__PURE__ */ f.jsx(
          W4,
          {
            style: {
              borderRadius: "10px",
              textAlign: "center",
              width: "60%",
              left: 0,
              right: 0,
              marginLeft: "auto",
              marginRight: "auto",
              position: "absolute",
              bottom: "10%"
            },
            children: /* @__PURE__ */ f.jsxs(U4, { children: [
              /* @__PURE__ */ f.jsxs(J, { sx: { mb: "1rem", display: "flex", flexDirection: "row" }, children: [
                /* @__PURE__ */ f.jsx(oe, { variant: "subtitle2", sx: { fontWeight: "bold", mr: "1rem" }, children: "Amaury Liemois" }),
                /* @__PURE__ */ f.jsxs(oe, { variant: "body2", children: [
                  "Bourgogne, Pommard",
                  " "
                ] })
              ] }),
              /* @__PURE__ */ f.jsx(J, { sx: { textAlign: "left" }, children: /* @__PURE__ */ f.jsxs(oe, { variant: "h2", color: "secondary.main", children: [
                "- 46 TCO",
                /* @__PURE__ */ f.jsx("sub", { children: "2" }),
                " / an"
              ] }) }),
              /* @__PURE__ */ f.jsx(J, { sx: { textAlign: "left" }, children: /* @__PURE__ */ f.jsx(
                at,
                {
                  sx: {
                    textTransform: "none",
                    m: "0",
                    p: "0"
                  },
                  children: t("Découvrir son histoire")
                }
              ) })
            ] })
          }
        )
      }
    )
  ] });
}, $c = (e) => {
  const { text: t, defaultVariant: n, typographyProps: o } = e;
  return typeof t == "string" ? /* @__PURE__ */ f.jsx(oe, { variant: n, ...o, children: t }) : t;
}, h7 = (e) => {
  const t = ge(), { step: n, extra: o = {}, orientation: r = "horizontal", valueFormatterFn: i } = e, { value: s, unit: a, label: c } = n, d = (u) => i ? i(u) : u.toLocaleString();
  return /* @__PURE__ */ f.jsxs(
    J,
    {
      sx: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        ...o
      },
      children: [
        /* @__PURE__ */ f.jsx(J, { sx: {
          display: "flex",
          flexDirection: "column"
        }, children: /* @__PURE__ */ f.jsx(
          $c,
          {
            text: c,
            defaultVariant: "body-bold",
            typographyProps: { textAlign: r === "vertical" ? "left" : "center" }
          }
        ) }),
        /* @__PURE__ */ f.jsxs(J, { sx: {
          display: "flex",
          flexDirection: "row",
          justifyContent: r === "horizontal" ? "center" : "flex-start",
          alignItems: "baseline",
          gap: "8px",
          zIndex: 2
        }, children: [
          s === null ? /* @__PURE__ */ f.jsx(V0, { size: 4, icon: "empty", boxProps: { sx: {
            borderRadius: "3px",
            backgroundColor: t.custom.grey[400],
            color: t.custom.grey[1400]
          } } }) : /* @__PURE__ */ f.jsx(oe, { variant: "h2", children: d(s) }),
          /* @__PURE__ */ f.jsx(oe, { variant: "body-medium", sx: { color: "#A3A2A0" }, children: a })
        ] }),
        e.children
      ]
    }
  );
}, Uw = B(to)(({ theme: e }) => ({
  border: `1px solid ${e.custom.grey[500]}`,
  borderRadius: e.spacing(2),
  position: "relative",
  background: "white",
  zIndex: 3
})), iY = B(J)(({ orientation: e = "horizontal" }) => ({
  position: "absolute",
  left: e === "horizontal" ? "100%" : "50%",
  top: e === "horizontal" ? "50%" : "100%",
  transform: "translate(-50%, -50%)",
  whiteSpace: "nowrap",
  zIndex: 3
})), sY = B(J)(({ orientation: e = "horizontal" }) => ({
  position: "absolute",
  left: "100%",
  top: "50%",
  transform: "translate(-50%, -50%)",
  whiteSpace: "nowrap",
  zIndex: 3
})), aY = B(to)({
  display: "flex",
  flexDirection: "column"
}), lY = B(to)(({ theme: e }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  gap: e.spacing(2)
})), Gw = (e) => {
  const t = ge(), { fullHeight: n, valueFormatterFn: o } = e;
  return /* @__PURE__ */ f.jsx(
    h7,
    {
      ...e,
      valueFormatterFn: o,
      extra: {
        padding: e.orientation === "vertical" ? t.spacing(2.5, 3) : n ? t.spacing(4, 6) : t.spacing(3, 6),
        borderBottom: n ? "inherit" : `1px solid ${t.custom.grey[500]}`,
        borderRight: e.orientation === "vertical" ? "" : `1px solid ${t.custom.grey[500]}`,
        borderRadius: t.spacing(2),
        marginBottom: `-${t.spacing(1.5)}`,
        boxShadow: "0px 4px 20px rgba(81, 78, 78, 0.12)",
        background: t.custom.grey.gradientLight,
        position: "relative",
        zIndex: 1,
        textAlign: e.orientation === "vertical" ? "left" : "center",
        height: n ? "100%" : "inherit",
        justifyContent: n ? "center" : "inherit",
        ...e.extra
      },
      orientation: e.orientation,
      children: e.children
    }
  );
}, qw = (e) => {
  const t = ge(), { valueFormatterFn: n } = e;
  return /* @__PURE__ */ f.jsx(
    h7,
    {
      ...e,
      valueFormatterFn: n,
      extra: {
        padding: e.orientation === "vertical" ? t.spacing(4.5, 3) : t.spacing(3, 6),
        backgroundColor: "white",
        borderRadius: `0 0 ${t.spacing(2)} ${t.spacing(2)}`,
        borderRight: e.orientation === "vertical" ? "" : `1px solid ${t.custom.grey[500]}`,
        boxShadow: "0px 4px 20px rgba(81, 78, 78, 0.12)",
        paddingTop: t.spacing(4),
        paddingBottom: t.spacing(2),
        position: "relative",
        zIndex: 0,
        textAlign: e.orientation === "vertical" ? "left" : "center"
      },
      orientation: e.orientation,
      children: e.children
    }
  );
}, cY = (e) => {
  const { percentageDifference: t, comparedTo: n, comparisonText: o, iconName: r, colors: i, disableText: s } = e;
  return /* @__PURE__ */ f.jsxs(be, { direction: "row", alignItems: "center", gap: "2px", flexWrap: "wrap", className: "comparison-block-wrapper", children: [
    /* @__PURE__ */ f.jsxs(
      J,
      {
        sx: {
          border: `1px solid ${i.primaryColor}`,
          background: i.secondaryColor,
          width: "fit-content",
          padding: "3px 7px",
          display: "flex",
          borderRadius: "20px",
          alignItems: "center",
          gap: "2px",
          color: i.primaryColor,
          marginRight: "6px"
        },
        children: [
          /* @__PURE__ */ f.jsx(_t, { icon: r, size: 1 }),
          t && /* @__PURE__ */ f.jsx(J, { display: "flex", alignItems: "center", flexDirection: "row", gap: "8px", children: /* @__PURE__ */ f.jsx(oe, { component: "span", variant: "h6", children: t }) })
        ]
      }
    ),
    !s && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      o !== void 0 && (n == null ? void 0 : n.label) !== void 0 && /* @__PURE__ */ f.jsxs(oe, { variant: "body", children: [
        o,
        " ",
        /* @__PURE__ */ f.jsx(oe, { variant: "body-bold", children: n.label })
      ] }),
      (n == null ? void 0 : n.value) !== void 0 && (n == null ? void 0 : n.unit) !== void 0 && /* @__PURE__ */ f.jsxs(be, { flexDirection: "row", children: [
        /* @__PURE__ */ f.jsx(oe, { variant: "body", children: "(" }),
        /* @__PURE__ */ f.jsx(ms, { value: n.value, unit: n.unit, position: "default-side", size: "small" }),
        /* @__PURE__ */ f.jsx(oe, { variant: "body", children: ")" })
      ] })
    ] })
  ] });
}, dY = (e) => {
  const { currentValue: t, previousValue: n, improvement: o, layout: r } = e, i = ge(), s = {
    primaryColor: i.custom.green[500],
    secondaryColor: i.custom.green[100]
  }, a = {
    primaryColor: i.custom.red[500],
    secondaryColor: i.custom.red[100]
  };
  if (t === n)
    return {
      color: {
        primaryColor: i.custom.grey[2800],
        secondaryColor: i.custom.grey[300]
      },
      icon: "equal"
    };
  const c = r.size === "M" && r.direction === "horizontal", d = c ? "plus" : "arrowUpRight", u = c ? "minus" : "arrowDownRight", p = t > n, h = p ? d : u;
  return o === "increase" ? {
    color: p ? s : a,
    icon: h
  } : {
    color: p ? a : s,
    icon: h
  };
}, uY = (e) => {
  const { percentageDifference: t, comparedTo: n, comparisonText: o, iconName: r, colors: i } = e;
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs(J, { display: "flex", alignItems: "center", gap: "8px", mb: "4px", children: [
      /* @__PURE__ */ f.jsx(
        V0,
        {
          icon: r,
          size: 3,
          boxProps: {
            sx: {
              backgroundColor: i.primaryColor,
              borderRadius: "32px",
              color: "#fff"
            }
          }
        }
      ),
      t && /* @__PURE__ */ f.jsx(ms, { value: t, unit: "", size: "inter" })
    ] }),
    o !== void 0 && (n == null ? void 0 : n.label) !== void 0 && /* @__PURE__ */ f.jsxs(oe, { variant: "body", children: [
      o,
      " ",
      /* @__PURE__ */ f.jsx(oe, { variant: "body-bold", children: n.label })
    ] }),
    (n == null ? void 0 : n.value) !== void 0 && (n == null ? void 0 : n.unit) !== void 0 && /* @__PURE__ */ f.jsxs(be, { flexDirection: "row", children: [
      /* @__PURE__ */ f.jsx(oe, { variant: "body", children: "(" }),
      /* @__PURE__ */ f.jsx(ms, { value: n.value, unit: n.unit, position: "default-side", size: "small" }),
      /* @__PURE__ */ f.jsx(oe, { variant: "body", children: ")" })
    ] })
  ] });
}, fY = (e) => {
  const { percentageDifference: t, comparedTo: n, iconName: o, colors: r, comparisonText: i } = e;
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs(J, { display: "flex", alignItems: "center", gap: "8px", children: [
      /* @__PURE__ */ f.jsx(
        V0,
        {
          icon: o,
          size: 0.5,
          boxProps: {
            sx: {
              backgroundColor: r.primaryColor,
              borderRadius: "32px",
              color: "#fff"
            }
          }
        }
      ),
      t && /* @__PURE__ */ f.jsx(ms, { value: t, unit: "", size: "small" })
    ] }),
    i !== void 0 && (n == null ? void 0 : n.label) !== void 0 && /* @__PURE__ */ f.jsxs(oe, { variant: "body", children: [
      i,
      " ",
      /* @__PURE__ */ f.jsx(oe, { variant: "body-bold", children: n.label })
    ] }),
    (n == null ? void 0 : n.value) !== void 0 && (n == null ? void 0 : n.unit) !== void 0 && /* @__PURE__ */ f.jsxs(be, { flexDirection: "row", children: [
      /* @__PURE__ */ f.jsx(oe, { variant: "body", children: "(" }),
      /* @__PURE__ */ f.jsx(ms, { value: n.value, unit: n.unit, position: "default-side", size: "small" }),
      /* @__PURE__ */ f.jsx(oe, { variant: "body", children: ")" })
    ] })
  ] });
}, pY = (e) => {
  const { percentageDifference: t, comparedTo: n, iconName: o, colors: r, comparisonText: i } = e;
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsxs(J, { display: "flex", alignItems: "center", flexDirection: "row", gap: "8px", mb: "4px", flexWrap: "wrap", children: [
    /* @__PURE__ */ f.jsx(
      V0,
      {
        icon: o,
        size: 3,
        boxProps: {
          sx: {
            backgroundColor: r.primaryColor,
            borderRadius: "32px",
            color: "#fff"
          }
        }
      }
    ),
    t && /* @__PURE__ */ f.jsx(oe, { component: "span", variant: "h2", children: t }),
    i !== void 0 && (n == null ? void 0 : n.label) !== void 0 && /* @__PURE__ */ f.jsxs(oe, { variant: "body", children: [
      i,
      " ",
      /* @__PURE__ */ f.jsx(oe, { variant: "body-bold", children: n.label })
    ] }),
    (n == null ? void 0 : n.value) !== void 0 && (n == null ? void 0 : n.unit) !== void 0 && /* @__PURE__ */ f.jsxs(be, { flexDirection: "row", children: [
      /* @__PURE__ */ f.jsx(oe, { variant: "body", children: "(" }),
      /* @__PURE__ */ f.jsx(ms, { value: n.value, unit: n.unit, position: "default-side", size: "small" }),
      /* @__PURE__ */ f.jsx(oe, { variant: "body", children: ")" })
    ] })
  ] }) });
}, hY = (e) => {
  const {
    percentageDifference: t,
    iconName: n,
    colors: o
  } = e;
  return /* @__PURE__ */ f.jsxs(be, { flexDirection: "row", alignItems: "center", gap: "2px", className: "comparison-block-wrapper", children: [
    /* @__PURE__ */ f.jsx(
      J,
      {
        sx: {
          border: `1px solid ${o.primaryColor}`,
          background: o.secondaryColor,
          width: "fit-content",
          padding: "1px",
          display: "flex",
          borderRadius: "20px",
          alignItems: "center",
          color: o.primaryColor,
          marginRight: "2px"
        },
        children: /* @__PURE__ */ f.jsx(_t, { icon: n, size: 0.1 })
      }
    ),
    t && /* @__PURE__ */ f.jsx(
      ms,
      {
        value: t,
        unit: "",
        size: "micro",
        colorOverride: o.primaryColor
      }
    )
  ] });
}, Kw = (e) => {
  var b, C, x, v, S, M;
  const {
    currentValue: t,
    comparedTo: n,
    comparisonText: o = "par rapport à",
    improvement: r,
    layout: i = {
      direction: "vertical",
      size: "L"
    },
    disableText: s = !1,
    // works only for horizontal-m;
    locale: a
  } = e, c = Number(n.value), d = dY({
    currentValue: t,
    previousValue: c,
    improvement: r,
    layout: i
  }), u = c > 0 ? Math.abs(100 - t / c * 100) : null, p = u !== null ? new Intl.NumberFormat(a, {
    style: "percent",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(u / 100) : "", h = new Intl.NumberFormat(a).format(c), g = {
    ...n,
    value: h
  }, m = {
    comparisonText: o,
    percentageDifference: p,
    comparedTo: g,
    iconName: d.icon,
    colors: d.color,
    disableText: s
  };
  if (i.direction === "vertical")
    return /* @__PURE__ */ f.jsxs(
      J,
      {
        sx: {
          borderRadius: "12px",
          background: d.color.secondaryColor,
          width: "fit-content",
          padding: ((b = e.layout) == null ? void 0 : b.size) === "M" ? "8px" : "16px"
        },
        className: "comparison-block-wrapper",
        children: [
          ((C = e.layout) == null ? void 0 : C.size) === "L" && /* @__PURE__ */ f.jsx(uY, { ...m }),
          ((x = e.layout) == null ? void 0 : x.size) === "M" && /* @__PURE__ */ f.jsx(fY, { ...m })
        ]
      }
    );
  if (i.direction === "horizontal") {
    if (((v = e.layout) == null ? void 0 : v.size) === "L")
      return /* @__PURE__ */ f.jsx(
        J,
        {
          sx: {
            borderRadius: "12px",
            background: d.color.secondaryColor,
            width: "fit-content",
            padding: "24px 16px"
          },
          className: "comparison-block-wrapper",
          children: /* @__PURE__ */ f.jsx(pY, { ...m })
        }
      );
    if (((S = e.layout) == null ? void 0 : S.size) === "M")
      return /* @__PURE__ */ f.jsx(cY, { ...m });
  }
  if (((M = e.layout) == null ? void 0 : M.size) === "S")
    return /* @__PURE__ */ f.jsx(hY, { ...m });
}, Yw = (e) => {
  const { value: t, comparedTo: n, improvement: o } = e;
  if (!(t === null || n === null))
    return /* @__PURE__ */ f.jsx(
      Kw,
      {
        layout: {
          size: "M",
          direction: "horizontal"
        },
        disableText: !0,
        currentValue: t,
        comparedTo: {
          value: n,
          unit: "",
          // not used
          label: ""
          // not used
        },
        improvement: o
      }
    );
}, Xw = ({
  currentValue: e,
  targetValue: t,
  orientation: n,
  improvement: o
}) => /* @__PURE__ */ f.jsx(iY, { orientation: n, children: /* @__PURE__ */ f.jsx(
  Yw,
  {
    value: t,
    comparedTo: e,
    improvement: o
  }
) }), gY = ({
  currentValue: e,
  targetValue: t,
  orientation: n,
  improvement: o
}) => /* @__PURE__ */ f.jsx(sY, { orientation: n, children: /* @__PURE__ */ f.jsx(
  Yw,
  {
    value: t,
    comparedTo: e,
    improvement: o
  }
) }), mY = (e) => {
  const t = ge(), { color: n, completionPercent: o, label: r, noObjectiveLabel: i, outsideContainer: s } = e, a = (c) => new Intl.NumberFormat(void 0, {
    style: "percent",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(c / 100);
  return /* @__PURE__ */ f.jsxs(
    J,
    {
      sx: {
        borderRadius: t.spacing(1),
        padding: t.spacing(0.5, 1),
        margin: s ? t.spacing(2, 0) : t.spacing(0.5, 5),
        backgroundColor: n.secondary,
        position: "relative",
        zIndex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: t.spacing(1)
      },
      children: [
        /* @__PURE__ */ f.jsx(J, { display: "flex", alignItems: "center", children: /* @__PURE__ */ f.jsx(_t, { icon: "target", size: 3 }) }),
        /* @__PURE__ */ f.jsx(J, { sx: {
          gap: t.spacing(0.5)
        }, children: o !== null ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          /* @__PURE__ */ f.jsxs(oe, { variant: "body-bold", children: [
            a(o),
            " ",
            " "
          ] }),
          /* @__PURE__ */ f.jsx(oe, { variant: "caption", color: t.custom.grey[1400], children: r })
        ] }) : /* @__PURE__ */ f.jsx(oe, { variant: "body-medium", color: t.custom.grey[1400], children: i }) })
      ]
    }
  );
}, Jw = (e) => {
  const t = ge(), { completionPercent: n, color: o, label: r, noObjectiveLabel: i } = e, s = (a) => new Intl.NumberFormat(void 0, {
    style: "percent",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(a / 100);
  return /* @__PURE__ */ f.jsxs(J, { sx: { display: "flex", alignItems: "center", justifyContent: "center", width: "100%", gap: t.spacing(1), marginTop: t.spacing(2) }, children: [
    /* @__PURE__ */ f.jsx(J, { display: "flex", alignItems: "center", children: /* @__PURE__ */ f.jsx(_t, { icon: "target", size: 8 }) }),
    /* @__PURE__ */ f.jsxs(J, { sx: {
      display: "flex",
      flexDirection: "column",
      gap: t.spacing(1),
      width: "100%"
    }, children: [
      /* @__PURE__ */ f.jsx(J, { sx: {
        display: "flex",
        alignItems: "center",
        gap: t.spacing(0.5)
      }, children: n !== null ? /* @__PURE__ */ f.jsxs(J, { lineHeight: "0px", sx: { marginBottom: t.spacing(0.25) }, children: [
        /* @__PURE__ */ f.jsxs(oe, { variant: "big-bold", children: [
          s(n),
          " ",
          " "
        ] }),
        /* @__PURE__ */ f.jsx(oe, { variant: "caption", color: t.custom.grey[1400], children: r })
      ] }) : /* @__PURE__ */ f.jsx(oe, { variant: "body-medium", color: t.custom.grey[1400], children: i }) }),
      n !== null && /* @__PURE__ */ f.jsx(J, { sx: {
        height: t.spacing(1.75),
        backgroundColor: o.secondary,
        borderRadius: t.spacing(1),
        position: "relative",
        overflow: "hidden"
      }, children: /* @__PURE__ */ f.jsx(J, { sx: {
        position: "absolute",
        left: 0,
        top: 0,
        height: "100%",
        width: `${n}%`,
        backgroundColor: o.primary,
        borderRadius: t.spacing(1),
        transition: "width 0.3s ease-in-out"
      } }) })
    ] })
  ] });
}, Zp = (e) => {
  const { orientation: t, ...n } = e, o = ge(), r = Qw(e.completionPercent, o);
  return t === "horizontal" ? /* @__PURE__ */ f.jsx(mY, { ...n, color: r }) : /* @__PURE__ */ f.jsx(Jw, { ...n, color: r });
}, Qw = (e, t) => {
  if (e === null) {
    const n = zw.palette.primary[50] || "#EDF9FA";
    return {
      primary: n,
      secondary: n
    };
  }
  return e <= 30 ? {
    primary: t.custom.red[600],
    secondary: t.custom.red[100]
  } : e > 30 && e <= 70 ? {
    primary: t.custom.orange[500],
    secondary: t.custom.orange[50]
  } : {
    primary: t.custom.green[600],
    secondary: t.custom.green[100]
  };
}, bY = (e) => {
  var a;
  const { steps: t, textOptions: n, improvement: o, completionPercentage: r, valueFormatterFn: i } = e, s = t.endWithoutAction === void 0;
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs(Uw, { container: !0, children: [
      /* @__PURE__ */ f.jsxs(aY, { item: !0, xs: 6, children: [
        /* @__PURE__ */ f.jsx(
          Gw,
          {
            step: t.start,
            isLast: !1,
            fullHeight: !t.endWithoutAction,
            valueFormatterFn: i,
            children: t.endWithAction && /* @__PURE__ */ f.jsx(
              Xw,
              {
                targetValue: t.endWithAction.value,
                currentValue: t.start.value,
                orientation: "horizontal",
                improvement: o
              }
            )
          }
        ),
        t.endWithoutAction && /* @__PURE__ */ f.jsx(
          qw,
          {
            step: t.endWithoutAction,
            isLast: !1,
            valueFormatterFn: i,
            children: t.endWithAction && /* @__PURE__ */ f.jsx(
              gY,
              {
                targetValue: t.endWithAction.value,
                currentValue: (a = t.endWithoutAction) == null ? void 0 : a.value,
                orientation: "horizontal",
                improvement: o,
                completionPercent: r
              }
            )
          }
        )
      ] }),
      /* @__PURE__ */ f.jsxs(lY, { item: !0, xs: 6, children: [
        t.endWithAction && /* @__PURE__ */ f.jsx(h7, { step: t.endWithAction, isLast: !0, valueFormatterFn: i }),
        s === !1 && /* @__PURE__ */ f.jsx(
          Zp,
          {
            label: n.goalStep,
            noObjectiveLabel: n.noGoalLabel,
            orientation: "horizontal",
            improvement: o,
            completionPercent: r,
            valueFormatterFn: i
          }
        )
      ] })
    ] }),
    s === !0 && /* @__PURE__ */ f.jsx(
      Zp,
      {
        label: n.goalStep,
        noObjectiveLabel: n.noGoalLabel,
        orientation: "horizontal",
        improvement: o,
        outsideContainer: !0,
        completionPercent: r,
        valueFormatterFn: i
      }
    )
  ] });
}, CY = (e) => {
  const { steps: t, textOptions: n, improvement: o, completionPercentage: r, valueFormatterFn: i } = e, s = ge(), a = t.endWithoutAction === void 0, c = t.endWithoutAction === void 0 ? t.start : t.endWithoutAction;
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs(
      Uw,
      {
        container: !0,
        sx: {
          background: a ? s.palette.primary[50] : void 0
        },
        children: [
          /* @__PURE__ */ f.jsx(
            Gw,
            {
              step: c,
              isLast: !1,
              orientation: "vertical",
              valueFormatterFn: i,
              children: /* @__PURE__ */ f.jsx(
                Xw,
                {
                  targetValue: t.endWithAction.value,
                  currentValue: c.value,
                  orientation: "vertical",
                  improvement: o
                }
              )
            }
          ),
          /* @__PURE__ */ f.jsx(
            qw,
            {
              step: t.endWithAction,
              isLast: !0,
              orientation: "vertical",
              valueFormatterFn: i
            }
          )
        ]
      }
    ),
    r !== null && /* @__PURE__ */ f.jsx(
      Zp,
      {
        label: n.goalStep,
        noObjectiveLabel: n.noGoalLabel,
        orientation: "vertical",
        improvement: o,
        completionPercent: r,
        valueFormatterFn: i
      }
    )
  ] });
}, Vxe = (e) => {
  const {
    position: t,
    goal: n = null,
    unit: o = "",
    textOptions: r = {
      startingStep: "",
      targetWithoutPlanStep: "",
      targetWithPlanStep: "",
      goalStep: ""
    },
    steps: i,
    improvement: s,
    valueFormatterFn: a
  } = e, c = xY(n, i), d = {
    start: {
      value: i.start,
      label: r.startingStep,
      unit: o
    },
    endWithAction: {
      label: r.targetWithPlanStep,
      value: i.endWithAction,
      unit: o
    },
    endWithoutAction: i.endWithoutAction === void 0 ? void 0 : {
      value: i.endWithoutAction,
      unit: o,
      label: r.targetWithoutPlanStep
    }
  };
  if (t === "vertical")
    return /* @__PURE__ */ f.jsx(J, { children: /* @__PURE__ */ f.jsx(
      CY,
      {
        improvement: s,
        steps: d,
        completionPercentage: c,
        textOptions: r,
        valueFormatterFn: a
      }
    ) });
  if (t === "horizontal")
    return /* @__PURE__ */ f.jsx(J, { sx: { width: "100%" }, children: /* @__PURE__ */ f.jsx(
      bY,
      {
        improvement: s,
        steps: d,
        completionPercentage: c,
        textOptions: r,
        valueFormatterFn: a
      }
    ) });
}, xY = (e, t) => {
  if (e === null) return null;
  const { start: n, endWithAction: o, endWithoutAction: r } = t, i = r === void 0 ? Gf(e, n) : Gf(r, e);
  if (i === null) return null;
  const s = Gf(r ?? n, o);
  if (s === null) return null;
  const a = yY({ partial: s, total: i });
  return Math.round(a);
}, yY = (e) => {
  const { partial: t, total: n } = e;
  return n === 0 ? 0 : t / n * 100;
}, Gf = (e, t) => e === null || t === null ? null : e - t, vY = (e) => {
  const { children: t, anchor: n, setAnchor: o, paperOverrides: r } = e, i = !!n;
  return /* @__PURE__ */ f.jsx(
    Ar,
    {
      open: i,
      anchorEl: n,
      onClose: () => o(null),
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left"
      },
      slotProps: {
        paper: {
          sx: {
            borderRadius: "12px",
            boxShadow: "0px 4px 20px 0px rgba(81, 78, 78, 0.12)",
            ...r
          }
        }
      },
      children: t
    }
  );
};
function g7(e) {
  return e.variant === "themed" ? /* @__PURE__ */ f.jsx(wY, { ...e }) : e.variant === "headless" ? /* @__PURE__ */ f.jsx(Cm, { ...e }) : /* @__PURE__ */ f.jsx(Cm, { ...e, variant: "themed" });
}
const Wp = {
  leftside: {
    anchorPosition: "left",
    anchorIndicatorPosition: "calc(100% - (1.5 * 30px))"
  },
  rightside: {
    anchorPosition: "right",
    anchorIndicatorPosition: "15px"
  },
  center: {
    anchorPosition: "center",
    anchorIndicatorPosition: "calc(50% - (30px / 2))"
  }
};
function wY(e) {
  const t = ge(), n = e.anchorPosition ? Wp[e.anchorPosition].anchorPosition : "right", o = e.anchorPosition ? Wp[e.anchorPosition].anchorIndicatorPosition : "15px";
  return /* @__PURE__ */ f.jsxs(
    Ar,
    {
      open: e.open,
      anchorEl: e.anchor,
      onClose: e.onClose,
      transformOrigin: { horizontal: "right", vertical: "top" },
      anchorOrigin: { horizontal: n, vertical: "bottom" },
      slotProps: {
        paper: {
          sx: {
            padding: "24px 20px",
            borderRadius: "12px",
            marginTop: 1.5,
            overflow: "visible",
            boxShadow: "0px 4px 20px 0px rgba(81, 78, 78, 0.12)",
            border: `1px solid ${t.custom.grey[500]}`,
            transform: n === "center" ? "translateX(50%) !important" : "none",
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: "-15px",
              right: o,
              width: 0,
              height: 0,
              borderLeft: "15px solid transparent",
              borderRight: "15px solid transparent",
              borderBottom: `15px solid ${t.custom.grey[500]}`,
              zIndex: -1
            },
            "&:after": {
              content: '""',
              display: "block",
              position: "absolute",
              top: -14,
              right: o,
              width: 0,
              height: 0,
              borderLeft: "15px solid transparent",
              borderRight: "15px solid transparent",
              borderBottom: "15px solid #fff",
              zIndex: 0
            }
          }
        }
      },
      sx: e.sx,
      children: [
        e.showCloseButton && /* @__PURE__ */ f.jsx(
          Bt,
          {
            disableRipple: !0,
            sx: {
              padding: "0",
              position: "absolute",
              right: "8px",
              top: "8px",
              background: "tranparent",
              width: "16px",
              height: "16px",
              "&:hover": {
                background: "transparent"
              }
            },
            onClick: e.onClose,
            children: /* @__PURE__ */ f.jsx(f7, {})
          }
        ),
        e.children
      ]
    }
  );
}
function Cm(e) {
  const t = e.anchorPosition ? Wp[e.anchorPosition].anchorPosition : "right";
  return /* @__PURE__ */ f.jsx(
    Ar,
    {
      open: e.open,
      anchorEl: e.anchor,
      onClose: e.onClose,
      transformOrigin: { horizontal: "right", vertical: "top" },
      anchorOrigin: { horizontal: t, vertical: "bottom" },
      slotProps: {
        paper: {
          sx: {
            //empêche la présence d'artefacts.
            //par défaut vaut 4px, ce qui interagit mal avec BigPopoverLayout qui a un borderRadius de 12px
            borderRadius: "12px",
            ...e.paperProps
          }
        }
      },
      sx: e.sx,
      children: e.children
    }
  );
}
const Bc = (e) => {
  const { buttonOptions: t, defaultOptions: n } = e;
  return typeof t == "object" && "label" in t ? /* @__PURE__ */ f.jsx(
    at,
    {
      onClick: t.onClick,
      ...n,
      children: t.label
    }
  ) : t;
}, Dxe = (e) => /* @__PURE__ */ f.jsxs(
  J,
  {
    component: "div",
    sx: {
      background: "white",
      width: e.width ?? "376px",
      borderRadius: "12px",
      border: "1px solid #E7E6E4",
      boxShadow: "0px 4px 20px 0px rgba(81, 78, 78, 0.12)"
    },
    children: [
      /* @__PURE__ */ f.jsxs(
        be,
        {
          direction: "row",
          useFlexGap: !0,
          alignItems: "center",
          justifyContent: "space-between",
          sx: {
            padding: "18px 16px"
          },
          children: [
            e.headerIcon ?? /* @__PURE__ */ f.jsx(dK, {}),
            /* @__PURE__ */ f.jsx(oe, { variant: "h4", sx: { height: "24px" }, children: e.headerText }),
            /* @__PURE__ */ f.jsx(Bt, { sx: { padding: "0" }, onClick: e.onClose, children: /* @__PURE__ */ f.jsx(f7, {}) })
          ]
        }
      ),
      /* @__PURE__ */ f.jsx(ho, {}),
      /* @__PURE__ */ f.jsx(
        J,
        {
          sx: {
            padding: "24px",
            height: "420px",
            overflow: "auto"
          },
          children: e.children
        }
      ),
      e.bottomActions && /* @__PURE__ */ f.jsx(
        SY,
        {
          onCancel: e.onCancel,
          onValidate: e.onValidate,
          validateLabel: e.validateLabel,
          cancelLabel: e.cancelLabel
        }
      )
    ]
  }
), SY = (e) => {
  const { t } = ja();
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(ho, {}),
    /* @__PURE__ */ f.jsxs(
      be,
      {
        direction: "row",
        useFlexGap: !0,
        justifyContent: "space-between",
        alignItems: "center",
        sx: { padding: "20px 32px" },
        children: [
          /* @__PURE__ */ f.jsx(
            Bc,
            {
              defaultOptions: { variant: "text" },
              buttonOptions: {
                onClick: () => e.onCancel && e.onCancel(),
                label: e.cancelLabel || t("Annuler")
              }
            }
          ),
          /* @__PURE__ */ f.jsx(
            Bc,
            {
              defaultOptions: { variant: "primary" },
              buttonOptions: {
                onClick: () => e.onValidate && e.onValidate(),
                label: e.validateLabel || t("Valider")
              }
            }
          )
        ]
      }
    )
  ] });
};
function MY(e) {
  const t = ge(), {
    content: n,
    onChange: o,
    defaultIndex: r,
    ...i
  } = e, [s, a] = Ae(r ?? 0);
  return /* @__PURE__ */ f.jsx(
    Hr,
    {
      borderRadius: "12px",
      boxShadow: "0 4px 20px 0 rgba(81, 78, 78, 0.12)",
      padding: "24px 28px",
      ...i,
      children: /* @__PURE__ */ f.jsx(be, { gap: "24px", children: n.map((c, d) => /* @__PURE__ */ f.jsxs(be, { gap: "16px", children: [
        /* @__PURE__ */ f.jsxs(be, { gap: "16px", children: [
          c.header && /* @__PURE__ */ f.jsx(oe, { variant: "h5", children: c.header }),
          /* @__PURE__ */ f.jsx(be, { gap: "12px", children: c.options.map((u, p) => {
            const h = u.id === s;
            return /* @__PURE__ */ f.jsxs(
              be,
              {
                direction: "row",
                alignItems: "center",
                gap: "6px",
                sx: {
                  cursor: u.disabled ? "default" : "pointer",
                  "&:hover > span": {
                    color: h ? t.palette.primary[600] : t.custom.grey[1500]
                  }
                },
                onClick: () => {
                  u.disabled || (a(u.id), u.onClick && u.onClick(u, c)) || o == null || o(u, c);
                },
                children: [
                  /* @__PURE__ */ f.jsx(
                    oe,
                    {
                      variant: "body",
                      sx: {
                        color: u.disabled ? t.custom.grey[1500] : h ? t.palette.primary[600] : t.custom.grey[2800],
                        fontWeight: h ? 600 : 500
                      },
                      children: u.label
                    }
                  ),
                  h && /* @__PURE__ */ f.jsx(lK, { sx: { color: t.palette.primary[600], width: "16px", height: "16px" } })
                ]
              },
              `option-${p}`
            );
          }) })
        ] }),
        d < n.length - 1 && /* @__PURE__ */ f.jsx(ho, { color: t.custom.grey[500] })
      ] }, `${d}-option-popover`)) })
    }
  );
}
const Axe = (e) => {
  const { size: t, icon: n, body: o } = e, [r, i] = Ae(null), s = () => {
    i(null);
  }, a = (d) => {
    i(d.currentTarget);
  }, c = !!r;
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      style: {
        position: "relative",
        width: "20px",
        height: "20px"
      },
      onMouseEnter: a,
      onMouseLeave: s,
      children: [
        n,
        /* @__PURE__ */ f.jsx(
          Ar,
          {
            sx: {
              pointerEvents: "none",
              left: "-2.375rem",
              top: "9px"
            },
            open: c,
            anchorEl: r,
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "center"
            },
            slotProps: {
              paper: {
                sx: {
                  position: "relative",
                  top: "10px",
                  width: t,
                  borderRadius: "12px",
                  boxShadow: "0px 4px 20px 0px rgba(81, 78, 78, 0.12)",
                  border: "1px solid #E7E6E4",
                  overflow: "visible",
                  backgroundColor: "#FFFFFF",
                  "&:before": {
                    content: '""',
                    // It is the top-left of my current Popover box.
                    position: "absolute",
                    // This means we have an arrow that's on the left of our tooltip.
                    // We could make those in a function that translates `left | center | right` to a number;
                    top: 18 / 2 * -1,
                    left: 28,
                    // Style of my Box Shape.
                    width: 18,
                    height: 18,
                    borderTop: "1px solid #E7E6E4",
                    borderRight: "1px solid #E7E6E4",
                    backgroundColor: "#FFFFFF",
                    // Rotate my box.
                    transform: "rotate(-45deg)"
                  }
                }
              }
            },
            children: o
          }
        )
      ]
    }
  );
}, F3 = (e) => {
  const { size: t, icon: n, body: o, leftPosition: r } = e, [i, s] = Ae(null), a = () => {
    s(null);
  }, c = (u) => {
    s(u.currentTarget);
  }, d = !!i;
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      style: {
        position: "relative"
      },
      onMouseEnter: c,
      onMouseLeave: a,
      children: [
        n,
        /* @__PURE__ */ f.jsx(
          Ar,
          {
            sx: {
              pointerEvents: "none",
              left: "-2.375rem",
              top: "9px"
            },
            open: d,
            anchorEl: i,
            disableAutoFocus: !0,
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "center"
            },
            slotProps: {
              paper: {
                sx: {
                  position: "relative",
                  top: "10px",
                  width: t,
                  borderRadius: "12px",
                  boxShadow: "0px 4px 20px 0px rgba(81, 78, 78, 0.12)",
                  border: "1px solid #E7E6E4",
                  overflow: "visible",
                  backgroundColor: "#FFFFFF",
                  "&:before": {
                    content: '""',
                    // It is the top-left of my current Popover box.
                    position: "absolute",
                    // This means we have an arrow that's on the left of our tooltip.
                    // We could make those in a function that translates `left | center | right` to a number;
                    top: 18 / 2 * -1,
                    left: r || 28,
                    // Style of my Box Shape.
                    width: 18,
                    height: 18,
                    borderTop: "1px solid #E7E6E4",
                    borderRight: "1px solid #E7E6E4",
                    backgroundColor: "#FFFFFF",
                    // Rotate my box.
                    transform: "rotate(-45deg)"
                  }
                }
              }
            },
            children: o
          }
        )
      ]
    }
  );
}, Hxe = (e) => {
  const { content: t, x: n, y: o, open: r, setOpen: i, transformOrigin: s, paperOverrides: a } = e, c = ge();
  return /* @__PURE__ */ f.jsx(
    Ar,
    {
      anchorReference: "anchorPosition",
      anchorPosition: {
        top: o,
        left: n
      },
      open: r,
      onClose: () => i(!1),
      transformOrigin: s || {
        vertical: "center",
        horizontal: "center"
      },
      slotProps: {
        paper: {
          sx: {
            minWidth: "340px",
            padding: "24px 20px",
            borderRadius: "12px",
            marginTop: 1.5,
            overflow: "visible",
            boxShadow: "0px 4px 20px 0px rgba(81, 78, 78, 0.12)",
            border: `1px solid ${c.custom.grey[500]}`,
            ...a
          }
        }
      },
      children: t
    }
  );
}, eS = (e) => ({
  "&:hover": {
    backgroundColor: e.custom.grey[600]
  },
  "&:active": {
    backgroundColor: e.custom.grey[1e3]
  },
  transition: "ease-in-out 0.2s all",
  borderRadius: e.spacing(2),
  display: "flex",
  alignItems: "center"
}), TY = (e) => {
  const { selectedItem: t } = e, n = ge();
  return /* @__PURE__ */ f.jsxs(be, { sx: {
    ...eS(n),
    padding: n.spacing(0, 1),
    marginLeft: n.spacing(-1),
    justifyContent: "space-between",
    gap: n.spacing(1),
    flexDirection: "row"
  }, children: [
    /* @__PURE__ */ f.jsx(oe, { variant: "body", children: t == null ? void 0 : t.label }),
    /* @__PURE__ */ f.jsx(_t, { size: 1, icon: "arrowDownShort" })
  ] });
}, kY = () => {
  const e = ge();
  return /* @__PURE__ */ f.jsx(J, { sx: {
    ...eS(e),
    width: e.spacing(4),
    height: e.spacing(4),
    justifyContent: "center"
  }, children: /* @__PURE__ */ f.jsx(_t, { size: 2, icon: "arrowDownShort" }) });
}, tS = (e) => {
  const {
    optionsProps: t,
    selectedItem: n,
    setSelectedItem: o,
    variant: r = "primary"
  } = e, [i, s] = Ae(null), a = !!i, c = (u) => {
    s(a ? null : u.currentTarget);
  }, d = (u) => {
    var h;
    o(Number(u.id));
    const p = Number(u.id);
    (h = t.onChange) == null || h.call(t, p), s(null);
  };
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs(
      be,
      {
        direction: "row",
        alignItems: "center",
        gap: "4px",
        onClick: c,
        sx: { cursor: "pointer" },
        children: [
          r === "primary" && /* @__PURE__ */ f.jsx(TY, { selectedItem: n }),
          r === "secondary" && /* @__PURE__ */ f.jsx(kY, {})
        ]
      }
    ),
    a && /* @__PURE__ */ f.jsx(
      vY,
      {
        anchor: i,
        setAnchor: s,
        paperOverrides: void 0,
        children: /* @__PURE__ */ f.jsx(
          MY,
          {
            content: t.content,
            onChange: d,
            defaultIndex: n == null ? void 0 : n.id,
            minWidth: "287px"
          }
        )
      }
    )
  ] });
}, nS = (e, t) => ({
  padding: t.noExtraSpacing ? "none" : e.spacing(2, 4),
  justifyContent: "space-between"
}), EY = (e, t) => ({
  ...nS(e, t),
  padding: e.spacing(2, 2),
  paddingLeft: e.spacing(3),
  paddingBottom: e.spacing(2),
  gap: "4px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  width: "100%"
}), xm = (e) => {
  const { selectedItem: t, optionsProps: n, variant: o, orientation: r, extraStyle: i } = e, s = ge();
  return /* @__PURE__ */ f.jsxs(
    be,
    {
      sx: nS(s, i),
      flexDirection: r === "horizontal" ? "row" : "column",
      divider: r === "horizontal" && /* @__PURE__ */ f.jsx(
        J,
        {
          sx: {
            borderLeft: `1px solid ${s.custom.grey[500]}`,
            height: "100%",
            marginInline: s.spacing()
          }
        }
      ),
      children: [
        /* @__PURE__ */ f.jsx(be, { gap: s.spacing(1), children: /* @__PURE__ */ f.jsx(oe, { variant: "h3", children: t == null ? void 0 : t.group }) }),
        /* @__PURE__ */ f.jsx(
          tS,
          {
            selectedItem: t,
            setSelectedItem: e.setSelectedItem,
            optionsProps: n,
            variant: o,
            orientation: r
          }
        )
      ]
    }
  );
}, RY = (e) => {
  const { selectedItem: t, optionsProps: n, variant: o, orientation: r, extraStyle: i } = e, s = ge();
  return /* @__PURE__ */ f.jsxs(be, { sx: EY(s, i), children: [
    /* @__PURE__ */ f.jsxs(J, { children: [
      /* @__PURE__ */ f.jsx(oe, { variant: "h3", children: t == null ? void 0 : t.group }),
      /* @__PURE__ */ f.jsx(oe, { variant: "body", children: t == null ? void 0 : t.label })
    ] }),
    /* @__PURE__ */ f.jsx(
      tS,
      {
        selectedItem: t,
        setSelectedItem: e.setSelectedItem,
        optionsProps: n,
        variant: o,
        orientation: r
      }
    )
  ] });
}, OY = {
  noExtraSpacing: !1
}, _Y = (e) => {
  const {
    selectedItemId: t,
    options: n,
    variant: o = "primary",
    orientation: r = "vertical",
    extraStyle: i = {}
  } = e, s = {
    ...OY,
    ...i
  }, a = Object.groupBy(n, (h) => h.group), c = {
    content: Object.entries(a).flatMap(
      ([h, g]) => g ? [{ header: h, options: g }] : []
    ),
    onChange: () => {
    }
    // We don't want to use this `onChange` in this component.
    // Only the `onClick` from the Button.
  }, [d, u] = Ae(null), p = (h) => {
    const g = n.find((m) => m.id === h);
    u(g ?? null);
  };
  return mt(() => {
    if (t === void 0) {
      if (n.length > 0) {
        u(n[0]);
        return;
      }
      return;
    }
    p(t);
  }, [t]), /* @__PURE__ */ f.jsxs(
    be,
    {
      flexDirection: "row",
      justifyContent: "space-between",
      position: "relative",
      children: [
        o === "primary" && /* @__PURE__ */ f.jsx(
          xm,
          {
            selectedItem: d,
            setSelectedItem: p,
            optionsProps: c,
            orientation: r,
            variant: o,
            extraStyle: s
          }
        ),
        o === "secondary" && r === "vertical" && /* @__PURE__ */ f.jsx(
          RY,
          {
            selectedItem: d,
            setSelectedItem: p,
            optionsProps: c,
            orientation: r,
            variant: o,
            extraStyle: s
          }
        ),
        o === "secondary" && r === "horizontal" && // This is done as a placeholder waiting for Design team validation
        /* @__PURE__ */ f.jsx(
          xm,
          {
            selectedItem: d,
            setSelectedItem: p,
            optionsProps: c,
            orientation: r,
            variant: "primary",
            extraStyle: s
          }
        )
      ]
    }
  );
}, Fxe = (e) => {
  const { header: t, children: n, seeMoreText: o = "Voir plus de détail", soonAvailableText: r, disableFooter: i = !1 } = e, s = ge();
  return /* @__PURE__ */ f.jsxs(Hr, { sx: { flex: "0 0 calc(33.33% - 14px)", minWidth: "fit-content" }, children: [
    /* @__PURE__ */ f.jsxs(J, { sx: { height: "70%" }, children: [
      /* @__PURE__ */ f.jsx(be, { sx: {
        ...t.variant === "secondary" && {
          backgroundColor: s.custom.grey[200],
          borderTopLeftRadius: s.spacing(2),
          borderTopRightRadius: s.spacing(2),
          borderBottom: `1px solid ${s.custom.grey[500]}`
        }
      }, children: /* @__PURE__ */ f.jsx(_Y, { ...t }) }),
      /* @__PURE__ */ f.jsx(be, { padding: "28px 32px", paddingBottom: "37px", gap: "40px", children: n })
    ] }),
    i === !1 && /* @__PURE__ */ f.jsxs(
      be,
      {
        direction: "row",
        alignItems: "center",
        gap: s.spacing(3.5),
        padding: s.spacing(3.5, 4),
        borderTop: `1px solid ${s.custom.grey[500]}`,
        children: [
          /* @__PURE__ */ f.jsx(
            at,
            {
              variant: "ternary",
              endIcon: /* @__PURE__ */ f.jsx(_t, { size: 2, icon: "arrowRight" }),
              disabled: e.moreDetailAction === void 0,
              onClick: e.moreDetailAction,
              sx: {
                width: "100%",
                justifyContent: "space-between",
                fontWeight: 700
              },
              children: o
            }
          ),
          r !== void 0 && /* @__PURE__ */ f.jsx(FK, { soonAvailableText: r })
        ]
      }
    )
  ] });
}, Nxe = (e) => {
  const {
    children: t,
    hidden: n = null,
    defaultVisible: o = !0,
    seeMoreText: r,
    seeLessText: i
  } = e, s = ge(), [a, c] = Ae(o), d = a ? {
    icon: /* @__PURE__ */ f.jsx(_t, { size: 2, icon: "arrowUpShort" }),
    label: i
  } : {
    icon: /* @__PURE__ */ f.jsx(_t, { size: 2, icon: "arrowDownShort" }),
    label: r
  };
  return /* @__PURE__ */ f.jsxs(
    be,
    {
      padding: s.spacing(4),
      gap: s.spacing(3),
      border: `1px solid ${s.custom.grey[500]}`,
      borderRadius: "12px",
      height: "content-fit",
      children: [
        t,
        a && n,
        n !== null && /* @__PURE__ */ f.jsx(be, { flexDirection: "row", justifyContent: "center", children: /* @__PURE__ */ f.jsx(
          at,
          {
            variant: "text",
            endIcon: d.icon,
            onClick: () => c(!a),
            children: d.label
          }
        ) })
      ]
    }
  );
};
/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */
function D0(e) {
  return e + 0.5 | 0;
}
const Xi = (e, t, n) => Math.max(Math.min(e, n), t);
function W2(e) {
  return Xi(D0(e * 2.55), 0, 255);
}
function as(e) {
  return Xi(D0(e * 255), 0, 255);
}
function vi(e) {
  return Xi(D0(e / 2.55) / 100, 0, 1);
}
function ym(e) {
  return Xi(D0(e * 100), 0, 100);
}
const or = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, Up = [..."0123456789ABCDEF"], PY = (e) => Up[e & 15], LY = (e) => Up[(e & 240) >> 4] + Up[e & 15], g1 = (e) => (e & 240) >> 4 === (e & 15), IY = (e) => g1(e.r) && g1(e.g) && g1(e.b) && g1(e.a);
function jY(e) {
  var t = e.length, n;
  return e[0] === "#" && (t === 4 || t === 5 ? n = {
    r: 255 & or[e[1]] * 17,
    g: 255 & or[e[2]] * 17,
    b: 255 & or[e[3]] * 17,
    a: t === 5 ? or[e[4]] * 17 : 255
  } : (t === 7 || t === 9) && (n = {
    r: or[e[1]] << 4 | or[e[2]],
    g: or[e[3]] << 4 | or[e[4]],
    b: or[e[5]] << 4 | or[e[6]],
    a: t === 9 ? or[e[7]] << 4 | or[e[8]] : 255
  })), n;
}
const VY = (e, t) => e < 255 ? t(e) : "";
function DY(e) {
  var t = IY(e) ? PY : LY;
  return e ? "#" + t(e.r) + t(e.g) + t(e.b) + VY(e.a, t) : void 0;
}
const AY = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function oS(e, t, n) {
  const o = t * Math.min(n, 1 - n), r = (i, s = (i + e / 30) % 12) => n - o * Math.max(Math.min(s - 3, 9 - s, 1), -1);
  return [r(0), r(8), r(4)];
}
function HY(e, t, n) {
  const o = (r, i = (r + e / 60) % 6) => n - n * t * Math.max(Math.min(i, 4 - i, 1), 0);
  return [o(5), o(3), o(1)];
}
function FY(e, t, n) {
  const o = oS(e, 1, 0.5);
  let r;
  for (t + n > 1 && (r = 1 / (t + n), t *= r, n *= r), r = 0; r < 3; r++)
    o[r] *= 1 - t - n, o[r] += t;
  return o;
}
function NY(e, t, n, o, r) {
  return e === r ? (t - n) / o + (t < n ? 6 : 0) : t === r ? (n - e) / o + 2 : (e - t) / o + 4;
}
function m7(e) {
  const n = e.r / 255, o = e.g / 255, r = e.b / 255, i = Math.max(n, o, r), s = Math.min(n, o, r), a = (i + s) / 2;
  let c, d, u;
  return i !== s && (u = i - s, d = a > 0.5 ? u / (2 - i - s) : u / (i + s), c = NY(n, o, r, u, i), c = c * 60 + 0.5), [c | 0, d || 0, a];
}
function b7(e, t, n, o) {
  return (Array.isArray(t) ? e(t[0], t[1], t[2]) : e(t, n, o)).map(as);
}
function C7(e, t, n) {
  return b7(oS, e, t, n);
}
function $Y(e, t, n) {
  return b7(FY, e, t, n);
}
function BY(e, t, n) {
  return b7(HY, e, t, n);
}
function rS(e) {
  return (e % 360 + 360) % 360;
}
function zY(e) {
  const t = AY.exec(e);
  let n = 255, o;
  if (!t)
    return;
  t[5] !== o && (n = t[6] ? W2(+t[5]) : as(+t[5]));
  const r = rS(+t[2]), i = +t[3] / 100, s = +t[4] / 100;
  return t[1] === "hwb" ? o = $Y(r, i, s) : t[1] === "hsv" ? o = BY(r, i, s) : o = C7(r, i, s), {
    r: o[0],
    g: o[1],
    b: o[2],
    a: n
  };
}
function ZY(e, t) {
  var n = m7(e);
  n[0] = rS(n[0] + t), n = C7(n), e.r = n[0], e.g = n[1], e.b = n[2];
}
function WY(e) {
  if (!e)
    return;
  const t = m7(e), n = t[0], o = ym(t[1]), r = ym(t[2]);
  return e.a < 255 ? `hsla(${n}, ${o}%, ${r}%, ${vi(e.a)})` : `hsl(${n}, ${o}%, ${r}%)`;
}
const vm = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, wm = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function UY() {
  const e = {}, t = Object.keys(wm), n = Object.keys(vm);
  let o, r, i, s, a;
  for (o = 0; o < t.length; o++) {
    for (s = a = t[o], r = 0; r < n.length; r++)
      i = n[r], a = a.replace(i, vm[i]);
    i = parseInt(wm[s], 16), e[a] = [i >> 16 & 255, i >> 8 & 255, i & 255];
  }
  return e;
}
let m1;
function GY(e) {
  m1 || (m1 = UY(), m1.transparent = [0, 0, 0, 0]);
  const t = m1[e.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const qY = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function KY(e) {
  const t = qY.exec(e);
  let n = 255, o, r, i;
  if (t) {
    if (t[7] !== o) {
      const s = +t[7];
      n = t[8] ? W2(s) : Xi(s * 255, 0, 255);
    }
    return o = +t[1], r = +t[3], i = +t[5], o = 255 & (t[2] ? W2(o) : Xi(o, 0, 255)), r = 255 & (t[4] ? W2(r) : Xi(r, 0, 255)), i = 255 & (t[6] ? W2(i) : Xi(i, 0, 255)), {
      r: o,
      g: r,
      b: i,
      a: n
    };
  }
}
function YY(e) {
  return e && (e.a < 255 ? `rgba(${e.r}, ${e.g}, ${e.b}, ${vi(e.a)})` : `rgb(${e.r}, ${e.g}, ${e.b})`);
}
const qf = (e) => e <= 31308e-7 ? e * 12.92 : Math.pow(e, 1 / 2.4) * 1.055 - 0.055, Ya = (e) => e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
function XY(e, t, n) {
  const o = Ya(vi(e.r)), r = Ya(vi(e.g)), i = Ya(vi(e.b));
  return {
    r: as(qf(o + n * (Ya(vi(t.r)) - o))),
    g: as(qf(r + n * (Ya(vi(t.g)) - r))),
    b: as(qf(i + n * (Ya(vi(t.b)) - i))),
    a: e.a + n * (t.a - e.a)
  };
}
function b1(e, t, n) {
  if (e) {
    let o = m7(e);
    o[t] = Math.max(0, Math.min(o[t] + o[t] * n, t === 0 ? 360 : 1)), o = C7(o), e.r = o[0], e.g = o[1], e.b = o[2];
  }
}
function iS(e, t) {
  return e && Object.assign(t || {}, e);
}
function Sm(e) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(e) ? e.length >= 3 && (t = { r: e[0], g: e[1], b: e[2], a: 255 }, e.length > 3 && (t.a = as(e[3]))) : (t = iS(e, { r: 0, g: 0, b: 0, a: 1 }), t.a = as(t.a)), t;
}
function JY(e) {
  return e.charAt(0) === "r" ? KY(e) : zY(e);
}
let sS = class Gp {
  constructor(t) {
    if (t instanceof Gp)
      return t;
    const n = typeof t;
    let o;
    n === "object" ? o = Sm(t) : n === "string" && (o = jY(t) || GY(t) || JY(t)), this._rgb = o, this._valid = !!o;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = iS(this._rgb);
    return t && (t.a = vi(t.a)), t;
  }
  set rgb(t) {
    this._rgb = Sm(t);
  }
  rgbString() {
    return this._valid ? YY(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? DY(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? WY(this._rgb) : void 0;
  }
  mix(t, n) {
    if (t) {
      const o = this.rgb, r = t.rgb;
      let i;
      const s = n === i ? 0.5 : n, a = 2 * s - 1, c = o.a - r.a, d = ((a * c === -1 ? a : (a + c) / (1 + a * c)) + 1) / 2;
      i = 1 - d, o.r = 255 & d * o.r + i * r.r + 0.5, o.g = 255 & d * o.g + i * r.g + 0.5, o.b = 255 & d * o.b + i * r.b + 0.5, o.a = s * o.a + (1 - s) * r.a, this.rgb = o;
    }
    return this;
  }
  interpolate(t, n) {
    return t && (this._rgb = XY(this._rgb, t._rgb, n)), this;
  }
  clone() {
    return new Gp(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = as(t), this;
  }
  clearer(t) {
    const n = this._rgb;
    return n.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, n = D0(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = n, this;
  }
  opaquer(t) {
    const n = this._rgb;
    return n.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return b1(this._rgb, 2, t), this;
  }
  darken(t) {
    return b1(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return b1(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return b1(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return ZY(this._rgb, t), this;
  }
};
/*!
 * Chart.js v4.4.7
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */
function fi() {
}
const QY = /* @__PURE__ */ (() => {
  let e = 0;
  return () => e++;
})();
function It(e) {
  return e == null;
}
function fn(e) {
  if (Array.isArray && Array.isArray(e))
    return !0;
  const t = Object.prototype.toString.call(e);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function Dt(e) {
  return e !== null && Object.prototype.toString.call(e) === "[object Object]";
}
function kn(e) {
  return (typeof e == "number" || e instanceof Number) && isFinite(+e);
}
function Bo(e, t) {
  return kn(e) ? e : t;
}
function yt(e, t) {
  return typeof e > "u" ? t : e;
}
const eX = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 : +e / t, aS = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 * t : +e;
function rn(e, t, n) {
  if (e && typeof e.call == "function")
    return e.apply(n, t);
}
function en(e, t, n, o) {
  let r, i, s;
  if (fn(e))
    for (i = e.length, r = 0; r < i; r++)
      t.call(n, e[r], r);
  else if (Dt(e))
    for (s = Object.keys(e), i = s.length, r = 0; r < i; r++)
      t.call(n, e[s[r]], s[r]);
}
function Jd(e, t) {
  let n, o, r, i;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (n = 0, o = e.length; n < o; ++n)
    if (r = e[n], i = t[n], r.datasetIndex !== i.datasetIndex || r.index !== i.index)
      return !1;
  return !0;
}
function Qd(e) {
  if (fn(e))
    return e.map(Qd);
  if (Dt(e)) {
    const t = /* @__PURE__ */ Object.create(null), n = Object.keys(e), o = n.length;
    let r = 0;
    for (; r < o; ++r)
      t[n[r]] = Qd(e[n[r]]);
    return t;
  }
  return e;
}
function lS(e) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(e) === -1;
}
function tX(e, t, n, o) {
  if (!lS(e))
    return;
  const r = t[e], i = n[e];
  Dt(r) && Dt(i) ? ai(r, i, o) : t[e] = Qd(i);
}
function ai(e, t, n) {
  const o = fn(t) ? t : [
    t
  ], r = o.length;
  if (!Dt(e))
    return e;
  n = n || {};
  const i = n.merger || tX;
  let s;
  for (let a = 0; a < r; ++a) {
    if (s = o[a], !Dt(s))
      continue;
    const c = Object.keys(s);
    for (let d = 0, u = c.length; d < u; ++d)
      i(c[d], e, s, n);
  }
  return e;
}
function sc(e, t) {
  return ai(e, t, {
    merger: nX
  });
}
function nX(e, t, n) {
  if (!lS(e))
    return;
  const o = t[e], r = n[e];
  Dt(o) && Dt(r) ? sc(o, r) : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = Qd(r));
}
const Mm = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (e) => e,
  // default resolvers
  x: (e) => e.x,
  y: (e) => e.y
};
function oX(e) {
  const t = e.split("."), n = [];
  let o = "";
  for (const r of t)
    o += r, o.endsWith("\\") ? o = o.slice(0, -1) + "." : (n.push(o), o = "");
  return n;
}
function rX(e) {
  const t = oX(e);
  return (n) => {
    for (const o of t) {
      if (o === "")
        break;
      n = n && n[o];
    }
    return n;
  };
}
function bs(e, t) {
  return (Mm[t] || (Mm[t] = rX(t)))(e);
}
function x7(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const zc = (e) => typeof e < "u", Cs = (e) => typeof e == "function", Tm = (e, t) => {
  if (e.size !== t.size)
    return !1;
  for (const n of e)
    if (!t.has(n))
      return !1;
  return !0;
};
function iX(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const mn = Math.PI, pn = 2 * mn, sX = pn + mn, eu = Number.POSITIVE_INFINITY, aX = mn / 180, On = mn / 2, Vs = mn / 4, km = mn * 2 / 3, Ji = Math.log10, ni = Math.sign;
function ac(e, t, n) {
  return Math.abs(e - t) < n;
}
function Em(e) {
  const t = Math.round(e);
  e = ac(e, t, e / 1e3) ? t : e;
  const n = Math.pow(10, Math.floor(Ji(e))), o = e / n;
  return (o <= 1 ? 1 : o <= 2 ? 2 : o <= 5 ? 5 : 10) * n;
}
function lX(e) {
  const t = [], n = Math.sqrt(e);
  let o;
  for (o = 1; o < n; o++)
    e % o === 0 && (t.push(o), t.push(e / o));
  return n === (n | 0) && t.push(n), t.sort((r, i) => r - i).pop(), t;
}
function Hl(e) {
  return !isNaN(parseFloat(e)) && isFinite(e);
}
function cX(e, t) {
  const n = Math.round(e);
  return n - t <= e && n + t >= e;
}
function cS(e, t, n) {
  let o, r, i;
  for (o = 0, r = e.length; o < r; o++)
    i = e[o][n], isNaN(i) || (t.min = Math.min(t.min, i), t.max = Math.max(t.max, i));
}
function Or(e) {
  return e * (mn / 180);
}
function y7(e) {
  return e * (180 / mn);
}
function Rm(e) {
  if (!kn(e))
    return;
  let t = 1, n = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, n++;
  return n;
}
function dS(e, t) {
  const n = t.x - e.x, o = t.y - e.y, r = Math.sqrt(n * n + o * o);
  let i = Math.atan2(o, n);
  return i < -0.5 * mn && (i += pn), {
    angle: i,
    distance: r
  };
}
function qp(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function dX(e, t) {
  return (e - t + sX) % pn - mn;
}
function Go(e) {
  return (e % pn + pn) % pn;
}
function Zc(e, t, n, o) {
  const r = Go(e), i = Go(t), s = Go(n), a = Go(i - r), c = Go(s - r), d = Go(r - i), u = Go(r - s);
  return r === i || r === s || o && i === s || a > c && d < u;
}
function Wn(e, t, n) {
  return Math.max(t, Math.min(n, e));
}
function uX(e) {
  return Wn(e, -32768, 32767);
}
function Ti(e, t, n, o = 1e-6) {
  return e >= Math.min(t, n) - o && e <= Math.max(t, n) + o;
}
function v7(e, t, n) {
  n = n || ((s) => e[s] < t);
  let o = e.length - 1, r = 0, i;
  for (; o - r > 1; )
    i = r + o >> 1, n(i) ? r = i : o = i;
  return {
    lo: r,
    hi: o
  };
}
const ki = (e, t, n, o) => v7(e, n, o ? (r) => {
  const i = e[r][t];
  return i < n || i === n && e[r + 1][t] === n;
} : (r) => e[r][t] < n), fX = (e, t, n) => v7(e, n, (o) => e[o][t] >= n);
function pX(e, t, n) {
  let o = 0, r = e.length;
  for (; o < r && e[o] < t; )
    o++;
  for (; r > o && e[r - 1] > n; )
    r--;
  return o > 0 || r < e.length ? e.slice(o, r) : e;
}
const uS = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function hX(e, t) {
  if (e._chartjs) {
    e._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(e, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        t
      ]
    }
  }), uS.forEach((n) => {
    const o = "_onData" + x7(n), r = e[n];
    Object.defineProperty(e, n, {
      configurable: !0,
      enumerable: !1,
      value(...i) {
        const s = r.apply(this, i);
        return e._chartjs.listeners.forEach((a) => {
          typeof a[o] == "function" && a[o](...i);
        }), s;
      }
    });
  });
}
function Om(e, t) {
  const n = e._chartjs;
  if (!n)
    return;
  const o = n.listeners, r = o.indexOf(t);
  r !== -1 && o.splice(r, 1), !(o.length > 0) && (uS.forEach((i) => {
    delete e[i];
  }), delete e._chartjs);
}
function fS(e) {
  const t = new Set(e);
  return t.size === e.length ? e : Array.from(t);
}
const pS = function() {
  return typeof window > "u" ? function(e) {
    return e();
  } : window.requestAnimationFrame;
}();
function hS(e, t) {
  let n = [], o = !1;
  return function(...r) {
    n = r, o || (o = !0, pS.call(window, () => {
      o = !1, e.apply(t, n);
    }));
  };
}
function gX(e, t) {
  let n;
  return function(...o) {
    return t ? (clearTimeout(n), n = setTimeout(e, t, o)) : e.apply(this, o), t;
  };
}
const w7 = (e) => e === "start" ? "left" : e === "end" ? "right" : "center", so = (e, t, n) => e === "start" ? t : e === "end" ? n : (t + n) / 2, mX = (e, t, n, o) => e === (o ? "left" : "right") ? n : e === "center" ? (t + n) / 2 : t;
function gS(e, t, n) {
  const o = t.length;
  let r = 0, i = o;
  if (e._sorted) {
    const { iScale: s, _parsed: a } = e, c = s.axis, { min: d, max: u, minDefined: p, maxDefined: h } = s.getUserBounds();
    p && (r = Wn(Math.min(
      // @ts-expect-error Need to type _parsed
      ki(a, c, d).lo,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? o : ki(t, c, s.getPixelForValue(d)).lo
    ), 0, o - 1)), h ? i = Wn(Math.max(
      // @ts-expect-error Need to type _parsed
      ki(a, s.axis, u, !0).hi + 1,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? 0 : ki(t, c, s.getPixelForValue(u), !0).hi + 1
    ), r, o) - r : i = o - r;
  }
  return {
    start: r,
    count: i
  };
}
function mS(e) {
  const { xScale: t, yScale: n, _scaleRanges: o } = e, r = {
    xmin: t.min,
    xmax: t.max,
    ymin: n.min,
    ymax: n.max
  };
  if (!o)
    return e._scaleRanges = r, !0;
  const i = o.xmin !== t.min || o.xmax !== t.max || o.ymin !== n.min || o.ymax !== n.max;
  return Object.assign(o, r), i;
}
const C1 = (e) => e === 0 || e === 1, _m = (e, t, n) => -(Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * pn / n)), Pm = (e, t, n) => Math.pow(2, -10 * e) * Math.sin((e - t) * pn / n) + 1, lc = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => -e * (e - 2),
  easeInOutQuad: (e) => (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1),
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => (e -= 1) * e * e + 1,
  easeInOutCubic: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2),
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => -((e -= 1) * e * e * e - 1),
  easeInOutQuart: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e : -0.5 * ((e -= 2) * e * e * e - 2),
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => (e -= 1) * e * e * e * e + 1,
  easeInOutQuint: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e * e : 0.5 * ((e -= 2) * e * e * e * e + 2),
  easeInSine: (e) => -Math.cos(e * On) + 1,
  easeOutSine: (e) => Math.sin(e * On),
  easeInOutSine: (e) => -0.5 * (Math.cos(mn * e) - 1),
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * (e - 1)),
  easeOutExpo: (e) => e === 1 ? 1 : -Math.pow(2, -10 * e) + 1,
  easeInOutExpo: (e) => C1(e) ? e : e < 0.5 ? 0.5 * Math.pow(2, 10 * (e * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (e * 2 - 1)) + 2),
  easeInCirc: (e) => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1),
  easeOutCirc: (e) => Math.sqrt(1 - (e -= 1) * e),
  easeInOutCirc: (e) => (e /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
  easeInElastic: (e) => C1(e) ? e : _m(e, 0.075, 0.3),
  easeOutElastic: (e) => C1(e) ? e : Pm(e, 0.075, 0.3),
  easeInOutElastic(e) {
    return C1(e) ? e : e < 0.5 ? 0.5 * _m(e * 2, 0.1125, 0.45) : 0.5 + 0.5 * Pm(e * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(e) {
    return e * e * ((1.70158 + 1) * e - 1.70158);
  },
  easeOutBack(e) {
    return (e -= 1) * e * ((1.70158 + 1) * e + 1.70158) + 1;
  },
  easeInOutBack(e) {
    let t = 1.70158;
    return (e /= 0.5) < 1 ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t)) : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
  },
  easeInBounce: (e) => 1 - lc.easeOutBounce(1 - e),
  easeOutBounce(e) {
    return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  },
  easeInOutBounce: (e) => e < 0.5 ? lc.easeInBounce(e * 2) * 0.5 : lc.easeOutBounce(e * 2 - 1) * 0.5 + 0.5
};
function S7(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function Lm(e) {
  return S7(e) ? e : new sS(e);
}
function Kf(e) {
  return S7(e) ? e : new sS(e).saturate(0.5).darken(0.1).hexString();
}
const bX = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], CX = [
  "color",
  "borderColor",
  "backgroundColor"
];
function xX(e) {
  e.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), e.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (t) => t !== "onProgress" && t !== "onComplete" && t !== "fn"
  }), e.set("animations", {
    colors: {
      type: "color",
      properties: CX
    },
    numbers: {
      type: "number",
      properties: bX
    }
  }), e.describe("animations", {
    _fallback: "animation"
  }), e.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (t) => t | 0
        }
      }
    }
  });
}
function yX(e) {
  e.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const Im = /* @__PURE__ */ new Map();
function vX(e, t) {
  t = t || {};
  const n = e + JSON.stringify(t);
  let o = Im.get(n);
  return o || (o = new Intl.NumberFormat(e, t), Im.set(n, o)), o;
}
function A0(e, t, n) {
  return vX(t, n).format(e);
}
const bS = {
  values(e) {
    return fn(e) ? e : "" + e;
  },
  numeric(e, t, n) {
    if (e === 0)
      return "0";
    const o = this.chart.options.locale;
    let r, i = e;
    if (n.length > 1) {
      const d = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
      (d < 1e-4 || d > 1e15) && (r = "scientific"), i = wX(e, n);
    }
    const s = Ji(Math.abs(i)), a = isNaN(s) ? 1 : Math.max(Math.min(-1 * Math.floor(s), 20), 0), c = {
      notation: r,
      minimumFractionDigits: a,
      maximumFractionDigits: a
    };
    return Object.assign(c, this.options.ticks.format), A0(e, o, c);
  },
  logarithmic(e, t, n) {
    if (e === 0)
      return "0";
    const o = n[t].significand || e / Math.pow(10, Math.floor(Ji(e)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(o) || t > 0.8 * n.length ? bS.numeric.call(this, e, t, n) : "";
  }
};
function wX(e, t) {
  let n = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(n) >= 1 && e !== Math.floor(e) && (n = e - Math.floor(e)), n;
}
var N3 = {
  formatters: bS
};
function SX(e) {
  e.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (t, n) => n.lineWidth,
      tickColor: (t, n) => n.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: N3.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), e.route("scale.ticks", "color", "", "color"), e.route("scale.grid", "color", "", "borderColor"), e.route("scale.border", "color", "", "borderColor"), e.route("scale.title", "color", "", "color"), e.describe("scale", {
    _fallback: !1,
    _scriptable: (t) => !t.startsWith("before") && !t.startsWith("after") && t !== "callback" && t !== "parser",
    _indexable: (t) => t !== "borderDash" && t !== "tickBorderDash" && t !== "dash"
  }), e.describe("scales", {
    _fallback: "scale"
  }), e.describe("scale.ticks", {
    _scriptable: (t) => t !== "backdropPadding" && t !== "callback",
    _indexable: (t) => t !== "backdropPadding"
  });
}
const Ta = /* @__PURE__ */ Object.create(null), Kp = /* @__PURE__ */ Object.create(null);
function cc(e, t) {
  if (!t)
    return e;
  const n = t.split(".");
  for (let o = 0, r = n.length; o < r; ++o) {
    const i = n[o];
    e = e[i] || (e[i] = /* @__PURE__ */ Object.create(null));
  }
  return e;
}
function Yf(e, t, n) {
  return typeof t == "string" ? ai(cc(e, t), n) : ai(cc(e, ""), t);
}
class MX {
  constructor(t, n) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (o) => o.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (o, r) => Kf(r.backgroundColor), this.hoverBorderColor = (o, r) => Kf(r.borderColor), this.hoverColor = (o, r) => Kf(r.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t), this.apply(n);
  }
  set(t, n) {
    return Yf(this, t, n);
  }
  get(t) {
    return cc(this, t);
  }
  describe(t, n) {
    return Yf(Kp, t, n);
  }
  override(t, n) {
    return Yf(Ta, t, n);
  }
  route(t, n, o, r) {
    const i = cc(this, t), s = cc(this, o), a = "_" + n;
    Object.defineProperties(i, {
      [a]: {
        value: i[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const c = this[a], d = s[r];
          return Dt(c) ? Object.assign({}, d, c) : yt(c, d);
        },
        set(c) {
          this[a] = c;
        }
      }
    });
  }
  apply(t) {
    t.forEach((n) => n(this));
  }
}
var hn = /* @__PURE__ */ new MX({
  _scriptable: (e) => !e.startsWith("on"),
  _indexable: (e) => e !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  xX,
  yX,
  SX
]);
function TX(e) {
  return !e || It(e.size) || It(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family;
}
function tu(e, t, n, o, r) {
  let i = t[r];
  return i || (i = t[r] = e.measureText(r).width, n.push(r)), i > o && (o = i), o;
}
function kX(e, t, n, o) {
  o = o || {};
  let r = o.data = o.data || {}, i = o.garbageCollect = o.garbageCollect || [];
  o.font !== t && (r = o.data = {}, i = o.garbageCollect = [], o.font = t), e.save(), e.font = t;
  let s = 0;
  const a = n.length;
  let c, d, u, p, h;
  for (c = 0; c < a; c++)
    if (p = n[c], p != null && !fn(p))
      s = tu(e, r, i, s, p);
    else if (fn(p))
      for (d = 0, u = p.length; d < u; d++)
        h = p[d], h != null && !fn(h) && (s = tu(e, r, i, s, h));
  e.restore();
  const g = i.length / 2;
  if (g > n.length) {
    for (c = 0; c < g; c++)
      delete r[i[c]];
    i.splice(0, g);
  }
  return s;
}
function Ds(e, t, n) {
  const o = e.currentDevicePixelRatio, r = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((t - r) * o) / o + r;
}
function jm(e, t) {
  !t && !e || (t = t || e.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, e.width, e.height), t.restore());
}
function Yp(e, t, n, o) {
  CS(e, t, n, o, null);
}
function CS(e, t, n, o, r) {
  let i, s, a, c, d, u, p, h;
  const g = t.pointStyle, m = t.rotation, b = t.radius;
  let C = (m || 0) * aX;
  if (g && typeof g == "object" && (i = g.toString(), i === "[object HTMLImageElement]" || i === "[object HTMLCanvasElement]")) {
    e.save(), e.translate(n, o), e.rotate(C), e.drawImage(g, -g.width / 2, -g.height / 2, g.width, g.height), e.restore();
    return;
  }
  if (!(isNaN(b) || b <= 0)) {
    switch (e.beginPath(), g) {
      default:
        r ? e.ellipse(n, o, r / 2, b, 0, 0, pn) : e.arc(n, o, b, 0, pn), e.closePath();
        break;
      case "triangle":
        u = r ? r / 2 : b, e.moveTo(n + Math.sin(C) * u, o - Math.cos(C) * b), C += km, e.lineTo(n + Math.sin(C) * u, o - Math.cos(C) * b), C += km, e.lineTo(n + Math.sin(C) * u, o - Math.cos(C) * b), e.closePath();
        break;
      case "rectRounded":
        d = b * 0.516, c = b - d, s = Math.cos(C + Vs) * c, p = Math.cos(C + Vs) * (r ? r / 2 - d : c), a = Math.sin(C + Vs) * c, h = Math.sin(C + Vs) * (r ? r / 2 - d : c), e.arc(n - p, o - a, d, C - mn, C - On), e.arc(n + h, o - s, d, C - On, C), e.arc(n + p, o + a, d, C, C + On), e.arc(n - h, o + s, d, C + On, C + mn), e.closePath();
        break;
      case "rect":
        if (!m) {
          c = Math.SQRT1_2 * b, u = r ? r / 2 : c, e.rect(n - u, o - c, 2 * u, 2 * c);
          break;
        }
        C += Vs;
      case "rectRot":
        p = Math.cos(C) * (r ? r / 2 : b), s = Math.cos(C) * b, a = Math.sin(C) * b, h = Math.sin(C) * (r ? r / 2 : b), e.moveTo(n - p, o - a), e.lineTo(n + h, o - s), e.lineTo(n + p, o + a), e.lineTo(n - h, o + s), e.closePath();
        break;
      case "crossRot":
        C += Vs;
      case "cross":
        p = Math.cos(C) * (r ? r / 2 : b), s = Math.cos(C) * b, a = Math.sin(C) * b, h = Math.sin(C) * (r ? r / 2 : b), e.moveTo(n - p, o - a), e.lineTo(n + p, o + a), e.moveTo(n + h, o - s), e.lineTo(n - h, o + s);
        break;
      case "star":
        p = Math.cos(C) * (r ? r / 2 : b), s = Math.cos(C) * b, a = Math.sin(C) * b, h = Math.sin(C) * (r ? r / 2 : b), e.moveTo(n - p, o - a), e.lineTo(n + p, o + a), e.moveTo(n + h, o - s), e.lineTo(n - h, o + s), C += Vs, p = Math.cos(C) * (r ? r / 2 : b), s = Math.cos(C) * b, a = Math.sin(C) * b, h = Math.sin(C) * (r ? r / 2 : b), e.moveTo(n - p, o - a), e.lineTo(n + p, o + a), e.moveTo(n + h, o - s), e.lineTo(n - h, o + s);
        break;
      case "line":
        s = r ? r / 2 : Math.cos(C) * b, a = Math.sin(C) * b, e.moveTo(n - s, o - a), e.lineTo(n + s, o + a);
        break;
      case "dash":
        e.moveTo(n, o), e.lineTo(n + Math.cos(C) * (r ? r / 2 : b), o + Math.sin(C) * b);
        break;
      case !1:
        e.closePath();
        break;
    }
    e.fill(), t.borderWidth > 0 && e.stroke();
  }
}
function Ei(e, t, n) {
  return n = n || 0.5, !t || e && e.x > t.left - n && e.x < t.right + n && e.y > t.top - n && e.y < t.bottom + n;
}
function $3(e, t) {
  e.save(), e.beginPath(), e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), e.clip();
}
function B3(e) {
  e.restore();
}
function EX(e, t, n, o, r) {
  if (!t)
    return e.lineTo(n.x, n.y);
  if (r === "middle") {
    const i = (t.x + n.x) / 2;
    e.lineTo(i, t.y), e.lineTo(i, n.y);
  } else r === "after" != !!o ? e.lineTo(t.x, n.y) : e.lineTo(n.x, t.y);
  e.lineTo(n.x, n.y);
}
function RX(e, t, n, o) {
  if (!t)
    return e.lineTo(n.x, n.y);
  e.bezierCurveTo(o ? t.cp1x : t.cp2x, o ? t.cp1y : t.cp2y, o ? n.cp2x : n.cp1x, o ? n.cp2y : n.cp1y, n.x, n.y);
}
function OX(e, t) {
  t.translation && e.translate(t.translation[0], t.translation[1]), It(t.rotation) || e.rotate(t.rotation), t.color && (e.fillStyle = t.color), t.textAlign && (e.textAlign = t.textAlign), t.textBaseline && (e.textBaseline = t.textBaseline);
}
function _X(e, t, n, o, r) {
  if (r.strikethrough || r.underline) {
    const i = e.measureText(o), s = t - i.actualBoundingBoxLeft, a = t + i.actualBoundingBoxRight, c = n - i.actualBoundingBoxAscent, d = n + i.actualBoundingBoxDescent, u = r.strikethrough ? (c + d) / 2 : d;
    e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = r.decorationWidth || 2, e.moveTo(s, u), e.lineTo(a, u), e.stroke();
  }
}
function PX(e, t) {
  const n = e.fillStyle;
  e.fillStyle = t.color, e.fillRect(t.left, t.top, t.width, t.height), e.fillStyle = n;
}
function ka(e, t, n, o, r, i = {}) {
  const s = fn(t) ? t : [
    t
  ], a = i.strokeWidth > 0 && i.strokeColor !== "";
  let c, d;
  for (e.save(), e.font = r.string, OX(e, i), c = 0; c < s.length; ++c)
    d = s[c], i.backdrop && PX(e, i.backdrop), a && (i.strokeColor && (e.strokeStyle = i.strokeColor), It(i.strokeWidth) || (e.lineWidth = i.strokeWidth), e.strokeText(d, n, o, i.maxWidth)), e.fillText(d, n, o, i.maxWidth), _X(e, n, o, d, i), o += Number(r.lineHeight);
  e.restore();
}
function Wc(e, t) {
  const { x: n, y: o, w: r, h: i, radius: s } = t;
  e.arc(n + s.topLeft, o + s.topLeft, s.topLeft, 1.5 * mn, mn, !0), e.lineTo(n, o + i - s.bottomLeft), e.arc(n + s.bottomLeft, o + i - s.bottomLeft, s.bottomLeft, mn, On, !0), e.lineTo(n + r - s.bottomRight, o + i), e.arc(n + r - s.bottomRight, o + i - s.bottomRight, s.bottomRight, On, 0, !0), e.lineTo(n + r, o + s.topRight), e.arc(n + r - s.topRight, o + s.topRight, s.topRight, 0, -On, !0), e.lineTo(n + s.topLeft, o);
}
const LX = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, IX = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function jX(e, t) {
  const n = ("" + e).match(LX);
  if (!n || n[1] === "normal")
    return t * 1.2;
  switch (e = +n[2], n[3]) {
    case "px":
      return e;
    case "%":
      e /= 100;
      break;
  }
  return t * e;
}
const VX = (e) => +e || 0;
function M7(e, t) {
  const n = {}, o = Dt(t), r = o ? Object.keys(t) : t, i = Dt(e) ? o ? (s) => yt(e[s], e[t[s]]) : (s) => e[s] : () => e;
  for (const s of r)
    n[s] = VX(i(s));
  return n;
}
function xS(e) {
  return M7(e, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function aa(e) {
  return M7(e, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function no(e) {
  const t = xS(e);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function Dn(e, t) {
  e = e || {}, t = t || hn.font;
  let n = yt(e.size, t.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let o = yt(e.style, t.style);
  o && !("" + o).match(IX) && (console.warn('Invalid font style specified: "' + o + '"'), o = void 0);
  const r = {
    family: yt(e.family, t.family),
    lineHeight: jX(yt(e.lineHeight, t.lineHeight), n),
    size: n,
    style: o,
    weight: yt(e.weight, t.weight),
    string: ""
  };
  return r.string = TX(r), r;
}
function dn(e, t, n, o) {
  let r, i, s;
  for (r = 0, i = e.length; r < i; ++r)
    if (s = e[r], s !== void 0 && (t !== void 0 && typeof s == "function" && (s = s(t)), n !== void 0 && fn(s) && (s = s[n % s.length]), s !== void 0))
      return s;
}
function DX(e, t, n) {
  const { min: o, max: r } = e, i = aS(t, (r - o) / 2), s = (a, c) => n && a === 0 ? 0 : a + c;
  return {
    min: s(o, -Math.abs(i)),
    max: s(r, i)
  };
}
function Rs(e, t) {
  return Object.assign(Object.create(e), t);
}
function T7(e, t = [
  ""
], n, o, r = () => e[0]) {
  const i = n || e;
  typeof o > "u" && (o = SS("_fallback", e));
  const s = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: e,
    _rootScopes: i,
    _fallback: o,
    _getTarget: r,
    override: (a) => T7([
      a,
      ...e
    ], t, i, o)
  };
  return new Proxy(s, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(a, c) {
      return delete a[c], delete a._keys, delete e[0][c], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(a, c) {
      return vS(a, c, () => ZX(c, t, e, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(a, c) {
      return Reflect.getOwnPropertyDescriptor(a._scopes[0], c);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(a, c) {
      return Dm(a).includes(c);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(a) {
      return Dm(a);
    },
    /**
    * A trap for setting property values.
    */
    set(a, c, d) {
      const u = a._storage || (a._storage = r());
      return a[c] = u[c] = d, delete a._keys, !0;
    }
  });
}
function Fl(e, t, n, o) {
  const r = {
    _cacheable: !1,
    _proxy: e,
    _context: t,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: yS(e, o),
    setContext: (i) => Fl(e, i, n, o),
    override: (i) => Fl(e.override(i), t, n, o)
  };
  return new Proxy(r, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(i, s) {
      return delete i[s], delete e[s], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(i, s, a) {
      return vS(i, s, () => HX(i, s, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(i, s) {
      return i._descriptors.allKeys ? Reflect.has(e, s) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(e, s);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e);
    },
    /**
    * A trap for the in operator.
    */
    has(i, s) {
      return Reflect.has(e, s);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(e);
    },
    /**
    * A trap for setting property values.
    */
    set(i, s, a) {
      return e[s] = a, delete i[s], !0;
    }
  });
}
function yS(e, t = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: n = t.scriptable, _indexable: o = t.indexable, _allKeys: r = t.allKeys } = e;
  return {
    allKeys: r,
    scriptable: n,
    indexable: o,
    isScriptable: Cs(n) ? n : () => n,
    isIndexable: Cs(o) ? o : () => o
  };
}
const AX = (e, t) => e ? e + x7(t) : t, k7 = (e, t) => Dt(t) && e !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function vS(e, t, n) {
  if (Object.prototype.hasOwnProperty.call(e, t) || t === "constructor")
    return e[t];
  const o = n();
  return e[t] = o, o;
}
function HX(e, t, n) {
  const { _proxy: o, _context: r, _subProxy: i, _descriptors: s } = e;
  let a = o[t];
  return Cs(a) && s.isScriptable(t) && (a = FX(t, a, e, n)), fn(a) && a.length && (a = NX(t, a, e, s.isIndexable)), k7(t, a) && (a = Fl(a, r, i && i[t], s)), a;
}
function FX(e, t, n, o) {
  const { _proxy: r, _context: i, _subProxy: s, _stack: a } = n;
  if (a.has(e))
    throw new Error("Recursion detected: " + Array.from(a).join("->") + "->" + e);
  a.add(e);
  let c = t(i, s || o);
  return a.delete(e), k7(e, c) && (c = E7(r._scopes, r, e, c)), c;
}
function NX(e, t, n, o) {
  const { _proxy: r, _context: i, _subProxy: s, _descriptors: a } = n;
  if (typeof i.index < "u" && o(e))
    return t[i.index % t.length];
  if (Dt(t[0])) {
    const c = t, d = r._scopes.filter((u) => u !== c);
    t = [];
    for (const u of c) {
      const p = E7(d, r, e, u);
      t.push(Fl(p, i, s && s[e], a));
    }
  }
  return t;
}
function wS(e, t, n) {
  return Cs(e) ? e(t, n) : e;
}
const $X = (e, t) => e === !0 ? t : typeof e == "string" ? bs(t, e) : void 0;
function BX(e, t, n, o, r) {
  for (const i of t) {
    const s = $X(n, i);
    if (s) {
      e.add(s);
      const a = wS(s._fallback, n, r);
      if (typeof a < "u" && a !== n && a !== o)
        return a;
    } else if (s === !1 && typeof o < "u" && n !== o)
      return null;
  }
  return !1;
}
function E7(e, t, n, o) {
  const r = t._rootScopes, i = wS(t._fallback, n, o), s = [
    ...e,
    ...r
  ], a = /* @__PURE__ */ new Set();
  a.add(o);
  let c = Vm(a, s, n, i || n, o);
  return c === null || typeof i < "u" && i !== n && (c = Vm(a, s, i, c, o), c === null) ? !1 : T7(Array.from(a), [
    ""
  ], r, i, () => zX(t, n, o));
}
function Vm(e, t, n, o, r) {
  for (; n; )
    n = BX(e, t, n, o, r);
  return n;
}
function zX(e, t, n) {
  const o = e._getTarget();
  t in o || (o[t] = {});
  const r = o[t];
  return fn(r) && Dt(n) ? n : r || {};
}
function ZX(e, t, n, o) {
  let r;
  for (const i of t)
    if (r = SS(AX(i, e), n), typeof r < "u")
      return k7(e, r) ? E7(n, o, e, r) : r;
}
function SS(e, t) {
  for (const n of t) {
    if (!n)
      continue;
    const o = n[e];
    if (typeof o < "u")
      return o;
  }
}
function Dm(e) {
  let t = e._keys;
  return t || (t = e._keys = WX(e._scopes)), t;
}
function WX(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    for (const o of Object.keys(n).filter((r) => !r.startsWith("_")))
      t.add(o);
  return Array.from(t);
}
function MS(e, t, n, o) {
  const { iScale: r } = e, { key: i = "r" } = this._parsing, s = new Array(o);
  let a, c, d, u;
  for (a = 0, c = o; a < c; ++a)
    d = a + n, u = t[d], s[a] = {
      r: r.parse(bs(u, i), d)
    };
  return s;
}
const UX = Number.EPSILON || 1e-14, Nl = (e, t) => t < e.length && !e[t].skip && e[t], TS = (e) => e === "x" ? "y" : "x";
function GX(e, t, n, o) {
  const r = e.skip ? t : e, i = t, s = n.skip ? t : n, a = qp(i, r), c = qp(s, i);
  let d = a / (a + c), u = c / (a + c);
  d = isNaN(d) ? 0 : d, u = isNaN(u) ? 0 : u;
  const p = o * d, h = o * u;
  return {
    previous: {
      x: i.x - p * (s.x - r.x),
      y: i.y - p * (s.y - r.y)
    },
    next: {
      x: i.x + h * (s.x - r.x),
      y: i.y + h * (s.y - r.y)
    }
  };
}
function qX(e, t, n) {
  const o = e.length;
  let r, i, s, a, c, d = Nl(e, 0);
  for (let u = 0; u < o - 1; ++u)
    if (c = d, d = Nl(e, u + 1), !(!c || !d)) {
      if (ac(t[u], 0, UX)) {
        n[u] = n[u + 1] = 0;
        continue;
      }
      r = n[u] / t[u], i = n[u + 1] / t[u], a = Math.pow(r, 2) + Math.pow(i, 2), !(a <= 9) && (s = 3 / Math.sqrt(a), n[u] = r * s * t[u], n[u + 1] = i * s * t[u]);
    }
}
function KX(e, t, n = "x") {
  const o = TS(n), r = e.length;
  let i, s, a, c = Nl(e, 0);
  for (let d = 0; d < r; ++d) {
    if (s = a, a = c, c = Nl(e, d + 1), !a)
      continue;
    const u = a[n], p = a[o];
    s && (i = (u - s[n]) / 3, a[`cp1${n}`] = u - i, a[`cp1${o}`] = p - i * t[d]), c && (i = (c[n] - u) / 3, a[`cp2${n}`] = u + i, a[`cp2${o}`] = p + i * t[d]);
  }
}
function YX(e, t = "x") {
  const n = TS(t), o = e.length, r = Array(o).fill(0), i = Array(o);
  let s, a, c, d = Nl(e, 0);
  for (s = 0; s < o; ++s)
    if (a = c, c = d, d = Nl(e, s + 1), !!c) {
      if (d) {
        const u = d[t] - c[t];
        r[s] = u !== 0 ? (d[n] - c[n]) / u : 0;
      }
      i[s] = a ? d ? ni(r[s - 1]) !== ni(r[s]) ? 0 : (r[s - 1] + r[s]) / 2 : r[s - 1] : r[s];
    }
  qX(e, r, i), KX(e, i, t);
}
function x1(e, t, n) {
  return Math.max(Math.min(e, n), t);
}
function XX(e, t) {
  let n, o, r, i, s, a = Ei(e[0], t);
  for (n = 0, o = e.length; n < o; ++n)
    s = i, i = a, a = n < o - 1 && Ei(e[n + 1], t), i && (r = e[n], s && (r.cp1x = x1(r.cp1x, t.left, t.right), r.cp1y = x1(r.cp1y, t.top, t.bottom)), a && (r.cp2x = x1(r.cp2x, t.left, t.right), r.cp2y = x1(r.cp2y, t.top, t.bottom)));
}
function JX(e, t, n, o, r) {
  let i, s, a, c;
  if (t.spanGaps && (e = e.filter((d) => !d.skip)), t.cubicInterpolationMode === "monotone")
    YX(e, r);
  else {
    let d = o ? e[e.length - 1] : e[0];
    for (i = 0, s = e.length; i < s; ++i)
      a = e[i], c = GX(d, a, e[Math.min(i + 1, s - (o ? 0 : 1)) % s], t.tension), a.cp1x = c.previous.x, a.cp1y = c.previous.y, a.cp2x = c.next.x, a.cp2y = c.next.y, d = a;
  }
  t.capBezierPoints && XX(e, n);
}
function R7() {
  return typeof window < "u" && typeof document < "u";
}
function O7(e) {
  let t = e.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function nu(e, t, n) {
  let o;
  return typeof e == "string" ? (o = parseInt(e, 10), e.indexOf("%") !== -1 && (o = o / 100 * t.parentNode[n])) : o = e, o;
}
const z3 = (e) => e.ownerDocument.defaultView.getComputedStyle(e, null);
function QX(e, t) {
  return z3(e).getPropertyValue(t);
}
const eJ = [
  "top",
  "right",
  "bottom",
  "left"
];
function la(e, t, n) {
  const o = {};
  n = n ? "-" + n : "";
  for (let r = 0; r < 4; r++) {
    const i = eJ[r];
    o[i] = parseFloat(e[t + "-" + i + n]) || 0;
  }
  return o.width = o.left + o.right, o.height = o.top + o.bottom, o;
}
const tJ = (e, t, n) => (e > 0 || t > 0) && (!n || !n.shadowRoot);
function nJ(e, t) {
  const n = e.touches, o = n && n.length ? n[0] : e, { offsetX: r, offsetY: i } = o;
  let s = !1, a, c;
  if (tJ(r, i, e.target))
    a = r, c = i;
  else {
    const d = t.getBoundingClientRect();
    a = o.clientX - d.left, c = o.clientY - d.top, s = !0;
  }
  return {
    x: a,
    y: c,
    box: s
  };
}
function Ws(e, t) {
  if ("native" in e)
    return e;
  const { canvas: n, currentDevicePixelRatio: o } = t, r = z3(n), i = r.boxSizing === "border-box", s = la(r, "padding"), a = la(r, "border", "width"), { x: c, y: d, box: u } = nJ(e, n), p = s.left + (u && a.left), h = s.top + (u && a.top);
  let { width: g, height: m } = t;
  return i && (g -= s.width + a.width, m -= s.height + a.height), {
    x: Math.round((c - p) / g * n.width / o),
    y: Math.round((d - h) / m * n.height / o)
  };
}
function oJ(e, t, n) {
  let o, r;
  if (t === void 0 || n === void 0) {
    const i = e && O7(e);
    if (!i)
      t = e.clientWidth, n = e.clientHeight;
    else {
      const s = i.getBoundingClientRect(), a = z3(i), c = la(a, "border", "width"), d = la(a, "padding");
      t = s.width - d.width - c.width, n = s.height - d.height - c.height, o = nu(a.maxWidth, i, "clientWidth"), r = nu(a.maxHeight, i, "clientHeight");
    }
  }
  return {
    width: t,
    height: n,
    maxWidth: o || eu,
    maxHeight: r || eu
  };
}
const y1 = (e) => Math.round(e * 10) / 10;
function rJ(e, t, n, o) {
  const r = z3(e), i = la(r, "margin"), s = nu(r.maxWidth, e, "clientWidth") || eu, a = nu(r.maxHeight, e, "clientHeight") || eu, c = oJ(e, t, n);
  let { width: d, height: u } = c;
  if (r.boxSizing === "content-box") {
    const h = la(r, "border", "width"), g = la(r, "padding");
    d -= g.width + h.width, u -= g.height + h.height;
  }
  return d = Math.max(0, d - i.width), u = Math.max(0, o ? d / o : u - i.height), d = y1(Math.min(d, s, c.maxWidth)), u = y1(Math.min(u, a, c.maxHeight)), d && !u && (u = y1(d / 2)), (t !== void 0 || n !== void 0) && o && c.height && u > c.height && (u = c.height, d = y1(Math.floor(u * o))), {
    width: d,
    height: u
  };
}
function Am(e, t, n) {
  const o = t || 1, r = Math.floor(e.height * o), i = Math.floor(e.width * o);
  e.height = Math.floor(e.height), e.width = Math.floor(e.width);
  const s = e.canvas;
  return s.style && (n || !s.style.height && !s.style.width) && (s.style.height = `${e.height}px`, s.style.width = `${e.width}px`), e.currentDevicePixelRatio !== o || s.height !== r || s.width !== i ? (e.currentDevicePixelRatio = o, s.height = r, s.width = i, e.ctx.setTransform(o, 0, 0, o, 0, 0), !0) : !1;
}
const iJ = function() {
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    };
    R7() && (window.addEventListener("test", null, t), window.removeEventListener("test", null, t));
  } catch {
  }
  return e;
}();
function Hm(e, t) {
  const n = QX(e, t), o = n && n.match(/^(\d+)(\.\d+)?px$/);
  return o ? +o[1] : void 0;
}
function Us(e, t, n, o) {
  return {
    x: e.x + n * (t.x - e.x),
    y: e.y + n * (t.y - e.y)
  };
}
function sJ(e, t, n, o) {
  return {
    x: e.x + n * (t.x - e.x),
    y: o === "middle" ? n < 0.5 ? e.y : t.y : o === "after" ? n < 1 ? e.y : t.y : n > 0 ? t.y : e.y
  };
}
function aJ(e, t, n, o) {
  const r = {
    x: e.cp2x,
    y: e.cp2y
  }, i = {
    x: t.cp1x,
    y: t.cp1y
  }, s = Us(e, r, n), a = Us(r, i, n), c = Us(i, t, n), d = Us(s, a, n), u = Us(a, c, n);
  return Us(d, u, n);
}
const lJ = function(e, t) {
  return {
    x(n) {
      return e + e + t - n;
    },
    setWidth(n) {
      t = n;
    },
    textAlign(n) {
      return n === "center" ? n : n === "right" ? "left" : "right";
    },
    xPlus(n, o) {
      return n - o;
    },
    leftForLtr(n, o) {
      return n - o;
    }
  };
}, cJ = function() {
  return {
    x(e) {
      return e;
    },
    setWidth(e) {
    },
    textAlign(e) {
      return e;
    },
    xPlus(e, t) {
      return e + t;
    },
    leftForLtr(e, t) {
      return e;
    }
  };
};
function yl(e, t, n) {
  return e ? lJ(t, n) : cJ();
}
function kS(e, t) {
  let n, o;
  (t === "ltr" || t === "rtl") && (n = e.canvas.style, o = [
    n.getPropertyValue("direction"),
    n.getPropertyPriority("direction")
  ], n.setProperty("direction", t, "important"), e.prevTextDirection = o);
}
function ES(e, t) {
  t !== void 0 && (delete e.prevTextDirection, e.canvas.style.setProperty("direction", t[0], t[1]));
}
function RS(e) {
  return e === "angle" ? {
    between: Zc,
    compare: dX,
    normalize: Go
  } : {
    between: Ti,
    compare: (t, n) => t - n,
    normalize: (t) => t
  };
}
function Fm({ start: e, end: t, count: n, loop: o, style: r }) {
  return {
    start: e % n,
    end: t % n,
    loop: o && (t - e + 1) % n === 0,
    style: r
  };
}
function dJ(e, t, n) {
  const { property: o, start: r, end: i } = n, { between: s, normalize: a } = RS(o), c = t.length;
  let { start: d, end: u, loop: p } = e, h, g;
  if (p) {
    for (d += c, u += c, h = 0, g = c; h < g && s(a(t[d % c][o]), r, i); ++h)
      d--, u--;
    d %= c, u %= c;
  }
  return u < d && (u += c), {
    start: d,
    end: u,
    loop: p,
    style: e.style
  };
}
function OS(e, t, n) {
  if (!n)
    return [
      e
    ];
  const { property: o, start: r, end: i } = n, s = t.length, { compare: a, between: c, normalize: d } = RS(o), { start: u, end: p, loop: h, style: g } = dJ(e, t, n), m = [];
  let b = !1, C = null, x, v, S;
  const M = () => c(r, S, x) && a(r, S) !== 0, w = () => a(i, x) === 0 || c(i, S, x), k = () => b || M(), E = () => !b || w();
  for (let R = u, O = u; R <= p; ++R)
    v = t[R % s], !v.skip && (x = d(v[o]), x !== S && (b = c(x, r, i), C === null && k() && (C = a(x, r) === 0 ? R : O), C !== null && E() && (m.push(Fm({
      start: C,
      end: R,
      loop: h,
      count: s,
      style: g
    })), C = null), O = R, S = x));
  return C !== null && m.push(Fm({
    start: C,
    end: p,
    loop: h,
    count: s,
    style: g
  })), m;
}
function _S(e, t) {
  const n = [], o = e.segments;
  for (let r = 0; r < o.length; r++) {
    const i = OS(o[r], e.points, t);
    i.length && n.push(...i);
  }
  return n;
}
function uJ(e, t, n, o) {
  let r = 0, i = t - 1;
  if (n && !o)
    for (; r < t && !e[r].skip; )
      r++;
  for (; r < t && e[r].skip; )
    r++;
  for (r %= t, n && (i += r); i > r && e[i % t].skip; )
    i--;
  return i %= t, {
    start: r,
    end: i
  };
}
function fJ(e, t, n, o) {
  const r = e.length, i = [];
  let s = t, a = e[t], c;
  for (c = t + 1; c <= n; ++c) {
    const d = e[c % r];
    d.skip || d.stop ? a.skip || (o = !1, i.push({
      start: t % r,
      end: (c - 1) % r,
      loop: o
    }), t = s = d.stop ? c : null) : (s = c, a.skip && (t = c)), a = d;
  }
  return s !== null && i.push({
    start: t % r,
    end: s % r,
    loop: o
  }), i;
}
function pJ(e, t) {
  const n = e.points, o = e.options.spanGaps, r = n.length;
  if (!r)
    return [];
  const i = !!e._loop, { start: s, end: a } = uJ(n, r, i, o);
  if (o === !0)
    return Nm(e, [
      {
        start: s,
        end: a,
        loop: i
      }
    ], n, t);
  const c = a < s ? a + r : a, d = !!e._fullLoop && s === 0 && a === r - 1;
  return Nm(e, fJ(n, s, c, d), n, t);
}
function Nm(e, t, n, o) {
  return !o || !o.setContext || !n ? t : hJ(e, t, n, o);
}
function hJ(e, t, n, o) {
  const r = e._chart.getContext(), i = $m(e.options), { _datasetIndex: s, options: { spanGaps: a } } = e, c = n.length, d = [];
  let u = i, p = t[0].start, h = p;
  function g(m, b, C, x) {
    const v = a ? -1 : 1;
    if (m !== b) {
      for (m += c; n[m % c].skip; )
        m -= v;
      for (; n[b % c].skip; )
        b += v;
      m % c !== b % c && (d.push({
        start: m % c,
        end: b % c,
        loop: C,
        style: x
      }), u = x, p = b % c);
    }
  }
  for (const m of t) {
    p = a ? p : m.start;
    let b = n[p % c], C;
    for (h = p + 1; h <= m.end; h++) {
      const x = n[h % c];
      C = $m(o.setContext(Rs(r, {
        type: "segment",
        p0: b,
        p1: x,
        p0DataIndex: (h - 1) % c,
        p1DataIndex: h % c,
        datasetIndex: s
      }))), gJ(C, u) && g(p, h - 1, m.loop, u), b = x, u = C;
    }
    p < h - 1 && g(p, h - 1, m.loop, u);
  }
  return d;
}
function $m(e) {
  return {
    backgroundColor: e.backgroundColor,
    borderCapStyle: e.borderCapStyle,
    borderDash: e.borderDash,
    borderDashOffset: e.borderDashOffset,
    borderJoinStyle: e.borderJoinStyle,
    borderWidth: e.borderWidth,
    borderColor: e.borderColor
  };
}
function gJ(e, t) {
  if (!t)
    return !1;
  const n = [], o = function(r, i) {
    return S7(i) ? (n.includes(i) || n.push(i), n.indexOf(i)) : i;
  };
  return JSON.stringify(e, o) !== JSON.stringify(t, o);
}
/*!
 * Chart.js v4.4.7
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */
class mJ {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, n, o, r) {
    const i = n.listeners[r], s = n.duration;
    i.forEach((a) => a({
      chart: t,
      initial: n.initial,
      numSteps: s,
      currentStep: Math.min(o - n.start, s)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = pS.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let n = 0;
    this._charts.forEach((o, r) => {
      if (!o.running || !o.items.length)
        return;
      const i = o.items;
      let s = i.length - 1, a = !1, c;
      for (; s >= 0; --s)
        c = i[s], c._active ? (c._total > o.duration && (o.duration = c._total), c.tick(t), a = !0) : (i[s] = i[i.length - 1], i.pop());
      a && (r.draw(), this._notify(r, o, t, "progress")), i.length || (o.running = !1, this._notify(r, o, t, "complete"), o.initial = !1), n += i.length;
    }), this._lastDate = t, n === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const n = this._charts;
    let o = n.get(t);
    return o || (o = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, n.set(t, o)), o;
  }
  listen(t, n, o) {
    this._getAnims(t).listeners[n].push(o);
  }
  add(t, n) {
    !n || !n.length || this._getAnims(t).items.push(...n);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const n = this._charts.get(t);
    n && (n.running = !0, n.start = Date.now(), n.duration = n.items.reduce((o, r) => Math.max(o, r._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const n = this._charts.get(t);
    return !(!n || !n.running || !n.items.length);
  }
  stop(t) {
    const n = this._charts.get(t);
    if (!n || !n.items.length)
      return;
    const o = n.items;
    let r = o.length - 1;
    for (; r >= 0; --r)
      o[r].cancel();
    n.items = [], this._notify(t, n, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var bi = /* @__PURE__ */ new mJ();
const Bm = "transparent", bJ = {
  boolean(e, t, n) {
    return n > 0.5 ? t : e;
  },
  color(e, t, n) {
    const o = Lm(e || Bm), r = o.valid && Lm(t || Bm);
    return r && r.valid ? r.mix(o, n).hexString() : t;
  },
  number(e, t, n) {
    return e + (t - e) * n;
  }
};
class CJ {
  constructor(t, n, o, r) {
    const i = n[o];
    r = dn([
      t.to,
      r,
      i,
      t.from
    ]);
    const s = dn([
      t.from,
      i,
      r
    ]);
    this._active = !0, this._fn = t.fn || bJ[t.type || typeof s], this._easing = lc[t.easing] || lc.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = n, this._prop = o, this._from = s, this._to = r, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, n, o) {
    if (this._active) {
      this._notify(!1);
      const r = this._target[this._prop], i = o - this._start, s = this._duration - i;
      this._start = o, this._duration = Math.floor(Math.max(s, t.duration)), this._total += i, this._loop = !!t.loop, this._to = dn([
        t.to,
        n,
        r,
        t.from
      ]), this._from = dn([
        t.from,
        r,
        n
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const n = t - this._start, o = this._duration, r = this._prop, i = this._from, s = this._loop, a = this._to;
    let c;
    if (this._active = i !== a && (s || n < o), !this._active) {
      this._target[r] = a, this._notify(!0);
      return;
    }
    if (n < 0) {
      this._target[r] = i;
      return;
    }
    c = n / o % 2, c = s && c > 1 ? 2 - c : c, c = this._easing(Math.min(1, Math.max(0, c))), this._target[r] = this._fn(i, a, c);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((n, o) => {
      t.push({
        res: n,
        rej: o
      });
    });
  }
  _notify(t) {
    const n = t ? "res" : "rej", o = this._promises || [];
    for (let r = 0; r < o.length; r++)
      o[r][n]();
  }
}
class PS {
  constructor(t, n) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(n);
  }
  configure(t) {
    if (!Dt(t))
      return;
    const n = Object.keys(hn.animation), o = this._properties;
    Object.getOwnPropertyNames(t).forEach((r) => {
      const i = t[r];
      if (!Dt(i))
        return;
      const s = {};
      for (const a of n)
        s[a] = i[a];
      (fn(i.properties) && i.properties || [
        r
      ]).forEach((a) => {
        (a === r || !o.has(a)) && o.set(a, s);
      });
    });
  }
  _animateOptions(t, n) {
    const o = n.options, r = yJ(t, o);
    if (!r)
      return [];
    const i = this._createAnimations(r, o);
    return o.$shared && xJ(t.options.$animations, o).then(() => {
      t.options = o;
    }, () => {
    }), i;
  }
  _createAnimations(t, n) {
    const o = this._properties, r = [], i = t.$animations || (t.$animations = {}), s = Object.keys(n), a = Date.now();
    let c;
    for (c = s.length - 1; c >= 0; --c) {
      const d = s[c];
      if (d.charAt(0) === "$")
        continue;
      if (d === "options") {
        r.push(...this._animateOptions(t, n));
        continue;
      }
      const u = n[d];
      let p = i[d];
      const h = o.get(d);
      if (p)
        if (h && p.active()) {
          p.update(h, u, a);
          continue;
        } else
          p.cancel();
      if (!h || !h.duration) {
        t[d] = u;
        continue;
      }
      i[d] = p = new CJ(h, t, d, u), r.push(p);
    }
    return r;
  }
  update(t, n) {
    if (this._properties.size === 0) {
      Object.assign(t, n);
      return;
    }
    const o = this._createAnimations(t, n);
    if (o.length)
      return bi.add(this._chart, o), !0;
  }
}
function xJ(e, t) {
  const n = [], o = Object.keys(t);
  for (let r = 0; r < o.length; r++) {
    const i = e[o[r]];
    i && i.active() && n.push(i.wait());
  }
  return Promise.all(n);
}
function yJ(e, t) {
  if (!t)
    return;
  let n = e.options;
  if (!n) {
    e.options = t;
    return;
  }
  return n.$shared && (e.options = n = Object.assign({}, n, {
    $shared: !1,
    $animations: {}
  })), n;
}
function zm(e, t) {
  const n = e && e.options || {}, o = n.reverse, r = n.min === void 0 ? t : 0, i = n.max === void 0 ? t : 0;
  return {
    start: o ? i : r,
    end: o ? r : i
  };
}
function vJ(e, t, n) {
  if (n === !1)
    return !1;
  const o = zm(e, n), r = zm(t, n);
  return {
    top: r.end,
    right: o.end,
    bottom: r.start,
    left: o.start
  };
}
function wJ(e) {
  let t, n, o, r;
  return Dt(e) ? (t = e.top, n = e.right, o = e.bottom, r = e.left) : t = n = o = r = e, {
    top: t,
    right: n,
    bottom: o,
    left: r,
    disabled: e === !1
  };
}
function LS(e, t) {
  const n = [], o = e._getSortedDatasetMetas(t);
  let r, i;
  for (r = 0, i = o.length; r < i; ++r)
    n.push(o[r].index);
  return n;
}
function Zm(e, t, n, o = {}) {
  const r = e.keys, i = o.mode === "single";
  let s, a, c, d;
  if (t === null)
    return;
  let u = !1;
  for (s = 0, a = r.length; s < a; ++s) {
    if (c = +r[s], c === n) {
      if (u = !0, o.all)
        continue;
      break;
    }
    d = e.values[c], kn(d) && (i || t === 0 || ni(t) === ni(d)) && (t += d);
  }
  return !u && !o.all ? 0 : t;
}
function SJ(e, t) {
  const { iScale: n, vScale: o } = t, r = n.axis === "x" ? "x" : "y", i = o.axis === "x" ? "x" : "y", s = Object.keys(e), a = new Array(s.length);
  let c, d, u;
  for (c = 0, d = s.length; c < d; ++c)
    u = s[c], a[c] = {
      [r]: u,
      [i]: e[u]
    };
  return a;
}
function Xf(e, t) {
  const n = e && e.options.stacked;
  return n || n === void 0 && t.stack !== void 0;
}
function MJ(e, t, n) {
  return `${e.id}.${t.id}.${n.stack || n.type}`;
}
function TJ(e) {
  const { min: t, max: n, minDefined: o, maxDefined: r } = e.getUserBounds();
  return {
    min: o ? t : Number.NEGATIVE_INFINITY,
    max: r ? n : Number.POSITIVE_INFINITY
  };
}
function kJ(e, t, n) {
  const o = e[t] || (e[t] = {});
  return o[n] || (o[n] = {});
}
function Wm(e, t, n, o) {
  for (const r of t.getMatchingVisibleMetas(o).reverse()) {
    const i = e[r.index];
    if (n && i > 0 || !n && i < 0)
      return r.index;
  }
  return null;
}
function Um(e, t) {
  const { chart: n, _cachedMeta: o } = e, r = n._stacks || (n._stacks = {}), { iScale: i, vScale: s, index: a } = o, c = i.axis, d = s.axis, u = MJ(i, s, o), p = t.length;
  let h;
  for (let g = 0; g < p; ++g) {
    const m = t[g], { [c]: b, [d]: C } = m, x = m._stacks || (m._stacks = {});
    h = x[d] = kJ(r, u, b), h[a] = C, h._top = Wm(h, s, !0, o.type), h._bottom = Wm(h, s, !1, o.type);
    const v = h._visualValues || (h._visualValues = {});
    v[a] = C;
  }
}
function Jf(e, t) {
  const n = e.scales;
  return Object.keys(n).filter((o) => n[o].axis === t).shift();
}
function EJ(e, t) {
  return Rs(e, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
function RJ(e, t, n) {
  return Rs(e, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: n,
    index: t,
    mode: "default",
    type: "data"
  });
}
function _2(e, t) {
  const n = e.controller.index, o = e.vScale && e.vScale.axis;
  if (o) {
    t = t || e._parsed;
    for (const r of t) {
      const i = r._stacks;
      if (!i || i[o] === void 0 || i[o][n] === void 0)
        return;
      delete i[o][n], i[o]._visualValues !== void 0 && i[o]._visualValues[n] !== void 0 && delete i[o]._visualValues[n];
    }
  }
}
const Qf = (e) => e === "reset" || e === "none", Gm = (e, t) => t ? e : Object.assign({}, e), OJ = (e, t, n) => e && !t.hidden && t._stacked && {
  keys: LS(n, !0),
  values: null
};
class Pr {
  constructor(t, n) {
    this.chart = t, this._ctx = t.ctx, this.index = n, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = Xf(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && _2(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, n = this._cachedMeta, o = this.getDataset(), r = (p, h, g, m) => p === "x" ? h : p === "r" ? m : g, i = n.xAxisID = yt(o.xAxisID, Jf(t, "x")), s = n.yAxisID = yt(o.yAxisID, Jf(t, "y")), a = n.rAxisID = yt(o.rAxisID, Jf(t, "r")), c = n.indexAxis, d = n.iAxisID = r(c, i, s, a), u = n.vAxisID = r(c, s, i, a);
    n.xScale = this.getScaleForId(i), n.yScale = this.getScaleForId(s), n.rScale = this.getScaleForId(a), n.iScale = this.getScaleForId(d), n.vScale = this.getScaleForId(u);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const n = this._cachedMeta;
    return t === n.iScale ? n.vScale : n.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && Om(this._data, this), t._stacked && _2(t);
  }
  _dataCheck() {
    const t = this.getDataset(), n = t.data || (t.data = []), o = this._data;
    if (Dt(n)) {
      const r = this._cachedMeta;
      this._data = SJ(n, r);
    } else if (o !== n) {
      if (o) {
        Om(o, this);
        const r = this._cachedMeta;
        _2(r), r._parsed = [];
      }
      n && Object.isExtensible(n) && hX(n, this), this._syncList = [], this._data = n;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const n = this._cachedMeta, o = this.getDataset();
    let r = !1;
    this._dataCheck();
    const i = n._stacked;
    n._stacked = Xf(n.vScale, n), n.stack !== o.stack && (r = !0, _2(n), n.stack = o.stack), this._resyncElements(t), (r || i !== n._stacked) && (Um(this, n._parsed), n._stacked = Xf(n.vScale, n));
  }
  configure() {
    const t = this.chart.config, n = t.datasetScopeKeys(this._type), o = t.getOptionScopes(this.getDataset(), n, !0);
    this.options = t.createResolver(o, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, n) {
    const { _cachedMeta: o, _data: r } = this, { iScale: i, _stacked: s } = o, a = i.axis;
    let c = t === 0 && n === r.length ? !0 : o._sorted, d = t > 0 && o._parsed[t - 1], u, p, h;
    if (this._parsing === !1)
      o._parsed = r, o._sorted = !0, h = r;
    else {
      fn(r[t]) ? h = this.parseArrayData(o, r, t, n) : Dt(r[t]) ? h = this.parseObjectData(o, r, t, n) : h = this.parsePrimitiveData(o, r, t, n);
      const g = () => p[a] === null || d && p[a] < d[a];
      for (u = 0; u < n; ++u)
        o._parsed[u + t] = p = h[u], c && (g() && (c = !1), d = p);
      o._sorted = c;
    }
    s && Um(this, h);
  }
  parsePrimitiveData(t, n, o, r) {
    const { iScale: i, vScale: s } = t, a = i.axis, c = s.axis, d = i.getLabels(), u = i === s, p = new Array(r);
    let h, g, m;
    for (h = 0, g = r; h < g; ++h)
      m = h + o, p[h] = {
        [a]: u || i.parse(d[m], m),
        [c]: s.parse(n[m], m)
      };
    return p;
  }
  parseArrayData(t, n, o, r) {
    const { xScale: i, yScale: s } = t, a = new Array(r);
    let c, d, u, p;
    for (c = 0, d = r; c < d; ++c)
      u = c + o, p = n[u], a[c] = {
        x: i.parse(p[0], u),
        y: s.parse(p[1], u)
      };
    return a;
  }
  parseObjectData(t, n, o, r) {
    const { xScale: i, yScale: s } = t, { xAxisKey: a = "x", yAxisKey: c = "y" } = this._parsing, d = new Array(r);
    let u, p, h, g;
    for (u = 0, p = r; u < p; ++u)
      h = u + o, g = n[h], d[u] = {
        x: i.parse(bs(g, a), h),
        y: s.parse(bs(g, c), h)
      };
    return d;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, n, o) {
    const r = this.chart, i = this._cachedMeta, s = n[t.axis], a = {
      keys: LS(r, !0),
      values: n._stacks[t.axis]._visualValues
    };
    return Zm(a, s, i.index, {
      mode: o
    });
  }
  updateRangeFromParsed(t, n, o, r) {
    const i = o[n.axis];
    let s = i === null ? NaN : i;
    const a = r && o._stacks[n.axis];
    r && a && (r.values = a, s = Zm(r, i, this._cachedMeta.index)), t.min = Math.min(t.min, s), t.max = Math.max(t.max, s);
  }
  getMinMax(t, n) {
    const o = this._cachedMeta, r = o._parsed, i = o._sorted && t === o.iScale, s = r.length, a = this._getOtherScale(t), c = OJ(n, o, this.chart), d = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: u, max: p } = TJ(a);
    let h, g;
    function m() {
      g = r[h];
      const b = g[a.axis];
      return !kn(g[t.axis]) || u > b || p < b;
    }
    for (h = 0; h < s && !(!m() && (this.updateRangeFromParsed(d, t, g, c), i)); ++h)
      ;
    if (i) {
      for (h = s - 1; h >= 0; --h)
        if (!m()) {
          this.updateRangeFromParsed(d, t, g, c);
          break;
        }
    }
    return d;
  }
  getAllParsedValues(t) {
    const n = this._cachedMeta._parsed, o = [];
    let r, i, s;
    for (r = 0, i = n.length; r < i; ++r)
      s = n[r][t.axis], kn(s) && o.push(s);
    return o;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, o = n.iScale, r = n.vScale, i = this.getParsed(t);
    return {
      label: o ? "" + o.getLabelForValue(i[o.axis]) : "",
      value: r ? "" + r.getLabelForValue(i[r.axis]) : ""
    };
  }
  _update(t) {
    const n = this._cachedMeta;
    this.update(t || "default"), n._clip = wJ(yt(this.options.clip, vJ(n.xScale, n.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, n = this.chart, o = this._cachedMeta, r = o.data || [], i = n.chartArea, s = [], a = this._drawStart || 0, c = this._drawCount || r.length - a, d = this.options.drawActiveElementsOnTop;
    let u;
    for (o.dataset && o.dataset.draw(t, i, a, c), u = a; u < a + c; ++u) {
      const p = r[u];
      p.hidden || (p.active && d ? s.push(p) : p.draw(t, i));
    }
    for (u = 0; u < s.length; ++u)
      s[u].draw(t, i);
  }
  getStyle(t, n) {
    const o = n ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(o) : this.resolveDataElementOptions(t || 0, o);
  }
  getContext(t, n, o) {
    const r = this.getDataset();
    let i;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const s = this._cachedMeta.data[t];
      i = s.$context || (s.$context = RJ(this.getContext(), t, s)), i.parsed = this.getParsed(t), i.raw = r.data[t], i.index = i.dataIndex = t;
    } else
      i = this.$context || (this.$context = EJ(this.chart.getContext(), this.index)), i.dataset = r, i.index = i.datasetIndex = this.index;
    return i.active = !!n, i.mode = o, i;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, n) {
    return this._resolveElementOptions(this.dataElementType.id, n, t);
  }
  _resolveElementOptions(t, n = "default", o) {
    const r = n === "active", i = this._cachedDataOpts, s = t + "-" + n, a = i[s], c = this.enableOptionSharing && zc(o);
    if (a)
      return Gm(a, c);
    const d = this.chart.config, u = d.datasetElementScopeKeys(this._type, t), p = r ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], h = d.getOptionScopes(this.getDataset(), u), g = Object.keys(hn.elements[t]), m = () => this.getContext(o, r, n), b = d.resolveNamedOptions(h, g, m, p);
    return b.$shared && (b.$shared = c, i[s] = Object.freeze(Gm(b, c))), b;
  }
  _resolveAnimations(t, n, o) {
    const r = this.chart, i = this._cachedDataOpts, s = `animation-${n}`, a = i[s];
    if (a)
      return a;
    let c;
    if (r.options.animation !== !1) {
      const u = this.chart.config, p = u.datasetAnimationScopeKeys(this._type, n), h = u.getOptionScopes(this.getDataset(), p);
      c = u.createResolver(h, this.getContext(t, o, n));
    }
    const d = new PS(r, c && c.animations);
    return c && c._cacheable && (i[s] = Object.freeze(d)), d;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, n) {
    return !n || Qf(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, n) {
    const o = this.resolveDataElementOptions(t, n), r = this._sharedOptions, i = this.getSharedOptions(o), s = this.includeOptions(n, i) || i !== r;
    return this.updateSharedOptions(i, n, o), {
      sharedOptions: i,
      includeOptions: s
    };
  }
  updateElement(t, n, o, r) {
    Qf(r) ? Object.assign(t, o) : this._resolveAnimations(n, r).update(t, o);
  }
  updateSharedOptions(t, n, o) {
    t && !Qf(n) && this._resolveAnimations(void 0, n).update(t, o);
  }
  _setStyle(t, n, o, r) {
    t.active = r;
    const i = this.getStyle(n, r);
    this._resolveAnimations(n, o, r).update(t, {
      options: !r && this.getSharedOptions(i) || i
    });
  }
  removeHoverStyle(t, n, o) {
    this._setStyle(t, o, "active", !1);
  }
  setHoverStyle(t, n, o) {
    this._setStyle(t, o, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const n = this._data, o = this._cachedMeta.data;
    for (const [a, c, d] of this._syncList)
      this[a](c, d);
    this._syncList = [];
    const r = o.length, i = n.length, s = Math.min(i, r);
    s && this.parse(0, s), i > r ? this._insertElements(r, i - r, t) : i < r && this._removeElements(i, r - i);
  }
  _insertElements(t, n, o = !0) {
    const r = this._cachedMeta, i = r.data, s = t + n;
    let a;
    const c = (d) => {
      for (d.length += n, a = d.length - 1; a >= s; a--)
        d[a] = d[a - n];
    };
    for (c(i), a = t; a < s; ++a)
      i[a] = new this.dataElementType();
    this._parsing && c(r._parsed), this.parse(t, n), o && this.updateElements(i, t, n, "reset");
  }
  updateElements(t, n, o, r) {
  }
  _removeElements(t, n) {
    const o = this._cachedMeta;
    if (this._parsing) {
      const r = o._parsed.splice(t, n);
      o._stacked && _2(o, r);
    }
    o.data.splice(t, n);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [n, o, r] = t;
      this[n](o, r);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, n) {
    n && this._sync([
      "_removeElements",
      t,
      n
    ]);
    const o = arguments.length - 2;
    o && this._sync([
      "_insertElements",
      t,
      o
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
Ge(Pr, "defaults", {}), Ge(Pr, "datasetElementType", null), Ge(Pr, "dataElementType", null);
function _J(e, t) {
  if (!e._cache.$bar) {
    const n = e.getMatchingVisibleMetas(t);
    let o = [];
    for (let r = 0, i = n.length; r < i; r++)
      o = o.concat(n[r].controller.getAllParsedValues(e));
    e._cache.$bar = fS(o.sort((r, i) => r - i));
  }
  return e._cache.$bar;
}
function PJ(e) {
  const t = e.iScale, n = _J(t, e.type);
  let o = t._length, r, i, s, a;
  const c = () => {
    s === 32767 || s === -32768 || (zc(a) && (o = Math.min(o, Math.abs(s - a) || o)), a = s);
  };
  for (r = 0, i = n.length; r < i; ++r)
    s = t.getPixelForValue(n[r]), c();
  for (a = void 0, r = 0, i = t.ticks.length; r < i; ++r)
    s = t.getPixelForTick(r), c();
  return o;
}
function LJ(e, t, n, o) {
  const r = n.barThickness;
  let i, s;
  return It(r) ? (i = t.min * n.categoryPercentage, s = n.barPercentage) : (i = r * o, s = 1), {
    chunk: i / o,
    ratio: s,
    start: t.pixels[e] - i / 2
  };
}
function IJ(e, t, n, o) {
  const r = t.pixels, i = r[e];
  let s = e > 0 ? r[e - 1] : null, a = e < r.length - 1 ? r[e + 1] : null;
  const c = n.categoryPercentage;
  s === null && (s = i - (a === null ? t.end - t.start : a - i)), a === null && (a = i + i - s);
  const d = i - (i - Math.min(s, a)) / 2 * c;
  return {
    chunk: Math.abs(a - s) / 2 * c / o,
    ratio: n.barPercentage,
    start: d
  };
}
function jJ(e, t, n, o) {
  const r = n.parse(e[0], o), i = n.parse(e[1], o), s = Math.min(r, i), a = Math.max(r, i);
  let c = s, d = a;
  Math.abs(s) > Math.abs(a) && (c = a, d = s), t[n.axis] = d, t._custom = {
    barStart: c,
    barEnd: d,
    start: r,
    end: i,
    min: s,
    max: a
  };
}
function IS(e, t, n, o) {
  return fn(e) ? jJ(e, t, n, o) : t[n.axis] = n.parse(e, o), t;
}
function qm(e, t, n, o) {
  const r = e.iScale, i = e.vScale, s = r.getLabels(), a = r === i, c = [];
  let d, u, p, h;
  for (d = n, u = n + o; d < u; ++d)
    h = t[d], p = {}, p[r.axis] = a || r.parse(s[d], d), c.push(IS(h, p, i, d));
  return c;
}
function e6(e) {
  return e && e.barStart !== void 0 && e.barEnd !== void 0;
}
function VJ(e, t, n) {
  return e !== 0 ? ni(e) : (t.isHorizontal() ? 1 : -1) * (t.min >= n ? 1 : -1);
}
function DJ(e) {
  let t, n, o, r, i;
  return e.horizontal ? (t = e.base > e.x, n = "left", o = "right") : (t = e.base < e.y, n = "bottom", o = "top"), t ? (r = "end", i = "start") : (r = "start", i = "end"), {
    start: n,
    end: o,
    reverse: t,
    top: r,
    bottom: i
  };
}
function AJ(e, t, n, o) {
  let r = t.borderSkipped;
  const i = {};
  if (!r) {
    e.borderSkipped = i;
    return;
  }
  if (r === !0) {
    e.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: s, end: a, reverse: c, top: d, bottom: u } = DJ(e);
  r === "middle" && n && (e.enableBorderRadius = !0, (n._top || 0) === o ? r = d : (n._bottom || 0) === o ? r = u : (i[Km(u, s, a, c)] = !0, r = d)), i[Km(r, s, a, c)] = !0, e.borderSkipped = i;
}
function Km(e, t, n, o) {
  return o ? (e = HJ(e, t, n), e = Ym(e, n, t)) : e = Ym(e, t, n), e;
}
function HJ(e, t, n) {
  return e === t ? n : e === n ? t : e;
}
function Ym(e, t, n) {
  return e === "start" ? t : e === "end" ? n : e;
}
function FJ(e, { inflateAmount: t }, n) {
  e.inflateAmount = t === "auto" ? n === 1 ? 0.33 : 0 : t;
}
class xd extends Pr {
  parsePrimitiveData(t, n, o, r) {
    return qm(t, n, o, r);
  }
  parseArrayData(t, n, o, r) {
    return qm(t, n, o, r);
  }
  parseObjectData(t, n, o, r) {
    const { iScale: i, vScale: s } = t, { xAxisKey: a = "x", yAxisKey: c = "y" } = this._parsing, d = i.axis === "x" ? a : c, u = s.axis === "x" ? a : c, p = [];
    let h, g, m, b;
    for (h = o, g = o + r; h < g; ++h)
      b = n[h], m = {}, m[i.axis] = i.parse(bs(b, d), h), p.push(IS(bs(b, u), m, s, h));
    return p;
  }
  updateRangeFromParsed(t, n, o, r) {
    super.updateRangeFromParsed(t, n, o, r);
    const i = o._custom;
    i && n === this._cachedMeta.vScale && (t.min = Math.min(t.min, i.min), t.max = Math.max(t.max, i.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, { iScale: o, vScale: r } = n, i = this.getParsed(t), s = i._custom, a = e6(s) ? "[" + s.start + ", " + s.end + "]" : "" + r.getLabelForValue(i[r.axis]);
    return {
      label: "" + o.getLabelForValue(i[o.axis]),
      value: a
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const n = this._cachedMeta;
    this.updateElements(n.data, 0, n.data.length, t);
  }
  updateElements(t, n, o, r) {
    const i = r === "reset", { index: s, _cachedMeta: { vScale: a } } = this, c = a.getBasePixel(), d = a.isHorizontal(), u = this._getRuler(), { sharedOptions: p, includeOptions: h } = this._getSharedOptions(n, r);
    for (let g = n; g < n + o; g++) {
      const m = this.getParsed(g), b = i || It(m[a.axis]) ? {
        base: c,
        head: c
      } : this._calculateBarValuePixels(g), C = this._calculateBarIndexPixels(g, u), x = (m._stacks || {})[a.axis], v = {
        horizontal: d,
        base: b.base,
        enableBorderRadius: !x || e6(m._custom) || s === x._top || s === x._bottom,
        x: d ? b.head : C.center,
        y: d ? C.center : b.head,
        height: d ? C.size : Math.abs(b.size),
        width: d ? Math.abs(b.size) : C.size
      };
      h && (v.options = p || this.resolveDataElementOptions(g, t[g].active ? "active" : r));
      const S = v.options || t[g].options;
      AJ(v, S, x, s), FJ(v, S, u.ratio), this.updateElement(t[g], g, v, r);
    }
  }
  _getStacks(t, n) {
    const { iScale: o } = this._cachedMeta, r = o.getMatchingVisibleMetas(this._type).filter((u) => u.controller.options.grouped), i = o.options.stacked, s = [], a = this._cachedMeta.controller.getParsed(n), c = a && a[o.axis], d = (u) => {
      const p = u._parsed.find((g) => g[o.axis] === c), h = p && p[u.vScale.axis];
      if (It(h) || isNaN(h))
        return !0;
    };
    for (const u of r)
      if (!(n !== void 0 && d(u)) && ((i === !1 || s.indexOf(u.stack) === -1 || i === void 0 && u.stack === void 0) && s.push(u.stack), u.index === t))
        break;
    return s.length || s.push(void 0), s;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getStackIndex(t, n, o) {
    const r = this._getStacks(t, o), i = n !== void 0 ? r.indexOf(n) : -1;
    return i === -1 ? r.length - 1 : i;
  }
  _getRuler() {
    const t = this.options, n = this._cachedMeta, o = n.iScale, r = [];
    let i, s;
    for (i = 0, s = n.data.length; i < s; ++i)
      r.push(o.getPixelForValue(this.getParsed(i)[o.axis], i));
    const a = t.barThickness;
    return {
      min: a || PJ(n),
      pixels: r,
      start: o._startPixel,
      end: o._endPixel,
      stackCount: this._getStackCount(),
      scale: o,
      grouped: t.grouped,
      ratio: a ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: n, _stacked: o, index: r }, options: { base: i, minBarLength: s } } = this, a = i || 0, c = this.getParsed(t), d = c._custom, u = e6(d);
    let p = c[n.axis], h = 0, g = o ? this.applyStack(n, c, o) : p, m, b;
    g !== p && (h = g - p, g = p), u && (p = d.barStart, g = d.barEnd - d.barStart, p !== 0 && ni(p) !== ni(d.barEnd) && (h = 0), h += p);
    const C = !It(i) && !u ? i : h;
    let x = n.getPixelForValue(C);
    if (this.chart.getDataVisibility(t) ? m = n.getPixelForValue(h + g) : m = x, b = m - x, Math.abs(b) < s) {
      b = VJ(b, n, a) * s, p === a && (x -= b / 2);
      const v = n.getPixelForDecimal(0), S = n.getPixelForDecimal(1), M = Math.min(v, S), w = Math.max(v, S);
      x = Math.max(Math.min(x, w), M), m = x + b, o && !u && (c._stacks[n.axis]._visualValues[r] = n.getValueForPixel(m) - n.getValueForPixel(x));
    }
    if (x === n.getPixelForValue(a)) {
      const v = ni(b) * n.getLineWidthForValue(a) / 2;
      x += v, b -= v;
    }
    return {
      size: b,
      base: x,
      head: m,
      center: m + b / 2
    };
  }
  _calculateBarIndexPixels(t, n) {
    const o = n.scale, r = this.options, i = r.skipNull, s = yt(r.maxBarThickness, 1 / 0);
    let a, c;
    if (n.grouped) {
      const d = i ? this._getStackCount(t) : n.stackCount, u = r.barThickness === "flex" ? IJ(t, n, r, d) : LJ(t, n, r, d), p = this._getStackIndex(this.index, this._cachedMeta.stack, i ? t : void 0);
      a = u.start + u.chunk * p + u.chunk / 2, c = Math.min(s, u.chunk * u.ratio);
    } else
      a = o.getPixelForValue(this.getParsed(t)[o.axis], t), c = Math.min(s, n.min * n.ratio);
    return {
      base: a - c / 2,
      head: a + c / 2,
      center: a,
      size: c
    };
  }
  draw() {
    const t = this._cachedMeta, n = t.vScale, o = t.data, r = o.length;
    let i = 0;
    for (; i < r; ++i)
      this.getParsed(i)[n.axis] !== null && !o[i].hidden && o[i].draw(this._ctx);
  }
}
Ge(xd, "id", "bar"), Ge(xd, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), Ge(xd, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
class yd extends Pr {
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
  }
  parsePrimitiveData(t, n, o, r) {
    const i = super.parsePrimitiveData(t, n, o, r);
    for (let s = 0; s < i.length; s++)
      i[s]._custom = this.resolveDataElementOptions(s + o).radius;
    return i;
  }
  parseArrayData(t, n, o, r) {
    const i = super.parseArrayData(t, n, o, r);
    for (let s = 0; s < i.length; s++) {
      const a = n[o + s];
      i[s]._custom = yt(a[2], this.resolveDataElementOptions(s + o).radius);
    }
    return i;
  }
  parseObjectData(t, n, o, r) {
    const i = super.parseObjectData(t, n, o, r);
    for (let s = 0; s < i.length; s++) {
      const a = n[o + s];
      i[s]._custom = yt(a && a.r && +a.r, this.resolveDataElementOptions(s + o).radius);
    }
    return i;
  }
  getMaxOverflow() {
    const t = this._cachedMeta.data;
    let n = 0;
    for (let o = t.length - 1; o >= 0; --o)
      n = Math.max(n, t[o].size(this.resolveDataElementOptions(o)) / 2);
    return n > 0 && n;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, o = this.chart.data.labels || [], { xScale: r, yScale: i } = n, s = this.getParsed(t), a = r.getLabelForValue(s.x), c = i.getLabelForValue(s.y), d = s._custom;
    return {
      label: o[t] || "",
      value: "(" + a + ", " + c + (d ? ", " + d : "") + ")"
    };
  }
  update(t) {
    const n = this._cachedMeta.data;
    this.updateElements(n, 0, n.length, t);
  }
  updateElements(t, n, o, r) {
    const i = r === "reset", { iScale: s, vScale: a } = this._cachedMeta, { sharedOptions: c, includeOptions: d } = this._getSharedOptions(n, r), u = s.axis, p = a.axis;
    for (let h = n; h < n + o; h++) {
      const g = t[h], m = !i && this.getParsed(h), b = {}, C = b[u] = i ? s.getPixelForDecimal(0.5) : s.getPixelForValue(m[u]), x = b[p] = i ? a.getBasePixel() : a.getPixelForValue(m[p]);
      b.skip = isNaN(C) || isNaN(x), d && (b.options = c || this.resolveDataElementOptions(h, g.active ? "active" : r), i && (b.options.radius = 0)), this.updateElement(g, h, b, r);
    }
  }
  resolveDataElementOptions(t, n) {
    const o = this.getParsed(t);
    let r = super.resolveDataElementOptions(t, n);
    r.$shared && (r = Object.assign({}, r, {
      $shared: !1
    }));
    const i = r.radius;
    return n !== "active" && (r.radius = 0), r.radius += yt(o && o._custom, i), r;
  }
}
Ge(yd, "id", "bubble"), Ge(yd, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "borderWidth",
        "radius"
      ]
    }
  }
}), Ge(yd, "overrides", {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
function NJ(e, t, n) {
  let o = 1, r = 1, i = 0, s = 0;
  if (t < pn) {
    const a = e, c = a + t, d = Math.cos(a), u = Math.sin(a), p = Math.cos(c), h = Math.sin(c), g = (S, M, w) => Zc(S, a, c, !0) ? 1 : Math.max(M, M * n, w, w * n), m = (S, M, w) => Zc(S, a, c, !0) ? -1 : Math.min(M, M * n, w, w * n), b = g(0, d, p), C = g(On, u, h), x = m(mn, d, p), v = m(mn + On, u, h);
    o = (b - x) / 2, r = (C - v) / 2, i = -(b + x) / 2, s = -(C + v) / 2;
  }
  return {
    ratioX: o,
    ratioY: r,
    offsetX: i,
    offsetY: s
  };
}
class Qi extends Pr {
  constructor(t, n) {
    super(t, n), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, n) {
    const o = this.getDataset().data, r = this._cachedMeta;
    if (this._parsing === !1)
      r._parsed = o;
    else {
      let i = (c) => +o[c];
      if (Dt(o[t])) {
        const { key: c = "value" } = this._parsing;
        i = (d) => +bs(o[d], c);
      }
      let s, a;
      for (s = t, a = t + n; s < a; ++s)
        r._parsed[s] = i(s);
    }
  }
  _getRotation() {
    return Or(this.options.rotation - 90);
  }
  _getCircumference() {
    return Or(this.options.circumference);
  }
  _getRotationExtents() {
    let t = pn, n = -pn;
    for (let o = 0; o < this.chart.data.datasets.length; ++o)
      if (this.chart.isDatasetVisible(o) && this.chart.getDatasetMeta(o).type === this._type) {
        const r = this.chart.getDatasetMeta(o).controller, i = r._getRotation(), s = r._getCircumference();
        t = Math.min(t, i), n = Math.max(n, i + s);
      }
    return {
      rotation: t,
      circumference: n - t
    };
  }
  update(t) {
    const n = this.chart, { chartArea: o } = n, r = this._cachedMeta, i = r.data, s = this.getMaxBorderWidth() + this.getMaxOffset(i) + this.options.spacing, a = Math.max((Math.min(o.width, o.height) - s) / 2, 0), c = Math.min(eX(this.options.cutout, a), 1), d = this._getRingWeight(this.index), { circumference: u, rotation: p } = this._getRotationExtents(), { ratioX: h, ratioY: g, offsetX: m, offsetY: b } = NJ(p, u, c), C = (o.width - s) / h, x = (o.height - s) / g, v = Math.max(Math.min(C, x) / 2, 0), S = aS(this.options.radius, v), M = Math.max(S * c, 0), w = (S - M) / this._getVisibleDatasetWeightTotal();
    this.offsetX = m * S, this.offsetY = b * S, r.total = this.calculateTotal(), this.outerRadius = S - w * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - w * d, 0), this.updateElements(i, 0, i.length, t);
  }
  _circumference(t, n) {
    const o = this.options, r = this._cachedMeta, i = this._getCircumference();
    return n && o.animation.animateRotate || !this.chart.getDataVisibility(t) || r._parsed[t] === null || r.data[t].hidden ? 0 : this.calculateCircumference(r._parsed[t] * i / pn);
  }
  updateElements(t, n, o, r) {
    const i = r === "reset", s = this.chart, a = s.chartArea, d = s.options.animation, u = (a.left + a.right) / 2, p = (a.top + a.bottom) / 2, h = i && d.animateScale, g = h ? 0 : this.innerRadius, m = h ? 0 : this.outerRadius, { sharedOptions: b, includeOptions: C } = this._getSharedOptions(n, r);
    let x = this._getRotation(), v;
    for (v = 0; v < n; ++v)
      x += this._circumference(v, i);
    for (v = n; v < n + o; ++v) {
      const S = this._circumference(v, i), M = t[v], w = {
        x: u + this.offsetX,
        y: p + this.offsetY,
        startAngle: x,
        endAngle: x + S,
        circumference: S,
        outerRadius: m,
        innerRadius: g
      };
      C && (w.options = b || this.resolveDataElementOptions(v, M.active ? "active" : r)), x += S, this.updateElement(M, v, w, r);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, n = t.data;
    let o = 0, r;
    for (r = 0; r < n.length; r++) {
      const i = t._parsed[r];
      i !== null && !isNaN(i) && this.chart.getDataVisibility(r) && !n[r].hidden && (o += Math.abs(i));
    }
    return o;
  }
  calculateCircumference(t) {
    const n = this._cachedMeta.total;
    return n > 0 && !isNaN(t) ? pn * (Math.abs(t) / n) : 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, o = this.chart, r = o.data.labels || [], i = A0(n._parsed[t], o.options.locale);
    return {
      label: r[t] || "",
      value: i
    };
  }
  getMaxBorderWidth(t) {
    let n = 0;
    const o = this.chart;
    let r, i, s, a, c;
    if (!t) {
      for (r = 0, i = o.data.datasets.length; r < i; ++r)
        if (o.isDatasetVisible(r)) {
          s = o.getDatasetMeta(r), t = s.data, a = s.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (r = 0, i = t.length; r < i; ++r)
      c = a.resolveDataElementOptions(r), c.borderAlign !== "inner" && (n = Math.max(n, c.borderWidth || 0, c.hoverBorderWidth || 0));
    return n;
  }
  getMaxOffset(t) {
    let n = 0;
    for (let o = 0, r = t.length; o < r; ++o) {
      const i = this.resolveDataElementOptions(o);
      n = Math.max(n, i.offset || 0, i.hoverOffset || 0);
    }
    return n;
  }
  _getRingWeightOffset(t) {
    let n = 0;
    for (let o = 0; o < t; ++o)
      this.chart.isDatasetVisible(o) && (n += this._getRingWeight(o));
    return n;
  }
  _getRingWeight(t) {
    return Math.max(yt(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
Ge(Qi, "id", "doughnut"), Ge(Qi, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), Ge(Qi, "descriptors", {
  _scriptable: (t) => t !== "spacing",
  _indexable: (t) => t !== "spacing" && !t.startsWith("borderDash") && !t.startsWith("hoverBorderDash")
}), Ge(Qi, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const n = t.data;
          if (n.labels.length && n.datasets.length) {
            const { labels: { pointStyle: o, color: r } } = t.legend.options;
            return n.labels.map((i, s) => {
              const c = t.getDatasetMeta(0).controller.getStyle(s);
              return {
                text: i,
                fillStyle: c.backgroundColor,
                strokeStyle: c.borderColor,
                fontColor: r,
                lineWidth: c.borderWidth,
                pointStyle: o,
                hidden: !t.getDataVisibility(s),
                index: s
              };
            });
          }
          return [];
        }
      },
      onClick(t, n, o) {
        o.chart.toggleDataVisibility(n.index), o.chart.update();
      }
    }
  }
});
class vd extends Pr {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const n = this._cachedMeta, { dataset: o, data: r = [], _dataset: i } = n, s = this.chart._animationsDisabled;
    let { start: a, count: c } = gS(n, r, s);
    this._drawStart = a, this._drawCount = c, mS(n) && (a = 0, c = r.length), o._chart = this.chart, o._datasetIndex = this.index, o._decimated = !!i._decimated, o.points = r;
    const d = this.resolveDatasetElementOptions(t);
    this.options.showLine || (d.borderWidth = 0), d.segment = this.options.segment, this.updateElement(o, void 0, {
      animated: !s,
      options: d
    }, t), this.updateElements(r, a, c, t);
  }
  updateElements(t, n, o, r) {
    const i = r === "reset", { iScale: s, vScale: a, _stacked: c, _dataset: d } = this._cachedMeta, { sharedOptions: u, includeOptions: p } = this._getSharedOptions(n, r), h = s.axis, g = a.axis, { spanGaps: m, segment: b } = this.options, C = Hl(m) ? m : Number.POSITIVE_INFINITY, x = this.chart._animationsDisabled || i || r === "none", v = n + o, S = t.length;
    let M = n > 0 && this.getParsed(n - 1);
    for (let w = 0; w < S; ++w) {
      const k = t[w], E = x ? k : {};
      if (w < n || w >= v) {
        E.skip = !0;
        continue;
      }
      const R = this.getParsed(w), O = It(R[g]), P = E[h] = s.getPixelForValue(R[h], w), _ = E[g] = i || O ? a.getBasePixel() : a.getPixelForValue(c ? this.applyStack(a, R, c) : R[g], w);
      E.skip = isNaN(P) || isNaN(_) || O, E.stop = w > 0 && Math.abs(R[h] - M[h]) > C, b && (E.parsed = R, E.raw = d.data[w]), p && (E.options = u || this.resolveDataElementOptions(w, k.active ? "active" : r)), x || this.updateElement(k, w, E, r), M = R;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, n = t.dataset, o = n.options && n.options.borderWidth || 0, r = t.data || [];
    if (!r.length)
      return o;
    const i = r[0].size(this.resolveDataElementOptions(0)), s = r[r.length - 1].size(this.resolveDataElementOptions(r.length - 1));
    return Math.max(o, i, s) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
Ge(vd, "id", "line"), Ge(vd, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), Ge(vd, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
class dc extends Pr {
  constructor(t, n) {
    super(t, n), this.innerRadius = void 0, this.outerRadius = void 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, o = this.chart, r = o.data.labels || [], i = A0(n._parsed[t].r, o.options.locale);
    return {
      label: r[t] || "",
      value: i
    };
  }
  parseObjectData(t, n, o, r) {
    return MS.bind(this)(t, n, o, r);
  }
  update(t) {
    const n = this._cachedMeta.data;
    this._updateRadius(), this.updateElements(n, 0, n.length, t);
  }
  getMinMax() {
    const t = this._cachedMeta, n = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    };
    return t.data.forEach((o, r) => {
      const i = this.getParsed(r).r;
      !isNaN(i) && this.chart.getDataVisibility(r) && (i < n.min && (n.min = i), i > n.max && (n.max = i));
    }), n;
  }
  _updateRadius() {
    const t = this.chart, n = t.chartArea, o = t.options, r = Math.min(n.right - n.left, n.bottom - n.top), i = Math.max(r / 2, 0), s = Math.max(o.cutoutPercentage ? i / 100 * o.cutoutPercentage : 1, 0), a = (i - s) / t.getVisibleDatasetCount();
    this.outerRadius = i - a * this.index, this.innerRadius = this.outerRadius - a;
  }
  updateElements(t, n, o, r) {
    const i = r === "reset", s = this.chart, c = s.options.animation, d = this._cachedMeta.rScale, u = d.xCenter, p = d.yCenter, h = d.getIndexAngle(0) - 0.5 * mn;
    let g = h, m;
    const b = 360 / this.countVisibleElements();
    for (m = 0; m < n; ++m)
      g += this._computeAngle(m, r, b);
    for (m = n; m < n + o; m++) {
      const C = t[m];
      let x = g, v = g + this._computeAngle(m, r, b), S = s.getDataVisibility(m) ? d.getDistanceFromCenterForValue(this.getParsed(m).r) : 0;
      g = v, i && (c.animateScale && (S = 0), c.animateRotate && (x = v = h));
      const M = {
        x: u,
        y: p,
        innerRadius: 0,
        outerRadius: S,
        startAngle: x,
        endAngle: v,
        options: this.resolveDataElementOptions(m, C.active ? "active" : r)
      };
      this.updateElement(C, m, M, r);
    }
  }
  countVisibleElements() {
    const t = this._cachedMeta;
    let n = 0;
    return t.data.forEach((o, r) => {
      !isNaN(this.getParsed(r).r) && this.chart.getDataVisibility(r) && n++;
    }), n;
  }
  _computeAngle(t, n, o) {
    return this.chart.getDataVisibility(t) ? Or(this.resolveDataElementOptions(t, n).angle || o) : 0;
  }
}
Ge(dc, "id", "polarArea"), Ge(dc, "defaults", {
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !0
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "startAngle",
        "endAngle",
        "innerRadius",
        "outerRadius"
      ]
    }
  },
  indexAxis: "r",
  startAngle: 0
}), Ge(dc, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const n = t.data;
          if (n.labels.length && n.datasets.length) {
            const { labels: { pointStyle: o, color: r } } = t.legend.options;
            return n.labels.map((i, s) => {
              const c = t.getDatasetMeta(0).controller.getStyle(s);
              return {
                text: i,
                fillStyle: c.backgroundColor,
                strokeStyle: c.borderColor,
                fontColor: r,
                lineWidth: c.borderWidth,
                pointStyle: o,
                hidden: !t.getDataVisibility(s),
                index: s
              };
            });
          }
          return [];
        }
      },
      onClick(t, n, o) {
        o.chart.toggleDataVisibility(n.index), o.chart.update();
      }
    }
  },
  scales: {
    r: {
      type: "radialLinear",
      angleLines: {
        display: !1
      },
      beginAtZero: !0,
      grid: {
        circular: !0
      },
      pointLabels: {
        display: !1
      },
      startAngle: 0
    }
  }
});
class Xp extends Qi {
}
Ge(Xp, "id", "pie"), Ge(Xp, "defaults", {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
});
class wd extends Pr {
  getLabelAndValue(t) {
    const n = this._cachedMeta.vScale, o = this.getParsed(t);
    return {
      label: n.getLabels()[t],
      value: "" + n.getLabelForValue(o[n.axis])
    };
  }
  parseObjectData(t, n, o, r) {
    return MS.bind(this)(t, n, o, r);
  }
  update(t) {
    const n = this._cachedMeta, o = n.dataset, r = n.data || [], i = n.iScale.getLabels();
    if (o.points = r, t !== "resize") {
      const s = this.resolveDatasetElementOptions(t);
      this.options.showLine || (s.borderWidth = 0);
      const a = {
        _loop: !0,
        _fullLoop: i.length === r.length,
        options: s
      };
      this.updateElement(o, void 0, a, t);
    }
    this.updateElements(r, 0, r.length, t);
  }
  updateElements(t, n, o, r) {
    const i = this._cachedMeta.rScale, s = r === "reset";
    for (let a = n; a < n + o; a++) {
      const c = t[a], d = this.resolveDataElementOptions(a, c.active ? "active" : r), u = i.getPointPositionForValue(a, this.getParsed(a).r), p = s ? i.xCenter : u.x, h = s ? i.yCenter : u.y, g = {
        x: p,
        y: h,
        angle: u.angle,
        skip: isNaN(p) || isNaN(h),
        options: d
      };
      this.updateElement(c, a, g, r);
    }
  }
}
Ge(wd, "id", "radar"), Ge(wd, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  indexAxis: "r",
  showLine: !0,
  elements: {
    line: {
      fill: "start"
    }
  }
}), Ge(wd, "overrides", {
  aspectRatio: 1,
  scales: {
    r: {
      type: "radialLinear"
    }
  }
});
class uc extends Pr {
  getLabelAndValue(t) {
    const n = this._cachedMeta, o = this.chart.data.labels || [], { xScale: r, yScale: i } = n, s = this.getParsed(t), a = r.getLabelForValue(s.x), c = i.getLabelForValue(s.y);
    return {
      label: o[t] || "",
      value: "(" + a + ", " + c + ")"
    };
  }
  update(t) {
    const n = this._cachedMeta, { data: o = [] } = n, r = this.chart._animationsDisabled;
    let { start: i, count: s } = gS(n, o, r);
    if (this._drawStart = i, this._drawCount = s, mS(n) && (i = 0, s = o.length), this.options.showLine) {
      this.datasetElementType || this.addElements();
      const { dataset: a, _dataset: c } = n;
      a._chart = this.chart, a._datasetIndex = this.index, a._decimated = !!c._decimated, a.points = o;
      const d = this.resolveDatasetElementOptions(t);
      d.segment = this.options.segment, this.updateElement(a, void 0, {
        animated: !r,
        options: d
      }, t);
    } else this.datasetElementType && (delete n.dataset, this.datasetElementType = !1);
    this.updateElements(o, i, s, t);
  }
  addElements() {
    const { showLine: t } = this.options;
    !this.datasetElementType && t && (this.datasetElementType = this.chart.registry.getElement("line")), super.addElements();
  }
  updateElements(t, n, o, r) {
    const i = r === "reset", { iScale: s, vScale: a, _stacked: c, _dataset: d } = this._cachedMeta, u = this.resolveDataElementOptions(n, r), p = this.getSharedOptions(u), h = this.includeOptions(r, p), g = s.axis, m = a.axis, { spanGaps: b, segment: C } = this.options, x = Hl(b) ? b : Number.POSITIVE_INFINITY, v = this.chart._animationsDisabled || i || r === "none";
    let S = n > 0 && this.getParsed(n - 1);
    for (let M = n; M < n + o; ++M) {
      const w = t[M], k = this.getParsed(M), E = v ? w : {}, R = It(k[m]), O = E[g] = s.getPixelForValue(k[g], M), P = E[m] = i || R ? a.getBasePixel() : a.getPixelForValue(c ? this.applyStack(a, k, c) : k[m], M);
      E.skip = isNaN(O) || isNaN(P) || R, E.stop = M > 0 && Math.abs(k[g] - S[g]) > x, C && (E.parsed = k, E.raw = d.data[M]), h && (E.options = p || this.resolveDataElementOptions(M, w.active ? "active" : r)), v || this.updateElement(w, M, E, r), S = k;
    }
    this.updateSharedOptions(p, r, u);
  }
  getMaxOverflow() {
    const t = this._cachedMeta, n = t.data || [];
    if (!this.options.showLine) {
      let a = 0;
      for (let c = n.length - 1; c >= 0; --c)
        a = Math.max(a, n[c].size(this.resolveDataElementOptions(c)) / 2);
      return a > 0 && a;
    }
    const o = t.dataset, r = o.options && o.options.borderWidth || 0;
    if (!n.length)
      return r;
    const i = n[0].size(this.resolveDataElementOptions(0)), s = n[n.length - 1].size(this.resolveDataElementOptions(n.length - 1));
    return Math.max(r, i, s) / 2;
  }
}
Ge(uc, "id", "scatter"), Ge(uc, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  showLine: !1,
  fill: !1
}), Ge(uc, "overrides", {
  interaction: {
    mode: "point"
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
var $J = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BarController: xd,
  BubbleController: yd,
  DoughnutController: Qi,
  LineController: vd,
  PieController: Xp,
  PolarAreaController: dc,
  RadarController: wd,
  ScatterController: uc
});
function As() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class _7 {
  constructor(t) {
    Ge(this, "options");
    this.options = t || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(t) {
    Object.assign(_7.prototype, t);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return As();
  }
  parse() {
    return As();
  }
  format() {
    return As();
  }
  add() {
    return As();
  }
  diff() {
    return As();
  }
  startOf() {
    return As();
  }
  endOf() {
    return As();
  }
}
var BJ = {
  _date: _7
};
function zJ(e, t, n, o) {
  const { controller: r, data: i, _sorted: s } = e, a = r._cachedMeta.iScale;
  if (a && t === a.axis && t !== "r" && s && i.length) {
    const c = a._reversePixels ? fX : ki;
    if (o) {
      if (r._sharedOptions) {
        const d = i[0], u = typeof d.getRange == "function" && d.getRange(t);
        if (u) {
          const p = c(i, t, n - u), h = c(i, t, n + u);
          return {
            lo: p.lo,
            hi: h.hi
          };
        }
      }
    } else return c(i, t, n);
  }
  return {
    lo: 0,
    hi: i.length - 1
  };
}
function H0(e, t, n, o, r) {
  const i = e.getSortedVisibleDatasetMetas(), s = n[t];
  for (let a = 0, c = i.length; a < c; ++a) {
    const { index: d, data: u } = i[a], { lo: p, hi: h } = zJ(i[a], t, s, r);
    for (let g = p; g <= h; ++g) {
      const m = u[g];
      m.skip || o(m, d, g);
    }
  }
}
function ZJ(e) {
  const t = e.indexOf("x") !== -1, n = e.indexOf("y") !== -1;
  return function(o, r) {
    const i = t ? Math.abs(o.x - r.x) : 0, s = n ? Math.abs(o.y - r.y) : 0;
    return Math.sqrt(Math.pow(i, 2) + Math.pow(s, 2));
  };
}
function t6(e, t, n, o, r) {
  const i = [];
  return !r && !e.isPointInArea(t) || H0(e, n, t, function(a, c, d) {
    !r && !Ei(a, e.chartArea, 0) || a.inRange(t.x, t.y, o) && i.push({
      element: a,
      datasetIndex: c,
      index: d
    });
  }, !0), i;
}
function WJ(e, t, n, o) {
  let r = [];
  function i(s, a, c) {
    const { startAngle: d, endAngle: u } = s.getProps([
      "startAngle",
      "endAngle"
    ], o), { angle: p } = dS(s, {
      x: t.x,
      y: t.y
    });
    Zc(p, d, u) && r.push({
      element: s,
      datasetIndex: a,
      index: c
    });
  }
  return H0(e, n, t, i), r;
}
function UJ(e, t, n, o, r, i) {
  let s = [];
  const a = ZJ(n);
  let c = Number.POSITIVE_INFINITY;
  function d(u, p, h) {
    const g = u.inRange(t.x, t.y, r);
    if (o && !g)
      return;
    const m = u.getCenterPoint(r);
    if (!(!!i || e.isPointInArea(m)) && !g)
      return;
    const C = a(t, m);
    C < c ? (s = [
      {
        element: u,
        datasetIndex: p,
        index: h
      }
    ], c = C) : C === c && s.push({
      element: u,
      datasetIndex: p,
      index: h
    });
  }
  return H0(e, n, t, d), s;
}
function n6(e, t, n, o, r, i) {
  return !i && !e.isPointInArea(t) ? [] : n === "r" && !o ? WJ(e, t, n, r) : UJ(e, t, n, o, r, i);
}
function Xm(e, t, n, o, r) {
  const i = [], s = n === "x" ? "inXRange" : "inYRange";
  let a = !1;
  return H0(e, n, t, (c, d, u) => {
    c[s] && c[s](t[n], r) && (i.push({
      element: c,
      datasetIndex: d,
      index: u
    }), a = a || c.inRange(t.x, t.y, r));
  }), o && !a ? [] : i;
}
var GJ = {
  evaluateInteractionItems: H0,
  modes: {
    index(e, t, n, o) {
      const r = Ws(t, e), i = n.axis || "x", s = n.includeInvisible || !1, a = n.intersect ? t6(e, r, i, o, s) : n6(e, r, i, !1, o, s), c = [];
      return a.length ? (e.getSortedVisibleDatasetMetas().forEach((d) => {
        const u = a[0].index, p = d.data[u];
        p && !p.skip && c.push({
          element: p,
          datasetIndex: d.index,
          index: u
        });
      }), c) : [];
    },
    dataset(e, t, n, o) {
      const r = Ws(t, e), i = n.axis || "xy", s = n.includeInvisible || !1;
      let a = n.intersect ? t6(e, r, i, o, s) : n6(e, r, i, !1, o, s);
      if (a.length > 0) {
        const c = a[0].datasetIndex, d = e.getDatasetMeta(c).data;
        a = [];
        for (let u = 0; u < d.length; ++u)
          a.push({
            element: d[u],
            datasetIndex: c,
            index: u
          });
      }
      return a;
    },
    point(e, t, n, o) {
      const r = Ws(t, e), i = n.axis || "xy", s = n.includeInvisible || !1;
      return t6(e, r, i, o, s);
    },
    nearest(e, t, n, o) {
      const r = Ws(t, e), i = n.axis || "xy", s = n.includeInvisible || !1;
      return n6(e, r, i, n.intersect, o, s);
    },
    x(e, t, n, o) {
      const r = Ws(t, e);
      return Xm(e, r, "x", n.intersect, o);
    },
    y(e, t, n, o) {
      const r = Ws(t, e);
      return Xm(e, r, "y", n.intersect, o);
    }
  }
};
const jS = [
  "left",
  "top",
  "right",
  "bottom"
];
function P2(e, t) {
  return e.filter((n) => n.pos === t);
}
function Jm(e, t) {
  return e.filter((n) => jS.indexOf(n.pos) === -1 && n.box.axis === t);
}
function L2(e, t) {
  return e.sort((n, o) => {
    const r = t ? o : n, i = t ? n : o;
    return r.weight === i.weight ? r.index - i.index : r.weight - i.weight;
  });
}
function qJ(e) {
  const t = [];
  let n, o, r, i, s, a;
  for (n = 0, o = (e || []).length; n < o; ++n)
    r = e[n], { position: i, options: { stack: s, stackWeight: a = 1 } } = r, t.push({
      index: n,
      box: r,
      pos: i,
      horizontal: r.isHorizontal(),
      weight: r.weight,
      stack: s && i + s,
      stackWeight: a
    });
  return t;
}
function KJ(e) {
  const t = {};
  for (const n of e) {
    const { stack: o, pos: r, stackWeight: i } = n;
    if (!o || !jS.includes(r))
      continue;
    const s = t[o] || (t[o] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    s.count++, s.weight += i;
  }
  return t;
}
function YJ(e, t) {
  const n = KJ(e), { vBoxMaxWidth: o, hBoxMaxHeight: r } = t;
  let i, s, a;
  for (i = 0, s = e.length; i < s; ++i) {
    a = e[i];
    const { fullSize: c } = a.box, d = n[a.stack], u = d && a.stackWeight / d.weight;
    a.horizontal ? (a.width = u ? u * o : c && t.availableWidth, a.height = r) : (a.width = o, a.height = u ? u * r : c && t.availableHeight);
  }
  return n;
}
function XJ(e) {
  const t = qJ(e), n = L2(t.filter((d) => d.box.fullSize), !0), o = L2(P2(t, "left"), !0), r = L2(P2(t, "right")), i = L2(P2(t, "top"), !0), s = L2(P2(t, "bottom")), a = Jm(t, "x"), c = Jm(t, "y");
  return {
    fullSize: n,
    leftAndTop: o.concat(i),
    rightAndBottom: r.concat(c).concat(s).concat(a),
    chartArea: P2(t, "chartArea"),
    vertical: o.concat(r).concat(c),
    horizontal: i.concat(s).concat(a)
  };
}
function Qm(e, t, n, o) {
  return Math.max(e[n], t[n]) + Math.max(e[o], t[o]);
}
function VS(e, t) {
  e.top = Math.max(e.top, t.top), e.left = Math.max(e.left, t.left), e.bottom = Math.max(e.bottom, t.bottom), e.right = Math.max(e.right, t.right);
}
function JJ(e, t, n, o) {
  const { pos: r, box: i } = n, s = e.maxPadding;
  if (!Dt(r)) {
    n.size && (e[r] -= n.size);
    const p = o[n.stack] || {
      size: 0,
      count: 1
    };
    p.size = Math.max(p.size, n.horizontal ? i.height : i.width), n.size = p.size / p.count, e[r] += n.size;
  }
  i.getPadding && VS(s, i.getPadding());
  const a = Math.max(0, t.outerWidth - Qm(s, e, "left", "right")), c = Math.max(0, t.outerHeight - Qm(s, e, "top", "bottom")), d = a !== e.w, u = c !== e.h;
  return e.w = a, e.h = c, n.horizontal ? {
    same: d,
    other: u
  } : {
    same: u,
    other: d
  };
}
function QJ(e) {
  const t = e.maxPadding;
  function n(o) {
    const r = Math.max(t[o] - e[o], 0);
    return e[o] += r, r;
  }
  e.y += n("top"), e.x += n("left"), n("right"), n("bottom");
}
function eQ(e, t) {
  const n = t.maxPadding;
  function o(r) {
    const i = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return r.forEach((s) => {
      i[s] = Math.max(t[s], n[s]);
    }), i;
  }
  return o(e ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function U2(e, t, n, o) {
  const r = [];
  let i, s, a, c, d, u;
  for (i = 0, s = e.length, d = 0; i < s; ++i) {
    a = e[i], c = a.box, c.update(a.width || t.w, a.height || t.h, eQ(a.horizontal, t));
    const { same: p, other: h } = JJ(t, n, a, o);
    d |= p && r.length, u = u || h, c.fullSize || r.push(a);
  }
  return d && U2(r, t, n, o) || u;
}
function v1(e, t, n, o, r) {
  e.top = n, e.left = t, e.right = t + o, e.bottom = n + r, e.width = o, e.height = r;
}
function eb(e, t, n, o) {
  const r = n.padding;
  let { x: i, y: s } = t;
  for (const a of e) {
    const c = a.box, d = o[a.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    }, u = a.stackWeight / d.weight || 1;
    if (a.horizontal) {
      const p = t.w * u, h = d.size || c.height;
      zc(d.start) && (s = d.start), c.fullSize ? v1(c, r.left, s, n.outerWidth - r.right - r.left, h) : v1(c, t.left + d.placed, s, p, h), d.start = s, d.placed += p, s = c.bottom;
    } else {
      const p = t.h * u, h = d.size || c.width;
      zc(d.start) && (i = d.start), c.fullSize ? v1(c, i, r.top, h, n.outerHeight - r.bottom - r.top) : v1(c, i, t.top + d.placed, h, p), d.start = i, d.placed += p, i = c.right;
    }
  }
  t.x = i, t.y = s;
}
var uo = {
  addBox(e, t) {
    e.boxes || (e.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(n) {
            t.draw(n);
          }
        }
      ];
    }, e.boxes.push(t);
  },
  removeBox(e, t) {
    const n = e.boxes ? e.boxes.indexOf(t) : -1;
    n !== -1 && e.boxes.splice(n, 1);
  },
  configure(e, t, n) {
    t.fullSize = n.fullSize, t.position = n.position, t.weight = n.weight;
  },
  update(e, t, n, o) {
    if (!e)
      return;
    const r = no(e.options.layout.padding), i = Math.max(t - r.width, 0), s = Math.max(n - r.height, 0), a = XJ(e.boxes), c = a.vertical, d = a.horizontal;
    en(e.boxes, (b) => {
      typeof b.beforeLayout == "function" && b.beforeLayout();
    });
    const u = c.reduce((b, C) => C.box.options && C.box.options.display === !1 ? b : b + 1, 0) || 1, p = Object.freeze({
      outerWidth: t,
      outerHeight: n,
      padding: r,
      availableWidth: i,
      availableHeight: s,
      vBoxMaxWidth: i / 2 / u,
      hBoxMaxHeight: s / 2
    }), h = Object.assign({}, r);
    VS(h, no(o));
    const g = Object.assign({
      maxPadding: h,
      w: i,
      h: s,
      x: r.left,
      y: r.top
    }, r), m = YJ(c.concat(d), p);
    U2(a.fullSize, g, p, m), U2(c, g, p, m), U2(d, g, p, m) && U2(c, g, p, m), QJ(g), eb(a.leftAndTop, g, p, m), g.x += g.w, g.y += g.h, eb(a.rightAndBottom, g, p, m), e.chartArea = {
      left: g.left,
      top: g.top,
      right: g.left + g.w,
      bottom: g.top + g.h,
      height: g.h,
      width: g.w
    }, en(a.chartArea, (b) => {
      const C = b.box;
      Object.assign(C, e.chartArea), C.update(g.w, g.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class DS {
  acquireContext(t, n) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, n, o) {
  }
  removeEventListener(t, n, o) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, n, o, r) {
    return n = Math.max(0, n || t.width), o = o || t.height, {
      width: n,
      height: Math.max(0, r ? Math.floor(n / r) : o)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class tQ extends DS {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const Sd = "$chartjs", nQ = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, tb = (e) => e === null || e === "";
function oQ(e, t) {
  const n = e.style, o = e.getAttribute("height"), r = e.getAttribute("width");
  if (e[Sd] = {
    initial: {
      height: o,
      width: r,
      style: {
        display: n.display,
        height: n.height,
        width: n.width
      }
    }
  }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", tb(r)) {
    const i = Hm(e, "width");
    i !== void 0 && (e.width = i);
  }
  if (tb(o))
    if (e.style.height === "")
      e.height = e.width / (t || 2);
    else {
      const i = Hm(e, "height");
      i !== void 0 && (e.height = i);
    }
  return e;
}
const AS = iJ ? {
  passive: !0
} : !1;
function rQ(e, t, n) {
  e && e.addEventListener(t, n, AS);
}
function iQ(e, t, n) {
  e && e.canvas && e.canvas.removeEventListener(t, n, AS);
}
function sQ(e, t) {
  const n = nQ[e.type] || e.type, { x: o, y: r } = Ws(e, t);
  return {
    type: n,
    chart: t,
    native: e,
    x: o !== void 0 ? o : null,
    y: r !== void 0 ? r : null
  };
}
function ou(e, t) {
  for (const n of e)
    if (n === t || n.contains(t))
      return !0;
}
function aQ(e, t, n) {
  const o = e.canvas, r = new MutationObserver((i) => {
    let s = !1;
    for (const a of i)
      s = s || ou(a.addedNodes, o), s = s && !ou(a.removedNodes, o);
    s && n();
  });
  return r.observe(document, {
    childList: !0,
    subtree: !0
  }), r;
}
function lQ(e, t, n) {
  const o = e.canvas, r = new MutationObserver((i) => {
    let s = !1;
    for (const a of i)
      s = s || ou(a.removedNodes, o), s = s && !ou(a.addedNodes, o);
    s && n();
  });
  return r.observe(document, {
    childList: !0,
    subtree: !0
  }), r;
}
const Uc = /* @__PURE__ */ new Map();
let nb = 0;
function HS() {
  const e = window.devicePixelRatio;
  e !== nb && (nb = e, Uc.forEach((t, n) => {
    n.currentDevicePixelRatio !== e && t();
  }));
}
function cQ(e, t) {
  Uc.size || window.addEventListener("resize", HS), Uc.set(e, t);
}
function dQ(e) {
  Uc.delete(e), Uc.size || window.removeEventListener("resize", HS);
}
function uQ(e, t, n) {
  const o = e.canvas, r = o && O7(o);
  if (!r)
    return;
  const i = hS((a, c) => {
    const d = r.clientWidth;
    n(a, c), d < r.clientWidth && n();
  }, window), s = new ResizeObserver((a) => {
    const c = a[0], d = c.contentRect.width, u = c.contentRect.height;
    d === 0 && u === 0 || i(d, u);
  });
  return s.observe(r), cQ(e, i), s;
}
function o6(e, t, n) {
  n && n.disconnect(), t === "resize" && dQ(e);
}
function fQ(e, t, n) {
  const o = e.canvas, r = hS((i) => {
    e.ctx !== null && n(sQ(i, e));
  }, e);
  return rQ(o, t, r), r;
}
class pQ extends DS {
  acquireContext(t, n) {
    const o = t && t.getContext && t.getContext("2d");
    return o && o.canvas === t ? (oQ(t, n), o) : null;
  }
  releaseContext(t) {
    const n = t.canvas;
    if (!n[Sd])
      return !1;
    const o = n[Sd].initial;
    [
      "height",
      "width"
    ].forEach((i) => {
      const s = o[i];
      It(s) ? n.removeAttribute(i) : n.setAttribute(i, s);
    });
    const r = o.style || {};
    return Object.keys(r).forEach((i) => {
      n.style[i] = r[i];
    }), n.width = n.width, delete n[Sd], !0;
  }
  addEventListener(t, n, o) {
    this.removeEventListener(t, n);
    const r = t.$proxies || (t.$proxies = {}), s = {
      attach: aQ,
      detach: lQ,
      resize: uQ
    }[n] || fQ;
    r[n] = s(t, n, o);
  }
  removeEventListener(t, n) {
    const o = t.$proxies || (t.$proxies = {}), r = o[n];
    if (!r)
      return;
    ({
      attach: o6,
      detach: o6,
      resize: o6
    }[n] || iQ)(t, n, r), o[n] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, n, o, r) {
    return rJ(t, n, o, r);
  }
  isAttached(t) {
    const n = t && O7(t);
    return !!(n && n.isConnected);
  }
}
function hQ(e) {
  return !R7() || typeof OffscreenCanvas < "u" && e instanceof OffscreenCanvas ? tQ : pQ;
}
var rd;
let Di = (rd = class {
  constructor() {
    Ge(this, "x");
    Ge(this, "y");
    Ge(this, "active", !1);
    Ge(this, "options");
    Ge(this, "$animations");
  }
  tooltipPosition(t) {
    const { x: n, y: o } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: n,
      y: o
    };
  }
  hasValue() {
    return Hl(this.x) && Hl(this.y);
  }
  getProps(t, n) {
    const o = this.$animations;
    if (!n || !o)
      return this;
    const r = {};
    return t.forEach((i) => {
      r[i] = o[i] && o[i].active() ? o[i]._to : this[i];
    }), r;
  }
}, Ge(rd, "defaults", {}), Ge(rd, "defaultRoutes"), rd);
function gQ(e, t) {
  const n = e.options.ticks, o = mQ(e), r = Math.min(n.maxTicksLimit || o, o), i = n.major.enabled ? CQ(t) : [], s = i.length, a = i[0], c = i[s - 1], d = [];
  if (s > r)
    return xQ(t, d, i, s / r), d;
  const u = bQ(i, t, r);
  if (s > 0) {
    let p, h;
    const g = s > 1 ? Math.round((c - a) / (s - 1)) : null;
    for (w1(t, d, u, It(g) ? 0 : a - g, a), p = 0, h = s - 1; p < h; p++)
      w1(t, d, u, i[p], i[p + 1]);
    return w1(t, d, u, c, It(g) ? t.length : c + g), d;
  }
  return w1(t, d, u), d;
}
function mQ(e) {
  const t = e.options.offset, n = e._tickSize(), o = e._length / n + (t ? 0 : 1), r = e._maxLength / n;
  return Math.floor(Math.min(o, r));
}
function bQ(e, t, n) {
  const o = yQ(e), r = t.length / n;
  if (!o)
    return Math.max(r, 1);
  const i = lX(o);
  for (let s = 0, a = i.length - 1; s < a; s++) {
    const c = i[s];
    if (c > r)
      return c;
  }
  return Math.max(r, 1);
}
function CQ(e) {
  const t = [];
  let n, o;
  for (n = 0, o = e.length; n < o; n++)
    e[n].major && t.push(n);
  return t;
}
function xQ(e, t, n, o) {
  let r = 0, i = n[0], s;
  for (o = Math.ceil(o), s = 0; s < e.length; s++)
    s === i && (t.push(e[s]), r++, i = n[r * o]);
}
function w1(e, t, n, o, r) {
  const i = yt(o, 0), s = Math.min(yt(r, e.length), e.length);
  let a = 0, c, d, u;
  for (n = Math.ceil(n), r && (c = r - o, n = c / Math.floor(c / n)), u = i; u < 0; )
    a++, u = Math.round(i + a * n);
  for (d = Math.max(i, 0); d < s; d++)
    d === u && (t.push(e[d]), a++, u = Math.round(i + a * n));
}
function yQ(e) {
  const t = e.length;
  let n, o;
  if (t < 2)
    return !1;
  for (o = e[0], n = 1; n < t; ++n)
    if (e[n] - e[n - 1] !== o)
      return !1;
  return o;
}
const vQ = (e) => e === "left" ? "right" : e === "right" ? "left" : e, ob = (e, t, n) => t === "top" || t === "left" ? e[t] + n : e[t] - n, rb = (e, t) => Math.min(t || e, e);
function ib(e, t) {
  const n = [], o = e.length / t, r = e.length;
  let i = 0;
  for (; i < r; i += o)
    n.push(e[Math.floor(i)]);
  return n;
}
function wQ(e, t, n) {
  const o = e.ticks.length, r = Math.min(t, o - 1), i = e._startPixel, s = e._endPixel, a = 1e-6;
  let c = e.getPixelForTick(r), d;
  if (!(n && (o === 1 ? d = Math.max(c - i, s - c) : t === 0 ? d = (e.getPixelForTick(1) - c) / 2 : d = (c - e.getPixelForTick(r - 1)) / 2, c += r < t ? d : -d, c < i - a || c > s + a)))
    return c;
}
function SQ(e, t) {
  en(e, (n) => {
    const o = n.gc, r = o.length / 2;
    let i;
    if (r > t) {
      for (i = 0; i < r; ++i)
        delete n.data[o[i]];
      o.splice(0, r);
    }
  });
}
function I2(e) {
  return e.drawTicks ? e.tickLength : 0;
}
function sb(e, t) {
  if (!e.display)
    return 0;
  const n = Dn(e.font, t), o = no(e.padding);
  return (fn(e.text) ? e.text.length : 1) * n.lineHeight + o.height;
}
function MQ(e, t) {
  return Rs(e, {
    scale: t,
    type: "scale"
  });
}
function TQ(e, t, n) {
  return Rs(e, {
    tick: n,
    index: t,
    type: "tick"
  });
}
function kQ(e, t, n) {
  let o = w7(e);
  return (n && t !== "right" || !n && t === "right") && (o = vQ(o)), o;
}
function EQ(e, t, n, o) {
  const { top: r, left: i, bottom: s, right: a, chart: c } = e, { chartArea: d, scales: u } = c;
  let p = 0, h, g, m;
  const b = s - r, C = a - i;
  if (e.isHorizontal()) {
    if (g = so(o, i, a), Dt(n)) {
      const x = Object.keys(n)[0], v = n[x];
      m = u[x].getPixelForValue(v) + b - t;
    } else n === "center" ? m = (d.bottom + d.top) / 2 + b - t : m = ob(e, n, t);
    h = a - i;
  } else {
    if (Dt(n)) {
      const x = Object.keys(n)[0], v = n[x];
      g = u[x].getPixelForValue(v) - C + t;
    } else n === "center" ? g = (d.left + d.right) / 2 - C + t : g = ob(e, n, t);
    m = so(o, s, r), p = n === "left" ? -On : On;
  }
  return {
    titleX: g,
    titleY: m,
    maxWidth: h,
    rotation: p
  };
}
class Va extends Di {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, n) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: n, _suggestedMin: o, _suggestedMax: r } = this;
    return t = Bo(t, Number.POSITIVE_INFINITY), n = Bo(n, Number.NEGATIVE_INFINITY), o = Bo(o, Number.POSITIVE_INFINITY), r = Bo(r, Number.NEGATIVE_INFINITY), {
      min: Bo(t, o),
      max: Bo(n, r),
      minDefined: kn(t),
      maxDefined: kn(n)
    };
  }
  getMinMax(t) {
    let { min: n, max: o, minDefined: r, maxDefined: i } = this.getUserBounds(), s;
    if (r && i)
      return {
        min: n,
        max: o
      };
    const a = this.getMatchingVisibleMetas();
    for (let c = 0, d = a.length; c < d; ++c)
      s = a[c].controller.getMinMax(this, t), r || (n = Math.min(n, s.min)), i || (o = Math.max(o, s.max));
    return n = i && n > o ? o : n, o = r && n > o ? n : o, {
      min: Bo(n, Bo(o, n)),
      max: Bo(o, Bo(n, o))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    rn(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, n, o) {
    const { beginAtZero: r, grace: i, ticks: s } = this.options, a = s.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = n, this._margins = o = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, o), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + o.left + o.right : this.height + o.top + o.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = DX(this, i, r), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const c = a < this.ticks.length;
    this._convertTicksToLabels(c ? ib(this.ticks, a) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), s.display && (s.autoSkip || s.source === "auto") && (this.ticks = gQ(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), c && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, n, o;
    this.isHorizontal() ? (n = this.left, o = this.right) : (n = this.top, o = this.bottom, t = !t), this._startPixel = n, this._endPixel = o, this._reversePixels = t, this._length = o - n, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    rn(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    rn(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    rn(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), rn(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    rn(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const n = this.options.ticks;
    let o, r, i;
    for (o = 0, r = t.length; o < r; o++)
      i = t[o], i.label = rn(n.callback, [
        i.value,
        o,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    rn(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    rn(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, n = t.ticks, o = rb(this.ticks.length, t.ticks.maxTicksLimit), r = n.minRotation || 0, i = n.maxRotation;
    let s = r, a, c, d;
    if (!this._isVisible() || !n.display || r >= i || o <= 1 || !this.isHorizontal()) {
      this.labelRotation = r;
      return;
    }
    const u = this._getLabelSizes(), p = u.widest.width, h = u.highest.height, g = Wn(this.chart.width - p, 0, this.maxWidth);
    a = t.offset ? this.maxWidth / o : g / (o - 1), p + 6 > a && (a = g / (o - (t.offset ? 0.5 : 1)), c = this.maxHeight - I2(t.grid) - n.padding - sb(t.title, this.chart.options.font), d = Math.sqrt(p * p + h * h), s = y7(Math.min(Math.asin(Wn((u.highest.height + 6) / a, -1, 1)), Math.asin(Wn(c / d, -1, 1)) - Math.asin(Wn(h / d, -1, 1)))), s = Math.max(r, Math.min(i, s))), this.labelRotation = s;
  }
  afterCalculateLabelRotation() {
    rn(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    rn(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: n, options: { ticks: o, title: r, grid: i } } = this, s = this._isVisible(), a = this.isHorizontal();
    if (s) {
      const c = sb(r, n.options.font);
      if (a ? (t.width = this.maxWidth, t.height = I2(i) + c) : (t.height = this.maxHeight, t.width = I2(i) + c), o.display && this.ticks.length) {
        const { first: d, last: u, widest: p, highest: h } = this._getLabelSizes(), g = o.padding * 2, m = Or(this.labelRotation), b = Math.cos(m), C = Math.sin(m);
        if (a) {
          const x = o.mirror ? 0 : C * p.width + b * h.height;
          t.height = Math.min(this.maxHeight, t.height + x + g);
        } else {
          const x = o.mirror ? 0 : b * p.width + C * h.height;
          t.width = Math.min(this.maxWidth, t.width + x + g);
        }
        this._calculatePadding(d, u, C, b);
      }
    }
    this._handleMargins(), a ? (this.width = this._length = n.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = n.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, n, o, r) {
    const { ticks: { align: i, padding: s }, position: a } = this.options, c = this.labelRotation !== 0, d = a !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const u = this.getPixelForTick(0) - this.left, p = this.right - this.getPixelForTick(this.ticks.length - 1);
      let h = 0, g = 0;
      c ? d ? (h = r * t.width, g = o * n.height) : (h = o * t.height, g = r * n.width) : i === "start" ? g = n.width : i === "end" ? h = t.width : i !== "inner" && (h = t.width / 2, g = n.width / 2), this.paddingLeft = Math.max((h - u + s) * this.width / (this.width - u), 0), this.paddingRight = Math.max((g - p + s) * this.width / (this.width - p), 0);
    } else {
      let u = n.height / 2, p = t.height / 2;
      i === "start" ? (u = 0, p = t.height) : i === "end" && (u = n.height, p = 0), this.paddingTop = u + s, this.paddingBottom = p + s;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    rn(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: n } = this.options;
    return n === "top" || n === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let n, o;
    for (n = 0, o = t.length; n < o; n++)
      It(t[n].label) && (t.splice(n, 1), o--, n--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const n = this.options.ticks.sampleSize;
      let o = this.ticks;
      n < o.length && (o = ib(o, n)), this._labelSizes = t = this._computeLabelSizes(o, o.length, this.options.ticks.maxTicksLimit);
    }
    return t;
  }
  _computeLabelSizes(t, n, o) {
    const { ctx: r, _longestTextCache: i } = this, s = [], a = [], c = Math.floor(n / rb(n, o));
    let d = 0, u = 0, p, h, g, m, b, C, x, v, S, M, w;
    for (p = 0; p < n; p += c) {
      if (m = t[p].label, b = this._resolveTickFontOptions(p), r.font = C = b.string, x = i[C] = i[C] || {
        data: {},
        gc: []
      }, v = b.lineHeight, S = M = 0, !It(m) && !fn(m))
        S = tu(r, x.data, x.gc, S, m), M = v;
      else if (fn(m))
        for (h = 0, g = m.length; h < g; ++h)
          w = m[h], !It(w) && !fn(w) && (S = tu(r, x.data, x.gc, S, w), M += v);
      s.push(S), a.push(M), d = Math.max(S, d), u = Math.max(M, u);
    }
    SQ(i, n);
    const k = s.indexOf(d), E = a.indexOf(u), R = (O) => ({
      width: s[O] || 0,
      height: a[O] || 0
    });
    return {
      first: R(0),
      last: R(n - 1),
      widest: R(k),
      highest: R(E),
      widths: s,
      heights: a
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, n) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const n = this._startPixel + t * this._length;
    return uX(this._alignToPixels ? Ds(this.chart, n, 0) : n);
  }
  getDecimalForPixel(t) {
    const n = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - n : n;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: n } = this;
    return t < 0 && n < 0 ? n : t > 0 && n > 0 ? t : 0;
  }
  getContext(t) {
    const n = this.ticks || [];
    if (t >= 0 && t < n.length) {
      const o = n[t];
      return o.$context || (o.$context = TQ(this.getContext(), t, o));
    }
    return this.$context || (this.$context = MQ(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, n = Or(this.labelRotation), o = Math.abs(Math.cos(n)), r = Math.abs(Math.sin(n)), i = this._getLabelSizes(), s = t.autoSkipPadding || 0, a = i ? i.widest.width + s : 0, c = i ? i.highest.height + s : 0;
    return this.isHorizontal() ? c * o > a * r ? a / o : c / r : c * r < a * o ? c / o : a / r;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const n = this.axis, o = this.chart, r = this.options, { grid: i, position: s, border: a } = r, c = i.offset, d = this.isHorizontal(), p = this.ticks.length + (c ? 1 : 0), h = I2(i), g = [], m = a.setContext(this.getContext()), b = m.display ? m.width : 0, C = b / 2, x = function(F) {
      return Ds(o, F, b);
    };
    let v, S, M, w, k, E, R, O, P, _, L, V;
    if (s === "top")
      v = x(this.bottom), E = this.bottom - h, O = v - C, _ = x(t.top) + C, V = t.bottom;
    else if (s === "bottom")
      v = x(this.top), _ = t.top, V = x(t.bottom) - C, E = v + C, O = this.top + h;
    else if (s === "left")
      v = x(this.right), k = this.right - h, R = v - C, P = x(t.left) + C, L = t.right;
    else if (s === "right")
      v = x(this.left), P = t.left, L = x(t.right) - C, k = v + C, R = this.left + h;
    else if (n === "x") {
      if (s === "center")
        v = x((t.top + t.bottom) / 2 + 0.5);
      else if (Dt(s)) {
        const F = Object.keys(s)[0], $ = s[F];
        v = x(this.chart.scales[F].getPixelForValue($));
      }
      _ = t.top, V = t.bottom, E = v + C, O = E + h;
    } else if (n === "y") {
      if (s === "center")
        v = x((t.left + t.right) / 2);
      else if (Dt(s)) {
        const F = Object.keys(s)[0], $ = s[F];
        v = x(this.chart.scales[F].getPixelForValue($));
      }
      k = v - C, R = k - h, P = t.left, L = t.right;
    }
    const j = yt(r.ticks.maxTicksLimit, p), I = Math.max(1, Math.ceil(p / j));
    for (S = 0; S < p; S += I) {
      const F = this.getContext(S), $ = i.setContext(F), A = a.setContext(F), H = $.lineWidth, N = $.color, z = A.dash || [], se = A.dashOffset, ne = $.tickWidth, Z = $.tickColor, q = $.tickBorderDash || [], G = $.tickBorderDashOffset;
      M = wQ(this, S, c), M !== void 0 && (w = Ds(o, M, H), d ? k = R = P = L = w : E = O = _ = V = w, g.push({
        tx1: k,
        ty1: E,
        tx2: R,
        ty2: O,
        x1: P,
        y1: _,
        x2: L,
        y2: V,
        width: H,
        color: N,
        borderDash: z,
        borderDashOffset: se,
        tickWidth: ne,
        tickColor: Z,
        tickBorderDash: q,
        tickBorderDashOffset: G
      }));
    }
    return this._ticksLength = p, this._borderValue = v, g;
  }
  _computeLabelItems(t) {
    const n = this.axis, o = this.options, { position: r, ticks: i } = o, s = this.isHorizontal(), a = this.ticks, { align: c, crossAlign: d, padding: u, mirror: p } = i, h = I2(o.grid), g = h + u, m = p ? -u : g, b = -Or(this.labelRotation), C = [];
    let x, v, S, M, w, k, E, R, O, P, _, L, V = "middle";
    if (r === "top")
      k = this.bottom - m, E = this._getXAxisLabelAlignment();
    else if (r === "bottom")
      k = this.top + m, E = this._getXAxisLabelAlignment();
    else if (r === "left") {
      const I = this._getYAxisLabelAlignment(h);
      E = I.textAlign, w = I.x;
    } else if (r === "right") {
      const I = this._getYAxisLabelAlignment(h);
      E = I.textAlign, w = I.x;
    } else if (n === "x") {
      if (r === "center")
        k = (t.top + t.bottom) / 2 + g;
      else if (Dt(r)) {
        const I = Object.keys(r)[0], F = r[I];
        k = this.chart.scales[I].getPixelForValue(F) + g;
      }
      E = this._getXAxisLabelAlignment();
    } else if (n === "y") {
      if (r === "center")
        w = (t.left + t.right) / 2 - g;
      else if (Dt(r)) {
        const I = Object.keys(r)[0], F = r[I];
        w = this.chart.scales[I].getPixelForValue(F);
      }
      E = this._getYAxisLabelAlignment(h).textAlign;
    }
    n === "y" && (c === "start" ? V = "top" : c === "end" && (V = "bottom"));
    const j = this._getLabelSizes();
    for (x = 0, v = a.length; x < v; ++x) {
      S = a[x], M = S.label;
      const I = i.setContext(this.getContext(x));
      R = this.getPixelForTick(x) + i.labelOffset, O = this._resolveTickFontOptions(x), P = O.lineHeight, _ = fn(M) ? M.length : 1;
      const F = _ / 2, $ = I.color, A = I.textStrokeColor, H = I.textStrokeWidth;
      let N = E;
      s ? (w = R, E === "inner" && (x === v - 1 ? N = this.options.reverse ? "left" : "right" : x === 0 ? N = this.options.reverse ? "right" : "left" : N = "center"), r === "top" ? d === "near" || b !== 0 ? L = -_ * P + P / 2 : d === "center" ? L = -j.highest.height / 2 - F * P + P : L = -j.highest.height + P / 2 : d === "near" || b !== 0 ? L = P / 2 : d === "center" ? L = j.highest.height / 2 - F * P : L = j.highest.height - _ * P, p && (L *= -1), b !== 0 && !I.showLabelBackdrop && (w += P / 2 * Math.sin(b))) : (k = R, L = (1 - _) * P / 2);
      let z;
      if (I.showLabelBackdrop) {
        const se = no(I.backdropPadding), ne = j.heights[x], Z = j.widths[x];
        let q = L - se.top, G = 0 - se.left;
        switch (V) {
          case "middle":
            q -= ne / 2;
            break;
          case "bottom":
            q -= ne;
            break;
        }
        switch (E) {
          case "center":
            G -= Z / 2;
            break;
          case "right":
            G -= Z;
            break;
          case "inner":
            x === v - 1 ? G -= Z : x > 0 && (G -= Z / 2);
            break;
        }
        z = {
          left: G,
          top: q,
          width: Z + se.width,
          height: ne + se.height,
          color: I.backdropColor
        };
      }
      C.push({
        label: M,
        font: O,
        textOffset: L,
        options: {
          rotation: b,
          color: $,
          strokeColor: A,
          strokeWidth: H,
          textAlign: N,
          textBaseline: V,
          translation: [
            w,
            k
          ],
          backdrop: z
        }
      });
    }
    return C;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: n } = this.options;
    if (-Or(this.labelRotation))
      return t === "top" ? "left" : "right";
    let r = "center";
    return n.align === "start" ? r = "left" : n.align === "end" ? r = "right" : n.align === "inner" && (r = "inner"), r;
  }
  _getYAxisLabelAlignment(t) {
    const { position: n, ticks: { crossAlign: o, mirror: r, padding: i } } = this.options, s = this._getLabelSizes(), a = t + i, c = s.widest.width;
    let d, u;
    return n === "left" ? r ? (u = this.right + i, o === "near" ? d = "left" : o === "center" ? (d = "center", u += c / 2) : (d = "right", u += c)) : (u = this.right - a, o === "near" ? d = "right" : o === "center" ? (d = "center", u -= c / 2) : (d = "left", u = this.left)) : n === "right" ? r ? (u = this.left + i, o === "near" ? d = "right" : o === "center" ? (d = "center", u -= c / 2) : (d = "left", u -= c)) : (u = this.left + a, o === "near" ? d = "left" : o === "center" ? (d = "center", u += c / 2) : (d = "right", u = this.right)) : d = "right", {
      textAlign: d,
      x: u
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, n = this.options.position;
    if (n === "left" || n === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (n === "top" || n === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: n }, left: o, top: r, width: i, height: s } = this;
    n && (t.save(), t.fillStyle = n, t.fillRect(o, r, i, s), t.restore());
  }
  getLineWidthForValue(t) {
    const n = this.options.grid;
    if (!this._isVisible() || !n.display)
      return 0;
    const r = this.ticks.findIndex((i) => i.value === t);
    return r >= 0 ? n.setContext(this.getContext(r)).lineWidth : 0;
  }
  drawGrid(t) {
    const n = this.options.grid, o = this.ctx, r = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let i, s;
    const a = (c, d, u) => {
      !u.width || !u.color || (o.save(), o.lineWidth = u.width, o.strokeStyle = u.color, o.setLineDash(u.borderDash || []), o.lineDashOffset = u.borderDashOffset, o.beginPath(), o.moveTo(c.x, c.y), o.lineTo(d.x, d.y), o.stroke(), o.restore());
    };
    if (n.display)
      for (i = 0, s = r.length; i < s; ++i) {
        const c = r[i];
        n.drawOnChartArea && a({
          x: c.x1,
          y: c.y1
        }, {
          x: c.x2,
          y: c.y2
        }, c), n.drawTicks && a({
          x: c.tx1,
          y: c.ty1
        }, {
          x: c.tx2,
          y: c.ty2
        }, {
          color: c.tickColor,
          width: c.tickWidth,
          borderDash: c.tickBorderDash,
          borderDashOffset: c.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: n, options: { border: o, grid: r } } = this, i = o.setContext(this.getContext()), s = o.display ? i.width : 0;
    if (!s)
      return;
    const a = r.setContext(this.getContext(0)).lineWidth, c = this._borderValue;
    let d, u, p, h;
    this.isHorizontal() ? (d = Ds(t, this.left, s) - s / 2, u = Ds(t, this.right, a) + a / 2, p = h = c) : (p = Ds(t, this.top, s) - s / 2, h = Ds(t, this.bottom, a) + a / 2, d = u = c), n.save(), n.lineWidth = i.width, n.strokeStyle = i.color, n.beginPath(), n.moveTo(d, p), n.lineTo(u, h), n.stroke(), n.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const o = this.ctx, r = this._computeLabelArea();
    r && $3(o, r);
    const i = this.getLabelItems(t);
    for (const s of i) {
      const a = s.options, c = s.font, d = s.label, u = s.textOffset;
      ka(o, d, 0, u, c, a);
    }
    r && B3(o);
  }
  drawTitle() {
    const { ctx: t, options: { position: n, title: o, reverse: r } } = this;
    if (!o.display)
      return;
    const i = Dn(o.font), s = no(o.padding), a = o.align;
    let c = i.lineHeight / 2;
    n === "bottom" || n === "center" || Dt(n) ? (c += s.bottom, fn(o.text) && (c += i.lineHeight * (o.text.length - 1))) : c += s.top;
    const { titleX: d, titleY: u, maxWidth: p, rotation: h } = EQ(this, c, n, a);
    ka(t, o.text, 0, 0, i, {
      color: o.color,
      maxWidth: p,
      rotation: h,
      textAlign: kQ(a, n, r),
      textBaseline: "middle",
      translation: [
        d,
        u
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, n = t.ticks && t.ticks.z || 0, o = yt(t.grid && t.grid.z, -1), r = yt(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== Va.prototype.draw ? [
      {
        z: n,
        draw: (i) => {
          this.draw(i);
        }
      }
    ] : [
      {
        z: o,
        draw: (i) => {
          this.drawBackground(), this.drawGrid(i), this.drawTitle();
        }
      },
      {
        z: r,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: n,
        draw: (i) => {
          this.drawLabels(i);
        }
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const n = this.chart.getSortedVisibleDatasetMetas(), o = this.axis + "AxisID", r = [];
    let i, s;
    for (i = 0, s = n.length; i < s; ++i) {
      const a = n[i];
      a[o] === this.id && (!t || a.type === t) && r.push(a);
    }
    return r;
  }
  _resolveTickFontOptions(t) {
    const n = this.options.ticks.setContext(this.getContext(t));
    return Dn(n.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class S1 {
  constructor(t, n, o) {
    this.type = t, this.scope = n, this.override = o, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const n = Object.getPrototypeOf(t);
    let o;
    _Q(n) && (o = this.register(n));
    const r = this.items, i = t.id, s = this.scope + "." + i;
    if (!i)
      throw new Error("class does not have id: " + t);
    return i in r || (r[i] = t, RQ(t, s, o), this.override && hn.override(t.id, t.overrides)), s;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const n = this.items, o = t.id, r = this.scope;
    o in n && delete n[o], r && o in hn[r] && (delete hn[r][o], this.override && delete Ta[o]);
  }
}
function RQ(e, t, n) {
  const o = ai(/* @__PURE__ */ Object.create(null), [
    n ? hn.get(n) : {},
    hn.get(t),
    e.defaults
  ]);
  hn.set(t, o), e.defaultRoutes && OQ(t, e.defaultRoutes), e.descriptors && hn.describe(t, e.descriptors);
}
function OQ(e, t) {
  Object.keys(t).forEach((n) => {
    const o = n.split("."), r = o.pop(), i = [
      e
    ].concat(o).join("."), s = t[n].split("."), a = s.pop(), c = s.join(".");
    hn.route(i, r, c, a);
  });
}
function _Q(e) {
  return "id" in e && "defaults" in e;
}
class PQ {
  constructor() {
    this.controllers = new S1(Pr, "datasets", !0), this.elements = new S1(Di, "elements"), this.plugins = new S1(Object, "plugins"), this.scales = new S1(Va, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, n, o) {
    [
      ...n
    ].forEach((r) => {
      const i = o || this._getRegistryForType(r);
      o || i.isForType(r) || i === this.plugins && r.id ? this._exec(t, i, r) : en(r, (s) => {
        const a = o || this._getRegistryForType(s);
        this._exec(t, a, s);
      });
    });
  }
  _exec(t, n, o) {
    const r = x7(t);
    rn(o["before" + r], [], o), n[t](o), rn(o["after" + r], [], o);
  }
  _getRegistryForType(t) {
    for (let n = 0; n < this._typedRegistries.length; n++) {
      const o = this._typedRegistries[n];
      if (o.isForType(t))
        return o;
    }
    return this.plugins;
  }
  _get(t, n, o) {
    const r = n.get(t);
    if (r === void 0)
      throw new Error('"' + t + '" is not a registered ' + o + ".");
    return r;
  }
}
var Br = /* @__PURE__ */ new PQ();
class LQ {
  constructor() {
    this._init = [];
  }
  notify(t, n, o, r) {
    n === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const i = r ? this._descriptors(t).filter(r) : this._descriptors(t), s = this._notify(i, t, n, o);
    return n === "afterDestroy" && (this._notify(i, t, "stop"), this._notify(this._init, t, "uninstall")), s;
  }
  _notify(t, n, o, r) {
    r = r || {};
    for (const i of t) {
      const s = i.plugin, a = s[o], c = [
        n,
        r,
        i.options
      ];
      if (rn(a, c, s) === !1 && r.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    It(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const n = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), n;
  }
  _createDescriptors(t, n) {
    const o = t && t.config, r = yt(o.options && o.options.plugins, {}), i = IQ(o);
    return r === !1 && !n ? [] : VQ(t, i, r, n);
  }
  _notifyStateChanges(t) {
    const n = this._oldCache || [], o = this._cache, r = (i, s) => i.filter((a) => !s.some((c) => a.plugin.id === c.plugin.id));
    this._notify(r(n, o), t, "stop"), this._notify(r(o, n), t, "start");
  }
}
function IQ(e) {
  const t = {}, n = [], o = Object.keys(Br.plugins.items);
  for (let i = 0; i < o.length; i++)
    n.push(Br.getPlugin(o[i]));
  const r = e.plugins || [];
  for (let i = 0; i < r.length; i++) {
    const s = r[i];
    n.indexOf(s) === -1 && (n.push(s), t[s.id] = !0);
  }
  return {
    plugins: n,
    localIds: t
  };
}
function jQ(e, t) {
  return !t && e === !1 ? null : e === !0 ? {} : e;
}
function VQ(e, { plugins: t, localIds: n }, o, r) {
  const i = [], s = e.getContext();
  for (const a of t) {
    const c = a.id, d = jQ(o[c], r);
    d !== null && i.push({
      plugin: a,
      options: DQ(e.config, {
        plugin: a,
        local: n[c]
      }, d, s)
    });
  }
  return i;
}
function DQ(e, { plugin: t, local: n }, o, r) {
  const i = e.pluginScopeKeys(t), s = e.getOptionScopes(o, i);
  return n && t.defaults && s.push(t.defaults), e.createResolver(s, r, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function Jp(e, t) {
  const n = hn.datasets[e] || {};
  return ((t.datasets || {})[e] || {}).indexAxis || t.indexAxis || n.indexAxis || "x";
}
function AQ(e, t) {
  let n = e;
  return e === "_index_" ? n = t : e === "_value_" && (n = t === "x" ? "y" : "x"), n;
}
function HQ(e, t) {
  return e === t ? "_index_" : "_value_";
}
function ab(e) {
  if (e === "x" || e === "y" || e === "r")
    return e;
}
function FQ(e) {
  if (e === "top" || e === "bottom")
    return "x";
  if (e === "left" || e === "right")
    return "y";
}
function Qp(e, ...t) {
  if (ab(e))
    return e;
  for (const n of t) {
    const o = n.axis || FQ(n.position) || e.length > 1 && ab(e[0].toLowerCase());
    if (o)
      return o;
  }
  throw new Error(`Cannot determine type of '${e}' axis. Please provide 'axis' or 'position' option.`);
}
function lb(e, t, n) {
  if (n[t + "AxisID"] === e)
    return {
      axis: t
    };
}
function NQ(e, t) {
  if (t.data && t.data.datasets) {
    const n = t.data.datasets.filter((o) => o.xAxisID === e || o.yAxisID === e);
    if (n.length)
      return lb(e, "x", n[0]) || lb(e, "y", n[0]);
  }
  return {};
}
function $Q(e, t) {
  const n = Ta[e.type] || {
    scales: {}
  }, o = t.scales || {}, r = Jp(e.type, t), i = /* @__PURE__ */ Object.create(null);
  return Object.keys(o).forEach((s) => {
    const a = o[s];
    if (!Dt(a))
      return console.error(`Invalid scale configuration for scale: ${s}`);
    if (a._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${s}`);
    const c = Qp(s, a, NQ(s, e), hn.scales[a.type]), d = HQ(c, r), u = n.scales || {};
    i[s] = sc(/* @__PURE__ */ Object.create(null), [
      {
        axis: c
      },
      a,
      u[c],
      u[d]
    ]);
  }), e.data.datasets.forEach((s) => {
    const a = s.type || e.type, c = s.indexAxis || Jp(a, t), u = (Ta[a] || {}).scales || {};
    Object.keys(u).forEach((p) => {
      const h = AQ(p, c), g = s[h + "AxisID"] || h;
      i[g] = i[g] || /* @__PURE__ */ Object.create(null), sc(i[g], [
        {
          axis: h
        },
        o[g],
        u[p]
      ]);
    });
  }), Object.keys(i).forEach((s) => {
    const a = i[s];
    sc(a, [
      hn.scales[a.type],
      hn.scale
    ]);
  }), i;
}
function FS(e) {
  const t = e.options || (e.options = {});
  t.plugins = yt(t.plugins, {}), t.scales = $Q(e, t);
}
function NS(e) {
  return e = e || {}, e.datasets = e.datasets || [], e.labels = e.labels || [], e;
}
function BQ(e) {
  return e = e || {}, e.data = NS(e.data), FS(e), e;
}
const cb = /* @__PURE__ */ new Map(), $S = /* @__PURE__ */ new Set();
function M1(e, t) {
  let n = cb.get(e);
  return n || (n = t(), cb.set(e, n), $S.add(n)), n;
}
const j2 = (e, t, n) => {
  const o = bs(t, n);
  o !== void 0 && e.add(o);
};
class zQ {
  constructor(t) {
    this._config = BQ(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = NS(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), FS(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return M1(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, n) {
    return M1(`${t}.transition.${n}`, () => [
      [
        `datasets.${t}.transitions.${n}`,
        `transitions.${n}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, n) {
    return M1(`${t}-${n}`, () => [
      [
        `datasets.${t}.elements.${n}`,
        `datasets.${t}`,
        `elements.${n}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const n = t.id, o = this.type;
    return M1(`${o}-plugin-${n}`, () => [
      [
        `plugins.${n}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, n) {
    const o = this._scopeCache;
    let r = o.get(t);
    return (!r || n) && (r = /* @__PURE__ */ new Map(), o.set(t, r)), r;
  }
  getOptionScopes(t, n, o) {
    const { options: r, type: i } = this, s = this._cachedScopes(t, o), a = s.get(n);
    if (a)
      return a;
    const c = /* @__PURE__ */ new Set();
    n.forEach((u) => {
      t && (c.add(t), u.forEach((p) => j2(c, t, p))), u.forEach((p) => j2(c, r, p)), u.forEach((p) => j2(c, Ta[i] || {}, p)), u.forEach((p) => j2(c, hn, p)), u.forEach((p) => j2(c, Kp, p));
    });
    const d = Array.from(c);
    return d.length === 0 && d.push(/* @__PURE__ */ Object.create(null)), $S.has(n) && s.set(n, d), d;
  }
  chartOptionScopes() {
    const { options: t, type: n } = this;
    return [
      t,
      Ta[n] || {},
      hn.datasets[n] || {},
      {
        type: n
      },
      hn,
      Kp
    ];
  }
  resolveNamedOptions(t, n, o, r = [
    ""
  ]) {
    const i = {
      $shared: !0
    }, { resolver: s, subPrefixes: a } = db(this._resolverCache, t, r);
    let c = s;
    if (WQ(s, n)) {
      i.$shared = !1, o = Cs(o) ? o() : o;
      const d = this.createResolver(t, o, a);
      c = Fl(s, o, d);
    }
    for (const d of n)
      i[d] = c[d];
    return i;
  }
  createResolver(t, n, o = [
    ""
  ], r) {
    const { resolver: i } = db(this._resolverCache, t, o);
    return Dt(n) ? Fl(i, n, void 0, r) : i;
  }
}
function db(e, t, n) {
  let o = e.get(t);
  o || (o = /* @__PURE__ */ new Map(), e.set(t, o));
  const r = n.join();
  let i = o.get(r);
  return i || (i = {
    resolver: T7(t, n),
    subPrefixes: n.filter((a) => !a.toLowerCase().includes("hover"))
  }, o.set(r, i)), i;
}
const ZQ = (e) => Dt(e) && Object.getOwnPropertyNames(e).some((t) => Cs(e[t]));
function WQ(e, t) {
  const { isScriptable: n, isIndexable: o } = yS(e);
  for (const r of t) {
    const i = n(r), s = o(r), a = (s || i) && e[r];
    if (i && (Cs(a) || ZQ(a)) || s && fn(a))
      return !0;
  }
  return !1;
}
var UQ = "4.4.7";
const GQ = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function ub(e, t) {
  return e === "top" || e === "bottom" || GQ.indexOf(e) === -1 && t === "x";
}
function fb(e, t) {
  return function(n, o) {
    return n[e] === o[e] ? n[t] - o[t] : n[e] - o[e];
  };
}
function pb(e) {
  const t = e.chart, n = t.options.animation;
  t.notifyPlugins("afterRender"), rn(n && n.onComplete, [
    e
  ], t);
}
function qQ(e) {
  const t = e.chart, n = t.options.animation;
  rn(n && n.onProgress, [
    e
  ], t);
}
function BS(e) {
  return R7() && typeof e == "string" ? e = document.getElementById(e) : e && e.length && (e = e[0]), e && e.canvas && (e = e.canvas), e;
}
const Md = {}, hb = (e) => {
  const t = BS(e);
  return Object.values(Md).filter((n) => n.canvas === t).pop();
};
function KQ(e, t, n) {
  const o = Object.keys(e);
  for (const r of o) {
    const i = +r;
    if (i >= t) {
      const s = e[r];
      delete e[r], (n > 0 || i > t) && (e[i + n] = s);
    }
  }
}
function YQ(e, t, n, o) {
  return !n || e.type === "mouseout" ? null : o ? t : e;
}
function T1(e, t, n) {
  return e.options.clip ? e[n] : t[n];
}
function XQ(e, t) {
  const { xScale: n, yScale: o } = e;
  return n && o ? {
    left: T1(n, t, "left"),
    right: T1(n, t, "right"),
    top: T1(o, t, "top"),
    bottom: T1(o, t, "bottom")
  } : t;
}
var $i;
let F0 = ($i = class {
  static register(...t) {
    Br.add(...t), gb();
  }
  static unregister(...t) {
    Br.remove(...t), gb();
  }
  constructor(t, n) {
    const o = this.config = new zQ(n), r = BS(t), i = hb(r);
    if (i)
      throw new Error("Canvas is already in use. Chart with ID '" + i.id + "' must be destroyed before the canvas with ID '" + i.canvas.id + "' can be reused.");
    const s = o.createResolver(o.chartOptionScopes(), this.getContext());
    this.platform = new (o.platform || hQ(r))(), this.platform.updateConfig(o);
    const a = this.platform.acquireContext(r, s.aspectRatio), c = a && a.canvas, d = c && c.height, u = c && c.width;
    if (this.id = QY(), this.ctx = a, this.canvas = c, this.width = u, this.height = d, this._options = s, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new LQ(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = gX((p) => this.update(p), s.resizeDelay || 0), this._dataChanges = [], Md[this.id] = this, !a || !c) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    bi.listen(this, "complete", pb), bi.listen(this, "progress", qQ), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: n }, width: o, height: r, _aspectRatio: i } = this;
    return It(t) ? n && i ? i : r ? o / r : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return Br;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : Am(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return jm(this.canvas, this.ctx), this;
  }
  stop() {
    return bi.stop(this), this;
  }
  resize(t, n) {
    bi.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: n
    } : this._resize(t, n);
  }
  _resize(t, n) {
    const o = this.options, r = this.canvas, i = o.maintainAspectRatio && this.aspectRatio, s = this.platform.getMaximumSize(r, t, n, i), a = o.devicePixelRatio || this.platform.getDevicePixelRatio(), c = this.width ? "resize" : "attach";
    this.width = s.width, this.height = s.height, this._aspectRatio = this.aspectRatio, Am(this, a, !0) && (this.notifyPlugins("resize", {
      size: s
    }), rn(o.onResize, [
      this,
      s
    ], this), this.attached && this._doResize(c) && this.render());
  }
  ensureScalesHaveIDs() {
    const n = this.options.scales || {};
    en(n, (o, r) => {
      o.id = r;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, n = t.scales, o = this.scales, r = Object.keys(o).reduce((s, a) => (s[a] = !1, s), {});
    let i = [];
    n && (i = i.concat(Object.keys(n).map((s) => {
      const a = n[s], c = Qp(s, a), d = c === "r", u = c === "x";
      return {
        options: a,
        dposition: d ? "chartArea" : u ? "bottom" : "left",
        dtype: d ? "radialLinear" : u ? "category" : "linear"
      };
    }))), en(i, (s) => {
      const a = s.options, c = a.id, d = Qp(c, a), u = yt(a.type, s.dtype);
      (a.position === void 0 || ub(a.position, d) !== ub(s.dposition)) && (a.position = s.dposition), r[c] = !0;
      let p = null;
      if (c in o && o[c].type === u)
        p = o[c];
      else {
        const h = Br.getScale(u);
        p = new h({
          id: c,
          type: u,
          ctx: this.ctx,
          chart: this
        }), o[p.id] = p;
      }
      p.init(a, t);
    }), en(r, (s, a) => {
      s || delete o[a];
    }), en(o, (s) => {
      uo.configure(this, s, s.options), uo.addBox(this, s);
    });
  }
  _updateMetasets() {
    const t = this._metasets, n = this.data.datasets.length, o = t.length;
    if (t.sort((r, i) => r.index - i.index), o > n) {
      for (let r = n; r < o; ++r)
        this._destroyDatasetMeta(r);
      t.splice(n, o - n);
    }
    this._sortedMetasets = t.slice(0).sort(fb("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: n } } = this;
    t.length > n.length && delete this._stacks, t.forEach((o, r) => {
      n.filter((i) => i === o._dataset).length === 0 && this._destroyDatasetMeta(r);
    });
  }
  buildOrUpdateControllers() {
    const t = [], n = this.data.datasets;
    let o, r;
    for (this._removeUnreferencedMetasets(), o = 0, r = n.length; o < r; o++) {
      const i = n[o];
      let s = this.getDatasetMeta(o);
      const a = i.type || this.config.type;
      if (s.type && s.type !== a && (this._destroyDatasetMeta(o), s = this.getDatasetMeta(o)), s.type = a, s.indexAxis = i.indexAxis || Jp(a, this.options), s.order = i.order || 0, s.index = o, s.label = "" + i.label, s.visible = this.isDatasetVisible(o), s.controller)
        s.controller.updateIndex(o), s.controller.linkScales();
      else {
        const c = Br.getController(a), { datasetElementType: d, dataElementType: u } = hn.datasets[a];
        Object.assign(c, {
          dataElementType: Br.getElement(u),
          datasetElementType: d && Br.getElement(d)
        }), s.controller = new c(this, o), t.push(s.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    en(this.data.datasets, (t, n) => {
      this.getDatasetMeta(n).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const n = this.config;
    n.update();
    const o = this._options = n.createResolver(n.chartOptionScopes(), this.getContext()), r = this._animationsDisabled = !o.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const i = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let s = 0;
    for (let d = 0, u = this.data.datasets.length; d < u; d++) {
      const { controller: p } = this.getDatasetMeta(d), h = !r && i.indexOf(p) === -1;
      p.buildOrUpdateElements(h), s = Math.max(+p.getMaxOverflow(), s);
    }
    s = this._minPadding = o.layout.autoPadding ? s : 0, this._updateLayout(s), r || en(i, (d) => {
      d.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort(fb("z", "_idx"));
    const { _active: a, _lastEvent: c } = this;
    c ? this._eventHandler(c, !0) : a.length && this._updateHoverStyles(a, a, !0), this.render();
  }
  _updateScales() {
    en(this.scales, (t) => {
      uo.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, n = new Set(Object.keys(this._listeners)), o = new Set(t.events);
    (!Tm(n, o) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, n = this._getUniformDataChanges() || [];
    for (const { method: o, start: r, count: i } of n) {
      const s = o === "_removeElements" ? -i : i;
      KQ(t, r, s);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const n = this.data.datasets.length, o = (i) => new Set(t.filter((s) => s[0] === i).map((s, a) => a + "," + s.splice(1).join(","))), r = o(0);
    for (let i = 1; i < n; i++)
      if (!Tm(r, o(i)))
        return;
    return Array.from(r).map((i) => i.split(",")).map((i) => ({
      method: i[1],
      start: +i[2],
      count: +i[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    uo.update(this, this.width, this.height, t);
    const n = this.chartArea, o = n.width <= 0 || n.height <= 0;
    this._layers = [], en(this.boxes, (r) => {
      o && r.position === "chartArea" || (r.configure && r.configure(), this._layers.push(...r._layers()));
    }, this), this._layers.forEach((r, i) => {
      r._idx = i;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let n = 0, o = this.data.datasets.length; n < o; ++n)
        this.getDatasetMeta(n).controller.configure();
      for (let n = 0, o = this.data.datasets.length; n < o; ++n)
        this._updateDataset(n, Cs(t) ? t({
          datasetIndex: n
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, n) {
    const o = this.getDatasetMeta(t), r = {
      meta: o,
      index: t,
      mode: n,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", r) !== !1 && (o.controller._update(n), r.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", r));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (bi.has(this) ? this.attached && !bi.running(this) && bi.start(this) : (this.draw(), pb({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: o, height: r } = this._resizeBeforeDraw;
      this._resizeBeforeDraw = null, this._resize(o, r);
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const n = this._layers;
    for (t = 0; t < n.length && n[t].z <= 0; ++t)
      n[t].draw(this.chartArea);
    for (this._drawDatasets(); t < n.length; ++t)
      n[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const n = this._sortedMetasets, o = [];
    let r, i;
    for (r = 0, i = n.length; r < i; ++r) {
      const s = n[r];
      (!t || s.visible) && o.push(s);
    }
    return o;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let n = t.length - 1; n >= 0; --n)
      this._drawDataset(t[n]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const n = this.ctx, o = t._clip, r = !o.disabled, i = XQ(t, this.chartArea), s = {
      meta: t,
      index: t.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", s) !== !1 && (r && $3(n, {
      left: o.left === !1 ? 0 : i.left - o.left,
      right: o.right === !1 ? this.width : i.right + o.right,
      top: o.top === !1 ? 0 : i.top - o.top,
      bottom: o.bottom === !1 ? this.height : i.bottom + o.bottom
    }), t.controller.draw(), r && B3(n), s.cancelable = !1, this.notifyPlugins("afterDatasetDraw", s));
  }
  isPointInArea(t) {
    return Ei(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, n, o, r) {
    const i = GJ.modes[n];
    return typeof i == "function" ? i(this, t, o, r) : [];
  }
  getDatasetMeta(t) {
    const n = this.data.datasets[t], o = this._metasets;
    let r = o.filter((i) => i && i._dataset === n).pop();
    return r || (r = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: n && n.order || 0,
      index: t,
      _dataset: n,
      _parsed: [],
      _sorted: !1
    }, o.push(r)), r;
  }
  getContext() {
    return this.$context || (this.$context = Rs(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const n = this.data.datasets[t];
    if (!n)
      return !1;
    const o = this.getDatasetMeta(t);
    return typeof o.hidden == "boolean" ? !o.hidden : !n.hidden;
  }
  setDatasetVisibility(t, n) {
    const o = this.getDatasetMeta(t);
    o.hidden = !n;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, n, o) {
    const r = o ? "show" : "hide", i = this.getDatasetMeta(t), s = i.controller._resolveAnimations(void 0, r);
    zc(n) ? (i.data[n].hidden = !o, this.update()) : (this.setDatasetVisibility(t, o), s.update(i, {
      visible: o
    }), this.update((a) => a.datasetIndex === t ? r : void 0));
  }
  hide(t, n) {
    this._updateVisibility(t, n, !1);
  }
  show(t, n) {
    this._updateVisibility(t, n, !0);
  }
  _destroyDatasetMeta(t) {
    const n = this._metasets[t];
    n && n.controller && n.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, n;
    for (this.stop(), bi.remove(this), t = 0, n = this.data.datasets.length; t < n; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: n } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), jm(t, n), this.platform.releaseContext(n), this.canvas = null, this.ctx = null), delete Md[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, n = this.platform, o = (i, s) => {
      n.addEventListener(this, i, s), t[i] = s;
    }, r = (i, s, a) => {
      i.offsetX = s, i.offsetY = a, this._eventHandler(i);
    };
    en(this.options.events, (i) => o(i, r));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, n = this.platform, o = (c, d) => {
      n.addEventListener(this, c, d), t[c] = d;
    }, r = (c, d) => {
      t[c] && (n.removeEventListener(this, c, d), delete t[c]);
    }, i = (c, d) => {
      this.canvas && this.resize(c, d);
    };
    let s;
    const a = () => {
      r("attach", a), this.attached = !0, this.resize(), o("resize", i), o("detach", s);
    };
    s = () => {
      this.attached = !1, r("resize", i), this._stop(), this._resize(0, 0), o("attach", a);
    }, n.isAttached(this.canvas) ? a() : s();
  }
  unbindEvents() {
    en(this._listeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._listeners = {}, en(this._responsiveListeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, n, o) {
    const r = o ? "set" : "remove";
    let i, s, a, c;
    for (n === "dataset" && (i = this.getDatasetMeta(t[0].datasetIndex), i.controller["_" + r + "DatasetHoverStyle"]()), a = 0, c = t.length; a < c; ++a) {
      s = t[a];
      const d = s && this.getDatasetMeta(s.datasetIndex).controller;
      d && d[r + "HoverStyle"](s.element, s.datasetIndex, s.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const n = this._active || [], o = t.map(({ datasetIndex: i, index: s }) => {
      const a = this.getDatasetMeta(i);
      if (!a)
        throw new Error("No dataset found at index " + i);
      return {
        datasetIndex: i,
        element: a.data[s],
        index: s
      };
    });
    !Jd(o, n) && (this._active = o, this._lastEvent = null, this._updateHoverStyles(o, n));
  }
  notifyPlugins(t, n, o) {
    return this._plugins.notify(this, t, n, o);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((n) => n.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, n, o) {
    const r = this.options.hover, i = (c, d) => c.filter((u) => !d.some((p) => u.datasetIndex === p.datasetIndex && u.index === p.index)), s = i(n, t), a = o ? t : i(t, n);
    s.length && this.updateHoverStyle(s, r.mode, !1), a.length && r.mode && this.updateHoverStyle(a, r.mode, !0);
  }
  _eventHandler(t, n) {
    const o = {
      event: t,
      replay: n,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, r = (s) => (s.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", o, r) === !1)
      return;
    const i = this._handleEvent(t, n, o.inChartArea);
    return o.cancelable = !1, this.notifyPlugins("afterEvent", o, r), (i || o.changed) && this.render(), this;
  }
  _handleEvent(t, n, o) {
    const { _active: r = [], options: i } = this, s = n, a = this._getActiveElements(t, r, o, s), c = iX(t), d = YQ(t, this._lastEvent, o, c);
    o && (this._lastEvent = null, rn(i.onHover, [
      t,
      a,
      this
    ], this), c && rn(i.onClick, [
      t,
      a,
      this
    ], this));
    const u = !Jd(a, r);
    return (u || n) && (this._active = a, this._updateHoverStyles(a, r, n)), this._lastEvent = d, u;
  }
  _getActiveElements(t, n, o, r) {
    if (t.type === "mouseout")
      return [];
    if (!o)
      return n;
    const i = this.options.hover;
    return this.getElementsAtEventForMode(t, i.mode, i, r);
  }
}, Ge($i, "defaults", hn), Ge($i, "instances", Md), Ge($i, "overrides", Ta), Ge($i, "registry", Br), Ge($i, "version", UQ), Ge($i, "getChart", hb), $i);
function gb() {
  return en(F0.instances, (e) => e._plugins.invalidate());
}
function JQ(e, t, n) {
  const { startAngle: o, pixelMargin: r, x: i, y: s, outerRadius: a, innerRadius: c } = t;
  let d = r / a;
  e.beginPath(), e.arc(i, s, a, o - d, n + d), c > r ? (d = r / c, e.arc(i, s, c, n + d, o - d, !0)) : e.arc(i, s, r, n + On, o - On), e.closePath(), e.clip();
}
function QQ(e) {
  return M7(e, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function eee(e, t, n, o) {
  const r = QQ(e.options.borderRadius), i = (n - t) / 2, s = Math.min(i, o * t / 2), a = (c) => {
    const d = (n - Math.min(i, c)) * o / 2;
    return Wn(c, 0, Math.min(i, d));
  };
  return {
    outerStart: a(r.outerStart),
    outerEnd: a(r.outerEnd),
    innerStart: Wn(r.innerStart, 0, s),
    innerEnd: Wn(r.innerEnd, 0, s)
  };
}
function Xa(e, t, n, o) {
  return {
    x: n + e * Math.cos(t),
    y: o + e * Math.sin(t)
  };
}
function ru(e, t, n, o, r, i) {
  const { x: s, y: a, startAngle: c, pixelMargin: d, innerRadius: u } = t, p = Math.max(t.outerRadius + o + n - d, 0), h = u > 0 ? u + o + n + d : 0;
  let g = 0;
  const m = r - c;
  if (o) {
    const I = u > 0 ? u - o : 0, F = p > 0 ? p - o : 0, $ = (I + F) / 2, A = $ !== 0 ? m * $ / ($ + o) : m;
    g = (m - A) / 2;
  }
  const b = Math.max(1e-3, m * p - n / mn) / p, C = (m - b) / 2, x = c + C + g, v = r - C - g, { outerStart: S, outerEnd: M, innerStart: w, innerEnd: k } = eee(t, h, p, v - x), E = p - S, R = p - M, O = x + S / E, P = v - M / R, _ = h + w, L = h + k, V = x + w / _, j = v - k / L;
  if (e.beginPath(), i) {
    const I = (O + P) / 2;
    if (e.arc(s, a, p, O, I), e.arc(s, a, p, I, P), M > 0) {
      const H = Xa(R, P, s, a);
      e.arc(H.x, H.y, M, P, v + On);
    }
    const F = Xa(L, v, s, a);
    if (e.lineTo(F.x, F.y), k > 0) {
      const H = Xa(L, j, s, a);
      e.arc(H.x, H.y, k, v + On, j + Math.PI);
    }
    const $ = (v - k / h + (x + w / h)) / 2;
    if (e.arc(s, a, h, v - k / h, $, !0), e.arc(s, a, h, $, x + w / h, !0), w > 0) {
      const H = Xa(_, V, s, a);
      e.arc(H.x, H.y, w, V + Math.PI, x - On);
    }
    const A = Xa(E, x, s, a);
    if (e.lineTo(A.x, A.y), S > 0) {
      const H = Xa(E, O, s, a);
      e.arc(H.x, H.y, S, x - On, O);
    }
  } else {
    e.moveTo(s, a);
    const I = Math.cos(O) * p + s, F = Math.sin(O) * p + a;
    e.lineTo(I, F);
    const $ = Math.cos(P) * p + s, A = Math.sin(P) * p + a;
    e.lineTo($, A);
  }
  e.closePath();
}
function tee(e, t, n, o, r) {
  const { fullCircles: i, startAngle: s, circumference: a } = t;
  let c = t.endAngle;
  if (i) {
    ru(e, t, n, o, c, r);
    for (let d = 0; d < i; ++d)
      e.fill();
    isNaN(a) || (c = s + (a % pn || pn));
  }
  return ru(e, t, n, o, c, r), e.fill(), c;
}
function nee(e, t, n, o, r) {
  const { fullCircles: i, startAngle: s, circumference: a, options: c } = t, { borderWidth: d, borderJoinStyle: u, borderDash: p, borderDashOffset: h } = c, g = c.borderAlign === "inner";
  if (!d)
    return;
  e.setLineDash(p || []), e.lineDashOffset = h, g ? (e.lineWidth = d * 2, e.lineJoin = u || "round") : (e.lineWidth = d, e.lineJoin = u || "bevel");
  let m = t.endAngle;
  if (i) {
    ru(e, t, n, o, m, r);
    for (let b = 0; b < i; ++b)
      e.stroke();
    isNaN(a) || (m = s + (a % pn || pn));
  }
  g && JQ(e, t, m), i || (ru(e, t, n, o, m, r), e.stroke());
}
class Qs extends Di {
  constructor(n) {
    super();
    Ge(this, "circumference");
    Ge(this, "endAngle");
    Ge(this, "fullCircles");
    Ge(this, "innerRadius");
    Ge(this, "outerRadius");
    Ge(this, "pixelMargin");
    Ge(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, n && Object.assign(this, n);
  }
  inRange(n, o, r) {
    const i = this.getProps([
      "x",
      "y"
    ], r), { angle: s, distance: a } = dS(i, {
      x: n,
      y: o
    }), { startAngle: c, endAngle: d, innerRadius: u, outerRadius: p, circumference: h } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], r), g = (this.options.spacing + this.options.borderWidth) / 2, m = yt(h, d - c), b = Zc(s, c, d) && c !== d, C = m >= pn || b, x = Ti(a, u + g, p + g);
    return C && x;
  }
  getCenterPoint(n) {
    const { x: o, y: r, startAngle: i, endAngle: s, innerRadius: a, outerRadius: c } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], n), { offset: d, spacing: u } = this.options, p = (i + s) / 2, h = (a + c + u + d) / 2;
    return {
      x: o + Math.cos(p) * h,
      y: r + Math.sin(p) * h
    };
  }
  tooltipPosition(n) {
    return this.getCenterPoint(n);
  }
  draw(n) {
    const { options: o, circumference: r } = this, i = (o.offset || 0) / 4, s = (o.spacing || 0) / 2, a = o.circular;
    if (this.pixelMargin = o.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = r > pn ? Math.floor(r / pn) : 0, r === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    n.save();
    const c = (this.startAngle + this.endAngle) / 2;
    n.translate(Math.cos(c) * i, Math.sin(c) * i);
    const d = 1 - Math.sin(Math.min(mn, r || 0)), u = i * d;
    n.fillStyle = o.backgroundColor, n.strokeStyle = o.borderColor, tee(n, this, u, s, a), nee(n, this, u, s, a), n.restore();
  }
}
Ge(Qs, "id", "arc"), Ge(Qs, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
}), Ge(Qs, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), Ge(Qs, "descriptors", {
  _scriptable: !0,
  _indexable: (n) => n !== "borderDash"
});
function zS(e, t, n = t) {
  e.lineCap = yt(n.borderCapStyle, t.borderCapStyle), e.setLineDash(yt(n.borderDash, t.borderDash)), e.lineDashOffset = yt(n.borderDashOffset, t.borderDashOffset), e.lineJoin = yt(n.borderJoinStyle, t.borderJoinStyle), e.lineWidth = yt(n.borderWidth, t.borderWidth), e.strokeStyle = yt(n.borderColor, t.borderColor);
}
function oee(e, t, n) {
  e.lineTo(n.x, n.y);
}
function ree(e) {
  return e.stepped ? EX : e.tension || e.cubicInterpolationMode === "monotone" ? RX : oee;
}
function ZS(e, t, n = {}) {
  const o = e.length, { start: r = 0, end: i = o - 1 } = n, { start: s, end: a } = t, c = Math.max(r, s), d = Math.min(i, a), u = r < s && i < s || r > a && i > a;
  return {
    count: o,
    start: c,
    loop: t.loop,
    ilen: d < c && !u ? o + d - c : d - c
  };
}
function iee(e, t, n, o) {
  const { points: r, options: i } = t, { count: s, start: a, loop: c, ilen: d } = ZS(r, n, o), u = ree(i);
  let { move: p = !0, reverse: h } = o || {}, g, m, b;
  for (g = 0; g <= d; ++g)
    m = r[(a + (h ? d - g : g)) % s], !m.skip && (p ? (e.moveTo(m.x, m.y), p = !1) : u(e, b, m, h, i.stepped), b = m);
  return c && (m = r[(a + (h ? d : 0)) % s], u(e, b, m, h, i.stepped)), !!c;
}
function see(e, t, n, o) {
  const r = t.points, { count: i, start: s, ilen: a } = ZS(r, n, o), { move: c = !0, reverse: d } = o || {};
  let u = 0, p = 0, h, g, m, b, C, x;
  const v = (M) => (s + (d ? a - M : M)) % i, S = () => {
    b !== C && (e.lineTo(u, C), e.lineTo(u, b), e.lineTo(u, x));
  };
  for (c && (g = r[v(0)], e.moveTo(g.x, g.y)), h = 0; h <= a; ++h) {
    if (g = r[v(h)], g.skip)
      continue;
    const M = g.x, w = g.y, k = M | 0;
    k === m ? (w < b ? b = w : w > C && (C = w), u = (p * u + M) / ++p) : (S(), e.lineTo(M, w), m = k, p = 0, b = C = w), x = w;
  }
  S();
}
function e5(e) {
  const t = e.options, n = t.borderDash && t.borderDash.length;
  return !e._decimated && !e._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !n ? see : iee;
}
function aee(e) {
  return e.stepped ? sJ : e.tension || e.cubicInterpolationMode === "monotone" ? aJ : Us;
}
function lee(e, t, n, o) {
  let r = t._path;
  r || (r = t._path = new Path2D(), t.path(r, n, o) && r.closePath()), zS(e, t.options), e.stroke(r);
}
function cee(e, t, n, o) {
  const { segments: r, options: i } = t, s = e5(t);
  for (const a of r)
    zS(e, i, a.style), e.beginPath(), s(e, t, a, {
      start: n,
      end: n + o - 1
    }) && e.closePath(), e.stroke();
}
const dee = typeof Path2D == "function";
function uee(e, t, n, o) {
  dee && !t.options.segment ? lee(e, t, n, o) : cee(e, t, n, o);
}
class es extends Di {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, n) {
    const o = this.options;
    if ((o.tension || o.cubicInterpolationMode === "monotone") && !o.stepped && !this._pointsUpdated) {
      const r = o.spanGaps ? this._loop : this._fullLoop;
      JX(this._points, o, t, r, n), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = pJ(this, this.options.segment));
  }
  first() {
    const t = this.segments, n = this.points;
    return t.length && n[t[0].start];
  }
  last() {
    const t = this.segments, n = this.points, o = t.length;
    return o && n[t[o - 1].end];
  }
  interpolate(t, n) {
    const o = this.options, r = t[n], i = this.points, s = _S(this, {
      property: n,
      start: r,
      end: r
    });
    if (!s.length)
      return;
    const a = [], c = aee(o);
    let d, u;
    for (d = 0, u = s.length; d < u; ++d) {
      const { start: p, end: h } = s[d], g = i[p], m = i[h];
      if (g === m) {
        a.push(g);
        continue;
      }
      const b = Math.abs((r - g[n]) / (m[n] - g[n])), C = c(g, m, b, o.stepped);
      C[n] = t[n], a.push(C);
    }
    return a.length === 1 ? a[0] : a;
  }
  pathSegment(t, n, o) {
    return e5(this)(t, this, n, o);
  }
  path(t, n, o) {
    const r = this.segments, i = e5(this);
    let s = this._loop;
    n = n || 0, o = o || this.points.length - n;
    for (const a of r)
      s &= i(t, this, a, {
        start: n,
        end: n + o - 1
      });
    return !!s;
  }
  draw(t, n, o, r) {
    const i = this.options || {};
    (this.points || []).length && i.borderWidth && (t.save(), uee(t, this, o, r), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
Ge(es, "id", "line"), Ge(es, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), Ge(es, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), Ge(es, "descriptors", {
  _scriptable: !0,
  _indexable: (t) => t !== "borderDash" && t !== "fill"
});
function mb(e, t, n, o) {
  const r = e.options, { [n]: i } = e.getProps([
    n
  ], o);
  return Math.abs(t - i) < r.radius + r.hitRadius;
}
class fc extends Di {
  constructor(n) {
    super();
    Ge(this, "parsed");
    Ge(this, "skip");
    Ge(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, n && Object.assign(this, n);
  }
  inRange(n, o, r) {
    const i = this.options, { x: s, y: a } = this.getProps([
      "x",
      "y"
    ], r);
    return Math.pow(n - s, 2) + Math.pow(o - a, 2) < Math.pow(i.hitRadius + i.radius, 2);
  }
  inXRange(n, o) {
    return mb(this, n, "x", o);
  }
  inYRange(n, o) {
    return mb(this, n, "y", o);
  }
  getCenterPoint(n) {
    const { x: o, y: r } = this.getProps([
      "x",
      "y"
    ], n);
    return {
      x: o,
      y: r
    };
  }
  size(n) {
    n = n || this.options || {};
    let o = n.radius || 0;
    o = Math.max(o, o && n.hoverRadius || 0);
    const r = o && n.borderWidth || 0;
    return (o + r) * 2;
  }
  draw(n, o) {
    const r = this.options;
    this.skip || r.radius < 0.1 || !Ei(this, o, this.size(r) / 2) || (n.strokeStyle = r.borderColor, n.lineWidth = r.borderWidth, n.fillStyle = r.backgroundColor, Yp(n, r, this.x, this.y));
  }
  getRange() {
    const n = this.options || {};
    return n.radius + n.hitRadius;
  }
}
Ge(fc, "id", "point"), /**
* @type {any}
*/
Ge(fc, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
Ge(fc, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function WS(e, t) {
  const { x: n, y: o, base: r, width: i, height: s } = e.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], t);
  let a, c, d, u, p;
  return e.horizontal ? (p = s / 2, a = Math.min(n, r), c = Math.max(n, r), d = o - p, u = o + p) : (p = i / 2, a = n - p, c = n + p, d = Math.min(o, r), u = Math.max(o, r)), {
    left: a,
    top: d,
    right: c,
    bottom: u
  };
}
function ts(e, t, n, o) {
  return e ? 0 : Wn(t, n, o);
}
function fee(e, t, n) {
  const o = e.options.borderWidth, r = e.borderSkipped, i = xS(o);
  return {
    t: ts(r.top, i.top, 0, n),
    r: ts(r.right, i.right, 0, t),
    b: ts(r.bottom, i.bottom, 0, n),
    l: ts(r.left, i.left, 0, t)
  };
}
function pee(e, t, n) {
  const { enableBorderRadius: o } = e.getProps([
    "enableBorderRadius"
  ]), r = e.options.borderRadius, i = aa(r), s = Math.min(t, n), a = e.borderSkipped, c = o || Dt(r);
  return {
    topLeft: ts(!c || a.top || a.left, i.topLeft, 0, s),
    topRight: ts(!c || a.top || a.right, i.topRight, 0, s),
    bottomLeft: ts(!c || a.bottom || a.left, i.bottomLeft, 0, s),
    bottomRight: ts(!c || a.bottom || a.right, i.bottomRight, 0, s)
  };
}
function hee(e) {
  const t = WS(e), n = t.right - t.left, o = t.bottom - t.top, r = fee(e, n / 2, o / 2), i = pee(e, n / 2, o / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: n,
      h: o,
      radius: i
    },
    inner: {
      x: t.left + r.l,
      y: t.top + r.t,
      w: n - r.l - r.r,
      h: o - r.t - r.b,
      radius: {
        topLeft: Math.max(0, i.topLeft - Math.max(r.t, r.l)),
        topRight: Math.max(0, i.topRight - Math.max(r.t, r.r)),
        bottomLeft: Math.max(0, i.bottomLeft - Math.max(r.b, r.l)),
        bottomRight: Math.max(0, i.bottomRight - Math.max(r.b, r.r))
      }
    }
  };
}
function r6(e, t, n, o) {
  const r = t === null, i = n === null, a = e && !(r && i) && WS(e, o);
  return a && (r || Ti(t, a.left, a.right)) && (i || Ti(n, a.top, a.bottom));
}
function gee(e) {
  return e.topLeft || e.topRight || e.bottomLeft || e.bottomRight;
}
function mee(e, t) {
  e.rect(t.x, t.y, t.w, t.h);
}
function i6(e, t, n = {}) {
  const o = e.x !== n.x ? -t : 0, r = e.y !== n.y ? -t : 0, i = (e.x + e.w !== n.x + n.w ? t : 0) - o, s = (e.y + e.h !== n.y + n.h ? t : 0) - r;
  return {
    x: e.x + o,
    y: e.y + r,
    w: e.w + i,
    h: e.h + s,
    radius: e.radius
  };
}
class pc extends Di {
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: n, options: { borderColor: o, backgroundColor: r } } = this, { inner: i, outer: s } = hee(this), a = gee(s.radius) ? Wc : mee;
    t.save(), (s.w !== i.w || s.h !== i.h) && (t.beginPath(), a(t, i6(s, n, i)), t.clip(), a(t, i6(i, -n, s)), t.fillStyle = o, t.fill("evenodd")), t.beginPath(), a(t, i6(i, n)), t.fillStyle = r, t.fill(), t.restore();
  }
  inRange(t, n, o) {
    return r6(this, t, n, o);
  }
  inXRange(t, n) {
    return r6(this, t, null, n);
  }
  inYRange(t, n) {
    return r6(this, null, t, n);
  }
  getCenterPoint(t) {
    const { x: n, y: o, base: r, horizontal: i } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], t);
    return {
      x: i ? (n + r) / 2 : n,
      y: i ? o : (o + r) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
}
Ge(pc, "id", "bar"), Ge(pc, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), Ge(pc, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
var bee = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcElement: Qs,
  BarElement: pc,
  LineElement: es,
  PointElement: fc
});
const t5 = [
  "rgb(54, 162, 235)",
  "rgb(255, 99, 132)",
  "rgb(255, 159, 64)",
  "rgb(255, 205, 86)",
  "rgb(75, 192, 192)",
  "rgb(153, 102, 255)",
  "rgb(201, 203, 207)"
  // grey
], bb = /* @__PURE__ */ t5.map((e) => e.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function US(e) {
  return t5[e % t5.length];
}
function GS(e) {
  return bb[e % bb.length];
}
function Cee(e, t) {
  return e.borderColor = US(t), e.backgroundColor = GS(t), ++t;
}
function xee(e, t) {
  return e.backgroundColor = e.data.map(() => US(t++)), t;
}
function yee(e, t) {
  return e.backgroundColor = e.data.map(() => GS(t++)), t;
}
function vee(e) {
  let t = 0;
  return (n, o) => {
    const r = e.getDatasetMeta(o).controller;
    r instanceof Qi ? t = xee(n, t) : r instanceof dc ? t = yee(n, t) : r && (t = Cee(n, t));
  };
}
function Cb(e) {
  let t;
  for (t in e)
    if (e[t].borderColor || e[t].backgroundColor)
      return !0;
  return !1;
}
function wee(e) {
  return e && (e.borderColor || e.backgroundColor);
}
function See() {
  return hn.borderColor !== "rgba(0,0,0,0.1)" || hn.backgroundColor !== "rgba(0,0,0,0.1)";
}
var Mee = {
  id: "colors",
  defaults: {
    enabled: !0,
    forceOverride: !1
  },
  beforeLayout(e, t, n) {
    if (!n.enabled)
      return;
    const { data: { datasets: o }, options: r } = e.config, { elements: i } = r, s = Cb(o) || wee(r) || i && Cb(i) || See();
    if (!n.forceOverride && s)
      return;
    const a = vee(e);
    o.forEach(a);
  }
};
function Tee(e, t, n, o, r) {
  const i = r.samples || o;
  if (i >= n)
    return e.slice(t, t + n);
  const s = [], a = (n - 2) / (i - 2);
  let c = 0;
  const d = t + n - 1;
  let u = t, p, h, g, m, b;
  for (s[c++] = e[u], p = 0; p < i - 2; p++) {
    let C = 0, x = 0, v;
    const S = Math.floor((p + 1) * a) + 1 + t, M = Math.min(Math.floor((p + 2) * a) + 1, n) + t, w = M - S;
    for (v = S; v < M; v++)
      C += e[v].x, x += e[v].y;
    C /= w, x /= w;
    const k = Math.floor(p * a) + 1 + t, E = Math.min(Math.floor((p + 1) * a) + 1, n) + t, { x: R, y: O } = e[u];
    for (g = m = -1, v = k; v < E; v++)
      m = 0.5 * Math.abs((R - C) * (e[v].y - O) - (R - e[v].x) * (x - O)), m > g && (g = m, h = e[v], b = v);
    s[c++] = h, u = b;
  }
  return s[c++] = e[d], s;
}
function kee(e, t, n, o) {
  let r = 0, i = 0, s, a, c, d, u, p, h, g, m, b;
  const C = [], x = t + n - 1, v = e[t].x, M = e[x].x - v;
  for (s = t; s < t + n; ++s) {
    a = e[s], c = (a.x - v) / M * o, d = a.y;
    const w = c | 0;
    if (w === u)
      d < m ? (m = d, p = s) : d > b && (b = d, h = s), r = (i * r + a.x) / ++i;
    else {
      const k = s - 1;
      if (!It(p) && !It(h)) {
        const E = Math.min(p, h), R = Math.max(p, h);
        E !== g && E !== k && C.push({
          ...e[E],
          x: r
        }), R !== g && R !== k && C.push({
          ...e[R],
          x: r
        });
      }
      s > 0 && k !== g && C.push(e[k]), C.push(a), u = w, i = 0, m = b = d, p = h = g = s;
    }
  }
  return C;
}
function qS(e) {
  if (e._decimated) {
    const t = e._data;
    delete e._decimated, delete e._data, Object.defineProperty(e, "data", {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: t
    });
  }
}
function xb(e) {
  e.data.datasets.forEach((t) => {
    qS(t);
  });
}
function Eee(e, t) {
  const n = t.length;
  let o = 0, r;
  const { iScale: i } = e, { min: s, max: a, minDefined: c, maxDefined: d } = i.getUserBounds();
  return c && (o = Wn(ki(t, i.axis, s).lo, 0, n - 1)), d ? r = Wn(ki(t, i.axis, a).hi + 1, o, n) - o : r = n - o, {
    start: o,
    count: r
  };
}
var Ree = {
  id: "decimation",
  defaults: {
    algorithm: "min-max",
    enabled: !1
  },
  beforeElementsUpdate: (e, t, n) => {
    if (!n.enabled) {
      xb(e);
      return;
    }
    const o = e.width;
    e.data.datasets.forEach((r, i) => {
      const { _data: s, indexAxis: a } = r, c = e.getDatasetMeta(i), d = s || r.data;
      if (dn([
        a,
        e.options.indexAxis
      ]) === "y" || !c.controller.supportsDecimation)
        return;
      const u = e.scales[c.xAxisID];
      if (u.type !== "linear" && u.type !== "time" || e.options.parsing)
        return;
      let { start: p, count: h } = Eee(c, d);
      const g = n.threshold || 4 * o;
      if (h <= g) {
        qS(r);
        return;
      }
      It(s) && (r._data = d, delete r.data, Object.defineProperty(r, "data", {
        configurable: !0,
        enumerable: !0,
        get: function() {
          return this._decimated;
        },
        set: function(b) {
          this._data = b;
        }
      }));
      let m;
      switch (n.algorithm) {
        case "lttb":
          m = Tee(d, p, h, o, n);
          break;
        case "min-max":
          m = kee(d, p, h, o);
          break;
        default:
          throw new Error(`Unsupported decimation algorithm '${n.algorithm}'`);
      }
      r._decimated = m;
    });
  },
  destroy(e) {
    xb(e);
  }
};
function Oee(e, t, n) {
  const o = e.segments, r = e.points, i = t.points, s = [];
  for (const a of o) {
    let { start: c, end: d } = a;
    d = P7(c, d, r);
    const u = n5(n, r[c], r[d], a.loop);
    if (!t.segments) {
      s.push({
        source: a,
        target: u,
        start: r[c],
        end: r[d]
      });
      continue;
    }
    const p = _S(t, u);
    for (const h of p) {
      const g = n5(n, i[h.start], i[h.end], h.loop), m = OS(a, r, g);
      for (const b of m)
        s.push({
          source: b,
          target: h,
          start: {
            [n]: yb(u, g, "start", Math.max)
          },
          end: {
            [n]: yb(u, g, "end", Math.min)
          }
        });
    }
  }
  return s;
}
function n5(e, t, n, o) {
  if (o)
    return;
  let r = t[e], i = n[e];
  return e === "angle" && (r = Go(r), i = Go(i)), {
    property: e,
    start: r,
    end: i
  };
}
function _ee(e, t) {
  const { x: n = null, y: o = null } = e || {}, r = t.points, i = [];
  return t.segments.forEach(({ start: s, end: a }) => {
    a = P7(s, a, r);
    const c = r[s], d = r[a];
    o !== null ? (i.push({
      x: c.x,
      y: o
    }), i.push({
      x: d.x,
      y: o
    })) : n !== null && (i.push({
      x: n,
      y: c.y
    }), i.push({
      x: n,
      y: d.y
    }));
  }), i;
}
function P7(e, t, n) {
  for (; t > e; t--) {
    const o = n[t];
    if (!isNaN(o.x) && !isNaN(o.y))
      break;
  }
  return t;
}
function yb(e, t, n, o) {
  return e && t ? o(e[n], t[n]) : e ? e[n] : t ? t[n] : 0;
}
function KS(e, t) {
  let n = [], o = !1;
  return fn(e) ? (o = !0, n = e) : n = _ee(e, t), n.length ? new es({
    points: n,
    options: {
      tension: 0
    },
    _loop: o,
    _fullLoop: o
  }) : null;
}
function vb(e) {
  return e && e.fill !== !1;
}
function Pee(e, t, n) {
  let r = e[t].fill;
  const i = [
    t
  ];
  let s;
  if (!n)
    return r;
  for (; r !== !1 && i.indexOf(r) === -1; ) {
    if (!kn(r))
      return r;
    if (s = e[r], !s)
      return !1;
    if (s.visible)
      return r;
    i.push(r), r = s.fill;
  }
  return !1;
}
function Lee(e, t, n) {
  const o = Dee(e);
  if (Dt(o))
    return isNaN(o.value) ? !1 : o;
  let r = parseFloat(o);
  return kn(r) && Math.floor(r) === r ? Iee(o[0], t, r, n) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(o) >= 0 && o;
}
function Iee(e, t, n, o) {
  return (e === "-" || e === "+") && (n = t + n), n === t || n < 0 || n >= o ? !1 : n;
}
function jee(e, t) {
  let n = null;
  return e === "start" ? n = t.bottom : e === "end" ? n = t.top : Dt(e) ? n = t.getPixelForValue(e.value) : t.getBasePixel && (n = t.getBasePixel()), n;
}
function Vee(e, t, n) {
  let o;
  return e === "start" ? o = n : e === "end" ? o = t.options.reverse ? t.min : t.max : Dt(e) ? o = e.value : o = t.getBaseValue(), o;
}
function Dee(e) {
  const t = e.options, n = t.fill;
  let o = yt(n && n.target, n);
  return o === void 0 && (o = !!t.backgroundColor), o === !1 || o === null ? !1 : o === !0 ? "origin" : o;
}
function Aee(e) {
  const { scale: t, index: n, line: o } = e, r = [], i = o.segments, s = o.points, a = Hee(t, n);
  a.push(KS({
    x: null,
    y: t.bottom
  }, o));
  for (let c = 0; c < i.length; c++) {
    const d = i[c];
    for (let u = d.start; u <= d.end; u++)
      Fee(r, s[u], a);
  }
  return new es({
    points: r,
    options: {}
  });
}
function Hee(e, t) {
  const n = [], o = e.getMatchingVisibleMetas("line");
  for (let r = 0; r < o.length; r++) {
    const i = o[r];
    if (i.index === t)
      break;
    i.hidden || n.unshift(i.dataset);
  }
  return n;
}
function Fee(e, t, n) {
  const o = [];
  for (let r = 0; r < n.length; r++) {
    const i = n[r], { first: s, last: a, point: c } = Nee(i, t, "x");
    if (!(!c || s && a)) {
      if (s)
        o.unshift(c);
      else if (e.push(c), !a)
        break;
    }
  }
  e.push(...o);
}
function Nee(e, t, n) {
  const o = e.interpolate(t, n);
  if (!o)
    return {};
  const r = o[n], i = e.segments, s = e.points;
  let a = !1, c = !1;
  for (let d = 0; d < i.length; d++) {
    const u = i[d], p = s[u.start][n], h = s[u.end][n];
    if (Ti(r, p, h)) {
      a = r === p, c = r === h;
      break;
    }
  }
  return {
    first: a,
    last: c,
    point: o
  };
}
class YS {
  constructor(t) {
    this.x = t.x, this.y = t.y, this.radius = t.radius;
  }
  pathSegment(t, n, o) {
    const { x: r, y: i, radius: s } = this;
    return n = n || {
      start: 0,
      end: pn
    }, t.arc(r, i, s, n.end, n.start, !0), !o.bounds;
  }
  interpolate(t) {
    const { x: n, y: o, radius: r } = this, i = t.angle;
    return {
      x: n + Math.cos(i) * r,
      y: o + Math.sin(i) * r,
      angle: i
    };
  }
}
function $ee(e) {
  const { chart: t, fill: n, line: o } = e;
  if (kn(n))
    return Bee(t, n);
  if (n === "stack")
    return Aee(e);
  if (n === "shape")
    return !0;
  const r = zee(e);
  return r instanceof YS ? r : KS(r, o);
}
function Bee(e, t) {
  const n = e.getDatasetMeta(t);
  return n && e.isDatasetVisible(t) ? n.dataset : null;
}
function zee(e) {
  return (e.scale || {}).getPointPositionForValue ? Wee(e) : Zee(e);
}
function Zee(e) {
  const { scale: t = {}, fill: n } = e, o = jee(n, t);
  if (kn(o)) {
    const r = t.isHorizontal();
    return {
      x: r ? o : null,
      y: r ? null : o
    };
  }
  return null;
}
function Wee(e) {
  const { scale: t, fill: n } = e, o = t.options, r = t.getLabels().length, i = o.reverse ? t.max : t.min, s = Vee(n, t, i), a = [];
  if (o.grid.circular) {
    const c = t.getPointPositionForValue(0, i);
    return new YS({
      x: c.x,
      y: c.y,
      radius: t.getDistanceFromCenterForValue(s)
    });
  }
  for (let c = 0; c < r; ++c)
    a.push(t.getPointPositionForValue(c, s));
  return a;
}
function s6(e, t, n) {
  const o = $ee(t), { line: r, scale: i, axis: s } = t, a = r.options, c = a.fill, d = a.backgroundColor, { above: u = d, below: p = d } = c || {};
  o && r.points.length && ($3(e, n), Uee(e, {
    line: r,
    target: o,
    above: u,
    below: p,
    area: n,
    scale: i,
    axis: s
  }), B3(e));
}
function Uee(e, t) {
  const { line: n, target: o, above: r, below: i, area: s, scale: a } = t, c = n._loop ? "angle" : t.axis;
  e.save(), c === "x" && i !== r && (wb(e, o, s.top), Sb(e, {
    line: n,
    target: o,
    color: r,
    scale: a,
    property: c
  }), e.restore(), e.save(), wb(e, o, s.bottom)), Sb(e, {
    line: n,
    target: o,
    color: i,
    scale: a,
    property: c
  }), e.restore();
}
function wb(e, t, n) {
  const { segments: o, points: r } = t;
  let i = !0, s = !1;
  e.beginPath();
  for (const a of o) {
    const { start: c, end: d } = a, u = r[c], p = r[P7(c, d, r)];
    i ? (e.moveTo(u.x, u.y), i = !1) : (e.lineTo(u.x, n), e.lineTo(u.x, u.y)), s = !!t.pathSegment(e, a, {
      move: s
    }), s ? e.closePath() : e.lineTo(p.x, n);
  }
  e.lineTo(t.first().x, n), e.closePath(), e.clip();
}
function Sb(e, t) {
  const { line: n, target: o, property: r, color: i, scale: s } = t, a = Oee(n, o, r);
  for (const { source: c, target: d, start: u, end: p } of a) {
    const { style: { backgroundColor: h = i } = {} } = c, g = o !== !0;
    e.save(), e.fillStyle = h, Gee(e, s, g && n5(r, u, p)), e.beginPath();
    const m = !!n.pathSegment(e, c);
    let b;
    if (g) {
      m ? e.closePath() : Mb(e, o, p, r);
      const C = !!o.pathSegment(e, d, {
        move: m,
        reverse: !0
      });
      b = m && C, b || Mb(e, o, u, r);
    }
    e.closePath(), e.fill(b ? "evenodd" : "nonzero"), e.restore();
  }
}
function Gee(e, t, n) {
  const { top: o, bottom: r } = t.chart.chartArea, { property: i, start: s, end: a } = n || {};
  i === "x" && (e.beginPath(), e.rect(s, o, a - s, r - o), e.clip());
}
function Mb(e, t, n, o) {
  const r = t.interpolate(n, o);
  r && e.lineTo(r.x, r.y);
}
var qee = {
  id: "filler",
  afterDatasetsUpdate(e, t, n) {
    const o = (e.data.datasets || []).length, r = [];
    let i, s, a, c;
    for (s = 0; s < o; ++s)
      i = e.getDatasetMeta(s), a = i.dataset, c = null, a && a.options && a instanceof es && (c = {
        visible: e.isDatasetVisible(s),
        index: s,
        fill: Lee(a, s, o),
        chart: e,
        axis: i.controller.options.indexAxis,
        scale: i.vScale,
        line: a
      }), i.$filler = c, r.push(c);
    for (s = 0; s < o; ++s)
      c = r[s], !(!c || c.fill === !1) && (c.fill = Pee(r, s, n.propagate));
  },
  beforeDraw(e, t, n) {
    const o = n.drawTime === "beforeDraw", r = e.getSortedVisibleDatasetMetas(), i = e.chartArea;
    for (let s = r.length - 1; s >= 0; --s) {
      const a = r[s].$filler;
      a && (a.line.updateControlPoints(i, a.axis), o && a.fill && s6(e.ctx, a, i));
    }
  },
  beforeDatasetsDraw(e, t, n) {
    if (n.drawTime !== "beforeDatasetsDraw")
      return;
    const o = e.getSortedVisibleDatasetMetas();
    for (let r = o.length - 1; r >= 0; --r) {
      const i = o[r].$filler;
      vb(i) && s6(e.ctx, i, e.chartArea);
    }
  },
  beforeDatasetDraw(e, t, n) {
    const o = t.meta.$filler;
    !vb(o) || n.drawTime !== "beforeDatasetDraw" || s6(e.ctx, o, e.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const Tb = (e, t) => {
  let { boxHeight: n = t, boxWidth: o = t } = e;
  return e.usePointStyle && (n = Math.min(n, t), o = e.pointStyleWidth || Math.min(o, t)), {
    boxWidth: o,
    boxHeight: n,
    itemHeight: Math.max(t, n)
  };
}, Kee = (e, t) => e !== null && t !== null && e.datasetIndex === t.datasetIndex && e.index === t.index;
let kb = class extends Di {
  constructor(t) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, n, o) {
    this.maxWidth = t, this.maxHeight = n, this._margins = o, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const t = this.options.labels || {};
    let n = rn(t.generateLabels, [
      this.chart
    ], this) || [];
    t.filter && (n = n.filter((o) => t.filter(o, this.chart.data))), t.sort && (n = n.sort((o, r) => t.sort(o, r, this.chart.data))), this.options.reverse && n.reverse(), this.legendItems = n;
  }
  fit() {
    const { options: t, ctx: n } = this;
    if (!t.display) {
      this.width = this.height = 0;
      return;
    }
    const o = t.labels, r = Dn(o.font), i = r.size, s = this._computeTitleHeight(), { boxWidth: a, itemHeight: c } = Tb(o, i);
    let d, u;
    n.font = r.string, this.isHorizontal() ? (d = this.maxWidth, u = this._fitRows(s, i, a, c) + 10) : (u = this.maxHeight, d = this._fitCols(s, r, a, c) + 10), this.width = Math.min(d, t.maxWidth || this.maxWidth), this.height = Math.min(u, t.maxHeight || this.maxHeight);
  }
  _fitRows(t, n, o, r) {
    const { ctx: i, maxWidth: s, options: { labels: { padding: a } } } = this, c = this.legendHitBoxes = [], d = this.lineWidths = [
      0
    ], u = r + a;
    let p = t;
    i.textAlign = "left", i.textBaseline = "middle";
    let h = -1, g = -u;
    return this.legendItems.forEach((m, b) => {
      const C = o + n / 2 + i.measureText(m.text).width;
      (b === 0 || d[d.length - 1] + C + 2 * a > s) && (p += u, d[d.length - (b > 0 ? 0 : 1)] = 0, g += u, h++), c[b] = {
        left: 0,
        top: g,
        row: h,
        width: C,
        height: r
      }, d[d.length - 1] += C + a;
    }), p;
  }
  _fitCols(t, n, o, r) {
    const { ctx: i, maxHeight: s, options: { labels: { padding: a } } } = this, c = this.legendHitBoxes = [], d = this.columnSizes = [], u = s - t;
    let p = a, h = 0, g = 0, m = 0, b = 0;
    return this.legendItems.forEach((C, x) => {
      const { itemWidth: v, itemHeight: S } = Yee(o, n, i, C, r);
      x > 0 && g + S + 2 * a > u && (p += h + a, d.push({
        width: h,
        height: g
      }), m += h + a, b++, h = g = 0), c[x] = {
        left: m,
        top: g,
        col: b,
        width: v,
        height: S
      }, h = Math.max(h, v), g += S + a;
    }), p += h, d.push({
      width: h,
      height: g
    }), p;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const t = this._computeTitleHeight(), { legendHitBoxes: n, options: { align: o, labels: { padding: r }, rtl: i } } = this, s = yl(i, this.left, this.width);
    if (this.isHorizontal()) {
      let a = 0, c = so(o, this.left + r, this.right - this.lineWidths[a]);
      for (const d of n)
        a !== d.row && (a = d.row, c = so(o, this.left + r, this.right - this.lineWidths[a])), d.top += this.top + t + r, d.left = s.leftForLtr(s.x(c), d.width), c += d.width + r;
    } else {
      let a = 0, c = so(o, this.top + t + r, this.bottom - this.columnSizes[a].height);
      for (const d of n)
        d.col !== a && (a = d.col, c = so(o, this.top + t + r, this.bottom - this.columnSizes[a].height)), d.top = c, d.left += this.left + r, d.left = s.leftForLtr(s.x(d.left), d.width), c += d.height + r;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const t = this.ctx;
      $3(t, this), this._draw(), B3(t);
    }
  }
  _draw() {
    const { options: t, columnSizes: n, lineWidths: o, ctx: r } = this, { align: i, labels: s } = t, a = hn.color, c = yl(t.rtl, this.left, this.width), d = Dn(s.font), { padding: u } = s, p = d.size, h = p / 2;
    let g;
    this.drawTitle(), r.textAlign = c.textAlign("left"), r.textBaseline = "middle", r.lineWidth = 0.5, r.font = d.string;
    const { boxWidth: m, boxHeight: b, itemHeight: C } = Tb(s, p), x = function(k, E, R) {
      if (isNaN(m) || m <= 0 || isNaN(b) || b < 0)
        return;
      r.save();
      const O = yt(R.lineWidth, 1);
      if (r.fillStyle = yt(R.fillStyle, a), r.lineCap = yt(R.lineCap, "butt"), r.lineDashOffset = yt(R.lineDashOffset, 0), r.lineJoin = yt(R.lineJoin, "miter"), r.lineWidth = O, r.strokeStyle = yt(R.strokeStyle, a), r.setLineDash(yt(R.lineDash, [])), s.usePointStyle) {
        const P = {
          radius: b * Math.SQRT2 / 2,
          pointStyle: R.pointStyle,
          rotation: R.rotation,
          borderWidth: O
        }, _ = c.xPlus(k, m / 2), L = E + h;
        CS(r, P, _, L, s.pointStyleWidth && m);
      } else {
        const P = E + Math.max((p - b) / 2, 0), _ = c.leftForLtr(k, m), L = aa(R.borderRadius);
        r.beginPath(), Object.values(L).some((V) => V !== 0) ? Wc(r, {
          x: _,
          y: P,
          w: m,
          h: b,
          radius: L
        }) : r.rect(_, P, m, b), r.fill(), O !== 0 && r.stroke();
      }
      r.restore();
    }, v = function(k, E, R) {
      ka(r, R.text, k, E + C / 2, d, {
        strikethrough: R.hidden,
        textAlign: c.textAlign(R.textAlign)
      });
    }, S = this.isHorizontal(), M = this._computeTitleHeight();
    S ? g = {
      x: so(i, this.left + u, this.right - o[0]),
      y: this.top + u + M,
      line: 0
    } : g = {
      x: this.left + u,
      y: so(i, this.top + M + u, this.bottom - n[0].height),
      line: 0
    }, kS(this.ctx, t.textDirection);
    const w = C + u;
    this.legendItems.forEach((k, E) => {
      r.strokeStyle = k.fontColor, r.fillStyle = k.fontColor;
      const R = r.measureText(k.text).width, O = c.textAlign(k.textAlign || (k.textAlign = s.textAlign)), P = m + h + R;
      let _ = g.x, L = g.y;
      c.setWidth(this.width), S ? E > 0 && _ + P + u > this.right && (L = g.y += w, g.line++, _ = g.x = so(i, this.left + u, this.right - o[g.line])) : E > 0 && L + w > this.bottom && (_ = g.x = _ + n[g.line].width + u, g.line++, L = g.y = so(i, this.top + M + u, this.bottom - n[g.line].height));
      const V = c.x(_);
      if (x(V, L, k), _ = mX(O, _ + m + h, S ? _ + P : this.right, t.rtl), v(c.x(_), L, k), S)
        g.x += P + u;
      else if (typeof k.text != "string") {
        const j = d.lineHeight;
        g.y += XS(k, j) + u;
      } else
        g.y += w;
    }), ES(this.ctx, t.textDirection);
  }
  drawTitle() {
    const t = this.options, n = t.title, o = Dn(n.font), r = no(n.padding);
    if (!n.display)
      return;
    const i = yl(t.rtl, this.left, this.width), s = this.ctx, a = n.position, c = o.size / 2, d = r.top + c;
    let u, p = this.left, h = this.width;
    if (this.isHorizontal())
      h = Math.max(...this.lineWidths), u = this.top + d, p = so(t.align, p, this.right - h);
    else {
      const m = this.columnSizes.reduce((b, C) => Math.max(b, C.height), 0);
      u = d + so(t.align, this.top, this.bottom - m - t.labels.padding - this._computeTitleHeight());
    }
    const g = so(a, p, p + h);
    s.textAlign = i.textAlign(w7(a)), s.textBaseline = "middle", s.strokeStyle = n.color, s.fillStyle = n.color, s.font = o.string, ka(s, n.text, g, u, o);
  }
  _computeTitleHeight() {
    const t = this.options.title, n = Dn(t.font), o = no(t.padding);
    return t.display ? n.lineHeight + o.height : 0;
  }
  _getLegendItemAt(t, n) {
    let o, r, i;
    if (Ti(t, this.left, this.right) && Ti(n, this.top, this.bottom)) {
      for (i = this.legendHitBoxes, o = 0; o < i.length; ++o)
        if (r = i[o], Ti(t, r.left, r.left + r.width) && Ti(n, r.top, r.top + r.height))
          return this.legendItems[o];
    }
    return null;
  }
  handleEvent(t) {
    const n = this.options;
    if (!Qee(t.type, n))
      return;
    const o = this._getLegendItemAt(t.x, t.y);
    if (t.type === "mousemove" || t.type === "mouseout") {
      const r = this._hoveredItem, i = Kee(r, o);
      r && !i && rn(n.onLeave, [
        t,
        r,
        this
      ], this), this._hoveredItem = o, o && !i && rn(n.onHover, [
        t,
        o,
        this
      ], this);
    } else o && rn(n.onClick, [
      t,
      o,
      this
    ], this);
  }
};
function Yee(e, t, n, o, r) {
  const i = Xee(o, e, t, n), s = Jee(r, o, t.lineHeight);
  return {
    itemWidth: i,
    itemHeight: s
  };
}
function Xee(e, t, n, o) {
  let r = e.text;
  return r && typeof r != "string" && (r = r.reduce((i, s) => i.length > s.length ? i : s)), t + n.size / 2 + o.measureText(r).width;
}
function Jee(e, t, n) {
  let o = e;
  return typeof t.text != "string" && (o = XS(t, n)), o;
}
function XS(e, t) {
  const n = e.text ? e.text.length : 0;
  return t * n;
}
function Qee(e, t) {
  return !!((e === "mousemove" || e === "mouseout") && (t.onHover || t.onLeave) || t.onClick && (e === "click" || e === "mouseup"));
}
var ete = {
  id: "legend",
  _element: kb,
  start(e, t, n) {
    const o = e.legend = new kb({
      ctx: e.ctx,
      options: n,
      chart: e
    });
    uo.configure(e, o, n), uo.addBox(e, o);
  },
  stop(e) {
    uo.removeBox(e, e.legend), delete e.legend;
  },
  beforeUpdate(e, t, n) {
    const o = e.legend;
    uo.configure(e, o, n), o.options = n;
  },
  afterUpdate(e) {
    const t = e.legend;
    t.buildLabels(), t.adjustHitBoxes();
  },
  afterEvent(e, t) {
    t.replay || e.legend.handleEvent(t.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(e, t, n) {
      const o = t.datasetIndex, r = n.chart;
      r.isDatasetVisible(o) ? (r.hide(o), t.hidden = !0) : (r.show(o), t.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (e) => e.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(e) {
        const t = e.data.datasets, { labels: { usePointStyle: n, pointStyle: o, textAlign: r, color: i, useBorderRadius: s, borderRadius: a } } = e.legend.options;
        return e._getSortedDatasetMetas().map((c) => {
          const d = c.controller.getStyle(n ? 0 : void 0), u = no(d.borderWidth);
          return {
            text: t[c.index].label,
            fillStyle: d.backgroundColor,
            fontColor: i,
            hidden: !c.visible,
            lineCap: d.borderCapStyle,
            lineDash: d.borderDash,
            lineDashOffset: d.borderDashOffset,
            lineJoin: d.borderJoinStyle,
            lineWidth: (u.width + u.height) / 4,
            strokeStyle: d.borderColor,
            pointStyle: o || d.pointStyle,
            rotation: d.rotation,
            textAlign: r || d.textAlign,
            borderRadius: s && (a || d.borderRadius),
            datasetIndex: c.index
          };
        }, this);
      }
    },
    title: {
      color: (e) => e.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (e) => !e.startsWith("on"),
    labels: {
      _scriptable: (e) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(e)
    }
  }
};
class L7 extends Di {
  constructor(t) {
    super(), this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, n) {
    const o = this.options;
    if (this.left = 0, this.top = 0, !o.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = t, this.height = this.bottom = n;
    const r = fn(o.text) ? o.text.length : 1;
    this._padding = no(o.padding);
    const i = r * Dn(o.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = i : this.width = i;
  }
  isHorizontal() {
    const t = this.options.position;
    return t === "top" || t === "bottom";
  }
  _drawArgs(t) {
    const { top: n, left: o, bottom: r, right: i, options: s } = this, a = s.align;
    let c = 0, d, u, p;
    return this.isHorizontal() ? (u = so(a, o, i), p = n + t, d = i - o) : (s.position === "left" ? (u = o + t, p = so(a, r, n), c = mn * -0.5) : (u = i - t, p = so(a, n, r), c = mn * 0.5), d = r - n), {
      titleX: u,
      titleY: p,
      maxWidth: d,
      rotation: c
    };
  }
  draw() {
    const t = this.ctx, n = this.options;
    if (!n.display)
      return;
    const o = Dn(n.font), i = o.lineHeight / 2 + this._padding.top, { titleX: s, titleY: a, maxWidth: c, rotation: d } = this._drawArgs(i);
    ka(t, n.text, 0, 0, o, {
      color: n.color,
      maxWidth: c,
      rotation: d,
      textAlign: w7(n.align),
      textBaseline: "middle",
      translation: [
        s,
        a
      ]
    });
  }
}
function tte(e, t) {
  const n = new L7({
    ctx: e.ctx,
    options: t,
    chart: e
  });
  uo.configure(e, n, t), uo.addBox(e, n), e.titleBlock = n;
}
var nte = {
  id: "title",
  _element: L7,
  start(e, t, n) {
    tte(e, n);
  },
  stop(e) {
    const t = e.titleBlock;
    uo.removeBox(e, t), delete e.titleBlock;
  },
  beforeUpdate(e, t, n) {
    const o = e.titleBlock;
    uo.configure(e, o, n), o.options = n;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const k1 = /* @__PURE__ */ new WeakMap();
var ote = {
  id: "subtitle",
  start(e, t, n) {
    const o = new L7({
      ctx: e.ctx,
      options: n,
      chart: e
    });
    uo.configure(e, o, n), uo.addBox(e, o), k1.set(e, o);
  },
  stop(e) {
    uo.removeBox(e, k1.get(e)), k1.delete(e);
  },
  beforeUpdate(e, t, n) {
    const o = k1.get(e);
    uo.configure(e, o, n), o.options = n;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "normal"
    },
    fullSize: !0,
    padding: 0,
    position: "top",
    text: "",
    weight: 1500
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const G2 = {
  average(e) {
    if (!e.length)
      return !1;
    let t, n, o = /* @__PURE__ */ new Set(), r = 0, i = 0;
    for (t = 0, n = e.length; t < n; ++t) {
      const a = e[t].element;
      if (a && a.hasValue()) {
        const c = a.tooltipPosition();
        o.add(c.x), r += c.y, ++i;
      }
    }
    return i === 0 || o.size === 0 ? !1 : {
      x: [
        ...o
      ].reduce((a, c) => a + c) / o.size,
      y: r / i
    };
  },
  nearest(e, t) {
    if (!e.length)
      return !1;
    let n = t.x, o = t.y, r = Number.POSITIVE_INFINITY, i, s, a;
    for (i = 0, s = e.length; i < s; ++i) {
      const c = e[i].element;
      if (c && c.hasValue()) {
        const d = c.getCenterPoint(), u = qp(t, d);
        u < r && (r = u, a = c);
      }
    }
    if (a) {
      const c = a.tooltipPosition();
      n = c.x, o = c.y;
    }
    return {
      x: n,
      y: o
    };
  }
};
function Nr(e, t) {
  return t && (fn(t) ? Array.prototype.push.apply(e, t) : e.push(t)), e;
}
function Ci(e) {
  return (typeof e == "string" || e instanceof String) && e.indexOf(`
`) > -1 ? e.split(`
`) : e;
}
function rte(e, t) {
  const { element: n, datasetIndex: o, index: r } = t, i = e.getDatasetMeta(o).controller, { label: s, value: a } = i.getLabelAndValue(r);
  return {
    chart: e,
    label: s,
    parsed: i.getParsed(r),
    raw: e.data.datasets[o].data[r],
    formattedValue: a,
    dataset: i.getDataset(),
    dataIndex: r,
    datasetIndex: o,
    element: n
  };
}
function Eb(e, t) {
  const n = e.chart.ctx, { body: o, footer: r, title: i } = e, { boxWidth: s, boxHeight: a } = t, c = Dn(t.bodyFont), d = Dn(t.titleFont), u = Dn(t.footerFont), p = i.length, h = r.length, g = o.length, m = no(t.padding);
  let b = m.height, C = 0, x = o.reduce((M, w) => M + w.before.length + w.lines.length + w.after.length, 0);
  if (x += e.beforeBody.length + e.afterBody.length, p && (b += p * d.lineHeight + (p - 1) * t.titleSpacing + t.titleMarginBottom), x) {
    const M = t.displayColors ? Math.max(a, c.lineHeight) : c.lineHeight;
    b += g * M + (x - g) * c.lineHeight + (x - 1) * t.bodySpacing;
  }
  h && (b += t.footerMarginTop + h * u.lineHeight + (h - 1) * t.footerSpacing);
  let v = 0;
  const S = function(M) {
    C = Math.max(C, n.measureText(M).width + v);
  };
  return n.save(), n.font = d.string, en(e.title, S), n.font = c.string, en(e.beforeBody.concat(e.afterBody), S), v = t.displayColors ? s + 2 + t.boxPadding : 0, en(o, (M) => {
    en(M.before, S), en(M.lines, S), en(M.after, S);
  }), v = 0, n.font = u.string, en(e.footer, S), n.restore(), C += m.width, {
    width: C,
    height: b
  };
}
function ite(e, t) {
  const { y: n, height: o } = t;
  return n < o / 2 ? "top" : n > e.height - o / 2 ? "bottom" : "center";
}
function ste(e, t, n, o) {
  const { x: r, width: i } = o, s = n.caretSize + n.caretPadding;
  if (e === "left" && r + i + s > t.width || e === "right" && r - i - s < 0)
    return !0;
}
function ate(e, t, n, o) {
  const { x: r, width: i } = n, { width: s, chartArea: { left: a, right: c } } = e;
  let d = "center";
  return o === "center" ? d = r <= (a + c) / 2 ? "left" : "right" : r <= i / 2 ? d = "left" : r >= s - i / 2 && (d = "right"), ste(d, e, t, n) && (d = "center"), d;
}
function Rb(e, t, n) {
  const o = n.yAlign || t.yAlign || ite(e, n);
  return {
    xAlign: n.xAlign || t.xAlign || ate(e, t, n, o),
    yAlign: o
  };
}
function lte(e, t) {
  let { x: n, width: o } = e;
  return t === "right" ? n -= o : t === "center" && (n -= o / 2), n;
}
function cte(e, t, n) {
  let { y: o, height: r } = e;
  return t === "top" ? o += n : t === "bottom" ? o -= r + n : o -= r / 2, o;
}
function Ob(e, t, n, o) {
  const { caretSize: r, caretPadding: i, cornerRadius: s } = e, { xAlign: a, yAlign: c } = n, d = r + i, { topLeft: u, topRight: p, bottomLeft: h, bottomRight: g } = aa(s);
  let m = lte(t, a);
  const b = cte(t, c, d);
  return c === "center" ? a === "left" ? m += d : a === "right" && (m -= d) : a === "left" ? m -= Math.max(u, h) + r : a === "right" && (m += Math.max(p, g) + r), {
    x: Wn(m, 0, o.width - t.width),
    y: Wn(b, 0, o.height - t.height)
  };
}
function E1(e, t, n) {
  const o = no(n.padding);
  return t === "center" ? e.x + e.width / 2 : t === "right" ? e.x + e.width - o.right : e.x + o.left;
}
function _b(e) {
  return Nr([], Ci(e));
}
function dte(e, t, n) {
  return Rs(e, {
    tooltip: t,
    tooltipItems: n,
    type: "tooltip"
  });
}
function Pb(e, t) {
  const n = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return n ? e.override(n) : e;
}
const JS = {
  beforeTitle: fi,
  title(e) {
    if (e.length > 0) {
      const t = e[0], n = t.chart.data.labels, o = n ? n.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return t.dataset.label || "";
      if (t.label)
        return t.label;
      if (o > 0 && t.dataIndex < o)
        return n[t.dataIndex];
    }
    return "";
  },
  afterTitle: fi,
  beforeBody: fi,
  beforeLabel: fi,
  label(e) {
    if (this && this.options && this.options.mode === "dataset")
      return e.label + ": " + e.formattedValue || e.formattedValue;
    let t = e.dataset.label || "";
    t && (t += ": ");
    const n = e.formattedValue;
    return It(n) || (t += n), t;
  },
  labelColor(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      borderColor: n.borderColor,
      backgroundColor: n.backgroundColor,
      borderWidth: n.borderWidth,
      borderDash: n.borderDash,
      borderDashOffset: n.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      pointStyle: n.pointStyle,
      rotation: n.rotation
    };
  },
  afterLabel: fi,
  afterBody: fi,
  beforeFooter: fi,
  footer: fi,
  afterFooter: fi
};
function Eo(e, t, n, o) {
  const r = e[t].call(n, o);
  return typeof r > "u" ? JS[t].call(n, o) : r;
}
class o5 extends Di {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const n = this.chart, o = this.options.setContext(this.getContext()), r = o.enabled && n.options.animation && o.animations, i = new PS(this.chart, r);
    return r._cacheable && (this._cachedAnimations = Object.freeze(i)), i;
  }
  getContext() {
    return this.$context || (this.$context = dte(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, n) {
    const { callbacks: o } = n, r = Eo(o, "beforeTitle", this, t), i = Eo(o, "title", this, t), s = Eo(o, "afterTitle", this, t);
    let a = [];
    return a = Nr(a, Ci(r)), a = Nr(a, Ci(i)), a = Nr(a, Ci(s)), a;
  }
  getBeforeBody(t, n) {
    return _b(Eo(n.callbacks, "beforeBody", this, t));
  }
  getBody(t, n) {
    const { callbacks: o } = n, r = [];
    return en(t, (i) => {
      const s = {
        before: [],
        lines: [],
        after: []
      }, a = Pb(o, i);
      Nr(s.before, Ci(Eo(a, "beforeLabel", this, i))), Nr(s.lines, Eo(a, "label", this, i)), Nr(s.after, Ci(Eo(a, "afterLabel", this, i))), r.push(s);
    }), r;
  }
  getAfterBody(t, n) {
    return _b(Eo(n.callbacks, "afterBody", this, t));
  }
  getFooter(t, n) {
    const { callbacks: o } = n, r = Eo(o, "beforeFooter", this, t), i = Eo(o, "footer", this, t), s = Eo(o, "afterFooter", this, t);
    let a = [];
    return a = Nr(a, Ci(r)), a = Nr(a, Ci(i)), a = Nr(a, Ci(s)), a;
  }
  _createItems(t) {
    const n = this._active, o = this.chart.data, r = [], i = [], s = [];
    let a = [], c, d;
    for (c = 0, d = n.length; c < d; ++c)
      a.push(rte(this.chart, n[c]));
    return t.filter && (a = a.filter((u, p, h) => t.filter(u, p, h, o))), t.itemSort && (a = a.sort((u, p) => t.itemSort(u, p, o))), en(a, (u) => {
      const p = Pb(t.callbacks, u);
      r.push(Eo(p, "labelColor", this, u)), i.push(Eo(p, "labelPointStyle", this, u)), s.push(Eo(p, "labelTextColor", this, u));
    }), this.labelColors = r, this.labelPointStyles = i, this.labelTextColors = s, this.dataPoints = a, a;
  }
  update(t, n) {
    const o = this.options.setContext(this.getContext()), r = this._active;
    let i, s = [];
    if (!r.length)
      this.opacity !== 0 && (i = {
        opacity: 0
      });
    else {
      const a = G2[o.position].call(this, r, this._eventPosition);
      s = this._createItems(o), this.title = this.getTitle(s, o), this.beforeBody = this.getBeforeBody(s, o), this.body = this.getBody(s, o), this.afterBody = this.getAfterBody(s, o), this.footer = this.getFooter(s, o);
      const c = this._size = Eb(this, o), d = Object.assign({}, a, c), u = Rb(this.chart, o, d), p = Ob(o, d, u, this.chart);
      this.xAlign = u.xAlign, this.yAlign = u.yAlign, i = {
        opacity: 1,
        x: p.x,
        y: p.y,
        width: c.width,
        height: c.height,
        caretX: a.x,
        caretY: a.y
      };
    }
    this._tooltipItems = s, this.$context = void 0, i && this._resolveAnimations().update(this, i), t && o.external && o.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: n
    });
  }
  drawCaret(t, n, o, r) {
    const i = this.getCaretPosition(t, o, r);
    n.lineTo(i.x1, i.y1), n.lineTo(i.x2, i.y2), n.lineTo(i.x3, i.y3);
  }
  getCaretPosition(t, n, o) {
    const { xAlign: r, yAlign: i } = this, { caretSize: s, cornerRadius: a } = o, { topLeft: c, topRight: d, bottomLeft: u, bottomRight: p } = aa(a), { x: h, y: g } = t, { width: m, height: b } = n;
    let C, x, v, S, M, w;
    return i === "center" ? (M = g + b / 2, r === "left" ? (C = h, x = C - s, S = M + s, w = M - s) : (C = h + m, x = C + s, S = M - s, w = M + s), v = C) : (r === "left" ? x = h + Math.max(c, u) + s : r === "right" ? x = h + m - Math.max(d, p) - s : x = this.caretX, i === "top" ? (S = g, M = S - s, C = x - s, v = x + s) : (S = g + b, M = S + s, C = x + s, v = x - s), w = S), {
      x1: C,
      x2: x,
      x3: v,
      y1: S,
      y2: M,
      y3: w
    };
  }
  drawTitle(t, n, o) {
    const r = this.title, i = r.length;
    let s, a, c;
    if (i) {
      const d = yl(o.rtl, this.x, this.width);
      for (t.x = E1(this, o.titleAlign, o), n.textAlign = d.textAlign(o.titleAlign), n.textBaseline = "middle", s = Dn(o.titleFont), a = o.titleSpacing, n.fillStyle = o.titleColor, n.font = s.string, c = 0; c < i; ++c)
        n.fillText(r[c], d.x(t.x), t.y + s.lineHeight / 2), t.y += s.lineHeight + a, c + 1 === i && (t.y += o.titleMarginBottom - a);
    }
  }
  _drawColorBox(t, n, o, r, i) {
    const s = this.labelColors[o], a = this.labelPointStyles[o], { boxHeight: c, boxWidth: d } = i, u = Dn(i.bodyFont), p = E1(this, "left", i), h = r.x(p), g = c < u.lineHeight ? (u.lineHeight - c) / 2 : 0, m = n.y + g;
    if (i.usePointStyle) {
      const b = {
        radius: Math.min(d, c) / 2,
        pointStyle: a.pointStyle,
        rotation: a.rotation,
        borderWidth: 1
      }, C = r.leftForLtr(h, d) + d / 2, x = m + c / 2;
      t.strokeStyle = i.multiKeyBackground, t.fillStyle = i.multiKeyBackground, Yp(t, b, C, x), t.strokeStyle = s.borderColor, t.fillStyle = s.backgroundColor, Yp(t, b, C, x);
    } else {
      t.lineWidth = Dt(s.borderWidth) ? Math.max(...Object.values(s.borderWidth)) : s.borderWidth || 1, t.strokeStyle = s.borderColor, t.setLineDash(s.borderDash || []), t.lineDashOffset = s.borderDashOffset || 0;
      const b = r.leftForLtr(h, d), C = r.leftForLtr(r.xPlus(h, 1), d - 2), x = aa(s.borderRadius);
      Object.values(x).some((v) => v !== 0) ? (t.beginPath(), t.fillStyle = i.multiKeyBackground, Wc(t, {
        x: b,
        y: m,
        w: d,
        h: c,
        radius: x
      }), t.fill(), t.stroke(), t.fillStyle = s.backgroundColor, t.beginPath(), Wc(t, {
        x: C,
        y: m + 1,
        w: d - 2,
        h: c - 2,
        radius: x
      }), t.fill()) : (t.fillStyle = i.multiKeyBackground, t.fillRect(b, m, d, c), t.strokeRect(b, m, d, c), t.fillStyle = s.backgroundColor, t.fillRect(C, m + 1, d - 2, c - 2));
    }
    t.fillStyle = this.labelTextColors[o];
  }
  drawBody(t, n, o) {
    const { body: r } = this, { bodySpacing: i, bodyAlign: s, displayColors: a, boxHeight: c, boxWidth: d, boxPadding: u } = o, p = Dn(o.bodyFont);
    let h = p.lineHeight, g = 0;
    const m = yl(o.rtl, this.x, this.width), b = function(R) {
      n.fillText(R, m.x(t.x + g), t.y + h / 2), t.y += h + i;
    }, C = m.textAlign(s);
    let x, v, S, M, w, k, E;
    for (n.textAlign = s, n.textBaseline = "middle", n.font = p.string, t.x = E1(this, C, o), n.fillStyle = o.bodyColor, en(this.beforeBody, b), g = a && C !== "right" ? s === "center" ? d / 2 + u : d + 2 + u : 0, M = 0, k = r.length; M < k; ++M) {
      for (x = r[M], v = this.labelTextColors[M], n.fillStyle = v, en(x.before, b), S = x.lines, a && S.length && (this._drawColorBox(n, t, M, m, o), h = Math.max(p.lineHeight, c)), w = 0, E = S.length; w < E; ++w)
        b(S[w]), h = p.lineHeight;
      en(x.after, b);
    }
    g = 0, h = p.lineHeight, en(this.afterBody, b), t.y -= i;
  }
  drawFooter(t, n, o) {
    const r = this.footer, i = r.length;
    let s, a;
    if (i) {
      const c = yl(o.rtl, this.x, this.width);
      for (t.x = E1(this, o.footerAlign, o), t.y += o.footerMarginTop, n.textAlign = c.textAlign(o.footerAlign), n.textBaseline = "middle", s = Dn(o.footerFont), n.fillStyle = o.footerColor, n.font = s.string, a = 0; a < i; ++a)
        n.fillText(r[a], c.x(t.x), t.y + s.lineHeight / 2), t.y += s.lineHeight + o.footerSpacing;
    }
  }
  drawBackground(t, n, o, r) {
    const { xAlign: i, yAlign: s } = this, { x: a, y: c } = t, { width: d, height: u } = o, { topLeft: p, topRight: h, bottomLeft: g, bottomRight: m } = aa(r.cornerRadius);
    n.fillStyle = r.backgroundColor, n.strokeStyle = r.borderColor, n.lineWidth = r.borderWidth, n.beginPath(), n.moveTo(a + p, c), s === "top" && this.drawCaret(t, n, o, r), n.lineTo(a + d - h, c), n.quadraticCurveTo(a + d, c, a + d, c + h), s === "center" && i === "right" && this.drawCaret(t, n, o, r), n.lineTo(a + d, c + u - m), n.quadraticCurveTo(a + d, c + u, a + d - m, c + u), s === "bottom" && this.drawCaret(t, n, o, r), n.lineTo(a + g, c + u), n.quadraticCurveTo(a, c + u, a, c + u - g), s === "center" && i === "left" && this.drawCaret(t, n, o, r), n.lineTo(a, c + p), n.quadraticCurveTo(a, c, a + p, c), n.closePath(), n.fill(), r.borderWidth > 0 && n.stroke();
  }
  _updateAnimationTarget(t) {
    const n = this.chart, o = this.$animations, r = o && o.x, i = o && o.y;
    if (r || i) {
      const s = G2[t.position].call(this, this._active, this._eventPosition);
      if (!s)
        return;
      const a = this._size = Eb(this, t), c = Object.assign({}, s, this._size), d = Rb(n, t, c), u = Ob(t, c, d, n);
      (r._to !== u.x || i._to !== u.y) && (this.xAlign = d.xAlign, this.yAlign = d.yAlign, this.width = a.width, this.height = a.height, this.caretX = s.x, this.caretY = s.y, this._resolveAnimations().update(this, u));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const n = this.options.setContext(this.getContext());
    let o = this.opacity;
    if (!o)
      return;
    this._updateAnimationTarget(n);
    const r = {
      width: this.width,
      height: this.height
    }, i = {
      x: this.x,
      y: this.y
    };
    o = Math.abs(o) < 1e-3 ? 0 : o;
    const s = no(n.padding), a = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    n.enabled && a && (t.save(), t.globalAlpha = o, this.drawBackground(i, t, r, n), kS(t, n.textDirection), i.y += s.top, this.drawTitle(i, t, n), this.drawBody(i, t, n), this.drawFooter(i, t, n), ES(t, n.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, n) {
    const o = this._active, r = t.map(({ datasetIndex: a, index: c }) => {
      const d = this.chart.getDatasetMeta(a);
      if (!d)
        throw new Error("Cannot find a dataset at index " + a);
      return {
        datasetIndex: a,
        element: d.data[c],
        index: c
      };
    }), i = !Jd(o, r), s = this._positionChanged(r, n);
    (i || s) && (this._active = r, this._eventPosition = n, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, n, o = !0) {
    if (n && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const r = this.options, i = this._active || [], s = this._getActiveElements(t, i, n, o), a = this._positionChanged(s, t), c = n || !Jd(s, i) || a;
    return c && (this._active = s, (r.enabled || r.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, n))), c;
  }
  _getActiveElements(t, n, o, r) {
    const i = this.options;
    if (t.type === "mouseout")
      return [];
    if (!r)
      return n.filter((a) => this.chart.data.datasets[a.datasetIndex] && this.chart.getDatasetMeta(a.datasetIndex).controller.getParsed(a.index) !== void 0);
    const s = this.chart.getElementsAtEventForMode(t, i.mode, i, o);
    return i.reverse && s.reverse(), s;
  }
  _positionChanged(t, n) {
    const { caretX: o, caretY: r, options: i } = this, s = G2[i.position].call(this, t, n);
    return s !== !1 && (o !== s.x || r !== s.y);
  }
}
Ge(o5, "positioners", G2);
var ute = {
  id: "tooltip",
  _element: o5,
  positioners: G2,
  afterInit(e, t, n) {
    n && (e.tooltip = new o5({
      chart: e,
      options: n
    }));
  },
  beforeUpdate(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  reset(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  afterDraw(e) {
    const t = e.tooltip;
    if (t && t._willRender()) {
      const n = {
        tooltip: t
      };
      if (e.notifyPlugins("beforeTooltipDraw", {
        ...n,
        cancelable: !0
      }) === !1)
        return;
      t.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", n);
    }
  },
  afterEvent(e, t) {
    if (e.tooltip) {
      const n = t.replay;
      e.tooltip.handleEvent(t.event, n, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (e, t) => t.bodyFont.size,
    boxWidth: (e, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: JS
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (e) => e !== "filter" && e !== "itemSort" && e !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
}, fte = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Colors: Mee,
  Decimation: Ree,
  Filler: qee,
  Legend: ete,
  SubTitle: ote,
  Title: nte,
  Tooltip: ute
});
const pte = (e, t, n, o) => (typeof t == "string" ? (n = e.push(t) - 1, o.unshift({
  index: n,
  label: t
})) : isNaN(t) && (n = null), n);
function hte(e, t, n, o) {
  const r = e.indexOf(t);
  if (r === -1)
    return pte(e, t, n, o);
  const i = e.lastIndexOf(t);
  return r !== i ? n : r;
}
const gte = (e, t) => e === null ? null : Wn(Math.round(e), 0, t);
function Lb(e) {
  const t = this.getLabels();
  return e >= 0 && e < t.length ? t[e] : e;
}
class r5 extends Va {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const n = this._addedLabels;
    if (n.length) {
      const o = this.getLabels();
      for (const { index: r, label: i } of n)
        o[r] === i && o.splice(r, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, n) {
    if (It(t))
      return null;
    const o = this.getLabels();
    return n = isFinite(n) && o[n] === t ? n : hte(o, t, yt(n, t), this._addedLabels), gte(n, o.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let { min: o, max: r } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (o = 0), n || (r = this.getLabels().length - 1)), this.min = o, this.max = r;
  }
  buildTicks() {
    const t = this.min, n = this.max, o = this.options.offset, r = [];
    let i = this.getLabels();
    i = t === 0 && n === i.length - 1 ? i : i.slice(t, n + 1), this._valueRange = Math.max(i.length - (o ? 0 : 1), 1), this._startValue = this.min - (o ? 0.5 : 0);
    for (let s = t; s <= n; s++)
      r.push({
        value: s
      });
    return r;
  }
  getLabelForValue(t) {
    return Lb.call(this, t);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
Ge(r5, "id", "category"), Ge(r5, "defaults", {
  ticks: {
    callback: Lb
  }
});
function mte(e, t) {
  const n = [], { bounds: r, step: i, min: s, max: a, precision: c, count: d, maxTicks: u, maxDigits: p, includeBounds: h } = e, g = i || 1, m = u - 1, { min: b, max: C } = t, x = !It(s), v = !It(a), S = !It(d), M = (C - b) / (p + 1);
  let w = Em((C - b) / m / g) * g, k, E, R, O;
  if (w < 1e-14 && !x && !v)
    return [
      {
        value: b
      },
      {
        value: C
      }
    ];
  O = Math.ceil(C / w) - Math.floor(b / w), O > m && (w = Em(O * w / m / g) * g), It(c) || (k = Math.pow(10, c), w = Math.ceil(w * k) / k), r === "ticks" ? (E = Math.floor(b / w) * w, R = Math.ceil(C / w) * w) : (E = b, R = C), x && v && i && cX((a - s) / i, w / 1e3) ? (O = Math.round(Math.min((a - s) / w, u)), w = (a - s) / O, E = s, R = a) : S ? (E = x ? s : E, R = v ? a : R, O = d - 1, w = (R - E) / O) : (O = (R - E) / w, ac(O, Math.round(O), w / 1e3) ? O = Math.round(O) : O = Math.ceil(O));
  const P = Math.max(Rm(w), Rm(E));
  k = Math.pow(10, It(c) ? P : c), E = Math.round(E * k) / k, R = Math.round(R * k) / k;
  let _ = 0;
  for (x && (h && E !== s ? (n.push({
    value: s
  }), E < s && _++, ac(Math.round((E + _ * w) * k) / k, s, Ib(s, M, e)) && _++) : E < s && _++); _ < O; ++_) {
    const L = Math.round((E + _ * w) * k) / k;
    if (v && L > a)
      break;
    n.push({
      value: L
    });
  }
  return v && h && R !== a ? n.length && ac(n[n.length - 1].value, a, Ib(a, M, e)) ? n[n.length - 1].value = a : n.push({
    value: a
  }) : (!v || R === a) && n.push({
    value: R
  }), n;
}
function Ib(e, t, { horizontal: n, minRotation: o }) {
  const r = Or(o), i = (n ? Math.sin(r) : Math.cos(r)) || 1e-3, s = 0.75 * t * ("" + e).length;
  return Math.min(t / i, s);
}
class iu extends Va {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    return It(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: n, maxDefined: o } = this.getUserBounds();
    let { min: r, max: i } = this;
    const s = (c) => r = n ? r : c, a = (c) => i = o ? i : c;
    if (t) {
      const c = ni(r), d = ni(i);
      c < 0 && d < 0 ? a(0) : c > 0 && d > 0 && s(0);
    }
    if (r === i) {
      let c = i === 0 ? 1 : Math.abs(i * 0.05);
      a(i + c), t || s(r - c);
    }
    this.min = r, this.max = i;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: n, stepSize: o } = t, r;
    return o ? (r = Math.ceil(this.max / o) - Math.floor(this.min / o) + 1, r > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${o} would result generating up to ${r} ticks. Limiting to 1000.`), r = 1e3)) : (r = this.computeTickLimit(), n = n || 11), n && (r = Math.min(n, r)), r;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, n = t.ticks;
    let o = this.getTickLimit();
    o = Math.max(2, o);
    const r = {
      maxTicks: o,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: n.precision,
      step: n.stepSize,
      count: n.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: n.minRotation || 0,
      includeBounds: n.includeBounds !== !1
    }, i = this._range || this, s = mte(r, i);
    return t.bounds === "ticks" && cS(s, this, "value"), t.reverse ? (s.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), s;
  }
  configure() {
    const t = this.ticks;
    let n = this.min, o = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const r = (o - n) / Math.max(t.length - 1, 1) / 2;
      n -= r, o += r;
    }
    this._startValue = n, this._endValue = o, this._valueRange = o - n;
  }
  getLabelForValue(t) {
    return A0(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class i5 extends iu {
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = kn(t) ? t : 0, this.max = kn(n) ? n : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), n = t ? this.width : this.height, o = Or(this.options.ticks.minRotation), r = (t ? Math.sin(o) : Math.cos(o)) || 1e-3, i = this._resolveTickFontOptions(0);
    return Math.ceil(n / Math.min(40, i.lineHeight / r));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
Ge(i5, "id", "linear"), Ge(i5, "defaults", {
  ticks: {
    callback: N3.formatters.numeric
  }
});
const Gc = (e) => Math.floor(Ji(e)), Hs = (e, t) => Math.pow(10, Gc(e) + t);
function jb(e) {
  return e / Math.pow(10, Gc(e)) === 1;
}
function Vb(e, t, n) {
  const o = Math.pow(10, n), r = Math.floor(e / o);
  return Math.ceil(t / o) - r;
}
function bte(e, t) {
  const n = t - e;
  let o = Gc(n);
  for (; Vb(e, t, o) > 10; )
    o++;
  for (; Vb(e, t, o) < 10; )
    o--;
  return Math.min(o, Gc(e));
}
function Cte(e, { min: t, max: n }) {
  t = Bo(e.min, t);
  const o = [], r = Gc(t);
  let i = bte(t, n), s = i < 0 ? Math.pow(10, Math.abs(i)) : 1;
  const a = Math.pow(10, i), c = r > i ? Math.pow(10, r) : 0, d = Math.round((t - c) * s) / s, u = Math.floor((t - c) / a / 10) * a * 10;
  let p = Math.floor((d - u) / Math.pow(10, i)), h = Bo(e.min, Math.round((c + u + p * Math.pow(10, i)) * s) / s);
  for (; h < n; )
    o.push({
      value: h,
      major: jb(h),
      significand: p
    }), p >= 10 ? p = p < 15 ? 15 : 20 : p++, p >= 20 && (i++, p = 2, s = i >= 0 ? 1 : s), h = Math.round((c + u + p * Math.pow(10, i)) * s) / s;
  const g = Bo(e.max, h);
  return o.push({
    value: g,
    major: jb(g),
    significand: p
  }), o;
}
class s5 extends Va {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    const o = iu.prototype.parse.apply(this, [
      t,
      n
    ]);
    if (o === 0) {
      this._zero = !0;
      return;
    }
    return kn(o) && o > 0 ? o : null;
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = kn(t) ? Math.max(0, t) : null, this.max = kn(n) ? Math.max(0, n) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !kn(this._userMin) && (this.min = t === Hs(this.min, 0) ? Hs(this.min, -1) : Hs(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let o = this.min, r = this.max;
    const i = (a) => o = t ? o : a, s = (a) => r = n ? r : a;
    o === r && (o <= 0 ? (i(1), s(10)) : (i(Hs(o, -1)), s(Hs(r, 1)))), o <= 0 && i(Hs(r, -1)), r <= 0 && s(Hs(o, 1)), this.min = o, this.max = r;
  }
  buildTicks() {
    const t = this.options, n = {
      min: this._userMin,
      max: this._userMax
    }, o = Cte(n, this);
    return t.bounds === "ticks" && cS(o, this, "value"), t.reverse ? (o.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), o;
  }
  getLabelForValue(t) {
    return t === void 0 ? "0" : A0(t, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const t = this.min;
    super.configure(), this._startValue = Ji(t), this._valueRange = Ji(this.max) - Ji(t);
  }
  getPixelForValue(t) {
    return (t === void 0 || t === 0) && (t = this.min), t === null || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : (Ji(t) - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    const n = this.getDecimalForPixel(t);
    return Math.pow(10, this._startValue + n * this._valueRange);
  }
}
Ge(s5, "id", "logarithmic"), Ge(s5, "defaults", {
  ticks: {
    callback: N3.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function a5(e) {
  const t = e.ticks;
  if (t.display && e.display) {
    const n = no(t.backdropPadding);
    return yt(t.font && t.font.size, hn.font.size) + n.height;
  }
  return 0;
}
function xte(e, t, n) {
  return n = fn(n) ? n : [
    n
  ], {
    w: kX(e, t.string, n),
    h: n.length * t.lineHeight
  };
}
function Db(e, t, n, o, r) {
  return e === o || e === r ? {
    start: t - n / 2,
    end: t + n / 2
  } : e < o || e > r ? {
    start: t - n,
    end: t
  } : {
    start: t,
    end: t + n
  };
}
function yte(e) {
  const t = {
    l: e.left + e._padding.left,
    r: e.right - e._padding.right,
    t: e.top + e._padding.top,
    b: e.bottom - e._padding.bottom
  }, n = Object.assign({}, t), o = [], r = [], i = e._pointLabels.length, s = e.options.pointLabels, a = s.centerPointLabels ? mn / i : 0;
  for (let c = 0; c < i; c++) {
    const d = s.setContext(e.getPointLabelContext(c));
    r[c] = d.padding;
    const u = e.getPointPosition(c, e.drawingArea + r[c], a), p = Dn(d.font), h = xte(e.ctx, p, e._pointLabels[c]);
    o[c] = h;
    const g = Go(e.getIndexAngle(c) + a), m = Math.round(y7(g)), b = Db(m, u.x, h.w, 0, 180), C = Db(m, u.y, h.h, 90, 270);
    vte(n, t, g, b, C);
  }
  e.setCenterPoint(t.l - n.l, n.r - t.r, t.t - n.t, n.b - t.b), e._pointLabelItems = Mte(e, o, r);
}
function vte(e, t, n, o, r) {
  const i = Math.abs(Math.sin(n)), s = Math.abs(Math.cos(n));
  let a = 0, c = 0;
  o.start < t.l ? (a = (t.l - o.start) / i, e.l = Math.min(e.l, t.l - a)) : o.end > t.r && (a = (o.end - t.r) / i, e.r = Math.max(e.r, t.r + a)), r.start < t.t ? (c = (t.t - r.start) / s, e.t = Math.min(e.t, t.t - c)) : r.end > t.b && (c = (r.end - t.b) / s, e.b = Math.max(e.b, t.b + c));
}
function wte(e, t, n) {
  const o = e.drawingArea, { extra: r, additionalAngle: i, padding: s, size: a } = n, c = e.getPointPosition(t, o + r + s, i), d = Math.round(y7(Go(c.angle + On))), u = Ete(c.y, a.h, d), p = Tte(d), h = kte(c.x, a.w, p);
  return {
    visible: !0,
    x: c.x,
    y: u,
    textAlign: p,
    left: h,
    top: u,
    right: h + a.w,
    bottom: u + a.h
  };
}
function Ste(e, t) {
  if (!t)
    return !0;
  const { left: n, top: o, right: r, bottom: i } = e;
  return !(Ei({
    x: n,
    y: o
  }, t) || Ei({
    x: n,
    y: i
  }, t) || Ei({
    x: r,
    y: o
  }, t) || Ei({
    x: r,
    y: i
  }, t));
}
function Mte(e, t, n) {
  const o = [], r = e._pointLabels.length, i = e.options, { centerPointLabels: s, display: a } = i.pointLabels, c = {
    extra: a5(i) / 2,
    additionalAngle: s ? mn / r : 0
  };
  let d;
  for (let u = 0; u < r; u++) {
    c.padding = n[u], c.size = t[u];
    const p = wte(e, u, c);
    o.push(p), a === "auto" && (p.visible = Ste(p, d), p.visible && (d = p));
  }
  return o;
}
function Tte(e) {
  return e === 0 || e === 180 ? "center" : e < 180 ? "left" : "right";
}
function kte(e, t, n) {
  return n === "right" ? e -= t : n === "center" && (e -= t / 2), e;
}
function Ete(e, t, n) {
  return n === 90 || n === 270 ? e -= t / 2 : (n > 270 || n < 90) && (e -= t), e;
}
function Rte(e, t, n) {
  const { left: o, top: r, right: i, bottom: s } = n, { backdropColor: a } = t;
  if (!It(a)) {
    const c = aa(t.borderRadius), d = no(t.backdropPadding);
    e.fillStyle = a;
    const u = o - d.left, p = r - d.top, h = i - o + d.width, g = s - r + d.height;
    Object.values(c).some((m) => m !== 0) ? (e.beginPath(), Wc(e, {
      x: u,
      y: p,
      w: h,
      h: g,
      radius: c
    }), e.fill()) : e.fillRect(u, p, h, g);
  }
}
function Ote(e, t) {
  const { ctx: n, options: { pointLabels: o } } = e;
  for (let r = t - 1; r >= 0; r--) {
    const i = e._pointLabelItems[r];
    if (!i.visible)
      continue;
    const s = o.setContext(e.getPointLabelContext(r));
    Rte(n, s, i);
    const a = Dn(s.font), { x: c, y: d, textAlign: u } = i;
    ka(n, e._pointLabels[r], c, d + a.lineHeight / 2, a, {
      color: s.color,
      textAlign: u,
      textBaseline: "middle"
    });
  }
}
function QS(e, t, n, o) {
  const { ctx: r } = e;
  if (n)
    r.arc(e.xCenter, e.yCenter, t, 0, pn);
  else {
    let i = e.getPointPosition(0, t);
    r.moveTo(i.x, i.y);
    for (let s = 1; s < o; s++)
      i = e.getPointPosition(s, t), r.lineTo(i.x, i.y);
  }
}
function _te(e, t, n, o, r) {
  const i = e.ctx, s = t.circular, { color: a, lineWidth: c } = t;
  !s && !o || !a || !c || n < 0 || (i.save(), i.strokeStyle = a, i.lineWidth = c, i.setLineDash(r.dash || []), i.lineDashOffset = r.dashOffset, i.beginPath(), QS(e, n, s, o), i.closePath(), i.stroke(), i.restore());
}
function Pte(e, t, n) {
  return Rs(e, {
    label: n,
    index: t,
    type: "pointLabel"
  });
}
class q2 extends iu {
  constructor(t) {
    super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const t = this._padding = no(a5(this.options) / 2), n = this.width = this.maxWidth - t.width, o = this.height = this.maxHeight - t.height;
    this.xCenter = Math.floor(this.left + n / 2 + t.left), this.yCenter = Math.floor(this.top + o / 2 + t.top), this.drawingArea = Math.floor(Math.min(n, o) / 2);
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!1);
    this.min = kn(t) && !isNaN(t) ? t : 0, this.max = kn(n) && !isNaN(n) ? n : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / a5(this.options));
  }
  generateTickLabels(t) {
    iu.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((n, o) => {
      const r = rn(this.options.pointLabels.callback, [
        n,
        o
      ], this);
      return r || r === 0 ? r : "";
    }).filter((n, o) => this.chart.getDataVisibility(o));
  }
  fit() {
    const t = this.options;
    t.display && t.pointLabels.display ? yte(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(t, n, o, r) {
    this.xCenter += Math.floor((t - n) / 2), this.yCenter += Math.floor((o - r) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, n, o, r));
  }
  getIndexAngle(t) {
    const n = pn / (this._pointLabels.length || 1), o = this.options.startAngle || 0;
    return Go(t * n + Or(o));
  }
  getDistanceFromCenterForValue(t) {
    if (It(t))
      return NaN;
    const n = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - t) * n : (t - this.min) * n;
  }
  getValueForDistanceFromCenter(t) {
    if (It(t))
      return NaN;
    const n = t / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - n : this.min + n;
  }
  getPointLabelContext(t) {
    const n = this._pointLabels || [];
    if (t >= 0 && t < n.length) {
      const o = n[t];
      return Pte(this.getContext(), t, o);
    }
  }
  getPointPosition(t, n, o = 0) {
    const r = this.getIndexAngle(t) - On + o;
    return {
      x: Math.cos(r) * n + this.xCenter,
      y: Math.sin(r) * n + this.yCenter,
      angle: r
    };
  }
  getPointPositionForValue(t, n) {
    return this.getPointPosition(t, this.getDistanceFromCenterForValue(n));
  }
  getBasePosition(t) {
    return this.getPointPositionForValue(t || 0, this.getBaseValue());
  }
  getPointLabelPosition(t) {
    const { left: n, top: o, right: r, bottom: i } = this._pointLabelItems[t];
    return {
      left: n,
      top: o,
      right: r,
      bottom: i
    };
  }
  drawBackground() {
    const { backgroundColor: t, grid: { circular: n } } = this.options;
    if (t) {
      const o = this.ctx;
      o.save(), o.beginPath(), QS(this, this.getDistanceFromCenterForValue(this._endValue), n, this._pointLabels.length), o.closePath(), o.fillStyle = t, o.fill(), o.restore();
    }
  }
  drawGrid() {
    const t = this.ctx, n = this.options, { angleLines: o, grid: r, border: i } = n, s = this._pointLabels.length;
    let a, c, d;
    if (n.pointLabels.display && Ote(this, s), r.display && this.ticks.forEach((u, p) => {
      if (p !== 0 || p === 0 && this.min < 0) {
        c = this.getDistanceFromCenterForValue(u.value);
        const h = this.getContext(p), g = r.setContext(h), m = i.setContext(h);
        _te(this, g, c, s, m);
      }
    }), o.display) {
      for (t.save(), a = s - 1; a >= 0; a--) {
        const u = o.setContext(this.getPointLabelContext(a)), { color: p, lineWidth: h } = u;
        !h || !p || (t.lineWidth = h, t.strokeStyle = p, t.setLineDash(u.borderDash), t.lineDashOffset = u.borderDashOffset, c = this.getDistanceFromCenterForValue(n.reverse ? this.min : this.max), d = this.getPointPosition(a, c), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(d.x, d.y), t.stroke());
      }
      t.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const t = this.ctx, n = this.options, o = n.ticks;
    if (!o.display)
      return;
    const r = this.getIndexAngle(0);
    let i, s;
    t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(r), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((a, c) => {
      if (c === 0 && this.min >= 0 && !n.reverse)
        return;
      const d = o.setContext(this.getContext(c)), u = Dn(d.font);
      if (i = this.getDistanceFromCenterForValue(this.ticks[c].value), d.showLabelBackdrop) {
        t.font = u.string, s = t.measureText(a.label).width, t.fillStyle = d.backdropColor;
        const p = no(d.backdropPadding);
        t.fillRect(-s / 2 - p.left, -i - u.size / 2 - p.top, s + p.width, u.size + p.height);
      }
      ka(t, a.label, 0, -i, u, {
        color: d.color,
        strokeColor: d.textStrokeColor,
        strokeWidth: d.textStrokeWidth
      });
    }), t.restore();
  }
  drawTitle() {
  }
}
Ge(q2, "id", "radialLinear"), Ge(q2, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: N3.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(t) {
      return t;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), Ge(q2, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), Ge(q2, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const Z3 = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, Po = /* @__PURE__ */ Object.keys(Z3);
function Ab(e, t) {
  return e - t;
}
function Hb(e, t) {
  if (It(t))
    return null;
  const n = e._adapter, { parser: o, round: r, isoWeekday: i } = e._parseOpts;
  let s = t;
  return typeof o == "function" && (s = o(s)), kn(s) || (s = typeof o == "string" ? n.parse(s, o) : n.parse(s)), s === null ? null : (r && (s = r === "week" && (Hl(i) || i === !0) ? n.startOf(s, "isoWeek", i) : n.startOf(s, r)), +s);
}
function Fb(e, t, n, o) {
  const r = Po.length;
  for (let i = Po.indexOf(e); i < r - 1; ++i) {
    const s = Z3[Po[i]], a = s.steps ? s.steps : Number.MAX_SAFE_INTEGER;
    if (s.common && Math.ceil((n - t) / (a * s.size)) <= o)
      return Po[i];
  }
  return Po[r - 1];
}
function Lte(e, t, n, o, r) {
  for (let i = Po.length - 1; i >= Po.indexOf(n); i--) {
    const s = Po[i];
    if (Z3[s].common && e._adapter.diff(r, o, s) >= t - 1)
      return s;
  }
  return Po[n ? Po.indexOf(n) : 0];
}
function Ite(e) {
  for (let t = Po.indexOf(e) + 1, n = Po.length; t < n; ++t)
    if (Z3[Po[t]].common)
      return Po[t];
}
function Nb(e, t, n) {
  if (!n)
    e[t] = !0;
  else if (n.length) {
    const { lo: o, hi: r } = v7(n, t), i = n[o] >= t ? n[o] : n[r];
    e[i] = !0;
  }
}
function jte(e, t, n, o) {
  const r = e._adapter, i = +r.startOf(t[0].value, o), s = t[t.length - 1].value;
  let a, c;
  for (a = i; a <= s; a = +r.add(a, 1, o))
    c = n[a], c >= 0 && (t[c].major = !0);
  return t;
}
function $b(e, t, n) {
  const o = [], r = {}, i = t.length;
  let s, a;
  for (s = 0; s < i; ++s)
    a = t[s], r[a] = s, o.push({
      value: a,
      major: !1
    });
  return i === 0 || !n ? o : jte(e, o, r, n);
}
class qc extends Va {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, n = {}) {
    const o = t.time || (t.time = {}), r = this._adapter = new BJ._date(t.adapters.date);
    r.init(n), sc(o.displayFormats, r.formats()), this._parseOpts = {
      parser: o.parser,
      round: o.round,
      isoWeekday: o.isoWeekday
    }, super.init(t), this._normalized = n.normalized;
  }
  parse(t, n) {
    return t === void 0 ? null : Hb(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, n = this._adapter, o = t.time.unit || "day";
    let { min: r, max: i, minDefined: s, maxDefined: a } = this.getUserBounds();
    function c(d) {
      !s && !isNaN(d.min) && (r = Math.min(r, d.min)), !a && !isNaN(d.max) && (i = Math.max(i, d.max));
    }
    (!s || !a) && (c(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && c(this.getMinMax(!1))), r = kn(r) && !isNaN(r) ? r : +n.startOf(Date.now(), o), i = kn(i) && !isNaN(i) ? i : +n.endOf(Date.now(), o) + 1, this.min = Math.min(r, i - 1), this.max = Math.max(r + 1, i);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let n = Number.POSITIVE_INFINITY, o = Number.NEGATIVE_INFINITY;
    return t.length && (n = t[0], o = t[t.length - 1]), {
      min: n,
      max: o
    };
  }
  buildTicks() {
    const t = this.options, n = t.time, o = t.ticks, r = o.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && r.length && (this.min = this._userMin || r[0], this.max = this._userMax || r[r.length - 1]);
    const i = this.min, s = this.max, a = pX(r, i, s);
    return this._unit = n.unit || (o.autoSkip ? Fb(n.minUnit, this.min, this.max, this._getLabelCapacity(i)) : Lte(this, a.length, n.minUnit, this.min, this.max)), this._majorUnit = !o.major.enabled || this._unit === "year" ? void 0 : Ite(this._unit), this.initOffsets(r), t.reverse && a.reverse(), $b(this, a, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t = []) {
    let n = 0, o = 0, r, i;
    this.options.offset && t.length && (r = this.getDecimalForValue(t[0]), t.length === 1 ? n = 1 - r : n = (this.getDecimalForValue(t[1]) - r) / 2, i = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? o = i : o = (i - this.getDecimalForValue(t[t.length - 2])) / 2);
    const s = t.length < 3 ? 0.5 : 0.25;
    n = Wn(n, 0, s), o = Wn(o, 0, s), this._offsets = {
      start: n,
      end: o,
      factor: 1 / (n + 1 + o)
    };
  }
  _generate() {
    const t = this._adapter, n = this.min, o = this.max, r = this.options, i = r.time, s = i.unit || Fb(i.minUnit, n, o, this._getLabelCapacity(n)), a = yt(r.ticks.stepSize, 1), c = s === "week" ? i.isoWeekday : !1, d = Hl(c) || c === !0, u = {};
    let p = n, h, g;
    if (d && (p = +t.startOf(p, "isoWeek", c)), p = +t.startOf(p, d ? "day" : s), t.diff(o, n, s) > 1e5 * a)
      throw new Error(n + " and " + o + " are too far apart with stepSize of " + a + " " + s);
    const m = r.ticks.source === "data" && this.getDataTimestamps();
    for (h = p, g = 0; h < o; h = +t.add(h, a, s), g++)
      Nb(u, h, m);
    return (h === o || r.bounds === "ticks" || g === 1) && Nb(u, h, m), Object.keys(u).sort(Ab).map((b) => +b);
  }
  getLabelForValue(t) {
    const n = this._adapter, o = this.options.time;
    return o.tooltipFormat ? n.format(t, o.tooltipFormat) : n.format(t, o.displayFormats.datetime);
  }
  format(t, n) {
    const r = this.options.time.displayFormats, i = this._unit, s = n || r[i];
    return this._adapter.format(t, s);
  }
  _tickFormatFunction(t, n, o, r) {
    const i = this.options, s = i.ticks.callback;
    if (s)
      return rn(s, [
        t,
        n,
        o
      ], this);
    const a = i.time.displayFormats, c = this._unit, d = this._majorUnit, u = c && a[c], p = d && a[d], h = o[n], g = d && p && h && h.major;
    return this._adapter.format(t, r || (g ? p : u));
  }
  generateTickLabels(t) {
    let n, o, r;
    for (n = 0, o = t.length; n < o; ++n)
      r = t[n], r.label = this._tickFormatFunction(r.value, n, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const n = this._offsets, o = this.getDecimalForValue(t);
    return this.getPixelForDecimal((n.start + o) * n.factor);
  }
  getValueForPixel(t) {
    const n = this._offsets, o = this.getDecimalForPixel(t) / n.factor - n.end;
    return this.min + o * (this.max - this.min);
  }
  _getLabelSize(t) {
    const n = this.options.ticks, o = this.ctx.measureText(t).width, r = Or(this.isHorizontal() ? n.maxRotation : n.minRotation), i = Math.cos(r), s = Math.sin(r), a = this._resolveTickFontOptions(0).size;
    return {
      w: o * i + a * s,
      h: o * s + a * i
    };
  }
  _getLabelCapacity(t) {
    const n = this.options.time, o = n.displayFormats, r = o[n.unit] || o.millisecond, i = this._tickFormatFunction(t, 0, $b(this, [
      t
    ], this._majorUnit), r), s = this._getLabelSize(i), a = Math.floor(this.isHorizontal() ? this.width / s.w : this.height / s.h) - 1;
    return a > 0 ? a : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], n, o;
    if (t.length)
      return t;
    const r = this.getMatchingVisibleMetas();
    if (this._normalized && r.length)
      return this._cache.data = r[0].controller.getAllParsedValues(this);
    for (n = 0, o = r.length; n < o; ++n)
      t = t.concat(r[n].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let n, o;
    if (t.length)
      return t;
    const r = this.getLabels();
    for (n = 0, o = r.length; n < o; ++n)
      t.push(Hb(this, r[n]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return fS(t.sort(Ab));
  }
}
Ge(qc, "id", "time"), Ge(qc, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function R1(e, t, n) {
  let o = 0, r = e.length - 1, i, s, a, c;
  n ? (t >= e[o].pos && t <= e[r].pos && ({ lo: o, hi: r } = ki(e, "pos", t)), { pos: i, time: a } = e[o], { pos: s, time: c } = e[r]) : (t >= e[o].time && t <= e[r].time && ({ lo: o, hi: r } = ki(e, "time", t)), { time: i, pos: a } = e[o], { time: s, pos: c } = e[r]);
  const d = s - i;
  return d ? a + (c - a) * (t - i) / d : a;
}
class l5 extends qc {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), n = this._table = this.buildLookupTable(t);
    this._minPos = R1(n, this.min), this._tableRange = R1(n, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: n, max: o } = this, r = [], i = [];
    let s, a, c, d, u;
    for (s = 0, a = t.length; s < a; ++s)
      d = t[s], d >= n && d <= o && r.push(d);
    if (r.length < 2)
      return [
        {
          time: n,
          pos: 0
        },
        {
          time: o,
          pos: 1
        }
      ];
    for (s = 0, a = r.length; s < a; ++s)
      u = r[s + 1], c = r[s - 1], d = r[s], Math.round((u + c) / 2) !== d && i.push({
        time: d,
        pos: s / (a - 1)
      });
    return i;
  }
  _generate() {
    const t = this.min, n = this.max;
    let o = super.getDataTimestamps();
    return (!o.includes(t) || !o.length) && o.splice(0, 0, t), (!o.includes(n) || o.length === 1) && o.push(n), o.sort((r, i) => r - i);
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const n = this.getDataTimestamps(), o = this.getLabelTimestamps();
    return n.length && o.length ? t = this.normalize(n.concat(o)) : t = n.length ? n : o, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (R1(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const n = this._offsets, o = this.getDecimalForPixel(t) / n.factor - n.end;
    return R1(this._table, o * this._tableRange + this._minPos, !0);
  }
}
Ge(l5, "id", "timeseries"), Ge(l5, "defaults", qc.defaults);
var Vte = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  CategoryScale: r5,
  LinearScale: i5,
  LogarithmicScale: s5,
  RadialLinearScale: q2,
  TimeScale: qc,
  TimeSeriesScale: l5
});
const Dte = [
  $J,
  bee,
  fte,
  Vte
], eM = "label";
function Bb(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function Ate(e, t) {
  const n = e.options;
  n && t && Object.assign(n, t);
}
function tM(e, t) {
  e.labels = t;
}
function nM(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : eM;
  const o = [];
  e.datasets = t.map((r) => {
    const i = e.datasets.find((s) => s[n] === r[n]);
    return !i || !r.data || o.includes(i) ? {
      ...r
    } : (o.push(i), Object.assign(i, r), i);
  });
}
function Hte(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : eM;
  const n = {
    labels: [],
    datasets: []
  };
  return tM(n, e.labels), nM(n, e.datasets, t), n;
}
function Fte(e, t) {
  return e.getElementsAtEventForMode(t.nativeEvent, "nearest", {
    intersect: !0
  }, !1);
}
function Nte(e, t) {
  const { height: n = 150, width: o = 300, redraw: r = !1, datasetIdKey: i, type: s, data: a, options: c, plugins: d = [], fallbackContent: u, updateMode: p, ...h } = e, g = St(null), m = St(null), b = () => {
    g.current && (m.current = new F0(g.current, {
      type: s,
      data: Hte(a, i),
      options: c && {
        ...c
      },
      plugins: d
    }), Bb(t, m.current));
  }, C = () => {
    Bb(t, null), m.current && (m.current.destroy(), m.current = null);
  };
  return mt(() => {
    !r && m.current && c && Ate(m.current, c);
  }, [
    r,
    c
  ]), mt(() => {
    !r && m.current && tM(m.current.config.data, a.labels);
  }, [
    r,
    a.labels
  ]), mt(() => {
    !r && m.current && a.datasets && nM(m.current.config.data, a.datasets, i);
  }, [
    r,
    a.datasets
  ]), mt(() => {
    m.current && (r ? (C(), setTimeout(b)) : m.current.update(p));
  }, [
    r,
    c,
    a.labels,
    a.datasets,
    p
  ]), mt(() => {
    m.current && (C(), setTimeout(b));
  }, [
    s
  ]), mt(() => (b(), () => C()), []), /* @__PURE__ */ Nt.createElement("canvas", {
    ref: g,
    role: "img",
    height: n,
    width: o,
    ...h
  }, u);
}
const W3 = /* @__PURE__ */ vs(Nte);
function oM(e, t) {
  return F0.register(t), /* @__PURE__ */ vs((n, o) => /* @__PURE__ */ Nt.createElement(W3, {
    ...n,
    ref: o,
    type: e
  }));
}
const $te = /* @__PURE__ */ oM("doughnut", Qi), Bte = /* @__PURE__ */ oM("scatter", uc), vl = (e, t = 0, n = 1) => j7(V7(t, e), n), I7 = (e) => {
  e._clipped = !1, e._unclipped = e.slice(0);
  for (let t = 0; t <= 3; t++)
    t < 3 ? ((e[t] < 0 || e[t] > 255) && (e._clipped = !0), e[t] = vl(e[t], 0, 255)) : t === 3 && (e[t] = vl(e[t], 0, 1));
  return e;
}, rM = {};
for (let e of [
  "Boolean",
  "Number",
  "String",
  "Function",
  "Array",
  "Date",
  "RegExp",
  "Undefined",
  "Null"
])
  rM[`[object ${e}]`] = e.toLowerCase();
function Lt(e) {
  return rM[Object.prototype.toString.call(e)] || "object";
}
const Vt = (e, t = null) => e.length >= 3 ? Array.prototype.slice.call(e) : Lt(e[0]) == "object" && t ? t.split("").filter((n) => e[0][n] !== void 0).map((n) => e[0][n]) : e[0], U3 = (e) => {
  if (e.length < 2) return null;
  const t = e.length - 1;
  return Lt(e[t]) == "string" ? e[t].toLowerCase() : null;
}, { PI: G3, min: j7, max: V7 } = Math, wi = G3 * 2, a6 = G3 / 3, zte = G3 / 180, Zte = 180 / G3, vt = {
  format: {},
  autodetect: []
};
let Ze = class {
  constructor(...t) {
    const n = this;
    if (Lt(t[0]) === "object" && t[0].constructor && t[0].constructor === this.constructor)
      return t[0];
    let o = U3(t), r = !1;
    if (!o) {
      r = !0, vt.sorted || (vt.autodetect = vt.autodetect.sort((i, s) => s.p - i.p), vt.sorted = !0);
      for (let i of vt.autodetect)
        if (o = i.test(...t), o) break;
    }
    if (vt.format[o]) {
      const i = vt.format[o].apply(
        null,
        r ? t : t.slice(0, -1)
      );
      n._rgb = I7(i);
    } else
      throw new Error("unknown format: " + t);
    n._rgb.length === 3 && n._rgb.push(1);
  }
  toString() {
    return Lt(this.hex) == "function" ? this.hex() : `[${this._rgb.join(",")}]`;
  }
};
const Wte = "2.6.0", wt = (...e) => new wt.Color(...e);
wt.Color = Ze;
wt.version = Wte;
const Ute = (...e) => {
  e = Vt(e, "cmyk");
  const [t, n, o, r] = e, i = e.length > 4 ? e[4] : 1;
  return r === 1 ? [0, 0, 0, i] : [
    t >= 1 ? 0 : 255 * (1 - t) * (1 - r),
    // r
    n >= 1 ? 0 : 255 * (1 - n) * (1 - r),
    // g
    o >= 1 ? 0 : 255 * (1 - o) * (1 - r),
    // b
    i
  ];
}, { max: zb } = Math, Gte = (...e) => {
  let [t, n, o] = Vt(e, "rgb");
  t = t / 255, n = n / 255, o = o / 255;
  const r = 1 - zb(t, zb(n, o)), i = r < 1 ? 1 / (1 - r) : 0, s = (1 - t - r) * i, a = (1 - n - r) * i, c = (1 - o - r) * i;
  return [s, a, c, r];
};
Ze.prototype.cmyk = function() {
  return Gte(this._rgb);
};
wt.cmyk = (...e) => new Ze(...e, "cmyk");
vt.format.cmyk = Ute;
vt.autodetect.push({
  p: 2,
  test: (...e) => {
    if (e = Vt(e, "cmyk"), Lt(e) === "array" && e.length === 4)
      return "cmyk";
  }
});
const l6 = (e) => Math.round(e * 100) / 100, qte = (...e) => {
  const t = Vt(e, "hsla");
  let n = U3(e) || "lsa";
  return t[0] = l6(t[0] || 0), t[1] = l6(t[1] * 100) + "%", t[2] = l6(t[2] * 100) + "%", n === "hsla" || t.length > 3 && t[3] < 1 ? (t[3] = t.length > 3 ? t[3] : 1, n = "hsla") : t.length = 3, `${n}(${t.join(",")})`;
}, iM = (...e) => {
  e = Vt(e, "rgba");
  let [t, n, o] = e;
  t /= 255, n /= 255, o /= 255;
  const r = j7(t, n, o), i = V7(t, n, o), s = (i + r) / 2;
  let a, c;
  return i === r ? (a = 0, c = Number.NaN) : a = s < 0.5 ? (i - r) / (i + r) : (i - r) / (2 - i - r), t == i ? c = (n - o) / (i - r) : n == i ? c = 2 + (o - t) / (i - r) : o == i && (c = 4 + (t - n) / (i - r)), c *= 60, c < 0 && (c += 360), e.length > 3 && e[3] !== void 0 ? [c, a, s, e[3]] : [c, a, s];
}, { round: c6 } = Math, Kte = (...e) => {
  const t = Vt(e, "rgba");
  let n = U3(e) || "rgb";
  return n.substr(0, 3) == "hsl" ? qte(iM(t), n) : (t[0] = c6(t[0]), t[1] = c6(t[1]), t[2] = c6(t[2]), (n === "rgba" || t.length > 3 && t[3] < 1) && (t[3] = t.length > 3 ? t[3] : 1, n = "rgba"), `${n}(${t.slice(0, n === "rgb" ? 3 : 4).join(",")})`);
}, { round: d6 } = Math, c5 = (...e) => {
  e = Vt(e, "hsl");
  const [t, n, o] = e;
  let r, i, s;
  if (n === 0)
    r = i = s = o * 255;
  else {
    const a = [0, 0, 0], c = [0, 0, 0], d = o < 0.5 ? o * (1 + n) : o + n - o * n, u = 2 * o - d, p = t / 360;
    a[0] = p + 1 / 3, a[1] = p, a[2] = p - 1 / 3;
    for (let h = 0; h < 3; h++)
      a[h] < 0 && (a[h] += 1), a[h] > 1 && (a[h] -= 1), 6 * a[h] < 1 ? c[h] = u + (d - u) * 6 * a[h] : 2 * a[h] < 1 ? c[h] = d : 3 * a[h] < 2 ? c[h] = u + (d - u) * (2 / 3 - a[h]) * 6 : c[h] = u;
    [r, i, s] = [d6(c[0] * 255), d6(c[1] * 255), d6(c[2] * 255)];
  }
  return e.length > 3 ? [r, i, s, e[3]] : [r, i, s, 1];
}, sM = /^rgb\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*\)$/, aM = /^rgba\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*,\s*([01]|[01]?\.\d+)\)$/, lM = /^rgb\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/, cM = /^rgba\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/, dM = /^hsl\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/, uM = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/, { round: Zb } = Math, D7 = (e) => {
  e = e.toLowerCase().trim();
  let t;
  if (vt.format.named)
    try {
      return vt.format.named(e);
    } catch {
    }
  if (t = e.match(sM)) {
    const n = t.slice(1, 4);
    for (let o = 0; o < 3; o++)
      n[o] = +n[o];
    return n[3] = 1, n;
  }
  if (t = e.match(aM)) {
    const n = t.slice(1, 5);
    for (let o = 0; o < 4; o++)
      n[o] = +n[o];
    return n;
  }
  if (t = e.match(lM)) {
    const n = t.slice(1, 4);
    for (let o = 0; o < 3; o++)
      n[o] = Zb(n[o] * 2.55);
    return n[3] = 1, n;
  }
  if (t = e.match(cM)) {
    const n = t.slice(1, 5);
    for (let o = 0; o < 3; o++)
      n[o] = Zb(n[o] * 2.55);
    return n[3] = +n[3], n;
  }
  if (t = e.match(dM)) {
    const n = t.slice(1, 4);
    n[1] *= 0.01, n[2] *= 0.01;
    const o = c5(n);
    return o[3] = 1, o;
  }
  if (t = e.match(uM)) {
    const n = t.slice(1, 4);
    n[1] *= 0.01, n[2] *= 0.01;
    const o = c5(n);
    return o[3] = +t[4], o;
  }
};
D7.test = (e) => sM.test(e) || aM.test(e) || lM.test(e) || cM.test(e) || dM.test(e) || uM.test(e);
Ze.prototype.css = function(e) {
  return Kte(this._rgb, e);
};
wt.css = (...e) => new Ze(...e, "css");
vt.format.css = D7;
vt.autodetect.push({
  p: 5,
  test: (e, ...t) => {
    if (!t.length && Lt(e) === "string" && D7.test(e))
      return "css";
  }
});
vt.format.gl = (...e) => {
  const t = Vt(e, "rgba");
  return t[0] *= 255, t[1] *= 255, t[2] *= 255, t;
};
wt.gl = (...e) => new Ze(...e, "gl");
Ze.prototype.gl = function() {
  const e = this._rgb;
  return [e[0] / 255, e[1] / 255, e[2] / 255, e[3]];
};
const { floor: Yte } = Math, Xte = (...e) => {
  e = Vt(e, "hcg");
  let [t, n, o] = e, r, i, s;
  o = o * 255;
  const a = n * 255;
  if (n === 0)
    r = i = s = o;
  else {
    t === 360 && (t = 0), t > 360 && (t -= 360), t < 0 && (t += 360), t /= 60;
    const c = Yte(t), d = t - c, u = o * (1 - n), p = u + a * (1 - d), h = u + a * d, g = u + a;
    switch (c) {
      case 0:
        [r, i, s] = [g, h, u];
        break;
      case 1:
        [r, i, s] = [p, g, u];
        break;
      case 2:
        [r, i, s] = [u, g, h];
        break;
      case 3:
        [r, i, s] = [u, p, g];
        break;
      case 4:
        [r, i, s] = [h, u, g];
        break;
      case 5:
        [r, i, s] = [g, u, p];
        break;
    }
  }
  return [r, i, s, e.length > 3 ? e[3] : 1];
}, Jte = (...e) => {
  const [t, n, o] = Vt(e, "rgb"), r = j7(t, n, o), i = V7(t, n, o), s = i - r, a = s * 100 / 255, c = r / (255 - s) * 100;
  let d;
  return s === 0 ? d = Number.NaN : (t === i && (d = (n - o) / s), n === i && (d = 2 + (o - t) / s), o === i && (d = 4 + (t - n) / s), d *= 60, d < 0 && (d += 360)), [d, a, c];
};
Ze.prototype.hcg = function() {
  return Jte(this._rgb);
};
wt.hcg = (...e) => new Ze(...e, "hcg");
vt.format.hcg = Xte;
vt.autodetect.push({
  p: 1,
  test: (...e) => {
    if (e = Vt(e, "hcg"), Lt(e) === "array" && e.length === 3)
      return "hcg";
  }
});
const Qte = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, ene = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/, fM = (e) => {
  if (e.match(Qte)) {
    (e.length === 4 || e.length === 7) && (e = e.substr(1)), e.length === 3 && (e = e.split(""), e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]);
    const t = parseInt(e, 16), n = t >> 16, o = t >> 8 & 255, r = t & 255;
    return [n, o, r, 1];
  }
  if (e.match(ene)) {
    (e.length === 5 || e.length === 9) && (e = e.substr(1)), e.length === 4 && (e = e.split(""), e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2] + e[3] + e[3]);
    const t = parseInt(e, 16), n = t >> 24 & 255, o = t >> 16 & 255, r = t >> 8 & 255, i = Math.round((t & 255) / 255 * 100) / 100;
    return [n, o, r, i];
  }
  throw new Error(`unknown hex color: ${e}`);
}, { round: O1 } = Math, pM = (...e) => {
  let [t, n, o, r] = Vt(e, "rgba"), i = U3(e) || "auto";
  r === void 0 && (r = 1), i === "auto" && (i = r < 1 ? "rgba" : "rgb"), t = O1(t), n = O1(n), o = O1(o);
  let a = "000000" + (t << 16 | n << 8 | o).toString(16);
  a = a.substr(a.length - 6);
  let c = "0" + O1(r * 255).toString(16);
  switch (c = c.substr(c.length - 2), i.toLowerCase()) {
    case "rgba":
      return `#${a}${c}`;
    case "argb":
      return `#${c}${a}`;
    default:
      return `#${a}`;
  }
};
Ze.prototype.hex = function(e) {
  return pM(this._rgb, e);
};
wt.hex = (...e) => new Ze(...e, "hex");
vt.format.hex = fM;
vt.autodetect.push({
  p: 4,
  test: (e, ...t) => {
    if (!t.length && Lt(e) === "string" && [3, 4, 5, 6, 7, 8, 9].indexOf(e.length) >= 0)
      return "hex";
  }
});
const { cos: Ja } = Math, tne = (...e) => {
  e = Vt(e, "hsi");
  let [t, n, o] = e, r, i, s;
  return isNaN(t) && (t = 0), isNaN(n) && (n = 0), t > 360 && (t -= 360), t < 0 && (t += 360), t /= 360, t < 1 / 3 ? (s = (1 - n) / 3, r = (1 + n * Ja(wi * t) / Ja(a6 - wi * t)) / 3, i = 1 - (s + r)) : t < 2 / 3 ? (t -= 1 / 3, r = (1 - n) / 3, i = (1 + n * Ja(wi * t) / Ja(a6 - wi * t)) / 3, s = 1 - (r + i)) : (t -= 2 / 3, i = (1 - n) / 3, s = (1 + n * Ja(wi * t) / Ja(a6 - wi * t)) / 3, r = 1 - (i + s)), r = vl(o * r * 3), i = vl(o * i * 3), s = vl(o * s * 3), [r * 255, i * 255, s * 255, e.length > 3 ? e[3] : 1];
}, { min: nne, sqrt: one, acos: rne } = Math, ine = (...e) => {
  let [t, n, o] = Vt(e, "rgb");
  t /= 255, n /= 255, o /= 255;
  let r;
  const i = nne(t, n, o), s = (t + n + o) / 3, a = s > 0 ? 1 - i / s : 0;
  return a === 0 ? r = NaN : (r = (t - n + (t - o)) / 2, r /= one((t - n) * (t - n) + (t - o) * (n - o)), r = rne(r), o > n && (r = wi - r), r /= wi), [r * 360, a, s];
};
Ze.prototype.hsi = function() {
  return ine(this._rgb);
};
wt.hsi = (...e) => new Ze(...e, "hsi");
vt.format.hsi = tne;
vt.autodetect.push({
  p: 2,
  test: (...e) => {
    if (e = Vt(e, "hsi"), Lt(e) === "array" && e.length === 3)
      return "hsi";
  }
});
Ze.prototype.hsl = function() {
  return iM(this._rgb);
};
wt.hsl = (...e) => new Ze(...e, "hsl");
vt.format.hsl = c5;
vt.autodetect.push({
  p: 2,
  test: (...e) => {
    if (e = Vt(e, "hsl"), Lt(e) === "array" && e.length === 3)
      return "hsl";
  }
});
const { floor: sne } = Math, ane = (...e) => {
  e = Vt(e, "hsv");
  let [t, n, o] = e, r, i, s;
  if (o *= 255, n === 0)
    r = i = s = o;
  else {
    t === 360 && (t = 0), t > 360 && (t -= 360), t < 0 && (t += 360), t /= 60;
    const a = sne(t), c = t - a, d = o * (1 - n), u = o * (1 - n * c), p = o * (1 - n * (1 - c));
    switch (a) {
      case 0:
        [r, i, s] = [o, p, d];
        break;
      case 1:
        [r, i, s] = [u, o, d];
        break;
      case 2:
        [r, i, s] = [d, o, p];
        break;
      case 3:
        [r, i, s] = [d, u, o];
        break;
      case 4:
        [r, i, s] = [p, d, o];
        break;
      case 5:
        [r, i, s] = [o, d, u];
        break;
    }
  }
  return [r, i, s, e.length > 3 ? e[3] : 1];
}, { min: lne, max: cne } = Math, dne = (...e) => {
  e = Vt(e, "rgb");
  let [t, n, o] = e;
  const r = lne(t, n, o), i = cne(t, n, o), s = i - r;
  let a, c, d;
  return d = i / 255, i === 0 ? (a = Number.NaN, c = 0) : (c = s / i, t === i && (a = (n - o) / s), n === i && (a = 2 + (o - t) / s), o === i && (a = 4 + (t - n) / s), a *= 60, a < 0 && (a += 360)), [a, c, d];
};
Ze.prototype.hsv = function() {
  return dne(this._rgb);
};
wt.hsv = (...e) => new Ze(...e, "hsv");
vt.format.hsv = ane;
vt.autodetect.push({
  p: 2,
  test: (...e) => {
    if (e = Vt(e, "hsv"), Lt(e) === "array" && e.length === 3)
      return "hsv";
  }
});
const Do = {
  // Corresponds roughly to RGB brighter/darker
  Kn: 18,
  // D65 standard referent
  Xn: 0.95047,
  Yn: 1,
  Zn: 1.08883,
  t0: 0.137931034,
  // 4 / 29
  t1: 0.206896552,
  // 6 / 29
  t2: 0.12841855,
  // 3 * t1 * t1
  t3: 8856452e-9
  // t1 * t1 * t1
}, { pow: une } = Math, hM = (...e) => {
  e = Vt(e, "lab");
  const [t, n, o] = e;
  let r, i, s, a, c, d;
  return i = (t + 16) / 116, r = isNaN(n) ? i : i + n / 500, s = isNaN(o) ? i : i - o / 200, i = Do.Yn * f6(i), r = Do.Xn * f6(r), s = Do.Zn * f6(s), a = u6(3.2404542 * r - 1.5371385 * i - 0.4985314 * s), c = u6(-0.969266 * r + 1.8760108 * i + 0.041556 * s), d = u6(0.0556434 * r - 0.2040259 * i + 1.0572252 * s), [a, c, d, e.length > 3 ? e[3] : 1];
}, u6 = (e) => 255 * (e <= 304e-5 ? 12.92 * e : 1.055 * une(e, 1 / 2.4) - 0.055), f6 = (e) => e > Do.t1 ? e * e * e : Do.t2 * (e - Do.t0), { pow: gM } = Math, mM = (...e) => {
  const [t, n, o] = Vt(e, "rgb"), [r, i, s] = fne(t, n, o), a = 116 * i - 16;
  return [a < 0 ? 0 : a, 500 * (r - i), 200 * (i - s)];
}, p6 = (e) => (e /= 255) <= 0.04045 ? e / 12.92 : gM((e + 0.055) / 1.055, 2.4), h6 = (e) => e > Do.t3 ? gM(e, 1 / 3) : e / Do.t2 + Do.t0, fne = (e, t, n) => {
  e = p6(e), t = p6(t), n = p6(n);
  const o = h6(
    (0.4124564 * e + 0.3575761 * t + 0.1804375 * n) / Do.Xn
  ), r = h6(
    (0.2126729 * e + 0.7151522 * t + 0.072175 * n) / Do.Yn
  ), i = h6(
    (0.0193339 * e + 0.119192 * t + 0.9503041 * n) / Do.Zn
  );
  return [o, r, i];
};
Ze.prototype.lab = function() {
  return mM(this._rgb);
};
wt.lab = (...e) => new Ze(...e, "lab");
vt.format.lab = hM;
vt.autodetect.push({
  p: 2,
  test: (...e) => {
    if (e = Vt(e, "lab"), Lt(e) === "array" && e.length === 3)
      return "lab";
  }
});
const { sin: pne, cos: hne } = Math, bM = (...e) => {
  let [t, n, o] = Vt(e, "lch");
  return isNaN(o) && (o = 0), o = o * zte, [t, hne(o) * n, pne(o) * n];
}, CM = (...e) => {
  e = Vt(e, "lch");
  const [t, n, o] = e, [r, i, s] = bM(t, n, o), [a, c, d] = hM(r, i, s);
  return [a, c, d, e.length > 3 ? e[3] : 1];
}, gne = (...e) => {
  const t = Vt(e, "hcl").reverse();
  return CM(...t);
}, { sqrt: mne, atan2: bne, round: Cne } = Math, xM = (...e) => {
  const [t, n, o] = Vt(e, "lab"), r = mne(n * n + o * o);
  let i = (bne(o, n) * Zte + 360) % 360;
  return Cne(r * 1e4) === 0 && (i = Number.NaN), [t, r, i];
}, yM = (...e) => {
  const [t, n, o] = Vt(e, "rgb"), [r, i, s] = mM(t, n, o);
  return xM(r, i, s);
};
Ze.prototype.lch = function() {
  return yM(this._rgb);
};
Ze.prototype.hcl = function() {
  return yM(this._rgb).reverse();
};
wt.lch = (...e) => new Ze(...e, "lch");
wt.hcl = (...e) => new Ze(...e, "hcl");
vt.format.lch = CM;
vt.format.hcl = gne;
["lch", "hcl"].forEach(
  (e) => vt.autodetect.push({
    p: 2,
    test: (...t) => {
      if (t = Vt(t, e), Lt(t) === "array" && t.length === 3)
        return e;
    }
  })
);
const $l = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  gold: "#ffd700",
  goldenrod: "#daa520",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  laserlemon: "#ffff54",
  lavender: "#e6e6fa",
  lavenderblush: "#fff0f5",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrod: "#fafad2",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  maroon2: "#7f0000",
  maroon3: "#b03060",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  purple2: "#7f007f",
  purple3: "#a020f0",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
Ze.prototype.name = function() {
  const e = pM(this._rgb, "rgb");
  for (let t of Object.keys($l))
    if ($l[t] === e) return t.toLowerCase();
  return e;
};
vt.format.named = (e) => {
  if (e = e.toLowerCase(), $l[e]) return fM($l[e]);
  throw new Error("unknown color name: " + e);
};
vt.autodetect.push({
  p: 5,
  test: (e, ...t) => {
    if (!t.length && Lt(e) === "string" && $l[e.toLowerCase()])
      return "named";
  }
});
const xne = (e) => {
  if (Lt(e) == "number" && e >= 0 && e <= 16777215) {
    const t = e >> 16, n = e >> 8 & 255, o = e & 255;
    return [t, n, o, 1];
  }
  throw new Error("unknown num color: " + e);
}, yne = (...e) => {
  const [t, n, o] = Vt(e, "rgb");
  return (t << 16) + (n << 8) + o;
};
Ze.prototype.num = function() {
  return yne(this._rgb);
};
wt.num = (...e) => new Ze(...e, "num");
vt.format.num = xne;
vt.autodetect.push({
  p: 5,
  test: (...e) => {
    if (e.length === 1 && Lt(e[0]) === "number" && e[0] >= 0 && e[0] <= 16777215)
      return "num";
  }
});
const { round: vM } = Math;
Ze.prototype.rgb = function(e = !0) {
  return e === !1 ? this._rgb.slice(0, 3) : this._rgb.slice(0, 3).map(vM);
};
Ze.prototype.rgba = function(e = !0) {
  return this._rgb.slice(0, 4).map((t, n) => n < 3 ? e === !1 ? t : vM(t) : t);
};
wt.rgb = (...e) => new Ze(...e, "rgb");
vt.format.rgb = (...e) => {
  const t = Vt(e, "rgba");
  return t[3] === void 0 && (t[3] = 1), t;
};
vt.autodetect.push({
  p: 3,
  test: (...e) => {
    if (e = Vt(e, "rgba"), Lt(e) === "array" && (e.length === 3 || e.length === 4 && Lt(e[3]) == "number" && e[3] >= 0 && e[3] <= 1))
      return "rgb";
  }
});
const { log: _1 } = Math, wM = (e) => {
  const t = e / 100;
  let n, o, r;
  return t < 66 ? (n = 255, o = t < 6 ? 0 : -155.25485562709179 - 0.44596950469579133 * (o = t - 2) + 104.49216199393888 * _1(o), r = t < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (r = t - 10) + 115.67994401066147 * _1(r)) : (n = 351.97690566805693 + 0.114206453784165 * (n = t - 55) - 40.25366309332127 * _1(n), o = 325.4494125711974 + 0.07943456536662342 * (o = t - 50) - 28.0852963507957 * _1(o), r = 255), [n, o, r, 1];
}, { round: vne } = Math, wne = (...e) => {
  const t = Vt(e, "rgb"), n = t[0], o = t[2];
  let r = 1e3, i = 4e4;
  const s = 0.4;
  let a;
  for (; i - r > s; ) {
    a = (i + r) * 0.5;
    const c = wM(a);
    c[2] / c[0] >= o / n ? i = a : r = a;
  }
  return vne(a);
};
Ze.prototype.temp = Ze.prototype.kelvin = Ze.prototype.temperature = function() {
  return wne(this._rgb);
};
wt.temp = wt.kelvin = wt.temperature = (...e) => new Ze(...e, "temp");
vt.format.temp = vt.format.kelvin = vt.format.temperature = wM;
const { pow: Td, sign: Sne } = Math, SM = (...e) => {
  e = Vt(e, "lab");
  const [t, n, o] = e, r = Td(t + 0.3963377774 * n + 0.2158037573 * o, 3), i = Td(t - 0.1055613458 * n - 0.0638541728 * o, 3), s = Td(t - 0.0894841775 * n - 1.291485548 * o, 3);
  return [
    255 * g6(4.0767416621 * r - 3.3077115913 * i + 0.2309699292 * s),
    255 * g6(-1.2684380046 * r + 2.6097574011 * i - 0.3413193965 * s),
    255 * g6(-0.0041960863 * r - 0.7034186147 * i + 1.707614701 * s),
    e.length > 3 ? e[3] : 1
  ];
};
function g6(e) {
  const t = Math.abs(e);
  return t > 31308e-7 ? (Sne(e) || 1) * (1.055 * Td(t, 1 / 2.4) - 0.055) : e * 12.92;
}
const { cbrt: m6, pow: Mne, sign: Tne } = Math, MM = (...e) => {
  const [t, n, o] = Vt(e, "rgb"), [r, i, s] = [
    b6(t / 255),
    b6(n / 255),
    b6(o / 255)
  ], a = m6(0.4122214708 * r + 0.5363325363 * i + 0.0514459929 * s), c = m6(0.2119034982 * r + 0.6806995451 * i + 0.1073969566 * s), d = m6(0.0883024619 * r + 0.2817188376 * i + 0.6299787005 * s);
  return [
    0.2104542553 * a + 0.793617785 * c - 0.0040720468 * d,
    1.9779984951 * a - 2.428592205 * c + 0.4505937099 * d,
    0.0259040371 * a + 0.7827717662 * c - 0.808675766 * d
  ];
};
function b6(e) {
  const t = Math.abs(e);
  return t < 0.04045 ? e / 12.92 : (Tne(e) || 1) * Mne((t + 0.055) / 1.055, 2.4);
}
Ze.prototype.oklab = function() {
  return MM(this._rgb);
};
wt.oklab = (...e) => new Ze(...e, "oklab");
vt.format.oklab = SM;
vt.autodetect.push({
  p: 3,
  test: (...e) => {
    if (e = Vt(e, "oklab"), Lt(e) === "array" && e.length === 3)
      return "oklab";
  }
});
const kne = (...e) => {
  e = Vt(e, "lch");
  const [t, n, o] = e, [r, i, s] = bM(t, n, o), [a, c, d] = SM(r, i, s);
  return [a, c, d, e.length > 3 ? e[3] : 1];
}, Ene = (...e) => {
  const [t, n, o] = Vt(e, "rgb"), [r, i, s] = MM(t, n, o);
  return xM(r, i, s);
};
Ze.prototype.oklch = function() {
  return Ene(this._rgb);
};
wt.oklch = (...e) => new Ze(...e, "oklch");
vt.format.oklch = kne;
vt.autodetect.push({
  p: 3,
  test: (...e) => {
    if (e = Vt(e, "oklch"), Lt(e) === "array" && e.length === 3)
      return "oklch";
  }
});
Ze.prototype.alpha = function(e, t = !1) {
  return e !== void 0 && Lt(e) === "number" ? t ? (this._rgb[3] = e, this) : new Ze([this._rgb[0], this._rgb[1], this._rgb[2], e], "rgb") : this._rgb[3];
};
Ze.prototype.clipped = function() {
  return this._rgb._clipped || !1;
};
Ze.prototype.darken = function(e = 1) {
  const t = this, n = t.lab();
  return n[0] -= Do.Kn * e, new Ze(n, "lab").alpha(t.alpha(), !0);
};
Ze.prototype.brighten = function(e = 1) {
  return this.darken(-e);
};
Ze.prototype.darker = Ze.prototype.darken;
Ze.prototype.brighter = Ze.prototype.brighten;
Ze.prototype.get = function(e) {
  const [t, n] = e.split("."), o = this[t]();
  if (n) {
    const r = t.indexOf(n) - (t.substr(0, 2) === "ok" ? 2 : 0);
    if (r > -1) return o[r];
    throw new Error(`unknown channel ${n} in mode ${t}`);
  } else
    return o;
};
const { pow: Rne } = Math, One = 1e-7, _ne = 20;
Ze.prototype.luminance = function(e, t = "rgb") {
  if (e !== void 0 && Lt(e) === "number") {
    if (e === 0)
      return new Ze([0, 0, 0, this._rgb[3]], "rgb");
    if (e === 1)
      return new Ze([255, 255, 255, this._rgb[3]], "rgb");
    let n = this.luminance(), o = _ne;
    const r = (s, a) => {
      const c = s.interpolate(a, 0.5, t), d = c.luminance();
      return Math.abs(e - d) < One || !o-- ? c : d > e ? r(s, c) : r(c, a);
    }, i = (n > e ? r(new Ze([0, 0, 0]), this) : r(this, new Ze([255, 255, 255]))).rgb();
    return new Ze([...i, this._rgb[3]]);
  }
  return Pne(...this._rgb.slice(0, 3));
};
const Pne = (e, t, n) => (e = C6(e), t = C6(t), n = C6(n), 0.2126 * e + 0.7152 * t + 0.0722 * n), C6 = (e) => (e /= 255, e <= 0.03928 ? e / 12.92 : Rne((e + 0.055) / 1.055, 2.4)), fo = {}, Kc = (e, t, n = 0.5, ...o) => {
  let r = o[0] || "lrgb";
  if (!fo[r] && !o.length && (r = Object.keys(fo)[0]), !fo[r])
    throw new Error(`interpolation mode ${r} is not defined`);
  return Lt(e) !== "object" && (e = new Ze(e)), Lt(t) !== "object" && (t = new Ze(t)), fo[r](e, t, n).alpha(
    e.alpha() + n * (t.alpha() - e.alpha())
  );
};
Ze.prototype.mix = Ze.prototype.interpolate = function(e, t = 0.5, ...n) {
  return Kc(this, e, t, ...n);
};
Ze.prototype.premultiply = function(e = !1) {
  const t = this._rgb, n = t[3];
  return e ? (this._rgb = [t[0] * n, t[1] * n, t[2] * n, n], this) : new Ze([t[0] * n, t[1] * n, t[2] * n, n], "rgb");
};
Ze.prototype.saturate = function(e = 1) {
  const t = this, n = t.lch();
  return n[1] += Do.Kn * e, n[1] < 0 && (n[1] = 0), new Ze(n, "lch").alpha(t.alpha(), !0);
};
Ze.prototype.desaturate = function(e = 1) {
  return this.saturate(-e);
};
Ze.prototype.set = function(e, t, n = !1) {
  const [o, r] = e.split("."), i = this[o]();
  if (r) {
    const s = o.indexOf(r) - (o.substr(0, 2) === "ok" ? 2 : 0);
    if (s > -1) {
      if (Lt(t) == "string")
        switch (t.charAt(0)) {
          case "+":
            i[s] += +t;
            break;
          case "-":
            i[s] += +t;
            break;
          case "*":
            i[s] *= +t.substr(1);
            break;
          case "/":
            i[s] /= +t.substr(1);
            break;
          default:
            i[s] = +t;
        }
      else if (Lt(t) === "number")
        i[s] = t;
      else
        throw new Error("unsupported value for Color.set");
      const a = new Ze(i, o);
      return n ? (this._rgb = a._rgb, this) : a;
    }
    throw new Error(`unknown channel ${r} in mode ${o}`);
  } else
    return i;
};
Ze.prototype.tint = function(e = 0.5, ...t) {
  return Kc(this, "white", e, ...t);
};
Ze.prototype.shade = function(e = 0.5, ...t) {
  return Kc(this, "black", e, ...t);
};
const Lne = (e, t, n) => {
  const o = e._rgb, r = t._rgb;
  return new Ze(
    o[0] + n * (r[0] - o[0]),
    o[1] + n * (r[1] - o[1]),
    o[2] + n * (r[2] - o[2]),
    "rgb"
  );
};
fo.rgb = Lne;
const { sqrt: x6, pow: Qa } = Math, Ine = (e, t, n) => {
  const [o, r, i] = e._rgb, [s, a, c] = t._rgb;
  return new Ze(
    x6(Qa(o, 2) * (1 - n) + Qa(s, 2) * n),
    x6(Qa(r, 2) * (1 - n) + Qa(a, 2) * n),
    x6(Qa(i, 2) * (1 - n) + Qa(c, 2) * n),
    "rgb"
  );
};
fo.lrgb = Ine;
const jne = (e, t, n) => {
  const o = e.lab(), r = t.lab();
  return new Ze(
    o[0] + n * (r[0] - o[0]),
    o[1] + n * (r[1] - o[1]),
    o[2] + n * (r[2] - o[2]),
    "lab"
  );
};
fo.lab = jne;
const g2 = (e, t, n, o) => {
  let r, i;
  o === "hsl" ? (r = e.hsl(), i = t.hsl()) : o === "hsv" ? (r = e.hsv(), i = t.hsv()) : o === "hcg" ? (r = e.hcg(), i = t.hcg()) : o === "hsi" ? (r = e.hsi(), i = t.hsi()) : o === "lch" || o === "hcl" ? (o = "hcl", r = e.hcl(), i = t.hcl()) : o === "oklch" && (r = e.oklch().reverse(), i = t.oklch().reverse());
  let s, a, c, d, u, p;
  (o.substr(0, 1) === "h" || o === "oklch") && ([s, c, u] = r, [a, d, p] = i);
  let h, g, m, b;
  return !isNaN(s) && !isNaN(a) ? (a > s && a - s > 180 ? b = a - (s + 360) : a < s && s - a > 180 ? b = a + 360 - s : b = a - s, g = s + n * b) : isNaN(s) ? isNaN(a) ? g = Number.NaN : (g = a, (u == 1 || u == 0) && o != "hsv" && (h = d)) : (g = s, (p == 1 || p == 0) && o != "hsv" && (h = c)), h === void 0 && (h = c + n * (d - c)), m = u + n * (p - u), o === "oklch" ? new Ze([m, h, g], o) : new Ze([g, h, m], o);
}, TM = (e, t, n) => g2(e, t, n, "lch");
fo.lch = TM;
fo.hcl = TM;
const Vne = (e, t, n) => {
  const o = e.num(), r = t.num();
  return new Ze(o + n * (r - o), "num");
};
fo.num = Vne;
const Dne = (e, t, n) => g2(e, t, n, "hcg");
fo.hcg = Dne;
const Ane = (e, t, n) => g2(e, t, n, "hsi");
fo.hsi = Ane;
const Hne = (e, t, n) => g2(e, t, n, "hsl");
fo.hsl = Hne;
const Fne = (e, t, n) => g2(e, t, n, "hsv");
fo.hsv = Fne;
const Nne = (e, t, n) => {
  const o = e.oklab(), r = t.oklab();
  return new Ze(
    o[0] + n * (r[0] - o[0]),
    o[1] + n * (r[1] - o[1]),
    o[2] + n * (r[2] - o[2]),
    "oklab"
  );
};
fo.oklab = Nne;
const $ne = (e, t, n) => g2(e, t, n, "oklch");
fo.oklch = $ne;
const { pow: y6, sqrt: v6, PI: w6, cos: Wb, sin: Ub, atan2: Bne } = Math, zne = (e, t = "lrgb", n = null) => {
  const o = e.length;
  n || (n = Array.from(new Array(o)).map(() => 1));
  const r = o / n.reduce(function(p, h) {
    return p + h;
  });
  if (n.forEach((p, h) => {
    n[h] *= r;
  }), e = e.map((p) => new Ze(p)), t === "lrgb")
    return Zne(e, n);
  const i = e.shift(), s = i.get(t), a = [];
  let c = 0, d = 0;
  for (let p = 0; p < s.length; p++)
    if (s[p] = (s[p] || 0) * n[0], a.push(isNaN(s[p]) ? 0 : n[0]), t.charAt(p) === "h" && !isNaN(s[p])) {
      const h = s[p] / 180 * w6;
      c += Wb(h) * n[0], d += Ub(h) * n[0];
    }
  let u = i.alpha() * n[0];
  e.forEach((p, h) => {
    const g = p.get(t);
    u += p.alpha() * n[h + 1];
    for (let m = 0; m < s.length; m++)
      if (!isNaN(g[m]))
        if (a[m] += n[h + 1], t.charAt(m) === "h") {
          const b = g[m] / 180 * w6;
          c += Wb(b) * n[h + 1], d += Ub(b) * n[h + 1];
        } else
          s[m] += g[m] * n[h + 1];
  });
  for (let p = 0; p < s.length; p++)
    if (t.charAt(p) === "h") {
      let h = Bne(d / a[p], c / a[p]) / w6 * 180;
      for (; h < 0; ) h += 360;
      for (; h >= 360; ) h -= 360;
      s[p] = h;
    } else
      s[p] = s[p] / a[p];
  return u /= o, new Ze(s, t).alpha(u > 0.99999 ? 1 : u, !0);
}, Zne = (e, t) => {
  const n = e.length, o = [0, 0, 0, 0];
  for (let r = 0; r < e.length; r++) {
    const i = e[r], s = t[r] / n, a = i._rgb;
    o[0] += y6(a[0], 2) * s, o[1] += y6(a[1], 2) * s, o[2] += y6(a[2], 2) * s, o[3] += a[3] * s;
  }
  return o[0] = v6(o[0]), o[1] = v6(o[1]), o[2] = v6(o[2]), o[3] > 0.9999999 && (o[3] = 1), new Ze(I7(o));
}, { pow: Wne } = Math;
function su(e) {
  let t = "rgb", n = wt("#ccc"), o = 0, r = [0, 1], i = [], s = [0, 0], a = !1, c = [], d = !1, u = 0, p = 1, h = !1, g = {}, m = !0, b = 1;
  const C = function(E) {
    if (E = E || ["#fff", "#000"], E && Lt(E) === "string" && wt.brewer && wt.brewer[E.toLowerCase()] && (E = wt.brewer[E.toLowerCase()]), Lt(E) === "array") {
      E.length === 1 && (E = [E[0], E[0]]), E = E.slice(0);
      for (let R = 0; R < E.length; R++)
        E[R] = wt(E[R]);
      i.length = 0;
      for (let R = 0; R < E.length; R++)
        i.push(R / (E.length - 1));
    }
    return w(), c = E;
  }, x = function(E) {
    if (a != null) {
      const R = a.length - 1;
      let O = 0;
      for (; O < R && E >= a[O]; )
        O++;
      return O - 1;
    }
    return 0;
  };
  let v = (E) => E, S = (E) => E;
  const M = function(E, R) {
    let O, P;
    if (R == null && (R = !1), isNaN(E) || E === null)
      return n;
    R ? P = E : a && a.length > 2 ? P = x(E) / (a.length - 2) : p !== u ? P = (E - u) / (p - u) : P = 1, P = S(P), R || (P = v(P)), b !== 1 && (P = Wne(P, b)), P = s[0] + P * (1 - s[0] - s[1]), P = vl(P, 0, 1);
    const _ = Math.floor(P * 1e4);
    if (m && g[_])
      O = g[_];
    else {
      if (Lt(c) === "array")
        for (let L = 0; L < i.length; L++) {
          const V = i[L];
          if (P <= V) {
            O = c[L];
            break;
          }
          if (P >= V && L === i.length - 1) {
            O = c[L];
            break;
          }
          if (P > V && P < i[L + 1]) {
            P = (P - V) / (i[L + 1] - V), O = wt.interpolate(
              c[L],
              c[L + 1],
              P,
              t
            );
            break;
          }
        }
      else Lt(c) === "function" && (O = c(P));
      m && (g[_] = O);
    }
    return O;
  };
  var w = () => g = {};
  C(e);
  const k = function(E) {
    const R = wt(M(E));
    return d && R[d] ? R[d]() : R;
  };
  return k.classes = function(E) {
    if (E != null) {
      if (Lt(E) === "array")
        a = E, r = [E[0], E[E.length - 1]];
      else {
        const R = wt.analyze(r);
        E === 0 ? a = [R.min, R.max] : a = wt.limits(R, "e", E);
      }
      return k;
    }
    return a;
  }, k.domain = function(E) {
    if (!arguments.length)
      return r;
    u = E[0], p = E[E.length - 1], i = [];
    const R = c.length;
    if (E.length === R && u !== p)
      for (let O of Array.from(E))
        i.push((O - u) / (p - u));
    else {
      for (let O = 0; O < R; O++)
        i.push(O / (R - 1));
      if (E.length > 2) {
        const O = E.map((_, L) => L / (E.length - 1)), P = E.map((_) => (_ - u) / (p - u));
        P.every((_, L) => O[L] === _) || (S = (_) => {
          if (_ <= 0 || _ >= 1) return _;
          let L = 0;
          for (; _ >= P[L + 1]; ) L++;
          const V = (_ - P[L]) / (P[L + 1] - P[L]);
          return O[L] + V * (O[L + 1] - O[L]);
        });
      }
    }
    return r = [u, p], k;
  }, k.mode = function(E) {
    return arguments.length ? (t = E, w(), k) : t;
  }, k.range = function(E, R) {
    return C(E), k;
  }, k.out = function(E) {
    return d = E, k;
  }, k.spread = function(E) {
    return arguments.length ? (o = E, k) : o;
  }, k.correctLightness = function(E) {
    return E == null && (E = !0), h = E, w(), h ? v = function(R) {
      const O = M(0, !0).lab()[0], P = M(1, !0).lab()[0], _ = O > P;
      let L = M(R, !0).lab()[0];
      const V = O + (P - O) * R;
      let j = L - V, I = 0, F = 1, $ = 20;
      for (; Math.abs(j) > 0.01 && $-- > 0; )
        (function() {
          return _ && (j *= -1), j < 0 ? (I = R, R += (F - R) * 0.5) : (F = R, R += (I - R) * 0.5), L = M(R, !0).lab()[0], j = L - V;
        })();
      return R;
    } : v = (R) => R, k;
  }, k.padding = function(E) {
    return E != null ? (Lt(E) === "number" && (E = [E, E]), s = E, k) : s;
  }, k.colors = function(E, R) {
    arguments.length < 2 && (R = "hex");
    let O = [];
    if (arguments.length === 0)
      O = c.slice(0);
    else if (E === 1)
      O = [k(0.5)];
    else if (E > 1) {
      const P = r[0], _ = r[1] - P;
      O = Une(0, E).map(
        (L) => k(P + L / (E - 1) * _)
      );
    } else {
      e = [];
      let P = [];
      if (a && a.length > 2)
        for (let _ = 1, L = a.length, V = 1 <= L; V ? _ < L : _ > L; V ? _++ : _--)
          P.push((a[_ - 1] + a[_]) * 0.5);
      else
        P = r;
      O = P.map((_) => k(_));
    }
    return wt[R] && (O = O.map((P) => P[R]())), O;
  }, k.cache = function(E) {
    return E != null ? (m = E, k) : m;
  }, k.gamma = function(E) {
    return E != null ? (b = E, k) : b;
  }, k.nodata = function(E) {
    return E != null ? (n = wt(E), k) : n;
  }, k;
}
function Une(e, t, n) {
  let o = [], r = e < t, i = t;
  for (let s = e; r ? s < i : s > i; r ? s++ : s--)
    o.push(s);
  return o;
}
const Gne = function(e) {
  let t = [1, 1];
  for (let n = 1; n < e; n++) {
    let o = [1];
    for (let r = 1; r <= t.length; r++)
      o[r] = (t[r] || 0) + t[r - 1];
    t = o;
  }
  return t;
}, qne = function(e) {
  let t, n, o, r;
  if (e = e.map((i) => new Ze(i)), e.length === 2)
    [n, o] = e.map((i) => i.lab()), t = function(i) {
      const s = [0, 1, 2].map((a) => n[a] + i * (o[a] - n[a]));
      return new Ze(s, "lab");
    };
  else if (e.length === 3)
    [n, o, r] = e.map((i) => i.lab()), t = function(i) {
      const s = [0, 1, 2].map(
        (a) => (1 - i) * (1 - i) * n[a] + 2 * (1 - i) * i * o[a] + i * i * r[a]
      );
      return new Ze(s, "lab");
    };
  else if (e.length === 4) {
    let i;
    [n, o, r, i] = e.map((s) => s.lab()), t = function(s) {
      const a = [0, 1, 2].map(
        (c) => (1 - s) * (1 - s) * (1 - s) * n[c] + 3 * (1 - s) * (1 - s) * s * o[c] + 3 * (1 - s) * s * s * r[c] + s * s * s * i[c]
      );
      return new Ze(a, "lab");
    };
  } else if (e.length >= 5) {
    let i, s, a;
    i = e.map((c) => c.lab()), a = e.length - 1, s = Gne(a), t = function(c) {
      const d = 1 - c, u = [0, 1, 2].map(
        (p) => i.reduce(
          (h, g, m) => h + s[m] * d ** (a - m) * c ** m * g[p],
          0
        )
      );
      return new Ze(u, "lab");
    };
  } else
    throw new RangeError("No point in running bezier with only one color.");
  return t;
}, Kne = (e) => {
  const t = qne(e);
  return t.scale = () => su(t), t;
}, jr = (e, t, n) => {
  if (!jr[n])
    throw new Error("unknown blend mode " + n);
  return jr[n](e, t);
}, Os = (e) => (t, n) => {
  const o = wt(n).rgb(), r = wt(t).rgb();
  return wt.rgb(e(o, r));
}, _s = (e) => (t, n) => {
  const o = [];
  return o[0] = e(t[0], n[0]), o[1] = e(t[1], n[1]), o[2] = e(t[2], n[2]), o;
}, Yne = (e) => e, Xne = (e, t) => e * t / 255, Jne = (e, t) => e > t ? t : e, Qne = (e, t) => e > t ? e : t, eoe = (e, t) => 255 * (1 - (1 - e / 255) * (1 - t / 255)), toe = (e, t) => t < 128 ? 2 * e * t / 255 : 255 * (1 - 2 * (1 - e / 255) * (1 - t / 255)), noe = (e, t) => 255 * (1 - (1 - t / 255) / (e / 255)), ooe = (e, t) => e === 255 ? 255 : (e = 255 * (t / 255) / (1 - e / 255), e > 255 ? 255 : e);
jr.normal = Os(_s(Yne));
jr.multiply = Os(_s(Xne));
jr.screen = Os(_s(eoe));
jr.overlay = Os(_s(toe));
jr.darken = Os(_s(Jne));
jr.lighten = Os(_s(Qne));
jr.dodge = Os(_s(ooe));
jr.burn = Os(_s(noe));
const { pow: roe, sin: ioe, cos: soe } = Math;
function aoe(e = 300, t = -1.5, n = 1, o = 1, r = [0, 1]) {
  let i = 0, s;
  Lt(r) === "array" ? s = r[1] - r[0] : (s = 0, r = [r, r]);
  const a = function(c) {
    const d = wi * ((e + 120) / 360 + t * c), u = roe(r[0] + s * c, o), h = (i !== 0 ? n[0] + c * i : n) * u * (1 - u) / 2, g = soe(d), m = ioe(d), b = u + h * (-0.14861 * g + 1.78277 * m), C = u + h * (-0.29227 * g - 0.90649 * m), x = u + h * (1.97294 * g);
    return wt(I7([b * 255, C * 255, x * 255, 1]));
  };
  return a.start = function(c) {
    return c == null ? e : (e = c, a);
  }, a.rotations = function(c) {
    return c == null ? t : (t = c, a);
  }, a.gamma = function(c) {
    return c == null ? o : (o = c, a);
  }, a.hue = function(c) {
    return c == null ? n : (n = c, Lt(n) === "array" ? (i = n[1] - n[0], i === 0 && (n = n[1])) : i = 0, a);
  }, a.lightness = function(c) {
    return c == null ? r : (Lt(c) === "array" ? (r = c, s = c[1] - c[0]) : (r = [c, c], s = 0), a);
  }, a.scale = () => wt.scale(a), a.hue(n), a;
}
const loe = "0123456789abcdef", { floor: coe, random: doe } = Math, uoe = () => {
  let e = "#";
  for (let t = 0; t < 6; t++)
    e += loe.charAt(coe(doe() * 16));
  return new Ze(e, "hex");
}, { log: Gb, pow: foe, floor: poe, abs: hoe } = Math;
function kM(e, t = null) {
  const n = {
    min: Number.MAX_VALUE,
    max: Number.MAX_VALUE * -1,
    sum: 0,
    values: [],
    count: 0
  };
  return Lt(e) === "object" && (e = Object.values(e)), e.forEach((o) => {
    t && Lt(o) === "object" && (o = o[t]), o != null && !isNaN(o) && (n.values.push(o), n.sum += o, o < n.min && (n.min = o), o > n.max && (n.max = o), n.count += 1);
  }), n.domain = [n.min, n.max], n.limits = (o, r) => EM(n, o, r), n;
}
function EM(e, t = "equal", n = 7) {
  Lt(e) == "array" && (e = kM(e));
  const { min: o, max: r } = e, i = e.values.sort((a, c) => a - c);
  if (n === 1)
    return [o, r];
  const s = [];
  if (t.substr(0, 1) === "c" && (s.push(o), s.push(r)), t.substr(0, 1) === "e") {
    s.push(o);
    for (let a = 1; a < n; a++)
      s.push(o + a / n * (r - o));
    s.push(r);
  } else if (t.substr(0, 1) === "l") {
    if (o <= 0)
      throw new Error(
        "Logarithmic scales are only possible for values > 0"
      );
    const a = Math.LOG10E * Gb(o), c = Math.LOG10E * Gb(r);
    s.push(o);
    for (let d = 1; d < n; d++)
      s.push(foe(10, a + d / n * (c - a)));
    s.push(r);
  } else if (t.substr(0, 1) === "q") {
    s.push(o);
    for (let a = 1; a < n; a++) {
      const c = (i.length - 1) * a / n, d = poe(c);
      if (d === c)
        s.push(i[d]);
      else {
        const u = c - d;
        s.push(i[d] * (1 - u) + i[d + 1] * u);
      }
    }
    s.push(r);
  } else if (t.substr(0, 1) === "k") {
    let a;
    const c = i.length, d = new Array(c), u = new Array(n);
    let p = !0, h = 0, g = null;
    g = [], g.push(o);
    for (let C = 1; C < n; C++)
      g.push(o + C / n * (r - o));
    for (g.push(r); p; ) {
      for (let x = 0; x < n; x++)
        u[x] = 0;
      for (let x = 0; x < c; x++) {
        const v = i[x];
        let S = Number.MAX_VALUE, M;
        for (let w = 0; w < n; w++) {
          const k = hoe(g[w] - v);
          k < S && (S = k, M = w), u[M]++, d[x] = M;
        }
      }
      const C = new Array(n);
      for (let x = 0; x < n; x++)
        C[x] = null;
      for (let x = 0; x < c; x++)
        a = d[x], C[a] === null ? C[a] = i[x] : C[a] += i[x];
      for (let x = 0; x < n; x++)
        C[x] *= 1 / u[x];
      p = !1;
      for (let x = 0; x < n; x++)
        if (C[x] !== g[x]) {
          p = !0;
          break;
        }
      g = C, h++, h > 200 && (p = !1);
    }
    const m = {};
    for (let C = 0; C < n; C++)
      m[C] = [];
    for (let C = 0; C < c; C++)
      a = d[C], m[a].push(i[C]);
    let b = [];
    for (let C = 0; C < n; C++)
      b.push(m[C][0]), b.push(m[C][m[C].length - 1]);
    b = b.sort((C, x) => C - x), s.push(b[0]);
    for (let C = 1; C < b.length; C += 2) {
      const x = b[C];
      !isNaN(x) && s.indexOf(x) === -1 && s.push(x);
    }
  }
  return s;
}
const goe = (e, t) => {
  e = new Ze(e), t = new Ze(t);
  const n = e.luminance(), o = t.luminance();
  return n > o ? (n + 0.05) / (o + 0.05) : (o + 0.05) / (n + 0.05);
}, { sqrt: pi, pow: In, min: moe, max: boe, atan2: qb, abs: Kb, cos: P1, sin: Yb, exp: Coe, PI: Xb } = Math;
function xoe(e, t, n = 1, o = 1, r = 1) {
  var i = function(ne) {
    return 360 * ne / (2 * Xb);
  }, s = function(ne) {
    return 2 * Xb * ne / 360;
  };
  e = new Ze(e), t = new Ze(t);
  const [a, c, d] = Array.from(e.lab()), [u, p, h] = Array.from(t.lab()), g = (a + u) / 2, m = pi(In(c, 2) + In(d, 2)), b = pi(In(p, 2) + In(h, 2)), C = (m + b) / 2, x = 0.5 * (1 - pi(In(C, 7) / (In(C, 7) + In(25, 7)))), v = c * (1 + x), S = p * (1 + x), M = pi(In(v, 2) + In(d, 2)), w = pi(In(S, 2) + In(h, 2)), k = (M + w) / 2, E = i(qb(d, v)), R = i(qb(h, S)), O = E >= 0 ? E : E + 360, P = R >= 0 ? R : R + 360, _ = Kb(O - P) > 180 ? (O + P + 360) / 2 : (O + P) / 2, L = 1 - 0.17 * P1(s(_ - 30)) + 0.24 * P1(s(2 * _)) + 0.32 * P1(s(3 * _ + 6)) - 0.2 * P1(s(4 * _ - 63));
  let V = P - O;
  V = Kb(V) <= 180 ? V : P <= O ? V + 360 : V - 360, V = 2 * pi(M * w) * Yb(s(V) / 2);
  const j = u - a, I = w - M, F = 1 + 0.015 * In(g - 50, 2) / pi(20 + In(g - 50, 2)), $ = 1 + 0.045 * k, A = 1 + 0.015 * k * L, H = 30 * Coe(-In((_ - 275) / 25, 2)), z = -(2 * pi(In(k, 7) / (In(k, 7) + In(25, 7)))) * Yb(2 * s(H)), se = pi(
    In(j / (n * F), 2) + In(I / (o * $), 2) + In(V / (r * A), 2) + z * (I / (o * $)) * (V / (r * A))
  );
  return boe(0, moe(100, se));
}
function yoe(e, t, n = "lab") {
  e = new Ze(e), t = new Ze(t);
  const o = e.get(n), r = t.get(n);
  let i = 0;
  for (let s in o) {
    const a = (o[s] || 0) - (r[s] || 0);
    i += a * a;
  }
  return Math.sqrt(i);
}
const voe = (...e) => {
  try {
    return new Ze(...e), !0;
  } catch {
    return !1;
  }
}, woe = {
  cool() {
    return su([wt.hsl(180, 1, 0.9), wt.hsl(250, 0.7, 0.4)]);
  },
  hot() {
    return su(["#000", "#f00", "#ff0", "#fff"]).mode(
      "rgb"
    );
  }
}, kd = {
  // sequential
  OrRd: ["#fff7ec", "#fee8c8", "#fdd49e", "#fdbb84", "#fc8d59", "#ef6548", "#d7301f", "#b30000", "#7f0000"],
  PuBu: ["#fff7fb", "#ece7f2", "#d0d1e6", "#a6bddb", "#74a9cf", "#3690c0", "#0570b0", "#045a8d", "#023858"],
  BuPu: ["#f7fcfd", "#e0ecf4", "#bfd3e6", "#9ebcda", "#8c96c6", "#8c6bb1", "#88419d", "#810f7c", "#4d004b"],
  Oranges: ["#fff5eb", "#fee6ce", "#fdd0a2", "#fdae6b", "#fd8d3c", "#f16913", "#d94801", "#a63603", "#7f2704"],
  BuGn: ["#f7fcfd", "#e5f5f9", "#ccece6", "#99d8c9", "#66c2a4", "#41ae76", "#238b45", "#006d2c", "#00441b"],
  YlOrBr: ["#ffffe5", "#fff7bc", "#fee391", "#fec44f", "#fe9929", "#ec7014", "#cc4c02", "#993404", "#662506"],
  YlGn: ["#ffffe5", "#f7fcb9", "#d9f0a3", "#addd8e", "#78c679", "#41ab5d", "#238443", "#006837", "#004529"],
  Reds: ["#fff5f0", "#fee0d2", "#fcbba1", "#fc9272", "#fb6a4a", "#ef3b2c", "#cb181d", "#a50f15", "#67000d"],
  RdPu: ["#fff7f3", "#fde0dd", "#fcc5c0", "#fa9fb5", "#f768a1", "#dd3497", "#ae017e", "#7a0177", "#49006a"],
  Greens: ["#f7fcf5", "#e5f5e0", "#c7e9c0", "#a1d99b", "#74c476", "#41ab5d", "#238b45", "#006d2c", "#00441b"],
  YlGnBu: ["#ffffd9", "#edf8b1", "#c7e9b4", "#7fcdbb", "#41b6c4", "#1d91c0", "#225ea8", "#253494", "#081d58"],
  Purples: ["#fcfbfd", "#efedf5", "#dadaeb", "#bcbddc", "#9e9ac8", "#807dba", "#6a51a3", "#54278f", "#3f007d"],
  GnBu: ["#f7fcf0", "#e0f3db", "#ccebc5", "#a8ddb5", "#7bccc4", "#4eb3d3", "#2b8cbe", "#0868ac", "#084081"],
  Greys: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#000000"],
  YlOrRd: ["#ffffcc", "#ffeda0", "#fed976", "#feb24c", "#fd8d3c", "#fc4e2a", "#e31a1c", "#bd0026", "#800026"],
  PuRd: ["#f7f4f9", "#e7e1ef", "#d4b9da", "#c994c7", "#df65b0", "#e7298a", "#ce1256", "#980043", "#67001f"],
  Blues: ["#f7fbff", "#deebf7", "#c6dbef", "#9ecae1", "#6baed6", "#4292c6", "#2171b5", "#08519c", "#08306b"],
  PuBuGn: ["#fff7fb", "#ece2f0", "#d0d1e6", "#a6bddb", "#67a9cf", "#3690c0", "#02818a", "#016c59", "#014636"],
  Viridis: ["#440154", "#482777", "#3f4a8a", "#31678e", "#26838f", "#1f9d8a", "#6cce5a", "#b6de2b", "#fee825"],
  // diverging
  Spectral: ["#9e0142", "#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#e6f598", "#abdda4", "#66c2a5", "#3288bd", "#5e4fa2"],
  RdYlGn: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#d9ef8b", "#a6d96a", "#66bd63", "#1a9850", "#006837"],
  RdBu: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#f7f7f7", "#d1e5f0", "#92c5de", "#4393c3", "#2166ac", "#053061"],
  PiYG: ["#8e0152", "#c51b7d", "#de77ae", "#f1b6da", "#fde0ef", "#f7f7f7", "#e6f5d0", "#b8e186", "#7fbc41", "#4d9221", "#276419"],
  PRGn: ["#40004b", "#762a83", "#9970ab", "#c2a5cf", "#e7d4e8", "#f7f7f7", "#d9f0d3", "#a6dba0", "#5aae61", "#1b7837", "#00441b"],
  RdYlBu: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee090", "#ffffbf", "#e0f3f8", "#abd9e9", "#74add1", "#4575b4", "#313695"],
  BrBG: ["#543005", "#8c510a", "#bf812d", "#dfc27d", "#f6e8c3", "#f5f5f5", "#c7eae5", "#80cdc1", "#35978f", "#01665e", "#003c30"],
  RdGy: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#ffffff", "#e0e0e0", "#bababa", "#878787", "#4d4d4d", "#1a1a1a"],
  PuOr: ["#7f3b08", "#b35806", "#e08214", "#fdb863", "#fee0b6", "#f7f7f7", "#d8daeb", "#b2abd2", "#8073ac", "#542788", "#2d004b"],
  // qualitative
  Set2: ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f", "#e5c494", "#b3b3b3"],
  Accent: ["#7fc97f", "#beaed4", "#fdc086", "#ffff99", "#386cb0", "#f0027f", "#bf5b17", "#666666"],
  Set1: ["#e41a1c", "#377eb8", "#4daf4a", "#984ea3", "#ff7f00", "#ffff33", "#a65628", "#f781bf", "#999999"],
  Set3: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462", "#b3de69", "#fccde5", "#d9d9d9", "#bc80bd", "#ccebc5", "#ffed6f"],
  Dark2: ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02", "#a6761d", "#666666"],
  Paired: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99", "#b15928"],
  Pastel2: ["#b3e2cd", "#fdcdac", "#cbd5e8", "#f4cae4", "#e6f5c9", "#fff2ae", "#f1e2cc", "#cccccc"],
  Pastel1: ["#fbb4ae", "#b3cde3", "#ccebc5", "#decbe4", "#fed9a6", "#ffffcc", "#e5d8bd", "#fddaec", "#f2f2f2"]
};
for (let e of Object.keys(kd))
  kd[e.toLowerCase()] = kd[e];
Object.assign(wt, {
  average: zne,
  bezier: Kne,
  blend: jr,
  cubehelix: aoe,
  mix: Kc,
  interpolate: Kc,
  random: uoe,
  scale: su,
  analyze: kM,
  contrast: goe,
  deltaE: xoe,
  distance: yoe,
  limits: EM,
  valid: voe,
  scales: woe,
  input: vt,
  colors: $l,
  brewer: kd
});
const Soe = (e) => {
  const { values: t, palette: n, legend: o = !0, hoveredArcIndex: r, setHoveredArcIndex: i, handleChartHover: s, hoverOffset: a, theme: c, ...d } = e, u = t && t.filter((p) => p !== null && p !== 0).length > 1;
  return {
    ...d,
    data: {
      datasets: [
        {
          data: t ?? [],
          backgroundColor: r === null || !o ? n : n.flatMap((p, h) => h !== r ? wt(p).alpha(0.4).css() : p),
          hoverBackgroundColor: n,
          hoverOffset: a
        }
      ]
    },
    options: {
      cutout: "78%",
      responsive: !0,
      maintainAspectRatio: !0,
      elements: {
        arc: {
          borderWidth: u ? e.borderWidth : 0,
          borderColor: e.borderColor ?? "white",
          spacing: u ? e.spacing : 0
        }
      },
      events: ["mousemove", "mouseout"],
      layout: {
        padding: e.spacing ? e.spacing / 2 : 0
      },
      onHover: (p, h) => {
        var g, m;
        if (p.type !== "mousemove" || !h.length) {
          i(null), ((g = p.native) == null ? void 0 : g.target).style.cursor = "default";
          return;
        }
        if (((m = p.native) == null ? void 0 : m.target).style.cursor = h[0] ? "pointer" : "default", i(h[0].index), r !== null && p.native) {
          const C = p.native.target.getBoundingClientRect(), x = C.left + C.width / 2, v = C.top + C.height / 2, S = p.native instanceof MouseEvent ? p.native.clientX : p.x, M = p.native instanceof MouseEvent ? p.native.clientY : p.y;
          s(S, M, x, v);
        }
      },
      plugins: {
        datalabels: { display: !1 },
        legend: {
          display: !1
        },
        tooltip: {
          enabled: !1
        }
      }
    },
    plugins: [
      {
        id: "doughnutBackground",
        style: {
          padding: "2px"
        },
        beforeDatasetsDraw: (p) => {
          const g = p.data.datasets.length > 0 && p.data.datasets[0].data.length > 0, m = p.data.datasets[0].data.every((k) => k === 0);
          if (g && !m)
            return;
          const b = p.canvas.clientWidth / 2, C = p.canvas.clientHeight / 2, x = p.ctx, { innerRadius: v, outerRadius: S } = p.getDatasetMeta(
            p.data.datasets.length - 1
          ).controller, M = S - v;
          x.lineWidth = M, x.strokeStyle = c.palette.primary[50] ?? "rgba(0, 0, 0, 0)";
          const w = S - M / 2;
          x.beginPath(), x.arc(b, C, w, 0, 2 * Math.PI), x.stroke();
        }
      }
    ]
  };
}, Moe = (e, t, n) => Object.entries(e.palette.primary).filter(([o]) => !isNaN(Number(o)) && t <= Number(o) && Number(o) <= n).sort(([o], [r]) => Number(r) - Number(o)).map(([, o]) => o), Toe = (e, t) => wt.scale(e).colors(t.length), RM = (e) => {
  const t = e.reduce((r, i) => r + i, 0);
  if (!t)
    return [...new Array(e.length)].map(() => 0);
  const n = e.map((r) => Math.floor(r / t * 100)), o = 100 - n.reduce((r, i) => r + i, 0);
  for (let r = 0; r < o; r++) {
    const i = n.indexOf(Math.max(...n));
    n[i]++;
  }
  return n;
}, OM = (e, t, n, o) => {
  const r = e - n, i = o - t, s = Math.atan2(i, r) * (180 / Math.PI);
  return s > -45 && s <= 45 ? "left" : s > 45 && s <= 135 ? "bottom" : s > 135 && s <= 180 || s >= -180 && s <= -135 ? "right" : "top";
}, Jb = (e, t, n, o = { x: 0, y: 0 }) => {
  const r = n.left + o.x + n.width / 2, i = n.top + o.y + n.height / 2, a = Math.min(n.width, n.height) / 2 * 0.8, c = t.reduce((C, x) => C + x, 0) || 0, d = {
    x: r,
    y: i - a,
    centerX: r,
    centerY: i,
    placement: "top"
  };
  if (c <= 0 || !t[e])
    return d;
  let u = -Math.PI / 2;
  for (let C = 0; C < e; C++)
    t[C] && (u += t[C] / c * (2 * Math.PI));
  const p = t[e] / c * (2 * Math.PI), h = u + p / 2, g = r + Math.cos(h) * a, m = i + Math.sin(h) * a, b = OM(g, m, r, i);
  return { x: g, y: m, centerX: r, centerY: i, placement: b };
}, A7 = (e) => {
  const { action: t, seeMore: n } = e, o = ge(), r = {
    display: "flex",
    marginLeft: "auto",
    color: o.palette.primary[700],
    fontSize: ".8rem",
    textDecoration: "none",
    alignItems: "center",
    fontWeight: o.typography.fontWeightBold,
    "&:hover": {
      textDecoration: "none"
    }
  }, i = (s) => {
    s.stopPropagation(), t();
  };
  return /* @__PURE__ */ f.jsx(at, { onClick: i, sx: r, children: n });
}, koe = (e) => {
  const {
    values: t,
    labels: n,
    palette: o,
    legend: r,
    hoveredArcIndex: i,
    setHoveredArcIndex: s,
    onLegendHover: a
  } = e, c = ge(), d = RM(t ?? []), u = (h, g) => {
    g && (a ? a(h) : s(h));
  }, p = () => {
    a ? a(null) : s(null);
  };
  return /* @__PURE__ */ f.jsx(be, { width: "100%", alignItems: "left", className: "doughnut-chart-legend-wrapper", children: /* @__PURE__ */ f.jsx(be, { display: "inline-flex", justifyContent: "center", children: n.map((h, g) => {
    const m = t !== void 0 && g < ((t == null ? void 0 : t.length) ?? 0) && t[g] !== void 0;
    return /* @__PURE__ */ f.jsx(
      be,
      {
        sx: {
          borderBottom: "1px solid #e3e2e0",
          "&:last-of-type": {
            borderBottom: "none"
          },
          padding: c.spacing(0.5, 0)
        },
        children: /* @__PURE__ */ f.jsxs(
          be,
          {
            direction: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            paddingY: "8px",
            onMouseEnter: () => u(g, m),
            onMouseLeave: () => p(),
            sx: {
              "&:hover": {
                background: c.custom.grey[500]
              },
              backgroundColor: i !== g ? "unset" : c.custom.grey[500],
              padding: c.spacing(0.5, 0.5)
            },
            className: "doughnut-chart-legend-item",
            children: [
              /* @__PURE__ */ f.jsx(
                J,
                {
                  minWidth: "10px",
                  height: "10px",
                  bgcolor: m ? o[g] : c.custom.grey[400]
                }
              ),
              /* @__PURE__ */ f.jsxs(
                be,
                {
                  direction: "row",
                  alignItems: "center",
                  gap: "8px",
                  sx: { width: "100%" },
                  children: [
                    /* @__PURE__ */ f.jsxs(be, { width: "100%", display: "flex", direction: "row", alignItems: "center", justifyContent: "space-between", gap: "8px", fontWeight: 400, className: "doughnut-chart-legend-item-value", children: [
                      /* @__PURE__ */ f.jsx(oe, { variant: "h5", className: "doughnut-chart-legend-item-label", children: h }),
                      /* @__PURE__ */ f.jsx(
                        J,
                        {
                          alignItems: "center",
                          sx: {
                            display: "flex",
                            borderRadius: c.spacing(0.75),
                            background: c.custom.grey[400],
                            padding: c.spacing(0.25, 1.25),
                            minWidth: c.spacing(6),
                            justifyContent: "center",
                            fontWeight: c.typography.fontWeightMedium,
                            fontSize: c.typography["body-medium"],
                            whiteSpace: "nowrap"
                          },
                          children: m ? `${d[g]} %` : "--%"
                        }
                      )
                    ] }),
                    (r == null ? void 0 : r.actions) && (r == null ? void 0 : r.seeMore) && (r == null ? void 0 : r.actions[g]) && /* @__PURE__ */ f.jsx(
                      A7,
                      {
                        action: r == null ? void 0 : r.actions[g],
                        seeMore: r == null ? void 0 : r.seeMore
                      }
                    )
                  ]
                }
              )
            ]
          }
        )
      },
      g
    );
  }) }) });
}, _M = (e) => {
  const { index: t, palette: n, icons: o, values: r } = e;
  return o && o[t] !== void 0 ? /* @__PURE__ */ f.jsx(
    J,
    {
      minWidth: "28px",
      width: "28px",
      height: "28px",
      sx: (i) => ({
        background: n[t] || i.custom.grey[400],
        padding: "16px 5px",
        color: "#fff"
      }),
      display: "flex",
      alignItems: "center",
      borderRadius: "6px",
      children: o[t]
    }
  ) : r[t] !== void 0 && n[t] !== void 0 ? /* @__PURE__ */ f.jsx(
    J,
    {
      minWidth: "12px",
      width: "12px",
      height: "12px",
      sx: {
        background: n[t],
        color: "#fff"
      },
      display: "flex",
      alignItems: "center"
    }
  ) : null;
}, Eoe = (e) => {
  const t = ge(), { values: n, labels: o, palette: r, icons: i = [], legend: s, setHoveredArcIndex: a, hoveredArcIndex: c, onLegendHover: d } = e, u = RM(n ?? []), p = (g, m) => {
    m && (d ? d(g) : a(g));
  }, h = () => {
    d ? d(null) : a(null);
  };
  return /* @__PURE__ */ f.jsx(
    be,
    {
      alignItems: "center",
      justifyContent: "center",
      sx: { width: "100%", alignItems: "flex-start" },
      className: "doughnut-chart-legend-wrapper",
      children: /* @__PURE__ */ f.jsx(be, { width: "100%", children: o.map((g, m) => {
        const b = !!n && n[m] !== void 0, C = (s == null ? void 0 : s.actions) && (s == null ? void 0 : s.seeMore) && (s == null ? void 0 : s.actions[m]) && s;
        return /* @__PURE__ */ f.jsx(
          be,
          {
            direction: "row",
            alignItems: "center",
            gap: "12px",
            onMouseEnter: () => p(m, b),
            onMouseLeave: () => h(),
            onClick: () => {
              var x, v;
              C && (x = s == null ? void 0 : s.actions) != null && x[m] && ((v = s == null ? void 0 : s.actions) == null || v[m]());
            },
            sx: {
              borderBottom: "1px solid #e3e2e0",
              "&:last-of-type": {
                borderBottom: "none"
              }
            },
            children: /* @__PURE__ */ f.jsxs(
              be,
              {
                direction: "row",
                gap: "8px",
                sx: {
                  width: "100%",
                  padding: ".4rem",
                  alignItems: "center",
                  backgroundColor: c !== m ? "unset" : t.custom.grey[500]
                },
                className: "doughnut-chart-legend-item",
                children: [
                  /* @__PURE__ */ f.jsx(
                    _M,
                    {
                      index: m,
                      palette: r,
                      icons: i,
                      values: n
                    }
                  ),
                  /* @__PURE__ */ f.jsx(
                    oe,
                    {
                      variant: "h5",
                      sx: {
                        marginLeft: "4px"
                      },
                      className: "doughnut-chart-legend-item-label",
                      children: g
                    }
                  ),
                  g ? "- " : "",
                  /* @__PURE__ */ f.jsx(
                    oe,
                    {
                      fontWeight: 400,
                      sx: {
                        fontSize: ".8rem",
                        display: "flex",
                        flexDirection: "row",
                        whiteSpace: "pre",
                        alignItems: "center"
                      },
                      className: "doughnut-chart-legend-item-value",
                      children: /* @__PURE__ */ f.jsx(
                        J,
                        {
                          component: "span",
                          alignItems: "center",
                          sx: {
                            display: "flex",
                            borderRadius: t.spacing(0.75),
                            background: t.custom.grey[400],
                            padding: t.spacing(0.25, 1.25),
                            minWidth: t.spacing(6),
                            justifyContent: "center",
                            fontWeight: t.typography.fontWeightMedium,
                            fontSize: t.typography["body-medium"],
                            whiteSpace: "nowrap"
                          },
                          children: b ? `${u[m]} %` : "--%"
                        }
                      )
                    }
                  ),
                  C && /* @__PURE__ */ f.jsx(
                    A7,
                    {
                      action: s.actions[m],
                      seeMore: s.seeMore
                    }
                  )
                ]
              }
            )
          },
          m
        );
      }) })
    }
  );
}, Roe = (e) => {
  const { values: t, labels: n, palette: o, legend: r, hoveredArcIndex: i, setHoveredArcIndex: s, icons: a = [], onLegendHover: c } = e, d = JSON.stringify(n);
  return mt(() => {
    s(null);
  }, [d, s]), !n || !n.length ? null : (r == null ? void 0 : r.position) === "bottom" ? /* @__PURE__ */ f.jsx(
    koe,
    {
      labels: n,
      hoveredArcIndex: i,
      setHoveredArcIndex: s,
      values: t,
      palette: o,
      legend: r,
      onLegendHover: c
    }
  ) : (r == null ? void 0 : r.position) === "right" ? /* @__PURE__ */ f.jsx(
    Eoe,
    {
      labels: n,
      setHoveredArcIndex: s,
      hoveredArcIndex: i,
      values: t,
      palette: o,
      legend: r,
      icons: a,
      onLegendHover: c
    }
  ) : null;
};
F0.register(Qs);
const Wxe = (e) => {
  const {
    values: t,
    labels: n,
    colors: o,
    legend: r,
    children: i,
    valuesUnit: s,
    className: a,
    valuesFormatterFn: c,
    createPalette: d = !0,
    isLoading: u = !1,
    displayTotal: p = !0,
    fullWidthLegend: h = !1,
    displayTotalVariant: g = "number-big",
    spacing: m = 0,
    borderWidth: b = 0,
    borderColor: C,
    hoverOffset: x = 0
  } = e, [v, S] = Ae(null), [M, w] = Ae(!1), [k, E] = Ae(), [R, O] = Ae(null), [P, _] = Ae(null), [L, V] = Ae("top"), [j, I] = Ae(!1), F = St(null), $ = St({ x: null, y: null }), A = St(null), H = St(null), N = pr((D, X, de, ue) => {
    if (D !== null && X !== null) {
      if ($.current = { x: D, y: X }, F.current && (clearTimeout(F.current), F.current = null), de !== void 0 && ue !== void 0) {
        const he = OM(D, X, de, ue);
        V(he);
      }
      O(D), _(X);
    } else
      F.current && clearTimeout(F.current), F.current = setTimeout(() => {
        O(null), _(null), F.current = null;
      }, 50);
  }, []), z = pr((D) => {
    if (S(D), D !== null && A.current && t && t.length > 0) {
      I(!0);
      const X = A.current.getBoundingClientRect(), de = Jb(D, t, X, { x: 0, y: 0 });
      de.x && de.y && ($.current = { x: de.x, y: de.y }, O(de.x), _(de.y), V(de.placement));
    } else
      I(!1);
  }, [t, S]), se = pr(() => {
    F.current && clearTimeout(F.current), w(!1), O(null), _(null), F.current = null;
  }, []);
  mt(() => {
    let D = null;
    const X = () => {
      D && window.clearTimeout(D), D = window.setTimeout(() => {
        if (v !== null && A.current && t && t.length > 0) {
          const de = A.current.getBoundingClientRect(), ue = Jb(v, t, de, { x: 0, y: 0 });
          ue.x && ue.y && ($.current = { x: ue.x, y: ue.y }, O(ue.x), _(ue.y), V(ue.placement));
        } else
          se();
        D = null;
      }, 5);
    };
    return window.addEventListener("scroll", X, { passive: !0 }), window.addEventListener("resize", X, { passive: !0 }), () => {
      window.removeEventListener("scroll", X), window.removeEventListener("resize", X), F.current && clearTimeout(F.current), D && window.clearTimeout(D);
    };
  }, [v, t, se]), mt(() => {
    if (!n || !t)
      return;
    const D = R !== null && P !== null && v !== null;
    D !== M && w(D);
  }, [n, t, R, P, v, M]);
  const ne = ge(), Z = Moe(ne, 100, 700), q = (r == null ? void 0 : r.position) ?? "bottom", G = d ? Toe(o && o.length ? o : Z, t ?? []) : o ?? Z, K = Soe({
    values: t,
    labels: n,
    spacing: m,
    hoverOffset: x,
    legend: !!r,
    theme: ne,
    palette: G,
    hoveredArcIndex: v,
    setHoveredArcIndex: S,
    handleChartHover: N,
    borderWidth: b,
    borderColor: C
  }), Q = (D, X = 35) => D.length <= X ? D : D.substring(0, X - 3) + "...";
  mt(() => {
    v !== null && n && n[v] !== void 0 && t && t[v] !== void 0 ? (E(
      /* @__PURE__ */ f.jsxs(be, { direction: "column", spacing: 1, children: [
        /* @__PURE__ */ f.jsxs(be, { direction: "row", alignItems: "center", spacing: 1, children: [
          /* @__PURE__ */ f.jsx(
            _M,
            {
              index: v,
              palette: G,
              icons: e.icons,
              values: t
            }
          ),
          /* @__PURE__ */ f.jsx(oe, { fontWeight: 700, fontSize: "0.75rem", children: r !== void 0 ? Q(n[v]) : n[v] })
        ] }),
        /* @__PURE__ */ f.jsxs(oe, { fontWeight: 700, sx: {
          fontSize: "1.5rem",
          lineHeight: ne.spacing(1.5),
          pt: ne.spacing(1)
        }, children: [
          c ? c(t[v]) : t[v],
          s && /* @__PURE__ */ f.jsx(oe, { component: "span", fontWeight: 500, fontSize: "0.75rem", color: Ee[1400], sx: { wordBreak: "break-word", whiteSpace: "break-spaces", marginLeft: "4px" }, children: s })
        ] })
      ] })
    ), w(!0)) : (E(null), w(!1));
  }, [v]);
  const re = p && (t == null ? void 0 : t.reduce((D, X) => D + X, 0)), U = i ?? (p && typeof p == "string" ? p : re), W = pr(() => {
    se(), S(null), I(!1);
  }, [se]);
  return /* @__PURE__ */ f.jsxs(
    be,
    {
      direction: q === "bottom" ? "column" : "row",
      gap: "3rem",
      className: `doughnut-chart ${a}`,
      ref: H,
      onMouseLeave: W,
      children: [
        /* @__PURE__ */ f.jsx(be, { children: /* @__PURE__ */ f.jsx(
          J,
          {
            position: "relative",
            margin: "28px auto",
            sx: q === "bottom" ? { maxWidth: "300px" } : { minWidth: "300px" },
            className: "doughnut-chart-wrapper",
            id: "doughnut-chart-wrapper",
            ref: A,
            children: /* @__PURE__ */ f.jsxs(J, { position: "relative", children: [
              /* @__PURE__ */ f.jsx($te, { ...K, style: { maxWidth: "100%" } }),
              M && k && /* @__PURE__ */ f.jsx(
                J,
                {
                  sx: {
                    position: "absolute",
                    pointerEvents: "none",
                    left: 0,
                    top: 0,
                    width: 0,
                    height: 0,
                    overflow: "visible",
                    zIndex: 1e3
                  },
                  children: /* @__PURE__ */ f.jsx("div", { style: {
                    position: "fixed",
                    left: R ? `${R}px` : 0,
                    top: P ? `${P}px` : 0,
                    pointerEvents: "none",
                    transform: "translate(-50%, -50%)",
                    zIndex: 1100
                  }, children: /* @__PURE__ */ f.jsx(
                    Ma,
                    {
                      open: M,
                      align: "start",
                      title: k,
                      width: "220px",
                      padding: ne.spacing(2),
                      arrow: !0,
                      placement: L,
                      PopperProps: {
                        disablePortal: !0,
                        modifiers: [
                          {
                            name: "preventOverflow",
                            enabled: !0,
                            options: {
                              boundary: document.body
                            }
                          },
                          {
                            name: "offset",
                            options: {
                              offset: j ? [8, 0] : [0, 14]
                            }
                          }
                        ]
                      },
                      children: /* @__PURE__ */ f.jsx("div", {})
                    }
                  ) })
                }
              ),
              /* @__PURE__ */ f.jsx(
                J,
                {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "absolute",
                  padding: "10%",
                  textAlign: "center",
                  sx: {
                    inset: "12.5%",
                    pointerEvents: "none",
                    top: 0,
                    bottom: 0
                  },
                  className: "doughnut-chart-content",
                  children: /* @__PURE__ */ f.jsx(J, { display: "flex", flexDirection: "column", children: u ? /* @__PURE__ */ f.jsx(Sa, {}) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
                    /* @__PURE__ */ f.jsx(oe, { variant: g, children: U }, "content-1"),
                    s ? p && /* @__PURE__ */ f.jsx(J, { sx: { color: Ee[1400] }, children: s }) : /* @__PURE__ */ f.jsx(f.Fragment, {})
                  ] }) })
                }
              )
            ] })
          }
        ) }),
        /* @__PURE__ */ f.jsx(
          J,
          {
            display: "flex",
            width: h ? "100%" : "inherit",
            onMouseEnter: () => {
              w(!1), O(null), _(null);
            },
            sx: { width: h ? "100%" : "inherit" },
            children: /* @__PURE__ */ f.jsx(
              Roe,
              {
                labels: n,
                hoveredArcIndex: v,
                setHoveredArcIndex: S,
                values: t,
                palette: G,
                legend: r,
                icons: e.icons,
                onLegendHover: z
              }
            )
          }
        )
      ]
    }
  );
};
/*!
 * chartjs-plugin-datalabels v2.2.0
 * https://chartjs-plugin-datalabels.netlify.app
 * (c) 2017-2022 chartjs-plugin-datalabels contributors
 * Released under the MIT license
 */
var Qb = function() {
  if (typeof window < "u") {
    if (window.devicePixelRatio)
      return window.devicePixelRatio;
    var e = window.screen;
    if (e)
      return (e.deviceXDPI || 1) / (e.logicalXDPI || 1);
  }
  return 1;
}(), hc = {
  // @todo move this in Chart.helpers.toTextLines
  toTextLines: function(e) {
    var t = [], n;
    for (e = [].concat(e); e.length; )
      n = e.pop(), typeof n == "string" ? t.unshift.apply(t, n.split(`
`)) : Array.isArray(n) ? e.push.apply(e, n) : It(e) || t.unshift("" + n);
    return t;
  },
  // @todo move this in Chart.helpers.canvas.textSize
  // @todo cache calls of measureText if font doesn't change?!
  textSize: function(e, t, n) {
    var o = [].concat(t), r = o.length, i = e.font, s = 0, a;
    for (e.font = n.string, a = 0; a < r; ++a)
      s = Math.max(e.measureText(o[a]).width, s);
    return e.font = i, {
      height: r * n.lineHeight,
      width: s
    };
  },
  /**
   * Returns value bounded by min and max. This is equivalent to max(min, min(value, max)).
   * @todo move this method in Chart.helpers.bound
   * https://doc.qt.io/qt-5/qtglobal.html#qBound
   */
  bound: function(e, t, n) {
    return Math.max(e, Math.min(t, n));
  },
  /**
   * Returns an array of pair [value, state] where state is:
   * * -1: value is only in a0 (removed)
   * *  1: value is only in a1 (added)
   */
  arrayDiff: function(e, t) {
    var n = e.slice(), o = [], r, i, s, a;
    for (r = 0, s = t.length; r < s; ++r)
      a = t[r], i = n.indexOf(a), i === -1 ? o.push([a, 1]) : n.splice(i, 1);
    for (r = 0, s = n.length; r < s; ++r)
      o.push([n[r], -1]);
    return o;
  },
  /**
   * https://github.com/chartjs/chartjs-plugin-datalabels/issues/70
   */
  rasterize: function(e) {
    return Math.round(e * Qb) / Qb;
  }
};
function S6(e, t) {
  var n = t.x, o = t.y;
  if (n === null)
    return { x: 0, y: -1 };
  if (o === null)
    return { x: 1, y: 0 };
  var r = e.x - n, i = e.y - o, s = Math.sqrt(r * r + i * i);
  return {
    x: s ? r / s : 0,
    y: s ? i / s : -1
  };
}
function Ooe(e, t, n, o, r) {
  switch (r) {
    case "center":
      n = o = 0;
      break;
    case "bottom":
      n = 0, o = 1;
      break;
    case "right":
      n = 1, o = 0;
      break;
    case "left":
      n = -1, o = 0;
      break;
    case "top":
      n = 0, o = -1;
      break;
    case "start":
      n = -n, o = -o;
      break;
    case "end":
      break;
    default:
      r *= Math.PI / 180, n = Math.cos(r), o = Math.sin(r);
      break;
  }
  return {
    x: e,
    y: t,
    vx: n,
    vy: o
  };
}
var _oe = 0, PM = 1, LM = 2, IM = 4, jM = 8;
function L1(e, t, n) {
  var o = _oe;
  return e < n.left ? o |= PM : e > n.right && (o |= LM), t < n.top ? o |= jM : t > n.bottom && (o |= IM), o;
}
function Poe(e, t) {
  for (var n = e.x0, o = e.y0, r = e.x1, i = e.y1, s = L1(n, o, t), a = L1(r, i, t), c, d, u; !(!(s | a) || s & a); )
    c = s || a, c & jM ? (d = n + (r - n) * (t.top - o) / (i - o), u = t.top) : c & IM ? (d = n + (r - n) * (t.bottom - o) / (i - o), u = t.bottom) : c & LM ? (u = o + (i - o) * (t.right - n) / (r - n), d = t.right) : c & PM && (u = o + (i - o) * (t.left - n) / (r - n), d = t.left), c === s ? (n = d, o = u, s = L1(n, o, t)) : (r = d, i = u, a = L1(r, i, t));
  return {
    x0: n,
    x1: r,
    y0: o,
    y1: i
  };
}
function I1(e, t) {
  var n = t.anchor, o = e, r, i;
  return t.clamp && (o = Poe(o, t.area)), n === "start" ? (r = o.x0, i = o.y0) : n === "end" ? (r = o.x1, i = o.y1) : (r = (o.x0 + o.x1) / 2, i = (o.y0 + o.y1) / 2), Ooe(r, i, e.vx, e.vy, t.align);
}
var j1 = {
  arc: function(e, t) {
    var n = (e.startAngle + e.endAngle) / 2, o = Math.cos(n), r = Math.sin(n), i = e.innerRadius, s = e.outerRadius;
    return I1({
      x0: e.x + o * i,
      y0: e.y + r * i,
      x1: e.x + o * s,
      y1: e.y + r * s,
      vx: o,
      vy: r
    }, t);
  },
  point: function(e, t) {
    var n = S6(e, t.origin), o = n.x * e.options.radius, r = n.y * e.options.radius;
    return I1({
      x0: e.x - o,
      y0: e.y - r,
      x1: e.x + o,
      y1: e.y + r,
      vx: n.x,
      vy: n.y
    }, t);
  },
  bar: function(e, t) {
    var n = S6(e, t.origin), o = e.x, r = e.y, i = 0, s = 0;
    return e.horizontal ? (o = Math.min(e.x, e.base), i = Math.abs(e.base - e.x)) : (r = Math.min(e.y, e.base), s = Math.abs(e.base - e.y)), I1({
      x0: o,
      y0: r + s,
      x1: o + i,
      y1: r,
      vx: n.x,
      vy: n.y
    }, t);
  },
  fallback: function(e, t) {
    var n = S6(e, t.origin);
    return I1({
      x0: e.x,
      y0: e.y,
      x1: e.x + (e.width || 0),
      y1: e.y + (e.height || 0),
      vx: n.x,
      vy: n.y
    }, t);
  }
}, Ri = hc.rasterize;
function Loe(e) {
  var t = e.borderWidth || 0, n = e.padding, o = e.size.height, r = e.size.width, i = -r / 2, s = -o / 2;
  return {
    frame: {
      x: i - n.left - t,
      y: s - n.top - t,
      w: r + n.width + t * 2,
      h: o + n.height + t * 2
    },
    text: {
      x: i,
      y: s,
      w: r,
      h: o
    }
  };
}
function Ioe(e, t) {
  var n = t.chart.getDatasetMeta(t.datasetIndex).vScale;
  if (!n)
    return null;
  if (n.xCenter !== void 0 && n.yCenter !== void 0)
    return { x: n.xCenter, y: n.yCenter };
  var o = n.getBasePixel();
  return e.horizontal ? { x: o, y: null } : { x: null, y: o };
}
function joe(e) {
  return e instanceof Qs ? j1.arc : e instanceof fc ? j1.point : e instanceof pc ? j1.bar : j1.fallback;
}
function Voe(e, t, n, o, r, i) {
  var s = Math.PI / 2;
  if (i) {
    var a = Math.min(i, r / 2, o / 2), c = t + a, d = n + a, u = t + o - a, p = n + r - a;
    e.moveTo(t, d), c < u && d < p ? (e.arc(c, d, a, -Math.PI, -s), e.arc(u, d, a, -s, 0), e.arc(u, p, a, 0, s), e.arc(c, p, a, s, Math.PI)) : c < u ? (e.moveTo(c, n), e.arc(u, d, a, -s, s), e.arc(c, d, a, s, Math.PI + s)) : d < p ? (e.arc(c, d, a, -Math.PI, 0), e.arc(c, p, a, 0, Math.PI)) : e.arc(c, d, a, -Math.PI, Math.PI), e.closePath(), e.moveTo(t, n);
  } else
    e.rect(t, n, o, r);
}
function Doe(e, t, n) {
  var o = n.backgroundColor, r = n.borderColor, i = n.borderWidth;
  !o && (!r || !i) || (e.beginPath(), Voe(
    e,
    Ri(t.x) + i / 2,
    Ri(t.y) + i / 2,
    Ri(t.w) - i,
    Ri(t.h) - i,
    n.borderRadius
  ), e.closePath(), o && (e.fillStyle = o, e.fill()), r && i && (e.strokeStyle = r, e.lineWidth = i, e.lineJoin = "miter", e.stroke()));
}
function Aoe(e, t, n) {
  var o = n.lineHeight, r = e.w, i = e.x, s = e.y + o / 2;
  return t === "center" ? i += r / 2 : (t === "end" || t === "right") && (i += r), {
    h: o,
    w: r,
    x: i,
    y: s
  };
}
function Hoe(e, t, n) {
  var o = e.shadowBlur, r = n.stroked, i = Ri(n.x), s = Ri(n.y), a = Ri(n.w);
  r && e.strokeText(t, i, s, a), n.filled && (o && r && (e.shadowBlur = 0), e.fillText(t, i, s, a), o && r && (e.shadowBlur = o));
}
function Foe(e, t, n, o) {
  var r = o.textAlign, i = o.color, s = !!i, a = o.font, c = t.length, d = o.textStrokeColor, u = o.textStrokeWidth, p = d && u, h;
  if (!(!c || !s && !p))
    for (n = Aoe(n, r, a), e.font = a.string, e.textAlign = r, e.textBaseline = "middle", e.shadowBlur = o.textShadowBlur, e.shadowColor = o.textShadowColor, s && (e.fillStyle = i), p && (e.lineJoin = "round", e.lineWidth = u, e.strokeStyle = d), h = 0, c = t.length; h < c; ++h)
      Hoe(e, t[h], {
        stroked: p,
        filled: s,
        w: n.w,
        x: n.x,
        y: n.y + n.h * h
      });
}
var VM = function(e, t, n, o) {
  var r = this;
  r._config = e, r._index = o, r._model = null, r._rects = null, r._ctx = t, r._el = n;
};
ai(VM.prototype, {
  /**
   * @private
   */
  _modelize: function(e, t, n, o) {
    var r = this, i = r._index, s = Dn(dn([n.font, {}], o, i)), a = dn([n.color, hn.color], o, i);
    return {
      align: dn([n.align, "center"], o, i),
      anchor: dn([n.anchor, "center"], o, i),
      area: o.chart.chartArea,
      backgroundColor: dn([n.backgroundColor, null], o, i),
      borderColor: dn([n.borderColor, null], o, i),
      borderRadius: dn([n.borderRadius, 0], o, i),
      borderWidth: dn([n.borderWidth, 0], o, i),
      clamp: dn([n.clamp, !1], o, i),
      clip: dn([n.clip, !1], o, i),
      color: a,
      display: e,
      font: s,
      lines: t,
      offset: dn([n.offset, 4], o, i),
      opacity: dn([n.opacity, 1], o, i),
      origin: Ioe(r._el, o),
      padding: no(dn([n.padding, 4], o, i)),
      positioner: joe(r._el),
      rotation: dn([n.rotation, 0], o, i) * (Math.PI / 180),
      size: hc.textSize(r._ctx, t, s),
      textAlign: dn([n.textAlign, "start"], o, i),
      textShadowBlur: dn([n.textShadowBlur, 0], o, i),
      textShadowColor: dn([n.textShadowColor, a], o, i),
      textStrokeColor: dn([n.textStrokeColor, a], o, i),
      textStrokeWidth: dn([n.textStrokeWidth, 0], o, i)
    };
  },
  update: function(e) {
    var t = this, n = null, o = null, r = t._index, i = t._config, s, a, c, d = dn([i.display, !0], e, r);
    d && (s = e.dataset.data[r], a = yt(rn(i.formatter, [s, e]), s), c = It(a) ? [] : hc.toTextLines(a), c.length && (n = t._modelize(d, c, i, e), o = Loe(n))), t._model = n, t._rects = o;
  },
  geometry: function() {
    return this._rects ? this._rects.frame : {};
  },
  rotation: function() {
    return this._model ? this._model.rotation : 0;
  },
  visible: function() {
    return this._model && this._model.opacity;
  },
  model: function() {
    return this._model;
  },
  draw: function(e, t) {
    var n = this, o = e.ctx, r = n._model, i = n._rects, s;
    this.visible() && (o.save(), r.clip && (s = r.area, o.beginPath(), o.rect(
      s.left,
      s.top,
      s.right - s.left,
      s.bottom - s.top
    ), o.clip()), o.globalAlpha = hc.bound(0, r.opacity, 1), o.translate(Ri(t.x), Ri(t.y)), o.rotate(r.rotation), Doe(o, i.frame, r), Foe(o, r.lines, i.text, r), o.restore());
  }
});
var Noe = Number.MIN_SAFE_INTEGER || -9007199254740991, $oe = Number.MAX_SAFE_INTEGER || 9007199254740991;
function V2(e, t, n) {
  var o = Math.cos(n), r = Math.sin(n), i = t.x, s = t.y;
  return {
    x: i + o * (e.x - i) - r * (e.y - s),
    y: s + r * (e.x - i) + o * (e.y - s)
  };
}
function eC(e, t) {
  var n = $oe, o = Noe, r = t.origin, i, s, a, c, d;
  for (i = 0; i < e.length; ++i)
    s = e[i], a = s.x - r.x, c = s.y - r.y, d = t.vx * a + t.vy * c, n = Math.min(n, d), o = Math.max(o, d);
  return {
    min: n,
    max: o
  };
}
function V1(e, t) {
  var n = t.x - e.x, o = t.y - e.y, r = Math.sqrt(n * n + o * o);
  return {
    vx: (t.x - e.x) / r,
    vy: (t.y - e.y) / r,
    origin: e,
    ln: r
  };
}
var DM = function() {
  this._rotation = 0, this._rect = {
    x: 0,
    y: 0,
    w: 0,
    h: 0
  };
};
ai(DM.prototype, {
  center: function() {
    var e = this._rect;
    return {
      x: e.x + e.w / 2,
      y: e.y + e.h / 2
    };
  },
  update: function(e, t, n) {
    this._rotation = n, this._rect = {
      x: t.x + e.x,
      y: t.y + e.y,
      w: t.w,
      h: t.h
    };
  },
  contains: function(e) {
    var t = this, n = 1, o = t._rect;
    return e = V2(e, t.center(), -t._rotation), !(e.x < o.x - n || e.y < o.y - n || e.x > o.x + o.w + n * 2 || e.y > o.y + o.h + n * 2);
  },
  // Separating Axis Theorem
  // https://gamedevelopment.tutsplus.com/tutorials/collision-detection-using-the-separating-axis-theorem--gamedev-169
  intersects: function(e) {
    var t = this._points(), n = e._points(), o = [
      V1(t[0], t[1]),
      V1(t[0], t[3])
    ], r, i, s;
    for (this._rotation !== e._rotation && o.push(
      V1(n[0], n[1]),
      V1(n[0], n[3])
    ), r = 0; r < o.length; ++r)
      if (i = eC(t, o[r]), s = eC(n, o[r]), i.max < s.min || s.max < i.min)
        return !1;
    return !0;
  },
  /**
   * @private
   */
  _points: function() {
    var e = this, t = e._rect, n = e._rotation, o = e.center();
    return [
      V2({ x: t.x, y: t.y }, o, n),
      V2({ x: t.x + t.w, y: t.y }, o, n),
      V2({ x: t.x + t.w, y: t.y + t.h }, o, n),
      V2({ x: t.x, y: t.y + t.h }, o, n)
    ];
  }
});
function AM(e, t, n) {
  var o = t.positioner(e, t), r = o.vx, i = o.vy;
  if (!r && !i)
    return { x: o.x, y: o.y };
  var s = n.w, a = n.h, c = t.rotation, d = Math.abs(s / 2 * Math.cos(c)) + Math.abs(a / 2 * Math.sin(c)), u = Math.abs(s / 2 * Math.sin(c)) + Math.abs(a / 2 * Math.cos(c)), p = 1 / Math.max(Math.abs(r), Math.abs(i));
  return d *= r * p, u *= i * p, d += t.offset * r, u += t.offset * i, {
    x: o.x + d,
    y: o.y + u
  };
}
function Boe(e, t) {
  var n, o, r, i;
  for (n = e.length - 1; n >= 0; --n)
    for (r = e[n].$layout, o = n - 1; o >= 0 && r._visible; --o)
      i = e[o].$layout, i._visible && r._box.intersects(i._box) && t(r, i);
  return e;
}
function zoe(e) {
  var t, n, o, r, i, s, a;
  for (t = 0, n = e.length; t < n; ++t)
    o = e[t], r = o.$layout, r._visible && (a = new Proxy(o._el, { get: (c, d) => c.getProps([d], !0)[d] }), i = o.geometry(), s = AM(a, o.model(), i), r._box.update(s, i, o.rotation()));
  return Boe(e, function(c, d) {
    var u = c._hidable, p = d._hidable;
    u && p || p ? d._visible = !1 : u && (c._visible = !1);
  });
}
var gc = {
  prepare: function(e) {
    var t = [], n, o, r, i, s;
    for (n = 0, r = e.length; n < r; ++n)
      for (o = 0, i = e[n].length; o < i; ++o)
        s = e[n][o], t.push(s), s.$layout = {
          _box: new DM(),
          _hidable: !1,
          _visible: !0,
          _set: n,
          _idx: s._index
        };
    return t.sort(function(a, c) {
      var d = a.$layout, u = c.$layout;
      return d._idx === u._idx ? u._set - d._set : u._idx - d._idx;
    }), this.update(t), t;
  },
  update: function(e) {
    var t = !1, n, o, r, i, s;
    for (n = 0, o = e.length; n < o; ++n)
      r = e[n], i = r.model(), s = r.$layout, s._hidable = i && i.display === "auto", s._visible = r.visible(), t |= s._hidable;
    t && zoe(e);
  },
  lookup: function(e, t) {
    var n, o;
    for (n = e.length - 1; n >= 0; --n)
      if (o = e[n].$layout, o && o._visible && o._box.contains(t))
        return e[n];
    return null;
  },
  draw: function(e, t) {
    var n, o, r, i, s, a;
    for (n = 0, o = t.length; n < o; ++n)
      r = t[n], i = r.$layout, i._visible && (s = r.geometry(), a = AM(r._el, r.model(), s), i._box.update(a, s, r.rotation()), r.draw(e, a));
  }
}, Zoe = function(e) {
  if (It(e))
    return null;
  var t = e, n, o, r;
  if (Dt(e))
    if (!It(e.label))
      t = e.label;
    else if (!It(e.r))
      t = e.r;
    else
      for (t = "", n = Object.keys(e), r = 0, o = n.length; r < o; ++r)
        t += (r !== 0 ? ", " : "") + n[r] + ": " + e[n[r]];
  return "" + t;
}, Woe = {
  align: "center",
  anchor: "center",
  backgroundColor: null,
  borderColor: null,
  borderRadius: 0,
  borderWidth: 0,
  clamp: !1,
  clip: !1,
  color: void 0,
  display: !0,
  font: {
    family: void 0,
    lineHeight: 1.2,
    size: void 0,
    style: void 0,
    weight: null
  },
  formatter: Zoe,
  labels: void 0,
  listeners: {},
  offset: 4,
  opacity: 1,
  padding: {
    top: 4,
    right: 4,
    bottom: 4,
    left: 4
  },
  rotation: 0,
  textAlign: "start",
  textStrokeColor: void 0,
  textStrokeWidth: 0,
  textShadowBlur: 0,
  textShadowColor: void 0
}, Oo = "$datalabels", HM = "$default";
function Uoe(e, t) {
  var n = e.datalabels, o = {}, r = [], i, s;
  return n === !1 ? null : (n === !0 && (n = {}), t = ai({}, [t, n]), i = t.labels || {}, s = Object.keys(i), delete t.labels, s.length ? s.forEach(function(a) {
    i[a] && r.push(ai({}, [
      t,
      i[a],
      { _key: a }
    ]));
  }) : r.push(t), o = r.reduce(function(a, c) {
    return en(c.listeners || {}, function(d, u) {
      a[u] = a[u] || {}, a[u][c._key || HM] = d;
    }), delete c.listeners, a;
  }, {}), {
    labels: r,
    listeners: o
  });
}
function d5(e, t, n, o) {
  if (t) {
    var r = n.$context, i = n.$groups, s;
    t[i._set] && (s = t[i._set][i._key], s && rn(s, [r, o]) === !0 && (e[Oo]._dirty = !0, n.update(r)));
  }
}
function Goe(e, t, n, o, r) {
  var i, s;
  !n && !o || (n ? o ? n !== o && (s = i = !0) : s = !0 : i = !0, s && d5(e, t.leave, n, r), i && d5(e, t.enter, o, r));
}
function qoe(e, t) {
  var n = e[Oo], o = n._listeners, r, i;
  if (!(!o.enter && !o.leave)) {
    if (t.type === "mousemove")
      i = gc.lookup(n._labels, t);
    else if (t.type !== "mouseout")
      return;
    r = n._hovered, n._hovered = i, Goe(e, o, r, i, t);
  }
}
function Koe(e, t) {
  var n = e[Oo], o = n._listeners.click, r = o && gc.lookup(n._labels, t);
  r && d5(e, o, r, t);
}
var Yoe = {
  id: "datalabels",
  defaults: Woe,
  beforeInit: function(e) {
    e[Oo] = {
      _actives: []
    };
  },
  beforeUpdate: function(e) {
    var t = e[Oo];
    t._listened = !1, t._listeners = {}, t._datasets = [], t._labels = [];
  },
  afterDatasetUpdate: function(e, t, n) {
    var o = t.index, r = e[Oo], i = r._datasets[o] = [], s = e.isDatasetVisible(o), a = e.data.datasets[o], c = Uoe(a, n), d = t.meta.data || [], u = e.ctx, p, h, g, m, b, C, x, v;
    for (u.save(), p = 0, g = d.length; p < g; ++p)
      if (x = d[p], x[Oo] = [], s && x && e.getDataVisibility(p) && !x.skip)
        for (h = 0, m = c.labels.length; h < m; ++h)
          b = c.labels[h], C = b._key, v = new VM(b, u, x, p), v.$groups = {
            _set: o,
            _key: C || HM
          }, v.$context = {
            active: !1,
            chart: e,
            dataIndex: p,
            dataset: a,
            datasetIndex: o
          }, v.update(v.$context), x[Oo].push(v), i.push(v);
    u.restore(), ai(r._listeners, c.listeners, {
      merger: function(S, M, w) {
        M[S] = M[S] || {}, M[S][t.index] = w[S], r._listened = !0;
      }
    });
  },
  afterUpdate: function(e) {
    e[Oo]._labels = gc.prepare(e[Oo]._datasets);
  },
  // Draw labels on top of all dataset elements
  // https://github.com/chartjs/chartjs-plugin-datalabels/issues/29
  // https://github.com/chartjs/chartjs-plugin-datalabels/issues/32
  afterDatasetsDraw: function(e) {
    gc.draw(e, e[Oo]._labels);
  },
  beforeEvent: function(e, t) {
    if (e[Oo]._listened) {
      var n = t.event;
      switch (n.type) {
        case "mousemove":
        case "mouseout":
          qoe(e, n);
          break;
        case "click":
          Koe(e, n);
          break;
      }
    }
  },
  afterEvent: function(e) {
    var t = e[Oo], n = t._actives, o = t._actives = e.getActiveElements(), r = hc.arrayDiff(n, o), i, s, a, c, d, u, p;
    for (i = 0, s = r.length; i < s; ++i)
      if (d = r[i], d[1])
        for (p = d[0].element[Oo] || [], a = 0, c = p.length; a < c; ++a)
          u = p[a], u.$context.active = d[1] === 1, u.update(u.$context);
    (t._dirty || r.length) && (gc.update(t._labels), e.render()), delete t._dirty;
  }
};
const Hn = (e, t) => parseInt(e.spacing(t)), H7 = ({ unit: e } = {}) => (t) => ({
  animation: !1,
  responsive: !0,
  maintainAspectRatio: !1,
  font: { family: "Montserrat", weight: "400" },
  interaction: {
    mode: "index",
    intersect: !0,
    axis: "x"
  },
  scales: {
    x: {
      ticks: {
        font: { family: "Montserrat" },
        padding: Hn(t, 2)
      },
      grid: {
        display: !1,
        tickLength: 0
      }
    },
    y: {
      grace: "5%",
      ticks: {
        font: { family: "Montserrat" },
        padding: Hn(t, 2)
      },
      border: {
        dash: [4, 4],
        display: !0
      },
      grid: {
        tickLength: 0
      }
    }
  },
  layout: {
    padding: Hn(t, 3)
  },
  plugins: {
    legend: {
      display: !1
    },
    datalabels: {
      display: !1
    },
    title: {
      display: !!e,
      text: e,
      align: "start",
      position: "top",
      fullSize: !0,
      padding: {
        bottom: Hn(t, 4),
        top: Hn(t, 2)
      },
      font: {
        family: "Montserrat",
        weight: "400",
        size: Hn(t, 1.75)
      }
    },
    tooltip: {
      enabled: !0,
      yAlign: "bottom",
      position: "nearest",
      titleFont: {
        family: "Montserrat",
        weight: "700",
        size: Hn(t, 1.75)
      },
      bodyFont: {
        family: "Montserrat",
        weight: "500",
        size: Hn(t, 1.5)
      },
      titleColor: t.custom.grey[2800],
      titleMarginBottom: Hn(t, 1.25),
      bodyColor: t.custom.grey[2800],
      bodySpacing: Hn(t, 0.75),
      padding: {
        top: Hn(t, 1.25),
        bottom: Hn(t, 1.25),
        left: Hn(t, 2.5),
        right: Hn(t, 2.5)
      },
      cornerRadius: Hn(t, 1),
      displayColors: !0,
      boxHeight: Hn(t, 1.25),
      boxWidth: Hn(t, 1.25),
      backgroundColor: t.custom.grey[100],
      borderColor: t.custom.grey[400],
      borderWidth: 1,
      boxPadding: Hn(t, 1),
      caretPadding: Hn(t, 1.75),
      usePointStyle: !0,
      multiKeyBackground: "transparent",
      caretSize: 8,
      callbacks: {
        title: (n) => {
          var o;
          return ((o = n[0]) == null ? void 0 : o.label) || "";
        },
        label: (n) => {
          const o = n.dataset.label || "", r = n.formattedValue;
          return r === "0" ? "" : e ? `${o ? `${o}: ` : ""}${r} ${e}` : `${o ? `${o}: ` : ""} ${r}`;
        },
        labelTextColor: () => t.custom.grey[2800],
        labelPointStyle: (n) => ({
          pointStyle: n.dataset.type === "line" ? "line" : "rect",
          rotation: 0
        })
      }
    }
  }
}), Xoe = (e) => {
  const { values: t, color: n, theme: o, updateCurrentSelectedPoint: r, ...i } = e;
  return {
    ...i,
    data: Joe(t, n),
    options: Qoe(o, r),
    plugins: [tre]
  };
}, Joe = (e, t) => ({
  datasets: [
    {
      data: e,
      backgroundColor: t,
      pointStyle: "circle",
      pointRadius: 8,
      pointHoverRadius: 9
    }
  ],
  labels: Array.from(e.map((n) => n.label))
}), Qoe = (e, t) => {
  var s, a, c, d;
  const n = {
    color: "#403d58",
    formatter: function(u) {
      return u.label;
    },
    align: "right",
    clamp: !0,
    padding: {
      left: 25
    },
    font: {
      weight: 600,
      size: 12,
      family: e.typography.fontFamily
    }
  }, o = H7(), r = (a = (s = o(e).scales) == null ? void 0 : s.x) == null ? void 0 : a.ticks, i = (d = (c = o(e).scales) == null ? void 0 : c.y) == null ? void 0 : d.ticks;
  return {
    plugins: {
      datalabels: n,
      legend: {
        display: !1,
        usePointStyle: !0
      },
      tooltip: {
        enabled: !1,
        external: ere
      }
    },
    scales: {
      x: {
        ticks: r,
        beginAtZero: !0,
        grace: "15%",
        linear: !0,
        border: {
          dash: [5, 5]
        }
      },
      y: {
        ticks: i,
        beginAtZero: !0,
        linear: !0,
        grace: "20%",
        border: {
          dash: [5, 5]
        }
      }
    },
    layout: {
      padding: {
        left: 25,
        right: 25,
        top: 15,
        bottom: 15
      }
    },
    onHover: (u, p) => {
      if (u.type === "click") {
        if (p.length) {
          t(p[0].index, u.x, u.y);
          return;
        }
        t(null, null, null);
      }
    }
  };
}, tC = {
  opacity: "0",
  position: "absolute",
  backgroundColor: "#393A36",
  color: "#fff",
  borderRadius: "4px",
  padding: "6px",
  pointerEvents: "none",
  textAlign: "center",
  fontSize: "10px",
  fontWeight: "600",
  minWidth: "30px"
}, ere = (e) => {
  const { chart: t, tooltip: n } = e;
  let o = document.getElementById("chartjs-tooltip-x");
  o || (o = document.createElement("div"), o.id = "chartjs-tooltip-x", Object.assign(o.style, tC), document.body.appendChild(o));
  let r = document.getElementById("chartjs-tooltip-y");
  if (r || (r = document.createElement("div"), r.id = "chartjs-tooltip-y", Object.assign(r.style, tC), document.body.appendChild(r)), n.opacity === 0) {
    o.style.opacity = "0", r.style.opacity = "0";
    return;
  }
  if (n.dataPoints) {
    const b = n.dataPoints[0], { x: C, y: x } = b.raw;
    o.textContent = `${C.toFixed(3)}`, r.textContent = `${x.toFixed(3)}`;
  }
  const i = t.canvas.getBoundingClientRect(), s = t.scales.x, c = t.scales.y.bottom + i.top + window.scrollY, d = s.left + i.left + window.scrollX, u = i.left + window.scrollX + n.caretX - o.offsetWidth / 2, p = c;
  o.style.left = `${u}px`, o.style.top = `${p}px`, o.style.opacity = "1";
  const h = d - r.offsetWidth, g = i.top + window.scrollY + n.caretY - r.offsetHeight / 2;
  r.style.left = `${h}px`, r.style.top = `${g}px`, r.style.opacity = "1";
}, tre = {
  id: "crosshair",
  defaults: {
    width: 1,
    color: "#000000",
    dash: [],
    tooltipBackground: "#f5f5f5",
    tooltipTextColor: "#000000",
    tooltipFontSize: 10,
    tooltipPadding: 6,
    tooltipRadius: 4
  },
  afterInit: (e) => {
    e.crosshair = {
      x: 0,
      y: 0,
      draw: !1,
      xValue: null,
      yValue: null
    };
  },
  afterEvent: (e, t) => {
    const { inChartArea: n } = t, o = e.getElementsAtEventForMode(t.event, "nearest", { intersect: !0 }, !1);
    if (o.length) {
      const r = o[0].index, i = e.data.datasets[0].data[r], { x: s, y: a } = o[0].element;
      e.crosshair = {
        x: s,
        y: a,
        draw: n,
        xValue: i.x,
        yValue: i.y
      };
    } else
      e.crosshair.draw = !1;
    e.draw();
  },
  beforeDatasetsDraw: (e) => {
    var d, u, p, h, g, m, b, C;
    const { ctx: t, crosshair: n } = e;
    if (!n) return;
    const { bottom: o, left: r } = e.chartArea, { x: i, y: s, draw: a } = n;
    if (!a) return;
    t.save(), t.beginPath(), t.lineWidth = ((u = (d = e.options.plugins) == null ? void 0 : d.crosshair) == null ? void 0 : u.width) ?? 1, t.strokeStyle = ((h = (p = e.options.plugins) == null ? void 0 : p.crosshair) == null ? void 0 : h.color) ?? "#000000";
    const c = ((m = (g = e.options.plugins) == null ? void 0 : g.crosshair) == null ? void 0 : m.dash) ?? [];
    t.setLineDash(c.filter((x) => x !== void 0)), t.moveTo(i, s), t.lineTo(i, o), t.moveTo(r, s), t.lineTo(i, s), t.stroke(), t.font = `${((C = (b = e.options.plugins) == null ? void 0 : b.crosshair) == null ? void 0 : C.tooltipFontSize) ?? 10}px ${t.font.split(" ").slice(-1)}`, t.textAlign = "center", t.textBaseline = "middle", t.restore();
  }
};
F0.register(...Dte, Yoe);
const Uxe = (e) => {
  const t = (i, s, a) => {
    var u;
    if (i === null || !((u = e.values) != null && u[i]) || s === null || a === null) {
      e.onPointSelection(null);
      return;
    }
    const d = { point: e.values[i], absoluteCoordinate: { x: s, y: a } };
    e.onPointSelection(d);
  }, n = "#F6A500", o = ge(), r = Xoe({
    ...e,
    color: o.palette.primary[500] ?? n,
    theme: o,
    updateCurrentSelectedPoint: t
  });
  return /* @__PURE__ */ f.jsxs(
    J,
    {
      sx: {
        backgroundColor: o.custom.grey[200],
        borderRadius: "8px",
        border: `1px solid ${o.custom.grey[500]}`,
        padding: "12px"
      },
      children: [
        e.y,
        /* @__PURE__ */ f.jsx(Bte, { ...r }),
        /* @__PURE__ */ f.jsx(
          J,
          {
            sx: {
              width: "100%",
              display: "flex",
              justifyContent: "flex-end"
            },
            children: e.x
          }
        )
      ]
    }
  );
}, nC = (e) => {
  var M;
  const {
    chart: t,
    datasetIndex: n,
    dataIndex: o,
    evolution: r,
    reverse: i,
    positiveArrowIcon: s = "arrowUp",
    negativeArrowIcon: a = "arrowDown",
    positiveColor: c,
    negativeColor: d
  } = e, u = St(), [p, h] = Ae([0, 0, 0]);
  if (mt(() => {
    !u.current || !t || n === void 0 || h([u.current.offsetWidth, u.current.offsetHeight]);
  }, [t, o, n]), !t || n === void 0) return null;
  const g = t.canvas.getBoundingClientRect(), m = g.top + window.scrollY + t.getDatasetMeta(n).data[o].y - p[1] - 10, b = g.left + window.scrollX + t.getDatasetMeta(n).data[o].x - p[0] / 2;
  console.log(t.canvas.getBoundingClientRect().top, window.scrollY);
  const C = Math.sign(r ?? 0), x = C === -1 ? i ? c : d : i ? d : c, v = C === -1 ? i ? c : d : i ? d : c, S = C === -1 ? a : s;
  return T_(
    /* @__PURE__ */ f.jsx(J, { ref: u, position: "absolute", top: m + "px", left: b + "px", children: /* @__PURE__ */ f.jsx(Tr, { sx: ore, children: /* @__PURE__ */ f.jsxs(be, { direction: "row", justifyContent: "center", alignItems: "center", paddingX: 1, paddingY: 0.5, display: "flex", gap: 1, children: [
      /* @__PURE__ */ f.jsx(oe, { fontWeight: 700, fontSize: "10px", lineHeight: "16px", children: (M = t.data.datasets[n].data[o]) == null ? void 0 : M.toString() }),
      /* @__PURE__ */ f.jsx(nre, { evolution: r, color: x, backgroundColor: v, icon: S })
    ] }) }) }),
    document.body
  );
}, nre = (e) => {
  const { evolution: t, color: n, icon: o } = e;
  return t === void 0 ? null : /* @__PURE__ */ f.jsxs(be, { direction: "row", justifyContent: "center", alignItems: "center", gap: 0.5, color: n, children: [
    /* @__PURE__ */ f.jsx(_t, { icon: o, size: 0.2 }),
    /* @__PURE__ */ f.jsxs(oe, { fontWeight: 700, fontSize: "10px", children: [
      Math.round(t),
      " %"
    ] })
  ] });
}, ore = {
  minWidth: "35px",
  minHeight: "24px",
  overflow: "visible",
  borderRadius: "8xp",
  boxShadow: "0px 4px 20px 0px rgba(81, 78, 78, 0.12)",
  "&::after": {
    boxShadow: "0px 4px 20px 0px rgba(81, 78, 78, 0.12)",
    content: '""',
    position: "absolute",
    left: 0,
    right: 0,
    margin: "-1px auto",
    width: 0,
    height: 0,
    borderTop: "7.5px solid white",
    borderLeft: "15px solid transparent",
    borderRight: "15px solid transparent"
  }
}, rre = (e) => e.data.datasets.forEach((t) => {
  t.type === "line" && (t.hidden = !0);
}), ire = (e, t, n = !1) => {
  if (t === null) return;
  const o = e.data.datasets.filter((i) => i.type === "bar").length, r = n ? t + o * 2 : t;
  e.data.datasets[r - o * 2].hidden = !1, e.data.datasets[r - o].hidden = !1, e.update();
}, sre = (e) => {
  const t = e.data.datasets.filter((n) => n.type === "bar").length ?? 0;
  e.data.datasets.forEach((n, o) => {
    n.type === "bar" && (n.backgroundColor = ca[o % t]);
  });
}, are = (e, t, n = "66") => {
  const o = e.data.datasets.filter((r) => r.type === "bar").length ?? 0;
  e.data.datasets.forEach((r, i) => {
    r.type === "bar" && (i === t ? r.backgroundColor = ca[i % o] : r.backgroundColor = ca[i % o] + n);
  });
}, ca = [
  "#ff8025",
  "#4dcdf0",
  "#f98cc0",
  "#2b59a4",
  "#ffb400",
  "#db3d53",
  "#00a950",
  "#58595b",
  "#8549ba"
], lre = (e) => {
  const t = ge(), { labels: n, icons: o, chart: r, handleOnMouseOver: i, legend: s, labelIndex: a } = e, c = r.data.datasets.findIndex((g) => g.type === "bar") ?? 0, u = (g) => {
    const m = g !== null ? g + c : void 0;
    i(r, m);
  }, p = n.map((g, m) => m), h = ca;
  return /* @__PURE__ */ f.jsx(be, { className: "doughnut-chart-legend-wrapper", children: /* @__PURE__ */ f.jsx(be, { display: "inline-flex", children: n.map((g, m) => {
    const b = p && p[m] !== void 0;
    return /* @__PURE__ */ f.jsx(
      be,
      {
        direction: "row",
        alignItems: "center",
        gap: "12px",
        padding: t.spacing(1, 2),
        onMouseEnter: () => {
          b && u(m);
        },
        onMouseLeave: () => u(null),
        sx: {
          backgroundColor: (C) => a === m ? C.custom.grey[300] : "",
          ...m === 0 ? {} : { borderTop: (C) => `1px solid ${C.custom.grey[500]}` }
        },
        children: /* @__PURE__ */ f.jsxs(be, { direction: "row", alignItems: "center", gap: "12px", sx: { width: "100%" }, children: [
          o && /* @__PURE__ */ f.jsx(
            be,
            {
              sx: {
                backgroundColor: (C) => b ? h[m] : C.custom.grey[400],
                color: "white"
              },
              p: 0.5,
              borderRadius: "4px",
              children: /* @__PURE__ */ f.jsx(_t, { icon: o[m] ?? "default", size: 3.5 })
            }
          ),
          !o && /* @__PURE__ */ f.jsx(
            J,
            {
              minWidth: "10px",
              height: "10px",
              bgcolor: (C) => b ? h[m] : C.custom.grey[400]
            }
          ),
          /* @__PURE__ */ f.jsx(oe, { variant: "h5", className: "doughnut-chart-legend-item-label", children: g }),
          (s == null ? void 0 : s.actions) && (s == null ? void 0 : s.seeMore) && (s == null ? void 0 : s.actions[m]) && /* @__PURE__ */ f.jsx(
            A7,
            {
              action: s == null ? void 0 : s.actions[m],
              seeMore: s == null ? void 0 : s.seeMore
            }
          )
        ] })
      },
      m
    );
  }) }) });
}, cre = {
  id: "lineReposition",
  beforeDatasetsDraw(e, t, n) {
    const {
      ctx: o,
      data: r,
      scales: { x: i }
    } = e;
    o.save();
    const s = e.getDatasetMeta(r.datasets.length - 1).data[0].width, a = e.data.datasets.filter((d) => d.type === "bar").length, c = r.datasets.findIndex((d) => d.type === "bar");
    r.datasets.forEach((d, u) => {
      if (d.type === "line" && d.kind === "top") {
        const p = u + c - a;
        i.ticks.forEach((h, g) => {
          const m = s / 2, b = g % 2 === 0 ? m : -m;
          e.getDatasetMeta(u).data[g].x = i.getPixelForValue(i.ticks[g].value) + b;
          const C = e.getDatasetMeta(p).data[g % 2].y, { height: x } = e.getDatasetMeta(p).data[g % 2].getProps(["height"]);
          e.getDatasetMeta(u).data[g].y = C + x;
        });
      }
      d.type === "line" && d.kind === "bottom" && i.ticks.forEach((p, h) => {
        const g = u + c, m = s / 2, b = h % 2 === 0 ? m : -m;
        e.getDatasetMeta(u).data[h].x = i.getPixelForValue(i.ticks[h].value) + b, e.getDatasetMeta(u).data[h].y = e.getDatasetMeta(g).data[h % 2].y;
      });
    });
  }
}, dre = () => {
  const e = St(), [t, n] = Ae(!1);
  return mt(() => {
    e.current && n(!0);
  }, []), mt(() => {
    if (!e.current) return;
    const o = () => e.current.resize();
    return window.addEventListener("resize", o), () => {
      window.removeEventListener("resize", o);
    };
  }, []), {
    ref: e,
    chartReady: t
  };
}, ure = () => {
  const [e, t] = Ae(), [n, o] = Ae(0);
  return {
    datasetIndex: e,
    evolution: n,
    highlightDataset: (i, s) => {
      if (rre(i), s === void 0) {
        t(void 0), sre(i);
        return;
      }
      t(s);
      const a = i.data.datasets[s], c = (a.data[a.data.length - 1] - a.data[0]) / a.data[0] * 100;
      o(c), are(i, s), ire(i, s);
    }
  };
}, fre = (e, t) => {
  var b, C, x, v;
  const n = ge(), { ref: o, chartReady: r } = dre(), { datasetIndex: i, evolution: s, highlightDataset: a } = ure(), c = tn(
    () => [
      ...t.map((S, M) => ({
        ...S,
        type: "line",
        backgroundColor: ca[M] + "66",
        label: `line - 1${M}`,
        hidden: !0,
        fill: "+3",
        kind: "bottom"
      })),
      ...t.map((S, M) => ({
        ...S,
        type: "line",
        backgroundColor: ca[M] + "66",
        label: `line - 0${M}`,
        hidden: !0,
        kind: "top"
      })),
      ...t.map((S, M) => ({
        ...S,
        type: "bar",
        backgroundColor: ca[M],
        barPercentage: 0.4,
        categoryPercentage: 0.9,
        stack: ""
      }))
    ],
    [t]
  ), d = {
    labels: e,
    datasets: c
  }, u = [cre], p = H7(), h = (C = (b = p(n).scales) == null ? void 0 : b.x) == null ? void 0 : C.ticks, g = (v = (x = p(n).scales) == null ? void 0 : x.y) == null ? void 0 : v.ticks;
  return {
    data: d,
    type: "line",
    ref: o,
    options: {
      animation: !1,
      responsive: !0,
      maintainAspectRatio: !1,
      plugins: {
        legend: { display: !1 },
        filler: {
          propagate: !1
        },
        datalabels: {
          display: !1
        },
        tooltip: {
          enabled: !1,
          external: () => {
          }
        }
      },
      scales: {
        x: {
          ticks: h,
          grid: {
            display: !1
          }
        },
        y: {
          ticks: g
        }
      }
    },
    plugins: u,
    highlightDataset: a,
    chartReady: r,
    evolution: s,
    datasetIndex: i,
    labelIndex: i !== void 0 ? i % t.length : void 0
  };
}, Gxe = (e) => {
  const t = ge(), {
    values: n,
    labels: o,
    icons: r,
    positiveArrowIcon: i = "arrowUpRight",
    negativeArrowIcon: s = "arrowDownRight",
    reverse: a = !1,
    positiveColor: c = t.custom.green[500],
    negativeColor: d = t.custom.red[500],
    legend: u,
    height: p = "100%",
    width: h = "100%"
  } = e, g = { positiveArrowIcon: i, negativeArrowIcon: s }, m = { positiveColor: c, negativeColor: d }, {
    chartReady: b,
    data: C,
    datasetIndex: x,
    labelIndex: v,
    highlightDataset: S,
    evolution: M,
    options: w,
    plugins: k,
    ref: E,
    type: R
  } = fre(o, n), O = (P) => {
    var j;
    if (!E.current) return;
    const _ = E.current, L = Fte(_, P), V = (j = L == null ? void 0 : L[0]) == null ? void 0 : j.datasetIndex;
    S(_, V);
  };
  return /* @__PURE__ */ f.jsxs(
    be,
    {
      position: "relative",
      direction: (u == null ? void 0 : u.position) === "bottom" ? "column" : "row",
      flexWrap: "wrap",
      sx: { backgroundColor: "white" },
      children: [
        /* @__PURE__ */ f.jsx(J, { flex: 2, width: "100%", height: "100%", children: /* @__PURE__ */ f.jsx(
          W3,
          {
            height: p,
            width: h,
            ref: E,
            type: R,
            data: C,
            options: w,
            plugins: k,
            onMouseMove: O
          }
        ) }),
        /* @__PURE__ */ f.jsx(J, { flex: 1, width: "100%", children: b && /* @__PURE__ */ f.jsx(
          lre,
          {
            labels: n.map(({ label: P }) => P),
            icons: r,
            handleOnMouseOver: S,
            chart: E.current,
            legend: u,
            labelIndex: v
          }
        ) }),
        /* @__PURE__ */ f.jsx(
          nC,
          {
            ...g,
            ...m,
            reverse: a,
            chart: E.current,
            datasetIndex: x,
            dataIndex: 0
          }
        ),
        /* @__PURE__ */ f.jsx(
          nC,
          {
            ...g,
            ...m,
            reverse: a,
            chart: E.current,
            datasetIndex: x,
            dataIndex: 1,
            evolution: M
          }
        )
      ]
    }
  );
}, pre = (e) => {
  const { startingValue: t, differences: n } = e, o = {
    pivot: null,
    results: []
  };
  return n.reduce((i, s) => {
    const a = i.pivot ?? t, c = a + s;
    return i.results.push([
      a,
      c
    ]), i.pivot = c, i;
  }, o).results;
}, hre = () => {
  const e = St(), [t, n] = Ae(!1);
  return mt(() => {
    e.current && n(!0);
  }, []), mt(() => {
    if (!e.current) return;
    const o = () => e.current.resize();
    return window.addEventListener("resize", o), () => {
      window.removeEventListener("resize", o);
    };
  }, []), {
    ref: e,
    chartReady: t
  };
}, gre = (e, t, n, o, r, i, s, a, c) => {
  const { chartReady: d, ref: u } = hre(), p = ge(), h = tn(
    () => i != null && i.length ? i.map((k) => k.value).filter((k) => k !== null) : null,
    [i]
  ), g = tn(() => h ? h.reduce((k, E) => k + E, 0) : null, [h]), m = tn(
    () => i != null && i.length ? i.filter((k) => k.value !== null).map((k) => k.label) : [],
    [i]
  ), b = tn(
    () => [
      ...o != null && o.label ? [o.label] : [],
      ...r != null && r.label ? [r.label] : [],
      ...m,
      ...s != null && s.label ? [s.label] : [" "],
      ...a != null && a.label ? [a.label] : []
    ].filter(Boolean),
    [o == null ? void 0 : o.label, r == null ? void 0 : r.label, m, s == null ? void 0 : s.label, a == null ? void 0 : a.label]
  ), C = tn(() => [(() => {
    const R = ((i == null ? void 0 : i.filter((H) => H.value !== null)) || []).map((H) => H.label), O = pre({
      startingValue: (r == null ? void 0 : r.value) ?? (o == null ? void 0 : o.value) ?? 0,
      differences: h ?? []
    }), P = new Array(b.length).fill(null), _ = o != null && o.label ? b.indexOf(o.label) : -1, L = r != null && r.label ? b.indexOf(r.label) : -1;
    _ >= 0 && (P[_] = [0, (o == null ? void 0 : o.value) ?? 0]), L >= 0 && (P[L] = [0, (r == null ? void 0 : r.value) ?? 0]);
    const V = b.findIndex((H) => R.includes(H)) ?? 2;
    V >= 0 && b.slice(V).forEach((H, N) => {
      const z = N + V, se = R.indexOf(H);
      se !== -1 && se < O.length && (P[z] = O[se]);
    });
    const j = b.findIndex((H) => (s == null ? void 0 : s.label) === H || H === " "), I = b.findIndex((H) => (a == null ? void 0 : a.label) === H);
    j >= 0 && (P[j] = [0, (s == null ? void 0 : s.value) ?? ((r == null ? void 0 : r.value) ?? (o == null ? void 0 : o.value) ?? 0) + (g ?? 0)]), I >= 0 && (P[I] = [0, (a == null ? void 0 : a.value) ?? (s == null ? void 0 : s.value) ?? 0]);
    const F = P.map((H) => H === null ? [0, 0] : H), $ = {
      [_]: (t == null ? void 0 : t.reference) ?? p.custom.dataviz.colors[2].main,
      [L]: (t == null ? void 0 : t.start) ?? p.custom.dataviz.colors[4].main,
      ...j >= 0 && { [j]: (t == null ? void 0 : t.target) ?? p.custom.dataviz.colors[4].main },
      ...I >= 0 && { [I]: (t == null ? void 0 : t.goal) ?? p.custom.dataviz.extra[12].main }
    }, A = P.map(
      (H, N) => $[N] || (i != null && i.some((z) => z.label === b[N]) ? H && H[1] - H[0] <= 0 ? c === "decrease" ? p.custom.dataviz.extra[14].main : p.custom.dataviz.colors[6].main : c === "decrease" ? p.custom.dataviz.colors[6].main : p.custom.dataviz.extra[14].main : "rgba(0, 0, 0, 0)")
    );
    return {
      type: "bar",
      label: "Waterfall",
      data: F,
      backgroundColor: A
    };
  })()], [o, r, h, t, s, a, p, b, i]), x = {
    labels: b,
    datasets: C
  }, v = H7({ unit: n })(p), S = pr((k) => {
    if (Array.isArray(k) && k.length === 2 && typeof k[0] == "number" && typeof k[1] == "number") {
      const [E, R] = k;
      return (R - E).toLocaleString(
        void 0,
        {
          minimumFractionDigits: e || 0,
          maximumFractionDigits: e || 0
        }
      );
    }
    return "";
  }, [e]), M = (k) => {
    const { dataIndex: E } = k, R = k.dataset.data[E];
    return (Array.isArray(R) && R.length === 2 ? R[1] - R[0] : 0) >= 0 ? "end" : "start";
  }, w = tn(() => {
    var E, R, O, P, _;
    return {
      ...v,
      skipNull: !0,
      scales: {
        x: {
          offset: !0,
          stacked: !1,
          border: {
            dash: [4, 4],
            display: !0
          },
          grid: {
            tickLength: 0
          },
          ticks: {
            ...(R = (E = v.scales) == null ? void 0 : E.x) == null ? void 0 : R.ticks,
            autoSkip: !1
          }
        },
        y: {
          beginAtZero: !0,
          type: "linear",
          grace: "20%",
          border: {
            dash: [4, 4],
            display: !0
          },
          grid: {
            tickLength: 0
          },
          ticks: {
            ...(P = (O = v.scales) == null ? void 0 : O.y) == null ? void 0 : P.ticks
          }
        }
      },
      plugins: {
        ...v.plugins,
        tooltip: { enabled: !1 },
        legend: { display: !1 },
        title: (_ = v.plugins) == null ? void 0 : _.title,
        datalabels: {
          color: p.custom.grey[2800],
          font: { family: "Montserrat", weight: "bold" },
          align: M,
          anchor: M,
          offset: 0,
          formatter: S
        }
      }
    };
  }, [v, S, p]);
  return {
    ref: u,
    chartReady: d,
    data: x,
    type: "bar",
    options: w,
    actionsTotalValue: g
  };
}, mre = (e) => {
  const t = ge(), { actionsTotalValue: n, improvement: o, target: r, goal: i, unit: s = "", textOptions: a, precision: c } = e, d = [], u = (() => {
    const h = (i == null ? void 0 : i.value) ?? 0, g = (r == null ? void 0 : r.value) ?? 0;
    if (g === 0 || h === 0) return 0;
    const m = h - g;
    return o === "increase" ? g / h * 100 : (m / Math.abs(g) + 1) * 100;
  })(), p = (h) => h && h >= 0 ? o === "decrease" ? t.custom.red[600] : t.custom.green[600] : h && h <= 0 ? o === "decrease" ? t.custom.green[600] : t.custom.red[600] : t.custom.green[600];
  return a != null && a.setOfActionsLabel && n !== null && d.push({
    label: a.setOfActionsLabel,
    value: `${n.toLocaleString(void 0, {
      minimumFractionDigits: c || 0,
      maximumFractionDigits: c || 0
    })}`,
    color: p(n),
    unit: s
  }), a != null && a.goalProgressLabelDescription && r && i && d.push({
    label: null,
    additionalComponent: /* @__PURE__ */ f.jsx(
      Jw,
      {
        completionPercent: u,
        improvement: o,
        color: Qw(u, t),
        label: a.goalProgressLabelDescription
      }
    )
  }), d;
}, bre = (e) => {
  const t = ge(), { label: n, value: o, unit: r, additionalComponent: i } = e;
  return /* @__PURE__ */ f.jsxs(
    Tr,
    {
      elevation: 0,
      sx: {
        borderRadius: t.spacing(1),
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        p: t.spacing(2, 2.5),
        gap: t.spacing(1.5),
        border: `1px solid ${t.palette.divider}`
      },
      children: [
        n !== null && /* @__PURE__ */ f.jsx(
          J,
          {
            sx: {
              display: "flex",
              alignItems: "center"
            },
            children: /* @__PURE__ */ f.jsx(oe, { variant: "big-bold", fontWeight: "semi-bold", fontSize: t.spacing(2), color: "text.primary", children: n })
          }
        ),
        o !== void 0 && /* @__PURE__ */ f.jsxs(be, { direction: "row", spacing: 1, alignItems: "baseline", children: [
          /* @__PURE__ */ f.jsx(oe, { variant: "big-bold", fontWeight: "bold", fontSize: t.spacing(4), color: e.color, children: o }),
          /* @__PURE__ */ f.jsx(oe, { variant: "small-medium", fontSize: t.spacing(2), color: t.custom.grey[1400], children: r })
        ] }),
        i && /* @__PURE__ */ f.jsx(J, { sx: {
          transform: `translate(${t.spacing(-0.5)}, ${t.spacing(-1.5)})`
        }, children: i })
      ]
    }
  );
}, Cre = (e) => {
  const t = ge(), {
    textOptions: n,
    target: o,
    goal: r,
    actionsTotalValue: i,
    improvement: s,
    precision: a,
    unit: c
  } = e, u = { ...{
    setOfActionsLabel: "",
    goalProgressLabelDescription: ""
  }, ...n }, p = mre({
    actionsTotalValue: i,
    improvement: s,
    target: o,
    goal: r,
    unit: c,
    precision: a,
    textOptions: u
  });
  return p.length === 0 ? null : /* @__PURE__ */ f.jsx(
    to,
    {
      container: !0,
      spacing: 2,
      sx: {
        pt: t.spacing(2),
        alignItems: "stretch"
      },
      children: p.map((h, g) => /* @__PURE__ */ f.jsx(to, { item: !0, xs: 3, children: /* @__PURE__ */ f.jsx(bre, { ...h }) }, `${h.label}-${g}`))
    }
  );
}, qxe = (e) => {
  const {
    reference: t,
    start: n,
    values: o,
    target: r,
    goal: i,
    colors: s,
    forcedPrecision: a = 0,
    unit: c,
    width: d = "100%",
    height: u = "100%",
    improvement: p = "decrease",
    textOptions: h,
    showLegend: g = !0
  } = e, m = ge(), { data: b, ref: C, type: x, options: v, actionsTotalValue: S } = gre(
    a,
    s,
    c,
    t,
    n,
    o,
    r,
    i,
    p
  ), M = r != null && r.value ? r : {
    label: (n == null ? void 0 : n.label) ?? (t == null ? void 0 : t.label) ?? "",
    value: (r == null ? void 0 : r.value) ?? ((n == null ? void 0 : n.value) ?? (t == null ? void 0 : t.value) ?? 0) + (S ?? 0)
  };
  return /* @__PURE__ */ f.jsxs(
    be,
    {
      direction: "column",
      position: "relative",
      width: d,
      minHeight: m.spacing(50),
      justifyContent: "stretch",
      children: [
        /* @__PURE__ */ f.jsx(
          J,
          {
            sx: {
              border: `1px solid ${m.palette.divider}`,
              backgroundColor: m.palette.background.paper,
              borderRadius: m.spacing(1),
              width: "100%",
              height: u
            },
            children: /* @__PURE__ */ f.jsx(
              W3,
              {
                ref: C,
                type: x,
                data: b,
                height: u,
                options: v
              }
            )
          }
        ),
        g && /* @__PURE__ */ f.jsx(
          Cre,
          {
            textOptions: h,
            target: M,
            improvement: p,
            goal: i,
            actionsTotalValue: S,
            unit: c,
            precision: a
          }
        )
      ]
    }
  );
}, ot = {
  DEFAULT_WIDTH: 500,
  DEFAULT_HEIGHT: 200,
  GAUGE_HEIGHT: 28,
  GAUGE_PADDING: 8,
  LEGEND_PADDING_X: 28,
  FONT_SIZE: {
    DEFAULT: 12,
    LABEL: 14
  },
  MARKER: {
    COMPANY_RADIUS: 5,
    COMPANY_STROKE_WIDTH: 3,
    AVERAGE_RADIUS: 3,
    AVERAGE_STROKE_WIDTH: 2,
    EDGE_RADIUS: 3
  },
  COLORS: {
    BORDER: "#E7E6E4",
    TEXT: "#393A36",
    MARKER: "#393A36",
    GRADIENT: {
      START: "#F0DF46",
      END: "#EB9411"
    }
  },
  TEXT: {
    DEFAULT_COMPANY_LABEL: "",
    DEFAULT_AVERAGE_LABEL: ""
  },
  LAYOUT: {
    COMPANY_MARKER_OFFSET: 18,
    AVERAGE_MARKER_TOP_OFFSET: 12,
    AVERAGE_MARKER_BOTTOM_OFFSET: 4,
    COMPANY_LABEL_VERTICAL_RATIO: 0.25,
    AVERAGE_LABEL_VERTICAL_RATIO: 0.75,
    COMPANY_LABEL_OFFSET: 8,
    AVERAGE_LABEL_OFFSET: 12,
    TITLE_OFFSET: 35,
    VALUES_LABEL_OFFSET: 8
  }
}, xre = (e, t, n) => e === t ? () => (n - ot.GAUGE_PADDING * 2) / 2 : (o) => (o - e) / (t - e) * (n - ot.GAUGE_PADDING * 2), yre = (e, t = ot.FONT_SIZE.DEFAULT) => e.length * (t * 0.6), oC = (e, t, n, o, r = ot.FONT_SIZE.DEFAULT) => {
  const i = ot.GAUGE_PADDING + n(e), s = yre(t, r) / 2;
  return i - s < ot.GAUGE_PADDING ? { x: ot.GAUGE_PADDING, anchor: "start" } : i + s > o - ot.GAUGE_PADDING ? { x: o - ot.GAUGE_PADDING, anchor: "end" } : { x: i, anchor: "middle" };
}, vre = (e, t) => (e + t) / 2, wre = ({
  minValue: e,
  maxValue: t,
  companyValue: n,
  averageValue: o,
  labelCompany: r,
  labelAverage: i,
  width: s,
  height: a
}) => {
  const c = xre(e, t, s), d = vre(e, t), u = oC(
    n,
    r,
    c,
    s
  ), p = oC(
    o,
    i,
    c,
    s
  ), h = a / 2, g = h - ot.GAUGE_HEIGHT, m = g + ot.GAUGE_HEIGHT / 2, b = {
    start: h - ot.LAYOUT.COMPANY_MARKER_OFFSET,
    end: g - ot.LAYOUT.COMPANY_MARKER_OFFSET
  }, C = {
    start: h - ot.LAYOUT.AVERAGE_MARKER_TOP_OFFSET,
    end: h + ot.GAUGE_HEIGHT - ot.LAYOUT.AVERAGE_MARKER_BOTTOM_OFFSET
  }, x = {
    company: a * ot.LAYOUT.COMPANY_LABEL_VERTICAL_RATIO - ot.LAYOUT.COMPANY_LABEL_OFFSET,
    average: a * ot.LAYOUT.AVERAGE_LABEL_VERTICAL_RATIO - ot.LAYOUT.AVERAGE_LABEL_OFFSET,
    title: g - ot.LAYOUT.TITLE_OFFSET,
    values: a - ot.LAYOUT.VALUES_LABEL_OFFSET
  }, v = {
    min: ot.GAUGE_PADDING,
    max: s - ot.GAUGE_PADDING,
    middle: ot.GAUGE_PADDING + (s - ot.GAUGE_PADDING * 2) / 2
  }, S = {
    x: ot.GAUGE_PADDING,
    y: m - ot.GAUGE_HEIGHT / 2,
    width: s - ot.GAUGE_PADDING * 2,
    height: ot.GAUGE_HEIGHT,
    animated: !1
  };
  return {
    scale: c,
    averageValueBoundaries: d,
    companyPosition: u,
    averagePosition: p,
    gaugeBackgroundProps: S,
    markerY: m,
    companyMarkerY: b,
    averageMarkerY: C,
    labelY: x,
    labelPositions: v
  };
}, Sre = ({ width: e, height: t, averageValueBoundaries: n, scale: o, animated: r = !1 }) => {
  const i = St(null);
  return mt(() => {
    if (i.current && r) {
      const s = i.current;
      s.style.opacity = "0", setTimeout(() => {
        s.style.transition = "all 0.5s linear", s.style.opacity = "1";
      }, 300);
    }
  }, [r]), /* @__PURE__ */ f.jsxs("g", { ref: i, style: { opacity: r ? "0" : "1" }, children: [
    /* @__PURE__ */ f.jsx(
      "line",
      {
        x1: ot.GAUGE_PADDING,
        y1: 1,
        x2: e - ot.GAUGE_PADDING,
        y2: 1,
        stroke: ot.COLORS.BORDER,
        strokeWidth: "1",
        strokeDasharray: "5 5"
      }
    ),
    /* @__PURE__ */ f.jsx(
      "line",
      {
        x1: ot.GAUGE_PADDING,
        y1: t - ot.LEGEND_PADDING_X,
        x2: e - ot.GAUGE_PADDING,
        y2: t - ot.LEGEND_PADDING_X,
        stroke: ot.COLORS.BORDER,
        strokeWidth: "1",
        strokeDasharray: "5 5"
      }
    ),
    /* @__PURE__ */ f.jsx(
      "line",
      {
        x1: ot.GAUGE_PADDING,
        y1: 0,
        x2: ot.GAUGE_PADDING,
        y2: t - ot.LEGEND_PADDING_X,
        stroke: ot.COLORS.BORDER,
        strokeWidth: "1",
        strokeDasharray: "5 5"
      }
    ),
    /* @__PURE__ */ f.jsx(
      "line",
      {
        x1: e - ot.GAUGE_PADDING,
        y1: 0,
        x2: e - ot.GAUGE_PADDING,
        y2: t - ot.LEGEND_PADDING_X,
        stroke: ot.COLORS.BORDER,
        strokeWidth: "1",
        strokeDasharray: "5 5"
      }
    ),
    /* @__PURE__ */ f.jsx(
      "line",
      {
        x1: o(n) + ot.GAUGE_PADDING,
        y1: 0,
        x2: o(n) + ot.GAUGE_PADDING,
        y2: t - ot.LEGEND_PADDING_X,
        stroke: ot.COLORS.BORDER,
        strokeWidth: "1",
        strokeDasharray: "5 5"
      }
    )
  ] });
}, Ed = (e, t = 0) => Number(e.toFixed(t < 0 || t > 100 ? 0 : t)), au = ({ label: e, value: t, unit: n, precision: o = 2, valueFormatter: r }) => {
  const i = ge(), s = r ? r(t) : Ed(t, o);
  return /* @__PURE__ */ f.jsxs(
    J,
    {
      sx: {
        display: "flex",
        width: "100%",
        flexDirection: "column",
        gap: i.spacing(0.75),
        padding: i.spacing(0.75, 1.5, 0, 0.75),
        textAlign: "left",
        justifyContent: "flex-start"
      },
      children: [
        /* @__PURE__ */ f.jsx(oe, { variant: "h5", color: i.custom.grey[2800], children: e }),
        /* @__PURE__ */ f.jsxs(J, { sx: { display: "flex", alignItems: "baseline" }, children: [
          /* @__PURE__ */ f.jsx(oe, { variant: "h2", color: i.custom.grey[2800], sx: { mr: 0.5 }, children: s }),
          /* @__PURE__ */ f.jsx(oe, { variant: "body-medium", color: i.custom.grey[1400], children: n })
        ] })
      ]
    }
  );
}, Mre = ({
  scale: e,
  companyValue: t,
  averageValue: n,
  markersYPosition: o,
  companyMarkerY: r,
  averageMarkerY: i,
  animated: s = !1,
  minValue: a,
  maxValue: c,
  precision: d = 2,
  unit: u = "",
  labelCompany: p = "",
  labelAverage: h = "",
  valueFormatter: g
}) => {
  const m = ge(), b = St(null), C = { transition: s ? "transform 0.3s linear" : "none" }, x = m.custom.grey[2800], v = (S) => S >= a && S <= c;
  return mt(() => {
    if (b.current && s) {
      const S = b.current;
      S.style.opacity = "0", setTimeout(() => {
        S.style.transition = "all 0.5s linear", S.style.opacity = "1";
      }, 300);
    }
  }, [s]), /* @__PURE__ */ f.jsxs("g", { ref: b, children: [
    [a, c].map((S, M) => {
      const w = `edge-${M}`, k = ot.GAUGE_PADDING + e(S);
      return /* @__PURE__ */ f.jsxs(
        "g",
        {
          transform: `translate(${k}, 0)`,
          style: C,
          children: [
            /* @__PURE__ */ f.jsx(
              "circle",
              {
                cy: o,
                r: ot.MARKER.EDGE_RADIUS,
                fill: x
              }
            ),
            /* @__PURE__ */ f.jsx(
              "line",
              {
                y1: o - ot.GAUGE_HEIGHT / 2,
                y2: o + ot.GAUGE_HEIGHT / 2,
                stroke: x,
                strokeWidth: "2"
              }
            )
          ]
        },
        w
      );
    }),
    v(t) && /* @__PURE__ */ f.jsx(Ma, { width: "unset", title: /* @__PURE__ */ f.jsx(au, { label: p, value: t, unit: u, precision: d, valueFormatter: g }), children: /* @__PURE__ */ f.jsxs(
      "g",
      {
        transform: `translate(${ot.GAUGE_PADDING + e(t)}, 0)`,
        style: C,
        children: [
          /* @__PURE__ */ f.jsx(
            "line",
            {
              y1: r.start,
              y2: r.end,
              stroke: x,
              strokeWidth: "1"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "circle",
            {
              cy: o,
              r: ot.MARKER.COMPANY_RADIUS,
              stroke: x,
              strokeWidth: ot.MARKER.COMPANY_STROKE_WIDTH,
              fill: m.palette.common.white
            }
          )
        ]
      }
    ) }),
    v(n) && /* @__PURE__ */ f.jsx(Ma, { width: "unset", title: /* @__PURE__ */ f.jsx(au, { label: h, value: n, unit: u, precision: d, valueFormatter: g }), children: /* @__PURE__ */ f.jsxs(
      "g",
      {
        transform: `translate(${ot.GAUGE_PADDING + e(n)}, 0)`,
        style: C,
        children: [
          /* @__PURE__ */ f.jsx(
            "line",
            {
              y1: i.start,
              y2: i.end,
              stroke: x,
              strokeWidth: "1"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "circle",
            {
              cy: o,
              r: ot.MARKER.AVERAGE_RADIUS,
              fill: m.palette.common.white,
              stroke: x,
              strokeWidth: ot.MARKER.AVERAGE_STROKE_WIDTH
            }
          )
        ]
      }
    ) })
  ] });
}, Tre = ({
  minValue: e,
  maxValue: t,
  companyValue: n,
  averageValue: o,
  companyPosition: r,
  averagePosition: i,
  labelCompany: s,
  labelAverage: a,
  labelYPositions: c,
  labelPositions: d,
  animated: u,
  precision: p = 0,
  unit: h = "",
  valueFormatter: g
}) => {
  const m = ge(), b = St(null), C = { transition: u ? "transform 0.3s linear" : "none" }, x = m.custom.grey[2800], v = e !== t, S = (M) => M >= e && M <= t;
  return mt(() => {
    if (b.current && u) {
      const M = b.current;
      M.style.opacity = "0", setTimeout(() => {
        M.style.transition = "all 0.5s linear", M.style.opacity = "1";
      }, 300);
    }
  }, [u]), /* @__PURE__ */ f.jsxs("g", { ref: b, children: [
    /* @__PURE__ */ f.jsxs("g", { children: [
      v && /* @__PURE__ */ f.jsx(
        "text",
        {
          transform: `translate(${d.min}, ${c.values})`,
          fill: x,
          fontSize: "12",
          fontWeight: "bold",
          textAnchor: "start",
          dominantBaseline: "middle",
          style: C,
          cursor: "pointer",
          children: g ? g(e) : Ed(e, p)
        }
      ),
      /* @__PURE__ */ f.jsx(
        "text",
        {
          transform: `translate(${d.middle}, ${c.values})`,
          fill: x,
          fontSize: "12",
          fontWeight: "bold",
          textAnchor: "middle",
          dominantBaseline: "middle",
          style: C,
          children: g ? g((t + e) / 2) : Ed((t + e) / 2, p)
        }
      ),
      v && /* @__PURE__ */ f.jsx(
        "text",
        {
          transform: `translate(${d.max}, ${c.values})`,
          fill: x,
          fontSize: "12",
          fontWeight: "bold",
          textAnchor: "end",
          dominantBaseline: "middle",
          style: C,
          children: g ? g(t) : Ed(t, p)
        }
      )
    ] }),
    /* @__PURE__ */ f.jsxs("g", { cursor: "default", children: [
      S(n) && /* @__PURE__ */ f.jsx(Ma, { width: "unset", title: /* @__PURE__ */ f.jsx(au, { label: s, value: n, unit: h, precision: p, valueFormatter: g }), children: /* @__PURE__ */ f.jsx(
        "text",
        {
          transform: `translate(${r.x}, ${c.company})`,
          fill: x,
          textAnchor: r.anchor,
          dominantBaseline: "middle",
          fontWeight: "700",
          fontSize: "12",
          style: C,
          children: s
        }
      ) }),
      S(o) && /* @__PURE__ */ f.jsx(Ma, { width: "unset", title: /* @__PURE__ */ f.jsx(au, { label: a, value: o, unit: h, precision: p, valueFormatter: g }), children: /* @__PURE__ */ f.jsx(
        "text",
        {
          transform: `translate(${i.x}, ${c.average})`,
          fill: x,
          fontSize: "12",
          fontWeight: "500",
          textAnchor: i.anchor,
          dominantBaseline: "middle",
          style: C,
          children: a
        }
      ) })
    ] })
  ] });
}, kre = ({
  x: e,
  y: t,
  width: n,
  height: o,
  animated: r = !1,
  backgroundProps: i = {}
}) => {
  var u, p;
  const s = St(null), a = "gaugeGradient";
  mt(() => {
    s.current && r && (s.current.style.transform = "scaleY(0)", s.current.style.transformOrigin = "left", setTimeout(() => {
      s.current && (s.current.style.transition = "all 0.2s linear", s.current.style.transform = "scaleY(1)");
    }, 100));
  }, [r]);
  const c = ((u = i.gradient) == null ? void 0 : u.start) || ot.COLORS.GRADIENT.START, d = ((p = i.gradient) == null ? void 0 : p.end) || ot.COLORS.GRADIENT.END;
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsxs("linearGradient", { id: a, x1: "0%", y1: "0%", x2: "100%", y2: "0%", children: [
      /* @__PURE__ */ f.jsx("stop", { offset: "0%", style: { stopColor: c } }),
      /* @__PURE__ */ f.jsx("stop", { offset: "100%", style: { stopColor: d } })
    ] }) }),
    /* @__PURE__ */ f.jsx(
      "rect",
      {
        ref: s,
        x: e,
        y: t,
        width: n,
        height: o,
        fill: i.fill || `url(#${a})`,
        stroke: i.stroke || "none",
        strokeWidth: i.strokeWidth || 0,
        rx: i.rx || 0,
        ry: i.ry || 0,
        style: {
          transformBox: "fill-box",
          transform: r ? "scaleY(0)" : "none",
          transformOrigin: "left"
        }
      }
    )
  ] });
}, Ere = () => {
  const e = St(null), [t, n] = Ae(0);
  return mt(() => {
    const o = () => {
      e.current && n(e.current.clientWidth);
    };
    return o(), window.addEventListener("resize", o), () => window.removeEventListener("resize", o);
  }, []), { containerRef: e, containerWidth: t };
}, Kxe = ({
  minValue: e,
  maxValue: t,
  averageValue: n,
  companyValue: o,
  labelAverage: r = ot.TEXT.DEFAULT_AVERAGE_LABEL,
  labelCompany: i = ot.TEXT.DEFAULT_COMPANY_LABEL,
  width: s,
  height: a = ot.DEFAULT_HEIGHT,
  label: c,
  animated: d = !1,
  backgroundProps: u,
  precision: p = 0,
  unit: h = "",
  valueFormatter: g
}) => {
  const { containerRef: m, containerWidth: b } = Ere(), C = b || s || ot.DEFAULT_WIDTH, {
    scale: x,
    averageValueBoundaries: v,
    companyPosition: S,
    averagePosition: M,
    gaugeBackgroundProps: w,
    markerY: k,
    companyMarkerY: E,
    averageMarkerY: R,
    labelY: O,
    labelPositions: P
  } = wre({
    minValue: e,
    maxValue: t,
    companyValue: o,
    averageValue: n,
    labelCompany: i,
    labelAverage: r,
    width: C,
    height: a,
    label: c
  });
  return /* @__PURE__ */ f.jsx(J, { ref: m, width: s || "100%", height: a, position: "relative", children: /* @__PURE__ */ f.jsxs("svg", { width: b, height: a, children: [
    /* @__PURE__ */ f.jsx(
      Sre,
      {
        width: b,
        height: a,
        scale: x,
        averageValueBoundaries: v,
        animated: d
      }
    ),
    /* @__PURE__ */ f.jsx(
      kre,
      {
        ...w,
        backgroundProps: u,
        animated: d
      }
    ),
    /* @__PURE__ */ f.jsx(
      Mre,
      {
        width: b,
        scale: x,
        companyValue: o,
        averageValue: n,
        markersYPosition: k,
        companyMarkerY: E,
        averageMarkerY: R,
        minValue: e,
        maxValue: t,
        animated: d,
        precision: p,
        unit: h,
        labelCompany: i,
        labelAverage: r,
        valueFormatter: g
      }
    ),
    /* @__PURE__ */ f.jsx(
      Tre,
      {
        minValue: e,
        maxValue: t,
        companyValue: o,
        averageValue: n,
        companyPosition: S,
        averagePosition: M,
        labelCompany: i,
        labelAverage: r,
        labelYPositions: O,
        labelPositions: P,
        animated: d,
        precision: p,
        unit: h,
        valueFormatter: g
      }
    )
  ] }) });
}, Rre = () => ({
  dataset: [],
  allLabels: [],
  totalNumberOfIems: 0
}), Ore = (e, t, n, o) => {
  const r = { ...t };
  return e.reduce((s, a) => {
    const c = Array(s.totalNumberOfIems).fill(null), d = {
      grouped: !1,
      pointStyle: "rect",
      borderColor: "transparent",
      label: n,
      data: [...c, a.value],
      backgroundColor: a.color ?? o,
      xoffset: s.totalNumberOfIems,
      order: 2,
      borderRadius: 4,
      scope: "initial"
    };
    return s.totalNumberOfIems += 1, s.allLabels.push(a.label), s.dataset.push(d), s;
  }, r);
}, _re = (e, t, n) => {
  var g, m, b, C;
  const o = { ...t }, r = [[], []], i = e.reduce((x, v) => (v.values.forEach((S, M) => {
    x[M].push(S);
  }), x), r), s = e.map((x) => x.label);
  o.allLabels = [...o.allLabels, ...s];
  const a = Array(o.totalNumberOfIems).fill(null), c = ((g = n == null ? void 0 : n.main) == null ? void 0 : g.color) ?? "#FFD6B9", d = {
    label: ((m = n == null ? void 0 : n.main) == null ? void 0 : m.label) ?? "",
    pointStyle: "rect",
    borderColor: "transparent",
    data: [...a, ...i[0]],
    backgroundColor: c,
    order: 2,
    borderRadius: 4,
    scope: "trajectory"
  };
  o.dataset.push(d);
  const u = ((b = n == null ? void 0 : n.difference) == null ? void 0 : b.color) ?? "#30C7A380", p = {
    label: ((C = n == null ? void 0 : n.difference) == null ? void 0 : C.label) ?? "",
    pointStyle: "rect",
    borderColor: "transparent",
    data: [...a, ...i[1]],
    backgroundColor: u,
    order: 2,
    borderRadius: 4,
    scope: "trajectory"
  };
  o.dataset.push(p);
  const h = i[0].length;
  return o.totalNumberOfIems += h, o;
}, Pre = (e) => {
  const { goal: t, chartState: n, label: o, color: r, forceLegend: i = !1 } = e, s = { ...n }, c = s.dataset[0].data[0], d = c === null || Array.isArray(c) || t === null, u = Array(s.allLabels.length).fill(null);
  u[0] = c, u[u.length - 1] = t;
  const p = r || "rgb(54, 162, 235)", h = {
    type: "line",
    pointStyle: "circle",
    spanGaps: !0,
    pointHoverBackgroundColor: p,
    pointBackgroundColor: p,
    backgroundColor: p,
    order: 1,
    label: o,
    data: u,
    pointRadius: 4,
    pointBorderWidth: 4,
    pointHoverRadius: 8,
    fill: !1,
    borderColor: p,
    tension: 0.4,
    borderWidth: 2,
    isGoalNull: d,
    scope: "goal",
    forceLegend: i
  };
  return s.dataset.push(h), s;
}, Lre = (e) => {
  var h, g, m;
  const t = ge(), {
    goal: n = null,
    initialValues: o = [],
    trajectory: r = [],
    trajectoryOptions: i,
    forceGoalLegend: s
  } = e, a = Rre(), c = t.custom.dataviz.colorsWithExtra[11].main, d = Ore(o, a, (h = i == null ? void 0 : i.initialValues) == null ? void 0 : h.label, c), u = _re(r, d, i), p = Pre({
    goal: n,
    chartState: u,
    label: (g = i == null ? void 0 : i.target) == null ? void 0 : g.label,
    color: (m = i == null ? void 0 : i.target) == null ? void 0 : m.color,
    forceLegend: s
  });
  return {
    datasets: p.dataset,
    initialValues: d.dataset,
    labels: p.allLabels
  };
}, Ire = () => {
  const e = St(), [t, n] = Ae(!1);
  return mt(() => {
    e.current && n(!0);
  }, []), mt(() => {
    if (!e.current) return;
    const o = () => e.current.resize();
    return window.addEventListener("resize", o), () => {
      window.removeEventListener("resize", o);
    };
  }, []), {
    ref: e,
    chartReady: t
  };
}, jre = ({ unit: e }) => {
  const t = ge(), n = (r) => parseInt(t.spacing(r));
  return {
    animation: !1,
    responsive: !0,
    maintainAspectRatio: !1,
    skipNull: !0,
    font: { family: "Montserrat", weight: 400 },
    interaction: {
      mode: "index",
      intersect: !0,
      axis: "x"
    },
    scales: {
      x: {
        ticks: {
          font: { family: "Montserrat" },
          padding: n(2)
        },
        grid: {
          display: !1,
          tickLength: 0
        }
      },
      y: {
        grace: "5%",
        ticks: {
          font: { family: "Montserrat" },
          padding: n(2)
        },
        border: {
          dash: [4, 4],
          display: !0
        },
        grid: {
          tickLength: 0
        }
      }
    },
    layout: { padding: n(3) },
    plugins: {
      legend: { display: !1 },
      datalabels: { display: !1 },
      title: {
        display: !0,
        text: e,
        align: "start",
        position: "top",
        fullSize: !0,
        padding: { bottom: n(4), top: n(2) },
        font: { family: "Montserrat", weight: 400, size: n(1.75) }
      },
      tooltip: {
        enabled: !0,
        yAlign: "bottom",
        position: "nearest",
        titleFont: {
          family: "Montserrat",
          weight: Number(t.typography.fontWeightBold),
          size: n(1.75)
        },
        bodyFont: {
          family: "Montserrat",
          weight: Number(t.typography.fontWeightMedium),
          size: n(1.5)
        },
        titleColor: t.custom.grey[2800],
        titleMarginBottom: n(1.25),
        bodyColor: t.custom.grey[2800],
        bodySpacing: n(0.75),
        padding: {
          top: n(1.25),
          bottom: n(1.25),
          left: n(2.5),
          right: n(2.5)
        },
        cornerRadius: n(1),
        displayColors: !0,
        boxHeight: n(1.25),
        boxWidth: n(1.25),
        backgroundColor: t.custom.grey[100],
        borderColor: t.custom.grey[400],
        borderWidth: 1,
        boxPadding: n(1),
        caretPadding: n(1.75),
        usePointStyle: !0,
        multiKeyBackground: "transparent",
        caretSize: 8,
        callbacks: {
          title: (r) => r[0].label || "",
          label: (r) => {
            const i = r.dataset.label || "", s = r.formattedValue;
            return s === "0" ? "" : e ? `${i ? `${i}: ` : ""}${s} ${e}` : `${i ? `${i}: ` : ""} ${s}`;
          },
          labelTextColor: () => t.custom.grey[2800],
          labelPointStyle: (r) => ({
            pointStyle: r.dataset.type === "line" ? "line" : "rect",
            rotation: 0
          })
        }
      }
    }
  };
}, Vre = (e) => {
  const { variant: t = "tags-grey", label: n, startIcon: o, endIcon: r, onClick: i, disabled: s } = e, a = ge(), c = {
    "tags-grey": a.custom.grey[2800],
    "tags-black": a.custom.grey[100],
    "tags-white": a.custom.grey[2800],
    "tags-green": a.custom.green[600],
    "tags-red": a.custom.red[600]
  };
  return /* @__PURE__ */ f.jsx(
    at,
    {
      startIcon: o && /* @__PURE__ */ f.jsx(
        oe,
        {
          sx: {
            color: c[t]
          },
          variant: "small-bold",
          children: /* @__PURE__ */ f.jsx(_t, { size: 1, icon: o })
        }
      ),
      endIcon: r && /* @__PURE__ */ f.jsx(
        oe,
        {
          sx: {
            color: c[t]
          },
          variant: "small-bold",
          children: /* @__PURE__ */ f.jsx(_t, { size: 1, icon: r })
        }
      ),
      variant: t,
      onClick: i,
      disabled: s,
      children: /* @__PURE__ */ f.jsx(
        oe,
        {
          sx: {
            color: c[t]
          },
          variant: "small-bold",
          children: n
        }
      )
    }
  );
}, Yxe = (e) => {
  const { user: t, deleteAction: n } = e;
  return /* @__PURE__ */ f.jsxs(
    be,
    {
      sx: {
        display: "flex",
        gap: "5px",
        padding: "8px",
        border: "1px solid #E7E6E4",
        backgroundColor: "Red",
        borderRadius: "8px",
        width: "fit-content",
        justifyContent: "center",
        alignItems: "center"
      },
      children: [
        /* @__PURE__ */ f.jsx(l2, { alt: `${t.firstname} ${t.lastname}`, variant: "small" }),
        /* @__PURE__ */ f.jsx(oe, { variant: "body-bold", children: t.firstname }),
        /* @__PURE__ */ f.jsx(oe, { variant: "body-bold", children: t.lastname }),
        n && /* @__PURE__ */ f.jsx(J, { onClick: n, children: /* @__PURE__ */ f.jsx(_t, { size: 2, icon: "delete" }) })
      ]
    }
  );
}, Dre = (e) => {
  const { block: t, improvement: n, textOptions: o } = e, r = ge();
  return /* @__PURE__ */ f.jsxs(
    J,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: r.spacing(2, 3),
        border: `1px solid ${r.palette.divider}`,
        backgroundColor: r.palette.background.paper,
        borderRadius: r.spacing(1),
        height: "100%",
        position: "relative"
      },
      children: [
        /* @__PURE__ */ f.jsxs(
          be,
          {
            direction: "row",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            spacing: r.spacing(2),
            minHeight: r.spacing(4),
            sx: { width: "100%" },
            children: [
              /* @__PURE__ */ f.jsxs(be, { direction: "row", alignItems: "flex-start", spacing: 1.5, children: [
                t.isLine ? /* @__PURE__ */ f.jsx(
                  J,
                  {
                    sx: {
                      width: r.spacing(2),
                      transform: `translateY(${r.spacing(1)})`,
                      height: r.spacing(0.25),
                      backgroundColor: t.color
                    }
                  }
                ) : /* @__PURE__ */ f.jsx(
                  J,
                  {
                    sx: {
                      minWidth: r.spacing(2),
                      transform: `translateY(${r.spacing(0.25)})`,
                      height: r.spacing(2),
                      backgroundColor: t.color,
                      borderRadius: r.spacing(0.5)
                    }
                  }
                ),
                /* @__PURE__ */ f.jsx(
                  oe,
                  {
                    variant: "body2",
                    sx: { fontWeight: r.typography.fontWeightBold },
                    children: t.label
                  }
                )
              ] }),
              /* @__PURE__ */ f.jsx(be, { children: t.complete && /* @__PURE__ */ f.jsx(
                Vre,
                {
                  startIcon: "circleCheck",
                  variant: "tags-green",
                  label: o.complete || "",
                  disabled: !0
                }
              ) })
            ]
          }
        ),
        t.dataPoints && t.dataPoints.length > 0 && /* @__PURE__ */ f.jsx(be, { spacing: 2, sx: { mt: t.dataPoints[0].startValue && t.dataPoints[0].endValue ? r.spacing(1) : 0 }, children: t.dataPoints.map((i, s) => /* @__PURE__ */ f.jsxs(be, { direction: "row", alignItems: "center", spacing: 0.5, children: [
          !!i.startValue && !!i.endValue && /* @__PURE__ */ f.jsx(
            Kw,
            {
              currentValue: i.endValue,
              comparedTo: {
                value: i.startValue,
                label: i.label
              },
              improvement: n,
              layout: {
                direction: "horizontal",
                size: "M"
              },
              disableText: !0
            }
          ),
          /* @__PURE__ */ f.jsx(be, { direction: "column", alignItems: "flex-start", spacing: 1, children: i.label && /* @__PURE__ */ f.jsx(oe, { variant: "small", children: i.label }) })
        ] }, `${t.key}-${s}`)) }),
        /* @__PURE__ */ f.jsx(J, { children: t.dataPoints && t.dataPoints.map((i, s) => i.link && /* @__PURE__ */ f.jsx(
          t7,
          {
            href: i.link.url,
            target: "_blank",
            rel: "noopener noreferrer",
            sx: {
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              gap: r.spacing(1),
              cursor: "pointer"
            },
            children: /* @__PURE__ */ f.jsxs(
              be,
              {
                direction: "row",
                alignItems: "center",
                spacing: r.spacing(1),
                color: r.palette.primary.main,
                mt: r.spacing(2),
                sx: { "&:hover": { opacity: 0.8 } },
                children: [
                  /* @__PURE__ */ f.jsx(_t, { icon: i.link.icon, size: 1 }),
                  /* @__PURE__ */ f.jsx(oe, { variant: "body-medium", sx: { fontWeight: r.typography.fontWeightBold }, color: r.palette.primary.main, children: i.link.label })
                ]
              }
            )
          },
          `link-${t.key}-${s}`
        )) })
      ]
    }
  );
}, D2 = (e) => {
  const t = e.findIndex((i) => i !== null), n = t !== -1 ? e[t] : null, o = [...e].reverse().findIndex((i) => i !== null), r = o !== -1 ? e[e.length - 1 - o] : null;
  return { firstValue: n, lastValue: r };
}, Are = (e) => {
  const t = ge(), { datasets: n, datasetsLabels: o, improvement: r, urlEditTrajectories: i, textOptions: s } = e, [a, c] = [o[0], o[o.length - 1]], d = n.filter((b) => b.scope === "initial"), u = n.filter((b) => b.scope === "trajectory"), p = n.filter((b) => b.scope === "goal"), h = [];
  if (d.length > 0) {
    const b = d[0];
    h.push({
      key: "initial-value",
      label: b.label,
      color: `${b.backgroundColor}`
    });
  }
  const g = u.map((b) => `${b.backgroundColor}`).reverse();
  if (u.length > 0 && d.length > 0) {
    const b = u[1], C = b ? b.data.map((S) => Number(S)) : [], x = Number(d[0].data[0]), { lastValue: v } = D2(C);
    if (x && v) {
      const S = [
        {
          startValue: x,
          endValue: v,
          label: `${s == null ? void 0 : s.between} ${a} ${s == null ? void 0 : s.and} ${c}`
        }
      ];
      if (u.length > 1) {
        const w = u[0].data.map((E) => Number(E)), { lastValue: k } = D2(w);
        k && S.push({
          startValue: k,
          endValue: v,
          label: `${s == null ? void 0 : s.withoutActionPlan}`
        });
      }
      h.push({
        key: "trajectory-with-action-plan",
        label: u[1].label,
        color: g[0],
        dataPoints: S
      });
    }
  }
  if (u.length > 1 && d.length > 0) {
    const C = u[0].data.map((S) => Number(S)), x = Number(d[0].data[0]), { lastValue: v } = D2(C);
    x && v && h.push({
      key: "trajectory-without-action-plan",
      label: u[0].label,
      color: g[1],
      dataPoints: [{
        startValue: x,
        endValue: v,
        label: `${s == null ? void 0 : s.between} ${a} ${s == null ? void 0 : s.and} ${c}`
      }]
    });
  }
  const m = p[0];
  if (m.scope === "goal") {
    const b = m ? m.data.map((R) => Number(R)) : null, { firstValue: C, lastValue: x } = b ? D2(b) : { firstValue: null, lastValue: null }, v = u[1], S = v ? v.data.map((R) => Number(R)) : null, { lastValue: M } = S ? D2(S) : { lastValue: null }, w = m.isGoalNull, k = {
      key: "goal",
      label: (m == null ? void 0 : m.label) || (s == null ? void 0 : s.goal),
      color: m ? `${m.backgroundColor}` : t.custom.dataviz.colorsWithExtra[13].main,
      isLine: !0,
      dataPoints: [{
        startValue: C || void 0,
        endValue: x || void 0,
        label: w === !1 ? `${s == null ? void 0 : s.between} ${a} ${s == null ? void 0 : s.and} ${c}` : `${s == null ? void 0 : s.noObjective}`,
        link: s != null && s.editTrajectories ? {
          label: `${s == null ? void 0 : s.editTrajectories}`,
          url: i,
          icon: "edit"
        } : void 0
      }],
      complete: M && x ? r === "decrease" ? M <= x : M >= x : !1
    };
    console.log("Yo :", m, w);
    const E = !!m.forceLegend;
    (w && E || m.isGoalNull !== !0) && h.push(k);
  }
  return h;
}, Hre = (e) => {
  const t = ge(), {
    datasets: n,
    datasetsLabels: o,
    improvement: r,
    urlEditTrajectories: i,
    textOptions: s
  } = e, c = { ...{
    complete: "",
    between: "",
    and: "",
    withoutActionPlan: "",
    goal: "",
    noObjective: "",
    editTrajectories: ""
  }, ...s }, d = Are({
    datasets: n,
    datasetsLabels: o,
    improvement: r,
    urlEditTrajectories: i,
    textOptions: c
  });
  return /* @__PURE__ */ f.jsx(
    to,
    {
      container: !0,
      spacing: 2,
      sx: {
        p: t.spacing(3.25, 0, 0, 0),
        alignItems: "stretch"
      },
      children: d.map((u) => /* @__PURE__ */ f.jsx(to, { item: !0, xs: 12, sm: 6, md: 3, children: /* @__PURE__ */ f.jsx(
        Dre,
        {
          block: u,
          improvement: r,
          textOptions: c
        }
      ) }, u.key))
    }
  );
}, Xxe = (e) => {
  const {
    unit: t,
    width: n = "100%",
    height: o = "100%",
    showLegend: r = !0,
    improvement: i = "decrease",
    urlEditTrajectories: s,
    textOptions: a,
    ...c
  } = e, d = ge(), { ref: u } = Ire(), p = Lre(c), h = jre({ unit: t }), m = ((b) => {
    const C = b.length, x = b.slice(0, C - 1), v = b.slice(C - 1, C)[0];
    return (v == null ? void 0 : v.scope) === "goal" && (v == null ? void 0 : v.isGoalNull) === !0 ? x : b;
  })(p.datasets);
  return /* @__PURE__ */ f.jsxs(
    be,
    {
      direction: "column",
      position: "relative",
      width: n,
      height: o,
      minHeight: d.spacing(50),
      justifyContent: "stretch",
      children: [
        /* @__PURE__ */ f.jsx(
          J,
          {
            sx: {
              border: `1px solid ${d.palette.divider}`,
              backgroundColor: d.palette.background.paper,
              borderRadius: d.spacing(1),
              height: "100%",
              width: "100%"
            },
            children: /* @__PURE__ */ f.jsx(
              W3,
              {
                ref: u,
                type: "bar",
                data: {
                  labels: p.labels,
                  // This dataset is used in order NOT to display the goal if goal is null
                  datasets: m
                },
                options: h
              }
            )
          }
        ),
        r && /* @__PURE__ */ f.jsx(
          Hre,
          {
            datasets: p.datasets,
            datasetsLabels: p.labels,
            improvement: i,
            urlEditTrajectories: s,
            textOptions: a
          }
        )
      ]
    }
  );
}, FM = (e) => /* @__PURE__ */ y.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("rect", { x: 1, y: 1, width: 18, height: 18, rx: 3, fill: "white" }), /* @__PURE__ */ y.createElement("rect", { x: 1, y: 1, width: 18, height: 18, rx: 3, stroke: "#D1CFCE", strokeWidth: 2 })), NM = (e) => /* @__PURE__ */ y.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("rect", { width: 20, height: 20, rx: 4, fill: "url(#paint0_linear_2034_7850)" }), /* @__PURE__ */ y.createElement("path", { d: "M8.32244 13.9335L4.56689 10.178L5.36133 9.38351L8.32244 12.3446L14.628 6.03906L15.4224 6.83351L8.32244 13.9335Z", fill: "white" }), /* @__PURE__ */ y.createElement("defs", null, /* @__PURE__ */ y.createElement("linearGradient", { id: "paint0_linear_2034_7850", x1: 7.58928, y1: 755124e-13, x2: 7.58928, y2: 20, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ y.createElement("stop", { stopColor: "#484945" }), /* @__PURE__ */ y.createElement("stop", { offset: 1, stopColor: "#2A2B27" })))), Fre = B(si)(() => ({
  ":hover": {
    background: Ee[400]
  }
})), Jxe = (e) => {
  const { values: t, ...n } = e, { onChange: o, ...r } = n, i = Object.entries(t);
  return /* @__PURE__ */ f.jsx(X4, { children: i.map(([s, a], c) => /* @__PURE__ */ f.jsx(
    u2,
    {
      control: /* @__PURE__ */ f.jsx(
        Fre,
        {
          ...r,
          checkedIcon: /* @__PURE__ */ f.jsx(NM, {}),
          icon: /* @__PURE__ */ f.jsx(FM, {}),
          disableRipple: !0,
          onChange: (d, u) => {
            const p = {};
            p[s] = { name: a.name, state: u }, o(p);
          }
        }
      ),
      sx: { gap: "1rem" },
      label: a.name,
      checked: a.state
    },
    `${s}-${c}`
  )) });
}, Qxe = (e, t, n) => Object.entries(t).flatMap((r) => {
  const [i, s] = r;
  if (s.state === !1) return [];
  const a = Number(i), c = e.find((d) => d.id === a);
  return c ? [c] : [n({ id: a, name: s.name })];
}), eye = (e, t) => {
  const n = {};
  return e.reduce((r, i) => {
    const s = t.some((a) => a.id === i.id);
    return r[i.id] = {
      name: i.name,
      state: s
    }, r;
  }, n);
}, Nre = B(si)(() => ({
  ":hover": {
    background: Ee[400]
  }
})), $re = (e) => {
  const { values: t, onChange: n, FormGroupProps: o, FormControlLabelProps: r, CheckboxProps: i } = e, s = Object.entries(t);
  return /* @__PURE__ */ f.jsx(X4, { ...o, children: s.map(([a, c], d) => /* @__PURE__ */ f.jsx(
    u2,
    {
      sx: { gap: "1rem" },
      checked: c.state,
      ...r,
      label: c.name,
      control: /* @__PURE__ */ f.jsx(
        Nre,
        {
          checkedIcon: /* @__PURE__ */ f.jsx(NM, {}),
          icon: /* @__PURE__ */ f.jsx(FM, {}),
          disableRipple: !0,
          ...i,
          onChange: (u, p) => {
            const h = { ...t };
            h[a] = {
              ...h[a],
              name: c.name,
              state: p
            }, n(h);
          }
        }
      )
    },
    `${a}-${d}`
  )) });
}, Bre = (e) => {
  const {
    values: t,
    selectedItems: n,
    onChange: o,
    getId: r = (d) => d.id,
    getName: i = (d) => d.name,
    ...s
  } = e, a = (n == null ? void 0 : n.map((d) => r(d))) ?? [], c = t.reduce((d, u) => {
    const p = r(u), h = a.includes(p), g = n === void 0 ? !1 : h;
    return d[p] = {
      name: i(u),
      state: g,
      rawData: u
    }, d;
  }, {});
  return /* @__PURE__ */ f.jsx(
    $re,
    {
      values: c,
      onChange: (d) => {
        const u = Object.values(d).flatMap((p) => p.state === !1 ? [] : p.rawData);
        return o(u);
      },
      ...s
    }
  );
}, zre = B(J)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  border: `1px solid ${Ee[500]}`,
  background: e.palette.background.paper,
  borderRadius: e.spacing(2),
  overflow: "hidden",
  boxShadow: e.custom.shadows.grey,
  [e.breakpoints.up("md")]: {
    flexDirection: "row-reverse",
    justifyContent: "space-between"
  }
})), Zre = B(J)(({ theme: e }) => ({
  padding: e.spacing(4),
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  [e.breakpoints.up("md")]: {
    padding: e.spacing(6)
  }
})), Wre = B(J)({
  display: "flex",
  flexDirection: "column"
}), Ure = B(J)(({ theme: e }) => ({
  margin: e.spacing(2, 0, 2, 0)
})), Gre = B(J)(({ theme: e }) => ({
  alignSelf: "flex-end",
  [e.breakpoints.up("md")]: {
    alignSelf: "flex-start"
  }
})), qre = B(J)(({ theme: e }) => ({
  width: "100%",
  height: e.spacing(30),
  [e.breakpoints.up("md")]: {
    maxWidth: "500px",
    height: "auto"
  }
})), Kre = B("img")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  objectPosition: "center"
}), tye = (e) => {
  const { title: t, subtitle: n, description: o, imageUrl: r, callToAction: i, sxProps: s = {} } = e, a = ge();
  return /* @__PURE__ */ f.jsxs(zre, { sx: s, children: [
    r && /* @__PURE__ */ f.jsx(qre, { children: /* @__PURE__ */ f.jsx(Kre, { src: r, alt: "hero image" }) }),
    /* @__PURE__ */ f.jsxs(Zre, { children: [
      /* @__PURE__ */ f.jsxs(Wre, { children: [
        /* @__PURE__ */ f.jsx($c, { defaultVariant: "h2", text: t }),
        n && /* @__PURE__ */ f.jsx(
          $c,
          {
            defaultVariant: "h5",
            text: n,
            typographyProps: {
              color: a.custom.grey[2e3],
              padding: a.spacing(0.5, 0, 0.5, 0)
            }
          }
        ),
        o && /* @__PURE__ */ f.jsx(Ure, { children: o })
      ] }),
      i && /* @__PURE__ */ f.jsx(Gre, { children: /* @__PURE__ */ f.jsx(
        Bc,
        {
          buttonOptions: i,
          defaultOptions: {
            sx: {
              display: "inline-flex",
              padding: a.spacing(3),
              letterSpacing: a.spacing(0.02),
              fontWeight: a.typography["body-bold"].fontWeight
            },
            variant: "primary",
            endIcon: /* @__PURE__ */ f.jsx(_t, { size: 2, icon: "arrowRight" })
          }
        }
      ) })
    ] })
  ] });
}, Yre = B(J)(() => ({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0)",
  zIndex: 1e3,
  transition: "background-color 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  visibility: "hidden",
  "&.open": {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    visibility: "visible"
  }
})), Xre = B(J)(({ theme: e }) => ({
  position: "fixed",
  top: 0,
  right: 0,
  bottom: 0,
  width: "75%",
  backgroundColor: e.palette.background.paper,
  zIndex: 1001,
  overflowY: "auto",
  transform: "translateX(100%)",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  opacity: 0,
  borderRadius: `${e.spacing(1)} 0 0 ${e.spacing(1)}`,
  "&.open": {
    transform: "translateX(0)",
    opacity: 1,
    visibility: "visible",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
  },
  [e.breakpoints.down("md")]: {
    width: "100%"
  }
})), rC = B(J)({
  width: "100%",
  height: "400px",
  backgroundColor: "#f0f0f0",
  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "opacity 0.3s ease-in-out"
  }
}), Jre = B(Bt)(({ theme: e }) => ({
  position: "fixed",
  top: e.spacing(2),
  right: e.spacing(2.5),
  zIndex: 1002,
  backgroundColor: "white",
  visibility: "hidden",
  transform: "translateX(200%)",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.8)"
  },
  "&.open": {
    transform: "translateX(0)",
    opacity: 1,
    visibility: "visible",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
  }
})), Qre = B(be)({
  padding: "2rem 4rem"
}), eie = ({ isOpen: e, onClose: t, article: n }) => (mt(() => (e ? document.body.style.overflow = "hidden" : document.body.style.overflow = "unset", () => {
  document.body.style.overflow = "unset";
}), [e]), /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
  /* @__PURE__ */ f.jsx(Yre, { className: e ? "open" : "", onClick: t }),
  /* @__PURE__ */ f.jsx(Jre, { className: e ? "open" : "", onClick: t, children: /* @__PURE__ */ f.jsx(_t, { size: 2, icon: "close" }) }),
  /* @__PURE__ */ f.jsxs(Xre, { className: e ? "open" : "", children: [
    /* @__PURE__ */ f.jsx(v_, { fallback: /* @__PURE__ */ f.jsx(rC, {}), children: /* @__PURE__ */ f.jsx(rC, { children: /* @__PURE__ */ f.jsx(
      "img",
      {
        src: n.imageSrc,
        alt: n.title,
        loading: "lazy",
        onLoad: (o) => {
          o.target.style.opacity = "1";
        },
        style: { opacity: 0 }
      }
    ) }) }),
    /* @__PURE__ */ f.jsxs(Qre, { spacing: 3, children: [
      /* @__PURE__ */ f.jsx(oe, { variant: "h2", children: n.title }),
      /* @__PURE__ */ f.jsx(oe, { variant: "body1", dangerouslySetInnerHTML: {
        __html: n.content
      } })
    ] })
  ] })
] })), tie = [3, 5, 9, 3], nie = B(be, {
  shouldForwardProp: (e) => e !== "isRightColumn"
})(({ isRightColumn: e, theme: t }) => ({
  border: `1px solid ${Ee[500]}`,
  borderRadius: t.spacing(1),
  overflow: "hidden",
  margin: 0,
  padding: 0,
  height: "100%",
  width: "100%",
  flexDirection: e ? "row" : "column",
  [t.breakpoints.down("md")]: {
    flexDirection: "column"
  },
  boxShadow: t.custom.shadows.grey
})), oie = B(J, {
  shouldForwardProp: (e) => e !== "isRightColumn"
})(({ isRightColumn: e, theme: t }) => ({
  flex: e ? "0 0 35%" : "1 1 auto",
  lineHeight: 0,
  position: "relative",
  width: "100%",
  height: e ? "100%" : "380px",
  backgroundColor: t.palette.grey[400],
  overflow: "hidden",
  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center",
    display: "block",
    [t.breakpoints.down("md")]: {
      height: "200px"
    }
  },
  [t.breakpoints.down("md")]: {
    height: "140px"
  },
  [t.breakpoints.down("md")]: {
    flex: 2
  }
})), rie = B(be)(({ theme: e }) => ({
  flex: "1 1 0",
  backgroundColor: e.palette.background.paper,
  padding: e.spacing(3, 3, 2, 3),
  justifyContent: "space-between",
  gap: e.spacing(1),
  [e.breakpoints.down("md")]: {
    padding: e.spacing(2, 2, 1.5, 2)
  },
  [e.breakpoints.down("md")]: {
    flex: "1 1 0"
  }
})), iie = B(t7)({
  display: "block",
  width: "100%",
  height: "100%",
  cursor: "pointer"
}), sie = B(at)(({ theme: e }) => ({
  display: "inline-flex",
  alignSelf: "flex-start",
  fontWeight: 700,
  gap: e.spacing(1)
})), aie = B(oe, {
  shouldForwardProp: (e) => e !== "isFirst"
})(({ isFirst: e, articlesNumber: t, theme: n }) => ({
  display: "-webkit-box",
  WebkitLineClamp: e ? 5 : tie[t - 1] || 3,
  marginTop: n.spacing(2),
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  [n.breakpoints.down("md")]: {
    WebkitLineClamp: e ? 3 : 2,
    marginTop: n.spacing(1)
  }
})), iC = (e) => {
  const [t, n] = Ae(!1), {
    title: o,
    description: r,
    imageSrc: i,
    content: s,
    onClick: a,
    isFirst: c = !1,
    articlesNumber: d = 1,
    isRightColumn: u = !1,
    readMoreText: p = "Lire l'article"
  } = e, h = () => {
    a ? a() : n(!0);
  };
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs(nie, { isRightColumn: u, children: [
      /* @__PURE__ */ f.jsx(oie, { isRightColumn: u, children: /* @__PURE__ */ f.jsx(iie, { onClick: h, children: /* @__PURE__ */ f.jsx("img", { src: i, alt: o }) }) }),
      /* @__PURE__ */ f.jsxs(rie, { children: [
        /* @__PURE__ */ f.jsxs(J, { children: [
          /* @__PURE__ */ f.jsx(oe, { variant: "h3", mb: "0.2rem", children: o }),
          /* @__PURE__ */ f.jsx(aie, { variant: "body", mb: "1rem", isFirst: c, articlesNumber: d, dangerouslySetInnerHTML: {
            __html: r
          } })
        ] }),
        /* @__PURE__ */ f.jsxs(sie, { variant: "text", onClick: h, children: [
          /* @__PURE__ */ f.jsx(oe, { fontWeight: 700, fontSize: "0.875rem", children: p }),
          /* @__PURE__ */ f.jsx(_t, { size: 2, icon: "arrowRight" })
        ] })
      ] })
    ] }),
    !a && /* @__PURE__ */ f.jsx(
      eie,
      {
        isOpen: t,
        onClose: () => n(!1),
        article: {
          title: o,
          description: r,
          imageSrc: i,
          content: s || r
        }
      }
    )
  ] });
}, nye = (e) => {
  const { articles: t = [], sxProps: n = {} } = e, [o, ...r] = t;
  return /* @__PURE__ */ f.jsxs(
    to,
    {
      container: !0,
      columns: r.length > 0 ? 2 : 1,
      sx: {
        ...n,
        height: "100%",
        "& .MuiGrid-item": {
          "@media (max-width: 1068px)": {
            width: "100%",
            maxWidth: "100%",
            flexBasis: "100%"
          }
        }
      },
      spacing: 4,
      children: [
        /* @__PURE__ */ f.jsx(to, { item: !0, xs: 1, children: /* @__PURE__ */ f.jsx(iC, { ...o, isFirst: !0, articlesNumber: t.length }) }),
        /* @__PURE__ */ f.jsx(to, { item: !0, xs: 1, children: /* @__PURE__ */ f.jsx(
          Op,
          {
            gap: 3,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
            sx: {
              "@media (max-width: 1068px)": {
                gap: 2,
                marginTop: 0
              }
            },
            children: r.map((i, s) => /* @__PURE__ */ f.jsx(Op, { height: "100%", children: /* @__PURE__ */ f.jsx(
              iC,
              {
                ...i,
                isRightColumn: t.length >= 3,
                articlesNumber: t.length
              }
            ) }, `article-${s}`))
          }
        ) })
      ]
    }
  );
}, oye = (e) => {
  const { title: t, children: n, objectives: o = [], tooltipMessage: r } = e, i = ge();
  return /* @__PURE__ */ f.jsxs(
    be,
    {
      sx: {
        borderRadius: "12px",
        border: `1px solid ${i.palette.grey[500]}`,
        padding: "34px",
        maxWidth: "360px",
        background: i.palette.background.paper
      },
      children: [
        /* @__PURE__ */ f.jsxs(J, { display: "flex", children: [
          /* @__PURE__ */ f.jsx(oe, { variant: "h3", component: "h3", mb: "1.5rem", children: t }),
          r && /* @__PURE__ */ f.jsx(_t, { size: 3, icon: "information" })
        ] }),
        /* @__PURE__ */ f.jsx(J, { fontWeight: 700, display: "flex", gap: "0.5rem", mb: "1rem", children: n }),
        /* @__PURE__ */ f.jsx(
          be,
          {
            sx: {
              "> div:not(:last-of-type)": {
                mb: "1rem"
              }
            },
            children: o.map((s, a) => /* @__PURE__ */ f.jsxs(be, { flexDirection: "row", alignItems: "center", gap: ".5rem", children: [
              /* @__PURE__ */ f.jsx(oe, { variant: "small-medium", children: s.objective }),
              /* @__PURE__ */ f.jsx(NK, { boxProps: { sx: { padding: "0.1rem 0.5rem" } }, children: s.component })
            ] }, a))
          }
        )
      ]
    }
  );
}, rye = (e) => {
  const { title: t, subtitle: n, description: o } = e, r = ge();
  return /* @__PURE__ */ f.jsxs(
    be,
    {
      sx: {
        borderRadius: "12px",
        border: `1px solid ${r.palette.grey[500]}`,
        padding: "34px",
        maxWidth: "360px",
        background: r.palette.background.paper
      },
      children: [
        /* @__PURE__ */ f.jsxs(be, { flexDirection: "row", alignContent: "center", justifyContent: "space-between", children: [
          /* @__PURE__ */ f.jsx(oe, { variant: "h3", component: "h3", mb: "1.5rem", children: t }),
          n && /* @__PURE__ */ f.jsx(lie, { text: n })
        ] }),
        /* @__PURE__ */ f.jsx(be, { children: /* @__PURE__ */ f.jsx(oe, { variant: "body-medium", children: /* @__PURE__ */ f.jsx(J, { dangerouslySetInnerHTML: { __html: o } }) }) })
      ]
    }
  );
};
function lie(e) {
  const { text: t } = e;
  return /* @__PURE__ */ f.jsx(
    Ma,
    {
      sx: {
        textAlign: "center"
      },
      arrow: !1,
      title: /* @__PURE__ */ f.jsx(oe, { variant: "body-medium", children: t }),
      placement: "top",
      children: /* @__PURE__ */ f.jsx(J, { children: /* @__PURE__ */ f.jsx(_t, { size: 3, icon: "information" }) })
    }
  );
}
const iye = (e) => {
  const { value: t, maxLength: n, ...o } = e, r = t.map(
    (u, p) => t.slice(0, p + 1).reduce(
      (h, g) => {
        const m = h.length + g.length;
        if (m > n) {
          const b = n - m, C = [...h.words, g.slice(0, b)].filter(Boolean);
          return {
            length: m,
            words: C,
            rest: t.length - C.length
          };
        }
        return { ...h, length: m, words: [...h.words, g] };
      },
      { length: 0, words: [], rest: 0 }
    )
  ), i = r[r.length - 1], a = t[t.length - 1].length === i.words[i.words.length - 1].length ? "" : "…", c = i.words.join(", "), d = i.rest > 0 ? `${c}… +${i.rest}` : c + a;
  return /* @__PURE__ */ f.jsx(oe, { ...o, children: d });
}, sye = (e) => {
  const {
    value: t,
    maxLength: n,
    separator: o = ",",
    ...r
  } = e;
  if (n === 0)
    return /* @__PURE__ */ f.jsx(oe, { ...r, children: "" });
  const i = t.join("").length;
  if (n > i)
    return /* @__PURE__ */ f.jsx(oe, { ...r, children: t.join(o) });
  let s = 0;
  const a = t.reduce((x, v) => {
    const S = s + v.length, M = {
      low: s,
      high: S
    };
    return s = S, x.push(M), x;
  }, []), c = a.findIndex((x) => x.low < n && n <= x.high), d = c + 1, u = a.length - d, h = a[c].high === n ? "" : "…", g = d * o.length, m = t.join(o).slice(0, n - 1 + g), b = u ? `+${u}` : "", C = `${m}${h} ${b}`;
  return /* @__PURE__ */ f.jsx(oe, { ...r, children: C });
}, aye = (e) => {
  const {
    setOpen: t,
    options: n,
    onValidate: o,
    onCancel: r,
    canValidate: i = !0,
    confirmAction: s,
    cancelText: a,
    validateText: c,
    ...d
  } = e, [u, p] = Ae(!1), h = () => t(!1), g = () => {
    p(!1);
  }, m = () => {
    r && r(), h();
  }, b = () => {
    if (!s) {
      o && o(), h();
      return;
    }
    u ? (p(!1), o && o(), h()) : p(!0);
  };
  return /* @__PURE__ */ f.jsxs(d2, { onClose: m, ...d, fullWidth: !0, maxWidth: "md", scroll: "body", children: [
    /* @__PURE__ */ f.jsxs(_0, { sx: BM, children: [
      n.title,
      /* @__PURE__ */ f.jsx(at, { variant: "text", endIcon: /* @__PURE__ */ f.jsx(j3, {}), onClick: m })
    ] }),
    /* @__PURE__ */ f.jsx(J, { sx: { width: "100%" }, children: n.content }),
    /* @__PURE__ */ f.jsx(
      $M,
      {
        onCancelAction: m,
        onConfirmAction: b,
        canValidate: i,
        cancelText: a,
        validateText: c
      }
    ),
    s && /* @__PURE__ */ f.jsx(
      cie,
      {
        openConfirmAction: u,
        onCancel: g,
        onValidate: b,
        confirmAction: s,
        cancelText: a,
        validateText: c
      }
    )
  ] });
}, cie = (e) => {
  const { confirmAction: t, onCancel: n, onValidate: o, openConfirmAction: r, cancelText: i, validateText: s } = e;
  return /* @__PURE__ */ f.jsxs(
    d2,
    {
      open: r,
      onClose: n,
      sx: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: `1px solid ${Ee[500]}`,
        minHeight: "68px",
        padding: "28px 27px 28px 32px"
      },
      children: [
        /* @__PURE__ */ f.jsxs(_0, { sx: BM, children: [
          t.title,
          /* @__PURE__ */ f.jsx(at, { variant: "text", endIcon: /* @__PURE__ */ f.jsx(j3, {}), onClick: n })
        ] }),
        /* @__PURE__ */ f.jsx(
          J,
          {
            sx: {
              padding: "32px",
              width: "100%"
            },
            children: t.content
          }
        ),
        /* @__PURE__ */ f.jsx(
          $M,
          {
            onCancelAction: n,
            onConfirmAction: o,
            cancelText: t.cancelText ?? i,
            validateText: t.validateText ?? s
          }
        )
      ]
    }
  );
}, $M = (e) => {
  const { onCancelAction: t, onConfirmAction: n, canValidate: o = !0, cancelText: r, validateText: i } = e;
  return /* @__PURE__ */ f.jsxs(
    k3,
    {
      sx: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderTop: `1px solid ${Ee[500]}`,
        minHeight: "68px",
        paddingInline: "1rem",
        padding: "28px 32px 32px 32px"
      },
      children: [
        /* @__PURE__ */ f.jsx(at, { variant: "text", onClick: t, children: r }),
        /* @__PURE__ */ f.jsx(at, { variant: "primary", onClick: n, disabled: !o, children: i })
      ]
    }
  );
}, BM = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderBottom: `1px solid ${Ee[500]}`,
  minHeight: "68px",
  padding: "28px 27px 28px 32px"
}, die = B(a2)(({ theme: e }) => ({
  fontFamily: e.typography.fontFamily,
  ...e.typography.body
})), N0 = vs(function(e, t) {
  const n = ge(), { sx: o, error: r, ...i } = e;
  return /* @__PURE__ */ f.jsx(
    die,
    {
      ...i,
      sx: {
        color: r ? n.custom.red[600] : n.custom.grey[2800],
        border: r ? `1px solid ${n.custom.red[600]}` : `1px solid ${n.custom.grey[1400]}`,
        backgroundColor: r ? n.custom.red[100] : "inherit",
        borderRadius: "16px",
        paddingInline: "20px",
        ...o
      }
    }
  );
}), lye = (e) => {
  const { title: t, unit: n, placeholder: o, value: r, description: i, error: s, required: a, ...c } = e, d = a ? "*" : "", u = ge(), p = St(!1), h = p.current && s, [g, m] = Ae(!1), [b, C] = Ae(!1), [x, v] = Ae(!1);
  mt(() => {
    const E = S(M, e.setMinMaxError);
    m(E);
    const R = S(w, e.setMinError);
    C(R);
    const O = S(k, e.setMaxError);
    v(O);
  }, [r]);
  const S = (E, R) => {
    const O = E();
    return R !== void 0 && R(O), O;
  }, M = () => {
    if (e.min === void 0 && e.max === void 0 || r === void 0 || r === "") return !1;
    const E = Number(r);
    return !(e.min !== void 0 && E > e.min && e.max !== void 0 && E < e.max);
  }, w = () => e.min === void 0 || r === void 0 || r === "" ? !1 : !(e.min < Number(r) && e.max === void 0), k = () => e.max === void 0 || r === void 0 || r === "" ? !1 : !(e.max > Number(r) && e.min === void 0);
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: "10px"
      },
      children: [
        /* @__PURE__ */ f.jsx(oe, { variant: "h5", children: `${t}${d} :` }),
        /* @__PURE__ */ f.jsxs(
          "div",
          {
            style: {
              display: "flex",
              alignItems: "center",
              gap: "5px"
            },
            children: [
              /* @__PURE__ */ f.jsx(
                N0,
                {
                  ...c,
                  type: "number",
                  style: {
                    minWidth: "150px",
                    width: "10%",
                    borderColor: h ? u.palette.error.main : "inherit",
                    backgroundColor: h ? u.palette.error.light : "inherit"
                  },
                  placeholder: o,
                  value: r,
                  onChange: (E) => {
                    p.current = !0, c.onChange && c.onChange(E);
                  }
                }
              ),
              /* @__PURE__ */ f.jsx(oe, { variant: "body", children: n })
            ]
          }
        ),
        (!!e.minMaxErrorMessage && g || !!e.minErrorMessage && b || !!e.maxErrorMessage && x) && /* @__PURE__ */ f.jsxs(
          oe,
          {
            variant: "body",
            style: {
              color: u.custom.red[600]
            },
            children: [
              !!e.minMaxErrorMessage && g && e.minMaxErrorMessage,
              !!e.minErrorMessage && b && e.minErrorMessage,
              !!e.maxErrorMessage && x && e.maxErrorMessage
            ]
          }
        ),
        /* @__PURE__ */ f.jsx(oe, { variant: "body", children: i })
      ]
    }
  );
}, cye = (e) => {
  const { unit: t, sx: n, ...o } = e;
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        gap: "1rem"
      },
      children: [
        /* @__PURE__ */ f.jsx(
          N0,
          {
            type: "number",
            sx: {
              minWidth: "125px",
              width: "10%",
              ...n
            },
            ...o
          }
        ),
        /* @__PURE__ */ f.jsx(oe, { variant: "body", children: t })
      ]
    }
  );
};
function dye(e) {
  const t = ge(), n = {
    height: "40px",
    padding: "0px 6px 0px 20px",
    ...t.custom.searchBox,
    minWidth: "350px"
  }, o = {
    height: "20px",
    padding: "0px",
    width: "100%",
    "&>.MuiInputBase-root>fieldset": {
      border: "none"
    },
    "&>.MuiInputBase-root>input": {
      padding: "0"
    }
  }, r = {
    height: "48px",
    padding: "0px 16px 0px 24px",
    borderTop: "1px solid " + t.custom.grey[500],
    borderBottom: "1px solid " + t.custom.grey[500],
    background: t.custom.grey[200]
  }, i = {
    "&>.MuiInputBase-root>fieldset": {
      border: "none"
    },
    "&>.MuiInputBase-root>input": {
      width: "100%",
      height: "48px",
      padding: "0",
      border: "none"
    }
  };
  return /* @__PURE__ */ f.jsxs(
    be,
    {
      direction: "row",
      useFlexGap: !0,
      gap: "10px",
      justifyContent: "space-between",
      alignItems: "center",
      sx: e.variant === "standalone" ? n : r,
      children: [
        /* @__PURE__ */ f.jsx(
          Ir,
          {
            label: "",
            type: "search",
            placeholder: e.placeholder,
            value: e.value,
            onChange: (s) => {
              e.onChange(s.target.value);
            },
            sx: e.variant === "standalone" ? o : i
          }
        ),
        /* @__PURE__ */ f.jsx(CK, {})
      ]
    }
  );
}
const uye = vs(function(t, n) {
  const { title: o, placeholder: r, value: i, description: s, sx: a, error: c, required: d, ...u } = t, p = d ? "*" : "", h = ge(), g = St(!1), m = g.current && c;
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: "10px"
      },
      children: [
        /* @__PURE__ */ f.jsx(oe, { variant: "h5", children: `${o}${p} :` }),
        /* @__PURE__ */ f.jsx(
          N0,
          {
            ...u,
            sx: {
              width: "70%",
              borderColor: m ? h.custom.red[600] : "inherit",
              backgroundColor: m ? h.custom.red[100] : "inherit",
              ...a
            },
            placeholder: r,
            value: i,
            onChange: (b) => {
              g.current = !0, u.onChange && u.onChange(b);
            }
          }
        ),
        /* @__PURE__ */ f.jsx(oe, { variant: "body", children: s })
      ]
    }
  );
});
function fye(e) {
  return /* @__PURE__ */ f.jsxs("div", { children: [
    /* @__PURE__ */ f.jsx(oe, { variant: "body-bold", sx: { marginBottom: "16px" }, children: e.header }),
    /* @__PURE__ */ f.jsxs(be, { direction: "column", useFlexGap: !0, gap: "12px", children: [
      /* @__PURE__ */ f.jsxs(be, { direction: "row", sx: { height: "20px" }, useFlexGap: !0, gap: "12px", justifyContent: "flex-start", children: [
        /* @__PURE__ */ f.jsx(si, { checked: !0, sx: { width: "20px", height: "20px" } }),
        /* @__PURE__ */ f.jsx(oe, { variant: "body", children: e.allText })
      ] }),
      e.values.map((t, n) => /* @__PURE__ */ f.jsxs(
        be,
        {
          direction: "row",
          sx: { height: "20px" },
          useFlexGap: !0,
          gap: "12px",
          justifyContent: "flex-start",
          children: [
            /* @__PURE__ */ f.jsx(si, { checked: !1, sx: { width: "20px", height: "20px" } }),
            /* @__PURE__ */ f.jsx(oe, { variant: "body", children: t })
          ]
        },
        n
      ))
    ] })
  ] });
}
function pye(e) {
  return /* @__PURE__ */ f.jsxs(be, { direction: "column", useFlexGap: !0, gap: "12px", alignItems: "flex-start", children: [
    /* @__PURE__ */ f.jsx(oe, { variant: "body-bold", children: e.header }),
    /* @__PURE__ */ f.jsx(be, { direction: "row", useFlexGap: !0, gap: "8px", flexWrap: "wrap", children: e.values.map((t, n) => /* @__PURE__ */ f.jsxs(
      be,
      {
        direction: "row",
        useFlexGap: !0,
        gap: "4px",
        sx: { height: "28px", borderRadius: "4px", background: "#EFEDEC", paddingLeft: "8px" },
        alignItems: "center",
        children: [
          /* @__PURE__ */ f.jsx(oe, { variant: "body", children: t }),
          /* @__PURE__ */ f.jsx(Bt, { sx: { width: "20px", height: "20px" }, children: /* @__PURE__ */ f.jsx(f7, { sx: { width: "16px", height: "16px" } }) })
        ]
      },
      n
    )) }),
    /* @__PURE__ */ f.jsx(at, { variant: "text", startIcon: /* @__PURE__ */ f.jsx(iK, {}), children: e.addText })
  ] });
}
const uie = (e) => {
  const t = ge(), { steps: n, currentStep: o = 0, icons: r = [], clickable: i = !1, onClick: s } = e;
  return /* @__PURE__ */ f.jsxs(J, { display: "inline-flex", position: "relative", children: [
    /* @__PURE__ */ f.jsx(be, { direction: "row", gap: "12px", position: "relative", sx: { zIndex: 1 }, children: [...Array(n ?? r.length).keys()].map((a) => {
      const c = a <= o;
      return /* @__PURE__ */ f.jsx(
        p7,
        {
          size: "medium",
          border: `1px solid ${t.custom.grey[500]}`,
          color: c ? "#FFF" : t.custom.grey[2800],
          bgcolor: c ? t.custom.grey[2800] : "#FFF",
          sx: {
            fill: c ? "#FFF" : t.custom.grey[2800],
            cursor: i ? "pointer" : "default",
            "&:hover": i ? {
              fill: "#FFF",
              color: "#FFF",
              bgcolor: t.custom.grey[c ? 2800 : 2e3]
            } : {}
          },
          onClick: () => {
            i && s && s(a);
          },
          children: r && r[a] ? r[a] : a + 1
        },
        a
      );
    }) }),
    /* @__PURE__ */ f.jsx(
      ho,
      {
        sx: {
          backgroundColor: t.custom.grey[500],
          position: "absolute",
          inset: `${36 / 2}px`
        }
      }
    )
  ] });
}, zM = (e) => /* @__PURE__ */ y.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M11.021 7.69411H0.333496V6.30524H11.021L6.021 1.30522L7.00016 0.333008L13.6668 6.99967L7.00016 13.6663L6.021 12.6941L11.021 7.69411Z", fill: "white" })), ZM = (e) => /* @__PURE__ */ y.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M2.97919 7.69411L7.97921 12.6941L7.00004 13.6663L0.333374 6.99967L7.00004 0.333008L7.97921 1.30522L2.97919 6.30524H13.6667V7.69411H2.97919Z", fill: "#B06803" })), fie = (e) => {
  var t;
  return /* @__PURE__ */ f.jsxs(
    be,
    {
      direction: "row",
      alignItems: "center",
      justifyContent: "space-between",
      sx: {
        minHeight: "96px",
        zIndex: 1e3,
        position: "sticky",
        top: "28px",
        border: "1px solid #E7E6E4",
        borderRadius: "52px",
        backgroundColor: "#FFFFFF",
        padding: "20px 28px"
      },
      children: [
        /* @__PURE__ */ f.jsx(pie, { title: e.title, subtitle: e.subtitle }),
        /* @__PURE__ */ f.jsx(
          uie,
          {
            icons: e.icons,
            steps: e.steps ?? ((t = e.icons) == null ? void 0 : t.length) ?? 0,
            currentStep: e.currentPage,
            clickable: e.navigable,
            onClick: e.onNavigate
          }
        ),
        /* @__PURE__ */ f.jsx(
          gie,
          {
            onPageForward: e.onPageForward,
            onPageBack: e.onPageBack,
            nextPageText: e.nextPageText,
            previousPageText: e.previousPageText,
            currentPage: e.currentPage,
            validateSteps: e.validateSteps,
            validateStepsTexts: e.validateStepsTexts,
            warningText: e.warningText,
            savingState: e.savingState,
            closeable: e.closeable,
            onClose: e.onClose
          }
        )
      ]
    }
  );
}, pie = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsx(be, { direction: "row", alignItems: "center", justifyContent: "start", marginX: "20px", maxWidth: "33%", children: /* @__PURE__ */ f.jsxs(be, { gap: "4px", children: [
    /* @__PURE__ */ f.jsx(oe, { variant: "h3", children: e.title }),
    e.subtitle && /* @__PURE__ */ f.jsx(oe, { variant: "body", color: t.custom.grey[2e3], children: e.subtitle })
  ] }) });
}, hie = (e) => {
  const t = ge(), n = e.saving ? Aw : Dw, o = e.saving ? {
    animation: "spin 1s linear infinite",
    "@keyframes spin": {
      "0%": {
        transform: "rotate(360deg)"
      },
      "100%": {
        transform: "rotate(0deg)"
      }
    }
  } : {}, r = /* @__PURE__ */ f.jsx(
    n,
    {
      sx: {
        width: "24px",
        color: t.custom.grey[2e3],
        ...o
      }
    }
  ), i = /* @__PURE__ */ f.jsx(J, { padding: "12px 16px", textAlign: "center", children: /* @__PURE__ */ f.jsx(oe, { variant: "body", children: e.saving ? e.savingMessage : e.savedMessage }) });
  return /* @__PURE__ */ f.jsx(F3, { icon: r, body: i, size: "260px" });
}, gie = (e) => {
  const t = ge(), n = /* @__PURE__ */ f.jsx(
    at,
    {
      variant: "primary",
      disabled: e.validateSteps && !e.validateSteps[e.currentPage],
      endIcon: /* @__PURE__ */ f.jsx(zM, {}),
      onClick: e.onPageForward,
      children: e.nextPageText
    }
  ), o = /* @__PURE__ */ f.jsxs(J, { padding: "12px 16px", children: [
    /* @__PURE__ */ f.jsx(oe, { variant: "body-bold", children: e.warningText || "" }),
    /* @__PURE__ */ f.jsx("br", {}),
    /* @__PURE__ */ f.jsx(oe, { variant: "body", children: e.validateStepsTexts && e.validateStepsTexts[e.currentPage] || "" })
  ] });
  return /* @__PURE__ */ f.jsxs(be, { direction: "row", alignItems: "center", justifyContent: "end", gap: "28px", children: [
    /* @__PURE__ */ f.jsx(J, { sx: { ">*": { display: "flex" } }, children: e.savingState && /* @__PURE__ */ f.jsx(hie, { ...e.savingState }) }),
    /* @__PURE__ */ f.jsxs(be, { direction: "row", gap: "20px", children: [
      e.previousPageText && /* @__PURE__ */ f.jsx(at, { variant: "text", startIcon: /* @__PURE__ */ f.jsx(ZM, {}), onClick: e.onPageBack, children: e.previousPageText }),
      e.validateSteps && !e.validateSteps[e.currentPage] ? e.nextPageText && /* @__PURE__ */ f.jsx(F3, { icon: n, body: o, size: "260px" }) : e.nextPageText && n
    ] }),
    e.closeable && /* @__PURE__ */ f.jsx(
      at,
      {
        variant: "white-filled",
        onClick: e.onClose,
        sx: {
          minWidth: 0,
          aspectRatio: 1,
          borderRadius: "100%",
          padding: 0,
          "&:hover": {
            background: t.custom.grey[400]
          },
          "&:active": {
            background: t.custom.grey[600]
          }
        },
        children: /* @__PURE__ */ f.jsx(
          Vw,
          {
            sx: {
              width: "20px",
              color: t.custom.grey[2800]
            }
          }
        )
      }
    )
  ] });
}, WM = (e) => {
  const t = ge(), { title: n, titleSize: o, badge: r } = e, s = o || "h1";
  return /* @__PURE__ */ f.jsxs(be, { direction: "row", alignItems: "center", gap: "16px", children: [
    typeof r == "number" ? /* @__PURE__ */ f.jsx(p7, { size: "big", children: r }) : /* @__PURE__ */ f.jsx(
      be,
      {
        width: "40px",
        alignItems: "center",
        color: t.custom.grey[2800],
        children: /* @__PURE__ */ f.jsx(be, { sx: { transform: "scale(250%)" }, children: r })
      }
    ),
    /* @__PURE__ */ f.jsx(oe, { variant: s, children: n })
  ] });
}, hye = (e) => {
  const { title: t, subtitle: n, pages: o, pageIndexToDisplay: r = 0, savingState: i, closeable: s = !0 } = e, a = o.map((u) => u.icon), c = o[r], d = (Array.isArray(c.content) ? c.content : [c.content]).map(
    (u, p) => /* @__PURE__ */ f.jsx(ws, { children: u }, p)
  );
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(
      fie,
      {
        title: t,
        subtitle: n,
        icons: a,
        steps: o.length,
        currentPage: r,
        nextPageText: e.nextPageText,
        previousPageText: e.previousPageText,
        onPageForward: e.onPageForward,
        onPageBack: e.onPageBack,
        validateSteps: e.validateSteps,
        validateStepsTexts: e.validateStepsTexts,
        warningText: e.warningText,
        savingState: i,
        navigable: e.navigable,
        onNavigate: e.onNavigate,
        closeable: s,
        onClose: e.onClose
      }
    ),
    /* @__PURE__ */ f.jsx(be, { direction: "column", alignItems: "center", children: /* @__PURE__ */ f.jsxs(
      "div",
      {
        style: {
          width: "1024px"
        },
        children: [
          /* @__PURE__ */ f.jsxs(be, { direction: "column", marginTop: "44px", marginBottom: "36px", gap: "2rem", children: [
            c.title && /* @__PURE__ */ f.jsx(WM, { title: c.title, badge: c.icon ?? r + 1 }),
            c.subTitle && /* @__PURE__ */ f.jsx(oe, { variant: "h4", children: c.subTitle }),
            c.subTitle && /* @__PURE__ */ f.jsx(ho, {}),
            c.info
          ] }),
          c.usesBaseLayout === !1 ? /* @__PURE__ */ f.jsx(f.Fragment, { children: d }) : /* @__PURE__ */ f.jsx(mie, { children: d })
        ]
      }
    ) })
  ] });
}, mie = (e) => {
  const { children: t } = e, n = Array.isArray(t) ? t : [t];
  return /* @__PURE__ */ f.jsx("div", { children: n.map((o, r) => /* @__PURE__ */ f.jsx(ws, { children: o }, r)) });
}, gye = ({ sx: e = {}, ...t }) => /* @__PURE__ */ f.jsx(
  J,
  {
    sx: {
      boxShadow: "0px 2px 8px 0px #2A2B270A",
      border: `1px solid ${Ee[500]}`,
      borderRadius: "16px",
      backgroundColor: "#FFFFFF",
      padding: "2rem",
      height: "fit-content",
      ...e
    },
    ...t
  }
), mye = (e) => {
  const { title: t, hint: n, indicator: o, children: r, ...i } = e;
  return /* @__PURE__ */ f.jsx(Hr, { width: "100%", padding: "32px", ...i, children: /* @__PURE__ */ f.jsxs(be, { gap: "32px", children: [
    /* @__PURE__ */ f.jsxs(be, { direction: "row", alignItems: "start", gap: "32px", children: [
      /* @__PURE__ */ f.jsx(oe, { variant: "h4", flex: 1, children: t }),
      o && /* @__PURE__ */ f.jsx(
        u7,
        {
          value: o.value,
          unit: o.unit,
          sx: {
            top: "-12px",
            right: "-12px"
          }
        }
      )
    ] }),
    /* @__PURE__ */ f.jsxs(be, { gap: "24px", children: [
      r,
      n && /* @__PURE__ */ f.jsx(WK, { children: /* @__PURE__ */ f.jsx(J, { dangerouslySetInnerHTML: { __html: n } }) })
    ] })
  ] }) });
}, bie = () => {
  const [e, t] = Ae({ isLocked: !1 }), n = (u) => {
    t({ isLocked: !0, message: u });
  }, o = () => {
    t({ isLocked: !1 });
  }, [r, i] = Ae({ isLocked: !1 }), s = (u) => {
    i({ isLocked: !0, message: u });
  }, a = () => {
    i({ isLocked: !1 });
  };
  return {
    forwardLock: e,
    lockForward: n,
    unlockForward: o,
    previousLock: r,
    lockPrevious: s,
    unlockPrevious: a,
    lockAll: (u) => {
      n(u), s(u);
    },
    unlockAll: () => {
      o(), a();
    }
  };
}, UM = h0(null), Cie = (e) => {
  const { children: t, startingPage: n = 0, ...o } = e, [r, i] = Ae(!1), [s, a] = Ae(!1), [c, d] = Ae(n), u = e.pages.length, p = e.pages[c] ?? null, h = bie(), [g, m] = Ae(!1), b = {
    ...o,
    ...h,
    isSaving: r,
    setSaving: i,
    selectedPage: p,
    selectedPageIndex: c,
    setPage: d,
    maxPage: u,
    formSaved: g,
    setFormSaved: m,
    isError: s,
    setError: a
  };
  return /* @__PURE__ */ f.jsx(UM.Provider, { value: b, children: t });
}, m2 = () => {
  const e = p0(UM);
  if (e)
    return e;
  throw new Error("useFormBaseContext must be used within an FormBaseContextProvider");
}, xie = () => {
  const { selectedPageIndex: e, setPage: t, onPageChange: n, pages: o, previousLock: r, forwardLock: i, maxPage: s, setFormSaved: a, isLoading: c } = m2(), d = ge(), u = {
    selected: {
      color: "#FFF",
      background: d.custom.grey[2800],
      hover: {
        color: "#FFF",
        background: d.custom.grey[2800]
      }
    },
    locked: {
      color: d.custom.grey[500],
      background: "#FFF",
      hover: {
        color: d.custom.grey[500],
        background: "#FFF"
      }
    },
    default: {
      color: d.custom.grey[2800],
      background: "#FFF",
      hover: {
        color: "#FFF",
        background: d.custom.grey[2e3]
      }
    }
  };
  return c ? /* @__PURE__ */ f.jsx(Sa, {}) : /* @__PURE__ */ f.jsxs(J, { display: "inline-flex", position: "relative", children: [
    /* @__PURE__ */ f.jsx(be, { direction: "row", gap: "12px", position: "relative", sx: { zIndex: 1 }, children: [...Array(s)].map((p, h) => {
      var S, M;
      const g = r.isLocked && h < e, m = i.isLocked && h > e, b = g || m, x = h === e ? u.selected : u[b ? "locked" : "default"], v = ((S = o[h]) == null ? void 0 : S.icon) ?? h + 1;
      return /* @__PURE__ */ f.jsx(
        p7,
        {
          size: "medium",
          border: `1px solid ${d.custom.grey[500]}`,
          color: x.color,
          bgcolor: x.background,
          tooltip: (M = o[h]) == null ? void 0 : M.title,
          sx: {
            fill: x.color,
            cursor: b ? "default" : "pointer",
            "&:hover": {
              fill: x.hover.color,
              color: x.hover.color,
              bgcolor: x.hover.background
            }
          },
          onClick: () => {
            h === e || b || (a(!1), t(h), n == null || n(h, e));
          },
          children: v
        },
        `page-top-display-${h}`
      );
    }) }),
    /* @__PURE__ */ f.jsx(
      ho,
      {
        sx: {
          backgroundColor: d.custom.grey[500],
          position: "absolute",
          inset: `${36 / 2}px`
        }
      }
    )
  ] });
}, yie = () => {
  const { textOptions: e, isLoading: t } = m2(), n = ge();
  return /* @__PURE__ */ f.jsx(be, { direction: "row", alignItems: "center", justifyContent: "start", marginX: "20px", maxWidth: "33%", children: /* @__PURE__ */ f.jsxs(be, { gap: "4px", children: [
    /* @__PURE__ */ f.jsx(oe, { variant: "h3", children: t ? /* @__PURE__ */ f.jsx(Sa, { size: "18px" }) : e.title }),
    e.subtitle && /* @__PURE__ */ f.jsx(oe, { variant: "body", color: n.custom.grey[2e3], children: e.subtitle })
  ] }) });
}, vie = () => {
  const e = ge(), { isSaving: t, textOptions: n, isError: o } = m2(), r = t ? Aw : o ? yK : Dw, i = t ? {
    animation: "spin 1s linear infinite",
    "@keyframes spin": {
      "0%": {
        transform: "rotate(360deg)"
      },
      "100%": {
        transform: "rotate(0deg)"
      }
    }
  } : {}, s = /* @__PURE__ */ f.jsx(
    r,
    {
      sx: {
        width: "24px",
        color: o ? e.custom.red[600] : e.custom.grey[2e3],
        ...i
      }
    }
  ), a = /* @__PURE__ */ f.jsx(J, { padding: "12px 16px", textAlign: "center", children: /* @__PURE__ */ f.jsx(oe, { variant: "body-medium", children: t ? n.syncingMessage : o ? n.errorDefaultMessage : n.savingDefaultMessage }) });
  return /* @__PURE__ */ f.jsx(F3, { icon: s, body: a, size: "260px" });
}, wie = () => {
  const {
    confirmExit: e,
    selectedPageIndex: t,
    setPage: n,
    maxPage: o,
    forwardLock: r,
    previousLock: i,
    textOptions: s,
    onClose: a,
    onValidate: c,
    onPageChange: d,
    showSync: u,
    setFormSaved: p,
    openConfirmDialog: h,
    isLoading: g
  } = m2(), m = ge(), C = t === o - 1 && s.finalPage ? s.finalPage : s.nextPage, x = /* @__PURE__ */ f.jsx(
    at,
    {
      variant: "primary",
      disabled: r.isLocked || g,
      endIcon: /* @__PURE__ */ f.jsx(zM, {}),
      onClick: () => {
        if (t === o - 1) {
          p(!0), c == null || c();
          return;
        }
        return p(!1), d == null || d(t + 1, t), n(t + 1);
      },
      children: C
    }
  ), v = /* @__PURE__ */ f.jsxs(J, { padding: "12px 16px", children: [
    /* @__PURE__ */ f.jsx(oe, { variant: "body-bold", children: s.warningText ? s.warningText : "" }),
    /* @__PURE__ */ f.jsx("br", {}),
    /* @__PURE__ */ f.jsx(oe, { variant: "body", children: r.isLocked && r.message || "" })
  ] });
  return /* @__PURE__ */ f.jsxs(be, { direction: "row", alignItems: "center", justifyContent: "end", gap: "28px", children: [
    /* @__PURE__ */ f.jsx(J, { sx: { ">*": { display: "flex" } }, children: u && /* @__PURE__ */ f.jsx(vie, {}) }),
    /* @__PURE__ */ f.jsxs(be, { direction: "row", gap: "20px", children: [
      s.previousPage && /* @__PURE__ */ f.jsx(
        at,
        {
          sx: { minWidth: "90px" },
          variant: "text",
          disabled: i.isLocked || g,
          startIcon: i.isLocked || g ? null : /* @__PURE__ */ f.jsx(ZM, {}),
          onClick: () => {
            if (p(!1), t === 0) {
              d == null || d(t, t);
              return;
            }
            return d == null || d(t - 1, t), n(t - 1);
          },
          children: s.previousPage
        }
      ),
      r.isLocked ? C && /* @__PURE__ */ f.jsx(F3, { icon: x, body: v, size: "260px", leftPosition: 130 }) : C && x
    ] }),
    a && /* @__PURE__ */ f.jsx(
      at,
      {
        variant: "white-filled",
        onClick: e ? h : a,
        sx: {
          minWidth: 0,
          aspectRatio: 1,
          borderRadius: "100%",
          padding: 0,
          "&:hover": {
            background: m.custom.grey[400]
          },
          "&:active": {
            background: m.custom.grey[600]
          }
        },
        children: /* @__PURE__ */ f.jsx(
          Vw,
          {
            sx: {
              width: "20px",
              color: m.custom.grey[2800]
            }
          }
        )
      }
    )
  ] });
}, Sie = () => /* @__PURE__ */ f.jsxs(
  J,
  {
    sx: {
      zIndex: 1e3,
      minHeight: "96px",
      position: "sticky",
      top: "28px",
      border: "1px solid #E7E6E4",
      borderRadius: "52px",
      backgroundColor: "#FFFFFF",
      padding: "20px 28px",
      display: "grid",
      gridTemplateColumns: "1fr 50% 1fr",
      gridTemplateRows: "1fr",
      alignItems: "center"
    },
    children: [
      /* @__PURE__ */ f.jsx(J, { sx: {
        gridColumn: "1 / 3",
        gridRow: " 1 / 1",
        display: "flex",
        justifyContent: "left"
      }, children: /* @__PURE__ */ f.jsx(yie, {}) }),
      /* @__PURE__ */ f.jsx(J, { sx: {
        gridColumn: "2 / 3",
        gridRow: " 1 / 1",
        display: "flex",
        justifyContent: "center"
      }, children: /* @__PURE__ */ f.jsx(xie, {}) }),
      /* @__PURE__ */ f.jsx(J, { sx: {
        gridColumn: "3 / 3",
        gridRow: " 1 / 1",
        display: "flex",
        justifyContent: "right"
      }, children: /* @__PURE__ */ f.jsx(wie, {}) })
    ]
  }
), Mie = () => {
  const { selectedPage: e, selectedPageIndex: t, isLoading: n } = m2(), o = e.icon ?? t + 1, r = e.title, i = e.subtitle;
  return n ? /* @__PURE__ */ f.jsx(Tie, {}) : /* @__PURE__ */ f.jsx(be, { direction: "column", alignItems: "center", children: /* @__PURE__ */ f.jsxs(
    "div",
    {
      style: { width: "1024px" },
      children: [
        /* @__PURE__ */ f.jsxs(be, { direction: "column", marginTop: "44px", marginBottom: "36px", gap: "2rem", children: [
          r && /* @__PURE__ */ f.jsx(WM, { title: r, badge: o }),
          i && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
            /* @__PURE__ */ f.jsx(oe, { variant: "h4", children: i }),
            /* @__PURE__ */ f.jsx(ho, {})
          ] })
        ] }),
        e.content
      ]
    }
  ) });
}, Tie = () => /* @__PURE__ */ f.jsx(
  J,
  {
    sx: {
      marginLeft: "auto",
      marginRight: "auto",
      width: "fit-content",
      marginTop: "5%",
      marginBottom: "5%"
    },
    children: /* @__PURE__ */ f.jsx(Sa, {})
  }
), kie = (e) => {
  const t = ge(), { onClose: n, open: o, confirmOptions: r } = e, i = () => {
    r.onConfirm(), n();
  }, s = () => {
    r.onCancel(), n();
  };
  return /* @__PURE__ */ f.jsxs(
    d2,
    {
      fullWidth: !0,
      maxWidth: "xs",
      open: o,
      onClose: n,
      sx: {
        ".MuiPaper-rounded": {
          borderRadius: "12px"
        }
      },
      children: [
        /* @__PURE__ */ f.jsxs(
          _0,
          {
            sx: {
              borderBottom: `1px solid ${t.custom.grey[500]}`
            },
            children: [
              /* @__PURE__ */ f.jsxs(
                J,
                {
                  sx: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    minHeight: "68px"
                  },
                  children: [
                    /* @__PURE__ */ f.jsx(oe, { variant: "h3", children: r.titleText }),
                    /* @__PURE__ */ f.jsx(at, { variant: "text", endIcon: /* @__PURE__ */ f.jsx(j3, {}), onClick: n })
                  ]
                }
              ),
              (r == null ? void 0 : r.infoText) && /* @__PURE__ */ f.jsx(oe, { sx: { marginBlock: 1.5 }, children: r.infoText })
            ]
          }
        ),
        /* @__PURE__ */ f.jsxs(be, { flexDirection: "column", alignItems: "center", p: 3, gap: "1rem", children: [
          /* @__PURE__ */ f.jsx(at, { variant: "primary", onClick: i, children: r.confirmText }),
          /* @__PURE__ */ f.jsx(at, { onClick: s, children: r.cancelText })
        ] })
      ]
    }
  );
}, Eie = () => {
  const { confirmExit: e, formSaved: t } = m2(), n = (o) => {
    o.preventDefault();
  };
  return mt(() => {
    if (e)
      return window.removeEventListener("beforeunload", n), t === !1 && window.addEventListener("beforeunload", n), () => {
        window.removeEventListener("beforeunload", n);
      };
  }, [t, e]), /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(Sie, {}),
    /* @__PURE__ */ f.jsx(Mie, {})
  ] });
}, bye = (e) => {
  const [t, n] = Ae(!1);
  return /* @__PURE__ */ f.jsxs(
    Cie,
    {
      ...e,
      openConfirmDialog: () => n(!0),
      children: [
        /* @__PURE__ */ f.jsx(Eie, {}),
        e.confirmExit && /* @__PURE__ */ f.jsx(
          kie,
          {
            open: t,
            onClose: () => n(!1),
            confirmOptions: e.confirmOptions
          }
        )
      ]
    }
  );
}, Cye = (e) => {
  const {
    value: t,
    onChange: n,
    defaultOption: o,
    unit: r,
    error: i = !1,
    disabled: s = !1,
    ExtraInputProps: a = {},
    Tooltip: c = {}
  } = e, d = ge(), { text: u, props: p } = c;
  return /* @__PURE__ */ f.jsxs(be, { gap: d.spacing(1), children: [
    /* @__PURE__ */ f.jsxs(be, { flexDirection: "row", gap: d.spacing(1.5), alignItems: "center", children: [
      /* @__PURE__ */ f.jsx(
        Rie,
        {
          fullWidth: !0,
          value: t,
          onChange: (h) => {
            const g = h.currentTarget.value;
            n(g);
          },
          error: i,
          disabled: s,
          ...a
        }
      ),
      r && /* @__PURE__ */ f.jsx(
        oe,
        {
          variant: "body-medium",
          maxWidth: "200px",
          sx: {
            textWrap: "nowrap",
            overflow: "clip",
            textOverflow: "ellipsis"
          },
          children: r
        }
      ),
      o && /* @__PURE__ */ f.jsx(
        nY,
        {
          size: "s",
          icon: "reset",
          tooltip: {
            text: u,
            props: p
          },
          buttonProps: {
            onClick: () => {
              var h;
              n(o.value), (h = o.extraAction) == null || h.call(o, o.value);
            },
            disabled: s
          }
        }
      )
    ] }),
    o && /* @__PURE__ */ f.jsx(oe, { variant: "small-medium", children: `${o.label} ${o.value}` })
  ] });
}, Rie = B(a2)(({ theme: e }) => ({
  "&.MuiInputBase-root": {
    backgroundColor: "white",
    height: "40px",
    borderRadius: "24px",
    paddingRight: "12px",
    paddingLeft: "20px",
    border: `1px solid ${e.custom.grey[500]}`,
    ":hover": {
      backgroundColor: e.custom.grey[300]
    },
    color: e.custom.grey[2800],
    ...e.typography["body-medium"],
    "& ::placeholder": {
      ...e.typography["body-medium"],
      color: e.custom.grey[1400]
    }
  },
  "&.Mui-disabled": {
    backgroundColor: e.custom.grey[500],
    ":hover": {
      backgroundColor: e.custom.grey[500]
    }
  },
  "&.Mui-focused": {
    border: `2px solid ${e.custom.grey[2800]}`
  },
  "&.Mui-error": {
    border: `1px solid ${e.custom.red[600]}`,
    backgroundColor: e.custom.red[100],
    color: e.custom.red[600],
    ":hover": {
      backgroundColor: e.custom.red[200]
    }
  }
}));
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function ns(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function tr(e, t) {
  return (n) => {
    t.setState((o) => ({
      ...o,
      [e]: ns(n, o[e])
    }));
  };
}
function q3(e) {
  return e instanceof Function;
}
function Oie(e) {
  return Array.isArray(e) && e.every((t) => typeof t == "number");
}
function GM(e, t) {
  const n = [], o = (r) => {
    r.forEach((i) => {
      n.push(i);
      const s = t(i);
      s != null && s.length && o(s);
    });
  };
  return o(e), n;
}
function ct(e, t, n) {
  let o = [], r;
  return (i) => {
    let s;
    n.key && n.debug && (s = Date.now());
    const a = e(i);
    if (!(a.length !== o.length || a.some((u, p) => o[p] !== u)))
      return r;
    o = a;
    let d;
    if (n.key && n.debug && (d = Date.now()), r = t(...a), n == null || n.onChange == null || n.onChange(r), n.key && n.debug && n != null && n.debug()) {
      const u = Math.round((Date.now() - s) * 100) / 100, p = Math.round((Date.now() - d) * 100) / 100, h = p / 16, g = (m, b) => {
        for (m = String(m); m.length < b; )
          m = " " + m;
        return m;
      };
      console.info(`%c⏱ ${g(p, 5)} /${g(u, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * h, 120))}deg 100% 31%);`, n == null ? void 0 : n.key);
    }
    return r;
  };
}
function dt(e, t, n, o) {
  return {
    debug: () => {
      var r;
      return (r = e == null ? void 0 : e.debugAll) != null ? r : e[t];
    },
    key: process.env.NODE_ENV === "development" && n,
    onChange: o
  };
}
function _ie(e, t, n, o) {
  const r = () => {
    var s;
    return (s = i.getValue()) != null ? s : e.options.renderFallbackValue;
  }, i = {
    id: `${t.id}_${n.id}`,
    row: t,
    column: n,
    getValue: () => t.getValue(o),
    renderValue: r,
    getContext: ct(() => [e, n, t, i], (s, a, c, d) => ({
      table: s,
      column: a,
      row: c,
      cell: d,
      getValue: d.getValue,
      renderValue: d.renderValue
    }), dt(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((s) => {
    s.createCell == null || s.createCell(i, n, t, e);
  }, {}), i;
}
function Pie(e, t, n, o) {
  var r, i;
  const a = {
    ...e._getDefaultColumnDef(),
    ...t
  }, c = a.accessorKey;
  let d = (r = (i = a.id) != null ? i : c ? typeof String.prototype.replaceAll == "function" ? c.replaceAll(".", "_") : c.replace(/\./g, "_") : void 0) != null ? r : typeof a.header == "string" ? a.header : void 0, u;
  if (a.accessorFn ? u = a.accessorFn : c && (c.includes(".") ? u = (h) => {
    let g = h;
    for (const b of c.split(".")) {
      var m;
      g = (m = g) == null ? void 0 : m[b], process.env.NODE_ENV !== "production" && g === void 0 && console.warn(`"${b}" in deeply nested key "${c}" returned undefined.`);
    }
    return g;
  } : u = (h) => h[a.accessorKey]), !d)
    throw process.env.NODE_ENV !== "production" ? new Error(a.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let p = {
    id: `${String(d)}`,
    accessorFn: u,
    parent: o,
    depth: n,
    columnDef: a,
    columns: [],
    getFlatColumns: ct(() => [!0], () => {
      var h;
      return [p, ...(h = p.columns) == null ? void 0 : h.flatMap((g) => g.getFlatColumns())];
    }, dt(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: ct(() => [e._getOrderColumnsFn()], (h) => {
      var g;
      if ((g = p.columns) != null && g.length) {
        let m = p.columns.flatMap((b) => b.getLeafColumns());
        return h(m);
      }
      return [p];
    }, dt(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const h of e._features)
    h.createColumn == null || h.createColumn(p, e);
  return p;
}
const ro = "debugHeaders";
function sC(e, t, n) {
  var o;
  let i = {
    id: (o = n.id) != null ? o : t.id,
    column: t,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const s = [], a = (c) => {
        c.subHeaders && c.subHeaders.length && c.subHeaders.map(a), s.push(c);
      };
      return a(i), s;
    },
    getContext: () => ({
      table: e,
      header: i,
      column: t
    })
  };
  return e._features.forEach((s) => {
    s.createHeader == null || s.createHeader(i, e);
  }), i;
}
const Lie = {
  createTable: (e) => {
    e.getHeaderGroups = ct(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, o, r) => {
      var i, s;
      const a = (i = o == null ? void 0 : o.map((p) => n.find((h) => h.id === p)).filter(Boolean)) != null ? i : [], c = (s = r == null ? void 0 : r.map((p) => n.find((h) => h.id === p)).filter(Boolean)) != null ? s : [], d = n.filter((p) => !(o != null && o.includes(p.id)) && !(r != null && r.includes(p.id)));
      return D1(t, [...a, ...d, ...c], e);
    }, dt(e.options, ro, "getHeaderGroups")), e.getCenterHeaderGroups = ct(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, o, r) => (n = n.filter((i) => !(o != null && o.includes(i.id)) && !(r != null && r.includes(i.id))), D1(t, n, e, "center")), dt(e.options, ro, "getCenterHeaderGroups")), e.getLeftHeaderGroups = ct(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (t, n, o) => {
      var r;
      const i = (r = o == null ? void 0 : o.map((s) => n.find((a) => a.id === s)).filter(Boolean)) != null ? r : [];
      return D1(t, i, e, "left");
    }, dt(e.options, ro, "getLeftHeaderGroups")), e.getRightHeaderGroups = ct(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (t, n, o) => {
      var r;
      const i = (r = o == null ? void 0 : o.map((s) => n.find((a) => a.id === s)).filter(Boolean)) != null ? r : [];
      return D1(t, i, e, "right");
    }, dt(e.options, ro, "getRightHeaderGroups")), e.getFooterGroups = ct(() => [e.getHeaderGroups()], (t) => [...t].reverse(), dt(e.options, ro, "getFooterGroups")), e.getLeftFooterGroups = ct(() => [e.getLeftHeaderGroups()], (t) => [...t].reverse(), dt(e.options, ro, "getLeftFooterGroups")), e.getCenterFooterGroups = ct(() => [e.getCenterHeaderGroups()], (t) => [...t].reverse(), dt(e.options, ro, "getCenterFooterGroups")), e.getRightFooterGroups = ct(() => [e.getRightHeaderGroups()], (t) => [...t].reverse(), dt(e.options, ro, "getRightFooterGroups")), e.getFlatHeaders = ct(() => [e.getHeaderGroups()], (t) => t.map((n) => n.headers).flat(), dt(e.options, ro, "getFlatHeaders")), e.getLeftFlatHeaders = ct(() => [e.getLeftHeaderGroups()], (t) => t.map((n) => n.headers).flat(), dt(e.options, ro, "getLeftFlatHeaders")), e.getCenterFlatHeaders = ct(() => [e.getCenterHeaderGroups()], (t) => t.map((n) => n.headers).flat(), dt(e.options, ro, "getCenterFlatHeaders")), e.getRightFlatHeaders = ct(() => [e.getRightHeaderGroups()], (t) => t.map((n) => n.headers).flat(), dt(e.options, ro, "getRightFlatHeaders")), e.getCenterLeafHeaders = ct(() => [e.getCenterFlatHeaders()], (t) => t.filter((n) => {
      var o;
      return !((o = n.subHeaders) != null && o.length);
    }), dt(e.options, ro, "getCenterLeafHeaders")), e.getLeftLeafHeaders = ct(() => [e.getLeftFlatHeaders()], (t) => t.filter((n) => {
      var o;
      return !((o = n.subHeaders) != null && o.length);
    }), dt(e.options, ro, "getLeftLeafHeaders")), e.getRightLeafHeaders = ct(() => [e.getRightFlatHeaders()], (t) => t.filter((n) => {
      var o;
      return !((o = n.subHeaders) != null && o.length);
    }), dt(e.options, ro, "getRightLeafHeaders")), e.getLeafHeaders = ct(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (t, n, o) => {
      var r, i, s, a, c, d;
      return [...(r = (i = t[0]) == null ? void 0 : i.headers) != null ? r : [], ...(s = (a = n[0]) == null ? void 0 : a.headers) != null ? s : [], ...(c = (d = o[0]) == null ? void 0 : d.headers) != null ? c : []].map((u) => u.getLeafHeaders()).flat();
    }, dt(e.options, ro, "getLeafHeaders"));
  }
};
function D1(e, t, n, o) {
  var r, i;
  let s = 0;
  const a = function(h, g) {
    g === void 0 && (g = 1), s = Math.max(s, g), h.filter((m) => m.getIsVisible()).forEach((m) => {
      var b;
      (b = m.columns) != null && b.length && a(m.columns, g + 1);
    }, 0);
  };
  a(e);
  let c = [];
  const d = (h, g) => {
    const m = {
      depth: g,
      id: [o, `${g}`].filter(Boolean).join("_"),
      headers: []
    }, b = [];
    h.forEach((C) => {
      const x = [...b].reverse()[0], v = C.column.depth === m.depth;
      let S, M = !1;
      if (v && C.column.parent ? S = C.column.parent : (S = C.column, M = !0), x && (x == null ? void 0 : x.column) === S)
        x.subHeaders.push(C);
      else {
        const w = sC(n, S, {
          id: [o, g, S.id, C == null ? void 0 : C.id].filter(Boolean).join("_"),
          isPlaceholder: M,
          placeholderId: M ? `${b.filter((k) => k.column === S).length}` : void 0,
          depth: g,
          index: b.length
        });
        w.subHeaders.push(C), b.push(w);
      }
      m.headers.push(C), C.headerGroup = m;
    }), c.push(m), g > 0 && d(b, g - 1);
  }, u = t.map((h, g) => sC(n, h, {
    depth: s,
    index: g
  }));
  d(u, s - 1), c.reverse();
  const p = (h) => h.filter((m) => m.column.getIsVisible()).map((m) => {
    let b = 0, C = 0, x = [0];
    m.subHeaders && m.subHeaders.length ? (x = [], p(m.subHeaders).forEach((S) => {
      let {
        colSpan: M,
        rowSpan: w
      } = S;
      b += M, x.push(w);
    })) : b = 1;
    const v = Math.min(...x);
    return C = C + v, m.colSpan = b, m.rowSpan = C, {
      colSpan: b,
      rowSpan: C
    };
  });
  return p((r = (i = c[0]) == null ? void 0 : i.headers) != null ? r : []), c;
}
const $0 = (e, t, n, o, r, i, s) => {
  let a = {
    id: t,
    index: o,
    original: n,
    depth: r,
    parentId: s,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (c) => {
      if (a._valuesCache.hasOwnProperty(c))
        return a._valuesCache[c];
      const d = e.getColumn(c);
      if (d != null && d.accessorFn)
        return a._valuesCache[c] = d.accessorFn(a.original, o), a._valuesCache[c];
    },
    getUniqueValues: (c) => {
      if (a._uniqueValuesCache.hasOwnProperty(c))
        return a._uniqueValuesCache[c];
      const d = e.getColumn(c);
      if (d != null && d.accessorFn)
        return d.columnDef.getUniqueValues ? (a._uniqueValuesCache[c] = d.columnDef.getUniqueValues(a.original, o), a._uniqueValuesCache[c]) : (a._uniqueValuesCache[c] = [a.getValue(c)], a._uniqueValuesCache[c]);
    },
    renderValue: (c) => {
      var d;
      return (d = a.getValue(c)) != null ? d : e.options.renderFallbackValue;
    },
    subRows: i ?? [],
    getLeafRows: () => GM(a.subRows, (c) => c.subRows),
    getParentRow: () => a.parentId ? e.getRow(a.parentId, !0) : void 0,
    getParentRows: () => {
      let c = [], d = a;
      for (; ; ) {
        const u = d.getParentRow();
        if (!u) break;
        c.push(u), d = u;
      }
      return c.reverse();
    },
    getAllCells: ct(() => [e.getAllLeafColumns()], (c) => c.map((d) => _ie(e, a, d, d.id)), dt(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: ct(() => [a.getAllCells()], (c) => c.reduce((d, u) => (d[u.column.id] = u, d), {}), dt(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let c = 0; c < e._features.length; c++) {
    const d = e._features[c];
    d == null || d.createRow == null || d.createRow(a, e);
  }
  return a;
}, Iie = {
  createColumn: (e, t) => {
    e._getFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : t.getPreFilteredRowModel(), e._getFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, qM = (e, t, n) => {
  var o, r;
  const i = n == null || (o = n.toString()) == null ? void 0 : o.toLowerCase();
  return !!(!((r = e.getValue(t)) == null || (r = r.toString()) == null || (r = r.toLowerCase()) == null) && r.includes(i));
};
qM.autoRemove = (e) => Lr(e);
const KM = (e, t, n) => {
  var o;
  return !!(!((o = e.getValue(t)) == null || (o = o.toString()) == null) && o.includes(n));
};
KM.autoRemove = (e) => Lr(e);
const YM = (e, t, n) => {
  var o;
  return ((o = e.getValue(t)) == null || (o = o.toString()) == null ? void 0 : o.toLowerCase()) === (n == null ? void 0 : n.toLowerCase());
};
YM.autoRemove = (e) => Lr(e);
const XM = (e, t, n) => {
  var o;
  return (o = e.getValue(t)) == null ? void 0 : o.includes(n);
};
XM.autoRemove = (e) => Lr(e) || !(e != null && e.length);
const JM = (e, t, n) => !n.some((o) => {
  var r;
  return !((r = e.getValue(t)) != null && r.includes(o));
});
JM.autoRemove = (e) => Lr(e) || !(e != null && e.length);
const QM = (e, t, n) => n.some((o) => {
  var r;
  return (r = e.getValue(t)) == null ? void 0 : r.includes(o);
});
QM.autoRemove = (e) => Lr(e) || !(e != null && e.length);
const eT = (e, t, n) => e.getValue(t) === n;
eT.autoRemove = (e) => Lr(e);
const tT = (e, t, n) => e.getValue(t) == n;
tT.autoRemove = (e) => Lr(e);
const F7 = (e, t, n) => {
  let [o, r] = n;
  const i = e.getValue(t);
  return i >= o && i <= r;
};
F7.resolveFilterValue = (e) => {
  let [t, n] = e, o = typeof t != "number" ? parseFloat(t) : t, r = typeof n != "number" ? parseFloat(n) : n, i = t === null || Number.isNaN(o) ? -1 / 0 : o, s = n === null || Number.isNaN(r) ? 1 / 0 : r;
  if (i > s) {
    const a = i;
    i = s, s = a;
  }
  return [i, s];
};
F7.autoRemove = (e) => Lr(e) || Lr(e[0]) && Lr(e[1]);
const Ur = {
  includesString: qM,
  includesStringSensitive: KM,
  equalsString: YM,
  arrIncludes: XM,
  arrIncludesAll: JM,
  arrIncludesSome: QM,
  equals: eT,
  weakEquals: tT,
  inNumberRange: F7
};
function Lr(e) {
  return e == null || e === "";
}
const jie = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: tr("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, t) => {
    e.getAutoFilterFn = () => {
      const n = t.getCoreRowModel().flatRows[0], o = n == null ? void 0 : n.getValue(e.id);
      return typeof o == "string" ? Ur.includesString : typeof o == "number" ? Ur.inNumberRange : typeof o == "boolean" || o !== null && typeof o == "object" ? Ur.equals : Array.isArray(o) ? Ur.arrIncludes : Ur.weakEquals;
    }, e.getFilterFn = () => {
      var n, o;
      return q3(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (n = (o = t.options.filterFns) == null ? void 0 : o[e.columnDef.filterFn]) != null ? n : Ur[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var n, o, r;
      return ((n = e.columnDef.enableColumnFilter) != null ? n : !0) && ((o = t.options.enableColumnFilters) != null ? o : !0) && ((r = t.options.enableFilters) != null ? r : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var n;
      return (n = t.getState().columnFilters) == null || (n = n.find((o) => o.id === e.id)) == null ? void 0 : n.value;
    }, e.getFilterIndex = () => {
      var n, o;
      return (n = (o = t.getState().columnFilters) == null ? void 0 : o.findIndex((r) => r.id === e.id)) != null ? n : -1;
    }, e.setFilterValue = (n) => {
      t.setColumnFilters((o) => {
        const r = e.getFilterFn(), i = o == null ? void 0 : o.find((u) => u.id === e.id), s = ns(n, i ? i.value : void 0);
        if (aC(r, s, e)) {
          var a;
          return (a = o == null ? void 0 : o.filter((u) => u.id !== e.id)) != null ? a : [];
        }
        const c = {
          id: e.id,
          value: s
        };
        if (i) {
          var d;
          return (d = o == null ? void 0 : o.map((u) => u.id === e.id ? c : u)) != null ? d : [];
        }
        return o != null && o.length ? [...o, c] : [c];
      });
    };
  },
  createRow: (e, t) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (t) => {
      const n = e.getAllLeafColumns(), o = (r) => {
        var i;
        return (i = ns(t, r)) == null ? void 0 : i.filter((s) => {
          const a = n.find((c) => c.id === s.id);
          if (a) {
            const c = a.getFilterFn();
            if (aC(c, s.value, a))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(o);
    }, e.resetColumnFilters = (t) => {
      var n, o;
      e.setColumnFilters(t ? [] : (n = (o = e.initialState) == null ? void 0 : o.columnFilters) != null ? n : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function aC(e, t, n) {
  return (e && e.autoRemove ? e.autoRemove(t, n) : !1) || typeof t > "u" || typeof t == "string" && !t;
}
const Vie = (e, t, n) => n.reduce((o, r) => {
  const i = r.getValue(e);
  return o + (typeof i == "number" ? i : 0);
}, 0), Die = (e, t, n) => {
  let o;
  return n.forEach((r) => {
    const i = r.getValue(e);
    i != null && (o > i || o === void 0 && i >= i) && (o = i);
  }), o;
}, Aie = (e, t, n) => {
  let o;
  return n.forEach((r) => {
    const i = r.getValue(e);
    i != null && (o < i || o === void 0 && i >= i) && (o = i);
  }), o;
}, Hie = (e, t, n) => {
  let o, r;
  return n.forEach((i) => {
    const s = i.getValue(e);
    s != null && (o === void 0 ? s >= s && (o = r = s) : (o > s && (o = s), r < s && (r = s)));
  }), [o, r];
}, Fie = (e, t) => {
  let n = 0, o = 0;
  if (t.forEach((r) => {
    let i = r.getValue(e);
    i != null && (i = +i) >= i && (++n, o += i);
  }), n) return o / n;
}, Nie = (e, t) => {
  if (!t.length)
    return;
  const n = t.map((i) => i.getValue(e));
  if (!Oie(n))
    return;
  if (n.length === 1)
    return n[0];
  const o = Math.floor(n.length / 2), r = n.sort((i, s) => i - s);
  return n.length % 2 !== 0 ? r[o] : (r[o - 1] + r[o]) / 2;
}, $ie = (e, t) => Array.from(new Set(t.map((n) => n.getValue(e))).values()), Bie = (e, t) => new Set(t.map((n) => n.getValue(e))).size, zie = (e, t) => t.length, Rd = {
  sum: Vie,
  min: Die,
  max: Aie,
  extent: Hie,
  mean: Fie,
  median: Nie,
  unique: $ie,
  uniqueCount: Bie,
  count: zie
}, Zie = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var t, n;
      return (t = (n = e.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? t : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: tr("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, t) => {
    e.toggleGrouping = () => {
      t.setGrouping((n) => n != null && n.includes(e.id) ? n.filter((o) => o !== e.id) : [...n ?? [], e.id]);
    }, e.getCanGroup = () => {
      var n, o;
      return ((n = e.columnDef.enableGrouping) != null ? n : !0) && ((o = t.options.enableGrouping) != null ? o : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.includes(e.id);
    }, e.getGroupedIndex = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const n = e.getCanGroup();
      return () => {
        n && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const n = t.getCoreRowModel().flatRows[0], o = n == null ? void 0 : n.getValue(e.id);
      if (typeof o == "number")
        return Rd.sum;
      if (Object.prototype.toString.call(o) === "[object Date]")
        return Rd.extent;
    }, e.getAggregationFn = () => {
      var n, o;
      if (!e)
        throw new Error();
      return q3(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (n = (o = t.options.aggregationFns) == null ? void 0 : o[e.columnDef.aggregationFn]) != null ? n : Rd[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (t) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(t), e.resetGrouping = (t) => {
      var n, o;
      e.setGrouping(t ? [] : (n = (o = e.initialState) == null ? void 0 : o.grouping) != null ? n : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, t) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (n) => {
      if (e._groupingValuesCache.hasOwnProperty(n))
        return e._groupingValuesCache[n];
      const o = t.getColumn(n);
      return o != null && o.columnDef.getGroupingValue ? (e._groupingValuesCache[n] = o.columnDef.getGroupingValue(e.original), e._groupingValuesCache[n]) : e.getValue(n);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, t, n, o) => {
    e.getIsGrouped = () => t.getIsGrouped() && t.id === n.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && t.getIsGrouped(), e.getIsAggregated = () => {
      var r;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((r = n.subRows) != null && r.length);
    };
  }
};
function Wie(e, t, n) {
  if (!(t != null && t.length) || !n)
    return e;
  const o = e.filter((i) => !t.includes(i.id));
  return n === "remove" ? o : [...t.map((i) => e.find((s) => s.id === i)).filter(Boolean), ...o];
}
const Uie = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: tr("columnOrder", e)
  }),
  createColumn: (e, t) => {
    e.getIndex = ct((n) => [mc(t, n)], (n) => n.findIndex((o) => o.id === e.id), dt(t.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (n) => {
      var o;
      return ((o = mc(t, n)[0]) == null ? void 0 : o.id) === e.id;
    }, e.getIsLastColumn = (n) => {
      var o;
      const r = mc(t, n);
      return ((o = r[r.length - 1]) == null ? void 0 : o.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (t) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(t), e.resetColumnOrder = (t) => {
      var n;
      e.setColumnOrder(t ? [] : (n = e.initialState.columnOrder) != null ? n : []);
    }, e._getOrderColumnsFn = ct(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (t, n, o) => (r) => {
      let i = [];
      if (!(t != null && t.length))
        i = r;
      else {
        const s = [...t], a = [...r];
        for (; a.length && s.length; ) {
          const c = s.shift(), d = a.findIndex((u) => u.id === c);
          d > -1 && i.push(a.splice(d, 1)[0]);
        }
        i = [...i, ...a];
      }
      return Wie(i, n, o);
    }, dt(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, M6 = () => ({
  left: [],
  right: []
}), Gie = {
  getInitialState: (e) => ({
    columnPinning: M6(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: tr("columnPinning", e)
  }),
  createColumn: (e, t) => {
    e.pin = (n) => {
      const o = e.getLeafColumns().map((r) => r.id).filter(Boolean);
      t.setColumnPinning((r) => {
        var i, s;
        if (n === "right") {
          var a, c;
          return {
            left: ((a = r == null ? void 0 : r.left) != null ? a : []).filter((p) => !(o != null && o.includes(p))),
            right: [...((c = r == null ? void 0 : r.right) != null ? c : []).filter((p) => !(o != null && o.includes(p))), ...o]
          };
        }
        if (n === "left") {
          var d, u;
          return {
            left: [...((d = r == null ? void 0 : r.left) != null ? d : []).filter((p) => !(o != null && o.includes(p))), ...o],
            right: ((u = r == null ? void 0 : r.right) != null ? u : []).filter((p) => !(o != null && o.includes(p)))
          };
        }
        return {
          left: ((i = r == null ? void 0 : r.left) != null ? i : []).filter((p) => !(o != null && o.includes(p))),
          right: ((s = r == null ? void 0 : r.right) != null ? s : []).filter((p) => !(o != null && o.includes(p)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((o) => {
      var r, i, s;
      return ((r = o.columnDef.enablePinning) != null ? r : !0) && ((i = (s = t.options.enableColumnPinning) != null ? s : t.options.enablePinning) != null ? i : !0);
    }), e.getIsPinned = () => {
      const n = e.getLeafColumns().map((a) => a.id), {
        left: o,
        right: r
      } = t.getState().columnPinning, i = n.some((a) => o == null ? void 0 : o.includes(a)), s = n.some((a) => r == null ? void 0 : r.includes(a));
      return i ? "left" : s ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var n, o;
      const r = e.getIsPinned();
      return r ? (n = (o = t.getState().columnPinning) == null || (o = o[r]) == null ? void 0 : o.indexOf(e.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (e, t) => {
    e.getCenterVisibleCells = ct(() => [e._getAllVisibleCells(), t.getState().columnPinning.left, t.getState().columnPinning.right], (n, o, r) => {
      const i = [...o ?? [], ...r ?? []];
      return n.filter((s) => !i.includes(s.column.id));
    }, dt(t.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = ct(() => [e._getAllVisibleCells(), t.getState().columnPinning.left], (n, o) => (o ?? []).map((i) => n.find((s) => s.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "left"
    })), dt(t.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = ct(() => [e._getAllVisibleCells(), t.getState().columnPinning.right], (n, o) => (o ?? []).map((i) => n.find((s) => s.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "right"
    })), dt(t.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (t) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(t), e.resetColumnPinning = (t) => {
      var n, o;
      return e.setColumnPinning(t ? M6() : (n = (o = e.initialState) == null ? void 0 : o.columnPinning) != null ? n : M6());
    }, e.getIsSomeColumnsPinned = (t) => {
      var n;
      const o = e.getState().columnPinning;
      if (!t) {
        var r, i;
        return !!((r = o.left) != null && r.length || (i = o.right) != null && i.length);
      }
      return !!((n = o[t]) != null && n.length);
    }, e.getLeftLeafColumns = ct(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (t, n) => (n ?? []).map((o) => t.find((r) => r.id === o)).filter(Boolean), dt(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = ct(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (t, n) => (n ?? []).map((o) => t.find((r) => r.id === o)).filter(Boolean), dt(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = ct(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, o) => {
      const r = [...n ?? [], ...o ?? []];
      return t.filter((i) => !r.includes(i.id));
    }, dt(e.options, "debugColumns", "getCenterLeafColumns"));
  }
}, A1 = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, T6 = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), qie = {
  getDefaultColumnDef: () => A1,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: T6(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: tr("columnSizing", e),
    onColumnSizingInfoChange: tr("columnSizingInfo", e)
  }),
  createColumn: (e, t) => {
    e.getSize = () => {
      var n, o, r;
      const i = t.getState().columnSizing[e.id];
      return Math.min(Math.max((n = e.columnDef.minSize) != null ? n : A1.minSize, (o = i ?? e.columnDef.size) != null ? o : A1.size), (r = e.columnDef.maxSize) != null ? r : A1.maxSize);
    }, e.getStart = ct((n) => [n, mc(t, n), t.getState().columnSizing], (n, o) => o.slice(0, e.getIndex(n)).reduce((r, i) => r + i.getSize(), 0), dt(t.options, "debugColumns", "getStart")), e.getAfter = ct((n) => [n, mc(t, n), t.getState().columnSizing], (n, o) => o.slice(e.getIndex(n) + 1).reduce((r, i) => r + i.getSize(), 0), dt(t.options, "debugColumns", "getAfter")), e.resetSize = () => {
      t.setColumnSizing((n) => {
        let {
          [e.id]: o,
          ...r
        } = n;
        return r;
      });
    }, e.getCanResize = () => {
      var n, o;
      return ((n = e.columnDef.enableResizing) != null ? n : !0) && ((o = t.options.enableColumnResizing) != null ? o : !0);
    }, e.getIsResizing = () => t.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, t) => {
    e.getSize = () => {
      let n = 0;
      const o = (r) => {
        if (r.subHeaders.length)
          r.subHeaders.forEach(o);
        else {
          var i;
          n += (i = r.column.getSize()) != null ? i : 0;
        }
      };
      return o(e), n;
    }, e.getStart = () => {
      if (e.index > 0) {
        const n = e.headerGroup.headers[e.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, e.getResizeHandler = (n) => {
      const o = t.getColumn(e.column.id), r = o == null ? void 0 : o.getCanResize();
      return (i) => {
        if (!o || !r || (i.persist == null || i.persist(), k6(i) && i.touches && i.touches.length > 1))
          return;
        const s = e.getSize(), a = e ? e.getLeafHeaders().map((x) => [x.column.id, x.column.getSize()]) : [[o.id, o.getSize()]], c = k6(i) ? Math.round(i.touches[0].clientX) : i.clientX, d = {}, u = (x, v) => {
          typeof v == "number" && (t.setColumnSizingInfo((S) => {
            var M, w;
            const k = t.options.columnResizeDirection === "rtl" ? -1 : 1, E = (v - ((M = S == null ? void 0 : S.startOffset) != null ? M : 0)) * k, R = Math.max(E / ((w = S == null ? void 0 : S.startSize) != null ? w : 0), -0.999999);
            return S.columnSizingStart.forEach((O) => {
              let [P, _] = O;
              d[P] = Math.round(Math.max(_ + _ * R, 0) * 100) / 100;
            }), {
              ...S,
              deltaOffset: E,
              deltaPercentage: R
            };
          }), (t.options.columnResizeMode === "onChange" || x === "end") && t.setColumnSizing((S) => ({
            ...S,
            ...d
          })));
        }, p = (x) => u("move", x), h = (x) => {
          u("end", x), t.setColumnSizingInfo((v) => ({
            ...v,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, g = n || typeof document < "u" ? document : null, m = {
          moveHandler: (x) => p(x.clientX),
          upHandler: (x) => {
            g == null || g.removeEventListener("mousemove", m.moveHandler), g == null || g.removeEventListener("mouseup", m.upHandler), h(x.clientX);
          }
        }, b = {
          moveHandler: (x) => (x.cancelable && (x.preventDefault(), x.stopPropagation()), p(x.touches[0].clientX), !1),
          upHandler: (x) => {
            var v;
            g == null || g.removeEventListener("touchmove", b.moveHandler), g == null || g.removeEventListener("touchend", b.upHandler), x.cancelable && (x.preventDefault(), x.stopPropagation()), h((v = x.touches[0]) == null ? void 0 : v.clientX);
          }
        }, C = Kie() ? {
          passive: !1
        } : !1;
        k6(i) ? (g == null || g.addEventListener("touchmove", b.moveHandler, C), g == null || g.addEventListener("touchend", b.upHandler, C)) : (g == null || g.addEventListener("mousemove", m.moveHandler, C), g == null || g.addEventListener("mouseup", m.upHandler, C)), t.setColumnSizingInfo((x) => ({
          ...x,
          startOffset: c,
          startSize: s,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: a,
          isResizingColumn: o.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (t) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(t), e.setColumnSizingInfo = (t) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(t), e.resetColumnSizing = (t) => {
      var n;
      e.setColumnSizing(t ? {} : (n = e.initialState.columnSizing) != null ? n : {});
    }, e.resetHeaderSizeInfo = (t) => {
      var n;
      e.setColumnSizingInfo(t ? T6() : (n = e.initialState.columnSizingInfo) != null ? n : T6());
    }, e.getTotalSize = () => {
      var t, n;
      return (t = (n = e.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? t : 0;
    }, e.getLeftTotalSize = () => {
      var t, n;
      return (t = (n = e.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? t : 0;
    }, e.getCenterTotalSize = () => {
      var t, n;
      return (t = (n = e.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? t : 0;
    }, e.getRightTotalSize = () => {
      var t, n;
      return (t = (n = e.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? t : 0;
    };
  }
};
let H1 = null;
function Kie() {
  if (typeof H1 == "boolean") return H1;
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, t), window.removeEventListener("test", n);
  } catch {
    e = !1;
  }
  return H1 = e, H1;
}
function k6(e) {
  return e.type === "touchstart";
}
const Yie = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: tr("columnVisibility", e)
  }),
  createColumn: (e, t) => {
    e.toggleVisibility = (n) => {
      e.getCanHide() && t.setColumnVisibility((o) => ({
        ...o,
        [e.id]: n ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var n, o;
      const r = e.columns;
      return (n = r.length ? r.some((i) => i.getIsVisible()) : (o = t.getState().columnVisibility) == null ? void 0 : o[e.id]) != null ? n : !0;
    }, e.getCanHide = () => {
      var n, o;
      return ((n = e.columnDef.enableHiding) != null ? n : !0) && ((o = t.options.enableHiding) != null ? o : !0);
    }, e.getToggleVisibilityHandler = () => (n) => {
      e.toggleVisibility == null || e.toggleVisibility(n.target.checked);
    };
  },
  createRow: (e, t) => {
    e._getAllVisibleCells = ct(() => [e.getAllCells(), t.getState().columnVisibility], (n) => n.filter((o) => o.column.getIsVisible()), dt(t.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = ct(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (n, o, r) => [...n, ...o, ...r], dt(t.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const t = (n, o) => ct(() => [o(), o().filter((r) => r.getIsVisible()).map((r) => r.id).join("_")], (r) => r.filter((i) => i.getIsVisible == null ? void 0 : i.getIsVisible()), dt(e.options, "debugColumns", n));
    e.getVisibleFlatColumns = t("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = t("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = t("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = t("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = t("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (n) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(n), e.resetColumnVisibility = (n) => {
      var o;
      e.setColumnVisibility(n ? {} : (o = e.initialState.columnVisibility) != null ? o : {});
    }, e.toggleAllColumnsVisible = (n) => {
      var o;
      n = (o = n) != null ? o : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((r, i) => ({
        ...r,
        [i.id]: n || !(i.getCanHide != null && i.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var o;
      e.toggleAllColumnsVisible((o = n.target) == null ? void 0 : o.checked);
    };
  }
};
function mc(e, t) {
  return t ? t === "center" ? e.getCenterVisibleLeafColumns() : t === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const Xie = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, Jie = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: tr("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (t) => {
      var n;
      const o = (n = e.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[t.id]) == null ? void 0 : n.getValue();
      return typeof o == "string" || typeof o == "number";
    }
  }),
  createColumn: (e, t) => {
    e.getCanGlobalFilter = () => {
      var n, o, r, i;
      return ((n = e.columnDef.enableGlobalFilter) != null ? n : !0) && ((o = t.options.enableGlobalFilter) != null ? o : !0) && ((r = t.options.enableFilters) != null ? r : !0) && ((i = t.options.getColumnCanGlobalFilter == null ? void 0 : t.options.getColumnCanGlobalFilter(e)) != null ? i : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => Ur.includesString, e.getGlobalFilterFn = () => {
      var t, n;
      const {
        globalFilterFn: o
      } = e.options;
      return q3(o) ? o : o === "auto" ? e.getGlobalAutoFilterFn() : (t = (n = e.options.filterFns) == null ? void 0 : n[o]) != null ? t : Ur[o];
    }, e.setGlobalFilter = (t) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(t);
    }, e.resetGlobalFilter = (t) => {
      e.setGlobalFilter(t ? void 0 : e.initialState.globalFilter);
    };
  }
}, Qie = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: tr("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetExpanded = () => {
      var o, r;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((o = (r = e.options.autoResetAll) != null ? r : e.options.autoResetExpanded) != null ? o : !e.options.manualExpanding) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetExpanded(), n = !1;
        });
      }
    }, e.setExpanded = (o) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(o), e.toggleAllRowsExpanded = (o) => {
      o ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (o) => {
      var r, i;
      e.setExpanded(o ? {} : (r = (i = e.initialState) == null ? void 0 : i.expanded) != null ? r : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((o) => o.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (o) => {
      o.persist == null || o.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const o = e.getState().expanded;
      return o === !0 || Object.values(o).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const o = e.getState().expanded;
      return typeof o == "boolean" ? o === !0 : !(!Object.keys(o).length || e.getRowModel().flatRows.some((r) => !r.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let o = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((i) => {
        const s = i.split(".");
        o = Math.max(o, s.length);
      }), o;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, t) => {
    e.toggleExpanded = (n) => {
      t.setExpanded((o) => {
        var r;
        const i = o === !0 ? !0 : !!(o != null && o[e.id]);
        let s = {};
        if (o === !0 ? Object.keys(t.getRowModel().rowsById).forEach((a) => {
          s[a] = !0;
        }) : s = o, n = (r = n) != null ? r : !i, !i && n)
          return {
            ...s,
            [e.id]: !0
          };
        if (i && !n) {
          const {
            [e.id]: a,
            ...c
          } = s;
          return c;
        }
        return o;
      });
    }, e.getIsExpanded = () => {
      var n;
      const o = t.getState().expanded;
      return !!((n = t.options.getIsRowExpanded == null ? void 0 : t.options.getIsRowExpanded(e)) != null ? n : o === !0 || o != null && o[e.id]);
    }, e.getCanExpand = () => {
      var n, o, r;
      return (n = t.options.getRowCanExpand == null ? void 0 : t.options.getRowCanExpand(e)) != null ? n : ((o = t.options.enableExpanding) != null ? o : !0) && !!((r = e.subRows) != null && r.length);
    }, e.getIsAllParentsExpanded = () => {
      let n = !0, o = e;
      for (; n && o.parentId; )
        o = t.getRow(o.parentId, !0), n = o.getIsExpanded();
      return n;
    }, e.getToggleExpandedHandler = () => {
      const n = e.getCanExpand();
      return () => {
        n && e.toggleExpanded();
      };
    };
  }
}, u5 = 0, f5 = 10, E6 = () => ({
  pageIndex: u5,
  pageSize: f5
}), ese = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...E6(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: tr("pagination", e)
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetPageIndex = () => {
      var o, r;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((o = (r = e.options.autoResetAll) != null ? r : e.options.autoResetPageIndex) != null ? o : !e.options.manualPagination) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetPageIndex(), n = !1;
        });
      }
    }, e.setPagination = (o) => {
      const r = (i) => ns(o, i);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(r);
    }, e.resetPagination = (o) => {
      var r;
      e.setPagination(o ? E6() : (r = e.initialState.pagination) != null ? r : E6());
    }, e.setPageIndex = (o) => {
      e.setPagination((r) => {
        let i = ns(o, r.pageIndex);
        const s = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return i = Math.max(0, Math.min(i, s)), {
          ...r,
          pageIndex: i
        };
      });
    }, e.resetPageIndex = (o) => {
      var r, i;
      e.setPageIndex(o ? u5 : (r = (i = e.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageIndex) != null ? r : u5);
    }, e.resetPageSize = (o) => {
      var r, i;
      e.setPageSize(o ? f5 : (r = (i = e.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageSize) != null ? r : f5);
    }, e.setPageSize = (o) => {
      e.setPagination((r) => {
        const i = Math.max(1, ns(o, r.pageSize)), s = r.pageSize * r.pageIndex, a = Math.floor(s / i);
        return {
          ...r,
          pageIndex: a,
          pageSize: i
        };
      });
    }, e.setPageCount = (o) => e.setPagination((r) => {
      var i;
      let s = ns(o, (i = e.options.pageCount) != null ? i : -1);
      return typeof s == "number" && (s = Math.max(-1, s)), {
        ...r,
        pageCount: s
      };
    }), e.getPageOptions = ct(() => [e.getPageCount()], (o) => {
      let r = [];
      return o && o > 0 && (r = [...new Array(o)].fill(null).map((i, s) => s)), r;
    }, dt(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: o
      } = e.getState().pagination, r = e.getPageCount();
      return r === -1 ? !0 : r === 0 ? !1 : o < r - 1;
    }, e.previousPage = () => e.setPageIndex((o) => o - 1), e.nextPage = () => e.setPageIndex((o) => o + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var o;
      return (o = e.options.pageCount) != null ? o : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var o;
      return (o = e.options.rowCount) != null ? o : e.getPrePaginationRowModel().rows.length;
    };
  }
}, R6 = () => ({
  top: [],
  bottom: []
}), tse = {
  getInitialState: (e) => ({
    rowPinning: R6(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: tr("rowPinning", e)
  }),
  createRow: (e, t) => {
    e.pin = (n, o, r) => {
      const i = o ? e.getLeafRows().map((c) => {
        let {
          id: d
        } = c;
        return d;
      }) : [], s = r ? e.getParentRows().map((c) => {
        let {
          id: d
        } = c;
        return d;
      }) : [], a = /* @__PURE__ */ new Set([...s, e.id, ...i]);
      t.setRowPinning((c) => {
        var d, u;
        if (n === "bottom") {
          var p, h;
          return {
            top: ((p = c == null ? void 0 : c.top) != null ? p : []).filter((b) => !(a != null && a.has(b))),
            bottom: [...((h = c == null ? void 0 : c.bottom) != null ? h : []).filter((b) => !(a != null && a.has(b))), ...Array.from(a)]
          };
        }
        if (n === "top") {
          var g, m;
          return {
            top: [...((g = c == null ? void 0 : c.top) != null ? g : []).filter((b) => !(a != null && a.has(b))), ...Array.from(a)],
            bottom: ((m = c == null ? void 0 : c.bottom) != null ? m : []).filter((b) => !(a != null && a.has(b)))
          };
        }
        return {
          top: ((d = c == null ? void 0 : c.top) != null ? d : []).filter((b) => !(a != null && a.has(b))),
          bottom: ((u = c == null ? void 0 : c.bottom) != null ? u : []).filter((b) => !(a != null && a.has(b)))
        };
      });
    }, e.getCanPin = () => {
      var n;
      const {
        enableRowPinning: o,
        enablePinning: r
      } = t.options;
      return typeof o == "function" ? o(e) : (n = o ?? r) != null ? n : !0;
    }, e.getIsPinned = () => {
      const n = [e.id], {
        top: o,
        bottom: r
      } = t.getState().rowPinning, i = n.some((a) => o == null ? void 0 : o.includes(a)), s = n.some((a) => r == null ? void 0 : r.includes(a));
      return i ? "top" : s ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var n, o;
      const r = e.getIsPinned();
      if (!r) return -1;
      const i = (n = r === "top" ? t.getTopRows() : t.getBottomRows()) == null ? void 0 : n.map((s) => {
        let {
          id: a
        } = s;
        return a;
      });
      return (o = i == null ? void 0 : i.indexOf(e.id)) != null ? o : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (t) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(t), e.resetRowPinning = (t) => {
      var n, o;
      return e.setRowPinning(t ? R6() : (n = (o = e.initialState) == null ? void 0 : o.rowPinning) != null ? n : R6());
    }, e.getIsSomeRowsPinned = (t) => {
      var n;
      const o = e.getState().rowPinning;
      if (!t) {
        var r, i;
        return !!((r = o.top) != null && r.length || (i = o.bottom) != null && i.length);
      }
      return !!((n = o[t]) != null && n.length);
    }, e._getPinnedRows = (t, n, o) => {
      var r;
      return ((r = e.options.keepPinnedRows) == null || r ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (n ?? []).map((s) => {
          const a = e.getRow(s, !0);
          return a.getIsAllParentsExpanded() ? a : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (n ?? []).map((s) => t.find((a) => a.id === s))
      )).filter(Boolean).map((s) => ({
        ...s,
        position: o
      }));
    }, e.getTopRows = ct(() => [e.getRowModel().rows, e.getState().rowPinning.top], (t, n) => e._getPinnedRows(t, n, "top"), dt(e.options, "debugRows", "getTopRows")), e.getBottomRows = ct(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (t, n) => e._getPinnedRows(t, n, "bottom"), dt(e.options, "debugRows", "getBottomRows")), e.getCenterRows = ct(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (t, n, o) => {
      const r = /* @__PURE__ */ new Set([...n ?? [], ...o ?? []]);
      return t.filter((i) => !r.has(i.id));
    }, dt(e.options, "debugRows", "getCenterRows"));
  }
}, nse = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: tr("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (t) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(t), e.resetRowSelection = (t) => {
      var n;
      return e.setRowSelection(t ? {} : (n = e.initialState.rowSelection) != null ? n : {});
    }, e.toggleAllRowsSelected = (t) => {
      e.setRowSelection((n) => {
        t = typeof t < "u" ? t : !e.getIsAllRowsSelected();
        const o = {
          ...n
        }, r = e.getPreGroupedRowModel().flatRows;
        return t ? r.forEach((i) => {
          i.getCanSelect() && (o[i.id] = !0);
        }) : r.forEach((i) => {
          delete o[i.id];
        }), o;
      });
    }, e.toggleAllPageRowsSelected = (t) => e.setRowSelection((n) => {
      const o = typeof t < "u" ? t : !e.getIsAllPageRowsSelected(), r = {
        ...n
      };
      return e.getRowModel().rows.forEach((i) => {
        p5(r, i.id, o, !0, e);
      }), r;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = ct(() => [e.getState().rowSelection, e.getCoreRowModel()], (t, n) => Object.keys(t).length ? O6(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, dt(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = ct(() => [e.getState().rowSelection, e.getFilteredRowModel()], (t, n) => Object.keys(t).length ? O6(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, dt(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = ct(() => [e.getState().rowSelection, e.getSortedRowModel()], (t, n) => Object.keys(t).length ? O6(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, dt(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const t = e.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = e.getState();
      let o = !!(t.length && Object.keys(n).length);
      return o && t.some((r) => r.getCanSelect() && !n[r.id]) && (o = !1), o;
    }, e.getIsAllPageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows.filter((r) => r.getCanSelect()), {
        rowSelection: n
      } = e.getState();
      let o = !!t.length;
      return o && t.some((r) => !n[r.id]) && (o = !1), o;
    }, e.getIsSomeRowsSelected = () => {
      var t;
      const n = Object.keys((t = e.getState().rowSelection) != null ? t : {}).length;
      return n > 0 && n < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : t.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (t) => {
      e.toggleAllRowsSelected(t.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (t) => {
      e.toggleAllPageRowsSelected(t.target.checked);
    };
  },
  createRow: (e, t) => {
    e.toggleSelected = (n, o) => {
      const r = e.getIsSelected();
      t.setRowSelection((i) => {
        var s;
        if (n = typeof n < "u" ? n : !r, e.getCanSelect() && r === n)
          return i;
        const a = {
          ...i
        };
        return p5(a, e.id, n, (s = o == null ? void 0 : o.selectChildren) != null ? s : !0, t), a;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return N7(e, n);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return h5(e, n) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return h5(e, n) === "all";
    }, e.getCanSelect = () => {
      var n;
      return typeof t.options.enableRowSelection == "function" ? t.options.enableRowSelection(e) : (n = t.options.enableRowSelection) != null ? n : !0;
    }, e.getCanSelectSubRows = () => {
      var n;
      return typeof t.options.enableSubRowSelection == "function" ? t.options.enableSubRowSelection(e) : (n = t.options.enableSubRowSelection) != null ? n : !0;
    }, e.getCanMultiSelect = () => {
      var n;
      return typeof t.options.enableMultiRowSelection == "function" ? t.options.enableMultiRowSelection(e) : (n = t.options.enableMultiRowSelection) != null ? n : !0;
    }, e.getToggleSelectedHandler = () => {
      const n = e.getCanSelect();
      return (o) => {
        var r;
        n && e.toggleSelected((r = o.target) == null ? void 0 : r.checked);
      };
    };
  }
}, p5 = (e, t, n, o, r) => {
  var i;
  const s = r.getRow(t, !0);
  n ? (s.getCanMultiSelect() || Object.keys(e).forEach((a) => delete e[a]), s.getCanSelect() && (e[t] = !0)) : delete e[t], o && (i = s.subRows) != null && i.length && s.getCanSelectSubRows() && s.subRows.forEach((a) => p5(e, a.id, n, o, r));
};
function O6(e, t) {
  const n = e.getState().rowSelection, o = [], r = {}, i = function(s, a) {
    return s.map((c) => {
      var d;
      const u = N7(c, n);
      if (u && (o.push(c), r[c.id] = c), (d = c.subRows) != null && d.length && (c = {
        ...c,
        subRows: i(c.subRows)
      }), u)
        return c;
    }).filter(Boolean);
  };
  return {
    rows: i(t.rows),
    flatRows: o,
    rowsById: r
  };
}
function N7(e, t) {
  var n;
  return (n = t[e.id]) != null ? n : !1;
}
function h5(e, t, n) {
  var o;
  if (!((o = e.subRows) != null && o.length)) return !1;
  let r = !0, i = !1;
  return e.subRows.forEach((s) => {
    if (!(i && !r) && (s.getCanSelect() && (N7(s, t) ? i = !0 : r = !1), s.subRows && s.subRows.length)) {
      const a = h5(s, t);
      a === "all" ? i = !0 : (a === "some" && (i = !0), r = !1);
    }
  }), r ? "all" : i ? "some" : !1;
}
const g5 = /([0-9]+)/gm, ose = (e, t, n) => nT(xs(e.getValue(n)).toLowerCase(), xs(t.getValue(n)).toLowerCase()), rse = (e, t, n) => nT(xs(e.getValue(n)), xs(t.getValue(n))), ise = (e, t, n) => $7(xs(e.getValue(n)).toLowerCase(), xs(t.getValue(n)).toLowerCase()), sse = (e, t, n) => $7(xs(e.getValue(n)), xs(t.getValue(n))), ase = (e, t, n) => {
  const o = e.getValue(n), r = t.getValue(n);
  return o > r ? 1 : o < r ? -1 : 0;
}, lse = (e, t, n) => $7(e.getValue(n), t.getValue(n));
function $7(e, t) {
  return e === t ? 0 : e > t ? 1 : -1;
}
function xs(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function nT(e, t) {
  const n = e.split(g5).filter(Boolean), o = t.split(g5).filter(Boolean);
  for (; n.length && o.length; ) {
    const r = n.shift(), i = o.shift(), s = parseInt(r, 10), a = parseInt(i, 10), c = [s, a].sort();
    if (isNaN(c[0])) {
      if (r > i)
        return 1;
      if (i > r)
        return -1;
      continue;
    }
    if (isNaN(c[1]))
      return isNaN(s) ? -1 : 1;
    if (s > a)
      return 1;
    if (a > s)
      return -1;
  }
  return n.length - o.length;
}
const qs = {
  alphanumeric: ose,
  alphanumericCaseSensitive: rse,
  text: ise,
  textCaseSensitive: sse,
  datetime: ase,
  basic: lse
}, cse = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: tr("sorting", e),
    isMultiSortEvent: (t) => t.shiftKey
  }),
  createColumn: (e, t) => {
    e.getAutoSortingFn = () => {
      const n = t.getFilteredRowModel().flatRows.slice(10);
      let o = !1;
      for (const r of n) {
        const i = r == null ? void 0 : r.getValue(e.id);
        if (Object.prototype.toString.call(i) === "[object Date]")
          return qs.datetime;
        if (typeof i == "string" && (o = !0, i.split(g5).length > 1))
          return qs.alphanumeric;
      }
      return o ? qs.text : qs.basic;
    }, e.getAutoSortDir = () => {
      const n = t.getFilteredRowModel().flatRows[0];
      return typeof (n == null ? void 0 : n.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var n, o;
      if (!e)
        throw new Error();
      return q3(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (n = (o = t.options.sortingFns) == null ? void 0 : o[e.columnDef.sortingFn]) != null ? n : qs[e.columnDef.sortingFn];
    }, e.toggleSorting = (n, o) => {
      const r = e.getNextSortingOrder(), i = typeof n < "u" && n !== null;
      t.setSorting((s) => {
        const a = s == null ? void 0 : s.find((g) => g.id === e.id), c = s == null ? void 0 : s.findIndex((g) => g.id === e.id);
        let d = [], u, p = i ? n : r === "desc";
        if (s != null && s.length && e.getCanMultiSort() && o ? a ? u = "toggle" : u = "add" : s != null && s.length && c !== s.length - 1 ? u = "replace" : a ? u = "toggle" : u = "replace", u === "toggle" && (i || r || (u = "remove")), u === "add") {
          var h;
          d = [...s, {
            id: e.id,
            desc: p
          }], d.splice(0, d.length - ((h = t.options.maxMultiSortColCount) != null ? h : Number.MAX_SAFE_INTEGER));
        } else u === "toggle" ? d = s.map((g) => g.id === e.id ? {
          ...g,
          desc: p
        } : g) : u === "remove" ? d = s.filter((g) => g.id !== e.id) : d = [{
          id: e.id,
          desc: p
        }];
        return d;
      });
    }, e.getFirstSortDir = () => {
      var n, o;
      return ((n = (o = e.columnDef.sortDescFirst) != null ? o : t.options.sortDescFirst) != null ? n : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (n) => {
      var o, r;
      const i = e.getFirstSortDir(), s = e.getIsSorted();
      return s ? s !== i && ((o = t.options.enableSortingRemoval) == null || o) && // If enableSortRemove, enable in general
      (!(n && (r = t.options.enableMultiRemove) != null) || r) ? !1 : s === "desc" ? "asc" : "desc" : i;
    }, e.getCanSort = () => {
      var n, o;
      return ((n = e.columnDef.enableSorting) != null ? n : !0) && ((o = t.options.enableSorting) != null ? o : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var n, o;
      return (n = (o = e.columnDef.enableMultiSort) != null ? o : t.options.enableMultiSort) != null ? n : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var n;
      const o = (n = t.getState().sorting) == null ? void 0 : n.find((r) => r.id === e.id);
      return o ? o.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var n, o;
      return (n = (o = t.getState().sorting) == null ? void 0 : o.findIndex((r) => r.id === e.id)) != null ? n : -1;
    }, e.clearSorting = () => {
      t.setSorting((n) => n != null && n.length ? n.filter((o) => o.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const n = e.getCanSort();
      return (o) => {
        n && (o.persist == null || o.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? t.options.isMultiSortEvent == null ? void 0 : t.options.isMultiSortEvent(o) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (t) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(t), e.resetSorting = (t) => {
      var n, o;
      e.setSorting(t ? [] : (n = (o = e.initialState) == null ? void 0 : o.sorting) != null ? n : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, dse = [
  Lie,
  Yie,
  Uie,
  Gie,
  Iie,
  jie,
  Xie,
  //depends on ColumnFaceting
  Jie,
  //depends on ColumnFiltering
  cse,
  Zie,
  //depends on RowSorting
  Qie,
  ese,
  tse,
  nse,
  qie
];
function use(e) {
  var t, n;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const o = [...dse, ...(t = e._features) != null ? t : []];
  let r = {
    _features: o
  };
  const i = r._features.reduce((h, g) => Object.assign(h, g.getDefaultOptions == null ? void 0 : g.getDefaultOptions(r)), {}), s = (h) => r.options.mergeOptions ? r.options.mergeOptions(i, h) : {
    ...i,
    ...h
  };
  let c = {
    ...{},
    ...(n = e.initialState) != null ? n : {}
  };
  r._features.forEach((h) => {
    var g;
    c = (g = h.getInitialState == null ? void 0 : h.getInitialState(c)) != null ? g : c;
  });
  const d = [];
  let u = !1;
  const p = {
    _features: o,
    options: {
      ...i,
      ...e
    },
    initialState: c,
    _queue: (h) => {
      d.push(h), u || (u = !0, Promise.resolve().then(() => {
        for (; d.length; )
          d.shift()();
        u = !1;
      }).catch((g) => setTimeout(() => {
        throw g;
      })));
    },
    reset: () => {
      r.setState(r.initialState);
    },
    setOptions: (h) => {
      const g = ns(h, r.options);
      r.options = s(g);
    },
    getState: () => r.options.state,
    setState: (h) => {
      r.options.onStateChange == null || r.options.onStateChange(h);
    },
    _getRowId: (h, g, m) => {
      var b;
      return (b = r.options.getRowId == null ? void 0 : r.options.getRowId(h, g, m)) != null ? b : `${m ? [m.id, g].join(".") : g}`;
    },
    getCoreRowModel: () => (r._getCoreRowModel || (r._getCoreRowModel = r.options.getCoreRowModel(r)), r._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => r.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (h, g) => {
      let m = (g ? r.getPrePaginationRowModel() : r.getRowModel()).rowsById[h];
      if (!m && (m = r.getCoreRowModel().rowsById[h], !m))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${h}`) : new Error();
      return m;
    },
    _getDefaultColumnDef: ct(() => [r.options.defaultColumn], (h) => {
      var g;
      return h = (g = h) != null ? g : {}, {
        header: (m) => {
          const b = m.header.column.columnDef;
          return b.accessorKey ? b.accessorKey : b.accessorFn ? b.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (m) => {
          var b, C;
          return (b = (C = m.renderValue()) == null || C.toString == null ? void 0 : C.toString()) != null ? b : null;
        },
        ...r._features.reduce((m, b) => Object.assign(m, b.getDefaultColumnDef == null ? void 0 : b.getDefaultColumnDef()), {}),
        ...h
      };
    }, dt(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => r.options.columns,
    getAllColumns: ct(() => [r._getColumnDefs()], (h) => {
      const g = function(m, b, C) {
        return C === void 0 && (C = 0), m.map((x) => {
          const v = Pie(r, x, C, b), S = x;
          return v.columns = S.columns ? g(S.columns, v, C + 1) : [], v;
        });
      };
      return g(h);
    }, dt(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: ct(() => [r.getAllColumns()], (h) => h.flatMap((g) => g.getFlatColumns()), dt(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: ct(() => [r.getAllFlatColumns()], (h) => h.reduce((g, m) => (g[m.id] = m, g), {}), dt(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: ct(() => [r.getAllColumns(), r._getOrderColumnsFn()], (h, g) => {
      let m = h.flatMap((b) => b.getLeafColumns());
      return g(m);
    }, dt(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (h) => {
      const g = r._getAllFlatColumnsById()[h];
      return process.env.NODE_ENV !== "production" && !g && console.error(`[Table] Column with id '${h}' does not exist.`), g;
    }
  };
  Object.assign(r, p);
  for (let h = 0; h < r._features.length; h++) {
    const g = r._features[h];
    g == null || g.createTable == null || g.createTable(r);
  }
  return r;
}
function fse() {
  return (e) => ct(() => [e.options.data], (t) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, o = function(r, i, s) {
      i === void 0 && (i = 0);
      const a = [];
      for (let d = 0; d < r.length; d++) {
        const u = $0(e, e._getRowId(r[d], d, s), r[d], d, i, void 0, s == null ? void 0 : s.id);
        if (n.flatRows.push(u), n.rowsById[u.id] = u, a.push(u), e.options.getSubRows) {
          var c;
          u.originalSubRows = e.options.getSubRows(r[d], d), (c = u.originalSubRows) != null && c.length && (u.subRows = o(u.originalSubRows, i + 1, u));
        }
      }
      return a;
    };
    return n.rows = o(t), n;
  }, dt(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function pse() {
  return (e) => ct(() => [e.getState().expanded, e.getPreExpandedRowModel(), e.options.paginateExpandedRows], (t, n, o) => !n.rows.length || t !== !0 && !Object.keys(t ?? {}).length || !o ? n : oT(n), dt(e.options, "debugTable", "getExpandedRowModel"));
}
function oT(e) {
  const t = [], n = (o) => {
    var r;
    t.push(o), (r = o.subRows) != null && r.length && o.getIsExpanded() && o.subRows.forEach(n);
  };
  return e.rows.forEach(n), {
    rows: t,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
function hse() {
  return (e, t) => ct(() => {
    var n;
    return [(n = e.getColumn(t)) == null ? void 0 : n.getFacetedRowModel()];
  }, (n) => {
    if (!n) return;
    const o = n.flatRows.flatMap((s) => {
      var a;
      return (a = s.getUniqueValues(t)) != null ? a : [];
    }).map(Number).filter((s) => !Number.isNaN(s));
    if (!o.length) return;
    let r = o[0], i = o[o.length - 1];
    for (const s of o)
      s < r ? r = s : s > i && (i = s);
    return [r, i];
  }, dt(e.options, "debugTable", "getFacetedMinMaxValues"));
}
function rT(e, t, n) {
  return n.options.filterFromLeafRows ? gse(e, t, n) : mse(e, t, n);
}
function gse(e, t, n) {
  var o;
  const r = [], i = {}, s = (o = n.options.maxLeafRowFilterDepth) != null ? o : 100, a = function(c, d) {
    d === void 0 && (d = 0);
    const u = [];
    for (let h = 0; h < c.length; h++) {
      var p;
      let g = c[h];
      const m = $0(n, g.id, g.original, g.index, g.depth, void 0, g.parentId);
      if (m.columnFilters = g.columnFilters, (p = g.subRows) != null && p.length && d < s) {
        if (m.subRows = a(g.subRows, d + 1), g = m, t(g) && !m.subRows.length) {
          u.push(g), i[g.id] = g, r.push(g);
          continue;
        }
        if (t(g) || m.subRows.length) {
          u.push(g), i[g.id] = g, r.push(g);
          continue;
        }
      } else
        g = m, t(g) && (u.push(g), i[g.id] = g, r.push(g));
    }
    return u;
  };
  return {
    rows: a(e),
    flatRows: r,
    rowsById: i
  };
}
function mse(e, t, n) {
  var o;
  const r = [], i = {}, s = (o = n.options.maxLeafRowFilterDepth) != null ? o : 100, a = function(c, d) {
    d === void 0 && (d = 0);
    const u = [];
    for (let h = 0; h < c.length; h++) {
      let g = c[h];
      if (t(g)) {
        var p;
        if ((p = g.subRows) != null && p.length && d < s) {
          const b = $0(n, g.id, g.original, g.index, g.depth, void 0, g.parentId);
          b.subRows = a(g.subRows, d + 1), g = b;
        }
        u.push(g), r.push(g), i[g.id] = g;
      }
    }
    return u;
  };
  return {
    rows: a(e),
    flatRows: r,
    rowsById: i
  };
}
function bse() {
  return (e, t) => ct(() => [e.getPreFilteredRowModel(), e.getState().columnFilters, e.getState().globalFilter, e.getFilteredRowModel()], (n, o, r) => {
    if (!n.rows.length || !(o != null && o.length) && !r)
      return n;
    const i = [...o.map((a) => a.id).filter((a) => a !== t), r ? "__global__" : void 0].filter(Boolean), s = (a) => {
      for (let c = 0; c < i.length; c++)
        if (a.columnFilters[i[c]] === !1)
          return !1;
      return !0;
    };
    return rT(n.rows, s, e);
  }, dt(e.options, "debugTable", "getFacetedRowModel"));
}
function Cse() {
  return (e, t) => ct(() => {
    var n;
    return [(n = e.getColumn(t)) == null ? void 0 : n.getFacetedRowModel()];
  }, (n) => {
    if (!n) return /* @__PURE__ */ new Map();
    let o = /* @__PURE__ */ new Map();
    for (let i = 0; i < n.flatRows.length; i++) {
      const s = n.flatRows[i].getUniqueValues(t);
      for (let a = 0; a < s.length; a++) {
        const c = s[a];
        if (o.has(c)) {
          var r;
          o.set(c, ((r = o.get(c)) != null ? r : 0) + 1);
        } else
          o.set(c, 1);
      }
    }
    return o;
  }, dt(e.options, "debugTable", `getFacetedUniqueValues_${t}`));
}
function xse() {
  return (e) => ct(() => [e.getPreFilteredRowModel(), e.getState().columnFilters, e.getState().globalFilter], (t, n, o) => {
    if (!t.rows.length || !(n != null && n.length) && !o) {
      for (let h = 0; h < t.flatRows.length; h++)
        t.flatRows[h].columnFilters = {}, t.flatRows[h].columnFiltersMeta = {};
      return t;
    }
    const r = [], i = [];
    (n ?? []).forEach((h) => {
      var g;
      const m = e.getColumn(h.id);
      if (!m)
        return;
      const b = m.getFilterFn();
      if (!b) {
        process.env.NODE_ENV !== "production" && console.warn(`Could not find a valid 'column.filterFn' for column with the ID: ${m.id}.`);
        return;
      }
      r.push({
        id: h.id,
        filterFn: b,
        resolvedValue: (g = b.resolveFilterValue == null ? void 0 : b.resolveFilterValue(h.value)) != null ? g : h.value
      });
    });
    const s = (n ?? []).map((h) => h.id), a = e.getGlobalFilterFn(), c = e.getAllLeafColumns().filter((h) => h.getCanGlobalFilter());
    o && a && c.length && (s.push("__global__"), c.forEach((h) => {
      var g;
      i.push({
        id: h.id,
        filterFn: a,
        resolvedValue: (g = a.resolveFilterValue == null ? void 0 : a.resolveFilterValue(o)) != null ? g : o
      });
    }));
    let d, u;
    for (let h = 0; h < t.flatRows.length; h++) {
      const g = t.flatRows[h];
      if (g.columnFilters = {}, r.length)
        for (let m = 0; m < r.length; m++) {
          d = r[m];
          const b = d.id;
          g.columnFilters[b] = d.filterFn(g, b, d.resolvedValue, (C) => {
            g.columnFiltersMeta[b] = C;
          });
        }
      if (i.length) {
        for (let m = 0; m < i.length; m++) {
          u = i[m];
          const b = u.id;
          if (u.filterFn(g, b, u.resolvedValue, (C) => {
            g.columnFiltersMeta[b] = C;
          })) {
            g.columnFilters.__global__ = !0;
            break;
          }
        }
        g.columnFilters.__global__ !== !0 && (g.columnFilters.__global__ = !1);
      }
    }
    const p = (h) => {
      for (let g = 0; g < s.length; g++)
        if (h.columnFilters[s[g]] === !1)
          return !1;
      return !0;
    };
    return rT(t.rows, p, e);
  }, dt(e.options, "debugTable", "getFilteredRowModel", () => e._autoResetPageIndex()));
}
function yse() {
  return (e) => ct(() => [e.getState().grouping, e.getPreGroupedRowModel()], (t, n) => {
    if (!n.rows.length || !t.length)
      return n.rows.forEach((c) => {
        c.depth = 0, c.parentId = void 0;
      }), n;
    const o = t.filter((c) => e.getColumn(c)), r = [], i = {}, s = function(c, d, u) {
      if (d === void 0 && (d = 0), d >= o.length)
        return c.map((m) => (m.depth = d, r.push(m), i[m.id] = m, m.subRows && (m.subRows = s(m.subRows, d + 1, m.id)), m));
      const p = o[d], h = vse(c, p);
      return Array.from(h.entries()).map((m, b) => {
        let [C, x] = m, v = `${p}:${C}`;
        v = u ? `${u}>${v}` : v;
        const S = s(x, d + 1, v);
        S.forEach((k) => {
          k.parentId = v;
        });
        const M = d ? GM(x, (k) => k.subRows) : x, w = $0(e, v, M[0].original, b, d, void 0, u);
        return Object.assign(w, {
          groupingColumnId: p,
          groupingValue: C,
          subRows: S,
          leafRows: M,
          getValue: (k) => {
            if (o.includes(k)) {
              if (w._valuesCache.hasOwnProperty(k))
                return w._valuesCache[k];
              if (x[0]) {
                var E;
                w._valuesCache[k] = (E = x[0].getValue(k)) != null ? E : void 0;
              }
              return w._valuesCache[k];
            }
            if (w._groupingValuesCache.hasOwnProperty(k))
              return w._groupingValuesCache[k];
            const R = e.getColumn(k), O = R == null ? void 0 : R.getAggregationFn();
            if (O)
              return w._groupingValuesCache[k] = O(k, M, x), w._groupingValuesCache[k];
          }
        }), S.forEach((k) => {
          r.push(k), i[k.id] = k;
        }), w;
      });
    }, a = s(n.rows, 0);
    return a.forEach((c) => {
      r.push(c), i[c.id] = c;
    }), {
      rows: a,
      flatRows: r,
      rowsById: i
    };
  }, dt(e.options, "debugTable", "getGroupedRowModel", () => {
    e._queue(() => {
      e._autoResetExpanded(), e._autoResetPageIndex();
    });
  }));
}
function vse(e, t) {
  const n = /* @__PURE__ */ new Map();
  return e.reduce((o, r) => {
    const i = `${r.getGroupingValue(t)}`, s = o.get(i);
    return s ? s.push(r) : o.set(i, [r]), o;
  }, n);
}
function wse(e) {
  return (t) => ct(() => [t.getState().pagination, t.getPrePaginationRowModel(), t.options.paginateExpandedRows ? void 0 : t.getState().expanded], (n, o) => {
    if (!o.rows.length)
      return o;
    const {
      pageSize: r,
      pageIndex: i
    } = n;
    let {
      rows: s,
      flatRows: a,
      rowsById: c
    } = o;
    const d = r * i, u = d + r;
    s = s.slice(d, u);
    let p;
    t.options.paginateExpandedRows ? p = {
      rows: s,
      flatRows: a,
      rowsById: c
    } : p = oT({
      rows: s,
      flatRows: a,
      rowsById: c
    }), p.flatRows = [];
    const h = (g) => {
      p.flatRows.push(g), g.subRows.length && g.subRows.forEach(h);
    };
    return p.rows.forEach(h), p;
  }, dt(t.options, "debugTable", "getPaginationRowModel"));
}
function Sse() {
  return (e) => ct(() => [e.getState().sorting, e.getPreSortedRowModel()], (t, n) => {
    if (!n.rows.length || !(t != null && t.length))
      return n;
    const o = e.getState().sorting, r = [], i = o.filter((c) => {
      var d;
      return (d = e.getColumn(c.id)) == null ? void 0 : d.getCanSort();
    }), s = {};
    i.forEach((c) => {
      const d = e.getColumn(c.id);
      d && (s[c.id] = {
        sortUndefined: d.columnDef.sortUndefined,
        invertSorting: d.columnDef.invertSorting,
        sortingFn: d.getSortingFn()
      });
    });
    const a = (c) => {
      const d = c.map((u) => ({
        ...u
      }));
      return d.sort((u, p) => {
        for (let g = 0; g < i.length; g += 1) {
          var h;
          const m = i[g], b = s[m.id], C = b.sortUndefined, x = (h = m == null ? void 0 : m.desc) != null ? h : !1;
          let v = 0;
          if (C) {
            const S = u.getValue(m.id), M = p.getValue(m.id), w = S === void 0, k = M === void 0;
            if (w || k) {
              if (C === "first") return w ? -1 : 1;
              if (C === "last") return w ? 1 : -1;
              v = w && k ? 0 : w ? C : -C;
            }
          }
          if (v === 0 && (v = b.sortingFn(u, p, m.id)), v !== 0)
            return x && (v *= -1), b.invertSorting && (v *= -1), v;
        }
        return u.index - p.index;
      }), d.forEach((u) => {
        var p;
        r.push(u), (p = u.subRows) != null && p.length && (u.subRows = a(u.subRows));
      }), d;
    };
    return {
      rows: a(n.rows),
      flatRows: r,
      rowsById: n.rowsById
    };
  }, dt(e.options, "debugTable", "getSortedRowModel", () => e._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Mse(e) {
  const t = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [n] = y.useState(() => ({
    current: use(t)
  })), [o, r] = y.useState(() => n.current.initialState);
  return n.current.setOptions((i) => ({
    ...i,
    ...e,
    state: {
      ...o,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (s) => {
      r(s), e.onStateChange == null || e.onStateChange(s);
    }
  })), n.current;
}
/**
   * match-sorter-utils
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
const iT = {
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  Ấ: "A",
  Ắ: "A",
  Ẳ: "A",
  Ẵ: "A",
  Ặ: "A",
  Æ: "AE",
  Ầ: "A",
  Ằ: "A",
  Ȃ: "A",
  Ç: "C",
  Ḉ: "C",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  Ế: "E",
  Ḗ: "E",
  Ề: "E",
  Ḕ: "E",
  Ḝ: "E",
  Ȇ: "E",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  Ḯ: "I",
  Ȋ: "I",
  Ð: "D",
  Ñ: "N",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  Ố: "O",
  Ṍ: "O",
  Ṓ: "O",
  Ȏ: "O",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  Ý: "Y",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  ấ: "a",
  ắ: "a",
  ẳ: "a",
  ẵ: "a",
  ặ: "a",
  æ: "ae",
  ầ: "a",
  ằ: "a",
  ȃ: "a",
  ç: "c",
  ḉ: "c",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  ế: "e",
  ḗ: "e",
  ề: "e",
  ḕ: "e",
  ḝ: "e",
  ȇ: "e",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  ḯ: "i",
  ȋ: "i",
  ð: "d",
  ñ: "n",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  ố: "o",
  ṍ: "o",
  ṓ: "o",
  ȏ: "o",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  ý: "y",
  ÿ: "y",
  Ā: "A",
  ā: "a",
  Ă: "A",
  ă: "a",
  Ą: "A",
  ą: "a",
  Ć: "C",
  ć: "c",
  Ĉ: "C",
  ĉ: "c",
  Ċ: "C",
  ċ: "c",
  Č: "C",
  č: "c",
  C̆: "C",
  c̆: "c",
  Ď: "D",
  ď: "d",
  Đ: "D",
  đ: "d",
  Ē: "E",
  ē: "e",
  Ĕ: "E",
  ĕ: "e",
  Ė: "E",
  ė: "e",
  Ę: "E",
  ę: "e",
  Ě: "E",
  ě: "e",
  Ĝ: "G",
  Ǵ: "G",
  ĝ: "g",
  ǵ: "g",
  Ğ: "G",
  ğ: "g",
  Ġ: "G",
  ġ: "g",
  Ģ: "G",
  ģ: "g",
  Ĥ: "H",
  ĥ: "h",
  Ħ: "H",
  ħ: "h",
  Ḫ: "H",
  ḫ: "h",
  Ĩ: "I",
  ĩ: "i",
  Ī: "I",
  ī: "i",
  Ĭ: "I",
  ĭ: "i",
  Į: "I",
  į: "i",
  İ: "I",
  ı: "i",
  Ĳ: "IJ",
  ĳ: "ij",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  Ḱ: "K",
  ḱ: "k",
  K̆: "K",
  k̆: "k",
  Ĺ: "L",
  ĺ: "l",
  Ļ: "L",
  ļ: "l",
  Ľ: "L",
  ľ: "l",
  Ŀ: "L",
  ŀ: "l",
  Ł: "l",
  ł: "l",
  Ḿ: "M",
  ḿ: "m",
  M̆: "M",
  m̆: "m",
  Ń: "N",
  ń: "n",
  Ņ: "N",
  ņ: "n",
  Ň: "N",
  ň: "n",
  ŉ: "n",
  N̆: "N",
  n̆: "n",
  Ō: "O",
  ō: "o",
  Ŏ: "O",
  ŏ: "o",
  Ő: "O",
  ő: "o",
  Œ: "OE",
  œ: "oe",
  P̆: "P",
  p̆: "p",
  Ŕ: "R",
  ŕ: "r",
  Ŗ: "R",
  ŗ: "r",
  Ř: "R",
  ř: "r",
  R̆: "R",
  r̆: "r",
  Ȓ: "R",
  ȓ: "r",
  Ś: "S",
  ś: "s",
  Ŝ: "S",
  ŝ: "s",
  Ş: "S",
  Ș: "S",
  ș: "s",
  ş: "s",
  Š: "S",
  š: "s",
  Ţ: "T",
  ţ: "t",
  ț: "t",
  Ț: "T",
  Ť: "T",
  ť: "t",
  Ŧ: "T",
  ŧ: "t",
  T̆: "T",
  t̆: "t",
  Ũ: "U",
  ũ: "u",
  Ū: "U",
  ū: "u",
  Ŭ: "U",
  ŭ: "u",
  Ů: "U",
  ů: "u",
  Ű: "U",
  ű: "u",
  Ų: "U",
  ų: "u",
  Ȗ: "U",
  ȗ: "u",
  V̆: "V",
  v̆: "v",
  Ŵ: "W",
  ŵ: "w",
  Ẃ: "W",
  ẃ: "w",
  X̆: "X",
  x̆: "x",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Y̆: "Y",
  y̆: "y",
  Ź: "Z",
  ź: "z",
  Ż: "Z",
  ż: "z",
  Ž: "Z",
  ž: "z",
  ſ: "s",
  ƒ: "f",
  Ơ: "O",
  ơ: "o",
  Ư: "U",
  ư: "u",
  Ǎ: "A",
  ǎ: "a",
  Ǐ: "I",
  ǐ: "i",
  Ǒ: "O",
  ǒ: "o",
  Ǔ: "U",
  ǔ: "u",
  Ǖ: "U",
  ǖ: "u",
  Ǘ: "U",
  ǘ: "u",
  Ǚ: "U",
  ǚ: "u",
  Ǜ: "U",
  ǜ: "u",
  Ứ: "U",
  ứ: "u",
  Ṹ: "U",
  ṹ: "u",
  Ǻ: "A",
  ǻ: "a",
  Ǽ: "AE",
  ǽ: "ae",
  Ǿ: "O",
  ǿ: "o",
  Þ: "TH",
  þ: "th",
  Ṕ: "P",
  ṕ: "p",
  Ṥ: "S",
  ṥ: "s",
  X́: "X",
  x́: "x",
  Ѓ: "Г",
  ѓ: "г",
  Ќ: "К",
  ќ: "к",
  A̋: "A",
  a̋: "a",
  E̋: "E",
  e̋: "e",
  I̋: "I",
  i̋: "i",
  Ǹ: "N",
  ǹ: "n",
  Ồ: "O",
  ồ: "o",
  Ṑ: "O",
  ṑ: "o",
  Ừ: "U",
  ừ: "u",
  Ẁ: "W",
  ẁ: "w",
  Ỳ: "Y",
  ỳ: "y",
  Ȁ: "A",
  ȁ: "a",
  Ȅ: "E",
  ȅ: "e",
  Ȉ: "I",
  ȉ: "i",
  Ȍ: "O",
  ȍ: "o",
  Ȑ: "R",
  ȑ: "r",
  Ȕ: "U",
  ȕ: "u",
  B̌: "B",
  b̌: "b",
  Č̣: "C",
  č̣: "c",
  Ê̌: "E",
  ê̌: "e",
  F̌: "F",
  f̌: "f",
  Ǧ: "G",
  ǧ: "g",
  Ȟ: "H",
  ȟ: "h",
  J̌: "J",
  ǰ: "j",
  Ǩ: "K",
  ǩ: "k",
  M̌: "M",
  m̌: "m",
  P̌: "P",
  p̌: "p",
  Q̌: "Q",
  q̌: "q",
  Ř̩: "R",
  ř̩: "r",
  Ṧ: "S",
  ṧ: "s",
  V̌: "V",
  v̌: "v",
  W̌: "W",
  w̌: "w",
  X̌: "X",
  x̌: "x",
  Y̌: "Y",
  y̌: "y",
  A̧: "A",
  a̧: "a",
  B̧: "B",
  b̧: "b",
  Ḑ: "D",
  ḑ: "d",
  Ȩ: "E",
  ȩ: "e",
  Ɛ̧: "E",
  ɛ̧: "e",
  Ḩ: "H",
  ḩ: "h",
  I̧: "I",
  i̧: "i",
  Ɨ̧: "I",
  ɨ̧: "i",
  M̧: "M",
  m̧: "m",
  O̧: "O",
  o̧: "o",
  Q̧: "Q",
  q̧: "q",
  U̧: "U",
  u̧: "u",
  X̧: "X",
  x̧: "x",
  Z̧: "Z",
  z̧: "z"
}, Tse = Object.keys(iT).join("|"), kse = new RegExp(Tse, "g");
function Ese(e) {
  return e.replace(kse, (t) => iT[t]);
}
/**
 * @name match-sorter
 * @license MIT license.
 * @copyright (c) 2099 Kent C. Dodds
 * @author Kent C. Dodds <me@kentcdodds.com> (https://kentcdodds.com)
 */
const xo = {
  CASE_SENSITIVE_EQUAL: 7,
  EQUAL: 6,
  STARTS_WITH: 5,
  WORD_STARTS_WITH: 4,
  CONTAINS: 3,
  ACRONYM: 2,
  MATCHES: 1,
  NO_MATCH: 0
};
function Rse(e, t, n) {
  var o;
  if (n = n || {}, n.threshold = (o = n.threshold) != null ? o : xo.MATCHES, !n.accessors) {
    const s = lC(e, t, n);
    return {
      // ends up being duplicate of 'item' in matches but consistent
      rankedValue: e,
      rank: s,
      accessorIndex: -1,
      accessorThreshold: n.threshold,
      passed: s >= n.threshold
    };
  }
  const r = Ise(e, n.accessors), i = {
    rankedValue: e,
    rank: xo.NO_MATCH,
    accessorIndex: -1,
    accessorThreshold: n.threshold,
    passed: !1
  };
  for (let s = 0; s < r.length; s++) {
    const a = r[s];
    let c = lC(a.itemValue, t, n);
    const {
      minRanking: d,
      maxRanking: u,
      threshold: p = n.threshold
    } = a.attributes;
    c < d && c >= xo.MATCHES ? c = d : c > u && (c = u), c = Math.min(c, u), c >= p && c > i.rank && (i.rank = c, i.passed = !0, i.accessorIndex = s, i.accessorThreshold = p, i.rankedValue = a.itemValue);
  }
  return i;
}
function lC(e, t, n) {
  return e = cC(e, n), t = cC(t, n), t.length > e.length ? xo.NO_MATCH : e === t ? xo.CASE_SENSITIVE_EQUAL : (e = e.toLowerCase(), t = t.toLowerCase(), e === t ? xo.EQUAL : e.startsWith(t) ? xo.STARTS_WITH : e.includes(` ${t}`) ? xo.WORD_STARTS_WITH : e.includes(t) ? xo.CONTAINS : t.length === 1 ? xo.NO_MATCH : Ose(e).includes(t) ? xo.ACRONYM : _se(e, t));
}
function Ose(e) {
  let t = "";
  return e.split(" ").forEach((o) => {
    o.split("-").forEach((i) => {
      t += i.substr(0, 1);
    });
  }), t;
}
function _se(e, t) {
  let n = 0, o = 0;
  function r(c, d, u) {
    for (let p = u, h = d.length; p < h; p++)
      if (d[p] === c)
        return n += 1, p + 1;
    return -1;
  }
  function i(c) {
    const d = 1 / c, u = n / t.length;
    return xo.MATCHES + u * d;
  }
  const s = r(t[0], e, 0);
  if (s < 0)
    return xo.NO_MATCH;
  o = s;
  for (let c = 1, d = t.length; c < d; c++) {
    const u = t[c];
    if (o = r(u, e, o), !(o > -1))
      return xo.NO_MATCH;
  }
  const a = o - s;
  return i(a);
}
function Pse(e, t) {
  return e.rank === t.rank ? 0 : e.rank > t.rank ? -1 : 1;
}
function cC(e, t) {
  let {
    keepDiacritics: n
  } = t;
  return e = `${e}`, n || (e = Ese(e)), e;
}
function Lse(e, t) {
  let n = t;
  typeof t == "object" && (n = t.accessor);
  const o = n(e);
  return o == null ? [] : Array.isArray(o) ? o : [String(o)];
}
function Ise(e, t) {
  const n = [];
  for (let o = 0, r = t.length; o < r; o++) {
    const i = t[o], s = jse(i), a = Lse(e, i);
    for (let c = 0, d = a.length; c < d; c++)
      n.push({
        itemValue: a[c],
        attributes: s
      });
  }
  return n;
}
const dC = {
  maxRanking: 1 / 0,
  minRanking: -1 / 0
};
function jse(e) {
  return typeof e == "function" ? dC : {
    ...dC,
    ...e
  };
}
var B7 = {}, _6 = {};
const Vse = /* @__PURE__ */ Vi(tV);
var uC;
function bt() {
  return uC || (uC = 1, function(e) {
    "use client";
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t.createSvgIcon;
      }
    });
    var t = Vse;
  }(_6)), _6;
}
var Dse = ht;
Object.defineProperty(B7, "__esModule", {
  value: !0
});
var sT = B7.default = void 0, Ase = Dse(bt()), Hse = f;
sT = B7.default = (0, Ase.default)(/* @__PURE__ */ (0, Hse.jsx)("path", {
  d: "m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8z"
}), "ArrowDownward");
var z7 = {}, Fse = ht;
Object.defineProperty(z7, "__esModule", {
  value: !0
});
var aT = z7.default = void 0, Nse = Fse(bt()), $se = f;
aT = z7.default = (0, Nse.default)(/* @__PURE__ */ (0, $se.jsx)("path", {
  d: "m10 17 5-5-5-5z"
}), "ArrowRight");
var Z7 = {}, Bse = ht;
Object.defineProperty(Z7, "__esModule", {
  value: !0
});
var lT = Z7.default = void 0, zse = Bse(bt()), Zse = f;
lT = Z7.default = (0, zse.default)(/* @__PURE__ */ (0, Zse.jsx)("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
}), "Cancel");
var W7 = {}, Wse = ht;
Object.defineProperty(W7, "__esModule", {
  value: !0
});
var cT = W7.default = void 0, Use = Wse(bt()), Gse = f;
cT = W7.default = (0, Use.default)(/* @__PURE__ */ (0, Gse.jsx)("path", {
  d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "ChevronLeft");
var U7 = {}, qse = ht;
Object.defineProperty(U7, "__esModule", {
  value: !0
});
var dT = U7.default = void 0, Kse = qse(bt()), Yse = f;
dT = U7.default = (0, Kse.default)(/* @__PURE__ */ (0, Yse.jsx)("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "ChevronRight");
var G7 = {}, Xse = ht;
Object.defineProperty(G7, "__esModule", {
  value: !0
});
var uT = G7.default = void 0, Jse = Xse(bt()), Qse = f;
uT = G7.default = (0, Jse.default)(/* @__PURE__ */ (0, Qse.jsx)("path", {
  d: "M5 13h14v-2H5zm-2 4h14v-2H3zM7 7v2h14V7z"
}), "ClearAll");
var q7 = {}, eae = ht;
Object.defineProperty(q7, "__esModule", {
  value: !0
});
var fT = q7.default = void 0, tae = eae(bt()), nae = f;
fT = q7.default = (0, tae.default)(/* @__PURE__ */ (0, nae.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
var K7 = {}, oae = ht;
Object.defineProperty(K7, "__esModule", {
  value: !0
});
var pT = K7.default = void 0, rae = oae(bt()), iae = f;
pT = K7.default = (0, rae.default)(/* @__PURE__ */ (0, iae.jsx)("path", {
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), "ContentCopy");
var Y7 = {}, sae = ht;
Object.defineProperty(Y7, "__esModule", {
  value: !0
});
var hT = Y7.default = void 0, aae = sae(bt()), lae = f;
hT = Y7.default = (0, aae.default)(/* @__PURE__ */ (0, lae.jsx)("path", {
  d: "M3 3h18v2H3zm0 16h18v2H3z"
}), "DensityLarge");
var X7 = {}, cae = ht;
Object.defineProperty(X7, "__esModule", {
  value: !0
});
var gT = X7.default = void 0, dae = cae(bt()), uae = f;
gT = X7.default = (0, dae.default)(/* @__PURE__ */ (0, uae.jsx)("path", {
  d: "M3 3h18v2H3zm0 16h18v2H3zm0-8h18v2H3z"
}), "DensityMedium");
var J7 = {}, fae = ht;
Object.defineProperty(J7, "__esModule", {
  value: !0
});
var mT = J7.default = void 0, pae = fae(bt()), hae = f;
mT = J7.default = (0, pae.default)(/* @__PURE__ */ (0, hae.jsx)("path", {
  d: "M3 2h18v2H3zm0 18h18v2H3zm0-6h18v2H3zm0-6h18v2H3z"
}), "DensitySmall");
var Q7 = {}, gae = ht;
Object.defineProperty(Q7, "__esModule", {
  value: !0
});
var bT = Q7.default = void 0, mae = gae(bt()), bae = f;
bT = Q7.default = (0, mae.default)(/* @__PURE__ */ (0, bae.jsx)("path", {
  d: "M20 9H4v2h16zM4 15h16v-2H4z"
}), "DragHandle");
var eh = {}, Cae = ht;
Object.defineProperty(eh, "__esModule", {
  value: !0
});
var CT = eh.default = void 0, xae = Cae(bt()), fC = f;
CT = eh.default = (0, xae.default)([/* @__PURE__ */ (0, fC.jsx)("path", {
  d: "M8 8H6v7c0 1.1.9 2 2 2h9v-2H8z"
}, "0"), /* @__PURE__ */ (0, fC.jsx)("path", {
  d: "M20 3h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 8h-8V7h8zM4 12H2v7c0 1.1.9 2 2 2h9v-2H4z"
}, "1")], "DynamicFeed");
var th = {}, yae = ht;
Object.defineProperty(th, "__esModule", {
  value: !0
});
var xT = th.default = void 0, vae = yae(bt()), wae = f;
xT = th.default = (0, vae.default)(/* @__PURE__ */ (0, wae.jsx)("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), "Edit");
var nh = {}, Sae = ht;
Object.defineProperty(nh, "__esModule", {
  value: !0
});
var yT = nh.default = void 0, Mae = Sae(bt()), Tae = f;
yT = nh.default = (0, Mae.default)(/* @__PURE__ */ (0, Tae.jsx)("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");
var oh = {}, kae = ht;
Object.defineProperty(oh, "__esModule", {
  value: !0
});
var vT = oh.default = void 0, Eae = kae(bt()), Rae = f;
vT = oh.default = (0, Eae.default)(/* @__PURE__ */ (0, Rae.jsx)("path", {
  d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61"
}), "FilterAlt");
var rh = {}, Oae = ht;
Object.defineProperty(rh, "__esModule", {
  value: !0
});
var wT = rh.default = void 0, _ae = Oae(bt()), Pae = f;
wT = rh.default = (0, _ae.default)(/* @__PURE__ */ (0, Pae.jsx)("path", {
  d: "M10 18h4v-2h-4zM3 6v2h18V6zm3 7h12v-2H6z"
}), "FilterList");
var ih = {}, Lae = ht;
Object.defineProperty(ih, "__esModule", {
  value: !0
});
var ST = ih.default = void 0, Iae = Lae(bt()), jae = f;
ST = ih.default = (0, Iae.default)(/* @__PURE__ */ (0, jae.jsx)("path", {
  d: "M10.83 8H21V6H8.83zm5 5H18v-2h-4.17zM14 16.83V18h-4v-2h3.17l-3-3H6v-2h2.17l-3-3H3V6h.17L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41z"
}), "FilterListOff");
var sh = {}, Vae = ht;
Object.defineProperty(sh, "__esModule", {
  value: !0
});
var MT = sh.default = void 0, Dae = Vae(bt()), Aae = f;
MT = sh.default = (0, Dae.default)(/* @__PURE__ */ (0, Aae.jsx)("path", {
  d: "M18.41 16.59 13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage");
var ah = {}, Hae = ht;
Object.defineProperty(ah, "__esModule", {
  value: !0
});
var TT = ah.default = void 0, Fae = Hae(bt()), Nae = f;
TT = ah.default = (0, Fae.default)(/* @__PURE__ */ (0, Nae.jsx)("path", {
  d: "M7 14H5v5h5v-2H7zm-2-4h2V7h3V5H5zm12 7h-3v2h5v-5h-2zM14 5v2h3v3h2V5z"
}), "Fullscreen");
var lh = {}, $ae = ht;
Object.defineProperty(lh, "__esModule", {
  value: !0
});
var kT = lh.default = void 0, Bae = $ae(bt()), zae = f;
kT = lh.default = (0, Bae.default)(/* @__PURE__ */ (0, zae.jsx)("path", {
  d: "M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"
}), "FullscreenExit");
var ch = {}, Zae = ht;
Object.defineProperty(ch, "__esModule", {
  value: !0
});
var ET = ch.default = void 0, Wae = Zae(bt()), pC = f;
ET = ch.default = (0, Wae.default)([/* @__PURE__ */ (0, pC.jsx)("path", {
  d: "M18 6.41 16.59 5 12 9.58 7.41 5 6 6.41l6 6z"
}, "0"), /* @__PURE__ */ (0, pC.jsx)("path", {
  d: "m18 13-1.41-1.41L12 16.17l-4.59-4.58L6 13l6 6z"
}, "1")], "KeyboardDoubleArrowDown");
var dh = {}, Uae = ht;
Object.defineProperty(dh, "__esModule", {
  value: !0
});
var RT = dh.default = void 0, Gae = Uae(bt()), qae = f;
RT = dh.default = (0, Gae.default)(/* @__PURE__ */ (0, qae.jsx)("path", {
  d: "M5.59 7.41 10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage");
var uh = {}, Kae = ht;
Object.defineProperty(uh, "__esModule", {
  value: !0
});
var OT = uh.default = void 0, Yae = Kae(bt()), Xae = f;
OT = uh.default = (0, Yae.default)(/* @__PURE__ */ (0, Xae.jsx)("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "MoreHoriz");
var fh = {}, Jae = ht;
Object.defineProperty(fh, "__esModule", {
  value: !0
});
var _T = fh.default = void 0, Qae = Jae(bt()), ele = f;
_T = fh.default = (0, Qae.default)(/* @__PURE__ */ (0, ele.jsx)("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "MoreVert");
var ph = {}, tle = ht;
Object.defineProperty(ph, "__esModule", {
  value: !0
});
var PT = ph.default = void 0, nle = tle(bt()), ole = f;
PT = ph.default = (0, nle.default)(/* @__PURE__ */ (0, ole.jsx)("path", {
  fillRule: "evenodd",
  d: "M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3"
}), "PushPin");
var hh = {}, rle = ht;
Object.defineProperty(hh, "__esModule", {
  value: !0
});
var LT = hh.default = void 0, ile = rle(bt()), sle = f;
LT = hh.default = (0, ile.default)(/* @__PURE__ */ (0, sle.jsx)("path", {
  d: "M12 5V2L8 6l4 4V7c3.31 0 6 2.69 6 6 0 2.97-2.17 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93 0-4.42-3.58-8-8-8m-6 8c0-1.65.67-3.15 1.76-4.24L6.34 7.34C4.9 8.79 4 10.79 4 13c0 4.08 3.05 7.44 7 7.93v-2.02c-2.83-.48-5-2.94-5-5.91"
}), "RestartAlt");
var gh = {}, ale = ht;
Object.defineProperty(gh, "__esModule", {
  value: !0
});
var IT = gh.default = void 0, lle = ale(bt()), cle = f;
IT = gh.default = (0, lle.default)(/* @__PURE__ */ (0, cle.jsx)("path", {
  d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m3-10H5V5h10z"
}), "Save");
var mh = {}, dle = ht;
Object.defineProperty(mh, "__esModule", {
  value: !0
});
var jT = mh.default = void 0, ule = dle(bt()), fle = f;
jT = mh.default = (0, ule.default)(/* @__PURE__ */ (0, fle.jsx)("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), "Search");
var bh = {}, ple = ht;
Object.defineProperty(bh, "__esModule", {
  value: !0
});
var VT = bh.default = void 0, hle = ple(bt()), hC = f;
VT = bh.default = (0, hle.default)([/* @__PURE__ */ (0, hC.jsx)("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3 6.08 3 3.28 5.64 3.03 9h2.02C5.3 6.75 7.18 5 9.5 5 11.99 5 14 7.01 14 9.5S11.99 14 9.5 14c-.17 0-.33-.03-.5-.05v2.02c.17.02.33.03.5.03 1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19z"
}, "0"), /* @__PURE__ */ (0, hC.jsx)("path", {
  d: "M6.47 10.82 4 13.29l-2.47-2.47-.71.71L3.29 14 .82 16.47l.71.71L4 14.71l2.47 2.47.71-.71L4.71 14l2.47-2.47z"
}, "1")], "SearchOff");
var Ch = {}, gle = ht;
Object.defineProperty(Ch, "__esModule", {
  value: !0
});
var DT = Ch.default = void 0, mle = gle(bt()), ble = f;
DT = Ch.default = (0, mle.default)(/* @__PURE__ */ (0, ble.jsx)("path", {
  d: "M3 18h6v-2H3zM3 6v2h18V6zm0 7h12v-2H3z"
}), "Sort");
var xh = {}, Cle = ht;
Object.defineProperty(xh, "__esModule", {
  value: !0
});
var AT = xh.default = void 0, xle = Cle(bt()), yle = f;
AT = xh.default = (0, xle.default)(/* @__PURE__ */ (0, yle.jsx)("path", {
  d: "m18 12 4-4-4-4v3H3v2h15zM6 12l-4 4 4 4v-3h15v-2H6z"
}), "SyncAlt");
var yh = {}, vle = ht;
Object.defineProperty(yh, "__esModule", {
  value: !0
});
var HT = yh.default = void 0, wle = vle(bt()), Sle = f;
HT = yh.default = (0, wle.default)(/* @__PURE__ */ (0, Sle.jsx)("path", {
  d: "M14.67 5v14H9.33V5zm1 14H21V5h-5.33zm-7.34 0V5H3v14z"
}), "ViewColumn");
var vh = {}, Mle = ht;
Object.defineProperty(vh, "__esModule", {
  value: !0
});
var FT = vh.default = void 0, Tle = Mle(bt()), kle = f;
FT = vh.default = (0, Tle.default)(/* @__PURE__ */ (0, kle.jsx)("path", {
  d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z"
}), "VisibilityOff");
function el(e, t, n) {
  let o = n.initialDeps ?? [], r;
  return () => {
    var i, s, a, c;
    let d;
    n.key && ((i = n.debug) != null && i.call(n)) && (d = Date.now());
    const u = e();
    if (!(u.length !== o.length || u.some((g, m) => o[m] !== g)))
      return r;
    o = u;
    let h;
    if (n.key && ((s = n.debug) != null && s.call(n)) && (h = Date.now()), r = t(...u), n.key && ((a = n.debug) != null && a.call(n))) {
      const g = Math.round((Date.now() - d) * 100) / 100, m = Math.round((Date.now() - h) * 100) / 100, b = m / 16, C = (x, v) => {
        for (x = String(x); x.length < v; )
          x = " " + x;
        return x;
      };
      console.info(
        `%c⏱ ${C(m, 5)} /${C(g, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * b, 120)
        )}deg 100% 31%);`,
        n == null ? void 0 : n.key
      );
    }
    return (c = n == null ? void 0 : n.onChange) == null || c.call(n, r), r;
  };
}
function P6(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const Ele = (e, t) => Math.abs(e - t) < 1, Rle = (e, t, n) => {
  let o;
  return function(...r) {
    e.clearTimeout(o), o = e.setTimeout(() => t.apply(this, r), n);
  };
}, Ole = (e) => e, NT = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), n = Math.min(e.endIndex + e.overscan, e.count - 1), o = [];
  for (let r = t; r <= n; r++)
    o.push(r);
  return o;
}, _le = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const o = e.targetWindow;
  if (!o)
    return;
  const r = (s) => {
    const { width: a, height: c } = s;
    t({ width: Math.round(a), height: Math.round(c) });
  };
  if (r(n.getBoundingClientRect()), !o.ResizeObserver)
    return () => {
    };
  const i = new o.ResizeObserver((s) => {
    const a = s[0];
    if (a != null && a.borderBoxSize) {
      const c = a.borderBoxSize[0];
      if (c) {
        r({ width: c.inlineSize, height: c.blockSize });
        return;
      }
    }
    r(n.getBoundingClientRect());
  });
  return i.observe(n, { box: "border-box" }), () => {
    i.unobserve(n);
  };
}, gC = {
  passive: !0
}, Ple = typeof window > "u" ? !0 : "onscrollend" in window, Lle = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const o = e.targetWindow;
  if (!o)
    return;
  let r = 0;
  const i = Ple ? () => {
  } : Rle(
    o,
    () => {
      t(r, !1);
    },
    e.options.isScrollingResetDelay
  ), s = (d) => () => {
    const { horizontal: u, isRtl: p } = e.options;
    r = u ? n.scrollLeft * (p && -1 || 1) : n.scrollTop, i(), t(r, d);
  }, a = s(!0), c = s(!1);
  return c(), n.addEventListener("scroll", a, gC), n.addEventListener("scrollend", c, gC), () => {
    n.removeEventListener("scroll", a), n.removeEventListener("scrollend", c);
  };
}, Ile = (e, t, n) => {
  if (t != null && t.borderBoxSize) {
    const o = t.borderBoxSize[0];
    if (o)
      return Math.round(
        o[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[n.options.horizontal ? "width" : "height"]
  );
}, jle = (e, {
  adjustments: t = 0,
  behavior: n
}, o) => {
  var r, i;
  const s = e + t;
  (i = (r = o.scrollElement) == null ? void 0 : r.scrollTo) == null || i.call(r, {
    [o.options.horizontal ? "left" : "top"]: s,
    behavior: n
  });
};
class Vle {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const o = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((r) => {
        r.forEach((i) => {
          this._measureElement(i.target, i);
        });
      }));
      return {
        disconnect: () => {
          var r;
          return (r = o()) == null ? void 0 : r.disconnect();
        },
        observe: (r) => {
          var i;
          return (i = o()) == null ? void 0 : i.observe(r, { box: "border-box" });
        },
        unobserve: (r) => {
          var i;
          return (i = o()) == null ? void 0 : i.unobserve(r);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      Object.entries(n).forEach(([o, r]) => {
        typeof r > "u" && delete n[o];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: Ole,
        rangeExtractor: NT,
        onChange: () => {
        },
        measureElement: Ile,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        ...n
      };
    }, this.notify = (n) => {
      var o, r;
      (r = (o = this.options).onChange) == null || r.call(o, this, n);
    }, this.maybeNotify = el(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (n) => {
        this.notify(n);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.observer.disconnect(), this.elementsCache.clear();
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const o = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== o) {
        if (this.cleanup(), !o) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = o, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (r) => {
            this.scrollRect = r, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (r, i) => {
            this.scrollAdjustments = 0, this.scrollDirection = i ? this.getScrollOffset() < r ? "forward" : "backward" : null, this.scrollOffset = r, this.isScrolling = i, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (n, o) => {
      const r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
      for (let s = o - 1; s >= 0; s--) {
        const a = n[s];
        if (r.has(a.lane))
          continue;
        const c = i.get(
          a.lane
        );
        if (c == null || a.end > c.end ? i.set(a.lane, a) : a.end < c.end && r.set(a.lane, !0), r.size === this.options.lanes)
          break;
      }
      return i.size === this.options.lanes ? Array.from(i.values()).sort((s, a) => s.end === a.end ? s.index - a.index : s.end - a.end)[0] : void 0;
    }, this.getMeasurementOptions = el(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (n, o, r, i, s) => (this.pendingMeasuredCacheIndexes = [], {
        count: n,
        paddingStart: o,
        scrollMargin: r,
        getItemKey: i,
        enabled: s
      }),
      {
        key: !1
      }
    ), this.getMeasurements = el(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: n, paddingStart: o, scrollMargin: r, getItemKey: i, enabled: s }, a) => {
        if (!s)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((u) => {
          this.itemSizeCache.set(u.key, u.size);
        }));
        const c = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const d = this.measurementsCache.slice(0, c);
        for (let u = c; u < n; u++) {
          const p = i(u), h = this.options.lanes === 1 ? d[u - 1] : this.getFurthestMeasurement(d, u), g = h ? h.end + this.options.gap : o + r, m = a.get(p), b = typeof m == "number" ? m : this.options.estimateSize(u), C = g + b, x = h ? h.lane : u % this.options.lanes;
          d[u] = {
            index: u,
            start: g,
            size: b,
            end: C,
            key: p,
            lane: x
          };
        }
        return this.measurementsCache = d, d;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = el(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (n, o, r) => this.range = n.length > 0 && o > 0 ? Dle({
        measurements: n,
        outerSize: o,
        scrollOffset: r
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = el(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (n, o, r, i) => o === null ? [] : n({
        startIndex: o.startIndex,
        endIndex: o.endIndex,
        overscan: r,
        count: i
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const o = this.options.indexAttribute, r = n.getAttribute(o);
      return r ? parseInt(r, 10) : (console.warn(
        `Missing attribute name '${o}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (n, o) => {
      const r = this.indexFromElement(n), i = this.measurementsCache[r];
      if (!i)
        return;
      const s = i.key, a = this.elementsCache.get(s);
      a !== n && (a && this.observer.unobserve(a), this.observer.observe(n), this.elementsCache.set(s, n)), n.isConnected && this.resizeItem(r, this.options.measureElement(n, o, this));
    }, this.resizeItem = (n, o) => {
      const r = this.measurementsCache[n];
      if (!r)
        return;
      const i = this.itemSizeCache.get(r.key) ?? r.size, s = o - i;
      s !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(r, s, this) : r.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", s), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += s,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(r.index), this.itemSizeCache = new Map(this.itemSizeCache.set(r.key, o)), this.notify(!1));
    }, this.measureElement = (n) => {
      if (!n) {
        this.elementsCache.forEach((o, r) => {
          o.isConnected || (this.observer.unobserve(o), this.elementsCache.delete(r));
        });
        return;
      }
      this._measureElement(n, void 0);
    }, this.getVirtualItems = el(
      () => [this.getIndexes(), this.getMeasurements()],
      (n, o) => {
        const r = [];
        for (let i = 0, s = n.length; i < s; i++) {
          const a = n[i], c = o[a];
          r.push(c);
        }
        return r;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const o = this.getMeasurements();
      if (o.length !== 0)
        return P6(
          o[$T(
            0,
            o.length - 1,
            (r) => P6(o[r]).start,
            n
          )]
        );
    }, this.getOffsetForAlignment = (n, o) => {
      const r = this.getSize(), i = this.getScrollOffset();
      o === "auto" && (n <= i ? o = "start" : n >= i + r ? o = "end" : o = "start"), o === "start" ? n = n : o === "end" ? n = n - r : o === "center" && (n = n - r / 2);
      const s = this.options.horizontal ? "scrollWidth" : "scrollHeight", c = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[s] : this.scrollElement[s] : 0) - r;
      return Math.max(Math.min(c, n), 0);
    }, this.getOffsetForIndex = (n, o = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const r = this.measurementsCache[n];
      if (!r)
        return;
      const i = this.getSize(), s = this.getScrollOffset();
      if (o === "auto")
        if (r.end >= s + i - this.options.scrollPaddingEnd)
          o = "end";
        else if (r.start <= s + this.options.scrollPaddingStart)
          o = "start";
        else
          return [s, o];
      const a = o === "end" ? r.end + this.options.scrollPaddingEnd : r.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(a, o), o];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (n, { align: o = "start", behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(n, o), {
        adjustments: void 0,
        behavior: r
      });
    }, this.scrollToIndex = (n, { align: o = "auto", behavior: r } = {}) => {
      n = Math.max(0, Math.min(n, this.options.count - 1)), this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const i = this.getOffsetForIndex(n, o);
      if (!i) return;
      const [s, a] = i;
      this._scrollToOffset(s, { adjustments: void 0, behavior: r }), r !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(n)
        )) {
          const [d] = P6(
            this.getOffsetForIndex(n, a)
          );
          Ele(d, this.getScrollOffset()) || this.scrollToIndex(n, { align: a, behavior: r });
        } else
          this.scrollToIndex(n, { align: a, behavior: r });
      }));
    }, this.scrollBy = (n, { behavior: o } = {}) => {
      this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + n, {
        adjustments: void 0,
        behavior: o
      });
    }, this.getTotalSize = () => {
      var n;
      const o = this.getMeasurements();
      let r;
      return o.length === 0 ? r = this.options.paddingStart : r = this.options.lanes === 1 ? ((n = o[o.length - 1]) == null ? void 0 : n.end) ?? 0 : Math.max(
        ...o.slice(-this.options.lanes).map((i) => i.end)
      ), r - this.options.scrollMargin + this.options.paddingEnd;
    }, this._scrollToOffset = (n, {
      adjustments: o,
      behavior: r
    }) => {
      this.options.scrollToFn(n, { behavior: r, adjustments: o }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(t);
  }
}
const $T = (e, t, n, o) => {
  for (; e <= t; ) {
    const r = (e + t) / 2 | 0, i = n(r);
    if (i < o)
      e = r + 1;
    else if (i > o)
      t = r - 1;
    else
      return r;
  }
  return e > 0 ? e - 1 : 0;
};
function Dle({
  measurements: e,
  outerSize: t,
  scrollOffset: n
}) {
  const o = e.length - 1, i = $T(0, o, (a) => e[a].start, n);
  let s = i;
  for (; s < o && e[s].end < n + t; )
    s++;
  return { startIndex: i, endIndex: s };
}
const Ale = typeof document < "u" ? y.useLayoutEffect : y.useEffect;
function Hle(e) {
  const t = y.useReducer(() => ({}), {})[1], n = {
    ...e,
    onChange: (r, i) => {
      var s;
      i ? k_(t) : t(), (s = e.onChange) == null || s.call(e, r, i);
    }
  }, [o] = y.useState(
    () => new Vle(n)
  );
  return o.setOptions(n), y.useEffect(() => o._didMount(), []), Ale(() => o._willUpdate()), o;
}
function BT(e) {
  return Hle({
    observeElementRect: _le,
    observeElementOffset: Lle,
    scrollToFn: jle,
    ...e
  });
}
let mC = 36, zT = "";
for (; mC--; )
  zT += mC.toString(36);
function bC(e = 11) {
  let t = "", n = e;
  for (; n--; )
    t += zT[Math.random() * 36 | 0];
  return t;
}
const Fle = (e) => e.replace(/[|\\{}()[\]^$+*?.-]/g, (t) => `\\${t}`), Nle = (e) => e.replace(/\s{2,}/g, " ").split(" ").join("|"), $le = ({
  terms: e,
  matchExactly: t = !1
}) => {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  const n = Fle(e.trim());
  return `(${t ? n : Nle(n)})`;
}, Ble = ({
  terms: e,
  matchExactly: t = !1
}) => {
  try {
    const n = /^([/~@;%#'])(.*?)\1([gimsuy]*)$/.exec(e);
    return n ? new RegExp(n[2], n[3]) : new RegExp($le({ terms: e, matchExactly: t }), "ig");
  } catch {
    throw new TypeError("Expected terms to be either a string or a RegExp!");
  }
}, zle = (e) => (t) => t !== null && typeof t == "object" && e in t, F1 = zle("match"), N1 = (e) => typeof e < "u";
function Zle({
  curr: e,
  next: t,
  prev: n,
  clipBy: o = 3
}) {
  const r = e.text.split(" "), i = r.length;
  if (e.match || o >= i)
    return e.text;
  const s = "...";
  return N1(t) && N1(n) && F1(n) && F1(t) ? i > o * 2 ? [
    ...r.slice(0, o),
    s,
    ...r.slice(-o)
  ].join(" ") : e.text : N1(t) && F1(t) ? [s, ...r.slice(-o)].join(" ") : N1(n) && F1(n) ? [...r.slice(0, o), s].join(" ") : e.text;
}
var Wle = Object.defineProperty, Ule = Object.defineProperties, Gle = Object.getOwnPropertyDescriptors, CC = Object.getOwnPropertySymbols, qle = Object.prototype.hasOwnProperty, Kle = Object.prototype.propertyIsEnumerable, xC = (e, t, n) => t in e ? Wle(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, $1 = (e, t) => {
  for (var n in t || (t = {}))
    qle.call(t, n) && xC(e, n, t[n]);
  if (CC)
    for (var n of CC(t))
      Kle.call(t, n) && xC(e, n, t[n]);
  return e;
}, Yle = (e, t) => Ule(e, Gle(t));
const Xle = (e) => e.length > 0, L6 = ({
  text: e,
  query: t,
  clipBy: n,
  matchExactly: o = !1
}) => {
  const r = typeof t == "string" ? t.trim() : t;
  if (r === "")
    return [
      {
        key: bC(),
        text: e,
        match: !1
      }
    ];
  const i = Ble({ terms: t, matchExactly: o });
  return e.split(i).filter(Xle).map((s) => ({
    // Compose the object for a match
    key: bC(),
    text: s,
    match: o ? s.toLowerCase() === r.toLowerCase() : i.test(s)
  })).map((s, a, c) => $1($1({}, s), typeof n == "number" && {
    // We only overwrite the text if there is a clip
    text: Zle(Yle($1($1({
      curr: s
    }, a < c.length - 1 && { next: c[a + 1] }), a > 0 && { prev: c[a - 1] }), {
      // If this wasn't the first chunk, set the previous chunk
      clipBy: n
    }))
  }));
};
function Jle(e) {
  return typeof e == "string";
}
function Qle(e, t, n) {
  return e === void 0 || Jle(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...n
    }
  };
}
function e2e(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((o) => o.match(/^on[A-Z]/) && typeof e[o] == "function" && !t.includes(o)).forEach((o) => {
    n[o] = e[o];
  }), n;
}
function Da(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function t2e(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function n2e(...e) {
  return y.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      t2e(n, t);
    });
  }, e);
}
function yC(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function o2e(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: o,
    externalForwardedProps: r,
    className: i
  } = e;
  if (!t) {
    const g = xe(n == null ? void 0 : n.className, i, r == null ? void 0 : r.className, o == null ? void 0 : o.className), m = {
      ...n == null ? void 0 : n.style,
      ...r == null ? void 0 : r.style,
      ...o == null ? void 0 : o.style
    }, b = {
      ...n,
      ...r,
      ...o
    };
    return g.length > 0 && (b.className = g), Object.keys(m).length > 0 && (b.style = m), {
      props: b,
      internalRef: void 0
    };
  }
  const s = e2e({
    ...r,
    ...o
  }), a = yC(o), c = yC(r), d = t(s), u = xe(d == null ? void 0 : d.className, n == null ? void 0 : n.className, i, r == null ? void 0 : r.className, o == null ? void 0 : o.className), p = {
    ...d == null ? void 0 : d.style,
    ...n == null ? void 0 : n.style,
    ...r == null ? void 0 : r.style,
    ...o == null ? void 0 : o.style
  }, h = {
    ...d,
    ...n,
    ...c,
    ...a
  };
  return u.length > 0 && (h.className = u), Object.keys(p).length > 0 && (h.style = p), {
    props: h,
    internalRef: d.ref
  };
}
function r2e(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function yn(e) {
  var p;
  const {
    elementType: t,
    externalSlotProps: n,
    ownerState: o,
    skipResolvingSlotProps: r = !1,
    ...i
  } = e, s = r ? {} : r2e(n, o), {
    props: a,
    internalRef: c
  } = o2e({
    ...i,
    externalSlotProps: s
  }), d = n2e(c, s == null ? void 0 : s.ref, (p = e.additionalProps) == null ? void 0 : p.ref);
  return Qle(t, {
    ...a,
    ref: d
  }, o);
}
const Yr = (e, t) => e.length !== t.length ? !1 : t.every((n) => e.includes(n)), wh = ({
  openTo: e,
  defaultOpenTo: t,
  views: n,
  defaultViews: o
}) => {
  const r = n ?? o;
  let i;
  if (e != null)
    i = e;
  else if (r.includes(t))
    i = t;
  else if (r.length > 0)
    i = r[0];
  else
    throw new Error("MUI: The `views` prop must contain at least one view");
  return {
    views: r,
    openTo: i
  };
}, lu = (e, t, n) => {
  let o = t;
  return o = e.setHours(o, e.getHours(n)), o = e.setMinutes(o, e.getMinutes(n)), o = e.setSeconds(o, e.getSeconds(n)), o;
}, bc = ({
  date: e,
  disableFuture: t,
  disablePast: n,
  maxDate: o,
  minDate: r,
  isDateDisabled: i,
  utils: s,
  timezone: a
}) => {
  const c = lu(s, s.dateWithTimezone(void 0, a), e);
  n && s.isBefore(r, c) && (r = c), t && s.isAfter(o, c) && (o = c);
  let d = e, u = e;
  for (s.isBefore(e, r) && (d = r, u = null), s.isAfter(e, o) && (u && (u = o), d = null); d || u; ) {
    if (d && s.isAfter(d, o) && (d = null), u && s.isBefore(u, r) && (u = null), d) {
      if (!i(d))
        return d;
      d = s.addDays(d, 1);
    }
    if (u) {
      if (!i(u))
        return u;
      u = s.addDays(u, -1);
    }
  }
  return null;
}, i2e = (e, t) => t == null || !e.isValid(t) ? null : t, go = (e, t, n) => t == null || !e.isValid(t) ? n : t, s2e = (e, t, n) => !e.isValid(t) && t != null && !e.isValid(n) && n != null ? !0 : e.isEqual(t, n), Sh = (e, t) => {
  const o = [e.startOfYear(t)];
  for (; o.length < 12; ) {
    const r = o[o.length - 1];
    o.push(e.addMonths(r, 1));
  }
  return o;
}, Mh = (e, t, n) => n === "date" ? e.startOfDay(e.dateWithTimezone(void 0, t)) : e.dateWithTimezone(void 0, t), _r = (e, t) => {
  const n = e.setHours(e.date(), t === "am" ? 2 : 14);
  return e.format(n, "meridiem");
}, a2e = ["year", "month", "day"], wl = (e) => a2e.includes(e), Yc = (e, {
  format: t,
  views: n
}, o) => {
  if (t != null)
    return t;
  const r = e.formats;
  return Yr(n, ["year"]) ? r.year : Yr(n, ["month"]) ? r.month : Yr(n, ["day"]) ? r.dayOfMonth : Yr(n, ["month", "year"]) ? `${r.month} ${r.year}` : Yr(n, ["day", "month"]) ? `${r.month} ${r.dayOfMonth}` : o ? /en/.test(e.getCurrentLocaleCode()) ? r.normalDateWithWeekday : r.normalDate : r.keyboardDate;
}, l2e = (e, t) => {
  const n = e.startOfWeek(t);
  return [0, 1, 2, 3, 4, 5, 6].map((o) => e.addDays(n, o));
}, ZT = ["hours", "minutes", "seconds"], Bl = (e) => ZT.includes(e), Bi = (e) => ZT.includes(e) || e === "meridiem", c2e = (e, t) => e ? t.getHours(e) >= 12 ? "pm" : "am" : null, Xc = (e, t, n) => n && (e >= 12 ? "pm" : "am") !== t ? t === "am" ? e - 12 : e + 12 : e, d2e = (e, t, n, o) => {
  const r = Xc(o.getHours(e), t, n);
  return o.setHours(e, r);
}, vC = (e, t) => t.getHours(e) * 3600 + t.getMinutes(e) * 60 + t.getSeconds(e), B0 = (e, t) => (n, o) => e ? t.isAfter(n, o) : vC(n, t) > vC(o, t), cu = (e, {
  format: t,
  views: n,
  ampm: o
}) => {
  if (t != null)
    return t;
  const r = e.formats;
  return Yr(n, ["hours"]) ? o ? `${r.hours12h} ${r.meridiem}` : r.hours24h : Yr(n, ["minutes"]) ? r.minutes : Yr(n, ["seconds"]) ? r.seconds : Yr(n, ["minutes", "seconds"]) ? `${r.minutes}:${r.seconds}` : Yr(n, ["hours", "minutes", "seconds"]) ? o ? `${r.hours12h}:${r.minutes}:${r.seconds} ${r.meridiem}` : `${r.hours24h}:${r.minutes}:${r.seconds}` : o ? `${r.hours12h}:${r.minutes} ${r.meridiem}` : `${r.hours24h}:${r.minutes}`;
}, Er = {
  year: 1,
  month: 2,
  day: 3,
  hours: 4,
  minutes: 5,
  seconds: 6,
  milliseconds: 7
}, u2e = (e) => Math.max(...e.map((t) => {
  var n;
  return (n = Er[t.type]) != null ? n : 1;
})), A2 = (e, t, n) => {
  if (t === Er.year)
    return e.startOfYear(n);
  if (t === Er.month)
    return e.startOfMonth(n);
  if (t === Er.day)
    return e.startOfDay(n);
  let o = n;
  return t < Er.minutes && (o = e.setMinutes(o, 0)), t < Er.seconds && (o = e.setSeconds(o, 0)), t < Er.milliseconds && (o = e.setMilliseconds(o, 0)), o;
}, f2e = ({
  props: e,
  utils: t,
  granularity: n,
  timezone: o,
  getTodayDate: r
}) => {
  var i;
  let s = r ? r() : A2(t, n, Mh(t, o));
  e.minDate != null && t.isAfterDay(e.minDate, s) && (s = A2(t, n, e.minDate)), e.maxDate != null && t.isBeforeDay(e.maxDate, s) && (s = A2(t, n, e.maxDate));
  const a = B0((i = e.disableIgnoringDatePartForTimeValidation) != null ? i : !1, t);
  return e.minTime != null && a(e.minTime, s) && (s = A2(t, n, e.disableIgnoringDatePartForTimeValidation ? e.minTime : lu(t, s, e.minTime))), e.maxTime != null && a(s, e.maxTime) && (s = A2(t, n, e.disableIgnoringDatePartForTimeValidation ? e.maxTime : lu(t, s, e.maxTime))), s;
}, Th = (e, t) => {
  const n = e.formatTokenMap[t];
  if (n == null)
    throw new Error([`MUI: The token "${t}" is not supported by the Date and Time Pickers.`, "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."].join(`
`));
  return typeof n == "string" ? {
    type: n,
    contentType: n === "meridiem" ? "letter" : "digit",
    maxLength: void 0
  } : {
    type: n.sectionType,
    contentType: n.contentType,
    maxLength: n.maxLength
  };
}, p2e = (e) => {
  switch (e) {
    case "ArrowUp":
      return 1;
    case "ArrowDown":
      return -1;
    case "PageUp":
      return 5;
    case "PageDown":
      return -5;
    default:
      return 0;
  }
}, K3 = (e, t, n) => {
  const o = [], r = e.dateWithTimezone(void 0, t), i = e.startOfWeek(r), s = e.endOfWeek(r);
  let a = i;
  for (; e.isBefore(a, s); )
    o.push(a), a = e.addDays(a, 1);
  return o.map((c) => e.formatByString(c, n));
}, WT = (e, t, n, o) => {
  switch (n) {
    case "month":
      return Sh(e, e.dateWithTimezone(void 0, t)).map((r) => e.formatByString(r, o));
    case "weekDay":
      return K3(e, t, o);
    case "meridiem": {
      const r = e.dateWithTimezone(void 0, t);
      return [e.startOfDay(r), e.endOfDay(r)].map((i) => e.formatByString(i, o));
    }
    default:
      return [];
  }
}, UT = (e, t, n) => {
  let o = t;
  for (o = Number(o).toString(); o.length < n; )
    o = `0${o}`;
  return o;
}, GT = (e, t, n, o, r) => {
  if (process.env.NODE_ENV !== "production" && r.type !== "day" && r.contentType === "digit-with-letter")
    throw new Error([`MUI: The token "${r.format}" is a digit format with letter in it.'
             This type of format is only supported for 'day' sections`].join(`
`));
  if (r.type === "day" && r.contentType === "digit-with-letter") {
    const s = e.setDate(o.longestMonth, n);
    return e.formatByString(s, r.format);
  }
  const i = n.toString();
  return r.hasLeadingZerosInInput ? UT(e, i, r.maxLength) : i;
}, h2e = (e, t, n, o, r, i, s) => {
  const a = p2e(o), c = o === "Home", d = o === "End", u = n.value === "" || c || d, p = () => {
    const g = r[n.type]({
      currentDate: i,
      format: n.format,
      contentType: n.contentType
    }), m = (v) => GT(e, t, v, g, n), b = n.type === "minutes" && s != null && s.minutesStep ? s.minutesStep : 1;
    let x = parseInt(n.value, 10) + a * b;
    if (u) {
      if (n.type === "year" && !d && !c)
        return e.formatByString(e.dateWithTimezone(void 0, t), n.format);
      a > 0 || c ? x = g.minimum : x = g.maximum;
    }
    return x % b !== 0 && ((a < 0 || c) && (x += b - (b + x) % b), (a > 0 || d) && (x -= x % b)), x > g.maximum ? m(g.minimum + (x - g.maximum - 1) % (g.maximum - g.minimum + 1)) : x < g.minimum ? m(g.maximum - (g.minimum - x - 1) % (g.maximum - g.minimum + 1)) : m(x);
  }, h = () => {
    const g = WT(e, t, n.type, n.format);
    if (g.length === 0)
      return n.value;
    if (u)
      return a > 0 || c ? g[0] : g[g.length - 1];
    const b = (g.indexOf(n.value) + g.length + a) % g.length;
    return g[b];
  };
  return n.contentType === "digit" || n.contentType === "digit-with-letter" ? p() : h();
}, kh = (e, t) => {
  let n = e.value || e.placeholder;
  const o = t === "non-input" ? e.hasLeadingZerosInFormat : e.hasLeadingZerosInInput;
  return t === "non-input" && e.hasLeadingZerosInInput && !e.hasLeadingZerosInFormat && (n = Number(n).toString()), ["input-rtl", "input-ltr"].includes(t) && e.contentType === "digit" && !o && n.length === 1 && (n = `${n}‎`), t === "input-rtl" && (n = `⁨${n}⁩`), n;
}, fl = (e) => e.replace(/[\u2066\u2067\u2068\u2069]/g, ""), qT = (e, t) => {
  let n = 0, o = t ? 1 : 0;
  const r = [];
  for (let i = 0; i < e.length; i += 1) {
    const s = e[i], a = kh(s, t ? "input-rtl" : "input-ltr"), c = `${s.startSeparator}${a}${s.endSeparator}`, d = fl(c).length, u = c.length, p = fl(a), h = o + a.indexOf(p[0]) + s.startSeparator.length, g = h + p.length;
    r.push(T({}, s, {
      start: n,
      end: n + d,
      startInInput: h,
      endInInput: g
    })), n += d, o += u;
  }
  return r;
}, g2e = (e, t, n, o, r) => {
  switch (o.type) {
    case "year":
      return n.fieldYearPlaceholder({
        digitAmount: e.formatByString(e.dateWithTimezone(void 0, t), r).length,
        format: r
      });
    case "month":
      return n.fieldMonthPlaceholder({
        contentType: o.contentType,
        format: r
      });
    case "day":
      return n.fieldDayPlaceholder({
        format: r
      });
    case "weekDay":
      return n.fieldWeekDayPlaceholder({
        contentType: o.contentType,
        format: r
      });
    case "hours":
      return n.fieldHoursPlaceholder({
        format: r
      });
    case "minutes":
      return n.fieldMinutesPlaceholder({
        format: r
      });
    case "seconds":
      return n.fieldSecondsPlaceholder({
        format: r
      });
    case "meridiem":
      return n.fieldMeridiemPlaceholder({
        format: r
      });
    default:
      return r;
  }
}, wC = (e, t, n, o) => {
  if (process.env.NODE_ENV !== "production" && Th(e, n).type === "weekDay")
    throw new Error("changeSectionValueFormat doesn't support week day formats");
  return e.formatByString(e.parse(t, n), o);
}, KT = (e, t, n) => e.formatByString(e.dateWithTimezone(void 0, t), n).length === 4, YT = (e, t, n, o, r) => {
  if (n !== "digit")
    return !1;
  const i = e.dateWithTimezone(void 0, t);
  switch (o) {
    case "year":
      return KT(e, t, r) ? e.formatByString(e.setYear(i, 1), r) === "0001" : e.formatByString(e.setYear(i, 2001), r) === "01";
    case "month":
      return e.formatByString(e.startOfYear(i), r).length > 1;
    case "day":
      return e.formatByString(e.startOfMonth(i), r).length > 1;
    case "weekDay":
      return e.formatByString(e.startOfWeek(i), r).length > 1;
    case "hours":
      return e.formatByString(e.setHours(i, 1), r).length > 1;
    case "minutes":
      return e.formatByString(e.setMinutes(i, 1), r).length > 1;
    case "seconds":
      return e.formatByString(e.setSeconds(i, 1), r).length > 1;
    default:
      throw new Error("Invalid section type");
  }
}, m2e = (e, t) => {
  const n = [], {
    start: o,
    end: r
  } = e.escapedCharacters, i = new RegExp(`(\\${o}[^\\${r}]*\\${r})+`, "g");
  let s = null;
  for (; s = i.exec(t); )
    n.push({
      start: s.index,
      end: i.lastIndex - 1
    });
  return n;
}, SC = (e, t, n, o, r, i, s, a) => {
  let c = "";
  const d = [], u = e.date(), p = (S) => {
    if (S === "")
      return null;
    const M = Th(e, S), w = YT(e, t, M.contentType, M.type, S), k = s ? w : M.contentType === "digit", E = r != null && e.isValid(r);
    let R = E ? e.formatByString(r, S) : "", O = null;
    if (k)
      if (w)
        O = R === "" ? e.formatByString(u, S).length : R.length;
      else {
        if (M.maxLength == null)
          throw new Error(`MUI: The token ${S} should have a 'maxDigitNumber' property on it's adapter`);
        O = M.maxLength, E && (R = UT(e, R, O));
      }
    return d.push(T({}, M, {
      format: S,
      maxLength: O,
      value: R,
      placeholder: g2e(e, t, n, M, S),
      hasLeadingZeros: w,
      hasLeadingZerosInFormat: w,
      hasLeadingZerosInInput: k,
      startSeparator: d.length === 0 ? c : "",
      endSeparator: "",
      modified: !1
    })), null;
  };
  let h = 10, g = o, m = e.expandFormat(o);
  for (; m !== g; )
    if (g = m, m = e.expandFormat(g), h -= 1, h < 0)
      throw new Error("MUI: The format expansion seems to be  enter in an infinite loop. Please open an issue with the format passed to the picker component");
  const b = m, C = m2e(e, b), x = new RegExp(`^(${Object.keys(e.formatTokenMap).sort((S, M) => M.length - S.length).join("|")})`, "g");
  let v = "";
  for (let S = 0; S < b.length; S += 1) {
    const M = C.find((O) => O.start <= S && O.end >= S), w = b[S], k = M != null, E = `${v}${b.slice(S)}`, R = x.test(E);
    !k && w.match(/([A-Za-z]+)/) && R ? (v = E.slice(0, x.lastIndex), S += x.lastIndex - 1) : k && (M == null ? void 0 : M.start) === S || (M == null ? void 0 : M.end) === S || (p(v), v = "", d.length === 0 ? c += w : d[d.length - 1].endSeparator += w);
  }
  return p(v), d.map((S) => {
    const M = (w) => {
      let k = w;
      return a && k !== null && k.includes(" ") && (k = `⁩${k}⁦`), i === "spacious" && ["/", ".", "-"].includes(k) && (k = ` ${k} `), k;
    };
    return S.startSeparator = M(S.startSeparator), S.endSeparator = M(S.endSeparator), S;
  });
}, b2e = (e, t) => {
  const n = t.some((a) => a.type === "day"), o = [], r = [];
  for (let a = 0; a < t.length; a += 1) {
    const c = t[a];
    n && c.type === "weekDay" || (o.push(c.format), r.push(kh(c, "non-input")));
  }
  const i = o.join(" "), s = r.join(" ");
  return e.parse(s, i);
}, C2e = (e, t) => {
  const o = e.map((r) => {
    const i = kh(r, t ? "input-rtl" : "input-ltr");
    return `${r.startSeparator}${i}${r.endSeparator}`;
  }).join("");
  return t ? `⁦${o}⁩` : o;
}, x2e = (e, t) => {
  const n = e.dateWithTimezone(void 0, t), o = e.endOfYear(n), r = e.endOfDay(n), {
    maxDaysInMonth: i,
    longestMonth: s
  } = Sh(e, n).reduce((a, c) => {
    const d = e.getDaysInMonth(c);
    return d > a.maxDaysInMonth ? {
      maxDaysInMonth: d,
      longestMonth: c
    } : a;
  }, {
    maxDaysInMonth: 0,
    longestMonth: null
  });
  return {
    year: ({
      format: a
    }) => ({
      minimum: 0,
      maximum: KT(e, t, a) ? 9999 : 99
    }),
    month: () => ({
      minimum: 1,
      // Assumption: All years have the same amount of months
      maximum: e.getMonth(o) + 1
    }),
    day: ({
      currentDate: a
    }) => ({
      minimum: 1,
      maximum: a != null && e.isValid(a) ? e.getDaysInMonth(a) : i,
      longestMonth: s
    }),
    weekDay: ({
      format: a,
      contentType: c
    }) => {
      if (c === "digit") {
        const d = K3(e, t, a).map(Number);
        return {
          minimum: Math.min(...d),
          maximum: Math.max(...d)
        };
      }
      return {
        minimum: 1,
        maximum: 7
      };
    },
    hours: ({
      format: a
    }) => {
      const c = e.getHours(r);
      return e.formatByString(e.endOfDay(n), a) !== c.toString() ? {
        minimum: 1,
        maximum: Number(e.formatByString(e.startOfDay(n), a))
      } : {
        minimum: 0,
        maximum: c
      };
    },
    minutes: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of minutes
      maximum: e.getMinutes(r)
    }),
    seconds: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of seconds
      maximum: e.getSeconds(r)
    }),
    meridiem: () => ({
      minimum: 0,
      maximum: 0
    })
  };
};
let MC = !1;
const TC = (e, t) => {
  if (process.env.NODE_ENV !== "production" && !MC) {
    const n = [];
    ["date", "date-time"].includes(t) && n.push("weekDay", "day", "month", "year"), ["time", "date-time"].includes(t) && n.push("hours", "minutes", "seconds", "meridiem");
    const o = e.find((r) => !n.includes(r.type));
    o && (console.warn(`MUI: The field component you are using is not compatible with the "${o.type} date section.`, `The supported date sections are ["${n.join('", "')}"]\`.`), MC = !0);
  }
}, y2e = (e, t, n, o, r) => {
  switch (n.type) {
    case "year":
      return e.setYear(r, e.getYear(o));
    case "month":
      return e.setMonth(r, e.getMonth(o));
    case "weekDay": {
      const i = K3(e, t, n.format), s = e.formatByString(o, n.format), a = i.indexOf(s), d = i.indexOf(n.value) - a;
      return e.addDays(o, d);
    }
    case "day":
      return e.setDate(r, e.getDate(o));
    case "meridiem": {
      const i = e.getHours(o) < 12, s = e.getHours(r);
      return i && s >= 12 ? e.addHours(r, -12) : !i && s < 12 ? e.addHours(r, 12) : r;
    }
    case "hours":
      return e.setHours(r, e.getHours(o));
    case "minutes":
      return e.setMinutes(r, e.getMinutes(o));
    case "seconds":
      return e.setSeconds(r, e.getSeconds(o));
    default:
      return r;
  }
}, kC = {
  year: 1,
  month: 2,
  day: 3,
  weekDay: 4,
  hours: 5,
  minutes: 6,
  seconds: 7,
  meridiem: 8
}, EC = (e, t, n, o, r, i) => (
  // cloning sections before sort to avoid mutating it
  [...o].sort((s, a) => kC[s.type] - kC[a.type]).reduce((s, a) => !i || a.modified ? y2e(e, t, a, n, s) : s, r)
), v2e = () => navigator.userAgent.toLowerCase().indexOf("android") > -1, w2e = (e, t) => {
  const n = {};
  if (!t)
    return e.forEach((c, d) => {
      const u = d === 0 ? null : d - 1, p = d === e.length - 1 ? null : d + 1;
      n[d] = {
        leftIndex: u,
        rightIndex: p
      };
    }), {
      neighbors: n,
      startIndex: 0,
      endIndex: e.length - 1
    };
  const o = {}, r = {};
  let i = 0, s = 0, a = e.length - 1;
  for (; a >= 0; ) {
    s = e.findIndex(
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      (c, d) => {
        var u;
        return d >= i && ((u = c.endSeparator) == null ? void 0 : u.includes(" ")) && // Special case where the spaces were not there in the initial input
        c.endSeparator !== " / ";
      }
    ), s === -1 && (s = e.length - 1);
    for (let c = s; c >= i; c -= 1)
      r[c] = a, o[a] = c, a -= 1;
    i = s + 1;
  }
  return e.forEach((c, d) => {
    const u = r[d], p = u === 0 ? null : o[u - 1], h = u === e.length - 1 ? null : o[u + 1];
    n[d] = {
      leftIndex: p,
      rightIndex: h
    };
  }), {
    neighbors: n,
    startIndex: o[0],
    endIndex: o[e.length - 1]
  };
}, S2e = ["value", "referenceDate"], Nn = {
  emptyValue: null,
  getTodayValue: Mh,
  getInitialReferenceValue: (e) => {
    let {
      value: t,
      referenceDate: n
    } = e, o = le(e, S2e);
    return t != null && o.utils.isValid(t) ? t : n ?? f2e(o);
  },
  cleanValue: i2e,
  areValuesEqual: s2e,
  isSameError: (e, t) => e === t,
  hasError: (e) => e != null,
  defaultErrorState: null,
  getTimezone: (e, t) => t == null || !e.isValid(t) ? null : e.getTimezone(t),
  setTimezone: (e, t, n) => n == null ? null : e.setTimezone(n, t)
}, Eh = {
  updateReferenceValue: (e, t, n) => t == null || !e.isValid(t) ? n : t,
  getSectionsFromValue: (e, t, n, o, r) => !e.isValid(t) && !!n ? n : qT(r(t), o),
  getValueStrFromSections: C2e,
  getActiveDateManager: (e, t) => ({
    date: t.value,
    referenceDate: t.referenceValue,
    getSections: (n) => n,
    getNewValuesFromNewActiveDate: (n) => ({
      value: n,
      referenceValue: n == null || !e.isValid(n) ? t.referenceValue : n
    })
  }),
  parseValueStr: (e, t, n) => n(e.trim(), t)
}, M2e = ["localeText"], du = /* @__PURE__ */ y.createContext(null);
process.env.NODE_ENV !== "production" && (du.displayName = "MuiPickersAdapterContext");
const Rh = function(t) {
  var n;
  const {
    localeText: o
  } = t, r = le(t, M2e), {
    utils: i,
    localeText: s
  } = (n = y.useContext(du)) != null ? n : {
    utils: void 0,
    localeText: void 0
  }, a = jt({
    // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
    // We will then merge this theme value with our value manually
    props: r,
    name: "MuiLocalizationProvider"
  }), {
    children: c,
    dateAdapter: d,
    dateFormats: u,
    dateLibInstance: p,
    adapterLocale: h,
    localeText: g
  } = a, m = y.useMemo(() => T({}, g, s, o), [g, s, o]), b = y.useMemo(() => {
    if (!d)
      return i || null;
    const v = new d({
      locale: h,
      formats: u,
      instance: p
    });
    if (!v.isMUIAdapter)
      throw new Error(["MUI: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`", "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`", "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"].join(`
`));
    return v;
  }, [d, h, u, p, i]), C = y.useMemo(() => b ? {
    minDate: b.date("1900-01-01T00:00:00.000"),
    maxDate: b.date("2099-12-31T00:00:00.000")
  } : null, [b]), x = y.useMemo(() => ({
    utils: b,
    defaultDates: C,
    localeText: m
  }), [C, b, m]);
  return /* @__PURE__ */ f.jsx(du.Provider, {
    value: x,
    children: c
  });
};
process.env.NODE_ENV !== "production" && (Rh.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Locale for the date library you are using
   */
  adapterLocale: l.any,
  children: l.node,
  /**
   * Date library adapter class function.
   * @see See the localization provider {@link https://mui.com/x/react-date-pickers/getting-started/#setup-your-date-library-adapter date adapter setup section} for more details.
   */
  dateAdapter: l.func,
  /**
   * Formats that are used for any child pickers
   */
  dateFormats: l.shape({
    dayOfMonth: l.string,
    fullDate: l.string,
    fullDateTime: l.string,
    fullDateTime12h: l.string,
    fullDateTime24h: l.string,
    fullDateWithWeekday: l.string,
    fullTime: l.string,
    fullTime12h: l.string,
    fullTime24h: l.string,
    hours12h: l.string,
    hours24h: l.string,
    keyboardDate: l.string,
    keyboardDateTime: l.string,
    keyboardDateTime12h: l.string,
    keyboardDateTime24h: l.string,
    meridiem: l.string,
    minutes: l.string,
    month: l.string,
    monthAndDate: l.string,
    monthAndYear: l.string,
    monthShort: l.string,
    normalDate: l.string,
    normalDateWithWeekday: l.string,
    seconds: l.string,
    shortDate: l.string,
    weekday: l.string,
    weekdayShort: l.string,
    year: l.string
  }),
  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: l.any,
  /**
   * Locale for components texts
   */
  localeText: l.object
});
const T2e = (e) => ({
  components: {
    MuiLocalizationProvider: {
      defaultProps: {
        localeText: T({}, e)
      }
    }
  }
}), XT = {
  // Calendar navigation
  previousMonth: "Previous month",
  nextMonth: "Next month",
  // View navigation
  openPreviousView: "open previous view",
  openNextView: "open next view",
  calendarViewSwitchingButtonAriaLabel: (e) => e === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
  // DateRange placeholders
  start: "Start",
  end: "End",
  // Action bar
  cancelButtonLabel: "Cancel",
  clearButtonLabel: "Clear",
  okButtonLabel: "OK",
  todayButtonLabel: "Today",
  // Toolbar titles
  datePickerToolbarTitle: "Select date",
  dateTimePickerToolbarTitle: "Select date & time",
  timePickerToolbarTitle: "Select time",
  dateRangePickerToolbarTitle: "Select date range",
  // Clock labels
  clockLabelText: (e, t, n) => `Select ${e}. ${t === null ? "No time selected" : `Selected time is ${n.format(t, "fullTime")}`}`,
  hoursClockNumberText: (e) => `${e} hours`,
  minutesClockNumberText: (e) => `${e} minutes`,
  secondsClockNumberText: (e) => `${e} seconds`,
  // Digital clock labels
  selectViewText: (e) => `Select ${e}`,
  // Calendar labels
  calendarWeekNumberHeaderLabel: "Week number",
  calendarWeekNumberHeaderText: "#",
  calendarWeekNumberAriaLabelText: (e) => `Week ${e}`,
  calendarWeekNumberText: (e) => `${e}`,
  // Open picker labels
  openDatePickerDialogue: (e, t) => e !== null && t.isValid(e) ? `Choose date, selected date is ${t.format(e, "fullDate")}` : "Choose date",
  openTimePickerDialogue: (e, t) => e !== null && t.isValid(e) ? `Choose time, selected time is ${t.format(e, "fullTime")}` : "Choose time",
  fieldClearLabel: "Clear value",
  // Table labels
  timeTableLabel: "pick time",
  dateTableLabel: "pick date",
  // Field section placeholders
  fieldYearPlaceholder: (e) => "Y".repeat(e.digitAmount),
  fieldMonthPlaceholder: (e) => e.contentType === "letter" ? "MMMM" : "MM",
  fieldDayPlaceholder: () => "DD",
  fieldWeekDayPlaceholder: (e) => e.contentType === "letter" ? "EEEE" : "EE",
  fieldHoursPlaceholder: () => "hh",
  fieldMinutesPlaceholder: () => "mm",
  fieldSecondsPlaceholder: () => "ss",
  fieldMeridiemPlaceholder: () => "aa"
}, k2e = XT;
T2e(XT);
const Aa = () => {
  const e = y.useContext(du);
  if (e === null)
    throw new Error(["MUI: Can not find the date and time pickers localization context.", "It looks like you forgot to wrap your component in LocalizationProvider.", "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"].join(`
`));
  if (e.utils === null)
    throw new Error(["MUI: Can not find the date and time pickers adapter from its localization context.", "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."].join(`
`));
  const t = y.useMemo(() => T({}, k2e, e.localeText), [e.localeText]);
  return y.useMemo(() => T({}, e, {
    localeText: t
  }), [e, t]);
}, kt = () => Aa().utils, Ha = () => Aa().defaultDates, $n = () => Aa().localeText, Fa = (e) => {
  const t = kt(), n = y.useRef();
  return n.current === void 0 && (n.current = t.dateWithTimezone(void 0, e)), n.current;
};
function JT(e) {
  return _e("MuiPickersToolbar", e);
}
Re("MuiPickersToolbar", ["root", "content"]);
const E2e = (e) => {
  const {
    classes: t,
    isLandscape: n
  } = e;
  return Oe({
    root: ["root"],
    content: ["content"],
    penIconButton: ["penIconButton", n && "penIconButtonLandscape"]
  }, JT, t);
}, R2e = B("div", {
  name: "MuiPickersToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => T({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  padding: e.spacing(2, 3)
}, t.isLandscape && {
  height: "auto",
  maxWidth: 160,
  padding: 16,
  justifyContent: "flex-start",
  flexWrap: "wrap"
})), O2e = B("div", {
  name: "MuiPickersToolbar",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})(({
  ownerState: e
}) => {
  var t;
  return {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    justifyContent: e.isLandscape ? "flex-start" : "space-between",
    flexDirection: e.isLandscape ? (t = e.landscapeDirection) != null ? t : "column" : "row",
    flex: 1,
    alignItems: e.isLandscape ? "flex-start" : "center"
  };
}), Oh = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = jt({
    props: t,
    name: "MuiPickersToolbar"
  }), {
    children: r,
    className: i,
    toolbarTitle: s,
    hidden: a,
    titleId: c
  } = o, d = o, u = E2e(d);
  return a ? null : /* @__PURE__ */ f.jsxs(R2e, {
    ref: n,
    className: xe(u.root, i),
    ownerState: d,
    children: [/* @__PURE__ */ f.jsx(oe, {
      color: "text.secondary",
      variant: "overline",
      id: c,
      children: s
    }), /* @__PURE__ */ f.jsx(O2e, {
      className: u.content,
      ownerState: d,
      children: r
    })]
  });
});
function _2e(e) {
  return _e("MuiDatePickerToolbar", e);
}
Re("MuiDatePickerToolbar", ["root", "title"]);
const P2e = ["value", "isLandscape", "onChange", "toolbarFormat", "toolbarPlaceholder", "views", "className"], L2e = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"],
    title: ["title"]
  }, _2e, t);
}, I2e = B(Oh, {
  name: "MuiDatePickerToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), j2e = B(oe, {
  name: "MuiDatePickerToolbar",
  slot: "Title",
  overridesResolver: (e, t) => t.title
})(({
  ownerState: e
}) => T({}, e.isLandscape && {
  margin: "auto 16px auto auto"
})), QT = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = jt({
    props: t,
    name: "MuiDatePickerToolbar"
  }), {
    value: r,
    isLandscape: i,
    toolbarFormat: s,
    toolbarPlaceholder: a = "––",
    views: c,
    className: d
  } = o, u = le(o, P2e), p = kt(), h = $n(), g = L2e(o), m = y.useMemo(() => {
    if (!r)
      return a;
    const C = Yc(p, {
      format: s,
      views: c
    }, !0);
    return p.formatByString(r, C);
  }, [r, s, a, p, c]), b = o;
  return /* @__PURE__ */ f.jsx(I2e, T({
    ref: n,
    toolbarTitle: h.datePickerToolbarTitle,
    isLandscape: i,
    className: xe(g.root, d)
  }, u, {
    children: /* @__PURE__ */ f.jsx(j2e, {
      variant: "h4",
      align: i ? "left" : "center",
      ownerState: b,
      className: g.title,
      children: m
    })
  }));
});
process.env.NODE_ENV !== "production" && (QT.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * className applied to the root component.
   */
  className: l.string,
  disabled: l.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: l.bool,
  isLandscape: l.bool.isRequired,
  onChange: l.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: l.func.isRequired,
  readOnly: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  titleId: l.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: l.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: l.node,
  value: l.any,
  /**
   * Currently visible picker view.
   */
  view: l.oneOf(["day", "month", "year"]).isRequired,
  views: l.arrayOf(l.oneOf(["day", "month", "year"]).isRequired).isRequired
});
const z0 = (e) => {
  if (e !== void 0)
    return Object.keys(e).reduce((t, n) => T({}, t, {
      [`${n.slice(0, 1).toLowerCase()}${n.slice(1)}`]: e[n]
    }), {});
};
function ek(e, t) {
  var n, o, r, i;
  const s = kt(), a = Ha(), c = jt({
    props: e,
    name: t
  }), d = y.useMemo(() => {
    var p;
    return ((p = c.localeText) == null ? void 0 : p.toolbarTitle) == null ? c.localeText : T({}, c.localeText, {
      datePickerToolbarTitle: c.localeText.toolbarTitle
    });
  }, [c.localeText]), u = (n = c.slots) != null ? n : z0(c.components);
  return T({}, c, {
    localeText: d
  }, wh({
    views: c.views,
    openTo: c.openTo,
    defaultViews: ["year", "day"],
    defaultOpenTo: "day"
  }), {
    disableFuture: (o = c.disableFuture) != null ? o : !1,
    disablePast: (r = c.disablePast) != null ? r : !1,
    minDate: go(s, c.minDate, a.minDate),
    maxDate: go(s, c.maxDate, a.maxDate),
    slots: T({
      toolbar: QT
    }, u),
    slotProps: (i = c.slotProps) != null ? i : c.componentsProps
  });
}
const V2e = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), D2e = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft"), A2e = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight"), tk = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar"), H2e = ft(/* @__PURE__ */ f.jsxs(y.Fragment, {
  children: [/* @__PURE__ */ f.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ f.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Clock"), F2e = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange"), N2e = ft(/* @__PURE__ */ f.jsxs(y.Fragment, {
  children: [/* @__PURE__ */ f.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ f.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Time"), $2e = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
function B2e(e) {
  return _e("MuiPickersArrowSwitcher", e);
}
Re("MuiPickersArrowSwitcher", ["root", "spacer", "button"]);
const z2e = ["children", "className", "slots", "slotProps", "isNextDisabled", "isNextHidden", "onGoToNext", "nextLabel", "isPreviousDisabled", "isPreviousHidden", "onGoToPrevious", "previousLabel"], Z2e = ["ownerState"], W2e = ["ownerState"], U2e = B("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex"
}), G2e = B("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Spacer",
  overridesResolver: (e, t) => t.spacer
})(({
  theme: e
}) => ({
  width: e.spacing(3)
})), RC = B(Bt, {
  name: "MuiPickersArrowSwitcher",
  slot: "Button",
  overridesResolver: (e, t) => t.button
})(({
  ownerState: e
}) => T({}, e.hidden && {
  visibility: "hidden"
})), q2e = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"],
    spacer: ["spacer"],
    button: ["button"]
  }, B2e, t);
}, nk = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i, s;
  const c = ge().direction === "rtl", d = jt({
    props: t,
    name: "MuiPickersArrowSwitcher"
  }), {
    children: u,
    className: p,
    slots: h,
    slotProps: g,
    isNextDisabled: m,
    isNextHidden: b,
    onGoToNext: C,
    nextLabel: x,
    isPreviousDisabled: v,
    isPreviousHidden: S,
    onGoToPrevious: M,
    previousLabel: w
  } = d, k = le(d, z2e), E = d, R = q2e(E), O = {
    isDisabled: m,
    isHidden: b,
    goTo: C,
    label: x
  }, P = {
    isDisabled: v,
    isHidden: S,
    goTo: M,
    label: w
  }, _ = (o = h == null ? void 0 : h.previousIconButton) != null ? o : RC, L = yn({
    elementType: _,
    externalSlotProps: g == null ? void 0 : g.previousIconButton,
    additionalProps: {
      size: "medium",
      title: P.label,
      "aria-label": P.label,
      disabled: P.isDisabled,
      edge: "end",
      onClick: P.goTo
    },
    ownerState: T({}, E, {
      hidden: P.isHidden
    }),
    className: R.button
  }), V = (r = h == null ? void 0 : h.nextIconButton) != null ? r : RC, j = yn({
    elementType: V,
    externalSlotProps: g == null ? void 0 : g.nextIconButton,
    additionalProps: {
      size: "medium",
      title: O.label,
      "aria-label": O.label,
      disabled: O.isDisabled,
      edge: "start",
      onClick: O.goTo
    },
    ownerState: T({}, E, {
      hidden: O.isHidden
    }),
    className: R.button
  }), I = (i = h == null ? void 0 : h.leftArrowIcon) != null ? i : D2e, F = yn({
    elementType: I,
    externalSlotProps: g == null ? void 0 : g.leftArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: void 0
  }), $ = le(F, Z2e), A = (s = h == null ? void 0 : h.rightArrowIcon) != null ? s : A2e, H = yn({
    elementType: A,
    externalSlotProps: g == null ? void 0 : g.rightArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: void 0
  }), N = le(H, W2e);
  return /* @__PURE__ */ f.jsxs(U2e, T({
    ref: n,
    className: xe(R.root, p),
    ownerState: E
  }, k, {
    children: [/* @__PURE__ */ f.jsx(_, T({}, L, {
      children: c ? /* @__PURE__ */ f.jsx(A, T({}, N)) : /* @__PURE__ */ f.jsx(I, T({}, $))
    })), u ? /* @__PURE__ */ f.jsx(oe, {
      variant: "subtitle1",
      component: "span",
      children: u
    }) : /* @__PURE__ */ f.jsx(G2e, {
      className: R.spacer,
      ownerState: E
    }), /* @__PURE__ */ f.jsx(V, T({}, j, {
      children: c ? /* @__PURE__ */ f.jsx(I, T({}, $)) : /* @__PURE__ */ f.jsx(A, T({}, N))
    }))]
  }));
}), Jc = 36, Y3 = 2, X3 = 320, K2e = 280, J3 = 334, ok = 232, K2 = 48, Y2e = B(d2)({
  [`& .${rc.container}`]: {
    outline: 0
  },
  [`& .${rc.paper}`]: {
    outline: 0,
    minWidth: X3
  }
}), X2e = B(Y4)({
  "&:first-of-type": {
    padding: 0
  }
});
function J2e(e) {
  var t, n;
  const {
    children: o,
    onDismiss: r,
    open: i,
    slots: s,
    slotProps: a
  } = e, c = (t = s == null ? void 0 : s.dialog) != null ? t : Y2e, d = (n = s == null ? void 0 : s.mobileTransition) != null ? n : Ia;
  return /* @__PURE__ */ f.jsx(c, T({
    open: i,
    onClose: r
  }, a == null ? void 0 : a.dialog, {
    TransitionComponent: d,
    TransitionProps: a == null ? void 0 : a.mobileTransition,
    PaperComponent: s == null ? void 0 : s.mobilePaper,
    PaperProps: a == null ? void 0 : a.mobilePaper,
    children: /* @__PURE__ */ f.jsx(X2e, {
      children: o
    })
  }));
}
function Q2e(e) {
  return _e("MuiPickersPopper", e);
}
Re("MuiPickersPopper", ["root", "paper"]);
function sl(e, t) {
  return Array.isArray(t) ? t.every((n) => e.indexOf(n) !== -1) : e.indexOf(t) !== -1;
}
const ece = (e, t) => (n) => {
  (n.key === "Enter" || n.key === " ") && (e(n), n.preventDefault(), n.stopPropagation());
}, uu = (e = document) => {
  const t = e.activeElement;
  return t ? t.shadowRoot ? uu(t.shadowRoot) : t : null;
}, _h = "@media (pointer: fine)", tce = "@media (prefers-reduced-motion: reduce)", Sl = typeof navigator < "u" && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i), OC = Sl && Sl[1] ? parseInt(Sl[1], 10) : null, _C = Sl && Sl[2] ? parseInt(Sl[2], 10) : null, nce = OC && OC < 10 || _C && _C < 13 || !1, rk = () => y0(tce, {
  defaultMatches: !1
}) || nce, oce = ["PaperComponent", "popperPlacement", "ownerState", "children", "paperSlotProps", "paperClasses", "onPaperClick", "onPaperTouchStart"], rce = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"],
    paper: ["paper"]
  }, Q2e, t);
}, ice = B(s2, {
  name: "MuiPickersPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  zIndex: e.zIndex.modal
})), sce = B(Tr, {
  name: "MuiPickersPopper",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(({
  ownerState: e
}) => T({
  outline: 0,
  transformOrigin: "top center"
}, e.placement.includes("top") && {
  transformOrigin: "bottom center"
}));
function ace(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function lce(e, t) {
  const n = y.useRef(!1), o = y.useRef(!1), r = y.useRef(null), i = y.useRef(!1);
  y.useEffect(() => {
    if (!e)
      return;
    function c() {
      i.current = !0;
    }
    return document.addEventListener("mousedown", c, !0), document.addEventListener("touchstart", c, !0), () => {
      document.removeEventListener("mousedown", c, !0), document.removeEventListener("touchstart", c, !0), i.current = !1;
    };
  }, [e]);
  const s = Ke((c) => {
    if (!i.current)
      return;
    const d = o.current;
    o.current = !1;
    const u = gn(r.current);
    if (!r.current || // is a TouchEvent?
    "clientX" in c && ace(c, u))
      return;
    if (n.current) {
      n.current = !1;
      return;
    }
    let p;
    c.composedPath ? p = c.composedPath().indexOf(r.current) > -1 : p = !u.documentElement.contains(c.target) || r.current.contains(c.target), !p && !d && t(c);
  }), a = () => {
    o.current = !0;
  };
  return y.useEffect(() => {
    if (e) {
      const c = gn(r.current), d = () => {
        n.current = !0;
      };
      return c.addEventListener("touchstart", s), c.addEventListener("touchmove", d), () => {
        c.removeEventListener("touchstart", s), c.removeEventListener("touchmove", d);
      };
    }
  }, [e, s]), y.useEffect(() => {
    if (e) {
      const c = gn(r.current);
      return c.addEventListener("click", s), () => {
        c.removeEventListener("click", s), o.current = !1;
      };
    }
  }, [e, s]), [r, a, a];
}
const cce = /* @__PURE__ */ y.forwardRef((e, t) => {
  const {
    PaperComponent: n,
    popperPlacement: o,
    ownerState: r,
    children: i,
    paperSlotProps: s,
    paperClasses: a,
    onPaperClick: c,
    onPaperTouchStart: d
    // picks up the style props provided by `Transition`
    // https://mui.com/material-ui/transitions/#child-requirement
  } = e, u = le(e, oce), p = T({}, r, {
    placement: o
  }), h = yn({
    elementType: n,
    externalSlotProps: s,
    additionalProps: {
      tabIndex: -1,
      elevation: 8,
      ref: t
    },
    className: a,
    ownerState: p
  });
  return /* @__PURE__ */ f.jsx(n, T({}, u, h, {
    onClick: (g) => {
      var m;
      c(g), (m = h.onClick) == null || m.call(h, g);
    },
    onTouchStart: (g) => {
      var m;
      d(g), (m = h.onTouchStart) == null || m.call(h, g);
    },
    ownerState: p,
    children: i
  }));
});
function dce(e) {
  var t, n, o, r;
  const i = jt({
    props: e,
    name: "MuiPickersPopper"
  }), {
    anchorEl: s,
    children: a,
    containerRef: c = null,
    shouldRestoreFocus: d,
    onBlur: u,
    onDismiss: p,
    open: h,
    role: g,
    placement: m,
    slots: b,
    slotProps: C,
    reduceAnimations: x
  } = i;
  y.useEffect(() => {
    function H(N) {
      h && (N.key === "Escape" || N.key === "Esc") && p();
    }
    return document.addEventListener("keydown", H), () => {
      document.removeEventListener("keydown", H);
    };
  }, [p, h]);
  const v = y.useRef(null);
  y.useEffect(() => {
    g === "tooltip" || d && !d() || (h ? v.current = uu(document) : v.current && v.current instanceof HTMLElement && setTimeout(() => {
      v.current instanceof HTMLElement && v.current.focus();
    }));
  }, [h, g, d]);
  const [S, M, w] = lce(h, u ?? p), k = y.useRef(null), E = Tt(k, c), R = Tt(E, S), O = i, P = rce(O), _ = rk(), L = x ?? _, V = (H) => {
    H.key === "Escape" && (H.stopPropagation(), p());
  }, j = ((t = b == null ? void 0 : b.desktopTransition) != null ? t : L) ? Ia : gs, I = (n = b == null ? void 0 : b.desktopTrapFocus) != null ? n : Ac, F = (o = b == null ? void 0 : b.desktopPaper) != null ? o : sce, $ = (r = b == null ? void 0 : b.popper) != null ? r : ice, A = yn({
    elementType: $,
    externalSlotProps: C == null ? void 0 : C.popper,
    additionalProps: {
      transition: !0,
      role: g,
      open: h,
      anchorEl: s,
      placement: m,
      onKeyDown: V
    },
    className: P.root,
    ownerState: i
  });
  return /* @__PURE__ */ f.jsx($, T({}, A, {
    children: ({
      TransitionProps: H,
      placement: N
    }) => /* @__PURE__ */ f.jsx(I, T({
      open: h,
      disableAutoFocus: !0,
      disableRestoreFocus: !0,
      disableEnforceFocus: g === "tooltip",
      isEnabled: () => !0
    }, C == null ? void 0 : C.desktopTrapFocus, {
      children: /* @__PURE__ */ f.jsx(j, T({}, H, C == null ? void 0 : C.desktopTransition, {
        children: /* @__PURE__ */ f.jsx(cce, {
          PaperComponent: F,
          ownerState: O,
          popperPlacement: N,
          ref: R,
          onPaperClick: M,
          onPaperTouchStart: w,
          paperClasses: P.paper,
          paperSlotProps: C == null ? void 0 : C.desktopPaper,
          children: a
        })
      }))
    }))
  }));
}
function uce(e) {
  return _e("MuiPickersToolbarText", e);
}
const PC = Re("MuiPickersToolbarText", ["root", "selected"]), fce = ["className", "selected", "value"], pce = (e) => {
  const {
    classes: t,
    selected: n
  } = e;
  return Oe({
    root: ["root", n && "selected"]
  }, uce, t);
}, hce = B(oe, {
  name: "MuiPickersToolbarText",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`&.${PC.selected}`]: t.selected
  }]
})(({
  theme: e
}) => ({
  transition: e.transitions.create("color"),
  color: (e.vars || e).palette.text.secondary,
  [`&.${PC.selected}`]: {
    color: (e.vars || e).palette.text.primary
  }
})), Ph = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = jt({
    props: t,
    name: "MuiPickersToolbarText"
  }), {
    className: r,
    value: i
  } = o, s = le(o, fce), a = pce(o);
  return /* @__PURE__ */ f.jsx(hce, T({
    ref: n,
    className: xe(r, a.root),
    component: "span"
  }, s, {
    children: i
  }));
}), gce = ["align", "className", "selected", "typographyClassName", "value", "variant", "width"], mce = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"]
  }, JT, t);
}, bce = B(at, {
  name: "MuiPickersToolbarButton",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: 0,
  minWidth: 16,
  textTransform: "none"
}), Zo = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = jt({
    props: t,
    name: "MuiPickersToolbarButton"
  }), {
    align: r,
    className: i,
    selected: s,
    typographyClassName: a,
    value: c,
    variant: d,
    width: u
  } = o, p = le(o, gce), h = mce(o);
  return /* @__PURE__ */ f.jsx(bce, T({
    variant: "text",
    ref: n,
    className: xe(i, h.root)
  }, u ? {
    sx: {
      width: u
    }
  } : {}, p, {
    children: /* @__PURE__ */ f.jsx(Ph, {
      align: r,
      className: a,
      variant: d,
      value: c,
      selected: s
    })
  }));
}), Lh = ({
  timezone: e,
  value: t,
  defaultValue: n,
  onChange: o,
  valueManager: r
}) => {
  var i, s;
  const a = kt(), c = y.useRef(n), d = (i = t ?? c.current) != null ? i : r.emptyValue, u = y.useMemo(() => r.getTimezone(a, d), [a, r, d]), p = Ke((b) => u == null ? b : r.setTimezone(a, u, b)), h = (s = e ?? u) != null ? s : "default", g = y.useMemo(() => r.setTimezone(a, h, d), [r, a, h, d]), m = Ke((b, ...C) => {
    const x = p(b);
    o == null || o(x, ...C);
  });
  return {
    value: g,
    handleValueChange: m,
    timezone: h
  };
}, b2 = ({
  name: e,
  timezone: t,
  value: n,
  defaultValue: o,
  onChange: r,
  valueManager: i
}) => {
  const [s, a] = Fn({
    name: e,
    state: "value",
    controlled: n,
    default: o ?? i.emptyValue
  }), c = Ke((d, ...u) => {
    a(d), r == null || r(d, ...u);
  });
  return Lh({
    timezone: t,
    value: s,
    defaultValue: void 0,
    onChange: c,
    valueManager: i
  });
};
function ik(e, t, n, o) {
  const {
    value: r,
    onError: i
  } = e, s = Aa(), a = y.useRef(o), c = t({
    adapter: s,
    value: r,
    props: e
  });
  return y.useEffect(() => {
    i && !n(c, a.current) && i(c, r), a.current = c;
  }, [n, i, a, c, r]), c;
}
const Cce = (e) => {
  const t = kt(), n = $n(), o = Aa(), i = ge().direction === "rtl", {
    valueManager: s,
    fieldValueManager: a,
    valueType: c,
    validator: d,
    internalProps: u,
    internalProps: {
      value: p,
      defaultValue: h,
      referenceDate: g,
      onChange: m,
      format: b,
      formatDensity: C = "dense",
      selectedSections: x,
      onSelectedSectionsChange: v,
      shouldRespectLeadingZeros: S = !1,
      timezone: M
    }
  } = e, {
    timezone: w,
    value: k,
    handleValueChange: E
  } = Lh({
    timezone: M,
    value: p,
    defaultValue: h,
    onChange: m,
    valueManager: s
  }), R = y.useMemo(() => x2e(t, w), [t, w]), O = y.useCallback((Z, q = null) => a.getSectionsFromValue(t, Z, q, i, (G) => SC(t, w, n, b, G, C, S, i)), [a, b, n, i, S, t, C, w]), P = y.useMemo(() => a.getValueStrFromSections(O(s.emptyValue), i), [a, O, s.emptyValue, i]), [_, L] = y.useState(() => {
    const Z = O(k);
    TC(Z, c);
    const q = {
      sections: Z,
      value: k,
      referenceValue: s.emptyValue,
      tempValueStrAndroid: null
    }, G = u2e(Z), K = s.getInitialReferenceValue({
      referenceDate: g,
      value: k,
      utils: t,
      props: u,
      granularity: G,
      timezone: w
    });
    return T({}, q, {
      referenceValue: K
    });
  }), [V, j] = Fn({
    controlled: x,
    default: null,
    name: "useField",
    state: "selectedSectionIndexes"
  }), I = (Z) => {
    j(Z), v == null || v(Z), L((q) => T({}, q, {
      selectedSectionQuery: null
    }));
  }, F = y.useMemo(() => {
    if (V == null)
      return null;
    if (V === "all")
      return {
        startIndex: 0,
        endIndex: _.sections.length - 1,
        shouldSelectBoundarySelectors: !0
      };
    if (typeof V == "number")
      return {
        startIndex: V,
        endIndex: V
      };
    if (typeof V == "string") {
      const Z = _.sections.findIndex((q) => q.type === V);
      return {
        startIndex: Z,
        endIndex: Z
      };
    }
    return V;
  }, [V, _.sections]), $ = ({
    value: Z,
    referenceValue: q,
    sections: G
  }) => {
    if (L((Q) => T({}, Q, {
      sections: G,
      value: Z,
      referenceValue: q,
      tempValueStrAndroid: null
    })), s.areValuesEqual(t, _.value, Z))
      return;
    const K = {
      validationError: d({
        adapter: o,
        value: Z,
        props: T({}, u, {
          value: Z,
          timezone: w
        })
      })
    };
    E(Z, K);
  }, A = (Z, q) => {
    const G = [..._.sections];
    return G[Z] = T({}, G[Z], {
      value: q,
      modified: !0
    }), qT(G, i);
  }, H = () => {
    $({
      value: s.emptyValue,
      referenceValue: _.referenceValue,
      sections: O(s.emptyValue)
    });
  }, N = () => {
    if (F == null)
      return;
    const Z = _.sections[F.startIndex], q = a.getActiveDateManager(t, _, Z), K = q.getSections(_.sections).filter((W) => W.value !== "").length === (Z.value === "" ? 0 : 1), Q = A(F.startIndex, ""), re = K ? null : t.date(/* @__PURE__ */ new Date("")), U = q.getNewValuesFromNewActiveDate(re);
    (re != null && !t.isValid(re)) != (q.date != null && !t.isValid(q.date)) ? $(T({}, U, {
      sections: Q
    })) : L((W) => T({}, W, U, {
      sections: Q,
      tempValueStrAndroid: null
    }));
  }, z = (Z) => {
    const q = (Q, re) => {
      const U = t.parse(Q, b);
      if (U == null || !t.isValid(U))
        return null;
      const W = SC(t, w, n, b, U, C, S, i);
      return EC(t, w, U, W, re, !1);
    }, G = a.parseValueStr(Z, _.referenceValue, q), K = a.updateReferenceValue(t, G, _.referenceValue);
    $({
      value: G,
      referenceValue: K,
      sections: O(G, _.sections)
    });
  }, se = ({
    activeSection: Z,
    newSectionValue: q,
    shouldGoToNextSection: G
  }) => {
    G && F && F.startIndex < _.sections.length - 1 ? I(F.startIndex + 1) : F && F.startIndex !== F.endIndex && I(F.startIndex);
    const K = a.getActiveDateManager(t, _, Z), Q = A(F.startIndex, q), re = K.getSections(Q), U = b2e(t, re);
    let W, D;
    if (U != null && t.isValid(U)) {
      const X = EC(t, w, U, re, K.referenceDate, !0);
      W = K.getNewValuesFromNewActiveDate(X), D = !0;
    } else
      W = K.getNewValuesFromNewActiveDate(U), D = (U != null && !t.isValid(U)) != (K.date != null && !t.isValid(K.date));
    return D ? $(T({}, W, {
      sections: Q
    })) : L((X) => T({}, X, W, {
      sections: Q,
      tempValueStrAndroid: null
    }));
  }, ne = (Z) => L((q) => T({}, q, {
    tempValueStrAndroid: Z
  }));
  return y.useEffect(() => {
    const Z = O(_.value);
    TC(Z, c), L((q) => T({}, q, {
      sections: Z
    }));
  }, [b, t.locale]), y.useEffect(() => {
    let Z = !1;
    s.areValuesEqual(t, _.value, k) ? Z = s.getTimezone(t, _.value) !== s.getTimezone(t, k) : Z = !0, Z && L((q) => T({}, q, {
      value: k,
      referenceValue: a.updateReferenceValue(t, k, q.referenceValue),
      sections: O(k)
    }));
  }, [k]), {
    state: _,
    selectedSectionIndexes: F,
    setSelectedSections: I,
    clearValue: H,
    clearActiveSection: N,
    updateSectionValue: se,
    updateValueFromValueStr: z,
    setTempAndroidValueStr: ne,
    sectionsValueBoundaries: R,
    placeholder: P,
    timezone: w
  };
}, xce = 5e3, tl = (e) => e.saveQuery != null, yce = ({
  sections: e,
  updateSectionValue: t,
  sectionsValueBoundaries: n,
  setTempAndroidValueStr: o,
  timezone: r
}) => {
  const i = kt(), [s, a] = y.useState(null), c = Ke(() => a(null));
  y.useEffect(() => {
    var g;
    s != null && ((g = e[s.sectionIndex]) == null ? void 0 : g.type) !== s.sectionType && c();
  }, [e, s, c]), y.useEffect(() => {
    if (s != null) {
      const g = setTimeout(() => c(), xce);
      return () => {
        window.clearTimeout(g);
      };
    }
    return () => {
    };
  }, [s, c]);
  const d = ({
    keyPressed: g,
    sectionIndex: m
  }, b, C) => {
    const x = g.toLowerCase(), v = e[m];
    if (s != null && (!C || C(s.value)) && s.sectionIndex === m) {
      const M = `${s.value}${x}`, w = b(M, v);
      if (!tl(w))
        return a({
          sectionIndex: m,
          value: M,
          sectionType: v.type
        }), w;
    }
    const S = b(x, v);
    return tl(S) && !S.saveQuery ? (c(), null) : (a({
      sectionIndex: m,
      value: x,
      sectionType: v.type
    }), tl(S) ? null : S);
  }, u = (g) => {
    const m = (x, v, S) => {
      const M = v.filter((w) => w.toLowerCase().startsWith(S));
      return M.length === 0 ? {
        saveQuery: !1
      } : {
        sectionValue: M[0],
        shouldGoToNextSection: M.length === 1
      };
    }, b = (x, v, S, M) => {
      const w = (k) => WT(i, r, v.type, k);
      if (v.contentType === "letter")
        return m(v.format, w(v.format), x);
      if (S && M != null && Th(i, S).contentType === "letter") {
        const k = w(S), E = m(S, k, x);
        return tl(E) ? {
          saveQuery: !1
        } : T({}, E, {
          sectionValue: M(E.sectionValue, k)
        });
      }
      return {
        saveQuery: !1
      };
    };
    return d(g, (x, v) => {
      switch (v.type) {
        case "month": {
          const S = (M) => wC(i, M, i.formats.month, v.format);
          return b(x, v, i.formats.month, S);
        }
        case "weekDay": {
          const S = (M, w) => w.indexOf(M).toString();
          return b(x, v, i.formats.weekday, S);
        }
        case "meridiem":
          return b(x, v);
        default:
          return {
            saveQuery: !1
          };
      }
    });
  }, p = (g) => {
    const m = (C, x) => {
      const v = +`${C}`, S = n[x.type]({
        currentDate: null,
        format: x.format,
        contentType: x.contentType
      });
      if (v > S.maximum)
        return {
          saveQuery: !1
        };
      if (v < S.minimum)
        return {
          saveQuery: !0
        };
      const M = +`${C}0` > S.maximum || C.length === S.maximum.toString().length;
      return {
        sectionValue: GT(i, r, v, S, x),
        shouldGoToNextSection: M
      };
    };
    return d(g, (C, x) => {
      if (x.contentType === "digit" || x.contentType === "digit-with-letter")
        return m(C, x);
      if (x.type === "month") {
        const v = YT(i, r, "digit", "month", "MM"), S = m(C, {
          type: x.type,
          format: "MM",
          hasLeadingZerosInFormat: v,
          hasLeadingZerosInInput: !0,
          contentType: "digit",
          maxLength: 2
        });
        if (tl(S))
          return S;
        const M = wC(i, S.sectionValue, "MM", x.format);
        return T({}, S, {
          sectionValue: M
        });
      }
      if (x.type === "weekDay") {
        const v = m(C, x);
        if (tl(v))
          return v;
        const S = K3(i, r, x.format)[Number(v.sectionValue) - 1];
        return T({}, v, {
          sectionValue: S
        });
      }
      return {
        saveQuery: !1
      };
    }, (C) => !Number.isNaN(Number(C)));
  };
  return {
    applyCharacterEditing: Ke((g) => {
      const m = e[g.sectionIndex], C = g.keyPressed !== " " && !Number.isNaN(Number(g.keyPressed)) ? p(g) : u(g);
      C == null ? o(null) : t({
        activeSection: m,
        newSectionValue: C.sectionValue,
        shouldGoToNextSection: C.shouldGoToNextSection
      });
    }),
    resetCharacterQuery: c
  };
}, vce = ["onClick", "onKeyDown", "onFocus", "onBlur", "onMouseUp", "onPaste", "error", "clearable", "onClear", "disabled"], Ih = (e) => {
  const t = kt(), {
    state: n,
    selectedSectionIndexes: o,
    setSelectedSections: r,
    clearValue: i,
    clearActiveSection: s,
    updateSectionValue: a,
    updateValueFromValueStr: c,
    setTempAndroidValueStr: d,
    sectionsValueBoundaries: u,
    placeholder: p,
    timezone: h
  } = Cce(e), {
    inputRef: g,
    internalProps: m,
    internalProps: {
      readOnly: b = !1,
      unstableFieldRef: C,
      minutesStep: x
    },
    forwardedProps: {
      onClick: v,
      onKeyDown: S,
      onFocus: M,
      onBlur: w,
      onMouseUp: k,
      onPaste: E,
      error: R,
      clearable: O,
      onClear: P,
      disabled: _
    },
    fieldValueManager: L,
    valueManager: V,
    validator: j
  } = e, I = le(e.forwardedProps, vce), {
    applyCharacterEditing: F,
    resetCharacterQuery: $
  } = yce({
    sections: n.sections,
    updateSectionValue: a,
    sectionsValueBoundaries: u,
    setTempAndroidValueStr: d,
    timezone: h
  }), A = y.useRef(null), H = Tt(g, A), N = y.useRef(void 0), se = ge().direction === "rtl", ne = y.useMemo(() => w2e(n.sections, se), [n.sections, se]), Z = () => {
    var te;
    if (b) {
      r(null);
      return;
    }
    const ie = (te = A.current.selectionStart) != null ? te : 0;
    let ye;
    ie <= n.sections[0].startInInput || ie >= n.sections[n.sections.length - 1].endInInput ? ye = 1 : ye = n.sections.findIndex((We) => We.startInInput - We.startSeparator.length > ie);
    const Ne = ye === -1 ? n.sections.length - 1 : ye - 1;
    r(Ne);
  }, q = Ke((te, ...ie) => {
    te.isDefaultPrevented() || (v == null || v(te, ...ie), Z());
  }), G = Ke((te) => {
    k == null || k(te), te.preventDefault();
  }), K = Ke((...te) => {
    M == null || M(...te);
    const ie = A.current;
    window.clearTimeout(N.current), N.current = setTimeout(() => {
      !ie || ie !== A.current || o != null || b || (// avoid selecting all sections when focusing empty field without value
      ie.value.length && Number(ie.selectionEnd) - Number(ie.selectionStart) === ie.value.length ? r("all") : Z());
    });
  }), Q = Ke((...te) => {
    w == null || w(...te), r(null);
  }), re = Ke((te) => {
    if (E == null || E(te), b) {
      te.preventDefault();
      return;
    }
    const ie = te.clipboardData.getData("text");
    if (o && o.startIndex === o.endIndex) {
      const ye = n.sections[o.startIndex], Ne = /^[a-zA-Z]+$/.test(ie), We = /^[0-9]+$/.test(ie), qe = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(ie);
      if (ye.contentType === "letter" && Ne || ye.contentType === "digit" && We || ye.contentType === "digit-with-letter" && qe) {
        $(), a({
          activeSection: ye,
          newSectionValue: ie,
          shouldGoToNextSection: !0
        }), te.preventDefault();
        return;
      }
      if (Ne || We) {
        te.preventDefault();
        return;
      }
    }
    te.preventDefault(), $(), c(ie);
  }), U = Ke((te) => {
    if (b)
      return;
    const ie = te.target.value;
    if (ie === "") {
      $(), i();
      return;
    }
    const ye = te.nativeEvent.data, Ne = ye && ye.length > 1, We = Ne ? ye : ie, qe = fl(We);
    if (o == null || Ne) {
      c(Ne ? ye : qe);
      return;
    }
    let Me;
    if (o.startIndex === 0 && o.endIndex === n.sections.length - 1 && qe.length === 1)
      Me = qe;
    else {
      const Pe = fl(L.getValueStrFromSections(n.sections, se));
      let fe = -1, ae = -1;
      for (let Le = 0; Le < Pe.length; Le += 1)
        fe === -1 && Pe[Le] !== qe[Le] && (fe = Le), ae === -1 && Pe[Pe.length - Le - 1] !== qe[qe.length - Le - 1] && (ae = Le);
      const Te = n.sections[o.startIndex];
      if (fe < Te.start || Pe.length - ae - 1 > Te.end)
        return;
      const Ye = qe.length - Pe.length + Te.end - fl(Te.endSeparator || "").length;
      Me = qe.slice(Te.start + fl(Te.startSeparator || "").length, Ye);
    }
    if (Me.length === 0) {
      v2e() ? d(We) : ($(), s());
      return;
    }
    F({
      keyPressed: Me,
      sectionIndex: o.startIndex
    });
  }), W = Ke((te) => {
    switch (S == null || S(te), !0) {
      case (te.key === "a" && (te.ctrlKey || te.metaKey)): {
        te.preventDefault(), r("all");
        break;
      }
      case te.key === "ArrowRight": {
        if (te.preventDefault(), o == null)
          r(ne.startIndex);
        else if (o.startIndex !== o.endIndex)
          r(o.endIndex);
        else {
          const ie = ne.neighbors[o.startIndex].rightIndex;
          ie !== null && r(ie);
        }
        break;
      }
      case te.key === "ArrowLeft": {
        if (te.preventDefault(), o == null)
          r(ne.endIndex);
        else if (o.startIndex !== o.endIndex)
          r(o.startIndex);
        else {
          const ie = ne.neighbors[o.startIndex].leftIndex;
          ie !== null && r(ie);
        }
        break;
      }
      case te.key === "Delete": {
        if (te.preventDefault(), b)
          break;
        o == null || o.startIndex === 0 && o.endIndex === n.sections.length - 1 ? i() : s(), $();
        break;
      }
      case ["ArrowUp", "ArrowDown", "Home", "End", "PageUp", "PageDown"].includes(te.key): {
        if (te.preventDefault(), b || o == null)
          break;
        const ie = n.sections[o.startIndex], ye = L.getActiveDateManager(t, n, ie), Ne = h2e(t, h, ie, te.key, u, ye.date, {
          minutesStep: x
        });
        a({
          activeSection: ie,
          newSectionValue: Ne,
          shouldGoToNextSection: !1
        });
        break;
      }
    }
  });
  En(() => {
    if (!A.current)
      return;
    if (o == null) {
      A.current.scrollLeft && (A.current.scrollLeft = 0);
      return;
    }
    const te = n.sections[o.startIndex], ie = n.sections[o.endIndex];
    let ye = te.startInInput, Ne = ie.endInInput;
    if (o.shouldSelectBoundarySelectors && (ye -= te.startSeparator.length, Ne += ie.endSeparator.length), ye !== A.current.selectionStart || Ne !== A.current.selectionEnd) {
      const We = A.current.scrollTop;
      A.current === uu(document) && A.current.setSelectionRange(ye, Ne), A.current.scrollTop = We;
    }
  });
  const D = ik(T({}, m, {
    value: n.value,
    timezone: h
  }), j, V.isSameError, V.defaultErrorState), X = y.useMemo(() => R !== void 0 ? R : V.hasError(D), [V, D, R]);
  y.useEffect(() => {
    !X && !o && $();
  }, [n.referenceValue, o, X]), y.useEffect(() => (A.current && A.current === document.activeElement && r("all"), () => window.clearTimeout(N.current)), []), y.useEffect(() => {
    n.tempValueStrAndroid != null && o != null && ($(), s());
  }, [n.tempValueStrAndroid]);
  const de = y.useMemo(() => {
    var te;
    return (te = n.tempValueStrAndroid) != null ? te : L.getValueStrFromSections(n.sections, se);
  }, [n.sections, L, n.tempValueStrAndroid, se]), ue = y.useMemo(() => o == null || n.sections[o.startIndex].contentType === "letter" ? "text" : "numeric", [o, n.sections]), he = A.current && A.current === uu(document), Ue = V.areValuesEqual(t, n.value, V.emptyValue), me = !he && Ue;
  y.useImperativeHandle(C, () => ({
    getSections: () => n.sections,
    getActiveSectionIndex: () => {
      var te, ie, ye;
      const Ne = (te = A.current.selectionStart) != null ? te : 0, We = (ie = A.current.selectionEnd) != null ? ie : 0, qe = !!((ye = A.current) != null && ye.readOnly);
      if (Ne === 0 && We === 0 || qe)
        return null;
      const Me = Ne <= n.sections[0].startInInput ? 1 : n.sections.findIndex((Pe) => Pe.startInInput - Pe.startSeparator.length > Ne);
      return Me === -1 ? n.sections.length - 1 : Me - 1;
    },
    setSelectedSections: (te) => r(te)
  }));
  const Ie = Ke((te, ...ie) => {
    var ye;
    te.preventDefault(), P == null || P(te, ...ie), i(), A == null || (ye = A.current) == null || ye.focus(), r(0);
  });
  return T({
    placeholder: p,
    autoComplete: "off",
    disabled: !!_
  }, I, {
    value: me ? "" : de,
    inputMode: ue,
    readOnly: b,
    onClick: q,
    onFocus: K,
    onBlur: Q,
    onPaste: re,
    onChange: U,
    onKeyDown: W,
    onMouseUp: G,
    onClear: Ie,
    error: X,
    ref: H,
    clearable: !!(O && !Ue && !b && !_)
  });
}, wce = ({
  open: e,
  onOpen: t,
  onClose: n
}) => {
  const o = y.useRef(typeof e == "boolean").current, [r, i] = y.useState(!1);
  y.useEffect(() => {
    if (o) {
      if (typeof e != "boolean")
        throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
      i(e);
    }
  }, [o, e]);
  const s = y.useCallback((a) => {
    o || i(a), a && t && t(), !a && n && n();
  }, [o, t, n]);
  return {
    isOpen: r,
    setIsOpen: s
  };
}, Sce = (e) => {
  const {
    action: t,
    hasChanged: n,
    dateState: o,
    isControlled: r
  } = e, i = !r && !o.hasBeenModifiedSinceMount;
  return t.name === "setValueFromField" ? !0 : t.name === "setValueFromAction" ? i && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : n(o.lastPublishedValue) : t.name === "setValueFromView" && t.selectionState !== "shallow" || t.name === "setValueFromShortcut" ? i ? !0 : n(o.lastPublishedValue) : !1;
}, Mce = (e) => {
  const {
    action: t,
    hasChanged: n,
    dateState: o,
    isControlled: r,
    closeOnSelect: i
  } = e, s = !r && !o.hasBeenModifiedSinceMount;
  return t.name === "setValueFromAction" ? s && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : n(o.lastCommittedValue) : t.name === "setValueFromView" && t.selectionState === "finish" && i ? s ? !0 : n(o.lastCommittedValue) : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" && n(o.lastCommittedValue) : !1;
}, Tce = (e) => {
  const {
    action: t,
    closeOnSelect: n
  } = e;
  return t.name === "setValueFromAction" ? !0 : t.name === "setValueFromView" ? t.selectionState === "finish" && n : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" : !1;
}, kce = ({
  props: e,
  valueManager: t,
  valueType: n,
  wrapperVariant: o,
  validator: r
}) => {
  const {
    onAccept: i,
    onChange: s,
    value: a,
    defaultValue: c,
    closeOnSelect: d = o === "desktop",
    selectedSections: u,
    onSelectedSectionsChange: p,
    timezone: h
  } = e, {
    current: g
  } = y.useRef(c), {
    current: m
  } = y.useRef(a !== void 0);
  process.env.NODE_ENV !== "production" && (y.useEffect(() => {
    m !== (a !== void 0) && console.error([`MUI: A component is changing the ${m ? "" : "un"}controlled value of a picker to be ${m ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled valuefor the lifetime of the component.", "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
  }, [a]), y.useEffect(() => {
    !m && g !== c && console.error(["MUI: A component is changing the defaultValue of an uncontrolled picker after being initialized. To suppress this warning opt to use a controlled value."].join(`
`));
  }, [JSON.stringify(g)]));
  const b = kt(), C = Aa(), [x, v] = Fn({
    controlled: u,
    default: null,
    name: "usePickerValue",
    state: "selectedSections"
  }), {
    isOpen: S,
    setIsOpen: M
  } = wce(e), [w, k] = y.useState(() => {
    let K;
    return a !== void 0 ? K = a : g !== void 0 ? K = g : K = t.emptyValue, {
      draft: K,
      lastPublishedValue: K,
      lastCommittedValue: K,
      lastControlledValue: a,
      hasBeenModifiedSinceMount: !1
    };
  }), {
    timezone: E,
    handleValueChange: R
  } = Lh({
    timezone: h,
    value: a,
    defaultValue: g,
    onChange: s,
    valueManager: t
  });
  ik(T({}, e, {
    value: w.draft,
    timezone: E
  }), r, t.isSameError, t.defaultErrorState);
  const O = Ke((K) => {
    const Q = {
      action: K,
      dateState: w,
      hasChanged: (D) => !t.areValuesEqual(b, K.value, D),
      isControlled: m,
      closeOnSelect: d
    }, re = Sce(Q), U = Mce(Q), W = Tce(Q);
    if (k((D) => T({}, D, {
      draft: K.value,
      lastPublishedValue: re ? K.value : D.lastPublishedValue,
      lastCommittedValue: U ? K.value : D.lastCommittedValue,
      hasBeenModifiedSinceMount: !0
    })), re) {
      const X = {
        validationError: K.name === "setValueFromField" ? K.context.validationError : r({
          adapter: C,
          value: K.value,
          props: T({}, e, {
            value: K.value,
            timezone: E
          })
        })
      };
      K.name === "setValueFromShortcut" && K.shortcut != null && (X.shortcut = K.shortcut), R(K.value, X);
    }
    U && i && i(K.value), W && M(!1);
  });
  if (a !== void 0 && (w.lastControlledValue === void 0 || !t.areValuesEqual(b, w.lastControlledValue, a))) {
    const K = t.areValuesEqual(b, w.draft, a);
    k((Q) => T({}, Q, {
      lastControlledValue: a
    }, K ? {} : {
      lastCommittedValue: a,
      lastPublishedValue: a,
      draft: a,
      hasBeenModifiedSinceMount: !0
    }));
  }
  const P = Ke(() => {
    O({
      value: t.emptyValue,
      name: "setValueFromAction",
      pickerAction: "clear"
    });
  }), _ = Ke(() => {
    O({
      value: w.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "accept"
    });
  }), L = Ke(() => {
    O({
      value: w.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "dismiss"
    });
  }), V = Ke(() => {
    O({
      value: w.lastCommittedValue,
      name: "setValueFromAction",
      pickerAction: "cancel"
    });
  }), j = Ke(() => {
    O({
      value: t.getTodayValue(b, E, n),
      name: "setValueFromAction",
      pickerAction: "today"
    });
  }), I = Ke(() => M(!0)), F = Ke(() => M(!1)), $ = Ke((K, Q = "partial") => O({
    name: "setValueFromView",
    value: K,
    selectionState: Q
  })), A = Ke((K, Q, re) => O({
    name: "setValueFromShortcut",
    value: K,
    changeImportance: Q ?? "accept",
    shortcut: re
  })), H = Ke((K, Q) => O({
    name: "setValueFromField",
    value: K,
    context: Q
  })), N = Ke((K) => {
    v(K), p == null || p(K);
  }), z = {
    onClear: P,
    onAccept: _,
    onDismiss: L,
    onCancel: V,
    onSetToday: j,
    onOpen: I,
    onClose: F
  }, se = {
    value: w.draft,
    onChange: H,
    selectedSections: x,
    onSelectedSectionsChange: N
  }, ne = y.useMemo(() => t.cleanValue(b, w.draft), [b, t, w.draft]), Z = {
    value: ne,
    onChange: $,
    onClose: F,
    open: S,
    onSelectedSectionsChange: N
  }, G = T({}, z, {
    value: ne,
    onChange: $,
    onSelectShortcut: A,
    isValid: (K) => {
      const Q = r({
        adapter: C,
        value: K,
        props: T({}, e, {
          value: K,
          timezone: E
        })
      });
      return !t.hasError(Q);
    }
  });
  return {
    open: S,
    fieldProps: se,
    viewProps: Z,
    layoutProps: G,
    actions: z
  };
};
let I6 = !1;
function Z0({
  onChange: e,
  onViewChange: t,
  openTo: n,
  view: o,
  views: r,
  autoFocus: i,
  focusedView: s,
  onFocusedViewChange: a
}) {
  var c, d;
  process.env.NODE_ENV !== "production" && (I6 || (o != null && !r.includes(o) && (console.warn(`MUI: \`view="${o}"\` is not a valid prop.`, `It must be an element of \`views=["${r.join('", "')}"]\`.`), I6 = !0), o == null && n != null && !r.includes(n) && (console.warn(`MUI: \`openTo="${n}"\` is not a valid prop.`, `It must be an element of \`views=["${r.join('", "')}"]\`.`), I6 = !0)));
  const u = y.useRef(n), p = y.useRef(r), h = y.useRef(r.includes(n) ? n : r[0]), [g, m] = Fn({
    name: "useViews",
    state: "view",
    controlled: o,
    default: h.current
  }), b = y.useRef(i ? g : null), [C, x] = Fn({
    name: "useViews",
    state: "focusedView",
    controlled: s,
    default: b.current
  });
  y.useEffect(() => {
    (u.current && u.current !== n || p.current && p.current.some((O) => !r.includes(O))) && (m(r.includes(n) ? n : r[0]), p.current = r, u.current = n);
  }, [n, m, g, r]);
  const v = r.indexOf(g), S = (c = r[v - 1]) != null ? c : null, M = (d = r[v + 1]) != null ? d : null, w = Ke((O, P) => {
    x(P ? O : (_) => O === _ ? null : _), a == null || a(O, P);
  }), k = Ke((O) => {
    w(O, !0), O !== g && (m(O), t && t(O));
  }), E = Ke(() => {
    M && k(M);
  }), R = Ke((O, P, _) => {
    const L = P === "finish", V = _ ? (
      // handles case like `DateTimePicker`, where a view might return a `finish` selection state
      // but we it's not the final view given all `views` -> overall selection state should be `partial`.
      r.indexOf(_) < r.length - 1
    ) : !!M;
    if (e(O, L && V ? "partial" : P, _), _ && _ !== g) {
      const I = r[r.indexOf(_) + 1];
      I && k(I);
    } else L && E();
  });
  return {
    view: g,
    setView: k,
    focusedView: C,
    setFocusedView: w,
    nextView: M,
    previousView: S,
    // Always return up to date default view instead of the initial one (i.e. defaultView.current)
    defaultView: r.includes(n) ? n : r[0],
    goToNextView: E,
    setValueAndGoToNextView: R
  };
}
const Ece = ["className", "sx"], Rce = ({
  props: e,
  propsFromPickerValue: t,
  additionalViewProps: n,
  inputRef: o,
  autoFocusView: r
}) => {
  const {
    onChange: i,
    open: s,
    onSelectedSectionsChange: a,
    onClose: c
  } = t, {
    view: d,
    views: u,
    openTo: p,
    onViewChange: h,
    viewRenderers: g,
    timezone: m
  } = e, b = le(e, Ece), {
    view: C,
    setView: x,
    defaultView: v,
    focusedView: S,
    setFocusedView: M,
    setValueAndGoToNextView: w
  } = Z0({
    view: d,
    views: u,
    openTo: p,
    onChange: i,
    onViewChange: h,
    autoFocus: r
  }), {
    hasUIView: k,
    viewModeLookup: E
  } = y.useMemo(() => u.reduce((j, I) => {
    let F;
    return g[I] != null ? F = "UI" : F = "field", j.viewModeLookup[I] = F, F === "UI" && (j.hasUIView = !0), j;
  }, {
    hasUIView: !1,
    viewModeLookup: {}
  }), [g, u]), R = y.useMemo(() => u.reduce((j, I) => g[I] != null && Bl(I) ? j + 1 : j, 0), [g, u]), O = E[C], P = Ke(() => O === "UI"), [_, L] = y.useState(O === "UI" ? C : null);
  return _ !== C && E[C] === "UI" && L(C), En(() => {
    O === "field" && s && (c(), setTimeout(() => {
      o == null || o.current.focus(), a(C);
    }));
  }, [C]), En(() => {
    if (!s)
      return;
    let j = C;
    O === "field" && _ != null && (j = _), j !== v && E[j] === "UI" && E[v] === "UI" && (j = v), j !== C && x(j), M(j, !0);
  }, [s]), {
    hasUIView: k,
    shouldRestoreFocus: P,
    layoutProps: {
      views: u,
      view: _,
      onViewChange: x
    },
    renderCurrentView: () => {
      if (_ == null)
        return null;
      const j = g[_];
      return j == null ? null : j(T({}, b, n, t, {
        views: u,
        timezone: m,
        onChange: w,
        view: _,
        onViewChange: x,
        focusedView: S,
        onFocusedViewChange: M,
        showViewSwitcher: R > 1,
        timeViewsCount: R
      }));
    }
  };
};
function LC() {
  return typeof window > "u" ? "portrait" : window.screen && window.screen.orientation && window.screen.orientation.angle ? Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait" : window.orientation && Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
}
const Oce = (e, t) => {
  const [n, o] = y.useState(LC);
  return En(() => {
    const i = () => {
      o(LC());
    };
    return window.addEventListener("orientationchange", i), () => {
      window.removeEventListener("orientationchange", i);
    };
  }, []), sl(e, ["hours", "minutes", "seconds"]) ? !1 : (t || n) === "landscape";
}, _ce = ({
  props: e,
  propsFromPickerValue: t,
  propsFromPickerViews: n,
  wrapperVariant: o
}) => {
  const {
    orientation: r
  } = e, i = Oce(n.views, r);
  return {
    layoutProps: T({}, n, t, {
      isLandscape: i,
      wrapperVariant: o,
      disabled: e.disabled,
      readOnly: e.readOnly
    })
  };
}, Pce = (e, t = "warning") => {
  let n = !1;
  const o = Array.isArray(e) ? e.join(`
`) : e;
  return () => {
    n || (n = !0, t === "error" ? console.error(o) : console.warn(o));
  };
}, Lce = Pce(["The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.", "You can replace it with the `textField` component slot in most cases.", "For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5)."]), sk = ({
  props: e,
  valueManager: t,
  valueType: n,
  wrapperVariant: o,
  inputRef: r,
  additionalViewProps: i,
  validator: s,
  autoFocusView: a
}) => {
  process.env.NODE_ENV !== "production" && e.renderInput != null && Lce();
  const c = kce({
    props: e,
    valueManager: t,
    valueType: n,
    wrapperVariant: o,
    validator: s
  }), d = Rce({
    props: e,
    inputRef: r,
    additionalViewProps: i,
    autoFocusView: a,
    propsFromPickerValue: c.viewProps
  }), u = _ce({
    props: e,
    wrapperVariant: o,
    propsFromPickerValue: c.layoutProps,
    propsFromPickerViews: d.layoutProps
  });
  return {
    // Picker value
    open: c.open,
    actions: c.actions,
    fieldProps: c.fieldProps,
    // Picker views
    renderCurrentView: d.renderCurrentView,
    hasUIView: d.hasUIView,
    shouldRestoreFocus: d.shouldRestoreFocus,
    // Picker layout
    layoutProps: u.layoutProps
  };
};
function ak(e) {
  return _e("MuiPickersLayout", e);
}
const j6 = Re("MuiPickersLayout", ["root", "landscape", "contentWrapper", "toolbar", "actionBar", "tabs", "shortcuts"]), Ice = ["onAccept", "onClear", "onCancel", "onSetToday", "actions"];
function lk(e) {
  const {
    onAccept: t,
    onClear: n,
    onCancel: o,
    onSetToday: r,
    actions: i
  } = e, s = le(e, Ice), a = $n();
  if (i == null || i.length === 0)
    return null;
  const c = i == null ? void 0 : i.map((d) => {
    switch (d) {
      case "clear":
        return /* @__PURE__ */ f.jsx(at, {
          onClick: n,
          children: a.clearButtonLabel
        }, d);
      case "cancel":
        return /* @__PURE__ */ f.jsx(at, {
          onClick: o,
          children: a.cancelButtonLabel
        }, d);
      case "accept":
        return /* @__PURE__ */ f.jsx(at, {
          onClick: t,
          children: a.okButtonLabel
        }, d);
      case "today":
        return /* @__PURE__ */ f.jsx(at, {
          onClick: r,
          children: a.todayButtonLabel
        }, d);
      default:
        return null;
    }
  });
  return /* @__PURE__ */ f.jsx(k3, T({}, s, {
    children: c
  }));
}
process.env.NODE_ENV !== "production" && (lk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Ordered array of actions to display.
   * If empty, does not display that action bar.
   * @default `['cancel', 'accept']` for mobile and `[]` for desktop
   */
  actions: l.arrayOf(l.oneOf(["accept", "cancel", "clear", "today"]).isRequired),
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: l.bool,
  onAccept: l.func.isRequired,
  onCancel: l.func.isRequired,
  onClear: l.func.isRequired,
  onSetToday: l.func.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const jce = ["items", "changeImportance", "isLandscape", "onChange", "isValid"], Vce = ["getValue"];
function ck(e) {
  const {
    items: t,
    changeImportance: n,
    onChange: o,
    isValid: r
  } = e, i = le(e, jce);
  if (t == null || t.length === 0)
    return null;
  const s = t.map((a) => {
    let {
      getValue: c
    } = a, d = le(a, Vce);
    const u = c({
      isValid: r
    });
    return {
      label: d.label,
      onClick: () => {
        o(u, n, d);
      },
      disabled: !r(u)
    };
  });
  return /* @__PURE__ */ f.jsx(n7, T({
    dense: !0,
    sx: [{
      maxHeight: J3,
      maxWidth: 200,
      overflow: "auto"
    }, ...Array.isArray(i.sx) ? i.sx : [i.sx]]
  }, i, {
    children: s.map((a) => /* @__PURE__ */ f.jsx(lw, {
      children: /* @__PURE__ */ f.jsx(hs, T({}, a))
    }, a.label))
  }));
}
process.env.NODE_ENV !== "production" && (ck.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Importance of the change when picking a shortcut:
   * - "accept": fires `onChange`, fires `onAccept` and closes the picker.
   * - "set": fires `onChange` but do not fire `onAccept` and does not close the picker.
   * @default "accept"
   */
  changeImportance: l.oneOf(["accept", "set"]),
  className: l.string,
  component: l.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: l.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: l.bool,
  isLandscape: l.bool.isRequired,
  isValid: l.func.isRequired,
  /**
   * Ordered array of shortcuts to display.
   * If empty, does not display the shortcuts.
   * @default `[]`
   */
  items: l.arrayOf(l.shape({
    getValue: l.func.isRequired,
    label: l.string.isRequired
  })),
  onChange: l.func.isRequired,
  style: l.object,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function Dce(e) {
  return e.view !== null;
}
const Ace = (e) => {
  const {
    classes: t,
    isLandscape: n
  } = e;
  return Oe({
    root: ["root", n && "landscape"],
    contentWrapper: ["contentWrapper"],
    toolbar: ["toolbar"],
    actionBar: ["actionBar"],
    tabs: ["tabs"],
    landscape: ["landscape"],
    shortcuts: ["shortcuts"]
  }, ak, t);
}, Hce = (e) => {
  var t, n;
  const {
    wrapperVariant: o,
    onAccept: r,
    onClear: i,
    onCancel: s,
    onSetToday: a,
    view: c,
    views: d,
    onViewChange: u,
    value: p,
    onChange: h,
    onSelectShortcut: g,
    isValid: m,
    isLandscape: b,
    disabled: C,
    readOnly: x,
    children: v,
    components: S,
    componentsProps: M,
    slots: w,
    slotProps: k
    // TODO: Remove this "as" hack. It get introduced to mark `value` prop in PickersLayoutProps as not required.
    // The true type should be
    // - For pickers value: TDate | null
    // - For range pickers value: [TDate | null, TDate | null]
  } = e, E = w ?? z0(S), R = k ?? M, O = Ace(e), P = (t = E == null ? void 0 : E.actionBar) != null ? t : lk, _ = yn({
    elementType: P,
    externalSlotProps: R == null ? void 0 : R.actionBar,
    additionalProps: {
      onAccept: r,
      onClear: i,
      onCancel: s,
      onSetToday: a,
      actions: o === "desktop" ? [] : ["cancel", "accept"],
      className: O.actionBar
    },
    ownerState: T({}, e, {
      wrapperVariant: o
    })
  }), L = /* @__PURE__ */ f.jsx(P, T({}, _)), V = E == null ? void 0 : E.toolbar, j = yn({
    elementType: V,
    externalSlotProps: R == null ? void 0 : R.toolbar,
    additionalProps: {
      isLandscape: b,
      onChange: h,
      value: p,
      view: c,
      onViewChange: u,
      views: d,
      disabled: C,
      readOnly: x,
      className: O.toolbar
    },
    ownerState: T({}, e, {
      wrapperVariant: o
    })
  }), I = Dce(j) && V ? /* @__PURE__ */ f.jsx(V, T({}, j)) : null, F = v, $ = E == null ? void 0 : E.tabs, A = c && $ ? /* @__PURE__ */ f.jsx($, T({
    view: c,
    onViewChange: u,
    className: O.tabs
  }, R == null ? void 0 : R.tabs)) : null, H = (n = E == null ? void 0 : E.shortcuts) != null ? n : ck, N = yn({
    elementType: H,
    externalSlotProps: R == null ? void 0 : R.shortcuts,
    additionalProps: {
      isValid: m,
      isLandscape: b,
      onChange: g,
      className: O.shortcuts
    },
    ownerState: {
      isValid: m,
      isLandscape: b,
      onChange: g,
      className: O.shortcuts,
      wrapperVariant: o
    }
  }), z = c && H ? /* @__PURE__ */ f.jsx(H, T({}, N)) : null;
  return {
    toolbar: I,
    content: F,
    tabs: A,
    actionBar: L,
    shortcuts: z
  };
}, Fce = (e) => {
  const {
    isLandscape: t,
    classes: n
  } = e;
  return Oe({
    root: ["root", t && "landscape"],
    contentWrapper: ["contentWrapper"]
  }, ak, n);
}, dk = B("div", {
  name: "MuiPickersLayout",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => ({
  display: "grid",
  gridAutoColumns: "max-content auto max-content",
  gridAutoRows: "max-content auto max-content",
  [`& .${j6.toolbar}`]: t.isLandscape ? {
    gridColumn: e.direction === "rtl" ? 3 : 1,
    gridRow: "2 / 3"
  } : {
    gridColumn: "2 / 4",
    gridRow: 1
  },
  [`.${j6.shortcuts}`]: t.isLandscape ? {
    gridColumn: "2 / 4",
    gridRow: 1
  } : {
    gridColumn: e.direction === "rtl" ? 3 : 1,
    gridRow: "2 / 3"
  },
  [`& .${j6.actionBar}`]: {
    gridColumn: "1 / 4",
    gridRow: 3
  }
}));
dk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: l.elementType,
  ownerState: l.shape({
    isLandscape: l.bool.isRequired
  }).isRequired,
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
};
const Nce = B("div", {
  name: "MuiPickersLayout",
  slot: "ContentWrapper",
  overridesResolver: (e, t) => t.contentWrapper
})({
  gridColumn: 2,
  gridRow: 2,
  display: "flex",
  flexDirection: "column"
}), jh = function(t) {
  const n = jt({
    props: t,
    name: "MuiPickersLayout"
  }), {
    toolbar: o,
    content: r,
    tabs: i,
    actionBar: s,
    shortcuts: a
  } = Hce(n), {
    sx: c,
    className: d,
    isLandscape: u,
    ref: p,
    wrapperVariant: h
  } = n, g = n, m = Fce(g);
  return /* @__PURE__ */ f.jsxs(dk, {
    ref: p,
    sx: c,
    className: xe(d, m.root),
    ownerState: g,
    children: [u ? a : o, u ? o : a, /* @__PURE__ */ f.jsx(Nce, {
      className: m.contentWrapper,
      children: h === "desktop" ? /* @__PURE__ */ f.jsxs(y.Fragment, {
        children: [r, i]
      }) : /* @__PURE__ */ f.jsxs(y.Fragment, {
        children: [i, r]
      })
    }), s]
  });
};
process.env.NODE_ENV !== "production" && (jh.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  className: l.string,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  disabled: l.bool,
  isLandscape: l.bool.isRequired,
  isValid: l.func.isRequired,
  onAccept: l.func.isRequired,
  onCancel: l.func.isRequired,
  onChange: l.func.isRequired,
  onClear: l.func.isRequired,
  onClose: l.func.isRequired,
  onDismiss: l.func.isRequired,
  onOpen: l.func.isRequired,
  onSelectShortcut: l.func.isRequired,
  onSetToday: l.func.isRequired,
  onViewChange: l.func.isRequired,
  /**
   * Force rendering in particular orientation.
   */
  orientation: l.oneOf(["landscape", "portrait"]),
  readOnly: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  value: l.any,
  view: l.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  views: l.arrayOf(l.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired).isRequired,
  wrapperVariant: l.oneOf(["desktop", "mobile"])
});
function $ce(e, {
  disableFuture: t,
  maxDate: n,
  timezone: o
}) {
  const r = kt();
  return y.useMemo(() => {
    const i = r.dateWithTimezone(void 0, o), s = r.startOfMonth(t && r.isBefore(i, n) ? i : n);
    return !r.isAfter(s, e);
  }, [t, n, e, r, o]);
}
function Bce(e, {
  disablePast: t,
  minDate: n,
  timezone: o
}) {
  const r = kt();
  return y.useMemo(() => {
    const i = r.dateWithTimezone(void 0, o), s = r.startOfMonth(t && r.isAfter(i, n) ? i : n);
    return !r.isBefore(s, e);
  }, [t, n, e, r, o]);
}
function Q3(e, t, n, o) {
  const r = kt(), i = c2e(e, r), s = y.useCallback((a) => {
    const c = e == null ? null : d2e(e, a, !!t, r);
    n(c, o ?? "partial");
  }, [t, e, n, o, r]);
  return {
    meridiemMode: i,
    handleMeridiemChange: s
  };
}
const m5 = ["disablePast", "disableFuture", "minDate", "maxDate", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear"], b5 = ["disablePast", "disableFuture", "minTime", "maxTime", "shouldDisableClock", "shouldDisableTime", "minutesStep", "ampm", "disableIgnoringDatePartForTimeValidation"], uk = ["minDateTime", "maxDateTime"], zce = [...m5, ...b5, ...uk], C2 = (e) => zce.reduce((t, n) => (e.hasOwnProperty(n) && (t[n] = e[n]), t), {}), Zce = ["value", "defaultValue", "referenceDate", "format", "formatDensity", "onChange", "timezone", "readOnly", "onError", "shouldRespectLeadingZeros", "selectedSections", "onSelectedSectionsChange", "unstableFieldRef"], Vh = (e, t) => {
  const n = T({}, e), o = {}, r = (i) => {
    n.hasOwnProperty(i) && (o[i] = n[i], delete n[i]);
  };
  return Zce.forEach(r), t === "date" ? m5.forEach(r) : t === "time" ? b5.forEach(r) : t === "date-time" && (m5.forEach(r), b5.forEach(r), uk.forEach(r)), {
    forwardedProps: n,
    internalProps: o
  };
}, W0 = ({
  props: e,
  value: t,
  adapter: n
}) => {
  if (t === null)
    return null;
  const {
    shouldDisableDate: o,
    shouldDisableMonth: r,
    shouldDisableYear: i,
    disablePast: s,
    disableFuture: a,
    timezone: c
  } = e, d = n.utils.dateWithTimezone(void 0, c), u = go(n.utils, e.minDate, n.defaultDates.minDate), p = go(n.utils, e.maxDate, n.defaultDates.maxDate);
  switch (!0) {
    case !n.utils.isValid(t):
      return "invalidDate";
    case !!(o && o(t)):
      return "shouldDisableDate";
    case !!(r && r(t)):
      return "shouldDisableMonth";
    case !!(i && i(t)):
      return "shouldDisableYear";
    case !!(a && n.utils.isAfterDay(t, d)):
      return "disableFuture";
    case !!(s && n.utils.isBeforeDay(t, d)):
      return "disablePast";
    case !!(u && n.utils.isBeforeDay(t, u)):
      return "minDate";
    case !!(p && n.utils.isAfterDay(t, p)):
      return "maxDate";
    default:
      return null;
  }
}, ef = ({
  adapter: e,
  value: t,
  props: n
}) => {
  if (t === null)
    return null;
  const {
    minTime: o,
    maxTime: r,
    minutesStep: i,
    shouldDisableClock: s,
    shouldDisableTime: a,
    disableIgnoringDatePartForTimeValidation: c = !1,
    disablePast: d,
    disableFuture: u,
    timezone: p
  } = n, h = e.utils.dateWithTimezone(void 0, p), g = B0(c, e.utils);
  switch (!0) {
    case !e.utils.isValid(t):
      return "invalidDate";
    case !!(o && g(o, t)):
      return "minTime";
    case !!(r && g(t, r)):
      return "maxTime";
    case !!(u && e.utils.isAfter(t, h)):
      return "disableFuture";
    case !!(d && e.utils.isBefore(t, h)):
      return "disablePast";
    case !!(a && a(t, "hours")):
      return "shouldDisableTime-hours";
    case !!(a && a(t, "minutes")):
      return "shouldDisableTime-minutes";
    case !!(a && a(t, "seconds")):
      return "shouldDisableTime-seconds";
    case !!(s && s(e.utils.getHours(t), "hours")):
      return "shouldDisableClock-hours";
    case !!(s && s(e.utils.getMinutes(t), "minutes")):
      return "shouldDisableClock-minutes";
    case !!(s && s(e.utils.getSeconds(t), "seconds")):
      return "shouldDisableClock-seconds";
    case !!(i && e.utils.getMinutes(t) % i !== 0):
      return "minutesStep";
    default:
      return null;
  }
}, Dh = ({
  props: e,
  value: t,
  adapter: n
}) => {
  const o = W0({
    adapter: n,
    value: t,
    props: e
  });
  return o !== null ? o : ef({
    adapter: n,
    value: t,
    props: e
  });
};
function Wce(e) {
  return _e("MuiPickersDay", e);
}
const Fs = Re("MuiPickersDay", ["root", "dayWithMargin", "dayOutsideMonth", "hiddenDaySpacingFiller", "today", "selected", "disabled"]), Uce = ["autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDaySelect", "onFocus", "onBlur", "onKeyDown", "onMouseDown", "onMouseEnter", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today", "isFirstVisibleCell", "isLastVisibleCell"], Gce = (e) => {
  const {
    selected: t,
    disableMargin: n,
    disableHighlightToday: o,
    today: r,
    disabled: i,
    outsideCurrentMonth: s,
    showDaysOutsideCurrentMonth: a,
    classes: c
  } = e, d = s && !a;
  return Oe({
    root: ["root", t && !d && "selected", i && "disabled", !n && "dayWithMargin", !o && r && "today", s && a && "dayOutsideMonth", d && "hiddenDaySpacingFiller"],
    hiddenDaySpacingFiller: ["hiddenDaySpacingFiller"]
  }, Wce, c);
}, fk = ({
  theme: e,
  ownerState: t
}) => T({}, e.typography.caption, {
  width: Jc,
  height: Jc,
  borderRadius: "50%",
  padding: 0,
  // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
  backgroundColor: "transparent",
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.short
  }),
  color: (e.vars || e).palette.text.primary,
  "@media (pointer: fine)": {
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : $t(e.palette.primary.main, e.palette.action.hoverOpacity)
    }
  },
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : $t(e.palette.primary.main, e.palette.action.focusOpacity),
    [`&.${Fs.selected}`]: {
      willChange: "background-color",
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  [`&.${Fs.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    fontWeight: e.typography.fontWeightMedium,
    "&:hover": {
      willChange: "background-color",
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  [`&.${Fs.disabled}:not(.${Fs.selected})`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${Fs.disabled}&.${Fs.selected}`]: {
    opacity: 0.6
  }
}, !t.disableMargin && {
  margin: `0 ${Y3}px`
}, t.outsideCurrentMonth && t.showDaysOutsideCurrentMonth && {
  color: (e.vars || e).palette.text.secondary
}, !t.disableHighlightToday && t.today && {
  [`&:not(.${Fs.selected})`]: {
    border: `1px solid ${(e.vars || e).palette.text.secondary}`
  }
}), pk = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, !n.disableMargin && t.dayWithMargin, !n.disableHighlightToday && n.today && t.today, !n.outsideCurrentMonth && n.showDaysOutsideCurrentMonth && t.dayOutsideMonth, n.outsideCurrentMonth && !n.showDaysOutsideCurrentMonth && t.hiddenDaySpacingFiller];
}, qce = B(wo, {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: pk
})(fk), Kce = B("div", {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: pk
})(({
  theme: e,
  ownerState: t
}) => T({}, fk({
  theme: e,
  ownerState: t
}), {
  // visibility: 'hidden' does not work here as it hides the element from screen readers as well
  opacity: 0,
  pointerEvents: "none"
})), H2 = () => {
}, hk = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = jt({
    props: t,
    name: "MuiPickersDay"
  }), {
    autoFocus: r = !1,
    className: i,
    day: s,
    disabled: a = !1,
    disableHighlightToday: c = !1,
    disableMargin: d = !1,
    isAnimating: u,
    onClick: p,
    onDaySelect: h,
    onFocus: g = H2,
    onBlur: m = H2,
    onKeyDown: b = H2,
    onMouseDown: C = H2,
    onMouseEnter: x = H2,
    outsideCurrentMonth: v,
    selected: S = !1,
    showDaysOutsideCurrentMonth: M = !1,
    children: w,
    today: k = !1
  } = o, E = le(o, Uce), R = T({}, o, {
    autoFocus: r,
    disabled: a,
    disableHighlightToday: c,
    disableMargin: d,
    selected: S,
    showDaysOutsideCurrentMonth: M,
    today: k
  }), O = Gce(R), P = kt(), _ = y.useRef(null), L = Tt(_, n);
  En(() => {
    r && !a && !u && !v && _.current.focus();
  }, [r, a, u, v]);
  const V = (I) => {
    C(I), v && I.preventDefault();
  }, j = (I) => {
    a || h(s), v && I.currentTarget.focus(), p && p(I);
  };
  return v && !M ? /* @__PURE__ */ f.jsx(Kce, {
    className: xe(O.root, O.hiddenDaySpacingFiller, i),
    ownerState: R,
    role: E.role
  }) : /* @__PURE__ */ f.jsx(qce, T({
    className: xe(O.root, i),
    ref: L,
    centerRipple: !0,
    disabled: a,
    tabIndex: S ? 0 : -1,
    onKeyDown: (I) => b(I, s),
    onFocus: (I) => g(I, s),
    onBlur: (I) => m(I, s),
    onMouseEnter: (I) => x(I, s),
    onClick: j,
    onMouseDown: V
  }, E, {
    ownerState: R,
    children: w || P.format(s, "dayOfMonth")
  }));
});
process.env.NODE_ENV !== "production" && (hk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: l.oneOfType([l.func, l.shape({
    current: l.shape({
      focusVisible: l.func.isRequired
    })
  })]),
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  className: l.string,
  component: l.elementType,
  /**
   * The date to show.
   */
  day: l.any.isRequired,
  /**
   * If `true`, renders as disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: l.bool,
  /**
   * If `true`, days are rendering without margin. Useful for displaying linked range of days.
   * @default false
   */
  disableMargin: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: l.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: l.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: l.string,
  isAnimating: l.bool,
  /**
   * If `true`, day is the first visible cell of the month.
   * Either the first day of the month or the first day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isFirstVisibleCell: l.bool.isRequired,
  /**
   * If `true`, day is the last visible cell of the month.
   * Either the last day of the month or the last day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isLastVisibleCell: l.bool.isRequired,
  onBlur: l.func,
  onDaySelect: l.func.isRequired,
  onFocus: l.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: l.func,
  onKeyDown: l.func,
  onMouseEnter: l.func,
  /**
   * If `true`, day is outside of month and will be hidden.
   */
  outsideCurrentMonth: l.bool.isRequired,
  /**
   * If `true`, renders as selected.
   * @default false
   */
  selected: l.bool,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: l.bool,
  style: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * @default 0
   */
  tabIndex: l.number,
  /**
   * If `true`, renders as today date.
   * @default false
   */
  today: l.bool,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: l.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: l.oneOfType([l.func, l.shape({
    current: l.shape({
      pulsate: l.func.isRequired,
      start: l.func.isRequired,
      stop: l.func.isRequired
    })
  })])
});
const Yce = /* @__PURE__ */ y.memo(hk), Xce = (e) => _e("MuiPickersSlideTransition", e), rr = Re("MuiPickersSlideTransition", ["root", "slideEnter-left", "slideEnter-right", "slideEnterActive", "slideExit", "slideExitActiveLeft-left", "slideExitActiveLeft-right"]), Jce = ["children", "className", "reduceAnimations", "slideDirection", "transKey", "classes"], Qce = (e) => {
  const {
    classes: t,
    slideDirection: n
  } = e, o = {
    root: ["root"],
    exit: ["slideExit"],
    enterActive: ["slideEnterActive"],
    enter: [`slideEnter-${n}`],
    exitActive: [`slideExitActiveLeft-${n}`]
  };
  return Oe(o, Xce, t);
}, e0e = B(k0, {
  name: "MuiPickersSlideTransition",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`.${rr["slideEnter-left"]}`]: t["slideEnter-left"]
  }, {
    [`.${rr["slideEnter-right"]}`]: t["slideEnter-right"]
  }, {
    [`.${rr.slideEnterActive}`]: t.slideEnterActive
  }, {
    [`.${rr.slideExit}`]: t.slideExit
  }, {
    [`.${rr["slideExitActiveLeft-left"]}`]: t["slideExitActiveLeft-left"]
  }, {
    [`.${rr["slideExitActiveLeft-right"]}`]: t["slideExitActiveLeft-right"]
  }]
})(({
  theme: e
}) => {
  const t = e.transitions.create("transform", {
    duration: e.transitions.duration.complex,
    easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
  });
  return {
    display: "block",
    position: "relative",
    overflowX: "hidden",
    "& > *": {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0
    },
    [`& .${rr["slideEnter-left"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      zIndex: 1
    },
    [`& .${rr["slideEnter-right"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      zIndex: 1
    },
    [`& .${rr.slideEnterActive}`]: {
      transform: "translate(0%)",
      transition: t
    },
    [`& .${rr.slideExit}`]: {
      transform: "translate(0%)"
    },
    [`& .${rr["slideExitActiveLeft-left"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      transition: t,
      zIndex: 0
    },
    [`& .${rr["slideExitActiveLeft-right"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      transition: t,
      zIndex: 0
    }
  };
});
function t0e(e) {
  const t = jt({
    props: e,
    name: "MuiPickersSlideTransition"
  }), {
    children: n,
    className: o,
    reduceAnimations: r,
    transKey: i
    // extracting `classes` from `other`
  } = t, s = le(t, Jce), a = Qce(t), c = ge();
  if (r)
    return /* @__PURE__ */ f.jsx("div", {
      className: xe(a.root, o),
      children: n
    });
  const d = {
    exit: a.exit,
    enterActive: a.enterActive,
    enter: a.enter,
    exitActive: a.exitActive
  };
  return /* @__PURE__ */ f.jsx(e0e, {
    className: xe(a.root, o),
    childFactory: (u) => /* @__PURE__ */ y.cloneElement(u, {
      classNames: d
    }),
    role: "presentation",
    children: /* @__PURE__ */ f.jsx(k4, T({
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: c.transitions.duration.complex,
      classNames: d
    }, s, {
      children: n
    }), i)
  });
}
const gk = ({
  shouldDisableDate: e,
  shouldDisableMonth: t,
  shouldDisableYear: n,
  minDate: o,
  maxDate: r,
  disableFuture: i,
  disablePast: s,
  timezone: a
}) => {
  const c = Aa();
  return y.useCallback((d) => W0({
    adapter: c,
    value: d,
    props: {
      shouldDisableDate: e,
      shouldDisableMonth: t,
      shouldDisableYear: n,
      minDate: o,
      maxDate: r,
      disableFuture: i,
      disablePast: s,
      timezone: a
    }
  }) !== null, [c, e, t, n, o, r, i, s, a]);
}, n0e = (e) => _e("MuiDayCalendar", e);
Re("MuiDayCalendar", ["root", "header", "weekDayLabel", "loadingContainer", "slideTransition", "monthContainer", "weekContainer", "weekNumberLabel", "weekNumber"]);
const o0e = ["parentProps", "day", "focusableDay", "selectedDays", "isDateDisabled", "currentMonthNumber", "isViewFocused"], r0e = ["ownerState"], i0e = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"],
    header: ["header"],
    weekDayLabel: ["weekDayLabel"],
    loadingContainer: ["loadingContainer"],
    slideTransition: ["slideTransition"],
    monthContainer: ["monthContainer"],
    weekContainer: ["weekContainer"],
    weekNumberLabel: ["weekNumberLabel"],
    weekNumber: ["weekNumber"]
  }, n0e, t);
}, mk = (Jc + Y3 * 2) * 6, s0e = B("div", {
  name: "MuiDayCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), a0e = B("div", {
  name: "MuiDayCalendar",
  slot: "Header",
  overridesResolver: (e, t) => t.header
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}), l0e = B(oe, {
  name: "MuiDayCalendar",
  slot: "WeekDayLabel",
  overridesResolver: (e, t) => t.weekDayLabel
})(({
  theme: e
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: (e.vars || e).palette.text.secondary
})), c0e = B(oe, {
  name: "MuiDayCalendar",
  slot: "WeekNumberLabel",
  overridesResolver: (e, t) => t.weekNumberLabel
})(({
  theme: e
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: e.palette.text.disabled
})), d0e = B(oe, {
  name: "MuiDayCalendar",
  slot: "WeekNumber",
  overridesResolver: (e, t) => t.weekNumber
})(({
  theme: e
}) => T({}, e.typography.caption, {
  width: Jc,
  height: Jc,
  padding: 0,
  margin: `0 ${Y3}px`,
  color: e.palette.text.disabled,
  fontSize: "0.75rem",
  alignItems: "center",
  justifyContent: "center",
  display: "inline-flex"
})), u0e = B("div", {
  name: "MuiDayCalendar",
  slot: "LoadingContainer",
  overridesResolver: (e, t) => t.loadingContainer
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: mk
}), f0e = B(t0e, {
  name: "MuiDayCalendar",
  slot: "SlideTransition",
  overridesResolver: (e, t) => t.slideTransition
})({
  minHeight: mk
}), p0e = B("div", {
  name: "MuiDayCalendar",
  slot: "MonthContainer",
  overridesResolver: (e, t) => t.monthContainer
})({
  overflow: "hidden"
}), h0e = B("div", {
  name: "MuiDayCalendar",
  slot: "WeekContainer",
  overridesResolver: (e, t) => t.weekContainer
})({
  margin: `${Y3}px 0`,
  display: "flex",
  justifyContent: "center"
});
function g0e(e) {
  var t, n, o;
  let {
    parentProps: r,
    day: i,
    focusableDay: s,
    selectedDays: a,
    isDateDisabled: c,
    currentMonthNumber: d,
    isViewFocused: u
  } = e, p = le(e, o0e);
  const {
    disabled: h,
    disableHighlightToday: g,
    isMonthSwitchingAnimating: m,
    showDaysOutsideCurrentMonth: b,
    components: C,
    componentsProps: x,
    slots: v,
    slotProps: S,
    timezone: M
  } = r, w = kt(), k = Fa(M), E = s !== null && w.isSameDay(i, s), R = a.some(($) => w.isSameDay($, i)), O = w.isSameDay(i, k), P = (t = (n = v == null ? void 0 : v.day) != null ? n : C == null ? void 0 : C.Day) != null ? t : Yce, _ = yn({
    elementType: P,
    externalSlotProps: (o = S == null ? void 0 : S.day) != null ? o : x == null ? void 0 : x.day,
    additionalProps: T({
      disableHighlightToday: g,
      showDaysOutsideCurrentMonth: b,
      role: "gridcell",
      isAnimating: m,
      // it is used in date range dragging logic by accessing `dataset.timestamp`
      "data-timestamp": w.toJsDate(i).valueOf()
    }, p),
    ownerState: T({}, r, {
      day: i,
      selected: R
    })
  }), L = le(_, r0e), V = y.useMemo(() => h || c(i), [h, c, i]), j = y.useMemo(() => w.getMonth(i) !== d, [w, i, d]), I = y.useMemo(() => {
    const $ = w.startOfMonth(w.setMonth(i, d));
    return b ? w.isSameDay(i, w.startOfWeek($)) : w.isSameDay(i, $);
  }, [d, i, b, w]), F = y.useMemo(() => {
    const $ = w.endOfMonth(w.setMonth(i, d));
    return b ? w.isSameDay(i, w.endOfWeek($)) : w.isSameDay(i, $);
  }, [d, i, b, w]);
  return /* @__PURE__ */ f.jsx(P, T({}, L, {
    day: i,
    disabled: V,
    autoFocus: u && E,
    today: O,
    outsideCurrentMonth: j,
    isFirstVisibleCell: I,
    isLastVisibleCell: F,
    selected: R,
    tabIndex: E ? 0 : -1,
    "aria-selected": R,
    "aria-current": O ? "date" : void 0
  }));
}
function m0e(e) {
  const t = jt({
    props: e,
    name: "MuiDayCalendar"
  }), {
    onFocusedDayChange: n,
    className: o,
    currentMonth: r,
    selectedDays: i,
    focusedDay: s,
    loading: a,
    onSelectedDaysChange: c,
    onMonthSwitchingAnimationEnd: d,
    readOnly: u,
    reduceAnimations: p,
    renderLoading: h = () => /* @__PURE__ */ f.jsx("span", {
      children: "..."
    }),
    slideDirection: g,
    TransitionProps: m,
    disablePast: b,
    disableFuture: C,
    minDate: x,
    maxDate: v,
    shouldDisableDate: S,
    shouldDisableMonth: M,
    shouldDisableYear: w,
    dayOfWeekFormatter: k,
    hasFocus: E,
    onFocusedViewChange: R,
    gridLabelId: O,
    displayWeekNumber: P,
    fixedWeekNumber: _,
    autoFocus: L,
    timezone: V
  } = t, j = Fa(V), I = kt(), F = i0e(t), A = ge().direction === "rtl", H = k || ((me, Ie) => I.format(Ie, "weekdayShort").charAt(0).toUpperCase()), N = gk({
    shouldDisableDate: S,
    shouldDisableMonth: M,
    shouldDisableYear: w,
    minDate: x,
    maxDate: v,
    disablePast: b,
    disableFuture: C,
    timezone: V
  }), z = $n(), [se, ne] = Fn({
    name: "DayCalendar",
    state: "hasFocus",
    controlled: E,
    default: L ?? !1
  }), [Z, q] = y.useState(() => s || j), G = Ke((me) => {
    u || c(me);
  }), K = (me) => {
    N(me) || (n(me), q(me), R == null || R(!0), ne(!0));
  }, Q = Ke((me, Ie) => {
    switch (me.key) {
      case "ArrowUp":
        K(I.addDays(Ie, -7)), me.preventDefault();
        break;
      case "ArrowDown":
        K(I.addDays(Ie, 7)), me.preventDefault();
        break;
      case "ArrowLeft": {
        const te = I.addDays(Ie, A ? 1 : -1), ie = I.addMonths(Ie, A ? 1 : -1), ye = bc({
          utils: I,
          date: te,
          minDate: A ? te : I.startOfMonth(ie),
          maxDate: A ? I.endOfMonth(ie) : te,
          isDateDisabled: N,
          timezone: V
        });
        K(ye || te), me.preventDefault();
        break;
      }
      case "ArrowRight": {
        const te = I.addDays(Ie, A ? -1 : 1), ie = I.addMonths(Ie, A ? -1 : 1), ye = bc({
          utils: I,
          date: te,
          minDate: A ? I.startOfMonth(ie) : te,
          maxDate: A ? te : I.endOfMonth(ie),
          isDateDisabled: N,
          timezone: V
        });
        K(ye || te), me.preventDefault();
        break;
      }
      case "Home":
        K(I.startOfWeek(Ie)), me.preventDefault();
        break;
      case "End":
        K(I.endOfWeek(Ie)), me.preventDefault();
        break;
      case "PageUp":
        K(I.addMonths(Ie, 1)), me.preventDefault();
        break;
      case "PageDown":
        K(I.addMonths(Ie, -1)), me.preventDefault();
        break;
    }
  }), re = Ke((me, Ie) => K(Ie)), U = Ke((me, Ie) => {
    se && I.isSameDay(Z, Ie) && (R == null || R(!1));
  }), W = I.getMonth(r), D = y.useMemo(() => i.filter((me) => !!me).map((me) => I.startOfDay(me)), [I, i]), X = W, de = y.useMemo(() => /* @__PURE__ */ y.createRef(), [X]), ue = I.startOfWeek(j), he = y.useMemo(() => {
    const me = I.startOfMonth(r), Ie = I.endOfMonth(r);
    return N(Z) || I.isAfterDay(Z, Ie) || I.isBeforeDay(Z, me) ? bc({
      utils: I,
      date: Z,
      minDate: me,
      maxDate: Ie,
      disablePast: b,
      disableFuture: C,
      isDateDisabled: N,
      timezone: V
    }) : Z;
  }, [r, C, b, Z, N, I, V]), Ue = y.useMemo(() => {
    const me = I.setTimezone(r, V), Ie = I.getWeekArray(me);
    let te = I.addMonths(me, 1);
    for (; _ && Ie.length < _; ) {
      const ie = I.getWeekArray(te), ye = I.isSameDay(Ie[Ie.length - 1][0], ie[0][0]);
      ie.slice(ye ? 1 : 0).forEach((Ne) => {
        Ie.length < _ && Ie.push(Ne);
      }), te = I.addMonths(te, 1);
    }
    return Ie;
  }, [r, _, I, V]);
  return /* @__PURE__ */ f.jsxs(s0e, {
    role: "grid",
    "aria-labelledby": O,
    className: F.root,
    children: [/* @__PURE__ */ f.jsxs(a0e, {
      role: "row",
      className: F.header,
      children: [P && /* @__PURE__ */ f.jsx(c0e, {
        variant: "caption",
        role: "columnheader",
        "aria-label": z.calendarWeekNumberHeaderLabel,
        className: F.weekNumberLabel,
        children: z.calendarWeekNumberHeaderText
      }), l2e(I, j).map((me, Ie) => {
        var te;
        const ie = I.format(me, "weekdayShort");
        return /* @__PURE__ */ f.jsx(l0e, {
          variant: "caption",
          role: "columnheader",
          "aria-label": I.format(I.addDays(ue, Ie), "weekday"),
          className: F.weekDayLabel,
          children: (te = H == null ? void 0 : H(ie, me)) != null ? te : ie
        }, ie + Ie.toString());
      })]
    }), a ? /* @__PURE__ */ f.jsx(u0e, {
      className: F.loadingContainer,
      children: h()
    }) : /* @__PURE__ */ f.jsx(f0e, T({
      transKey: X,
      onExited: d,
      reduceAnimations: p,
      slideDirection: g,
      className: xe(o, F.slideTransition)
    }, m, {
      nodeRef: de,
      children: /* @__PURE__ */ f.jsx(p0e, {
        ref: de,
        role: "rowgroup",
        className: F.monthContainer,
        children: Ue.map((me, Ie) => /* @__PURE__ */ f.jsxs(h0e, {
          role: "row",
          className: F.weekContainer,
          "aria-rowindex": Ie + 1,
          children: [P && /* @__PURE__ */ f.jsx(d0e, {
            className: F.weekNumber,
            role: "rowheader",
            "aria-label": z.calendarWeekNumberAriaLabelText(I.getWeekNumber(me[0])),
            children: z.calendarWeekNumberText(I.getWeekNumber(me[0]))
          }), me.map((te, ie) => /* @__PURE__ */ f.jsx(g0e, {
            parentProps: t,
            day: te,
            selectedDays: D,
            focusableDay: he,
            onKeyDown: Q,
            onFocus: re,
            onBlur: U,
            onDaySelect: G,
            isDateDisabled: N,
            currentMonthNumber: W,
            isViewFocused: se,
            "aria-colindex": ie + 1
          }, te.toString()))]
        }, `week-${me[0]}`))
      })
    }))]
  });
}
const b0e = (e, t, n) => (o, r) => {
  switch (r.type) {
    case "changeMonth":
      return T({}, o, {
        slideDirection: r.direction,
        currentMonth: r.newMonth,
        isMonthSwitchingAnimating: !e
      });
    case "finishMonthSwitchingAnimation":
      return T({}, o, {
        isMonthSwitchingAnimating: !1
      });
    case "changeFocusedDay": {
      if (o.focusedDay != null && r.focusedDay != null && n.isSameDay(r.focusedDay, o.focusedDay))
        return o;
      const i = r.focusedDay != null && !t && !n.isSameMonth(o.currentMonth, r.focusedDay);
      return T({}, o, {
        focusedDay: r.focusedDay,
        isMonthSwitchingAnimating: i && !e && !r.withoutMonthSwitchingAnimation,
        currentMonth: i ? n.startOfMonth(r.focusedDay) : o.currentMonth,
        slideDirection: r.focusedDay != null && n.isAfterDay(r.focusedDay, o.currentMonth) ? "left" : "right"
      });
    }
    default:
      throw new Error("missing support");
  }
}, C0e = (e) => {
  const {
    value: t,
    referenceDate: n,
    defaultCalendarMonth: o,
    disableFuture: r,
    disablePast: i,
    disableSwitchToMonthOnDayFocus: s = !1,
    maxDate: a,
    minDate: c,
    onMonthChange: d,
    reduceAnimations: u,
    shouldDisableDate: p,
    timezone: h
  } = e, g = kt(), m = y.useRef(b0e(!!u, s, g)).current, b = y.useMemo(
    () => {
      let E = null;
      return n ? E = n : o && (E = g.startOfMonth(o)), Nn.getInitialReferenceValue({
        value: t,
        utils: g,
        timezone: h,
        props: e,
        referenceDate: E,
        granularity: Er.day
      });
    },
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), [C, x] = y.useReducer(m, {
    isMonthSwitchingAnimating: !1,
    focusedDay: b,
    currentMonth: g.startOfMonth(b),
    slideDirection: "left"
  }), v = y.useCallback((E) => {
    x(T({
      type: "changeMonth"
    }, E)), d && d(E.newMonth);
  }, [d]), S = y.useCallback((E) => {
    const R = E;
    g.isSameMonth(R, C.currentMonth) || v({
      newMonth: g.startOfMonth(R),
      direction: g.isAfterDay(R, C.currentMonth) ? "left" : "right"
    });
  }, [C.currentMonth, v, g]), M = gk({
    shouldDisableDate: p,
    minDate: c,
    maxDate: a,
    disableFuture: r,
    disablePast: i,
    timezone: h
  }), w = y.useCallback(() => {
    x({
      type: "finishMonthSwitchingAnimation"
    });
  }, []), k = Ke((E, R) => {
    M(E) || x({
      type: "changeFocusedDay",
      focusedDay: E,
      withoutMonthSwitchingAnimation: R
    });
  });
  return {
    referenceDate: b,
    calendarState: C,
    changeMonth: S,
    changeFocusedDay: k,
    isDateDisabled: M,
    onMonthSwitchingAnimationEnd: w,
    handleChangeMonth: v
  };
}, x0e = ["props", "getOpenDialogAriaText"], y0e = ["ownerState"], v0e = ["ownerState"], Ah = (e) => {
  var t, n, o, r, i;
  let {
    props: s,
    getOpenDialogAriaText: a
  } = e, c = le(e, x0e);
  const {
    slots: d,
    slotProps: u,
    className: p,
    sx: h,
    format: g,
    formatDensity: m,
    timezone: b,
    name: C,
    label: x,
    inputRef: v,
    readOnly: S,
    disabled: M,
    autoFocus: w,
    localeText: k,
    reduceAnimations: E
  } = s, R = kt(), O = y.useRef(null), P = y.useRef(null), _ = di(), L = (t = u == null || (n = u.toolbar) == null ? void 0 : n.hidden) != null ? t : !1, {
    open: V,
    actions: j,
    hasUIView: I,
    layoutProps: F,
    renderCurrentView: $,
    shouldRestoreFocus: A,
    fieldProps: H
  } = sk(T({}, c, {
    props: s,
    inputRef: O,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "desktop"
  })), N = (o = d.inputAdornment) != null ? o : Fc, z = yn({
    elementType: N,
    externalSlotProps: u == null ? void 0 : u.inputAdornment,
    additionalProps: {
      position: "end"
    },
    ownerState: s
  }), se = le(z, y0e), ne = (r = d.openPickerButton) != null ? r : Bt, Z = yn({
    elementType: ne,
    externalSlotProps: u == null ? void 0 : u.openPickerButton,
    additionalProps: {
      disabled: M || S,
      onClick: V ? j.onClose : j.onOpen,
      "aria-label": a(H.value, R),
      edge: se.position
    },
    ownerState: s
  }), q = le(Z, v0e), G = d.openPickerIcon, K = d.field, Q = yn({
    elementType: K,
    externalSlotProps: u == null ? void 0 : u.field,
    additionalProps: T({}, H, L && {
      id: _
    }, {
      readOnly: S,
      disabled: M,
      className: p,
      sx: h,
      format: g,
      formatDensity: m,
      timezone: b,
      label: x,
      name: C,
      autoFocus: w && !s.open,
      focused: V ? !0 : void 0
    }),
    ownerState: s
  });
  I && (Q.InputProps = T({}, Q.InputProps, {
    ref: P
  }, !s.disableOpenPicker && {
    [`${se.position}Adornment`]: /* @__PURE__ */ f.jsx(N, T({}, se, {
      children: /* @__PURE__ */ f.jsx(ne, T({}, q, {
        children: /* @__PURE__ */ f.jsx(G, T({}, u == null ? void 0 : u.openPickerIcon))
      }))
    }))
  }));
  const re = T({
    textField: d.textField,
    clearIcon: d.clearIcon,
    clearButton: d.clearButton
  }, Q.slots), U = (i = d.layout) != null ? i : jh, W = Tt(O, Q.inputRef, v);
  let D = _;
  L && (x ? D = `${_}-label` : D = void 0);
  const X = T({}, u, {
    toolbar: T({}, u == null ? void 0 : u.toolbar, {
      titleId: _
    }),
    popper: T({
      "aria-labelledby": D
    }, u == null ? void 0 : u.popper)
  });
  return {
    renderPicker: () => /* @__PURE__ */ f.jsxs(Rh, {
      localeText: k,
      children: [/* @__PURE__ */ f.jsx(K, T({}, Q, {
        slots: re,
        slotProps: X,
        inputRef: W
      })), /* @__PURE__ */ f.jsx(dce, T({
        role: "dialog",
        placement: "bottom-start",
        anchorEl: P.current
      }, j, {
        open: V,
        slots: d,
        slotProps: X,
        shouldRestoreFocus: A,
        reduceAnimations: E,
        children: /* @__PURE__ */ f.jsx(U, T({}, F, X == null ? void 0 : X.layout, {
          slots: d,
          slotProps: X,
          children: $()
        }))
      }))]
    })
  };
}, w0e = (e) => {
  var t, n, o;
  const r = kt(), i = Ha();
  return T({}, e, {
    disablePast: (t = e.disablePast) != null ? t : !1,
    disableFuture: (n = e.disableFuture) != null ? n : !1,
    format: (o = e.format) != null ? o : r.formats.keyboardDate,
    minDate: go(r, e.minDate, i.minDate),
    maxDate: go(r, e.maxDate, i.maxDate)
  });
}, S0e = ({
  props: e,
  inputRef: t
}) => {
  const n = w0e(e), {
    forwardedProps: o,
    internalProps: r
  } = Vh(n, "date");
  return Ih({
    inputRef: t,
    forwardedProps: o,
    internalProps: r,
    valueManager: Nn,
    fieldValueManager: Eh,
    validator: W0,
    valueType: "date"
  });
}, M0e = ["ownerState"], Hh = ({
  clearable: e,
  fieldProps: t,
  InputProps: n,
  onClear: o,
  slots: r,
  slotProps: i,
  components: s,
  componentsProps: a
}) => {
  var c, d, u, p, h, g;
  const m = $n(), b = (c = (d = r == null ? void 0 : r.clearButton) != null ? d : s == null ? void 0 : s.ClearButton) != null ? c : Bt, C = yn({
    elementType: b,
    externalSlotProps: (u = i == null ? void 0 : i.clearButton) != null ? u : a == null ? void 0 : a.clearButton,
    ownerState: {},
    className: "clearButton",
    additionalProps: {
      title: m.fieldClearLabel
    }
  }), x = le(C, M0e), v = (p = (h = r == null ? void 0 : r.clearIcon) != null ? h : s == null ? void 0 : s.ClearIcon) != null ? p : $2e, S = yn({
    elementType: v,
    externalSlotProps: (g = i == null ? void 0 : i.clearIcon) != null ? g : a == null ? void 0 : a.clearIcon,
    ownerState: {}
  }), M = T({}, n, {
    endAdornment: /* @__PURE__ */ f.jsxs(y.Fragment, {
      children: [e && /* @__PURE__ */ f.jsx(Fc, {
        position: "end",
        sx: {
          marginRight: n != null && n.endAdornment ? -1 : -1.5
        },
        children: /* @__PURE__ */ f.jsx(b, T({}, x, {
          onClick: o,
          children: /* @__PURE__ */ f.jsx(v, T({
            fontSize: "small"
          }, S))
        }))
      }), n == null ? void 0 : n.endAdornment]
    })
  }), w = T({}, t, {
    sx: [{
      "& .clearButton": {
        opacity: 1
      },
      "@media (pointer: fine)": {
        "& .clearButton": {
          opacity: 0
        },
        "&:hover, &:focus-within": {
          ".clearButton": {
            opacity: 1
          }
        }
      }
    }, ...Array.isArray(t.sx) ? t.sx : [t.sx]]
  });
  return {
    InputProps: M,
    fieldProps: w
  };
}, T0e = ["components", "componentsProps", "slots", "slotProps", "InputProps", "inputProps"], k0e = ["inputRef"], E0e = ["ref", "onPaste", "onKeyDown", "inputMode", "readOnly", "clearable", "onClear"], Fh = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i;
  const s = jt({
    props: t,
    name: "MuiDateField"
  }), {
    components: a,
    componentsProps: c,
    slots: d,
    slotProps: u,
    InputProps: p,
    inputProps: h
  } = s, g = le(s, T0e), m = s, b = (o = (r = d == null ? void 0 : d.textField) != null ? r : a == null ? void 0 : a.TextField) != null ? o : Ir, C = yn({
    elementType: b,
    externalSlotProps: (i = u == null ? void 0 : u.textField) != null ? i : c == null ? void 0 : c.textField,
    externalForwardedProps: g,
    ownerState: m
  }), {
    inputRef: x
  } = C, v = le(C, k0e);
  v.inputProps = T({}, h, v.inputProps), v.InputProps = T({}, p, v.InputProps);
  const S = S0e({
    props: v,
    inputRef: x
  }), {
    ref: M,
    onPaste: w,
    onKeyDown: k,
    inputMode: E,
    readOnly: R,
    clearable: O,
    onClear: P
  } = S, _ = le(S, E0e), {
    InputProps: L,
    fieldProps: V
  } = Hh({
    onClear: P,
    clearable: O,
    fieldProps: _,
    InputProps: _.InputProps,
    slots: d,
    slotProps: u,
    components: a,
    componentsProps: c
  });
  return /* @__PURE__ */ f.jsx(b, T({
    ref: n
  }, V, {
    InputProps: T({}, L, {
      readOnly: R
    }),
    inputProps: T({}, _.inputProps, {
      inputMode: E,
      onPaste: w,
      onKeyDown: k,
      ref: M
    })
  }));
});
process.env.NODE_ENV !== "production" && (Fh.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: l.bool,
  className: l.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: l.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: l.elementType,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: l.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: l.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The helper text content.
   */
  helperText: l.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: l.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: l.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: l.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: l.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: l.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  onBlur: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  onFocus: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: l.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: l.any,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: l.bool,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: l.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: l.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: l.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default `false`
   */
  shouldRespectLeadingZeros: l.bool,
  /**
   * The size of the component.
   */
  size: l.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  style: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: l.oneOfType([l.func, l.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: l.oneOf(["filled", "outlined", "standard"])
});
const R0e = (e) => _e("MuiPickersFadeTransitionGroup", e);
Re("MuiPickersFadeTransitionGroup", ["root"]);
const O0e = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"]
  }, R0e, t);
}, _0e = B(k0, {
  name: "MuiPickersFadeTransitionGroup",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "block",
  position: "relative"
});
function bk(e) {
  const t = jt({
    props: e,
    name: "MuiPickersFadeTransitionGroup"
  }), {
    children: n,
    className: o,
    reduceAnimations: r,
    transKey: i
  } = t, s = O0e(t), a = ge();
  return r ? n : /* @__PURE__ */ f.jsx(_0e, {
    className: xe(s.root, o),
    children: /* @__PURE__ */ f.jsx(Ia, {
      appear: !1,
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: {
        appear: a.transitions.duration.enteringScreen,
        enter: a.transitions.duration.enteringScreen,
        exit: 0
      },
      children: n
    }, i)
  });
}
function P0e(e) {
  return _e("MuiPickersMonth", e);
}
const B1 = Re("MuiPickersMonth", ["root", "monthButton", "disabled", "selected"]), L0e = ["autoFocus", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "aria-label", "monthsPerRow"], I0e = (e) => {
  const {
    disabled: t,
    selected: n,
    classes: o
  } = e;
  return Oe({
    root: ["root"],
    monthButton: ["monthButton", t && "disabled", n && "selected"]
  }, P0e, o);
}, j0e = B("div", {
  name: "MuiPickersMonth",
  slot: "Root",
  overridesResolver: (e, t) => [t.root]
})(({
  ownerState: e
}) => ({
  flexBasis: e.monthsPerRow === 3 ? "33.3%" : "25%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
})), V0e = B("button", {
  name: "MuiPickersMonth",
  slot: "MonthButton",
  overridesResolver: (e, t) => [t.monthButton, {
    [`&.${B1.disabled}`]: t.disabled
  }, {
    [`&.${B1.selected}`]: t.selected
  }]
})(({
  theme: e
}) => T({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, e.typography.subtitle1, {
  margin: "8px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : $t(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : $t(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${B1.disabled}`]: {
    color: (e.vars || e).palette.text.secondary
  },
  [`&.${B1.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  }
})), D0e = /* @__PURE__ */ y.memo(function(t) {
  const n = jt({
    props: t,
    name: "MuiPickersMonth"
  }), {
    autoFocus: o,
    children: r,
    disabled: i,
    selected: s,
    value: a,
    tabIndex: c,
    onClick: d,
    onKeyDown: u,
    onFocus: p,
    onBlur: h,
    "aria-current": g,
    "aria-label": m
    // We don't want to forward this prop to the root element
  } = n, b = le(n, L0e), C = y.useRef(null), x = I0e(n);
  return En(() => {
    if (o) {
      var v;
      (v = C.current) == null || v.focus();
    }
  }, [o]), /* @__PURE__ */ f.jsx(j0e, T({
    className: x.root,
    ownerState: n
  }, b, {
    children: /* @__PURE__ */ f.jsx(V0e, {
      ref: C,
      disabled: i,
      type: "button",
      role: "radio",
      tabIndex: i ? -1 : c,
      "aria-current": g,
      "aria-checked": s,
      "aria-label": m,
      onClick: (v) => d(v, a),
      onKeyDown: (v) => u(v, a),
      onFocus: (v) => p(v, a),
      onBlur: (v) => h(v, a),
      className: x.monthButton,
      ownerState: n,
      children: r
    })
  }));
});
function A0e(e) {
  return _e("MuiMonthCalendar", e);
}
Re("MuiMonthCalendar", ["root"]);
const H0e = ["className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "shouldDisableMonth", "readOnly", "disableHighlightToday", "autoFocus", "onMonthFocus", "hasFocus", "onFocusedViewChange", "monthsPerRow", "timezone", "gridLabelId"], F0e = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"]
  }, A0e, t);
};
function N0e(e, t) {
  const n = kt(), o = Ha(), r = jt({
    props: e,
    name: t
  });
  return T({
    disableFuture: !1,
    disablePast: !1
  }, r, {
    minDate: go(n, r.minDate, o.minDate),
    maxDate: go(n, r.maxDate, o.maxDate)
  });
}
const $0e = B("div", {
  name: "MuiMonthCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexWrap: "wrap",
  alignContent: "stretch",
  padding: "0 4px",
  width: X3,
  // avoid padding increasing width over defined
  boxSizing: "border-box"
}), Ck = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = N0e(t, "MuiMonthCalendar"), {
    className: r,
    value: i,
    defaultValue: s,
    referenceDate: a,
    disabled: c,
    disableFuture: d,
    disablePast: u,
    maxDate: p,
    minDate: h,
    onChange: g,
    shouldDisableMonth: m,
    readOnly: b,
    disableHighlightToday: C,
    autoFocus: x = !1,
    onMonthFocus: v,
    hasFocus: S,
    onFocusedViewChange: M,
    monthsPerRow: w = 3,
    timezone: k,
    gridLabelId: E
  } = o, R = le(o, H0e), {
    value: O,
    handleValueChange: P,
    timezone: _
  } = b2({
    name: "MonthCalendar",
    timezone: k,
    value: i,
    defaultValue: s,
    onChange: g,
    valueManager: Nn
  }), L = Fa(_), V = e2(), j = kt(), I = y.useMemo(
    () => Nn.getInitialReferenceValue({
      value: O,
      utils: j,
      props: o,
      timezone: _,
      referenceDate: a,
      granularity: Er.month
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), F = o, $ = F0e(F), A = y.useMemo(() => j.getMonth(L), [j, L]), H = y.useMemo(() => O != null ? j.getMonth(O) : C ? null : j.getMonth(I), [O, j, C, I]), [N, z] = y.useState(() => H || A), [se, ne] = Fn({
    name: "MonthCalendar",
    state: "hasFocus",
    controlled: S,
    default: x ?? !1
  }), Z = Ke((W) => {
    ne(W), M && M(W);
  }), q = y.useCallback((W) => {
    const D = j.startOfMonth(u && j.isAfter(L, h) ? L : h), X = j.startOfMonth(d && j.isBefore(L, p) ? L : p), de = j.startOfMonth(W);
    return j.isBefore(de, D) || j.isAfter(de, X) ? !0 : m ? m(de) : !1;
  }, [d, u, p, h, L, m, j]), G = Ke((W, D) => {
    if (b)
      return;
    const X = j.setMonth(O ?? I, D);
    P(X);
  }), K = Ke((W) => {
    q(j.setMonth(O ?? I, W)) || (z(W), Z(!0), v && v(W));
  });
  y.useEffect(() => {
    z((W) => H !== null && W !== H ? H : W);
  }, [H]);
  const Q = Ke((W, D) => {
    switch (W.key) {
      case "ArrowUp":
        K((12 + D - 3) % 12), W.preventDefault();
        break;
      case "ArrowDown":
        K((12 + D + 3) % 12), W.preventDefault();
        break;
      case "ArrowLeft":
        K((12 + D + (V.direction === "ltr" ? -1 : 1)) % 12), W.preventDefault();
        break;
      case "ArrowRight":
        K((12 + D + (V.direction === "ltr" ? 1 : -1)) % 12), W.preventDefault();
        break;
    }
  }), re = Ke((W, D) => {
    K(D);
  }), U = Ke((W, D) => {
    N === D && Z(!1);
  });
  return /* @__PURE__ */ f.jsx($0e, T({
    ref: n,
    className: xe($.root, r),
    ownerState: F,
    role: "radiogroup",
    "aria-labelledby": E
  }, R, {
    children: Sh(j, O ?? I).map((W) => {
      const D = j.getMonth(W), X = j.format(W, "monthShort"), de = j.format(W, "month"), ue = D === H, he = c || q(W);
      return /* @__PURE__ */ f.jsx(D0e, {
        selected: ue,
        value: D,
        onClick: G,
        onKeyDown: Q,
        autoFocus: se && D === N,
        disabled: he,
        tabIndex: D === N ? 0 : -1,
        onFocus: re,
        onBlur: U,
        "aria-current": A === D ? "date" : void 0,
        "aria-label": de,
        monthsPerRow: w,
        children: X
      }, X);
    })
  }));
});
process.env.NODE_ENV !== "production" && (Ck.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * className applied to the root element.
   */
  className: l.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true` picker is disabled
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  gridLabelId: l.string,
  hasFocus: l.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: l.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: l.func,
  onFocusedViewChange: l.func,
  onMonthFocus: l.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid month using the validation props, except callbacks such as `shouldDisableMonth`.
   */
  referenceDate: l.any,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: l.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any
});
function B0e(e) {
  return _e("MuiPickersYear", e);
}
const z1 = Re("MuiPickersYear", ["root", "yearButton", "selected", "disabled"]), z0e = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "yearsPerRow"], Z0e = (e) => {
  const {
    disabled: t,
    selected: n,
    classes: o
  } = e;
  return Oe({
    root: ["root"],
    yearButton: ["yearButton", t && "disabled", n && "selected"]
  }, B0e, o);
}, W0e = B("div", {
  name: "MuiPickersYear",
  slot: "Root",
  overridesResolver: (e, t) => [t.root]
})(({
  ownerState: e
}) => ({
  flexBasis: e.yearsPerRow === 3 ? "33.3%" : "25%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
})), U0e = B("button", {
  name: "MuiPickersYear",
  slot: "YearButton",
  overridesResolver: (e, t) => [t.yearButton, {
    [`&.${z1.disabled}`]: t.disabled
  }, {
    [`&.${z1.selected}`]: t.selected
  }]
})(({
  theme: e
}) => T({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, e.typography.subtitle1, {
  margin: "6px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.focusOpacity})` : $t(e.palette.action.active, e.palette.action.focusOpacity)
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : $t(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${z1.disabled}`]: {
    color: (e.vars || e).palette.text.secondary
  },
  [`&.${z1.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  }
})), G0e = /* @__PURE__ */ y.memo(function(t) {
  const n = jt({
    props: t,
    name: "MuiPickersYear"
  }), {
    autoFocus: o,
    className: r,
    children: i,
    disabled: s,
    selected: a,
    value: c,
    tabIndex: d,
    onClick: u,
    onKeyDown: p,
    onFocus: h,
    onBlur: g,
    "aria-current": m
    // We don't want to forward this prop to the root element
  } = n, b = le(n, z0e), C = y.useRef(null), x = Z0e(n);
  return y.useEffect(() => {
    o && C.current.focus();
  }, [o]), /* @__PURE__ */ f.jsx(W0e, T({
    className: xe(x.root, r),
    ownerState: n
  }, b, {
    children: /* @__PURE__ */ f.jsx(U0e, {
      ref: C,
      disabled: s,
      type: "button",
      role: "radio",
      tabIndex: s ? -1 : d,
      "aria-current": m,
      "aria-checked": a,
      onClick: (v) => u(v, c),
      onKeyDown: (v) => p(v, c),
      onFocus: (v) => h(v, c),
      onBlur: (v) => g(v, c),
      className: x.yearButton,
      ownerState: n,
      children: i
    })
  }));
});
function q0e(e) {
  return _e("MuiYearCalendar", e);
}
Re("MuiYearCalendar", ["root"]);
const K0e = ["autoFocus", "className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "readOnly", "shouldDisableYear", "disableHighlightToday", "onYearFocus", "hasFocus", "onFocusedViewChange", "yearsPerRow", "timezone", "gridLabelId"], Y0e = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"]
  }, q0e, t);
};
function X0e(e, t) {
  var n;
  const o = kt(), r = Ha(), i = jt({
    props: e,
    name: t
  });
  return T({
    disablePast: !1,
    disableFuture: !1
  }, i, {
    yearsPerRow: (n = i.yearsPerRow) != null ? n : 3,
    minDate: go(o, i.minDate, r.minDate),
    maxDate: go(o, i.maxDate, r.maxDate)
  });
}
const J0e = B("div", {
  name: "MuiYearCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  overflowY: "auto",
  height: "100%",
  padding: "0 4px",
  width: X3,
  maxHeight: K2e,
  // avoid padding increasing width over defined
  boxSizing: "border-box",
  position: "relative"
}), xk = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = X0e(t, "MuiYearCalendar"), {
    autoFocus: r,
    className: i,
    value: s,
    defaultValue: a,
    referenceDate: c,
    disabled: d,
    disableFuture: u,
    disablePast: p,
    maxDate: h,
    minDate: g,
    onChange: m,
    readOnly: b,
    shouldDisableYear: C,
    disableHighlightToday: x,
    onYearFocus: v,
    hasFocus: S,
    onFocusedViewChange: M,
    yearsPerRow: w,
    timezone: k,
    gridLabelId: E
  } = o, R = le(o, K0e), {
    value: O,
    handleValueChange: P,
    timezone: _
  } = b2({
    name: "YearCalendar",
    timezone: k,
    value: s,
    defaultValue: a,
    onChange: m,
    valueManager: Nn
  }), L = Fa(_), V = e2(), j = kt(), I = y.useMemo(
    () => Nn.getInitialReferenceValue({
      value: O,
      utils: j,
      props: o,
      timezone: _,
      referenceDate: c,
      granularity: Er.year
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), F = o, $ = Y0e(F), A = y.useMemo(() => j.getYear(L), [j, L]), H = y.useMemo(() => O != null ? j.getYear(O) : x ? null : j.getYear(I), [O, j, x, I]), [N, z] = y.useState(() => H || A), [se, ne] = Fn({
    name: "YearCalendar",
    state: "hasFocus",
    controlled: S,
    default: r ?? !1
  }), Z = Ke((X) => {
    ne(X), M && M(X);
  }), q = y.useCallback((X) => {
    if (p && j.isBeforeYear(X, L) || u && j.isAfterYear(X, L) || g && j.isBeforeYear(X, g) || h && j.isAfterYear(X, h))
      return !0;
    if (!C)
      return !1;
    const de = j.startOfYear(X);
    return C(de);
  }, [u, p, h, g, L, C, j]), G = Ke((X, de) => {
    if (b)
      return;
    const ue = j.setYear(O ?? I, de);
    P(ue);
  }), K = Ke((X) => {
    q(j.setYear(O ?? I, X)) || (z(X), Z(!0), v == null || v(X));
  });
  y.useEffect(() => {
    z((X) => H !== null && X !== H ? H : X);
  }, [H]);
  const Q = Ke((X, de) => {
    switch (X.key) {
      case "ArrowUp":
        K(de - w), X.preventDefault();
        break;
      case "ArrowDown":
        K(de + w), X.preventDefault();
        break;
      case "ArrowLeft":
        K(de + (V.direction === "ltr" ? -1 : 1)), X.preventDefault();
        break;
      case "ArrowRight":
        K(de + (V.direction === "ltr" ? 1 : -1)), X.preventDefault();
        break;
    }
  }), re = Ke((X, de) => {
    K(de);
  }), U = Ke((X, de) => {
    N === de && Z(!1);
  }), W = y.useRef(null), D = Tt(n, W);
  return y.useEffect(() => {
    if (r || W.current === null)
      return;
    const X = W.current.querySelector('[tabindex="0"]');
    if (!X)
      return;
    const de = X.offsetHeight, ue = X.offsetTop, he = W.current.clientHeight, Ue = W.current.scrollTop, me = ue + de;
    de > he || ue < Ue || (W.current.scrollTop = me - he / 2 - de / 2);
  }, [r]), /* @__PURE__ */ f.jsx(J0e, T({
    ref: D,
    className: xe($.root, i),
    ownerState: F,
    role: "radiogroup",
    "aria-labelledby": E
  }, R, {
    children: j.getYearRange(g, h).map((X) => {
      const de = j.getYear(X), ue = de === H, he = d || q(X);
      return /* @__PURE__ */ f.jsx(G0e, {
        selected: ue,
        value: de,
        onClick: G,
        onKeyDown: Q,
        autoFocus: se && de === N,
        disabled: he,
        tabIndex: de === N ? 0 : -1,
        onFocus: re,
        onBlur: U,
        "aria-current": A === de ? "date" : void 0,
        yearsPerRow: w,
        children: j.format(X, "year")
      }, j.format(X, "year"));
    })
  }));
});
process.env.NODE_ENV !== "production" && (xk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * className applied to the root element.
   */
  className: l.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true` picker is disabled
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  gridLabelId: l.string,
  hasFocus: l.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: l.func,
  onFocusedViewChange: l.func,
  onYearFocus: l.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid year using the validation props, except callbacks such as `shouldDisableYear`.
   */
  referenceDate: l.any,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: l.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: l.oneOf([3, 4])
});
const Q0e = (e) => _e("MuiPickersCalendarHeader", e), e1e = Re("MuiPickersCalendarHeader", ["root", "labelContainer", "label", "switchViewButton", "switchViewIcon"]), t1e = ["slots", "slotProps", "components", "componentsProps", "currentMonth", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onMonthChange", "onViewChange", "view", "reduceAnimations", "views", "labelId", "className", "timezone"], n1e = ["ownerState"], o1e = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"],
    labelContainer: ["labelContainer"],
    label: ["label"],
    switchViewButton: ["switchViewButton"],
    switchViewIcon: ["switchViewIcon"]
  }, Q0e, t);
}, r1e = B("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  alignItems: "center",
  marginTop: 16,
  marginBottom: 8,
  paddingLeft: 24,
  paddingRight: 12,
  // prevent jumping in safari
  maxHeight: 30,
  minHeight: 30
}), i1e = B("div", {
  name: "MuiPickersCalendarHeader",
  slot: "LabelContainer",
  overridesResolver: (e, t) => t.labelContainer
})(({
  theme: e
}) => T({
  display: "flex",
  overflow: "hidden",
  alignItems: "center",
  cursor: "pointer",
  marginRight: "auto"
}, e.typography.body1, {
  fontWeight: e.typography.fontWeightMedium
})), s1e = B("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Label",
  overridesResolver: (e, t) => t.label
})({
  marginRight: 6
}), a1e = B(Bt, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewButton",
  overridesResolver: (e, t) => t.switchViewButton
})(({
  ownerState: e
}) => T({
  marginRight: "auto"
}, e.view === "year" && {
  [`.${e1e.switchViewIcon}`]: {
    transform: "rotate(180deg)"
  }
})), l1e = B(V2e, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewIcon",
  overridesResolver: (e, t) => t.switchViewIcon
})(({
  theme: e
}) => ({
  willChange: "transform",
  transition: e.transitions.create("transform"),
  transform: "rotate(0deg)"
})), yk = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i, s;
  const a = $n(), c = kt(), d = jt({
    props: t,
    name: "MuiPickersCalendarHeader"
  }), {
    slots: u,
    slotProps: p,
    components: h,
    currentMonth: g,
    disabled: m,
    disableFuture: b,
    disablePast: C,
    maxDate: x,
    minDate: v,
    onMonthChange: S,
    onViewChange: M,
    view: w,
    reduceAnimations: k,
    views: E,
    labelId: R,
    className: O,
    timezone: P
  } = d, _ = le(d, t1e), L = d, V = o1e(d), j = (o = (r = u == null ? void 0 : u.switchViewButton) != null ? r : h == null ? void 0 : h.SwitchViewButton) != null ? o : a1e, I = yn({
    elementType: j,
    externalSlotProps: p == null ? void 0 : p.switchViewButton,
    additionalProps: {
      size: "small",
      "aria-label": a.calendarViewSwitchingButtonAriaLabel(w)
    },
    ownerState: L,
    className: V.switchViewButton
  }), F = (i = (s = u == null ? void 0 : u.switchViewIcon) != null ? s : h == null ? void 0 : h.SwitchViewIcon) != null ? i : l1e, $ = yn({
    elementType: F,
    externalSlotProps: p == null ? void 0 : p.switchViewIcon,
    ownerState: void 0,
    className: V.switchViewIcon
  }), A = le($, n1e), H = () => S(c.addMonths(g, 1), "left"), N = () => S(c.addMonths(g, -1), "right"), z = $ce(g, {
    disableFuture: b,
    maxDate: x,
    timezone: P
  }), se = Bce(g, {
    disablePast: C,
    minDate: v,
    timezone: P
  }), ne = () => {
    if (!(E.length === 1 || !M || m))
      if (E.length === 2)
        M(E.find((Z) => Z !== w) || E[0]);
      else {
        const Z = E.indexOf(w) !== 0 ? 0 : 1;
        M(E[Z]);
      }
  };
  return E.length === 1 && E[0] === "year" ? null : /* @__PURE__ */ f.jsxs(r1e, T({}, _, {
    ownerState: L,
    className: xe(O, V.root),
    ref: n,
    children: [/* @__PURE__ */ f.jsxs(i1e, {
      role: "presentation",
      onClick: ne,
      ownerState: L,
      "aria-live": "polite",
      className: V.labelContainer,
      children: [/* @__PURE__ */ f.jsx(bk, {
        reduceAnimations: k,
        transKey: c.format(g, "monthAndYear"),
        children: /* @__PURE__ */ f.jsx(s1e, {
          id: R,
          ownerState: L,
          className: V.label,
          children: c.format(g, "monthAndYear")
        })
      }), E.length > 1 && !m && /* @__PURE__ */ f.jsx(j, T({}, I, {
        children: /* @__PURE__ */ f.jsx(F, T({}, A))
      }))]
    }), /* @__PURE__ */ f.jsx(Ia, {
      in: w === "day",
      children: /* @__PURE__ */ f.jsx(nk, {
        slots: u,
        slotProps: p,
        onGoToPrevious: N,
        isPreviousDisabled: se,
        previousLabel: a.previousMonth,
        onGoToNext: H,
        isNextDisabled: z,
        nextLabel: a.nextMonth
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (yk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * className applied to the root element.
   */
  className: l.string,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  currentMonth: l.any.isRequired,
  disabled: l.bool,
  disableFuture: l.bool,
  disablePast: l.bool,
  labelId: l.string,
  maxDate: l.any.isRequired,
  minDate: l.any.isRequired,
  onMonthChange: l.func.isRequired,
  onViewChange: l.func,
  reduceAnimations: l.bool.isRequired,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  timezone: l.string.isRequired,
  view: l.oneOf(["day", "month", "year"]).isRequired,
  views: l.arrayOf(l.oneOf(["day", "month", "year"]).isRequired).isRequired
});
const tf = B("div")({
  overflow: "hidden",
  width: X3,
  maxHeight: J3,
  display: "flex",
  flexDirection: "column",
  margin: "0 auto"
}), c1e = (e) => _e("MuiDateCalendar", e);
Re("MuiDateCalendar", ["root", "viewTransitionContainer"]);
const d1e = ["autoFocus", "onViewChange", "value", "defaultValue", "referenceDate", "disableFuture", "disablePast", "defaultCalendarMonth", "onChange", "onYearChange", "onMonthChange", "reduceAnimations", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear", "view", "views", "openTo", "className", "disabled", "readOnly", "minDate", "maxDate", "disableHighlightToday", "focusedView", "onFocusedViewChange", "showDaysOutsideCurrentMonth", "fixedWeekNumber", "dayOfWeekFormatter", "components", "componentsProps", "slots", "slotProps", "loading", "renderLoading", "displayWeekNumber", "yearsPerRow", "monthsPerRow", "timezone"], u1e = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"],
    viewTransitionContainer: ["viewTransitionContainer"]
  }, c1e, t);
};
function f1e(e, t) {
  var n, o, r, i, s, a, c;
  const d = kt(), u = Ha(), p = rk(), h = jt({
    props: e,
    name: t
  });
  return T({}, h, {
    loading: (n = h.loading) != null ? n : !1,
    disablePast: (o = h.disablePast) != null ? o : !1,
    disableFuture: (r = h.disableFuture) != null ? r : !1,
    openTo: (i = h.openTo) != null ? i : "day",
    views: (s = h.views) != null ? s : ["year", "day"],
    reduceAnimations: (a = h.reduceAnimations) != null ? a : p,
    renderLoading: (c = h.renderLoading) != null ? c : () => /* @__PURE__ */ f.jsx("span", {
      children: "..."
    }),
    minDate: go(d, h.minDate, u.minDate),
    maxDate: go(d, h.maxDate, u.maxDate)
  });
}
const p1e = B(tf, {
  name: "MuiDateCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "column",
  height: J3
}), h1e = B(bk, {
  name: "MuiDateCalendar",
  slot: "ViewTransitionContainer",
  overridesResolver: (e, t) => t.viewTransitionContainer
})({}), Nh = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i;
  const s = kt(), a = di(), c = f1e(t, "MuiDateCalendar"), {
    autoFocus: d,
    onViewChange: u,
    value: p,
    defaultValue: h,
    referenceDate: g,
    disableFuture: m,
    disablePast: b,
    defaultCalendarMonth: C,
    onChange: x,
    onYearChange: v,
    onMonthChange: S,
    reduceAnimations: M,
    shouldDisableDate: w,
    shouldDisableMonth: k,
    shouldDisableYear: E,
    view: R,
    views: O,
    openTo: P,
    className: _,
    disabled: L,
    readOnly: V,
    minDate: j,
    maxDate: I,
    disableHighlightToday: F,
    focusedView: $,
    onFocusedViewChange: A,
    showDaysOutsideCurrentMonth: H,
    fixedWeekNumber: N,
    dayOfWeekFormatter: z,
    components: se,
    componentsProps: ne,
    slots: Z,
    slotProps: q,
    loading: G,
    renderLoading: K,
    displayWeekNumber: Q,
    yearsPerRow: re,
    monthsPerRow: U,
    timezone: W
  } = c, D = le(c, d1e), {
    value: X,
    handleValueChange: de,
    timezone: ue
  } = b2({
    name: "DateCalendar",
    timezone: W,
    value: p,
    defaultValue: h,
    onChange: x,
    valueManager: Nn
  }), {
    view: he,
    setView: Ue,
    focusedView: me,
    setFocusedView: Ie,
    goToNextView: te,
    setValueAndGoToNextView: ie
  } = Z0({
    view: R,
    views: O,
    openTo: P,
    onChange: de,
    onViewChange: u,
    autoFocus: d,
    focusedView: $,
    onFocusedViewChange: A
  }), {
    referenceDate: ye,
    calendarState: Ne,
    changeFocusedDay: We,
    changeMonth: qe,
    handleChangeMonth: Me,
    isDateDisabled: Pe,
    onMonthSwitchingAnimationEnd: fe
  } = C0e({
    value: X,
    defaultCalendarMonth: C,
    referenceDate: g,
    reduceAnimations: M,
    onMonthChange: S,
    minDate: j,
    maxDate: I,
    shouldDisableDate: w,
    disablePast: b,
    disableFuture: m,
    timezone: ue
  }), ae = L && X || j, Te = L && X || I, tt = `${a}-grid-label`, Ye = me !== null, Le = (o = (r = Z == null ? void 0 : Z.calendarHeader) != null ? r : se == null ? void 0 : se.CalendarHeader) != null ? o : yk, Ve = yn({
    elementType: Le,
    externalSlotProps: (i = q == null ? void 0 : q.calendarHeader) != null ? i : ne == null ? void 0 : ne.calendarHeader,
    additionalProps: {
      views: O,
      view: he,
      currentMonth: Ne.currentMonth,
      onViewChange: Ue,
      onMonthChange: (Ct, qt) => Me({
        newMonth: Ct,
        direction: qt
      }),
      minDate: ae,
      maxDate: Te,
      disabled: L,
      disablePast: b,
      disableFuture: m,
      reduceAnimations: M,
      timezone: ue,
      labelId: tt,
      slots: Z,
      slotProps: q
    },
    ownerState: c
  }), Ce = Ke((Ct) => {
    const qt = s.startOfMonth(Ct), Bn = s.endOfMonth(Ct), xn = Pe(Ct) ? bc({
      utils: s,
      date: Ct,
      minDate: s.isBefore(j, qt) ? qt : j,
      maxDate: s.isAfter(I, Bn) ? Bn : I,
      disablePast: b,
      disableFuture: m,
      isDateDisabled: Pe,
      timezone: ue
    }) : Ct;
    xn ? (ie(xn, "finish"), S == null || S(qt)) : (te(), qe(qt)), We(xn, !0);
  }), Se = Ke((Ct) => {
    const qt = s.startOfYear(Ct), Bn = s.endOfYear(Ct), xn = Pe(Ct) ? bc({
      utils: s,
      date: Ct,
      minDate: s.isBefore(j, qt) ? qt : j,
      maxDate: s.isAfter(I, Bn) ? Bn : I,
      disablePast: b,
      disableFuture: m,
      isDateDisabled: Pe,
      timezone: ue
    }) : Ct;
    xn ? (ie(xn, "finish"), v == null || v(xn)) : (te(), qe(qt)), We(xn, !0);
  }), ve = Ke((Ct) => de(Ct && lu(s, Ct, X ?? ye), "finish", he));
  y.useEffect(() => {
    X != null && s.isValid(X) && qe(X);
  }, [X]);
  const Be = c, rt = u1e(Be), pt = {
    disablePast: b,
    disableFuture: m,
    maxDate: I,
    minDate: j
  }, Je = {
    disableHighlightToday: F,
    readOnly: V,
    disabled: L,
    timezone: ue,
    gridLabelId: tt
  }, At = y.useRef(he);
  y.useEffect(() => {
    At.current !== he && (me === At.current && Ie(he, !0), At.current = he);
  }, [me, Ie, he]);
  const Ht = y.useMemo(() => [X], [X]);
  return /* @__PURE__ */ f.jsxs(p1e, T({
    ref: n,
    className: xe(rt.root, _),
    ownerState: Be
  }, D, {
    children: [/* @__PURE__ */ f.jsx(Le, T({}, Ve)), /* @__PURE__ */ f.jsx(h1e, {
      reduceAnimations: M,
      className: rt.viewTransitionContainer,
      transKey: he,
      ownerState: Be,
      children: /* @__PURE__ */ f.jsxs("div", {
        children: [he === "year" && /* @__PURE__ */ f.jsx(xk, T({}, pt, Je, {
          value: X,
          onChange: Se,
          shouldDisableYear: E,
          hasFocus: Ye,
          onFocusedViewChange: (Ct) => Ie("year", Ct),
          yearsPerRow: re,
          referenceDate: ye
        })), he === "month" && /* @__PURE__ */ f.jsx(Ck, T({}, pt, Je, {
          hasFocus: Ye,
          className: _,
          value: X,
          onChange: Ce,
          shouldDisableMonth: k,
          onFocusedViewChange: (Ct) => Ie("month", Ct),
          monthsPerRow: U,
          referenceDate: ye
        })), he === "day" && /* @__PURE__ */ f.jsx(m0e, T({}, Ne, pt, Je, {
          onMonthSwitchingAnimationEnd: fe,
          onFocusedDayChange: We,
          reduceAnimations: M,
          selectedDays: Ht,
          onSelectedDaysChange: ve,
          shouldDisableDate: w,
          shouldDisableMonth: k,
          shouldDisableYear: E,
          hasFocus: Ye,
          onFocusedViewChange: (Ct) => Ie("day", Ct),
          showDaysOutsideCurrentMonth: H,
          fixedWeekNumber: N,
          dayOfWeekFormatter: z,
          displayWeekNumber: Q,
          components: se,
          componentsProps: ne,
          slots: Z,
          slotProps: q,
          loading: G,
          renderLoading: K
        }))]
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (Nh.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  className: l.string,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: l.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: l.any,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: l.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: l.number,
  /**
   * Controlled focused view.
   */
  focusedView: l.oneOf(["day", "month", "year"]),
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: l.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: l.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: l.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: l.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: l.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["day", "month", "year"]),
  /**
   * Make picker read only.
   * @default false
   */
  readOnly: l.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`.
   */
  referenceDate: l.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: l.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: l.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: l.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: l.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["day", "month", "year"]),
  /**
   * Available views.
   */
  views: l.arrayOf(l.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: l.oneOf([3, 4])
});
const mr = ({
  view: e,
  onViewChange: t,
  views: n,
  focusedView: o,
  onFocusedViewChange: r,
  value: i,
  defaultValue: s,
  referenceDate: a,
  onChange: c,
  className: d,
  classes: u,
  disableFuture: p,
  disablePast: h,
  minDate: g,
  maxDate: m,
  shouldDisableDate: b,
  shouldDisableMonth: C,
  shouldDisableYear: x,
  reduceAnimations: v,
  onMonthChange: S,
  monthsPerRow: M,
  onYearChange: w,
  yearsPerRow: k,
  defaultCalendarMonth: E,
  components: R,
  componentsProps: O,
  slots: P,
  slotProps: _,
  loading: L,
  renderLoading: V,
  disableHighlightToday: j,
  readOnly: I,
  disabled: F,
  showDaysOutsideCurrentMonth: $,
  dayOfWeekFormatter: A,
  sx: H,
  autoFocus: N,
  fixedWeekNumber: z,
  displayWeekNumber: se,
  timezone: ne
}) => /* @__PURE__ */ f.jsx(Nh, {
  view: e,
  onViewChange: t,
  views: n.filter(wl),
  focusedView: o && wl(o) ? o : null,
  onFocusedViewChange: r,
  value: i,
  defaultValue: s,
  referenceDate: a,
  onChange: c,
  className: d,
  classes: u,
  disableFuture: p,
  disablePast: h,
  minDate: g,
  maxDate: m,
  shouldDisableDate: b,
  shouldDisableMonth: C,
  shouldDisableYear: x,
  reduceAnimations: v,
  onMonthChange: S,
  monthsPerRow: M,
  onYearChange: w,
  yearsPerRow: k,
  defaultCalendarMonth: E,
  components: R,
  componentsProps: O,
  slots: P,
  slotProps: _,
  loading: L,
  renderLoading: V,
  disableHighlightToday: j,
  readOnly: I,
  disabled: F,
  showDaysOutsideCurrentMonth: $,
  dayOfWeekFormatter: A,
  sx: H,
  autoFocus: N,
  fixedWeekNumber: z,
  displayWeekNumber: se,
  timezone: ne
}), vk = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i, s;
  const a = $n(), c = kt(), d = ek(t, "MuiDesktopDatePicker"), u = T({
    day: mr,
    month: mr,
    year: mr
  }, d.viewRenderers), p = T({}, d, {
    viewRenderers: u,
    format: Yc(c, d, !1),
    yearsPerRow: (o = d.yearsPerRow) != null ? o : 4,
    slots: T({
      openPickerIcon: tk,
      field: Fh
    }, d.slots),
    slotProps: T({}, d.slotProps, {
      field: (g) => {
        var m;
        return T({}, Da((m = d.slotProps) == null ? void 0 : m.field, g), C2(d), {
          ref: n
        });
      },
      toolbar: T({
        hidden: !0
      }, (r = d.slotProps) == null ? void 0 : r.toolbar)
    })
  }), {
    renderPicker: h
  } = Ah({
    props: p,
    valueManager: Nn,
    valueType: "date",
    getOpenDialogAriaText: (i = (s = p.localeText) == null ? void 0 : s.openDatePickerDialogue) != null ? i : a.openDatePickerDialogue,
    validator: W0
  });
  return h();
});
vk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Class name applied to the root element.
   */
  className: l.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: l.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: l.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: l.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: l.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: l.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: l.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: l.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: l.object,
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: l.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: l.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: l.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: l.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: l.oneOf(["landscape", "portrait"]),
  readOnly: l.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: l.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: l.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: l.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: l.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: l.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: l.shape({
    day: l.func,
    month: l.func,
    year: l.func
  }),
  /**
   * Available views.
   */
  views: l.arrayOf(l.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 4
   */
  yearsPerRow: l.oneOf([3, 4])
};
const g1e = ["props", "getOpenDialogAriaText"], $h = (e) => {
  var t, n, o;
  let {
    props: r,
    getOpenDialogAriaText: i
  } = e, s = le(e, g1e);
  const {
    slots: a,
    slotProps: c,
    className: d,
    sx: u,
    format: p,
    formatDensity: h,
    timezone: g,
    name: m,
    label: b,
    inputRef: C,
    readOnly: x,
    disabled: v,
    localeText: S
  } = r, M = kt(), w = y.useRef(null), k = di(), E = (t = c == null || (n = c.toolbar) == null ? void 0 : n.hidden) != null ? t : !1, {
    open: R,
    actions: O,
    layoutProps: P,
    renderCurrentView: _,
    fieldProps: L
  } = sk(T({}, s, {
    props: r,
    inputRef: w,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "mobile"
  })), V = a.field, j = yn({
    elementType: V,
    externalSlotProps: c == null ? void 0 : c.field,
    additionalProps: T({}, L, E && {
      id: k
    }, !(v || x) && {
      onClick: O.onOpen,
      onKeyDown: ece(O.onOpen)
    }, {
      readOnly: x ?? !0,
      disabled: v,
      className: d,
      sx: u,
      format: p,
      formatDensity: h,
      timezone: g,
      label: b,
      name: m
    }),
    ownerState: r
  });
  j.inputProps = T({}, j.inputProps, {
    "aria-label": i(L.value, M)
  });
  const I = T({
    textField: a.textField
  }, j.slots), F = (o = a.layout) != null ? o : jh, $ = Tt(w, j.inputRef, C);
  let A = k;
  E && (b ? A = `${k}-label` : A = void 0);
  const H = T({}, c, {
    toolbar: T({}, c == null ? void 0 : c.toolbar, {
      titleId: k
    }),
    mobilePaper: T({
      "aria-labelledby": A
    }, c == null ? void 0 : c.mobilePaper)
  });
  return {
    renderPicker: () => /* @__PURE__ */ f.jsxs(Rh, {
      localeText: S,
      children: [/* @__PURE__ */ f.jsx(V, T({}, j, {
        slots: I,
        slotProps: H,
        inputRef: $
      })), /* @__PURE__ */ f.jsx(J2e, T({}, O, {
        open: R,
        slots: a,
        slotProps: H,
        children: /* @__PURE__ */ f.jsx(F, T({}, P, H == null ? void 0 : H.layout, {
          slots: a,
          slotProps: H,
          children: _()
        }))
      }))]
    })
  };
}, wk = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i;
  const s = $n(), a = kt(), c = ek(t, "MuiMobileDatePicker"), d = T({
    day: mr,
    month: mr,
    year: mr
  }, c.viewRenderers), u = T({}, c, {
    viewRenderers: d,
    format: Yc(a, c, !1),
    slots: T({
      field: Fh
    }, c.slots),
    slotProps: T({}, c.slotProps, {
      field: (h) => {
        var g;
        return T({}, Da((g = c.slotProps) == null ? void 0 : g.field, h), C2(c), {
          ref: n
        });
      },
      toolbar: T({
        hidden: !1
      }, (o = c.slotProps) == null ? void 0 : o.toolbar)
    })
  }), {
    renderPicker: p
  } = $h({
    props: u,
    valueManager: Nn,
    valueType: "date",
    getOpenDialogAriaText: (r = (i = u.localeText) == null ? void 0 : i.openDatePickerDialogue) != null ? r : s.openDatePickerDialogue,
    validator: W0
  });
  return p();
});
wk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Class name applied to the root element.
   */
  className: l.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: l.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: l.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: l.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: l.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: l.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: l.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: l.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: l.object,
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: l.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: l.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: l.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: l.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: l.oneOf(["landscape", "portrait"]),
  readOnly: l.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: l.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: l.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: l.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: l.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: l.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: l.shape({
    day: l.func,
    month: l.func,
    year: l.func
  }),
  /**
   * Available views.
   */
  views: l.arrayOf(l.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: l.oneOf([3, 4])
};
const m1e = ["desktopModeMediaQuery"], Sk = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = jt({
    props: t,
    name: "MuiDatePicker"
  }), {
    desktopModeMediaQuery: r = _h
  } = o, i = le(o, m1e);
  return y0(r, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ f.jsx(vk, T({
    ref: n
  }, i)) : /* @__PURE__ */ f.jsx(wk, T({
    ref: n
  }, i));
});
process.env.NODE_ENV !== "production" && (Sk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Class name applied to the root element.
   */
  className: l.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: l.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: l.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: l.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: l.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: l.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: l.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: l.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: l.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: l.object,
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: l.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: l.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: l.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: l.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: l.oneOf(["landscape", "portrait"]),
  readOnly: l.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: l.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: l.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: l.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: l.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: l.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: l.shape({
    day: l.func,
    month: l.func,
    year: l.func
  }),
  /**
   * Available views.
   */
  views: l.arrayOf(l.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 4 on desktop, 3 on mobile
   */
  yearsPerRow: l.oneOf([3, 4])
});
const b1e = (e) => {
  var t, n, o, r, i, s, a, c;
  const d = kt(), u = Ha(), h = ((t = e.ampm) != null ? t : d.is12HourCycleInCurrentLocale()) ? d.formats.keyboardDateTime12h : d.formats.keyboardDateTime24h;
  return T({}, e, {
    disablePast: (n = e.disablePast) != null ? n : !1,
    disableFuture: (o = e.disableFuture) != null ? o : !1,
    format: (r = e.format) != null ? r : h,
    disableIgnoringDatePartForTimeValidation: !!(e.minDateTime || e.maxDateTime),
    minDate: go(d, (i = e.minDateTime) != null ? i : e.minDate, u.minDate),
    maxDate: go(d, (s = e.maxDateTime) != null ? s : e.maxDate, u.maxDate),
    minTime: (a = e.minDateTime) != null ? a : e.minTime,
    maxTime: (c = e.maxDateTime) != null ? c : e.maxTime
  });
}, C1e = ({
  props: e,
  inputRef: t
}) => {
  const n = b1e(e), {
    forwardedProps: o,
    internalProps: r
  } = Vh(n, "date-time");
  return Ih({
    inputRef: t,
    forwardedProps: o,
    internalProps: r,
    valueManager: Nn,
    fieldValueManager: Eh,
    validator: Dh,
    valueType: "date-time"
  });
}, x1e = ["components", "componentsProps", "slots", "slotProps", "InputProps", "inputProps"], y1e = ["inputRef"], v1e = ["ref", "onPaste", "onKeyDown", "inputMode", "readOnly", "clearable", "onClear"], Bh = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i;
  const s = jt({
    props: t,
    name: "MuiDateTimeField"
  }), {
    components: a,
    componentsProps: c,
    slots: d,
    slotProps: u,
    InputProps: p,
    inputProps: h
  } = s, g = le(s, x1e), m = s, b = (o = (r = d == null ? void 0 : d.textField) != null ? r : a == null ? void 0 : a.TextField) != null ? o : Ir, C = yn({
    elementType: b,
    externalSlotProps: (i = u == null ? void 0 : u.textField) != null ? i : c == null ? void 0 : c.textField,
    externalForwardedProps: g,
    ownerState: m
  }), {
    inputRef: x
  } = C, v = le(C, y1e);
  v.inputProps = T({}, h, v.inputProps), v.InputProps = T({}, p, v.InputProps);
  const S = C1e({
    props: v,
    inputRef: x
  }), {
    ref: M,
    onPaste: w,
    onKeyDown: k,
    inputMode: E,
    readOnly: R,
    clearable: O,
    onClear: P
  } = S, _ = le(S, v1e), {
    InputProps: L,
    fieldProps: V
  } = Hh({
    onClear: P,
    clearable: O,
    fieldProps: _,
    InputProps: _.InputProps,
    slots: d,
    slotProps: u,
    components: a,
    componentsProps: c
  });
  return /* @__PURE__ */ f.jsx(b, T({
    ref: n
  }, V, {
    InputProps: T({}, L, {
      readOnly: R
    }),
    inputProps: T({}, _.inputProps, {
      inputMode: E,
      onPaste: w,
      onKeyDown: k,
      ref: M
    })
  }));
});
process.env.NODE_ENV !== "production" && (Bh.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: l.bool,
  className: l.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: l.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: l.elementType,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: l.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: l.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The helper text content.
   */
  helperText: l.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: l.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: l.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: l.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: l.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: l.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */
  maxDateTime: l.any,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */
  minDateTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  onBlur: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  onFocus: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: l.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: l.any,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: l.bool,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: l.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: l.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default `false`
   */
  shouldRespectLeadingZeros: l.bool,
  /**
   * The size of the component.
   */
  size: l.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  style: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: l.oneOfType([l.func, l.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: l.oneOf(["filled", "outlined", "standard"])
});
function w1e(e) {
  return _e("MuiDateTimePickerTabs", e);
}
Re("MuiDateTimePickerTabs", ["root"]);
const S1e = (e) => wl(e) ? "date" : "time", M1e = (e) => e === "date" ? "day" : "hours", T1e = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"]
  }, w1e, t);
}, k1e = B(L3, {
  name: "MuiDateTimePickerTabs",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  boxShadow: `0 -1px 0 0 inset ${(e.vars || e).palette.divider}`,
  "&:last-child": {
    boxShadow: `0 1px 0 0 inset ${(e.vars || e).palette.divider}`,
    [`& .${Cd.indicator}`]: {
      bottom: "auto",
      top: 0
    }
  }
})), Mk = function(t) {
  const n = jt({
    props: t,
    name: "MuiDateTimePickerTabs"
  }), {
    dateIcon: o = /* @__PURE__ */ f.jsx(F2e, {}),
    onViewChange: r,
    timeIcon: i = /* @__PURE__ */ f.jsx(N2e, {}),
    view: s,
    hidden: a = typeof window > "u" || window.innerHeight < 667,
    className: c,
    sx: d
  } = n, u = $n(), p = T1e(n), h = (g, m) => {
    r(M1e(m));
  };
  return a ? null : /* @__PURE__ */ f.jsxs(k1e, {
    ownerState: n,
    variant: "fullWidth",
    value: S1e(s),
    onChange: h,
    className: xe(c, p.root),
    sx: d,
    children: [/* @__PURE__ */ f.jsx(Nc, {
      value: "date",
      "aria-label": u.dateTableLabel,
      icon: /* @__PURE__ */ f.jsx(y.Fragment, {
        children: o
      })
    }), /* @__PURE__ */ f.jsx(Nc, {
      value: "time",
      "aria-label": u.timeTableLabel,
      icon: /* @__PURE__ */ f.jsx(y.Fragment, {
        children: i
      })
    })]
  });
};
process.env.NODE_ENV !== "production" && (Mk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  className: l.string,
  /**
   * Date tab icon.
   * @default DateRange
   */
  dateIcon: l.node,
  /**
   * Toggles visibility of the tabs allowing view switching.
   * @default `window.innerHeight < 667` for `DesktopDateTimePicker` and `MobileDateTimePicker`, `displayStaticWrapperAs === 'desktop'` for `StaticDateTimePicker`
   */
  hidden: l.bool,
  /**
   * Callback called when a tab is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: l.func.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Time tab icon.
   * @default Time
   */
  timeIcon: l.node,
  /**
   * Currently visible picker view.
   */
  view: l.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired
});
function E1e(e) {
  return _e("MuiDateTimePickerToolbar", e);
}
const V6 = Re("MuiDateTimePickerToolbar", ["root", "dateContainer", "timeContainer", "timeDigitsContainer", "separator", "timeLabelReverse", "ampmSelection", "ampmLandscape", "ampmLabel"]), R1e = ["ampm", "ampmInClock", "value", "onChange", "view", "isLandscape", "onViewChange", "toolbarFormat", "toolbarPlaceholder", "views", "disabled", "readOnly", "toolbarVariant"], O1e = (e) => {
  const {
    classes: t,
    theme: n,
    isLandscape: o
  } = e, r = {
    root: ["root"],
    dateContainer: ["dateContainer"],
    timeContainer: ["timeContainer", n.direction === "rtl" && "timeLabelReverse"],
    timeDigitsContainer: ["timeDigitsContainer", n.direction === "rtl" && "timeLabelReverse"],
    separator: ["separator"],
    ampmSelection: ["ampmSelection", o && "ampmLandscape"],
    ampmLabel: ["ampmLabel"]
  };
  return Oe(r, E1e, t);
}, Tk = B(Oh, {
  name: "MuiDateTimePickerToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => ({
  paddingLeft: t.toolbarVariant === "desktop" && !t.isLandscape ? 24 : 16,
  paddingRight: t.toolbarVariant === "desktop" && !t.isLandscape ? 0 : 16,
  borderBottom: t.toolbarVariant === "desktop" ? `1px solid ${(e.vars || e).palette.divider}` : void 0,
  borderRight: t.toolbarVariant === "desktop" && t.isLandscape ? `1px solid ${(e.vars || e).palette.divider}` : void 0,
  justifyContent: "space-around",
  position: "relative"
}));
Tk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: l.elementType,
  classes: l.object,
  className: l.string,
  isLandscape: l.bool.isRequired,
  isMobileKeyboardViewOpen: l.bool,
  landscapeDirection: l.oneOf(["column", "row"]),
  ownerState: l.object.isRequired,
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  toggleMobileKeyboardView: l.func,
  toolbarTitle: l.node,
  viewType: l.oneOf(["date", "time"])
};
const _1e = B("div", {
  name: "MuiDateTimePickerToolbar",
  slot: "DateContainer",
  overridesResolver: (e, t) => t.dateContainer
})({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start"
}), kk = B("div", {
  name: "MuiDateTimePickerToolbar",
  slot: "TimeContainer",
  overridesResolver: (e, t) => t.timeContainer
})(({
  theme: e,
  ownerState: t
}) => {
  const n = t.isLandscape && t.toolbarVariant !== "desktop" ? "column" : "row";
  return T({
    display: "flex",
    flexDirection: n
  }, t.toolbarVariant === "desktop" && T({}, !t.isLandscape && {
    gap: 9,
    marginRight: 4,
    alignSelf: "flex-end"
  }), e.direction === "rtl" && {
    flexDirection: `${n}-reverse`
  });
}), P1e = B("div", {
  name: "MuiDateTimePickerToolbar",
  slot: "TimeDigitsContainer",
  overridesResolver: (e, t) => t.timeDigitsContainer
})(({
  theme: e,
  ownerState: t
}) => T({
  display: "flex"
}, t.toolbarVariant === "desktop" && {
  gap: 1.5
}, e.direction === "rtl" && {
  flexDirection: "row-reverse"
}));
kk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: l.elementType,
  ownerState: l.object.isRequired,
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
};
const IC = B(Ph, {
  name: "MuiDateTimePickerToolbar",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})(({
  ownerState: e
}) => ({
  margin: e.toolbarVariant === "desktop" ? 0 : "0 4px 0 2px",
  cursor: "default"
})), L1e = B("div", {
  name: "MuiDateTimePickerToolbar",
  slot: "AmPmSelection",
  overridesResolver: (e, t) => [{
    [`.${V6.ampmLabel}`]: t.ampmLabel
  }, {
    [`&.${V6.ampmLandscape}`]: t.ampmLandscape
  }, t.ampmSelection]
})(({
  ownerState: e
}) => T({
  display: "flex",
  flexDirection: "column",
  marginRight: "auto",
  marginLeft: 12
}, e.isLandscape && {
  margin: "4px 0 auto",
  flexDirection: "row",
  justifyContent: "space-around",
  width: "100%"
}, {
  [`& .${V6.ampmLabel}`]: {
    fontSize: 17
  }
}));
function Ek(e) {
  const t = jt({
    props: e,
    name: "MuiDateTimePickerToolbar"
  }), {
    ampm: n,
    ampmInClock: o,
    value: r,
    onChange: i,
    view: s,
    isLandscape: a,
    onViewChange: c,
    toolbarFormat: d,
    toolbarPlaceholder: u = "––",
    views: p,
    disabled: h,
    readOnly: g,
    toolbarVariant: m = "mobile"
  } = t, b = le(t, R1e), C = t, x = kt(), {
    meridiemMode: v,
    handleMeridiemChange: S
  } = Q3(r, n, i), M = !!(n && !o), w = m === "desktop", k = $n(), E = ge(), R = O1e(T({}, C, {
    theme: E
  })), O = (_) => n ? x.format(_, "hours12h") : x.format(_, "hours24h"), P = y.useMemo(() => r ? d ? x.formatByString(r, d) : x.format(r, "shortDate") : u, [r, d, u, x]);
  return /* @__PURE__ */ f.jsxs(Tk, T({
    toolbarTitle: k.dateTimePickerToolbarTitle,
    isLandscape: a,
    className: R.root
  }, b, {
    ownerState: C,
    children: [/* @__PURE__ */ f.jsxs(_1e, {
      className: R.dateContainer,
      ownerState: C,
      children: [p.includes("year") && /* @__PURE__ */ f.jsx(Zo, {
        tabIndex: -1,
        variant: "subtitle1",
        onClick: () => c("year"),
        selected: s === "year",
        value: r ? x.format(r, "year") : "–"
      }), p.includes("day") && /* @__PURE__ */ f.jsx(Zo, {
        tabIndex: -1,
        variant: w ? "h5" : "h4",
        onClick: () => c("day"),
        selected: s === "day",
        value: P
      })]
    }), /* @__PURE__ */ f.jsxs(kk, {
      className: R.timeContainer,
      ownerState: C,
      children: [/* @__PURE__ */ f.jsxs(P1e, {
        className: R.timeDigitsContainer,
        ownerState: C,
        children: [p.includes("hours") && /* @__PURE__ */ f.jsx(Zo, {
          variant: w ? "h5" : "h3",
          width: w && !a ? K2 : void 0,
          onClick: () => c("hours"),
          selected: s === "hours",
          value: r ? O(r) : "--"
        }), p.includes("minutes") && /* @__PURE__ */ f.jsxs(y.Fragment, {
          children: [/* @__PURE__ */ f.jsx(IC, {
            variant: w ? "h5" : "h3",
            value: ":",
            className: R.separator,
            ownerState: C
          }), /* @__PURE__ */ f.jsx(Zo, {
            variant: w ? "h5" : "h3",
            width: w && !a ? K2 : void 0,
            onClick: () => c("minutes"),
            selected: s === "minutes",
            value: r ? x.format(r, "minutes") : "--"
          })]
        }), p.includes("seconds") && /* @__PURE__ */ f.jsxs(y.Fragment, {
          children: [/* @__PURE__ */ f.jsx(IC, {
            variant: w ? "h5" : "h3",
            value: ":",
            className: R.separator,
            ownerState: C
          }), /* @__PURE__ */ f.jsx(Zo, {
            variant: w ? "h5" : "h3",
            width: w && !a ? K2 : void 0,
            onClick: () => c("seconds"),
            selected: s === "seconds",
            value: r ? x.format(r, "seconds") : "--"
          })]
        })]
      }), M && !w && /* @__PURE__ */ f.jsxs(L1e, {
        className: R.ampmSelection,
        ownerState: C,
        children: [/* @__PURE__ */ f.jsx(Zo, {
          variant: "subtitle2",
          selected: v === "am",
          typographyClassName: R.ampmLabel,
          value: _r(x, "am"),
          onClick: g ? void 0 : () => S("am"),
          disabled: h
        }), /* @__PURE__ */ f.jsx(Zo, {
          variant: "subtitle2",
          selected: v === "pm",
          typographyClassName: R.ampmLabel,
          value: _r(x, "pm"),
          onClick: g ? void 0 : () => S("pm"),
          disabled: h
        })]
      }), n && w && /* @__PURE__ */ f.jsx(Zo, {
        variant: "h5",
        onClick: () => c("meridiem"),
        selected: s === "meridiem",
        value: r && v ? _r(x, v) : "--",
        width: K2
      })]
    })]
  }));
}
process.env.NODE_ENV !== "production" && (Ek.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  ampm: l.bool,
  ampmInClock: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * className applied to the root component.
   */
  className: l.string,
  disabled: l.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: l.bool,
  isLandscape: l.bool.isRequired,
  onChange: l.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: l.func.isRequired,
  readOnly: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  titleId: l.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: l.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: l.node,
  toolbarVariant: l.oneOf(["desktop", "mobile"]),
  value: l.any,
  /**
   * Currently visible picker view.
   */
  view: l.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired,
  views: l.arrayOf(l.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired).isRequired
});
function Rk(e, t) {
  var n, o, r, i, s, a, c, d, u, p, h;
  const g = kt(), m = Ha(), b = jt({
    props: e,
    name: t
  }), C = (n = b.ampm) != null ? n : g.is12HourCycleInCurrentLocale(), x = y.useMemo(() => {
    var M;
    return ((M = b.localeText) == null ? void 0 : M.toolbarTitle) == null ? b.localeText : T({}, b.localeText, {
      dateTimePickerToolbarTitle: b.localeText.toolbarTitle
    });
  }, [b.localeText]), v = (o = b.slots) != null ? o : z0(b.components), S = (r = b.slotProps) != null ? r : b.componentsProps;
  return T({}, b, wh({
    views: b.views,
    openTo: b.openTo,
    defaultViews: ["year", "day", "hours", "minutes"],
    defaultOpenTo: "day"
  }), {
    ampm: C,
    localeText: x,
    orientation: (i = b.orientation) != null ? i : "portrait",
    // TODO: Remove from public API
    disableIgnoringDatePartForTimeValidation: (s = b.disableIgnoringDatePartForTimeValidation) != null ? s : !!(b.minDateTime || b.maxDateTime || // allow time clock to correctly check time validity: https://github.com/mui/mui-x/issues/8520
    b.disablePast || b.disableFuture),
    disableFuture: (a = b.disableFuture) != null ? a : !1,
    disablePast: (c = b.disablePast) != null ? c : !1,
    minDate: go(g, (d = b.minDateTime) != null ? d : b.minDate, m.minDate),
    maxDate: go(g, (u = b.maxDateTime) != null ? u : b.maxDate, m.maxDate),
    minTime: (p = b.minDateTime) != null ? p : b.minTime,
    maxTime: (h = b.maxDateTime) != null ? h : b.maxTime,
    slots: T({
      toolbar: Ek,
      tabs: Mk
    }, v),
    slotProps: T({}, S, {
      toolbar: T({
        ampm: C
      }, S == null ? void 0 : S.toolbar)
    })
  });
}
function I1e(e) {
  return _e("MuiMultiSectionDigitalClock", e);
}
Re("MuiMultiSectionDigitalClock", ["root"]);
function j1e(e) {
  return _e("MuiMultiSectionDigitalClockSection", e);
}
const V1e = Re("MuiMultiSectionDigitalClockSection", ["root", "item"]), D1e = ["autoFocus", "onChange", "className", "disabled", "readOnly", "items", "active", "slots", "slotProps", "skipDisabled"], A1e = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"],
    item: ["item"]
  }, j1e, t);
}, H1e = B(P0, {
  name: "MuiMultiSectionDigitalClockSection",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => ({
  maxHeight: ok,
  width: 56,
  padding: 0,
  overflow: "hidden",
  "@media (prefers-reduced-motion: no-preference)": {
    scrollBehavior: t.alreadyRendered ? "smooth" : "auto"
  },
  "@media (pointer: fine)": {
    "&:hover": {
      overflowY: "auto"
    }
  },
  "@media (pointer: none), (pointer: coarse)": {
    overflowY: "auto"
  },
  "&:not(:first-of-type)": {
    borderLeft: `1px solid ${(e.vars || e).palette.divider}`
  },
  "&:after": {
    display: "block",
    content: '""',
    // subtracting the height of one item, extra margin and borders to make sure the max height is correct
    height: "calc(100% - 40px - 6px)"
  }
})), F1e = B(Jo, {
  name: "MuiMultiSectionDigitalClockSection",
  slot: "Item",
  overridesResolver: (e, t) => t.item
})(({
  theme: e
}) => ({
  padding: 8,
  margin: "2px 4px",
  width: K2,
  justifyContent: "center",
  "&:first-of-type": {
    marginTop: 4
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : $t(e.palette.primary.main, e.palette.action.hoverOpacity)
  },
  "&.Mui-selected": {
    backgroundColor: (e.vars || e).palette.primary.main,
    color: (e.vars || e).palette.primary.contrastText,
    "&:focus-visible, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  "&.Mui-focusVisible": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : $t(e.palette.primary.main, e.palette.action.focusOpacity)
  }
})), N1e = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o;
  const r = y.useRef(null), i = Tt(n, r), s = y.useRef(null), a = jt({
    props: t,
    name: "MuiMultiSectionDigitalClockSection"
  }), {
    autoFocus: c,
    onChange: d,
    className: u,
    disabled: p,
    readOnly: h,
    items: g,
    active: m,
    slots: b,
    slotProps: C,
    skipDisabled: x
  } = a, v = le(a, D1e), S = y.useMemo(() => T({}, a, {
    alreadyRendered: !!r.current
  }), [a]), M = A1e(S), w = (o = b == null ? void 0 : b.digitalClockSectionItem) != null ? o : F1e;
  return y.useEffect(() => {
    if (r.current === null)
      return;
    const k = r.current.querySelector('[role="option"][aria-selected="true"]');
    if (m && c && k && k.focus(), !k || s.current === k)
      return;
    s.current = k;
    const E = k.offsetTop;
    r.current.scrollTop = E - 4;
  }), /* @__PURE__ */ f.jsx(H1e, T({
    ref: i,
    className: xe(M.root, u),
    ownerState: S,
    autoFocusItem: c && m,
    role: "listbox"
  }, v, {
    children: g.map((k) => {
      var E, R;
      if (x && (E = k.isDisabled) != null && E.call(k, k.value))
        return null;
      const O = k.isSelected(k.value);
      return /* @__PURE__ */ f.jsx(w, T({
        onClick: () => !h && d(k.value),
        selected: O,
        disabled: p || ((R = k.isDisabled) == null ? void 0 : R.call(k, k.value)),
        disableRipple: h,
        role: "option",
        "aria-disabled": h,
        "aria-label": k.ariaLabel,
        "aria-selected": O,
        className: M.item
      }, C == null ? void 0 : C.digitalClockSectionItem, {
        children: k.label
      }), k.label);
    })
  }));
}), $1e = ({
  now: e,
  value: t,
  utils: n,
  ampm: o,
  isDisabled: r,
  resolveAriaLabel: i,
  timeStep: s
}) => {
  const a = t ? n.getHours(t) : null, c = [], d = (p) => a === null ? !1 : o ? p === 12 ? a === 12 || a === 0 : a === p || a - 12 === p : a === p, u = o ? 11 : 23;
  for (let p = 0; p <= u; p += s) {
    let h = n.format(n.setHours(e, p), o ? "hours12h" : "hours24h");
    const g = i(parseInt(h, 10).toString());
    h = n.formatNumber(h), c.push({
      value: p,
      label: h,
      isSelected: d,
      isDisabled: r,
      ariaLabel: g
    });
  }
  return c;
}, jC = ({
  value: e,
  utils: t,
  isDisabled: n,
  timeStep: o,
  resolveLabel: r,
  resolveAriaLabel: i,
  hasValue: s = !0
}) => {
  const a = (c) => e === null ? !1 : s && e === c;
  return [...Array.from({
    length: Math.ceil(60 / o)
  }, (c, d) => {
    const u = o * d;
    return {
      value: u,
      label: t.formatNumber(r(u)),
      isDisabled: n,
      isSelected: a,
      ariaLabel: i(u.toString())
    };
  })];
}, zh = ({
  value: e,
  referenceDate: t,
  utils: n,
  props: o,
  timezone: r
}) => {
  const i = y.useMemo(
    () => Nn.getInitialReferenceValue({
      value: e,
      utils: n,
      props: o,
      referenceDate: t,
      granularity: Er.day,
      timezone: r,
      getTodayDate: () => Mh(n, r, "date")
    }),
    // We only want to compute the reference date on mount.
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  );
  return e ?? i;
}, B1e = ["ampm", "timeSteps", "autoFocus", "components", "componentsProps", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableClock", "shouldDisableTime", "onChange", "view", "views", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "skipDisabled", "timezone"], z1e = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"]
  }, I1e, t);
}, Z1e = B(tf, {
  name: "MuiMultiSectionDigitalClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`
})), Ok = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = kt(), r = jt({
    props: t,
    name: "MuiMultiSectionDigitalClock"
  }), {
    ampm: i = o.is12HourCycleInCurrentLocale(),
    timeSteps: s,
    autoFocus: a,
    components: c,
    componentsProps: d,
    slots: u,
    slotProps: p,
    value: h,
    defaultValue: g,
    referenceDate: m,
    disableIgnoringDatePartForTimeValidation: b = !1,
    maxTime: C,
    minTime: x,
    disableFuture: v,
    disablePast: S,
    minutesStep: M = 1,
    shouldDisableClock: w,
    shouldDisableTime: k,
    onChange: E,
    view: R,
    views: O = ["hours", "minutes"],
    openTo: P,
    onViewChange: _,
    focusedView: L,
    onFocusedViewChange: V,
    className: j,
    disabled: I,
    readOnly: F,
    skipDisabled: $ = !1,
    timezone: A
  } = r, H = le(r, B1e), {
    value: N,
    handleValueChange: z,
    timezone: se
  } = b2({
    name: "MultiSectionDigitalClock",
    timezone: A,
    value: h,
    defaultValue: g,
    onChange: E,
    valueManager: Nn
  }), ne = $n(), Z = Fa(se), q = y.useMemo(() => T({
    hours: 1,
    minutes: 5,
    seconds: 5
  }, s), [s]), G = zh({
    value: N,
    referenceDate: m,
    utils: o,
    props: r,
    timezone: se
  }), K = Ke((te, ie, ye) => z(te, ie, ye)), Q = y.useMemo(() => !i || !O.includes("hours") || O.includes("meridiem") ? O : [...O, "meridiem"], [i, O]), {
    view: re,
    setValueAndGoToNextView: U,
    focusedView: W
  } = Z0({
    view: R,
    views: Q,
    openTo: P,
    onViewChange: _,
    onChange: K,
    focusedView: L,
    onFocusedViewChange: V
  }), D = Ke((te) => {
    U(te, "finish", "meridiem");
  }), {
    meridiemMode: X,
    handleMeridiemChange: de
  } = Q3(G, i, D, "finish"), ue = y.useCallback((te, ie) => {
    const ye = B0(b, o), Ne = ie === "hours" || ie === "minutes" && Q.includes("seconds"), We = ({
      start: Me,
      end: Pe
    }) => !(x && ye(x, Pe) || C && ye(Me, C) || v && ye(Me, Z) || S && ye(Z, Ne ? Pe : Me)), qe = (Me, Pe = 1) => {
      if (Me % Pe !== 0 || w != null && w(Me, ie))
        return !1;
      if (k)
        switch (ie) {
          case "hours":
            return !k(o.setHours(G, Me), "hours");
          case "minutes":
            return !k(o.setMinutes(G, Me), "minutes");
          case "seconds":
            return !k(o.setSeconds(G, Me), "seconds");
          default:
            return !1;
        }
      return !0;
    };
    switch (ie) {
      case "hours": {
        const Me = Xc(te, X, i), Pe = o.setHours(G, Me), fe = o.setSeconds(o.setMinutes(Pe, 0), 0), ae = o.setSeconds(o.setMinutes(Pe, 59), 59);
        return !We({
          start: fe,
          end: ae
        }) || !qe(Me);
      }
      case "minutes": {
        const Me = o.setMinutes(G, te), Pe = o.setSeconds(Me, 0), fe = o.setSeconds(Me, 59);
        return !We({
          start: Pe,
          end: fe
        }) || !qe(te, M);
      }
      case "seconds": {
        const Me = o.setSeconds(G, te);
        return !We({
          start: Me,
          end: Me
        }) || !qe(te);
      }
      default:
        throw new Error("not supported");
    }
  }, [i, G, b, C, X, x, M, w, k, o, v, S, Z, Q]), he = y.useCallback((te) => {
    switch (te) {
      case "hours":
        return {
          onChange: (ie) => {
            const ye = Xc(ie, X, i);
            U(o.setHours(G, ye), "finish", "hours");
          },
          items: $1e({
            now: Z,
            value: N,
            ampm: i,
            utils: o,
            isDisabled: (ie) => I || ue(ie, "hours"),
            timeStep: q.hours,
            resolveAriaLabel: ne.hoursClockNumberText
          })
        };
      case "minutes":
        return {
          onChange: (ie) => {
            U(o.setMinutes(G, ie), "finish", "minutes");
          },
          items: jC({
            value: o.getMinutes(G),
            utils: o,
            isDisabled: (ie) => I || ue(ie, "minutes"),
            resolveLabel: (ie) => o.format(o.setMinutes(Z, ie), "minutes"),
            timeStep: q.minutes,
            hasValue: !!N,
            resolveAriaLabel: ne.minutesClockNumberText
          })
        };
      case "seconds":
        return {
          onChange: (ie) => {
            U(o.setSeconds(G, ie), "finish", "seconds");
          },
          items: jC({
            value: o.getSeconds(G),
            utils: o,
            isDisabled: (ie) => I || ue(ie, "seconds"),
            resolveLabel: (ie) => o.format(o.setSeconds(Z, ie), "seconds"),
            timeStep: q.seconds,
            hasValue: !!N,
            resolveAriaLabel: ne.secondsClockNumberText
          })
        };
      case "meridiem": {
        const ie = _r(o, "am"), ye = _r(o, "pm");
        return {
          onChange: de,
          items: [{
            value: "am",
            label: ie,
            isSelected: () => !!N && X === "am",
            ariaLabel: ie
          }, {
            value: "pm",
            label: ye,
            isSelected: () => !!N && X === "pm",
            ariaLabel: ye
          }]
        };
      }
      default:
        throw new Error(`Unknown view: ${te} found.`);
    }
  }, [Z, N, i, o, q.hours, q.minutes, q.seconds, ne.hoursClockNumberText, ne.minutesClockNumberText, ne.secondsClockNumberText, X, U, G, I, ue, de]), Ue = y.useMemo(() => Q.reduce((te, ie) => T({}, te, {
    [ie]: he(ie)
  }), {}), [Q, he]), me = r, Ie = z1e(me);
  return /* @__PURE__ */ f.jsx(Z1e, T({
    ref: n,
    className: xe(Ie.root, j),
    ownerState: me,
    role: "group"
  }, H, {
    children: Object.entries(Ue).map(([te, ie]) => /* @__PURE__ */ f.jsx(N1e, {
      items: ie.items,
      onChange: ie.onChange,
      active: re === te,
      autoFocus: a ?? W === te,
      disabled: I,
      readOnly: F,
      slots: u ?? c,
      slotProps: p ?? d,
      skipDisabled: $,
      "aria-label": ne.selectViewText(te)
    }, te))
  }));
});
process.env.NODE_ENV !== "production" && (Ok.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  className: l.string,
  /**
   * Overrideable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * Controlled focused view.
   */
  focusedView: l.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: l.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: l.any,
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overrideable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: l.shape({
    hours: l.number,
    minutes: l.number,
    seconds: l.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Available views.
   * @default ['hours', 'minutes']
   */
  views: l.arrayOf(l.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired)
});
const W1e = B("div")({
  display: "flex",
  margin: "0 auto"
});
function U1e(e) {
  return _e("MuiTimeClock", e);
}
Re("MuiTimeClock", ["root", "arrowSwitcher"]);
const zl = 220, oi = 36, Qc = {
  x: zl / 2,
  y: zl / 2
}, _k = {
  x: Qc.x,
  y: 0
}, G1e = _k.x - Qc.x, q1e = _k.y - Qc.y, K1e = (e) => e * (180 / Math.PI), Pk = (e, t, n) => {
  const o = t - Qc.x, r = n - Qc.y, i = Math.atan2(G1e, q1e) - Math.atan2(o, r);
  let s = K1e(i);
  s = Math.round(s / e) * e, s %= 360;
  const a = Math.floor(s / e) || 0, c = o ** 2 + r ** 2, d = Math.sqrt(c);
  return {
    value: a,
    distance: d
  };
}, Y1e = (e, t, n = 1) => {
  const o = n * 6;
  let {
    value: r
  } = Pk(o, e, t);
  return r = r * n % 60, r;
}, X1e = (e, t, n) => {
  const {
    value: o,
    distance: r
  } = Pk(30, e, t);
  let i = o || 12;
  return n ? i %= 12 : r < zl / 2 - oi && (i += 12, i %= 24), i;
};
function J1e(e) {
  return _e("MuiClockPointer", e);
}
Re("MuiClockPointer", ["root", "thumb"]);
const Q1e = ["className", "hasSelected", "isInner", "type", "viewValue"], ede = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"],
    thumb: ["thumb"]
  }, J1e, t);
}, tde = B("div", {
  name: "MuiClockPointer",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => T({
  width: 2,
  backgroundColor: (e.vars || e).palette.primary.main,
  position: "absolute",
  left: "calc(50% - 1px)",
  bottom: "50%",
  transformOrigin: "center bottom 0px"
}, t.shouldAnimate && {
  transition: e.transitions.create(["transform", "height"])
})), nde = B("div", {
  name: "MuiClockPointer",
  slot: "Thumb",
  overridesResolver: (e, t) => t.thumb
})(({
  theme: e,
  ownerState: t
}) => T({
  width: 4,
  height: 4,
  backgroundColor: (e.vars || e).palette.primary.contrastText,
  borderRadius: "50%",
  position: "absolute",
  top: -21,
  left: `calc(50% - ${oi / 2}px)`,
  border: `${(oi - 4) / 2}px solid ${(e.vars || e).palette.primary.main}`,
  boxSizing: "content-box"
}, t.hasSelected && {
  backgroundColor: (e.vars || e).palette.primary.main
}));
function ode(e) {
  const t = jt({
    props: e,
    name: "MuiClockPointer"
  }), {
    className: n,
    isInner: o,
    type: r,
    viewValue: i
  } = t, s = le(t, Q1e), a = y.useRef(r);
  y.useEffect(() => {
    a.current = r;
  }, [r]);
  const c = T({}, t, {
    shouldAnimate: a.current !== r
  }), d = ede(c), u = () => {
    let h = 360 / (r === "hours" ? 12 : 60) * i;
    return r === "hours" && i > 12 && (h -= 360), {
      height: Math.round((o ? 0.26 : 0.4) * zl),
      transform: `rotateZ(${h}deg)`
    };
  };
  return /* @__PURE__ */ f.jsx(tde, T({
    style: u(),
    className: xe(n, d.root),
    ownerState: c
  }, s, {
    children: /* @__PURE__ */ f.jsx(nde, {
      ownerState: c,
      className: d.thumb
    })
  }));
}
function rde(e) {
  return _e("MuiClock", e);
}
Re("MuiClock", ["root", "clock", "wrapper", "squareMask", "pin", "amButton", "pmButton", "meridiemText"]);
const ide = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"],
    clock: ["clock"],
    wrapper: ["wrapper"],
    squareMask: ["squareMask"],
    pin: ["pin"],
    amButton: ["amButton"],
    pmButton: ["pmButton"],
    meridiemText: ["meridiemText"]
  }, rde, t);
}, sde = B("div", {
  name: "MuiClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: e.spacing(2)
})), ade = B("div", {
  name: "MuiClock",
  slot: "Clock",
  overridesResolver: (e, t) => t.clock
})({
  backgroundColor: "rgba(0,0,0,.07)",
  borderRadius: "50%",
  height: 220,
  width: 220,
  flexShrink: 0,
  position: "relative",
  pointerEvents: "none"
}), lde = B("div", {
  name: "MuiClock",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})({
  "&:focus": {
    outline: "none"
  }
}), cde = B("div", {
  name: "MuiClock",
  slot: "SquareMask",
  overridesResolver: (e, t) => t.squareMask
})(({
  ownerState: e
}) => T({
  width: "100%",
  height: "100%",
  position: "absolute",
  pointerEvents: "auto",
  outline: 0,
  // Disable scroll capabilities.
  touchAction: "none",
  userSelect: "none"
}, e.disabled ? {} : {
  "@media (pointer: fine)": {
    cursor: "pointer",
    borderRadius: "50%"
  },
  "&:active": {
    cursor: "move"
  }
})), dde = B("div", {
  name: "MuiClock",
  slot: "Pin",
  overridesResolver: (e, t) => t.pin
})(({
  theme: e
}) => ({
  width: 6,
  height: 6,
  borderRadius: "50%",
  backgroundColor: (e.vars || e).palette.primary.main,
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)"
})), ude = B(Bt, {
  name: "MuiClock",
  slot: "AmButton",
  overridesResolver: (e, t) => t.amButton
})(({
  theme: e,
  ownerState: t
}) => T({
  zIndex: 1,
  position: "absolute",
  bottom: 8,
  left: 8,
  paddingLeft: 4,
  paddingRight: 4,
  width: oi
}, t.meridiemMode === "am" && {
  backgroundColor: (e.vars || e).palette.primary.main,
  color: (e.vars || e).palette.primary.contrastText,
  "&:hover": {
    backgroundColor: (e.vars || e).palette.primary.light
  }
})), fde = B(Bt, {
  name: "MuiClock",
  slot: "PmButton",
  overridesResolver: (e, t) => t.pmButton
})(({
  theme: e,
  ownerState: t
}) => T({
  zIndex: 1,
  position: "absolute",
  bottom: 8,
  right: 8,
  paddingLeft: 4,
  paddingRight: 4,
  width: oi
}, t.meridiemMode === "pm" && {
  backgroundColor: (e.vars || e).palette.primary.main,
  color: (e.vars || e).palette.primary.contrastText,
  "&:hover": {
    backgroundColor: (e.vars || e).palette.primary.light
  }
})), VC = B(oe, {
  name: "MuiClock",
  slot: "meridiemText",
  overridesResolver: (e, t) => t.meridiemText
})({
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
});
function pde(e) {
  const t = jt({
    props: e,
    name: "MuiClock"
  }), {
    ampm: n,
    ampmInClock: o,
    autoFocus: r,
    children: i,
    value: s,
    handleMeridiemChange: a,
    isTimeDisabled: c,
    meridiemMode: d,
    minutesStep: u = 1,
    onChange: p,
    selectedId: h,
    type: g,
    viewValue: m,
    disabled: b,
    readOnly: C,
    className: x
  } = t, v = t, S = kt(), M = $n(), w = y.useRef(!1), k = ide(v), E = c(m, g), R = !n && g === "hours" && (m < 1 || m > 12), O = (H, N) => {
    b || C || c(H, g) || p(H, N);
  }, P = (H, N) => {
    let {
      offsetX: z,
      offsetY: se
    } = H;
    if (z === void 0) {
      const Z = H.target.getBoundingClientRect();
      z = H.changedTouches[0].clientX - Z.left, se = H.changedTouches[0].clientY - Z.top;
    }
    const ne = g === "seconds" || g === "minutes" ? Y1e(z, se, u) : X1e(z, se, !!n);
    O(ne, N);
  }, _ = (H) => {
    w.current = !0, P(H, "shallow");
  }, L = (H) => {
    w.current && (P(H, "finish"), w.current = !1);
  }, V = (H) => {
    H.buttons > 0 && P(H.nativeEvent, "shallow");
  }, j = (H) => {
    w.current && (w.current = !1), P(H.nativeEvent, "finish");
  }, I = y.useMemo(() => g === "hours" ? !0 : m % 5 === 0, [g, m]), F = g === "minutes" ? u : 1, $ = y.useRef(null);
  En(() => {
    r && $.current.focus();
  }, [r]);
  const A = (H) => {
    if (!w.current)
      switch (H.key) {
        case "Home":
          O(0, "partial"), H.preventDefault();
          break;
        case "End":
          O(g === "minutes" ? 59 : 23, "partial"), H.preventDefault();
          break;
        case "ArrowUp":
          O(m + F, "partial"), H.preventDefault();
          break;
        case "ArrowDown":
          O(m - F, "partial"), H.preventDefault();
          break;
      }
  };
  return /* @__PURE__ */ f.jsxs(sde, {
    className: xe(x, k.root),
    children: [/* @__PURE__ */ f.jsxs(ade, {
      className: k.clock,
      children: [/* @__PURE__ */ f.jsx(cde, {
        onTouchMove: _,
        onTouchEnd: L,
        onMouseUp: j,
        onMouseMove: V,
        ownerState: {
          disabled: b
        },
        className: k.squareMask
      }), !E && /* @__PURE__ */ f.jsxs(y.Fragment, {
        children: [/* @__PURE__ */ f.jsx(dde, {
          className: k.pin
        }), s != null && /* @__PURE__ */ f.jsx(ode, {
          type: g,
          viewValue: m,
          isInner: R,
          hasSelected: I
        })]
      }), /* @__PURE__ */ f.jsx(lde, {
        "aria-activedescendant": h,
        "aria-label": M.clockLabelText(g, s, S),
        ref: $,
        role: "listbox",
        onKeyDown: A,
        tabIndex: 0,
        className: k.wrapper,
        children: i
      })]
    }), n && o && /* @__PURE__ */ f.jsxs(y.Fragment, {
      children: [/* @__PURE__ */ f.jsx(ude, {
        onClick: C ? void 0 : () => a("am"),
        disabled: b || d === null,
        ownerState: v,
        className: k.amButton,
        title: _r(S, "am"),
        children: /* @__PURE__ */ f.jsx(VC, {
          variant: "caption",
          className: k.meridiemText,
          children: _r(S, "am")
        })
      }), /* @__PURE__ */ f.jsx(fde, {
        disabled: b || d === null,
        onClick: C ? void 0 : () => a("pm"),
        ownerState: v,
        className: k.pmButton,
        title: _r(S, "pm"),
        children: /* @__PURE__ */ f.jsx(VC, {
          variant: "caption",
          className: k.meridiemText,
          children: _r(S, "pm")
        })
      })]
    })]
  });
}
function hde(e) {
  return _e("MuiClockNumber", e);
}
const Z1 = Re("MuiClockNumber", ["root", "selected", "disabled"]), gde = ["className", "disabled", "index", "inner", "label", "selected"], mde = (e) => {
  const {
    classes: t,
    selected: n,
    disabled: o
  } = e;
  return Oe({
    root: ["root", n && "selected", o && "disabled"]
  }, hde, t);
}, bde = B("span", {
  name: "MuiClockNumber",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`&.${Z1.disabled}`]: t.disabled
  }, {
    [`&.${Z1.selected}`]: t.selected
  }]
})(({
  theme: e,
  ownerState: t
}) => T({
  height: oi,
  width: oi,
  position: "absolute",
  left: `calc((100% - ${oi}px) / 2)`,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50%",
  color: (e.vars || e).palette.text.primary,
  fontFamily: e.typography.fontFamily,
  "&:focused": {
    backgroundColor: (e.vars || e).palette.background.paper
  },
  [`&.${Z1.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText
  },
  [`&.${Z1.disabled}`]: {
    pointerEvents: "none",
    color: (e.vars || e).palette.text.disabled
  }
}, t.inner && T({}, e.typography.body2, {
  color: (e.vars || e).palette.text.secondary
})));
function Lk(e) {
  const t = jt({
    props: e,
    name: "MuiClockNumber"
  }), {
    className: n,
    disabled: o,
    index: r,
    inner: i,
    label: s,
    selected: a
  } = t, c = le(t, gde), d = t, u = mde(d), p = r % 12 / 12 * Math.PI * 2 - Math.PI / 2, h = (zl - oi - 2) / 2 * (i ? 0.65 : 1), g = Math.round(Math.cos(p) * h), m = Math.round(Math.sin(p) * h);
  return /* @__PURE__ */ f.jsx(bde, T({
    className: xe(n, u.root),
    "aria-disabled": o ? !0 : void 0,
    "aria-selected": a ? !0 : void 0,
    role: "option",
    style: {
      transform: `translate(${g}px, ${m + (zl - oi) / 2}px`
    },
    ownerState: d
  }, c, {
    children: s
  }));
}
const Cde = ({
  ampm: e,
  value: t,
  getClockNumberText: n,
  isDisabled: o,
  selectedId: r,
  utils: i
}) => {
  const s = t ? i.getHours(t) : null, a = [], c = e ? 1 : 0, d = e ? 12 : 23, u = (p) => s === null ? !1 : e ? p === 12 ? s === 12 || s === 0 : s === p || s - 12 === p : s === p;
  for (let p = c; p <= d; p += 1) {
    let h = p.toString();
    p === 0 && (h = "00");
    const g = !e && (p === 0 || p > 12);
    h = i.formatNumber(h);
    const m = u(p);
    a.push(/* @__PURE__ */ f.jsx(Lk, {
      id: m ? r : void 0,
      index: p,
      inner: g,
      selected: m,
      disabled: o(p),
      label: h,
      "aria-label": n(h)
    }, p));
  }
  return a;
}, DC = ({
  utils: e,
  value: t,
  isDisabled: n,
  getClockNumberText: o,
  selectedId: r
}) => {
  const i = e.formatNumber;
  return [[5, i("05")], [10, i("10")], [15, i("15")], [20, i("20")], [25, i("25")], [30, i("30")], [35, i("35")], [40, i("40")], [45, i("45")], [50, i("50")], [55, i("55")], [0, i("00")]].map(([s, a], c) => {
    const d = s === t;
    return /* @__PURE__ */ f.jsx(Lk, {
      label: a,
      id: d ? r : void 0,
      index: c + 1,
      inner: !1,
      disabled: n(s),
      selected: d,
      "aria-label": o(a)
    }, s);
  });
}, xde = ["ampm", "ampmInClock", "autoFocus", "components", "componentsProps", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableClock", "shouldDisableTime", "showViewSwitcher", "onChange", "view", "views", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "timezone"], yde = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"],
    arrowSwitcher: ["arrowSwitcher"]
  }, U1e, t);
}, vde = B(tf, {
  name: "MuiTimeClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "column",
  position: "relative"
}), wde = B(nk, {
  name: "MuiTimeClock",
  slot: "ArrowSwitcher",
  overridesResolver: (e, t) => t.arrowSwitcher
})({
  position: "absolute",
  right: 12,
  top: 15
}), Sde = ["hours", "minutes"], Ik = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = kt(), r = jt({
    props: t,
    name: "MuiTimeClock"
  }), {
    ampm: i = o.is12HourCycleInCurrentLocale(),
    ampmInClock: s = !1,
    autoFocus: a,
    components: c,
    componentsProps: d,
    slots: u,
    slotProps: p,
    value: h,
    defaultValue: g,
    referenceDate: m,
    disableIgnoringDatePartForTimeValidation: b = !1,
    maxTime: C,
    minTime: x,
    disableFuture: v,
    disablePast: S,
    minutesStep: M = 1,
    shouldDisableClock: w,
    shouldDisableTime: k,
    showViewSwitcher: E,
    onChange: R,
    view: O,
    views: P = Sde,
    openTo: _,
    onViewChange: L,
    focusedView: V,
    onFocusedViewChange: j,
    className: I,
    disabled: F,
    readOnly: $,
    timezone: A
  } = r, H = le(r, xde), N = u ?? z0(c), z = p ?? d, {
    value: se,
    handleValueChange: ne,
    timezone: Z
  } = b2({
    name: "TimeClock",
    timezone: A,
    value: h,
    defaultValue: g,
    onChange: R,
    valueManager: Nn
  }), q = zh({
    value: se,
    referenceDate: m,
    utils: o,
    props: r,
    timezone: Z
  }), G = $n(), K = Fa(Z), {
    view: Q,
    setView: re,
    previousView: U,
    nextView: W,
    setValueAndGoToNextView: D
  } = Z0({
    view: O,
    views: P,
    openTo: _,
    onViewChange: L,
    onChange: ne,
    focusedView: V,
    onFocusedViewChange: j
  }), {
    meridiemMode: X,
    handleMeridiemChange: de
  } = Q3(q, i, D), ue = y.useCallback((te, ie) => {
    const ye = B0(b, o), Ne = ie === "hours" || ie === "minutes" && P.includes("seconds"), We = ({
      start: Me,
      end: Pe
    }) => !(x && ye(x, Pe) || C && ye(Me, C) || v && ye(Me, K) || S && ye(K, Ne ? Pe : Me)), qe = (Me, Pe = 1) => {
      if (Me % Pe !== 0 || w != null && w(Me, ie))
        return !1;
      if (k)
        switch (ie) {
          case "hours":
            return !k(o.setHours(q, Me), "hours");
          case "minutes":
            return !k(o.setMinutes(q, Me), "minutes");
          case "seconds":
            return !k(o.setSeconds(q, Me), "seconds");
          default:
            return !1;
        }
      return !0;
    };
    switch (ie) {
      case "hours": {
        const Me = Xc(te, X, i), Pe = o.setHours(q, Me), fe = o.setSeconds(o.setMinutes(Pe, 0), 0), ae = o.setSeconds(o.setMinutes(Pe, 59), 59);
        return !We({
          start: fe,
          end: ae
        }) || !qe(Me);
      }
      case "minutes": {
        const Me = o.setMinutes(q, te), Pe = o.setSeconds(Me, 0), fe = o.setSeconds(Me, 59);
        return !We({
          start: Pe,
          end: fe
        }) || !qe(te, M);
      }
      case "seconds": {
        const Me = o.setSeconds(q, te);
        return !We({
          start: Me,
          end: Me
        }) || !qe(te);
      }
      default:
        throw new Error("not supported");
    }
  }, [i, q, b, C, X, x, M, w, k, o, v, S, K, P]), he = di(), Ue = y.useMemo(() => {
    switch (Q) {
      case "hours": {
        const te = (ie, ye) => {
          const Ne = Xc(ie, X, i);
          D(o.setHours(q, Ne), ye);
        };
        return {
          onChange: te,
          viewValue: o.getHours(q),
          children: Cde({
            value: se,
            utils: o,
            ampm: i,
            onChange: te,
            getClockNumberText: G.hoursClockNumberText,
            isDisabled: (ie) => F || ue(ie, "hours"),
            selectedId: he
          })
        };
      }
      case "minutes": {
        const te = o.getMinutes(q), ie = (ye, Ne) => {
          D(o.setMinutes(q, ye), Ne);
        };
        return {
          viewValue: te,
          onChange: ie,
          children: DC({
            utils: o,
            value: te,
            onChange: ie,
            getClockNumberText: G.minutesClockNumberText,
            isDisabled: (ye) => F || ue(ye, "minutes"),
            selectedId: he
          })
        };
      }
      case "seconds": {
        const te = o.getSeconds(q), ie = (ye, Ne) => {
          D(o.setSeconds(q, ye), Ne);
        };
        return {
          viewValue: te,
          onChange: ie,
          children: DC({
            utils: o,
            value: te,
            onChange: ie,
            getClockNumberText: G.secondsClockNumberText,
            isDisabled: (ye) => F || ue(ye, "seconds"),
            selectedId: he
          })
        };
      }
      default:
        throw new Error("You must provide the type for ClockView");
    }
  }, [Q, o, se, i, G.hoursClockNumberText, G.minutesClockNumberText, G.secondsClockNumberText, X, D, q, ue, he, F]), me = r, Ie = yde(me);
  return /* @__PURE__ */ f.jsxs(vde, T({
    ref: n,
    className: xe(Ie.root, I),
    ownerState: me
  }, H, {
    children: [/* @__PURE__ */ f.jsx(pde, T({
      autoFocus: a ?? !!V,
      ampmInClock: s && P.includes("hours"),
      value: se,
      type: Q,
      ampm: i,
      minutesStep: M,
      isTimeDisabled: ue,
      meridiemMode: X,
      handleMeridiemChange: de,
      selectedId: he,
      disabled: F,
      readOnly: $
    }, Ue)), E && /* @__PURE__ */ f.jsx(wde, {
      className: Ie.arrowSwitcher,
      slots: N,
      slotProps: z,
      onGoToPrevious: () => re(U),
      isPreviousDisabled: !U,
      previousLabel: G.openPreviousView,
      onGoToNext: () => re(W),
      isNextDisabled: !W,
      nextLabel: G.openNextView,
      ownerState: me
    })]
  }));
});
process.env.NODE_ENV !== "production" && (Ik.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default false
   */
  ampmInClock: l.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  className: l.string,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * Controlled focused view.
   */
  focusedView: l.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: l.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["hours", "minutes", "seconds"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: l.any,
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  showViewSwitcher: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Available views.
   * @default ['hours', 'minutes']
   */
  views: l.arrayOf(l.oneOf(["hours", "minutes", "seconds"]).isRequired)
});
function Mde(e) {
  return _e("MuiDigitalClock", e);
}
const Tde = Re("MuiDigitalClock", ["root", "list", "item"]), kde = ["ampm", "timeStep", "autoFocus", "components", "componentsProps", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableClock", "shouldDisableTime", "onChange", "view", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "views", "skipDisabled", "timezone"], Ede = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"],
    list: ["list"],
    item: ["item"]
  }, Mde, t);
}, Rde = B(tf, {
  name: "MuiDigitalClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  ownerState: e
}) => ({
  overflowY: "auto",
  width: "100%",
  "@media (prefers-reduced-motion: no-preference)": {
    scrollBehavior: e.alreadyRendered ? "smooth" : "auto"
  },
  maxHeight: ok
})), Ode = B(P0, {
  name: "MuiDigitalClock",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  padding: 0
}), _de = B(Jo, {
  name: "MuiDigitalClock",
  slot: "Item",
  overridesResolver: (e, t) => t.item
})(({
  theme: e
}) => ({
  padding: "8px 16px",
  margin: "2px 4px",
  "&:first-of-type": {
    marginTop: 4
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : $t(e.palette.primary.main, e.palette.action.hoverOpacity)
  },
  "&.Mui-selected": {
    backgroundColor: (e.vars || e).palette.primary.main,
    color: (e.vars || e).palette.primary.contrastText,
    "&:focus-visible, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  "&.Mui-focusVisible": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : $t(e.palette.primary.main, e.palette.action.focusOpacity)
  }
})), jk = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i;
  const s = kt(), a = y.useRef(null), c = Tt(n, a), d = jt({
    props: t,
    name: "MuiDigitalClock"
  }), {
    ampm: u = s.is12HourCycleInCurrentLocale(),
    timeStep: p = 30,
    autoFocus: h,
    components: g,
    componentsProps: m,
    slots: b,
    slotProps: C,
    value: x,
    defaultValue: v,
    referenceDate: S,
    disableIgnoringDatePartForTimeValidation: M = !1,
    maxTime: w,
    minTime: k,
    disableFuture: E,
    disablePast: R,
    minutesStep: O = 1,
    shouldDisableClock: P,
    shouldDisableTime: _,
    onChange: L,
    view: V,
    openTo: j,
    onViewChange: I,
    focusedView: F,
    onFocusedViewChange: $,
    className: A,
    disabled: H,
    readOnly: N,
    views: z = ["hours"],
    skipDisabled: se = !1,
    timezone: ne
  } = d, Z = le(d, kde), {
    value: q,
    handleValueChange: G,
    timezone: K
  } = b2({
    name: "DigitalClock",
    timezone: ne,
    value: x,
    defaultValue: v,
    onChange: L,
    valueManager: Nn
  }), Q = $n(), re = Fa(K), U = y.useMemo(() => T({}, d, {
    alreadyRendered: !!a.current
  }), [d]), W = Ede(U), D = (o = (r = b == null ? void 0 : b.digitalClockItem) != null ? r : g == null ? void 0 : g.DigitalClockItem) != null ? o : _de, X = yn({
    elementType: D,
    externalSlotProps: (i = C == null ? void 0 : C.digitalClockItem) != null ? i : m == null ? void 0 : m.digitalClockItem,
    ownerState: {},
    className: W.item
  }), de = zh({
    value: q,
    referenceDate: S,
    utils: s,
    props: d,
    timezone: K
  }), ue = Ke((te) => G(te, "finish", "hours")), {
    setValueAndGoToNextView: he
  } = Z0({
    view: V,
    views: z,
    openTo: j,
    onViewChange: I,
    onChange: ue,
    focusedView: F,
    onFocusedViewChange: $
  }), Ue = Ke((te) => {
    he(te, "finish");
  });
  y.useEffect(() => {
    if (a.current === null)
      return;
    const te = a.current.querySelector('[role="listbox"] [role="option"][aria-selected="true"]');
    if (!te)
      return;
    const ie = te.offsetTop;
    a.current.scrollTop = ie - 4;
  });
  const me = y.useCallback((te) => {
    const ie = B0(M, s), ye = () => !(k && ie(k, te) || w && ie(te, w) || E && ie(te, re) || R && ie(re, te)), Ne = () => s.getMinutes(te) % O !== 0 || P != null && P(s.toJsDate(te).getTime(), "hours") ? !1 : _ ? !_(te, "hours") : !0;
    return !ye() || !Ne();
  }, [M, s, k, w, E, re, R, O, P, _]), Ie = y.useMemo(() => {
    const te = s.startOfDay(de);
    return [te, ...Array.from({
      length: Math.ceil(24 * 60 / p) - 1
    }, (ie, ye) => s.addMinutes(te, p * (ye + 1)))];
  }, [de, p, s]);
  return /* @__PURE__ */ f.jsx(Rde, T({
    ref: c,
    className: xe(W.root, A),
    ownerState: U
  }, Z, {
    children: /* @__PURE__ */ f.jsx(Ode, {
      autoFocusItem: h || !!F,
      role: "listbox",
      "aria-label": Q.timePickerToolbarTitle,
      className: W.list,
      children: Ie.map((te) => {
        if (se && me(te))
          return null;
        const ie = s.isEqual(te, q);
        return /* @__PURE__ */ f.jsx(D, T({
          onClick: () => !N && Ue(te),
          selected: ie,
          disabled: H || me(te),
          disableRipple: N,
          role: "option",
          "aria-disabled": N,
          "aria-selected": ie
        }, X, {
          children: s.format(te, u ? "fullTime12h" : "fullTime24h")
        }), s.toISO(te));
      })
    })
  }));
});
process.env.NODE_ENV !== "production" && (jk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  className: l.string,
  /**
   * Overrideable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * Controlled focused view.
   */
  focusedView: l.oneOf(["hours"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: l.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["hours"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: l.any,
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overrideable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The time steps between two time options.
   * For example, if `timeStep = 45`, then the available time options will be `[00:00, 00:45, 01:30, 02:15, 03:00, etc.]`.
   * @default 30
   */
  timeStep: l.number,
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["hours"]),
  /**
   * Available views.
   * @default ['hours']
   */
  views: l.arrayOf(l.oneOf(["hours"]))
});
const Ml = ({
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: o,
  views: r,
  value: i,
  defaultValue: s,
  referenceDate: a,
  onChange: c,
  className: d,
  classes: u,
  disableFuture: p,
  disablePast: h,
  minTime: g,
  maxTime: m,
  shouldDisableTime: b,
  shouldDisableClock: C,
  minutesStep: x,
  ampm: v,
  ampmInClock: S,
  components: M,
  componentsProps: w,
  slots: k,
  slotProps: E,
  readOnly: R,
  disabled: O,
  sx: P,
  autoFocus: _,
  showViewSwitcher: L,
  disableIgnoringDatePartForTimeValidation: V,
  timezone: j
}) => /* @__PURE__ */ f.jsx(Ik, {
  view: e,
  onViewChange: t,
  focusedView: n && Bl(n) ? n : null,
  onFocusedViewChange: o,
  views: r.filter(Bl),
  value: i,
  defaultValue: s,
  referenceDate: a,
  onChange: c,
  className: d,
  classes: u,
  disableFuture: p,
  disablePast: h,
  minTime: g,
  maxTime: m,
  shouldDisableTime: b,
  shouldDisableClock: C,
  minutesStep: x,
  ampm: v,
  ampmInClock: S,
  components: M,
  componentsProps: w,
  slots: k,
  slotProps: E,
  readOnly: R,
  disabled: O,
  sx: P,
  autoFocus: _,
  showViewSwitcher: L,
  disableIgnoringDatePartForTimeValidation: V,
  timezone: j
}), Vk = ({
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: o,
  views: r,
  value: i,
  defaultValue: s,
  referenceDate: a,
  onChange: c,
  className: d,
  classes: u,
  disableFuture: p,
  disablePast: h,
  minTime: g,
  maxTime: m,
  shouldDisableTime: b,
  shouldDisableClock: C,
  minutesStep: x,
  ampm: v,
  components: S,
  componentsProps: M,
  slots: w,
  slotProps: k,
  readOnly: E,
  disabled: R,
  sx: O,
  autoFocus: P,
  disableIgnoringDatePartForTimeValidation: _,
  timeSteps: L,
  skipDisabled: V,
  timezone: j
}) => /* @__PURE__ */ f.jsx(jk, {
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: o,
  views: r.filter(Bl),
  value: i,
  defaultValue: s,
  referenceDate: a,
  onChange: c,
  className: d,
  classes: u,
  disableFuture: p,
  disablePast: h,
  minTime: g,
  maxTime: m,
  shouldDisableTime: b,
  shouldDisableClock: C,
  minutesStep: x,
  ampm: v,
  components: S,
  componentsProps: M,
  slots: w,
  slotProps: k,
  readOnly: E,
  disabled: R,
  sx: O,
  autoFocus: P,
  disableIgnoringDatePartForTimeValidation: _,
  timeStep: L == null ? void 0 : L.minutes,
  skipDisabled: V,
  timezone: j
}), C5 = ({
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: o,
  views: r,
  value: i,
  defaultValue: s,
  referenceDate: a,
  onChange: c,
  className: d,
  classes: u,
  disableFuture: p,
  disablePast: h,
  minTime: g,
  maxTime: m,
  shouldDisableTime: b,
  shouldDisableClock: C,
  minutesStep: x,
  ampm: v,
  components: S,
  componentsProps: M,
  slots: w,
  slotProps: k,
  readOnly: E,
  disabled: R,
  sx: O,
  autoFocus: P,
  disableIgnoringDatePartForTimeValidation: _,
  timeSteps: L,
  skipDisabled: V,
  timezone: j
}) => /* @__PURE__ */ f.jsx(Ok, {
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: o,
  views: r.filter(Bl),
  value: i,
  defaultValue: s,
  referenceDate: a,
  onChange: c,
  className: d,
  classes: u,
  disableFuture: p,
  disablePast: h,
  minTime: g,
  maxTime: m,
  shouldDisableTime: b,
  shouldDisableClock: C,
  minutesStep: x,
  ampm: v,
  components: S,
  componentsProps: M,
  slots: w,
  slotProps: k,
  readOnly: E,
  disabled: R,
  sx: O,
  autoFocus: P,
  disableIgnoringDatePartForTimeValidation: _,
  timeSteps: L,
  skipDisabled: V,
  timezone: j
}), Ns = ({
  view: e,
  onViewChange: t,
  views: n,
  focusedView: o,
  onFocusedViewChange: r,
  value: i,
  defaultValue: s,
  referenceDate: a,
  onChange: c,
  className: d,
  classes: u,
  disableFuture: p,
  disablePast: h,
  minDate: g,
  minTime: m,
  maxDate: b,
  maxTime: C,
  shouldDisableDate: x,
  shouldDisableMonth: v,
  shouldDisableYear: S,
  shouldDisableTime: M,
  shouldDisableClock: w,
  reduceAnimations: k,
  minutesStep: E,
  ampm: R,
  onMonthChange: O,
  monthsPerRow: P,
  onYearChange: _,
  yearsPerRow: L,
  defaultCalendarMonth: V,
  components: j,
  componentsProps: I,
  slots: F,
  slotProps: $,
  loading: A,
  renderLoading: H,
  disableHighlightToday: N,
  readOnly: z,
  disabled: se,
  showDaysOutsideCurrentMonth: ne,
  dayOfWeekFormatter: Z,
  sx: q,
  autoFocus: G,
  fixedWeekNumber: K,
  displayWeekNumber: Q,
  timezone: re,
  disableIgnoringDatePartForTimeValidation: U,
  timeSteps: W,
  skipDisabled: D,
  timeViewsCount: X,
  shouldRenderTimeInASingleColumn: de
}) => {
  var ue, he;
  const Ue = !!((ue = Da((he = $ == null ? void 0 : $.actionBar) != null ? he : I == null ? void 0 : I.actionBar, {})) != null && (ue = ue.actions) != null && ue.length), me = {
    view: Bi(e) ? e : "hours",
    onViewChange: t,
    focusedView: o && Bi(o) ? o : null,
    onFocusedViewChange: r,
    views: n.filter(Bi),
    value: i,
    defaultValue: s,
    referenceDate: a,
    onChange: c,
    className: d,
    classes: u,
    disableFuture: p,
    disablePast: h,
    minTime: m,
    maxTime: C,
    shouldDisableTime: M,
    shouldDisableClock: w,
    minutesStep: E,
    ampm: R,
    components: j,
    componentsProps: I,
    slots: F,
    slotProps: $,
    readOnly: z,
    disabled: se,
    autoFocus: G,
    disableIgnoringDatePartForTimeValidation: U,
    timeSteps: W,
    skipDisabled: D,
    timezone: re
  };
  return /* @__PURE__ */ f.jsxs(y.Fragment, {
    children: [/* @__PURE__ */ f.jsxs(W1e, {
      children: [/* @__PURE__ */ f.jsx(Nh, {
        view: wl(e) ? e : "day",
        onViewChange: t,
        views: n.filter(wl),
        focusedView: o && wl(o) ? o : null,
        onFocusedViewChange: r,
        value: i,
        defaultValue: s,
        referenceDate: a,
        onChange: c,
        className: d,
        classes: u,
        disableFuture: p,
        disablePast: h,
        minDate: g,
        maxDate: b,
        shouldDisableDate: x,
        shouldDisableMonth: v,
        shouldDisableYear: S,
        reduceAnimations: k,
        onMonthChange: O,
        monthsPerRow: P,
        onYearChange: _,
        yearsPerRow: L,
        defaultCalendarMonth: V,
        components: j,
        componentsProps: I,
        slots: F,
        slotProps: $,
        loading: A,
        renderLoading: H,
        disableHighlightToday: N,
        readOnly: z,
        disabled: se,
        showDaysOutsideCurrentMonth: ne,
        dayOfWeekFormatter: Z,
        sx: q,
        autoFocus: G,
        fixedWeekNumber: K,
        displayWeekNumber: Q,
        timezone: re
      }), X > 0 && /* @__PURE__ */ f.jsxs(y.Fragment, {
        children: [/* @__PURE__ */ f.jsx(ho, {
          orientation: "vertical"
        }), de ? Vk(T({}, me, {
          view: "hours",
          views: ["hours"],
          focusedView: o && Bi(o) ? "hours" : null,
          sx: T({
            width: "auto",
            [`&.${Tde.root}`]: {
              maxHeight: J3
            }
          }, Array.isArray(q) ? q : [q])
        })) : C5(T({}, me, {
          view: Bi(e) ? e : "hours",
          views: n.filter(Bi),
          focusedView: o && Bi(o) ? o : null,
          sx: T({
            borderBottom: 0,
            width: "auto",
            [`.${V1e.root}`]: {
              maxHeight: "100%"
            }
          }, Array.isArray(q) ? q : [q])
        }))]
      })]
    }), Ue && /* @__PURE__ */ f.jsx(ho, {})]
  });
}, Pde = ["views", "format"], Dk = (e, t) => {
  let {
    views: n,
    format: o
  } = t, r = le(t, Pde);
  if (o)
    return o;
  const i = [], s = [];
  if (n.forEach((d) => {
    Bl(d) ? s.push(d) : i.push(d);
  }), s.length === 0)
    return Yc(e, T({
      views: i
    }, r), !1);
  if (i.length === 0)
    return cu(e, T({
      views: s
    }, r));
  const a = cu(e, T({
    views: s
  }, r));
  return `${Yc(e, T({
    views: i
  }, r), !1)} ${a}`;
}, Lde = (e, t, n) => n ? t.filter((o) => !Bi(o) || o === "hours") : e ? [...t, "meridiem"] : t, Ide = (e, t) => {
  var n, o;
  return 24 * 60 / (((n = e.hours) != null ? n : 1) * ((o = e.minutes) != null ? o : 5)) <= t;
};
function Ak({
  thresholdToRenderTimeInASingleColumn: e,
  ampm: t,
  timeSteps: n,
  views: o
}) {
  const r = e ?? 24, i = T({
    hours: 1,
    minutes: 5,
    seconds: 5
  }, n), s = Ide(i, r);
  return {
    thresholdToRenderTimeInASingleColumn: r,
    timeSteps: i,
    shouldRenderTimeInASingleColumn: s,
    views: Lde(t, o, s)
  };
}
const Hk = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i, s, a, c, d;
  const u = $n(), p = kt(), h = Rk(t, "MuiDesktopDateTimePicker"), {
    shouldRenderTimeInASingleColumn: g,
    thresholdToRenderTimeInASingleColumn: m,
    views: b,
    timeSteps: C
  } = Ak(h), x = !h.viewRenderers || Object.keys(h.viewRenderers).length === 0, v = (
    // we can only ensure the expected two-column layout if none of the renderers are overridden
    x ? {
      day: Ns,
      month: Ns,
      year: Ns,
      hours: Ns,
      minutes: Ns,
      seconds: Ns,
      meridiem: Ns
    } : T({
      day: mr,
      month: mr,
      year: mr,
      hours: null,
      minutes: null,
      seconds: null,
      meridiem: null
    }, h.viewRenderers)
  ), S = (o = h.ampmInClock) != null ? o : !0, M = x ? ["accept"] : [], w = T({}, h, {
    viewRenderers: v,
    format: Dk(p, h),
    views: b,
    yearsPerRow: (r = h.yearsPerRow) != null ? r : 4,
    ampmInClock: S,
    timeSteps: C,
    thresholdToRenderTimeInASingleColumn: m,
    shouldRenderTimeInASingleColumn: g,
    slots: T({
      field: Bh,
      openPickerIcon: tk
    }, h.slots),
    slotProps: T({}, h.slotProps, {
      field: (E) => {
        var R;
        return T({}, Da((R = h.slotProps) == null ? void 0 : R.field, E), C2(h), {
          ref: n
        });
      },
      toolbar: T({
        hidden: !0,
        ampmInClock: S,
        toolbarVariant: x ? "desktop" : "mobile"
      }, (i = h.slotProps) == null ? void 0 : i.toolbar),
      tabs: T({
        hidden: !0
      }, (s = h.slotProps) == null ? void 0 : s.tabs),
      actionBar: T({
        actions: M
      }, (a = h.slotProps) == null ? void 0 : a.actionBar)
    })
  }), {
    renderPicker: k
  } = Ah({
    props: w,
    valueManager: Nn,
    valueType: "date-time",
    getOpenDialogAriaText: (c = (d = w.localeText) == null ? void 0 : d.openDatePickerDialogue) != null ? c : u.openDatePickerDialogue,
    validator: Dh
  });
  return k();
});
Hk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: l.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Class name applied to the root element.
   */
  className: l.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: l.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: l.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: l.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: l.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: l.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: l.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: l.object,
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */
  maxDateTime: l.any,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */
  minDateTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: l.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: l.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: l.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: l.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: l.oneOf(["landscape", "portrait"]),
  readOnly: l.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: l.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: l.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: l.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: l.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: l.bool,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: l.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: l.shape({
    hours: l.number,
    minutes: l.number,
    seconds: l.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: l.shape({
    day: l.func,
    hours: l.func,
    meridiem: l.func,
    minutes: l.func,
    month: l.func,
    seconds: l.func,
    year: l.func
  }),
  /**
   * Available views.
   */
  views: l.arrayOf(l.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 4
   */
  yearsPerRow: l.oneOf([3, 4])
};
const Fk = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i, s, a;
  const c = $n(), d = kt(), u = Rk(t, "MuiMobileDateTimePicker"), p = T({
    day: mr,
    month: mr,
    year: mr,
    hours: Ml,
    minutes: Ml,
    seconds: Ml
  }, u.viewRenderers), h = (o = u.ampmInClock) != null ? o : !1, g = T({}, u, {
    viewRenderers: p,
    format: Dk(d, u),
    ampmInClock: h,
    slots: T({
      field: Bh
    }, u.slots),
    slotProps: T({}, u.slotProps, {
      field: (b) => {
        var C;
        return T({}, Da((C = u.slotProps) == null ? void 0 : C.field, b), C2(u), {
          ref: n
        });
      },
      toolbar: T({
        hidden: !1,
        ampmInClock: h
      }, (r = u.slotProps) == null ? void 0 : r.toolbar),
      tabs: T({
        hidden: !1
      }, (i = u.slotProps) == null ? void 0 : i.tabs)
    })
  }), {
    renderPicker: m
  } = $h({
    props: g,
    valueManager: Nn,
    valueType: "date-time",
    getOpenDialogAriaText: (s = (a = g.localeText) == null ? void 0 : a.openDatePickerDialogue) != null ? s : c.openDatePickerDialogue,
    validator: Dh
  });
  return m();
});
Fk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: l.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Class name applied to the root element.
   */
  className: l.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: l.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: l.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: l.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: l.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: l.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: l.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: l.object,
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */
  maxDateTime: l.any,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */
  minDateTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: l.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: l.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: l.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: l.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: l.oneOf(["landscape", "portrait"]),
  readOnly: l.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: l.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: l.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: l.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: l.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: l.shape({
    day: l.func,
    hours: l.func,
    minutes: l.func,
    month: l.func,
    seconds: l.func,
    year: l.func
  }),
  /**
   * Available views.
   */
  views: l.arrayOf(l.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: l.oneOf([3, 4])
};
const jde = ["desktopModeMediaQuery"], Nk = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = jt({
    props: t,
    name: "MuiDateTimePicker"
  }), {
    desktopModeMediaQuery: r = _h
  } = o, i = le(o, jde);
  return y0(r, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ f.jsx(Hk, T({
    ref: n
  }, i)) : /* @__PURE__ */ f.jsx(Fk, T({
    ref: n
  }, i));
});
process.env.NODE_ENV !== "production" && (Nk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: l.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Class name applied to the root element.
   */
  className: l.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: l.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: l.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: l.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: l.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: l.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: l.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: l.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: l.object,
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */
  maxDateTime: l.any,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */
  minDateTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: l.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: l.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: l.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: l.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: l.oneOf(["landscape", "portrait"]),
  readOnly: l.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: l.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: l.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: l.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: l.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: l.bool,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: l.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: l.shape({
    hours: l.number,
    minutes: l.number,
    seconds: l.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: l.shape({
    day: l.func,
    hours: l.func,
    meridiem: l.func,
    minutes: l.func,
    month: l.func,
    seconds: l.func,
    year: l.func
  }),
  /**
   * Available views.
   */
  views: l.arrayOf(l.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 4 on desktop, 3 on mobile
   */
  yearsPerRow: l.oneOf([3, 4])
});
const Vde = (e) => {
  var t, n, o, r;
  const i = kt(), a = ((t = e.ampm) != null ? t : i.is12HourCycleInCurrentLocale()) ? i.formats.fullTime12h : i.formats.fullTime24h;
  return T({}, e, {
    disablePast: (n = e.disablePast) != null ? n : !1,
    disableFuture: (o = e.disableFuture) != null ? o : !1,
    format: (r = e.format) != null ? r : a
  });
}, Dde = ({
  props: e,
  inputRef: t
}) => {
  const n = Vde(e), {
    forwardedProps: o,
    internalProps: r
  } = Vh(n, "time");
  return Ih({
    inputRef: t,
    forwardedProps: o,
    internalProps: r,
    valueManager: Nn,
    fieldValueManager: Eh,
    validator: ef,
    valueType: "time"
  });
}, Ade = ["slots", "slotProps", "components", "componentsProps", "InputProps", "inputProps"], Hde = ["inputRef"], Fde = ["ref", "onPaste", "onKeyDown", "inputMode", "readOnly", "clearable", "onClear"], Zh = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i;
  const s = jt({
    props: t,
    name: "MuiTimeField"
  }), {
    slots: a,
    slotProps: c,
    components: d,
    componentsProps: u,
    InputProps: p,
    inputProps: h
  } = s, g = le(s, Ade), m = s, b = (o = (r = a == null ? void 0 : a.textField) != null ? r : d == null ? void 0 : d.TextField) != null ? o : Ir, C = yn({
    elementType: b,
    externalSlotProps: (i = c == null ? void 0 : c.textField) != null ? i : u == null ? void 0 : u.textField,
    externalForwardedProps: g,
    ownerState: m
  }), {
    inputRef: x
  } = C, v = le(C, Hde);
  v.inputProps = T({}, h, v.inputProps), v.InputProps = T({}, p, v.InputProps);
  const S = Dde({
    props: v,
    inputRef: x
  }), {
    ref: M,
    onPaste: w,
    onKeyDown: k,
    inputMode: E,
    readOnly: R,
    clearable: O,
    onClear: P
  } = S, _ = le(S, Fde), {
    InputProps: L,
    fieldProps: V
  } = Hh({
    onClear: P,
    clearable: O,
    fieldProps: _,
    InputProps: _.InputProps,
    slots: a,
    slotProps: c,
    components: d,
    componentsProps: u
  });
  return /* @__PURE__ */ f.jsx(b, T({
    ref: n
  }, V, {
    InputProps: T({}, L, {
      readOnly: R
    }),
    inputProps: T({}, _.inputProps, {
      inputMode: E,
      onPaste: w,
      onKeyDown: k,
      ref: M
    })
  }));
});
process.env.NODE_ENV !== "production" && (Zh.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: l.bool,
  className: l.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: l.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: l.elementType,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: l.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: l.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The helper text content.
   */
  helperText: l.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: l.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: l.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: l.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: l.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: l.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  onBlur: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  onFocus: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: l.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: l.any,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: l.bool,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default `false`
   */
  shouldRespectLeadingZeros: l.bool,
  /**
   * The size of the component.
   */
  size: l.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  style: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: l.oneOfType([l.func, l.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: l.oneOf(["filled", "outlined", "standard"])
});
function Nde(e) {
  return _e("MuiTimePickerToolbar", e);
}
const Cc = Re("MuiTimePickerToolbar", ["root", "separator", "hourMinuteLabel", "hourMinuteLabelLandscape", "hourMinuteLabelReverse", "ampmSelection", "ampmLandscape", "ampmLabel"]), $de = ["ampm", "ampmInClock", "value", "isLandscape", "onChange", "view", "onViewChange", "views", "disabled", "readOnly", "className"], Bde = (e) => {
  const {
    theme: t,
    isLandscape: n,
    classes: o
  } = e, r = {
    root: ["root"],
    separator: ["separator"],
    hourMinuteLabel: ["hourMinuteLabel", n && "hourMinuteLabelLandscape", t.direction === "rtl" && "hourMinuteLabelReverse"],
    ampmSelection: ["ampmSelection", n && "ampmLandscape"],
    ampmLabel: ["ampmLabel"]
  };
  return Oe(r, Nde, o);
}, zde = B(Oh, {
  name: "MuiTimePickerToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Zde = B(Ph, {
  name: "MuiTimePickerToolbar",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})({
  outline: 0,
  margin: "0 4px 0 2px",
  cursor: "default"
}), $k = B("div", {
  name: "MuiTimePickerToolbar",
  slot: "HourMinuteLabel",
  overridesResolver: (e, t) => [{
    [`&.${Cc.hourMinuteLabelLandscape}`]: t.hourMinuteLabelLandscape,
    [`&.${Cc.hourMinuteLabelReverse}`]: t.hourMinuteLabelReverse
  }, t.hourMinuteLabel]
})(({
  theme: e,
  ownerState: t
}) => T({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-end"
}, t.isLandscape && {
  marginTop: "auto"
}, e.direction === "rtl" && {
  flexDirection: "row-reverse"
}));
$k.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: l.elementType,
  ownerState: l.object.isRequired,
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
};
const Bk = B("div", {
  name: "MuiTimePickerToolbar",
  slot: "AmPmSelection",
  overridesResolver: (e, t) => [{
    [`.${Cc.ampmLabel}`]: t.ampmLabel
  }, {
    [`&.${Cc.ampmLandscape}`]: t.ampmLandscape
  }, t.ampmSelection]
})(({
  ownerState: e
}) => T({
  display: "flex",
  flexDirection: "column",
  marginRight: "auto",
  marginLeft: 12
}, e.isLandscape && {
  margin: "4px 0 auto",
  flexDirection: "row",
  justifyContent: "space-around",
  flexBasis: "100%"
}, {
  [`& .${Cc.ampmLabel}`]: {
    fontSize: 17
  }
}));
Bk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: l.elementType,
  ownerState: l.object.isRequired,
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
};
function zk(e) {
  const t = jt({
    props: e,
    name: "MuiTimePickerToolbar"
  }), {
    ampm: n,
    ampmInClock: o,
    value: r,
    isLandscape: i,
    onChange: s,
    view: a,
    onViewChange: c,
    views: d,
    disabled: u,
    readOnly: p,
    className: h
  } = t, g = le(t, $de), m = kt(), b = $n(), C = ge(), x = !!(n && !o && d.includes("hours")), {
    meridiemMode: v,
    handleMeridiemChange: S
  } = Q3(r, n, s), M = (R) => n ? m.format(R, "hours12h") : m.format(R, "hours24h"), w = t, k = Bde(T({}, w, {
    theme: C
  })), E = /* @__PURE__ */ f.jsx(Zde, {
    tabIndex: -1,
    value: ":",
    variant: "h3",
    selected: !1,
    className: k.separator
  });
  return /* @__PURE__ */ f.jsxs(zde, T({
    landscapeDirection: "row",
    toolbarTitle: b.timePickerToolbarTitle,
    isLandscape: i,
    ownerState: w,
    className: xe(k.root, h)
  }, g, {
    children: [/* @__PURE__ */ f.jsxs($k, {
      className: k.hourMinuteLabel,
      ownerState: w,
      children: [sl(d, "hours") && /* @__PURE__ */ f.jsx(Zo, {
        tabIndex: -1,
        variant: "h3",
        onClick: () => c("hours"),
        selected: a === "hours",
        value: r ? M(r) : "--"
      }), sl(d, ["hours", "minutes"]) && E, sl(d, "minutes") && /* @__PURE__ */ f.jsx(Zo, {
        tabIndex: -1,
        variant: "h3",
        onClick: () => c("minutes"),
        selected: a === "minutes",
        value: r ? m.format(r, "minutes") : "--"
      }), sl(d, ["minutes", "seconds"]) && E, sl(d, "seconds") && /* @__PURE__ */ f.jsx(Zo, {
        variant: "h3",
        onClick: () => c("seconds"),
        selected: a === "seconds",
        value: r ? m.format(r, "seconds") : "--"
      })]
    }), x && /* @__PURE__ */ f.jsxs(Bk, {
      className: k.ampmSelection,
      ownerState: w,
      children: [/* @__PURE__ */ f.jsx(Zo, {
        disableRipple: !0,
        variant: "subtitle2",
        selected: v === "am",
        typographyClassName: k.ampmLabel,
        value: _r(m, "am"),
        onClick: p ? void 0 : () => S("am"),
        disabled: u
      }), /* @__PURE__ */ f.jsx(Zo, {
        disableRipple: !0,
        variant: "subtitle2",
        selected: v === "pm",
        typographyClassName: k.ampmLabel,
        value: _r(m, "pm"),
        onClick: p ? void 0 : () => S("pm"),
        disabled: u
      })]
    })]
  }));
}
process.env.NODE_ENV !== "production" && (zk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  ampm: l.bool,
  ampmInClock: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * className applied to the root component.
   */
  className: l.string,
  disabled: l.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: l.bool,
  isLandscape: l.bool.isRequired,
  onChange: l.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: l.func.isRequired,
  readOnly: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  titleId: l.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: l.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: l.node,
  value: l.any,
  /**
   * Currently visible picker view.
   */
  view: l.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired,
  views: l.arrayOf(l.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired).isRequired
});
function Zk(e, t) {
  var n, o, r, i, s;
  const a = kt(), c = jt({
    props: e,
    name: t
  }), d = (n = c.ampm) != null ? n : a.is12HourCycleInCurrentLocale(), u = y.useMemo(() => {
    var g;
    return ((g = c.localeText) == null ? void 0 : g.toolbarTitle) == null ? c.localeText : T({}, c.localeText, {
      timePickerToolbarTitle: c.localeText.toolbarTitle
    });
  }, [c.localeText]), p = (o = c.slots) != null ? o : z0(c.components), h = (r = c.slotProps) != null ? r : c.componentsProps;
  return T({}, c, {
    ampm: d,
    localeText: u
  }, wh({
    views: c.views,
    openTo: c.openTo,
    defaultViews: ["hours", "minutes"],
    defaultOpenTo: "hours"
  }), {
    disableFuture: (i = c.disableFuture) != null ? i : !1,
    disablePast: (s = c.disablePast) != null ? s : !1,
    slots: T({
      toolbar: zk
    }, p),
    slotProps: T({}, h, {
      toolbar: T({
        ampm: d,
        ampmInClock: c.ampmInClock
      }, h == null ? void 0 : h.toolbar)
    })
  });
}
const Wk = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i, s, a, c;
  const d = $n(), u = kt(), p = Zk(t, "MuiDesktopTimePicker"), {
    shouldRenderTimeInASingleColumn: h,
    views: g,
    timeSteps: m
  } = Ak(p), b = h ? Vk : C5, C = T({
    hours: b,
    minutes: b,
    seconds: b,
    meridiem: b
  }, p.viewRenderers), x = (o = p.ampmInClock) != null ? o : !0, v = h ? [] : ["accept"], M = ((r = C.hours) == null ? void 0 : r.name) === C5.name ? g : g.filter((E) => E !== "meridiem"), w = T({}, p, {
    ampmInClock: x,
    timeSteps: m,
    viewRenderers: C,
    format: cu(u, p),
    // Setting only `hours` time view in case of single column time picker
    // Allows for easy view lifecycle management
    views: h ? ["hours"] : M,
    slots: T({
      field: Zh,
      openPickerIcon: H2e
    }, p.slots),
    slotProps: T({}, p.slotProps, {
      field: (E) => {
        var R;
        return T({}, Da((R = p.slotProps) == null ? void 0 : R.field, E), C2(p), {
          ref: n
        });
      },
      toolbar: T({
        hidden: !0,
        ampmInClock: x
      }, (i = p.slotProps) == null ? void 0 : i.toolbar),
      actionBar: T({
        actions: v
      }, (s = p.slotProps) == null ? void 0 : s.actionBar)
    })
  }), {
    renderPicker: k
  } = Ah({
    props: w,
    valueManager: Nn,
    valueType: "time",
    getOpenDialogAriaText: (a = (c = w.localeText) == null ? void 0 : c.openTimePickerDialogue) != null ? a : d.openTimePickerDialogue,
    validator: ef
  });
  return k();
});
Wk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: l.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Class name applied to the root element.
   */
  className: l.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: l.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: l.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: l.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: l.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: l.oneOf(["landscape", "portrait"]),
  readOnly: l.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: l.any,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: l.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: l.shape({
    hours: l.number,
    minutes: l.number,
    seconds: l.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: l.shape({
    hours: l.func,
    meridiem: l.func,
    minutes: l.func,
    seconds: l.func
  }),
  /**
   * Available views.
   */
  views: l.arrayOf(l.oneOf(["hours", "minutes", "seconds"]).isRequired)
};
const Uk = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var o, r, i, s;
  const a = $n(), c = kt(), d = Zk(t, "MuiMobileTimePicker"), u = T({
    hours: Ml,
    minutes: Ml,
    seconds: Ml
  }, d.viewRenderers), p = (o = d.ampmInClock) != null ? o : !1, h = T({}, d, {
    ampmInClock: p,
    viewRenderers: u,
    format: cu(c, d),
    slots: T({
      field: Zh
    }, d.slots),
    slotProps: T({}, d.slotProps, {
      field: (m) => {
        var b;
        return T({}, Da((b = d.slotProps) == null ? void 0 : b.field, m), C2(d), {
          ref: n
        });
      },
      toolbar: T({
        hidden: !1,
        ampmInClock: p
      }, (r = d.slotProps) == null ? void 0 : r.toolbar)
    })
  }), {
    renderPicker: g
  } = $h({
    props: h,
    valueManager: Nn,
    valueType: "time",
    getOpenDialogAriaText: (i = (s = h.localeText) == null ? void 0 : s.openTimePickerDialogue) != null ? i : a.openTimePickerDialogue,
    validator: ef
  });
  return g();
});
Uk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: l.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Class name applied to the root element.
   */
  className: l.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: l.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: l.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: l.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: l.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: l.oneOf(["landscape", "portrait"]),
  readOnly: l.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: l.any,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: l.shape({
    hours: l.func,
    minutes: l.func,
    seconds: l.func
  }),
  /**
   * Available views.
   */
  views: l.arrayOf(l.oneOf(["hours", "minutes", "seconds"]).isRequired)
};
const Wde = ["desktopModeMediaQuery"], Gk = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = jt({
    props: t,
    name: "MuiTimePicker"
  }), {
    desktopModeMediaQuery: r = _h
  } = o, i = le(o, Wde);
  return y0(r, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ f.jsx(Wk, T({
    ref: n
  }, i)) : /* @__PURE__ */ f.jsx(Uk, T({
    ref: n
  }, i));
});
process.env.NODE_ENV !== "production" && (Gk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: l.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Class name applied to the root element.
   */
  className: l.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: l.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: l.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: sn,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: l.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: l.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: l.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: l.oneOf(["landscape", "portrait"]),
  readOnly: l.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: l.any,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: l.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: l.shape({
    hours: l.number,
    minutes: l.number,
    seconds: l.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: l.shape({
    hours: l.func,
    meridiem: l.func,
    minutes: l.func,
    seconds: l.func
  }),
  /**
   * Available views.
   */
  views: l.arrayOf(l.oneOf(["hours", "minutes", "seconds"]).isRequired)
});
const Tl = (e) => {
  var t, n, o, r;
  return (r = (t = e.id) !== null && t !== void 0 ? t : (o = (n = e.accessorKey) === null || n === void 0 ? void 0 : n.toString) === null || o === void 0 ? void 0 : o.call(n)) !== null && r !== void 0 ? r : e.header;
}, fu = (e) => {
  const t = [], n = (o) => {
    o.forEach((r) => {
      r.columns ? n(r.columns) : t.push(r);
    });
  };
  return n(e), t;
}, qk = ({ columnDefs: e, tableOptions: t }) => {
  const { aggregationFns: n = {}, defaultDisplayColumn: o, filterFns: r = {}, sortingFns: i = {}, state: { columnFilterFns: s = {} } = {} } = t;
  return e.map((a) => {
    var c, d;
    if (a.id || (a.id = Tl(a)), a.columnDefType || (a.columnDefType = "data"), !((c = a.columns) === null || c === void 0) && c.length)
      a.columnDefType = "group", a.columns = qk({
        columnDefs: a.columns,
        tableOptions: t
      });
    else if (a.columnDefType === "data") {
      if (Array.isArray(a.aggregationFn)) {
        const u = a.aggregationFn;
        a.aggregationFn = (p, h, g) => u.map((m) => {
          var b;
          return (b = n[m]) === null || b === void 0 ? void 0 : b.call(n, p, h, g);
        });
      }
      Object.keys(r).includes(s[a.id]) && (a.filterFn = (d = r[s[a.id]]) !== null && d !== void 0 ? d : r.fuzzy, a._filterFn = s[a.id]), Object.keys(i).includes(a.sortingFn) && (a.sortingFn = i[a.sortingFn]);
    } else a.columnDefType === "display" && (a = Object.assign(Object.assign({}, o), a));
    return a;
  });
}, Ude = (e, t, n) => {
  e.getCanPin() && e.pin(t.getIsPinned());
  const o = [...n];
  return o.splice(o.indexOf(t.id), 0, o.splice(o.indexOf(e.id), 1)[0]), o;
}, Gde = (e) => {
  const { filterVariant: t } = e;
  return t === "multi-select" ? "arrIncludesSome" : t != null && t.includes("range") ? "betweenInclusive" : t === "select" || t === "checkbox" ? "equals" : "fuzzy";
}, nf = ({ header: e, table: t }) => {
  var n;
  const { options: { columnFilterModeOptions: o } } = t, { column: r } = e, { columnDef: i } = r, { filterVariant: s } = i, a = !!(s != null && s.startsWith("date") || s != null && s.startsWith("time")), c = s === "autocomplete", d = (s == null ? void 0 : s.includes("range")) || ["between", "betweenInclusive", "inNumberRange"].includes(i._filterFn), u = s === "select", p = s === "multi-select", h = ["autocomplete", "text"].includes(s) || !u && !p, g = i._filterFn, m = (n = i == null ? void 0 : i.columnFilterModeOptions) !== null && n !== void 0 ? n : o, b = r.getFacetedUniqueValues();
  return {
    allowedColumnFilterOptions: m,
    currentFilterOption: g,
    facetedUniqueValues: b,
    isAutocompleteFilter: c,
    isDateFilter: a,
    isMultiSelectFilter: p,
    isRangeFilter: d,
    isSelectFilter: u,
    isTextboxFilter: h
  };
}, Kk = ({ header: e, table: t }) => {
  const { column: n } = e, { columnDef: o } = n, { facetedUniqueValues: r, isAutocompleteFilter: i, isMultiSelectFilter: s, isSelectFilter: a } = nf({ header: e, table: t });
  return tn(() => {
    var c;
    return (c = o.filterSelectOptions) !== null && c !== void 0 ? c : (a || s || i) && r ? Array.from(r.keys()).filter((d) => d != null).sort((d, u) => d.localeCompare(u)) : void 0;
  }, [
    o.filterSelectOptions,
    r,
    s,
    a
  ]);
}, qde = (e, t, n = -1, o = 0, r, i) => $0(e, "mrt-row-create", Object.assign({}, ...fu(e.options.columns).map((s) => ({
  [Tl(s)]: ""
}))), n, o, r, i), Fe = (e, t) => e instanceof Function ? e(t) : e, Si = (e) => {
  var t, n, o;
  let r = "", i = "";
  return e && (typeof e != "object" ? (r = e, i = e) : (r = (n = (t = e.label) !== null && t !== void 0 ? t : e.text) !== null && n !== void 0 ? n : e.value, i = (o = e.value) !== null && o !== void 0 ? o : r)), { label: r, value: i };
}, Yk = ({ cell: e, table: t }) => {
  const { enableEditing: n } = t.options, { column: { columnDef: o }, row: r } = e;
  return !e.getIsPlaceholder() && Fe(n, r) && Fe(o.enableEditing, r) !== !1;
}, Kde = ({ cell: e, table: t }) => {
  const { options: { editDisplayMode: n }, refs: { editInputRefs: o } } = t, { column: r } = e;
  Yk({ cell: e, table: t }) && n === "cell" && (t.setEditingCell(e), queueMicrotask(() => {
    var i;
    const s = o.current[r.id];
    s && (s.focus(), (i = s.select) === null || i === void 0 || i.call(s));
  }));
};
function Na({ header: e, id: t, size: n, tableOptions: o }) {
  const { defaultDisplayColumn: r, displayColumnDefOptions: i, localization: s } = o;
  return Object.assign(Object.assign(Object.assign(Object.assign({}, r), { header: e ? s[e] : "", size: n }), i == null ? void 0 : i[t]), { id: t });
}
const Xk = (e) => {
  const { enableRowPinning: t, rowPinningDisplayMode: n } = e;
  return !!(t && !(n != null && n.startsWith("select")));
}, Jk = (e) => {
  const { enableRowDragging: t, enableRowOrdering: n } = e;
  return !!(t || n);
}, Wh = (e) => {
  const { enableExpanding: t, enableGrouping: n, renderDetailPanel: o, state: { grouping: r } } = e;
  return !!(t || n && (r != null && r.length) || o);
}, Uh = (e) => {
  const { createDisplayMode: t, editDisplayMode: n, enableEditing: o, enableRowActions: r, state: { creatingRow: i } } = e;
  return !!(r || i && t === "row" || o && ["modal", "row"].includes(n ?? ""));
}, Qk = (e) => !!e.enableRowSelection, eE = (e) => !!e.enableRowNumbers, tE = (e) => e.layoutMode === "grid-no-grow", Yde = (e) => [
  Xk(e) && "mrt-row-pin",
  Jk(e) && "mrt-row-drag",
  e.positionActionsColumn === "first" && Uh(e) && "mrt-row-actions",
  e.positionExpandColumn === "first" && Wh(e) && "mrt-row-expand",
  Qk(e) && "mrt-row-select",
  eE(e) && "mrt-row-numbers"
].filter(Boolean), Xde = (e) => [
  e.positionActionsColumn === "last" && Uh(e) && "mrt-row-actions",
  e.positionExpandColumn === "last" && Wh(e) && "mrt-row-expand",
  tE(e) && "mrt-row-spacer"
].filter(Boolean), nE = (e, t = !1) => {
  const { state: { columnOrder: n = [] } } = e, o = Yde(e), r = Xde(e), i = fu(e.columns).map((a) => Tl(a));
  let s = t ? i : Array.from(/* @__PURE__ */ new Set([...n, ...i]));
  return s = s.filter((a) => !o.includes(a) && !r.includes(a)), [
    ...o,
    ...s,
    ...r
  ];
}, Jde = (e, t, n) => {
  let o = 0;
  return e.columnFiltersMeta[n] && (o = Pse(e.columnFiltersMeta[n], t.columnFiltersMeta[n])), o === 0 ? qs.alphanumeric(e, t, n) : o;
}, Qde = Object.assign(Object.assign({}, qs), { fuzzy: Jde }), eue = (e, t) => Math.max(...Object.values(t.columnFiltersMeta).map((n) => n.rank)) - Math.max(...Object.values(e.columnFiltersMeta).map((n) => n.rank)), oE = (e, t) => {
  const { getCenterRows: n, getPrePaginationRowModel: o, getRowModel: r, getState: i, getTopRows: s, options: { createDisplayMode: a, enablePagination: c, enableRowPinning: d, manualPagination: u, positionCreatingRow: p, rowPinningDisplayMode: h } } = e, { creatingRow: g, pagination: m } = i(), b = tue(e);
  let C = [];
  if (!b)
    C = !d || h != null && h.includes("sticky") ? t ? o().rows : r().rows : n();
  else {
    if (C = o().rows.sort((x, v) => eue(x, v)), c && !u && !t) {
      const x = m.pageIndex * m.pageSize;
      C = C.slice(x, x + m.pageSize);
    }
    d && !(h != null && h.includes("sticky")) && (C = C.filter((x) => !x.getIsPinned()));
  }
  if (d && (h != null && h.includes("sticky"))) {
    const x = C.filter((v) => v.getIsPinned()).map((v) => v.id);
    C = [
      ...s().filter((v) => !x.includes(v.id)),
      ...C
    ];
  }
  if (p !== void 0 && g && a === "row") {
    const x = isNaN(+p) ? p === "top" ? 0 : C.length : +p;
    C = [
      ...C.slice(0, x),
      g,
      ...C.slice(x)
    ];
  }
  return C;
}, rE = (e) => {
  const { getState: t, options: { enableGlobalFilterRankedResults: n, manualExpanding: o, manualFiltering: r, manualGrouping: i, manualSorting: s } } = e, { expanded: a, globalFilterFn: c } = t();
  return !o && !r && !i && !s && n && c === "fuzzy" && a !== !0 && !Object.values(a).some(Boolean);
}, tue = (e) => {
  const { globalFilter: t, sorting: n } = e.getState();
  return rE(e) && t && !Object.values(n).some(Boolean);
}, pu = ({ row: e, table: t }) => {
  const { options: { enableRowSelection: n } } = t;
  return e.getIsSelected() || Fe(n, e) && e.getCanSelectSubRows() && e.getIsAllSubRowsSelected();
}, nue = ({ row: e, staticRowIndex: t = 0, table: n }) => (o, r) => {
  var i;
  const { getState: s, options: { enableBatchRowSelection: a, enableMultiRowSelection: c, enableRowPinning: d, manualPagination: u, rowPinningDisplayMode: p }, refs: { lastSelectedRowId: h } } = n, { pagination: { pageIndex: g, pageSize: m } } = s(), b = u ? 0 : m * g, C = pu({ row: e, table: n });
  e.toggleSelected(r ?? !C);
  const x = /* @__PURE__ */ new Set([e.id]);
  if (a && c && o.nativeEvent.shiftKey && h.current !== null) {
    const v = oE(n, !0), S = v.findIndex((M) => M.id === h.current);
    if (S !== -1) {
      const M = pu({
        row: v == null ? void 0 : v[S],
        table: n
      }), w = t + b, [k, E] = S < w ? [S, w] : [w, S];
      if (C !== M)
        for (let R = k; R <= E; R++)
          v[R].toggleSelected(!C), x.add(v[R].id);
    }
  }
  h.current = e.id, e.getCanSelectSubRows() && e.getIsAllSubRowsSelected() && ((i = e.subRows) === null || i === void 0 || i.forEach((v) => v.toggleSelected(!1))), d && (p != null && p.includes("select")) && x.forEach((v) => {
    n.getRow(v).pin(C ? !1 : p != null && p.includes("bottom") ? "bottom" : "top");
  });
}, iE = ({ table: e }) => (t, n, o) => {
  const { options: { enableRowPinning: r, rowPinningDisplayMode: i, selectAllMode: s }, refs: { lastSelectedRowId: a } } = e;
  s === "all" || o ? e.toggleAllRowsSelected(n ?? t.target.checked) : e.toggleAllPageRowsSelected(n ?? t.target.checked), r && (i != null && i.includes("select")) && e.setRowPinning({ bottom: [], top: [] }), a.current = null;
}, oue = Object.assign({}, Rd), sE = (e, t, n, o) => {
  const r = Rse(e.getValue(t), n, {
    threshold: xo.MATCHES
  });
  return o(r), r.passed;
};
sE.autoRemove = (e) => !e;
const aE = (e, t, n) => e.getValue(t).toString().toLowerCase().trim().includes(n.toString().toLowerCase().trim());
aE.autoRemove = (e) => !e;
const lE = (e, t, n) => e.getValue(t).toString().toLowerCase().trim().startsWith(n.toString().toLowerCase().trim());
lE.autoRemove = (e) => !e;
const cE = (e, t, n) => e.getValue(t).toString().toLowerCase().trim().endsWith(n.toString().toLowerCase().trim());
cE.autoRemove = (e) => !e;
const of = (e, t, n) => e.getValue(t).toString().toLowerCase().trim() === (n == null ? void 0 : n.toString().toLowerCase().trim());
of.autoRemove = (e) => !e;
const dE = (e, t, n) => e.getValue(t).toString().toLowerCase().trim() !== n.toString().toLowerCase().trim();
dE.autoRemove = (e) => !e;
const rf = (e, t, n) => !isNaN(+n) && !isNaN(+e.getValue(t)) ? +e.getValue(t) > +n : e.getValue(t).toString().toLowerCase().trim() > (n == null ? void 0 : n.toString().toLowerCase().trim());
rf.autoRemove = (e) => !e;
const Gh = (e, t, n) => of(e, t, n) || rf(e, t, n);
Gh.autoRemove = (e) => !e;
const sf = (e, t, n) => !isNaN(+n) && !isNaN(+e.getValue(t)) ? +e.getValue(t) < +n : e.getValue(t).toString().toLowerCase().trim() < (n == null ? void 0 : n.toString().toLowerCase().trim());
sf.autoRemove = (e) => !e;
const qh = (e, t, n) => of(e, t, n) || sf(e, t, n);
qh.autoRemove = (e) => !e;
const uE = (e, t, n) => (["", void 0].includes(n[0]) || rf(e, t, n[0])) && (!isNaN(+n[0]) && !isNaN(+n[1]) && +n[0] > +n[1] || ["", void 0].includes(n[1]) || sf(e, t, n[1]));
uE.autoRemove = (e) => !e;
const fE = (e, t, n) => (["", void 0].includes(n[0]) || Gh(e, t, n[0])) && (!isNaN(+n[0]) && !isNaN(+n[1]) && +n[0] > +n[1] || ["", void 0].includes(n[1]) || qh(e, t, n[1]));
fE.autoRemove = (e) => !e;
const pE = (e, t, n) => !e.getValue(t).toString().trim();
pE.autoRemove = (e) => !e;
const hE = (e, t, n) => !!e.getValue(t).toString().trim();
hE.autoRemove = (e) => !e;
const rue = Object.assign(Object.assign({}, Ur), {
  between: uE,
  betweenInclusive: fE,
  contains: aE,
  empty: pE,
  endsWith: cE,
  equals: of,
  fuzzy: sE,
  greaterThan: rf,
  greaterThanOrEqualTo: Gh,
  lessThan: sf,
  lessThanOrEqualTo: qh,
  notEmpty: hE,
  notEquals: dE,
  startsWith: lE
});
function Pt(e, t) {
  var n = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
}
const iue = (e) => {
  var { row: t, table: n, variant: o = "icon" } = e, r = Pt(e, ["row", "table", "variant"]);
  const { getState: i, options: { icons: { CancelIcon: s, SaveIcon: a }, localization: c, onCreatingRowCancel: d, onCreatingRowSave: u, onEditingRowCancel: p, onEditingRowSave: h }, refs: { editInputRefs: g }, setCreatingRow: m, setEditingRow: b } = n, { creatingRow: C, editingRow: x, isSaving: v } = i(), S = (C == null ? void 0 : C.id) === t.id, M = (x == null ? void 0 : x.id) === t.id, w = () => {
    S ? (d == null || d({ row: t, table: n }), m(null)) : M && (p == null || p({ row: t, table: n }), b(null)), t._valuesCache = {};
  }, k = () => {
    var E;
    (E = Object.values(g == null ? void 0 : g.current).filter((R) => {
      var O, P;
      return t.id === ((P = (O = R == null ? void 0 : R.name) === null || O === void 0 ? void 0 : O.split("_")) === null || P === void 0 ? void 0 : P[0]);
    })) === null || E === void 0 || E.forEach((R) => {
      R.value !== void 0 && Object.hasOwn(t == null ? void 0 : t._valuesCache, R.name) && (t._valuesCache[R.name] = R.value);
    }), S ? u == null || u({
      exitCreatingMode: () => m(null),
      row: t,
      table: n,
      values: t._valuesCache
    }) : M && (h == null || h({
      exitEditingMode: () => b(null),
      row: t,
      table: n,
      values: t == null ? void 0 : t._valuesCache
    }));
  };
  return f.jsx(J, { onClick: (E) => E.stopPropagation(), sx: (E) => Object.assign({ display: "flex", gap: "0.75rem" }, Fe(r == null ? void 0 : r.sx, E)), children: o === "icon" ? f.jsxs(f.Fragment, { children: [f.jsx(ln, { title: c.cancel, children: f.jsx(Bt, { "aria-label": c.cancel, onClick: w, children: f.jsx(s, {}) }) }), (S && u || M && h) && f.jsx(ln, { title: c.save, children: f.jsx(Bt, { "aria-label": c.save, color: "info", disabled: v, onClick: k, children: v ? f.jsx(Sa, { size: 18 }) : f.jsx(a, {}) }) })] }) : f.jsxs(f.Fragment, { children: [f.jsx(at, { onClick: w, sx: { minWidth: "100px" }, children: c.cancel }), f.jsxs(at, { disabled: v, onClick: k, sx: { minWidth: "100px" }, variant: "contained", children: [v && f.jsx(Sa, { color: "inherit", size: 18 }), c.save] })] }) });
}, xc = (e) => e.replace(/[^a-zA-Z0-9]/g, "_"), sue = (e, t) => {
  var n;
  const o = Fe(e, t), r = (n = o == null ? void 0 : o.baseBackgroundColor) !== null && n !== void 0 ? n : t.palette.mode === "dark" ? fd(t.palette.background.default, 0.05) : t.palette.background.default;
  return Object.assign({ baseBackgroundColor: r, draggingBorderColor: t.palette.primary.main, matchHighlightColor: t.palette.mode === "dark" ? C4(t.palette.warning.dark, 0.25) : fd(t.palette.warning.light, 0.5), menuBackgroundColor: fd(r, 0.07), pinnedRowBackgroundColor: $t(t.palette.primary.main, 0.1), selectedRowBackgroundColor: $t(t.palette.primary.main, 0.2) }, o);
}, x5 = {
  content: '""',
  height: "100%",
  left: 0,
  position: "absolute",
  top: 0,
  width: "100%",
  zIndex: -1
}, gE = ({ column: e, table: t, theme: n }) => {
  const { baseBackgroundColor: o } = t.options.mrtTheme, r = e == null ? void 0 : e.getIsPinned();
  return {
    '&[data-pinned="true"]': {
      "&:before": Object.assign({ backgroundColor: $t(C4(o, n.palette.mode === "dark" ? 0.05 : 0.01), 0.97), boxShadow: e ? r === "left" && e.getIsLastColumn(r) ? `-4px 0 4px -4px ${$t(n.palette.grey[700], 0.5)} inset` : r === "right" && e.getIsFirstColumn(r) ? `4px 0 4px -4px ${$t(n.palette.grey[700], 0.5)} inset` : void 0 : void 0 }, x5)
    }
  };
}, Kh = ({ column: e, header: t, table: n, tableCellProps: o, theme: r }) => {
  var i, s, a, c, d, u;
  const { getState: p, options: { enableColumnVirtualization: h, layoutMode: g } } = n, { draggingColumn: m } = p(), { columnDef: b } = e, { columnDefType: C } = b, x = b.columnDefType !== "group" && e.getIsPinned(), v = {
    minWidth: `max(calc(var(--${t ? "header" : "col"}-${xc((i = t == null ? void 0 : t.id) !== null && i !== void 0 ? i : e.id)}-size) * 1px), ${(s = b.minSize) !== null && s !== void 0 ? s : 30}px)`,
    width: `calc(var(--${t ? "header" : "col"}-${xc((a = t == null ? void 0 : t.id) !== null && a !== void 0 ? a : e.id)}-size) * 1px)`
  };
  g === "grid" ? v.flex = `${[0, !1].includes(b.grow) ? 0 : `var(--${t ? "header" : "col"}-${xc((c = t == null ? void 0 : t.id) !== null && c !== void 0 ? c : e.id)}-size)`} 0 auto` : g === "grid-no-grow" && (v.flex = `${+(b.grow || 0)} 0 auto`);
  const S = x ? Object.assign(Object.assign({}, gE({ column: e, table: n, theme: r })), { left: x === "left" ? `${e.getStart("left")}px` : void 0, opacity: 0.97, position: "sticky", right: x === "right" ? `${e.getAfter("right")}px` : void 0 }) : {};
  return Object.assign(Object.assign(Object.assign({ backgroundColor: "inherit", backgroundImage: "inherit", display: g != null && g.startsWith("grid") ? "flex" : void 0, justifyContent: C === "group" ? "center" : g != null && g.startsWith("grid") ? o.align : void 0, opacity: ((d = n.getState().draggingColumn) === null || d === void 0 ? void 0 : d.id) === e.id || ((u = n.getState().hoveredColumn) === null || u === void 0 ? void 0 : u.id) === e.id ? 0.5 : 1, position: "relative", transition: h ? "none" : "padding 150ms ease-in-out", zIndex: e.getIsResizing() || (m == null ? void 0 : m.id) === e.id ? 2 : C !== "group" && x ? 1 : 0 }, S), v), Fe(o == null ? void 0 : o.sx, r));
}, W1 = (e) => e.direction === "rtl" ? { style: { transform: "scaleX(-1)" } } : void 0, Fr = (e) => ({
  disableInteractive: !0,
  enterDelay: 1e3,
  enterNextDelay: 1e3,
  placement: e
}), Ro = (e) => {
  var { icon: t, label: n, onOpenSubMenu: o, table: r } = e, i = Pt(e, ["icon", "label", "onOpenSubMenu", "table"]);
  const { options: { icons: { ArrowRightIcon: s } } } = r;
  return f.jsxs(Jo, Object.assign({ sx: {
    alignItems: "center",
    justifyContent: "space-between",
    minWidth: "120px",
    my: 0,
    py: "6px"
  } }, i, { children: [f.jsxs(J, { sx: {
    alignItems: "center",
    display: "flex"
  }, children: [f.jsx(r7, { children: t }), n] }), o && f.jsx(Bt, { onClick: o, onMouseEnter: o, size: "small", sx: { p: 0 }, children: f.jsx(s, {}) })] }));
}, aue = (e) => {
  var { anchorEl: t, handleEdit: n, row: o, setAnchorEl: r, staticRowIndex: i, table: s } = e, a = Pt(e, ["anchorEl", "handleEdit", "row", "setAnchorEl", "staticRowIndex", "table"]);
  const { getState: c, options: { editDisplayMode: d, enableEditing: u, icons: { EditIcon: p }, localization: h, mrtTheme: { menuBackgroundColor: g }, renderRowActionMenuItems: m } } = s, { density: b } = c();
  return f.jsxs(p2, Object.assign({ MenuListProps: {
    dense: b === "compact",
    sx: {
      backgroundColor: g
    }
  }, anchorEl: t, disableScrollLock: !0, onClick: (C) => C.stopPropagation(), onClose: () => r(null), open: !!t }, a, { children: [Fe(u, o) && ["modal", "row"].includes(d) && f.jsx(Ro, { icon: f.jsx(p, {}), label: h.edit, onClick: n, table: s }), m == null ? void 0 : m({
    closeMenu: () => r(null),
    row: o,
    staticRowIndex: i,
    table: s
  })] }));
}, AC = {
  "&:hover": {
    opacity: 1
  },
  height: "2rem",
  ml: "10px",
  opacity: 0.5,
  transition: "opacity 150ms",
  width: "2rem"
}, lue = (e) => {
  var { cell: t, row: n, staticRowIndex: o, table: r } = e, i = Pt(e, ["cell", "row", "staticRowIndex", "table"]);
  const { getState: s, options: { createDisplayMode: a, editDisplayMode: c, enableEditing: d, icons: { EditIcon: u, MoreHorizIcon: p }, localization: h, renderRowActionMenuItems: g, renderRowActions: m }, setEditingRow: b } = r, { creatingRow: C, editingRow: x } = s(), v = (C == null ? void 0 : C.id) === n.id, S = (x == null ? void 0 : x.id) === n.id, M = v && a === "row" || S && c === "row", [w, k] = Ae(null), E = (O) => {
    O.stopPropagation(), O.preventDefault(), k(O.currentTarget);
  }, R = (O) => {
    O.stopPropagation(), b(Object.assign({}, n)), k(null);
  };
  return f.jsx(f.Fragment, { children: m && !M ? m({ cell: t, row: n, staticRowIndex: o, table: r }) : M ? f.jsx(iue, { row: n, table: r }) : !g && Fe(d, n) && ["modal", "row"].includes(c) ? f.jsx(ln, { placement: "right", title: h.edit, children: f.jsx(Bt, Object.assign({ "aria-label": h.edit, onClick: R, sx: AC }, i, { children: f.jsx(u, {}) })) }) : g ? f.jsxs(f.Fragment, { children: [f.jsx(ln, Object.assign({}, Fr(), { title: h.rowActions, children: f.jsx(Bt, Object.assign({ "aria-label": h.rowActions, onClick: E, size: "small", sx: AC }, i, { children: f.jsx(p, {}) })) })), f.jsx(aue, { anchorEl: w, handleEdit: R, row: n, setAnchorEl: k, staticRowIndex: o, table: r })] }) : null });
}, cue = (e) => Object.assign({ Cell: ({ cell: t, row: n, staticRowIndex: o, table: r }) => f.jsx(lue, { cell: t, row: n, staticRowIndex: o, table: r }) }, Na({
  header: "actions",
  id: "mrt-row-actions",
  size: 70,
  tableOptions: e
})), mE = (e) => {
  var t, n, { location: o, table: r } = e, i = Pt(e, ["location", "table"]);
  const { options: { icons: { DragHandleIcon: s }, localization: a } } = r;
  return f.jsx(ln, Object.assign({}, Fr("top"), { title: (t = i == null ? void 0 : i.title) !== null && t !== void 0 ? t : a.move, children: f.jsx(Bt, Object.assign({ "aria-label": (n = i.title) !== null && n !== void 0 ? n : a.move, disableRipple: !0, draggable: "true", size: "small" }, i, { onClick: (c) => {
    var d;
    c.stopPropagation(), (d = i == null ? void 0 : i.onClick) === null || d === void 0 || d.call(i, c);
  }, sx: (c) => Object.assign({ "&:active": {
    cursor: "grabbing"
  }, "&:hover": {
    backgroundColor: "transparent",
    opacity: 1
  }, cursor: "grab", m: "0 -0.1rem", opacity: o === "row" ? 1 : 0.5, p: "2px", transition: "all 150ms ease-in-out" }, Fe(i == null ? void 0 : i.sx, c)), title: void 0, children: f.jsx(s, {}) })) }));
}, due = (e) => {
  var { row: t, rowRef: n, table: o } = e, r = Pt(e, ["row", "rowRef", "table"]);
  const { options: { muiRowDragHandleProps: i } } = o, s = Object.assign(Object.assign({}, Fe(i, {
    row: t,
    table: o
  })), r), a = (d) => {
    var u;
    (u = s == null ? void 0 : s.onDragStart) === null || u === void 0 || u.call(s, d);
    try {
      d.dataTransfer.setDragImage(n.current, 0, 0);
    } catch (p) {
      console.error(p);
    }
    o.setDraggingRow(t);
  }, c = (d) => {
    var u;
    (u = s == null ? void 0 : s.onDragEnd) === null || u === void 0 || u.call(s, d), o.setDraggingRow(null), o.setHoveredRow(null);
  };
  return f.jsx(mE, Object.assign({}, s, { location: "row", onDragEnd: c, onDragStart: a, table: o }));
}, uue = (e) => Object.assign({ Cell: ({ row: t, rowRef: n, table: o }) => f.jsx(due, { row: t, rowRef: n, table: o }), grow: !1 }, Na({
  header: "move",
  id: "mrt-row-drag",
  size: 60,
  tableOptions: e
})), fue = (e) => {
  var t, n, { table: o } = e, r = Pt(e, ["table"]);
  const { getCanSomeRowsExpand: i, getIsAllRowsExpanded: s, getIsSomeRowsExpanded: a, getState: c, options: { icons: { KeyboardDoubleArrowDownIcon: d }, localization: u, muiExpandAllButtonProps: p, renderDetailPanel: h }, toggleAllRowsExpanded: g } = o, { density: m, isLoading: b } = c(), C = Object.assign(Object.assign({}, Fe(p, {
    table: o
  })), r), x = s();
  return f.jsx(ln, Object.assign({}, Fr(), { title: (t = C == null ? void 0 : C.title) !== null && t !== void 0 ? t : x ? u.collapseAll : u.expandAll, children: f.jsx("span", { children: f.jsx(Bt, Object.assign({ "aria-label": u.expandAll, disabled: b || !h && !i(), onClick: () => g(!x) }, C, { sx: (v) => Object.assign({ height: m === "compact" ? "1.75rem" : "2.25rem", mt: m !== "compact" ? "-0.25rem" : void 0, width: m === "compact" ? "1.75rem" : "2.25rem" }, Fe(C == null ? void 0 : C.sx, v)), title: void 0, children: (n = C == null ? void 0 : C.children) !== null && n !== void 0 ? n : f.jsx(d, { style: {
    transform: `rotate(${x ? -180 : a() ? -90 : 0}deg)`,
    transition: "transform 150ms"
  } }) })) }) }));
}, HC = ({ row: e, staticRowIndex: t, table: n }) => {
  var o, r;
  const i = ge(), { getState: s, options: { icons: { ExpandMoreIcon: a }, localization: c, muiExpandButtonProps: d, positionExpandColumn: u, renderDetailPanel: p } } = n, { density: h } = s(), g = Fe(d, {
    row: e,
    staticRowIndex: t,
    table: n
  }), m = e.getCanExpand(), b = e.getIsExpanded(), C = (v) => {
    var S;
    v.stopPropagation(), e.toggleExpanded(), (S = g == null ? void 0 : g.onClick) === null || S === void 0 || S.call(g, v);
  }, x = !!(p != null && p({ row: e, table: n }));
  return f.jsx(ln, Object.assign({ disableHoverListener: !m && !x }, Fr(), { title: (o = g == null ? void 0 : g.title) !== null && o !== void 0 ? o : b ? c.collapse : c.expand, children: f.jsx("span", { children: f.jsx(Bt, Object.assign({ "aria-label": c.expand, disabled: !m && !x }, g, { onClick: C, sx: (v) => Object.assign({ height: h === "compact" ? "1.75rem" : "2.25rem", opacity: !m && !x ? 0.3 : 1, [v.direction === "rtl" || u === "last" ? "mr" : "ml"]: `${e.depth * 16}px`, width: h === "compact" ? "1.75rem" : "2.25rem" }, Fe(g == null ? void 0 : g.sx, v)), title: void 0, children: (r = g == null ? void 0 : g.children) !== null && r !== void 0 ? r : f.jsx(a, { style: {
    transform: `rotate(${!m && !p ? u === "last" || i.direction === "rtl" ? 90 : -90 : b ? -180 : 0}deg)`,
    transition: "transform 150ms"
  } }) })) }) }));
}, pue = (e) => {
  var t;
  const { defaultColumn: n, enableExpandAll: o, groupedColumnMode: r, positionExpandColumn: i, renderDetailPanel: s, state: { grouping: a } } = e, c = i === "last" ? {
    align: "right"
  } : void 0;
  return Object.assign({ Cell: ({ cell: d, column: u, row: p, staticRowIndex: h, table: g }) => {
    var m, b, C;
    const x = { row: p, staticRowIndex: h, table: g }, v = (m = p.subRows) === null || m === void 0 ? void 0 : m.length;
    return r === "remove" && p.groupingColumnId ? f.jsxs(be, { alignItems: "center", flexDirection: "row", gap: "0.25rem", children: [f.jsx(HC, Object.assign({}, x)), f.jsx(ln, Object.assign({}, Fr("right"), { title: g.getColumn(p.groupingColumnId).columnDef.header, children: f.jsx("span", { children: p.groupingValue }) })), !!v && f.jsxs("span", { children: ["(", v, ")"] })] }) : f.jsxs(f.Fragment, { children: [f.jsx(HC, Object.assign({}, x)), (C = (b = u.columnDef).GroupedCell) === null || C === void 0 ? void 0 : C.call(b, { cell: d, column: u, row: p, table: g })] });
  }, Header: o ? ({ table: d }) => {
    var u;
    return f.jsxs(f.Fragment, { children: [f.jsx(fue, { table: d }), r === "remove" && ((u = a == null ? void 0 : a.map((p) => d.getColumn(p).columnDef.header)) === null || u === void 0 ? void 0 : u.join(", "))] });
  } : void 0, muiTableBodyCellProps: c, muiTableHeadCellProps: c }, Na({
    header: "expand",
    id: "mrt-row-expand",
    size: r === "remove" ? (t = n == null ? void 0 : n.size) !== null && t !== void 0 ? t : 180 : s ? o ? 60 : 70 : 100,
    tableOptions: e
  }));
}, hue = (e) => {
  const { localization: t, rowNumberDisplayMode: n } = e, { pagination: { pageIndex: o, pageSize: r } } = e.state;
  return Object.assign({ Cell: ({ row: i, staticRowIndex: s }) => {
    var a;
    return ((a = n === "static" ? (s || 0) + (r || 0) * (o || 0) : i.index) !== null && a !== void 0 ? a : 0) + 1;
  }, Header: () => t.rowNumber, grow: !1 }, Na({
    header: "rowNumbers",
    id: "mrt-row-numbers",
    size: 50,
    tableOptions: e
  }));
}, D6 = (e) => {
  var { pinningPosition: t, row: n, table: o } = e, r = Pt(e, ["pinningPosition", "row", "table"]);
  const { options: { icons: { CloseIcon: i, PushPinIcon: s }, localization: a, rowPinningDisplayMode: c } } = o, d = n.getIsPinned(), [u, p] = Ae(!1), h = (g) => {
    p(!1), g.stopPropagation(), n.pin(d ? !1 : t);
  };
  return f.jsx(ln, Object.assign({}, Fr(), { open: u, title: d ? a.unpin : a.pin, children: f.jsx(Bt, Object.assign({ "aria-label": a.pin, onClick: h, onMouseEnter: () => p(!0), onMouseLeave: () => p(!1), size: "small" }, r, { sx: (g) => Object.assign({ height: "24px", width: "24px" }, Fe(r == null ? void 0 : r.sx, g)), children: d ? f.jsx(i, {}) : f.jsx(s, { fontSize: "small", style: {
    transform: `rotate(${c === "sticky" ? 135 : t === "top" ? 180 : 0}deg)`
  } }) })) }));
}, gue = (e) => {
  var { row: t, table: n } = e, o = Pt(e, ["row", "table"]);
  const { getState: r, options: { enableRowPinning: i, rowPinningDisplayMode: s } } = n, { density: a } = r();
  if (!Fe(i, t))
    return null;
  const d = Object.assign({
    row: t,
    table: n
  }, o);
  return s === "top-and-bottom" && !t.getIsPinned() ? f.jsxs(J, { sx: {
    display: "flex",
    flexDirection: a === "compact" ? "row" : "column"
  }, children: [f.jsx(D6, Object.assign({ pinningPosition: "top" }, d)), f.jsx(D6, Object.assign({ pinningPosition: "bottom" }, d))] }) : f.jsx(D6, Object.assign({ pinningPosition: s === "bottom" ? "bottom" : "top" }, d));
}, mue = (e) => Object.assign({ Cell: ({ row: t, table: n }) => f.jsx(gue, { row: t, table: n }), grow: !1 }, Na({
  header: "pin",
  id: "mrt-row-pin",
  size: 60,
  tableOptions: e
})), y5 = (e) => {
  var t, { row: n, staticRowIndex: o, table: r } = e, i = Pt(e, ["row", "staticRowIndex", "table"]);
  const { getState: s, options: { enableMultiRowSelection: a, localization: c, muiSelectAllCheckboxProps: d, muiSelectCheckboxProps: u, selectAllMode: p } } = r, { density: h, isLoading: g } = s(), m = !n, b = m ? p === "page" ? r.getIsAllPageRowsSelected() : r.getIsAllRowsSelected() : void 0, C = m ? b : pu({ row: n, table: r }), x = Object.assign(Object.assign({}, m ? Fe(d, { table: r }) : Fe(u, {
    row: n,
    staticRowIndex: o,
    table: r
  })), i), v = n ? nue({
    row: n,
    staticRowIndex: o,
    table: r
  }) : void 0, S = iE({ table: r }), M = Object.assign(Object.assign({ "aria-label": m ? c.toggleSelectAll : c.toggleSelectRow, checked: C, disabled: g || n && !n.getCanSelect() || (n == null ? void 0 : n.id) === "mrt-row-create", inputProps: {
    "aria-label": m ? c.toggleSelectAll : c.toggleSelectRow
  }, onChange: (w) => {
    w.stopPropagation(), m ? S(w) : v(w);
  }, size: h === "compact" ? "small" : "medium" }, x), { onClick: (w) => {
    var k;
    w.stopPropagation(), (k = x == null ? void 0 : x.onClick) === null || k === void 0 || k.call(x, w);
  }, sx: (w) => Object.assign({ height: h === "compact" ? "1.75rem" : "2.5rem", m: h !== "compact" ? "-0.4rem" : void 0, width: h === "compact" ? "1.75rem" : "2.5rem", zIndex: 0 }, Fe(x == null ? void 0 : x.sx, w)), title: void 0 });
  return f.jsx(ln, Object.assign({}, Fr(), { title: (t = x == null ? void 0 : x.title) !== null && t !== void 0 ? t : m ? c.toggleSelectAll : c.toggleSelectRow, children: a === !1 ? f.jsx(P3, Object.assign({}, M)) : f.jsx(si, Object.assign({ indeterminate: !C && m ? r.getIsSomeRowsSelected() : (n == null ? void 0 : n.getIsSomeSelected()) && n.getCanSelectSubRows() }, M)) }));
}, bue = (e) => {
  const { enableMultiRowSelection: t, enableSelectAll: n } = e;
  return Object.assign({ Cell: ({ row: o, staticRowIndex: r, table: i }) => f.jsx(y5, { row: o, staticRowIndex: r, table: i }), Header: n && t ? ({ table: o }) => f.jsx(y5, { table: o }) : void 0, grow: !1 }, Na({
    header: "select",
    id: "mrt-row-select",
    size: n ? 60 : 70,
    tableOptions: e
  }));
}, Cue = {
  ArrowDownwardIcon: sT,
  ArrowRightIcon: aT,
  CancelIcon: lT,
  ChevronLeftIcon: cT,
  ChevronRightIcon: dT,
  ClearAllIcon: uT,
  CloseIcon: fT,
  ContentCopy: pT,
  DensityLargeIcon: hT,
  DensityMediumIcon: gT,
  DensitySmallIcon: mT,
  DragHandleIcon: bT,
  DynamicFeedIcon: CT,
  EditIcon: xT,
  ExpandMoreIcon: yT,
  FilterAltIcon: vT,
  FilterListIcon: wT,
  FilterListOffIcon: ST,
  FirstPageIcon: MT,
  FullscreenExitIcon: kT,
  FullscreenIcon: TT,
  KeyboardDoubleArrowDownIcon: ET,
  LastPageIcon: RT,
  MoreHorizIcon: OT,
  MoreVertIcon: _T,
  PushPinIcon: PT,
  RestartAltIcon: LT,
  SaveIcon: IT,
  SearchIcon: jT,
  SearchOffIcon: VT,
  SortIcon: DT,
  SyncAltIcon: AT,
  ViewColumnIcon: HT,
  VisibilityOffIcon: FT
}, xue = {
  actions: "Actions",
  and: "and",
  cancel: "Cancel",
  changeFilterMode: "Change filter mode",
  changeSearchMode: "Change search mode",
  clearFilter: "Clear filter",
  clearSearch: "Clear search",
  clearSelection: "Clear selection",
  clearSort: "Clear sort",
  clickToCopy: "Click to copy",
  copy: "Copy",
  collapse: "Collapse",
  collapseAll: "Collapse all",
  columnActions: "Column Actions",
  copiedToClipboard: "Copied to clipboard",
  dropToGroupBy: "Drop to group by {column}",
  edit: "Edit",
  expand: "Expand",
  expandAll: "Expand all",
  filterArrIncludes: "Includes",
  filterArrIncludesAll: "Includes all",
  filterArrIncludesSome: "Includes",
  filterBetween: "Between",
  filterBetweenInclusive: "Between Inclusive",
  filterByColumn: "Filter by {column}",
  filterContains: "Contains",
  filterEmpty: "Empty",
  filterEndsWith: "Ends With",
  filterEquals: "Equals",
  filterEqualsString: "Equals",
  filterFuzzy: "Fuzzy",
  filterGreaterThan: "Greater Than",
  filterGreaterThanOrEqualTo: "Greater Than Or Equal To",
  filterInNumberRange: "Between",
  filterIncludesString: "Contains",
  filterIncludesStringSensitive: "Contains",
  filterLessThan: "Less Than",
  filterLessThanOrEqualTo: "Less Than Or Equal To",
  filterMode: "Filter Mode: {filterType}",
  filterNotEmpty: "Not Empty",
  filterNotEquals: "Not Equals",
  filterStartsWith: "Starts With",
  filterWeakEquals: "Equals",
  filteringByColumn: "Filtering by {column} - {filterType} {filterValue}",
  goToFirstPage: "Go to first page",
  goToLastPage: "Go to last page",
  goToNextPage: "Go to next page",
  goToPreviousPage: "Go to previous page",
  grab: "Grab",
  groupByColumn: "Group by {column}",
  groupedBy: "Grouped by ",
  hideAll: "Hide all",
  hideColumn: "Hide {column} column",
  max: "Max",
  min: "Min",
  move: "Move",
  noRecordsToDisplay: "No records to display",
  noResultsFound: "No results found",
  of: "of",
  or: "or",
  pin: "Pin",
  pinToLeft: "Pin to left",
  pinToRight: "Pin to right",
  resetColumnSize: "Reset column size",
  resetOrder: "Reset order",
  rowActions: "Row Actions",
  rowNumber: "#",
  rowNumbers: "Row Numbers",
  rowsPerPage: "Rows per page",
  save: "Save",
  search: "Search",
  selectedCountOfRowCountRowsSelected: "{selectedCount} of {rowCount} row(s) selected",
  select: "Select",
  showAll: "Show all",
  showAllColumns: "Show all columns",
  showHideColumns: "Show/Hide columns",
  showHideFilters: "Show/Hide filters",
  showHideSearch: "Show/Hide search",
  sortByColumnAsc: "Sort by {column} ascending",
  sortByColumnDesc: "Sort by {column} descending",
  sortedByColumnAsc: "Sorted by {column} ascending",
  sortedByColumnDesc: "Sorted by {column} descending",
  thenBy: ", then by ",
  toggleDensity: "Toggle density",
  toggleFullScreen: "Toggle full screen",
  toggleSelectAll: "Toggle select all",
  toggleSelectRow: "Toggle select row",
  toggleVisibility: "Toggle visibility",
  ungroupByColumn: "Ungroup by {column}",
  unpin: "Unpin",
  unpinAll: "Unpin all"
}, yue = {
  filterVariant: "text",
  maxSize: 1e3,
  minSize: 40,
  size: 180
}, bE = {
  columnDefType: "display",
  enableClickToCopy: !1,
  enableColumnActions: !1,
  enableColumnDragging: !1,
  enableColumnFilter: !1,
  enableColumnOrdering: !1,
  enableEditing: !1,
  enableGlobalFilter: !1,
  enableGrouping: !1,
  enableHiding: !1,
  enableResizing: !1,
  enableSorting: !1
}, vue = (e) => {
  var t, { aggregationFns: n, autoResetExpanded: o = !1, columnFilterDisplayMode: r = "subheader", columnResizeDirection: i, columnResizeMode: s = "onChange", createDisplayMode: a = "modal", defaultColumn: c, defaultDisplayColumn: d, editDisplayMode: u = "modal", enableBatchRowSelection: p = !0, enableBottomToolbar: h = !0, enableColumnActions: g = !0, enableColumnFilters: m = !0, enableColumnOrdering: b = !1, enableColumnPinning: C = !1, enableColumnResizing: x = !1, enableColumnVirtualization: v, enableDensityToggle: S = !0, enableExpandAll: M = !0, enableExpanding: w, enableFacetedValues: k = !1, enableFilterMatchHighlighting: E = !0, enableFilters: R = !0, enableFullScreenToggle: O = !0, enableGlobalFilter: P = !0, enableGlobalFilterRankedResults: _ = !0, enableGrouping: L = !1, enableHiding: V = !0, enableMultiRowSelection: j = !0, enableMultiSort: I = !0, enablePagination: F = !0, enableRowPinning: $ = !1, enableRowSelection: A = !1, enableRowVirtualization: H, enableSelectAll: N = !0, enableSorting: z = !0, enableStickyHeader: se = !1, enableTableFooter: ne = !0, enableTableHead: Z = !0, enableToolbarInternalActions: q = !0, enableTopToolbar: G = !0, filterFns: K, icons: Q, layoutMode: re, localization: U, manualFiltering: W, manualGrouping: D, manualPagination: X, manualSorting: de, mrtTheme: ue, paginationDisplayMode: he = "default", positionActionsColumn: Ue = "first", positionCreatingRow: me = "top", positionExpandColumn: Ie = "first", positionGlobalFilter: te = "right", positionPagination: ie = "bottom", positionToolbarAlertBanner: ye = "top", positionToolbarDropZone: Ne = "top", rowNumberDisplayMode: We = "static", rowPinningDisplayMode: qe = "sticky", selectAllMode: Me = "page", sortingFns: Pe } = e, fe = Pt(e, ["aggregationFns", "autoResetExpanded", "columnFilterDisplayMode", "columnResizeDirection", "columnResizeMode", "createDisplayMode", "defaultColumn", "defaultDisplayColumn", "editDisplayMode", "enableBatchRowSelection", "enableBottomToolbar", "enableColumnActions", "enableColumnFilters", "enableColumnOrdering", "enableColumnPinning", "enableColumnResizing", "enableColumnVirtualization", "enableDensityToggle", "enableExpandAll", "enableExpanding", "enableFacetedValues", "enableFilterMatchHighlighting", "enableFilters", "enableFullScreenToggle", "enableGlobalFilter", "enableGlobalFilterRankedResults", "enableGrouping", "enableHiding", "enableMultiRowSelection", "enableMultiSort", "enablePagination", "enableRowPinning", "enableRowSelection", "enableRowVirtualization", "enableSelectAll", "enableSorting", "enableStickyHeader", "enableTableFooter", "enableTableHead", "enableToolbarInternalActions", "enableTopToolbar", "filterFns", "icons", "layoutMode", "localization", "manualFiltering", "manualGrouping", "manualPagination", "manualSorting", "mrtTheme", "paginationDisplayMode", "positionActionsColumn", "positionCreatingRow", "positionExpandColumn", "positionGlobalFilter", "positionPagination", "positionToolbarAlertBanner", "positionToolbarDropZone", "rowNumberDisplayMode", "rowPinningDisplayMode", "selectAllMode", "sortingFns"]);
  const ae = ge();
  return Q = tn(() => Object.assign(Object.assign({}, Cue), Q), [Q]), U = tn(() => Object.assign(Object.assign({}, xue), U), [U]), ue = tn(() => sue(ue, ae), [ue, ae]), n = tn(() => Object.assign(Object.assign({}, oue), n), []), K = tn(() => Object.assign(Object.assign({}, rue), K), []), Pe = tn(() => Object.assign(Object.assign({}, Qde), Pe), []), c = tn(() => Object.assign(Object.assign({}, yue), c), [c]), d = tn(() => Object.assign(Object.assign({}, bE), d), [d]), [v, H] = tn(() => [v, H], []), i || (i = ae.direction || "ltr"), re = re || (x ? "grid-no-grow" : "semantic"), re === "semantic" && (H || v) && (re = "grid"), H && (se = !0), F === !1 && X === void 0 && (X = !0), !((t = fe.data) === null || t === void 0) && t.length || (W = !0, D = !0, X = !0, de = !0), Object.assign({
    aggregationFns: n,
    autoResetExpanded: o,
    columnFilterDisplayMode: r,
    columnResizeDirection: i,
    columnResizeMode: s,
    createDisplayMode: a,
    defaultColumn: c,
    defaultDisplayColumn: d,
    editDisplayMode: u,
    enableBatchRowSelection: p,
    enableBottomToolbar: h,
    enableColumnActions: g,
    enableColumnFilters: m,
    enableColumnOrdering: b,
    enableColumnPinning: C,
    enableColumnResizing: x,
    enableColumnVirtualization: v,
    enableDensityToggle: S,
    enableExpandAll: M,
    enableExpanding: w,
    enableFacetedValues: k,
    enableFilterMatchHighlighting: E,
    enableFilters: R,
    enableFullScreenToggle: O,
    enableGlobalFilter: P,
    enableGlobalFilterRankedResults: _,
    enableGrouping: L,
    enableHiding: V,
    enableMultiRowSelection: j,
    enableMultiSort: I,
    enablePagination: F,
    enableRowPinning: $,
    enableRowSelection: A,
    enableRowVirtualization: H,
    enableSelectAll: N,
    enableSorting: z,
    enableStickyHeader: se,
    enableTableFooter: ne,
    enableTableHead: Z,
    enableToolbarInternalActions: q,
    enableTopToolbar: G,
    filterFns: K,
    getCoreRowModel: fse(),
    getExpandedRowModel: w || L ? pse() : void 0,
    getFacetedMinMaxValues: k ? hse() : void 0,
    getFacetedRowModel: k ? bse() : void 0,
    getFacetedUniqueValues: k ? Cse() : void 0,
    getFilteredRowModel: (m || P || R) && !W ? xse() : void 0,
    getGroupedRowModel: L && !D ? yse() : void 0,
    getPaginationRowModel: F && !X ? wse() : void 0,
    getSortedRowModel: z && !de ? Sse() : void 0,
    getSubRows: (Te) => Te == null ? void 0 : Te.subRows,
    icons: Q,
    layoutMode: re,
    localization: U,
    manualFiltering: W,
    manualGrouping: D,
    manualPagination: X,
    manualSorting: de,
    mrtTheme: ue,
    paginationDisplayMode: he,
    positionActionsColumn: Ue,
    positionCreatingRow: me,
    positionExpandColumn: Ie,
    positionGlobalFilter: te,
    positionPagination: ie,
    positionToolbarAlertBanner: ye,
    positionToolbarDropZone: Ne,
    rowNumberDisplayMode: We,
    rowPinningDisplayMode: qe,
    selectAllMode: Me,
    sortingFns: Pe
  }, fe);
}, A6 = {
  children: null,
  sx: {
    minWidth: 0,
    p: 0,
    width: 0
  }
}, wue = (e) => Object.assign(Object.assign(Object.assign(Object.assign({}, Na({
  id: "mrt-row-spacer",
  size: 0,
  tableOptions: e
})), { grow: !0 }), bE), { muiTableBodyCellProps: A6, muiTableFooterCellProps: A6, muiTableHeadCellProps: A6 }), Sue = (e) => {
  const { getIsSomeRowsPinned: t, getPrePaginationRowModel: n, getState: o, options: { enablePagination: r, enableRowPinning: i, rowCount: s } } = e, { columnOrder: a, density: c, globalFilter: d, isFullScreen: u, isLoading: p, pagination: h, showSkeletons: g, sorting: m } = o(), b = e.options.columns.length, C = s ?? n().rows.length, x = w_(() => ({}), {})[1], v = St(), S = St();
  mt(() => {
    typeof window < "u" && (v.current = document.body.style.height);
  }, []), mt(() => {
    if (typeof window < "u")
      if (u)
        S.current = document.body.getBoundingClientRect().top, document.body.style.height = "100dvh";
      else {
        if (document.body.style.height = v.current, !S.current)
          return;
        window.scrollTo({
          behavior: "instant",
          top: -1 * S.current
        });
      }
  }, [u]), mt(() => {
    b !== a.length && e.setColumnOrder(nE(e.options));
  }, [b]), mt(() => {
    if (!r || p || g)
      return;
    const { pageIndex: w, pageSize: k } = h;
    w * k >= C && e.setPageIndex(Math.ceil(C / k) - 1);
  }, [C]);
  const M = St(m);
  mt(() => {
    m.length && (M.current = m);
  }, [m]), mt(() => {
    rE(e) && (d ? e.setSorting([]) : e.setSorting(() => M.current || []));
  }, [d]), mt(() => {
    i && t() && setTimeout(() => {
      x();
    }, 150);
  }, [c]);
}, Mue = (e) => {
  var t, n, o, r, i, s, a, c, d, u, p, h, g, m, b, C, x, v, S, M, w, k, E, R, O, P, _, L, V, j, I, F, $, A, H;
  const N = St(null), z = St(null), se = St(null), ne = St({}), Z = St({}), q = St(null), G = St(null), K = St({}), Q = St(null), re = St(null), U = St(null), W = St(null), D = tn(() => {
    var Wt, Y, ke;
    const He = (Wt = e.initialState) !== null && Wt !== void 0 ? Wt : {};
    return He.columnOrder = (Y = He.columnOrder) !== null && Y !== void 0 ? Y : nE(Object.assign(Object.assign({}, e), { state: Object.assign(Object.assign({}, e.initialState), e.state) })), He.globalFilterFn = (ke = e.globalFilterFn) !== null && ke !== void 0 ? ke : "fuzzy", He;
  }, []);
  e.initialState = D;
  const [X, de] = Ae((t = D.actionCell) !== null && t !== void 0 ? t : null), [ue, he] = Ae((n = D.creatingRow) !== null && n !== void 0 ? n : null), [Ue, me] = Ae(() => Object.assign({}, ...fu(e.columns).map((Wt) => {
    var Y, ke, He, st;
    return {
      [Tl(Wt)]: Wt.filterFn instanceof Function ? (Y = Wt.filterFn.name) !== null && Y !== void 0 ? Y : "custom" : (st = (ke = Wt.filterFn) !== null && ke !== void 0 ? ke : (He = D == null ? void 0 : D.columnFilterFns) === null || He === void 0 ? void 0 : He[Tl(Wt)]) !== null && st !== void 0 ? st : Gde(Wt)
    };
  }))), [Ie, te] = Ae((o = D.columnOrder) !== null && o !== void 0 ? o : []), [ie, ye] = Ae((r = D.columnSizingInfo) !== null && r !== void 0 ? r : {}), [Ne, We] = Ae((i = D == null ? void 0 : D.density) !== null && i !== void 0 ? i : "comfortable"), [qe, Me] = Ae((s = D.draggingColumn) !== null && s !== void 0 ? s : null), [Pe, fe] = Ae((a = D.draggingRow) !== null && a !== void 0 ? a : null), [ae, Te] = Ae((c = D.editingCell) !== null && c !== void 0 ? c : null), [tt, Ye] = Ae((d = D.editingRow) !== null && d !== void 0 ? d : null), [Le, Ve] = Ae((u = D.globalFilterFn) !== null && u !== void 0 ? u : "fuzzy"), [Ce, Se] = Ae((p = D.grouping) !== null && p !== void 0 ? p : []), [ve, Be] = Ae((h = D.hoveredColumn) !== null && h !== void 0 ? h : null), [rt, pt] = Ae((g = D.hoveredRow) !== null && g !== void 0 ? g : null), [Je, At] = Ae((m = D == null ? void 0 : D.isFullScreen) !== null && m !== void 0 ? m : !1), [Ht, Ct] = Ae((b = D == null ? void 0 : D.pagination) !== null && b !== void 0 ? b : { pageIndex: 0, pageSize: 10 }), [qt, Bn] = Ae((C = D == null ? void 0 : D.showAlertBanner) !== null && C !== void 0 ? C : !1), [xn, $o] = Ae((x = D == null ? void 0 : D.showColumnFilters) !== null && x !== void 0 ? x : !1), [zn, bn] = Ae((v = D == null ? void 0 : D.showGlobalFilter) !== null && v !== void 0 ? v : !1), [Zt, vn] = Ae((S = D == null ? void 0 : D.showToolbarDropZone) !== null && S !== void 0 ? S : !1);
  e.state = Object.assign({
    actionCell: X,
    columnFilterFns: Ue,
    columnOrder: Ie,
    columnSizingInfo: ie,
    creatingRow: ue,
    density: Ne,
    draggingColumn: qe,
    draggingRow: Pe,
    editingCell: ae,
    editingRow: tt,
    globalFilterFn: Le,
    grouping: Ce,
    hoveredColumn: ve,
    hoveredRow: rt,
    isFullScreen: Je,
    pagination: Ht,
    showAlertBanner: qt,
    showColumnFilters: xn,
    showGlobalFilter: zn,
    showToolbarDropZone: Zt
  }, e.state);
  const Qe = e, oo = St([]);
  Qe.columns = Qe.state.columnSizingInfo.isResizingColumn || Qe.state.draggingColumn || Qe.state.draggingRow ? oo.current : qk({
    columnDefs: [
      ...[
        Xk(Qe) && mue(Qe),
        Jk(Qe) && uue(Qe),
        Uh(Qe) && cue(Qe),
        Wh(Qe) && pue(Qe),
        Qk(Qe) && bue(Qe),
        eE(Qe) && hue(Qe)
      ].filter(Boolean),
      ...Qe.columns,
      ...[
        tE(Qe) && wue(Qe)
      ].filter(Boolean)
    ],
    tableOptions: Qe
  }), oo.current = Qe.columns, Qe.data = tn(() => (Qe.state.isLoading || Qe.state.showSkeletons) && !Qe.data.length ? [
    ...Array(Math.min(Qe.state.pagination.pageSize, 20)).fill(null)
  ].map(() => Object.assign({}, ...fu(Qe.columns).map((Wt) => ({
    [Tl(Wt)]: null
  })))) : Qe.data, [
    Qe.data,
    Qe.state.isLoading,
    Qe.state.showSkeletons
  ]);
  const Kt = Mse(Object.assign(Object.assign({
    onColumnOrderChange: te,
    onColumnSizingInfoChange: ye,
    onGroupingChange: Se,
    onPaginationChange: Ct
  }, Qe), { globalFilterFn: (M = Qe.filterFns) === null || M === void 0 ? void 0 : M[Le ?? "fuzzy"] }));
  return Kt.refs = {
    actionCellRef: z,
    bottomToolbarRef: se,
    editInputRefs: ne,
    filterInputRefs: Z,
    lastSelectedRowId: N,
    searchInputRef: q,
    tableContainerRef: G,
    tableFooterRef: W,
    tableHeadCellRefs: K,
    tableHeadRef: U,
    tablePaperRef: Q,
    topToolbarRef: re
  }, Kt.setActionCell = (w = Qe.onActionCellChange) !== null && w !== void 0 ? w : de, Kt.setCreatingRow = (Wt) => {
    var Y, ke;
    let He = Wt;
    Wt === !0 && (He = qde(Kt)), (ke = (Y = Qe == null ? void 0 : Qe.onCreatingRowChange) === null || Y === void 0 ? void 0 : Y.call(Qe, He)) !== null && ke !== void 0 || he(He);
  }, Kt.setColumnFilterFns = (k = Qe.onColumnFilterFnsChange) !== null && k !== void 0 ? k : me, Kt.setDensity = (E = Qe.onDensityChange) !== null && E !== void 0 ? E : We, Kt.setDraggingColumn = (R = Qe.onDraggingColumnChange) !== null && R !== void 0 ? R : Me, Kt.setDraggingRow = (O = Qe.onDraggingRowChange) !== null && O !== void 0 ? O : fe, Kt.setEditingCell = (P = Qe.onEditingCellChange) !== null && P !== void 0 ? P : Te, Kt.setEditingRow = (_ = Qe.onEditingRowChange) !== null && _ !== void 0 ? _ : Ye, Kt.setGlobalFilterFn = (L = Qe.onGlobalFilterFnChange) !== null && L !== void 0 ? L : Ve, Kt.setHoveredColumn = (V = Qe.onHoveredColumnChange) !== null && V !== void 0 ? V : Be, Kt.setHoveredRow = (j = Qe.onHoveredRowChange) !== null && j !== void 0 ? j : pt, Kt.setIsFullScreen = (I = Qe.onIsFullScreenChange) !== null && I !== void 0 ? I : At, Kt.setShowAlertBanner = (F = Qe.onShowAlertBannerChange) !== null && F !== void 0 ? F : Bn, Kt.setShowColumnFilters = ($ = Qe.onShowColumnFiltersChange) !== null && $ !== void 0 ? $ : $o, Kt.setShowGlobalFilter = (A = Qe.onShowGlobalFilterChange) !== null && A !== void 0 ? A : bn, Kt.setShowToolbarDropZone = (H = Qe.onShowToolbarDropZoneChange) !== null && H !== void 0 ? H : vn, Sue(Kt), Kt;
}, Tue = (e) => Mue(vue(e)), CE = (e, t) => {
  const n = NT(e);
  return t === void 0 || (t >= 0 && t < Math.max(e.startIndex - e.overscan, 0) && n.unshift(t), t >= 0 && t > e.endIndex + e.overscan && n.push(t)), n;
}, kue = (e) => {
  var t, n, o, r;
  const { getState: i, options: { columnVirtualizerInstanceRef: s, columnVirtualizerOptions: a, enableColumnPinning: c, enableColumnVirtualization: d }, refs: { tableContainerRef: u } } = e, { columnPinning: p, columnVisibility: h, draggingColumn: g } = i();
  if (!d)
    return;
  const m = Fe(a, {
    table: e
  }), b = e.getVisibleLeafColumns(), [C, x] = tn(() => c ? [
    e.getLeftVisibleLeafColumns().map((R) => R.getPinnedIndex()),
    e.getRightVisibleLeafColumns().map((R) => b.length - R.getPinnedIndex() - 1).sort((R, O) => R - O)
  ] : [[], []], [p, h, c]), v = C.length, S = x.length, M = tn(() => g != null && g.id ? b.findIndex((R) => R.id === (g == null ? void 0 : g.id)) : void 0, [g == null ? void 0 : g.id]), w = BT(Object.assign({ count: b.length, estimateSize: (R) => b[R].getSize(), getScrollElement: () => u.current, horizontal: !0, overscan: 3, rangeExtractor: pr((R) => {
    const O = CE(R, M);
    return !v && !S ? O : [
      .../* @__PURE__ */ new Set([
        ...C,
        ...O,
        ...x
      ])
    ];
  }, [C, x, M]) }, m)), k = w.getVirtualItems();
  w.virtualColumns = k;
  const E = k.length;
  if (E) {
    const R = w.getTotalSize(), O = ((t = k[v]) === null || t === void 0 ? void 0 : t.start) || 0, P = ((n = k[C.length - 1]) === null || n === void 0 ? void 0 : n.end) || 0, _ = ((o = k[E - S]) === null || o === void 0 ? void 0 : o.start) || 0, L = ((r = k[E - S - 1]) === null || r === void 0 ? void 0 : r.end) || 0;
    w.virtualPaddingLeft = O - P, w.virtualPaddingRight = R - L - (S ? R - _ : 0);
  }
  return s && (s.current = w), w;
}, Eue = (e, t) => {
  var n;
  const { getRowModel: o, getState: r, options: { enableRowVirtualization: i, renderDetailPanel: s, rowVirtualizerInstanceRef: a, rowVirtualizerOptions: c }, refs: { tableContainerRef: d } } = e, { density: u, draggingRow: p, expanded: h } = r();
  if (!i)
    return;
  const g = Fe(c, {
    table: e
  }), m = (n = t == null ? void 0 : t.length) !== null && n !== void 0 ? n : o().rows.length, b = u === "compact" ? 37 : u === "comfortable" ? 58 : 73, C = BT(Object.assign({ count: s ? m * 2 : m, estimateSize: (x) => s && x % 2 === 1 ? h === !0 ? 100 : 0 : b, getScrollElement: () => d.current, measureElement: typeof window < "u" && navigator.userAgent.indexOf("Firefox") === -1 ? (x) => x == null ? void 0 : x.getBoundingClientRect().height : void 0, overscan: 4, rangeExtractor: pr((x) => {
    var v;
    return CE(x, (v = p == null ? void 0 : p.index) !== null && v !== void 0 ? v : 0);
  }, [p]) }, g));
  return C.virtualRows = C.getVirtualItems(), a && (a.current = C), C;
}, Rue = (e) => {
  const { getRowModel: t, getState: n, options: { data: o, enableGlobalFilterRankedResults: r, positionCreatingRow: i } } = e, { creatingRow: s, expanded: a, globalFilter: c, pagination: d, rowPinning: u, sorting: p } = n();
  return tn(() => oE(e), [
    s,
    o,
    r,
    a,
    t().rows,
    c,
    d.pageIndex,
    d.pageSize,
    i,
    u,
    p
  ]);
}, H6 = ["string", "number"], FC = ({ cell: e, rowRef: t, staticColumnIndex: n, staticRowIndex: o, table: r }) => {
  var i, s, a;
  const { getState: c, options: { enableFilterMatchHighlighting: d, mrtTheme: { matchHighlightColor: u } } } = r, { column: p, row: h } = e, { columnDef: g } = p, { globalFilter: m, globalFilterFn: b } = c(), C = p.getFilterValue();
  let x = e.getIsAggregated() && g.AggregatedCell ? g.AggregatedCell({
    cell: e,
    column: p,
    row: h,
    table: r,
    staticColumnIndex: n,
    staticRowIndex: o
  }) : h.getIsGrouped() && !e.getIsGrouped() ? null : e.getIsGrouped() && g.GroupedCell ? g.GroupedCell({
    cell: e,
    column: p,
    row: h,
    table: r,
    staticColumnIndex: n,
    staticRowIndex: o
  }) : void 0;
  const v = x !== void 0;
  if (v || (x = e.renderValue()), d && g.enableFilterMatchHighlighting !== !1 && String(x) && H6.includes(typeof x) && (C && H6.includes(typeof C) && ["autocomplete", "text"].includes(g.filterVariant) || m && H6.includes(typeof m) && p.getCanGlobalFilter())) {
    const S = L6 == null ? void 0 : L6({
      matchExactly: (C ? g._filterFn : b) !== "fuzzy",
      query: ((i = C ?? m) !== null && i !== void 0 ? i : "").toString(),
      text: x == null ? void 0 : x.toString()
    });
    ((S == null ? void 0 : S.length) > 1 || !((s = S == null ? void 0 : S[0]) === null || s === void 0) && s.match) && (x = f.jsx("span", { "aria-label": x, role: "note", children: (a = S == null ? void 0 : S.map(({ key: M, match: w, text: k }) => f.jsx(J, { "aria-hidden": "true", component: "span", sx: w ? {
      backgroundColor: u,
      borderRadius: "2px",
      color: (E) => E.palette.mode === "dark" ? E.palette.common.white : E.palette.common.black,
      padding: "2px 1px"
    } : void 0, children: k }, M))) !== null && a !== void 0 ? a : x }));
  }
  return g.Cell && !v && (x = g.Cell({
    cell: e,
    column: p,
    renderedCellValue: x,
    row: h,
    rowRef: t,
    staticColumnIndex: n,
    staticRowIndex: o,
    table: r
  })), x;
}, Oue = (e) => {
  var t, { cell: n, table: o } = e, r = Pt(e, ["cell", "table"]);
  const { options: { localization: i, muiCopyButtonProps: s } } = o, { column: a, row: c } = n, { columnDef: d } = a, [u, p] = Ae(!1), h = (m, b) => {
    m.stopPropagation(), navigator.clipboard.writeText(b), p(!0), setTimeout(() => p(!1), 4e3);
  }, g = Object.assign(Object.assign(Object.assign({}, Fe(s, {
    cell: n,
    column: a,
    row: c,
    table: o
  })), Fe(d.muiCopyButtonProps, {
    cell: n,
    column: a,
    row: c,
    table: o
  })), r);
  return f.jsx(ln, Object.assign({}, Fr("top"), { title: (t = g == null ? void 0 : g.title) !== null && t !== void 0 ? t : u ? i.copiedToClipboard : i.clickToCopy, children: f.jsx(at, Object.assign({ onClick: (m) => h(m, n.getValue()), size: "small", type: "button", variant: "text" }, g, { sx: (m) => Object.assign({ backgroundColor: "transparent", border: "none", color: "inherit", cursor: "copy", fontFamily: "inherit", fontSize: "inherit", letterSpacing: "inherit", m: "-0.25rem", minWidth: "unset", py: 0, textAlign: "inherit", textTransform: "inherit" }, Fe(g == null ? void 0 : g.sx, m)), title: void 0 })) }));
}, _ue = (e) => {
  var t, n, { cell: o, table: r } = e, i = Pt(e, ["cell", "table"]);
  const { getState: s, options: { createDisplayMode: a, editDisplayMode: c, muiEditTextFieldProps: d }, refs: { editInputRefs: u }, setCreatingRow: p, setEditingCell: h, setEditingRow: g } = r, { column: m, row: b } = o, { columnDef: C } = m, { creatingRow: x, editingRow: v } = s(), { editSelectOptions: S, editVariant: M } = C, w = (x == null ? void 0 : x.id) === b.id, k = (v == null ? void 0 : v.id) === b.id, [E, R] = Ae(() => o.getValue()), [O, P] = Ae(!0), _ = Object.assign(Object.assign(Object.assign({}, Fe(d, {
    cell: o,
    column: m,
    row: b,
    table: r
  })), Fe(C.muiEditTextFieldProps, {
    cell: o,
    column: m,
    row: b,
    table: r
  })), i), L = Fe(S, {
    cell: o,
    column: m,
    row: b,
    table: r
  }), V = M === "select" || (_ == null ? void 0 : _.select), j = (A) => {
    b._valuesCache[m.id] = A, w ? p(b) : k && g(b);
  }, I = (A) => {
    var H;
    (H = _.onChange) === null || H === void 0 || H.call(_, A), R(A.target.value), V && j(A.target.value);
  }, F = (A) => {
    var H;
    (H = _.onBlur) === null || H === void 0 || H.call(_, A), j(E), h(null);
  }, $ = (A) => {
    var H, N;
    (H = _.onKeyDown) === null || H === void 0 || H.call(_, A), A.key === "Enter" && !A.shiftKey && O && ((N = u.current[m.id]) === null || N === void 0 || N.blur());
  };
  return C.Edit ? f.jsx(f.Fragment, { children: (t = C.Edit) === null || t === void 0 ? void 0 : t.call(C, { cell: o, column: m, row: b, table: r }) }) : f.jsx(Ir, Object.assign({ disabled: Fe(C.enableEditing, b) === !1, fullWidth: !0, inputRef: (A) => {
    A && (u.current[m.id] = A, _.inputRef && (_.inputRef = A));
  }, label: ["custom", "modal"].includes(w ? a : c) ? C.header : void 0, margin: "none", name: m.id, placeholder: ["custom", "modal"].includes(w ? a : c) ? void 0 : C.header, select: V, size: "small", value: E ?? "", variant: "standard" }, _, { InputProps: Object.assign(Object.assign(Object.assign({}, _.variant !== "outlined" ? { disableUnderline: c === "table" } : {}), _.InputProps), { sx: (A) => {
    var H;
    return Object.assign({ mb: 0 }, Fe((H = _ == null ? void 0 : _.InputProps) === null || H === void 0 ? void 0 : H.sx, A));
  } }), SelectProps: Object.assign({ MenuProps: { disableScrollLock: !0 } }, _.SelectProps), inputProps: Object.assign({ autoComplete: "new-password" }, _.inputProps), onBlur: F, onChange: I, onClick: (A) => {
    var H;
    A.stopPropagation(), (H = _ == null ? void 0 : _.onClick) === null || H === void 0 || H.call(_, A);
  }, onKeyDown: $, onCompositionStart: () => P(!1), onCompositionEnd: () => P(!0), children: (n = _.children) !== null && n !== void 0 ? n : L == null ? void 0 : L.map((A) => {
    const { label: H, value: N } = Si(A);
    return f.jsx(Jo, { sx: {
      alignItems: "center",
      display: "flex",
      gap: "0.5rem",
      m: 0
    }, value: N, children: H }, N);
  }) }));
}, xE = (e) => {
  var t, n, o, r, i, { cell: s, numRows: a, rowRef: c, staticColumnIndex: d, staticRowIndex: u, table: p } = e, h = Pt(e, ["cell", "numRows", "rowRef", "staticColumnIndex", "staticRowIndex", "table"]);
  const g = ge(), { getState: m, options: { columnResizeDirection: b, columnResizeMode: C, createDisplayMode: x, editDisplayMode: v, enableCellActions: S, enableClickToCopy: M, enableColumnOrdering: w, enableColumnPinning: k, enableGrouping: E, layoutMode: R, mrtTheme: { draggingBorderColor: O }, muiSkeletonProps: P, muiTableBodyCellProps: _ }, setHoveredColumn: L } = p, { actionCell: V, columnSizingInfo: j, creatingRow: I, density: F, draggingColumn: $, draggingRow: A, editingCell: H, editingRow: N, hoveredColumn: z, hoveredRow: se, isLoading: ne, showSkeletons: Z } = m(), { column: q, row: G } = s, { columnDef: K } = q, { columnDefType: Q } = K, re = { cell: s, column: q, row: G, table: p }, U = Object.assign(Object.assign(Object.assign({}, Fe(_, re)), Fe(K.muiTableBodyCellProps, re)), h), W = Fe(P, {
    cell: s,
    column: q,
    row: G,
    table: p
  }), [D, X] = Ae(100);
  mt(() => {
    if (!ne && !Z || D !== 100)
      return;
    const Me = q.getSize();
    X(Q === "display" ? Me / 2 : Math.round(Math.random() * (Me - Me / 3) + Me / 3));
  }, [ne, Z]);
  const de = tn(() => {
    const Me = ($ == null ? void 0 : $.id) === q.id, Pe = (z == null ? void 0 : z.id) === q.id, fe = (A == null ? void 0 : A.id) === G.id, ae = (se == null ? void 0 : se.id) === G.id, Te = q.getIsFirstColumn(), tt = q.getIsLastColumn(), Ye = a && u === a - 1, Le = j.isResizingColumn === q.id, Ve = Le && C === "onChange", Ce = Ve ? `2px solid ${O} !important` : Me || fe ? `1px dashed ${g.palette.grey[500]} !important` : Pe || ae || Le ? `2px dashed ${O} !important` : void 0;
    return Ve ? b === "ltr" ? { borderRight: Ce } : { borderLeft: Ce } : Ce ? {
      borderBottom: fe || ae || Ye && !Le ? Ce : void 0,
      borderLeft: Me || Pe || (fe || ae) && Te ? Ce : void 0,
      borderRight: Me || Pe || (fe || ae) && tt ? Ce : void 0,
      borderTop: fe || ae ? Ce : void 0
    } : void 0;
  }, [
    j.isResizingColumn,
    $,
    A,
    z,
    se,
    u
  ]), ue = k && K.columnDefType !== "group" && q.getIsPinned(), he = Yk({ cell: s, table: p }), Ue = he && !["custom", "modal"].includes(v) && (v === "table" || (N == null ? void 0 : N.id) === G.id || (H == null ? void 0 : H.id) === s.id) && !G.getIsGrouped(), me = he && x === "row" && (I == null ? void 0 : I.id) === G.id, Ie = (Fe(M, s) === !0 || Fe(K.enableClickToCopy, s) === !0) && !["context-menu", !1].includes(
    // @ts-ignore
    Fe(K.enableClickToCopy, s)
  ), te = Fe(S, s), ie = {
    cell: s,
    table: p,
    staticColumnIndex: d,
    staticRowIndex: u
  }, ye = (Me) => {
    var Pe;
    (Pe = U == null ? void 0 : U.onDoubleClick) === null || Pe === void 0 || Pe.call(U, Me), Kde({ cell: s, table: p });
  }, Ne = (Me) => {
    var Pe;
    (Pe = U == null ? void 0 : U.onDragEnter) === null || Pe === void 0 || Pe.call(U, Me), E && (z == null ? void 0 : z.id) === "drop-zone" && L(null), w && $ && L(K.enableColumnOrdering !== !1 ? q : null);
  }, We = (Me) => {
    K.enableColumnOrdering !== !1 && Me.preventDefault();
  }, qe = (Me) => {
    var Pe;
    (Pe = U == null ? void 0 : U.onContextMenu) === null || Pe === void 0 || Pe.call(U, Me), te && (Me.preventDefault(), p.setActionCell(s), p.refs.actionCellRef.current = Me.currentTarget);
  };
  return f.jsx(I0, Object.assign({ align: g.direction === "rtl" ? "right" : "left", "data-index": d, "data-pinned": !!ue || void 0 }, U, { onContextMenu: qe, onDoubleClick: ye, onDragEnter: Ne, onDragOver: We, sx: (Me) => Object.assign(Object.assign({ "&:hover": {
    outline: (V == null ? void 0 : V.id) === s.id || v === "cell" && he || v === "table" && (me || Ue) ? `1px solid ${Me.palette.grey[500]}` : void 0,
    textOverflow: "clip"
  }, alignItems: R != null && R.startsWith("grid") ? "center" : void 0, cursor: te ? "context-menu" : he && v === "cell" ? "pointer" : "inherit", outline: (V == null ? void 0 : V.id) === s.id ? `1px solid ${Me.palette.grey[500]}` : void 0, outlineOffset: "-1px", overflow: "hidden", p: F === "compact" ? Q === "display" ? "0 0.5rem" : "0.5rem" : F === "comfortable" ? Q === "display" ? "0.5rem 0.75rem" : "1rem" : Q === "display" ? "1rem 1.25rem" : "1.5rem", textOverflow: Q !== "display" ? "ellipsis" : void 0, whiteSpace: G.getIsPinned() || F === "compact" ? "nowrap" : "normal" }, Kh({
    column: q,
    table: p,
    tableCellProps: U,
    theme: Me
  })), de), children: (t = U.children) !== null && t !== void 0 ? t : f.jsxs(f.Fragment, { children: [s.getIsPlaceholder() ? (o = (n = K.PlaceholderCell) === null || n === void 0 ? void 0 : n.call(K, { cell: s, column: q, row: G, table: p })) !== null && o !== void 0 ? o : null : Z !== !1 && (ne || Z) ? f.jsx(xw, Object.assign({ animation: "wave", height: 20, width: D }, W)) : Q === "display" && (["mrt-row-expand", "mrt-row-numbers", "mrt-row-select"].includes(q.id) || !G.getIsGrouped()) ? (r = K.Cell) === null || r === void 0 ? void 0 : r.call(K, {
    cell: s,
    column: q,
    renderedCellValue: s.renderValue(),
    row: G,
    rowRef: c,
    staticColumnIndex: d,
    staticRowIndex: u,
    table: p
  }) : me || Ue ? f.jsx(_ue, { cell: s, table: p }) : Ie && K.enableClickToCopy !== !1 ? f.jsx(Oue, { cell: s, table: p, children: f.jsx(FC, Object.assign({}, ie)) }) : f.jsx(FC, Object.assign({}, ie)), s.getIsGrouped() && !K.GroupedCell && f.jsxs(f.Fragment, { children: [" (", (i = G.subRows) === null || i === void 0 ? void 0 : i.length, ")"] })] }) }));
}, Pue = t4(xE, (e, t) => t.cell === e.cell), Lue = (e) => {
  var { parentRowRef: t, row: n, rowVirtualizer: o, staticRowIndex: r, table: i, virtualRow: s } = e, a = Pt(e, ["parentRowRef", "row", "rowVirtualizer", "staticRowIndex", "table", "virtualRow"]);
  const { getState: c, getVisibleLeafColumns: d, options: { layoutMode: u, mrtTheme: { baseBackgroundColor: p }, muiDetailPanelProps: h, muiTableBodyRowProps: g, renderDetailPanel: m } } = i, { isLoading: b } = c(), C = Fe(g, {
    isDetailPanel: !0,
    row: n,
    staticRowIndex: r,
    table: i
  }), x = Object.assign(Object.assign({}, Fe(h, {
    row: n,
    table: i
  })), a), v = !b && (m == null ? void 0 : m({ row: n, table: i }));
  return f.jsx(j0, Object.assign({ className: "Mui-TableBodyCell-DetailPanel", "data-index": m ? r * 2 + 1 : r, ref: (S) => {
    var M;
    S && ((M = o == null ? void 0 : o.measureElement) === null || M === void 0 || M.call(o, S));
  } }, C, { sx: (S) => {
    var M, w;
    return Object.assign({ display: u != null && u.startsWith("grid") ? "flex" : void 0, position: s ? "absolute" : void 0, top: s ? `${(w = (M = t.current) === null || M === void 0 ? void 0 : M.getBoundingClientRect()) === null || w === void 0 ? void 0 : w.height}px` : void 0, transform: s ? `translateY(${s == null ? void 0 : s.start}px)` : void 0, width: "100%" }, Fe(C == null ? void 0 : C.sx, S));
  }, children: f.jsx(I0, Object.assign({ className: "Mui-TableBodyCell-DetailPanel", colSpan: d().length }, x, { sx: (S) => Object.assign({ backgroundColor: s ? p : void 0, borderBottom: n.getIsExpanded() ? void 0 : "none", display: u != null && u.startsWith("grid") ? "flex" : void 0, py: v && n.getIsExpanded() ? "1rem" : 0, transition: s ? void 0 : "all 150ms ease-in-out", width: "100%" }, Fe(x == null ? void 0 : x.sx, S)), children: s ? n.getIsExpanded() && v : f.jsx(Ts, { in: n.getIsExpanded(), mountOnEnter: !0, unmountOnExit: !0, children: v }) })) }));
}, Od = (e) => {
  var t, n, o, r, { columnVirtualizer: i, numRows: s, pinnedRowIds: a, row: c, rowVirtualizer: d, staticRowIndex: u, table: p, virtualRow: h } = e, g = Pt(e, ["columnVirtualizer", "numRows", "pinnedRowIds", "row", "rowVirtualizer", "staticRowIndex", "table", "virtualRow"]);
  const m = ge(), { getState: b, options: { enableRowOrdering: C, enableRowPinning: x, enableStickyFooter: v, enableStickyHeader: S, layoutMode: M, memoMode: w, mrtTheme: { baseBackgroundColor: k, pinnedRowBackgroundColor: E, selectedRowBackgroundColor: R }, muiTableBodyRowProps: O, renderDetailPanel: P, rowPinningDisplayMode: _ }, refs: { tableFooterRef: L, tableHeadRef: V }, setHoveredRow: j } = p, { density: I, draggingColumn: F, draggingRow: $, editingCell: A, editingRow: H, hoveredRow: N, isFullScreen: z, rowPinning: se } = b(), ne = c.getVisibleCells(), { virtualColumns: Z, virtualPaddingLeft: q, virtualPaddingRight: G } = i ?? {}, K = pu({ row: c, table: p }), Q = x && c.getIsPinned(), re = ($ == null ? void 0 : $.id) === c.id, U = (N == null ? void 0 : N.id) === c.id, W = Object.assign(Object.assign({}, Fe(O, {
    row: c,
    staticRowIndex: u,
    table: p
  })), g), [D, X] = tn(() => !x || !(_ != null && _.includes("sticky")) || !a || !c.getIsPinned() ? [] : [
    [...a].reverse().indexOf(c.id),
    a.indexOf(c.id)
  ], [a, se]), de = (S || z) && ((t = V.current) === null || t === void 0 ? void 0 : t.clientHeight) || 0, ue = v && ((n = L.current) === null || n === void 0 ? void 0 : n.clientHeight) || 0, he = Fe(W == null ? void 0 : W.sx, m), Ue = I === "compact" ? 37 : I === "comfortable" ? 53 : 69, Ie = /* @ts-ignore */ parseInt((r = (o = W == null ? void 0 : W.style) === null || o === void 0 ? void 0 : o.height) !== null && r !== void 0 ? r : he == null ? void 0 : he.height, 10) || void 0 || Ue, te = (qe) => {
    C && $ && j(c);
  }, ie = (qe) => {
    qe.preventDefault();
  }, ye = St(null), Ne = K ? R : Q ? E : void 0, We = (W == null ? void 0 : W.hover) !== !1 ? K ? Ne : m.palette.mode === "dark" ? `${fd(k, 0.3)}` : `${C4(k, 0.3)}` : void 0;
  return f.jsxs(f.Fragment, { children: [f.jsxs(j0, Object.assign({ "data-index": P ? u * 2 : u, "data-pinned": !!Q || void 0, "data-selected": K || void 0, onDragEnter: te, onDragOver: ie, ref: (qe) => {
    qe && (ye.current = qe, d == null || d.measureElement(qe));
  }, selected: K }, W, { style: Object.assign({ transform: h ? `translateY(${h.start}px)` : void 0 }, W == null ? void 0 : W.style), sx: (qe) => Object.assign({ "&:hover td:after": We ? Object.assign({ backgroundColor: $t(We, 0.3) }, x5) : void 0, backgroundColor: `${k} !important`, bottom: !h && D !== void 0 && Q ? `${D * Ie + (v ? ue - 1 : 0)}px` : void 0, boxSizing: "border-box", display: M != null && M.startsWith("grid") ? "flex" : void 0, opacity: Q ? 0.97 : re || U ? 0.5 : 1, position: h ? "absolute" : _ != null && _.includes("sticky") && Q ? "sticky" : "relative", td: Object.assign({}, gE({ table: p, theme: qe })), "td:after": Ne ? Object.assign({ backgroundColor: Ne }, x5) : void 0, top: h ? 0 : X !== void 0 && Q ? `${X * Ie + (S || z ? de - 1 : 0)}px` : void 0, transition: h ? "none" : "all 150ms ease-in-out", width: "100%", zIndex: _ != null && _.includes("sticky") && Q ? 2 : 0 }, he), children: [q ? f.jsx("td", { style: { display: "flex", width: q } }) : null, (Z ?? ne).map((qe, Me) => {
    let Pe = qe;
    i && (Me = qe.index, Pe = ne[Me]);
    const fe = {
      cell: Pe,
      numRows: s,
      rowRef: ye,
      staticColumnIndex: Me,
      staticRowIndex: u,
      table: p
    };
    return Pe ? w === "cells" && Pe.column.columnDef.columnDefType === "data" && !F && !$ && (A == null ? void 0 : A.id) !== Pe.id && (H == null ? void 0 : H.id) !== c.id ? f.jsx(Pue, Object.assign({}, fe), Pe.id) : f.jsx(xE, Object.assign({}, fe), Pe.id) : null;
  }), G ? f.jsx("td", { style: { display: "flex", width: G } }) : null] })), P && !c.getIsGrouped() && f.jsx(Lue, { parentRowRef: ye, row: c, rowVirtualizer: d, staticRowIndex: u, table: p, virtualRow: h })] });
}, F6 = t4(Od, (e, t) => e.row === t.row && e.staticRowIndex === t.staticRowIndex), yE = (e) => {
  var t, n, o, r, i, s, { columnVirtualizer: a, table: c } = e, d = Pt(e, ["columnVirtualizer", "table"]);
  const { getBottomRows: u, getIsSomeRowsPinned: p, getRowModel: h, getState: g, getTopRows: m, options: { enableStickyFooter: b, enableStickyHeader: C, layoutMode: x, localization: v, memoMode: S, muiTableBodyProps: M, renderDetailPanel: w, renderEmptyRowsFallback: k, rowPinningDisplayMode: E }, refs: { tableFooterRef: R, tableHeadRef: O, tablePaperRef: P } } = c, { columnFilters: _, globalFilter: L, isFullScreen: V, rowPinning: j } = g(), I = Object.assign(Object.assign({}, Fe(M, { table: c })), d), F = (C || V) && ((t = O.current) === null || t === void 0 ? void 0 : t.clientHeight) || 0, $ = b && ((n = R.current) === null || n === void 0 ? void 0 : n.clientHeight) || 0, A = tn(() => {
    var ne, Z;
    return !(!((ne = j.bottom) === null || ne === void 0) && ne.length) && !(!((Z = j.top) === null || Z === void 0) && Z.length) ? [] : h().rows.filter((q) => q.getIsPinned()).map((q) => q.id);
  }, [j, h().rows]), H = Rue(c), N = Eue(c, H), { virtualRows: z } = N ?? {}, se = {
    columnVirtualizer: a,
    numRows: H.length,
    table: c
  };
  return f.jsxs(f.Fragment, { children: [!(E != null && E.includes("sticky")) && p("top") && f.jsx(bd, Object.assign({}, I, { sx: (ne) => Object.assign({ display: x != null && x.startsWith("grid") ? "grid" : void 0, position: "sticky", top: F - 1, zIndex: 1 }, Fe(I == null ? void 0 : I.sx, ne)), children: m().map((ne, Z) => {
    const q = Object.assign(Object.assign({}, se), {
      row: ne,
      staticRowIndex: Z
    });
    return S === "rows" ? f.jsx(F6, Object.assign({}, q), ne.id) : f.jsx(Od, Object.assign({}, q), ne.id);
  }) })), f.jsx(bd, Object.assign({}, I, { sx: (ne) => Object.assign({ display: x != null && x.startsWith("grid") ? "grid" : void 0, height: N ? `${N.getTotalSize()}px` : void 0, minHeight: H.length ? void 0 : "100px", position: "relative" }, Fe(I == null ? void 0 : I.sx, ne)), children: (o = I == null ? void 0 : I.children) !== null && o !== void 0 ? o : H.length ? f.jsx(f.Fragment, { children: (z ?? H).map((ne, Z) => {
    let q = ne;
    if (N) {
      if (w) {
        if (ne.index % 2 === 1)
          return null;
        Z = ne.index / 2;
      } else
        Z = ne.index;
      q = H[Z];
    }
    const G = Object.assign(Object.assign({}, se), {
      pinnedRowIds: A,
      row: q,
      rowVirtualizer: N,
      staticRowIndex: Z,
      virtualRow: N ? ne : void 0
    }), K = `${q.id}-${q.index}`;
    return S === "rows" ? f.jsx(F6, Object.assign({}, G), K) : f.jsx(Od, Object.assign({}, G), K);
  }) }) : f.jsx("tr", { style: {
    display: x != null && x.startsWith("grid") ? "grid" : void 0
  }, children: f.jsx("td", { colSpan: c.getVisibleLeafColumns().length, style: {
    display: x != null && x.startsWith("grid") ? "grid" : void 0
  }, children: (r = k == null ? void 0 : k({ table: c })) !== null && r !== void 0 ? r : f.jsx(oe, { sx: {
    color: "text.secondary",
    fontStyle: "italic",
    maxWidth: `min(100vw, ${(s = (i = P.current) === null || i === void 0 ? void 0 : i.clientWidth) !== null && s !== void 0 ? s : 360}px)`,
    py: "2rem",
    textAlign: "center",
    width: "100%"
  }, children: L || _.length ? v.noResultsFound : v.noRecordsToDisplay }) }) }) })), !(E != null && E.includes("sticky")) && p("bottom") && f.jsx(bd, Object.assign({}, I, { sx: (ne) => Object.assign({ bottom: $ - 1, display: x != null && x.startsWith("grid") ? "grid" : void 0, position: "sticky", zIndex: 1 }, Fe(I == null ? void 0 : I.sx, ne)), children: u().map((ne, Z) => {
    const q = Object.assign(Object.assign({}, se), {
      row: ne,
      staticRowIndex: Z
    });
    return S === "rows" ? f.jsx(F6, Object.assign({}, q), ne.id) : f.jsx(Od, Object.assign({}, q), ne.id);
  }) }))] });
}, Iue = t4(yE, (e, t) => e.table.options.data === t.table.options.data), jue = (e) => {
  var t, n, o, { footer: r, staticColumnIndex: i, table: s } = e, a = Pt(e, ["footer", "staticColumnIndex", "table"]);
  const c = ge(), { getState: d, options: { enableColumnPinning: u, muiTableFooterCellProps: p } } = s, { density: h } = d(), { column: g } = r, { columnDef: m } = g, { columnDefType: b } = m, C = u && m.columnDefType !== "group" && g.getIsPinned(), x = { column: g, table: s }, v = Object.assign(Object.assign(Object.assign({}, Fe(p, x)), Fe(m.muiTableFooterCellProps, x)), a);
  return f.jsx(I0, Object.assign({ align: b === "group" ? "center" : c.direction === "rtl" ? "right" : "left", colSpan: r.colSpan, "data-index": i, "data-pinned": !!C || void 0, variant: "footer" }, v, { sx: (S) => Object.assign(Object.assign({ fontWeight: "bold", p: h === "compact" ? "0.5rem" : h === "comfortable" ? "1rem" : "1.5rem", verticalAlign: "top" }, Kh({
    column: g,
    header: r,
    table: s,
    tableCellProps: v,
    theme: S
  })), Fe(v == null ? void 0 : v.sx, S)), children: (t = v.children) !== null && t !== void 0 ? t : r.isPlaceholder ? null : (o = (n = Fe(m.Footer, {
    column: g,
    footer: r,
    table: s
  })) !== null && n !== void 0 ? n : m.footer) !== null && o !== void 0 ? o : null }));
}, Vue = (e) => {
  var t, { columnVirtualizer: n, footerGroup: o, table: r } = e, i = Pt(e, ["columnVirtualizer", "footerGroup", "table"]);
  const { options: { layoutMode: s, mrtTheme: { baseBackgroundColor: a }, muiTableFooterRowProps: c } } = r, { virtualColumns: d, virtualPaddingLeft: u, virtualPaddingRight: p } = n ?? {};
  if (!(!((t = o.headers) === null || t === void 0) && t.some((g) => typeof g.column.columnDef.footer == "string" && !!g.column.columnDef.footer || g.column.columnDef.Footer)))
    return null;
  const h = Object.assign(Object.assign({}, Fe(c, {
    footerGroup: o,
    table: r
  })), i);
  return f.jsxs(j0, Object.assign({}, h, { sx: (g) => Object.assign({ backgroundColor: a, display: s != null && s.startsWith("grid") ? "flex" : void 0, position: "relative", width: "100%" }, Fe(h == null ? void 0 : h.sx, g)), children: [u ? f.jsx("th", { style: { display: "flex", width: u } }) : null, (d ?? o.headers).map((g, m) => {
    let b = g;
    return n && (m = g.index, b = o.headers[m]), b ? f.jsx(jue, { footer: b, staticColumnIndex: m, table: r }, b.id) : null;
  }), p ? f.jsx("th", { style: { display: "flex", width: p } }) : null] }));
}, Due = (e) => {
  var { columnVirtualizer: t, table: n } = e, o = Pt(e, ["columnVirtualizer", "table"]);
  const { getFooterGroups: r, getState: i, options: { enableStickyFooter: s, layoutMode: a, muiTableFooterProps: c }, refs: { tableFooterRef: d } } = n, { isFullScreen: u } = i(), p = Object.assign(Object.assign({}, Fe(c, {
    table: n
  })), o), h = (u || s) && s !== !1;
  return f.jsx(Sw, Object.assign({}, p, { ref: (g) => {
    d.current = g, p != null && p.ref && (p.ref.current = g);
  }, sx: (g) => Object.assign({ bottom: h ? 0 : void 0, display: a != null && a.startsWith("grid") ? "grid" : void 0, opacity: h ? 0.97 : void 0, outline: h ? g.palette.mode === "light" ? `1px solid ${g.palette.grey[300]}` : `1px solid ${g.palette.grey[700]}` : void 0, position: h ? "sticky" : "relative", zIndex: h ? 1 : void 0 }, Fe(p == null ? void 0 : p.sx, g)), children: r().map((g) => f.jsx(Vue, { columnVirtualizer: t, footerGroup: g, table: n }, g.id)) }));
}, Aue = (e) => [
  {
    divider: !1,
    label: e.filterFuzzy,
    option: "fuzzy",
    symbol: "≈"
  },
  {
    divider: !1,
    label: e.filterContains,
    option: "contains",
    symbol: "*"
  },
  {
    divider: !1,
    label: e.filterStartsWith,
    option: "startsWith",
    symbol: "a"
  },
  {
    divider: !0,
    label: e.filterEndsWith,
    option: "endsWith",
    symbol: "z"
  },
  {
    divider: !1,
    label: e.filterEquals,
    option: "equals",
    symbol: "="
  },
  {
    divider: !0,
    label: e.filterNotEquals,
    option: "notEquals",
    symbol: "≠"
  },
  {
    divider: !1,
    label: e.filterBetween,
    option: "between",
    symbol: "⇿"
  },
  {
    divider: !0,
    label: e.filterBetweenInclusive,
    option: "betweenInclusive",
    symbol: "⬌"
  },
  {
    divider: !1,
    label: e.filterGreaterThan,
    option: "greaterThan",
    symbol: ">"
  },
  {
    divider: !1,
    label: e.filterGreaterThanOrEqualTo,
    option: "greaterThanOrEqualTo",
    symbol: "≥"
  },
  {
    divider: !1,
    label: e.filterLessThan,
    option: "lessThan",
    symbol: "<"
  },
  {
    divider: !0,
    label: e.filterLessThanOrEqualTo,
    option: "lessThanOrEqualTo",
    symbol: "≤"
  },
  {
    divider: !1,
    label: e.filterEmpty,
    option: "empty",
    symbol: "∅"
  },
  {
    divider: !1,
    label: e.filterNotEmpty,
    option: "notEmpty",
    symbol: "!∅"
  }
], U1 = ["between", "betweenInclusive", "inNumberRange"], N6 = ["empty", "notEmpty"], Hue = ["arrIncludesSome", "arrIncludesAll", "arrIncludes"], Fue = ["range-slider", "date-range", "datetime-range", "range"], vE = (e) => {
  var t, n, o, r, { anchorEl: i, header: s, onSelect: a, setAnchorEl: c, setFilterValue: d, table: u } = e, p = Pt(e, ["anchorEl", "header", "onSelect", "setAnchorEl", "setFilterValue", "table"]);
  const { getState: h, options: { columnFilterModeOptions: g, globalFilterModeOptions: m, localization: b, mrtTheme: { menuBackgroundColor: C }, renderColumnFilterModeMenuItems: x, renderGlobalFilterModeMenuItems: v }, setColumnFilterFns: S, setGlobalFilterFn: M } = u, { density: w, globalFilterFn: k } = h(), { column: E } = s ?? {}, { columnDef: R } = E ?? {}, O = E == null ? void 0 : E.getFilterValue();
  let P = (t = R == null ? void 0 : R.columnFilterModeOptions) !== null && t !== void 0 ? t : g;
  Fue.includes(R == null ? void 0 : R.filterVariant) && (P = [
    ...U1,
    ...P ?? []
  ].filter((j) => U1.includes(j)));
  const _ = tn(() => Aue(b).filter((j) => R ? P === void 0 || (P == null ? void 0 : P.includes(j.option)) : (!m || m.includes(j.option)) && ["contains", "fuzzy", "startsWith"].includes(j.option)), []), L = (j) => {
    var I, F;
    const $ = (I = R == null ? void 0 : R._filterFn) !== null && I !== void 0 ? I : "";
    !s || !E ? M(j) : j !== $ && (S((A) => Object.assign(Object.assign({}, A), { [s.id]: j })), N6.includes(j) ? O !== " " && !N6.includes($) ? E.setFilterValue(" ") : O && E.setFilterValue(O) : (R == null ? void 0 : R.filterVariant) === "multi-select" || Hue.includes(j) ? O instanceof String || O != null && O.length ? (E.setFilterValue([]), d == null || d([])) : O && E.setFilterValue(O) : !((F = R == null ? void 0 : R.filterVariant) === null || F === void 0) && F.includes("range") || U1.includes(j) ? !Array.isArray(O) || !(O != null && O.every((A) => A === "")) && !U1.includes($) ? (E.setFilterValue(["", ""]), d == null || d("")) : E.setFilterValue(O) : Array.isArray(O) ? (E.setFilterValue(""), d == null || d("")) : O === " " && N6.includes($) ? E.setFilterValue(void 0) : E.setFilterValue(O)), c(null), a == null || a();
  }, V = s && R ? R._filterFn : k;
  return f.jsx(p2, Object.assign({ MenuListProps: {
    dense: w === "compact",
    sx: {
      backgroundColor: C
    }
  }, anchorEl: i, anchorOrigin: { horizontal: "right", vertical: "center" }, disableScrollLock: !0, onClose: () => c(null), open: !!i }, p, { children: (r = s && E && R ? (o = (n = R.renderColumnFilterModeMenuItems) === null || n === void 0 ? void 0 : n.call(R, {
    column: E,
    internalFilterOptions: _,
    onSelectFilterMode: L,
    table: u
  })) !== null && o !== void 0 ? o : x == null ? void 0 : x({
    column: E,
    internalFilterOptions: _,
    onSelectFilterMode: L,
    table: u
  }) : v == null ? void 0 : v({
    internalFilterOptions: _,
    onSelectFilterMode: L,
    table: u
  })) !== null && r !== void 0 ? r : _.map(({ divider: j, label: I, option: F, symbol: $ }, A) => f.jsx(Ro, { divider: j, icon: $, label: I, onClick: () => L(F), selected: F === V, table: u, value: F }, A)) }));
}, Nue = (e) => {
  var t, n, o, r, i, s, a, c, d, u, { anchorEl: p, header: h, setAnchorEl: g, table: m } = e, b = Pt(e, ["anchorEl", "header", "setAnchorEl", "table"]);
  const { getAllLeafColumns: C, getState: x, options: { columnFilterDisplayMode: v, columnFilterModeOptions: S, enableColumnFilterModes: M, enableColumnFilters: w, enableColumnPinning: k, enableColumnResizing: E, enableGrouping: R, enableHiding: O, enableSorting: P, enableSortingRemoval: _, icons: { ClearAllIcon: L, DynamicFeedIcon: V, FilterListIcon: j, FilterListOffIcon: I, PushPinIcon: F, RestartAltIcon: $, SortIcon: A, ViewColumnIcon: H, VisibilityOffIcon: N }, localization: z, mrtTheme: { menuBackgroundColor: se }, renderColumnActionsMenuItems: ne }, refs: { filterInputRefs: Z }, setColumnFilterFns: q, setColumnOrder: G, setColumnSizingInfo: K, setShowColumnFilters: Q } = m, { column: re } = h, { columnDef: U } = re, { columnSizing: W, columnVisibility: D, density: X, showColumnFilters: de } = x(), ue = re.getFilterValue(), [he, Ue] = Ae(null), me = () => {
    re.clearSorting(), g(null);
  }, Ie = () => {
    re.toggleSorting(!1), g(null);
  }, te = () => {
    re.toggleSorting(!0), g(null);
  }, ie = () => {
    K((Le) => Object.assign(Object.assign({}, Le), { isResizingColumn: !1 })), re.resetSize(), g(null);
  }, ye = () => {
    re.toggleVisibility(!1), g(null);
  }, Ne = (Le) => {
    re.pin(Le), g(null);
  }, We = () => {
    re.toggleGrouping(), G((Le) => ["mrt-row-expand", ...Le]), g(null);
  }, qe = () => {
    re.setFilterValue(void 0), g(null), ["empty", "notEmpty"].includes(U._filterFn) && q((Le) => {
      var Ve;
      return Object.assign(Object.assign({}, Le), { [h.id]: (Ve = Te == null ? void 0 : Te[0]) !== null && Ve !== void 0 ? Ve : "fuzzy" });
    });
  }, Me = () => {
    Q(!0), queueMicrotask(() => {
      var Le;
      return (Le = Z.current[`${re.id}-0`]) === null || Le === void 0 ? void 0 : Le.focus();
    }), g(null);
  }, Pe = () => {
    C().filter((Le) => Le.columnDef.enableHiding !== !1).forEach((Le) => Le.toggleVisibility(!0)), g(null);
  }, fe = (Le) => {
    Le.stopPropagation(), Ue(Le.currentTarget);
  }, ae = !!U.filterSelectOptions, Te = (t = U == null ? void 0 : U.columnFilterModeOptions) !== null && t !== void 0 ? t : S, tt = M && U.enableColumnFilterModes !== !1 && !ae && (Te === void 0 || !!(Te != null && Te.length)), Ye = [
    ...P && re.getCanSort() ? [
      _ !== !1 && f.jsx(Ro, { icon: f.jsx(L, {}), label: z.clearSort, onClick: me, table: m }, 0),
      f.jsx(Ro, { disabled: re.getIsSorted() === "asc", icon: f.jsx(A, { style: { transform: "rotate(180deg) scaleX(-1)" } }), label: (n = z.sortByColumnAsc) === null || n === void 0 ? void 0 : n.replace("{column}", String(U.header)), onClick: Ie, table: m }, 1),
      f.jsx(Ro, { disabled: re.getIsSorted() === "desc", divider: w || R || O, icon: f.jsx(A, {}), label: (o = z.sortByColumnDesc) === null || o === void 0 ? void 0 : o.replace("{column}", String(U.header)), onClick: te, table: m }, 2)
    ] : [],
    ...w && re.getCanFilter() ? [
      f.jsx(Ro, { disabled: !ue || Array.isArray(ue) && !ue.filter((Le) => Le).length, icon: f.jsx(I, {}), label: z.clearFilter, onClick: qe, table: m }, 3),
      v === "subheader" && f.jsx(Ro, { disabled: de && !M, divider: R || O, icon: f.jsx(j, {}), label: (r = z.filterByColumn) === null || r === void 0 ? void 0 : r.replace("{column}", String(U.header)), onClick: de ? fe : Me, onOpenSubMenu: tt ? fe : void 0, table: m }, 4),
      tt && f.jsx(vE, { anchorEl: he, header: h, onSelect: Me, setAnchorEl: Ue, table: m }, 5)
    ].filter(Boolean) : [],
    ...R && re.getCanGroup() ? [
      f.jsx(Ro, { divider: k, icon: f.jsx(V, {}), label: (i = z[re.getIsGrouped() ? "ungroupByColumn" : "groupByColumn"]) === null || i === void 0 ? void 0 : i.replace("{column}", String(U.header)), onClick: We, table: m }, 6)
    ] : [],
    ...k && re.getCanPin() ? [
      f.jsx(Ro, { disabled: re.getIsPinned() === "left" || !re.getCanPin(), icon: f.jsx(F, { style: { transform: "rotate(90deg)" } }), label: z.pinToLeft, onClick: () => Ne("left"), table: m }, 7),
      f.jsx(Ro, { disabled: re.getIsPinned() === "right" || !re.getCanPin(), icon: f.jsx(F, { style: { transform: "rotate(-90deg)" } }), label: z.pinToRight, onClick: () => Ne("right"), table: m }, 8),
      f.jsx(Ro, { disabled: !re.getIsPinned(), divider: O, icon: f.jsx(F, {}), label: z.unpin, onClick: () => Ne(!1), table: m }, 9)
    ] : [],
    ...E && re.getCanResize() ? [
      f.jsx(Ro, { disabled: !W[re.id], icon: f.jsx($, {}), label: z.resetColumnSize, onClick: ie, table: m }, 10)
    ] : [],
    ...O ? [
      f.jsx(Ro, { disabled: !re.getCanHide(), icon: f.jsx(N, {}), label: (s = z.hideColumn) === null || s === void 0 ? void 0 : s.replace("{column}", String(U.header)), onClick: ye, table: m }, 11),
      f.jsx(Ro, { disabled: !Object.values(D).filter((Le) => !Le).length, icon: f.jsx(H, {}), label: (a = z.showAllColumns) === null || a === void 0 ? void 0 : a.replace("{column}", String(U.header)), onClick: Pe, table: m }, 12)
    ] : []
  ].filter(Boolean);
  return f.jsx(p2, Object.assign({ MenuListProps: {
    dense: X === "compact",
    sx: {
      backgroundColor: se
    }
  }, anchorEl: p, disableScrollLock: !0, onClose: () => g(null), open: !!p }, b, { children: (u = (d = (c = U.renderColumnActionsMenuItems) === null || c === void 0 ? void 0 : c.call(U, {
    closeMenu: () => g(null),
    column: re,
    internalColumnMenuItems: Ye,
    table: m
  })) !== null && d !== void 0 ? d : ne == null ? void 0 : ne({
    closeMenu: () => g(null),
    column: re,
    internalColumnMenuItems: Ye,
    table: m
  })) !== null && u !== void 0 ? u : Ye }));
}, $ue = (e) => {
  var t, n, { header: o, table: r } = e, i = Pt(e, ["header", "table"]);
  const { options: { icons: { MoreVertIcon: s }, localization: a, muiColumnActionsButtonProps: c } } = r, { column: d } = o, { columnDef: u } = d, [p, h] = Ae(null), g = (b) => {
    b.stopPropagation(), b.preventDefault(), h(b.currentTarget);
  }, m = Object.assign(Object.assign(Object.assign({}, Fe(c, {
    column: d,
    table: r
  })), Fe(u.muiColumnActionsButtonProps, {
    column: d,
    table: r
  })), i);
  return f.jsxs(f.Fragment, { children: [f.jsx(ln, Object.assign({}, Fr("top"), { title: (t = m == null ? void 0 : m.title) !== null && t !== void 0 ? t : a.columnActions, children: f.jsx(Bt, Object.assign({ "aria-label": a.columnActions, onClick: g, size: "small" }, m, { sx: (b) => Object.assign({ "&:hover": {
    opacity: 1
  }, height: "2rem", m: "-8px -4px", opacity: 0.3, transition: "all 150ms", width: "2rem" }, Fe(m == null ? void 0 : m.sx, b)), title: void 0, children: (n = m == null ? void 0 : m.children) !== null && n !== void 0 ? n : f.jsx(s, { style: { transform: "scale(0.9)" } }) })) })), p && f.jsx(Nue, { anchorEl: p, header: o, setAnchorEl: h, table: r })] });
}, Bue = (e) => {
  var t, n, o, { column: r, table: i } = e, s = Pt(e, ["column", "table"]);
  const { getState: a, options: { localization: c, muiFilterCheckboxProps: d } } = i, { density: u } = a(), { columnDef: p } = r, h = Object.assign(Object.assign(Object.assign({}, Fe(d, {
    column: r,
    table: i
  })), Fe(p.muiFilterCheckboxProps, {
    column: r,
    table: i
  })), s), g = (t = c.filterByColumn) === null || t === void 0 ? void 0 : t.replace("{column}", p.header);
  return f.jsx(ln, Object.assign({}, Fr(), { title: (n = h == null ? void 0 : h.title) !== null && n !== void 0 ? n : g, children: f.jsx(u2, { control: f.jsx(si, Object.assign({ checked: r.getFilterValue() === "true", color: r.getFilterValue() === void 0 ? "default" : "primary", indeterminate: r.getFilterValue() === void 0, size: u === "compact" ? "small" : "medium" }, h, { onChange: (m, b) => {
    var C;
    r.setFilterValue(r.getFilterValue() === void 0 ? "true" : r.getFilterValue() === "true" ? "false" : void 0), (C = h == null ? void 0 : h.onChange) === null || C === void 0 || C.call(h, m, b);
  }, onClick: (m) => {
    var b;
    m.stopPropagation(), (b = h == null ? void 0 : h.onClick) === null || b === void 0 || b.call(h, m);
  }, sx: (m) => Object.assign({ height: "2.5rem", width: "2.5rem" }, Fe(h == null ? void 0 : h.sx, m)) })), disableTypography: !0, label: (o = h.title) !== null && o !== void 0 ? o : g, sx: { color: "text.secondary", fontWeight: "normal", mt: "-4px" }, title: void 0 }) }));
}, wE = (e) => {
  var t, n, o, r, i, s, a, c, d, u, p, h, g, m, b, C, { header: x, rangeFilterIndex: v, table: S } = e, M = Pt(e, ["header", "rangeFilterIndex", "table"]);
  const { options: { enableColumnFilterModes: w, icons: { CloseIcon: k, FilterListIcon: E }, localization: R, manualFiltering: O, muiFilterAutocompleteProps: P, muiFilterDatePickerProps: _, muiFilterDateTimePickerProps: L, muiFilterTextFieldProps: V, muiFilterTimePickerProps: j }, refs: { filterInputRefs: I }, setColumnFilterFns: F } = S, { column: $ } = x, { columnDef: A } = $, { filterVariant: H } = A, N = { column: $, rangeFilterIndex: v, table: S }, z = Object.assign(Object.assign(Object.assign({}, Fe(V, N)), Fe(A.muiFilterTextFieldProps, N)), M), se = Object.assign(Object.assign({}, Fe(P, N)), Fe(A.muiFilterAutocompleteProps, N)), ne = Object.assign(Object.assign({}, Fe(_, N)), Fe(A.muiFilterDatePickerProps, N)), Z = Object.assign(Object.assign({}, Fe(L, N)), Fe(A.muiFilterDateTimePickerProps, N)), q = Object.assign(Object.assign({}, Fe(j, N)), Fe(A.muiFilterTimePickerProps, N)), { allowedColumnFilterOptions: G, currentFilterOption: K, facetedUniqueValues: Q, isAutocompleteFilter: re, isDateFilter: U, isMultiSelectFilter: W, isRangeFilter: D, isSelectFilter: X, isTextboxFilter: de } = nf({ header: x, table: S }), ue = Kk({ header: x, table: S }), he = ["empty", "notEmpty"].includes(K) ? (
    //@ts-ignore
    R[`filter${((n = (t = K == null ? void 0 : K.charAt) === null || t === void 0 ? void 0 : t.call(K, 0)) === null || n === void 0 ? void 0 : n.toUpperCase()) + (K == null ? void 0 : K.slice(1))}`]
  ) : "", Ue = D ? v === 0 ? R.min : v === 1 ? R.max : "" : (o = z == null ? void 0 : z.placeholder) !== null && o !== void 0 ? o : (r = R.filterByColumn) === null || r === void 0 ? void 0 : r.replace("{column}", String(A.header)), me = !!(w && A.enableColumnFilterModes !== !1 && !v && (G === void 0 || G != null && G.length)), [Ie, te] = Ae(null), [ie, ye] = Ae(() => {
    var ve, Be;
    return W ? $.getFilterValue() || [] : D ? ((ve = $.getFilterValue()) === null || ve === void 0 ? void 0 : ve[v]) || "" : (Be = $.getFilterValue()) !== null && Be !== void 0 ? Be : "";
  }), [Ne, We] = Ae(re ? ie : null), qe = pr(n2((ve) => {
    D ? $.setFilterValue((Be) => {
      const rt = Be ?? ["", ""];
      return rt[v] = ve ?? void 0, rt;
    }) : $.setFilterValue(ve ?? void 0);
  }, de ? O ? 400 : 200 : 1), []), Me = (ve) => {
    ye(ve ?? ""), qe(ve);
  }, Pe = (ve) => {
    var Be;
    const rt = z.type === "date" ? ve.target.valueAsDate : z.type === "number" ? ve.target.valueAsNumber : ve.target.value;
    Me(rt), (Be = z == null ? void 0 : z.onChange) === null || Be === void 0 || Be.call(z, ve);
  }, fe = (ve) => {
    We(ve), Me(Si(ve).value);
  }, ae = () => {
    W ? (ye([]), $.setFilterValue([])) : D ? (ye(""), $.setFilterValue((ve) => {
      const Be = Array.isArray(ve) && ve || ["", ""];
      return Be[v] = void 0, Be;
    })) : (ye(""), $.setFilterValue(void 0));
  }, Te = () => {
    ye(""), $.setFilterValue(void 0), F((ve) => {
      var Be;
      return Object.assign(Object.assign({}, ve), { [x.id]: (Be = G == null ? void 0 : G[0]) !== null && Be !== void 0 ? Be : "fuzzy" });
    });
  }, tt = (ve) => {
    te(ve.currentTarget);
  }, Ye = St(!1);
  if (mt(() => {
    if (Ye.current) {
      const ve = $.getFilterValue();
      ve === void 0 ? ae() : ye(D && v !== void 0 ? ve[v] : ve);
    }
    Ye.current = !0;
  }, [$.getFilterValue()]), A.Filter)
    return f.jsx(f.Fragment, { children: (i = A.Filter) === null || i === void 0 ? void 0 : i.call(A, { column: $, header: x, rangeFilterIndex: v, table: S }) });
  const Le = !re && !U && !he ? f.jsx(Fc, { position: "end", sx: { mr: X || W ? "20px" : void 0 }, children: f.jsx(ln, { placement: "right", title: (s = R.clearFilter) !== null && s !== void 0 ? s : "", children: f.jsx("span", { children: f.jsx(Bt, { "aria-label": R.clearFilter, disabled: !(!((a = ie == null ? void 0 : ie.toString()) === null || a === void 0) && a.length), onClick: ae, size: "small", sx: {
    height: "2rem",
    transform: "scale(0.9)",
    width: "2rem"
  }, children: f.jsx(k, {}) }) }) }) }) : null, Ve = me ? f.jsxs(Fc, { position: "start", children: [f.jsx(ln, { title: R.changeFilterMode, children: f.jsx("span", { children: f.jsx(Bt, { "aria-label": R.changeFilterMode, onClick: tt, size: "small", sx: { height: "1.75rem", width: "1.75rem" }, children: f.jsx(E, {}) }) }) }), he && f.jsx(hs, { label: he, onDelete: Te })] }) : null, Ce = Object.assign(Object.assign({ FormHelperTextProps: {
    sx: {
      fontSize: "0.75rem",
      lineHeight: "0.8rem",
      whiteSpace: "nowrap"
    }
  }, InputProps: Le ? { endAdornment: Le, startAdornment: Ve } : { startAdornment: Ve }, fullWidth: !0, helperText: me ? f.jsx("label", { children: R.filterMode.replace(
    "{filterType}",
    // @ts-ignore
    R[`filter${((c = K == null ? void 0 : K.charAt(0)) === null || c === void 0 ? void 0 : c.toUpperCase()) + (K == null ? void 0 : K.slice(1))}`]
  ) }) : null, inputProps: {
    "aria-label": Ue,
    autoComplete: "new-password",
    // disable autocomplete and autofill
    disabled: !!he,
    sx: {
      textOverflow: "ellipsis",
      width: he ? 0 : void 0
    },
    title: Ue
  }, inputRef: (ve) => {
    I.current[`${$.id}-${v ?? 0}`] = ve, z.inputRef && (z.inputRef = ve);
  }, margin: "none", placeholder: he || X || W ? void 0 : Ue, variant: "standard" }, z), { sx: (ve) => Object.assign({ minWidth: U ? "160px" : w && v === 0 ? "110px" : D ? "100px" : he ? "auto" : "120px", mx: "-2px", p: 0, width: "calc(100% + 4px)" }, Fe(z == null ? void 0 : z.sx, ve)) }), Se = {
    onChange: (ve) => {
      Me(ve);
    },
    value: ie || null
  };
  return f.jsxs(f.Fragment, { children: [H != null && H.startsWith("time") ? f.jsx(Gk, Object.assign({}, Se, q, { slotProps: {
    field: Object.assign({ clearable: !0, onClear: () => ae() }, (d = q == null ? void 0 : q.slotProps) === null || d === void 0 ? void 0 : d.field),
    textField: Object.assign(Object.assign({}, Ce), (u = q == null ? void 0 : q.slotProps) === null || u === void 0 ? void 0 : u.textField)
  } })) : H != null && H.startsWith("datetime") ? f.jsx(Nk, Object.assign({}, Se, Z, { slotProps: {
    field: Object.assign({ clearable: !0, onClear: () => ae() }, (p = Z == null ? void 0 : Z.slotProps) === null || p === void 0 ? void 0 : p.field),
    textField: Object.assign(Object.assign({}, Ce), (h = Z == null ? void 0 : Z.slotProps) === null || h === void 0 ? void 0 : h.textField)
  } })) : H != null && H.startsWith("date") ? f.jsx(Sk, Object.assign({}, Se, ne, { slotProps: {
    field: Object.assign({ clearable: !0, onClear: () => ae() }, (g = ne == null ? void 0 : ne.slotProps) === null || g === void 0 ? void 0 : g.field),
    textField: Object.assign(Object.assign({}, Ce), (m = ne == null ? void 0 : ne.slotProps) === null || m === void 0 ? void 0 : m.textField)
  } })) : re ? f.jsx(ew, Object.assign({ freeSolo: !0, getOptionLabel: (ve) => Si(ve).label, onChange: (ve, Be) => fe(Be), options: (b = ue == null ? void 0 : ue.map((ve) => Si(ve))) !== null && b !== void 0 ? b : [] }, se, { renderInput: (ve) => {
    var Be;
    return f.jsx(Ir, Object.assign({}, ve, Ce, { InputProps: Object.assign(Object.assign({}, ve.InputProps), { startAdornment: (Be = Ce == null ? void 0 : Ce.InputProps) === null || Be === void 0 ? void 0 : Be.startAdornment }), inputProps: Object.assign(Object.assign({}, ve.inputProps), Ce == null ? void 0 : Ce.inputProps), onChange: Pe, onClick: (rt) => rt.stopPropagation() }));
  }, value: Ne })) : f.jsx(Ir, Object.assign({ select: X || W }, Ce, { SelectProps: Object.assign({ MenuProps: { disableScrollLock: !0 }, displayEmpty: !0, multiple: W, renderValue: W ? (ve) => ve != null && ve.length ? f.jsx(J, { sx: { display: "flex", flexWrap: "wrap", gap: "2px" }, children: ve == null ? void 0 : ve.map((Be) => {
    const rt = ue == null ? void 0 : ue.find((pt) => Si(pt).value === Be);
    return f.jsx(hs, { label: Si(rt).label }, Be);
  }) }) : f.jsx(J, { sx: { opacity: 0.5 }, children: Ue }) : void 0 }, Ce.SelectProps), onChange: Pe, onClick: (ve) => ve.stopPropagation(), value: ie ?? "", children: (X || W) && [
    f.jsx(Jo, { disabled: !0, divider: !0, hidden: !0, value: "", children: f.jsx(J, { sx: { opacity: 0.5 }, children: Ue }) }, "p"),
    (C = z.children) !== null && C !== void 0 ? C : ue == null ? void 0 : ue.map((ve, Be) => {
      var rt;
      const { label: pt, value: Je } = Si(ve);
      return f.jsxs(Jo, { sx: {
        alignItems: "center",
        display: "flex",
        gap: "0.5rem",
        m: 0
      }, value: Je, children: [W && f.jsx(si, { checked: ((rt = $.getFilterValue()) !== null && rt !== void 0 ? rt : []).includes(Je), sx: { mr: "0.5rem" } }), pt, " ", !A.filterSelectOptions && `(${Q.get(Je)})`] }, `${Be}-${Je}`);
    })
  ] })), f.jsx(vE, { anchorEl: Ie, header: x, setAnchorEl: te, setFilterValue: ye, table: S })] });
}, zue = (e) => {
  var { header: t, table: n } = e, o = Pt(e, ["header", "table"]);
  return f.jsx(J, Object.assign({}, o, { sx: (r) => Object.assign({ display: "grid", gap: "1rem", gridTemplateColumns: "1fr 1fr" }, Fe(o == null ? void 0 : o.sx, r)), children: [0, 1].map((r) => f.jsx(wE, { header: t, rangeFilterIndex: r, table: n }, r)) }));
}, Zue = (e) => {
  var t, n, { header: o, table: r } = e, i = Pt(e, ["header", "table"]);
  const { options: { enableColumnFilterModes: s, localization: a, muiFilterSliderProps: c }, refs: { filterInputRefs: d } } = r, { column: u } = o, { columnDef: p } = u, h = p._filterFn, g = s && p.enableColumnFilterModes !== !1, m = Object.assign(Object.assign(Object.assign({}, Fe(c, { column: u, table: r })), Fe(p.muiFilterSliderProps, { column: u, table: r })), i);
  let [b, C] = m.min !== void 0 && m.max !== void 0 ? [m.min, m.max] : (t = u.getFacetedMinMaxValues()) !== null && t !== void 0 ? t : [0, 1];
  Array.isArray(b) && (b = b[0]), Array.isArray(C) && (C = C[0]), b === null && (b = 0), C === null && (C = 1);
  const [x, v] = Ae([b, C]), S = u.getFilterValue(), M = St(!1);
  return mt(() => {
    M.current && (S === void 0 ? v([b, C]) : Array.isArray(S) && v(S)), M.current = !0;
  }, [S, b, C]), f.jsxs(be, { children: [f.jsx(c7, Object.assign({ disableSwap: !0, max: C, min: b, onChange: (w, k) => {
    v(k);
  }, onChangeCommitted: (w, k) => {
    Array.isArray(k) && (k[0] <= b && k[1] >= C ? u.setFilterValue(void 0) : u.setFilterValue(k));
  }, value: x, valueLabelDisplay: "auto" }, m, { slotProps: {
    input: {
      ref: (w) => {
        var k, E;
        w && (d.current[`${u.id}-0`] = w, !((E = (k = m == null ? void 0 : m.slotProps) === null || k === void 0 ? void 0 : k.input) === null || E === void 0) && E.ref && (m.slotProps.input.ref = w));
      }
    }
  }, sx: (w) => Object.assign({ m: "auto", minWidth: `${u.getSize() - 50}px`, mt: g ? "6px" : "10px", px: "4px", width: "calc(100% - 8px)" }, Fe(m == null ? void 0 : m.sx, w)) })), g ? f.jsx(J4, { sx: {
    fontSize: "0.75rem",
    lineHeight: "0.8rem",
    m: "-3px -6px",
    whiteSpace: "nowrap"
  }, children: a.filterMode.replace(
    "{filterType}",
    // @ts-ignore
    a[`filter${((n = h == null ? void 0 : h.charAt(0)) === null || n === void 0 ? void 0 : n.toUpperCase()) + (h == null ? void 0 : h.slice(1))}`]
  ) }) : null] });
}, SE = (e) => {
  var { header: t, table: n } = e, o = Pt(e, ["header", "table"]);
  const { getState: r, options: { columnFilterDisplayMode: i } } = n, { showColumnFilters: s } = r(), { column: a } = t, { columnDef: c } = a, { isRangeFilter: d } = nf({ header: t, table: n });
  return f.jsx(Ts, Object.assign({ in: s || i === "popover", mountOnEnter: !0, unmountOnExit: !0 }, o, { children: c.filterVariant === "checkbox" ? f.jsx(Bue, { column: a, table: n }) : c.filterVariant === "range-slider" ? f.jsx(Zue, { header: t, table: n }) : d ? f.jsx(zue, { header: t, table: n }) : f.jsx(wE, { header: t, table: n }) }));
}, Wue = (e) => {
  var t, n, { header: o, table: r } = e, i = Pt(e, ["header", "table"]);
  const { options: { columnFilterDisplayMode: s, icons: { FilterAltIcon: a }, localization: c }, refs: { filterInputRefs: d }, setShowColumnFilters: u } = r, { column: p } = o, { columnDef: h } = p, g = p.getFilterValue(), [m, b] = Ae(null), { currentFilterOption: C, isMultiSelectFilter: x, isRangeFilter: v, isSelectFilter: S } = nf({ header: o, table: r }), M = Kk({ header: o, table: r }), w = (R) => Si(M == null ? void 0 : M.find((O) => Si(O).value === (R !== void 0 ? g[R] : g))).label, k = Array.isArray(g) && g.some(Boolean) || !!g && !Array.isArray(g), E = s === "popover" && !k ? (t = c.filterByColumn) === null || t === void 0 ? void 0 : t.replace("{column}", String(h.header)) : c.filteringByColumn.replace("{column}", String(h.header)).replace("{filterType}", C ? (
    // @ts-ignore
    c[`filter${((n = C == null ? void 0 : C.charAt(0)) === null || n === void 0 ? void 0 : n.toUpperCase()) + (C == null ? void 0 : C.slice(1))}`]
  ) : "").replace("{filterValue}", `"${Array.isArray(g) ? g.map((R, O) => x ? w(O) : R).join(`" ${v ? c.and : c.or} "`) : S ? w() : g}"`).replace('" "', "");
  return f.jsxs(f.Fragment, { children: [f.jsx(gs, { in: s === "popover" || !!g && !v || v && // @ts-ignore
  (!!(g != null && g[0]) || !!(g != null && g[1])), unmountOnExit: !0, children: f.jsx(J, { component: "span", sx: { flex: "0 0" }, children: f.jsx(ln, { placement: "top", title: E, children: f.jsx(Bt, Object.assign({ disableRipple: !0, onClick: (R) => {
    s === "popover" ? b(R.currentTarget) : u(!0), queueMicrotask(() => {
      var O, P, _, L;
      (P = (O = d.current[`${p.id}-0`]) === null || O === void 0 ? void 0 : O.focus) === null || P === void 0 || P.call(O), (L = (_ = d.current[`${p.id}-0`]) === null || _ === void 0 ? void 0 : _.select) === null || L === void 0 || L.call(_);
    }), R.stopPropagation();
  }, size: "small" }, i, { sx: (R) => Object.assign({ height: "16px", ml: "4px", opacity: k ? 1 : 0.3, p: "8px", transform: "scale(0.75)", transition: "all 150ms ease-in-out", width: "16px" }, Fe(i == null ? void 0 : i.sx, R)), children: f.jsx(a, {}) })) }) }) }), s === "popover" && f.jsx(Ar, { anchorEl: m, anchorOrigin: {
    horizontal: "center",
    vertical: "top"
  }, disableScrollLock: !0, onClick: (R) => R.stopPropagation(), onClose: (R) => {
    R.stopPropagation(), b(null);
  }, onKeyDown: (R) => R.key === "Enter" && b(null), open: !!m, slotProps: { paper: { sx: { overflow: "visible" } } }, transformOrigin: {
    horizontal: "center",
    vertical: "bottom"
  }, children: f.jsx(J, { sx: { p: "1rem" }, children: f.jsx(SE, { header: o, table: r }) }) })] });
}, Uue = (e) => {
  var { column: t, table: n, tableHeadCellRef: o } = e, r = Pt(e, ["column", "table", "tableHeadCellRef"]);
  const { getState: i, options: { enableColumnOrdering: s, muiColumnDragHandleProps: a }, setColumnOrder: c, setDraggingColumn: d, setHoveredColumn: u } = n, { columnDef: p } = t, { columnOrder: h, draggingColumn: g, hoveredColumn: m } = i(), b = Object.assign(Object.assign(Object.assign({}, Fe(a, { column: t, table: n })), Fe(p.muiColumnDragHandleProps, {
    column: t,
    table: n
  })), r), C = (v) => {
    var S;
    (S = b == null ? void 0 : b.onDragStart) === null || S === void 0 || S.call(b, v), d(t);
    try {
      v.dataTransfer.setDragImage(o.current, 0, 0);
    } catch (M) {
      console.error(M);
    }
  }, x = (v) => {
    var S;
    (S = b == null ? void 0 : b.onDragEnd) === null || S === void 0 || S.call(b, v), (m == null ? void 0 : m.id) === "drop-zone" ? t.toggleGrouping() : s && m && (m == null ? void 0 : m.id) !== (g == null ? void 0 : g.id) && c(Ude(t, m, h)), d(null), u(null);
  };
  return f.jsx(mE, Object.assign({}, b, { onDragEnd: x, onDragStart: C, table: n }));
}, Gue = (e) => {
  var t, { header: n, table: o } = e, r = Pt(e, ["header", "table"]);
  const { getState: i, options: { columnResizeDirection: s, columnResizeMode: a }, setColumnSizingInfo: c } = o, { density: d } = i(), { column: u } = n, p = n.getResizeHandler(), h = d === "compact" ? "-8px" : d === "comfortable" ? "-16px" : "-24px", g = u.columnDef.columnDefType === "display" ? "4px" : "0";
  return f.jsx(J, { className: "Mui-TableHeadCell-ResizeHandle-Wrapper", onDoubleClick: () => {
    c((m) => Object.assign(Object.assign({}, m), { isResizingColumn: !1 })), u.resetSize();
  }, onMouseDown: p, onTouchStart: p, style: {
    transform: u.getIsResizing() && a === "onEnd" ? `translateX(${(s === "rtl" ? -1 : 1) * ((t = i().columnSizingInfo.deltaOffset) !== null && t !== void 0 ? t : 0)}px)` : void 0
  }, sx: (m) => ({
    "&:active > hr": {
      backgroundColor: m.palette.info.main,
      opacity: n.subHeaders.length || a === "onEnd" ? 1 : 0
    },
    cursor: "col-resize",
    left: s === "rtl" ? g : void 0,
    ml: s === "rtl" ? h : void 0,
    mr: s === "ltr" ? h : void 0,
    position: "absolute",
    px: "4px",
    right: s === "ltr" ? g : void 0
  }), children: f.jsx(ho, { className: "Mui-TableHeadCell-ResizeHandle-Divider", flexItem: !0, orientation: "vertical", sx: (m) => Object.assign({ borderRadius: "2px", borderWidth: "2px", height: "24px", touchAction: "none", transform: "translateX(4px)", transition: u.getIsResizing() ? void 0 : "all 150ms ease-in-out", userSelect: "none", zIndex: 4 }, Fe(r == null ? void 0 : r.sx, m)) }) });
}, que = (e) => {
  var { header: t, table: n } = e, o = Pt(e, ["header", "table"]);
  const { getState: r, options: { icons: { ArrowDownwardIcon: i, SyncAltIcon: s }, localization: a } } = n, { column: c } = t, { columnDef: d } = c, { isLoading: u, showSkeletons: p, sorting: h } = r(), g = !!c.getIsSorted(), m = u || p ? "" : c.getIsSorted() ? c.getIsSorted() === "desc" ? a.sortedByColumnDesc.replace("{column}", d.header) : a.sortedByColumnAsc.replace("{column}", d.header) : c.getNextSortingOrder() === "desc" ? a.sortByColumnDesc.replace("{column}", d.header) : a.sortByColumnAsc.replace("{column}", d.header), b = g ? c.getIsSorted() : void 0;
  return f.jsx(ln, { placement: "top", title: m, children: f.jsx(tw, { badgeContent: h.length > 1 ? c.getSortIndex() + 1 : 0, overlap: "circular", children: f.jsx(Tw, Object.assign({ IconComponent: g ? i : (C) => f.jsx(s, Object.assign({}, C, { direction: b, style: {
    transform: "rotate(-90deg) scaleX(0.9) translateX(-1px)"
  } })), active: !0, "aria-label": m, direction: b, onClick: (C) => {
    var x;
    C.stopPropagation(), (x = t.column.getToggleSortingHandler()) === null || x === void 0 || x(C);
  } }, o, { sx: (C) => Object.assign({ ".MuiTableSortLabel-icon": {
    color: `${C.palette.mode === "dark" ? C.palette.text.primary : C.palette.text.secondary} !important`
  }, flex: "0 0", opacity: g ? 1 : 0.3, transition: "all 150ms ease-in-out", width: "3ch" }, Fe(o == null ? void 0 : o.sx, C)) })) }) });
}, Kue = (e) => {
  var t, n, o, r, i, s, { columnVirtualizer: a, header: c, staticColumnIndex: d, table: u } = e, p = Pt(e, ["columnVirtualizer", "header", "staticColumnIndex", "table"]);
  const h = ge(), { getState: g, options: { columnFilterDisplayMode: m, columnResizeDirection: b, columnResizeMode: C, enableColumnActions: x, enableColumnDragging: v, enableColumnOrdering: S, enableColumnPinning: M, enableGrouping: w, enableMultiSort: k, layoutMode: E, mrtTheme: { draggingBorderColor: R }, muiTableHeadCellProps: O }, refs: { tableHeadCellRefs: P }, setHoveredColumn: _ } = u, { columnSizingInfo: L, density: V, draggingColumn: j, grouping: I, hoveredColumn: F, showColumnFilters: $ } = g(), { column: A } = c, { columnDef: H } = A, { columnDefType: N } = H, z = Object.assign(Object.assign(Object.assign({}, Fe(O, { column: A, table: u })), Fe(H.muiTableHeadCellProps, {
    column: A,
    table: u
  })), p), se = M && H.columnDefType !== "group" && A.getIsPinned(), ne = (x || H.enableColumnActions) && H.enableColumnActions !== !1, Z = v !== !1 && H.enableColumnDragging !== !1 && (v || S && H.enableColumnOrdering !== !1 || w && H.enableGrouping !== !1 && !I.includes(A.id)), q = tn(() => {
    let U = 0;
    return A.getCanSort() && (U += 1), ne && (U += 1.75), Z && (U += 1.5), U;
  }, [ne, Z]), G = tn(() => {
    const U = L.isResizingColumn === A.id && C === "onChange" && !c.subHeaders.length, W = U ? `2px solid ${R} !important` : (j == null ? void 0 : j.id) === A.id ? `1px dashed ${h.palette.grey[500]}` : (F == null ? void 0 : F.id) === A.id ? `2px dashed ${R}` : void 0;
    return U ? b === "ltr" ? { borderRight: W } : { borderLeft: W } : W ? {
      borderLeft: W,
      borderRight: W,
      borderTop: W
    } : void 0;
  }, [j, F, L.isResizingColumn]), K = (U) => {
    w && (F == null ? void 0 : F.id) === "drop-zone" && _(null), S && j && N !== "group" && _(H.enableColumnOrdering !== !1 ? A : null);
  }, Q = (U) => {
    H.enableColumnOrdering !== !1 && U.preventDefault();
  }, re = (t = Fe(H.Header, {
    column: A,
    header: c,
    table: u
  })) !== null && t !== void 0 ? t : H.header;
  return f.jsxs(I0, Object.assign({ align: N === "group" ? "center" : h.direction === "rtl" ? "right" : "left", "aria-sort": A.getIsSorted() ? A.getIsSorted() === "asc" ? "ascending" : "descending" : "none", colSpan: c.colSpan, "data-can-sort": A.getCanSort() || void 0, "data-index": d, "data-pinned": !!se || void 0, "data-sort": A.getIsSorted() || void 0, onDragEnter: K, onDragOver: Q, ref: (U) => {
    var W;
    U && (P.current[A.id] = U, N !== "group" && ((W = a == null ? void 0 : a.measureElement) === null || W === void 0 || W.call(a, U)));
  } }, z, { sx: (U) => Object.assign(Object.assign({ "& :hover": {
    ".MuiButtonBase-root": {
      opacity: 1
    }
  }, flexDirection: E != null && E.startsWith("grid") ? "column" : void 0, fontWeight: "bold", overflow: "visible", p: V === "compact" ? "0.5rem" : V === "comfortable" ? N === "display" ? "0.75rem" : "1rem" : N === "display" ? "1rem 1.25rem" : "1.5rem", pb: N === "display" ? 0 : $ || V === "compact" ? "0.4rem" : "0.6rem", pt: N === "group" || V === "compact" ? "0.25rem" : V === "comfortable" ? ".75rem" : "1.25rem", userSelect: k && A.getCanSort() ? "none" : void 0, verticalAlign: "top" }, Kh({
    column: A,
    header: c,
    table: u,
    tableCellProps: z,
    theme: U
  })), G), children: [c.isPlaceholder ? null : (n = z.children) !== null && n !== void 0 ? n : f.jsxs(J, { className: "Mui-TableHeadCell-Content", sx: {
    alignItems: "center",
    display: "flex",
    flexDirection: (z == null ? void 0 : z.align) === "right" ? "row-reverse" : "row",
    justifyContent: N === "group" || (z == null ? void 0 : z.align) === "center" ? "center" : A.getCanResize() ? "space-between" : "flex-start",
    position: "relative",
    width: "100%"
  }, children: [f.jsxs(J, { className: "Mui-TableHeadCell-Content-Labels", onClick: A.getToggleSortingHandler(), sx: {
    alignItems: "center",
    cursor: A.getCanSort() && N !== "group" ? "pointer" : void 0,
    display: "flex",
    flexDirection: (z == null ? void 0 : z.align) === "right" ? "row-reverse" : "row",
    overflow: N === "data" ? "hidden" : void 0,
    pl: (z == null ? void 0 : z.align) === "center" ? `${q}rem` : void 0
  }, children: [f.jsx(J, { className: "Mui-TableHeadCell-Content-Wrapper", sx: {
    "&:hover": {
      textOverflow: "clip"
    },
    minWidth: `${Math.min((r = (o = H.header) === null || o === void 0 ? void 0 : o.length) !== null && r !== void 0 ? r : 0, 4)}ch`,
    overflow: N === "data" ? "hidden" : void 0,
    textOverflow: "ellipsis",
    whiteSpace: ((s = (i = H.header) === null || i === void 0 ? void 0 : i.length) !== null && s !== void 0 ? s : 0) < 20 ? "nowrap" : "normal"
  }, children: re }), A.getCanFilter() && f.jsx(Wue, { header: c, table: u }), A.getCanSort() && f.jsx(que, { header: c, table: u })] }), N !== "group" && f.jsxs(J, { className: "Mui-TableHeadCell-Content-Actions", sx: {
    whiteSpace: "nowrap"
  }, children: [Z && f.jsx(Uue, { column: A, table: u, tableHeadCellRef: {
    current: P.current[A.id]
  } }), ne && f.jsx($ue, { header: c, table: u })] }), A.getCanResize() && f.jsx(Gue, { header: c, table: u })] }), m === "subheader" && A.getCanFilter() && f.jsx(SE, { header: c, table: u })] }));
}, Yue = (e) => {
  var { columnVirtualizer: t, headerGroup: n, table: o } = e, r = Pt(e, ["columnVirtualizer", "headerGroup", "table"]);
  const { options: { enableStickyHeader: i, layoutMode: s, mrtTheme: { baseBackgroundColor: a }, muiTableHeadRowProps: c } } = o, { virtualColumns: d, virtualPaddingLeft: u, virtualPaddingRight: p } = t ?? {}, h = Object.assign(Object.assign({}, Fe(c, {
    headerGroup: n,
    table: o
  })), r);
  return f.jsxs(j0, Object.assign({}, h, { sx: (g) => Object.assign({ backgroundColor: a, boxShadow: `4px 0 8px ${$t(g.palette.common.black, 0.1)}`, display: s != null && s.startsWith("grid") ? "flex" : void 0, position: i && s === "semantic" ? "sticky" : "relative", top: 0 }, Fe(h == null ? void 0 : h.sx, g)), children: [u ? f.jsx("th", { style: { display: "flex", width: u } }) : null, (d ?? n.headers).map((g, m) => {
    let b = g;
    return t && (m = g.index, b = n.headers[m]), b ? f.jsx(Kue, { columnVirtualizer: t, header: b, staticColumnIndex: m, table: o }, b.id) : null;
  }), p ? f.jsx("th", { style: { display: "flex", width: p } }) : null] }));
}, Xue = (e) => {
  var t, n, o, { stackAlertBanner: r, table: i } = e, s = Pt(e, ["stackAlertBanner", "table"]);
  const { getFilteredSelectedRowModel: a, getPrePaginationRowModel: c, getState: d, options: { enableRowSelection: u, enableSelectAll: p, localization: h, manualPagination: g, muiToolbarAlertBannerChipProps: m, muiToolbarAlertBannerProps: b, positionToolbarAlertBanner: C, renderToolbarAlertBannerContent: x, rowCount: v }, refs: { tablePaperRef: S } } = i, { density: M, grouping: w, rowSelection: k, showAlertBanner: E } = d(), R = Object.assign(Object.assign({}, Fe(b, {
    table: i
  })), s), O = Fe(m, {
    table: i
  }), P = v ?? c().flatRows.length, _ = tn(() => g ? Object.values(k).filter(Boolean).length : a().rows.length, [k, P, g]), L = _ > 0 ? f.jsxs(be, { alignItems: "center", direction: "row", gap: "16px", children: [(n = (t = h.selectedCountOfRowCountRowsSelected) === null || t === void 0 ? void 0 : t.replace("{selectedCount}", _.toLocaleString())) === null || n === void 0 ? void 0 : n.replace("{rowCount}", P.toString()), f.jsx(at, { onClick: (j) => iE({ table: i })(j, !1, !0), size: "small", sx: { p: "2px" }, children: h.clearSelection })] }) : null, V = w.length > 0 ? f.jsxs("span", { children: [h.groupedBy, " ", w.map((j, I) => f.jsxs(ws, { children: [I > 0 ? h.thenBy : "", f.jsx(hs, Object.assign({ label: i.getColumn(j).columnDef.header, onDelete: () => i.getColumn(j).toggleGrouping() }, O))] }, `${I}-${j}`))] }) : null;
  return f.jsx(Ts, { in: E || !!L || !!V, timeout: r ? 200 : 0, children: f.jsx(Av, Object.assign({ color: "info", icon: !1 }, R, { sx: (j) => {
    var I, F;
    return Object.assign({ "& .MuiAlert-message": {
      maxWidth: `calc(${(F = (I = S.current) === null || I === void 0 ? void 0 : I.clientWidth) !== null && F !== void 0 ? F : 360}px - 1rem)`,
      width: "100%"
    }, borderRadius: 0, fontSize: "1rem", left: 0, mb: r ? 0 : C === "bottom" ? "-1rem" : void 0, p: 0, position: "relative", right: 0, top: 0, width: "100%", zIndex: 2 }, Fe(R == null ? void 0 : R.sx, j));
  }, children: (o = x == null ? void 0 : x({
    groupedAlert: V,
    selectedAlert: L,
    table: i
  })) !== null && o !== void 0 ? o : f.jsxs(f.Fragment, { children: [(R == null ? void 0 : R.title) && f.jsx(Hv, { children: R.title }), f.jsxs(be, { sx: {
    p: C !== "head-overlay" ? "0.5rem 1rem" : M === "spacious" ? "0.75rem 1.25rem" : M === "comfortable" ? "0.5rem 0.75rem" : "0.25rem 0.5rem"
  }, children: [R == null ? void 0 : R.children, (R == null ? void 0 : R.children) && (L || V) && f.jsx("br", {}), f.jsxs(J, { sx: { display: "flex" }, children: [u && p && C === "head-overlay" && f.jsx(y5, { table: i }), " ", L] }), L && V && f.jsx("br", {}), V] })] }) })) });
}, Jue = (e) => {
  var { columnVirtualizer: t, table: n } = e, o = Pt(e, ["columnVirtualizer", "table"]);
  const { getState: r, options: { enableStickyHeader: i, layoutMode: s, muiTableHeadProps: a, positionToolbarAlertBanner: c }, refs: { tableHeadRef: d } } = n, { isFullScreen: u, showAlertBanner: p } = r(), h = Object.assign(Object.assign({}, Fe(a, { table: n })), o), g = i || u;
  return f.jsx(Mw, Object.assign({}, h, { ref: (m) => {
    d.current = m, h != null && h.ref && (h.ref.current = m);
  }, sx: (m) => Object.assign({ display: s != null && s.startsWith("grid") ? "grid" : void 0, opacity: 0.97, position: g ? "sticky" : "relative", top: g && (s != null && s.startsWith("grid")) ? 0 : void 0, zIndex: g ? 2 : void 0 }, Fe(h == null ? void 0 : h.sx, m)), children: c === "head-overlay" && (p || n.getSelectedRowModel().rows.length > 0) ? f.jsx("tr", { style: {
    display: s != null && s.startsWith("grid") ? "grid" : void 0
  }, children: f.jsx("th", { colSpan: n.getVisibleLeafColumns().length, style: {
    display: s != null && s.startsWith("grid") ? "grid" : void 0,
    padding: 0
  }, children: f.jsx(Xue, { table: n }) }) }) : n.getHeaderGroups().map((m) => f.jsx(Yue, { columnVirtualizer: t, headerGroup: m, table: n }, m.id)) }));
}, Que = (e) => {
  var { table: t } = e, n = Pt(e, ["table"]);
  const { getFlatHeaders: o, getState: r, options: { columns: i, enableStickyHeader: s, enableTableFooter: a, enableTableHead: c, layoutMode: d, memoMode: u, muiTableProps: p, renderCaption: h } } = t, { columnSizing: g, columnSizingInfo: m, columnVisibility: b, isFullScreen: C } = r(), x = Object.assign(Object.assign({}, Fe(p, { table: t })), n), v = Fe(h, { table: t }), S = tn(() => {
    const k = o(), E = {};
    for (let R = 0; R < k.length; R++) {
      const O = k[R], P = O.getSize();
      E[`--header-${xc(O.id)}-size`] = P, E[`--col-${xc(O.column.id)}-size`] = P;
    }
    return E;
  }, [i, g, m, b]), w = {
    columnVirtualizer: kue(t),
    table: t
  };
  return f.jsxs(ww, Object.assign({ stickyHeader: s || C }, x, { style: Object.assign(Object.assign({}, S), x == null ? void 0 : x.style), sx: (k) => Object.assign({ borderCollapse: "separate", display: d != null && d.startsWith("grid") ? "grid" : void 0, position: "relative" }, Fe(x == null ? void 0 : x.sx, k)), children: [!!v && f.jsx("caption", { children: v }), c && f.jsx(Jue, Object.assign({}, w)), u === "table-body" || m.isResizingColumn ? f.jsx(Iue, Object.assign({}, w)) : f.jsx(yE, Object.assign({}, w)), a && f.jsx(Due, Object.assign({}, w))] }));
}, e3e = [5, 10, 15, 20, 25, 30, 50, 100], t3e = (e) => {
  var { position: t = "bottom", table: n } = e, o = Pt(e, ["position", "table"]);
  const r = ge(), i = y0("(max-width: 720px)"), { getState: s, options: { enableToolbarInternalActions: a, icons: { ChevronLeftIcon: c, ChevronRightIcon: d, FirstPageIcon: u, LastPageIcon: p }, localization: h, muiPaginationProps: g, paginationDisplayMode: m } } = n, { pagination: { pageIndex: b = 0, pageSize: C = 10 }, showGlobalFilter: x } = s(), v = Object.assign(Object.assign({}, Fe(g, {
    table: n
  })), o), S = n.getRowCount(), M = n.getPageCount(), w = M > 2, k = b * C, E = Math.min(b * C + C, S), R = v ?? {}, { SelectProps: O = {}, disabled: P = !1, rowsPerPageOptions: _ = e3e, showFirstButton: L = w, showLastButton: V = w, showRowsPerPage: j = !0 } = R, I = Pt(R, ["SelectProps", "disabled", "rowsPerPageOptions", "showFirstButton", "showLastButton", "showRowsPerPage"]), F = b <= 0 || P, $ = E >= S || P;
  i && (O == null ? void 0 : O.native) !== !1 && (O.native = !0);
  const A = Fr();
  return f.jsxs(J, { className: "MuiTablePagination-root", sx: {
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    justifyContent: { md: "space-between", sm: "center" },
    justifySelf: "flex-end",
    mt: t === "top" && a && !x ? "3rem" : void 0,
    position: "relative",
    px: "8px",
    py: "12px",
    zIndex: 2
  }, children: [j && f.jsxs(J, { sx: { alignItems: "center", display: "flex", gap: "8px" }, children: [f.jsx(Q4, { htmlFor: "mrt-rows-per-page", sx: { mb: 0 }, children: h.rowsPerPage }), f.jsx(L0, Object.assign({ MenuProps: { disableScrollLock: !0 }, disableUnderline: !0, disabled: P, inputProps: {
    "aria-label": h.rowsPerPage,
    id: "mrt-rows-per-page"
  }, label: h.rowsPerPage, onChange: (H) => n.setPageSize(+H.target.value), sx: { mb: 0 }, value: C, variant: "standard" }, O, { children: _.map((H) => {
    var N;
    const z = typeof H != "number" ? H.value : H, se = typeof H != "number" ? H.label : `${H}`;
    return (N = O == null ? void 0 : O.children) !== null && N !== void 0 ? N : O != null && O.native ? f.jsx("option", { value: z, children: se }, z) : f.jsx(Jo, { sx: { m: 0 }, value: z, children: se }, z);
  }) }))] }), m === "pages" ? f.jsx(mw, Object.assign({ count: M, disabled: P, onChange: (H, N) => n.setPageIndex(N - 1), page: b + 1, renderItem: (H) => f.jsx(s7, Object.assign({ slots: {
    first: u,
    last: p,
    next: d,
    previous: c
  } }, H)), showFirstButton: L, showLastButton: V }, I)) : m === "default" ? f.jsxs(f.Fragment, { children: [f.jsx(oe, { align: "center", component: "span", sx: { m: "0 4px", minWidth: "8ch" }, variant: "body2", children: `${E === 0 ? 0 : (k + 1).toLocaleString()}-${E.toLocaleString()} ${h.of} ${S.toLocaleString()}` }), f.jsxs(J, { gap: "xs", children: [L && f.jsx(ln, Object.assign({}, A, { title: h.goToFirstPage, children: f.jsx("span", { children: f.jsx(Bt, { "aria-label": h.goToFirstPage, disabled: F, onClick: () => n.firstPage(), size: "small", children: f.jsx(u, Object.assign({}, W1(r))) }) }) })), f.jsx(ln, Object.assign({}, A, { title: h.goToPreviousPage, children: f.jsx("span", { children: f.jsx(Bt, { "aria-label": h.goToPreviousPage, disabled: F, onClick: () => n.previousPage(), size: "small", children: f.jsx(c, Object.assign({}, W1(r))) }) }) })), f.jsx(ln, Object.assign({}, A, { title: h.goToNextPage, children: f.jsx("span", { children: f.jsx(Bt, { "aria-label": h.goToNextPage, disabled: $, onClick: () => n.nextPage(), size: "small", children: f.jsx(d, Object.assign({}, W1(r))) }) }) })), V && f.jsx(ln, Object.assign({}, A, { title: h.goToLastPage, children: f.jsx("span", { children: f.jsx(Bt, { "aria-label": h.goToLastPage, disabled: $, onClick: () => n.lastPage(), size: "small", children: f.jsx(p, Object.assign({}, W1(r))) }) }) }))] })] }) : null] });
};
function xye(e) {
  const t = ge(), n = {
    enableDensityToggle: !1,
    //contrôle pas utilisé
    enableRowActions: !1,
    // commandes de la ligne
    positionActionsColumn: "last",
    enableRowSelection: !0,
    // commandes de séléction de ligne
    enableSelectAll: !0,
    enableToolbarInternalActions: !1,
    // commandes en haut du tableau
    enableColumnActions: !1,
    // commandes dans les headers de colonne
    muiTableBodyCellProps: {
      // style des cellules
      sx: {
        padding: "0 20px",
        "&:last-child[data-pinned='true']": {
          width: "1%"
        },
        color: t.palette.primary[700],
        fontSize: "12px",
        fontWeight: 700,
        borderInline: `1px solid ${t.custom.grey[500]}`
      }
    },
    muiTableBodyRowProps: {
      //style des lignes
      sx: {
        height: "64px"
      }
    },
    muiTableHeadCellProps: {
      //style des cellules d'en tête
      sx: {
        fontWeight: "500",
        color: t.custom.grey[2e3],
        backgroundColor: t.custom.grey[200],
        border: "1px solid " + t.custom.grey[500],
        textOverflow: "ellipsis",
        height: "52px",
        alignItems: "center",
        alignSelf: "stretch",
        paddingLeft: "20px",
        //pour séparer le texte et les boutons de tri
        "&>.Mui-TableHeadCell-Content>.Mui-TableHeadCell-Content-Labels": {
          display: "flex",
          justifyContent: "space-between",
          width: "100%"
        },
        "&>.Mui-TableHeadCell-Content .MuiDivider-vertical": {
          opacity: "0"
        }
      }
    },
    muiTableHeadRowProps: {
      sx: {
        boxShadow: "none"
      }
    },
    muiTableProps: {
      //style de la table
      sx: {
        "& tr:nth-of-type(even)": {
          backgroundColor: `${t.custom.grey[200]} !important`
        },
        "[data-pinned='true']:before": {
          display: "none"
        }
      }
    },
    paginationDisplayMode: "pages",
    muiPaginationProps: {
      //style de la pagination
      shape: "circular",
      variant: "text",
      showFirstButton: !1,
      showLastButton: !1,
      showRowsPerPage: !1,
      sx: {
        marginTop: "2px",
        "& button[aria-current=true]": {
          //FIXME: impossible de passer dans le thème car incompatibilité de type
          backgroundColor: t.palette.primary[500],
          color: t.custom.grey[100]
        }
      }
    },
    icons: {
      // icones custom
      ChevronLeftIcon: () => /* @__PURE__ */ f.jsx(sK, {}),
      ChevronRightIcon: () => /* @__PURE__ */ f.jsx(aK, {})
    },
    enableColumnResizing: !0,
    // Smart resize to avoir columns to be hidden by borders
    layoutMode: "grid",
    ...e
  }, o = Tue(n);
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(J, { sx: { overflow: "auto", width: "100%", height: "100%" }, children: /* @__PURE__ */ f.jsx(Que, { table: o }) }),
    n.enablePagination && /* @__PURE__ */ f.jsx(
      be,
      {
        alignItems: "flex-end",
        sx: {
          margin: "40px",
          marginTop: "32px",
          ".MuiTablePagination-root": {
            padding: 0
          }
        },
        children: /* @__PURE__ */ f.jsx(t3e, { table: o })
      }
    )
  ] });
}
const ME = (e) => /* @__PURE__ */ y.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("circle", { cx: 8, cy: 8, r: 8, fill: "white" }), /* @__PURE__ */ y.createElement("path", { d: "M8.00005 1.77777C4.56539 1.77777 1.77783 4.56533 1.77783 7.99999C1.77783 11.4347 4.56539 14.2222 8.00005 14.2222C11.4347 14.2222 14.2223 11.4347 14.2223 7.99999C14.2223 4.56533 11.4347 1.77777 8.00005 1.77777ZM8.62228 11.1111H7.37783V9.86666H8.62228V11.1111ZM8.62228 8.62222H7.37783V4.88888H8.62228V8.62222Z", fill: "#EE3C15" }));
function yye(e) {
  let t;
  switch (e.grade) {
    case "A":
      t = "darkgreen";
      break;
    case "B":
      t = "lightgreen";
      break;
    case "C":
      t = "goldenrod";
      break;
    case "D":
      t = "orange";
      break;
    case "E":
      t = "red";
      break;
  }
  return /* @__PURE__ */ f.jsxs(
    J,
    {
      component: "span",
      sx: {
        border: "1px solid #E7E6E4",
        display: "flex",
        padding: "20px"
      },
      children: [
        /* @__PURE__ */ f.jsxs(
          J,
          {
            sx: {
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              width: "48px"
            },
            children: [
              /* @__PURE__ */ f.jsx(
                oe,
                {
                  sx: {
                    display: "inline",
                    color: "white",
                    background: t,
                    borderRadius: "100%",
                    width: "24px",
                    height: "24px",
                    textAlign: "center"
                  },
                  children: e.grade.toUpperCase()
                }
              ),
              e.hasWarning === !0 && /* @__PURE__ */ f.jsx(
                ps,
                {
                  component: ME,
                  sx: {
                    top: "-6px",
                    right: "6px",
                    display: "inline",
                    position: "relative"
                  }
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ f.jsxs(oe, { children: [
          e.value,
          " / ",
          e.maxScore
        ] })
      ]
    }
  );
}
function vye(e) {
  const t = ge();
  return /* @__PURE__ */ f.jsx(J, { component: "span", children: /* @__PURE__ */ f.jsx(
    oe,
    {
      sx: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "inline-block",
        color: t.custom.grey[2500],
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "20px"
      },
      children: e.value
    }
  ) });
}
function wye(e) {
  const t = ge();
  return /* @__PURE__ */ f.jsxs(J, { component: "span", sx: { display: "flex", gap: "8px" }, children: [
    /* @__PURE__ */ f.jsxs(
      J,
      {
        sx: {
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-end",
          width: "48px"
        },
        children: [
          /* @__PURE__ */ f.jsx(
            oe,
            {
              sx: {
                display: "inline",
                color: t.custom.grey[2800],
                fontFamily: "Montserrat",
                fontStyle: "normal",
                fontSize: "18px",
                fontWeight: "800",
                lineHeight: "normal"
              },
              children: e.value
            }
          ),
          e.hasWarning === !0 && /* @__PURE__ */ f.jsx(
            ps,
            {
              component: ME,
              sx: {
                top: "-6px",
                right: "6px",
                display: "inline",
                position: "relative"
              }
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ f.jsx(
      oe,
      {
        variant: "caption",
        sx: {
          display: "inline",
          color: t.custom.grey[1400]
        },
        children: e.unit
      }
    )
  ] });
}
const Sye = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsx(Hr, { sx: { paddingBlock: "32px", paddingLeft: "32px", paddingRight: "40px" }, children: /* @__PURE__ */ f.jsxs(be, { flexDirection: "row", gap: "32px", justifyContent: "space-between", children: [
    /* @__PURE__ */ f.jsxs(J, { sx: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "row",
      gap: "28px"
    }, children: [
      /* @__PURE__ */ f.jsx(J, { sx: {
        minWidth: "100px",
        minHeight: "100px"
      }, children: /* @__PURE__ */ f.jsx(Pw, { illustration: "trajectoryActions" }) }),
      /* @__PURE__ */ f.jsxs(J, { sx: {
        display: "flex",
        flexDirection: "column",
        gap: "12px"
      }, children: [
        /* @__PURE__ */ f.jsx(oe, { variant: "h4", children: e.boldText }),
        /* @__PURE__ */ f.jsx(oe, { variant: "body-medium", children: e.smallInfoText })
      ] })
    ] }),
    /* @__PURE__ */ f.jsx(J, { sx: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minWidth: "233px",
      borderLeft: `1px solid ${t.custom.grey[500]}`,
      paddingLeft: "32px"
    }, children: /* @__PURE__ */ f.jsx(
      at,
      {
        onClick: e.buttonAction.action,
        variant: "primary",
        children: e.buttonAction.label
      }
    ) })
  ] }) });
}, Mye = (e) => {
  const { header: t, blocks: n } = e, o = ge(), r = Array.isArray(n) ? n : [n], i = n !== void 0;
  return /* @__PURE__ */ f.jsxs(Hr, { children: [
    /* @__PURE__ */ f.jsx(J, { sx: {
      borderBottom: i ? `1px solid ${o.custom.grey[500]}` : "none"
    }, children: t }),
    i && /* @__PURE__ */ f.jsx(be, { sx: {
      backgroundColor: o.custom.grey[200],
      padding: o.spacing(3),
      gap: o.spacing(3)
    }, children: r.map((s) => s) })
  ] });
}, NC = (e) => {
  const { value: t } = e, n = ge();
  return Array.isArray(t) ? /* @__PURE__ */ f.jsx(be, { children: t.map((o, r) => /* @__PURE__ */ f.jsxs(
    be,
    {
      flexDirection: "row",
      gap: n.spacing(0.5),
      alignItems: "center",
      sx: { overflowWrap: "anywhere" },
      children: [
        /* @__PURE__ */ f.jsx(oe, { variant: "body", children: "• " }),
        /* @__PURE__ */ f.jsx(oe, { variant: "body", children: o })
      ]
    },
    `valueList-${r}`
  )) }) : /* @__PURE__ */ f.jsx(oe, { variant: "body", children: t });
}, n3e = (e) => {
  const t = ge(), { comparison: n } = e;
  return /* @__PURE__ */ f.jsxs(
    be,
    {
      flexDirection: "row",
      justifyContent: "start",
      gap: t.spacing(2),
      children: [
        /* @__PURE__ */ f.jsxs(be, { gap: t.spacing(2), width: "50%", children: [
          /* @__PURE__ */ f.jsx(oe, { variant: "body-bold", children: n.start.year }),
          /* @__PURE__ */ f.jsx(NC, { value: n.start.value })
        ] }),
        n.current && /* @__PURE__ */ f.jsxs(be, { gap: t.spacing(2), width: "50%", children: [
          /* @__PURE__ */ f.jsx(oe, { variant: "body-bold", children: n.current.year }),
          /* @__PURE__ */ f.jsx(oe, { variant: "body", children: /* @__PURE__ */ f.jsx(NC, { value: n.current.value }) })
        ] })
      ]
    }
  );
}, Tye = (e) => {
  const { title: t, value: n, unit: o, fields: r } = e, i = ge(), s = Array.isArray(r) ? r : [r], a = r !== void 0, c = s.length - 1;
  return /* @__PURE__ */ f.jsxs(Hr, { children: [
    /* @__PURE__ */ f.jsx(J, { sx: {
      borderBottom: a ? `1px solid ${i.custom.grey[500]}` : "none"
    }, children: /* @__PURE__ */ f.jsxs(
      be,
      {
        flexDirection: "row",
        gap: i.spacing(2),
        sx: {
          justifyContent: "space-between",
          alignItems: "center",
          padding: i.spacing(2, 4, 2, 4)
        },
        children: [
          /* @__PURE__ */ f.jsx(oe, { variant: "h4", children: t }),
          n !== null && /* @__PURE__ */ f.jsx(J, { sx: { display: "flex", gap: i.spacing(2) }, children: /* @__PURE__ */ f.jsx(u7, { value: n, unit: o ?? "" }) })
        ]
      }
    ) }),
    a && /* @__PURE__ */ f.jsx(be, { sx: {
      padding: i.spacing(3, 0, 3, 0)
    }, children: s.map((d, u) => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      d,
      c !== u && /* @__PURE__ */ f.jsx(J, { sx: {
        marginBlock: i.spacing(2),
        borderBottom: `1px solid ${i.custom.grey[500]}`
      } })
    ] }, `blockItemContainer-${u}`)) })
  ] });
}, U0 = (e) => {
  const { children: t, blockOptions: n } = e, o = ge();
  return /* @__PURE__ */ f.jsxs(be, { padding: o.spacing(0, 4, 0, 4), gap: o.spacing(2), children: [
    /* @__PURE__ */ f.jsx(oe, { variant: "h5", children: n.title }),
    /* @__PURE__ */ f.jsxs(
      be,
      {
        flexDirection: "row",
        gap: o.spacing(3),
        sx: {
          display: "grid",
          gridTemplateColumns: "[a] 1fr [b] 1px [c] 1fr"
        },
        children: [
          /* @__PURE__ */ f.jsx(J, { sx: { gridColumn: "a" }, children: /* @__PURE__ */ f.jsx(n3e, { comparison: n.comparisonValues }) }),
          /* @__PURE__ */ f.jsx(J, { sx: { border: `1px solid ${o.custom.grey[500]}` } }),
          /* @__PURE__ */ f.jsx(J, { sx: { gridColumn: "c" }, children: /* @__PURE__ */ f.jsxs(be, { gap: o.spacing(2), children: [
            /* @__PURE__ */ f.jsx(oe, { variant: "body-bold", children: n.rightSubtitle }),
            t
          ] }) })
        ]
      }
    )
  ] });
}, kye = (e) => {
  const t = ge(), { emptyText: n, illustration: o } = e;
  return /* @__PURE__ */ f.jsx(Hr, { children: /* @__PURE__ */ f.jsxs(
    be,
    {
      justifyContent: "center",
      alignItems: "center",
      padding: t.spacing(2, 0, 2, 0),
      gap: t.spacing(2.5),
      children: [
        /* @__PURE__ */ f.jsx(
          Pw,
          {
            width: 60,
            height: 60,
            illustration: o
          }
        ),
        /* @__PURE__ */ f.jsx(J, { children: n })
      ]
    }
  ) });
}, Eye = (e) => {
  const t = ge(), { suggestionTitle: n, text: o } = e;
  return /* @__PURE__ */ f.jsx(zK, { size: "small", children: /* @__PURE__ */ f.jsxs(
    be,
    {
      flexDirection: "row",
      gap: t.spacing(3),
      children: [
        /* @__PURE__ */ f.jsx(_t, { size: 8, icon: "suggestions" }),
        /* @__PURE__ */ f.jsxs(be, { flexDirection: "column", gap: t.spacing(1), children: [
          n,
          o
        ] })
      ]
    }
  ) });
}, Rye = (e) => {
  const { blockOptions: t, ...n } = e;
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx(U0, { blockOptions: t, children: /* @__PURE__ */ f.jsx(Bre, { ...n }) }) });
}, Oye = (e) => {
  const { blockOptions: t, ...n } = e;
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx(U0, { blockOptions: t, children: /* @__PURE__ */ f.jsx(N0, { ...n, type: "number" }) }) });
}, _ye = (e) => {
  const { values: t, onChange: n, variant: o = "primary", flexDirection: r = "row", title: i, description: s, ...a } = e, c = (d, u) => {
    const p = Object.fromEntries(
      Object.entries(t).map(([h, g]) => [h, { ...g, state: h === d && u }])
    );
    n(p);
  };
  return /* @__PURE__ */ f.jsxs(
    J,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        gap: "10px"
      },
      children: [
        i && /* @__PURE__ */ f.jsxs(oe, { variant: "h5", children: [
          i,
          " :"
        ] }),
        s && /* @__PURE__ */ f.jsx(oe, { variant: "body", children: s }),
        /* @__PURE__ */ f.jsx(R3, { sx: { flexDirection: r }, children: Object.entries(t).map(([d, u], p) => /* @__PURE__ */ f.jsx(
          u2,
          {
            value: p,
            componentsProps: {
              typography: { variant: "body" }
            },
            control: /* @__PURE__ */ f.jsx(
              P3,
              {
                id: `${d}-${p}`,
                checked: u.state,
                disabled: u.disabled,
                icon: /* @__PURE__ */ f.jsx(o3e, { variant: o }),
                checkedIcon: /* @__PURE__ */ f.jsx(r3e, { variant: o }),
                ...a
              }
            ),
            label: u.name,
            onChange: (h, g) => c(d, g)
          },
          `${d}-${p}`
        )) })
      ]
    }
  );
}, o3e = B((e) => {
  const { variant: t, ...n } = e, o = t === "primary" ? Yh : i3e;
  return /* @__PURE__ */ f.jsx(o, { ...n });
})({}), r3e = B((e) => {
  const { variant: t, ...n } = e, o = t === "primary" ? TE : s3e;
  return /* @__PURE__ */ f.jsx(o, { ...n });
})({}), Yh = B("span")({
  borderRadius: "50%",
  width: 20,
  height: 20,
  boxShadow: `0 0 0 2px ${Ee[1600]}`,
  backgroundColor: Ee[100],
  "input:disabled ~ &": {
    boxShadow: `0 0 0 2px ${Ee[800]}`,
    background: Ee[100]
  }
}), TE = B(Yh)({
  backgroundColor: Ee[2800],
  boxShadow: `0 0 0 2px ${Ee[2800]}`,
  "&::before": {
    display: "block",
    width: 20,
    height: 20,
    backgroundImage: `radial-gradient(${Ee[100]},${Ee[100]} 28%,transparent 32%)`,
    content: '""'
  },
  "input:disabled ~ &": {
    boxShadow: `0 0 0 2px ${Ee[800]}`,
    background: Ee[800],
    "&::before": {
      display: "block",
      width: 20,
      height: 20,
      backgroundImage: `radial-gradient(${Ee[100]},${Ee[100]} 28%,transparent 32%)`,
      content: '""'
    }
  }
}), i3e = B(Yh)({
  boxShadow: `0 0 0 2px ${Ee[2800]}`
}), s3e = B(TE)({
  boxShadow: `0 0 0 2px ${Ee[2e3]}`,
  backgroundColor: Ee[2e3]
}), kE = (e) => {
  const {
    values: t,
    onChange: n,
    variant: o = "primary",
    flexDirection: r = "row",
    FormControlProps: i,
    FormControlLabelProps: s,
    RadioProps: a
  } = e;
  return /* @__PURE__ */ f.jsx(R3, { sx: { flexDirection: r }, ...i, children: Object.entries(t).map(([c, d], u) => /* @__PURE__ */ Yl(
    u2,
    {
      value: u,
      componentsProps: {
        typography: { variant: "body" }
      },
      ...s,
      key: `${c}-${u}`,
      label: d.name,
      control: /* @__PURE__ */ f.jsx(
        P3,
        {
          id: `${c}-${u}`,
          checked: d.state,
          disabled: d.disabled,
          icon: /* @__PURE__ */ f.jsx(a3e, { variant: o }),
          checkedIcon: /* @__PURE__ */ f.jsx(l3e, { variant: o }),
          disableRipple: !0,
          ...a
        }
      ),
      onChange: (p, h) => {
        const g = { ...t };
        Object.entries(g).forEach((m) => m[1].state = !1), g[c] = {
          ...g[c],
          state: h
        }, n(g);
      }
    }
  )) });
}, a3e = B((e) => {
  const { variant: t, ...n } = e, o = t === "primary" ? Xh : c3e;
  return /* @__PURE__ */ f.jsx(o, { ...n });
})({}), l3e = B((e) => {
  const { variant: t, ...n } = e, o = t === "primary" ? EE : d3e;
  return /* @__PURE__ */ f.jsx(o, { ...n });
})({}), Xh = B("span")({
  borderRadius: "50%",
  width: 20,
  height: 20,
  boxShadow: `0 0 0 2px ${Ee[1600]}`,
  backgroundColor: Ee[100],
  "input:disabled ~ &": {
    boxShadow: `0 0 0 2px ${Ee[800]}`,
    background: Ee[100]
  }
}), EE = B(Xh)({
  backgroundColor: Ee[2800],
  boxShadow: `0 0 0 2px ${Ee[2800]}`,
  "&::before": {
    display: "block",
    width: 20,
    height: 20,
    backgroundImage: `radial-gradient(${Ee[100]},${Ee[100]} 28%,transparent 32%)`,
    content: '""'
  },
  "input:disabled ~ &": {
    boxShadow: `0 0 0 2px ${Ee[800]}`,
    background: Ee[800],
    "&::before": {
      display: "block",
      width: 20,
      height: 20,
      backgroundImage: `radial-gradient(${Ee[100]},${Ee[100]} 28%,transparent 32%)`,
      content: '""'
    }
  }
}), c3e = B(Xh)({
  boxShadow: `0 0 0 2px ${Ee[2800]}`
}), d3e = B(EE)({
  boxShadow: `0 0 0 2px ${Ee[2e3]}`,
  backgroundColor: Ee[2e3]
}), u3e = (e) => {
  const {
    values: t,
    selectedItem: n,
    onChange: o,
    getId: r = (c) => c.id,
    getName: i = (c) => c.name,
    ...s
  } = e, a = t.reduce((c, d) => {
    const u = r(d), p = n === void 0 ? !1 : u === r(n);
    return c[u] = {
      name: i(d),
      state: p,
      rawData: d
    }, c;
  }, {});
  return /* @__PURE__ */ f.jsx(
    kE,
    {
      values: a,
      onChange: (c) => {
        const d = Object.values(c).find((u) => u.state === !0);
        if (d === void 0 || d.rawData === void 0) {
          console.error("Please, check with your admin...");
          return;
        }
        return o(d.rawData);
      },
      ...s
    }
  );
}, Pye = (e) => {
  const {
    value: t,
    onChange: n,
    trueKeyName: o = "Oui",
    falseKeyName: r = "Non",
    ...i
  } = e, s = {
    id1: {
      name: o,
      state: t === !0
    },
    id2: {
      name: r,
      state: t === !1
    }
  };
  return /* @__PURE__ */ f.jsx(
    kE,
    {
      values: s,
      onChange: (a) => {
        const c = Object.values(a).find((d) => d.state === !0);
        if (c !== void 0) {
          const d = c.name === o;
          n(d);
        }
      },
      ...i
    }
  );
}, Lye = (e) => {
  const { blockOptions: t, ...n } = e;
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx(U0, { blockOptions: t, children: /* @__PURE__ */ f.jsx(u3e, { ...n }) }) });
}, f3e = (e) => /* @__PURE__ */ y.createElement("svg", { width: 16, height: 15, viewBox: "0 0 16 15", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M2.89332 14.6818V13.0909H10.0842C11.1607 13.0909 12.0901 12.7383 12.8723 12.033C13.6545 11.3277 14.0456 10.45 14.0456 9.40002C14.0456 8.35 13.6545 7.47235 12.8723 6.76705C12.0901 6.06175 11.1607 5.7091 10.0842 5.7091H3.38648L6.0274 8.34999L4.91375 9.46364L0.36377 4.91363L4.91375 0.363647L6.0274 1.47727L3.38648 4.11819H10.0683C11.5903 4.11819 12.8988 4.62463 13.9939 5.63751C15.089 6.6504 15.6365 7.90456 15.6365 9.40002C15.6365 10.8955 15.089 12.1496 13.9939 13.1625C12.8988 14.1754 11.5903 14.6818 10.0683 14.6818H2.89332Z", fill: "currentColor" }));
var Jh = {}, p3e = ht;
Object.defineProperty(Jh, "__esModule", {
  value: !0
});
var Qh = Jh.default = void 0, h3e = p3e(bt()), g3e = f;
Qh = Jh.default = (0, h3e.default)(/* @__PURE__ */ (0, g3e.jsx)("path", {
  d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
}), "KeyboardArrowDown");
var e8 = {}, m3e = ht;
Object.defineProperty(e8, "__esModule", {
  value: !0
});
var t8 = e8.default = void 0, b3e = m3e(bt()), C3e = f;
t8 = e8.default = (0, b3e.default)(/* @__PURE__ */ (0, C3e.jsx)("path", {
  d: "M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"
}), "KeyboardArrowUp");
const RE = (e) => {
  const t = ge(), { sx: n, ...o } = e;
  return /* @__PURE__ */ f.jsx(
    J,
    {
      sx: {
        display: "grid",
        gridTemplateColumns: "1fr 20px",
        alignItems: "center",
        width: "100%",
        justifyContent: "space-between",
        gap: "4px",
        color: t.palette.primary[600],
        ...n
      },
      ...o,
      children: e.children
    }
  );
}, x3e = (e) => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
  e.icon && /* @__PURE__ */ f.jsx(J, { sx: {
    display: "flex",
    gridColumn: "1 / 2"
  }, children: e.icon }),
  /* @__PURE__ */ f.jsx(RE, { children: /* @__PURE__ */ f.jsx(oe, { sx: {
    gridColumn: "1 / 2",
    overflow: "visible"
  }, variant: "body", children: e.displayText }) })
] }), y3e = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M15.8056 29.8333L6.41675 20.4444L8.40283 18.4583L15.8056 25.8611L31.5695 10.0972L33.5556 12.0833L15.8056 29.8333Z", fill: "inherit" })), v3e = (e) => {
  const t = ge();
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    e.icon && /* @__PURE__ */ f.jsx(J, { sx: {
      display: "flex",
      flexDirection: "column",
      gridColumn: "1 / 2"
    }, children: e.icon }),
    /* @__PURE__ */ f.jsxs(RE, { children: [
      /* @__PURE__ */ f.jsx(
        oe,
        {
          sx: {
            gridColumn: "1 / 2",
            color: t.palette.primary[600],
            overflow: "visible"
          },
          variant: "body-bold",
          children: e.displayText
        }
      ),
      /* @__PURE__ */ f.jsx(J, { sx: {
        gridColumn: "2 / 2",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "16px",
        height: "16px"
      }, children: /* @__PURE__ */ f.jsx(y3e, {}) })
    ] })
  ] });
}, v5 = (e) => {
  const { isSelected: t, icon: n, displayText: o, onClick: r } = e, i = ge();
  return /* @__PURE__ */ f.jsx(
    J,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        paddingBlock: "4px",
        ":hover": {
          backgroundColor: i.custom.grey[300]
        }
      },
      onClick: () => r && r(),
      children: /* @__PURE__ */ f.jsx(J, { sx: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        position: "relative",
        width: "90%",
        left: "5%",
        cursor: "pointer"
      }, children: t === !1 ? /* @__PURE__ */ f.jsx(x3e, { displayText: o, icon: n }) : /* @__PURE__ */ f.jsx(v3e, { displayText: o, icon: n }) })
    }
  );
}, OE = h0(null), _E = (e) => {
  const {
    children: t,
    disabled: n = !1,
    closeOnSelect: o = !0,
    disableSearch: r = !1,
    ...i
  } = e, s = {
    disabled: n,
    closeOnSelect: o,
    disableSearch: r,
    ...i
  };
  return /* @__PURE__ */ f.jsx(OE.Provider, { value: s, children: t });
}, G0 = () => {
  const e = p0(OE);
  if (e)
    return e;
  throw new Error("useFoodsSelectContext must be used within an FoodsSelectContextProvider");
}, w3e = () => {
  const { search: e, setSearch: t, textOptions: n } = G0(), o = ge();
  return /* @__PURE__ */ f.jsxs(J, { sx: {
    display: "flex",
    gap: "8px",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    height: "40px",
    padding: "0px 20px 0px 20px",
    borderRadius: "24px",
    border: `1px solid ${o.custom.grey[500]}`,
    background: "white",
    boxShadow: "0px 2px 8px 0px " + o.custom.grey[500]
  }, children: [
    /* @__PURE__ */ f.jsx(
      Ir,
      {
        label: "",
        placeholder: n.searchPlaceholder,
        value: e,
        onChange: (r) => {
          t(r.target.value);
        },
        sx: {
          width: "100%",
          "&>.MuiInputBase-root": {
            ">fieldset": {
              border: "none"
            },
            ">input": {
              padding: 0
            }
          }
        }
      }
    ),
    /* @__PURE__ */ f.jsxs(J, { sx: {
      display: "flex",
      gap: "8px",
      alignItems: "center"
    }, children: [
      e !== "" && /* @__PURE__ */ f.jsx(
        J,
        {
          sx: { display: "flex" },
          onClick: () => t(""),
          children: /* @__PURE__ */ f.jsx(_t, { size: 2, icon: "close" })
        }
      ),
      /* @__PURE__ */ f.jsx(_t, { size: 3, icon: "search" })
    ] })
  ] });
}, S3e = (e, t) => t === void 0 || e === null ? null : t(e), M3e = (e) => {
  const { selectedOption: t, onChange: n, getIcon: o, getName: r } = e, { noValue: i, disableSearch: s } = G0(), a = ge(), c = S3e(t, o), d = t === null ? "" : r(t);
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    s === !1 && /* @__PURE__ */ f.jsx(J, { sx: {
      width: "90%",
      position: "relative",
      left: "5%",
      marginBottom: "10px"
    }, children: /* @__PURE__ */ f.jsx(w3e, {}) }),
    /* @__PURE__ */ f.jsxs(J, { sx: { display: "fleX", flexDirection: "column", gap: "4px" }, children: [
      i && /* @__PURE__ */ f.jsx(
        v5,
        {
          isSelected: !1,
          icon: /* @__PURE__ */ f.jsx(_t, { size: 1, icon: "close" }),
          displayText: i,
          onClick: () => n(null)
        }
      ),
      t !== null && /* @__PURE__ */ f.jsx(
        v5,
        {
          isSelected: !0,
          icon: c,
          displayText: d
        }
      ),
      /* @__PURE__ */ f.jsx(
        J,
        {
          sx: {
            marginBlock: "4px",
            borderBottom: `1px solid ${a.custom.grey[500]}`
          }
        }
      )
    ] })
  ] });
}, T3e = (e) => {
  const t = ge(), { selectedOption: n, options: o, getId: r, getName: i, onChange: s, getIcon: a } = e, { isSearchFound: c, textOptions: d } = G0(), u = o.filter((p) => c(i(p)));
  return /* @__PURE__ */ f.jsxs(J, { sx: {
    marginBlock: "8px",
    display: "flex",
    flexDirection: "column"
  }, children: [
    /* @__PURE__ */ f.jsx(
      M3e,
      {
        selectedOption: n,
        getName: i,
        getIcon: a,
        onChange: s
      }
    ),
    u.length === 0 && /* @__PURE__ */ f.jsxs(J, { sx: { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "8px", marginBlock: "4px" }, children: [
      /* @__PURE__ */ f.jsx(V0, { icon: "questionMark", size: 3, boxProps: {
        sx: {
          backgroundColor: t.palette.primary[50],
          borderRadius: "32px"
        }
      } }),
      /* @__PURE__ */ f.jsx(oe, { variant: "body-medium", children: d.noResult })
    ] }),
    u.map((p, h) => {
      const g = i(p), m = n === null ? !1 : r(p) === r(n);
      if (m === !0)
        return null;
      const b = a ? a(p) : null;
      return /* @__PURE__ */ f.jsx(ws, { children: /* @__PURE__ */ f.jsx(
        v5,
        {
          isSelected: m,
          icon: b,
          displayText: g,
          onClick: () => s(p)
        }
      ) }, `select-${h}`);
    })
  ] });
}, k3e = (e, t, n, o, r) => e.length === 0 ? n !== null ? o(n) : t : n === null ? r : o(n), E3e = (e) => {
  const { textOptions: t, disabled: n, closeOnSelect: o, setSearch: r, disableOnEmpty: i } = G0(), s = ge(), [a, c] = Ae(null), d = () => c(null), u = a !== null, { selectedOption: p } = e, h = u ? /* @__PURE__ */ f.jsx(t8, {}) : /* @__PURE__ */ f.jsx(Qh, {}), g = u ? { border: `2px solid ${s.custom.grey[2800]}` } : {}, m = k3e(
    e.options,
    t.emptyOptionsText,
    p,
    e.getName,
    t.placeholder
  ), b = i && e.options.length === 0;
  return /* @__PURE__ */ f.jsxs(ws, { children: [
    /* @__PURE__ */ f.jsxs(
      at,
      {
        variant: "select",
        onClick: (C) => u ? d() : c(C.currentTarget),
        sx: {
          ...g,
          width: "100%",
          height: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0px 12px 0px 12px"
        },
        disabled: n || b,
        children: [
          e.getIcon && p && e.getIcon(p),
          /* @__PURE__ */ f.jsx(
            oe,
            {
              variant: "body-medium",
              sx: {
                width: "100%",
                textAlign: "left",
                marginLeft: "8px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis"
              },
              children: m
            }
          ),
          h
        ]
      }
    ),
    /* @__PURE__ */ f.jsx(
      g7,
      {
        sx: { top: "5px" },
        paperProps: {
          width: "280px",
          maxHeight: "300px",
          border: `1px solid ${s.custom.grey[500]}`,
          borderRadius: "12px",
          boxShadow: "0px 4px 20px 0px #514E4E1F",
          ...e.BoxOptionsProps
        },
        variant: "headless",
        anchor: a,
        open: u,
        onClose: () => {
          d(), r("");
        },
        anchorPosition: "rightside",
        children: /* @__PURE__ */ f.jsx(
          T3e,
          {
            selectedOption: e.selectedOption,
            options: e.options,
            getId: e.getId,
            getName: e.getName,
            getIcon: e.getIcon,
            onChange: (C) => {
              e.onChange(C), r(""), o === !0 && d();
            }
          }
        )
      }
    )
  ] });
}, R3e = (e, t) => !(e === !0 || t.length === 0), PE = (e) => {
  const {
    options: t,
    selectedOption: n,
    originalValue: o,
    onChange: r,
    getId: i,
    getName: s,
    getIcon: a,
    unit: c,
    BoxProps: d = {},
    BoxOptionsProps: u = {}
  } = e, { disabled: p, textOptions: h } = G0(), g = R3e(p, t);
  return /* @__PURE__ */ f.jsxs(J, { sx: {
    width: "300px",
    ...d
  }, children: [
    /* @__PURE__ */ f.jsxs(J, { sx: { display: "flex", alignItems: "center", direction: "row", gap: "8px" }, children: [
      /* @__PURE__ */ f.jsx(
        E3e,
        {
          options: t,
          getId: i,
          getName: s,
          onChange: r,
          getIcon: a,
          selectedOption: n,
          BoxOptionsProps: u
        }
      ),
      c && /* @__PURE__ */ f.jsx(oe, { variant: "body", children: c }),
      g && o && /* @__PURE__ */ f.jsx(Bt, { onClick: () => r(o), children: /* @__PURE__ */ f.jsx(f3e, {}) })
    ] }),
    g && o && /* @__PURE__ */ f.jsx(oe, { variant: "small-medium", children: `${h.defaultValueText} : ${s(o)}` })
  ] });
}, O3e = (e) => {
  const {
    // FoodsSelectContextProvider arguments
    textOptions: t,
    noValue: n,
    disabled: o,
    closeOnSelect: r,
    disableSearch: i,
    disableOnEmpty: s = !1,
    ...a
  } = e, [c, d] = Ae(""), u = (p) => c === "" ? !0 : p.toLowerCase().includes(c.toLowerCase());
  return /* @__PURE__ */ f.jsx(
    _E,
    {
      textOptions: t,
      noValue: n,
      disabled: o,
      closeOnSelect: r,
      disableSearch: i,
      search: c,
      setSearch: d,
      isSearchFound: u,
      disableOnEmpty: s,
      children: /* @__PURE__ */ f.jsx(PE, { ...a })
    }
  );
}, Iye = (e) => {
  const {
    // FoodsSelectContextProvider arguments
    textOptions: t,
    noValue: n,
    disabled: o,
    closeOnSelect: r,
    search: i,
    setSearch: s,
    isSearchFound: a,
    disableOnEmpty: c = !1,
    ...d
  } = e;
  return /* @__PURE__ */ f.jsx(
    _E,
    {
      textOptions: t,
      noValue: n,
      disabled: o,
      closeOnSelect: r,
      search: i,
      setSearch: s,
      isSearchFound: a,
      disableOnEmpty: c,
      children: /* @__PURE__ */ f.jsx(PE, { ...d })
    }
  );
}, jye = (e) => {
  const { blockOptions: t, ...n } = e;
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx(U0, { blockOptions: t, children: /* @__PURE__ */ f.jsx(O3e, { ...n }) }) });
}, Vye = (e) => {
  const { blockOptions: t, ...n } = e;
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx(U0, { blockOptions: t, children: /* @__PURE__ */ f.jsx(N0, { ...n }) }) });
}, Dye = (e) => {
  const { title: t, cancel: n, confirm: o } = e, r = ge();
  return /* @__PURE__ */ f.jsxs(
    be,
    {
      flexDirection: "row",
      gap: r.spacing(4),
      sx: {
        justifyContent: "space-between",
        alignItems: "center",
        padding: r.spacing(3, 4, 3, 4)
      },
      children: [
        /* @__PURE__ */ f.jsx($c, { text: t, defaultVariant: "h3" }),
        /* @__PURE__ */ f.jsxs(J, { sx: { display: "flex", gap: r.spacing(2) }, children: [
          /* @__PURE__ */ f.jsx(at, { variant: "ternary", onClick: n.action, children: n.label }),
          /* @__PURE__ */ f.jsx(
            at,
            {
              variant: "validate",
              onClick: o.action,
              disabled: o.disabled ?? !1,
              startIcon: /* @__PURE__ */ f.jsx(_t, { size: 2, icon: "check" }),
              children: o.label
            }
          )
        ] })
      ]
    }
  );
}, Aye = (e) => {
  const { title: t, cancel: n, confirm: o } = e, r = ge();
  return /* @__PURE__ */ f.jsxs(
    be,
    {
      flexDirection: "row",
      gap: r.spacing(4),
      sx: {
        justifyContent: "space-between",
        alignItems: "center",
        padding: r.spacing(3, 4, 3, 4)
      },
      children: [
        /* @__PURE__ */ f.jsx(oe, { variant: "h3", children: t }),
        /* @__PURE__ */ f.jsxs(J, { sx: { display: "flex", gap: r.spacing(2) }, children: [
          /* @__PURE__ */ f.jsx(at, { variant: "ternary", onClick: n.action, children: n.label }),
          /* @__PURE__ */ f.jsx(
            at,
            {
              variant: "validate",
              onClick: o.action,
              startIcon: /* @__PURE__ */ f.jsx(_t, { size: 2, icon: "check" }),
              children: o.label
            }
          )
        ] })
      ]
    }
  );
}, Hye = (e) => {
  const { title: t, actionButton: n, cancelButton: o } = e, r = ge();
  return /* @__PURE__ */ f.jsxs(
    be,
    {
      flexDirection: "row",
      gap: r.spacing(4),
      sx: {
        justifyContent: "space-between",
        alignItems: "center",
        padding: r.spacing(3, 4, 3, 4)
      },
      children: [
        /* @__PURE__ */ f.jsx($c, { text: t, defaultVariant: "h3" }),
        /* @__PURE__ */ f.jsxs(J, { sx: { display: "flex", gap: r.spacing(2) }, children: [
          o && /* @__PURE__ */ f.jsx(
            Bc,
            {
              buttonOptions: o,
              defaultOptions: {
                variant: "ternary"
              }
            }
          ),
          n && /* @__PURE__ */ f.jsx(
            Bc,
            {
              buttonOptions: n,
              defaultOptions: {
                variant: "primary",
                endIcon: /* @__PURE__ */ f.jsx(_t, { size: 2, icon: "arrowRight" })
              }
            }
          )
        ] })
      ]
    }
  );
}, _3e = (e) => {
  const t = ge(), n = {
    lineColor: t.custom.grey[1500],
    fontColor: t.custom.grey[2500],
    fullUpLineColor: t.custom.green[400],
    fullUpFontColor: t.custom.green[400]
  }, o = e.value >= 100, i = (() => {
    const s = {
      ...n,
      ...e.styleProperties
    };
    return {
      color: o ? s.fullUpLineColor : s.lineColor,
      fontColor: o ? s.fullUpFontColor : s.fontColor
    };
  })();
  return /* @__PURE__ */ f.jsxs(J, { sx: { display: "flex", alignItems: "center", gap: "5px" }, children: [
    /* @__PURE__ */ f.jsx(J, { sx: { width: "100%", mr: 1 }, children: /* @__PURE__ */ f.jsx(
      sw,
      {
        variant: "determinate",
        ...e,
        sx: {
          "&.MuiLinearProgress-determinate": {
            backgroundColor: t.custom.grey[400],
            borderBottomLeftRadius: "8px",
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
            borderBottomRightRadius: "8px",
            height: "8px"
          },
          "& .MuiLinearProgress-bar": {
            backgroundColor: i.color
          }
        }
      }
    ) }),
    /* @__PURE__ */ f.jsx(J, { sx: { minWidth: 35 }, children: /* @__PURE__ */ f.jsx(
      oe,
      {
        variant: o ? "body-bold" : "body",
        sx: { color: i.fontColor },
        children: `${Math.round(e.value)}%`
      }
    ) })
  ] });
}, P3e = "data:image/svg+xml,%3csvg%20width='12'%20height='12'%20viewBox='0%200%2012%2012'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M6.36793%203.67567V8.45768L8.76534%206.06668L6.36793%203.67567ZM1.60513%2011.7333C1.27265%2011.7333%200.988677%2011.6156%200.75321%2011.3801C0.517733%2011.1446%200.399994%2010.8607%200.399994%2010.5282V1.60516C0.399994%201.27268%200.517733%200.988708%200.75321%200.753241C0.988677%200.517763%201.27265%200.400024%201.60513%200.400024H10.5282C10.8606%200.400024%2011.1446%200.517763%2011.3801%200.753241C11.6156%200.988708%2011.7333%201.27268%2011.7333%201.60516V10.5282C11.7333%2010.8607%2011.6156%2011.1446%2011.3801%2011.3801C11.1446%2011.6156%2010.8606%2011.7333%2010.5282%2011.7333H1.60513ZM3.39998%2010.7333V1.40001H1.60513C1.55384%201.40001%201.50682%201.42138%201.46408%201.46411C1.42134%201.50685%201.39998%201.55387%201.39998%201.60516V10.5282C1.39998%2010.5795%201.42134%2010.6265%201.46408%2010.6692C1.50682%2010.712%201.55384%2010.7333%201.60513%2010.7333H3.39998ZM4.39996%2010.7333H10.5282C10.5794%2010.7333%2010.6265%2010.712%2010.6692%2010.6692C10.7119%2010.6265%2010.7333%2010.5795%2010.7333%2010.5282V1.60516C10.7333%201.55387%2010.7119%201.50685%2010.6692%201.46411C10.6265%201.42138%2010.5794%201.40001%2010.5282%201.40001H4.39996V10.7333Z'%20fill='white'/%3e%3c/svg%3e", L3e = "data:image/svg+xml,%3csvg%20width='12'%20height='12'%20viewBox='0%200%2012%2012'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.76534%208.45768V3.67567L6.36793%206.06668L8.76534%208.45768ZM1.60513%2011.7333C1.27265%2011.7333%200.988677%2011.6156%200.75321%2011.3801C0.517733%2011.1446%200.399994%2010.8607%200.399994%2010.5282V1.60516C0.399994%201.27268%200.517733%200.988708%200.75321%200.753241C0.988677%200.517763%201.27265%200.400024%201.60513%200.400024H10.5282C10.8606%200.400024%2011.1446%200.517763%2011.3801%200.753241C11.6156%200.988708%2011.7333%201.27268%2011.7333%201.60516V10.5282C11.7333%2010.8607%2011.6156%2011.1446%2011.3801%2011.3801C11.1446%2011.6156%2010.8606%2011.7333%2010.5282%2011.7333H1.60513ZM3.39998%2010.7333V1.40001H1.60513C1.55384%201.40001%201.50682%201.42138%201.46408%201.46411C1.42134%201.50685%201.39998%201.55387%201.39998%201.60516V10.5282C1.39998%2010.5795%201.42134%2010.6265%201.46408%2010.6692C1.50682%2010.712%201.55384%2010.7333%201.60513%2010.7333H3.39998ZM4.39996%2010.7333H10.5282C10.5794%2010.7333%2010.6265%2010.712%2010.6692%2010.6692C10.7119%2010.6265%2010.7333%2010.5795%2010.7333%2010.5282V1.60516C10.7333%201.55387%2010.7119%201.50685%2010.6692%201.46411C10.6265%201.42138%2010.5794%201.40001%2010.5282%201.40001H4.39996V10.7333Z'%20fill='white'/%3e%3c/svg%3e", Fye = (e) => {
  const [t, n] = Ae(!1), [o, r] = Ae(() => {
    const c = /* @__PURE__ */ new Map();
    return e.links.forEach((d, u) => {
      const p = e.isCurrent(d.link);
      c.set(u, p);
    }), c;
  }), i = (c) => {
    r((d) => {
      const u = new Map(d);
      return u.set(c, !d.get(c)), u;
    });
  }, { t: s } = ja(), a = () => {
    n((c) => (e.handleIsOpen(!c), !c));
  };
  return /* @__PURE__ */ f.jsx(
    J,
    {
      sx: {
        background: "linear-gradient(180deg, #484945 0%, #2A2B27 100%)",
        // backgroundColor: "black",
        width: t ? "280px" : "80px",
        height: "100vh",
        transition: "width 0.3s ease"
      },
      children: /* @__PURE__ */ f.jsxs(
        be,
        {
          direction: "column",
          justifyContent: "space-between",
          useFlexGap: !0,
          sx: { height: "100vh", paddingBottom: "44px" },
          children: [
            /* @__PURE__ */ f.jsxs("div", { children: [
              /* @__PURE__ */ f.jsx(V3e, { ...e, isOpen: t }),
              /* @__PURE__ */ f.jsx("div", { style: { borderTop: "1px solid", marginBottom: "12px", borderColor: Ee[2700] } }),
              /* @__PURE__ */ f.jsx(be, { direction: "column", gap: "12px", useFlexGap: !0, sx: { marginTop: "0px" }, children: e.links.map((c, d) => /* @__PURE__ */ f.jsxs(Nt.Fragment, { children: [
                /* @__PURE__ */ f.jsx(
                  w5,
                  {
                    ...c,
                    isSubmenu: !1,
                    isOpen: t,
                    onClick: () => i(d),
                    navigate: e.navigate,
                    isCurrent: e.isCurrent,
                    isSubMenuOpen: o.get(d)
                  }
                ),
                o.get(d) && c.sublinks && t && /* @__PURE__ */ f.jsx(
                  j3e,
                  {
                    sublinks: c.sublinks,
                    navigate: e.navigate,
                    isCurrent: e.isCurrent
                  }
                )
              ] }, d)) })
            ] }),
            /* @__PURE__ */ f.jsxs("div", { style: { display: "flex", flexDirection: "column" }, children: [
              e.settingsRoute && /* @__PURE__ */ f.jsx(
                w5,
                {
                  isSubmenu: !1,
                  icon: /* @__PURE__ */ f.jsx(xK, {}),
                  label: e.settingsText,
                  link: e.settingsRoute,
                  isOpen: t,
                  navigate: e.navigate,
                  isCurrent: e.isCurrent
                }
              ),
              /* @__PURE__ */ f.jsxs(
                J,
                {
                  sx: {
                    width: "100%",
                    overflow: "hidden"
                  },
                  children: [
                    /* @__PURE__ */ f.jsx("div", { style: { borderTop: "1px solid", marginTop: "12px", borderColor: Ee[2700] } }),
                    /* @__PURE__ */ f.jsxs(
                      Bt,
                      {
                        sx: {
                          marginLeft: "20px",
                          width: "fit-content",
                          height: "40px",
                          gap: "8px"
                        },
                        onClick: a,
                        children: [
                          /* @__PURE__ */ f.jsx(
                            "img",
                            {
                              src: t ? L3e : P3e,
                              alt: "Icon",
                              style: { width: "24px", height: "24px" }
                            }
                          ),
                          t && /* @__PURE__ */ f.jsx(
                            oe,
                            {
                              variant: "body",
                              sx: {
                                color: Ee[100],
                                overflow: "hidden",
                                width: "fit-content",
                                whiteSpace: "nowrap",
                                "&:hover": {
                                  color: Ee[1e3],
                                  cursor: "pointer"
                                }
                              },
                              children: s("Réduire la barre de navigation")
                            }
                          )
                        ]
                      }
                    ),
                    /* @__PURE__ */ f.jsx(
                      "div",
                      {
                        style: { borderTop: "1px solid", marginBottom: "12px", borderColor: Ee[2700] }
                      }
                    ),
                    /* @__PURE__ */ f.jsx(D3e, { ...e, isOpen: t })
                  ]
                }
              )
            ] })
          ]
        }
      )
    }
  );
};
function I3e(e) {
  return e == null ? void 0 : e.firstname.charAt(0).concat(" ").concat(e == null ? void 0 : e.lastname.charAt(0));
}
const w5 = (e) => {
  const t = e.isCurrent(e.link), n = e.isSubmenu ? t ? "selected-submenu" : "default-menu" : t ? "selected-menu" : "default-menu";
  return /* @__PURE__ */ f.jsxs(
    c2,
    {
      style: {
        display: "flex",
        overflow: "hidden",
        paddingLeft: "20px",
        paddingRight: "20px"
      },
      children: [
        /* @__PURE__ */ f.jsxs(
          at,
          {
            variant: n,
            "aria-label": "link",
            sx: {
              flex: 1,
              justifyContent: "flex-start",
              height: "40px",
              minWidth: "0px",
              gap: "8px",
              padding: "8px"
            },
            onClick: () => e.navigate(e.link),
            children: [
              e.icon,
              e.isOpen && e.label
            ]
          }
        ),
        e.isOpen && e.sublinks && /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx(
          at,
          {
            variant: n,
            "aria-label": "link",
            sx: {
              height: "40px",
              minWidth: "0px",
              "&:hover": {
                cursor: "pointer"
              }
            },
            onClick: e.onClick,
            children: e.isSubMenuOpen ? /* @__PURE__ */ f.jsx(t8, {}) : /* @__PURE__ */ f.jsx(Qh, {})
          }
        ) })
      ]
    }
  );
}, j3e = (e) => {
  const { sublinks: t, navigate: n, isCurrent: o } = e;
  return /* @__PURE__ */ f.jsx(
    J,
    {
      sx: {
        paddingLeft: "30px"
      },
      children: t == null ? void 0 : t.map((r, i) => /* @__PURE__ */ Yl(
        w5,
        {
          ...r,
          isSubmenu: !0,
          key: i,
          isOpen: !0,
          navigate: n,
          isCurrent: o
        }
      ))
    }
  );
}, V3e = (e) => {
  var t, n, o, r;
  return /* @__PURE__ */ f.jsxs(
    J,
    {
      sx: {
        width: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
      },
      children: [
        /* @__PURE__ */ f.jsx(
          l2,
          {
            alt: "app-logo",
            src: ((t = e.organization) == null ? void 0 : t.picture) || "",
            sx: {
              marginTop: "40px",
              marginBottom: "40px",
              marginLeft: "16px",
              marginRight: "16px",
              width: "48px",
              height: "48px"
            },
            children: ((n = e.organization) == null ? void 0 : n.picture) ?? /* @__PURE__ */ f.jsx(f.Fragment, { children: (o = e.organization) == null ? void 0 : o.name.charAt(0) })
          }
        ),
        e.isOpen && /* @__PURE__ */ f.jsx(
          oe,
          {
            variant: "body-bold",
            sx: {
              color: Ee[100],
              overflow: "hidden",
              width: "fit-content",
              whiteSpace: "nowrap"
            },
            children: (r = e.organization) == null ? void 0 : r.name
          }
        )
      ]
    }
  );
};
function D3e(e) {
  var a, c, d, u;
  const [t, n] = Ae(null), i = {
    ...e,
    isUserPopoverOpen: !!t,
    anchor: t,
    onClose: () => n(null)
  }, { t: s } = ja();
  return /* @__PURE__ */ f.jsxs(
    J,
    {
      sx: {
        width: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
      },
      children: [
        /* @__PURE__ */ f.jsx(ln, { title: s("Gérer votre profil"), children: /* @__PURE__ */ f.jsxs(
          at,
          {
            onClick: (p) => {
              n(p.currentTarget);
            },
            children: [
              /* @__PURE__ */ f.jsx(
                l2,
                {
                  alt: "profile-picture",
                  src: ((a = e.connectedUser) == null ? void 0 : a.picture) || "",
                  sx: {
                    margin: "0px 20px",
                    width: "40px",
                    height: "40px"
                  },
                  children: ((c = e.connectedUser) == null ? void 0 : c.picture) ?? I3e(e.connectedUser)
                }
              ),
              e.isOpen && /* @__PURE__ */ f.jsxs(
                oe,
                {
                  variant: "body-bold",
                  sx: {
                    color: Ee[100],
                    overflow: "hidden",
                    width: "fit-content",
                    whiteSpace: "nowrap"
                  },
                  children: [
                    (d = e.connectedUser) == null ? void 0 : d.firstname,
                    " ",
                    (u = e.connectedUser) == null ? void 0 : u.lastname
                  ]
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ f.jsx(A3e, { ...i })
      ]
    }
  );
}
const A3e = (e) => {
  const { anchor: t, isUserPopoverOpen: n, onClose: o, userActions: r } = { ...e };
  return /* @__PURE__ */ f.jsx(
    g7,
    {
      variant: "headless",
      anchor: t,
      open: n,
      onClose: o,
      sx: { marginLeft: e.isOpen ? "300px" : "90px" },
      children: /* @__PURE__ */ f.jsx(H3e, { userActions: r })
    }
  );
}, H3e = ({ userActions: e }) => {
  const { t } = ja();
  return /* @__PURE__ */ f.jsx(J, { sx: { display: "flex", width: "280px", flexDirection: "column", margin: "5px auto" }, children: e.map((n) => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    n.separator && /* @__PURE__ */ f.jsx("hr", { style: { width: "100%" } }),
    /* @__PURE__ */ f.jsx(J, { sx: { padding: "5px 24px" }, children: /* @__PURE__ */ f.jsx(at, { ...n, children: t(n.label) }) })
  ] })) });
}, F3e = (e) => {
  const t = ge(), { anchor: n, isPopoverOpen: o, onClose: r, userActions: i, isExpanded: s, textOptions: a, logout: c } = e;
  return /* @__PURE__ */ f.jsx(
    g7,
    {
      variant: "headless",
      anchor: n,
      open: o,
      onClose: r,
      sx: {
        marginLeft: s ? "300px" : "90px"
      },
      children: /* @__PURE__ */ f.jsxs(J, { sx: {
        display: "flex",
        width: "fit-content",
        flexDirection: "column",
        margin: "5px auto"
      }, children: [
        i.map((d, u) => /* @__PURE__ */ f.jsx(J, { sx: { padding: "5px 24px" }, children: d }, u)),
        i && i.length > 0 && // Only display the separator if at least one userAction is provided
        /* @__PURE__ */ f.jsx("hr", { style: { width: "100%", border: "1px solid #E7E6E4" } }),
        /* @__PURE__ */ f.jsx(J, { sx: { padding: "5px 24px" }, children: /* @__PURE__ */ f.jsx(
          at,
          {
            variant: "text",
            startIcon: /* @__PURE__ */ f.jsx(mK, {}),
            onClick: c,
            sx: {
              color: t.palette.primary[700],
              "&:hover": {
                color: t.palette.primary[500]
              }
            },
            children: /* @__PURE__ */ f.jsx(oe, { variant: "body-bold", sx: { color: "inherit" }, children: a.logout })
          }
        ) })
      ] })
    }
  );
}, N3e = (e) => e.firstname.charAt(0).concat(" ").concat(e.lastname.charAt(0)), $3e = (e) => {
  const { user: t, userActions: n, isExpanded: o, textOptions: r, logout: i } = e, s = ge(), [a, c] = Ae(null), d = !!a, u = () => c(null);
  return /* @__PURE__ */ f.jsxs(J, { sx: {
    height: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    color: s.custom.grey[100]
  }, children: [
    /* @__PURE__ */ f.jsxs(
      at,
      {
        fullWidth: !0,
        sx: {
          "&:hover": {
            textDecoration: "none"
          },
          color: s.custom.grey[100],
          justifyContent: o ? "space-between" : "center"
        },
        onClick: (p) => c(p.currentTarget),
        children: [
          /* @__PURE__ */ f.jsxs(J, { sx: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "16px"
          }, children: [
            /* @__PURE__ */ f.jsx(
              l2,
              {
                alt: "profile-picture",
                src: t.picture || "",
                children: t.picture ?? N3e(t)
              }
            ),
            o && /* @__PURE__ */ f.jsxs(
              oe,
              {
                variant: "body-bold",
                sx: {
                  color: s.custom.grey[100],
                  overflow: "hidden",
                  width: "fit-content",
                  whiteSpace: "nowrap"
                },
                children: [
                  t.firstname,
                  " ",
                  t.lastname
                ]
              }
            )
          ] }),
          o && /* @__PURE__ */ f.jsx(_t, { size: 2, icon: "actions" })
        ]
      }
    ),
    /* @__PURE__ */ f.jsx(
      F3e,
      {
        isExpanded: o,
        userActions: n,
        isPopoverOpen: d,
        anchor: a,
        onClose: u,
        logout: i,
        textOptions: r
      }
    )
  ] });
}, LE = (e) => {
  const { button: t, isExpanded: n } = e, o = t.isSelected ? "selected-submenu" : "default-menu";
  return /* @__PURE__ */ f.jsx(
    c2,
    {
      style: {
        display: "flex",
        justifyContent: "center"
      },
      children: /* @__PURE__ */ f.jsxs(
        at,
        {
          variant: o,
          "aria-label": "link",
          sx: n ? {
            flex: 1,
            justifyContent: "flex-start",
            gap: "8px",
            padding: "8px"
          } : {},
          onClick: t.action,
          disabled: t.disabled,
          children: [
            t.icon,
            n && t.label
          ]
        }
      )
    }
  );
}, B3e = B(({ className: e, ...t }) => /* @__PURE__ */ f.jsx(ln, { ...t, arrow: !0, classes: { popper: e } })), z3e = B3e((e) => ({
  [`& .${Io.arrow}`]: {
    color: "#FFF"
  },
  [`& .${Io.tooltip}`]: {
    padding: "12px 16px 12px 16px",
    borderRadius: "8px",
    backgroundColor: "#FFF"
  }
})), Z3e = (e) => {
  const { button: t, isExpanded: n } = e;
  return n === !0 ? /* @__PURE__ */ f.jsx(U3e, { button: t }) : /* @__PURE__ */ f.jsx(W3e, { button: t });
}, W3e = (e) => {
  const { button: t } = e, n = t.isSelected ? "selected-menu" : "default-menu";
  return /* @__PURE__ */ f.jsx(
    z3e,
    {
      title: /* @__PURE__ */ f.jsx(oe, { variant: "body-bold", children: t.label }),
      placement: "right",
      children: /* @__PURE__ */ f.jsx(
        c2,
        {
          style: {
            display: "flex",
            justifyContent: "center"
          },
          children: /* @__PURE__ */ f.jsx(
            at,
            {
              variant: n,
              "aria-label": "link",
              onClick: t.action,
              disabled: t.disabled,
              children: t.icon
            }
          )
        }
      )
    }
  );
}, U3e = (e) => {
  const { button: t } = e, n = t.isSelected ? "selected-menu" : "default-menu";
  return /* @__PURE__ */ f.jsx(
    c2,
    {
      style: {
        display: "flex",
        overflow: "hidden"
      },
      children: /* @__PURE__ */ f.jsxs(
        at,
        {
          variant: n,
          "aria-label": "link",
          sx: {
            flex: 1,
            justifyContent: "flex-start",
            gap: "8px",
            paddingLeft: "8px"
          },
          onClick: t.action,
          disabled: t.disabled,
          children: [
            t.icon,
            t.label
          ]
        }
      )
    }
  );
}, G3e = (e) => {
  const t = ge(), { button: n, isExpanded: o, extendSidebar: r } = e, i = n.items.some((u) => u.isSelected), [s, a] = Ae(i), c = s ? /* @__PURE__ */ f.jsx(_t, { icon: "arrowUpShort", size: 2 }) : /* @__PURE__ */ f.jsx(_t, { icon: "arrowDownShort", size: 2 }), d = i ? "selected-menu" : "default-menu";
  return /* @__PURE__ */ f.jsxs(ws, { children: [
    /* @__PURE__ */ f.jsx(
      c2,
      {
        style: {
          display: "flex",
          justifyContent: "center"
        },
        children: /* @__PURE__ */ f.jsxs(
          at,
          {
            variant: d,
            "aria-label": "link",
            sx: o ? {
              flex: 1,
              gap: "8px",
              padding: "8px"
            } : {},
            onClick: () => {
              if (o) return a(!s);
              r(), s || a(!0);
            },
            children: [
              /* @__PURE__ */ f.jsxs(
                J,
                {
                  sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: o ? "none" : "center",
                    gap: ".5rem",
                    width: "100%"
                  },
                  children: [
                    n.icon,
                    o && /* @__PURE__ */ f.jsx(
                      oe,
                      {
                        sx: {
                          color: t.custom.grey[100],
                          flexWrap: "nowrap"
                        },
                        variant: "body-bold",
                        children: n.label
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ f.jsx(
                J,
                {
                  sx: {
                    display: "flex",
                    alignItems: "center"
                  },
                  children: o && c
                }
              )
            ]
          }
        )
      }
    ),
    o && s && /* @__PURE__ */ f.jsx(J, { sx: { paddingLeft: "30px" }, children: n.items.map((u, p) => /* @__PURE__ */ f.jsx(LE, { button: u, isExpanded: o }, p)) })
  ] });
}, q3e = (e) => {
  const { buttons: t, isExpanded: n, extendSidebar: o } = e;
  return /* @__PURE__ */ f.jsx(
    J,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        gap: "4px"
      },
      children: t.map((r, i) => r.type === "drawer" ? /* @__PURE__ */ f.jsx(
        G3e,
        {
          button: r,
          isExpanded: n,
          extendSidebar: o
        },
        i
      ) : r.type === "topLink" ? /* @__PURE__ */ f.jsx(Z3e, { button: r, isExpanded: n }, i) : /* @__PURE__ */ f.jsx(LE, { button: r, isExpanded: n }, i))
    }
  );
}, K3e = (e) => {
  const { children: t, anchor: n, setAnchor: o, paperOverrides: r } = e, i = ge(), s = !!n;
  return /* @__PURE__ */ f.jsx(
    Ar,
    {
      open: s,
      anchorEl: n,
      onClose: () => o(null),
      anchorOrigin: {
        vertical: "center",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "center",
        horizontal: "left"
      },
      slotProps: {
        paper: {
          sx: {
            padding: "24px 20px",
            borderRadius: "12px",
            boxShadow: "0px 4px 20px 0px rgba(81, 78, 78, 0.12)",
            border: `1px solid ${i.custom.grey[500]}`,
            ...r
          }
        }
      },
      sx: {
        marginLeft: "10px"
      },
      children: t
    }
  );
}, Y3e = (e) => {
  const { isExtended: t, name: n, picture: o, popover: r } = e, i = ge(), [s, a] = Ae(null);
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs(
      J,
      {
        sx: {
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: t ? "space-between" : "center",
          color: i.custom.grey[100]
        },
        onClick: (c) => {
          r !== void 0 && a(c.currentTarget);
        },
        children: [
          /* @__PURE__ */ f.jsxs(J, { sx: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "16px"
          }, children: [
            /* @__PURE__ */ f.jsx(
              l2,
              {
                alt: "app-logo",
                src: o || "",
                sx: {
                  width: "48px",
                  height: "48px"
                },
                children: o ?? n.charAt(0)
              }
            ),
            t && /* @__PURE__ */ f.jsx(
              oe,
              {
                variant: "body-bold",
                sx: {
                  color: i.custom.grey[100],
                  overflow: "hidden",
                  width: "fit-content",
                  whiteSpace: "nowrap"
                },
                children: n
              }
            )
          ] }),
          t && /* @__PURE__ */ f.jsx(_t, { size: 2, icon: "actions" })
        ]
      }
    ),
    /* @__PURE__ */ f.jsx(
      K3e,
      {
        anchor: s,
        setAnchor: a,
        children: r == null ? void 0 : r.element,
        paperOverrides: r == null ? void 0 : r.paperSx
      }
    )
  ] });
}, X3e = (e) => {
  const t = ge(), { isExpanded: n, toggleSidebar: o, textOptions: r } = e, i = n ? {
    justifyContent: "space-between"
  } : {
    justifyContent: "center"
  };
  return /* @__PURE__ */ f.jsxs(
    J,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "32px",
        ...i,
        borderBlock: "1px solid",
        borderColor: t.custom.grey[2700],
        "& > *": {
          color: t.custom.grey[100]
        },
        "&:hover > *": {
          cursor: "pointer",
          color: t.custom.grey[1e3]
        }
      },
      onClick: o,
      children: [
        !n && /* @__PURE__ */ f.jsx(_t, { size: 1, icon: "openPanel" }),
        n && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          /* @__PURE__ */ f.jsx(
            oe,
            {
              variant: "small-bold",
              sx: {
                color: t.custom.grey[100],
                overflow: "hidden",
                width: "fit-content",
                whiteSpace: "nowrap"
              },
              children: r.shortenSidebar
            }
          ),
          /* @__PURE__ */ f.jsx(_t, { size: 1, icon: "closePanel" })
        ] })
      ]
    }
  );
}, Nye = (e) => {
  const t = ge(), {
    buttons: n,
    connectedUser: o,
    organization: r,
    sidebarTexts: i,
    sidebarOptions: s = {},
    userActions: a,
    logoutAction: c,
    sidebarStatusHandler: d
  } = e, {
    isExpanded: u = !1,
    notExpandedSize: p = "80px",
    expandedSize: h = "280px"
  } = s, [g, m] = Ae(u);
  return mt(() => {
    d(g);
  }, [g, d]), /* @__PURE__ */ f.jsx(
    J,
    {
      sx: {
        background: "linear-gradient(180deg, #484945 0%, #2A2B27 100%)",
        width: g ? h : p,
        height: "100%",
        transition: "width 0.3s ease",
        position: "relative",
        "&:after": {
          width: "30px",
          height: "30px",
          content: '""',
          background: `radial-gradient(transparent 15px, ${t.custom.grey[2600]} 16px)`,
          clipPath: "inset(0 15px 15px 0)",
          position: "absolute",
          top: 0,
          left: g ? h : p,
          transition: "left .3s ease",
          zIndex: 1
        }
      },
      children: /* @__PURE__ */ f.jsxs(J, { sx: {
        overflow: "hidden",
        display: "grid",
        gridTemplateRows: "80px 1fr 36px 80px",
        minHeight: "100vh",
        height: "100%",
        width: "100%",
        "& > * > *": g ? {
          // This is used to apply a space on the sides
          // Without affecting the borders
          // It's applied everywhere, so that it's not repeated in the children
          paddingLeft: "20px",
          paddingRight: "20px"
        } : {}
      }, children: [
        /* @__PURE__ */ f.jsx(J, { sx: {
          gridRow: "1",
          borderBottom: `1px solid ${t.custom.grey[2300]}`
        }, children: /* @__PURE__ */ f.jsx(
          Y3e,
          {
            name: `${r.name}`,
            picture: r.picture,
            popover: r.popover,
            isExtended: g
          }
        ) }),
        /* @__PURE__ */ f.jsx(J, { sx: {
          gridRow: "2",
          paddingTop: "16px"
        }, children: /* @__PURE__ */ f.jsx(
          q3e,
          {
            buttons: n,
            isExpanded: g,
            extendSidebar: () => m(!0)
          }
        ) }),
        /* @__PURE__ */ f.jsx(J, { sx: {
          gridRow: "3",
          backgroundColor: t.custom.grey[3e3]
        }, children: /* @__PURE__ */ f.jsx(
          X3e,
          {
            isExpanded: g,
            toggleSidebar: () => m(!g),
            textOptions: i
          }
        ) }),
        /* @__PURE__ */ f.jsx(J, { sx: {
          gridRow: "4",
          backgroundColor: t.custom.grey[3e3]
        }, children: /* @__PURE__ */ f.jsx(
          $3e,
          {
            user: o,
            userActions: a,
            isExpanded: g,
            textOptions: i,
            logout: c
          }
        ) })
      ] })
    }
  );
}, $ye = (e) => {
  const t = ge(), { icon: n, action: o, label: r } = e;
  return /* @__PURE__ */ f.jsx(
    at,
    {
      variant: "text",
      startIcon: n,
      onClick: o,
      sx: {
        color: t.custom.grey[2800]
      },
      children: /* @__PURE__ */ f.jsx(oe, { variant: "body-bold", children: r })
    }
  );
};
var n8 = {}, J3e = ht;
Object.defineProperty(n8, "__esModule", {
  value: !0
});
var IE = n8.default = void 0, Q3e = J3e(bt()), efe = f;
IE = n8.default = (0, Q3e.default)(/* @__PURE__ */ (0, efe.jsx)("path", {
  d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), "ArrowForward");
const Bye = (e) => /* @__PURE__ */ f.jsx(J, { sx: { minWidth: 205 }, children: /* @__PURE__ */ f.jsxs(W4, { variant: "outlined", style: { borderRadius: "10px" }, children: [
  /* @__PURE__ */ f.jsxs(
    U4,
    {
      style: {
        textAlign: "left",
        marginLeft: "0.5rem",
        marginRight: "0.5rem"
      },
      children: [
        e.heading.contentUrl && /* @__PURE__ */ f.jsx("img", { src: e.heading.contentUrl, width: "30", alt: "icon-ssq" }),
        /* @__PURE__ */ f.jsx("div", { style: { minHeight: "100px", marginTop: "0.5rem" }, children: /* @__PURE__ */ f.jsx(oe, { variant: "subtitle2", component: "div", style: { fontWeight: "bold" }, children: e.heading.title }) }),
        /* @__PURE__ */ f.jsx(oe, { variant: "caption", component: "div", children: e.progress.label }),
        /* @__PURE__ */ f.jsx(J, { children: /* @__PURE__ */ f.jsx(_3e, { value: e.progress.value }) })
      ]
    }
  ),
  /* @__PURE__ */ f.jsx(
    ow,
    {
      style: {
        textAlign: "left",
        marginLeft: "0.5rem",
        marginRight: "0.5rem"
      },
      children: /* @__PURE__ */ f.jsxs(J, { sx: { color: "#AA062B" }, children: [
        /* @__PURE__ */ f.jsx(
          at,
          {
            variant: "text",
            size: "small",
            color: "inherit",
            style: { textTransform: "initial", fontWeight: "bold" },
            component: e.link.component,
            to: e.link.to,
            children: e.link.label
          }
        ),
        /* @__PURE__ */ f.jsx(IE, { color: "inherit", style: { verticalAlign: "middle" } })
      ] })
    }
  )
] }) }), zye = (e) => {
  const { choices: t, onClick: n, defaultIndex: o, ...r } = e, [i, s] = Ae(o ?? 0);
  return /* @__PURE__ */ f.jsx(
    be,
    {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: "8px",
      children: t.map((a, c) => /* @__PURE__ */ Yl(
        Nw,
        {
          ...r,
          key: `${c}-button-tab`,
          value: c,
          onClick: () => {
            n == null || n(c), s(c);
          },
          selected: c === i,
          sx: {
            borderRadius: "8px",
            padding: "12px 16px",
            textTransform: "none"
          }
        },
        /* @__PURE__ */ f.jsx(oe, { variant: "h5", color: "inherit", children: a })
      ))
    }
  );
}, Zye = (e) => {
  const { tabs: t, value: n, renderComponents: o, ...r } = e, [i, s] = Ae(0), a = ge(), c = (d, u) => {
    s(u);
  };
  return mt(() => {
    s(n ?? 0);
  }, [n]), /* @__PURE__ */ f.jsxs(J, { sx: { width: "100%" }, ...r, children: [
    /* @__PURE__ */ f.jsx(J, { children: /* @__PURE__ */ f.jsx(
      L3,
      {
        TabIndicatorProps: {
          sx: {
            backgroundColor: a.palette.primary[600],
            color: a.palette.primary[600]
          }
        },
        value: i,
        onChange: c,
        "aria-label": "section-tabs",
        children: t.map((d, u) => /* @__PURE__ */ f.jsx(ln, { title: d.tooltip || "", arrow: !0, children: /* @__PURE__ */ f.jsx(
          Nc,
          {
            icon: /* @__PURE__ */ f.jsx(
              J,
              {
                sx: {
                  ...u === i && { fill: a.palette.primary[600] }
                },
                children: d == null ? void 0 : d.icon
              }
            ),
            label: /* @__PURE__ */ f.jsx(
              oe,
              {
                variant: "h4",
                sx: {
                  textTransform: "none",
                  ...u === i && {
                    color: a.palette.primary[600]
                  }
                },
                children: d.name
              }
            ),
            disabled: d.disabled,
            sx: {
              opacity: d.disabled ? 0.36 : 1
            },
            onClick: () => {
              d.onClick && d.onClick();
            },
            iconPosition: "start",
            ...nfe(u)
          }
        ) }, u))
      }
    ) }),
    o && (t == null ? void 0 : t.map((d, u) => /* @__PURE__ */ f.jsx(tfe, { value: i, index: u, children: d.component }, u)))
  ] });
}, tfe = (e) => {
  const { children: t, value: n, index: o, ...r } = e;
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      role: "tabpanel",
      hidden: n !== o,
      id: `tabpanel-${o}`,
      "aria-labelledby": `tab-${o}`,
      ...r,
      children: n === o && /* @__PURE__ */ f.jsx(J, { sx: { padding: 3 }, children: t })
    }
  );
}, nfe = (e) => ({
  id: `tab-${e}`,
  "aria-controls": `tabpanel-${e}`
}), ofe = B(J)(({ theme: e }) => () => ({
  "&.secondary-tabs-wrapper": {
    width: "100%",
    border: `1px solid ${Ee[500]}`,
    borderRadius: "12px",
    "& > .secondary-tabs": {
      borderTopLeftRadius: "12px",
      borderTopRightRadius: "12px",
      "& .MuiTabs-indicator": {
        backgroundColor: e.palette.background.paper
      },
      "& .MuiButtonBase-root": {
        fontWeight: e.typography.fontWeightBold,
        borderRadius: 0,
        background: Ee[200],
        textTransform: "unset",
        borderRight: `1px solid ${Ee[500]}`,
        display: "flex",
        flexDirection: "row",
        "& > svg": {
          marginRight: "0.5rem"
        }
      },
      "& .MuiButtonBase-root::after": {
        content: '" "',
        background: Ee[500],
        bottom: 0,
        left: 0,
        right: 0,
        width: "100%",
        height: "1px",
        position: "absolute",
        zIndex: 10
      },
      "& .MuiButtonBase-root.Mui-selected": {
        color: e.palette.primary[600],
        background: e.palette.background.paper
      },
      "& .MuiButtonBase-root.Mui-selected::after": {
        background: e.palette.background.paper
      },
      "& .MuiTabs-flexContainer": {
        background: Ee[200]
      },
      "& .MuiTabs-flexContainer::after": {
        content: '" "',
        background: Ee[500],
        bottom: 0,
        left: 0,
        right: 0,
        width: "100%",
        height: "1px",
        position: "absolute"
      }
    },
    "& .secondary-tabs-content": {
      borderBottomLeftRadius: "12px",
      borderBottomRightRadius: "12px",
      padding: "1.5rem",
      backgroundColor: e.palette.background.paper
    }
  }
})), rfe = ({ children: e, value: t, index: n }) => /* @__PURE__ */ f.jsx(J, { role: "tabpanel", hidden: t !== n, className: "secondary-tabs-tabpanel", children: t === n && /* @__PURE__ */ f.jsx(J, { children: e }) }), Wye = ({ tabs: e, selectedTab: t, boxProps: n }) => {
  const o = () => e.findIndex((r) => t(r));
  return /* @__PURE__ */ f.jsxs(ofe, { ...n, className: "secondary-tabs-wrapper", children: [
    /* @__PURE__ */ f.jsx(
      L3,
      {
        TabIndicatorProps: { hidden: !0 },
        value: o(),
        className: "secondary-tabs",
        children: e.map((r, i) => /* @__PURE__ */ f.jsx(Nc, { label: r.name, disabled: r.disabled, icon: r.icon, onClick: r.onClick }, i))
      }
    ),
    /* @__PURE__ */ f.jsx(J, { className: "secondary-tabs-content", children: e.map((r, i) => /* @__PURE__ */ f.jsx(rfe, { value: o(), index: i, children: r.component }, i)) })
  ] });
}, ife = (e) => /* @__PURE__ */ y.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M8.41251 6.41666H2V5.58334H8.41251L5.4125 2.58333L6 2L10 6L6 10L5.4125 9.41668L8.41251 6.41666Z", fill: "#393A36" })), Uye = (e) => {
  const { texts: t } = e;
  if (t.length === 0)
    return null;
  const n = t.length - 1;
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
      },
      children: t.map((o, r) => /* @__PURE__ */ f.jsxs(ws, { children: [
        /* @__PURE__ */ f.jsx(oe, { variant: "body", children: o }),
        n !== r && /* @__PURE__ */ f.jsx("div", { style: { marginInline: "5px" }, children: /* @__PURE__ */ f.jsx(ife, {}) })
      ] }, `text-arrow-${Math.random()}`))
    }
  );
}, Gye = (e) => {
  const { title: t, titleSize: n, icon: o } = e, i = n || "h1";
  return /* @__PURE__ */ f.jsxs(
    oe,
    {
      variant: i,
      style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "5px"
      },
      children: [
        /* @__PURE__ */ f.jsx(
          "div",
          {
            style: {
              width: "40px",
              height: "40px",
              borderRadius: "25px",
              backgroundColor: Ee[400],
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            },
            children: o
          }
        ),
        t
      ]
    }
  );
}, qye = B((e) => {
  const t = ge(), { variant: n = "primary", content: o, disabled: r } = e;
  let i;
  switch (n) {
    case "primary":
      i = $C;
      break;
    case "secondary":
      i = sfe;
      break;
    case "tertiary":
      i = afe;
      break;
    case "disabled":
      i = lfe;
      break;
    default:
      i = $C;
  }
  return /* @__PURE__ */ f.jsx(i, { defaultValue: o, disabled: r, maxRows: 14, theme: t, ...e });
})({}), af = B($4)(({ theme: e }) => ({
  width: "100%",
  lineHeight: "22px",
  padding: "20px 24px 60px 24px",
  borderRadius: "12px",
  resize: "none",
  ...e.typography.body,
  color: Ee[2800],
  borderColor: Ee[500],
  "&:focus-visible": {
    outline: "0"
  }
})), $C = B(af)({
  backgroundColor: Ee[100]
}), sfe = B(af)({
  backgroundColor: Ee[300]
}), afe = B(af)({
  borderColor: Ee[2800],
  backgroundColor: Ee[100]
}), lfe = B(af)({
  color: Ee[2e3],
  backgroundColor: Ee[500]
});
function o8(e) {
  return jt;
}
const BC = /* @__PURE__ */ new Set();
function hu(e, t = "warning") {
  if (process.env.NODE_ENV === "production")
    return;
  const n = Array.isArray(e) ? e.join(`
`) : e;
  BC.has(n) || (BC.add(n), t === "error" ? console.error(n) : console.warn(n));
}
const cfe = (e, t) => {
  const n = y.useRef({}), [o, r] = y.useState(() => {
    const s = {};
    return e.forEach((a) => {
      a.models && Object.entries(a.models).forEach(([c, d]) => {
        n.current[c] = {
          isControlled: t[c] !== void 0,
          getDefaultValue: d.getDefaultValue
        }, s[c] = d.getDefaultValue(t);
      });
    }), s;
  }), i = Object.fromEntries(Object.entries(n.current).map(([s, a]) => {
    const c = t[s] ?? o[s];
    return [s, {
      value: c,
      setControlledValue: (d) => {
        a.isControlled || r((u) => T({}, u, {
          [s]: d
        }));
      }
    }];
  }));
  return process.env.NODE_ENV !== "production" && Object.entries(n.current).forEach(([s, a]) => {
    const c = t[s], d = a.getDefaultValue(t);
    y.useEffect(() => {
      a.isControlled !== (c !== void 0) && console.error([`MUI X: A component is changing the ${a.isControlled ? "" : "un"}controlled ${s} state of TreeView to be ${a.isControlled ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${s} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [c]);
    const {
      current: u
    } = y.useRef(d);
    y.useEffect(() => {
      !a.isControlled && u !== d && console.error([`MUI X: A component is changing the default ${s} state of an uncontrolled TreeView after being initialized. To suppress this warning opt to use a controlled TreeView.`].join(`
`));
    }, [JSON.stringify(d)]);
  }), i;
};
class dfe {
  constructor() {
    this.maxListeners = 20, this.warnOnce = !1, this.events = {};
  }
  on(t, n, o = {}) {
    let r = this.events[t];
    if (r || (r = {
      highPriority: /* @__PURE__ */ new Map(),
      regular: /* @__PURE__ */ new Map()
    }, this.events[t] = r), o.isFirst ? r.highPriority.set(n, !0) : r.regular.set(n, !0), process.env.NODE_ENV !== "production") {
      const i = r.highPriority.size + r.regular.size;
      i > this.maxListeners && !this.warnOnce && (this.warnOnce = !0, console.warn([`Possible EventEmitter memory leak detected. ${i} ${t} listeners added.`].join(`
`)));
    }
  }
  removeListener(t, n) {
    this.events[t] && (this.events[t].regular.delete(n), this.events[t].highPriority.delete(n));
  }
  removeAllListeners() {
    this.events = {};
  }
  emit(t, ...n) {
    const o = this.events[t];
    if (!o)
      return;
    const r = Array.from(o.highPriority.keys()), i = Array.from(o.regular.keys());
    for (let s = r.length - 1; s >= 0; s -= 1) {
      const a = r[s];
      o.highPriority.has(a) && a.apply(this, n);
    }
    for (let s = 0; s < i.length; s += 1) {
      const a = i[s];
      o.regular.has(a) && a.apply(this, n);
    }
  }
  once(t, n) {
    const o = this;
    this.on(t, function r(...i) {
      o.removeListener(t, r), n.apply(o, i);
    });
  }
}
const ufe = (e) => e.isPropagationStopped !== void 0, jE = () => {
  const [e] = y.useState(() => new dfe()), t = y.useCallback((...o) => {
    const [r, i, s = {}] = o;
    s.defaultMuiPrevented = !1, !(ufe(s) && s.isPropagationStopped()) && e.emit(r, i, s);
  }, [e]), n = y.useCallback((o, r) => (e.on(o, r), () => {
    e.removeListener(o, r);
  }), [e]);
  return {
    instance: {
      $$publishEvent: t,
      $$subscribeEvent: n
    }
  };
};
jE.params = {};
const VE = ({
  plugins: e
}) => {
  const t = new Set(e);
  return {
    instance: {
      getAvailablePlugins: () => t
    }
  };
};
VE.params = {};
let zC = 0;
const ffe = () => (zC += 1, `mui-tree-view-${zC}`), r8 = ({
  id: e,
  treeId: t = "",
  itemId: n
}) => e ?? `${t}-${n}`, i8 = ({
  params: e,
  state: t,
  setState: n
}) => {
  y.useEffect(() => {
    n((r) => r.id.treeId === e.id && r.id.treeId !== void 0 ? r : T({}, r, {
      id: T({}, r.id, {
        treeId: e.id ?? ffe()
      })
    }));
  }, [n, e.id]);
  const o = e.id ?? t.id.treeId;
  return {
    getRootProps: () => ({
      id: o
    }),
    contextValue: {
      treeId: o
    }
  };
};
i8.params = {
  id: !0
};
i8.getInitialState = ({
  id: e
}) => ({
  id: {
    treeId: e ?? void 0
  }
});
const pfe = [jE, VE, i8], hfe = ["slots", "slotProps", "apiRef", "experimentalFeatures"], gfe = (e) => {
  let {
    props: {
      slots: t,
      slotProps: n,
      apiRef: o,
      experimentalFeatures: r
    },
    plugins: i
  } = e, s = le(e.props, hfe);
  const a = {};
  i.forEach((h) => {
    Object.assign(a, h.params);
  });
  const c = {}, d = {};
  Object.keys(s).forEach((h) => {
    const g = s[h];
    a[h] ? c[h] = g : d[h] = g;
  });
  const u = r ?? {}, p = i.reduce((h, g) => g.getDefaultizedParams ? g.getDefaultizedParams({
    params: h,
    experimentalFeatures: u
  }) : h, c);
  return {
    apiRef: o,
    forwardedProps: d,
    pluginParams: p,
    slots: t ?? {},
    slotProps: n ?? {},
    experimentalFeatures: u
  };
}, mfe = ({
  plugins: e,
  instance: t,
  publicAPI: n,
  rootRef: o
}) => ({
  runItemPlugins: (a) => {
    let c = null, d = null;
    const u = [], p = {};
    e.forEach((m) => {
      if (!m.itemPlugin)
        return;
      const b = m.itemPlugin({
        props: a,
        rootRef: c,
        contentRef: d
      });
      b != null && b.rootRef && (c = b.rootRef), b != null && b.contentRef && (d = b.contentRef), b != null && b.propsEnhancers && (u.push(b.propsEnhancers), Object.keys(b.propsEnhancers).forEach((C) => {
        p[C] = !0;
      }));
    });
    const h = (m) => (b) => {
      const C = {};
      return u.forEach((x) => {
        const v = x[m];
        v != null && Object.assign(C, v(b));
      }), C;
    }, g = Object.fromEntries(Object.keys(p).map((m) => [m, h(m)]));
    return {
      contentRef: d,
      rootRef: c,
      propsEnhancers: g
    };
  },
  wrapItem: ({
    itemId: a,
    children: c
  }) => {
    let d = c;
    for (let u = e.length - 1; u >= 0; u -= 1) {
      const p = e[u];
      p.wrapItem && (d = p.wrapItem({
        itemId: a,
        children: d,
        instance: t
      }));
    }
    return d;
  },
  wrapRoot: ({
    children: a
  }) => {
    let c = a;
    for (let d = e.length - 1; d >= 0; d -= 1) {
      const u = e[d];
      u.wrapRoot && (c = u.wrapRoot({
        children: c,
        instance: t
      }));
    }
    return c;
  },
  instance: t,
  rootRef: o,
  publicAPI: n
});
function bfe(e) {
  const t = y.useRef({});
  return e ? (e.current == null && (e.current = {}), e.current) : t.current;
}
const Cfe = ({
  plugins: e,
  rootRef: t,
  props: n
}) => {
  const o = [...pfe, ...e], {
    pluginParams: r,
    forwardedProps: i,
    apiRef: s,
    experimentalFeatures: a,
    slots: c,
    slotProps: d
  } = gfe({
    plugins: o,
    props: n
  }), u = cfe(o, r), h = y.useRef({}).current, g = bfe(s), m = y.useRef(null), b = Tt(m, t), C = mfe({
    plugins: o,
    instance: h,
    publicAPI: g,
    rootRef: m
  }), [x, v] = y.useState(() => {
    const k = {};
    return o.forEach((E) => {
      E.getInitialState && Object.assign(k, E.getInitialState(r));
    }), k;
  }), S = [], M = (k) => {
    const E = k({
      instance: h,
      params: r,
      slots: c,
      slotProps: d,
      experimentalFeatures: a,
      state: x,
      setState: v,
      rootRef: m,
      models: u,
      plugins: o
    });
    E.getRootProps && S.push(E.getRootProps), E.publicAPI && Object.assign(g, E.publicAPI), E.instance && Object.assign(h, E.instance), E.contextValue && Object.assign(C, E.contextValue);
  };
  return o.forEach(M), {
    getRootProps: (k = {}) => {
      const E = T({
        role: "tree"
      }, i, k, {
        ref: b
      });
      return S.forEach((R) => {
        Object.assign(E, R(k));
      }), E;
    },
    rootRef: b,
    contextValue: C,
    instance: h
  };
}, s8 = /* @__PURE__ */ y.createContext(null);
process.env.NODE_ENV !== "production" && (s8.displayName = "TreeViewContext");
function xfe(e) {
  const {
    value: t,
    children: n
  } = e;
  return /* @__PURE__ */ f.jsx(s8.Provider, {
    value: t,
    children: t.wrapRoot({
      children: n,
      instance: t.instance
    })
  });
}
const $a = () => {
  const e = y.useContext(s8);
  if (e == null)
    throw new Error(["MUI X: Could not find the Tree View context.", "It looks like you rendered your component outside of a SimpleTreeView or RichTreeView parent component.", "This can also happen if you are bundling multiple versions of the Tree View."].join(`
`));
  return e;
}, yfe = (e, t, n) => {
  e.$$publishEvent(t, n);
}, pl = "__TREE_VIEW_ROOT_PARENT_ID__", vfe = (e) => {
  const t = {};
  return e.forEach((n, o) => {
    t[n] = o;
  }), t;
}, lf = /* @__PURE__ */ y.createContext(() => -1);
process.env.NODE_ENV !== "production" && (lf.displayName = "TreeViewItemDepthContext");
const wfe = ["children"], DE = ({
  items: e,
  isItemDisabled: t,
  getItemLabel: n,
  getItemId: o
}) => {
  const r = {}, i = {}, s = {
    [pl]: []
  }, a = (d, u, p) => {
    var b, C;
    const h = o ? o(d) : d.id;
    if (h == null)
      throw new Error(["MUI X: The Tree View component requires all items to have a unique `id` property.", "Alternatively, you can use the `getItemId` prop to specify a custom id for each item.", "An item was provided without id in the `items` prop:", JSON.stringify(d)].join(`
`));
    if (r[h] != null)
      throw new Error(["MUI X: The Tree View component requires all items to have a unique `id` property.", "Alternatively, you can use the `getItemId` prop to specify a custom id for each item.", `Two items were provided with the same id in the \`items\` prop: "${h}"`].join(`
`));
    const g = n ? n(d) : d.label;
    if (g == null)
      throw new Error(["MUI X: The Tree View component requires all items to have a `label` property.", "Alternatively, you can use the `getItemLabel` prop to specify a custom label for each item.", "An item was provided without label in the `items` prop:", JSON.stringify(d)].join(`
`));
    r[h] = {
      id: h,
      label: g,
      parentId: p,
      idAttribute: void 0,
      expandable: !!((b = d.children) != null && b.length),
      disabled: t ? t(d) : !1,
      depth: u
    }, i[h] = d;
    const m = p ?? pl;
    s[m] || (s[m] = []), s[m].push(h), (C = d.children) == null || C.forEach((x) => a(x, u + 1, h));
  };
  e.forEach((d) => a(d, 0, null));
  const c = {};
  return Object.keys(s).forEach((d) => {
    c[d] = vfe(s[d]);
  }), {
    itemMetaMap: r,
    itemMap: i,
    itemOrderedChildrenIds: s,
    itemChildrenIndexes: c
  };
}, q0 = ({
  instance: e,
  params: t,
  state: n,
  setState: o,
  experimentalFeatures: r
}) => {
  const i = y.useCallback((x) => n.items.itemMetaMap[x], [n.items.itemMetaMap]), s = y.useCallback((x) => n.items.itemMap[x], [n.items.itemMap]), a = y.useCallback(() => {
    const x = (v) => {
      const S = n.items.itemMap[v], M = le(S, wfe), w = n.items.itemOrderedChildrenIds[v];
      return w && (M.children = w.map(x)), M;
    };
    return n.items.itemOrderedChildrenIds[pl].map(x);
  }, [n.items.itemMap, n.items.itemOrderedChildrenIds]), c = y.useCallback((x) => {
    if (x == null)
      return !1;
    let v = e.getItemMeta(x);
    if (!v)
      return !1;
    if (v.disabled)
      return !0;
    for (; v.parentId != null; )
      if (v = e.getItemMeta(v.parentId), v.disabled)
        return !0;
    return !1;
  }, [e]), d = y.useCallback((x) => {
    const v = e.getItemMeta(x).parentId ?? pl;
    return n.items.itemChildrenIndexes[v][x];
  }, [e, n.items.itemChildrenIndexes]), u = y.useCallback((x) => n.items.itemOrderedChildrenIds[x ?? pl] ?? [], [n.items.itemOrderedChildrenIds]), p = (x) => {
    const v = e.getItemMeta(x);
    return v == null ? null : document.getElementById(r8({
      treeId: n.id.treeId,
      itemId: x,
      id: v.idAttribute
    }));
  }, h = (x) => t.disabledItemsFocusable ? !0 : !e.isItemDisabled(x), g = y.useRef(!1), m = y.useCallback(() => {
    g.current = !0;
  }, []), b = y.useCallback(() => g.current, []);
  return y.useEffect(() => {
    e.areItemUpdatesPrevented() || o((x) => {
      const v = DE({
        items: t.items,
        isItemDisabled: t.isItemDisabled,
        getItemId: t.getItemId,
        getItemLabel: t.getItemLabel
      });
      return Object.values(x.items.itemMetaMap).forEach((S) => {
        v.itemMetaMap[S.id] || yfe(e, "removeItem", {
          id: S.id
        });
      }), T({}, x, {
        items: v
      });
    });
  }, [e, o, t.items, t.isItemDisabled, t.getItemId, t.getItemLabel]), {
    getRootProps: () => ({
      style: {
        "--TreeView-itemChildrenIndentation": typeof t.itemChildrenIndentation == "number" ? `${t.itemChildrenIndentation}px` : t.itemChildrenIndentation
      }
    }),
    publicAPI: {
      getItem: s,
      getItemDOMElement: p,
      getItemTree: a,
      getItemOrderedChildrenIds: u
    },
    instance: {
      getItemMeta: i,
      getItem: s,
      getItemTree: a,
      getItemsToRender: () => {
        const x = (v) => {
          var M;
          const S = n.items.itemMetaMap[v];
          return {
            label: S.label,
            itemId: S.id,
            id: S.idAttribute,
            children: (M = n.items.itemOrderedChildrenIds[v]) == null ? void 0 : M.map(x)
          };
        };
        return n.items.itemOrderedChildrenIds[pl].map(x);
      },
      getItemIndex: d,
      getItemDOMElement: p,
      getItemOrderedChildrenIds: u,
      isItemDisabled: c,
      isItemNavigable: h,
      preventItemUpdates: m,
      areItemUpdatesPrevented: b
    },
    contextValue: {
      items: {
        onItemClick: t.onItemClick,
        disabledItemsFocusable: t.disabledItemsFocusable,
        indentationAtItemLevel: r.indentationAtItemLevel ?? !1
      }
    }
  };
};
q0.getInitialState = (e) => ({
  items: DE({
    items: e.items,
    isItemDisabled: e.isItemDisabled,
    getItemId: e.getItemId,
    getItemLabel: e.getItemLabel
  })
});
q0.getDefaultizedParams = ({
  params: e
}) => T({}, e, {
  disabledItemsFocusable: e.disabledItemsFocusable ?? !1,
  itemChildrenIndentation: e.itemChildrenIndentation ?? "12px"
});
q0.wrapRoot = ({
  children: e,
  instance: t
}) => /* @__PURE__ */ f.jsx(lf.Provider, {
  value: (n) => {
    var o;
    return ((o = t.getItemMeta(n)) == null ? void 0 : o.depth) ?? 0;
  },
  children: e
});
q0.params = {
  disabledItemsFocusable: !0,
  items: !0,
  isItemDisabled: !0,
  getItemLabel: !0,
  getItemId: !0,
  onItemClick: !0,
  itemChildrenIndentation: !0
};
const cf = ({
  instance: e,
  params: t,
  models: n
}) => {
  const o = y.useMemo(() => {
    const p = /* @__PURE__ */ new Map();
    return n.expandedItems.value.forEach((h) => {
      p.set(h, !0);
    }), p;
  }, [n.expandedItems.value]), r = (p, h) => {
    var g;
    (g = t.onExpandedItemsChange) == null || g.call(t, p, h), n.expandedItems.setControlledValue(h);
  }, i = y.useCallback((p) => o.has(p), [o]), s = y.useCallback((p) => {
    var h;
    return !!((h = e.getItemMeta(p)) != null && h.expandable);
  }, [e]), a = Ke((p, h) => {
    const g = e.isItemExpanded(h);
    e.setItemExpansion(p, h, !g);
  }), c = Ke((p, h, g) => {
    if (e.isItemExpanded(h) === g)
      return;
    let b;
    g ? b = [h].concat(n.expandedItems.value) : b = n.expandedItems.value.filter((C) => C !== h), t.onItemExpansionToggle && t.onItemExpansionToggle(p, h, g), r(p, b);
  }), d = (p, h) => {
    const g = e.getItemMeta(h), b = e.getItemOrderedChildrenIds(g.parentId).filter((x) => e.isItemExpandable(x) && !e.isItemExpanded(x)), C = n.expandedItems.value.concat(b);
    b.length > 0 && (t.onItemExpansionToggle && b.forEach((x) => {
      t.onItemExpansionToggle(p, x, !0);
    }), r(p, C));
  }, u = y.useMemo(() => t.expansionTrigger ? t.expansionTrigger : e.isTreeViewEditable ? "iconContainer" : "content", [t.expansionTrigger, e.isTreeViewEditable]);
  return {
    publicAPI: {
      setItemExpansion: c
    },
    instance: {
      isItemExpanded: i,
      isItemExpandable: s,
      setItemExpansion: c,
      toggleItemExpansion: a,
      expandAllSiblings: d
    },
    contextValue: {
      expansion: {
        expansionTrigger: u
      }
    }
  };
};
cf.models = {
  expandedItems: {
    getDefaultValue: (e) => e.defaultExpandedItems
  }
};
const Sfe = [];
cf.getDefaultizedParams = ({
  params: e
}) => T({}, e, {
  defaultExpandedItems: e.defaultExpandedItems ?? Sfe
});
cf.params = {
  expandedItems: !0,
  defaultExpandedItems: !0,
  onExpandedItemsChange: !0,
  onItemExpansionToggle: !0,
  expansionTrigger: !0
};
const AE = (e, t) => {
  let n = t.length - 1;
  for (; n >= 0 && !e.isItemNavigable(t[n]); )
    n -= 1;
  if (n !== -1)
    return t[n];
}, HE = (e, t) => {
  const n = e.getItemMeta(t), o = e.getItemOrderedChildrenIds(n.parentId), r = e.getItemIndex(t);
  if (r === 0)
    return n.parentId;
  let i = r - 1;
  for (; !e.isItemNavigable(o[i]) && i >= 0; )
    i -= 1;
  if (i === -1)
    return n.parentId == null ? null : HE(e, n.parentId);
  let s = o[i], a = AE(e, e.getItemOrderedChildrenIds(s));
  for (; e.isItemExpanded(s) && a != null; )
    s = a, a = e.getItemOrderedChildrenIds(s).find(e.isItemNavigable);
  return s;
}, _d = (e, t) => {
  if (e.isItemExpanded(t)) {
    const o = e.getItemOrderedChildrenIds(t).find(e.isItemNavigable);
    if (o != null)
      return o;
  }
  let n = e.getItemMeta(t);
  for (; n != null; ) {
    const o = e.getItemOrderedChildrenIds(n.parentId), r = e.getItemIndex(n.id);
    if (r < o.length - 1) {
      let i = r + 1;
      for (; !e.isItemNavigable(o[i]) && i < o.length - 1; )
        i += 1;
      if (e.isItemNavigable(o[i]))
        return o[i];
    }
    n = e.getItemMeta(n.parentId);
  }
  return null;
}, FE = (e) => {
  let t = null;
  for (; t == null || e.isItemExpanded(t); ) {
    const n = e.getItemOrderedChildrenIds(t), o = AE(e, n);
    if (o == null)
      return t;
    t = o;
  }
  return t;
}, e0 = (e) => e.getItemOrderedChildrenIds(null).find(e.isItemNavigable), NE = (e, t, n) => {
  if (t === n)
    return [t, n];
  const o = e.getItemMeta(t), r = e.getItemMeta(n);
  if (o.parentId === r.id || r.parentId === o.id)
    return r.parentId === o.id ? [o.id, r.id] : [r.id, o.id];
  const i = [o.id], s = [r.id];
  let a = o.parentId, c = r.parentId, d = s.indexOf(a) !== -1, u = i.indexOf(c) !== -1, p = !0, h = !0;
  for (; !u && !d; )
    p && (i.push(a), d = s.indexOf(a) !== -1, p = a !== null, !d && p && (a = e.getItemMeta(a).parentId)), h && !d && (s.push(c), u = i.indexOf(c) !== -1, h = c !== null, !u && h && (c = e.getItemMeta(c).parentId));
  const g = d ? a : c, m = e.getItemOrderedChildrenIds(g), b = i[i.indexOf(g) - 1], C = s[s.indexOf(g) - 1];
  return m.indexOf(b) < m.indexOf(C) ? [t, n] : [n, t];
}, Mfe = (e, t, n) => {
  const o = (c) => {
    if (e.isItemExpandable(c) && e.isItemExpanded(c))
      return e.getItemOrderedChildrenIds(c)[0];
    let d = e.getItemMeta(c);
    for (; d != null; ) {
      const u = e.getItemOrderedChildrenIds(d.parentId), p = e.getItemIndex(d.id);
      if (p < u.length - 1)
        return u[p + 1];
      d = e.getItemMeta(d.parentId);
    }
    throw new Error("Invalid range");
  }, [r, i] = NE(e, t, n), s = [r];
  let a = r;
  for (; a !== i; )
    a = o(a), e.isItemDisabled(a) || s.push(a);
  return s;
}, Tfe = (e) => {
  let t = e0(e);
  const n = [];
  for (; t != null; )
    n.push(t), t = _d(e, t);
  return n;
}, t0 = (e, t) => t !== e.closest('*[role="treeitem"]'), Pd = (e) => Array.isArray(e) ? e : e != null ? [e] : [], $6 = (e) => {
  const t = {};
  return e.forEach((n) => {
    t[n] = !0;
  }), t;
}, df = ({
  instance: e,
  params: t,
  models: n
}) => {
  const o = y.useRef(null), r = y.useRef({}), i = y.useMemo(() => {
    const b = /* @__PURE__ */ new Map();
    return Array.isArray(n.selectedItems.value) ? n.selectedItems.value.forEach((C) => {
      b.set(C, !0);
    }) : n.selectedItems.value != null && b.set(n.selectedItems.value, !0), b;
  }, [n.selectedItems.value]), s = (b, C) => {
    if (t.onItemSelectionToggle)
      if (t.multiSelect) {
        const x = C.filter((S) => !e.isItemSelected(S)), v = n.selectedItems.value.filter((S) => !C.includes(S));
        x.forEach((S) => {
          t.onItemSelectionToggle(b, S, !0);
        }), v.forEach((S) => {
          t.onItemSelectionToggle(b, S, !1);
        });
      } else C !== n.selectedItems.value && (n.selectedItems.value != null && t.onItemSelectionToggle(b, n.selectedItems.value, !1), C != null && t.onItemSelectionToggle(b, C, !0));
    t.onSelectedItemsChange && t.onSelectedItemsChange(b, C), n.selectedItems.setControlledValue(C);
  }, a = (b) => i.has(b), c = ({
    event: b,
    itemId: C,
    keepExistingSelection: x = !1,
    shouldBeSelected: v
  }) => {
    if (t.disableSelection)
      return;
    let S;
    if (x) {
      const M = Pd(n.selectedItems.value), w = e.isItemSelected(C);
      w && (v === !1 || v == null) ? S = M.filter((k) => k !== C) : !w && (v === !0 || v == null) ? S = [C].concat(M) : S = M;
    } else
      v === !1 || v == null && e.isItemSelected(C) ? S = t.multiSelect ? [] : null : S = t.multiSelect ? [C] : C;
    s(b, S), o.current = C, r.current = {};
  }, d = (b, [C, x]) => {
    if (t.disableSelection || !t.multiSelect)
      return;
    let v = Pd(n.selectedItems.value).slice();
    Object.keys(r.current).length > 0 && (v = v.filter((k) => !r.current[k]));
    const S = $6(v), M = Mfe(e, C, x), w = M.filter((k) => !S[k]);
    v = v.concat(w), s(b, v), r.current = $6(M);
  };
  return {
    getRootProps: () => ({
      "aria-multiselectable": t.multiSelect
    }),
    publicAPI: {
      selectItem: c
    },
    instance: {
      isItemSelected: a,
      selectItem: c,
      selectAllNavigableItems: (b) => {
        if (t.disableSelection || !t.multiSelect)
          return;
        const C = Tfe(e);
        s(b, C), r.current = $6(C);
      },
      expandSelectionRange: (b, C) => {
        if (o.current != null) {
          const [x, v] = NE(e, C, o.current);
          d(b, [x, v]);
        }
      },
      selectRangeFromStartToItem: (b, C) => {
        d(b, [e0(e), C]);
      },
      selectRangeFromItemToEnd: (b, C) => {
        d(b, [C, FE(e)]);
      },
      selectItemFromArrowNavigation: (b, C, x) => {
        if (t.disableSelection || !t.multiSelect)
          return;
        let v = Pd(n.selectedItems.value).slice();
        Object.keys(r.current).length === 0 ? (v.push(x), r.current = {
          [C]: !0,
          [x]: !0
        }) : (r.current[C] || (r.current = {}), r.current[x] ? (v = v.filter((S) => S !== C), delete r.current[C]) : (v.push(x), r.current[x] = !0)), s(b, v);
      }
    },
    contextValue: {
      selection: {
        multiSelect: t.multiSelect,
        checkboxSelection: t.checkboxSelection,
        disableSelection: t.disableSelection
      }
    }
  };
};
df.models = {
  selectedItems: {
    getDefaultValue: (e) => e.defaultSelectedItems
  }
};
const kfe = [];
df.getDefaultizedParams = ({
  params: e
}) => T({}, e, {
  disableSelection: e.disableSelection ?? !1,
  multiSelect: e.multiSelect ?? !1,
  checkboxSelection: e.checkboxSelection ?? !1,
  defaultSelectedItems: e.defaultSelectedItems ?? (e.multiSelect ? kfe : null)
});
df.params = {
  disableSelection: !0,
  multiSelect: !0,
  checkboxSelection: !0,
  defaultSelectedItems: !0,
  selectedItems: !0,
  onSelectedItemsChange: !0,
  onItemSelectionToggle: !0
};
const ZC = 1e3;
class Efe {
  constructor(t = ZC) {
    this.timeouts = /* @__PURE__ */ new Map(), this.cleanupTimeout = ZC, this.cleanupTimeout = t;
  }
  register(t, n, o) {
    this.timeouts || (this.timeouts = /* @__PURE__ */ new Map());
    const r = setTimeout(() => {
      typeof n == "function" && n(), this.timeouts.delete(o.cleanupToken);
    }, this.cleanupTimeout);
    this.timeouts.set(o.cleanupToken, r);
  }
  unregister(t) {
    const n = this.timeouts.get(t.cleanupToken);
    n && (this.timeouts.delete(t.cleanupToken), clearTimeout(n));
  }
  reset() {
    this.timeouts && (this.timeouts.forEach((t, n) => {
      this.unregister({
        cleanupToken: n
      });
    }), this.timeouts = void 0);
  }
}
class Rfe {
  constructor() {
    this.registry = new FinalizationRegistry((t) => {
      typeof t == "function" && t();
    });
  }
  register(t, n, o) {
    this.registry.register(t, n, o);
  }
  unregister(t) {
    this.registry.unregister(t);
  }
  // eslint-disable-next-line class-methods-use-this
  reset() {
  }
}
class Ofe {
}
function _fe(e) {
  let t = 0;
  return function(o, r, i) {
    e.registry === null && (e.registry = typeof FinalizationRegistry < "u" ? new Rfe() : new Efe());
    const [s] = y.useState(new Ofe()), a = y.useRef(null), c = y.useRef(void 0);
    c.current = i;
    const d = y.useRef(null);
    if (!a.current && c.current) {
      const u = (p, h) => {
        var g;
        h.defaultMuiPrevented || (g = c.current) == null || g.call(c, p, h);
      };
      a.current = o.$$subscribeEvent(r, u), t += 1, d.current = {
        cleanupToken: t
      }, e.registry.register(
        s,
        // The callback below will be called once this reference stops being retained
        () => {
          var p;
          (p = a.current) == null || p.call(a), a.current = null, d.current = null;
        },
        d.current
      );
    } else !c.current && a.current && (a.current(), a.current = null, d.current && (e.registry.unregister(d.current), d.current = null));
    y.useEffect(() => {
      if (!a.current && c.current) {
        const u = (p, h) => {
          var g;
          h.defaultMuiPrevented || (g = c.current) == null || g.call(c, p, h);
        };
        a.current = o.$$subscribeEvent(r, u);
      }
      return d.current && e.registry && (e.registry.unregister(d.current), d.current = null), () => {
        var u;
        (u = a.current) == null || u.call(a), a.current = null;
      };
    }, [o, r]);
  };
}
const Pfe = {
  registry: null
}, Lfe = _fe(Pfe), $E = (e = document) => {
  const t = e.activeElement;
  return t ? t.shadowRoot ? $E(t.shadowRoot) : t : null;
}, Ife = (e, t) => {
  let n = Pd(t).find((o) => {
    if (!e.isItemNavigable(o))
      return !1;
    const r = e.getItemMeta(o);
    return r && (r.parentId == null || e.isItemExpanded(r.parentId));
  });
  return n == null && (n = e0(e)), n;
}, a8 = ({
  instance: e,
  params: t,
  state: n,
  setState: o,
  models: r,
  rootRef: i
}) => {
  const s = Ife(e, r.selectedItems.value), a = Ke((C) => {
    const x = typeof C == "function" ? C(n.focusedItemId) : C;
    n.focusedItemId !== x && o((v) => T({}, v, {
      focusedItemId: x
    }));
  }), c = y.useCallback(() => !!i.current && i.current.contains($E(gn(i.current))), [i]), d = y.useCallback((C) => n.focusedItemId === C && c(), [n.focusedItemId, c]), u = (C) => {
    const x = e.getItemMeta(C);
    return x && (x.parentId == null || e.isItemExpanded(x.parentId));
  }, p = (C, x) => {
    const v = e.getItemDOMElement(x);
    v && v.focus(), a(x), t.onItemFocus && t.onItemFocus(C, x);
  }, h = Ke((C, x) => {
    u(x) && p(C, x);
  }), g = Ke(() => {
    if (n.focusedItemId == null)
      return;
    if (e.getItemMeta(n.focusedItemId)) {
      const x = e.getItemDOMElement(n.focusedItemId);
      x && x.blur();
    }
    a(null);
  }), m = (C) => C === s;
  Lfe(e, "removeItem", ({
    id: C
  }) => {
    n.focusedItemId === C && p(null, s);
  });
  const b = (C) => (x) => {
    var v;
    (v = C.onFocus) == null || v.call(C, x), !x.defaultMuiPrevented && x.target === x.currentTarget && p(x, s);
  };
  return {
    getRootProps: (C) => ({
      onFocus: b(C)
    }),
    publicAPI: {
      focusItem: h
    },
    instance: {
      isItemFocused: d,
      canItemBeTabbed: m,
      focusItem: h,
      removeFocusedItem: g
    }
  };
};
a8.getInitialState = () => ({
  focusedItemId: null
});
a8.params = {
  onItemFocus: !0
};
const da = (e, t) => e.getAvailablePlugins().has(t), jfe = ({
  props: e
}) => {
  const {
    instance: t
  } = $a(), {
    label: n,
    itemId: o
  } = e, [r, i] = y.useState(n), s = t.isItemBeingEdited(o);
  return y.useEffect(() => {
    s || i(n);
  }, [s, n]), {
    propsEnhancers: {
      labelInput: ({
        externalEventHandlers: a,
        interactions: c
      }) => t.isItemEditable(o) ? {
        value: r ?? "",
        "data-element": "labelInput",
        onChange: (g) => {
          var m;
          (m = a.onChange) == null || m.call(a, g), i(g.target.value);
        },
        onKeyDown: (g) => {
          var b;
          if ((b = a.onKeyDown) == null || b.call(a, g), g.defaultMuiPrevented)
            return;
          const m = g.target;
          g.key === "Enter" && m.value ? c.handleSaveItemLabel(g, m.value) : g.key === "Escape" && c.handleCancelItemLabelEditing(g);
        },
        onBlur: (g) => {
          var m;
          (m = a.onBlur) == null || m.call(a, g), !g.defaultMuiPrevented && g.target.value && c.handleSaveItemLabel(g, g.target.value);
        },
        autoFocus: !0,
        type: "text"
      } : {}
    }
  };
}, br = ({
  instance: e,
  state: t,
  setState: n,
  params: o
}) => {
  const r = y.useRef(t.editedItemId), i = (p) => r.current === p, s = (p) => {
    n((h) => T({}, h, {
      editedItemId: p
    })), r.current = p;
  }, a = (p) => p === t.editedItemId, c = !!o.isItemEditable, d = (p) => {
    if (p == null || !c)
      return !1;
    const h = e.getItem(p);
    return h ? typeof o.isItemEditable == "function" ? o.isItemEditable(h) : !!o.isItemEditable : !1;
  }, u = (p, h) => {
    if (!h)
      throw new Error(["MUI X: The Tree View component requires all items to have a `label` property.", "The label of an item cannot be empty.", p].join(`
`));
    n((g) => {
      const m = g.items.itemMetaMap[p];
      return m.label !== h ? T({}, g, {
        items: T({}, g.items, {
          itemMetaMap: T({}, g.items.itemMetaMap, {
            [p]: T({}, m, {
              label: h
            })
          })
        })
      }) : g;
    }), o.onItemLabelChange && o.onItemLabelChange(p, h);
  };
  return {
    instance: {
      setEditedItemId: s,
      isItemBeingEdited: a,
      updateItemLabel: u,
      isItemEditable: d,
      isTreeViewEditable: c,
      isItemBeingEditedRef: i
    },
    publicAPI: {
      updateItemLabel: u
    }
  };
};
br.itemPlugin = jfe;
br.getDefaultizedParams = ({
  params: e,
  experimentalFeatures: t
}) => {
  const n = t == null ? void 0 : t.labelEditing;
  return process.env.NODE_ENV !== "production" && e.isItemEditable && !n && hu(["MUI X: The label editing feature requires the `labelEditing` experimental feature to be enabled.", "You can do it by passing `experimentalFeatures={{ labelEditing: true}}` to the Rich Tree View Pro component.", "Check the documentation for more details: https://mui.com/x/react-tree-view/rich-tree-view/editing/"]), T({}, e, {
    isItemEditable: n ? e.isItemEditable ?? !1 : !1
  });
};
br.getInitialState = () => ({
  editedItemId: null
});
br.params = {
  onItemLabelChange: !0,
  isItemEditable: !0
};
function Vfe(e) {
  return !!e && e.length === 1 && !!e.match(/\S/);
}
const BE = ({
  instance: e,
  params: t,
  state: n
}) => {
  const o = Ms(), r = y.useRef({}), i = Ke((u) => {
    r.current = u(r.current);
  });
  y.useEffect(() => {
    if (e.areItemUpdatesPrevented())
      return;
    const u = {}, p = (h) => {
      u[h.id] = h.label.substring(0, 1).toLowerCase();
    };
    Object.values(n.items.itemMetaMap).forEach(p), r.current = u;
  }, [n.items.itemMetaMap, t.getItemId, e]);
  const s = (u, p) => {
    const h = p.toLowerCase(), g = (x) => {
      const v = _d(e, x);
      return v === null ? e0(e) : v;
    };
    let m = null, b = g(u);
    const C = {};
    for (; m == null && !C[b]; )
      r.current[b] === h ? m = b : (C[b] = !0, b = g(b));
    return m;
  }, a = (u) => !t.disableSelection && !e.isItemDisabled(u), c = (u) => !e.isItemDisabled(u) && e.isItemExpandable(u);
  return {
    instance: {
      updateFirstCharMap: i,
      handleItemKeyDown: (u, p) => {
        if (u.defaultMuiPrevented || u.altKey || t0(u.target, u.currentTarget))
          return;
        const h = u.ctrlKey || u.metaKey, g = u.key;
        switch (!0) {
          case (g === " " && a(p)): {
            u.preventDefault(), t.multiSelect && u.shiftKey ? e.expandSelectionRange(u, p) : e.selectItem({
              event: u,
              itemId: p,
              keepExistingSelection: t.multiSelect,
              shouldBeSelected: t.multiSelect ? void 0 : !0
            });
            break;
          }
          case g === "Enter": {
            da(e, br) && e.isItemEditable(p) && !e.isItemBeingEdited(p) ? e.setEditedItemId(p) : c(p) ? (e.toggleItemExpansion(u, p), u.preventDefault()) : a(p) && (t.multiSelect ? (u.preventDefault(), e.selectItem({
              event: u,
              itemId: p,
              keepExistingSelection: !0
            })) : e.isItemSelected(p) || (e.selectItem({
              event: u,
              itemId: p
            }), u.preventDefault()));
            break;
          }
          case g === "ArrowDown": {
            const m = _d(e, p);
            m && (u.preventDefault(), e.focusItem(u, m), t.multiSelect && u.shiftKey && a(m) && e.selectItemFromArrowNavigation(u, p, m));
            break;
          }
          case g === "ArrowUp": {
            const m = HE(e, p);
            m && (u.preventDefault(), e.focusItem(u, m), t.multiSelect && u.shiftKey && a(m) && e.selectItemFromArrowNavigation(u, p, m));
            break;
          }
          case (g === "ArrowRight" && !o || g === "ArrowLeft" && o): {
            if (h)
              return;
            if (e.isItemExpanded(p)) {
              const m = _d(e, p);
              m && (e.focusItem(u, m), u.preventDefault());
            } else c(p) && (e.toggleItemExpansion(u, p), u.preventDefault());
            break;
          }
          case (g === "ArrowLeft" && !o || g === "ArrowRight" && o): {
            if (h)
              return;
            if (c(p) && e.isItemExpanded(p))
              e.toggleItemExpansion(u, p), u.preventDefault();
            else {
              const m = e.getItemMeta(p).parentId;
              m && (e.focusItem(u, m), u.preventDefault());
            }
            break;
          }
          case g === "Home": {
            a(p) && t.multiSelect && h && u.shiftKey ? e.selectRangeFromStartToItem(u, p) : e.focusItem(u, e0(e)), u.preventDefault();
            break;
          }
          case g === "End": {
            a(p) && t.multiSelect && h && u.shiftKey ? e.selectRangeFromItemToEnd(u, p) : e.focusItem(u, FE(e)), u.preventDefault();
            break;
          }
          case g === "*": {
            e.expandAllSiblings(u, p), u.preventDefault();
            break;
          }
          case (String.fromCharCode(u.keyCode) === "A" && h && t.multiSelect && !t.disableSelection): {
            e.selectAllNavigableItems(u), u.preventDefault();
            break;
          }
          case (!h && !u.shiftKey && Vfe(g)): {
            const m = s(p, g);
            m != null && (e.focusItem(u, m), u.preventDefault());
            break;
          }
        }
      }
    }
  };
};
BE.params = {};
const zE = ({
  slots: e,
  slotProps: t
}) => ({
  contextValue: {
    icons: {
      slots: {
        collapseIcon: e.collapseIcon,
        expandIcon: e.expandIcon,
        endIcon: e.endIcon
      },
      slotProps: {
        collapseIcon: t.collapseIcon,
        expandIcon: t.expandIcon,
        endIcon: t.endIcon
      }
    }
  }
});
zE.params = {};
function Dfe(e) {
  return _e("MuiRichTreeView", e);
}
Re("MuiRichTreeView", ["root"]);
const Afe = [q0, cf, df, a8, BE, zE, br];
function ZE(e) {
  const {
    instance: t,
    items: {
      onItemClick: n
    },
    selection: {
      multiSelect: o,
      checkboxSelection: r,
      disableSelection: i
    },
    expansion: {
      expansionTrigger: s
    }
  } = $a(), a = t.isItemExpandable(e), c = t.isItemExpanded(e), d = t.isItemFocused(e), u = t.isItemSelected(e), p = t.isItemDisabled(e), h = t != null && t.isItemBeingEdited ? t == null ? void 0 : t.isItemBeingEdited(e) : !1, g = t.isItemEditable ? t.isItemEditable(e) : !1, m = (w) => {
    if (!p) {
      d || t.focusItem(w, e);
      const k = o && (w.shiftKey || w.ctrlKey || w.metaKey);
      a && !(k && t.isItemExpanded(e)) && t.toggleItemExpansion(w, e);
    }
  }, b = (w) => {
    p || (d || t.focusItem(w, e), o && (w.shiftKey || w.ctrlKey || w.metaKey) ? w.shiftKey ? t.expandSelectionRange(w, e) : t.selectItem({
      event: w,
      itemId: e,
      keepExistingSelection: !0
    }) : t.selectItem({
      event: w,
      itemId: e,
      shouldBeSelected: !0
    }));
  }, C = (w) => {
    if (i || p)
      return;
    const k = w.nativeEvent.shiftKey;
    o && k ? t.expandSelectionRange(w, e) : t.selectItem({
      event: w,
      itemId: e,
      keepExistingSelection: o,
      shouldBeSelected: w.target.checked
    });
  }, x = (w) => {
    (w.shiftKey || w.ctrlKey || w.metaKey || p) && w.preventDefault();
  }, v = () => {
    da(t, br) && t.isItemEditable(e) && (t.isItemBeingEdited(e) ? t.setEditedItemId(null) : t.setEditedItemId(e));
  };
  return {
    disabled: p,
    expanded: c,
    selected: u,
    focused: d,
    editable: g,
    editing: h,
    disableSelection: i,
    checkboxSelection: r,
    handleExpansion: m,
    handleSelection: b,
    handleCheckboxSelection: C,
    handleContentClick: n,
    preventSelection: x,
    expansionTrigger: s,
    toggleItemEditing: v,
    handleSaveItemLabel: (w, k) => {
      da(t, br) && t.isItemBeingEditedRef(e) && (t.updateItemLabel(e, k), v(), t.focusItem(w, e));
    },
    handleCancelItemLabelEditing: (w) => {
      da(t, br) && t.isItemBeingEditedRef(e) && (v(), t.focusItem(w, e));
    }
  };
}
const Hfe = B("div", {
  name: "MuiTreeItem2DragAndDropOverlay",
  slot: "Root",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => dd(e) && e !== "action"
})(({
  theme: e
}) => ({
  position: "absolute",
  left: 0,
  display: "flex",
  top: 0,
  bottom: 0,
  right: 0,
  pointerEvents: "none",
  variants: [{
    props: {
      action: "make-child"
    },
    style: {
      marginLeft: "calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))",
      borderRadius: e.shape.borderRadius,
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.darkChannel} / ${e.vars.palette.action.focusOpacity})` : $t(e.palette.primary.dark, e.palette.action.focusOpacity)
    }
  }, {
    props: {
      action: "reorder-above"
    },
    style: {
      marginLeft: "calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))",
      borderTop: `1px solid ${(e.vars || e).palette.action.active}`
    }
  }, {
    props: {
      action: "reorder-below"
    },
    style: {
      marginLeft: "calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))",
      borderBottom: `1px solid ${(e.vars || e).palette.action.active}`
    }
  }, {
    props: {
      action: "move-to-parent"
    },
    style: {
      marginLeft: "calc(var(--TreeView-indentMultiplier) * calc(var(--TreeView-itemDepth) - 1))",
      borderBottom: `1px solid ${(e.vars || e).palette.action.active}`
    }
  }]
}));
function l8(e) {
  return e.action == null ? null : /* @__PURE__ */ f.jsx(Hfe, T({}, e));
}
process.env.NODE_ENV !== "production" && (l8.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  action: l.oneOf(["make-child", "move-to-parent", "reorder-above", "reorder-below"]),
  style: l.object
});
const WE = B("input", {
  name: "MuiTreeItem2",
  slot: "LabelInput",
  overridesResolver: (e, t) => t.labelInput
})(({
  theme: e
}) => T({}, e.typography.body1, {
  width: "100%",
  backgroundColor: e.palette.background.paper,
  borderRadius: e.shape.borderRadius,
  border: "none",
  padding: "0 2px",
  boxSizing: "border-box",
  "&:focus": {
    outline: `1px solid ${e.palette.primary.main}`
  }
})), Ffe = ["classes", "className", "displayIcon", "expansionIcon", "icon", "label", "itemId", "onClick", "onMouseDown", "dragAndDropOverlayProps", "labelInputProps"], c8 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const {
    classes: o,
    className: r,
    displayIcon: i,
    expansionIcon: s,
    icon: a,
    label: c,
    itemId: d,
    onClick: u,
    onMouseDown: p,
    dragAndDropOverlayProps: h,
    labelInputProps: g
  } = t, m = le(t, Ffe), {
    disabled: b,
    expanded: C,
    selected: x,
    focused: v,
    editing: S,
    editable: M,
    disableSelection: w,
    checkboxSelection: k,
    handleExpansion: E,
    handleSelection: R,
    handleCheckboxSelection: O,
    handleContentClick: P,
    preventSelection: _,
    expansionTrigger: L,
    toggleItemEditing: V
  } = ZE(d), j = a || s || i, I = y.useRef(null), F = (H) => {
    _(H), p && p(H);
  }, $ = (H) => {
    var N;
    P == null || P(H, d), !((N = I.current) != null && N.contains(H.target)) && (L === "content" && E(H), k || R(H), u && u(H));
  }, A = (H) => {
    H.defaultMuiPrevented || V();
  };
  return (
    /* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- Key event is handled by the TreeView */
    /* @__PURE__ */ f.jsxs("div", T({}, m, {
      className: xe(o.root, r, C && o.expanded, x && o.selected, v && o.focused, b && o.disabled, S && o.editing, M && o.editable),
      onClick: $,
      onMouseDown: F,
      ref: n,
      children: [/* @__PURE__ */ f.jsx("div", {
        className: o.iconContainer,
        children: j
      }), k && /* @__PURE__ */ f.jsx(si, {
        className: o.checkbox,
        checked: x,
        onChange: O,
        disabled: b || w,
        ref: I,
        tabIndex: -1
      }), S ? /* @__PURE__ */ f.jsx(WE, T({}, g, {
        className: o.labelInput
      })) : /* @__PURE__ */ f.jsx("div", T({
        className: o.label
      }, M && {
        onDoubleClick: A
      }, {
        children: c
      })), h && /* @__PURE__ */ f.jsx(l8, T({}, h))]
    }))
  );
});
process.env.NODE_ENV !== "production" && (c8.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object.isRequired,
  className: l.string,
  /**
   * The icon to display next to the Tree Item's label. Either a parent or end icon.
   */
  displayIcon: l.node,
  dragAndDropOverlayProps: l.shape({
    action: l.oneOf(["make-child", "move-to-parent", "reorder-above", "reorder-below"]),
    style: l.object
  }),
  /**
   * The icon to display next to the Tree Item's label. Either an expansion or collapse icon.
   */
  expansionIcon: l.node,
  /**
   * The icon to display next to the Tree Item's label.
   */
  icon: l.node,
  /**
   * The id of the item.
   */
  itemId: l.string.isRequired,
  /**
   * The Tree Item label.
   */
  label: l.node,
  labelInputProps: l.shape({
    autoFocus: l.oneOf([!0]),
    "data-element": l.oneOf(["labelInput"]),
    onBlur: l.func,
    onChange: l.func,
    onKeyDown: l.func,
    type: l.oneOf(["text"]),
    value: l.string
  })
});
function UE(e) {
  return _e("MuiTreeItem", e);
}
const zo = Re("MuiTreeItem", ["root", "groupTransition", "content", "expanded", "selected", "focused", "disabled", "iconContainer", "label", "checkbox", "labelInput", "editable", "editing", "dragAndDropOverlay"]), GE = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "TreeViewExpandIcon"), qE = ft(/* @__PURE__ */ f.jsx("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "TreeViewCollapseIcon");
function d8(e) {
  const {
    children: t,
    itemId: n
  } = e, {
    wrapItem: o,
    instance: r
  } = $a();
  return o({
    children: t,
    itemId: n,
    instance: r
  });
}
d8.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: l.node,
  itemId: l.string.isRequired
};
const Nfe = ["children", "className", "slots", "slotProps", "ContentComponent", "ContentProps", "itemId", "id", "label", "onClick", "onMouseDown", "onFocus", "onBlur", "onKeyDown"], $fe = ["ownerState"], Bfe = ["ownerState"], zfe = ["ownerState"], Zfe = o8(), Wfe = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"],
    content: ["content"],
    expanded: ["expanded"],
    selected: ["selected"],
    focused: ["focused"],
    disabled: ["disabled"],
    iconContainer: ["iconContainer"],
    checkbox: ["checkbox"],
    label: ["label"],
    labelInput: ["labelInput"],
    editing: ["editing"],
    editable: ["editable"],
    groupTransition: ["groupTransition"]
  }, UE, t);
}, Ufe = B("li", {
  name: "MuiTreeItem",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  outline: 0
}), Gfe = B(c8, {
  name: "MuiTreeItem",
  slot: "Content",
  overridesResolver: (e, t) => [t.content, t.iconContainer && {
    [`& .${zo.iconContainer}`]: t.iconContainer
  }, t.label && {
    [`& .${zo.label}`]: t.label
  }],
  shouldForwardProp: (e) => T0(e) && e !== "indentationAtItemLevel"
})(({
  theme: e
}) => ({
  padding: e.spacing(0.5, 1),
  borderRadius: e.shape.borderRadius,
  width: "100%",
  boxSizing: "border-box",
  // prevent width + padding to overflow
  position: "relative",
  display: "flex",
  alignItems: "center",
  gap: e.spacing(1),
  cursor: "pointer",
  WebkitTapHighlightColor: "transparent",
  "&:hover": {
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${zo.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity,
    backgroundColor: "transparent"
  },
  [`&.${zo.focused}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${zo.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : $t(e.palette.primary.main, e.palette.action.selectedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : $t(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : $t(e.palette.primary.main, e.palette.action.selectedOpacity)
      }
    },
    [`&.${zo.focused}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : $t(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`& .${zo.iconContainer}`]: {
    width: 16,
    display: "flex",
    flexShrink: 0,
    justifyContent: "center",
    "& svg": {
      fontSize: 18
    }
  },
  [`& .${zo.label}`]: T({
    width: "100%",
    boxSizing: "border-box",
    // prevent width + padding to overflow
    // fixes overflow - see https://github.com/mui/material-ui/issues/27372
    minWidth: 0,
    position: "relative"
  }, e.typography.body1),
  [`& .${zo.checkbox}`]: {
    padding: 0
  },
  variants: [{
    props: {
      indentationAtItemLevel: !0
    },
    style: {
      paddingLeft: `calc(${e.spacing(1)} + var(--TreeView-itemChildrenIndentation) * var(--TreeView-itemDepth))`
    }
  }]
})), qfe = B(Ts, {
  name: "MuiTreeItem",
  slot: "GroupTransition",
  overridesResolver: (e, t) => t.groupTransition,
  shouldForwardProp: (e) => T0(e) && e !== "indentationAtItemLevel"
})({
  margin: 0,
  padding: 0,
  paddingLeft: "var(--TreeView-itemChildrenIndentation)",
  variants: [{
    props: {
      indentationAtItemLevel: !0
    },
    style: {
      paddingLeft: 0
    }
  }]
}), KE = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var ve, Be, rt, pt;
  const {
    icons: o,
    runItemPlugins: r,
    items: {
      disabledItemsFocusable: i,
      indentationAtItemLevel: s
    },
    selection: {
      disableSelection: a
    },
    expansion: {
      expansionTrigger: c
    },
    treeId: d,
    instance: u
  } = $a(), p = y.useContext(lf), h = Zfe({
    props: t,
    name: "MuiTreeItem"
  }), {
    children: g,
    className: m,
    slots: b,
    slotProps: C,
    ContentComponent: x = c8,
    ContentProps: v,
    itemId: S,
    id: M,
    label: w,
    onClick: k,
    onMouseDown: E,
    onBlur: R,
    onKeyDown: O
  } = h, P = le(h, Nfe), {
    expanded: _,
    focused: L,
    selected: V,
    disabled: j,
    editing: I,
    handleExpansion: F,
    handleCancelItemLabelEditing: $,
    handleSaveItemLabel: A
  } = ZE(S);
  process.env.NODE_ENV !== "production" && (h.ContentComponent && hu(["MUI X: The ContentComponent prop of the TreeItem component is deprecated and will be removed in the next major release.", "You can use the new TreeItem2 component or the new useTreeItem2 hook to customize the rendering of the content.", "For more detail, see https://mui.com/x/react-tree-view/tree-item-customization/."]), h.ContentProps && hu(["MUI X: The ContentProps prop of the TreeItem component is deprecated and will be removed in the next major release.", "You can use the new TreeItem2 component or the new useTreeItem2 hook to customize the rendering of the content.", "For more detail, see https://mui.com/x/react-tree-view/tree-item-customization/."]));
  const {
    contentRef: H,
    rootRef: N,
    propsEnhancers: z
  } = r(h), se = y.useRef(null), ne = y.useRef(null), Z = Tt(n, N, se), q = Tt(v == null ? void 0 : v.ref, H, ne), G = {
    expandIcon: (b == null ? void 0 : b.expandIcon) ?? o.slots.expandIcon ?? GE,
    collapseIcon: (b == null ? void 0 : b.collapseIcon) ?? o.slots.collapseIcon ?? qE,
    endIcon: (b == null ? void 0 : b.endIcon) ?? o.slots.endIcon,
    icon: b == null ? void 0 : b.icon,
    groupTransition: b == null ? void 0 : b.groupTransition
  }, K = (Je) => Array.isArray(Je) ? Je.length > 0 && Je.some(K) : !!Je, Q = K(g), re = T({}, h, {
    expanded: _,
    focused: L,
    selected: V,
    disabled: j,
    indentationAtItemLevel: s
  }), U = Wfe(re), W = G.groupTransition ?? void 0, D = Ft({
    elementType: W,
    ownerState: {},
    externalSlotProps: C == null ? void 0 : C.groupTransition,
    additionalProps: T({
      unmountOnExit: !0,
      in: _,
      component: "ul",
      role: "group"
    }, s ? {
      indentationAtItemLevel: !0
    } : {}),
    className: U.groupTransition
  }), X = (Je) => {
    c === "iconContainer" && F(Je);
  }, de = _ ? G.collapseIcon : G.expandIcon, ue = Ft({
    elementType: de,
    ownerState: {},
    externalSlotProps: (Je) => _ ? T({}, Kr(o.slotProps.collapseIcon, Je), Kr(C == null ? void 0 : C.collapseIcon, Je)) : T({}, Kr(o.slotProps.expandIcon, Je), Kr(C == null ? void 0 : C.expandIcon, Je)),
    additionalProps: {
      onClick: X
    }
  }), he = le(ue, $fe), Ue = Q && de ? /* @__PURE__ */ f.jsx(de, T({}, he)) : null, me = Q ? void 0 : G.endIcon, Ie = Ft({
    elementType: me,
    ownerState: {},
    externalSlotProps: (Je) => Q ? {} : T({}, Kr(o.slotProps.endIcon, Je), Kr(C == null ? void 0 : C.endIcon, Je))
  }), te = le(Ie, Bfe), ie = me ? /* @__PURE__ */ f.jsx(me, T({}, te)) : null, ye = G.icon, Ne = Ft({
    elementType: ye,
    ownerState: {},
    externalSlotProps: C == null ? void 0 : C.icon
  }), We = le(Ne, zfe), qe = ye ? /* @__PURE__ */ f.jsx(ye, T({}, We)) : null;
  let Me;
  V ? Me = !0 : a || j ? Me = void 0 : Me = !1;
  function Pe(Je) {
    !L && (!j || i) && Je.currentTarget === Je.target && u.focusItem(Je, S);
  }
  function fe(Je) {
    var At, Ht, Ct, qt;
    R == null || R(Je), !(I || // we can exit the editing state by clicking outside the input (within the Tree Item) or by pressing Enter or Escape -> we don't want to remove the focused item from the state in these cases
    // we can also exit the editing state by clicking on the root itself -> want to remove the focused item from the state in this case
    Je.relatedTarget && t0(Je.relatedTarget, se.current) && (Je.target && ((Ht = (At = Je.target) == null ? void 0 : At.dataset) == null ? void 0 : Ht.element) === "labelInput" && t0(Je.target, se.current) || ((qt = (Ct = Je.relatedTarget) == null ? void 0 : Ct.dataset) == null ? void 0 : qt.element) === "labelInput")) && u.removeFocusedItem();
  }
  const ae = (Je) => {
    var At, Ht;
    O == null || O(Je), ((Ht = (At = Je.target) == null ? void 0 : At.dataset) == null ? void 0 : Ht.element) !== "labelInput" && u.handleItemKeyDown(Je, S);
  }, Te = r8({
    itemId: S,
    treeId: d,
    id: M
  }), tt = u.canItemBeTabbed(S) ? 0 : -1, Ye = {
    rootRefObject: se,
    contentRefObject: ne,
    interactions: {
      handleSaveItemLabel: A,
      handleCancelItemLabelEditing: $
    }
  }, Le = ((ve = z.root) == null ? void 0 : ve.call(z, T({}, Ye, {
    externalEventHandlers: lo(P)
  }))) ?? {}, Ve = ((Be = z.content) == null ? void 0 : Be.call(z, T({}, Ye, {
    externalEventHandlers: lo(v)
  }))) ?? {}, Ce = ((rt = z.dragAndDropOverlay) == null ? void 0 : rt.call(z, T({}, Ye, {
    externalEventHandlers: {}
  }))) ?? {}, Se = ((pt = z.labelInput) == null ? void 0 : pt.call(z, T({}, Ye, {
    externalEventHandlers: {}
  }))) ?? {};
  return /* @__PURE__ */ f.jsx(d8, {
    itemId: S,
    children: /* @__PURE__ */ f.jsxs(Ufe, T({
      className: xe(U.root, m),
      role: "treeitem",
      "aria-expanded": Q ? _ : void 0,
      "aria-selected": Me,
      "aria-disabled": j || void 0,
      id: Te,
      tabIndex: tt
    }, P, {
      ownerState: re,
      onFocus: Pe,
      onBlur: fe,
      onKeyDown: ae,
      ref: Z,
      style: s ? T({}, P.style, {
        "--TreeView-itemDepth": typeof p == "function" ? p(S) : p
      }) : P.style
    }, Le, {
      children: [/* @__PURE__ */ f.jsx(Gfe, T({
        as: x,
        classes: {
          root: U.content,
          expanded: U.expanded,
          selected: U.selected,
          focused: U.focused,
          disabled: U.disabled,
          editable: U.editable,
          editing: U.editing,
          iconContainer: U.iconContainer,
          label: U.label,
          labelInput: U.labelInput,
          checkbox: U.checkbox
        },
        label: w,
        itemId: S,
        onClick: k,
        onMouseDown: E,
        icon: qe,
        expansionIcon: Ue,
        displayIcon: ie,
        ownerState: re
      }, v, Ve, Ce.action == null ? {} : {
        dragAndDropOverlayProps: Ce
      }, Se.value == null ? {} : {
        labelInputProps: Se
      }, {
        ref: q
      })), g && /* @__PURE__ */ f.jsx(qfe, T({
        as: W
      }, D, {
        children: g
      }))]
    }))
  });
});
process.env.NODE_ENV !== "production" && (KE.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  className: l.string,
  /**
   * The component used to render the content of the item.
   * @deprecated Consider using the `<TreeItem2 />` component or the `useTreeItem2` hook instead. For more details, see https://mui.com/x/react-tree-view/tree-item-customization/.
   * @default TreeItemContent
   */
  ContentComponent: Pa,
  /**
   * Props applied to ContentComponent.
   * @deprecated Consider using the `<TreeItem2 />` component or the `useTreeItem2` hook instead. For more details, see https://mui.com/x/react-tree-view/tree-item-customization/.
   */
  ContentProps: l.object,
  /**
   * If `true`, the item is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * The id of the item.
   */
  itemId: l.string.isRequired,
  /**
   * The Tree Item label.
   */
  label: l.node,
  /**
   * This prop isn't supported.
   * Use the `onItemFocus` callback on the tree if you need to monitor a item's focus.
   */
  onFocus: v0,
  /**
   * Callback fired when a key of the keyboard is pressed on the item.
   */
  onKeyDown: l.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const Kfe = ["ownerState"];
function Yfe({
  slots: e,
  slotProps: t,
  label: n,
  id: o,
  itemId: r,
  itemsToRender: i
}) {
  const s = (e == null ? void 0 : e.item) ?? KE, a = Ft({
    elementType: s,
    externalSlotProps: t == null ? void 0 : t.item,
    additionalProps: {
      itemId: r,
      id: o,
      label: n
    },
    ownerState: {
      itemId: r,
      label: n
    }
  }), c = le(a, Kfe), d = y.useMemo(() => i ? /* @__PURE__ */ f.jsx(YE, {
    itemsToRender: i,
    slots: e,
    slotProps: t
  }) : null, [i, e, t]);
  return /* @__PURE__ */ f.jsx(s, T({}, c, {
    children: d
  }));
}
function YE(e) {
  const {
    itemsToRender: t,
    slots: n,
    slotProps: o
  } = e;
  return /* @__PURE__ */ f.jsx(y.Fragment, {
    children: t.map((r) => /* @__PURE__ */ f.jsx(Yfe, {
      slots: n,
      slotProps: o,
      label: r.label,
      id: r.id,
      itemId: r.itemId,
      itemsToRender: r.children
    }, r.itemId))
  });
}
const Xfe = o8(), Jfe = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"]
  }, Dfe, t);
}, Qfe = B("ul", {
  name: "MuiRichTreeView",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: 0,
  margin: 0,
  listStyle: "none",
  outline: 0,
  position: "relative"
}), u8 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = Xfe({
    props: t,
    name: "MuiRichTreeView"
  });
  process.env.NODE_ENV !== "production" && o.children != null && hu(["MUI X: The Rich Tree View component does not support JSX children.", "If you want to add items, you need to use the `items` prop.", "Check the documentation for more details: https://mui.com/x/react-tree-view/rich-tree-view/items/."]);
  const {
    getRootProps: r,
    contextValue: i,
    instance: s
  } = Cfe({
    plugins: Afe,
    rootRef: n,
    props: o
  }), {
    slots: a,
    slotProps: c
  } = o, d = Jfe(o), u = (a == null ? void 0 : a.root) ?? Qfe, p = Ft({
    elementType: u,
    externalSlotProps: c == null ? void 0 : c.root,
    className: d.root,
    getSlotProps: r,
    ownerState: o
  });
  return /* @__PURE__ */ f.jsx(xfe, {
    value: i,
    children: /* @__PURE__ */ f.jsx(u, T({}, p, {
      children: /* @__PURE__ */ f.jsx(YE, {
        slots: a,
        slotProps: c,
        itemsToRender: s.getItemsToRender()
      })
    }))
  });
});
process.env.NODE_ENV !== "production" && (u8.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The ref object that allows Tree View manipulation. Can be instantiated with `useTreeViewApiRef()`.
   */
  apiRef: l.shape({
    current: l.shape({
      focusItem: l.func.isRequired,
      getItem: l.func.isRequired,
      getItemDOMElement: l.func.isRequired,
      getItemOrderedChildrenIds: l.func.isRequired,
      getItemTree: l.func.isRequired,
      selectItem: l.func.isRequired,
      setItemExpansion: l.func.isRequired,
      updateItemLabel: l.func.isRequired
    })
  }),
  /**
   * If `true`, the Tree View renders a checkbox at the left of its label that allows selecting it.
   * @default false
   */
  checkboxSelection: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  className: l.string,
  /**
   * Expanded item ids.
   * Used when the item's expansion is not controlled.
   * @default []
   */
  defaultExpandedItems: l.arrayOf(l.string),
  /**
   * Selected item ids. (Uncontrolled)
   * When `multiSelect` is true this takes an array of strings; when false (default) a string.
   * @default []
   */
  defaultSelectedItems: l.any,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: l.bool,
  /**
   * If `true` selection is disabled.
   * @default false
   */
  disableSelection: l.bool,
  /**
   * Expanded item ids.
   * Used when the item's expansion is controlled.
   */
  expandedItems: l.arrayOf(l.string),
  /**
   * The slot that triggers the item's expansion when clicked.
   * @default 'content'
   */
  expansionTrigger: l.oneOf(["content", "iconContainer"]),
  /**
   * Unstable features, breaking changes might be introduced.
   * For each feature, if the flag is not explicitly set to `true`,
   * the feature will be fully disabled and any property / method call will not have any effect.
   */
  experimentalFeatures: l.shape({
    indentationAtItemLevel: l.bool,
    labelEditing: l.bool
  }),
  /**
   * Used to determine the id of a given item.
   *
   * @template R
   * @param {R} item The item to check.
   * @returns {string} The id of the item.
   * @default (item) => item.id
   */
  getItemId: l.func,
  /**
   * Used to determine the string label for a given item.
   *
   * @template R
   * @param {R} item The item to check.
   * @returns {string} The label of the item.
   * @default (item) => item.label
   */
  getItemLabel: l.func,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: l.string,
  /**
   * Used to determine if a given item should be disabled.
   * @template R
   * @param {R} item The item to check.
   * @returns {boolean} `true` if the item should be disabled.
   */
  isItemDisabled: l.func,
  /**
   * Determines if a given item is editable or not.
   * Make sure to also enable the `labelEditing` experimental feature:
   * `<RichTreeViewPro experimentalFeatures={{ labelEditing: true }}  />`.
   * By default, the items are not editable.
   * @template R
   * @param {R} item The item to check.
   * @returns {boolean} `true` if the item is editable.
   */
  isItemEditable: l.oneOfType([l.func, l.bool]),
  /**
   * Horizontal indentation between an item and its children.
   * Examples: 24, "24px", "2rem", "2em".
   * @default 12px
   */
  itemChildrenIndentation: l.oneOfType([l.number, l.string]),
  items: l.array.isRequired,
  /**
   * If `true`, `ctrl` and `shift` will trigger multiselect.
   * @default false
   */
  multiSelect: l.bool,
  /**
   * Callback fired when Tree Items are expanded/collapsed.
   * @param {React.SyntheticEvent} event The DOM event that triggered the change.
   * @param {array} itemIds The ids of the expanded items.
   */
  onExpandedItemsChange: l.func,
  /**
   * Callback fired when the `content` slot of a given Tree Item is clicked.
   * @param {React.MouseEvent} event The DOM event that triggered the change.
   * @param {string} itemId The id of the focused item.
   */
  onItemClick: l.func,
  /**
   * Callback fired when a Tree Item is expanded or collapsed.
   * @param {React.SyntheticEvent} event The DOM event that triggered the change.
   * @param {array} itemId The itemId of the modified item.
   * @param {array} isExpanded `true` if the item has just been expanded, `false` if it has just been collapsed.
   */
  onItemExpansionToggle: l.func,
  /**
   * Callback fired when a given Tree Item is focused.
   * @param {React.SyntheticEvent | null} event The DOM event that triggered the change. **Warning**: This is a generic event not a focus event.
   * @param {string} itemId The id of the focused item.
   */
  onItemFocus: l.func,
  /**
   * Callback fired when the label of an item changes.
   * @param {TreeViewItemId} itemId The id of the item that was edited.
   * @param {string} newLabel The new label of the items.
   */
  onItemLabelChange: l.func,
  /**
   * Callback fired when a Tree Item is selected or deselected.
   * @param {React.SyntheticEvent} event The DOM event that triggered the change.
   * @param {array} itemId The itemId of the modified item.
   * @param {array} isSelected `true` if the item has just been selected, `false` if it has just been deselected.
   */
  onItemSelectionToggle: l.func,
  /**
   * Callback fired when Tree Items are selected/deselected.
   * @param {React.SyntheticEvent} event The DOM event that triggered the change.
   * @param {string[] | string} itemIds The ids of the selected items.
   * When `multiSelect` is `true`, this is an array of strings; when false (default) a string.
   */
  onSelectedItemsChange: l.func,
  /**
   * Selected item ids. (Controlled)
   * When `multiSelect` is true this takes an array of strings; when false (default) a string.
   */
  selectedItems: l.any,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const XE = (e) => Array.isArray(e) ? e.length > 0 && e.some(XE) : !!e, e6e = ({
  itemId: e,
  children: t
}) => {
  const {
    instance: n,
    selection: {
      multiSelect: o
    },
    publicAPI: r
  } = $a(), i = {
    expandable: XE(t),
    expanded: n.isItemExpanded(e),
    focused: n.isItemFocused(e),
    selected: n.isItemSelected(e),
    disabled: n.isItemDisabled(e),
    editing: n != null && n.isItemBeingEdited ? n == null ? void 0 : n.isItemBeingEdited(e) : !1,
    editable: n.isItemEditable ? n.isItemEditable(e) : !1
  }, s = (g) => {
    if (i.disabled)
      return;
    i.focused || n.focusItem(g, e);
    const m = o && (g.shiftKey || g.ctrlKey || g.metaKey);
    i.expandable && !(m && n.isItemExpanded(e)) && n.toggleItemExpansion(g, e);
  }, a = (g) => {
    if (i.disabled)
      return;
    i.focused || n.focusItem(g, e), o && (g.shiftKey || g.ctrlKey || g.metaKey) ? g.shiftKey ? n.expandSelectionRange(g, e) : n.selectItem({
      event: g,
      itemId: e,
      keepExistingSelection: !0
    }) : n.selectItem({
      event: g,
      itemId: e,
      shouldBeSelected: !0
    });
  }, c = (g) => {
    const m = g.nativeEvent.shiftKey;
    o && m ? n.expandSelectionRange(g, e) : n.selectItem({
      event: g,
      itemId: e,
      keepExistingSelection: o,
      shouldBeSelected: g.target.checked
    });
  }, d = () => {
    da(n, br) && n.isItemEditable(e) && (n.isItemBeingEdited(e) ? n.setEditedItemId(null) : n.setEditedItemId(e));
  };
  return {
    interactions: {
      handleExpansion: s,
      handleSelection: a,
      handleCheckboxSelection: c,
      toggleItemEditing: d,
      handleSaveItemLabel: (g, m) => {
        da(n, br) && n.isItemBeingEditedRef(e) && (n.updateItemLabel(e, m), d(), n.focusItem(g, e));
      },
      handleCancelItemLabelEditing: (g) => {
        da(n, br) && n.isItemBeingEditedRef(e) && (d(), n.focusItem(g, e));
      }
    },
    status: i,
    publicAPI: r
  };
}, t6e = (e) => {
  const {
    runItemPlugins: t,
    items: {
      onItemClick: n,
      disabledItemsFocusable: o,
      indentationAtItemLevel: r
    },
    selection: {
      disableSelection: i,
      checkboxSelection: s
    },
    expansion: {
      expansionTrigger: a
    },
    treeId: c,
    instance: d,
    publicAPI: u
  } = $a(), p = y.useContext(lf), {
    id: h,
    itemId: g,
    label: m,
    children: b,
    rootRef: C
  } = e, {
    rootRef: x,
    contentRef: v,
    propsEnhancers: S
  } = t(e), {
    interactions: M,
    status: w
  } = e6e({
    itemId: g,
    children: b
  }), k = y.useRef(null), E = y.useRef(null), R = Tt(C, x, k), O = Tt(v, E), P = y.useRef(null), _ = r8({
    itemId: g,
    treeId: c,
    id: h
  }), L = d.canItemBeTabbed(g) ? 0 : -1, V = {
    rootRefObject: k,
    contentRefObject: E,
    interactions: M
  }, j = (U) => (W) => {
    var X;
    if ((X = U.onFocus) == null || X.call(U, W), W.defaultMuiPrevented)
      return;
    const D = !w.disabled || o;
    !w.focused && D && W.currentTarget === W.target && d.focusItem(W, g);
  }, I = (U) => (W) => {
    var X, de, ue, he, Ue;
    if ((X = U.onBlur) == null || X.call(U, W), W.defaultMuiPrevented)
      return;
    const D = d.getItemDOMElement(g);
    w.editing || // we can exit the editing state by clicking outside the input (within the Tree Item) or by pressing Enter or Escape -> we don't want to remove the focused item from the state in these cases
    // we can also exit the editing state by clicking on the root itself -> want to remove the focused item from the state in this case
    W.relatedTarget && t0(W.relatedTarget, D) && (W.target && ((ue = (de = W.target) == null ? void 0 : de.dataset) == null ? void 0 : ue.element) === "labelInput" && t0(W.target, D) || ((Ue = (he = W.relatedTarget) == null ? void 0 : he.dataset) == null ? void 0 : Ue.element) === "labelInput") || d.removeFocusedItem();
  }, F = (U) => (W) => {
    var D, X, de;
    (D = U.onKeyDown) == null || D.call(U, W), !(W.defaultMuiPrevented || ((de = (X = W.target) == null ? void 0 : X.dataset) == null ? void 0 : de.element) === "labelInput") && d.handleItemKeyDown(W, g);
  }, $ = (U) => (W) => {
    var D;
    (D = U.onDoubleClick) == null || D.call(U, W), !W.defaultMuiPrevented && M.toggleItemEditing();
  }, A = (U) => (W) => {
    var D, X;
    (D = U.onClick) == null || D.call(U, W), n == null || n(W, g), !(W.defaultMuiPrevented || (X = P.current) != null && X.contains(W.target)) && (a === "content" && M.handleExpansion(W), s || M.handleSelection(W));
  }, H = (U) => (W) => {
    var D;
    (D = U.onMouseDown) == null || D.call(U, W), !W.defaultMuiPrevented && (W.shiftKey || W.ctrlKey || W.metaKey || w.disabled) && W.preventDefault();
  }, N = (U) => (W) => {
    var D;
    (D = U.onChange) == null || D.call(U, W), !W.defaultMuiPrevented && (i || w.disabled || M.handleCheckboxSelection(W));
  }, z = (U) => (W) => {
    var D;
    (D = U.onClick) == null || D.call(U, W), !W.defaultMuiPrevented && a === "iconContainer" && M.handleExpansion(W);
  };
  return {
    getRootProps: (U = {}) => {
      var ue;
      const W = T({}, lo(e), lo(U));
      let D;
      w.selected ? D = !0 : i || w.disabled ? D = void 0 : D = !1;
      const X = T({}, W, {
        ref: R,
        role: "treeitem",
        tabIndex: L,
        id: _,
        "aria-expanded": w.expandable ? w.expanded : void 0,
        "aria-selected": D,
        "aria-disabled": w.disabled || void 0
      }, U, {
        onFocus: j(W),
        onBlur: I(W),
        onKeyDown: F(W)
      });
      r && (X.style = {
        "--TreeView-itemDepth": typeof p == "function" ? p(g) : p
      });
      const de = ((ue = S.root) == null ? void 0 : ue.call(S, T({}, V, {
        externalEventHandlers: W
      }))) ?? {};
      return T({}, X, de);
    },
    getContentProps: (U = {}) => {
      var de;
      const W = lo(U), D = T({}, W, U, {
        ref: O,
        onClick: A(W),
        onMouseDown: H(W),
        status: w
      });
      r && (D.indentationAtItemLevel = !0);
      const X = ((de = S.content) == null ? void 0 : de.call(S, T({}, V, {
        externalEventHandlers: W
      }))) ?? {};
      return T({}, D, X);
    },
    getGroupTransitionProps: (U = {}) => {
      const W = lo(U), D = T({}, W, {
        unmountOnExit: !0,
        component: "ul",
        role: "group",
        in: w.expanded,
        children: b
      }, U);
      return r && (D.indentationAtItemLevel = !0), D;
    },
    getIconContainerProps: (U = {}) => {
      const W = lo(U);
      return T({}, W, U, {
        onClick: z(W)
      });
    },
    getCheckboxProps: (U = {}) => {
      const W = lo(U);
      return T({}, W, {
        visible: s,
        ref: P,
        checked: w.selected,
        disabled: i || w.disabled,
        tabIndex: -1
      }, U, {
        onChange: N(W)
      });
    },
    getLabelProps: (U = {}) => {
      const W = T({}, lo(U)), D = T({}, W, {
        children: m
      }, U, {
        onDoubleClick: $(W)
      });
      return d.isTreeViewEditable && (D.editable = w.editable), D;
    },
    getLabelInputProps: (U = {}) => {
      var X;
      const W = lo(U), D = ((X = S.labelInput) == null ? void 0 : X.call(S, {
        rootRefObject: k,
        contentRefObject: E,
        externalEventHandlers: W,
        interactions: M
      })) ?? {};
      return T({}, U, D);
    },
    getDragAndDropOverlayProps: (U = {}) => {
      var X;
      const W = lo(U), D = ((X = S.dragAndDropOverlay) == null ? void 0 : X.call(S, T({}, V, {
        externalEventHandlers: W
      }))) ?? {};
      return T({}, U, D);
    },
    rootRef: R,
    status: w,
    publicAPI: u
  };
}, n6e = t6e;
function JE(e) {
  const {
    slots: t,
    slotProps: n,
    status: o
  } = e, r = $a(), i = T({}, r.icons.slots, {
    expandIcon: r.icons.slots.expandIcon ?? GE,
    collapseIcon: r.icons.slots.collapseIcon ?? qE
  }), s = r.icons.slotProps;
  let a;
  t != null && t.icon ? a = "icon" : o.expandable ? o.expanded ? a = "collapseIcon" : a = "expandIcon" : a = "endIcon";
  const c = (t == null ? void 0 : t[a]) ?? i[a], d = Ft({
    elementType: c,
    externalSlotProps: (u) => T({}, Kr(s[a], u), Kr(n == null ? void 0 : n[a], u)),
    // TODO: Add proper ownerState
    ownerState: {}
  });
  return c ? /* @__PURE__ */ f.jsx(c, T({}, d)) : null;
}
process.env.NODE_ENV !== "production" && (JE.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  status: l.shape({
    disabled: l.bool.isRequired,
    editable: l.bool.isRequired,
    editing: l.bool.isRequired,
    expandable: l.bool.isRequired,
    expanded: l.bool.isRequired,
    focused: l.bool.isRequired,
    selected: l.bool.isRequired
  }).isRequired
});
const o6e = ["visible"], r6e = ["id", "itemId", "label", "disabled", "children", "slots", "slotProps"], i6e = o8(), s6e = B("li", {
  name: "MuiTreeItem2",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  outline: 0
}), a6e = B("div", {
  name: "MuiTreeItem2",
  slot: "Content",
  overridesResolver: (e, t) => t.content,
  shouldForwardProp: (e) => T0(e) && e !== "status" && e !== "indentationAtItemLevel"
})(({
  theme: e
}) => ({
  padding: e.spacing(0.5, 1),
  borderRadius: e.shape.borderRadius,
  width: "100%",
  boxSizing: "border-box",
  // prevent width + padding to overflow
  position: "relative",
  display: "flex",
  alignItems: "center",
  gap: e.spacing(1),
  cursor: "pointer",
  WebkitTapHighlightColor: "transparent",
  "&:hover": {
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  variants: [{
    props: {
      indentationAtItemLevel: !0
    },
    style: {
      paddingLeft: `calc(${e.spacing(1)} + var(--TreeView-itemChildrenIndentation) * var(--TreeView-itemDepth))`
    }
  }, {
    props: ({
      status: t
    }) => t.disabled,
    style: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      backgroundColor: "transparent"
    }
  }, {
    props: ({
      status: t
    }) => t.focused,
    style: {
      backgroundColor: (e.vars || e).palette.action.focus
    }
  }, {
    props: ({
      status: t
    }) => t.selected,
    style: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : $t(e.palette.primary.main, e.palette.action.selectedOpacity),
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : $t(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : $t(e.palette.primary.main, e.palette.action.selectedOpacity)
        }
      }
    }
  }, {
    props: ({
      status: t
    }) => t.selected && t.focused,
    style: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : $t(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  }]
})), l6e = B("div", {
  name: "MuiTreeItem2",
  slot: "Label",
  overridesResolver: (e, t) => t.label,
  shouldForwardProp: (e) => T0(e) && e !== "editable"
})(({
  theme: e
}) => T({
  width: "100%",
  boxSizing: "border-box",
  // prevent width + padding to overflow
  // fixes overflow - see https://github.com/mui/material-ui/issues/27372
  minWidth: 0,
  position: "relative",
  overflow: "hidden"
}, e.typography.body1, {
  variants: [{
    props: ({
      editable: t
    }) => t,
    style: {
      paddingLeft: "2px"
    }
  }]
})), c6e = B("div", {
  name: "MuiTreeItem2",
  slot: "IconContainer",
  overridesResolver: (e, t) => t.iconContainer
})({
  width: 16,
  display: "flex",
  flexShrink: 0,
  justifyContent: "center",
  "& svg": {
    fontSize: 18
  }
}), d6e = B(Ts, {
  name: "MuiTreeItem2",
  slot: "GroupTransition",
  overridesResolver: (e, t) => t.groupTransition,
  shouldForwardProp: (e) => T0(e) && e !== "indentationAtItemLevel"
})({
  margin: 0,
  padding: 0,
  paddingLeft: "var(--TreeView-itemChildrenIndentation)",
  variants: [{
    props: {
      indentationAtItemLevel: !0
    },
    style: {
      paddingLeft: 0
    }
  }]
}), u6e = B(/* @__PURE__ */ y.forwardRef((e, t) => {
  const {
    visible: n
  } = e, o = le(e, o6e);
  return n ? /* @__PURE__ */ f.jsx(si, T({}, o, {
    ref: t
  })) : null;
}), {
  name: "MuiTreeItem2",
  slot: "Checkbox",
  overridesResolver: (e, t) => t.checkbox
})({
  padding: 0
}), f6e = (e) => {
  const {
    classes: t
  } = e;
  return Oe({
    root: ["root"],
    content: ["content"],
    expanded: ["expanded"],
    editing: ["editing"],
    editable: ["editable"],
    selected: ["selected"],
    focused: ["focused"],
    disabled: ["disabled"],
    iconContainer: ["iconContainer"],
    checkbox: ["checkbox"],
    label: ["label"],
    groupTransition: ["groupTransition"],
    labelInput: ["labelInput"],
    dragAndDropOverlay: ["dragAndDropOverlay"]
  }, UE, t);
}, QE = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const o = i6e({
    props: t,
    name: "MuiTreeItem2"
  }), {
    id: r,
    itemId: i,
    label: s,
    disabled: a,
    children: c,
    slots: d = {},
    slotProps: u = {}
  } = o, p = le(o, r6e), {
    getRootProps: h,
    getContentProps: g,
    getIconContainerProps: m,
    getCheckboxProps: b,
    getLabelProps: C,
    getGroupTransitionProps: x,
    getLabelInputProps: v,
    getDragAndDropOverlayProps: S,
    status: M
  } = n6e({
    id: r,
    itemId: i,
    children: c,
    label: s,
    disabled: a
  }), w = T({}, o, M), k = f6e(w), E = d.root ?? s6e, R = Ft({
    elementType: E,
    getSlotProps: h,
    externalForwardedProps: p,
    externalSlotProps: u.root,
    additionalProps: {
      ref: n
    },
    ownerState: {},
    className: k.root
  }), O = d.content ?? a6e, P = Ft({
    elementType: O,
    getSlotProps: g,
    externalSlotProps: u.content,
    ownerState: {},
    className: xe(k.content, M.expanded && k.expanded, M.selected && k.selected, M.focused && k.focused, M.disabled && k.disabled, M.editing && k.editing, M.editable && k.editable)
  }), _ = d.iconContainer ?? c6e, L = Ft({
    elementType: _,
    getSlotProps: m,
    externalSlotProps: u.iconContainer,
    ownerState: {},
    className: k.iconContainer
  }), V = d.label ?? l6e, j = Ft({
    elementType: V,
    getSlotProps: C,
    externalSlotProps: u.label,
    ownerState: {},
    className: k.label
  }), I = d.checkbox ?? u6e, F = Ft({
    elementType: I,
    getSlotProps: b,
    externalSlotProps: u.checkbox,
    ownerState: {},
    className: k.checkbox
  }), $ = d.groupTransition ?? void 0, A = Ft({
    elementType: $,
    getSlotProps: x,
    externalSlotProps: u.groupTransition,
    ownerState: {},
    className: k.groupTransition
  }), H = d.labelInput ?? WE, N = Ft({
    elementType: H,
    getSlotProps: v,
    externalSlotProps: u.labelInput,
    ownerState: {},
    className: k.labelInput
  }), z = d.dragAndDropOverlay ?? l8, se = Ft({
    elementType: z,
    getSlotProps: S,
    externalSlotProps: u.dragAndDropOverlay,
    ownerState: {},
    className: k.dragAndDropOverlay
  });
  return /* @__PURE__ */ f.jsx(d8, {
    itemId: i,
    children: /* @__PURE__ */ f.jsxs(E, T({}, R, {
      children: [/* @__PURE__ */ f.jsxs(O, T({}, P, {
        children: [/* @__PURE__ */ f.jsx(_, T({}, L, {
          children: /* @__PURE__ */ f.jsx(JE, {
            status: M,
            slots: d,
            slotProps: u
          })
        })), /* @__PURE__ */ f.jsx(I, T({}, F)), M.editing ? /* @__PURE__ */ f.jsx(H, T({}, N)) : /* @__PURE__ */ f.jsx(V, T({}, j)), /* @__PURE__ */ f.jsx(z, T({}, se))]
      })), c && /* @__PURE__ */ f.jsx(d6e, T({
        as: $
      }, A))]
    }))
  });
});
process.env.NODE_ENV !== "production" && (QE.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  className: l.string,
  /**
   * If `true`, the item is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * The id attribute of the item. If not provided, it will be generated.
   */
  id: l.string,
  /**
   * The id of the item.
   * Must be unique.
   */
  itemId: l.string.isRequired,
  /**
   * The label of the item.
   */
  label: l.node,
  /**
   * Callback fired when the item root is blurred.
   */
  onBlur: l.func,
  /**
   * This prop isn't supported.
   * Use the `onItemFocus` callback on the tree if you need to monitor an item's focus.
   */
  onFocus: v0,
  /**
   * Callback fired when a key is pressed on the keyboard and the tree is in focus.
   */
  onKeyDown: l.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object
});
const eR = () => y.useRef(void 0);
function S5(e, t) {
  for (const n of e)
    if (n.children) {
      if (n.children.some((o) => o.id === t))
        return n;
      {
        const o = S5(n.children, t);
        if (o)
          return o;
      }
    }
}
function tR(e, t) {
  const n = [];
  let o = S5(e, t);
  for (; o; )
    n.push(o.id), o = S5(e, o.id);
  return n;
}
const nR = (e) => e.flatMap(({ id: t, label: n, children: o }) => [{ id: t, label: n }, ...nR(o || [])]), p6e = (e) => {
  const { children: t, leaf: n, selected: o, searched: r } = e, i = n && o, s = o ? "body-bold" : "body", a = (d) => i ? d.palette.primary[600] : "inherit", c = r ? "yellow" : "inherit";
  return /* @__PURE__ */ f.jsxs(be, { direction: "row", alignItems: "start", gap: 0.5, children: [
    /* @__PURE__ */ f.jsx(oe, { variant: s, sx: { color: a, backgroundColor: c }, fontWeight: "inherit", children: t }),
    i && /* @__PURE__ */ f.jsx(J, { color: a, mt: "-1px", children: /* @__PURE__ */ f.jsx(_t, { icon: "check", size: 2.5 }) })
  ] });
}, h6e = B(QE)(({ theme: e }) => ({
  [`& .${zo.selected}`]: {
    background: "none",
    fontWeight: "bold"
  },
  [`& .${zo.selected}:hover, & .${zo.content}:hover`]: {
    background: e.custom.grey[300]
  },
  [`.${zo.content}:has(+ .${gV.root} .Mui-selected)`]: {
    fontWeight: "bold"
  }
})), oR = vs((e, t) => {
  const { selectedItem: n, itemId: o, isLeaf: r, searchedItemIds: i } = e, s = r(e.itemId), a = n === o, c = (i == null ? void 0 : i.includes(o)) ?? !1;
  return /* @__PURE__ */ f.jsx(
    h6e,
    {
      ref: t,
      ...e,
      slotProps: {
        label: { leaf: s, selected: a, searched: c }
      },
      slots: { label: p6e }
    }
  );
}), g6e = B("input")(() => ({})), rR = (e) => e.disabled ?? !1, Kye = (e) => {
  const { searchable: t = !1 } = e;
  return t ? /* @__PURE__ */ f.jsx(b6e, { ...e }) : /* @__PURE__ */ f.jsx(m6e, { ...e });
}, m6e = (e) => {
  const { items: t, onSelectedItem: n, defaultSelectedId: o } = e, r = eR(), [i, s] = Ae(o ?? null), a = (d) => {
    var u;
    return ((u = r.current) == null ? void 0 : u.getItemOrderedChildrenIds(d).length) === 0;
  }, c = (d, u) => {
    s(u), a(u) ? n(u) : n(null);
  };
  return /* @__PURE__ */ f.jsx(
    u8,
    {
      apiRef: r,
      items: t,
      defaultExpandedItems: tR(t, o || ""),
      isItemDisabled: rR,
      selectedItems: i,
      onSelectedItemsChange: c,
      slotProps: {
        item: { selectedItem: i, isLeaf: a }
      },
      slots: { item: oR }
    }
  );
}, b6e = (e) => {
  const { t } = ja(), { items: n, onSelectedItem: o, defaultSelectedId: r } = e, { getInputProps: i, groupedOptions: s, inputValue: a } = Fv({
    id: "treeview-filter",
    options: nR(n)
  }), { onFocus: c, ...d } = i(), u = !!a && s.length === 0, [p, h] = Ae(r ?? null), g = eR(), m = (S) => {
    var M;
    return ((M = g.current) == null ? void 0 : M.getItemOrderedChildrenIds(S).length) === 0;
  }, b = (S, M) => {
    h(M), m(M) ? o(M) : o(null);
  }, [C, x] = Ae(!0), v = !C && a ? { expandedItems: s.flatMap((S) => tR(n, S.id)) } : {};
  return /* @__PURE__ */ f.jsxs(be, { children: [
    /* @__PURE__ */ f.jsx(
      g6e,
      {
        ...d,
        onBlur: () => x(!0),
        onFocus: (S) => {
          c == null || c(S), x(!1);
        }
      }
    ),
    u ? /* @__PURE__ */ f.jsx("p", { children: t("component.select.noResultFound") }) : /* @__PURE__ */ f.jsx(
      u8,
      {
        apiRef: g,
        items: n,
        ...v,
        isItemDisabled: rR,
        selectedItems: p,
        onSelectedItemsChange: b,
        slotProps: {
          item: {
            selectedItem: p,
            isLeaf: m,
            searchedItemIds: a ? s.map((S) => S.id) : []
          }
        },
        slots: { item: oR }
      }
    )
  ] });
};
function Yn(e) {
  this.content = e;
}
Yn.prototype = {
  constructor: Yn,
  find: function(e) {
    for (var t = 0; t < this.content.length; t += 2)
      if (this.content[t] === e) return t;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(e) {
    var t = this.find(e);
    return t == -1 ? void 0 : this.content[t + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(e, t, n) {
    var o = n && n != e ? this.remove(n) : this, r = o.find(e), i = o.content.slice();
    return r == -1 ? i.push(n || e, t) : (i[r + 1] = t, n && (i[r] = n)), new Yn(i);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(e) {
    var t = this.find(e);
    if (t == -1) return this;
    var n = this.content.slice();
    return n.splice(t, 2), new Yn(n);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(e, t) {
    return new Yn([e, t].concat(this.remove(e).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(e, t) {
    var n = this.remove(e).content.slice();
    return n.push(e, t), new Yn(n);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(e, t, n) {
    var o = this.remove(t), r = o.content.slice(), i = o.find(e);
    return r.splice(i == -1 ? r.length : i, 0, t, n), new Yn(r);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(e) {
    for (var t = 0; t < this.content.length; t += 2)
      e(this.content[t], this.content[t + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(e) {
    return e = Yn.from(e), e.size ? new Yn(e.content.concat(this.subtract(e).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(e) {
    return e = Yn.from(e), e.size ? new Yn(this.subtract(e).content.concat(e.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(e) {
    var t = this;
    e = Yn.from(e);
    for (var n = 0; n < e.content.length; n += 2)
      t = t.remove(e.content[n]);
    return t;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var e = {};
    return this.forEach(function(t, n) {
      e[t] = n;
    }), e;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
Yn.from = function(e) {
  if (e instanceof Yn) return e;
  var t = [];
  if (e) for (var n in e) t.push(n, e[n]);
  return new Yn(t);
};
function iR(e, t, n) {
  for (let o = 0; ; o++) {
    if (o == e.childCount || o == t.childCount)
      return e.childCount == t.childCount ? null : n;
    let r = e.child(o), i = t.child(o);
    if (r == i) {
      n += r.nodeSize;
      continue;
    }
    if (!r.sameMarkup(i))
      return n;
    if (r.isText && r.text != i.text) {
      for (let s = 0; r.text[s] == i.text[s]; s++)
        n++;
      return n;
    }
    if (r.content.size || i.content.size) {
      let s = iR(r.content, i.content, n + 1);
      if (s != null)
        return s;
    }
    n += r.nodeSize;
  }
}
function sR(e, t, n, o) {
  for (let r = e.childCount, i = t.childCount; ; ) {
    if (r == 0 || i == 0)
      return r == i ? null : { a: n, b: o };
    let s = e.child(--r), a = t.child(--i), c = s.nodeSize;
    if (s == a) {
      n -= c, o -= c;
      continue;
    }
    if (!s.sameMarkup(a))
      return { a: n, b: o };
    if (s.isText && s.text != a.text) {
      let d = 0, u = Math.min(s.text.length, a.text.length);
      for (; d < u && s.text[s.text.length - d - 1] == a.text[a.text.length - d - 1]; )
        d++, n--, o--;
      return { a: n, b: o };
    }
    if (s.content.size || a.content.size) {
      let d = sR(s.content, a.content, n - 1, o - 1);
      if (d)
        return d;
    }
    n -= c, o -= c;
  }
}
class je {
  /**
  @internal
  */
  constructor(t, n) {
    if (this.content = t, this.size = n || 0, n == null)
      for (let o = 0; o < t.length; o++)
        this.size += t[o].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(t, n, o, r = 0, i) {
    for (let s = 0, a = 0; a < n; s++) {
      let c = this.content[s], d = a + c.nodeSize;
      if (d > t && o(c, r + a, i || null, s) !== !1 && c.content.size) {
        let u = a + 1;
        c.nodesBetween(Math.max(0, t - u), Math.min(c.content.size, n - u), o, r + u);
      }
      a = d;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(t) {
    this.nodesBetween(0, this.size, t);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(t, n, o, r) {
    let i = "", s = !0;
    return this.nodesBetween(t, n, (a, c) => {
      let d = a.isText ? a.text.slice(Math.max(t, c) - c, n - c) : a.isLeaf ? r ? typeof r == "function" ? r(a) : r : a.type.spec.leafText ? a.type.spec.leafText(a) : "" : "";
      a.isBlock && (a.isLeaf && d || a.isTextblock) && o && (s ? s = !1 : i += o), i += d;
    }, 0), i;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(t) {
    if (!t.size)
      return this;
    if (!this.size)
      return t;
    let n = this.lastChild, o = t.firstChild, r = this.content.slice(), i = 0;
    for (n.isText && n.sameMarkup(o) && (r[r.length - 1] = n.withText(n.text + o.text), i = 1); i < t.content.length; i++)
      r.push(t.content[i]);
    return new je(r, this.size + t.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(t, n = this.size) {
    if (t == 0 && n == this.size)
      return this;
    let o = [], r = 0;
    if (n > t)
      for (let i = 0, s = 0; s < n; i++) {
        let a = this.content[i], c = s + a.nodeSize;
        c > t && ((s < t || c > n) && (a.isText ? a = a.cut(Math.max(0, t - s), Math.min(a.text.length, n - s)) : a = a.cut(Math.max(0, t - s - 1), Math.min(a.content.size, n - s - 1))), o.push(a), r += a.nodeSize), s = c;
      }
    return new je(o, r);
  }
  /**
  @internal
  */
  cutByIndex(t, n) {
    return t == n ? je.empty : t == 0 && n == this.content.length ? this : new je(this.content.slice(t, n));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(t, n) {
    let o = this.content[t];
    if (o == n)
      return this;
    let r = this.content.slice(), i = this.size + n.nodeSize - o.nodeSize;
    return r[t] = n, new je(r, i);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(t) {
    return new je([t].concat(this.content), this.size + t.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(t) {
    return new je(this.content.concat(t), this.size + t.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(t) {
    if (this.content.length != t.content.length)
      return !1;
    for (let n = 0; n < this.content.length; n++)
      if (!this.content[n].eq(t.content[n]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(t) {
    let n = this.content[t];
    if (!n)
      throw new RangeError("Index " + t + " out of range for " + this);
    return n;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(t) {
    return this.content[t] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(t) {
    for (let n = 0, o = 0; n < this.content.length; n++) {
      let r = this.content[n];
      t(r, o, n), o += r.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(t, n = 0) {
    return iR(this, t, n);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(t, n = this.size, o = t.size) {
    return sR(this, t, n, o);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(t, n = -1) {
    if (t == 0)
      return G1(0, t);
    if (t == this.size)
      return G1(this.content.length, t);
    if (t > this.size || t < 0)
      throw new RangeError(`Position ${t} outside of fragment (${this})`);
    for (let o = 0, r = 0; ; o++) {
      let i = this.child(o), s = r + i.nodeSize;
      if (s >= t)
        return s == t || n > 0 ? G1(o + 1, s) : G1(o, r);
      r = s;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((t) => t.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(t, n) {
    if (!n)
      return je.empty;
    if (!Array.isArray(n))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new je(n.map(t.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(t) {
    if (!t.length)
      return je.empty;
    let n, o = 0;
    for (let r = 0; r < t.length; r++) {
      let i = t[r];
      o += i.nodeSize, r && i.isText && t[r - 1].sameMarkup(i) ? (n || (n = t.slice(0, r)), n[n.length - 1] = i.withText(n[n.length - 1].text + i.text)) : n && n.push(i);
    }
    return new je(n || t, o);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(t) {
    if (!t)
      return je.empty;
    if (t instanceof je)
      return t;
    if (Array.isArray(t))
      return this.fromArray(t);
    if (t.attrs)
      return new je([t], t.nodeSize);
    throw new RangeError("Can not convert " + t + " to a Fragment" + (t.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
je.empty = new je([], 0);
const B6 = { index: 0, offset: 0 };
function G1(e, t) {
  return B6.index = e, B6.offset = t, B6;
}
function gu(e, t) {
  if (e === t)
    return !0;
  if (!(e && typeof e == "object") || !(t && typeof t == "object"))
    return !1;
  let n = Array.isArray(e);
  if (Array.isArray(t) != n)
    return !1;
  if (n) {
    if (e.length != t.length)
      return !1;
    for (let o = 0; o < e.length; o++)
      if (!gu(e[o], t[o]))
        return !1;
  } else {
    for (let o in e)
      if (!(o in t) || !gu(e[o], t[o]))
        return !1;
    for (let o in t)
      if (!(o in e))
        return !1;
  }
  return !0;
}
let an = class M5 {
  /**
  @internal
  */
  constructor(t, n) {
    this.type = t, this.attrs = n;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(t) {
    let n, o = !1;
    for (let r = 0; r < t.length; r++) {
      let i = t[r];
      if (this.eq(i))
        return t;
      if (this.type.excludes(i.type))
        n || (n = t.slice(0, r));
      else {
        if (i.type.excludes(this.type))
          return t;
        !o && i.type.rank > this.type.rank && (n || (n = t.slice(0, r)), n.push(this), o = !0), n && n.push(i);
      }
    }
    return n || (n = t.slice()), o || n.push(this), n;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(t) {
    for (let n = 0; n < t.length; n++)
      if (this.eq(t[n]))
        return t.slice(0, n).concat(t.slice(n + 1));
    return t;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(t) {
    for (let n = 0; n < t.length; n++)
      if (this.eq(t[n]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(t) {
    return this == t || this.type == t.type && gu(this.attrs, t.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let t = { type: this.type.name };
    for (let n in this.attrs) {
      t.attrs = this.attrs;
      break;
    }
    return t;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(t, n) {
    if (!n)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let o = t.marks[n.type];
    if (!o)
      throw new RangeError(`There is no mark type ${n.type} in this schema`);
    let r = o.create(n.attrs);
    return o.checkAttrs(r.attrs), r;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(t, n) {
    if (t == n)
      return !0;
    if (t.length != n.length)
      return !1;
    for (let o = 0; o < t.length; o++)
      if (!t[o].eq(n[o]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(t) {
    if (!t || Array.isArray(t) && t.length == 0)
      return M5.none;
    if (t instanceof M5)
      return [t];
    let n = t.slice();
    return n.sort((o, r) => o.type.rank - r.type.rank), n;
  }
};
an.none = [];
class mu extends Error {
}
class et {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(t, n, o) {
    this.content = t, this.openStart = n, this.openEnd = o;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(t, n) {
    let o = lR(this.content, t + this.openStart, n);
    return o && new et(o, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(t, n) {
    return new et(aR(this.content, t + this.openStart, n + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(t) {
    return this.content.eq(t.content) && this.openStart == t.openStart && this.openEnd == t.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let t = { content: this.content.toJSON() };
    return this.openStart > 0 && (t.openStart = this.openStart), this.openEnd > 0 && (t.openEnd = this.openEnd), t;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(t, n) {
    if (!n)
      return et.empty;
    let o = n.openStart || 0, r = n.openEnd || 0;
    if (typeof o != "number" || typeof r != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new et(je.fromJSON(t, n.content), o, r);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(t, n = !0) {
    let o = 0, r = 0;
    for (let i = t.firstChild; i && !i.isLeaf && (n || !i.type.spec.isolating); i = i.firstChild)
      o++;
    for (let i = t.lastChild; i && !i.isLeaf && (n || !i.type.spec.isolating); i = i.lastChild)
      r++;
    return new et(t, o, r);
  }
}
et.empty = new et(je.empty, 0, 0);
function aR(e, t, n) {
  let { index: o, offset: r } = e.findIndex(t), i = e.maybeChild(o), { index: s, offset: a } = e.findIndex(n);
  if (r == t || i.isText) {
    if (a != n && !e.child(s).isText)
      throw new RangeError("Removing non-flat range");
    return e.cut(0, t).append(e.cut(n));
  }
  if (o != s)
    throw new RangeError("Removing non-flat range");
  return e.replaceChild(o, i.copy(aR(i.content, t - r - 1, n - r - 1)));
}
function lR(e, t, n, o) {
  let { index: r, offset: i } = e.findIndex(t), s = e.maybeChild(r);
  if (i == t || s.isText)
    return e.cut(0, t).append(n).append(e.cut(t));
  let a = lR(s.content, t - i - 1, n);
  return a && e.replaceChild(r, s.copy(a));
}
function C6e(e, t, n) {
  if (n.openStart > e.depth)
    throw new mu("Inserted content deeper than insertion position");
  if (e.depth - n.openStart != t.depth - n.openEnd)
    throw new mu("Inconsistent open depths");
  return cR(e, t, n, 0);
}
function cR(e, t, n, o) {
  let r = e.index(o), i = e.node(o);
  if (r == t.index(o) && o < e.depth - n.openStart) {
    let s = cR(e, t, n, o + 1);
    return i.copy(i.content.replaceChild(r, s));
  } else if (n.content.size)
    if (!n.openStart && !n.openEnd && e.depth == o && t.depth == o) {
      let s = e.parent, a = s.content;
      return fa(s, a.cut(0, e.parentOffset).append(n.content).append(a.cut(t.parentOffset)));
    } else {
      let { start: s, end: a } = x6e(n, e);
      return fa(i, uR(e, s, a, t, o));
    }
  else return fa(i, bu(e, t, o));
}
function dR(e, t) {
  if (!t.type.compatibleContent(e.type))
    throw new mu("Cannot join " + t.type.name + " onto " + e.type.name);
}
function T5(e, t, n) {
  let o = e.node(n);
  return dR(o, t.node(n)), o;
}
function ua(e, t) {
  let n = t.length - 1;
  n >= 0 && e.isText && e.sameMarkup(t[n]) ? t[n] = e.withText(t[n].text + e.text) : t.push(e);
}
function yc(e, t, n, o) {
  let r = (t || e).node(n), i = 0, s = t ? t.index(n) : r.childCount;
  e && (i = e.index(n), e.depth > n ? i++ : e.textOffset && (ua(e.nodeAfter, o), i++));
  for (let a = i; a < s; a++)
    ua(r.child(a), o);
  t && t.depth == n && t.textOffset && ua(t.nodeBefore, o);
}
function fa(e, t) {
  return e.type.checkContent(t), e.copy(t);
}
function uR(e, t, n, o, r) {
  let i = e.depth > r && T5(e, t, r + 1), s = o.depth > r && T5(n, o, r + 1), a = [];
  return yc(null, e, r, a), i && s && t.index(r) == n.index(r) ? (dR(i, s), ua(fa(i, uR(e, t, n, o, r + 1)), a)) : (i && ua(fa(i, bu(e, t, r + 1)), a), yc(t, n, r, a), s && ua(fa(s, bu(n, o, r + 1)), a)), yc(o, null, r, a), new je(a);
}
function bu(e, t, n) {
  let o = [];
  if (yc(null, e, n, o), e.depth > n) {
    let r = T5(e, t, n + 1);
    ua(fa(r, bu(e, t, n + 1)), o);
  }
  return yc(t, null, n, o), new je(o);
}
function x6e(e, t) {
  let n = t.depth - e.openStart, r = t.node(n).copy(e.content);
  for (let i = n - 1; i >= 0; i--)
    r = t.node(i).copy(je.from(r));
  return {
    start: r.resolveNoCache(e.openStart + n),
    end: r.resolveNoCache(r.content.size - e.openEnd - n)
  };
}
class n0 {
  /**
  @internal
  */
  constructor(t, n, o) {
    this.pos = t, this.path = n, this.parentOffset = o, this.depth = n.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(t) {
    return t == null ? this.depth : t < 0 ? this.depth + t : t;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(t) {
    return this.path[this.resolveDepth(t) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(t) {
    return this.path[this.resolveDepth(t) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(t) {
    return t = this.resolveDepth(t), this.index(t) + (t == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(t) {
    return t = this.resolveDepth(t), t == 0 ? 0 : this.path[t * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(t) {
    return t = this.resolveDepth(t), this.start(t) + this.node(t).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(t) {
    if (t = this.resolveDepth(t), !t)
      throw new RangeError("There is no position before the top-level node");
    return t == this.depth + 1 ? this.pos : this.path[t * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(t) {
    if (t = this.resolveDepth(t), !t)
      throw new RangeError("There is no position after the top-level node");
    return t == this.depth + 1 ? this.pos : this.path[t * 3 - 1] + this.path[t * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let t = this.parent, n = this.index(this.depth);
    if (n == t.childCount)
      return null;
    let o = this.pos - this.path[this.path.length - 1], r = t.child(n);
    return o ? t.child(n).cut(o) : r;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let t = this.index(this.depth), n = this.pos - this.path[this.path.length - 1];
    return n ? this.parent.child(t).cut(0, n) : t == 0 ? null : this.parent.child(t - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(t, n) {
    n = this.resolveDepth(n);
    let o = this.path[n * 3], r = n == 0 ? 0 : this.path[n * 3 - 1] + 1;
    for (let i = 0; i < t; i++)
      r += o.child(i).nodeSize;
    return r;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let t = this.parent, n = this.index();
    if (t.content.size == 0)
      return an.none;
    if (this.textOffset)
      return t.child(n).marks;
    let o = t.maybeChild(n - 1), r = t.maybeChild(n);
    if (!o) {
      let a = o;
      o = r, r = a;
    }
    let i = o.marks;
    for (var s = 0; s < i.length; s++)
      i[s].type.spec.inclusive === !1 && (!r || !i[s].isInSet(r.marks)) && (i = i[s--].removeFromSet(i));
    return i;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(t) {
    let n = this.parent.maybeChild(this.index());
    if (!n || !n.isInline)
      return null;
    let o = n.marks, r = t.parent.maybeChild(t.index());
    for (var i = 0; i < o.length; i++)
      o[i].type.spec.inclusive === !1 && (!r || !o[i].isInSet(r.marks)) && (o = o[i--].removeFromSet(o));
    return o;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(t) {
    for (let n = this.depth; n > 0; n--)
      if (this.start(n) <= t && this.end(n) >= t)
        return n;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(t = this, n) {
    if (t.pos < this.pos)
      return t.blockRange(this);
    for (let o = this.depth - (this.parent.inlineContent || this.pos == t.pos ? 1 : 0); o >= 0; o--)
      if (t.pos <= this.end(o) && (!n || n(this.node(o))))
        return new Cu(this, t, o);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(t) {
    return this.pos - this.parentOffset == t.pos - t.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(t) {
    return t.pos > this.pos ? t : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(t) {
    return t.pos < this.pos ? t : this;
  }
  /**
  @internal
  */
  toString() {
    let t = "";
    for (let n = 1; n <= this.depth; n++)
      t += (t ? "/" : "") + this.node(n).type.name + "_" + this.index(n - 1);
    return t + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(t, n) {
    if (!(n >= 0 && n <= t.content.size))
      throw new RangeError("Position " + n + " out of range");
    let o = [], r = 0, i = n;
    for (let s = t; ; ) {
      let { index: a, offset: c } = s.content.findIndex(i), d = i - c;
      if (o.push(s, a, r + c), !d || (s = s.child(a), s.isText))
        break;
      i = d - 1, r += c + 1;
    }
    return new n0(n, o, i);
  }
  /**
  @internal
  */
  static resolveCached(t, n) {
    let o = WC.get(t);
    if (o)
      for (let i = 0; i < o.elts.length; i++) {
        let s = o.elts[i];
        if (s.pos == n)
          return s;
      }
    else
      WC.set(t, o = new y6e());
    let r = o.elts[o.i] = n0.resolve(t, n);
    return o.i = (o.i + 1) % v6e, r;
  }
}
class y6e {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const v6e = 12, WC = /* @__PURE__ */ new WeakMap();
class Cu {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(t, n, o) {
    this.$from = t, this.$to = n, this.depth = o;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const w6e = /* @__PURE__ */ Object.create(null);
let ls = class k5 {
  /**
  @internal
  */
  constructor(t, n, o, r = an.none) {
    this.type = t, this.attrs = n, this.marks = r, this.content = o || je.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(t) {
    return this.content.child(t);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(t) {
    return this.content.maybeChild(t);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(t) {
    this.content.forEach(t);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(t, n, o, r = 0) {
    this.content.nodesBetween(t, n, o, r, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(t) {
    this.nodesBetween(0, this.content.size, t);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
  */
  textBetween(t, n, o, r) {
    return this.content.textBetween(t, n, o, r);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(t) {
    return this == t || this.sameMarkup(t) && this.content.eq(t.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(t) {
    return this.hasMarkup(t.type, t.attrs, t.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(t, n, o) {
    return this.type == t && gu(this.attrs, n || t.defaultAttrs || w6e) && an.sameSet(this.marks, o || an.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(t = null) {
    return t == this.content ? this : new k5(this.type, this.attrs, t, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(t) {
    return t == this.marks ? this : new k5(this.type, this.attrs, this.content, t);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(t, n = this.content.size) {
    return t == 0 && n == this.content.size ? this : this.copy(this.content.cut(t, n));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(t, n = this.content.size, o = !1) {
    if (t == n)
      return et.empty;
    let r = this.resolve(t), i = this.resolve(n), s = o ? 0 : r.sharedDepth(n), a = r.start(s), d = r.node(s).content.cut(r.pos - a, i.pos - a);
    return new et(d, r.depth - s, i.depth - s);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(t, n, o) {
    return C6e(this.resolve(t), this.resolve(n), o);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(t) {
    for (let n = this; ; ) {
      let { index: o, offset: r } = n.content.findIndex(t);
      if (n = n.maybeChild(o), !n)
        return null;
      if (r == t || n.isText)
        return n;
      t -= r + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(t) {
    let { index: n, offset: o } = this.content.findIndex(t);
    return { node: this.content.maybeChild(n), index: n, offset: o };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(t) {
    if (t == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: n, offset: o } = this.content.findIndex(t);
    if (o < t)
      return { node: this.content.child(n), index: n, offset: o };
    let r = this.content.child(n - 1);
    return { node: r, index: n - 1, offset: o - r.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(t) {
    return n0.resolveCached(this, t);
  }
  /**
  @internal
  */
  resolveNoCache(t) {
    return n0.resolve(this, t);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(t, n, o) {
    let r = !1;
    return n > t && this.nodesBetween(t, n, (i) => (o.isInSet(i.marks) && (r = !0), !r)), r;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let t = this.type.name;
    return this.content.size && (t += "(" + this.content.toStringInner() + ")"), fR(this.marks, t);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(t) {
    let n = this.type.contentMatch.matchFragment(this.content, 0, t);
    if (!n)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return n;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(t, n, o = je.empty, r = 0, i = o.childCount) {
    let s = this.contentMatchAt(t).matchFragment(o, r, i), a = s && s.matchFragment(this.content, n);
    if (!a || !a.validEnd)
      return !1;
    for (let c = r; c < i; c++)
      if (!this.type.allowsMarks(o.child(c).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(t, n, o, r) {
    if (r && !this.type.allowsMarks(r))
      return !1;
    let i = this.contentMatchAt(t).matchType(o), s = i && i.matchFragment(this.content, n);
    return s ? s.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(t) {
    return t.content.size ? this.canReplace(this.childCount, this.childCount, t.content) : this.type.compatibleContent(t.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let t = an.none;
    for (let n = 0; n < this.marks.length; n++) {
      let o = this.marks[n];
      o.type.checkAttrs(o.attrs), t = o.addToSet(t);
    }
    if (!an.sameSet(t, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((n) => n.type.name)}`);
    this.content.forEach((n) => n.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let t = { type: this.type.name };
    for (let n in this.attrs) {
      t.attrs = this.attrs;
      break;
    }
    return this.content.size && (t.content = this.content.toJSON()), this.marks.length && (t.marks = this.marks.map((n) => n.toJSON())), t;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(t, n) {
    if (!n)
      throw new RangeError("Invalid input for Node.fromJSON");
    let o;
    if (n.marks) {
      if (!Array.isArray(n.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      o = n.marks.map(t.markFromJSON);
    }
    if (n.type == "text") {
      if (typeof n.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return t.text(n.text, o);
    }
    let r = je.fromJSON(t, n.content), i = t.nodeType(n.type).create(n.attrs, r, o);
    return i.type.checkAttrs(i.attrs), i;
  }
};
ls.prototype.text = void 0;
class xu extends ls {
  /**
  @internal
  */
  constructor(t, n, o, r) {
    if (super(t, n, null, r), !o)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = o;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : fR(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(t, n) {
    return this.text.slice(t, n);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(t) {
    return t == this.marks ? this : new xu(this.type, this.attrs, this.text, t);
  }
  withText(t) {
    return t == this.text ? this : new xu(this.type, this.attrs, t, this.marks);
  }
  cut(t = 0, n = this.text.length) {
    return t == 0 && n == this.text.length ? this : this.withText(this.text.slice(t, n));
  }
  eq(t) {
    return this.sameMarkup(t) && this.text == t.text;
  }
  toJSON() {
    let t = super.toJSON();
    return t.text = this.text, t;
  }
}
function fR(e, t) {
  for (let n = e.length - 1; n >= 0; n--)
    t = e[n].type.name + "(" + t + ")";
  return t;
}
class Ea {
  /**
  @internal
  */
  constructor(t) {
    this.validEnd = t, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(t, n) {
    let o = new S6e(t, n);
    if (o.next == null)
      return Ea.empty;
    let r = pR(o);
    o.next && o.err("Unexpected trailing text");
    let i = _6e(O6e(r));
    return P6e(i, o), i;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(t) {
    for (let n = 0; n < this.next.length; n++)
      if (this.next[n].type == t)
        return this.next[n].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(t, n = 0, o = t.childCount) {
    let r = this;
    for (let i = n; r && i < o; i++)
      r = r.matchType(t.child(i).type);
    return r;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let t = 0; t < this.next.length; t++) {
      let { type: n } = this.next[t];
      if (!(n.isText || n.hasRequiredAttrs()))
        return n;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(t) {
    for (let n = 0; n < this.next.length; n++)
      for (let o = 0; o < t.next.length; o++)
        if (this.next[n].type == t.next[o].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(t, n = !1, o = 0) {
    let r = [this];
    function i(s, a) {
      let c = s.matchFragment(t, o);
      if (c && (!n || c.validEnd))
        return je.from(a.map((d) => d.createAndFill()));
      for (let d = 0; d < s.next.length; d++) {
        let { type: u, next: p } = s.next[d];
        if (!(u.isText || u.hasRequiredAttrs()) && r.indexOf(p) == -1) {
          r.push(p);
          let h = i(p, a.concat(u));
          if (h)
            return h;
        }
      }
      return null;
    }
    return i(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(t) {
    for (let o = 0; o < this.wrapCache.length; o += 2)
      if (this.wrapCache[o] == t)
        return this.wrapCache[o + 1];
    let n = this.computeWrapping(t);
    return this.wrapCache.push(t, n), n;
  }
  /**
  @internal
  */
  computeWrapping(t) {
    let n = /* @__PURE__ */ Object.create(null), o = [{ match: this, type: null, via: null }];
    for (; o.length; ) {
      let r = o.shift(), i = r.match;
      if (i.matchType(t)) {
        let s = [];
        for (let a = r; a.type; a = a.via)
          s.push(a.type);
        return s.reverse();
      }
      for (let s = 0; s < i.next.length; s++) {
        let { type: a, next: c } = i.next[s];
        !a.isLeaf && !a.hasRequiredAttrs() && !(a.name in n) && (!r.type || c.validEnd) && (o.push({ match: a.contentMatch, type: a, via: r }), n[a.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(t) {
    if (t >= this.next.length)
      throw new RangeError(`There's no ${t}th edge in this content match`);
    return this.next[t];
  }
  /**
  @internal
  */
  toString() {
    let t = [];
    function n(o) {
      t.push(o);
      for (let r = 0; r < o.next.length; r++)
        t.indexOf(o.next[r].next) == -1 && n(o.next[r].next);
    }
    return n(this), t.map((o, r) => {
      let i = r + (o.validEnd ? "*" : " ") + " ";
      for (let s = 0; s < o.next.length; s++)
        i += (s ? ", " : "") + o.next[s].type.name + "->" + t.indexOf(o.next[s].next);
      return i;
    }).join(`
`);
  }
}
Ea.empty = new Ea(!0);
class S6e {
  constructor(t, n) {
    this.string = t, this.nodeTypes = n, this.inline = null, this.pos = 0, this.tokens = t.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(t) {
    return this.next == t && (this.pos++ || !0);
  }
  err(t) {
    throw new SyntaxError(t + " (in content expression '" + this.string + "')");
  }
}
function pR(e) {
  let t = [];
  do
    t.push(M6e(e));
  while (e.eat("|"));
  return t.length == 1 ? t[0] : { type: "choice", exprs: t };
}
function M6e(e) {
  let t = [];
  do
    t.push(T6e(e));
  while (e.next && e.next != ")" && e.next != "|");
  return t.length == 1 ? t[0] : { type: "seq", exprs: t };
}
function T6e(e) {
  let t = R6e(e);
  for (; ; )
    if (e.eat("+"))
      t = { type: "plus", expr: t };
    else if (e.eat("*"))
      t = { type: "star", expr: t };
    else if (e.eat("?"))
      t = { type: "opt", expr: t };
    else if (e.eat("{"))
      t = k6e(e, t);
    else
      break;
  return t;
}
function UC(e) {
  /\D/.test(e.next) && e.err("Expected number, got '" + e.next + "'");
  let t = Number(e.next);
  return e.pos++, t;
}
function k6e(e, t) {
  let n = UC(e), o = n;
  return e.eat(",") && (e.next != "}" ? o = UC(e) : o = -1), e.eat("}") || e.err("Unclosed braced range"), { type: "range", min: n, max: o, expr: t };
}
function E6e(e, t) {
  let n = e.nodeTypes, o = n[t];
  if (o)
    return [o];
  let r = [];
  for (let i in n) {
    let s = n[i];
    s.isInGroup(t) && r.push(s);
  }
  return r.length == 0 && e.err("No node type or group '" + t + "' found"), r;
}
function R6e(e) {
  if (e.eat("(")) {
    let t = pR(e);
    return e.eat(")") || e.err("Missing closing paren"), t;
  } else if (/\W/.test(e.next))
    e.err("Unexpected token '" + e.next + "'");
  else {
    let t = E6e(e, e.next).map((n) => (e.inline == null ? e.inline = n.isInline : e.inline != n.isInline && e.err("Mixing inline and block content"), { type: "name", value: n }));
    return e.pos++, t.length == 1 ? t[0] : { type: "choice", exprs: t };
  }
}
function O6e(e) {
  let t = [[]];
  return r(i(e, 0), n()), t;
  function n() {
    return t.push([]) - 1;
  }
  function o(s, a, c) {
    let d = { term: c, to: a };
    return t[s].push(d), d;
  }
  function r(s, a) {
    s.forEach((c) => c.to = a);
  }
  function i(s, a) {
    if (s.type == "choice")
      return s.exprs.reduce((c, d) => c.concat(i(d, a)), []);
    if (s.type == "seq")
      for (let c = 0; ; c++) {
        let d = i(s.exprs[c], a);
        if (c == s.exprs.length - 1)
          return d;
        r(d, a = n());
      }
    else if (s.type == "star") {
      let c = n();
      return o(a, c), r(i(s.expr, c), c), [o(c)];
    } else if (s.type == "plus") {
      let c = n();
      return r(i(s.expr, a), c), r(i(s.expr, c), c), [o(c)];
    } else {
      if (s.type == "opt")
        return [o(a)].concat(i(s.expr, a));
      if (s.type == "range") {
        let c = a;
        for (let d = 0; d < s.min; d++) {
          let u = n();
          r(i(s.expr, c), u), c = u;
        }
        if (s.max == -1)
          r(i(s.expr, c), c);
        else
          for (let d = s.min; d < s.max; d++) {
            let u = n();
            o(c, u), r(i(s.expr, c), u), c = u;
          }
        return [o(c)];
      } else {
        if (s.type == "name")
          return [o(a, void 0, s.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function hR(e, t) {
  return t - e;
}
function GC(e, t) {
  let n = [];
  return o(t), n.sort(hR);
  function o(r) {
    let i = e[r];
    if (i.length == 1 && !i[0].term)
      return o(i[0].to);
    n.push(r);
    for (let s = 0; s < i.length; s++) {
      let { term: a, to: c } = i[s];
      !a && n.indexOf(c) == -1 && o(c);
    }
  }
}
function _6e(e) {
  let t = /* @__PURE__ */ Object.create(null);
  return n(GC(e, 0));
  function n(o) {
    let r = [];
    o.forEach((s) => {
      e[s].forEach(({ term: a, to: c }) => {
        if (!a)
          return;
        let d;
        for (let u = 0; u < r.length; u++)
          r[u][0] == a && (d = r[u][1]);
        GC(e, c).forEach((u) => {
          d || r.push([a, d = []]), d.indexOf(u) == -1 && d.push(u);
        });
      });
    });
    let i = t[o.join(",")] = new Ea(o.indexOf(e.length - 1) > -1);
    for (let s = 0; s < r.length; s++) {
      let a = r[s][1].sort(hR);
      i.next.push({ type: r[s][0], next: t[a.join(",")] || n(a) });
    }
    return i;
  }
}
function P6e(e, t) {
  for (let n = 0, o = [e]; n < o.length; n++) {
    let r = o[n], i = !r.validEnd, s = [];
    for (let a = 0; a < r.next.length; a++) {
      let { type: c, next: d } = r.next[a];
      s.push(c.name), i && !(c.isText || c.hasRequiredAttrs()) && (i = !1), o.indexOf(d) == -1 && o.push(d);
    }
    i && t.err("Only non-generatable nodes (" + s.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function gR(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let n in e) {
    let o = e[n];
    if (!o.hasDefault)
      return null;
    t[n] = o.default;
  }
  return t;
}
function mR(e, t) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let o in e) {
    let r = t && t[o];
    if (r === void 0) {
      let i = e[o];
      if (i.hasDefault)
        r = i.default;
      else
        throw new RangeError("No value supplied for attribute " + o);
    }
    n[o] = r;
  }
  return n;
}
function bR(e, t, n, o) {
  for (let r in t)
    if (!(r in e))
      throw new RangeError(`Unsupported attribute ${r} for ${n} of type ${r}`);
  for (let r in e) {
    let i = e[r];
    i.validate && i.validate(t[r]);
  }
}
function CR(e, t) {
  let n = /* @__PURE__ */ Object.create(null);
  if (t)
    for (let o in t)
      n[o] = new I6e(e, o, t[o]);
  return n;
}
let qC = class xR {
  /**
  @internal
  */
  constructor(t, n, o) {
    this.name = t, this.schema = n, this.spec = o, this.markSet = null, this.groups = o.group ? o.group.split(" ") : [], this.attrs = CR(t, o.attrs), this.defaultAttrs = gR(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(o.inline || t == "text"), this.isText = t == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == Ea.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(t) {
    return this.groups.indexOf(t) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let t in this.attrs)
      if (this.attrs[t].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(t) {
    return this == t || this.contentMatch.compatible(t.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(t) {
    return !t && this.defaultAttrs ? this.defaultAttrs : mR(this.attrs, t);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(t = null, n, o) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new ls(this, this.computeAttrs(t), je.from(n), an.setFrom(o));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(t = null, n, o) {
    return n = je.from(n), this.checkContent(n), new ls(this, this.computeAttrs(t), n, an.setFrom(o));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(t = null, n, o) {
    if (t = this.computeAttrs(t), n = je.from(n), n.size) {
      let s = this.contentMatch.fillBefore(n);
      if (!s)
        return null;
      n = s.append(n);
    }
    let r = this.contentMatch.matchFragment(n), i = r && r.fillBefore(je.empty, !0);
    return i ? new ls(this, t, n.append(i), an.setFrom(o)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(t) {
    let n = this.contentMatch.matchFragment(t);
    if (!n || !n.validEnd)
      return !1;
    for (let o = 0; o < t.childCount; o++)
      if (!this.allowsMarks(t.child(o).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(t) {
    if (!this.validContent(t))
      throw new RangeError(`Invalid content for node ${this.name}: ${t.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(t) {
    bR(this.attrs, t, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(t) {
    return this.markSet == null || this.markSet.indexOf(t) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(t) {
    if (this.markSet == null)
      return !0;
    for (let n = 0; n < t.length; n++)
      if (!this.allowsMarkType(t[n].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(t) {
    if (this.markSet == null)
      return t;
    let n;
    for (let o = 0; o < t.length; o++)
      this.allowsMarkType(t[o].type) ? n && n.push(t[o]) : n || (n = t.slice(0, o));
    return n ? n.length ? n : an.none : t;
  }
  /**
  @internal
  */
  static compile(t, n) {
    let o = /* @__PURE__ */ Object.create(null);
    t.forEach((i, s) => o[i] = new xR(i, n, s));
    let r = n.spec.topNode || "doc";
    if (!o[r])
      throw new RangeError("Schema is missing its top node type ('" + r + "')");
    if (!o.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let i in o.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return o;
  }
};
function L6e(e, t, n) {
  let o = n.split("|");
  return (r) => {
    let i = r === null ? "null" : typeof r;
    if (o.indexOf(i) < 0)
      throw new RangeError(`Expected value of type ${o} for attribute ${t} on type ${e}, got ${i}`);
  };
}
class I6e {
  constructor(t, n, o) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(o, "default"), this.default = o.default, this.validate = typeof o.validate == "string" ? L6e(t, n, o.validate) : o.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class uf {
  /**
  @internal
  */
  constructor(t, n, o, r) {
    this.name = t, this.rank = n, this.schema = o, this.spec = r, this.attrs = CR(t, r.attrs), this.excluded = null;
    let i = gR(this.attrs);
    this.instance = i ? new an(this, i) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(t = null) {
    return !t && this.instance ? this.instance : new an(this, mR(this.attrs, t));
  }
  /**
  @internal
  */
  static compile(t, n) {
    let o = /* @__PURE__ */ Object.create(null), r = 0;
    return t.forEach((i, s) => o[i] = new uf(i, r++, n, s)), o;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(t) {
    for (var n = 0; n < t.length; n++)
      t[n].type == this && (t = t.slice(0, n).concat(t.slice(n + 1)), n--);
    return t;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(t) {
    for (let n = 0; n < t.length; n++)
      if (t[n].type == this)
        return t[n];
  }
  /**
  @internal
  */
  checkAttrs(t) {
    bR(this.attrs, t, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(t) {
    return this.excluded.indexOf(t) > -1;
  }
}
class yR {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(t) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let n = this.spec = {};
    for (let r in t)
      n[r] = t[r];
    n.nodes = Yn.from(t.nodes), n.marks = Yn.from(t.marks || {}), this.nodes = qC.compile(this.spec.nodes, this), this.marks = uf.compile(this.spec.marks, this);
    let o = /* @__PURE__ */ Object.create(null);
    for (let r in this.nodes) {
      if (r in this.marks)
        throw new RangeError(r + " can not be both a node and a mark");
      let i = this.nodes[r], s = i.spec.content || "", a = i.spec.marks;
      if (i.contentMatch = o[s] || (o[s] = Ea.parse(s, this.nodes)), i.inlineContent = i.contentMatch.inlineContent, i.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!i.isInline || !i.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = i;
      }
      i.markSet = a == "_" ? null : a ? KC(this, a.split(" ")) : a == "" || !i.inlineContent ? [] : null;
    }
    for (let r in this.marks) {
      let i = this.marks[r], s = i.spec.excludes;
      i.excluded = s == null ? [i] : s == "" ? [] : KC(this, s.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(t, n = null, o, r) {
    if (typeof t == "string")
      t = this.nodeType(t);
    else if (t instanceof qC) {
      if (t.schema != this)
        throw new RangeError("Node type from different schema used (" + t.name + ")");
    } else throw new RangeError("Invalid node type: " + t);
    return t.createChecked(n, o, r);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(t, n) {
    let o = this.nodes.text;
    return new xu(o, o.defaultAttrs, t, an.setFrom(n));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(t, n) {
    return typeof t == "string" && (t = this.marks[t]), t.create(n);
  }
  /**
  Deserialize a node from its JSON representation. This method is
  bound.
  */
  nodeFromJSON(t) {
    return ls.fromJSON(this, t);
  }
  /**
  Deserialize a mark from its JSON representation. This method is
  bound.
  */
  markFromJSON(t) {
    return an.fromJSON(this, t);
  }
  /**
  @internal
  */
  nodeType(t) {
    let n = this.nodes[t];
    if (!n)
      throw new RangeError("Unknown node type: " + t);
    return n;
  }
}
function KC(e, t) {
  let n = [];
  for (let o = 0; o < t.length; o++) {
    let r = t[o], i = e.marks[r], s = i;
    if (i)
      n.push(i);
    else
      for (let a in e.marks) {
        let c = e.marks[a];
        (r == "_" || c.spec.group && c.spec.group.split(" ").indexOf(r) > -1) && n.push(s = c);
      }
    if (!s)
      throw new SyntaxError("Unknown mark type: '" + t[o] + "'");
  }
  return n;
}
function j6e(e) {
  return e.tag != null;
}
function V6e(e) {
  return e.style != null;
}
class cs {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(t, n) {
    this.schema = t, this.rules = n, this.tags = [], this.styles = [];
    let o = this.matchedStyles = [];
    n.forEach((r) => {
      if (j6e(r))
        this.tags.push(r);
      else if (V6e(r)) {
        let i = /[^=]*/.exec(r.style)[0];
        o.indexOf(i) < 0 && o.push(i), this.styles.push(r);
      }
    }), this.normalizeLists = !this.tags.some((r) => {
      if (!/^(ul|ol)\b/.test(r.tag) || !r.node)
        return !1;
      let i = t.nodes[r.node];
      return i.contentMatch.matchType(i);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(t, n = {}) {
    let o = new XC(this, n, !1);
    return o.addAll(t, an.none, n.from, n.to), o.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(t, n = {}) {
    let o = new XC(this, n, !0);
    return o.addAll(t, an.none, n.from, n.to), et.maxOpen(o.finish());
  }
  /**
  @internal
  */
  matchTag(t, n, o) {
    for (let r = o ? this.tags.indexOf(o) + 1 : 0; r < this.tags.length; r++) {
      let i = this.tags[r];
      if (H6e(t, i.tag) && (i.namespace === void 0 || t.namespaceURI == i.namespace) && (!i.context || n.matchesContext(i.context))) {
        if (i.getAttrs) {
          let s = i.getAttrs(t);
          if (s === !1)
            continue;
          i.attrs = s || void 0;
        }
        return i;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(t, n, o, r) {
    for (let i = r ? this.styles.indexOf(r) + 1 : 0; i < this.styles.length; i++) {
      let s = this.styles[i], a = s.style;
      if (!(a.indexOf(t) != 0 || s.context && !o.matchesContext(s.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      a.length > t.length && (a.charCodeAt(t.length) != 61 || a.slice(t.length + 1) != n))) {
        if (s.getAttrs) {
          let c = s.getAttrs(n);
          if (c === !1)
            continue;
          s.attrs = c || void 0;
        }
        return s;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(t) {
    let n = [];
    function o(r) {
      let i = r.priority == null ? 50 : r.priority, s = 0;
      for (; s < n.length; s++) {
        let a = n[s];
        if ((a.priority == null ? 50 : a.priority) < i)
          break;
      }
      n.splice(s, 0, r);
    }
    for (let r in t.marks) {
      let i = t.marks[r].spec.parseDOM;
      i && i.forEach((s) => {
        o(s = JC(s)), s.mark || s.ignore || s.clearMark || (s.mark = r);
      });
    }
    for (let r in t.nodes) {
      let i = t.nodes[r].spec.parseDOM;
      i && i.forEach((s) => {
        o(s = JC(s)), s.node || s.ignore || s.mark || (s.node = r);
      });
    }
    return n;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(t) {
    return t.cached.domParser || (t.cached.domParser = new cs(t, cs.schemaRules(t)));
  }
}
const vR = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, D6e = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, wR = { ol: !0, ul: !0 }, o0 = 1, E5 = 2, Ld = 4;
function YC(e, t, n) {
  return t != null ? (t ? o0 : 0) | (t === "full" ? E5 : 0) : e && e.whitespace == "pre" ? o0 | E5 : n & -5;
}
class q1 {
  constructor(t, n, o, r, i, s) {
    this.type = t, this.attrs = n, this.marks = o, this.solid = r, this.options = s, this.content = [], this.activeMarks = an.none, this.match = i || (s & Ld ? null : t.contentMatch);
  }
  findWrapping(t) {
    if (!this.match) {
      if (!this.type)
        return [];
      let n = this.type.contentMatch.fillBefore(je.from(t));
      if (n)
        this.match = this.type.contentMatch.matchFragment(n);
      else {
        let o = this.type.contentMatch, r;
        return (r = o.findWrapping(t.type)) ? (this.match = o, r) : null;
      }
    }
    return this.match.findWrapping(t.type);
  }
  finish(t) {
    if (!(this.options & o0)) {
      let o = this.content[this.content.length - 1], r;
      if (o && o.isText && (r = /[ \t\r\n\u000c]+$/.exec(o.text))) {
        let i = o;
        o.text.length == r[0].length ? this.content.pop() : this.content[this.content.length - 1] = i.withText(i.text.slice(0, i.text.length - r[0].length));
      }
    }
    let n = je.from(this.content);
    return !t && this.match && (n = n.append(this.match.fillBefore(je.empty, !0))), this.type ? this.type.create(this.attrs, n, this.marks) : n;
  }
  inlineContext(t) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : t.parentNode && !vR.hasOwnProperty(t.parentNode.nodeName.toLowerCase());
  }
}
class XC {
  constructor(t, n, o) {
    this.parser = t, this.options = n, this.isOpen = o, this.open = 0, this.localPreserveWS = !1;
    let r = n.topNode, i, s = YC(null, n.preserveWhitespace, 0) | (o ? Ld : 0);
    r ? i = new q1(r.type, r.attrs, an.none, !0, n.topMatch || r.type.contentMatch, s) : o ? i = new q1(null, null, an.none, !0, null, s) : i = new q1(t.schema.topNodeType, null, an.none, !0, null, s), this.nodes = [i], this.find = n.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(t, n) {
    t.nodeType == 3 ? this.addTextNode(t, n) : t.nodeType == 1 && this.addElement(t, n);
  }
  addTextNode(t, n) {
    let o = t.nodeValue, r = this.top, i = r.options & E5 ? "full" : this.localPreserveWS || (r.options & o0) > 0;
    if (i === "full" || r.inlineContext(t) || /[^ \t\r\n\u000c]/.test(o)) {
      if (i)
        i !== "full" ? o = o.replace(/\r?\n|\r/g, " ") : o = o.replace(/\r\n?/g, `
`);
      else if (o = o.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(o) && this.open == this.nodes.length - 1) {
        let s = r.content[r.content.length - 1], a = t.previousSibling;
        (!s || a && a.nodeName == "BR" || s.isText && /[ \t\r\n\u000c]$/.test(s.text)) && (o = o.slice(1));
      }
      o && this.insertNode(this.parser.schema.text(o), n), this.findInText(t);
    } else
      this.findInside(t);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(t, n, o) {
    let r = this.localPreserveWS, i = this.top;
    (t.tagName == "PRE" || /pre/.test(t.style && t.style.whiteSpace)) && (this.localPreserveWS = !0);
    let s = t.nodeName.toLowerCase(), a;
    wR.hasOwnProperty(s) && this.parser.normalizeLists && A6e(t);
    let c = this.options.ruleFromNode && this.options.ruleFromNode(t) || (a = this.parser.matchTag(t, this, o));
    e: if (c ? c.ignore : D6e.hasOwnProperty(s))
      this.findInside(t), this.ignoreFallback(t, n);
    else if (!c || c.skip || c.closeParent) {
      c && c.closeParent ? this.open = Math.max(0, this.open - 1) : c && c.skip.nodeType && (t = c.skip);
      let d, u = this.needsBlock;
      if (vR.hasOwnProperty(s))
        i.content.length && i.content[0].isInline && this.open && (this.open--, i = this.top), d = !0, i.type || (this.needsBlock = !0);
      else if (!t.firstChild) {
        this.leafFallback(t, n);
        break e;
      }
      let p = c && c.skip ? n : this.readStyles(t, n);
      p && this.addAll(t, p), d && this.sync(i), this.needsBlock = u;
    } else {
      let d = this.readStyles(t, n);
      d && this.addElementByRule(t, c, d, c.consuming === !1 ? a : void 0);
    }
    this.localPreserveWS = r;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(t, n) {
    t.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(t.ownerDocument.createTextNode(`
`), n);
  }
  // Called for ignored nodes
  ignoreFallback(t, n) {
    t.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), n);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(t, n) {
    let o = t.style;
    if (o && o.length)
      for (let r = 0; r < this.parser.matchedStyles.length; r++) {
        let i = this.parser.matchedStyles[r], s = o.getPropertyValue(i);
        if (s)
          for (let a = void 0; ; ) {
            let c = this.parser.matchStyle(i, s, this, a);
            if (!c)
              break;
            if (c.ignore)
              return null;
            if (c.clearMark ? n = n.filter((d) => !c.clearMark(d)) : n = n.concat(this.parser.schema.marks[c.mark].create(c.attrs)), c.consuming === !1)
              a = c;
            else
              break;
          }
      }
    return n;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(t, n, o, r) {
    let i, s;
    if (n.node)
      if (s = this.parser.schema.nodes[n.node], s.isLeaf)
        this.insertNode(s.create(n.attrs), o) || this.leafFallback(t, o);
      else {
        let c = this.enter(s, n.attrs || null, o, n.preserveWhitespace);
        c && (i = !0, o = c);
      }
    else {
      let c = this.parser.schema.marks[n.mark];
      o = o.concat(c.create(n.attrs));
    }
    let a = this.top;
    if (s && s.isLeaf)
      this.findInside(t);
    else if (r)
      this.addElement(t, o, r);
    else if (n.getContent)
      this.findInside(t), n.getContent(t, this.parser.schema).forEach((c) => this.insertNode(c, o));
    else {
      let c = t;
      typeof n.contentElement == "string" ? c = t.querySelector(n.contentElement) : typeof n.contentElement == "function" ? c = n.contentElement(t) : n.contentElement && (c = n.contentElement), this.findAround(t, c, !0), this.addAll(c, o), this.findAround(t, c, !1);
    }
    i && this.sync(a) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(t, n, o, r) {
    let i = o || 0;
    for (let s = o ? t.childNodes[o] : t.firstChild, a = r == null ? null : t.childNodes[r]; s != a; s = s.nextSibling, ++i)
      this.findAtPoint(t, i), this.addDOM(s, n);
    this.findAtPoint(t, i);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(t, n) {
    let o, r;
    for (let i = this.open; i >= 0; i--) {
      let s = this.nodes[i], a = s.findWrapping(t);
      if (a && (!o || o.length > a.length) && (o = a, r = s, !a.length) || s.solid)
        break;
    }
    if (!o)
      return null;
    this.sync(r);
    for (let i = 0; i < o.length; i++)
      n = this.enterInner(o[i], null, n, !1);
    return n;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(t, n) {
    if (t.isInline && this.needsBlock && !this.top.type) {
      let r = this.textblockFromContext();
      r && (n = this.enterInner(r, null, n));
    }
    let o = this.findPlace(t, n);
    if (o) {
      this.closeExtra();
      let r = this.top;
      r.match && (r.match = r.match.matchType(t.type));
      let i = an.none;
      for (let s of o.concat(t.marks))
        (r.type ? r.type.allowsMarkType(s.type) : QC(s.type, t.type)) && (i = s.addToSet(i));
      return r.content.push(t.mark(i)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(t, n, o, r) {
    let i = this.findPlace(t.create(n), o);
    return i && (i = this.enterInner(t, n, o, !0, r)), i;
  }
  // Open a node of the given type
  enterInner(t, n, o, r = !1, i) {
    this.closeExtra();
    let s = this.top;
    s.match = s.match && s.match.matchType(t);
    let a = YC(t, i, s.options);
    s.options & Ld && s.content.length == 0 && (a |= Ld);
    let c = an.none;
    return o = o.filter((d) => (s.type ? s.type.allowsMarkType(d.type) : QC(d.type, t)) ? (c = d.addToSet(c), !1) : !0), this.nodes.push(new q1(t, n, c, r, null, a)), this.open++, o;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(t = !1) {
    let n = this.nodes.length - 1;
    if (n > this.open) {
      for (; n > this.open; n--)
        this.nodes[n - 1].content.push(this.nodes[n].finish(t));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(t) {
    for (let n = this.open; n >= 0; n--) {
      if (this.nodes[n] == t)
        return this.open = n, !0;
      this.localPreserveWS && (this.nodes[n].options |= o0);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let t = 0;
    for (let n = this.open; n >= 0; n--) {
      let o = this.nodes[n].content;
      for (let r = o.length - 1; r >= 0; r--)
        t += o[r].nodeSize;
      n && t++;
    }
    return t;
  }
  findAtPoint(t, n) {
    if (this.find)
      for (let o = 0; o < this.find.length; o++)
        this.find[o].node == t && this.find[o].offset == n && (this.find[o].pos = this.currentPos);
  }
  findInside(t) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].pos == null && t.nodeType == 1 && t.contains(this.find[n].node) && (this.find[n].pos = this.currentPos);
  }
  findAround(t, n, o) {
    if (t != n && this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].pos == null && t.nodeType == 1 && t.contains(this.find[r].node) && n.compareDocumentPosition(this.find[r].node) & (o ? 2 : 4) && (this.find[r].pos = this.currentPos);
  }
  findInText(t) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == t && (this.find[n].pos = this.currentPos - (t.nodeValue.length - this.find[n].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(t) {
    if (t.indexOf("|") > -1)
      return t.split(/\s*\|\s*/).some(this.matchesContext, this);
    let n = t.split("/"), o = this.options.context, r = !this.isOpen && (!o || o.parent.type == this.nodes[0].type), i = -(o ? o.depth + 1 : 0) + (r ? 0 : 1), s = (a, c) => {
      for (; a >= 0; a--) {
        let d = n[a];
        if (d == "") {
          if (a == n.length - 1 || a == 0)
            continue;
          for (; c >= i; c--)
            if (s(a - 1, c))
              return !0;
          return !1;
        } else {
          let u = c > 0 || c == 0 && r ? this.nodes[c].type : o && c >= i ? o.node(c - i).type : null;
          if (!u || u.name != d && !u.isInGroup(d))
            return !1;
          c--;
        }
      }
      return !0;
    };
    return s(n.length - 1, this.open);
  }
  textblockFromContext() {
    let t = this.options.context;
    if (t)
      for (let n = t.depth; n >= 0; n--) {
        let o = t.node(n).contentMatchAt(t.indexAfter(n)).defaultType;
        if (o && o.isTextblock && o.defaultAttrs)
          return o;
      }
    for (let n in this.parser.schema.nodes) {
      let o = this.parser.schema.nodes[n];
      if (o.isTextblock && o.defaultAttrs)
        return o;
    }
  }
}
function A6e(e) {
  for (let t = e.firstChild, n = null; t; t = t.nextSibling) {
    let o = t.nodeType == 1 ? t.nodeName.toLowerCase() : null;
    o && wR.hasOwnProperty(o) && n ? (n.appendChild(t), t = n) : o == "li" ? n = t : o && (n = null);
  }
}
function H6e(e, t) {
  return (e.matches || e.msMatchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector).call(e, t);
}
function JC(e) {
  let t = {};
  for (let n in e)
    t[n] = e[n];
  return t;
}
function QC(e, t) {
  let n = t.schema.nodes;
  for (let o in n) {
    let r = n[o];
    if (!r.allowsMarkType(e))
      continue;
    let i = [], s = (a) => {
      i.push(a);
      for (let c = 0; c < a.edgeCount; c++) {
        let { type: d, next: u } = a.edge(c);
        if (d == t || i.indexOf(u) < 0 && s(u))
          return !0;
      }
    };
    if (s(r.contentMatch))
      return !0;
  }
}
class Ba {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(t, n) {
    this.nodes = t, this.marks = n;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(t, n = {}, o) {
    o || (o = z6(n).createDocumentFragment());
    let r = o, i = [];
    return t.forEach((s) => {
      if (i.length || s.marks.length) {
        let a = 0, c = 0;
        for (; a < i.length && c < s.marks.length; ) {
          let d = s.marks[c];
          if (!this.marks[d.type.name]) {
            c++;
            continue;
          }
          if (!d.eq(i[a][0]) || d.type.spec.spanning === !1)
            break;
          a++, c++;
        }
        for (; a < i.length; )
          r = i.pop()[1];
        for (; c < s.marks.length; ) {
          let d = s.marks[c++], u = this.serializeMark(d, s.isInline, n);
          u && (i.push([d, r]), r.appendChild(u.dom), r = u.contentDOM || u.dom);
        }
      }
      r.appendChild(this.serializeNodeInner(s, n));
    }), o;
  }
  /**
  @internal
  */
  serializeNodeInner(t, n) {
    let { dom: o, contentDOM: r } = Id(z6(n), this.nodes[t.type.name](t), null, t.attrs);
    if (r) {
      if (t.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(t.content, n, r);
    }
    return o;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(t, n = {}) {
    let o = this.serializeNodeInner(t, n);
    for (let r = t.marks.length - 1; r >= 0; r--) {
      let i = this.serializeMark(t.marks[r], t.isInline, n);
      i && ((i.contentDOM || i.dom).appendChild(o), o = i.dom);
    }
    return o;
  }
  /**
  @internal
  */
  serializeMark(t, n, o = {}) {
    let r = this.marks[t.type.name];
    return r && Id(z6(o), r(t, n), null, t.attrs);
  }
  static renderSpec(t, n, o = null, r) {
    return Id(t, n, o, r);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(t) {
    return t.cached.domSerializer || (t.cached.domSerializer = new Ba(this.nodesFromSchema(t), this.marksFromSchema(t)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(t) {
    let n = ex(t.nodes);
    return n.text || (n.text = (o) => o.text), n;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(t) {
    return ex(t.marks);
  }
}
function ex(e) {
  let t = {};
  for (let n in e) {
    let o = e[n].spec.toDOM;
    o && (t[n] = o);
  }
  return t;
}
function z6(e) {
  return e.document || window.document;
}
const tx = /* @__PURE__ */ new WeakMap();
function F6e(e) {
  let t = tx.get(e);
  return t === void 0 && tx.set(e, t = N6e(e)), t;
}
function N6e(e) {
  let t = null;
  function n(o) {
    if (o && typeof o == "object")
      if (Array.isArray(o))
        if (typeof o[0] == "string")
          t || (t = []), t.push(o);
        else
          for (let r = 0; r < o.length; r++)
            n(o[r]);
      else
        for (let r in o)
          n(o[r]);
  }
  return n(e), t;
}
function Id(e, t, n, o) {
  if (typeof t == "string")
    return { dom: e.createTextNode(t) };
  if (t.nodeType != null)
    return { dom: t };
  if (t.dom && t.dom.nodeType != null)
    return t;
  let r = t[0], i;
  if (typeof r != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (o && (i = F6e(o)) && i.indexOf(t) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let s = r.indexOf(" ");
  s > 0 && (n = r.slice(0, s), r = r.slice(s + 1));
  let a, c = n ? e.createElementNS(n, r) : e.createElement(r), d = t[1], u = 1;
  if (d && typeof d == "object" && d.nodeType == null && !Array.isArray(d)) {
    u = 2;
    for (let p in d)
      if (d[p] != null) {
        let h = p.indexOf(" ");
        h > 0 ? c.setAttributeNS(p.slice(0, h), p.slice(h + 1), d[p]) : c.setAttribute(p, d[p]);
      }
  }
  for (let p = u; p < t.length; p++) {
    let h = t[p];
    if (h === 0) {
      if (p < t.length - 1 || p > u)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: c, contentDOM: c };
    } else {
      let { dom: g, contentDOM: m } = Id(e, h, n, o);
      if (c.appendChild(g), m) {
        if (a)
          throw new RangeError("Multiple content holes");
        a = m;
      }
    }
  }
  return { dom: c, contentDOM: a };
}
const SR = 65535, MR = Math.pow(2, 16);
function $6e(e, t) {
  return e + t * MR;
}
function nx(e) {
  return e & SR;
}
function B6e(e) {
  return (e - (e & SR)) / MR;
}
const TR = 1, kR = 2, jd = 4, ER = 8;
class R5 {
  /**
  @internal
  */
  constructor(t, n, o) {
    this.pos = t, this.delInfo = n, this.recover = o;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & ER) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (TR | jd)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (kR | jd)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & jd) > 0;
  }
}
class Ko {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(t, n = !1) {
    if (this.ranges = t, this.inverted = n, !t.length && Ko.empty)
      return Ko.empty;
  }
  /**
  @internal
  */
  recover(t) {
    let n = 0, o = nx(t);
    if (!this.inverted)
      for (let r = 0; r < o; r++)
        n += this.ranges[r * 3 + 2] - this.ranges[r * 3 + 1];
    return this.ranges[o * 3] + n + B6e(t);
  }
  mapResult(t, n = 1) {
    return this._map(t, n, !1);
  }
  map(t, n = 1) {
    return this._map(t, n, !0);
  }
  /**
  @internal
  */
  _map(t, n, o) {
    let r = 0, i = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let c = this.ranges[a] - (this.inverted ? r : 0);
      if (c > t)
        break;
      let d = this.ranges[a + i], u = this.ranges[a + s], p = c + d;
      if (t <= p) {
        let h = d ? t == c ? -1 : t == p ? 1 : n : n, g = c + r + (h < 0 ? 0 : u);
        if (o)
          return g;
        let m = t == (n < 0 ? c : p) ? null : $6e(a / 3, t - c), b = t == c ? kR : t == p ? TR : jd;
        return (n < 0 ? t != c : t != p) && (b |= ER), new R5(g, b, m);
      }
      r += u - d;
    }
    return o ? t + r : new R5(t + r, 0, null);
  }
  /**
  @internal
  */
  touches(t, n) {
    let o = 0, r = nx(n), i = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let c = this.ranges[a] - (this.inverted ? o : 0);
      if (c > t)
        break;
      let d = this.ranges[a + i], u = c + d;
      if (t <= u && a == r * 3)
        return !0;
      o += this.ranges[a + s] - d;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(t) {
    let n = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let r = 0, i = 0; r < this.ranges.length; r += 3) {
      let s = this.ranges[r], a = s - (this.inverted ? i : 0), c = s + (this.inverted ? 0 : i), d = this.ranges[r + n], u = this.ranges[r + o];
      t(a, a + d, c, c + u), i += u - d;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new Ko(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(t) {
    return t == 0 ? Ko.empty : new Ko(t < 0 ? [0, -t, 0] : [0, 0, t]);
  }
}
Ko.empty = new Ko([]);
class kl {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(t = [], n, o = 0, r = t.length) {
    this.maps = t, this.mirror = n, this.from = o, this.to = r;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(t = 0, n = this.maps.length) {
    return new kl(this.maps, this.mirror, t, n);
  }
  /**
  @internal
  */
  copy() {
    return new kl(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(t, n) {
    this.to = this.maps.push(t), n != null && this.setMirror(this.maps.length - 1, n);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(t) {
    for (let n = 0, o = this.maps.length; n < t.maps.length; n++) {
      let r = t.getMirror(n);
      this.appendMap(t.maps[n], r != null && r < n ? o + r : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(t) {
    if (this.mirror) {
      for (let n = 0; n < this.mirror.length; n++)
        if (this.mirror[n] == t)
          return this.mirror[n + (n % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(t, n) {
    this.mirror || (this.mirror = []), this.mirror.push(t, n);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(t) {
    for (let n = t.maps.length - 1, o = this.maps.length + t.maps.length; n >= 0; n--) {
      let r = t.getMirror(n);
      this.appendMap(t.maps[n].invert(), r != null && r > n ? o - r - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let t = new kl();
    return t.appendMappingInverted(this), t;
  }
  /**
  Map a position through this mapping.
  */
  map(t, n = 1) {
    if (this.mirror)
      return this._map(t, n, !0);
    for (let o = this.from; o < this.to; o++)
      t = this.maps[o].map(t, n);
    return t;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(t, n = 1) {
    return this._map(t, n, !1);
  }
  /**
  @internal
  */
  _map(t, n, o) {
    let r = 0;
    for (let i = this.from; i < this.to; i++) {
      let s = this.maps[i], a = s.mapResult(t, n);
      if (a.recover != null) {
        let c = this.getMirror(i);
        if (c != null && c > i && c < this.to) {
          i = c, t = this.maps[c].recover(a.recover);
          continue;
        }
      }
      r |= a.delInfo, t = a.pos;
    }
    return o ? t : new R5(t, r, null);
  }
}
const Z6 = /* @__PURE__ */ Object.create(null);
class Co {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return Ko.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(t) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(t, n) {
    if (!n || !n.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let o = Z6[n.stepType];
    if (!o)
      throw new RangeError(`No step type ${n.stepType} defined`);
    return o.fromJSON(t, n);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(t, n) {
    if (t in Z6)
      throw new RangeError("Duplicate use of step JSON ID " + t);
    return Z6[t] = n, n.prototype.jsonID = t, n;
  }
}
class An {
  /**
  @internal
  */
  constructor(t, n) {
    this.doc = t, this.failed = n;
  }
  /**
  Create a successful step result.
  */
  static ok(t) {
    return new An(t, null);
  }
  /**
  Create a failed step result.
  */
  static fail(t) {
    return new An(null, t);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(t, n, o, r) {
    try {
      return An.ok(t.replace(n, o, r));
    } catch (i) {
      if (i instanceof mu)
        return An.fail(i.message);
      throw i;
    }
  }
}
function f8(e, t, n) {
  let o = [];
  for (let r = 0; r < e.childCount; r++) {
    let i = e.child(r);
    i.content.size && (i = i.copy(f8(i.content, t, i))), i.isInline && (i = t(i, n, r)), o.push(i);
  }
  return je.fromArray(o);
}
class rs extends Co {
  /**
  Create a mark step.
  */
  constructor(t, n, o) {
    super(), this.from = t, this.to = n, this.mark = o;
  }
  apply(t) {
    let n = t.slice(this.from, this.to), o = t.resolve(this.from), r = o.node(o.sharedDepth(this.to)), i = new et(f8(n.content, (s, a) => !s.isAtom || !a.type.allowsMarkType(this.mark.type) ? s : s.mark(this.mark.addToSet(s.marks)), r), n.openStart, n.openEnd);
    return An.fromReplace(t, this.from, this.to, i);
  }
  invert() {
    return new Xr(this.from, this.to, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), o = t.mapResult(this.to, -1);
    return n.deleted && o.deleted || n.pos >= o.pos ? null : new rs(n.pos, o.pos, this.mark);
  }
  merge(t) {
    return t instanceof rs && t.mark.eq(this.mark) && this.from <= t.to && this.to >= t.from ? new rs(Math.min(this.from, t.from), Math.max(this.to, t.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new rs(n.from, n.to, t.markFromJSON(n.mark));
  }
}
Co.jsonID("addMark", rs);
class Xr extends Co {
  /**
  Create a mark-removing step.
  */
  constructor(t, n, o) {
    super(), this.from = t, this.to = n, this.mark = o;
  }
  apply(t) {
    let n = t.slice(this.from, this.to), o = new et(f8(n.content, (r) => r.mark(this.mark.removeFromSet(r.marks)), t), n.openStart, n.openEnd);
    return An.fromReplace(t, this.from, this.to, o);
  }
  invert() {
    return new rs(this.from, this.to, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), o = t.mapResult(this.to, -1);
    return n.deleted && o.deleted || n.pos >= o.pos ? null : new Xr(n.pos, o.pos, this.mark);
  }
  merge(t) {
    return t instanceof Xr && t.mark.eq(this.mark) && this.from <= t.to && this.to >= t.from ? new Xr(Math.min(this.from, t.from), Math.max(this.to, t.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new Xr(n.from, n.to, t.markFromJSON(n.mark));
  }
}
Co.jsonID("removeMark", Xr);
class is extends Co {
  /**
  Create a node mark step.
  */
  constructor(t, n) {
    super(), this.pos = t, this.mark = n;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return An.fail("No node at mark step's position");
    let o = n.type.create(n.attrs, null, this.mark.addToSet(n.marks));
    return An.fromReplace(t, this.pos, this.pos + 1, new et(je.from(o), 0, n.isLeaf ? 0 : 1));
  }
  invert(t) {
    let n = t.nodeAt(this.pos);
    if (n) {
      let o = this.mark.addToSet(n.marks);
      if (o.length == n.marks.length) {
        for (let r = 0; r < n.marks.length; r++)
          if (!n.marks[r].isInSet(o))
            return new is(this.pos, n.marks[r]);
        return new is(this.pos, this.mark);
      }
    }
    return new Zl(this.pos, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new is(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new is(n.pos, t.markFromJSON(n.mark));
  }
}
Co.jsonID("addNodeMark", is);
class Zl extends Co {
  /**
  Create a mark-removing step.
  */
  constructor(t, n) {
    super(), this.pos = t, this.mark = n;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return An.fail("No node at mark step's position");
    let o = n.type.create(n.attrs, null, this.mark.removeFromSet(n.marks));
    return An.fromReplace(t, this.pos, this.pos + 1, new et(je.from(o), 0, n.isLeaf ? 0 : 1));
  }
  invert(t) {
    let n = t.nodeAt(this.pos);
    return !n || !this.mark.isInSet(n.marks) ? this : new is(this.pos, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new Zl(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new Zl(n.pos, t.markFromJSON(n.mark));
  }
}
Co.jsonID("removeNodeMark", Zl);
class Zn extends Co {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(t, n, o, r = !1) {
    super(), this.from = t, this.to = n, this.slice = o, this.structure = r;
  }
  apply(t) {
    return this.structure && O5(t, this.from, this.to) ? An.fail("Structure replace would overwrite content") : An.fromReplace(t, this.from, this.to, this.slice);
  }
  getMap() {
    return new Ko([this.from, this.to - this.from, this.slice.size]);
  }
  invert(t) {
    return new Zn(this.from, this.from + this.slice.size, t.slice(this.from, this.to));
  }
  map(t) {
    let n = t.mapResult(this.from, 1), o = t.mapResult(this.to, -1);
    return n.deletedAcross && o.deletedAcross ? null : new Zn(n.pos, Math.max(n.pos, o.pos), this.slice);
  }
  merge(t) {
    if (!(t instanceof Zn) || t.structure || this.structure)
      return null;
    if (this.from + this.slice.size == t.from && !this.slice.openEnd && !t.slice.openStart) {
      let n = this.slice.size + t.slice.size == 0 ? et.empty : new et(this.slice.content.append(t.slice.content), this.slice.openStart, t.slice.openEnd);
      return new Zn(this.from, this.to + (t.to - t.from), n, this.structure);
    } else if (t.to == this.from && !this.slice.openStart && !t.slice.openEnd) {
      let n = this.slice.size + t.slice.size == 0 ? et.empty : new et(t.slice.content.append(this.slice.content), t.slice.openStart, this.slice.openEnd);
      return new Zn(t.from, this.to, n, this.structure);
    } else
      return null;
  }
  toJSON() {
    let t = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (t.slice = this.slice.toJSON()), this.structure && (t.structure = !0), t;
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new Zn(n.from, n.to, et.fromJSON(t, n.slice), !!n.structure);
  }
}
Co.jsonID("replace", Zn);
class Un extends Co {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(t, n, o, r, i, s, a = !1) {
    super(), this.from = t, this.to = n, this.gapFrom = o, this.gapTo = r, this.slice = i, this.insert = s, this.structure = a;
  }
  apply(t) {
    if (this.structure && (O5(t, this.from, this.gapFrom) || O5(t, this.gapTo, this.to)))
      return An.fail("Structure gap-replace would overwrite content");
    let n = t.slice(this.gapFrom, this.gapTo);
    if (n.openStart || n.openEnd)
      return An.fail("Gap is not a flat range");
    let o = this.slice.insertAt(this.insert, n.content);
    return o ? An.fromReplace(t, this.from, this.to, o) : An.fail("Content does not fit in gap");
  }
  getMap() {
    return new Ko([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(t) {
    let n = this.gapTo - this.gapFrom;
    return new Un(this.from, this.from + this.slice.size + n, this.from + this.insert, this.from + this.insert + n, t.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), o = t.mapResult(this.to, -1), r = this.from == this.gapFrom ? n.pos : t.map(this.gapFrom, -1), i = this.to == this.gapTo ? o.pos : t.map(this.gapTo, 1);
    return n.deletedAcross && o.deletedAcross || r < n.pos || i > o.pos ? null : new Un(n.pos, o.pos, r, i, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let t = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (t.slice = this.slice.toJSON()), this.structure && (t.structure = !0), t;
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number" || typeof n.gapFrom != "number" || typeof n.gapTo != "number" || typeof n.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new Un(n.from, n.to, n.gapFrom, n.gapTo, et.fromJSON(t, n.slice), n.insert, !!n.structure);
  }
}
Co.jsonID("replaceAround", Un);
function O5(e, t, n) {
  let o = e.resolve(t), r = n - t, i = o.depth;
  for (; r > 0 && i > 0 && o.indexAfter(i) == o.node(i).childCount; )
    i--, r--;
  if (r > 0) {
    let s = o.node(i).maybeChild(o.indexAfter(i));
    for (; r > 0; ) {
      if (!s || s.isLeaf)
        return !0;
      s = s.firstChild, r--;
    }
  }
  return !1;
}
function z6e(e, t, n, o) {
  let r = [], i = [], s, a;
  e.doc.nodesBetween(t, n, (c, d, u) => {
    if (!c.isInline)
      return;
    let p = c.marks;
    if (!o.isInSet(p) && u.type.allowsMarkType(o.type)) {
      let h = Math.max(d, t), g = Math.min(d + c.nodeSize, n), m = o.addToSet(p);
      for (let b = 0; b < p.length; b++)
        p[b].isInSet(m) || (s && s.to == h && s.mark.eq(p[b]) ? s.to = g : r.push(s = new Xr(h, g, p[b])));
      a && a.to == h ? a.to = g : i.push(a = new rs(h, g, o));
    }
  }), r.forEach((c) => e.step(c)), i.forEach((c) => e.step(c));
}
function Z6e(e, t, n, o) {
  let r = [], i = 0;
  e.doc.nodesBetween(t, n, (s, a) => {
    if (!s.isInline)
      return;
    i++;
    let c = null;
    if (o instanceof uf) {
      let d = s.marks, u;
      for (; u = o.isInSet(d); )
        (c || (c = [])).push(u), d = u.removeFromSet(d);
    } else o ? o.isInSet(s.marks) && (c = [o]) : c = s.marks;
    if (c && c.length) {
      let d = Math.min(a + s.nodeSize, n);
      for (let u = 0; u < c.length; u++) {
        let p = c[u], h;
        for (let g = 0; g < r.length; g++) {
          let m = r[g];
          m.step == i - 1 && p.eq(r[g].style) && (h = m);
        }
        h ? (h.to = d, h.step = i) : r.push({ style: p, from: Math.max(a, t), to: d, step: i });
      }
    }
  }), r.forEach((s) => e.step(new Xr(s.from, s.to, s.style)));
}
function p8(e, t, n, o = n.contentMatch, r = !0) {
  let i = e.doc.nodeAt(t), s = [], a = t + 1;
  for (let c = 0; c < i.childCount; c++) {
    let d = i.child(c), u = a + d.nodeSize, p = o.matchType(d.type);
    if (!p)
      s.push(new Zn(a, u, et.empty));
    else {
      o = p;
      for (let h = 0; h < d.marks.length; h++)
        n.allowsMarkType(d.marks[h].type) || e.step(new Xr(a, u, d.marks[h]));
      if (r && d.isText && n.whitespace != "pre") {
        let h, g = /\r?\n|\r/g, m;
        for (; h = g.exec(d.text); )
          m || (m = new et(je.from(n.schema.text(" ", n.allowedMarks(d.marks))), 0, 0)), s.push(new Zn(a + h.index, a + h.index + h[0].length, m));
      }
    }
    a = u;
  }
  if (!o.validEnd) {
    let c = o.fillBefore(je.empty, !0);
    e.replace(a, a, new et(c, 0, 0));
  }
  for (let c = s.length - 1; c >= 0; c--)
    e.step(s[c]);
}
function W6e(e, t, n) {
  return (t == 0 || e.canReplace(t, e.childCount)) && (n == e.childCount || e.canReplace(0, n));
}
function x2(e) {
  let n = e.parent.content.cutByIndex(e.startIndex, e.endIndex);
  for (let o = e.depth; ; --o) {
    let r = e.$from.node(o), i = e.$from.index(o), s = e.$to.indexAfter(o);
    if (o < e.depth && r.canReplace(i, s, n))
      return o;
    if (o == 0 || r.type.spec.isolating || !W6e(r, i, s))
      break;
  }
  return null;
}
function U6e(e, t, n) {
  let { $from: o, $to: r, depth: i } = t, s = o.before(i + 1), a = r.after(i + 1), c = s, d = a, u = je.empty, p = 0;
  for (let m = i, b = !1; m > n; m--)
    b || o.index(m) > 0 ? (b = !0, u = je.from(o.node(m).copy(u)), p++) : c--;
  let h = je.empty, g = 0;
  for (let m = i, b = !1; m > n; m--)
    b || r.after(m + 1) < r.end(m) ? (b = !0, h = je.from(r.node(m).copy(h)), g++) : d++;
  e.step(new Un(c, d, s, a, new et(u.append(h), p, g), u.size - p, !0));
}
function h8(e, t, n = null, o = e) {
  let r = G6e(e, t), i = r && q6e(o, t);
  return i ? r.map(ox).concat({ type: t, attrs: n }).concat(i.map(ox)) : null;
}
function ox(e) {
  return { type: e, attrs: null };
}
function G6e(e, t) {
  let { parent: n, startIndex: o, endIndex: r } = e, i = n.contentMatchAt(o).findWrapping(t);
  if (!i)
    return null;
  let s = i.length ? i[0] : t;
  return n.canReplaceWith(o, r, s) ? i : null;
}
function q6e(e, t) {
  let { parent: n, startIndex: o, endIndex: r } = e, i = n.child(o), s = t.contentMatch.findWrapping(i.type);
  if (!s)
    return null;
  let c = (s.length ? s[s.length - 1] : t).contentMatch;
  for (let d = o; c && d < r; d++)
    c = c.matchType(n.child(d).type);
  return !c || !c.validEnd ? null : s;
}
function K6e(e, t, n) {
  let o = je.empty;
  for (let s = n.length - 1; s >= 0; s--) {
    if (o.size) {
      let a = n[s].type.contentMatch.matchFragment(o);
      if (!a || !a.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    o = je.from(n[s].type.create(n[s].attrs, o));
  }
  let r = t.start, i = t.end;
  e.step(new Un(r, i, r, i, new et(o, 0, 0), n.length, !0));
}
function Y6e(e, t, n, o, r) {
  if (!o.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let i = e.steps.length;
  e.doc.nodesBetween(t, n, (s, a) => {
    let c = typeof r == "function" ? r(s) : r;
    if (s.isTextblock && !s.hasMarkup(o, c) && X6e(e.doc, e.mapping.slice(i).map(a), o)) {
      let d = null;
      if (o.schema.linebreakReplacement) {
        let g = o.whitespace == "pre", m = !!o.contentMatch.matchType(o.schema.linebreakReplacement);
        g && !m ? d = !1 : !g && m && (d = !0);
      }
      d === !1 && OR(e, s, a, i), p8(e, e.mapping.slice(i).map(a, 1), o, void 0, d === null);
      let u = e.mapping.slice(i), p = u.map(a, 1), h = u.map(a + s.nodeSize, 1);
      return e.step(new Un(p, h, p + 1, h - 1, new et(je.from(o.create(c, null, s.marks)), 0, 0), 1, !0)), d === !0 && RR(e, s, a, i), !1;
    }
  });
}
function RR(e, t, n, o) {
  t.forEach((r, i) => {
    if (r.isText) {
      let s, a = /\r?\n|\r/g;
      for (; s = a.exec(r.text); ) {
        let c = e.mapping.slice(o).map(n + 1 + i + s.index);
        e.replaceWith(c, c + 1, t.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function OR(e, t, n, o) {
  t.forEach((r, i) => {
    if (r.type == r.type.schema.linebreakReplacement) {
      let s = e.mapping.slice(o).map(n + 1 + i);
      e.replaceWith(s, s + 1, t.type.schema.text(`
`));
    }
  });
}
function X6e(e, t, n) {
  let o = e.resolve(t), r = o.index();
  return o.parent.canReplaceWith(r, r + 1, n);
}
function J6e(e, t, n, o, r) {
  let i = e.doc.nodeAt(t);
  if (!i)
    throw new RangeError("No node at given position");
  n || (n = i.type);
  let s = n.create(o, null, r || i.marks);
  if (i.isLeaf)
    return e.replaceWith(t, t + i.nodeSize, s);
  if (!n.validContent(i.content))
    throw new RangeError("Invalid content for node type " + n.name);
  e.step(new Un(t, t + i.nodeSize, t + 1, t + i.nodeSize - 1, new et(je.from(s), 0, 0), 1, !0));
}
function El(e, t, n = 1, o) {
  let r = e.resolve(t), i = r.depth - n, s = o && o[o.length - 1] || r.parent;
  if (i < 0 || r.parent.type.spec.isolating || !r.parent.canReplace(r.index(), r.parent.childCount) || !s.type.validContent(r.parent.content.cutByIndex(r.index(), r.parent.childCount)))
    return !1;
  for (let d = r.depth - 1, u = n - 2; d > i; d--, u--) {
    let p = r.node(d), h = r.index(d);
    if (p.type.spec.isolating)
      return !1;
    let g = p.content.cutByIndex(h, p.childCount), m = o && o[u + 1];
    m && (g = g.replaceChild(0, m.type.create(m.attrs)));
    let b = o && o[u] || p;
    if (!p.canReplace(h + 1, p.childCount) || !b.type.validContent(g))
      return !1;
  }
  let a = r.indexAfter(i), c = o && o[0];
  return r.node(i).canReplaceWith(a, a, c ? c.type : r.node(i + 1).type);
}
function Q6e(e, t, n = 1, o) {
  let r = e.doc.resolve(t), i = je.empty, s = je.empty;
  for (let a = r.depth, c = r.depth - n, d = n - 1; a > c; a--, d--) {
    i = je.from(r.node(a).copy(i));
    let u = o && o[d];
    s = je.from(u ? u.type.create(u.attrs, s) : r.node(a).copy(s));
  }
  e.step(new Zn(t, t, new et(i.append(s), n, n), !0));
}
function Ps(e, t) {
  let n = e.resolve(t), o = n.index();
  return _R(n.nodeBefore, n.nodeAfter) && n.parent.canReplace(o, o + 1);
}
function epe(e, t) {
  t.content.size || e.type.compatibleContent(t.type);
  let n = e.contentMatchAt(e.childCount), { linebreakReplacement: o } = e.type.schema;
  for (let r = 0; r < t.childCount; r++) {
    let i = t.child(r), s = i.type == o ? e.type.schema.nodes.text : i.type;
    if (n = n.matchType(s), !n || !e.type.allowsMarks(i.marks))
      return !1;
  }
  return n.validEnd;
}
function _R(e, t) {
  return !!(e && t && !e.isLeaf && epe(e, t));
}
function ff(e, t, n = -1) {
  let o = e.resolve(t);
  for (let r = o.depth; ; r--) {
    let i, s, a = o.index(r);
    if (r == o.depth ? (i = o.nodeBefore, s = o.nodeAfter) : n > 0 ? (i = o.node(r + 1), a++, s = o.node(r).maybeChild(a)) : (i = o.node(r).maybeChild(a - 1), s = o.node(r + 1)), i && !i.isTextblock && _R(i, s) && o.node(r).canReplace(a, a + 1))
      return t;
    if (r == 0)
      break;
    t = n < 0 ? o.before(r) : o.after(r);
  }
}
function tpe(e, t, n) {
  let o = null, { linebreakReplacement: r } = e.doc.type.schema, i = e.doc.resolve(t - n), s = i.node().type;
  if (r && s.inlineContent) {
    let u = s.whitespace == "pre", p = !!s.contentMatch.matchType(r);
    u && !p ? o = !1 : !u && p && (o = !0);
  }
  let a = e.steps.length;
  if (o === !1) {
    let u = e.doc.resolve(t + n);
    OR(e, u.node(), u.before(), a);
  }
  s.inlineContent && p8(e, t + n - 1, s, i.node().contentMatchAt(i.index()), o == null);
  let c = e.mapping.slice(a), d = c.map(t - n);
  if (e.step(new Zn(d, c.map(t + n, -1), et.empty, !0)), o === !0) {
    let u = e.doc.resolve(d);
    RR(e, u.node(), u.before(), e.steps.length);
  }
  return e;
}
function npe(e, t, n) {
  let o = e.resolve(t);
  if (o.parent.canReplaceWith(o.index(), o.index(), n))
    return t;
  if (o.parentOffset == 0)
    for (let r = o.depth - 1; r >= 0; r--) {
      let i = o.index(r);
      if (o.node(r).canReplaceWith(i, i, n))
        return o.before(r + 1);
      if (i > 0)
        return null;
    }
  if (o.parentOffset == o.parent.content.size)
    for (let r = o.depth - 1; r >= 0; r--) {
      let i = o.indexAfter(r);
      if (o.node(r).canReplaceWith(i, i, n))
        return o.after(r + 1);
      if (i < o.node(r).childCount)
        return null;
    }
  return null;
}
function PR(e, t, n) {
  let o = e.resolve(t);
  if (!n.content.size)
    return t;
  let r = n.content;
  for (let i = 0; i < n.openStart; i++)
    r = r.firstChild.content;
  for (let i = 1; i <= (n.openStart == 0 && n.size ? 2 : 1); i++)
    for (let s = o.depth; s >= 0; s--) {
      let a = s == o.depth ? 0 : o.pos <= (o.start(s + 1) + o.end(s + 1)) / 2 ? -1 : 1, c = o.index(s) + (a > 0 ? 1 : 0), d = o.node(s), u = !1;
      if (i == 1)
        u = d.canReplace(c, c, r);
      else {
        let p = d.contentMatchAt(c).findWrapping(r.firstChild.type);
        u = p && d.canReplaceWith(c, c, p[0]);
      }
      if (u)
        return a == 0 ? o.pos : a < 0 ? o.before(s + 1) : o.after(s + 1);
    }
  return null;
}
function pf(e, t, n = t, o = et.empty) {
  if (t == n && !o.size)
    return null;
  let r = e.resolve(t), i = e.resolve(n);
  return LR(r, i, o) ? new Zn(t, n, o) : new ope(r, i, o).fit();
}
function LR(e, t, n) {
  return !n.openStart && !n.openEnd && e.start() == t.start() && e.parent.canReplace(e.index(), t.index(), n.content);
}
class ope {
  constructor(t, n, o) {
    this.$from = t, this.$to = n, this.unplaced = o, this.frontier = [], this.placed = je.empty;
    for (let r = 0; r <= t.depth; r++) {
      let i = t.node(r);
      this.frontier.push({
        type: i.type,
        match: i.contentMatchAt(t.indexAfter(r))
      });
    }
    for (let r = t.depth; r > 0; r--)
      this.placed = je.from(t.node(r).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let d = this.findFittable();
      d ? this.placeNodes(d) : this.openMore() || this.dropNode();
    }
    let t = this.mustMoveInline(), n = this.placed.size - this.depth - this.$from.depth, o = this.$from, r = this.close(t < 0 ? this.$to : o.doc.resolve(t));
    if (!r)
      return null;
    let i = this.placed, s = o.depth, a = r.depth;
    for (; s && a && i.childCount == 1; )
      i = i.firstChild.content, s--, a--;
    let c = new et(i, s, a);
    return t > -1 ? new Un(o.pos, t, this.$to.pos, this.$to.end(), c, n) : c.size || o.pos != this.$to.pos ? new Zn(o.pos, r.pos, c) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let t = this.unplaced.openStart;
    for (let n = this.unplaced.content, o = 0, r = this.unplaced.openEnd; o < t; o++) {
      let i = n.firstChild;
      if (n.childCount > 1 && (r = 0), i.type.spec.isolating && r <= o) {
        t = o;
        break;
      }
      n = i.content;
    }
    for (let n = 1; n <= 2; n++)
      for (let o = n == 1 ? t : this.unplaced.openStart; o >= 0; o--) {
        let r, i = null;
        o ? (i = W6(this.unplaced.content, o - 1).firstChild, r = i.content) : r = this.unplaced.content;
        let s = r.firstChild;
        for (let a = this.depth; a >= 0; a--) {
          let { type: c, match: d } = this.frontier[a], u, p = null;
          if (n == 1 && (s ? d.matchType(s.type) || (p = d.fillBefore(je.from(s), !1)) : i && c.compatibleContent(i.type)))
            return { sliceDepth: o, frontierDepth: a, parent: i, inject: p };
          if (n == 2 && s && (u = d.findWrapping(s.type)))
            return { sliceDepth: o, frontierDepth: a, parent: i, wrap: u };
          if (i && d.matchType(i.type))
            break;
        }
      }
  }
  openMore() {
    let { content: t, openStart: n, openEnd: o } = this.unplaced, r = W6(t, n);
    return !r.childCount || r.firstChild.isLeaf ? !1 : (this.unplaced = new et(t, n + 1, Math.max(o, r.size + n >= t.size - o ? n + 1 : 0)), !0);
  }
  dropNode() {
    let { content: t, openStart: n, openEnd: o } = this.unplaced, r = W6(t, n);
    if (r.childCount <= 1 && n > 0) {
      let i = t.size - n <= n + r.size;
      this.unplaced = new et(Y2(t, n - 1, 1), n - 1, i ? n - 1 : o);
    } else
      this.unplaced = new et(Y2(t, n, 1), n, o);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: t, frontierDepth: n, parent: o, inject: r, wrap: i }) {
    for (; this.depth > n; )
      this.closeFrontierNode();
    if (i)
      for (let b = 0; b < i.length; b++)
        this.openFrontierNode(i[b]);
    let s = this.unplaced, a = o ? o.content : s.content, c = s.openStart - t, d = 0, u = [], { match: p, type: h } = this.frontier[n];
    if (r) {
      for (let b = 0; b < r.childCount; b++)
        u.push(r.child(b));
      p = p.matchFragment(r);
    }
    let g = a.size + t - (s.content.size - s.openEnd);
    for (; d < a.childCount; ) {
      let b = a.child(d), C = p.matchType(b.type);
      if (!C)
        break;
      d++, (d > 1 || c == 0 || b.content.size) && (p = C, u.push(IR(b.mark(h.allowedMarks(b.marks)), d == 1 ? c : 0, d == a.childCount ? g : -1)));
    }
    let m = d == a.childCount;
    m || (g = -1), this.placed = X2(this.placed, n, je.from(u)), this.frontier[n].match = p, m && g < 0 && o && o.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let b = 0, C = a; b < g; b++) {
      let x = C.lastChild;
      this.frontier.push({ type: x.type, match: x.contentMatchAt(x.childCount) }), C = x.content;
    }
    this.unplaced = m ? t == 0 ? et.empty : new et(Y2(s.content, t - 1, 1), t - 1, g < 0 ? s.openEnd : t - 1) : new et(Y2(s.content, t, d), s.openStart, s.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let t = this.frontier[this.depth], n;
    if (!t.type.isTextblock || !U6(this.$to, this.$to.depth, t.type, t.match, !1) || this.$to.depth == this.depth && (n = this.findCloseLevel(this.$to)) && n.depth == this.depth)
      return -1;
    let { depth: o } = this.$to, r = this.$to.after(o);
    for (; o > 1 && r == this.$to.end(--o); )
      ++r;
    return r;
  }
  findCloseLevel(t) {
    e: for (let n = Math.min(this.depth, t.depth); n >= 0; n--) {
      let { match: o, type: r } = this.frontier[n], i = n < t.depth && t.end(n + 1) == t.pos + (t.depth - (n + 1)), s = U6(t, n, r, o, i);
      if (s) {
        for (let a = n - 1; a >= 0; a--) {
          let { match: c, type: d } = this.frontier[a], u = U6(t, a, d, c, !0);
          if (!u || u.childCount)
            continue e;
        }
        return { depth: n, fit: s, move: i ? t.doc.resolve(t.after(n + 1)) : t };
      }
    }
  }
  close(t) {
    let n = this.findCloseLevel(t);
    if (!n)
      return null;
    for (; this.depth > n.depth; )
      this.closeFrontierNode();
    n.fit.childCount && (this.placed = X2(this.placed, n.depth, n.fit)), t = n.move;
    for (let o = n.depth + 1; o <= t.depth; o++) {
      let r = t.node(o), i = r.type.contentMatch.fillBefore(r.content, !0, t.index(o));
      this.openFrontierNode(r.type, r.attrs, i);
    }
    return t;
  }
  openFrontierNode(t, n = null, o) {
    let r = this.frontier[this.depth];
    r.match = r.match.matchType(t), this.placed = X2(this.placed, this.depth, je.from(t.create(n, o))), this.frontier.push({ type: t, match: t.contentMatch });
  }
  closeFrontierNode() {
    let n = this.frontier.pop().match.fillBefore(je.empty, !0);
    n.childCount && (this.placed = X2(this.placed, this.frontier.length, n));
  }
}
function Y2(e, t, n) {
  return t == 0 ? e.cutByIndex(n, e.childCount) : e.replaceChild(0, e.firstChild.copy(Y2(e.firstChild.content, t - 1, n)));
}
function X2(e, t, n) {
  return t == 0 ? e.append(n) : e.replaceChild(e.childCount - 1, e.lastChild.copy(X2(e.lastChild.content, t - 1, n)));
}
function W6(e, t) {
  for (let n = 0; n < t; n++)
    e = e.firstChild.content;
  return e;
}
function IR(e, t, n) {
  if (t <= 0)
    return e;
  let o = e.content;
  return t > 1 && (o = o.replaceChild(0, IR(o.firstChild, t - 1, o.childCount == 1 ? n - 1 : 0))), t > 0 && (o = e.type.contentMatch.fillBefore(o).append(o), n <= 0 && (o = o.append(e.type.contentMatch.matchFragment(o).fillBefore(je.empty, !0)))), e.copy(o);
}
function U6(e, t, n, o, r) {
  let i = e.node(t), s = r ? e.indexAfter(t) : e.index(t);
  if (s == i.childCount && !n.compatibleContent(i.type))
    return null;
  let a = o.fillBefore(i.content, !0, s);
  return a && !rpe(n, i.content, s) ? a : null;
}
function rpe(e, t, n) {
  for (let o = n; o < t.childCount; o++)
    if (!e.allowsMarks(t.child(o).marks))
      return !0;
  return !1;
}
function ipe(e) {
  return e.spec.defining || e.spec.definingForContent;
}
function spe(e, t, n, o) {
  if (!o.size)
    return e.deleteRange(t, n);
  let r = e.doc.resolve(t), i = e.doc.resolve(n);
  if (LR(r, i, o))
    return e.step(new Zn(t, n, o));
  let s = VR(r, e.doc.resolve(n));
  s[s.length - 1] == 0 && s.pop();
  let a = -(r.depth + 1);
  s.unshift(a);
  for (let h = r.depth, g = r.pos - 1; h > 0; h--, g--) {
    let m = r.node(h).type.spec;
    if (m.defining || m.definingAsContext || m.isolating)
      break;
    s.indexOf(h) > -1 ? a = h : r.before(h) == g && s.splice(1, 0, -h);
  }
  let c = s.indexOf(a), d = [], u = o.openStart;
  for (let h = o.content, g = 0; ; g++) {
    let m = h.firstChild;
    if (d.push(m), g == o.openStart)
      break;
    h = m.content;
  }
  for (let h = u - 1; h >= 0; h--) {
    let g = d[h], m = ipe(g.type);
    if (m && !g.sameMarkup(r.node(Math.abs(a) - 1)))
      u = h;
    else if (m || !g.type.isTextblock)
      break;
  }
  for (let h = o.openStart; h >= 0; h--) {
    let g = (h + u + 1) % (o.openStart + 1), m = d[g];
    if (m)
      for (let b = 0; b < s.length; b++) {
        let C = s[(b + c) % s.length], x = !0;
        C < 0 && (x = !1, C = -C);
        let v = r.node(C - 1), S = r.index(C - 1);
        if (v.canReplaceWith(S, S, m.type, m.marks))
          return e.replace(r.before(C), x ? i.after(C) : n, new et(jR(o.content, 0, o.openStart, g), g, o.openEnd));
      }
  }
  let p = e.steps.length;
  for (let h = s.length - 1; h >= 0 && (e.replace(t, n, o), !(e.steps.length > p)); h--) {
    let g = s[h];
    g < 0 || (t = r.before(g), n = i.after(g));
  }
}
function jR(e, t, n, o, r) {
  if (t < n) {
    let i = e.firstChild;
    e = e.replaceChild(0, i.copy(jR(i.content, t + 1, n, o, i)));
  }
  if (t > o) {
    let i = r.contentMatchAt(0), s = i.fillBefore(e).append(e);
    e = s.append(i.matchFragment(s).fillBefore(je.empty, !0));
  }
  return e;
}
function ape(e, t, n, o) {
  if (!o.isInline && t == n && e.doc.resolve(t).parent.content.size) {
    let r = npe(e.doc, t, o.type);
    r != null && (t = n = r);
  }
  e.replaceRange(t, n, new et(je.from(o), 0, 0));
}
function lpe(e, t, n) {
  let o = e.doc.resolve(t), r = e.doc.resolve(n), i = VR(o, r);
  for (let s = 0; s < i.length; s++) {
    let a = i[s], c = s == i.length - 1;
    if (c && a == 0 || o.node(a).type.contentMatch.validEnd)
      return e.delete(o.start(a), r.end(a));
    if (a > 0 && (c || o.node(a - 1).canReplace(o.index(a - 1), r.indexAfter(a - 1))))
      return e.delete(o.before(a), r.after(a));
  }
  for (let s = 1; s <= o.depth && s <= r.depth; s++)
    if (t - o.start(s) == o.depth - s && n > o.end(s) && r.end(s) - n != r.depth - s && o.start(s - 1) == r.start(s - 1) && o.node(s - 1).canReplace(o.index(s - 1), r.index(s - 1)))
      return e.delete(o.before(s), n);
  e.delete(t, n);
}
function VR(e, t) {
  let n = [], o = Math.min(e.depth, t.depth);
  for (let r = o; r >= 0; r--) {
    let i = e.start(r);
    if (i < e.pos - (e.depth - r) || t.end(r) > t.pos + (t.depth - r) || e.node(r).type.spec.isolating || t.node(r).type.spec.isolating)
      break;
    (i == t.start(r) || r == e.depth && r == t.depth && e.parent.inlineContent && t.parent.inlineContent && r && t.start(r - 1) == i - 1) && n.push(r);
  }
  return n;
}
class Rl extends Co {
  /**
  Construct an attribute step.
  */
  constructor(t, n, o) {
    super(), this.pos = t, this.attr = n, this.value = o;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return An.fail("No node at attribute step's position");
    let o = /* @__PURE__ */ Object.create(null);
    for (let i in n.attrs)
      o[i] = n.attrs[i];
    o[this.attr] = this.value;
    let r = n.type.create(o, null, n.marks);
    return An.fromReplace(t, this.pos, this.pos + 1, new et(je.from(r), 0, n.isLeaf ? 0 : 1));
  }
  getMap() {
    return Ko.empty;
  }
  invert(t) {
    return new Rl(this.pos, this.attr, t.nodeAt(this.pos).attrs[this.attr]);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new Rl(n.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(t, n) {
    if (typeof n.pos != "number" || typeof n.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new Rl(n.pos, n.attr, n.value);
  }
}
Co.jsonID("attr", Rl);
class r0 extends Co {
  /**
  Construct an attribute step.
  */
  constructor(t, n) {
    super(), this.attr = t, this.value = n;
  }
  apply(t) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let r in t.attrs)
      n[r] = t.attrs[r];
    n[this.attr] = this.value;
    let o = t.type.create(n, t.content, t.marks);
    return An.ok(o);
  }
  getMap() {
    return Ko.empty;
  }
  invert(t) {
    return new r0(this.attr, t.attrs[this.attr]);
  }
  map(t) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(t, n) {
    if (typeof n.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new r0(n.attr, n.value);
  }
}
Co.jsonID("docAttr", r0);
let Wl = class extends Error {
};
Wl = function e(t) {
  let n = Error.call(this, t);
  return n.__proto__ = e.prototype, n;
};
Wl.prototype = Object.create(Error.prototype);
Wl.prototype.constructor = Wl;
Wl.prototype.name = "TransformError";
class DR {
  /**
  Create a transform that starts with the given document.
  */
  constructor(t) {
    this.doc = t, this.steps = [], this.docs = [], this.mapping = new kl();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(t) {
    let n = this.maybeStep(t);
    if (n.failed)
      throw new Wl(n.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(t) {
    let n = t.apply(this.doc);
    return n.failed || this.addStep(t, n.doc), n;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(t, n) {
    this.docs.push(this.doc), this.steps.push(t), this.mapping.appendMap(t.getMap()), this.doc = n;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(t, n = t, o = et.empty) {
    let r = pf(this.doc, t, n, o);
    return r && this.step(r), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(t, n, o) {
    return this.replace(t, n, new et(je.from(o), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(t, n) {
    return this.replace(t, n, et.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(t, n) {
    return this.replaceWith(t, t, n);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(t, n, o) {
    return spe(this, t, n, o), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(t, n, o) {
    return ape(this, t, n, o), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(t, n) {
    return lpe(this, t, n), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(t, n) {
    return U6e(this, t, n), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(t, n = 1) {
    return tpe(this, t, n), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(t, n) {
    return K6e(this, t, n), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(t, n = t, o, r = null) {
    return Y6e(this, t, n, o, r), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(t, n, o = null, r) {
    return J6e(this, t, n, o, r), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(t, n, o) {
    return this.step(new Rl(t, n, o)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(t, n) {
    return this.step(new r0(t, n)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(t, n) {
    return this.step(new is(t, n)), this;
  }
  /**
  Remove a mark (or a mark of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(t, n) {
    if (!(n instanceof an)) {
      let o = this.doc.nodeAt(t);
      if (!o)
        throw new RangeError("No node at position " + t);
      if (n = n.isInSet(o.marks), !n)
        return this;
    }
    return this.step(new Zl(t, n)), this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split.
  */
  split(t, n = 1, o) {
    return Q6e(this, t, n, o), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(t, n, o) {
    return z6e(this, t, n, o), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(t, n, o) {
    return Z6e(this, t, n, o), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(t, n, o) {
    return p8(this, t, n, o), this;
  }
}
const G6 = /* @__PURE__ */ Object.create(null);
class Mt {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(t, n, o) {
    this.$anchor = t, this.$head = n, this.ranges = o || [new cpe(t.min(n), t.max(n))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let t = this.ranges;
    for (let n = 0; n < t.length; n++)
      if (t[n].$from.pos != t[n].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(t, n = et.empty) {
    let o = n.content.lastChild, r = null;
    for (let a = 0; a < n.openEnd; a++)
      r = o, o = o.lastChild;
    let i = t.steps.length, s = this.ranges;
    for (let a = 0; a < s.length; a++) {
      let { $from: c, $to: d } = s[a], u = t.mapping.slice(i);
      t.replaceRange(u.map(c.pos), u.map(d.pos), a ? et.empty : n), a == 0 && sx(t, i, (o ? o.isInline : r && r.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(t, n) {
    let o = t.steps.length, r = this.ranges;
    for (let i = 0; i < r.length; i++) {
      let { $from: s, $to: a } = r[i], c = t.mapping.slice(o), d = c.map(s.pos), u = c.map(a.pos);
      i ? t.deleteRange(d, u) : (t.replaceRangeWith(d, u, n), sx(t, o, n.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(t, n, o = !1) {
    let r = t.parent.inlineContent ? new xt(t) : al(t.node(0), t.parent, t.pos, t.index(), n, o);
    if (r)
      return r;
    for (let i = t.depth - 1; i >= 0; i--) {
      let s = n < 0 ? al(t.node(0), t.node(i), t.before(i + 1), t.index(i), n, o) : al(t.node(0), t.node(i), t.after(i + 1), t.index(i) + 1, n, o);
      if (s)
        return s;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(t, n = 1) {
    return this.findFrom(t, n) || this.findFrom(t, -n) || new Cr(t.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(t) {
    return al(t, t, 0, 0, 1) || new Cr(t);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(t) {
    return al(t, t, t.content.size, t.childCount, -1) || new Cr(t);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(t, n) {
    if (!n || !n.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let o = G6[n.type];
    if (!o)
      throw new RangeError(`No selection type ${n.type} defined`);
    return o.fromJSON(t, n);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(t, n) {
    if (t in G6)
      throw new RangeError("Duplicate use of selection JSON ID " + t);
    return G6[t] = n, n.prototype.jsonID = t, n;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return xt.between(this.$anchor, this.$head).getBookmark();
  }
}
Mt.prototype.visible = !0;
class cpe {
  /**
  Create a range.
  */
  constructor(t, n) {
    this.$from = t, this.$to = n;
  }
}
let rx = !1;
function ix(e) {
  !rx && !e.parent.inlineContent && (rx = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + e.parent.type.name + ")"));
}
class xt extends Mt {
  /**
  Construct a text selection between the given points.
  */
  constructor(t, n = t) {
    ix(t), ix(n), super(t, n);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(t, n) {
    let o = t.resolve(n.map(this.head));
    if (!o.parent.inlineContent)
      return Mt.near(o);
    let r = t.resolve(n.map(this.anchor));
    return new xt(r.parent.inlineContent ? r : o, o);
  }
  replace(t, n = et.empty) {
    if (super.replace(t, n), n == et.empty) {
      let o = this.$from.marksAcross(this.$to);
      o && t.ensureMarks(o);
    }
  }
  eq(t) {
    return t instanceof xt && t.anchor == this.anchor && t.head == this.head;
  }
  getBookmark() {
    return new hf(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.anchor != "number" || typeof n.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new xt(t.resolve(n.anchor), t.resolve(n.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(t, n, o = n) {
    let r = t.resolve(n);
    return new this(r, o == n ? r : t.resolve(o));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(t, n, o) {
    let r = t.pos - n.pos;
    if ((!o || r) && (o = r >= 0 ? 1 : -1), !n.parent.inlineContent) {
      let i = Mt.findFrom(n, o, !0) || Mt.findFrom(n, -o, !0);
      if (i)
        n = i.$head;
      else
        return Mt.near(n, o);
    }
    return t.parent.inlineContent || (r == 0 ? t = n : (t = (Mt.findFrom(t, -o, !0) || Mt.findFrom(t, o, !0)).$anchor, t.pos < n.pos != r < 0 && (t = n))), new xt(t, n);
  }
}
Mt.jsonID("text", xt);
class hf {
  constructor(t, n) {
    this.anchor = t, this.head = n;
  }
  map(t) {
    return new hf(t.map(this.anchor), t.map(this.head));
  }
  resolve(t) {
    return xt.between(t.resolve(this.anchor), t.resolve(this.head));
  }
}
class ut extends Mt {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(t) {
    let n = t.nodeAfter, o = t.node(0).resolve(t.pos + n.nodeSize);
    super(t, o), this.node = n;
  }
  map(t, n) {
    let { deleted: o, pos: r } = n.mapResult(this.anchor), i = t.resolve(r);
    return o ? Mt.near(i) : new ut(i);
  }
  content() {
    return new et(je.from(this.node), 0, 0);
  }
  eq(t) {
    return t instanceof ut && t.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new g8(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new ut(t.resolve(n.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(t, n) {
    return new ut(t.resolve(n));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(t) {
    return !t.isText && t.type.spec.selectable !== !1;
  }
}
ut.prototype.visible = !1;
Mt.jsonID("node", ut);
class g8 {
  constructor(t) {
    this.anchor = t;
  }
  map(t) {
    let { deleted: n, pos: o } = t.mapResult(this.anchor);
    return n ? new hf(o, o) : new g8(o);
  }
  resolve(t) {
    let n = t.resolve(this.anchor), o = n.nodeAfter;
    return o && ut.isSelectable(o) ? new ut(n) : Mt.near(n);
  }
}
class Cr extends Mt {
  /**
  Create an all-selection over the given document.
  */
  constructor(t) {
    super(t.resolve(0), t.resolve(t.content.size));
  }
  replace(t, n = et.empty) {
    if (n == et.empty) {
      t.delete(0, t.doc.content.size);
      let o = Mt.atStart(t.doc);
      o.eq(t.selection) || t.setSelection(o);
    } else
      super.replace(t, n);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(t) {
    return new Cr(t);
  }
  map(t) {
    return new Cr(t);
  }
  eq(t) {
    return t instanceof Cr;
  }
  getBookmark() {
    return dpe;
  }
}
Mt.jsonID("all", Cr);
const dpe = {
  map() {
    return this;
  },
  resolve(e) {
    return new Cr(e);
  }
};
function al(e, t, n, o, r, i = !1) {
  if (t.inlineContent)
    return xt.create(e, n);
  for (let s = o - (r > 0 ? 0 : 1); r > 0 ? s < t.childCount : s >= 0; s += r) {
    let a = t.child(s);
    if (a.isAtom) {
      if (!i && ut.isSelectable(a))
        return ut.create(e, n - (r < 0 ? a.nodeSize : 0));
    } else {
      let c = al(e, a, n + r, r < 0 ? a.childCount : 0, r, i);
      if (c)
        return c;
    }
    n += a.nodeSize * r;
  }
  return null;
}
function sx(e, t, n) {
  let o = e.steps.length - 1;
  if (o < t)
    return;
  let r = e.steps[o];
  if (!(r instanceof Zn || r instanceof Un))
    return;
  let i = e.mapping.maps[o], s;
  i.forEach((a, c, d, u) => {
    s == null && (s = u);
  }), e.setSelection(Mt.near(e.doc.resolve(s), n));
}
const ax = 1, lx = 2, cx = 4;
class upe extends DR {
  /**
  @internal
  */
  constructor(t) {
    super(t.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = t.selection, this.storedMarks = t.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(t) {
    if (t.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = t, this.curSelectionFor = this.steps.length, this.updated = (this.updated | ax) & -3, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & ax) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(t) {
    return this.storedMarks = t, this.updated |= lx, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(t) {
    return an.sameSet(this.storedMarks || this.selection.$from.marks(), t) || this.setStoredMarks(t), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(t) {
    return this.ensureMarks(t.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(t) {
    return this.ensureMarks(t.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & lx) > 0;
  }
  /**
  @internal
  */
  addStep(t, n) {
    super.addStep(t, n), this.updated = this.updated & -3, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(t) {
    return this.time = t, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(t) {
    return this.selection.replace(this, t), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(t, n = !0) {
    let o = this.selection;
    return n && (t = t.mark(this.storedMarks || (o.empty ? o.$from.marks() : o.$from.marksAcross(o.$to) || an.none))), o.replaceWith(this, t), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(t, n, o) {
    let r = this.doc.type.schema;
    if (n == null)
      return t ? this.replaceSelectionWith(r.text(t), !0) : this.deleteSelection();
    {
      if (o == null && (o = n), o = o ?? n, !t)
        return this.deleteRange(n, o);
      let i = this.storedMarks;
      if (!i) {
        let s = this.doc.resolve(n);
        i = o == n ? s.marks() : s.marksAcross(this.doc.resolve(o));
      }
      return this.replaceRangeWith(n, o, r.text(t, i)), this.selection.empty || this.setSelection(Mt.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(t, n) {
    return this.meta[typeof t == "string" ? t : t.key] = n, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(t) {
    return this.meta[typeof t == "string" ? t : t.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let t in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= cx, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & cx) > 0;
  }
}
function dx(e, t) {
  return !t || !e ? e : e.bind(t);
}
class J2 {
  constructor(t, n, o) {
    this.name = t, this.init = dx(n.init, o), this.apply = dx(n.apply, o);
  }
}
const fpe = [
  new J2("doc", {
    init(e) {
      return e.doc || e.schema.topNodeType.createAndFill();
    },
    apply(e) {
      return e.doc;
    }
  }),
  new J2("selection", {
    init(e, t) {
      return e.selection || Mt.atStart(t.doc);
    },
    apply(e) {
      return e.selection;
    }
  }),
  new J2("storedMarks", {
    init(e) {
      return e.storedMarks || null;
    },
    apply(e, t, n, o) {
      return o.selection.$cursor ? e.storedMarks : null;
    }
  }),
  new J2("scrollToSelection", {
    init() {
      return 0;
    },
    apply(e, t) {
      return e.scrolledIntoView ? t + 1 : t;
    }
  })
];
class q6 {
  constructor(t, n) {
    this.schema = t, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = fpe.slice(), n && n.forEach((o) => {
      if (this.pluginsByKey[o.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + o.key + ")");
      this.plugins.push(o), this.pluginsByKey[o.key] = o, o.spec.state && this.fields.push(new J2(o.key, o.spec.state, o));
    });
  }
}
class hl {
  /**
  @internal
  */
  constructor(t) {
    this.config = t;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(t) {
    return this.applyTransaction(t).state;
  }
  /**
  @internal
  */
  filterTransaction(t, n = -1) {
    for (let o = 0; o < this.config.plugins.length; o++)
      if (o != n) {
        let r = this.config.plugins[o];
        if (r.spec.filterTransaction && !r.spec.filterTransaction.call(r, t, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(t) {
    if (!this.filterTransaction(t))
      return { state: this, transactions: [] };
    let n = [t], o = this.applyInner(t), r = null;
    for (; ; ) {
      let i = !1;
      for (let s = 0; s < this.config.plugins.length; s++) {
        let a = this.config.plugins[s];
        if (a.spec.appendTransaction) {
          let c = r ? r[s].n : 0, d = r ? r[s].state : this, u = c < n.length && a.spec.appendTransaction.call(a, c ? n.slice(c) : n, d, o);
          if (u && o.filterTransaction(u, s)) {
            if (u.setMeta("appendedTransaction", t), !r) {
              r = [];
              for (let p = 0; p < this.config.plugins.length; p++)
                r.push(p < s ? { state: o, n: n.length } : { state: this, n: 0 });
            }
            n.push(u), o = o.applyInner(u), i = !0;
          }
          r && (r[s] = { state: o, n: n.length });
        }
      }
      if (!i)
        return { state: o, transactions: n };
    }
  }
  /**
  @internal
  */
  applyInner(t) {
    if (!t.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let n = new hl(this.config), o = this.config.fields;
    for (let r = 0; r < o.length; r++) {
      let i = o[r];
      n[i.name] = i.apply(t, this[i.name], this, n);
    }
    return n;
  }
  /**
  Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new upe(this);
  }
  /**
  Create a new state.
  */
  static create(t) {
    let n = new q6(t.doc ? t.doc.type.schema : t.schema, t.plugins), o = new hl(n);
    for (let r = 0; r < n.fields.length; r++)
      o[n.fields[r].name] = n.fields[r].init(t, o);
    return o;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(t) {
    let n = new q6(this.schema, t.plugins), o = n.fields, r = new hl(n);
    for (let i = 0; i < o.length; i++) {
      let s = o[i].name;
      r[s] = this.hasOwnProperty(s) ? this[s] : o[i].init(t, r);
    }
    return r;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(t) {
    let n = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (n.storedMarks = this.storedMarks.map((o) => o.toJSON())), t && typeof t == "object")
      for (let o in t) {
        if (o == "doc" || o == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let r = t[o], i = r.spec.state;
        i && i.toJSON && (n[o] = i.toJSON.call(r, this[r.key]));
      }
    return n;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(t, n, o) {
    if (!n)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!t.schema)
      throw new RangeError("Required config field 'schema' missing");
    let r = new q6(t.schema, t.plugins), i = new hl(r);
    return r.fields.forEach((s) => {
      if (s.name == "doc")
        i.doc = ls.fromJSON(t.schema, n.doc);
      else if (s.name == "selection")
        i.selection = Mt.fromJSON(i.doc, n.selection);
      else if (s.name == "storedMarks")
        n.storedMarks && (i.storedMarks = n.storedMarks.map(t.schema.markFromJSON));
      else {
        if (o)
          for (let a in o) {
            let c = o[a], d = c.spec.state;
            if (c.key == s.name && d && d.fromJSON && Object.prototype.hasOwnProperty.call(n, a)) {
              i[s.name] = d.fromJSON.call(c, t, n[a], i);
              return;
            }
          }
        i[s.name] = s.init(t, i);
      }
    }), i;
  }
}
function AR(e, t, n) {
  for (let o in e) {
    let r = e[o];
    r instanceof Function ? r = r.bind(t) : o == "handleDOMEvents" && (r = AR(r, t, {})), n[o] = r;
  }
  return n;
}
class Kn {
  /**
  Create a plugin.
  */
  constructor(t) {
    this.spec = t, this.props = {}, t.props && AR(t.props, this, this.props), this.key = t.key ? t.key.key : HR("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(t) {
    return t[this.key];
  }
}
const K6 = /* @__PURE__ */ Object.create(null);
function HR(e) {
  return e in K6 ? e + "$" + ++K6[e] : (K6[e] = 0, e + "$");
}
class No {
  /**
  Create a plugin key.
  */
  constructor(t = "key") {
    this.key = HR(t);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(t) {
    return t.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(t) {
    return t[this.key];
  }
}
const Qn = function(e) {
  for (var t = 0; ; t++)
    if (e = e.previousSibling, !e)
      return t;
}, i0 = function(e) {
  let t = e.assignedSlot || e.parentNode;
  return t && t.nodeType == 11 ? t.host : t;
};
let _5 = null;
const yi = function(e, t, n) {
  let o = _5 || (_5 = document.createRange());
  return o.setEnd(e, n ?? e.nodeValue.length), o.setStart(e, t || 0), o;
}, ppe = function() {
  _5 = null;
}, Ra = function(e, t, n, o) {
  return n && (ux(e, t, n, o, -1) || ux(e, t, n, o, 1));
}, hpe = /^(img|br|input|textarea|hr)$/i;
function ux(e, t, n, o, r) {
  for (; ; ) {
    if (e == n && t == o)
      return !0;
    if (t == (r < 0 ? 0 : fr(e))) {
      let i = e.parentNode;
      if (!i || i.nodeType != 1 || K0(e) || hpe.test(e.nodeName) || e.contentEditable == "false")
        return !1;
      t = Qn(e) + (r < 0 ? 0 : 1), e = i;
    } else if (e.nodeType == 1) {
      if (e = e.childNodes[t + (r < 0 ? -1 : 0)], e.contentEditable == "false")
        return !1;
      t = r < 0 ? fr(e) : 0;
    } else
      return !1;
  }
}
function fr(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function gpe(e, t) {
  for (; ; ) {
    if (e.nodeType == 3 && t)
      return e;
    if (e.nodeType == 1 && t > 0) {
      if (e.contentEditable == "false")
        return null;
      e = e.childNodes[t - 1], t = fr(e);
    } else if (e.parentNode && !K0(e))
      t = Qn(e), e = e.parentNode;
    else
      return null;
  }
}
function mpe(e, t) {
  for (; ; ) {
    if (e.nodeType == 3 && t < e.nodeValue.length)
      return e;
    if (e.nodeType == 1 && t < e.childNodes.length) {
      if (e.contentEditable == "false")
        return null;
      e = e.childNodes[t], t = 0;
    } else if (e.parentNode && !K0(e))
      t = Qn(e) + 1, e = e.parentNode;
    else
      return null;
  }
}
function bpe(e, t, n) {
  for (let o = t == 0, r = t == fr(e); o || r; ) {
    if (e == n)
      return !0;
    let i = Qn(e);
    if (e = e.parentNode, !e)
      return !1;
    o = o && i == 0, r = r && i == fr(e);
  }
}
function K0(e) {
  let t;
  for (let n = e; n && !(t = n.pmViewDesc); n = n.parentNode)
    ;
  return t && t.node && t.node.isBlock && (t.dom == e || t.contentDOM == e);
}
const gf = function(e) {
  return e.focusNode && Ra(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset);
};
function Ks(e, t) {
  let n = document.createEvent("Event");
  return n.initEvent("keydown", !0, !0), n.keyCode = e, n.key = n.code = t, n;
}
function Cpe(e) {
  let t = e.activeElement;
  for (; t && t.shadowRoot; )
    t = t.shadowRoot.activeElement;
  return t;
}
function xpe(e, t, n) {
  if (e.caretPositionFromPoint)
    try {
      let o = e.caretPositionFromPoint(t, n);
      if (o)
        return { node: o.offsetNode, offset: Math.min(fr(o.offsetNode), o.offset) };
    } catch {
    }
  if (e.caretRangeFromPoint) {
    let o = e.caretRangeFromPoint(t, n);
    if (o)
      return { node: o.startContainer, offset: Math.min(fr(o.startContainer), o.startOffset) };
  }
}
const li = typeof navigator < "u" ? navigator : null, fx = typeof document < "u" ? document : null, Ls = li && li.userAgent || "", P5 = /Edge\/(\d+)/.exec(Ls), FR = /MSIE \d/.exec(Ls), L5 = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Ls), Ao = !!(FR || L5 || P5), ds = FR ? document.documentMode : L5 ? +L5[1] : P5 ? +P5[1] : 0, Vr = !Ao && /gecko\/(\d+)/i.test(Ls);
Vr && +(/Firefox\/(\d+)/.exec(Ls) || [0, 0])[1];
const I5 = !Ao && /Chrome\/(\d+)/.exec(Ls), po = !!I5, NR = I5 ? +I5[1] : 0, So = !Ao && !!li && /Apple Computer/.test(li.vendor), Ul = So && (/Mobile\/\w+/.test(Ls) || !!li && li.maxTouchPoints > 2), dr = Ul || (li ? /Mac/.test(li.platform) : !1), ype = li ? /Win/.test(li.platform) : !1, Oi = /Android \d/.test(Ls), Y0 = !!fx && "webkitFontSmoothing" in fx.documentElement.style, vpe = Y0 ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function wpe(e) {
  let t = e.defaultView && e.defaultView.visualViewport;
  return t ? {
    left: 0,
    right: t.width,
    top: 0,
    bottom: t.height
  } : {
    left: 0,
    right: e.documentElement.clientWidth,
    top: 0,
    bottom: e.documentElement.clientHeight
  };
}
function hi(e, t) {
  return typeof e == "number" ? e : e[t];
}
function Spe(e) {
  let t = e.getBoundingClientRect(), n = t.width / e.offsetWidth || 1, o = t.height / e.offsetHeight || 1;
  return {
    left: t.left,
    right: t.left + e.clientWidth * n,
    top: t.top,
    bottom: t.top + e.clientHeight * o
  };
}
function px(e, t, n) {
  let o = e.someProp("scrollThreshold") || 0, r = e.someProp("scrollMargin") || 5, i = e.dom.ownerDocument;
  for (let s = n || e.dom; s; s = i0(s)) {
    if (s.nodeType != 1)
      continue;
    let a = s, c = a == i.body, d = c ? wpe(i) : Spe(a), u = 0, p = 0;
    if (t.top < d.top + hi(o, "top") ? p = -(d.top - t.top + hi(r, "top")) : t.bottom > d.bottom - hi(o, "bottom") && (p = t.bottom - t.top > d.bottom - d.top ? t.top + hi(r, "top") - d.top : t.bottom - d.bottom + hi(r, "bottom")), t.left < d.left + hi(o, "left") ? u = -(d.left - t.left + hi(r, "left")) : t.right > d.right - hi(o, "right") && (u = t.right - d.right + hi(r, "right")), u || p)
      if (c)
        i.defaultView.scrollBy(u, p);
      else {
        let h = a.scrollLeft, g = a.scrollTop;
        p && (a.scrollTop += p), u && (a.scrollLeft += u);
        let m = a.scrollLeft - h, b = a.scrollTop - g;
        t = { left: t.left - m, top: t.top - b, right: t.right - m, bottom: t.bottom - b };
      }
    if (c || /^(fixed|sticky)$/.test(getComputedStyle(s).position))
      break;
  }
}
function Mpe(e) {
  let t = e.dom.getBoundingClientRect(), n = Math.max(0, t.top), o, r;
  for (let i = (t.left + t.right) / 2, s = n + 1; s < Math.min(innerHeight, t.bottom); s += 5) {
    let a = e.root.elementFromPoint(i, s);
    if (!a || a == e.dom || !e.dom.contains(a))
      continue;
    let c = a.getBoundingClientRect();
    if (c.top >= n - 20) {
      o = a, r = c.top;
      break;
    }
  }
  return { refDOM: o, refTop: r, stack: $R(e.dom) };
}
function $R(e) {
  let t = [], n = e.ownerDocument;
  for (let o = e; o && (t.push({ dom: o, top: o.scrollTop, left: o.scrollLeft }), e != n); o = i0(o))
    ;
  return t;
}
function Tpe({ refDOM: e, refTop: t, stack: n }) {
  let o = e ? e.getBoundingClientRect().top : 0;
  BR(n, o == 0 ? 0 : o - t);
}
function BR(e, t) {
  for (let n = 0; n < e.length; n++) {
    let { dom: o, top: r, left: i } = e[n];
    o.scrollTop != r + t && (o.scrollTop = r + t), o.scrollLeft != i && (o.scrollLeft = i);
  }
}
let nl = null;
function kpe(e) {
  if (e.setActive)
    return e.setActive();
  if (nl)
    return e.focus(nl);
  let t = $R(e);
  e.focus(nl == null ? {
    get preventScroll() {
      return nl = { preventScroll: !0 }, !0;
    }
  } : void 0), nl || (nl = !1, BR(t, 0));
}
function zR(e, t) {
  let n, o = 2e8, r, i = 0, s = t.top, a = t.top, c, d;
  for (let u = e.firstChild, p = 0; u; u = u.nextSibling, p++) {
    let h;
    if (u.nodeType == 1)
      h = u.getClientRects();
    else if (u.nodeType == 3)
      h = yi(u).getClientRects();
    else
      continue;
    for (let g = 0; g < h.length; g++) {
      let m = h[g];
      if (m.top <= s && m.bottom >= a) {
        s = Math.max(m.bottom, s), a = Math.min(m.top, a);
        let b = m.left > t.left ? m.left - t.left : m.right < t.left ? t.left - m.right : 0;
        if (b < o) {
          n = u, o = b, r = b && n.nodeType == 3 ? {
            left: m.right < t.left ? m.right : m.left,
            top: t.top
          } : t, u.nodeType == 1 && b && (i = p + (t.left >= (m.left + m.right) / 2 ? 1 : 0));
          continue;
        }
      } else m.top > t.top && !c && m.left <= t.left && m.right >= t.left && (c = u, d = { left: Math.max(m.left, Math.min(m.right, t.left)), top: m.top });
      !n && (t.left >= m.right && t.top >= m.top || t.left >= m.left && t.top >= m.bottom) && (i = p + 1);
    }
  }
  return !n && c && (n = c, r = d, o = 0), n && n.nodeType == 3 ? Epe(n, r) : !n || o && n.nodeType == 1 ? { node: e, offset: i } : zR(n, r);
}
function Epe(e, t) {
  let n = e.nodeValue.length, o = document.createRange();
  for (let r = 0; r < n; r++) {
    o.setEnd(e, r + 1), o.setStart(e, r);
    let i = zi(o, 1);
    if (i.top != i.bottom && m8(t, i))
      return { node: e, offset: r + (t.left >= (i.left + i.right) / 2 ? 1 : 0) };
  }
  return { node: e, offset: 0 };
}
function m8(e, t) {
  return e.left >= t.left - 1 && e.left <= t.right + 1 && e.top >= t.top - 1 && e.top <= t.bottom + 1;
}
function Rpe(e, t) {
  let n = e.parentNode;
  return n && /^li$/i.test(n.nodeName) && t.left < e.getBoundingClientRect().left ? n : e;
}
function Ope(e, t, n) {
  let { node: o, offset: r } = zR(t, n), i = -1;
  if (o.nodeType == 1 && !o.firstChild) {
    let s = o.getBoundingClientRect();
    i = s.left != s.right && n.left > (s.left + s.right) / 2 ? 1 : -1;
  }
  return e.docView.posFromDOM(o, r, i);
}
function _pe(e, t, n, o) {
  let r = -1;
  for (let i = t, s = !1; i != e.dom; ) {
    let a = e.docView.nearestDesc(i, !0), c;
    if (!a)
      return null;
    if (a.dom.nodeType == 1 && (a.node.isBlock && a.parent || !a.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((c = a.dom.getBoundingClientRect()).width || c.height) && (a.node.isBlock && a.parent && (!s && c.left > o.left || c.top > o.top ? r = a.posBefore : (!s && c.right < o.left || c.bottom < o.top) && (r = a.posAfter), s = !0), !a.contentDOM && r < 0 && !a.node.isText))
      return (a.node.isBlock ? o.top < (c.top + c.bottom) / 2 : o.left < (c.left + c.right) / 2) ? a.posBefore : a.posAfter;
    i = a.dom.parentNode;
  }
  return r > -1 ? r : e.docView.posFromDOM(t, n, -1);
}
function ZR(e, t, n) {
  let o = e.childNodes.length;
  if (o && n.top < n.bottom)
    for (let r = Math.max(0, Math.min(o - 1, Math.floor(o * (t.top - n.top) / (n.bottom - n.top)) - 2)), i = r; ; ) {
      let s = e.childNodes[i];
      if (s.nodeType == 1) {
        let a = s.getClientRects();
        for (let c = 0; c < a.length; c++) {
          let d = a[c];
          if (m8(t, d))
            return ZR(s, t, d);
        }
      }
      if ((i = (i + 1) % o) == r)
        break;
    }
  return e;
}
function Ppe(e, t) {
  let n = e.dom.ownerDocument, o, r = 0, i = xpe(n, t.left, t.top);
  i && ({ node: o, offset: r } = i);
  let s = (e.root.elementFromPoint ? e.root : n).elementFromPoint(t.left, t.top), a;
  if (!s || !e.dom.contains(s.nodeType != 1 ? s.parentNode : s)) {
    let d = e.dom.getBoundingClientRect();
    if (!m8(t, d) || (s = ZR(e.dom, t, d), !s))
      return null;
  }
  if (So)
    for (let d = s; o && d; d = i0(d))
      d.draggable && (o = void 0);
  if (s = Rpe(s, t), o) {
    if (Vr && o.nodeType == 1 && (r = Math.min(r, o.childNodes.length), r < o.childNodes.length)) {
      let u = o.childNodes[r], p;
      u.nodeName == "IMG" && (p = u.getBoundingClientRect()).right <= t.left && p.bottom > t.top && r++;
    }
    let d;
    Y0 && r && o.nodeType == 1 && (d = o.childNodes[r - 1]).nodeType == 1 && d.contentEditable == "false" && d.getBoundingClientRect().top >= t.top && r--, o == e.dom && r == o.childNodes.length - 1 && o.lastChild.nodeType == 1 && t.top > o.lastChild.getBoundingClientRect().bottom ? a = e.state.doc.content.size : (r == 0 || o.nodeType != 1 || o.childNodes[r - 1].nodeName != "BR") && (a = _pe(e, o, r, t));
  }
  a == null && (a = Ope(e, s, t));
  let c = e.docView.nearestDesc(s, !0);
  return { pos: a, inside: c ? c.posAtStart - c.border : -1 };
}
function hx(e) {
  return e.top < e.bottom || e.left < e.right;
}
function zi(e, t) {
  let n = e.getClientRects();
  if (n.length) {
    let o = n[t < 0 ? 0 : n.length - 1];
    if (hx(o))
      return o;
  }
  return Array.prototype.find.call(n, hx) || e.getBoundingClientRect();
}
const Lpe = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function WR(e, t, n) {
  let { node: o, offset: r, atom: i } = e.docView.domFromPos(t, n < 0 ? -1 : 1), s = Y0 || Vr;
  if (o.nodeType == 3)
    if (s && (Lpe.test(o.nodeValue) || (n < 0 ? !r : r == o.nodeValue.length))) {
      let c = zi(yi(o, r, r), n);
      if (Vr && r && /\s/.test(o.nodeValue[r - 1]) && r < o.nodeValue.length) {
        let d = zi(yi(o, r - 1, r - 1), -1);
        if (d.top == c.top) {
          let u = zi(yi(o, r, r + 1), -1);
          if (u.top != c.top)
            return F2(u, u.left < d.left);
        }
      }
      return c;
    } else {
      let c = r, d = r, u = n < 0 ? 1 : -1;
      return n < 0 && !r ? (d++, u = -1) : n >= 0 && r == o.nodeValue.length ? (c--, u = 1) : n < 0 ? c-- : d++, F2(zi(yi(o, c, d), u), u < 0);
    }
  if (!e.state.doc.resolve(t - (i || 0)).parent.inlineContent) {
    if (i == null && r && (n < 0 || r == fr(o))) {
      let c = o.childNodes[r - 1];
      if (c.nodeType == 1)
        return Y6(c.getBoundingClientRect(), !1);
    }
    if (i == null && r < fr(o)) {
      let c = o.childNodes[r];
      if (c.nodeType == 1)
        return Y6(c.getBoundingClientRect(), !0);
    }
    return Y6(o.getBoundingClientRect(), n >= 0);
  }
  if (i == null && r && (n < 0 || r == fr(o))) {
    let c = o.childNodes[r - 1], d = c.nodeType == 3 ? yi(c, fr(c) - (s ? 0 : 1)) : c.nodeType == 1 && (c.nodeName != "BR" || !c.nextSibling) ? c : null;
    if (d)
      return F2(zi(d, 1), !1);
  }
  if (i == null && r < fr(o)) {
    let c = o.childNodes[r];
    for (; c.pmViewDesc && c.pmViewDesc.ignoreForCoords; )
      c = c.nextSibling;
    let d = c ? c.nodeType == 3 ? yi(c, 0, s ? 0 : 1) : c.nodeType == 1 ? c : null : null;
    if (d)
      return F2(zi(d, -1), !0);
  }
  return F2(zi(o.nodeType == 3 ? yi(o) : o, -n), n >= 0);
}
function F2(e, t) {
  if (e.width == 0)
    return e;
  let n = t ? e.left : e.right;
  return { top: e.top, bottom: e.bottom, left: n, right: n };
}
function Y6(e, t) {
  if (e.height == 0)
    return e;
  let n = t ? e.top : e.bottom;
  return { top: n, bottom: n, left: e.left, right: e.right };
}
function UR(e, t, n) {
  let o = e.state, r = e.root.activeElement;
  o != t && e.updateState(t), r != e.dom && e.focus();
  try {
    return n();
  } finally {
    o != t && e.updateState(o), r != e.dom && r && r.focus();
  }
}
function Ipe(e, t, n) {
  let o = t.selection, r = n == "up" ? o.$from : o.$to;
  return UR(e, t, () => {
    let { node: i } = e.docView.domFromPos(r.pos, n == "up" ? -1 : 1);
    for (; ; ) {
      let a = e.docView.nearestDesc(i, !0);
      if (!a)
        break;
      if (a.node.isBlock) {
        i = a.contentDOM || a.dom;
        break;
      }
      i = a.dom.parentNode;
    }
    let s = WR(e, r.pos, 1);
    for (let a = i.firstChild; a; a = a.nextSibling) {
      let c;
      if (a.nodeType == 1)
        c = a.getClientRects();
      else if (a.nodeType == 3)
        c = yi(a, 0, a.nodeValue.length).getClientRects();
      else
        continue;
      for (let d = 0; d < c.length; d++) {
        let u = c[d];
        if (u.bottom > u.top + 1 && (n == "up" ? s.top - u.top > (u.bottom - s.top) * 2 : u.bottom - s.bottom > (s.bottom - u.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const jpe = /[\u0590-\u08ac]/;
function Vpe(e, t, n) {
  let { $head: o } = t.selection;
  if (!o.parent.isTextblock)
    return !1;
  let r = o.parentOffset, i = !r, s = r == o.parent.content.size, a = e.domSelection();
  return a ? !jpe.test(o.parent.textContent) || !a.modify ? n == "left" || n == "backward" ? i : s : UR(e, t, () => {
    let { focusNode: c, focusOffset: d, anchorNode: u, anchorOffset: p } = e.domSelectionRange(), h = a.caretBidiLevel;
    a.modify("move", n, "character");
    let g = o.depth ? e.docView.domAfterPos(o.before()) : e.dom, { focusNode: m, focusOffset: b } = e.domSelectionRange(), C = m && !g.contains(m.nodeType == 1 ? m : m.parentNode) || c == m && d == b;
    try {
      a.collapse(u, p), c && (c != u || d != p) && a.extend && a.extend(c, d);
    } catch {
    }
    return h != null && (a.caretBidiLevel = h), C;
  }) : o.pos == o.start() || o.pos == o.end();
}
let gx = null, mx = null, bx = !1;
function Dpe(e, t, n) {
  return gx == t && mx == n ? bx : (gx = t, mx = n, bx = n == "up" || n == "down" ? Ipe(e, t, n) : Vpe(e, t, n));
}
const xr = 0, Cx = 1, ea = 2, ci = 3;
class X0 {
  constructor(t, n, o, r) {
    this.parent = t, this.children = n, this.dom = o, this.contentDOM = r, this.dirty = xr, o.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(t) {
    return !1;
  }
  matchesMark(t) {
    return !1;
  }
  matchesNode(t, n, o) {
    return !1;
  }
  matchesHack(t) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(t) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let t = 0;
    for (let n = 0; n < this.children.length; n++)
      t += this.children[n].size;
    return t;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let t = 0; t < this.children.length; t++)
      this.children[t].destroy();
  }
  posBeforeChild(t) {
    for (let n = 0, o = this.posAtStart; ; n++) {
      let r = this.children[n];
      if (r == t)
        return o;
      o += r.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(t, n, o) {
    if (this.contentDOM && this.contentDOM.contains(t.nodeType == 1 ? t : t.parentNode))
      if (o < 0) {
        let i, s;
        if (t == this.contentDOM)
          i = t.childNodes[n - 1];
        else {
          for (; t.parentNode != this.contentDOM; )
            t = t.parentNode;
          i = t.previousSibling;
        }
        for (; i && !((s = i.pmViewDesc) && s.parent == this); )
          i = i.previousSibling;
        return i ? this.posBeforeChild(s) + s.size : this.posAtStart;
      } else {
        let i, s;
        if (t == this.contentDOM)
          i = t.childNodes[n];
        else {
          for (; t.parentNode != this.contentDOM; )
            t = t.parentNode;
          i = t.nextSibling;
        }
        for (; i && !((s = i.pmViewDesc) && s.parent == this); )
          i = i.nextSibling;
        return i ? this.posBeforeChild(s) : this.posAtEnd;
      }
    let r;
    if (t == this.dom && this.contentDOM)
      r = n > Qn(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      r = t.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (n == 0)
        for (let i = t; ; i = i.parentNode) {
          if (i == this.dom) {
            r = !1;
            break;
          }
          if (i.previousSibling)
            break;
        }
      if (r == null && n == t.childNodes.length)
        for (let i = t; ; i = i.parentNode) {
          if (i == this.dom) {
            r = !0;
            break;
          }
          if (i.nextSibling)
            break;
        }
    }
    return r ?? o > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(t, n = !1) {
    for (let o = !0, r = t; r; r = r.parentNode) {
      let i = this.getDesc(r), s;
      if (i && (!n || i.node))
        if (o && (s = i.nodeDOM) && !(s.nodeType == 1 ? s.contains(t.nodeType == 1 ? t : t.parentNode) : s == t))
          o = !1;
        else
          return i;
    }
  }
  getDesc(t) {
    let n = t.pmViewDesc;
    for (let o = n; o; o = o.parent)
      if (o == this)
        return n;
  }
  posFromDOM(t, n, o) {
    for (let r = t; r; r = r.parentNode) {
      let i = this.getDesc(r);
      if (i)
        return i.localPosFromDOM(t, n, o);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(t) {
    for (let n = 0, o = 0; n < this.children.length; n++) {
      let r = this.children[n], i = o + r.size;
      if (o == t && i != o) {
        for (; !r.border && r.children.length; )
          r = r.children[0];
        return r;
      }
      if (t < i)
        return r.descAt(t - o - r.border);
      o = i;
    }
  }
  domFromPos(t, n) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: t + 1 };
    let o = 0, r = 0;
    for (let i = 0; o < this.children.length; o++) {
      let s = this.children[o], a = i + s.size;
      if (a > t || s instanceof qR) {
        r = t - i;
        break;
      }
      i = a;
    }
    if (r)
      return this.children[o].domFromPos(r - this.children[o].border, n);
    for (let i; o && !(i = this.children[o - 1]).size && i instanceof GR && i.side >= 0; o--)
      ;
    if (n <= 0) {
      let i, s = !0;
      for (; i = o ? this.children[o - 1] : null, !(!i || i.dom.parentNode == this.contentDOM); o--, s = !1)
        ;
      return i && n && s && !i.border && !i.domAtom ? i.domFromPos(i.size, n) : { node: this.contentDOM, offset: i ? Qn(i.dom) + 1 : 0 };
    } else {
      let i, s = !0;
      for (; i = o < this.children.length ? this.children[o] : null, !(!i || i.dom.parentNode == this.contentDOM); o++, s = !1)
        ;
      return i && s && !i.border && !i.domAtom ? i.domFromPos(0, n) : { node: this.contentDOM, offset: i ? Qn(i.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(t, n, o = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: t, to: n, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let r = -1, i = -1;
    for (let s = o, a = 0; ; a++) {
      let c = this.children[a], d = s + c.size;
      if (r == -1 && t <= d) {
        let u = s + c.border;
        if (t >= u && n <= d - c.border && c.node && c.contentDOM && this.contentDOM.contains(c.contentDOM))
          return c.parseRange(t, n, u);
        t = s;
        for (let p = a; p > 0; p--) {
          let h = this.children[p - 1];
          if (h.size && h.dom.parentNode == this.contentDOM && !h.emptyChildAt(1)) {
            r = Qn(h.dom) + 1;
            break;
          }
          t -= h.size;
        }
        r == -1 && (r = 0);
      }
      if (r > -1 && (d > n || a == this.children.length - 1)) {
        n = d;
        for (let u = a + 1; u < this.children.length; u++) {
          let p = this.children[u];
          if (p.size && p.dom.parentNode == this.contentDOM && !p.emptyChildAt(-1)) {
            i = Qn(p.dom);
            break;
          }
          n += p.size;
        }
        i == -1 && (i = this.contentDOM.childNodes.length);
        break;
      }
      s = d;
    }
    return { node: this.contentDOM, from: t, to: n, fromOffset: r, toOffset: i };
  }
  emptyChildAt(t) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let n = this.children[t < 0 ? 0 : this.children.length - 1];
    return n.size == 0 || n.emptyChildAt(t);
  }
  domAfterPos(t) {
    let { node: n, offset: o } = this.domFromPos(t, 0);
    if (n.nodeType != 1 || o == n.childNodes.length)
      throw new RangeError("No node after pos " + t);
    return n.childNodes[o];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(t, n, o, r = !1) {
    let i = Math.min(t, n), s = Math.max(t, n);
    for (let g = 0, m = 0; g < this.children.length; g++) {
      let b = this.children[g], C = m + b.size;
      if (i > m && s < C)
        return b.setSelection(t - m - b.border, n - m - b.border, o, r);
      m = C;
    }
    let a = this.domFromPos(t, t ? -1 : 1), c = n == t ? a : this.domFromPos(n, n ? -1 : 1), d = o.root.getSelection(), u = o.domSelectionRange(), p = !1;
    if ((Vr || So) && t == n) {
      let { node: g, offset: m } = a;
      if (g.nodeType == 3) {
        if (p = !!(m && g.nodeValue[m - 1] == `
`), p && m == g.nodeValue.length)
          for (let b = g, C; b; b = b.parentNode) {
            if (C = b.nextSibling) {
              C.nodeName == "BR" && (a = c = { node: C.parentNode, offset: Qn(C) + 1 });
              break;
            }
            let x = b.pmViewDesc;
            if (x && x.node && x.node.isBlock)
              break;
          }
      } else {
        let b = g.childNodes[m - 1];
        p = b && (b.nodeName == "BR" || b.contentEditable == "false");
      }
    }
    if (Vr && u.focusNode && u.focusNode != c.node && u.focusNode.nodeType == 1) {
      let g = u.focusNode.childNodes[u.focusOffset];
      g && g.contentEditable == "false" && (r = !0);
    }
    if (!(r || p && So) && Ra(a.node, a.offset, u.anchorNode, u.anchorOffset) && Ra(c.node, c.offset, u.focusNode, u.focusOffset))
      return;
    let h = !1;
    if ((d.extend || t == n) && !p) {
      d.collapse(a.node, a.offset);
      try {
        t != n && d.extend(c.node, c.offset), h = !0;
      } catch {
      }
    }
    if (!h) {
      if (t > n) {
        let m = a;
        a = c, c = m;
      }
      let g = document.createRange();
      g.setEnd(c.node, c.offset), g.setStart(a.node, a.offset), d.removeAllRanges(), d.addRange(g);
    }
  }
  ignoreMutation(t) {
    return !this.contentDOM && t.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(t, n) {
    for (let o = 0, r = 0; r < this.children.length; r++) {
      let i = this.children[r], s = o + i.size;
      if (o == s ? t <= s && n >= o : t < s && n > o) {
        let a = o + i.border, c = s - i.border;
        if (t >= a && n <= c) {
          this.dirty = t == o || n == s ? ea : Cx, t == a && n == c && (i.contentLost || i.dom.parentNode != this.contentDOM) ? i.dirty = ci : i.markDirty(t - a, n - a);
          return;
        } else
          i.dirty = i.dom == i.contentDOM && i.dom.parentNode == this.contentDOM && !i.children.length ? ea : ci;
      }
      o = s;
    }
    this.dirty = ea;
  }
  markParentsDirty() {
    let t = 1;
    for (let n = this.parent; n; n = n.parent, t++) {
      let o = t == 1 ? ea : Cx;
      n.dirty < o && (n.dirty = o);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  isText(t) {
    return !1;
  }
}
class GR extends X0 {
  constructor(t, n, o, r) {
    let i, s = n.type.toDOM;
    if (typeof s == "function" && (s = s(o, () => {
      if (!i)
        return r;
      if (i.parent)
        return i.parent.posBeforeChild(i);
    })), !n.type.spec.raw) {
      if (s.nodeType != 1) {
        let a = document.createElement("span");
        a.appendChild(s), s = a;
      }
      s.contentEditable = "false", s.classList.add("ProseMirror-widget");
    }
    super(t, [], s, null), this.widget = n, this.widget = n, i = this;
  }
  matchesWidget(t) {
    return this.dirty == xr && t.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(t) {
    let n = this.widget.spec.stopEvent;
    return n ? n(t) : !1;
  }
  ignoreMutation(t) {
    return t.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get side() {
    return this.widget.type.side;
  }
}
class Ape extends X0 {
  constructor(t, n, o, r) {
    super(t, [], n, null), this.textDOM = o, this.text = r;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(t, n) {
    return t != this.textDOM ? this.posAtStart + (n ? this.size : 0) : this.posAtStart + n;
  }
  domFromPos(t) {
    return { node: this.textDOM, offset: t };
  }
  ignoreMutation(t) {
    return t.type === "characterData" && t.target.nodeValue == t.oldValue;
  }
}
class Oa extends X0 {
  constructor(t, n, o, r, i) {
    super(t, [], o, r), this.mark = n, this.spec = i;
  }
  static create(t, n, o, r) {
    let i = r.nodeViews[n.type.name], s = i && i(n, r, o);
    return (!s || !s.dom) && (s = Ba.renderSpec(document, n.type.spec.toDOM(n, o), null, n.attrs)), new Oa(t, n, s.dom, s.contentDOM || s.dom, s);
  }
  parseRule() {
    return this.dirty & ci || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(t) {
    return this.dirty != ci && this.mark.eq(t);
  }
  markDirty(t, n) {
    if (super.markDirty(t, n), this.dirty != xr) {
      let o = this.parent;
      for (; !o.node; )
        o = o.parent;
      o.dirty < this.dirty && (o.dirty = this.dirty), this.dirty = xr;
    }
  }
  slice(t, n, o) {
    let r = Oa.create(this.parent, this.mark, !0, o), i = this.children, s = this.size;
    n < s && (i = V5(i, n, s, o)), t > 0 && (i = V5(i, 0, t, o));
    for (let a = 0; a < i.length; a++)
      i[a].parent = r;
    return r.children = i, r;
  }
  ignoreMutation(t) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(t) : super.ignoreMutation(t);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class us extends X0 {
  constructor(t, n, o, r, i, s, a, c, d) {
    super(t, [], i, s), this.node = n, this.outerDeco = o, this.innerDeco = r, this.nodeDOM = a;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(t, n, o, r, i, s) {
    let a = i.nodeViews[n.type.name], c, d = a && a(n, i, () => {
      if (!c)
        return s;
      if (c.parent)
        return c.parent.posBeforeChild(c);
    }, o, r), u = d && d.dom, p = d && d.contentDOM;
    if (n.isText) {
      if (!u)
        u = document.createTextNode(n.text);
      else if (u.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else u || ({ dom: u, contentDOM: p } = Ba.renderSpec(document, n.type.spec.toDOM(n), null, n.attrs));
    !p && !n.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), n.type.spec.draggable && (u.draggable = !0));
    let h = u;
    return u = XR(u, o, n), d ? c = new Hpe(t, n, o, r, u, p || null, h, d, i, s + 1) : n.isText ? new mf(t, n, o, r, u, h, i) : new us(t, n, o, r, u, p || null, h, i, s + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let t = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (t.preserveWhitespace = "full"), !this.contentDOM)
      t.getContent = () => this.node.content;
    else if (!this.contentLost)
      t.contentElement = this.contentDOM;
    else {
      for (let n = this.children.length - 1; n >= 0; n--) {
        let o = this.children[n];
        if (this.dom.contains(o.dom.parentNode)) {
          t.contentElement = o.dom.parentNode;
          break;
        }
      }
      t.contentElement || (t.getContent = () => je.empty);
    }
    return t;
  }
  matchesNode(t, n, o) {
    return this.dirty == xr && t.eq(this.node) && yu(n, this.outerDeco) && o.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(t, n) {
    let o = this.node.inlineContent, r = n, i = t.composing ? this.localCompositionInfo(t, n) : null, s = i && i.pos > -1 ? i : null, a = i && i.pos < 0, c = new Npe(this, s && s.node, t);
    zpe(this.node, this.innerDeco, (d, u, p) => {
      d.spec.marks ? c.syncToMarks(d.spec.marks, o, t) : d.type.side >= 0 && !p && c.syncToMarks(u == this.node.childCount ? an.none : this.node.child(u).marks, o, t), c.placeWidget(d, t, r);
    }, (d, u, p, h) => {
      c.syncToMarks(d.marks, o, t);
      let g;
      c.findNodeMatch(d, u, p, h) || a && t.state.selection.from > r && t.state.selection.to < r + d.nodeSize && (g = c.findIndexWithChild(i.node)) > -1 && c.updateNodeAt(d, u, p, g, t) || c.updateNextNode(d, u, p, t, h, r) || c.addNode(d, u, p, t, r), r += d.nodeSize;
    }), c.syncToMarks([], o, t), this.node.isTextblock && c.addTextblockHacks(), c.destroyRest(), (c.changed || this.dirty == ea) && (s && this.protectLocalComposition(t, s), KR(this.contentDOM, this.children, t), Ul && Zpe(this.dom));
  }
  localCompositionInfo(t, n) {
    let { from: o, to: r } = t.state.selection;
    if (!(t.state.selection instanceof xt) || o < n || r > n + this.node.content.size)
      return null;
    let i = t.input.compositionNode;
    if (!i || !this.dom.contains(i.parentNode))
      return null;
    if (this.node.inlineContent) {
      let s = i.nodeValue, a = Wpe(this.node.content, s, o - n, r - n);
      return a < 0 ? null : { node: i, pos: a, text: s };
    } else
      return { node: i, pos: -1, text: "" };
  }
  protectLocalComposition(t, { node: n, pos: o, text: r }) {
    if (this.getDesc(n))
      return;
    let i = n;
    for (; i.parentNode != this.contentDOM; i = i.parentNode) {
      for (; i.previousSibling; )
        i.parentNode.removeChild(i.previousSibling);
      for (; i.nextSibling; )
        i.parentNode.removeChild(i.nextSibling);
      i.pmViewDesc && (i.pmViewDesc = void 0);
    }
    let s = new Ape(this, i, n, r);
    t.input.compositionNodes.push(s), this.children = V5(this.children, o, o + r.length, t, s);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(t, n, o, r) {
    return this.dirty == ci || !t.sameMarkup(this.node) ? !1 : (this.updateInner(t, n, o, r), !0);
  }
  updateInner(t, n, o, r) {
    this.updateOuterDeco(n), this.node = t, this.innerDeco = o, this.contentDOM && this.updateChildren(r, this.posAtStart), this.dirty = xr;
  }
  updateOuterDeco(t) {
    if (yu(t, this.outerDeco))
      return;
    let n = this.nodeDOM.nodeType != 1, o = this.dom;
    this.dom = YR(this.dom, this.nodeDOM, j5(this.outerDeco, this.node, n), j5(t, this.node, n)), this.dom != o && (o.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = t;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.dom.draggable = !0);
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.dom.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function xx(e, t, n, o, r) {
  XR(o, t, e);
  let i = new us(void 0, e, t, n, o, o, o, r, 0);
  return i.contentDOM && i.updateChildren(r, 0), i;
}
class mf extends us {
  constructor(t, n, o, r, i, s, a) {
    super(t, n, o, r, i, null, s, a, 0);
  }
  parseRule() {
    let t = this.nodeDOM.parentNode;
    for (; t && t != this.dom && !t.pmIsDeco; )
      t = t.parentNode;
    return { skip: t || !0 };
  }
  update(t, n, o, r) {
    return this.dirty == ci || this.dirty != xr && !this.inParent() || !t.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(n), (this.dirty != xr || t.text != this.node.text) && t.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = t.text, r.trackWrites == this.nodeDOM && (r.trackWrites = null)), this.node = t, this.dirty = xr, !0);
  }
  inParent() {
    let t = this.parent.contentDOM;
    for (let n = this.nodeDOM; n; n = n.parentNode)
      if (n == t)
        return !0;
    return !1;
  }
  domFromPos(t) {
    return { node: this.nodeDOM, offset: t };
  }
  localPosFromDOM(t, n, o) {
    return t == this.nodeDOM ? this.posAtStart + Math.min(n, this.node.text.length) : super.localPosFromDOM(t, n, o);
  }
  ignoreMutation(t) {
    return t.type != "characterData" && t.type != "selection";
  }
  slice(t, n, o) {
    let r = this.node.cut(t, n), i = document.createTextNode(r.text);
    return new mf(this.parent, r, this.outerDeco, this.innerDeco, i, i, o);
  }
  markDirty(t, n) {
    super.markDirty(t, n), this.dom != this.nodeDOM && (t == 0 || n == this.nodeDOM.nodeValue.length) && (this.dirty = ci);
  }
  get domAtom() {
    return !1;
  }
  isText(t) {
    return this.node.text == t;
  }
}
class qR extends X0 {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(t) {
    return this.dirty == xr && this.dom.nodeName == t;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class Hpe extends us {
  constructor(t, n, o, r, i, s, a, c, d, u) {
    super(t, n, o, r, i, s, a, d, u), this.spec = c;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(t, n, o, r) {
    if (this.dirty == ci)
      return !1;
    if (this.spec.update && (this.node.type == t.type || this.spec.multiType)) {
      let i = this.spec.update(t, n, o);
      return i && this.updateInner(t, n, o, r), i;
    } else return !this.contentDOM && !t.isLeaf ? !1 : super.update(t, n, o, r);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(t, n, o, r) {
    this.spec.setSelection ? this.spec.setSelection(t, n, o.root) : super.setSelection(t, n, o, r);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(t) {
    return this.spec.stopEvent ? this.spec.stopEvent(t) : !1;
  }
  ignoreMutation(t) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(t) : super.ignoreMutation(t);
  }
}
function KR(e, t, n) {
  let o = e.firstChild, r = !1;
  for (let i = 0; i < t.length; i++) {
    let s = t[i], a = s.dom;
    if (a.parentNode == e) {
      for (; a != o; )
        o = yx(o), r = !0;
      o = o.nextSibling;
    } else
      r = !0, e.insertBefore(a, o);
    if (s instanceof Oa) {
      let c = o ? o.previousSibling : e.lastChild;
      KR(s.contentDOM, s.children, n), o = c ? c.nextSibling : e.firstChild;
    }
  }
  for (; o; )
    o = yx(o), r = !0;
  r && n.trackWrites == e && (n.trackWrites = null);
}
const vc = function(e) {
  e && (this.nodeName = e);
};
vc.prototype = /* @__PURE__ */ Object.create(null);
const ta = [new vc()];
function j5(e, t, n) {
  if (e.length == 0)
    return ta;
  let o = n ? ta[0] : new vc(), r = [o];
  for (let i = 0; i < e.length; i++) {
    let s = e[i].type.attrs;
    if (s) {
      s.nodeName && r.push(o = new vc(s.nodeName));
      for (let a in s) {
        let c = s[a];
        c != null && (n && r.length == 1 && r.push(o = new vc(t.isInline ? "span" : "div")), a == "class" ? o.class = (o.class ? o.class + " " : "") + c : a == "style" ? o.style = (o.style ? o.style + ";" : "") + c : a != "nodeName" && (o[a] = c));
      }
    }
  }
  return r;
}
function YR(e, t, n, o) {
  if (n == ta && o == ta)
    return t;
  let r = t;
  for (let i = 0; i < o.length; i++) {
    let s = o[i], a = n[i];
    if (i) {
      let c;
      a && a.nodeName == s.nodeName && r != e && (c = r.parentNode) && c.nodeName.toLowerCase() == s.nodeName || (c = document.createElement(s.nodeName), c.pmIsDeco = !0, c.appendChild(r), a = ta[0]), r = c;
    }
    Fpe(r, a || ta[0], s);
  }
  return r;
}
function Fpe(e, t, n) {
  for (let o in t)
    o != "class" && o != "style" && o != "nodeName" && !(o in n) && e.removeAttribute(o);
  for (let o in n)
    o != "class" && o != "style" && o != "nodeName" && n[o] != t[o] && e.setAttribute(o, n[o]);
  if (t.class != n.class) {
    let o = t.class ? t.class.split(" ").filter(Boolean) : [], r = n.class ? n.class.split(" ").filter(Boolean) : [];
    for (let i = 0; i < o.length; i++)
      r.indexOf(o[i]) == -1 && e.classList.remove(o[i]);
    for (let i = 0; i < r.length; i++)
      o.indexOf(r[i]) == -1 && e.classList.add(r[i]);
    e.classList.length == 0 && e.removeAttribute("class");
  }
  if (t.style != n.style) {
    if (t.style) {
      let o = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, r;
      for (; r = o.exec(t.style); )
        e.style.removeProperty(r[1]);
    }
    n.style && (e.style.cssText += n.style);
  }
}
function XR(e, t, n) {
  return YR(e, e, ta, j5(t, n, e.nodeType != 1));
}
function yu(e, t) {
  if (e.length != t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (!e[n].type.eq(t[n].type))
      return !1;
  return !0;
}
function yx(e) {
  let t = e.nextSibling;
  return e.parentNode.removeChild(e), t;
}
class Npe {
  constructor(t, n, o) {
    this.lock = n, this.view = o, this.index = 0, this.stack = [], this.changed = !1, this.top = t, this.preMatch = $pe(t.node.content, t);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(t, n) {
    if (t != n) {
      for (let o = t; o < n; o++)
        this.top.children[o].destroy();
      this.top.children.splice(t, n - t), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(t, n, o) {
    let r = 0, i = this.stack.length >> 1, s = Math.min(i, t.length);
    for (; r < s && (r == i - 1 ? this.top : this.stack[r + 1 << 1]).matchesMark(t[r]) && t[r].type.spec.spanning !== !1; )
      r++;
    for (; r < i; )
      this.destroyRest(), this.top.dirty = xr, this.index = this.stack.pop(), this.top = this.stack.pop(), i--;
    for (; i < t.length; ) {
      this.stack.push(this.top, this.index + 1);
      let a = -1;
      for (let c = this.index; c < Math.min(this.index + 3, this.top.children.length); c++) {
        let d = this.top.children[c];
        if (d.matchesMark(t[i]) && !this.isLocked(d.dom)) {
          a = c;
          break;
        }
      }
      if (a > -1)
        a > this.index && (this.changed = !0, this.destroyBetween(this.index, a)), this.top = this.top.children[this.index];
      else {
        let c = Oa.create(this.top, t[i], n, o);
        this.top.children.splice(this.index, 0, c), this.top = c, this.changed = !0;
      }
      this.index = 0, i++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(t, n, o, r) {
    let i = -1, s;
    if (r >= this.preMatch.index && (s = this.preMatch.matches[r - this.preMatch.index]).parent == this.top && s.matchesNode(t, n, o))
      i = this.top.children.indexOf(s, this.index);
    else
      for (let a = this.index, c = Math.min(this.top.children.length, a + 5); a < c; a++) {
        let d = this.top.children[a];
        if (d.matchesNode(t, n, o) && !this.preMatch.matched.has(d)) {
          i = a;
          break;
        }
      }
    return i < 0 ? !1 : (this.destroyBetween(this.index, i), this.index++, !0);
  }
  updateNodeAt(t, n, o, r, i) {
    let s = this.top.children[r];
    return s.dirty == ci && s.dom == s.contentDOM && (s.dirty = ea), s.update(t, n, o, i) ? (this.destroyBetween(this.index, r), this.index++, !0) : !1;
  }
  findIndexWithChild(t) {
    for (; ; ) {
      let n = t.parentNode;
      if (!n)
        return -1;
      if (n == this.top.contentDOM) {
        let o = t.pmViewDesc;
        if (o) {
          for (let r = this.index; r < this.top.children.length; r++)
            if (this.top.children[r] == o)
              return r;
        }
        return -1;
      }
      t = n;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(t, n, o, r, i, s) {
    for (let a = this.index; a < this.top.children.length; a++) {
      let c = this.top.children[a];
      if (c instanceof us) {
        let d = this.preMatch.matched.get(c);
        if (d != null && d != i)
          return !1;
        let u = c.dom, p, h = this.isLocked(u) && !(t.isText && c.node && c.node.isText && c.nodeDOM.nodeValue == t.text && c.dirty != ci && yu(n, c.outerDeco));
        if (!h && c.update(t, n, o, r))
          return this.destroyBetween(this.index, a), c.dom != u && (this.changed = !0), this.index++, !0;
        if (!h && (p = this.recreateWrapper(c, t, n, o, r, s)))
          return this.destroyBetween(this.index, a), this.top.children[this.index] = p, p.contentDOM && (p.dirty = ea, p.updateChildren(r, s + 1), p.dirty = xr), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(t, n, o, r, i, s) {
    if (t.dirty || n.isAtom || !t.children.length || !t.node.content.eq(n.content) || !yu(o, t.outerDeco) || !r.eq(t.innerDeco))
      return null;
    let a = us.create(this.top, n, o, r, i, s);
    if (a.contentDOM) {
      a.children = t.children, t.children = [];
      for (let c of a.children)
        c.parent = a;
    }
    return t.destroy(), a;
  }
  // Insert the node as a newly created node desc.
  addNode(t, n, o, r, i) {
    let s = us.create(this.top, t, n, o, r, i);
    s.contentDOM && s.updateChildren(r, i + 1), this.top.children.splice(this.index++, 0, s), this.changed = !0;
  }
  placeWidget(t, n, o) {
    let r = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (r && r.matchesWidget(t) && (t == r.widget || !r.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let i = new GR(this.top, t, n, o);
      this.top.children.splice(this.index++, 0, i), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let t = this.top.children[this.index - 1], n = this.top;
    for (; t instanceof Oa; )
      n = t, t = n.children[n.children.length - 1];
    (!t || // Empty textblock
    !(t instanceof mf) || /\n$/.test(t.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(t.node.text)) && ((So || po) && t && t.dom.contentEditable == "false" && this.addHackNode("IMG", n), this.addHackNode("BR", this.top));
  }
  addHackNode(t, n) {
    if (n == this.top && this.index < n.children.length && n.children[this.index].matchesHack(t))
      this.index++;
    else {
      let o = document.createElement(t);
      t == "IMG" && (o.className = "ProseMirror-separator", o.alt = ""), t == "BR" && (o.className = "ProseMirror-trailingBreak");
      let r = new qR(this.top, [], o, null);
      n != this.top ? n.children.push(r) : n.children.splice(this.index++, 0, r), this.changed = !0;
    }
  }
  isLocked(t) {
    return this.lock && (t == this.lock || t.nodeType == 1 && t.contains(this.lock.parentNode));
  }
}
function $pe(e, t) {
  let n = t, o = n.children.length, r = e.childCount, i = /* @__PURE__ */ new Map(), s = [];
  e: for (; r > 0; ) {
    let a;
    for (; ; )
      if (o) {
        let d = n.children[o - 1];
        if (d instanceof Oa)
          n = d, o = d.children.length;
        else {
          a = d, o--;
          break;
        }
      } else {
        if (n == t)
          break e;
        o = n.parent.children.indexOf(n), n = n.parent;
      }
    let c = a.node;
    if (c) {
      if (c != e.child(r - 1))
        break;
      --r, i.set(a, r), s.push(a);
    }
  }
  return { index: r, matched: i, matches: s.reverse() };
}
function Bpe(e, t) {
  return e.type.side - t.type.side;
}
function zpe(e, t, n, o) {
  let r = t.locals(e), i = 0;
  if (r.length == 0) {
    for (let d = 0; d < e.childCount; d++) {
      let u = e.child(d);
      o(u, r, t.forChild(i, u), d), i += u.nodeSize;
    }
    return;
  }
  let s = 0, a = [], c = null;
  for (let d = 0; ; ) {
    let u, p;
    for (; s < r.length && r[s].to == i; ) {
      let C = r[s++];
      C.widget && (u ? (p || (p = [u])).push(C) : u = C);
    }
    if (u)
      if (p) {
        p.sort(Bpe);
        for (let C = 0; C < p.length; C++)
          n(p[C], d, !!c);
      } else
        n(u, d, !!c);
    let h, g;
    if (c)
      g = -1, h = c, c = null;
    else if (d < e.childCount)
      g = d, h = e.child(d++);
    else
      break;
    for (let C = 0; C < a.length; C++)
      a[C].to <= i && a.splice(C--, 1);
    for (; s < r.length && r[s].from <= i && r[s].to > i; )
      a.push(r[s++]);
    let m = i + h.nodeSize;
    if (h.isText) {
      let C = m;
      s < r.length && r[s].from < C && (C = r[s].from);
      for (let x = 0; x < a.length; x++)
        a[x].to < C && (C = a[x].to);
      C < m && (c = h.cut(C - i), h = h.cut(0, C - i), m = C, g = -1);
    } else
      for (; s < r.length && r[s].to < m; )
        s++;
    let b = h.isInline && !h.isLeaf ? a.filter((C) => !C.inline) : a.slice();
    o(h, b, t.forChild(i, h), g), i = m;
  }
}
function Zpe(e) {
  if (e.nodeName == "UL" || e.nodeName == "OL") {
    let t = e.style.cssText;
    e.style.cssText = t + "; list-style: square !important", window.getComputedStyle(e).listStyle, e.style.cssText = t;
  }
}
function Wpe(e, t, n, o) {
  for (let r = 0, i = 0; r < e.childCount && i <= o; ) {
    let s = e.child(r++), a = i;
    if (i += s.nodeSize, !s.isText)
      continue;
    let c = s.text;
    for (; r < e.childCount; ) {
      let d = e.child(r++);
      if (i += d.nodeSize, !d.isText)
        break;
      c += d.text;
    }
    if (i >= n) {
      if (i >= o && c.slice(o - t.length - a, o - a) == t)
        return o - t.length;
      let d = a < o ? c.lastIndexOf(t, o - a - 1) : -1;
      if (d >= 0 && d + t.length + a >= n)
        return a + d;
      if (n == o && c.length >= o + t.length - a && c.slice(o - a, o - a + t.length) == t)
        return o;
    }
  }
  return -1;
}
function V5(e, t, n, o, r) {
  let i = [];
  for (let s = 0, a = 0; s < e.length; s++) {
    let c = e[s], d = a, u = a += c.size;
    d >= n || u <= t ? i.push(c) : (d < t && i.push(c.slice(0, t - d, o)), r && (i.push(r), r = void 0), u > n && i.push(c.slice(n - d, c.size, o)));
  }
  return i;
}
function b8(e, t = null) {
  let n = e.domSelectionRange(), o = e.state.doc;
  if (!n.focusNode)
    return null;
  let r = e.docView.nearestDesc(n.focusNode), i = r && r.size == 0, s = e.docView.posFromDOM(n.focusNode, n.focusOffset, 1);
  if (s < 0)
    return null;
  let a = o.resolve(s), c, d;
  if (gf(n)) {
    for (c = s; r && !r.node; )
      r = r.parent;
    let p = r.node;
    if (r && p.isAtom && ut.isSelectable(p) && r.parent && !(p.isInline && bpe(n.focusNode, n.focusOffset, r.dom))) {
      let h = r.posBefore;
      d = new ut(s == h ? a : o.resolve(h));
    }
  } else {
    if (n instanceof e.dom.ownerDocument.defaultView.Selection && n.rangeCount > 1) {
      let p = s, h = s;
      for (let g = 0; g < n.rangeCount; g++) {
        let m = n.getRangeAt(g);
        p = Math.min(p, e.docView.posFromDOM(m.startContainer, m.startOffset, 1)), h = Math.max(h, e.docView.posFromDOM(m.endContainer, m.endOffset, -1));
      }
      if (p < 0)
        return null;
      [c, s] = h == e.state.selection.anchor ? [h, p] : [p, h], a = o.resolve(s);
    } else
      c = e.docView.posFromDOM(n.anchorNode, n.anchorOffset, 1);
    if (c < 0)
      return null;
  }
  let u = o.resolve(c);
  if (!d) {
    let p = t == "pointer" || e.state.selection.head < a.pos && !i ? 1 : -1;
    d = C8(e, u, a, p);
  }
  return d;
}
function JR(e) {
  return e.editable ? e.hasFocus() : eO(e) && document.activeElement && document.activeElement.contains(e.dom);
}
function _i(e, t = !1) {
  let n = e.state.selection;
  if (QR(e, n), !!JR(e)) {
    if (!t && e.input.mouseDown && e.input.mouseDown.allowDefault && po) {
      let o = e.domSelectionRange(), r = e.domObserver.currentSelection;
      if (o.anchorNode && r.anchorNode && Ra(o.anchorNode, o.anchorOffset, r.anchorNode, r.anchorOffset)) {
        e.input.mouseDown.delayedSelectionSync = !0, e.domObserver.setCurSelection();
        return;
      }
    }
    if (e.domObserver.disconnectSelection(), e.cursorWrapper)
      Gpe(e);
    else {
      let { anchor: o, head: r } = n, i, s;
      vx && !(n instanceof xt) && (n.$from.parent.inlineContent || (i = wx(e, n.from)), !n.empty && !n.$from.parent.inlineContent && (s = wx(e, n.to))), e.docView.setSelection(o, r, e, t), vx && (i && Sx(i), s && Sx(s)), n.visible ? e.dom.classList.remove("ProseMirror-hideselection") : (e.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && Upe(e));
    }
    e.domObserver.setCurSelection(), e.domObserver.connectSelection();
  }
}
const vx = So || po && NR < 63;
function wx(e, t) {
  let { node: n, offset: o } = e.docView.domFromPos(t, 0), r = o < n.childNodes.length ? n.childNodes[o] : null, i = o ? n.childNodes[o - 1] : null;
  if (So && r && r.contentEditable == "false")
    return X6(r);
  if ((!r || r.contentEditable == "false") && (!i || i.contentEditable == "false")) {
    if (r)
      return X6(r);
    if (i)
      return X6(i);
  }
}
function X6(e) {
  return e.contentEditable = "true", So && e.draggable && (e.draggable = !1, e.wasDraggable = !0), e;
}
function Sx(e) {
  e.contentEditable = "false", e.wasDraggable && (e.draggable = !0, e.wasDraggable = null);
}
function Upe(e) {
  let t = e.dom.ownerDocument;
  t.removeEventListener("selectionchange", e.input.hideSelectionGuard);
  let n = e.domSelectionRange(), o = n.anchorNode, r = n.anchorOffset;
  t.addEventListener("selectionchange", e.input.hideSelectionGuard = () => {
    (n.anchorNode != o || n.anchorOffset != r) && (t.removeEventListener("selectionchange", e.input.hideSelectionGuard), setTimeout(() => {
      (!JR(e) || e.state.selection.visible) && e.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function Gpe(e) {
  let t = e.domSelection(), n = document.createRange();
  if (!t)
    return;
  let o = e.cursorWrapper.dom, r = o.nodeName == "IMG";
  r ? n.setStart(o.parentNode, Qn(o) + 1) : n.setStart(o, 0), n.collapse(!0), t.removeAllRanges(), t.addRange(n), !r && !e.state.selection.visible && Ao && ds <= 11 && (o.disabled = !0, o.disabled = !1);
}
function QR(e, t) {
  if (t instanceof ut) {
    let n = e.docView.descAt(t.from);
    n != e.lastSelectedViewDesc && (Mx(e), n && n.selectNode(), e.lastSelectedViewDesc = n);
  } else
    Mx(e);
}
function Mx(e) {
  e.lastSelectedViewDesc && (e.lastSelectedViewDesc.parent && e.lastSelectedViewDesc.deselectNode(), e.lastSelectedViewDesc = void 0);
}
function C8(e, t, n, o) {
  return e.someProp("createSelectionBetween", (r) => r(e, t, n)) || xt.between(t, n, o);
}
function Tx(e) {
  return e.editable && !e.hasFocus() ? !1 : eO(e);
}
function eO(e) {
  let t = e.domSelectionRange();
  if (!t.anchorNode)
    return !1;
  try {
    return e.dom.contains(t.anchorNode.nodeType == 3 ? t.anchorNode.parentNode : t.anchorNode) && (e.editable || e.dom.contains(t.focusNode.nodeType == 3 ? t.focusNode.parentNode : t.focusNode));
  } catch {
    return !1;
  }
}
function qpe(e) {
  let t = e.docView.domFromPos(e.state.selection.anchor, 0), n = e.domSelectionRange();
  return Ra(t.node, t.offset, n.anchorNode, n.anchorOffset);
}
function D5(e, t) {
  let { $anchor: n, $head: o } = e.selection, r = t > 0 ? n.max(o) : n.min(o), i = r.parent.inlineContent ? r.depth ? e.doc.resolve(t > 0 ? r.after() : r.before()) : null : r;
  return i && Mt.findFrom(i, t);
}
function Zi(e, t) {
  return e.dispatch(e.state.tr.setSelection(t).scrollIntoView()), !0;
}
function kx(e, t, n) {
  let o = e.state.selection;
  if (o instanceof xt)
    if (n.indexOf("s") > -1) {
      let { $head: r } = o, i = r.textOffset ? null : t < 0 ? r.nodeBefore : r.nodeAfter;
      if (!i || i.isText || !i.isLeaf)
        return !1;
      let s = e.state.doc.resolve(r.pos + i.nodeSize * (t < 0 ? -1 : 1));
      return Zi(e, new xt(o.$anchor, s));
    } else if (o.empty) {
      if (e.endOfTextblock(t > 0 ? "forward" : "backward")) {
        let r = D5(e.state, t);
        return r && r instanceof ut ? Zi(e, r) : !1;
      } else if (!(dr && n.indexOf("m") > -1)) {
        let r = o.$head, i = r.textOffset ? null : t < 0 ? r.nodeBefore : r.nodeAfter, s;
        if (!i || i.isText)
          return !1;
        let a = t < 0 ? r.pos - i.nodeSize : r.pos;
        return i.isAtom || (s = e.docView.descAt(a)) && !s.contentDOM ? ut.isSelectable(i) ? Zi(e, new ut(t < 0 ? e.state.doc.resolve(r.pos - i.nodeSize) : r)) : Y0 ? Zi(e, new xt(e.state.doc.resolve(t < 0 ? a : a + i.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (o instanceof ut && o.node.isInline)
      return Zi(e, new xt(t > 0 ? o.$to : o.$from));
    {
      let r = D5(e.state, t);
      return r ? Zi(e, r) : !1;
    }
  }
}
function vu(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function wc(e, t) {
  let n = e.pmViewDesc;
  return n && n.size == 0 && (t < 0 || e.nextSibling || e.nodeName != "BR");
}
function ol(e, t) {
  return t < 0 ? Kpe(e) : Ype(e);
}
function Kpe(e) {
  let t = e.domSelectionRange(), n = t.focusNode, o = t.focusOffset;
  if (!n)
    return;
  let r, i, s = !1;
  for (Vr && n.nodeType == 1 && o < vu(n) && wc(n.childNodes[o], -1) && (s = !0); ; )
    if (o > 0) {
      if (n.nodeType != 1)
        break;
      {
        let a = n.childNodes[o - 1];
        if (wc(a, -1))
          r = n, i = --o;
        else if (a.nodeType == 3)
          n = a, o = n.nodeValue.length;
        else
          break;
      }
    } else {
      if (tO(n))
        break;
      {
        let a = n.previousSibling;
        for (; a && wc(a, -1); )
          r = n.parentNode, i = Qn(a), a = a.previousSibling;
        if (a)
          n = a, o = vu(n);
        else {
          if (n = n.parentNode, n == e.dom)
            break;
          o = 0;
        }
      }
    }
  s ? A5(e, n, o) : r && A5(e, r, i);
}
function Ype(e) {
  let t = e.domSelectionRange(), n = t.focusNode, o = t.focusOffset;
  if (!n)
    return;
  let r = vu(n), i, s;
  for (; ; )
    if (o < r) {
      if (n.nodeType != 1)
        break;
      let a = n.childNodes[o];
      if (wc(a, 1))
        i = n, s = ++o;
      else
        break;
    } else {
      if (tO(n))
        break;
      {
        let a = n.nextSibling;
        for (; a && wc(a, 1); )
          i = a.parentNode, s = Qn(a) + 1, a = a.nextSibling;
        if (a)
          n = a, o = 0, r = vu(n);
        else {
          if (n = n.parentNode, n == e.dom)
            break;
          o = r = 0;
        }
      }
    }
  i && A5(e, i, s);
}
function tO(e) {
  let t = e.pmViewDesc;
  return t && t.node && t.node.isBlock;
}
function Xpe(e, t) {
  for (; e && t == e.childNodes.length && !K0(e); )
    t = Qn(e) + 1, e = e.parentNode;
  for (; e && t < e.childNodes.length; ) {
    let n = e.childNodes[t];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    e = n, t = 0;
  }
}
function Jpe(e, t) {
  for (; e && !t && !K0(e); )
    t = Qn(e), e = e.parentNode;
  for (; e && t; ) {
    let n = e.childNodes[t - 1];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    e = n, t = e.childNodes.length;
  }
}
function A5(e, t, n) {
  if (t.nodeType != 3) {
    let i, s;
    (s = Xpe(t, n)) ? (t = s, n = 0) : (i = Jpe(t, n)) && (t = i, n = i.nodeValue.length);
  }
  let o = e.domSelection();
  if (!o)
    return;
  if (gf(o)) {
    let i = document.createRange();
    i.setEnd(t, n), i.setStart(t, n), o.removeAllRanges(), o.addRange(i);
  } else o.extend && o.extend(t, n);
  e.domObserver.setCurSelection();
  let { state: r } = e;
  setTimeout(() => {
    e.state == r && _i(e);
  }, 50);
}
function Ex(e, t) {
  let n = e.state.doc.resolve(t);
  if (!(po || ype) && n.parent.inlineContent) {
    let r = e.coordsAtPos(t);
    if (t > n.start()) {
      let i = e.coordsAtPos(t - 1), s = (i.top + i.bottom) / 2;
      if (s > r.top && s < r.bottom && Math.abs(i.left - r.left) > 1)
        return i.left < r.left ? "ltr" : "rtl";
    }
    if (t < n.end()) {
      let i = e.coordsAtPos(t + 1), s = (i.top + i.bottom) / 2;
      if (s > r.top && s < r.bottom && Math.abs(i.left - r.left) > 1)
        return i.left > r.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(e.dom).direction == "rtl" ? "rtl" : "ltr";
}
function Rx(e, t, n) {
  let o = e.state.selection;
  if (o instanceof xt && !o.empty || n.indexOf("s") > -1 || dr && n.indexOf("m") > -1)
    return !1;
  let { $from: r, $to: i } = o;
  if (!r.parent.inlineContent || e.endOfTextblock(t < 0 ? "up" : "down")) {
    let s = D5(e.state, t);
    if (s && s instanceof ut)
      return Zi(e, s);
  }
  if (!r.parent.inlineContent) {
    let s = t < 0 ? r : i, a = o instanceof Cr ? Mt.near(s, t) : Mt.findFrom(s, t);
    return a ? Zi(e, a) : !1;
  }
  return !1;
}
function Ox(e, t) {
  if (!(e.state.selection instanceof xt))
    return !0;
  let { $head: n, $anchor: o, empty: r } = e.state.selection;
  if (!n.sameParent(o))
    return !0;
  if (!r)
    return !1;
  if (e.endOfTextblock(t > 0 ? "forward" : "backward"))
    return !0;
  let i = !n.textOffset && (t < 0 ? n.nodeBefore : n.nodeAfter);
  if (i && !i.isText) {
    let s = e.state.tr;
    return t < 0 ? s.delete(n.pos - i.nodeSize, n.pos) : s.delete(n.pos, n.pos + i.nodeSize), e.dispatch(s), !0;
  }
  return !1;
}
function _x(e, t, n) {
  e.domObserver.stop(), t.contentEditable = n, e.domObserver.start();
}
function Qpe(e) {
  if (!So || e.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: t, focusOffset: n } = e.domSelectionRange();
  if (t && t.nodeType == 1 && n == 0 && t.firstChild && t.firstChild.contentEditable == "false") {
    let o = t.firstChild;
    _x(e, o, "true"), setTimeout(() => _x(e, o, "false"), 20);
  }
  return !1;
}
function e5e(e) {
  let t = "";
  return e.ctrlKey && (t += "c"), e.metaKey && (t += "m"), e.altKey && (t += "a"), e.shiftKey && (t += "s"), t;
}
function t5e(e, t) {
  let n = t.keyCode, o = e5e(t);
  if (n == 8 || dr && n == 72 && o == "c")
    return Ox(e, -1) || ol(e, -1);
  if (n == 46 && !t.shiftKey || dr && n == 68 && o == "c")
    return Ox(e, 1) || ol(e, 1);
  if (n == 13 || n == 27)
    return !0;
  if (n == 37 || dr && n == 66 && o == "c") {
    let r = n == 37 ? Ex(e, e.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return kx(e, r, o) || ol(e, r);
  } else if (n == 39 || dr && n == 70 && o == "c") {
    let r = n == 39 ? Ex(e, e.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return kx(e, r, o) || ol(e, r);
  } else {
    if (n == 38 || dr && n == 80 && o == "c")
      return Rx(e, -1, o) || ol(e, -1);
    if (n == 40 || dr && n == 78 && o == "c")
      return Qpe(e) || Rx(e, 1, o) || ol(e, 1);
    if (o == (dr ? "m" : "c") && (n == 66 || n == 73 || n == 89 || n == 90))
      return !0;
  }
  return !1;
}
function nO(e, t) {
  e.someProp("transformCopied", (g) => {
    t = g(t, e);
  });
  let n = [], { content: o, openStart: r, openEnd: i } = t;
  for (; r > 1 && i > 1 && o.childCount == 1 && o.firstChild.childCount == 1; ) {
    r--, i--;
    let g = o.firstChild;
    n.push(g.type.name, g.attrs != g.type.defaultAttrs ? g.attrs : null), o = g.content;
  }
  let s = e.someProp("clipboardSerializer") || Ba.fromSchema(e.state.schema), a = lO(), c = a.createElement("div");
  c.appendChild(s.serializeFragment(o, { document: a }));
  let d = c.firstChild, u, p = 0;
  for (; d && d.nodeType == 1 && (u = aO[d.nodeName.toLowerCase()]); ) {
    for (let g = u.length - 1; g >= 0; g--) {
      let m = a.createElement(u[g]);
      for (; c.firstChild; )
        m.appendChild(c.firstChild);
      c.appendChild(m), p++;
    }
    d = c.firstChild;
  }
  d && d.nodeType == 1 && d.setAttribute("data-pm-slice", `${r} ${i}${p ? ` -${p}` : ""} ${JSON.stringify(n)}`);
  let h = e.someProp("clipboardTextSerializer", (g) => g(t, e)) || t.content.textBetween(0, t.content.size, `

`);
  return { dom: c, text: h, slice: t };
}
function oO(e, t, n, o, r) {
  let i = r.parent.type.spec.code, s, a;
  if (!n && !t)
    return null;
  let c = t && (o || i || !n);
  if (c) {
    if (e.someProp("transformPastedText", (h) => {
      t = h(t, i || o, e);
    }), i)
      return t ? new et(je.from(e.state.schema.text(t.replace(/\r\n?/g, `
`))), 0, 0) : et.empty;
    let p = e.someProp("clipboardTextParser", (h) => h(t, r, o, e));
    if (p)
      a = p;
    else {
      let h = r.marks(), { schema: g } = e.state, m = Ba.fromSchema(g);
      s = document.createElement("div"), t.split(/(?:\r\n?|\n)+/).forEach((b) => {
        let C = s.appendChild(document.createElement("p"));
        b && C.appendChild(m.serializeNode(g.text(b, h)));
      });
    }
  } else
    e.someProp("transformPastedHTML", (p) => {
      n = p(n, e);
    }), s = i5e(n), Y0 && s5e(s);
  let d = s && s.querySelector("[data-pm-slice]"), u = d && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(d.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let p = +u[3]; p > 0; p--) {
      let h = s.firstChild;
      for (; h && h.nodeType != 1; )
        h = h.nextSibling;
      if (!h)
        break;
      s = h;
    }
  if (a || (a = (e.someProp("clipboardParser") || e.someProp("domParser") || cs.fromSchema(e.state.schema)).parseSlice(s, {
    preserveWhitespace: !!(c || u),
    context: r,
    ruleFromNode(h) {
      return h.nodeName == "BR" && !h.nextSibling && h.parentNode && !n5e.test(h.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    a = a5e(Px(a, +u[1], +u[2]), u[4]);
  else if (a = et.maxOpen(o5e(a.content, r), !0), a.openStart || a.openEnd) {
    let p = 0, h = 0;
    for (let g = a.content.firstChild; p < a.openStart && !g.type.spec.isolating; p++, g = g.firstChild)
      ;
    for (let g = a.content.lastChild; h < a.openEnd && !g.type.spec.isolating; h++, g = g.lastChild)
      ;
    a = Px(a, p, h);
  }
  return e.someProp("transformPasted", (p) => {
    a = p(a, e);
  }), a;
}
const n5e = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function o5e(e, t) {
  if (e.childCount < 2)
    return e;
  for (let n = t.depth; n >= 0; n--) {
    let r = t.node(n).contentMatchAt(t.index(n)), i, s = [];
    if (e.forEach((a) => {
      if (!s)
        return;
      let c = r.findWrapping(a.type), d;
      if (!c)
        return s = null;
      if (d = s.length && i.length && iO(c, i, a, s[s.length - 1], 0))
        s[s.length - 1] = d;
      else {
        s.length && (s[s.length - 1] = sO(s[s.length - 1], i.length));
        let u = rO(a, c);
        s.push(u), r = r.matchType(u.type), i = c;
      }
    }), s)
      return je.from(s);
  }
  return e;
}
function rO(e, t, n = 0) {
  for (let o = t.length - 1; o >= n; o--)
    e = t[o].create(null, je.from(e));
  return e;
}
function iO(e, t, n, o, r) {
  if (r < e.length && r < t.length && e[r] == t[r]) {
    let i = iO(e, t, n, o.lastChild, r + 1);
    if (i)
      return o.copy(o.content.replaceChild(o.childCount - 1, i));
    if (o.contentMatchAt(o.childCount).matchType(r == e.length - 1 ? n.type : e[r + 1]))
      return o.copy(o.content.append(je.from(rO(n, e, r + 1))));
  }
}
function sO(e, t) {
  if (t == 0)
    return e;
  let n = e.content.replaceChild(e.childCount - 1, sO(e.lastChild, t - 1)), o = e.contentMatchAt(e.childCount).fillBefore(je.empty, !0);
  return e.copy(n.append(o));
}
function H5(e, t, n, o, r, i) {
  let s = t < 0 ? e.firstChild : e.lastChild, a = s.content;
  return e.childCount > 1 && (i = 0), r < o - 1 && (a = H5(a, t, n, o, r + 1, i)), r >= n && (a = t < 0 ? s.contentMatchAt(0).fillBefore(a, i <= r).append(a) : a.append(s.contentMatchAt(s.childCount).fillBefore(je.empty, !0))), e.replaceChild(t < 0 ? 0 : e.childCount - 1, s.copy(a));
}
function Px(e, t, n) {
  return t < e.openStart && (e = new et(H5(e.content, -1, t, e.openStart, 0, e.openEnd), t, e.openEnd)), n < e.openEnd && (e = new et(H5(e.content, 1, n, e.openEnd, 0, 0), e.openStart, n)), e;
}
const aO = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let Lx = null;
function lO() {
  return Lx || (Lx = document.implementation.createHTMLDocument("title"));
}
let J6 = null;
function r5e(e) {
  let t = window.trustedTypes;
  return t ? (J6 || (J6 = t.createPolicy("ProseMirrorClipboard", { createHTML: (n) => n })), J6.createHTML(e)) : e;
}
function i5e(e) {
  let t = /^(\s*<meta [^>]*>)*/.exec(e);
  t && (e = e.slice(t[0].length));
  let n = lO().createElement("div"), o = /<([a-z][^>\s]+)/i.exec(e), r;
  if ((r = o && aO[o[1].toLowerCase()]) && (e = r.map((i) => "<" + i + ">").join("") + e + r.map((i) => "</" + i + ">").reverse().join("")), n.innerHTML = r5e(e), r)
    for (let i = 0; i < r.length; i++)
      n = n.querySelector(r[i]) || n;
  return n;
}
function s5e(e) {
  let t = e.querySelectorAll(po ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let n = 0; n < t.length; n++) {
    let o = t[n];
    o.childNodes.length == 1 && o.textContent == " " && o.parentNode && o.parentNode.replaceChild(e.ownerDocument.createTextNode(" "), o);
  }
}
function a5e(e, t) {
  if (!e.size)
    return e;
  let n = e.content.firstChild.type.schema, o;
  try {
    o = JSON.parse(t);
  } catch {
    return e;
  }
  let { content: r, openStart: i, openEnd: s } = e;
  for (let a = o.length - 2; a >= 0; a -= 2) {
    let c = n.nodes[o[a]];
    if (!c || c.hasRequiredAttrs())
      break;
    r = je.from(c.create(o[a + 1], r)), i++, s++;
  }
  return new et(r, i, s);
}
const Mo = {}, To = {}, l5e = { touchstart: !0, touchmove: !0 };
class c5e {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "" }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function d5e(e) {
  for (let t in Mo) {
    let n = Mo[t];
    e.dom.addEventListener(t, e.input.eventHandlers[t] = (o) => {
      f5e(e, o) && !x8(e, o) && (e.editable || !(o.type in To)) && n(e, o);
    }, l5e[t] ? { passive: !0 } : void 0);
  }
  So && e.dom.addEventListener("input", () => null), F5(e);
}
function ss(e, t) {
  e.input.lastSelectionOrigin = t, e.input.lastSelectionTime = Date.now();
}
function u5e(e) {
  e.domObserver.stop();
  for (let t in e.input.eventHandlers)
    e.dom.removeEventListener(t, e.input.eventHandlers[t]);
  clearTimeout(e.input.composingTimeout), clearTimeout(e.input.lastIOSEnterFallbackTimeout);
}
function F5(e) {
  e.someProp("handleDOMEvents", (t) => {
    for (let n in t)
      e.input.eventHandlers[n] || e.dom.addEventListener(n, e.input.eventHandlers[n] = (o) => x8(e, o));
  });
}
function x8(e, t) {
  return e.someProp("handleDOMEvents", (n) => {
    let o = n[t.type];
    return o ? o(e, t) || t.defaultPrevented : !1;
  });
}
function f5e(e, t) {
  if (!t.bubbles)
    return !0;
  if (t.defaultPrevented)
    return !1;
  for (let n = t.target; n != e.dom; n = n.parentNode)
    if (!n || n.nodeType == 11 || n.pmViewDesc && n.pmViewDesc.stopEvent(t))
      return !1;
  return !0;
}
function p5e(e, t) {
  !x8(e, t) && Mo[t.type] && (e.editable || !(t.type in To)) && Mo[t.type](e, t);
}
To.keydown = (e, t) => {
  let n = t;
  if (e.input.shiftKey = n.keyCode == 16 || n.shiftKey, !dO(e, n) && (e.input.lastKeyCode = n.keyCode, e.input.lastKeyCodeTime = Date.now(), !(Oi && po && n.keyCode == 13)))
    if (n.keyCode != 229 && e.domObserver.forceFlush(), Ul && n.keyCode == 13 && !n.ctrlKey && !n.altKey && !n.metaKey) {
      let o = Date.now();
      e.input.lastIOSEnter = o, e.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        e.input.lastIOSEnter == o && (e.someProp("handleKeyDown", (r) => r(e, Ks(13, "Enter"))), e.input.lastIOSEnter = 0);
      }, 200);
    } else e.someProp("handleKeyDown", (o) => o(e, n)) || t5e(e, n) ? n.preventDefault() : ss(e, "key");
};
To.keyup = (e, t) => {
  t.keyCode == 16 && (e.input.shiftKey = !1);
};
To.keypress = (e, t) => {
  let n = t;
  if (dO(e, n) || !n.charCode || n.ctrlKey && !n.altKey || dr && n.metaKey)
    return;
  if (e.someProp("handleKeyPress", (r) => r(e, n))) {
    n.preventDefault();
    return;
  }
  let o = e.state.selection;
  if (!(o instanceof xt) || !o.$from.sameParent(o.$to)) {
    let r = String.fromCharCode(n.charCode);
    !/[\r\n]/.test(r) && !e.someProp("handleTextInput", (i) => i(e, o.$from.pos, o.$to.pos, r)) && e.dispatch(e.state.tr.insertText(r).scrollIntoView()), n.preventDefault();
  }
};
function bf(e) {
  return { left: e.clientX, top: e.clientY };
}
function h5e(e, t) {
  let n = t.x - e.clientX, o = t.y - e.clientY;
  return n * n + o * o < 100;
}
function y8(e, t, n, o, r) {
  if (o == -1)
    return !1;
  let i = e.state.doc.resolve(o);
  for (let s = i.depth + 1; s > 0; s--)
    if (e.someProp(t, (a) => s > i.depth ? a(e, n, i.nodeAfter, i.before(s), r, !0) : a(e, n, i.node(s), i.before(s), r, !1)))
      return !0;
  return !1;
}
function Ol(e, t, n) {
  if (e.focused || e.focus(), e.state.selection.eq(t))
    return;
  let o = e.state.tr.setSelection(t);
  o.setMeta("pointer", !0), e.dispatch(o);
}
function g5e(e, t) {
  if (t == -1)
    return !1;
  let n = e.state.doc.resolve(t), o = n.nodeAfter;
  return o && o.isAtom && ut.isSelectable(o) ? (Ol(e, new ut(n)), !0) : !1;
}
function m5e(e, t) {
  if (t == -1)
    return !1;
  let n = e.state.selection, o, r;
  n instanceof ut && (o = n.node);
  let i = e.state.doc.resolve(t);
  for (let s = i.depth + 1; s > 0; s--) {
    let a = s > i.depth ? i.nodeAfter : i.node(s);
    if (ut.isSelectable(a)) {
      o && n.$from.depth > 0 && s >= n.$from.depth && i.before(n.$from.depth + 1) == n.$from.pos ? r = i.before(n.$from.depth) : r = i.before(s);
      break;
    }
  }
  return r != null ? (Ol(e, ut.create(e.state.doc, r)), !0) : !1;
}
function b5e(e, t, n, o, r) {
  return y8(e, "handleClickOn", t, n, o) || e.someProp("handleClick", (i) => i(e, t, o)) || (r ? m5e(e, n) : g5e(e, n));
}
function C5e(e, t, n, o) {
  return y8(e, "handleDoubleClickOn", t, n, o) || e.someProp("handleDoubleClick", (r) => r(e, t, o));
}
function x5e(e, t, n, o) {
  return y8(e, "handleTripleClickOn", t, n, o) || e.someProp("handleTripleClick", (r) => r(e, t, o)) || y5e(e, n, o);
}
function y5e(e, t, n) {
  if (n.button != 0)
    return !1;
  let o = e.state.doc;
  if (t == -1)
    return o.inlineContent ? (Ol(e, xt.create(o, 0, o.content.size)), !0) : !1;
  let r = o.resolve(t);
  for (let i = r.depth + 1; i > 0; i--) {
    let s = i > r.depth ? r.nodeAfter : r.node(i), a = r.before(i);
    if (s.inlineContent)
      Ol(e, xt.create(o, a + 1, a + 1 + s.content.size));
    else if (ut.isSelectable(s))
      Ol(e, ut.create(o, a));
    else
      continue;
    return !0;
  }
}
function v8(e) {
  return wu(e);
}
const cO = dr ? "metaKey" : "ctrlKey";
Mo.mousedown = (e, t) => {
  let n = t;
  e.input.shiftKey = n.shiftKey;
  let o = v8(e), r = Date.now(), i = "singleClick";
  r - e.input.lastClick.time < 500 && h5e(n, e.input.lastClick) && !n[cO] && (e.input.lastClick.type == "singleClick" ? i = "doubleClick" : e.input.lastClick.type == "doubleClick" && (i = "tripleClick")), e.input.lastClick = { time: r, x: n.clientX, y: n.clientY, type: i };
  let s = e.posAtCoords(bf(n));
  s && (i == "singleClick" ? (e.input.mouseDown && e.input.mouseDown.done(), e.input.mouseDown = new v5e(e, s, n, !!o)) : (i == "doubleClick" ? C5e : x5e)(e, s.pos, s.inside, n) ? n.preventDefault() : ss(e, "pointer"));
};
class v5e {
  constructor(t, n, o, r) {
    this.view = t, this.pos = n, this.event = o, this.flushed = r, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = t.state.doc, this.selectNode = !!o[cO], this.allowDefault = o.shiftKey;
    let i, s;
    if (n.inside > -1)
      i = t.state.doc.nodeAt(n.inside), s = n.inside;
    else {
      let u = t.state.doc.resolve(n.pos);
      i = u.parent, s = u.depth ? u.before() : 0;
    }
    const a = r ? null : o.target, c = a ? t.docView.nearestDesc(a, !0) : null;
    this.target = c && c.dom.nodeType == 1 ? c.dom : null;
    let { selection: d } = t.state;
    (o.button == 0 && i.type.spec.draggable && i.type.spec.selectable !== !1 || d instanceof ut && d.from <= s && d.to > s) && (this.mightDrag = {
      node: i,
      pos: s,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && Vr && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), t.root.addEventListener("mouseup", this.up = this.up.bind(this)), t.root.addEventListener("mousemove", this.move = this.move.bind(this)), ss(t, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => _i(this.view)), this.view.input.mouseDown = null;
  }
  up(t) {
    if (this.done(), !this.view.dom.contains(t.target))
      return;
    let n = this.pos;
    this.view.state.doc != this.startDoc && (n = this.view.posAtCoords(bf(t))), this.updateAllowDefault(t), this.allowDefault || !n ? ss(this.view, "pointer") : b5e(this.view, n.pos, n.inside, t, this.selectNode) ? t.preventDefault() : t.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    So && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    po && !this.view.state.selection.visible && Math.min(Math.abs(n.pos - this.view.state.selection.from), Math.abs(n.pos - this.view.state.selection.to)) <= 2) ? (Ol(this.view, Mt.near(this.view.state.doc.resolve(n.pos))), t.preventDefault()) : ss(this.view, "pointer");
  }
  move(t) {
    this.updateAllowDefault(t), ss(this.view, "pointer"), t.buttons == 0 && this.done();
  }
  updateAllowDefault(t) {
    !this.allowDefault && (Math.abs(this.event.x - t.clientX) > 4 || Math.abs(this.event.y - t.clientY) > 4) && (this.allowDefault = !0);
  }
}
Mo.touchstart = (e) => {
  e.input.lastTouch = Date.now(), v8(e), ss(e, "pointer");
};
Mo.touchmove = (e) => {
  e.input.lastTouch = Date.now(), ss(e, "pointer");
};
Mo.contextmenu = (e) => v8(e);
function dO(e, t) {
  return e.composing ? !0 : So && Math.abs(t.timeStamp - e.input.compositionEndedAt) < 500 ? (e.input.compositionEndedAt = -2e8, !0) : !1;
}
const w5e = Oi ? 5e3 : -1;
To.compositionstart = To.compositionupdate = (e) => {
  if (!e.composing) {
    e.domObserver.flush();
    let { state: t } = e, n = t.selection.$to;
    if (t.selection instanceof xt && (t.storedMarks || !n.textOffset && n.parentOffset && n.nodeBefore.marks.some((o) => o.type.spec.inclusive === !1)))
      e.markCursor = e.state.storedMarks || n.marks(), wu(e, !0), e.markCursor = null;
    else if (wu(e, !t.selection.empty), Vr && t.selection.empty && n.parentOffset && !n.textOffset && n.nodeBefore.marks.length) {
      let o = e.domSelectionRange();
      for (let r = o.focusNode, i = o.focusOffset; r && r.nodeType == 1 && i != 0; ) {
        let s = i < 0 ? r.lastChild : r.childNodes[i - 1];
        if (!s)
          break;
        if (s.nodeType == 3) {
          let a = e.domSelection();
          a && a.collapse(s, s.nodeValue.length);
          break;
        } else
          r = s, i = -1;
      }
    }
    e.input.composing = !0;
  }
  uO(e, w5e);
};
To.compositionend = (e, t) => {
  e.composing && (e.input.composing = !1, e.input.compositionEndedAt = t.timeStamp, e.input.compositionPendingChanges = e.domObserver.pendingRecords().length ? e.input.compositionID : 0, e.input.compositionNode = null, e.input.compositionPendingChanges && Promise.resolve().then(() => e.domObserver.flush()), e.input.compositionID++, uO(e, 20));
};
function uO(e, t) {
  clearTimeout(e.input.composingTimeout), t > -1 && (e.input.composingTimeout = setTimeout(() => wu(e), t));
}
function fO(e) {
  for (e.composing && (e.input.composing = !1, e.input.compositionEndedAt = M5e()); e.input.compositionNodes.length > 0; )
    e.input.compositionNodes.pop().markParentsDirty();
}
function S5e(e) {
  let t = e.domSelectionRange();
  if (!t.focusNode)
    return null;
  let n = gpe(t.focusNode, t.focusOffset), o = mpe(t.focusNode, t.focusOffset);
  if (n && o && n != o) {
    let r = o.pmViewDesc, i = e.domObserver.lastChangedTextNode;
    if (n == i || o == i)
      return i;
    if (!r || !r.isText(o.nodeValue))
      return o;
    if (e.input.compositionNode == o) {
      let s = n.pmViewDesc;
      if (!(!s || !s.isText(n.nodeValue)))
        return o;
    }
  }
  return n || o;
}
function M5e() {
  let e = document.createEvent("Event");
  return e.initEvent("event", !0, !0), e.timeStamp;
}
function wu(e, t = !1) {
  if (!(Oi && e.domObserver.flushingSoon >= 0)) {
    if (e.domObserver.forceFlush(), fO(e), t || e.docView && e.docView.dirty) {
      let n = b8(e);
      return n && !n.eq(e.state.selection) ? e.dispatch(e.state.tr.setSelection(n)) : (e.markCursor || t) && !e.state.selection.empty ? e.dispatch(e.state.tr.deleteSelection()) : e.updateState(e.state), !0;
    }
    return !1;
  }
}
function T5e(e, t) {
  if (!e.dom.parentNode)
    return;
  let n = e.dom.parentNode.appendChild(document.createElement("div"));
  n.appendChild(t), n.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let o = getSelection(), r = document.createRange();
  r.selectNodeContents(t), e.dom.blur(), o.removeAllRanges(), o.addRange(r), setTimeout(() => {
    n.parentNode && n.parentNode.removeChild(n), e.focus();
  }, 50);
}
const s0 = Ao && ds < 15 || Ul && vpe < 604;
Mo.copy = To.cut = (e, t) => {
  let n = t, o = e.state.selection, r = n.type == "cut";
  if (o.empty)
    return;
  let i = s0 ? null : n.clipboardData, s = o.content(), { dom: a, text: c } = nO(e, s);
  i ? (n.preventDefault(), i.clearData(), i.setData("text/html", a.innerHTML), i.setData("text/plain", c)) : T5e(e, a), r && e.dispatch(e.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function k5e(e) {
  return e.openStart == 0 && e.openEnd == 0 && e.content.childCount == 1 ? e.content.firstChild : null;
}
function E5e(e, t) {
  if (!e.dom.parentNode)
    return;
  let n = e.input.shiftKey || e.state.selection.$from.parent.type.spec.code, o = e.dom.parentNode.appendChild(document.createElement(n ? "textarea" : "div"));
  n || (o.contentEditable = "true"), o.style.cssText = "position: fixed; left: -10000px; top: 10px", o.focus();
  let r = e.input.shiftKey && e.input.lastKeyCode != 45;
  setTimeout(() => {
    e.focus(), o.parentNode && o.parentNode.removeChild(o), n ? a0(e, o.value, null, r, t) : a0(e, o.textContent, o.innerHTML, r, t);
  }, 50);
}
function a0(e, t, n, o, r) {
  let i = oO(e, t, n, o, e.state.selection.$from);
  if (e.someProp("handlePaste", (c) => c(e, r, i || et.empty)))
    return !0;
  if (!i)
    return !1;
  let s = k5e(i), a = s ? e.state.tr.replaceSelectionWith(s, o) : e.state.tr.replaceSelection(i);
  return e.dispatch(a.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function pO(e) {
  let t = e.getData("text/plain") || e.getData("Text");
  if (t)
    return t;
  let n = e.getData("text/uri-list");
  return n ? n.replace(/\r?\n/g, " ") : "";
}
To.paste = (e, t) => {
  let n = t;
  if (e.composing && !Oi)
    return;
  let o = s0 ? null : n.clipboardData, r = e.input.shiftKey && e.input.lastKeyCode != 45;
  o && a0(e, pO(o), o.getData("text/html"), r, n) ? n.preventDefault() : E5e(e, n);
};
class hO {
  constructor(t, n, o) {
    this.slice = t, this.move = n, this.node = o;
  }
}
const gO = dr ? "altKey" : "ctrlKey";
Mo.dragstart = (e, t) => {
  let n = t, o = e.input.mouseDown;
  if (o && o.done(), !n.dataTransfer)
    return;
  let r = e.state.selection, i = r.empty ? null : e.posAtCoords(bf(n)), s;
  if (!(i && i.pos >= r.from && i.pos <= (r instanceof ut ? r.to - 1 : r.to))) {
    if (o && o.mightDrag)
      s = ut.create(e.state.doc, o.mightDrag.pos);
    else if (n.target && n.target.nodeType == 1) {
      let p = e.docView.nearestDesc(n.target, !0);
      p && p.node.type.spec.draggable && p != e.docView && (s = ut.create(e.state.doc, p.posBefore));
    }
  }
  let a = (s || e.state.selection).content(), { dom: c, text: d, slice: u } = nO(e, a);
  (!n.dataTransfer.files.length || !po || NR > 120) && n.dataTransfer.clearData(), n.dataTransfer.setData(s0 ? "Text" : "text/html", c.innerHTML), n.dataTransfer.effectAllowed = "copyMove", s0 || n.dataTransfer.setData("text/plain", d), e.dragging = new hO(u, !n[gO], s);
};
Mo.dragend = (e) => {
  let t = e.dragging;
  window.setTimeout(() => {
    e.dragging == t && (e.dragging = null);
  }, 50);
};
To.dragover = To.dragenter = (e, t) => t.preventDefault();
To.drop = (e, t) => {
  let n = t, o = e.dragging;
  if (e.dragging = null, !n.dataTransfer)
    return;
  let r = e.posAtCoords(bf(n));
  if (!r)
    return;
  let i = e.state.doc.resolve(r.pos), s = o && o.slice;
  s ? e.someProp("transformPasted", (m) => {
    s = m(s, e);
  }) : s = oO(e, pO(n.dataTransfer), s0 ? null : n.dataTransfer.getData("text/html"), !1, i);
  let a = !!(o && !n[gO]);
  if (e.someProp("handleDrop", (m) => m(e, n, s || et.empty, a))) {
    n.preventDefault();
    return;
  }
  if (!s)
    return;
  n.preventDefault();
  let c = s ? PR(e.state.doc, i.pos, s) : i.pos;
  c == null && (c = i.pos);
  let d = e.state.tr;
  if (a) {
    let { node: m } = o;
    m ? m.replace(d) : d.deleteSelection();
  }
  let u = d.mapping.map(c), p = s.openStart == 0 && s.openEnd == 0 && s.content.childCount == 1, h = d.doc;
  if (p ? d.replaceRangeWith(u, u, s.content.firstChild) : d.replaceRange(u, u, s), d.doc.eq(h))
    return;
  let g = d.doc.resolve(u);
  if (p && ut.isSelectable(s.content.firstChild) && g.nodeAfter && g.nodeAfter.sameMarkup(s.content.firstChild))
    d.setSelection(new ut(g));
  else {
    let m = d.mapping.map(c);
    d.mapping.maps[d.mapping.maps.length - 1].forEach((b, C, x, v) => m = v), d.setSelection(C8(e, g, d.doc.resolve(m)));
  }
  e.focus(), e.dispatch(d.setMeta("uiEvent", "drop"));
};
Mo.focus = (e) => {
  e.input.lastFocus = Date.now(), e.focused || (e.domObserver.stop(), e.dom.classList.add("ProseMirror-focused"), e.domObserver.start(), e.focused = !0, setTimeout(() => {
    e.docView && e.hasFocus() && !e.domObserver.currentSelection.eq(e.domSelectionRange()) && _i(e);
  }, 20));
};
Mo.blur = (e, t) => {
  let n = t;
  e.focused && (e.domObserver.stop(), e.dom.classList.remove("ProseMirror-focused"), e.domObserver.start(), n.relatedTarget && e.dom.contains(n.relatedTarget) && e.domObserver.currentSelection.clear(), e.focused = !1);
};
Mo.beforeinput = (e, t) => {
  if (po && Oi && t.inputType == "deleteContentBackward") {
    e.domObserver.flushSoon();
    let { domChangeCount: o } = e.input;
    setTimeout(() => {
      if (e.input.domChangeCount != o || (e.dom.blur(), e.focus(), e.someProp("handleKeyDown", (i) => i(e, Ks(8, "Backspace")))))
        return;
      let { $cursor: r } = e.state.selection;
      r && r.pos > 0 && e.dispatch(e.state.tr.delete(r.pos - 1, r.pos).scrollIntoView());
    }, 50);
  }
};
for (let e in To)
  Mo[e] = To[e];
function l0(e, t) {
  if (e == t)
    return !0;
  for (let n in e)
    if (e[n] !== t[n])
      return !1;
  for (let n in t)
    if (!(n in e))
      return !1;
  return !0;
}
class Su {
  constructor(t, n) {
    this.toDOM = t, this.spec = n || pa, this.side = this.spec.side || 0;
  }
  map(t, n, o, r) {
    let { pos: i, deleted: s } = t.mapResult(n.from + r, this.side < 0 ? -1 : 1);
    return s ? null : new Yo(i - o, i - o, this);
  }
  valid() {
    return !0;
  }
  eq(t) {
    return this == t || t instanceof Su && (this.spec.key && this.spec.key == t.spec.key || this.toDOM == t.toDOM && l0(this.spec, t.spec));
  }
  destroy(t) {
    this.spec.destroy && this.spec.destroy(t);
  }
}
class fs {
  constructor(t, n) {
    this.attrs = t, this.spec = n || pa;
  }
  map(t, n, o, r) {
    let i = t.map(n.from + r, this.spec.inclusiveStart ? -1 : 1) - o, s = t.map(n.to + r, this.spec.inclusiveEnd ? 1 : -1) - o;
    return i >= s ? null : new Yo(i, s, this);
  }
  valid(t, n) {
    return n.from < n.to;
  }
  eq(t) {
    return this == t || t instanceof fs && l0(this.attrs, t.attrs) && l0(this.spec, t.spec);
  }
  static is(t) {
    return t.type instanceof fs;
  }
  destroy() {
  }
}
class w8 {
  constructor(t, n) {
    this.attrs = t, this.spec = n || pa;
  }
  map(t, n, o, r) {
    let i = t.mapResult(n.from + r, 1);
    if (i.deleted)
      return null;
    let s = t.mapResult(n.to + r, -1);
    return s.deleted || s.pos <= i.pos ? null : new Yo(i.pos - o, s.pos - o, this);
  }
  valid(t, n) {
    let { index: o, offset: r } = t.content.findIndex(n.from), i;
    return r == n.from && !(i = t.child(o)).isText && r + i.nodeSize == n.to;
  }
  eq(t) {
    return this == t || t instanceof w8 && l0(this.attrs, t.attrs) && l0(this.spec, t.spec);
  }
  destroy() {
  }
}
class Yo {
  /**
  @internal
  */
  constructor(t, n, o) {
    this.from = t, this.to = n, this.type = o;
  }
  /**
  @internal
  */
  copy(t, n) {
    return new Yo(t, n, this.type);
  }
  /**
  @internal
  */
  eq(t, n = 0) {
    return this.type.eq(t.type) && this.from + n == t.from && this.to + n == t.to;
  }
  /**
  @internal
  */
  map(t, n, o) {
    return this.type.map(t, this, n, o);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(t, n, o) {
    return new Yo(t, t, new Su(n, o));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(t, n, o, r) {
    return new Yo(t, n, new fs(o, r));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(t, n, o, r) {
    return new Yo(t, n, new w8(o, r));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof fs;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof Su;
  }
}
const ll = [], pa = {};
class jn {
  /**
  @internal
  */
  constructor(t, n) {
    this.local = t.length ? t : ll, this.children = n.length ? n : ll;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(t, n) {
    return n.length ? Mu(n, t, 0, pa) : ao;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(t, n, o) {
    let r = [];
    return this.findInner(t ?? 0, n ?? 1e9, r, 0, o), r;
  }
  findInner(t, n, o, r, i) {
    for (let s = 0; s < this.local.length; s++) {
      let a = this.local[s];
      a.from <= n && a.to >= t && (!i || i(a.spec)) && o.push(a.copy(a.from + r, a.to + r));
    }
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] < n && this.children[s + 1] > t) {
        let a = this.children[s] + 1;
        this.children[s + 2].findInner(t - a, n - a, o, r + a, i);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(t, n, o) {
    return this == ao || t.maps.length == 0 ? this : this.mapInner(t, n, 0, 0, o || pa);
  }
  /**
  @internal
  */
  mapInner(t, n, o, r, i) {
    let s;
    for (let a = 0; a < this.local.length; a++) {
      let c = this.local[a].map(t, o, r);
      c && c.type.valid(n, c) ? (s || (s = [])).push(c) : i.onRemove && i.onRemove(this.local[a].spec);
    }
    return this.children.length ? R5e(this.children, s || [], t, n, o, r, i) : s ? new jn(s.sort(ha), ll) : ao;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(t, n) {
    return n.length ? this == ao ? jn.create(t, n) : this.addInner(t, n, 0) : this;
  }
  addInner(t, n, o) {
    let r, i = 0;
    t.forEach((a, c) => {
      let d = c + o, u;
      if (u = bO(n, a, d)) {
        for (r || (r = this.children.slice()); i < r.length && r[i] < c; )
          i += 3;
        r[i] == c ? r[i + 2] = r[i + 2].addInner(a, u, d + 1) : r.splice(i, 0, c, c + a.nodeSize, Mu(u, a, d + 1, pa)), i += 3;
      }
    });
    let s = mO(i ? CO(n) : n, -o);
    for (let a = 0; a < s.length; a++)
      s[a].type.valid(t, s[a]) || s.splice(a--, 1);
    return new jn(s.length ? this.local.concat(s).sort(ha) : this.local, r || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(t) {
    return t.length == 0 || this == ao ? this : this.removeInner(t, 0);
  }
  removeInner(t, n) {
    let o = this.children, r = this.local;
    for (let i = 0; i < o.length; i += 3) {
      let s, a = o[i] + n, c = o[i + 1] + n;
      for (let u = 0, p; u < t.length; u++)
        (p = t[u]) && p.from > a && p.to < c && (t[u] = null, (s || (s = [])).push(p));
      if (!s)
        continue;
      o == this.children && (o = this.children.slice());
      let d = o[i + 2].removeInner(s, a + 1);
      d != ao ? o[i + 2] = d : (o.splice(i, 3), i -= 3);
    }
    if (r.length) {
      for (let i = 0, s; i < t.length; i++)
        if (s = t[i])
          for (let a = 0; a < r.length; a++)
            r[a].eq(s, n) && (r == this.local && (r = this.local.slice()), r.splice(a--, 1));
    }
    return o == this.children && r == this.local ? this : r.length || o.length ? new jn(r, o) : ao;
  }
  forChild(t, n) {
    if (this == ao)
      return this;
    if (n.isLeaf)
      return jn.empty;
    let o, r;
    for (let a = 0; a < this.children.length; a += 3)
      if (this.children[a] >= t) {
        this.children[a] == t && (o = this.children[a + 2]);
        break;
      }
    let i = t + 1, s = i + n.content.size;
    for (let a = 0; a < this.local.length; a++) {
      let c = this.local[a];
      if (c.from < s && c.to > i && c.type instanceof fs) {
        let d = Math.max(i, c.from) - i, u = Math.min(s, c.to) - i;
        d < u && (r || (r = [])).push(c.copy(d, u));
      }
    }
    if (r) {
      let a = new jn(r.sort(ha), ll);
      return o ? new Ki([a, o]) : a;
    }
    return o || ao;
  }
  /**
  @internal
  */
  eq(t) {
    if (this == t)
      return !0;
    if (!(t instanceof jn) || this.local.length != t.local.length || this.children.length != t.children.length)
      return !1;
    for (let n = 0; n < this.local.length; n++)
      if (!this.local[n].eq(t.local[n]))
        return !1;
    for (let n = 0; n < this.children.length; n += 3)
      if (this.children[n] != t.children[n] || this.children[n + 1] != t.children[n + 1] || !this.children[n + 2].eq(t.children[n + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(t) {
    return S8(this.localsInner(t));
  }
  /**
  @internal
  */
  localsInner(t) {
    if (this == ao)
      return ll;
    if (t.inlineContent || !this.local.some(fs.is))
      return this.local;
    let n = [];
    for (let o = 0; o < this.local.length; o++)
      this.local[o].type instanceof fs || n.push(this.local[o]);
    return n;
  }
  forEachSet(t) {
    t(this);
  }
}
jn.empty = new jn([], []);
jn.removeOverlap = S8;
const ao = jn.empty;
class Ki {
  constructor(t) {
    this.members = t;
  }
  map(t, n) {
    const o = this.members.map((r) => r.map(t, n, pa));
    return Ki.from(o);
  }
  forChild(t, n) {
    if (n.isLeaf)
      return jn.empty;
    let o = [];
    for (let r = 0; r < this.members.length; r++) {
      let i = this.members[r].forChild(t, n);
      i != ao && (i instanceof Ki ? o = o.concat(i.members) : o.push(i));
    }
    return Ki.from(o);
  }
  eq(t) {
    if (!(t instanceof Ki) || t.members.length != this.members.length)
      return !1;
    for (let n = 0; n < this.members.length; n++)
      if (!this.members[n].eq(t.members[n]))
        return !1;
    return !0;
  }
  locals(t) {
    let n, o = !0;
    for (let r = 0; r < this.members.length; r++) {
      let i = this.members[r].localsInner(t);
      if (i.length)
        if (!n)
          n = i;
        else {
          o && (n = n.slice(), o = !1);
          for (let s = 0; s < i.length; s++)
            n.push(i[s]);
        }
    }
    return n ? S8(o ? n : n.sort(ha)) : ll;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(t) {
    switch (t.length) {
      case 0:
        return ao;
      case 1:
        return t[0];
      default:
        return new Ki(t.every((n) => n instanceof jn) ? t : t.reduce((n, o) => n.concat(o instanceof jn ? o : o.members), []));
    }
  }
  forEachSet(t) {
    for (let n = 0; n < this.members.length; n++)
      this.members[n].forEachSet(t);
  }
}
function R5e(e, t, n, o, r, i, s) {
  let a = e.slice();
  for (let d = 0, u = i; d < n.maps.length; d++) {
    let p = 0;
    n.maps[d].forEach((h, g, m, b) => {
      let C = b - m - (g - h);
      for (let x = 0; x < a.length; x += 3) {
        let v = a[x + 1];
        if (v < 0 || h > v + u - p)
          continue;
        let S = a[x] + u - p;
        g >= S ? a[x + 1] = h <= S ? -2 : -1 : h >= u && C && (a[x] += C, a[x + 1] += C);
      }
      p += C;
    }), u = n.maps[d].map(u, -1);
  }
  let c = !1;
  for (let d = 0; d < a.length; d += 3)
    if (a[d + 1] < 0) {
      if (a[d + 1] == -2) {
        c = !0, a[d + 1] = -1;
        continue;
      }
      let u = n.map(e[d] + i), p = u - r;
      if (p < 0 || p >= o.content.size) {
        c = !0;
        continue;
      }
      let h = n.map(e[d + 1] + i, -1), g = h - r, { index: m, offset: b } = o.content.findIndex(p), C = o.maybeChild(m);
      if (C && b == p && b + C.nodeSize == g) {
        let x = a[d + 2].mapInner(n, C, u + 1, e[d] + i + 1, s);
        x != ao ? (a[d] = p, a[d + 1] = g, a[d + 2] = x) : (a[d + 1] = -2, c = !0);
      } else
        c = !0;
    }
  if (c) {
    let d = O5e(a, e, t, n, r, i, s), u = Mu(d, o, 0, s);
    t = u.local;
    for (let p = 0; p < a.length; p += 3)
      a[p + 1] < 0 && (a.splice(p, 3), p -= 3);
    for (let p = 0, h = 0; p < u.children.length; p += 3) {
      let g = u.children[p];
      for (; h < a.length && a[h] < g; )
        h += 3;
      a.splice(h, 0, u.children[p], u.children[p + 1], u.children[p + 2]);
    }
  }
  return new jn(t.sort(ha), a);
}
function mO(e, t) {
  if (!t || !e.length)
    return e;
  let n = [];
  for (let o = 0; o < e.length; o++) {
    let r = e[o];
    n.push(new Yo(r.from + t, r.to + t, r.type));
  }
  return n;
}
function O5e(e, t, n, o, r, i, s) {
  function a(c, d) {
    for (let u = 0; u < c.local.length; u++) {
      let p = c.local[u].map(o, r, d);
      p ? n.push(p) : s.onRemove && s.onRemove(c.local[u].spec);
    }
    for (let u = 0; u < c.children.length; u += 3)
      a(c.children[u + 2], c.children[u] + d + 1);
  }
  for (let c = 0; c < e.length; c += 3)
    e[c + 1] == -1 && a(e[c + 2], t[c] + i + 1);
  return n;
}
function bO(e, t, n) {
  if (t.isLeaf)
    return null;
  let o = n + t.nodeSize, r = null;
  for (let i = 0, s; i < e.length; i++)
    (s = e[i]) && s.from > n && s.to < o && ((r || (r = [])).push(s), e[i] = null);
  return r;
}
function CO(e) {
  let t = [];
  for (let n = 0; n < e.length; n++)
    e[n] != null && t.push(e[n]);
  return t;
}
function Mu(e, t, n, o) {
  let r = [], i = !1;
  t.forEach((a, c) => {
    let d = bO(e, a, c + n);
    if (d) {
      i = !0;
      let u = Mu(d, a, n + c + 1, o);
      u != ao && r.push(c, c + a.nodeSize, u);
    }
  });
  let s = mO(i ? CO(e) : e, -n).sort(ha);
  for (let a = 0; a < s.length; a++)
    s[a].type.valid(t, s[a]) || (o.onRemove && o.onRemove(s[a].spec), s.splice(a--, 1));
  return s.length || r.length ? new jn(s, r) : ao;
}
function ha(e, t) {
  return e.from - t.from || e.to - t.to;
}
function S8(e) {
  let t = e;
  for (let n = 0; n < t.length - 1; n++) {
    let o = t[n];
    if (o.from != o.to)
      for (let r = n + 1; r < t.length; r++) {
        let i = t[r];
        if (i.from == o.from) {
          i.to != o.to && (t == e && (t = e.slice()), t[r] = i.copy(i.from, o.to), Ix(t, r + 1, i.copy(o.to, i.to)));
          continue;
        } else {
          i.from < o.to && (t == e && (t = e.slice()), t[n] = o.copy(o.from, i.from), Ix(t, r, o.copy(i.from, o.to)));
          break;
        }
      }
  }
  return t;
}
function Ix(e, t, n) {
  for (; t < e.length && ha(n, e[t]) > 0; )
    t++;
  e.splice(t, 0, n);
}
function Q6(e) {
  let t = [];
  return e.someProp("decorations", (n) => {
    let o = n(e.state);
    o && o != ao && t.push(o);
  }), e.cursorWrapper && t.push(jn.create(e.state.doc, [e.cursorWrapper.deco])), Ki.from(t);
}
const _5e = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, P5e = Ao && ds <= 11;
class L5e {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(t) {
    this.anchorNode = t.anchorNode, this.anchorOffset = t.anchorOffset, this.focusNode = t.focusNode, this.focusOffset = t.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(t) {
    return t.anchorNode == this.anchorNode && t.anchorOffset == this.anchorOffset && t.focusNode == this.focusNode && t.focusOffset == this.focusOffset;
  }
}
class I5e {
  constructor(t, n) {
    this.view = t, this.handleDOMChange = n, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new L5e(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((o) => {
      for (let r = 0; r < o.length; r++)
        this.queue.push(o[r]);
      Ao && ds <= 11 && o.some((r) => r.type == "childList" && r.removedNodes.length || r.type == "characterData" && r.oldValue.length > r.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), P5e && (this.onCharData = (o) => {
      this.queue.push({ target: o.target, type: "characterData", oldValue: o.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, _5e)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let t = this.observer.takeRecords();
      if (t.length) {
        for (let n = 0; n < t.length; n++)
          this.queue.push(t[n]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (Tx(this.view)) {
      if (this.suppressingSelectionUpdates)
        return _i(this.view);
      if (Ao && ds <= 11 && !this.view.state.selection.empty) {
        let t = this.view.domSelectionRange();
        if (t.focusNode && Ra(t.focusNode, t.focusOffset, t.anchorNode, t.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(t) {
    if (!t.focusNode)
      return !0;
    let n = /* @__PURE__ */ new Set(), o;
    for (let i = t.focusNode; i; i = i0(i))
      n.add(i);
    for (let i = t.anchorNode; i; i = i0(i))
      if (n.has(i)) {
        o = i;
        break;
      }
    let r = o && this.view.docView.nearestDesc(o);
    if (r && r.ignoreMutation({
      type: "selection",
      target: o.nodeType == 3 ? o.parentNode : o
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let t of this.observer.takeRecords())
        this.queue.push(t);
    return this.queue;
  }
  flush() {
    let { view: t } = this;
    if (!t.docView || this.flushingSoon > -1)
      return;
    let n = this.pendingRecords();
    n.length && (this.queue = []);
    let o = t.domSelectionRange(), r = !this.suppressingSelectionUpdates && !this.currentSelection.eq(o) && Tx(t) && !this.ignoreSelectionChange(o), i = -1, s = -1, a = !1, c = [];
    if (t.editable)
      for (let u = 0; u < n.length; u++) {
        let p = this.registerMutation(n[u], c);
        p && (i = i < 0 ? p.from : Math.min(p.from, i), s = s < 0 ? p.to : Math.max(p.to, s), p.typeOver && (a = !0));
      }
    if (Vr && c.length) {
      let u = c.filter((p) => p.nodeName == "BR");
      if (u.length == 2) {
        let [p, h] = u;
        p.parentNode && p.parentNode.parentNode == h.parentNode ? h.remove() : p.remove();
      } else {
        let { focusNode: p } = this.currentSelection;
        for (let h of u) {
          let g = h.parentNode;
          g && g.nodeName == "LI" && (!p || D5e(t, p) != g) && h.remove();
        }
      }
    }
    let d = null;
    i < 0 && r && t.input.lastFocus > Date.now() - 200 && Math.max(t.input.lastTouch, t.input.lastClick.time) < Date.now() - 300 && gf(o) && (d = b8(t)) && d.eq(Mt.near(t.state.doc.resolve(0), 1)) ? (t.input.lastFocus = 0, _i(t), this.currentSelection.set(o), t.scrollToSelection()) : (i > -1 || r) && (i > -1 && (t.docView.markDirty(i, s), j5e(t)), this.handleDOMChange(i, s, a, c), t.docView && t.docView.dirty ? t.updateState(t.state) : this.currentSelection.eq(o) || _i(t), this.currentSelection.set(o));
  }
  registerMutation(t, n) {
    if (n.indexOf(t.target) > -1)
      return null;
    let o = this.view.docView.nearestDesc(t.target);
    if (t.type == "attributes" && (o == this.view.docView || t.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    t.attributeName == "style" && !t.oldValue && !t.target.getAttribute("style")) || !o || o.ignoreMutation(t))
      return null;
    if (t.type == "childList") {
      for (let u = 0; u < t.addedNodes.length; u++) {
        let p = t.addedNodes[u];
        n.push(p), p.nodeType == 3 && (this.lastChangedTextNode = p);
      }
      if (o.contentDOM && o.contentDOM != o.dom && !o.contentDOM.contains(t.target))
        return { from: o.posBefore, to: o.posAfter };
      let r = t.previousSibling, i = t.nextSibling;
      if (Ao && ds <= 11 && t.addedNodes.length)
        for (let u = 0; u < t.addedNodes.length; u++) {
          let { previousSibling: p, nextSibling: h } = t.addedNodes[u];
          (!p || Array.prototype.indexOf.call(t.addedNodes, p) < 0) && (r = p), (!h || Array.prototype.indexOf.call(t.addedNodes, h) < 0) && (i = h);
        }
      let s = r && r.parentNode == t.target ? Qn(r) + 1 : 0, a = o.localPosFromDOM(t.target, s, -1), c = i && i.parentNode == t.target ? Qn(i) : t.target.childNodes.length, d = o.localPosFromDOM(t.target, c, 1);
      return { from: a, to: d };
    } else return t.type == "attributes" ? { from: o.posAtStart - o.border, to: o.posAtEnd + o.border } : (this.lastChangedTextNode = t.target, {
      from: o.posAtStart,
      to: o.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: t.target.nodeValue == t.oldValue
    });
  }
}
let jx = /* @__PURE__ */ new WeakMap(), Vx = !1;
function j5e(e) {
  if (!jx.has(e) && (jx.set(e, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(e.dom).whiteSpace) !== -1)) {
    if (e.requiresGeckoHackNode = Vr, Vx)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), Vx = !0;
  }
}
function Dx(e, t) {
  let n = t.startContainer, o = t.startOffset, r = t.endContainer, i = t.endOffset, s = e.domAtPos(e.state.selection.anchor);
  return Ra(s.node, s.offset, r, i) && ([n, o, r, i] = [r, i, n, o]), { anchorNode: n, anchorOffset: o, focusNode: r, focusOffset: i };
}
function V5e(e, t) {
  if (t.getComposedRanges) {
    let r = t.getComposedRanges(e.root)[0];
    if (r)
      return Dx(e, r);
  }
  let n;
  function o(r) {
    r.preventDefault(), r.stopImmediatePropagation(), n = r.getTargetRanges()[0];
  }
  return e.dom.addEventListener("beforeinput", o, !0), document.execCommand("indent"), e.dom.removeEventListener("beforeinput", o, !0), n ? Dx(e, n) : null;
}
function D5e(e, t) {
  for (let n = t.parentNode; n && n != e.dom; n = n.parentNode) {
    let o = e.docView.nearestDesc(n, !0);
    if (o && o.node.isBlock)
      return n;
  }
  return null;
}
function A5e(e, t, n) {
  let { node: o, fromOffset: r, toOffset: i, from: s, to: a } = e.docView.parseRange(t, n), c = e.domSelectionRange(), d, u = c.anchorNode;
  if (u && e.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (d = [{ node: u, offset: c.anchorOffset }], gf(c) || d.push({ node: c.focusNode, offset: c.focusOffset })), po && e.input.lastKeyCode === 8)
    for (let C = i; C > r; C--) {
      let x = o.childNodes[C - 1], v = x.pmViewDesc;
      if (x.nodeName == "BR" && !v) {
        i = C;
        break;
      }
      if (!v || v.size)
        break;
    }
  let p = e.state.doc, h = e.someProp("domParser") || cs.fromSchema(e.state.schema), g = p.resolve(s), m = null, b = h.parse(o, {
    topNode: g.parent,
    topMatch: g.parent.contentMatchAt(g.index()),
    topOpen: !0,
    from: r,
    to: i,
    preserveWhitespace: g.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: d,
    ruleFromNode: H5e,
    context: g
  });
  if (d && d[0].pos != null) {
    let C = d[0].pos, x = d[1] && d[1].pos;
    x == null && (x = C), m = { anchor: C + s, head: x + s };
  }
  return { doc: b, sel: m, from: s, to: a };
}
function H5e(e) {
  let t = e.pmViewDesc;
  if (t)
    return t.parseRule();
  if (e.nodeName == "BR" && e.parentNode) {
    if (So && /^(ul|ol)$/i.test(e.parentNode.nodeName)) {
      let n = document.createElement("div");
      return n.appendChild(document.createElement("li")), { skip: n };
    } else if (e.parentNode.lastChild == e || So && /^(tr|table)$/i.test(e.parentNode.nodeName))
      return { ignore: !0 };
  } else if (e.nodeName == "IMG" && e.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const F5e = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function N5e(e, t, n, o, r) {
  let i = e.input.compositionPendingChanges || (e.composing ? e.input.compositionID : 0);
  if (e.input.compositionPendingChanges = 0, t < 0) {
    let O = e.input.lastSelectionTime > Date.now() - 50 ? e.input.lastSelectionOrigin : null, P = b8(e, O);
    if (P && !e.state.selection.eq(P)) {
      if (po && Oi && e.input.lastKeyCode === 13 && Date.now() - 100 < e.input.lastKeyCodeTime && e.someProp("handleKeyDown", (L) => L(e, Ks(13, "Enter"))))
        return;
      let _ = e.state.tr.setSelection(P);
      O == "pointer" ? _.setMeta("pointer", !0) : O == "key" && _.scrollIntoView(), i && _.setMeta("composition", i), e.dispatch(_);
    }
    return;
  }
  let s = e.state.doc.resolve(t), a = s.sharedDepth(n);
  t = s.before(a + 1), n = e.state.doc.resolve(n).after(a + 1);
  let c = e.state.selection, d = A5e(e, t, n), u = e.state.doc, p = u.slice(d.from, d.to), h, g;
  e.input.lastKeyCode === 8 && Date.now() - 100 < e.input.lastKeyCodeTime ? (h = e.state.selection.to, g = "end") : (h = e.state.selection.from, g = "start"), e.input.lastKeyCode = null;
  let m = z5e(p.content, d.doc.content, d.from, h, g);
  if (m && e.input.domChangeCount++, (Ul && e.input.lastIOSEnter > Date.now() - 225 || Oi) && r.some((O) => O.nodeType == 1 && !F5e.test(O.nodeName)) && (!m || m.endA >= m.endB) && e.someProp("handleKeyDown", (O) => O(e, Ks(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (!m)
    if (o && c instanceof xt && !c.empty && c.$head.sameParent(c.$anchor) && !e.composing && !(d.sel && d.sel.anchor != d.sel.head))
      m = { start: c.from, endA: c.to, endB: c.to };
    else {
      if (d.sel) {
        let O = Ax(e, e.state.doc, d.sel);
        if (O && !O.eq(e.state.selection)) {
          let P = e.state.tr.setSelection(O);
          i && P.setMeta("composition", i), e.dispatch(P);
        }
      }
      return;
    }
  e.state.selection.from < e.state.selection.to && m.start == m.endB && e.state.selection instanceof xt && (m.start > e.state.selection.from && m.start <= e.state.selection.from + 2 && e.state.selection.from >= d.from ? m.start = e.state.selection.from : m.endA < e.state.selection.to && m.endA >= e.state.selection.to - 2 && e.state.selection.to <= d.to && (m.endB += e.state.selection.to - m.endA, m.endA = e.state.selection.to)), Ao && ds <= 11 && m.endB == m.start + 1 && m.endA == m.start && m.start > d.from && d.doc.textBetween(m.start - d.from - 1, m.start - d.from + 1) == "  " && (m.start--, m.endA--, m.endB--);
  let b = d.doc.resolveNoCache(m.start - d.from), C = d.doc.resolveNoCache(m.endB - d.from), x = u.resolve(m.start), v = b.sameParent(C) && b.parent.inlineContent && x.end() >= m.endA, S;
  if ((Ul && e.input.lastIOSEnter > Date.now() - 225 && (!v || r.some((O) => O.nodeName == "DIV" || O.nodeName == "P")) || !v && b.pos < d.doc.content.size && !b.sameParent(C) && (S = Mt.findFrom(d.doc.resolve(b.pos + 1), 1, !0)) && S.head == C.pos) && e.someProp("handleKeyDown", (O) => O(e, Ks(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (e.state.selection.anchor > m.start && B5e(u, m.start, m.endA, b, C) && e.someProp("handleKeyDown", (O) => O(e, Ks(8, "Backspace")))) {
    Oi && po && e.domObserver.suppressSelectionUpdates();
    return;
  }
  po && m.endB == m.start && (e.input.lastChromeDelete = Date.now()), Oi && !v && b.start() != C.start() && C.parentOffset == 0 && b.depth == C.depth && d.sel && d.sel.anchor == d.sel.head && d.sel.head == m.endA && (m.endB -= 2, C = d.doc.resolveNoCache(m.endB - d.from), setTimeout(() => {
    e.someProp("handleKeyDown", function(O) {
      return O(e, Ks(13, "Enter"));
    });
  }, 20));
  let M = m.start, w = m.endA, k, E, R;
  if (v) {
    if (b.pos == C.pos)
      Ao && ds <= 11 && b.parentOffset == 0 && (e.domObserver.suppressSelectionUpdates(), setTimeout(() => _i(e), 20)), k = e.state.tr.delete(M, w), E = u.resolve(m.start).marksAcross(u.resolve(m.endA));
    else if (
      // Adding or removing a mark
      m.endA == m.endB && (R = $5e(b.parent.content.cut(b.parentOffset, C.parentOffset), x.parent.content.cut(x.parentOffset, m.endA - x.start())))
    )
      k = e.state.tr, R.type == "add" ? k.addMark(M, w, R.mark) : k.removeMark(M, w, R.mark);
    else if (b.parent.child(b.index()).isText && b.index() == C.index() - (C.textOffset ? 0 : 1)) {
      let O = b.parent.textBetween(b.parentOffset, C.parentOffset);
      if (e.someProp("handleTextInput", (P) => P(e, M, w, O)))
        return;
      k = e.state.tr.insertText(O, M, w);
    }
  }
  if (k || (k = e.state.tr.replace(M, w, d.doc.slice(m.start - d.from, m.endB - d.from))), d.sel) {
    let O = Ax(e, k.doc, d.sel);
    O && !(po && e.composing && O.empty && (m.start != m.endB || e.input.lastChromeDelete < Date.now() - 100) && (O.head == M || O.head == k.mapping.map(w) - 1) || Ao && O.empty && O.head == M) && k.setSelection(O);
  }
  E && k.ensureMarks(E), i && k.setMeta("composition", i), e.dispatch(k.scrollIntoView());
}
function Ax(e, t, n) {
  return Math.max(n.anchor, n.head) > t.content.size ? null : C8(e, t.resolve(n.anchor), t.resolve(n.head));
}
function $5e(e, t) {
  let n = e.firstChild.marks, o = t.firstChild.marks, r = n, i = o, s, a, c;
  for (let u = 0; u < o.length; u++)
    r = o[u].removeFromSet(r);
  for (let u = 0; u < n.length; u++)
    i = n[u].removeFromSet(i);
  if (r.length == 1 && i.length == 0)
    a = r[0], s = "add", c = (u) => u.mark(a.addToSet(u.marks));
  else if (r.length == 0 && i.length == 1)
    a = i[0], s = "remove", c = (u) => u.mark(a.removeFromSet(u.marks));
  else
    return null;
  let d = [];
  for (let u = 0; u < t.childCount; u++)
    d.push(c(t.child(u)));
  if (je.from(d).eq(e))
    return { mark: a, type: s };
}
function B5e(e, t, n, o, r) {
  if (
    // The content must have shrunk
    n - t <= r.pos - o.pos || // newEnd must point directly at or after the end of the block that newStart points into
    ep(o, !0, !1) < r.pos
  )
    return !1;
  let i = e.resolve(t);
  if (!o.parent.isTextblock) {
    let a = i.nodeAfter;
    return a != null && n == t + a.nodeSize;
  }
  if (i.parentOffset < i.parent.content.size || !i.parent.isTextblock)
    return !1;
  let s = e.resolve(ep(i, !0, !0));
  return !s.parent.isTextblock || s.pos > n || ep(s, !0, !1) < n ? !1 : o.parent.content.cut(o.parentOffset).eq(s.parent.content);
}
function ep(e, t, n) {
  let o = e.depth, r = t ? e.end() : e.pos;
  for (; o > 0 && (t || e.indexAfter(o) == e.node(o).childCount); )
    o--, r++, t = !1;
  if (n) {
    let i = e.node(o).maybeChild(e.indexAfter(o));
    for (; i && !i.isLeaf; )
      i = i.firstChild, r++;
  }
  return r;
}
function z5e(e, t, n, o, r) {
  let i = e.findDiffStart(t, n);
  if (i == null)
    return null;
  let { a: s, b: a } = e.findDiffEnd(t, n + e.size, n + t.size);
  if (r == "end") {
    let c = Math.max(0, i - Math.min(s, a));
    o -= s + c - i;
  }
  if (s < i && e.size < t.size) {
    let c = o <= i && o >= s ? i - o : 0;
    i -= c, i && i < t.size && Hx(t.textBetween(i - 1, i + 1)) && (i += c ? 1 : -1), a = i + (a - s), s = i;
  } else if (a < i) {
    let c = o <= i && o >= a ? i - o : 0;
    i -= c, i && i < e.size && Hx(e.textBetween(i - 1, i + 1)) && (i += c ? 1 : -1), s = i + (s - a), a = i;
  }
  return { start: i, endA: s, endB: a };
}
function Hx(e) {
  if (e.length != 2)
    return !1;
  let t = e.charCodeAt(0), n = e.charCodeAt(1);
  return t >= 56320 && t <= 57343 && n >= 55296 && n <= 56319;
}
class Z5e {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(t, n) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new c5e(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = n, this.state = n.state, this.directPlugins = n.plugins || [], this.directPlugins.forEach(zx), this.dispatch = this.dispatch.bind(this), this.dom = t && t.mount || document.createElement("div"), t && (t.appendChild ? t.appendChild(this.dom) : typeof t == "function" ? t(this.dom) : t.mount && (this.mounted = !0)), this.editable = $x(this), Nx(this), this.nodeViews = Bx(this), this.docView = xx(this.state.doc, Fx(this), Q6(this), this.dom, this), this.domObserver = new I5e(this, (o, r, i, s) => N5e(this, o, r, i, s)), this.domObserver.start(), d5e(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let t = this._props;
      this._props = {};
      for (let n in t)
        this._props[n] = t[n];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(t) {
    t.handleDOMEvents != this._props.handleDOMEvents && F5(this);
    let n = this._props;
    this._props = t, t.plugins && (t.plugins.forEach(zx), this.directPlugins = t.plugins), this.updateStateInner(t.state, n);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(t) {
    let n = {};
    for (let o in this._props)
      n[o] = this._props[o];
    n.state = this.state;
    for (let o in t)
      n[o] = t[o];
    this.update(n);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(t) {
    this.updateStateInner(t, this._props);
  }
  updateStateInner(t, n) {
    var o;
    let r = this.state, i = !1, s = !1;
    t.storedMarks && this.composing && (fO(this), s = !0), this.state = t;
    let a = r.plugins != t.plugins || this._props.plugins != n.plugins;
    if (a || this._props.plugins != n.plugins || this._props.nodeViews != n.nodeViews) {
      let g = Bx(this);
      U5e(g, this.nodeViews) && (this.nodeViews = g, i = !0);
    }
    (a || n.handleDOMEvents != this._props.handleDOMEvents) && F5(this), this.editable = $x(this), Nx(this);
    let c = Q6(this), d = Fx(this), u = r.plugins != t.plugins && !r.doc.eq(t.doc) ? "reset" : t.scrollToSelection > r.scrollToSelection ? "to selection" : "preserve", p = i || !this.docView.matchesNode(t.doc, d, c);
    (p || !t.selection.eq(r.selection)) && (s = !0);
    let h = u == "preserve" && s && this.dom.style.overflowAnchor == null && Mpe(this);
    if (s) {
      this.domObserver.stop();
      let g = p && (Ao || po) && !this.composing && !r.selection.empty && !t.selection.empty && W5e(r.selection, t.selection);
      if (p) {
        let m = po ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = S5e(this)), (i || !this.docView.update(t.doc, d, c, this)) && (this.docView.updateOuterDeco(d), this.docView.destroy(), this.docView = xx(t.doc, d, c, this.dom, this)), m && !this.trackWrites && (g = !0);
      }
      g || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && qpe(this)) ? _i(this, g) : (QR(this, t.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(r), !((o = this.dragging) === null || o === void 0) && o.node && !r.doc.eq(t.doc) && this.updateDraggedNode(this.dragging, r), u == "reset" ? this.dom.scrollTop = 0 : u == "to selection" ? this.scrollToSelection() : h && Tpe(h);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let t = this.domSelectionRange().focusNode;
    if (!this.someProp("handleScrollToSelection", (n) => n(this))) if (this.state.selection instanceof ut) {
      let n = this.docView.domAfterPos(this.state.selection.from);
      n.nodeType == 1 && px(this, n.getBoundingClientRect(), t);
    } else
      px(this, this.coordsAtPos(this.state.selection.head, 1), t);
  }
  destroyPluginViews() {
    let t;
    for (; t = this.pluginViews.pop(); )
      t.destroy && t.destroy();
  }
  updatePluginViews(t) {
    if (!t || t.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let n = 0; n < this.directPlugins.length; n++) {
        let o = this.directPlugins[n];
        o.spec.view && this.pluginViews.push(o.spec.view(this));
      }
      for (let n = 0; n < this.state.plugins.length; n++) {
        let o = this.state.plugins[n];
        o.spec.view && this.pluginViews.push(o.spec.view(this));
      }
    } else
      for (let n = 0; n < this.pluginViews.length; n++) {
        let o = this.pluginViews[n];
        o.update && o.update(this, t);
      }
  }
  updateDraggedNode(t, n) {
    let o = t.node, r = -1;
    if (this.state.doc.nodeAt(o.from) == o.node)
      r = o.from;
    else {
      let i = o.from + (this.state.doc.content.size - n.doc.content.size);
      (i > 0 && this.state.doc.nodeAt(i)) == o.node && (r = i);
    }
    this.dragging = new hO(t.slice, t.move, r < 0 ? void 0 : ut.create(this.state.doc, r));
  }
  someProp(t, n) {
    let o = this._props && this._props[t], r;
    if (o != null && (r = n ? n(o) : o))
      return r;
    for (let s = 0; s < this.directPlugins.length; s++) {
      let a = this.directPlugins[s].props[t];
      if (a != null && (r = n ? n(a) : a))
        return r;
    }
    let i = this.state.plugins;
    if (i)
      for (let s = 0; s < i.length; s++) {
        let a = i[s].props[t];
        if (a != null && (r = n ? n(a) : a))
          return r;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (Ao) {
      let t = this.root.activeElement;
      if (t == this.dom)
        return !0;
      if (!t || !this.dom.contains(t))
        return !1;
      for (; t && this.dom != t && this.dom.contains(t); ) {
        if (t.contentEditable == "false")
          return !1;
        t = t.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && kpe(this.dom), _i(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let t = this._root;
    if (t == null) {
      for (let n = this.dom.parentNode; n; n = n.parentNode)
        if (n.nodeType == 9 || n.nodeType == 11 && n.host)
          return n.getSelection || (Object.getPrototypeOf(n).getSelection = () => n.ownerDocument.getSelection()), this._root = n;
    }
    return t || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(t) {
    return Ppe(this, t);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(t, n = 1) {
    return WR(this, t, n);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(t, n = 0) {
    return this.docView.domFromPos(t, n);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(t) {
    let n = this.docView.descAt(t);
    return n ? n.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(t, n, o = -1) {
    let r = this.docView.posFromDOM(t, n, o);
    if (r == null)
      throw new RangeError("DOM position not inside the editor");
    return r;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(t, n) {
    return Dpe(this, n || this.state, t);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(t, n) {
    return a0(this, "", t, !1, n || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(t, n) {
    return a0(this, t, null, !0, n || new ClipboardEvent("paste"));
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (u5e(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], Q6(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, ppe());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(t) {
    return p5e(this, t);
  }
  /**
  Dispatch a transaction. Will call
  [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
  when given, and otherwise defaults to applying the transaction to
  the current state and calling
  [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
  This method is bound to the view instance, so that it can be
  easily passed around.
  */
  dispatch(t) {
    let n = this._props.dispatchTransaction;
    n ? n.call(this, t) : this.updateState(this.state.apply(t));
  }
  /**
  @internal
  */
  domSelectionRange() {
    let t = this.domSelection();
    return t ? So && this.root.nodeType === 11 && Cpe(this.dom.ownerDocument) == this.dom && V5e(this, t) || t : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
function Fx(e) {
  let t = /* @__PURE__ */ Object.create(null);
  return t.class = "ProseMirror", t.contenteditable = String(e.editable), e.someProp("attributes", (n) => {
    if (typeof n == "function" && (n = n(e.state)), n)
      for (let o in n)
        o == "class" ? t.class += " " + n[o] : o == "style" ? t.style = (t.style ? t.style + ";" : "") + n[o] : !t[o] && o != "contenteditable" && o != "nodeName" && (t[o] = String(n[o]));
  }), t.translate || (t.translate = "no"), [Yo.node(0, e.state.doc.content.size, t)];
}
function Nx(e) {
  if (e.markCursor) {
    let t = document.createElement("img");
    t.className = "ProseMirror-separator", t.setAttribute("mark-placeholder", "true"), t.setAttribute("alt", ""), e.cursorWrapper = { dom: t, deco: Yo.widget(e.state.selection.from, t, { raw: !0, marks: e.markCursor }) };
  } else
    e.cursorWrapper = null;
}
function $x(e) {
  return !e.someProp("editable", (t) => t(e.state) === !1);
}
function W5e(e, t) {
  let n = Math.min(e.$anchor.sharedDepth(e.head), t.$anchor.sharedDepth(t.head));
  return e.$anchor.start(n) != t.$anchor.start(n);
}
function Bx(e) {
  let t = /* @__PURE__ */ Object.create(null);
  function n(o) {
    for (let r in o)
      Object.prototype.hasOwnProperty.call(t, r) || (t[r] = o[r]);
  }
  return e.someProp("nodeViews", n), e.someProp("markViews", n), t;
}
function U5e(e, t) {
  let n = 0, o = 0;
  for (let r in e) {
    if (e[r] != t[r])
      return !0;
    n++;
  }
  for (let r in t)
    o++;
  return n != o;
}
function zx(e) {
  if (e.spec.state || e.spec.filterTransaction || e.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var ys = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Tu = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, G5e = typeof navigator < "u" && /Mac/.test(navigator.platform), q5e = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var eo = 0; eo < 10; eo++) ys[48 + eo] = ys[96 + eo] = String(eo);
for (var eo = 1; eo <= 24; eo++) ys[eo + 111] = "F" + eo;
for (var eo = 65; eo <= 90; eo++)
  ys[eo] = String.fromCharCode(eo + 32), Tu[eo] = String.fromCharCode(eo);
for (var tp in ys) Tu.hasOwnProperty(tp) || (Tu[tp] = ys[tp]);
function K5e(e) {
  var t = G5e && e.metaKey && e.shiftKey && !e.ctrlKey && !e.altKey || q5e && e.shiftKey && e.key && e.key.length == 1 || e.key == "Unidentified", n = !t && e.key || (e.shiftKey ? Tu : ys)[e.keyCode] || e.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
const Y5e = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : !1;
function X5e(e) {
  let t = e.split(/-(?!$)/), n = t[t.length - 1];
  n == "Space" && (n = " ");
  let o, r, i, s;
  for (let a = 0; a < t.length - 1; a++) {
    let c = t[a];
    if (/^(cmd|meta|m)$/i.test(c))
      s = !0;
    else if (/^a(lt)?$/i.test(c))
      o = !0;
    else if (/^(c|ctrl|control)$/i.test(c))
      r = !0;
    else if (/^s(hift)?$/i.test(c))
      i = !0;
    else if (/^mod$/i.test(c))
      Y5e ? s = !0 : r = !0;
    else
      throw new Error("Unrecognized modifier name: " + c);
  }
  return o && (n = "Alt-" + n), r && (n = "Ctrl-" + n), s && (n = "Meta-" + n), i && (n = "Shift-" + n), n;
}
function J5e(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let n in e)
    t[X5e(n)] = e[n];
  return t;
}
function np(e, t, n = !0) {
  return t.altKey && (e = "Alt-" + e), t.ctrlKey && (e = "Ctrl-" + e), t.metaKey && (e = "Meta-" + e), n && t.shiftKey && (e = "Shift-" + e), e;
}
function Q5e(e) {
  return new Kn({ props: { handleKeyDown: xO(e) } });
}
function xO(e) {
  let t = J5e(e);
  return function(n, o) {
    let r = K5e(o), i, s = t[np(r, o)];
    if (s && s(n.state, n.dispatch, n))
      return !0;
    if (r.length == 1 && r != " ") {
      if (o.shiftKey) {
        let a = t[np(r, o, !1)];
        if (a && a(n.state, n.dispatch, n))
          return !0;
      }
      if ((o.shiftKey || o.altKey || o.metaKey || r.charCodeAt(0) > 127) && (i = ys[o.keyCode]) && i != r) {
        let a = t[np(i, o)];
        if (a && a(n.state, n.dispatch, n))
          return !0;
      }
    }
    return !1;
  };
}
const e4e = (e, t) => e.selection.empty ? !1 : (t && t(e.tr.deleteSelection().scrollIntoView()), !0);
function yO(e, t) {
  let { $cursor: n } = e.selection;
  return !n || (t ? !t.endOfTextblock("backward", e) : n.parentOffset > 0) ? null : n;
}
const t4e = (e, t, n) => {
  let o = yO(e, n);
  if (!o)
    return !1;
  let r = M8(o);
  if (!r) {
    let s = o.blockRange(), a = s && x2(s);
    return a == null ? !1 : (t && t(e.tr.lift(s, a).scrollIntoView()), !0);
  }
  let i = r.nodeBefore;
  if (MO(e, r, t, -1))
    return !0;
  if (o.parent.content.size == 0 && (Gl(i, "end") || ut.isSelectable(i)))
    for (let s = o.depth; ; s--) {
      let a = pf(e.doc, o.before(s), o.after(s), et.empty);
      if (a && a.slice.size < a.to - a.from) {
        if (t) {
          let c = e.tr.step(a);
          c.setSelection(Gl(i, "end") ? Mt.findFrom(c.doc.resolve(c.mapping.map(r.pos, -1)), -1) : ut.create(c.doc, r.pos - i.nodeSize)), t(c.scrollIntoView());
        }
        return !0;
      }
      if (s == 1 || o.node(s - 1).childCount > 1)
        break;
    }
  return i.isAtom && r.depth == o.depth - 1 ? (t && t(e.tr.delete(r.pos - i.nodeSize, r.pos).scrollIntoView()), !0) : !1;
}, n4e = (e, t, n) => {
  let o = yO(e, n);
  if (!o)
    return !1;
  let r = M8(o);
  return r ? vO(e, r, t) : !1;
}, o4e = (e, t, n) => {
  let o = wO(e, n);
  if (!o)
    return !1;
  let r = T8(o);
  return r ? vO(e, r, t) : !1;
};
function vO(e, t, n) {
  let o = t.nodeBefore, r = o, i = t.pos - 1;
  for (; !r.isTextblock; i--) {
    if (r.type.spec.isolating)
      return !1;
    let u = r.lastChild;
    if (!u)
      return !1;
    r = u;
  }
  let s = t.nodeAfter, a = s, c = t.pos + 1;
  for (; !a.isTextblock; c++) {
    if (a.type.spec.isolating)
      return !1;
    let u = a.firstChild;
    if (!u)
      return !1;
    a = u;
  }
  let d = pf(e.doc, i, c, et.empty);
  if (!d || d.from != i || d instanceof Zn && d.slice.size >= c - i)
    return !1;
  if (n) {
    let u = e.tr.step(d);
    u.setSelection(xt.create(u.doc, i)), n(u.scrollIntoView());
  }
  return !0;
}
function Gl(e, t, n = !1) {
  for (let o = e; o; o = t == "start" ? o.firstChild : o.lastChild) {
    if (o.isTextblock)
      return !0;
    if (n && o.childCount != 1)
      return !1;
  }
  return !1;
}
const r4e = (e, t, n) => {
  let { $head: o, empty: r } = e.selection, i = o;
  if (!r)
    return !1;
  if (o.parent.isTextblock) {
    if (n ? !n.endOfTextblock("backward", e) : o.parentOffset > 0)
      return !1;
    i = M8(o);
  }
  let s = i && i.nodeBefore;
  return !s || !ut.isSelectable(s) ? !1 : (t && t(e.tr.setSelection(ut.create(e.doc, i.pos - s.nodeSize)).scrollIntoView()), !0);
};
function M8(e) {
  if (!e.parent.type.spec.isolating)
    for (let t = e.depth - 1; t >= 0; t--) {
      if (e.index(t) > 0)
        return e.doc.resolve(e.before(t + 1));
      if (e.node(t).type.spec.isolating)
        break;
    }
  return null;
}
function wO(e, t) {
  let { $cursor: n } = e.selection;
  return !n || (t ? !t.endOfTextblock("forward", e) : n.parentOffset < n.parent.content.size) ? null : n;
}
const i4e = (e, t, n) => {
  let o = wO(e, n);
  if (!o)
    return !1;
  let r = T8(o);
  if (!r)
    return !1;
  let i = r.nodeAfter;
  if (MO(e, r, t, 1))
    return !0;
  if (o.parent.content.size == 0 && (Gl(i, "start") || ut.isSelectable(i))) {
    let s = pf(e.doc, o.before(), o.after(), et.empty);
    if (s && s.slice.size < s.to - s.from) {
      if (t) {
        let a = e.tr.step(s);
        a.setSelection(Gl(i, "start") ? Mt.findFrom(a.doc.resolve(a.mapping.map(r.pos)), 1) : ut.create(a.doc, a.mapping.map(r.pos))), t(a.scrollIntoView());
      }
      return !0;
    }
  }
  return i.isAtom && r.depth == o.depth - 1 ? (t && t(e.tr.delete(r.pos, r.pos + i.nodeSize).scrollIntoView()), !0) : !1;
}, s4e = (e, t, n) => {
  let { $head: o, empty: r } = e.selection, i = o;
  if (!r)
    return !1;
  if (o.parent.isTextblock) {
    if (n ? !n.endOfTextblock("forward", e) : o.parentOffset < o.parent.content.size)
      return !1;
    i = T8(o);
  }
  let s = i && i.nodeAfter;
  return !s || !ut.isSelectable(s) ? !1 : (t && t(e.tr.setSelection(ut.create(e.doc, i.pos)).scrollIntoView()), !0);
};
function T8(e) {
  if (!e.parent.type.spec.isolating)
    for (let t = e.depth - 1; t >= 0; t--) {
      let n = e.node(t);
      if (e.index(t) + 1 < n.childCount)
        return e.doc.resolve(e.after(t + 1));
      if (n.type.spec.isolating)
        break;
    }
  return null;
}
const a4e = (e, t) => {
  let n = e.selection, o = n instanceof ut, r;
  if (o) {
    if (n.node.isTextblock || !Ps(e.doc, n.from))
      return !1;
    r = n.from;
  } else if (r = ff(e.doc, n.from, -1), r == null)
    return !1;
  if (t) {
    let i = e.tr.join(r);
    o && i.setSelection(ut.create(i.doc, r - e.doc.resolve(r).nodeBefore.nodeSize)), t(i.scrollIntoView());
  }
  return !0;
}, l4e = (e, t) => {
  let n = e.selection, o;
  if (n instanceof ut) {
    if (n.node.isTextblock || !Ps(e.doc, n.to))
      return !1;
    o = n.to;
  } else if (o = ff(e.doc, n.to, 1), o == null)
    return !1;
  return t && t(e.tr.join(o).scrollIntoView()), !0;
}, c4e = (e, t) => {
  let { $from: n, $to: o } = e.selection, r = n.blockRange(o), i = r && x2(r);
  return i == null ? !1 : (t && t(e.tr.lift(r, i).scrollIntoView()), !0);
}, d4e = (e, t) => {
  let { $head: n, $anchor: o } = e.selection;
  return !n.parent.type.spec.code || !n.sameParent(o) ? !1 : (t && t(e.tr.insertText(`
`).scrollIntoView()), !0);
};
function SO(e) {
  for (let t = 0; t < e.edgeCount; t++) {
    let { type: n } = e.edge(t);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
const u4e = (e, t) => {
  let { $head: n, $anchor: o } = e.selection;
  if (!n.parent.type.spec.code || !n.sameParent(o))
    return !1;
  let r = n.node(-1), i = n.indexAfter(-1), s = SO(r.contentMatchAt(i));
  if (!s || !r.canReplaceWith(i, i, s))
    return !1;
  if (t) {
    let a = n.after(), c = e.tr.replaceWith(a, a, s.createAndFill());
    c.setSelection(Mt.near(c.doc.resolve(a), 1)), t(c.scrollIntoView());
  }
  return !0;
}, f4e = (e, t) => {
  let n = e.selection, { $from: o, $to: r } = n;
  if (n instanceof Cr || o.parent.inlineContent || r.parent.inlineContent)
    return !1;
  let i = SO(r.parent.contentMatchAt(r.indexAfter()));
  if (!i || !i.isTextblock)
    return !1;
  if (t) {
    let s = (!o.parentOffset && r.index() < r.parent.childCount ? o : r).pos, a = e.tr.insert(s, i.createAndFill());
    a.setSelection(xt.create(a.doc, s + 1)), t(a.scrollIntoView());
  }
  return !0;
}, p4e = (e, t) => {
  let { $cursor: n } = e.selection;
  if (!n || n.parent.content.size)
    return !1;
  if (n.depth > 1 && n.after() != n.end(-1)) {
    let i = n.before();
    if (El(e.doc, i))
      return t && t(e.tr.split(i).scrollIntoView()), !0;
  }
  let o = n.blockRange(), r = o && x2(o);
  return r == null ? !1 : (t && t(e.tr.lift(o, r).scrollIntoView()), !0);
}, h4e = (e, t) => {
  let { $from: n, to: o } = e.selection, r, i = n.sharedDepth(o);
  return i == 0 ? !1 : (r = n.before(i), t && t(e.tr.setSelection(ut.create(e.doc, r))), !0);
};
function g4e(e, t, n) {
  let o = t.nodeBefore, r = t.nodeAfter, i = t.index();
  return !o || !r || !o.type.compatibleContent(r.type) ? !1 : !o.content.size && t.parent.canReplace(i - 1, i) ? (n && n(e.tr.delete(t.pos - o.nodeSize, t.pos).scrollIntoView()), !0) : !t.parent.canReplace(i, i + 1) || !(r.isTextblock || Ps(e.doc, t.pos)) ? !1 : (n && n(e.tr.join(t.pos).scrollIntoView()), !0);
}
function MO(e, t, n, o) {
  let r = t.nodeBefore, i = t.nodeAfter, s, a, c = r.type.spec.isolating || i.type.spec.isolating;
  if (!c && g4e(e, t, n))
    return !0;
  let d = !c && t.parent.canReplace(t.index(), t.index() + 1);
  if (d && (s = (a = r.contentMatchAt(r.childCount)).findWrapping(i.type)) && a.matchType(s[0] || i.type).validEnd) {
    if (n) {
      let g = t.pos + i.nodeSize, m = je.empty;
      for (let x = s.length - 1; x >= 0; x--)
        m = je.from(s[x].create(null, m));
      m = je.from(r.copy(m));
      let b = e.tr.step(new Un(t.pos - 1, g, t.pos, g, new et(m, 1, 0), s.length, !0)), C = b.doc.resolve(g + 2 * s.length);
      C.nodeAfter && C.nodeAfter.type == r.type && Ps(b.doc, C.pos) && b.join(C.pos), n(b.scrollIntoView());
    }
    return !0;
  }
  let u = i.type.spec.isolating || o > 0 && c ? null : Mt.findFrom(t, 1), p = u && u.$from.blockRange(u.$to), h = p && x2(p);
  if (h != null && h >= t.depth)
    return n && n(e.tr.lift(p, h).scrollIntoView()), !0;
  if (d && Gl(i, "start", !0) && Gl(r, "end")) {
    let g = r, m = [];
    for (; m.push(g), !g.isTextblock; )
      g = g.lastChild;
    let b = i, C = 1;
    for (; !b.isTextblock; b = b.firstChild)
      C++;
    if (g.canReplace(g.childCount, g.childCount, b.content)) {
      if (n) {
        let x = je.empty;
        for (let S = m.length - 1; S >= 0; S--)
          x = je.from(m[S].copy(x));
        let v = e.tr.step(new Un(t.pos - m.length, t.pos + i.nodeSize, t.pos + C, t.pos + i.nodeSize - C, new et(x, m.length, 0), 0, !0));
        n(v.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function TO(e) {
  return function(t, n) {
    let o = t.selection, r = e < 0 ? o.$from : o.$to, i = r.depth;
    for (; r.node(i).isInline; ) {
      if (!i)
        return !1;
      i--;
    }
    return r.node(i).isTextblock ? (n && n(t.tr.setSelection(xt.create(t.doc, e < 0 ? r.start(i) : r.end(i)))), !0) : !1;
  };
}
const m4e = TO(-1), b4e = TO(1);
function C4e(e, t = null) {
  return function(n, o) {
    let { $from: r, $to: i } = n.selection, s = r.blockRange(i), a = s && h8(s, e, t);
    return a ? (o && o(n.tr.wrap(s, a).scrollIntoView()), !0) : !1;
  };
}
function Zx(e, t = null) {
  return function(n, o) {
    let r = !1;
    for (let i = 0; i < n.selection.ranges.length && !r; i++) {
      let { $from: { pos: s }, $to: { pos: a } } = n.selection.ranges[i];
      n.doc.nodesBetween(s, a, (c, d) => {
        if (r)
          return !1;
        if (!(!c.isTextblock || c.hasMarkup(e, t)))
          if (c.type == e)
            r = !0;
          else {
            let u = n.doc.resolve(d), p = u.index();
            r = u.parent.canReplaceWith(p, p + 1, e);
          }
      });
    }
    if (!r)
      return !1;
    if (o) {
      let i = n.tr;
      for (let s = 0; s < n.selection.ranges.length; s++) {
        let { $from: { pos: a }, $to: { pos: c } } = n.selection.ranges[s];
        i.setBlockType(a, c, e, t);
      }
      o(i.scrollIntoView());
    }
    return !0;
  };
}
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function x4e(e, t = null) {
  return function(n, o) {
    let { $from: r, $to: i } = n.selection, s = r.blockRange(i);
    if (!s)
      return !1;
    let a = o ? n.tr : null;
    return y4e(a, s, e, t) ? (o && o(a.scrollIntoView()), !0) : !1;
  };
}
function y4e(e, t, n, o = null) {
  let r = !1, i = t, s = t.$from.doc;
  if (t.depth >= 2 && t.$from.node(t.depth - 1).type.compatibleContent(n) && t.startIndex == 0) {
    if (t.$from.index(t.depth - 1) == 0)
      return !1;
    let c = s.resolve(t.start - 2);
    i = new Cu(c, c, t.depth), t.endIndex < t.parent.childCount && (t = new Cu(t.$from, s.resolve(t.$to.end(t.depth)), t.depth)), r = !0;
  }
  let a = h8(i, n, o, t);
  return a ? (e && v4e(e, t, a, r, n), !0) : !1;
}
function v4e(e, t, n, o, r) {
  let i = je.empty;
  for (let u = n.length - 1; u >= 0; u--)
    i = je.from(n[u].type.create(n[u].attrs, i));
  e.step(new Un(t.start - (o ? 2 : 0), t.end, t.start, t.end, new et(i, 0, 0), n.length, !0));
  let s = 0;
  for (let u = 0; u < n.length; u++)
    n[u].type == r && (s = u + 1);
  let a = n.length - s, c = t.start + n.length - (o ? 2 : 0), d = t.parent;
  for (let u = t.startIndex, p = t.endIndex, h = !0; u < p; u++, h = !1)
    !h && El(e.doc, c, a) && (e.split(c, a), c += 2 * a), c += d.child(u).nodeSize;
  return e;
}
function w4e(e) {
  return function(t, n) {
    let { $from: o, $to: r } = t.selection, i = o.blockRange(r, (s) => s.childCount > 0 && s.firstChild.type == e);
    return i ? n ? o.node(i.depth - 1).type == e ? S4e(t, n, e, i) : M4e(t, n, i) : !0 : !1;
  };
}
function S4e(e, t, n, o) {
  let r = e.tr, i = o.end, s = o.$to.end(o.depth);
  i < s && (r.step(new Un(i - 1, s, i, s, new et(je.from(n.create(null, o.parent.copy())), 1, 0), 1, !0)), o = new Cu(r.doc.resolve(o.$from.pos), r.doc.resolve(s), o.depth));
  const a = x2(o);
  if (a == null)
    return !1;
  r.lift(o, a);
  let c = r.mapping.map(i, -1) - 1;
  return Ps(r.doc, c) && r.join(c), t(r.scrollIntoView()), !0;
}
function M4e(e, t, n) {
  let o = e.tr, r = n.parent;
  for (let g = n.end, m = n.endIndex - 1, b = n.startIndex; m > b; m--)
    g -= r.child(m).nodeSize, o.delete(g - 1, g + 1);
  let i = o.doc.resolve(n.start), s = i.nodeAfter;
  if (o.mapping.map(n.end) != n.start + i.nodeAfter.nodeSize)
    return !1;
  let a = n.startIndex == 0, c = n.endIndex == r.childCount, d = i.node(-1), u = i.index(-1);
  if (!d.canReplace(u + (a ? 0 : 1), u + 1, s.content.append(c ? je.empty : je.from(r))))
    return !1;
  let p = i.pos, h = p + s.nodeSize;
  return o.step(new Un(p - (a ? 1 : 0), h + (c ? 1 : 0), p + 1, h - 1, new et((a ? je.empty : je.from(r.copy(je.empty))).append(c ? je.empty : je.from(r.copy(je.empty))), a ? 0 : 1, c ? 0 : 1), a ? 0 : 1)), t(o.scrollIntoView()), !0;
}
function T4e(e) {
  return function(t, n) {
    let { $from: o, $to: r } = t.selection, i = o.blockRange(r, (d) => d.childCount > 0 && d.firstChild.type == e);
    if (!i)
      return !1;
    let s = i.startIndex;
    if (s == 0)
      return !1;
    let a = i.parent, c = a.child(s - 1);
    if (c.type != e)
      return !1;
    if (n) {
      let d = c.lastChild && c.lastChild.type == a.type, u = je.from(d ? e.create() : null), p = new et(je.from(e.create(null, je.from(a.type.create(null, u)))), d ? 3 : 1, 0), h = i.start, g = i.end;
      n(t.tr.step(new Un(h - (d ? 3 : 1), g, h, g, p, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function Cf(e) {
  const { state: t, transaction: n } = e;
  let { selection: o } = n, { doc: r } = n, { storedMarks: i } = n;
  return {
    ...t,
    apply: t.apply.bind(t),
    applyTransaction: t.applyTransaction.bind(t),
    plugins: t.plugins,
    schema: t.schema,
    reconfigure: t.reconfigure.bind(t),
    toJSON: t.toJSON.bind(t),
    get storedMarks() {
      return i;
    },
    get selection() {
      return o;
    },
    get doc() {
      return r;
    },
    get tr() {
      return o = n.selection, r = n.doc, i = n.storedMarks, n;
    }
  };
}
class xf {
  constructor(t) {
    this.editor = t.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = t.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: t, editor: n, state: o } = this, { view: r } = n, { tr: i } = o, s = this.buildProps(i);
    return Object.fromEntries(Object.entries(t).map(([a, c]) => [a, (...u) => {
      const p = c(...u)(s);
      return !i.getMeta("preventDispatch") && !this.hasCustomState && r.dispatch(i), p;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(t, n = !0) {
    const { rawCommands: o, editor: r, state: i } = this, { view: s } = r, a = [], c = !!t, d = t || i.tr, u = () => (!c && n && !d.getMeta("preventDispatch") && !this.hasCustomState && s.dispatch(d), a.every((h) => h === !0)), p = {
      ...Object.fromEntries(Object.entries(o).map(([h, g]) => [h, (...b) => {
        const C = this.buildProps(d, n), x = g(...b)(C);
        return a.push(x), p;
      }])),
      run: u
    };
    return p;
  }
  createCan(t) {
    const { rawCommands: n, state: o } = this, r = !1, i = t || o.tr, s = this.buildProps(i, r);
    return {
      ...Object.fromEntries(Object.entries(n).map(([c, d]) => [c, (...u) => d(...u)({ ...s, dispatch: void 0 })])),
      chain: () => this.createChain(i, r)
    };
  }
  buildProps(t, n = !0) {
    const { rawCommands: o, editor: r, state: i } = this, { view: s } = r, a = {
      tr: t,
      editor: r,
      view: s,
      state: Cf({
        state: i,
        transaction: t
      }),
      dispatch: n ? () => {
      } : void 0,
      chain: () => this.createChain(t, n),
      can: () => this.createCan(t),
      get commands() {
        return Object.fromEntries(Object.entries(o).map(([c, d]) => [c, (...u) => d(...u)(a)]));
      }
    };
    return a;
  }
}
class k4e {
  constructor() {
    this.callbacks = {};
  }
  on(t, n) {
    return this.callbacks[t] || (this.callbacks[t] = []), this.callbacks[t].push(n), this;
  }
  emit(t, ...n) {
    const o = this.callbacks[t];
    return o && o.forEach((r) => r.apply(this, n)), this;
  }
  off(t, n) {
    const o = this.callbacks[t];
    return o && (n ? this.callbacks[t] = o.filter((r) => r !== n) : delete this.callbacks[t]), this;
  }
  once(t, n) {
    const o = (...r) => {
      this.off(t, o), n.apply(this, r);
    };
    return this.on(t, o);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
function it(e, t, n) {
  return e.config[t] === void 0 && e.parent ? it(e.parent, t, n) : typeof e.config[t] == "function" ? e.config[t].bind({
    ...n,
    parent: e.parent ? it(e.parent, t, n) : null
  }) : e.config[t];
}
function yf(e) {
  const t = e.filter((r) => r.type === "extension"), n = e.filter((r) => r.type === "node"), o = e.filter((r) => r.type === "mark");
  return {
    baseExtensions: t,
    nodeExtensions: n,
    markExtensions: o
  };
}
function kO(e) {
  const t = [], { nodeExtensions: n, markExtensions: o } = yf(e), r = [...n, ...o], i = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return e.forEach((s) => {
    const a = {
      name: s.name,
      options: s.options,
      storage: s.storage,
      extensions: r
    }, c = it(s, "addGlobalAttributes", a);
    if (!c)
      return;
    c().forEach((u) => {
      u.types.forEach((p) => {
        Object.entries(u.attributes).forEach(([h, g]) => {
          t.push({
            type: p,
            name: h,
            attribute: {
              ...i,
              ...g
            }
          });
        });
      });
    });
  }), r.forEach((s) => {
    const a = {
      name: s.name,
      options: s.options,
      storage: s.storage
    }, c = it(s, "addAttributes", a);
    if (!c)
      return;
    const d = c();
    Object.entries(d).forEach(([u, p]) => {
      const h = {
        ...i,
        ...p
      };
      typeof (h == null ? void 0 : h.default) == "function" && (h.default = h.default()), h != null && h.isRequired && (h == null ? void 0 : h.default) === void 0 && delete h.default, t.push({
        type: s.name,
        name: u,
        attribute: h
      });
    });
  }), t;
}
function qn(e, t) {
  if (typeof e == "string") {
    if (!t.nodes[e])
      throw Error(`There is no node type named '${e}'. Maybe you forgot to add the extension?`);
    return t.nodes[e];
  }
  return e;
}
function _n(...e) {
  return e.filter((t) => !!t).reduce((t, n) => {
    const o = { ...t };
    return Object.entries(n).forEach(([r, i]) => {
      if (!o[r]) {
        o[r] = i;
        return;
      }
      if (r === "class") {
        const a = i ? String(i).split(" ") : [], c = o[r] ? o[r].split(" ") : [], d = a.filter((u) => !c.includes(u));
        o[r] = [...c, ...d].join(" ");
      } else if (r === "style") {
        const a = i ? i.split(";").map((u) => u.trim()).filter(Boolean) : [], c = o[r] ? o[r].split(";").map((u) => u.trim()).filter(Boolean) : [], d = /* @__PURE__ */ new Map();
        c.forEach((u) => {
          const [p, h] = u.split(":").map((g) => g.trim());
          d.set(p, h);
        }), a.forEach((u) => {
          const [p, h] = u.split(":").map((g) => g.trim());
          d.set(p, h);
        }), o[r] = Array.from(d.entries()).map(([u, p]) => `${u}: ${p}`).join("; ");
      } else
        o[r] = i;
    }), o;
  }, {});
}
function N5(e, t) {
  return t.filter((n) => n.type === e.type.name).filter((n) => n.attribute.rendered).map((n) => n.attribute.renderHTML ? n.attribute.renderHTML(e.attrs) || {} : {
    [n.name]: e.attrs[n.name]
  }).reduce((n, o) => _n(n, o), {});
}
function EO(e) {
  return typeof e == "function";
}
function Ot(e, t = void 0, ...n) {
  return EO(e) ? t ? e.bind(t)(...n) : e(...n) : e;
}
function E4e(e = {}) {
  return Object.keys(e).length === 0 && e.constructor === Object;
}
function R4e(e) {
  return typeof e != "string" ? e : e.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(e) : e === "true" ? !0 : e === "false" ? !1 : e;
}
function Wx(e, t) {
  return "style" in e ? e : {
    ...e,
    getAttrs: (n) => {
      const o = e.getAttrs ? e.getAttrs(n) : e.attrs;
      if (o === !1)
        return !1;
      const r = t.reduce((i, s) => {
        const a = s.attribute.parseHTML ? s.attribute.parseHTML(n) : R4e(n.getAttribute(s.name));
        return a == null ? i : {
          ...i,
          [s.name]: a
        };
      }, {});
      return { ...o, ...r };
    }
  };
}
function Ux(e) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(e).filter(([t, n]) => t === "attrs" && E4e(n) ? !1 : n != null)
  );
}
function O4e(e, t) {
  var n;
  const o = kO(e), { nodeExtensions: r, markExtensions: i } = yf(e), s = (n = r.find((d) => it(d, "topNode"))) === null || n === void 0 ? void 0 : n.name, a = Object.fromEntries(r.map((d) => {
    const u = o.filter((x) => x.type === d.name), p = {
      name: d.name,
      options: d.options,
      storage: d.storage,
      editor: t
    }, h = e.reduce((x, v) => {
      const S = it(v, "extendNodeSchema", p);
      return {
        ...x,
        ...S ? S(d) : {}
      };
    }, {}), g = Ux({
      ...h,
      content: Ot(it(d, "content", p)),
      marks: Ot(it(d, "marks", p)),
      group: Ot(it(d, "group", p)),
      inline: Ot(it(d, "inline", p)),
      atom: Ot(it(d, "atom", p)),
      selectable: Ot(it(d, "selectable", p)),
      draggable: Ot(it(d, "draggable", p)),
      code: Ot(it(d, "code", p)),
      whitespace: Ot(it(d, "whitespace", p)),
      linebreakReplacement: Ot(it(d, "linebreakReplacement", p)),
      defining: Ot(it(d, "defining", p)),
      isolating: Ot(it(d, "isolating", p)),
      attrs: Object.fromEntries(u.map((x) => {
        var v;
        return [x.name, { default: (v = x == null ? void 0 : x.attribute) === null || v === void 0 ? void 0 : v.default }];
      }))
    }), m = Ot(it(d, "parseHTML", p));
    m && (g.parseDOM = m.map((x) => Wx(x, u)));
    const b = it(d, "renderHTML", p);
    b && (g.toDOM = (x) => b({
      node: x,
      HTMLAttributes: N5(x, u)
    }));
    const C = it(d, "renderText", p);
    return C && (g.toText = C), [d.name, g];
  })), c = Object.fromEntries(i.map((d) => {
    const u = o.filter((C) => C.type === d.name), p = {
      name: d.name,
      options: d.options,
      storage: d.storage,
      editor: t
    }, h = e.reduce((C, x) => {
      const v = it(x, "extendMarkSchema", p);
      return {
        ...C,
        ...v ? v(d) : {}
      };
    }, {}), g = Ux({
      ...h,
      inclusive: Ot(it(d, "inclusive", p)),
      excludes: Ot(it(d, "excludes", p)),
      group: Ot(it(d, "group", p)),
      spanning: Ot(it(d, "spanning", p)),
      code: Ot(it(d, "code", p)),
      attrs: Object.fromEntries(u.map((C) => {
        var x;
        return [C.name, { default: (x = C == null ? void 0 : C.attribute) === null || x === void 0 ? void 0 : x.default }];
      }))
    }), m = Ot(it(d, "parseHTML", p));
    m && (g.parseDOM = m.map((C) => Wx(C, u)));
    const b = it(d, "renderHTML", p);
    return b && (g.toDOM = (C) => b({
      mark: C,
      HTMLAttributes: N5(C, u)
    })), [d.name, g];
  }));
  return new yR({
    topNode: s,
    nodes: a,
    marks: c
  });
}
function op(e, t) {
  return t.nodes[e] || t.marks[e] || null;
}
function Gx(e, t) {
  return Array.isArray(t) ? t.some((n) => (typeof n == "string" ? n : n.name) === e.name) : t;
}
function k8(e, t) {
  const n = Ba.fromSchema(t).serializeFragment(e), r = document.implementation.createHTMLDocument().createElement("div");
  return r.appendChild(n), r.innerHTML;
}
const _4e = (e, t = 500) => {
  let n = "";
  const o = e.parentOffset;
  return e.parent.nodesBetween(Math.max(0, o - t), o, (r, i, s, a) => {
    var c, d;
    const u = ((d = (c = r.type.spec).toText) === null || d === void 0 ? void 0 : d.call(c, {
      node: r,
      pos: i,
      parent: s,
      index: a
    })) || r.textContent || "%leaf%";
    n += r.isAtom && !r.isText ? u : u.slice(0, Math.max(0, o - i));
  }), n;
};
function E8(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}
class vf {
  constructor(t) {
    this.find = t.find, this.handler = t.handler;
  }
}
const P4e = (e, t) => {
  if (E8(t))
    return t.exec(e);
  const n = t(e);
  if (!n)
    return null;
  const o = [n.text];
  return o.index = n.index, o.input = e, o.data = n.data, n.replaceWith && (n.text.includes(n.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), o.push(n.replaceWith)), o;
};
function K1(e) {
  var t;
  const { editor: n, from: o, to: r, text: i, rules: s, plugin: a } = e, { view: c } = n;
  if (c.composing)
    return !1;
  const d = c.state.doc.resolve(o);
  if (
    // check for code node
    d.parent.type.spec.code || !((t = d.nodeBefore || d.nodeAfter) === null || t === void 0) && t.marks.find((h) => h.type.spec.code)
  )
    return !1;
  let u = !1;
  const p = _4e(d) + i;
  return s.forEach((h) => {
    if (u)
      return;
    const g = P4e(p, h.find);
    if (!g)
      return;
    const m = c.state.tr, b = Cf({
      state: c.state,
      transaction: m
    }), C = {
      from: o - (g[0].length - i.length),
      to: r
    }, { commands: x, chain: v, can: S } = new xf({
      editor: n,
      state: b
    });
    h.handler({
      state: b,
      range: C,
      match: g,
      commands: x,
      chain: v,
      can: S
    }) === null || !m.steps.length || (m.setMeta(a, {
      transform: m,
      from: o,
      to: r,
      text: i
    }), c.dispatch(m), u = !0);
  }), u;
}
function L4e(e) {
  const { editor: t, rules: n } = e, o = new Kn({
    state: {
      init() {
        return null;
      },
      apply(r, i, s) {
        const a = r.getMeta(o);
        if (a)
          return a;
        const c = r.getMeta("applyInputRules");
        return !!c && setTimeout(() => {
          let { text: u } = c;
          typeof u == "string" ? u = u : u = k8(je.from(u), s.schema);
          const { from: p } = c, h = p + u.length;
          K1({
            editor: t,
            from: p,
            to: h,
            text: u,
            rules: n,
            plugin: o
          });
        }), r.selectionSet || r.docChanged ? null : i;
      }
    },
    props: {
      handleTextInput(r, i, s, a) {
        return K1({
          editor: t,
          from: i,
          to: s,
          text: a,
          rules: n,
          plugin: o
        });
      },
      handleDOMEvents: {
        compositionend: (r) => (setTimeout(() => {
          const { $cursor: i } = r.state.selection;
          i && K1({
            editor: t,
            from: i.pos,
            to: i.pos,
            text: "",
            rules: n,
            plugin: o
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(r, i) {
        if (i.key !== "Enter")
          return !1;
        const { $cursor: s } = r.state.selection;
        return s ? K1({
          editor: t,
          from: s.pos,
          to: s.pos,
          text: `
`,
          rules: n,
          plugin: o
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return o;
}
function I4e(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function Y1(e) {
  return I4e(e) !== "Object" ? !1 : e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
}
function wf(e, t) {
  const n = { ...e };
  return Y1(e) && Y1(t) && Object.keys(t).forEach((o) => {
    Y1(t[o]) && Y1(e[o]) ? n[o] = wf(e[o], t[o]) : n[o] = t[o];
  }), n;
}
class Sr {
  constructor(t = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...t
    }, this.name = this.config.name, t.defaultOptions && Object.keys(t.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ot(it(this, "addOptions", {
      name: this.name
    }))), this.storage = Ot(it(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(t = {}) {
    return new Sr(t);
  }
  configure(t = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => wf(this.options, t)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(t = {}) {
    const n = new Sr(t);
    return n.parent = this, this.child = n, n.name = t.name ? t.name : n.parent.name, t.defaultOptions && Object.keys(t.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Ot(it(n, "addOptions", {
      name: n.name
    })), n.storage = Ot(it(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
  static handleExit({ editor: t, mark: n }) {
    const { tr: o } = t.state, r = t.state.selection.$from;
    if (r.pos === r.end()) {
      const s = r.marks();
      if (!!!s.find((d) => (d == null ? void 0 : d.type.name) === n.name))
        return !1;
      const c = s.find((d) => (d == null ? void 0 : d.type.name) === n.name);
      return c && o.removeStoredMark(c), o.insertText(" ", r.pos), t.view.dispatch(o), !0;
    }
    return !1;
  }
}
function j4e(e) {
  return typeof e == "number";
}
class V4e {
  constructor(t) {
    this.find = t.find, this.handler = t.handler;
  }
}
const D4e = (e, t, n) => {
  if (E8(t))
    return [...e.matchAll(t)];
  const o = t(e, n);
  return o ? o.map((r) => {
    const i = [r.text];
    return i.index = r.index, i.input = e, i.data = r.data, r.replaceWith && (r.text.includes(r.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), i.push(r.replaceWith)), i;
  }) : [];
};
function A4e(e) {
  const { editor: t, state: n, from: o, to: r, rule: i, pasteEvent: s, dropEvent: a } = e, { commands: c, chain: d, can: u } = new xf({
    editor: t,
    state: n
  }), p = [];
  return n.doc.nodesBetween(o, r, (g, m) => {
    if (!g.isTextblock || g.type.spec.code)
      return;
    const b = Math.max(o, m), C = Math.min(r, m + g.content.size), x = g.textBetween(b - m, C - m, void 0, "￼");
    D4e(x, i.find, s).forEach((S) => {
      if (S.index === void 0)
        return;
      const M = b + S.index + 1, w = M + S[0].length, k = {
        from: n.tr.mapping.map(M),
        to: n.tr.mapping.map(w)
      }, E = i.handler({
        state: n,
        range: k,
        match: S,
        commands: c,
        chain: d,
        can: u,
        pasteEvent: s,
        dropEvent: a
      });
      p.push(E);
    });
  }), p.every((g) => g !== null);
}
let X1 = null;
const H4e = (e) => {
  var t;
  const n = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (t = n.clipboardData) === null || t === void 0 || t.setData("text/html", e), n;
};
function F4e(e) {
  const { editor: t, rules: n } = e;
  let o = null, r = !1, i = !1, s = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, a;
  try {
    a = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    a = null;
  }
  const c = ({ state: u, from: p, to: h, rule: g, pasteEvt: m }) => {
    const b = u.tr, C = Cf({
      state: u,
      transaction: b
    });
    if (!(!A4e({
      editor: t,
      state: C,
      from: Math.max(p - 1, 0),
      to: h.b - 1,
      rule: g,
      pasteEvent: m,
      dropEvent: a
    }) || !b.steps.length)) {
      try {
        a = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        a = null;
      }
      return s = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, b;
    }
  };
  return n.map((u) => new Kn({
    // we register a global drag handler to track the current drag source element
    view(p) {
      const h = (m) => {
        var b;
        o = !((b = p.dom.parentElement) === null || b === void 0) && b.contains(m.target) ? p.dom.parentElement : null, o && (X1 = t);
      }, g = () => {
        X1 && (X1 = null);
      };
      return window.addEventListener("dragstart", h), window.addEventListener("dragend", g), {
        destroy() {
          window.removeEventListener("dragstart", h), window.removeEventListener("dragend", g);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (p, h) => {
          if (i = o === p.dom.parentElement, a = h, !i) {
            const g = X1;
            g && setTimeout(() => {
              const m = g.state.selection;
              m && g.commands.deleteRange({ from: m.from, to: m.to });
            }, 10);
          }
          return !1;
        },
        paste: (p, h) => {
          var g;
          const m = (g = h.clipboardData) === null || g === void 0 ? void 0 : g.getData("text/html");
          return s = h, r = !!(m != null && m.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (p, h, g) => {
      const m = p[0], b = m.getMeta("uiEvent") === "paste" && !r, C = m.getMeta("uiEvent") === "drop" && !i, x = m.getMeta("applyPasteRules"), v = !!x;
      if (!b && !C && !v)
        return;
      if (v) {
        let { text: w } = x;
        typeof w == "string" ? w = w : w = k8(je.from(w), g.schema);
        const { from: k } = x, E = k + w.length, R = H4e(w);
        return c({
          rule: u,
          state: g,
          from: k,
          to: { b: E },
          pasteEvt: R
        });
      }
      const S = h.doc.content.findDiffStart(g.doc.content), M = h.doc.content.findDiffEnd(g.doc.content);
      if (!(!j4e(S) || !M || S === M.b))
        return c({
          rule: u,
          state: g,
          from: S,
          to: M,
          pasteEvt: s
        });
    }
  }));
}
function N4e(e) {
  const t = e.filter((n, o) => e.indexOf(n) !== o);
  return Array.from(new Set(t));
}
class gl {
  constructor(t, n) {
    this.splittableMarks = [], this.editor = n, this.extensions = gl.resolve(t), this.schema = O4e(this.extensions, n), this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */
  static resolve(t) {
    const n = gl.sort(gl.flatten(t)), o = N4e(n.map((r) => r.name));
    return o.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${o.map((r) => `'${r}'`).join(", ")}]. This can lead to issues.`), n;
  }
  /**
   * Create a flattened array of extensions by traversing the `addExtensions` field.
   * @param extensions An array of Tiptap extensions
   * @returns A flattened array of Tiptap extensions
   */
  static flatten(t) {
    return t.map((n) => {
      const o = {
        name: n.name,
        options: n.options,
        storage: n.storage
      }, r = it(n, "addExtensions", o);
      return r ? [n, ...this.flatten(r())] : n;
    }).flat(10);
  }
  /**
   * Sort extensions by priority.
   * @param extensions An array of Tiptap extensions
   * @returns A sorted array of Tiptap extensions by priority
   */
  static sort(t) {
    return t.sort((o, r) => {
      const i = it(o, "priority") || 100, s = it(r, "priority") || 100;
      return i > s ? -1 : i < s ? 1 : 0;
    });
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((t, n) => {
      const o = {
        name: n.name,
        options: n.options,
        storage: n.storage,
        editor: this.editor,
        type: op(n.name, this.schema)
      }, r = it(n, "addCommands", o);
      return r ? {
        ...t,
        ...r()
      } : t;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: t } = this, n = gl.sort([...this.extensions].reverse()), o = [], r = [], i = n.map((s) => {
      const a = {
        name: s.name,
        options: s.options,
        storage: s.storage,
        editor: t,
        type: op(s.name, this.schema)
      }, c = [], d = it(s, "addKeyboardShortcuts", a);
      let u = {};
      if (s.type === "mark" && it(s, "exitable", a) && (u.ArrowRight = () => Sr.handleExit({ editor: t, mark: s })), d) {
        const b = Object.fromEntries(Object.entries(d()).map(([C, x]) => [C, () => x({ editor: t })]));
        u = { ...u, ...b };
      }
      const p = Q5e(u);
      c.push(p);
      const h = it(s, "addInputRules", a);
      Gx(s, t.options.enableInputRules) && h && o.push(...h());
      const g = it(s, "addPasteRules", a);
      Gx(s, t.options.enablePasteRules) && g && r.push(...g());
      const m = it(s, "addProseMirrorPlugins", a);
      if (m) {
        const b = m();
        c.push(...b);
      }
      return c;
    }).flat();
    return [
      L4e({
        editor: t,
        rules: o
      }),
      ...F4e({
        editor: t,
        rules: r
      }),
      ...i
    ];
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return kO(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: t } = this, { nodeExtensions: n } = yf(this.extensions);
    return Object.fromEntries(n.filter((o) => !!it(o, "addNodeView")).map((o) => {
      const r = this.attributes.filter((c) => c.type === o.name), i = {
        name: o.name,
        options: o.options,
        storage: o.storage,
        editor: t,
        type: qn(o.name, this.schema)
      }, s = it(o, "addNodeView", i);
      if (!s)
        return [];
      const a = (c, d, u, p, h) => {
        const g = N5(c, r);
        return s()({
          // pass-through
          node: c,
          view: d,
          getPos: u,
          decorations: p,
          innerDecorations: h,
          // tiptap-specific
          editor: t,
          extension: o,
          HTMLAttributes: g
        });
      };
      return [o.name, a];
    }));
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    this.extensions.forEach((t) => {
      var n;
      this.editor.extensionStorage[t.name] = t.storage;
      const o = {
        name: t.name,
        options: t.options,
        storage: t.storage,
        editor: this.editor,
        type: op(t.name, this.schema)
      };
      t.type === "mark" && (!((n = Ot(it(t, "keepOnSplit", o))) !== null && n !== void 0) || n) && this.splittableMarks.push(t.name);
      const r = it(t, "onBeforeCreate", o), i = it(t, "onCreate", o), s = it(t, "onUpdate", o), a = it(t, "onSelectionUpdate", o), c = it(t, "onTransaction", o), d = it(t, "onFocus", o), u = it(t, "onBlur", o), p = it(t, "onDestroy", o);
      r && this.editor.on("beforeCreate", r), i && this.editor.on("create", i), s && this.editor.on("update", s), a && this.editor.on("selectionUpdate", a), c && this.editor.on("transaction", c), d && this.editor.on("focus", d), u && this.editor.on("blur", u), p && this.editor.on("destroy", p);
    });
  }
}
class Rn {
  constructor(t = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...t
    }, this.name = this.config.name, t.defaultOptions && Object.keys(t.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ot(it(this, "addOptions", {
      name: this.name
    }))), this.storage = Ot(it(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(t = {}) {
    return new Rn(t);
  }
  configure(t = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => wf(this.options, t)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(t = {}) {
    const n = new Rn({ ...this.config, ...t });
    return n.parent = this, this.child = n, n.name = t.name ? t.name : n.parent.name, t.defaultOptions && Object.keys(t.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Ot(it(n, "addOptions", {
      name: n.name
    })), n.storage = Ot(it(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
}
function RO(e, t, n) {
  const { from: o, to: r } = t, { blockSeparator: i = `

`, textSerializers: s = {} } = n || {};
  let a = "";
  return e.nodesBetween(o, r, (c, d, u, p) => {
    var h;
    c.isBlock && d > o && (a += i);
    const g = s == null ? void 0 : s[c.type.name];
    if (g)
      return u && (a += g({
        node: c,
        pos: d,
        parent: u,
        index: p,
        range: t
      })), !1;
    c.isText && (a += (h = c == null ? void 0 : c.text) === null || h === void 0 ? void 0 : h.slice(Math.max(o, d) - d, r - d));
  }), a;
}
function OO(e) {
  return Object.fromEntries(Object.entries(e.nodes).filter(([, t]) => t.spec.toText).map(([t, n]) => [t, n.spec.toText]));
}
const $4e = Rn.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Kn({
        key: new No("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: e } = this, { state: t, schema: n } = e, { doc: o, selection: r } = t, { ranges: i } = r, s = Math.min(...i.map((u) => u.$from.pos)), a = Math.max(...i.map((u) => u.$to.pos)), c = OO(n);
            return RO(o, { from: s, to: a }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: c
            });
          }
        }
      })
    ];
  }
}), B4e = () => ({ editor: e, view: t }) => (requestAnimationFrame(() => {
  var n;
  e.isDestroyed || (t.dom.blur(), (n = window == null ? void 0 : window.getSelection()) === null || n === void 0 || n.removeAllRanges());
}), !0), z4e = (e = !1) => ({ commands: t }) => t.setContent("", e), Z4e = () => ({ state: e, tr: t, dispatch: n }) => {
  const { selection: o } = t, { ranges: r } = o;
  return n && r.forEach(({ $from: i, $to: s }) => {
    e.doc.nodesBetween(i.pos, s.pos, (a, c) => {
      if (a.type.isText)
        return;
      const { doc: d, mapping: u } = t, p = d.resolve(u.map(c)), h = d.resolve(u.map(c + a.nodeSize)), g = p.blockRange(h);
      if (!g)
        return;
      const m = x2(g);
      if (a.type.isTextblock) {
        const { defaultType: b } = p.parent.contentMatchAt(p.index());
        t.setNodeMarkup(g.start, b);
      }
      (m || m === 0) && t.lift(g, m);
    });
  }), !0;
}, W4e = (e) => (t) => e(t), U4e = () => ({ state: e, dispatch: t }) => f4e(e, t), G4e = (e, t) => ({ editor: n, tr: o }) => {
  const { state: r } = n, i = r.doc.slice(e.from, e.to);
  o.deleteRange(e.from, e.to);
  const s = o.mapping.map(t);
  return o.insert(s, i.content), o.setSelection(new xt(o.doc.resolve(s - 1))), !0;
}, q4e = () => ({ tr: e, dispatch: t }) => {
  const { selection: n } = e, o = n.$anchor.node();
  if (o.content.size > 0)
    return !1;
  const r = e.selection.$anchor;
  for (let i = r.depth; i > 0; i -= 1)
    if (r.node(i).type === o.type) {
      if (t) {
        const a = r.before(i), c = r.after(i);
        e.delete(a, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, K4e = (e) => ({ tr: t, state: n, dispatch: o }) => {
  const r = qn(e, n.schema), i = t.selection.$anchor;
  for (let s = i.depth; s > 0; s -= 1)
    if (i.node(s).type === r) {
      if (o) {
        const c = i.before(s), d = i.after(s);
        t.delete(c, d).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, Y4e = (e) => ({ tr: t, dispatch: n }) => {
  const { from: o, to: r } = e;
  return n && t.delete(o, r), !0;
}, X4e = () => ({ state: e, dispatch: t }) => e4e(e, t), J4e = () => ({ commands: e }) => e.keyboardShortcut("Enter"), Q4e = () => ({ state: e, dispatch: t }) => u4e(e, t);
function ku(e, t, n = { strict: !0 }) {
  const o = Object.keys(t);
  return o.length ? o.every((r) => n.strict ? t[r] === e[r] : E8(t[r]) ? t[r].test(e[r]) : t[r] === e[r]) : !0;
}
function _O(e, t, n = {}) {
  return e.find((o) => o.type === t && ku(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(n).map((r) => [r, o.attrs[r]])),
    n
  ));
}
function qx(e, t, n = {}) {
  return !!_O(e, t, n);
}
function R8(e, t, n) {
  var o;
  if (!e || !t)
    return;
  let r = e.parent.childAfter(e.parentOffset);
  if ((!r.node || !r.node.marks.some((u) => u.type === t)) && (r = e.parent.childBefore(e.parentOffset)), !r.node || !r.node.marks.some((u) => u.type === t) || (n = n || ((o = r.node.marks[0]) === null || o === void 0 ? void 0 : o.attrs), !_O([...r.node.marks], t, n)))
    return;
  let s = r.index, a = e.start() + r.offset, c = s + 1, d = a + r.node.nodeSize;
  for (; s > 0 && qx([...e.parent.child(s - 1).marks], t, n); )
    s -= 1, a -= e.parent.child(s).nodeSize;
  for (; c < e.parent.childCount && qx([...e.parent.child(c).marks], t, n); )
    d += e.parent.child(c).nodeSize, c += 1;
  return {
    from: a,
    to: d
  };
}
function Is(e, t) {
  if (typeof e == "string") {
    if (!t.marks[e])
      throw Error(`There is no mark type named '${e}'. Maybe you forgot to add the extension?`);
    return t.marks[e];
  }
  return e;
}
const e7e = (e, t = {}) => ({ tr: n, state: o, dispatch: r }) => {
  const i = Is(e, o.schema), { doc: s, selection: a } = n, { $from: c, from: d, to: u } = a;
  if (r) {
    const p = R8(c, i, t);
    if (p && p.from <= d && p.to >= u) {
      const h = xt.create(s, p.from, p.to);
      n.setSelection(h);
    }
  }
  return !0;
}, t7e = (e) => (t) => {
  const n = typeof e == "function" ? e(t) : e;
  for (let o = 0; o < n.length; o += 1)
    if (n[o](t))
      return !0;
  return !1;
};
function PO(e) {
  return e instanceof xt;
}
function na(e = 0, t = 0, n = 0) {
  return Math.min(Math.max(e, t), n);
}
function LO(e, t = null) {
  if (!t)
    return null;
  const n = Mt.atStart(e), o = Mt.atEnd(e);
  if (t === "start" || t === !0)
    return n;
  if (t === "end")
    return o;
  const r = n.from, i = o.to;
  return t === "all" ? xt.create(e, na(0, r, i), na(e.content.size, r, i)) : xt.create(e, na(t, r, i), na(t, r, i));
}
const n7e = (e = null, t = {}) => ({ editor: n, view: o, tr: r, dispatch: i }) => {
  t = {
    scrollIntoView: !0,
    ...t
  };
  const s = () => {
    o.dom.focus(), requestAnimationFrame(() => {
      n.isDestroyed || (o.focus(), t != null && t.scrollIntoView && n.commands.scrollIntoView());
    });
  };
  if (o.hasFocus() && e === null || e === !1)
    return !0;
  if (i && e === null && !PO(n.state.selection))
    return s(), !0;
  const a = LO(r.doc, e) || n.state.selection, c = n.state.selection.eq(a);
  return i && (c || r.setSelection(a), c && r.storedMarks && r.setStoredMarks(r.storedMarks), s()), !0;
}, o7e = (e, t) => (n) => e.every((o, r) => t(o, { ...n, index: r })), r7e = (e, t) => ({ tr: n, commands: o }) => o.insertContentAt({ from: n.selection.from, to: n.selection.to }, e, t), IO = (e) => {
  const t = e.childNodes;
  for (let n = t.length - 1; n >= 0; n -= 1) {
    const o = t[n];
    o.nodeType === 3 && o.nodeValue && /^(\n\s\s|\n)$/.test(o.nodeValue) ? e.removeChild(o) : o.nodeType === 1 && IO(o);
  }
  return e;
};
function J1(e) {
  const t = `<body>${e}</body>`, n = new window.DOMParser().parseFromString(t, "text/html").body;
  return IO(n);
}
function Eu(e, t, n) {
  if (e instanceof ls || e instanceof je)
    return e;
  n = {
    slice: !0,
    parseOptions: {},
    ...n
  };
  const o = typeof e == "object" && e !== null, r = typeof e == "string";
  if (o)
    try {
      if (Array.isArray(e) && e.length > 0)
        return je.fromArray(e.map((a) => t.nodeFromJSON(a)));
      const s = t.nodeFromJSON(e);
      return n.errorOnInvalidContent && s.check(), s;
    } catch (i) {
      if (n.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: i });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", e, "Error:", i), Eu("", t, n);
    }
  if (r) {
    if (n.errorOnInvalidContent) {
      let s = !1, a = "";
      const c = new yR({
        topNode: t.spec.topNode,
        marks: t.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: t.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (d) => (s = !0, a = typeof d == "string" ? d : d.outerHTML, null)
              }
            ]
          }
        })
      });
      if (n.slice ? cs.fromSchema(c).parseSlice(J1(e), n.parseOptions) : cs.fromSchema(c).parse(J1(e), n.parseOptions), n.errorOnInvalidContent && s)
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${a}`) });
    }
    const i = cs.fromSchema(t);
    return n.slice ? i.parseSlice(J1(e), n.parseOptions).content : i.parse(J1(e), n.parseOptions);
  }
  return Eu("", t, n);
}
function i7e(e, t, n) {
  const o = e.steps.length - 1;
  if (o < t)
    return;
  const r = e.steps[o];
  if (!(r instanceof Zn || r instanceof Un))
    return;
  const i = e.mapping.maps[o];
  let s = 0;
  i.forEach((a, c, d, u) => {
    s === 0 && (s = u);
  }), e.setSelection(Mt.near(e.doc.resolve(s), n));
}
const s7e = (e) => !("type" in e), a7e = (e, t, n) => ({ tr: o, dispatch: r, editor: i }) => {
  var s;
  if (r) {
    n = {
      parseOptions: i.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...n
    };
    let a;
    try {
      a = Eu(t, i.schema, {
        parseOptions: {
          preserveWhitespace: "full",
          ...n.parseOptions
        },
        errorOnInvalidContent: (s = n.errorOnInvalidContent) !== null && s !== void 0 ? s : i.options.enableContentCheck
      });
    } catch (m) {
      return i.emit("contentError", {
        editor: i,
        error: m,
        disableCollaboration: () => {
          i.storage.collaboration && (i.storage.collaboration.isDisabled = !0);
        }
      }), !1;
    }
    let { from: c, to: d } = typeof e == "number" ? { from: e, to: e } : { from: e.from, to: e.to }, u = !0, p = !0;
    if ((s7e(a) ? a : [a]).forEach((m) => {
      m.check(), u = u ? m.isText && m.marks.length === 0 : !1, p = p ? m.isBlock : !1;
    }), c === d && p) {
      const { parent: m } = o.doc.resolve(c);
      m.isTextblock && !m.type.spec.code && !m.childCount && (c -= 1, d += 1);
    }
    let g;
    if (u) {
      if (Array.isArray(t))
        g = t.map((m) => m.text || "").join("");
      else if (t instanceof je) {
        let m = "";
        t.forEach((b) => {
          b.text && (m += b.text);
        }), g = m;
      } else typeof t == "object" && t && t.text ? g = t.text : g = t;
      o.insertText(g, c, d);
    } else
      g = a, o.replaceWith(c, d, g);
    n.updateSelection && i7e(o, o.steps.length - 1, -1), n.applyInputRules && o.setMeta("applyInputRules", { from: c, text: g }), n.applyPasteRules && o.setMeta("applyPasteRules", { from: c, text: g });
  }
  return !0;
}, l7e = () => ({ state: e, dispatch: t }) => a4e(e, t), c7e = () => ({ state: e, dispatch: t }) => l4e(e, t), d7e = () => ({ state: e, dispatch: t }) => t4e(e, t), u7e = () => ({ state: e, dispatch: t }) => i4e(e, t), f7e = () => ({ state: e, dispatch: t, tr: n }) => {
  try {
    const o = ff(e.doc, e.selection.$from.pos, -1);
    return o == null ? !1 : (n.join(o, 2), t && t(n), !0);
  } catch {
    return !1;
  }
}, p7e = () => ({ state: e, dispatch: t, tr: n }) => {
  try {
    const o = ff(e.doc, e.selection.$from.pos, 1);
    return o == null ? !1 : (n.join(o, 2), t && t(n), !0);
  } catch {
    return !1;
  }
}, h7e = () => ({ state: e, dispatch: t }) => n4e(e, t), g7e = () => ({ state: e, dispatch: t }) => o4e(e, t);
function jO() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
function VO() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function m7e(e) {
  const t = e.split(/-(?!$)/);
  let n = t[t.length - 1];
  n === "Space" && (n = " ");
  let o, r, i, s;
  for (let a = 0; a < t.length - 1; a += 1) {
    const c = t[a];
    if (/^(cmd|meta|m)$/i.test(c))
      s = !0;
    else if (/^a(lt)?$/i.test(c))
      o = !0;
    else if (/^(c|ctrl|control)$/i.test(c))
      r = !0;
    else if (/^s(hift)?$/i.test(c))
      i = !0;
    else if (/^mod$/i.test(c))
      jO() || VO() ? s = !0 : r = !0;
    else
      throw new Error(`Unrecognized modifier name: ${c}`);
  }
  return o && (n = `Alt-${n}`), r && (n = `Ctrl-${n}`), s && (n = `Meta-${n}`), i && (n = `Shift-${n}`), n;
}
const b7e = (e) => ({ editor: t, view: n, tr: o, dispatch: r }) => {
  const i = m7e(e).split(/-(?!$)/), s = i.find((d) => !["Alt", "Ctrl", "Meta", "Shift"].includes(d)), a = new KeyboardEvent("keydown", {
    key: s === "Space" ? " " : s,
    altKey: i.includes("Alt"),
    ctrlKey: i.includes("Ctrl"),
    metaKey: i.includes("Meta"),
    shiftKey: i.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), c = t.captureTransaction(() => {
    n.someProp("handleKeyDown", (d) => d(n, a));
  });
  return c == null || c.steps.forEach((d) => {
    const u = d.map(o.mapping);
    u && r && o.maybeStep(u);
  }), !0;
};
function c0(e, t, n = {}) {
  const { from: o, to: r, empty: i } = e.selection, s = t ? qn(t, e.schema) : null, a = [];
  e.doc.nodesBetween(o, r, (p, h) => {
    if (p.isText)
      return;
    const g = Math.max(o, h), m = Math.min(r, h + p.nodeSize);
    a.push({
      node: p,
      from: g,
      to: m
    });
  });
  const c = r - o, d = a.filter((p) => s ? s.name === p.node.type.name : !0).filter((p) => ku(p.node.attrs, n, { strict: !1 }));
  return i ? !!d.length : d.reduce((p, h) => p + h.to - h.from, 0) >= c;
}
const C7e = (e, t = {}) => ({ state: n, dispatch: o }) => {
  const r = qn(e, n.schema);
  return c0(n, r, t) ? c4e(n, o) : !1;
}, x7e = () => ({ state: e, dispatch: t }) => p4e(e, t), y7e = (e) => ({ state: t, dispatch: n }) => {
  const o = qn(e, t.schema);
  return w4e(o)(t, n);
}, v7e = () => ({ state: e, dispatch: t }) => d4e(e, t);
function Sf(e, t) {
  return t.nodes[e] ? "node" : t.marks[e] ? "mark" : null;
}
function Kx(e, t) {
  const n = typeof t == "string" ? [t] : t;
  return Object.keys(e).reduce((o, r) => (n.includes(r) || (o[r] = e[r]), o), {});
}
const w7e = (e, t) => ({ tr: n, state: o, dispatch: r }) => {
  let i = null, s = null;
  const a = Sf(typeof e == "string" ? e : e.name, o.schema);
  return a ? (a === "node" && (i = qn(e, o.schema)), a === "mark" && (s = Is(e, o.schema)), r && n.selection.ranges.forEach((c) => {
    o.doc.nodesBetween(c.$from.pos, c.$to.pos, (d, u) => {
      i && i === d.type && n.setNodeMarkup(u, void 0, Kx(d.attrs, t)), s && d.marks.length && d.marks.forEach((p) => {
        s === p.type && n.addMark(u, u + d.nodeSize, s.create(Kx(p.attrs, t)));
      });
    });
  }), !0) : !1;
}, S7e = () => ({ tr: e, dispatch: t }) => (t && e.scrollIntoView(), !0), M7e = () => ({ tr: e, dispatch: t }) => {
  if (t) {
    const n = new Cr(e.doc);
    e.setSelection(n);
  }
  return !0;
}, T7e = () => ({ state: e, dispatch: t }) => r4e(e, t), k7e = () => ({ state: e, dispatch: t }) => s4e(e, t), E7e = () => ({ state: e, dispatch: t }) => h4e(e, t), R7e = () => ({ state: e, dispatch: t }) => b4e(e, t), O7e = () => ({ state: e, dispatch: t }) => m4e(e, t);
function $5(e, t, n = {}, o = {}) {
  return Eu(e, t, {
    slice: !1,
    parseOptions: n,
    errorOnInvalidContent: o.errorOnInvalidContent
  });
}
const _7e = (e, t = !1, n = {}, o = {}) => ({ editor: r, tr: i, dispatch: s, commands: a }) => {
  var c, d;
  const { doc: u } = i;
  if (n.preserveWhitespace !== "full") {
    const p = $5(e, r.schema, n, {
      errorOnInvalidContent: (c = o.errorOnInvalidContent) !== null && c !== void 0 ? c : r.options.enableContentCheck
    });
    return s && i.replaceWith(0, u.content.size, p).setMeta("preventUpdate", !t), !0;
  }
  return s && i.setMeta("preventUpdate", !t), a.insertContentAt({ from: 0, to: u.content.size }, e, {
    parseOptions: n,
    errorOnInvalidContent: (d = o.errorOnInvalidContent) !== null && d !== void 0 ? d : r.options.enableContentCheck
  });
};
function DO(e, t) {
  const n = Is(t, e.schema), { from: o, to: r, empty: i } = e.selection, s = [];
  i ? (e.storedMarks && s.push(...e.storedMarks), s.push(...e.selection.$head.marks())) : e.doc.nodesBetween(o, r, (c) => {
    s.push(...c.marks);
  });
  const a = s.find((c) => c.type.name === n.name);
  return a ? { ...a.attrs } : {};
}
function P7e(e, t) {
  const n = new DR(e);
  return t.forEach((o) => {
    o.steps.forEach((r) => {
      n.step(r);
    });
  }), n;
}
function L7e(e) {
  for (let t = 0; t < e.edgeCount; t += 1) {
    const { type: n } = e.edge(t);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
function I7e(e, t, n) {
  const o = [];
  return e.nodesBetween(t.from, t.to, (r, i) => {
    n(r) && o.push({
      node: r,
      pos: i
    });
  }), o;
}
function j7e(e, t) {
  for (let n = e.depth; n > 0; n -= 1) {
    const o = e.node(n);
    if (t(o))
      return {
        pos: n > 0 ? e.before(n) : 0,
        start: e.start(n),
        depth: n,
        node: o
      };
  }
}
function O8(e) {
  return (t) => j7e(t.$from, e);
}
function V7e(e, t) {
  const n = {
    from: 0,
    to: e.content.size
  };
  return RO(e, n, t);
}
function D7e(e, t) {
  const n = qn(t, e.schema), { from: o, to: r } = e.selection, i = [];
  e.doc.nodesBetween(o, r, (a) => {
    i.push(a);
  });
  const s = i.reverse().find((a) => a.type.name === n.name);
  return s ? { ...s.attrs } : {};
}
function AO(e, t) {
  const n = Sf(typeof t == "string" ? t : t.name, e.schema);
  return n === "node" ? D7e(e, t) : n === "mark" ? DO(e, t) : {};
}
function A7e(e, t = JSON.stringify) {
  const n = {};
  return e.filter((o) => {
    const r = t(o);
    return Object.prototype.hasOwnProperty.call(n, r) ? !1 : n[r] = !0;
  });
}
function H7e(e) {
  const t = A7e(e);
  return t.length === 1 ? t : t.filter((n, o) => !t.filter((i, s) => s !== o).some((i) => n.oldRange.from >= i.oldRange.from && n.oldRange.to <= i.oldRange.to && n.newRange.from >= i.newRange.from && n.newRange.to <= i.newRange.to));
}
function F7e(e) {
  const { mapping: t, steps: n } = e, o = [];
  return t.maps.forEach((r, i) => {
    const s = [];
    if (r.ranges.length)
      r.forEach((a, c) => {
        s.push({ from: a, to: c });
      });
    else {
      const { from: a, to: c } = n[i];
      if (a === void 0 || c === void 0)
        return;
      s.push({ from: a, to: c });
    }
    s.forEach(({ from: a, to: c }) => {
      const d = t.slice(i).map(a, -1), u = t.slice(i).map(c), p = t.invert().map(d, -1), h = t.invert().map(u);
      o.push({
        oldRange: {
          from: p,
          to: h
        },
        newRange: {
          from: d,
          to: u
        }
      });
    });
  }), H7e(o);
}
function _8(e, t, n) {
  const o = [];
  return e === t ? n.resolve(e).marks().forEach((r) => {
    const i = n.resolve(e), s = R8(i, r.type);
    s && o.push({
      mark: r,
      ...s
    });
  }) : n.nodesBetween(e, t, (r, i) => {
    !r || (r == null ? void 0 : r.nodeSize) === void 0 || o.push(...r.marks.map((s) => ({
      from: i,
      to: i + r.nodeSize,
      mark: s
    })));
  }), o;
}
function Vd(e, t, n) {
  return Object.fromEntries(Object.entries(n).filter(([o]) => {
    const r = e.find((i) => i.type === t && i.name === o);
    return r ? r.attribute.keepOnSplit : !1;
  }));
}
function B5(e, t, n = {}) {
  const { empty: o, ranges: r } = e.selection, i = t ? Is(t, e.schema) : null;
  if (o)
    return !!(e.storedMarks || e.selection.$from.marks()).filter((p) => i ? i.name === p.type.name : !0).find((p) => ku(p.attrs, n, { strict: !1 }));
  let s = 0;
  const a = [];
  if (r.forEach(({ $from: p, $to: h }) => {
    const g = p.pos, m = h.pos;
    e.doc.nodesBetween(g, m, (b, C) => {
      if (!b.isText && !b.marks.length)
        return;
      const x = Math.max(g, C), v = Math.min(m, C + b.nodeSize), S = v - x;
      s += S, a.push(...b.marks.map((M) => ({
        mark: M,
        from: x,
        to: v
      })));
    });
  }), s === 0)
    return !1;
  const c = a.filter((p) => i ? i.name === p.mark.type.name : !0).filter((p) => ku(p.mark.attrs, n, { strict: !1 })).reduce((p, h) => p + h.to - h.from, 0), d = a.filter((p) => i ? p.mark.type !== i && p.mark.type.excludes(i) : !0).reduce((p, h) => p + h.to - h.from, 0);
  return (c > 0 ? c + d : c) >= s;
}
function N7e(e, t, n = {}) {
  if (!t)
    return c0(e, null, n) || B5(e, null, n);
  const o = Sf(t, e.schema);
  return o === "node" ? c0(e, t, n) : o === "mark" ? B5(e, t, n) : !1;
}
function Yx(e, t) {
  const { nodeExtensions: n } = yf(t), o = n.find((s) => s.name === e);
  if (!o)
    return !1;
  const r = {
    name: o.name,
    options: o.options,
    storage: o.storage
  }, i = Ot(it(o, "group", r));
  return typeof i != "string" ? !1 : i.split(" ").includes("list");
}
function Mf(e, { checkChildren: t = !0, ignoreWhitespace: n = !1 } = {}) {
  var o;
  if (n) {
    if (e.type.name === "hardBreak")
      return !0;
    if (e.isText)
      return /^\s*$/m.test((o = e.text) !== null && o !== void 0 ? o : "");
  }
  if (e.isText)
    return !e.text;
  if (e.isAtom || e.isLeaf)
    return !1;
  if (e.content.childCount === 0)
    return !0;
  if (t) {
    let r = !0;
    return e.content.forEach((i) => {
      r !== !1 && (Mf(i, { ignoreWhitespace: n, checkChildren: t }) || (r = !1));
    }), r;
  }
  return !1;
}
function $7e(e) {
  return e instanceof ut;
}
function B7e(e, t, n) {
  var o;
  const { selection: r } = t;
  let i = null;
  if (PO(r) && (i = r.$cursor), i) {
    const a = (o = e.storedMarks) !== null && o !== void 0 ? o : i.marks();
    return !!n.isInSet(a) || !a.some((c) => c.type.excludes(n));
  }
  const { ranges: s } = r;
  return s.some(({ $from: a, $to: c }) => {
    let d = a.depth === 0 ? e.doc.inlineContent && e.doc.type.allowsMarkType(n) : !1;
    return e.doc.nodesBetween(a.pos, c.pos, (u, p, h) => {
      if (d)
        return !1;
      if (u.isInline) {
        const g = !h || h.type.allowsMarkType(n), m = !!n.isInSet(u.marks) || !u.marks.some((b) => b.type.excludes(n));
        d = g && m;
      }
      return !d;
    }), d;
  });
}
const z7e = (e, t = {}) => ({ tr: n, state: o, dispatch: r }) => {
  const { selection: i } = n, { empty: s, ranges: a } = i, c = Is(e, o.schema);
  if (r)
    if (s) {
      const d = DO(o, c);
      n.addStoredMark(c.create({
        ...d,
        ...t
      }));
    } else
      a.forEach((d) => {
        const u = d.$from.pos, p = d.$to.pos;
        o.doc.nodesBetween(u, p, (h, g) => {
          const m = Math.max(g, u), b = Math.min(g + h.nodeSize, p);
          h.marks.find((x) => x.type === c) ? h.marks.forEach((x) => {
            c === x.type && n.addMark(m, b, c.create({
              ...x.attrs,
              ...t
            }));
          }) : n.addMark(m, b, c.create(t));
        });
      });
  return B7e(o, n, c);
}, Z7e = (e, t) => ({ tr: n }) => (n.setMeta(e, t), !0), W7e = (e, t = {}) => ({ state: n, dispatch: o, chain: r }) => {
  const i = qn(e, n.schema);
  let s;
  return n.selection.$anchor.sameParent(n.selection.$head) && (s = n.selection.$anchor.parent.attrs), i.isTextblock ? r().command(({ commands: a }) => Zx(i, { ...s, ...t })(n) ? !0 : a.clearNodes()).command(({ state: a }) => Zx(i, { ...s, ...t })(a, o)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, U7e = (e) => ({ tr: t, dispatch: n }) => {
  if (n) {
    const { doc: o } = t, r = na(e, 0, o.content.size), i = ut.create(o, r);
    t.setSelection(i);
  }
  return !0;
}, G7e = (e) => ({ tr: t, dispatch: n }) => {
  if (n) {
    const { doc: o } = t, { from: r, to: i } = typeof e == "number" ? { from: e, to: e } : e, s = xt.atStart(o).from, a = xt.atEnd(o).to, c = na(r, s, a), d = na(i, s, a), u = xt.create(o, c, d);
    t.setSelection(u);
  }
  return !0;
}, q7e = (e) => ({ state: t, dispatch: n }) => {
  const o = qn(e, t.schema);
  return T4e(o)(t, n);
};
function Xx(e, t) {
  const n = e.storedMarks || e.selection.$to.parentOffset && e.selection.$from.marks();
  if (n) {
    const o = n.filter((r) => t == null ? void 0 : t.includes(r.type.name));
    e.tr.ensureMarks(o);
  }
}
const K7e = ({ keepMarks: e = !0 } = {}) => ({ tr: t, state: n, dispatch: o, editor: r }) => {
  const { selection: i, doc: s } = t, { $from: a, $to: c } = i, d = r.extensionManager.attributes, u = Vd(d, a.node().type.name, a.node().attrs);
  if (i instanceof ut && i.node.isBlock)
    return !a.parentOffset || !El(s, a.pos) ? !1 : (o && (e && Xx(n, r.extensionManager.splittableMarks), t.split(a.pos).scrollIntoView()), !0);
  if (!a.parent.isBlock)
    return !1;
  const p = c.parentOffset === c.parent.content.size, h = a.depth === 0 ? void 0 : L7e(a.node(-1).contentMatchAt(a.indexAfter(-1)));
  let g = p && h ? [
    {
      type: h,
      attrs: u
    }
  ] : void 0, m = El(t.doc, t.mapping.map(a.pos), 1, g);
  if (!g && !m && El(t.doc, t.mapping.map(a.pos), 1, h ? [{ type: h }] : void 0) && (m = !0, g = h ? [
    {
      type: h,
      attrs: u
    }
  ] : void 0), o) {
    if (m && (i instanceof xt && t.deleteSelection(), t.split(t.mapping.map(a.pos), 1, g), h && !p && !a.parentOffset && a.parent.type !== h)) {
      const b = t.mapping.map(a.before()), C = t.doc.resolve(b);
      a.node(-1).canReplaceWith(C.index(), C.index() + 1, h) && t.setNodeMarkup(t.mapping.map(a.before()), h);
    }
    e && Xx(n, r.extensionManager.splittableMarks), t.scrollIntoView();
  }
  return m;
}, Y7e = (e, t = {}) => ({ tr: n, state: o, dispatch: r, editor: i }) => {
  var s;
  const a = qn(e, o.schema), { $from: c, $to: d } = o.selection, u = o.selection.node;
  if (u && u.isBlock || c.depth < 2 || !c.sameParent(d))
    return !1;
  const p = c.node(-1);
  if (p.type !== a)
    return !1;
  const h = i.extensionManager.attributes;
  if (c.parent.content.size === 0 && c.node(-1).childCount === c.indexAfter(-1)) {
    if (c.depth === 2 || c.node(-3).type !== a || c.index(-2) !== c.node(-2).childCount - 1)
      return !1;
    if (r) {
      let x = je.empty;
      const v = c.index(-1) ? 1 : c.index(-2) ? 2 : 3;
      for (let R = c.depth - v; R >= c.depth - 3; R -= 1)
        x = je.from(c.node(R).copy(x));
      const S = c.indexAfter(-1) < c.node(-2).childCount ? 1 : c.indexAfter(-2) < c.node(-3).childCount ? 2 : 3, M = {
        ...Vd(h, c.node().type.name, c.node().attrs),
        ...t
      }, w = ((s = a.contentMatch.defaultType) === null || s === void 0 ? void 0 : s.createAndFill(M)) || void 0;
      x = x.append(je.from(a.createAndFill(null, w) || void 0));
      const k = c.before(c.depth - (v - 1));
      n.replace(k, c.after(-S), new et(x, 4 - v, 0));
      let E = -1;
      n.doc.nodesBetween(k, n.doc.content.size, (R, O) => {
        if (E > -1)
          return !1;
        R.isTextblock && R.content.size === 0 && (E = O + 1);
      }), E > -1 && n.setSelection(xt.near(n.doc.resolve(E))), n.scrollIntoView();
    }
    return !0;
  }
  const g = d.pos === c.end() ? p.contentMatchAt(0).defaultType : null, m = {
    ...Vd(h, p.type.name, p.attrs),
    ...t
  }, b = {
    ...Vd(h, c.node().type.name, c.node().attrs),
    ...t
  };
  n.delete(c.pos, d.pos);
  const C = g ? [
    { type: a, attrs: m },
    { type: g, attrs: b }
  ] : [{ type: a, attrs: m }];
  if (!El(n.doc, c.pos, 2))
    return !1;
  if (r) {
    const { selection: x, storedMarks: v } = o, { splittableMarks: S } = i.extensionManager, M = v || x.$to.parentOffset && x.$from.marks();
    if (n.split(c.pos, 2, C).scrollIntoView(), !M || !r)
      return !0;
    const w = M.filter((k) => S.includes(k.type.name));
    n.ensureMarks(w);
  }
  return !0;
}, rp = (e, t) => {
  const n = O8((s) => s.type === t)(e.selection);
  if (!n)
    return !0;
  const o = e.doc.resolve(Math.max(0, n.pos - 1)).before(n.depth);
  if (o === void 0)
    return !0;
  const r = e.doc.nodeAt(o);
  return n.node.type === (r == null ? void 0 : r.type) && Ps(e.doc, n.pos) && e.join(n.pos), !0;
}, ip = (e, t) => {
  const n = O8((s) => s.type === t)(e.selection);
  if (!n)
    return !0;
  const o = e.doc.resolve(n.start).after(n.depth);
  if (o === void 0)
    return !0;
  const r = e.doc.nodeAt(o);
  return n.node.type === (r == null ? void 0 : r.type) && Ps(e.doc, o) && e.join(o), !0;
}, X7e = (e, t, n, o = {}) => ({ editor: r, tr: i, state: s, dispatch: a, chain: c, commands: d, can: u }) => {
  const { extensions: p, splittableMarks: h } = r.extensionManager, g = qn(e, s.schema), m = qn(t, s.schema), { selection: b, storedMarks: C } = s, { $from: x, $to: v } = b, S = x.blockRange(v), M = C || b.$to.parentOffset && b.$from.marks();
  if (!S)
    return !1;
  const w = O8((k) => Yx(k.type.name, p))(b);
  if (S.depth >= 1 && w && S.depth - w.depth <= 1) {
    if (w.node.type === g)
      return d.liftListItem(m);
    if (Yx(w.node.type.name, p) && g.validContent(w.node.content) && a)
      return c().command(() => (i.setNodeMarkup(w.pos, g), !0)).command(() => rp(i, g)).command(() => ip(i, g)).run();
  }
  return !n || !M || !a ? c().command(() => u().wrapInList(g, o) ? !0 : d.clearNodes()).wrapInList(g, o).command(() => rp(i, g)).command(() => ip(i, g)).run() : c().command(() => {
    const k = u().wrapInList(g, o), E = M.filter((R) => h.includes(R.type.name));
    return i.ensureMarks(E), k ? !0 : d.clearNodes();
  }).wrapInList(g, o).command(() => rp(i, g)).command(() => ip(i, g)).run();
}, J7e = (e, t = {}, n = {}) => ({ state: o, commands: r }) => {
  const { extendEmptyMarkRange: i = !1 } = n, s = Is(e, o.schema);
  return B5(o, s, t) ? r.unsetMark(s, { extendEmptyMarkRange: i }) : r.setMark(s, t);
}, Q7e = (e, t, n = {}) => ({ state: o, commands: r }) => {
  const i = qn(e, o.schema), s = qn(t, o.schema), a = c0(o, i, n);
  let c;
  return o.selection.$anchor.sameParent(o.selection.$head) && (c = o.selection.$anchor.parent.attrs), a ? r.setNode(s, c) : r.setNode(i, { ...c, ...n });
}, ehe = (e, t = {}) => ({ state: n, commands: o }) => {
  const r = qn(e, n.schema);
  return c0(n, r, t) ? o.lift(r) : o.wrapIn(r, t);
}, the = () => ({ state: e, dispatch: t }) => {
  const n = e.plugins;
  for (let o = 0; o < n.length; o += 1) {
    const r = n[o];
    let i;
    if (r.spec.isInputRules && (i = r.getState(e))) {
      if (t) {
        const s = e.tr, a = i.transform;
        for (let c = a.steps.length - 1; c >= 0; c -= 1)
          s.step(a.steps[c].invert(a.docs[c]));
        if (i.text) {
          const c = s.doc.resolve(i.from).marks();
          s.replaceWith(i.from, i.to, e.schema.text(i.text, c));
        } else
          s.delete(i.from, i.to);
      }
      return !0;
    }
  }
  return !1;
}, nhe = () => ({ tr: e, dispatch: t }) => {
  const { selection: n } = e, { empty: o, ranges: r } = n;
  return o || t && r.forEach((i) => {
    e.removeMark(i.$from.pos, i.$to.pos);
  }), !0;
}, ohe = (e, t = {}) => ({ tr: n, state: o, dispatch: r }) => {
  var i;
  const { extendEmptyMarkRange: s = !1 } = t, { selection: a } = n, c = Is(e, o.schema), { $from: d, empty: u, ranges: p } = a;
  if (!r)
    return !0;
  if (u && s) {
    let { from: h, to: g } = a;
    const m = (i = d.marks().find((C) => C.type === c)) === null || i === void 0 ? void 0 : i.attrs, b = R8(d, c, m);
    b && (h = b.from, g = b.to), n.removeMark(h, g, c);
  } else
    p.forEach((h) => {
      n.removeMark(h.$from.pos, h.$to.pos, c);
    });
  return n.removeStoredMark(c), !0;
}, rhe = (e, t = {}) => ({ tr: n, state: o, dispatch: r }) => {
  let i = null, s = null;
  const a = Sf(typeof e == "string" ? e : e.name, o.schema);
  return a ? (a === "node" && (i = qn(e, o.schema)), a === "mark" && (s = Is(e, o.schema)), r && n.selection.ranges.forEach((c) => {
    const d = c.$from.pos, u = c.$to.pos;
    let p, h, g, m;
    n.selection.empty ? o.doc.nodesBetween(d, u, (b, C) => {
      i && i === b.type && (g = Math.max(C, d), m = Math.min(C + b.nodeSize, u), p = C, h = b);
    }) : o.doc.nodesBetween(d, u, (b, C) => {
      C < d && i && i === b.type && (g = Math.max(C, d), m = Math.min(C + b.nodeSize, u), p = C, h = b), C >= d && C <= u && (i && i === b.type && n.setNodeMarkup(C, void 0, {
        ...b.attrs,
        ...t
      }), s && b.marks.length && b.marks.forEach((x) => {
        if (s === x.type) {
          const v = Math.max(C, d), S = Math.min(C + b.nodeSize, u);
          n.addMark(v, S, s.create({
            ...x.attrs,
            ...t
          }));
        }
      }));
    }), h && (p !== void 0 && n.setNodeMarkup(p, void 0, {
      ...h.attrs,
      ...t
    }), s && h.marks.length && h.marks.forEach((b) => {
      s === b.type && n.addMark(g, m, s.create({
        ...b.attrs,
        ...t
      }));
    }));
  }), !0) : !1;
}, ihe = (e, t = {}) => ({ state: n, dispatch: o }) => {
  const r = qn(e, n.schema);
  return C4e(r, t)(n, o);
}, she = (e, t = {}) => ({ state: n, dispatch: o }) => {
  const r = qn(e, n.schema);
  return x4e(r, t)(n, o);
};
var ahe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: B4e,
  clearContent: z4e,
  clearNodes: Z4e,
  command: W4e,
  createParagraphNear: U4e,
  cut: G4e,
  deleteCurrentNode: q4e,
  deleteNode: K4e,
  deleteRange: Y4e,
  deleteSelection: X4e,
  enter: J4e,
  exitCode: Q4e,
  extendMarkRange: e7e,
  first: t7e,
  focus: n7e,
  forEach: o7e,
  insertContent: r7e,
  insertContentAt: a7e,
  joinBackward: d7e,
  joinDown: c7e,
  joinForward: u7e,
  joinItemBackward: f7e,
  joinItemForward: p7e,
  joinTextblockBackward: h7e,
  joinTextblockForward: g7e,
  joinUp: l7e,
  keyboardShortcut: b7e,
  lift: C7e,
  liftEmptyBlock: x7e,
  liftListItem: y7e,
  newlineInCode: v7e,
  resetAttributes: w7e,
  scrollIntoView: S7e,
  selectAll: M7e,
  selectNodeBackward: T7e,
  selectNodeForward: k7e,
  selectParentNode: E7e,
  selectTextblockEnd: R7e,
  selectTextblockStart: O7e,
  setContent: _7e,
  setMark: z7e,
  setMeta: Z7e,
  setNode: W7e,
  setNodeSelection: U7e,
  setTextSelection: G7e,
  sinkListItem: q7e,
  splitBlock: K7e,
  splitListItem: Y7e,
  toggleList: X7e,
  toggleMark: J7e,
  toggleNode: Q7e,
  toggleWrap: ehe,
  undoInputRule: the,
  unsetAllMarks: nhe,
  unsetMark: ohe,
  updateAttributes: rhe,
  wrapIn: ihe,
  wrapInList: she
});
const lhe = Rn.create({
  name: "commands",
  addCommands() {
    return {
      ...ahe
    };
  }
}), che = Rn.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new Kn({
        key: new No("tiptapDrop"),
        props: {
          handleDrop: (e, t, n, o) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: t,
              slice: n,
              moved: o
            });
          }
        }
      })
    ];
  }
}), dhe = Rn.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Kn({
        key: new No("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), uhe = Rn.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: e } = this;
    return [
      new Kn({
        key: new No("focusEvents"),
        props: {
          handleDOMEvents: {
            focus: (t, n) => {
              e.isFocused = !0;
              const o = e.state.tr.setMeta("focus", { event: n }).setMeta("addToHistory", !1);
              return t.dispatch(o), !1;
            },
            blur: (t, n) => {
              e.isFocused = !1;
              const o = e.state.tr.setMeta("blur", { event: n }).setMeta("addToHistory", !1);
              return t.dispatch(o), !1;
            }
          }
        }
      })
    ];
  }
}), fhe = Rn.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const e = () => this.editor.commands.first(({ commands: s }) => [
      () => s.undoInputRule(),
      // maybe convert first text block node to default node
      () => s.command(({ tr: a }) => {
        const { selection: c, doc: d } = a, { empty: u, $anchor: p } = c, { pos: h, parent: g } = p, m = p.parent.isTextblock && h > 0 ? a.doc.resolve(h - 1) : p, b = m.parent.type.spec.isolating, C = p.pos - p.parentOffset, x = b && m.parent.childCount === 1 ? C === p.pos : Mt.atStart(d).from === h;
        return !u || !g.type.isTextblock || g.textContent.length || !x || x && p.parent.type.name === "paragraph" ? !1 : s.clearNodes();
      }),
      () => s.deleteSelection(),
      () => s.joinBackward(),
      () => s.selectNodeBackward()
    ]), t = () => this.editor.commands.first(({ commands: s }) => [
      () => s.deleteSelection(),
      () => s.deleteCurrentNode(),
      () => s.joinForward(),
      () => s.selectNodeForward()
    ]), o = {
      Enter: () => this.editor.commands.first(({ commands: s }) => [
        () => s.newlineInCode(),
        () => s.createParagraphNear(),
        () => s.liftEmptyBlock(),
        () => s.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: e,
      "Mod-Backspace": e,
      "Shift-Backspace": e,
      Delete: t,
      "Mod-Delete": t,
      "Mod-a": () => this.editor.commands.selectAll()
    }, r = {
      ...o
    }, i = {
      ...o,
      "Ctrl-h": e,
      "Alt-Backspace": e,
      "Ctrl-d": t,
      "Ctrl-Alt-Backspace": t,
      "Alt-Delete": t,
      "Alt-d": t,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return jO() || VO() ? i : r;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Kn({
        key: new No("clearDocument"),
        appendTransaction: (e, t, n) => {
          const o = e.some((b) => b.docChanged) && !t.doc.eq(n.doc), r = e.some((b) => b.getMeta("preventClearDocument"));
          if (!o || r)
            return;
          const { empty: i, from: s, to: a } = t.selection, c = Mt.atStart(t.doc).from, d = Mt.atEnd(t.doc).to;
          if (i || !(s === c && a === d) || !Mf(n.doc))
            return;
          const h = n.tr, g = Cf({
            state: n,
            transaction: h
          }), { commands: m } = new xf({
            editor: this.editor,
            state: g
          });
          if (m.clearNodes(), !!h.steps.length)
            return h;
        }
      })
    ];
  }
}), phe = Rn.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new Kn({
        key: new No("tiptapPaste"),
        props: {
          handlePaste: (e, t, n) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: t,
              slice: n
            });
          }
        }
      })
    ];
  }
}), hhe = Rn.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new Kn({
        key: new No("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
class Ys {
  get name() {
    return this.node.type.name;
  }
  constructor(t, n, o = !1, r = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = o, this.resolvedPos = t, this.editor = n, this.currentNode = r;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var t;
    return (t = this.actualDepth) !== null && t !== void 0 ? t : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(t) {
    let n = this.from, o = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      n = this.from + 1, o = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: n, to: o }, t);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const t = this.resolvedPos.start(this.resolvedPos.depth - 1), n = this.resolvedPos.doc.resolve(t);
    return new Ys(n, this.editor);
  }
  get before() {
    let t = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return t.depth !== this.depth && (t = this.resolvedPos.doc.resolve(this.from - 3)), new Ys(t, this.editor);
  }
  get after() {
    let t = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return t.depth !== this.depth && (t = this.resolvedPos.doc.resolve(this.to + 3)), new Ys(t, this.editor);
  }
  get children() {
    const t = [];
    return this.node.content.forEach((n, o) => {
      const r = n.isBlock && !n.isTextblock, i = n.isAtom && !n.isText, s = this.pos + o + (i ? 0 : 1), a = this.resolvedPos.doc.resolve(s);
      if (!r && a.depth <= this.depth)
        return;
      const c = new Ys(a, this.editor, r, r ? n : null);
      r && (c.actualDepth = this.depth + 1), t.push(new Ys(a, this.editor, r, r ? n : null));
    }), t;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const t = this.children;
    return t[t.length - 1] || null;
  }
  closest(t, n = {}) {
    let o = null, r = this.parent;
    for (; r && !o; ) {
      if (r.node.type.name === t)
        if (Object.keys(n).length > 0) {
          const i = r.node.attrs, s = Object.keys(n);
          for (let a = 0; a < s.length; a += 1) {
            const c = s[a];
            if (i[c] !== n[c])
              break;
          }
        } else
          o = r;
      r = r.parent;
    }
    return o;
  }
  querySelector(t, n = {}) {
    return this.querySelectorAll(t, n, !0)[0] || null;
  }
  querySelectorAll(t, n = {}, o = !1) {
    let r = [];
    if (!this.children || this.children.length === 0)
      return r;
    const i = Object.keys(n);
    return this.children.forEach((s) => {
      o && r.length > 0 || (s.node.type.name === t && i.every((c) => n[c] === s.node.attrs[c]) && r.push(s), !(o && r.length > 0) && (r = r.concat(s.querySelectorAll(t, n, o))));
    }), r;
  }
  setAttribute(t) {
    const { tr: n } = this.editor.state;
    n.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...t
    }), this.editor.view.dispatch(n);
  }
}
const ghe = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function mhe(e, t, n) {
  const o = document.querySelector("style[data-tiptap-style]");
  if (o !== null)
    return o;
  const r = document.createElement("style");
  return t && r.setAttribute("nonce", t), r.setAttribute("data-tiptap-style", ""), r.innerHTML = e, document.getElementsByTagName("head")[0].appendChild(r), r;
}
class bhe extends k4e {
  constructor(t = {}) {
    super(), this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: n }) => {
        throw n;
      },
      onPaste: () => null,
      onDrop: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(t), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("contentError", this.options.onContentError), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: n, slice: o, moved: r }) => this.options.onDrop(n, o, r)), this.on("paste", ({ event: n, slice: o }) => this.options.onPaste(n, o)), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && document && (this.css = mhe(ghe, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(t = {}) {
    this.options = {
      ...this.options,
      ...t
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(t, n = !0) {
    this.setOptions({ editable: t }), n && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(t, n) {
    const o = EO(n) ? n(t, [...this.state.plugins]) : [...this.state.plugins, t], r = this.state.reconfigure({ plugins: o });
    return this.view.updateState(r), r;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(t) {
    if (this.isDestroyed)
      return;
    const n = this.state.plugins;
    let o = n;
    if ([].concat(t).forEach((i) => {
      const s = typeof i == "string" ? `${i}$` : i.key;
      o = n.filter((a) => !a.key.startsWith(s));
    }), n.length === o.length)
      return;
    const r = this.state.reconfigure({
      plugins: o
    });
    return this.view.updateState(r), r;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var t, n;
    const r = [...this.options.enableCoreExtensions ? [
      dhe,
      $4e.configure({
        blockSeparator: (n = (t = this.options.coreExtensionOptions) === null || t === void 0 ? void 0 : t.clipboardTextSerializer) === null || n === void 0 ? void 0 : n.blockSeparator
      }),
      lhe,
      uhe,
      fhe,
      hhe,
      che,
      phe
    ].filter((i) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[i.name] !== !1 : !0) : [], ...this.options.extensions].filter((i) => ["extension", "node", "mark"].includes(i == null ? void 0 : i.type));
    this.extensionManager = new gl(r, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new xf({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    var t;
    let n;
    try {
      n = $5(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
    } catch (s) {
      if (!(s instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(s.message))
        throw s;
      this.emit("contentError", {
        editor: this,
        error: s,
        disableCollaboration: () => {
          this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((a) => a.name !== "collaboration"), this.createExtensionManager();
        }
      }), n = $5(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: !1 });
    }
    const o = LO(n, this.options.autofocus);
    this.view = new Z5e(this.options.element, {
      ...this.options.editorProps,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...(t = this.options.editorProps) === null || t === void 0 ? void 0 : t.attributes
      },
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: hl.create({
        doc: n,
        selection: o || void 0
      })
    });
    const r = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(r), this.createNodeViews(), this.prependClass();
    const i = this.view.dom;
    i.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(t) {
    this.isCapturingTransaction = !0, t(), this.isCapturingTransaction = !1;
    const n = this.capturedTransaction;
    return this.capturedTransaction = null, n;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(t) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = t;
        return;
      }
      t.steps.forEach((s) => {
        var a;
        return (a = this.capturedTransaction) === null || a === void 0 ? void 0 : a.step(s);
      });
      return;
    }
    const n = this.state.apply(t), o = !this.state.selection.eq(n.selection);
    this.emit("beforeTransaction", {
      editor: this,
      transaction: t,
      nextState: n
    }), this.view.updateState(n), this.emit("transaction", {
      editor: this,
      transaction: t
    }), o && this.emit("selectionUpdate", {
      editor: this,
      transaction: t
    });
    const r = t.getMeta("focus"), i = t.getMeta("blur");
    r && this.emit("focus", {
      editor: this,
      event: r.event,
      transaction: t
    }), i && this.emit("blur", {
      editor: this,
      event: i.event,
      transaction: t
    }), !(!t.docChanged || t.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: t
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(t) {
    return AO(this.state, t);
  }
  isActive(t, n) {
    const o = typeof t == "string" ? t : null, r = typeof t == "string" ? n : t;
    return N7e(this.state, o, r);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return k8(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(t) {
    const { blockSeparator: n = `

`, textSerializers: o = {} } = t || {};
    return V7e(this.state.doc, {
      blockSeparator: n,
      textSerializers: {
        ...OO(this.schema),
        ...o
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return Mf(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    if (this.emit("destroy"), this.view) {
      const t = this.view.dom;
      t && t.editor && delete t.editor, this.view.destroy();
    }
    this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var t;
    return !(!((t = this.view) === null || t === void 0) && t.docView);
  }
  $node(t, n) {
    var o;
    return ((o = this.$doc) === null || o === void 0 ? void 0 : o.querySelector(t, n)) || null;
  }
  $nodes(t, n) {
    var o;
    return ((o = this.$doc) === null || o === void 0 ? void 0 : o.querySelectorAll(t, n)) || null;
  }
  $pos(t) {
    const n = this.state.doc.resolve(t);
    return new Ys(n, this);
  }
  get $doc() {
    return this.$pos(0);
  }
}
function ql(e) {
  return new vf({
    find: e.find,
    handler: ({ state: t, range: n, match: o }) => {
      const r = Ot(e.getAttributes, void 0, o);
      if (r === !1 || r === null)
        return null;
      const { tr: i } = t, s = o[o.length - 1], a = o[0];
      if (s) {
        const c = a.search(/\S/), d = n.from + a.indexOf(s), u = d + s.length;
        if (_8(n.from, n.to, t.doc).filter((g) => g.mark.type.excluded.find((b) => b === e.type && b !== g.mark.type)).filter((g) => g.to > d).length)
          return null;
        u < n.to && i.delete(u, n.to), d > n.from && i.delete(n.from + c, d);
        const h = n.from + c + s.length;
        i.addMark(n.from + c, h, e.type.create(r || {})), i.removeStoredMark(e.type);
      }
    }
  });
}
function HO(e) {
  return new vf({
    find: e.find,
    handler: ({ state: t, range: n, match: o }) => {
      const r = Ot(e.getAttributes, void 0, o) || {}, { tr: i } = t, s = n.from;
      let a = n.to;
      const c = e.type.create(r);
      if (o[1]) {
        const d = o[0].lastIndexOf(o[1]);
        let u = s + d;
        u > a ? u = a : a = u + o[1].length;
        const p = o[0][o[0].length - 1];
        i.insertText(p, s + o[0].length - 1), i.replaceWith(u, a, c);
      } else if (o[0]) {
        const d = e.type.isInline ? s : s - 1;
        i.insert(d, e.type.create(r)).delete(i.mapping.map(s), i.mapping.map(a));
      }
      i.scrollIntoView();
    }
  });
}
function z5(e) {
  return new vf({
    find: e.find,
    handler: ({ state: t, range: n, match: o }) => {
      const r = t.doc.resolve(n.from), i = Ot(e.getAttributes, void 0, o) || {};
      if (!r.node(-1).canReplaceWith(r.index(-1), r.indexAfter(-1), e.type))
        return null;
      t.tr.delete(n.from, n.to).setBlockType(n.from, n.from, e.type, i);
    }
  });
}
function d0(e) {
  return new vf({
    find: e.find,
    handler: ({ state: t, range: n, match: o, chain: r }) => {
      const i = Ot(e.getAttributes, void 0, o) || {}, s = t.tr.delete(n.from, n.to), c = s.doc.resolve(n.from).blockRange(), d = c && h8(c, e.type, i);
      if (!d)
        return null;
      if (s.wrap(c, d), e.keepMarks && e.editor) {
        const { selection: p, storedMarks: h } = t, { splittableMarks: g } = e.editor.extensionManager, m = h || p.$to.parentOffset && p.$from.marks();
        if (m) {
          const b = m.filter((C) => g.includes(C.type.name));
          s.ensureMarks(b);
        }
      }
      if (e.keepAttributes) {
        const p = e.type.name === "bulletList" || e.type.name === "orderedList" ? "listItem" : "taskList";
        r().updateAttributes(p, i).run();
      }
      const u = s.doc.resolve(n.from - 1).nodeBefore;
      u && u.type === e.type && Ps(s.doc, n.from - 1) && (!e.joinPredicate || e.joinPredicate(o, u)) && s.join(n.from - 1);
    }
  });
}
class mo {
  constructor(t = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...t
    }, this.name = this.config.name, t.defaultOptions && Object.keys(t.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ot(it(this, "addOptions", {
      name: this.name
    }))), this.storage = Ot(it(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(t = {}) {
    return new mo(t);
  }
  configure(t = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => wf(this.options, t)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(t = {}) {
    const n = new mo(t);
    return n.parent = this, this.child = n, n.name = t.name ? t.name : n.parent.name, t.defaultOptions && Object.keys(t.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Ot(it(n, "addOptions", {
      name: n.name
    })), n.storage = Ot(it(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
}
function _a(e) {
  return new V4e({
    find: e.find,
    handler: ({ state: t, range: n, match: o, pasteEvent: r }) => {
      const i = Ot(e.getAttributes, void 0, o, r);
      if (i === !1 || i === null)
        return null;
      const { tr: s } = t, a = o[o.length - 1], c = o[0];
      let d = n.to;
      if (a) {
        const u = c.search(/\S/), p = n.from + c.indexOf(a), h = p + a.length;
        if (_8(n.from, n.to, t.doc).filter((m) => m.mark.type.excluded.find((C) => C === e.type && C !== m.mark.type)).filter((m) => m.to > p).length)
          return null;
        h < n.to && s.delete(h, n.to), p > n.from && s.delete(n.from + u, p), d = n.from + u + a.length, s.addMark(n.from + u, d, e.type.create(i || {})), s.removeStoredMark(e.type);
      }
    }
  });
}
function Che(e) {
  return e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Z5 = { exports: {} }, sp = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jx;
function xhe() {
  if (Jx) return sp;
  Jx = 1;
  var e = Nt;
  function t(p, h) {
    return p === h && (p !== 0 || 1 / p === 1 / h) || p !== p && h !== h;
  }
  var n = typeof Object.is == "function" ? Object.is : t, o = e.useState, r = e.useEffect, i = e.useLayoutEffect, s = e.useDebugValue;
  function a(p, h) {
    var g = h(), m = o({ inst: { value: g, getSnapshot: h } }), b = m[0].inst, C = m[1];
    return i(function() {
      b.value = g, b.getSnapshot = h, c(b) && C({ inst: b });
    }, [p, g, h]), r(function() {
      return c(b) && C({ inst: b }), p(function() {
        c(b) && C({ inst: b });
      });
    }, [p]), s(g), g;
  }
  function c(p) {
    var h = p.getSnapshot;
    p = p.value;
    try {
      var g = h();
      return !n(p, g);
    } catch {
      return !0;
    }
  }
  function d(p, h) {
    return h();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? d : a;
  return sp.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, sp;
}
var ap = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qx;
function yhe() {
  return Qx || (Qx = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = Nt, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(S) {
      {
        for (var M = arguments.length, w = new Array(M > 1 ? M - 1 : 0), k = 1; k < M; k++)
          w[k - 1] = arguments[k];
        o("error", S, w);
      }
    }
    function o(S, M, w) {
      {
        var k = t.ReactDebugCurrentFrame, E = k.getStackAddendum();
        E !== "" && (M += "%s", w = w.concat([E]));
        var R = w.map(function(O) {
          return String(O);
        });
        R.unshift("Warning: " + M), Function.prototype.apply.call(console[S], console, R);
      }
    }
    function r(S, M) {
      return S === M && (S !== 0 || 1 / S === 1 / M) || S !== S && M !== M;
    }
    var i = typeof Object.is == "function" ? Object.is : r, s = e.useState, a = e.useEffect, c = e.useLayoutEffect, d = e.useDebugValue, u = !1, p = !1;
    function h(S, M, w) {
      u || e.startTransition !== void 0 && (u = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var k = M();
      if (!p) {
        var E = M();
        i(k, E) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), p = !0);
      }
      var R = s({
        inst: {
          value: k,
          getSnapshot: M
        }
      }), O = R[0].inst, P = R[1];
      return c(function() {
        O.value = k, O.getSnapshot = M, g(O) && P({
          inst: O
        });
      }, [S, k, M]), a(function() {
        g(O) && P({
          inst: O
        });
        var _ = function() {
          g(O) && P({
            inst: O
          });
        };
        return S(_);
      }, [S]), d(k), k;
    }
    function g(S) {
      var M = S.getSnapshot, w = S.value;
      try {
        var k = M();
        return !i(w, k);
      } catch {
        return !0;
      }
    }
    function m(S, M, w) {
      return M();
    }
    var b = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", C = !b, x = C ? m : h, v = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : x;
    ap.useSyncExternalStore = v, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), ap;
}
process.env.NODE_ENV === "production" ? Z5.exports = xhe() : Z5.exports = yhe();
var Tf = Z5.exports;
const vhe = (...e) => (t) => {
  e.forEach((n) => {
    typeof n == "function" ? n(t) : n && (n.current = t);
  });
}, whe = ({ contentComponent: e }) => {
  const t = Tf.useSyncExternalStore(e.subscribe, e.getSnapshot, e.getServerSnapshot);
  return Nt.createElement(Nt.Fragment, null, Object.values(t));
};
function She() {
  const e = /* @__PURE__ */ new Set();
  let t = {};
  return {
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(n) {
      return e.add(n), () => {
        e.delete(n);
      };
    },
    getSnapshot() {
      return t;
    },
    getServerSnapshot() {
      return t;
    },
    /**
     * Adds a new NodeView Renderer to the editor.
     */
    setRenderer(n, o) {
      t = {
        ...t,
        [n]: B2.createPortal(o.reactElement, o.element, n)
      }, e.forEach((r) => r());
    },
    /**
     * Removes a NodeView Renderer from the editor.
     */
    removeRenderer(n) {
      const o = { ...t };
      delete o[n], t = o, e.forEach((r) => r());
    }
  };
}
class Mhe extends Nt.Component {
  constructor(t) {
    var n;
    super(t), this.editorContentRef = Nt.createRef(), this.initialized = !1, this.state = {
      hasContentComponentInitialized: !!(!((n = t.editor) === null || n === void 0) && n.contentComponent)
    };
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate() {
    this.init();
  }
  init() {
    const t = this.props.editor;
    if (t && !t.isDestroyed && t.options.element) {
      if (t.contentComponent)
        return;
      const n = this.editorContentRef.current;
      n.append(...t.options.element.childNodes), t.setOptions({
        element: n
      }), t.contentComponent = She(), this.state.hasContentComponentInitialized || (this.unsubscribeToContentComponent = t.contentComponent.subscribe(() => {
        this.setState((o) => o.hasContentComponentInitialized ? o : {
          hasContentComponentInitialized: !0
        }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent();
      })), t.createNodeViews(), this.initialized = !0;
    }
  }
  componentWillUnmount() {
    const t = this.props.editor;
    if (!t || (this.initialized = !1, t.isDestroyed || t.view.setProps({
      nodeViews: {}
    }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent(), t.contentComponent = null, !t.options.element.firstChild))
      return;
    const n = document.createElement("div");
    n.append(...t.options.element.childNodes), t.setOptions({
      element: n
    });
  }
  render() {
    const { editor: t, innerRef: n, ...o } = this.props;
    return Nt.createElement(
      Nt.Fragment,
      null,
      Nt.createElement("div", { ref: vhe(n, this.editorContentRef), ...o }),
      (t == null ? void 0 : t.contentComponent) && Nt.createElement(whe, { contentComponent: t.contentComponent })
    );
  }
}
const The = vs((e, t) => {
  const n = Nt.useMemo(() => Math.floor(Math.random() * 4294967295).toString(), [e.editor]);
  return Nt.createElement(Mhe, {
    key: n,
    innerRef: t,
    ...e
  });
}), khe = Nt.memo(The);
var Ehe = function e(t, n) {
  if (t === n) return !0;
  if (t && n && typeof t == "object" && typeof n == "object") {
    if (t.constructor !== n.constructor) return !1;
    var o, r, i;
    if (Array.isArray(t)) {
      if (o = t.length, o != n.length) return !1;
      for (r = o; r-- !== 0; )
        if (!e(t[r], n[r])) return !1;
      return !0;
    }
    if (t instanceof Map && n instanceof Map) {
      if (t.size !== n.size) return !1;
      for (r of t.entries())
        if (!n.has(r[0])) return !1;
      for (r of t.entries())
        if (!e(r[1], n.get(r[0]))) return !1;
      return !0;
    }
    if (t instanceof Set && n instanceof Set) {
      if (t.size !== n.size) return !1;
      for (r of t.entries())
        if (!n.has(r[0])) return !1;
      return !0;
    }
    if (ArrayBuffer.isView(t) && ArrayBuffer.isView(n)) {
      if (o = t.length, o != n.length) return !1;
      for (r = o; r-- !== 0; )
        if (t[r] !== n[r]) return !1;
      return !0;
    }
    if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
    if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
    if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
    if (i = Object.keys(t), o = i.length, o !== Object.keys(n).length) return !1;
    for (r = o; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, i[r])) return !1;
    for (r = o; r-- !== 0; ) {
      var s = i[r];
      if (!(s === "_owner" && t.$$typeof) && !e(t[s], n[s]))
        return !1;
    }
    return !0;
  }
  return t !== t && n !== n;
}, Rhe = /* @__PURE__ */ Che(Ehe), W5 = { exports: {} }, lp = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ey;
function Ohe() {
  if (ey) return lp;
  ey = 1;
  var e = Nt, t = Tf;
  function n(d, u) {
    return d === u && (d !== 0 || 1 / d === 1 / u) || d !== d && u !== u;
  }
  var o = typeof Object.is == "function" ? Object.is : n, r = t.useSyncExternalStore, i = e.useRef, s = e.useEffect, a = e.useMemo, c = e.useDebugValue;
  return lp.useSyncExternalStoreWithSelector = function(d, u, p, h, g) {
    var m = i(null);
    if (m.current === null) {
      var b = { hasValue: !1, value: null };
      m.current = b;
    } else b = m.current;
    m = a(function() {
      function x(k) {
        if (!v) {
          if (v = !0, S = k, k = h(k), g !== void 0 && b.hasValue) {
            var E = b.value;
            if (g(E, k)) return M = E;
          }
          return M = k;
        }
        if (E = M, o(S, k)) return E;
        var R = h(k);
        return g !== void 0 && g(E, R) ? E : (S = k, M = R);
      }
      var v = !1, S, M, w = p === void 0 ? null : p;
      return [function() {
        return x(u());
      }, w === null ? void 0 : function() {
        return x(w());
      }];
    }, [u, p, h, g]);
    var C = r(d, m[0], m[1]);
    return s(function() {
      b.hasValue = !0, b.value = C;
    }, [C]), c(C), C;
  }, lp;
}
var cp = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ty;
function _he() {
  return ty || (ty = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = Nt, t = Tf;
    function n(u, p) {
      return u === p && (u !== 0 || 1 / u === 1 / p) || u !== u && p !== p;
    }
    var o = typeof Object.is == "function" ? Object.is : n, r = t.useSyncExternalStore, i = e.useRef, s = e.useEffect, a = e.useMemo, c = e.useDebugValue;
    function d(u, p, h, g, m) {
      var b = i(null), C;
      b.current === null ? (C = {
        hasValue: !1,
        value: null
      }, b.current = C) : C = b.current;
      var x = a(function() {
        var w = !1, k, E, R = function(L) {
          if (!w) {
            w = !0, k = L;
            var V = g(L);
            if (m !== void 0 && C.hasValue) {
              var j = C.value;
              if (m(j, V))
                return E = j, j;
            }
            return E = V, V;
          }
          var I = k, F = E;
          if (o(I, L))
            return F;
          var $ = g(L);
          return m !== void 0 && m(F, $) ? F : (k = L, E = $, $);
        }, O = h === void 0 ? null : h, P = function() {
          return R(p());
        }, _ = O === null ? void 0 : function() {
          return R(O());
        };
        return [P, _];
      }, [p, h, g, m]), v = x[0], S = x[1], M = r(u, v, S);
      return s(function() {
        C.hasValue = !0, C.value = M;
      }, [M]), c(M), M;
    }
    cp.useSyncExternalStoreWithSelector = d, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), cp;
}
process.env.NODE_ENV === "production" ? W5.exports = Ohe() : W5.exports = _he();
var Phe = W5.exports;
const Lhe = typeof window < "u" ? S_ : mt;
class Ihe {
  constructor(t) {
    this.transactionNumber = 0, this.lastTransactionNumber = 0, this.subscribers = /* @__PURE__ */ new Set(), this.editor = t, this.lastSnapshot = { editor: t, transactionNumber: 0 }, this.getSnapshot = this.getSnapshot.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.watch = this.watch.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  /**
   * Get the current editor instance.
   */
  getSnapshot() {
    return this.transactionNumber === this.lastTransactionNumber ? this.lastSnapshot : (this.lastTransactionNumber = this.transactionNumber, this.lastSnapshot = { editor: this.editor, transactionNumber: this.transactionNumber }, this.lastSnapshot);
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return { editor: null, transactionNumber: 0 };
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(t) {
    return this.subscribers.add(t), () => {
      this.subscribers.delete(t);
    };
  }
  /**
   * Watch the editor instance for changes.
   */
  watch(t) {
    if (this.editor = t, this.editor) {
      const n = () => {
        this.transactionNumber += 1, this.subscribers.forEach((r) => r());
      }, o = this.editor;
      return o.on("transaction", n), () => {
        o.off("transaction", n);
      };
    }
  }
}
function jhe(e) {
  var t;
  const [n] = Ae(() => new Ihe(e.editor)), o = Phe.useSyncExternalStoreWithSelector(n.subscribe, n.getSnapshot, n.getServerSnapshot, e.selector, (t = e.equalityFn) !== null && t !== void 0 ? t : Rhe);
  return Lhe(() => n.watch(e.editor), [e.editor, n]), Ty(o), o;
}
const ny = process.env.NODE_ENV !== "production", U5 = typeof window > "u", Vhe = U5 || !!(typeof window < "u" && window.next);
class Dhe {
  constructor(t) {
    this.editor = null, this.subscriptions = /* @__PURE__ */ new Set(), this.isComponentMounted = !1, this.previousDeps = null, this.instanceId = "", this.options = t, this.subscriptions = /* @__PURE__ */ new Set(), this.setEditor(this.getInitialEditor()), this.scheduleDestroy(), this.getEditor = this.getEditor.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.subscribe = this.subscribe.bind(this), this.refreshEditorInstance = this.refreshEditorInstance.bind(this), this.scheduleDestroy = this.scheduleDestroy.bind(this), this.onRender = this.onRender.bind(this), this.createEditor = this.createEditor.bind(this);
  }
  setEditor(t) {
    this.editor = t, this.instanceId = Math.random().toString(36).slice(2, 9), this.subscriptions.forEach((n) => n());
  }
  getInitialEditor() {
    if (this.options.current.immediatelyRender === void 0)
      return U5 || Vhe ? (ny && console.warn("Tiptap Error: SSR has been detected, please set `immediatelyRender` explicitly to `false` to avoid hydration mismatches."), null) : this.createEditor();
    if (this.options.current.immediatelyRender && U5 && ny)
      throw new Error("Tiptap Error: SSR has been detected, and `immediatelyRender` has been set to `true` this is an unsupported configuration that may result in errors, explicitly set `immediatelyRender` to `false` to avoid hydration mismatches.");
    return this.options.current.immediatelyRender ? this.createEditor() : null;
  }
  /**
   * Create a new editor instance. And attach event listeners.
   */
  createEditor() {
    const t = {
      ...this.options.current,
      // Always call the most recent version of the callback function by default
      onBeforeCreate: (...o) => {
        var r, i;
        return (i = (r = this.options.current).onBeforeCreate) === null || i === void 0 ? void 0 : i.call(r, ...o);
      },
      onBlur: (...o) => {
        var r, i;
        return (i = (r = this.options.current).onBlur) === null || i === void 0 ? void 0 : i.call(r, ...o);
      },
      onCreate: (...o) => {
        var r, i;
        return (i = (r = this.options.current).onCreate) === null || i === void 0 ? void 0 : i.call(r, ...o);
      },
      onDestroy: (...o) => {
        var r, i;
        return (i = (r = this.options.current).onDestroy) === null || i === void 0 ? void 0 : i.call(r, ...o);
      },
      onFocus: (...o) => {
        var r, i;
        return (i = (r = this.options.current).onFocus) === null || i === void 0 ? void 0 : i.call(r, ...o);
      },
      onSelectionUpdate: (...o) => {
        var r, i;
        return (i = (r = this.options.current).onSelectionUpdate) === null || i === void 0 ? void 0 : i.call(r, ...o);
      },
      onTransaction: (...o) => {
        var r, i;
        return (i = (r = this.options.current).onTransaction) === null || i === void 0 ? void 0 : i.call(r, ...o);
      },
      onUpdate: (...o) => {
        var r, i;
        return (i = (r = this.options.current).onUpdate) === null || i === void 0 ? void 0 : i.call(r, ...o);
      },
      onContentError: (...o) => {
        var r, i;
        return (i = (r = this.options.current).onContentError) === null || i === void 0 ? void 0 : i.call(r, ...o);
      },
      onDrop: (...o) => {
        var r, i;
        return (i = (r = this.options.current).onDrop) === null || i === void 0 ? void 0 : i.call(r, ...o);
      },
      onPaste: (...o) => {
        var r, i;
        return (i = (r = this.options.current).onPaste) === null || i === void 0 ? void 0 : i.call(r, ...o);
      }
    };
    return new bhe(t);
  }
  /**
   * Get the current editor instance.
   */
  getEditor() {
    return this.editor;
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return null;
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(t) {
    return this.subscriptions.add(t), () => {
      this.subscriptions.delete(t);
    };
  }
  /**
   * On each render, we will create, update, or destroy the editor instance.
   * @param deps The dependencies to watch for changes
   * @returns A cleanup function
   */
  onRender(t) {
    return () => (this.isComponentMounted = !0, clearTimeout(this.scheduledDestructionTimeout), this.editor && !this.editor.isDestroyed && t.length === 0 ? this.editor.setOptions({
      ...this.options.current,
      editable: this.editor.isEditable
    }) : this.refreshEditorInstance(t), () => {
      this.isComponentMounted = !1, this.scheduleDestroy();
    });
  }
  /**
   * Recreate the editor instance if the dependencies have changed.
   */
  refreshEditorInstance(t) {
    if (this.editor && !this.editor.isDestroyed) {
      if (this.previousDeps === null) {
        this.previousDeps = t;
        return;
      }
      if (this.previousDeps.length === t.length && this.previousDeps.every((o, r) => o === t[r]))
        return;
    }
    this.editor && !this.editor.isDestroyed && this.editor.destroy(), this.setEditor(this.createEditor()), this.previousDeps = t;
  }
  /**
   * Schedule the destruction of the editor instance.
   * This will only destroy the editor if it was not mounted on the next tick.
   * This is to avoid destroying the editor instance when it's actually still mounted.
   */
  scheduleDestroy() {
    const t = this.instanceId, n = this.editor;
    this.scheduledDestructionTimeout = setTimeout(() => {
      if (this.isComponentMounted && this.instanceId === t) {
        n && n.setOptions(this.options.current);
        return;
      }
      n && !n.isDestroyed && (n.destroy(), this.instanceId === t && this.setEditor(null));
    }, 1);
  }
}
function Ahe(e = {}, t = []) {
  const n = St(e);
  n.current = e;
  const [o] = Ae(() => new Dhe(n)), r = Tf.useSyncExternalStore(o.subscribe, o.getEditor, o.getServerSnapshot);
  return Ty(r), mt(o.onRender(t)), jhe({
    editor: r,
    selector: ({ transactionNumber: i }) => e.shouldRerenderOnTransaction === !1 ? null : e.immediatelyRender && i === 0 ? 0 : i + 1
  }), r;
}
const Hhe = h0({
  editor: null
});
Hhe.Consumer;
const Fhe = h0({
  onDragStart: void 0
}), Nhe = () => p0(Fhe);
Nt.forwardRef((e, t) => {
  const { onDragStart: n } = Nhe(), o = e.as || "div";
  return (
    // @ts-ignore
    Nt.createElement(o, { ...e, ref: t, "data-node-view-wrapper": "", onDragStart: n, style: {
      whiteSpace: "normal",
      ...e.style
    } })
  );
});
const $he = /^\s*>\s$/, Bhe = mo.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [
      { tag: "blockquote" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["blockquote", _n(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: e }) => e.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: e }) => e.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: e }) => e.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      d0({
        find: $he,
        type: this.type
      })
    ];
  }
}), zhe = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, Zhe = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, Whe = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, Uhe = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, Ghe = Sr.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (e) => e.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (e) => e.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (e) => /^(bold(er)?|[5-9]\d{2,})$/.test(e) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["strong", _n(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: e }) => e.setMark(this.name),
      toggleBold: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetBold: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      ql({
        find: zhe,
        type: this.type
      }),
      ql({
        find: Whe,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      _a({
        find: Zhe,
        type: this.type
      }),
      _a({
        find: Uhe,
        type: this.type
      })
    ];
  }
}), qhe = "listItem", oy = "textStyle", ry = /^\s*([-+*])\s$/, Khe = mo.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["ul", _n(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: e, chain: t }) => this.options.keepAttributes ? t().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(qhe, this.editor.getAttributes(oy)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let e = d0({
      find: ry,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = d0({
      find: ry,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(oy),
      editor: this.editor
    })), [
      e
    ];
  }
}), Yhe = /(^|[^`])`([^`]+)`(?!`)/, Xhe = /(^|[^`])`([^`]+)`(?!`)/g, Jhe = Sr.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [
      { tag: "code" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["code", _n(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setCode: () => ({ commands: e }) => e.setMark(this.name),
      toggleCode: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetCode: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      ql({
        find: Yhe,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      _a({
        find: Xhe,
        type: this.type
      })
    ];
  }
}), Qhe = /^```([a-z]+)?[\s\n]$/, e8e = /^~~~([a-z]+)?[\s\n]$/, t8e = mo.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (e) => {
          var t;
          const { languageClassPrefix: n } = this.options, i = [...((t = e.firstElementChild) === null || t === void 0 ? void 0 : t.classList) || []].filter((s) => s.startsWith(n)).map((s) => s.replace(n, ""))[0];
          return i || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    return [
      "pre",
      _n(this.options.HTMLAttributes, t),
      [
        "code",
        {
          class: e.attrs.language ? this.options.languageClassPrefix + e.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (e) => ({ commands: t }) => t.setNode(this.name, e),
      toggleCodeBlock: (e) => ({ commands: t }) => t.toggleNode(this.name, "paragraph", e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: e, $anchor: t } = this.editor.state.selection, n = t.pos === 1;
        return !e || t.parent.type.name !== this.name ? !1 : n || !t.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: e }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: t } = e, { selection: n } = t, { $from: o, empty: r } = n;
        if (!r || o.parent.type !== this.type)
          return !1;
        const i = o.parentOffset === o.parent.nodeSize - 2, s = o.parent.textContent.endsWith(`

`);
        return !i || !s ? !1 : e.chain().command(({ tr: a }) => (a.delete(o.pos - 2, o.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: e }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: t } = e, { selection: n, doc: o } = t, { $from: r, empty: i } = n;
        if (!i || r.parent.type !== this.type || !(r.parentOffset === r.parent.nodeSize - 2))
          return !1;
        const a = r.after();
        return a === void 0 ? !1 : o.nodeAt(a) ? e.commands.command(({ tr: d }) => (d.setSelection(Mt.near(o.resolve(a))), !0)) : e.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      z5({
        find: Qhe,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      }),
      z5({
        find: e8e,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new Kn({
        key: new No("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (e, t) => {
            if (!t.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const n = t.clipboardData.getData("text/plain"), o = t.clipboardData.getData("vscode-editor-data"), r = o ? JSON.parse(o) : void 0, i = r == null ? void 0 : r.mode;
            if (!n || !i)
              return !1;
            const { tr: s, schema: a } = e.state, c = a.text(n.replace(/\r\n?/g, `
`));
            return s.replaceSelectionWith(this.type.create({ language: i }, c)), s.selection.$from.parent.type !== this.type && s.setSelection(xt.near(s.doc.resolve(Math.max(0, s.selection.from - 2)))), s.setMeta("paste", !0), e.dispatch(s), !0;
          }
        }
      })
    ];
  }
}), n8e = mo.create({
  name: "doc",
  topNode: !0,
  content: "block+"
});
function o8e(e = {}) {
  return new Kn({
    view(t) {
      return new r8e(t, e);
    }
  });
}
class r8e {
  constructor(t, n) {
    var o;
    this.editorView = t, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (o = n.width) !== null && o !== void 0 ? o : 1, this.color = n.color === !1 ? void 0 : n.color || "black", this.class = n.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((r) => {
      let i = (s) => {
        this[r](s);
      };
      return t.dom.addEventListener(r, i), { name: r, handler: i };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: t, handler: n }) => this.editorView.dom.removeEventListener(t, n));
  }
  update(t, n) {
    this.cursorPos != null && n.doc != t.state.doc && (this.cursorPos > t.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(t) {
    t != this.cursorPos && (this.cursorPos = t, t == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let t = this.editorView.state.doc.resolve(this.cursorPos), n = !t.parent.inlineContent, o;
    if (n) {
      let a = t.nodeBefore, c = t.nodeAfter;
      if (a || c) {
        let d = this.editorView.nodeDOM(this.cursorPos - (a ? a.nodeSize : 0));
        if (d) {
          let u = d.getBoundingClientRect(), p = a ? u.bottom : u.top;
          a && c && (p = (p + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2), o = { left: u.left, right: u.right, top: p - this.width / 2, bottom: p + this.width / 2 };
        }
      }
    }
    if (!o) {
      let a = this.editorView.coordsAtPos(this.cursorPos);
      o = { left: a.left - this.width / 2, right: a.left + this.width / 2, top: a.top, bottom: a.bottom };
    }
    let r = this.editorView.dom.offsetParent;
    this.element || (this.element = r.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", n), this.element.classList.toggle("prosemirror-dropcursor-inline", !n);
    let i, s;
    if (!r || r == document.body && getComputedStyle(r).position == "static")
      i = -pageXOffset, s = -pageYOffset;
    else {
      let a = r.getBoundingClientRect();
      i = a.left - r.scrollLeft, s = a.top - r.scrollTop;
    }
    this.element.style.left = o.left - i + "px", this.element.style.top = o.top - s + "px", this.element.style.width = o.right - o.left + "px", this.element.style.height = o.bottom - o.top + "px";
  }
  scheduleRemoval(t) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), t);
  }
  dragover(t) {
    if (!this.editorView.editable)
      return;
    let n = this.editorView.posAtCoords({ left: t.clientX, top: t.clientY }), o = n && n.inside >= 0 && this.editorView.state.doc.nodeAt(n.inside), r = o && o.type.spec.disableDropCursor, i = typeof r == "function" ? r(this.editorView, n, t) : r;
    if (n && !i) {
      let s = n.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let a = PR(this.editorView.state.doc, s, this.editorView.dragging.slice);
        a != null && (s = a);
      }
      this.setCursor(s), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(t) {
    (t.target == this.editorView.dom || !this.editorView.dom.contains(t.relatedTarget)) && this.setCursor(null);
  }
}
const i8e = Rn.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      o8e(this.options)
    ];
  }
});
class Tn extends Mt {
  /**
  Create a gap cursor.
  */
  constructor(t) {
    super(t, t);
  }
  map(t, n) {
    let o = t.resolve(n.map(this.head));
    return Tn.valid(o) ? new Tn(o) : Mt.near(o);
  }
  content() {
    return et.empty;
  }
  eq(t) {
    return t instanceof Tn && t.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new Tn(t.resolve(n.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new P8(this.anchor);
  }
  /**
  @internal
  */
  static valid(t) {
    let n = t.parent;
    if (n.isTextblock || !s8e(t) || !a8e(t))
      return !1;
    let o = n.type.spec.allowGapCursor;
    if (o != null)
      return o;
    let r = n.contentMatchAt(t.index()).defaultType;
    return r && r.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(t, n, o = !1) {
    e: for (; ; ) {
      if (!o && Tn.valid(t))
        return t;
      let r = t.pos, i = null;
      for (let s = t.depth; ; s--) {
        let a = t.node(s);
        if (n > 0 ? t.indexAfter(s) < a.childCount : t.index(s) > 0) {
          i = a.child(n > 0 ? t.indexAfter(s) : t.index(s) - 1);
          break;
        } else if (s == 0)
          return null;
        r += n;
        let c = t.doc.resolve(r);
        if (Tn.valid(c))
          return c;
      }
      for (; ; ) {
        let s = n > 0 ? i.firstChild : i.lastChild;
        if (!s) {
          if (i.isAtom && !i.isText && !ut.isSelectable(i)) {
            t = t.doc.resolve(r + i.nodeSize * n), o = !1;
            continue e;
          }
          break;
        }
        i = s, r += n;
        let a = t.doc.resolve(r);
        if (Tn.valid(a))
          return a;
      }
      return null;
    }
  }
}
Tn.prototype.visible = !1;
Tn.findFrom = Tn.findGapCursorFrom;
Mt.jsonID("gapcursor", Tn);
class P8 {
  constructor(t) {
    this.pos = t;
  }
  map(t) {
    return new P8(t.map(this.pos));
  }
  resolve(t) {
    let n = t.resolve(this.pos);
    return Tn.valid(n) ? new Tn(n) : Mt.near(n);
  }
}
function s8e(e) {
  for (let t = e.depth; t >= 0; t--) {
    let n = e.index(t), o = e.node(t);
    if (n == 0) {
      if (o.type.spec.isolating)
        return !0;
      continue;
    }
    for (let r = o.child(n - 1); ; r = r.lastChild) {
      if (r.childCount == 0 && !r.inlineContent || r.isAtom || r.type.spec.isolating)
        return !0;
      if (r.inlineContent)
        return !1;
    }
  }
  return !0;
}
function a8e(e) {
  for (let t = e.depth; t >= 0; t--) {
    let n = e.indexAfter(t), o = e.node(t);
    if (n == o.childCount) {
      if (o.type.spec.isolating)
        return !0;
      continue;
    }
    for (let r = o.child(n); ; r = r.firstChild) {
      if (r.childCount == 0 && !r.inlineContent || r.isAtom || r.type.spec.isolating)
        return !0;
      if (r.inlineContent)
        return !1;
    }
  }
  return !0;
}
function l8e() {
  return new Kn({
    props: {
      decorations: f8e,
      createSelectionBetween(e, t, n) {
        return t.pos == n.pos && Tn.valid(n) ? new Tn(n) : null;
      },
      handleClick: d8e,
      handleKeyDown: c8e,
      handleDOMEvents: { beforeinput: u8e }
    }
  });
}
const c8e = xO({
  ArrowLeft: Q1("horiz", -1),
  ArrowRight: Q1("horiz", 1),
  ArrowUp: Q1("vert", -1),
  ArrowDown: Q1("vert", 1)
});
function Q1(e, t) {
  const n = e == "vert" ? t > 0 ? "down" : "up" : t > 0 ? "right" : "left";
  return function(o, r, i) {
    let s = o.selection, a = t > 0 ? s.$to : s.$from, c = s.empty;
    if (s instanceof xt) {
      if (!i.endOfTextblock(n) || a.depth == 0)
        return !1;
      c = !1, a = o.doc.resolve(t > 0 ? a.after() : a.before());
    }
    let d = Tn.findGapCursorFrom(a, t, c);
    return d ? (r && r(o.tr.setSelection(new Tn(d))), !0) : !1;
  };
}
function d8e(e, t, n) {
  if (!e || !e.editable)
    return !1;
  let o = e.state.doc.resolve(t);
  if (!Tn.valid(o))
    return !1;
  let r = e.posAtCoords({ left: n.clientX, top: n.clientY });
  return r && r.inside > -1 && ut.isSelectable(e.state.doc.nodeAt(r.inside)) ? !1 : (e.dispatch(e.state.tr.setSelection(new Tn(o))), !0);
}
function u8e(e, t) {
  if (t.inputType != "insertCompositionText" || !(e.state.selection instanceof Tn))
    return !1;
  let { $from: n } = e.state.selection, o = n.parent.contentMatchAt(n.index()).findWrapping(e.state.schema.nodes.text);
  if (!o)
    return !1;
  let r = je.empty;
  for (let s = o.length - 1; s >= 0; s--)
    r = je.from(o[s].createAndFill(null, r));
  let i = e.state.tr.replace(n.pos, n.pos, new et(r, 0, 0));
  return i.setSelection(xt.near(i.doc.resolve(n.pos + 1))), e.dispatch(i), !1;
}
function f8e(e) {
  if (!(e.selection instanceof Tn))
    return null;
  let t = document.createElement("div");
  return t.className = "ProseMirror-gapcursor", jn.create(e.doc, [Yo.widget(e.selection.head, t, { key: "gapcursor" })]);
}
const p8e = Rn.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [
      l8e()
    ];
  },
  extendNodeSchema(e) {
    var t;
    const n = {
      name: e.name,
      options: e.options,
      storage: e.storage
    };
    return {
      allowGapCursor: (t = Ot(it(e, "allowGapCursor", n))) !== null && t !== void 0 ? t : null
    };
  }
}), h8e = mo.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["br", _n(this.options.HTMLAttributes, e)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: e, chain: t, state: n, editor: o }) => e.first([
        () => e.exitCode(),
        () => e.command(() => {
          const { selection: r, storedMarks: i } = n;
          if (r.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: s } = this.options, { splittableMarks: a } = o.extensionManager, c = i || r.$to.parentOffset && r.$from.marks();
          return t().insertContent({ type: this.name }).command(({ tr: d, dispatch: u }) => {
            if (u && c && s) {
              const p = c.filter((h) => a.includes(h.type.name));
              d.ensureMarks(p);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), g8e = mo.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((e) => ({
      tag: `h${e}`,
      attrs: { level: e }
    }));
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    return [`h${this.options.levels.includes(e.attrs.level) ? e.attrs.level : this.options.levels[0]}`, _n(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setHeading: (e) => ({ commands: t }) => this.options.levels.includes(e.level) ? t.setNode(this.name, e) : !1,
      toggleHeading: (e) => ({ commands: t }) => this.options.levels.includes(e.level) ? t.toggleNode(this.name, "paragraph", e) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((e, t) => ({
      ...e,
      [`Mod-Alt-${t}`]: () => this.editor.commands.toggleHeading({ level: t })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((e) => z5({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${e}})\\s$`),
      type: this.type,
      getAttributes: {
        level: e
      }
    }));
  }
});
var Ru = 200, Gn = function() {
};
Gn.prototype.append = function(t) {
  return t.length ? (t = Gn.from(t), !this.length && t || t.length < Ru && this.leafAppend(t) || this.length < Ru && t.leafPrepend(this) || this.appendInner(t)) : this;
};
Gn.prototype.prepend = function(t) {
  return t.length ? Gn.from(t).append(this) : this;
};
Gn.prototype.appendInner = function(t) {
  return new m8e(this, t);
};
Gn.prototype.slice = function(t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = this.length), t >= n ? Gn.empty : this.sliceInner(Math.max(0, t), Math.min(this.length, n));
};
Gn.prototype.get = function(t) {
  if (!(t < 0 || t >= this.length))
    return this.getInner(t);
};
Gn.prototype.forEach = function(t, n, o) {
  n === void 0 && (n = 0), o === void 0 && (o = this.length), n <= o ? this.forEachInner(t, n, o, 0) : this.forEachInvertedInner(t, n, o, 0);
};
Gn.prototype.map = function(t, n, o) {
  n === void 0 && (n = 0), o === void 0 && (o = this.length);
  var r = [];
  return this.forEach(function(i, s) {
    return r.push(t(i, s));
  }, n, o), r;
};
Gn.from = function(t) {
  return t instanceof Gn ? t : t && t.length ? new FO(t) : Gn.empty;
};
var FO = /* @__PURE__ */ function(e) {
  function t(o) {
    e.call(this), this.values = o;
  }
  t.__proto__ = e, t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
  var n = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return t.prototype.flatten = function() {
    return this.values;
  }, t.prototype.sliceInner = function(r, i) {
    return r == 0 && i == this.length ? this : new t(this.values.slice(r, i));
  }, t.prototype.getInner = function(r) {
    return this.values[r];
  }, t.prototype.forEachInner = function(r, i, s, a) {
    for (var c = i; c < s; c++)
      if (r(this.values[c], a + c) === !1)
        return !1;
  }, t.prototype.forEachInvertedInner = function(r, i, s, a) {
    for (var c = i - 1; c >= s; c--)
      if (r(this.values[c], a + c) === !1)
        return !1;
  }, t.prototype.leafAppend = function(r) {
    if (this.length + r.length <= Ru)
      return new t(this.values.concat(r.flatten()));
  }, t.prototype.leafPrepend = function(r) {
    if (this.length + r.length <= Ru)
      return new t(r.flatten().concat(this.values));
  }, n.length.get = function() {
    return this.values.length;
  }, n.depth.get = function() {
    return 0;
  }, Object.defineProperties(t.prototype, n), t;
}(Gn);
Gn.empty = new FO([]);
var m8e = /* @__PURE__ */ function(e) {
  function t(n, o) {
    e.call(this), this.left = n, this.right = o, this.length = n.length + o.length, this.depth = Math.max(n.depth, o.depth) + 1;
  }
  return t.__proto__ = e, t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, t.prototype.getInner = function(o) {
    return o < this.left.length ? this.left.get(o) : this.right.get(o - this.left.length);
  }, t.prototype.forEachInner = function(o, r, i, s) {
    var a = this.left.length;
    if (r < a && this.left.forEachInner(o, r, Math.min(i, a), s) === !1 || i > a && this.right.forEachInner(o, Math.max(r - a, 0), Math.min(this.length, i) - a, s + a) === !1)
      return !1;
  }, t.prototype.forEachInvertedInner = function(o, r, i, s) {
    var a = this.left.length;
    if (r > a && this.right.forEachInvertedInner(o, r - a, Math.max(i, a) - a, s + a) === !1 || i < a && this.left.forEachInvertedInner(o, Math.min(r, a), i, s) === !1)
      return !1;
  }, t.prototype.sliceInner = function(o, r) {
    if (o == 0 && r == this.length)
      return this;
    var i = this.left.length;
    return r <= i ? this.left.slice(o, r) : o >= i ? this.right.slice(o - i, r - i) : this.left.slice(o, i).append(this.right.slice(0, r - i));
  }, t.prototype.leafAppend = function(o) {
    var r = this.right.leafAppend(o);
    if (r)
      return new t(this.left, r);
  }, t.prototype.leafPrepend = function(o) {
    var r = this.left.leafPrepend(o);
    if (r)
      return new t(r, this.right);
  }, t.prototype.appendInner = function(o) {
    return this.left.depth >= Math.max(this.right.depth, o.depth) + 1 ? new t(this.left, new t(this.right, o)) : new t(this, o);
  }, t;
}(Gn);
const b8e = 500;
class Rr {
  constructor(t, n) {
    this.items = t, this.eventCount = n;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(t, n) {
    if (this.eventCount == 0)
      return null;
    let o = this.items.length;
    for (; ; o--)
      if (this.items.get(o - 1).selection) {
        --o;
        break;
      }
    let r, i;
    n && (r = this.remapping(o, this.items.length), i = r.maps.length);
    let s = t.tr, a, c, d = [], u = [];
    return this.items.forEach((p, h) => {
      if (!p.step) {
        r || (r = this.remapping(o, h + 1), i = r.maps.length), i--, u.push(p);
        return;
      }
      if (r) {
        u.push(new zr(p.map));
        let g = p.step.map(r.slice(i)), m;
        g && s.maybeStep(g).doc && (m = s.mapping.maps[s.mapping.maps.length - 1], d.push(new zr(m, void 0, void 0, d.length + u.length))), i--, m && r.appendMap(m, i);
      } else
        s.maybeStep(p.step);
      if (p.selection)
        return a = r ? p.selection.map(r.slice(i)) : p.selection, c = new Rr(this.items.slice(0, o).append(u.reverse().concat(d)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: c, transform: s, selection: a };
  }
  // Create a new branch with the given transform added.
  addTransform(t, n, o, r) {
    let i = [], s = this.eventCount, a = this.items, c = !r && a.length ? a.get(a.length - 1) : null;
    for (let u = 0; u < t.steps.length; u++) {
      let p = t.steps[u].invert(t.docs[u]), h = new zr(t.mapping.maps[u], p, n), g;
      (g = c && c.merge(h)) && (h = g, u ? i.pop() : a = a.slice(0, a.length - 1)), i.push(h), n && (s++, n = void 0), r || (c = h);
    }
    let d = s - o.depth;
    return d > x8e && (a = C8e(a, d), s -= d), new Rr(a.append(i), s);
  }
  remapping(t, n) {
    let o = new kl();
    return this.items.forEach((r, i) => {
      let s = r.mirrorOffset != null && i - r.mirrorOffset >= t ? o.maps.length - r.mirrorOffset : void 0;
      o.appendMap(r.map, s);
    }, t, n), o;
  }
  addMaps(t) {
    return this.eventCount == 0 ? this : new Rr(this.items.append(t.map((n) => new zr(n))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(t, n) {
    if (!this.eventCount)
      return this;
    let o = [], r = Math.max(0, this.items.length - n), i = t.mapping, s = t.steps.length, a = this.eventCount;
    this.items.forEach((h) => {
      h.selection && a--;
    }, r);
    let c = n;
    this.items.forEach((h) => {
      let g = i.getMirror(--c);
      if (g == null)
        return;
      s = Math.min(s, g);
      let m = i.maps[g];
      if (h.step) {
        let b = t.steps[g].invert(t.docs[g]), C = h.selection && h.selection.map(i.slice(c + 1, g));
        C && a++, o.push(new zr(m, b, C));
      } else
        o.push(new zr(m));
    }, r);
    let d = [];
    for (let h = n; h < s; h++)
      d.push(new zr(i.maps[h]));
    let u = this.items.slice(0, r).append(d).append(o), p = new Rr(u, a);
    return p.emptyItemCount() > b8e && (p = p.compress(this.items.length - o.length)), p;
  }
  emptyItemCount() {
    let t = 0;
    return this.items.forEach((n) => {
      n.step || t++;
    }), t;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(t = this.items.length) {
    let n = this.remapping(0, t), o = n.maps.length, r = [], i = 0;
    return this.items.forEach((s, a) => {
      if (a >= t)
        r.push(s), s.selection && i++;
      else if (s.step) {
        let c = s.step.map(n.slice(o)), d = c && c.getMap();
        if (o--, d && n.appendMap(d, o), c) {
          let u = s.selection && s.selection.map(n.slice(o));
          u && i++;
          let p = new zr(d.invert(), c, u), h, g = r.length - 1;
          (h = r.length && r[g].merge(p)) ? r[g] = h : r.push(p);
        }
      } else s.map && o--;
    }, this.items.length, 0), new Rr(Gn.from(r.reverse()), i);
  }
}
Rr.empty = new Rr(Gn.empty, 0);
function C8e(e, t) {
  let n;
  return e.forEach((o, r) => {
    if (o.selection && t-- == 0)
      return n = r, !1;
  }), e.slice(n);
}
class zr {
  constructor(t, n, o, r) {
    this.map = t, this.step = n, this.selection = o, this.mirrorOffset = r;
  }
  merge(t) {
    if (this.step && t.step && !t.selection) {
      let n = t.step.merge(this.step);
      if (n)
        return new zr(n.getMap().invert(), n, this.selection);
    }
  }
}
class Wi {
  constructor(t, n, o, r, i) {
    this.done = t, this.undone = n, this.prevRanges = o, this.prevTime = r, this.prevComposition = i;
  }
}
const x8e = 20;
function y8e(e, t, n, o) {
  let r = n.getMeta(ga), i;
  if (r)
    return r.historyState;
  n.getMeta(S8e) && (e = new Wi(e.done, e.undone, null, 0, -1));
  let s = n.getMeta("appendedTransaction");
  if (n.steps.length == 0)
    return e;
  if (s && s.getMeta(ga))
    return s.getMeta(ga).redo ? new Wi(e.done.addTransform(n, void 0, o, Dd(t)), e.undone, iy(n.mapping.maps), e.prevTime, e.prevComposition) : new Wi(e.done, e.undone.addTransform(n, void 0, o, Dd(t)), null, e.prevTime, e.prevComposition);
  if (n.getMeta("addToHistory") !== !1 && !(s && s.getMeta("addToHistory") === !1)) {
    let a = n.getMeta("composition"), c = e.prevTime == 0 || !s && e.prevComposition != a && (e.prevTime < (n.time || 0) - o.newGroupDelay || !v8e(n, e.prevRanges)), d = s ? dp(e.prevRanges, n.mapping) : iy(n.mapping.maps);
    return new Wi(e.done.addTransform(n, c ? t.selection.getBookmark() : void 0, o, Dd(t)), Rr.empty, d, n.time, a ?? e.prevComposition);
  } else return (i = n.getMeta("rebased")) ? new Wi(e.done.rebased(n, i), e.undone.rebased(n, i), dp(e.prevRanges, n.mapping), e.prevTime, e.prevComposition) : new Wi(e.done.addMaps(n.mapping.maps), e.undone.addMaps(n.mapping.maps), dp(e.prevRanges, n.mapping), e.prevTime, e.prevComposition);
}
function v8e(e, t) {
  if (!t)
    return !1;
  if (!e.docChanged)
    return !0;
  let n = !1;
  return e.mapping.maps[0].forEach((o, r) => {
    for (let i = 0; i < t.length; i += 2)
      o <= t[i + 1] && r >= t[i] && (n = !0);
  }), n;
}
function iy(e) {
  let t = [];
  for (let n = e.length - 1; n >= 0 && t.length == 0; n--)
    e[n].forEach((o, r, i, s) => t.push(i, s));
  return t;
}
function dp(e, t) {
  if (!e)
    return null;
  let n = [];
  for (let o = 0; o < e.length; o += 2) {
    let r = t.map(e[o], 1), i = t.map(e[o + 1], -1);
    r <= i && n.push(r, i);
  }
  return n;
}
function w8e(e, t, n) {
  let o = Dd(t), r = ga.get(t).spec.config, i = (n ? e.undone : e.done).popEvent(t, o);
  if (!i)
    return null;
  let s = i.selection.resolve(i.transform.doc), a = (n ? e.done : e.undone).addTransform(i.transform, t.selection.getBookmark(), r, o), c = new Wi(n ? a : i.remaining, n ? i.remaining : a, null, 0, -1);
  return i.transform.setSelection(s).setMeta(ga, { redo: n, historyState: c });
}
let up = !1, sy = null;
function Dd(e) {
  let t = e.plugins;
  if (sy != t) {
    up = !1, sy = t;
    for (let n = 0; n < t.length; n++)
      if (t[n].spec.historyPreserveItems) {
        up = !0;
        break;
      }
  }
  return up;
}
const ga = new No("history"), S8e = new No("closeHistory");
function M8e(e = {}) {
  return e = {
    depth: e.depth || 100,
    newGroupDelay: e.newGroupDelay || 500
  }, new Kn({
    key: ga,
    state: {
      init() {
        return new Wi(Rr.empty, Rr.empty, null, 0, -1);
      },
      apply(t, n, o) {
        return y8e(n, o, t, e);
      }
    },
    config: e,
    props: {
      handleDOMEvents: {
        beforeinput(t, n) {
          let o = n.inputType, r = o == "historyUndo" ? $O : o == "historyRedo" ? BO : null;
          return r ? (n.preventDefault(), r(t.state, t.dispatch)) : !1;
        }
      }
    }
  });
}
function NO(e, t) {
  return (n, o) => {
    let r = ga.getState(n);
    if (!r || (e ? r.undone : r.done).eventCount == 0)
      return !1;
    if (o) {
      let i = w8e(r, n, e);
      i && o(t ? i.scrollIntoView() : i);
    }
    return !0;
  };
}
const $O = NO(!1, !0), BO = NO(!0, !0), T8e = Rn.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: e, dispatch: t }) => $O(e, t),
      redo: () => ({ state: e, dispatch: t }) => BO(e, t)
    };
  },
  addProseMirrorPlugins() {
    return [
      M8e(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), zO = mo.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["hr", _n(this.options.HTMLAttributes, e)];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: e, state: t }) => {
        const { selection: n } = t, { $from: o, $to: r } = n, i = e();
        return o.parentOffset === 0 ? i.insertContentAt({
          from: Math.max(o.pos - 1, 0),
          to: r.pos
        }, {
          type: this.name
        }) : $7e(n) ? i.insertContentAt(r.pos, {
          type: this.name
        }) : i.insertContent({ type: this.name }), i.command(({ tr: s, dispatch: a }) => {
          var c;
          if (a) {
            const { $to: d } = s.selection, u = d.end();
            if (d.nodeAfter)
              d.nodeAfter.isTextblock ? s.setSelection(xt.create(s.doc, d.pos + 1)) : d.nodeAfter.isBlock ? s.setSelection(ut.create(s.doc, d.pos)) : s.setSelection(xt.create(s.doc, d.pos));
            else {
              const p = (c = d.parent.type.contentMatch.defaultType) === null || c === void 0 ? void 0 : c.create();
              p && (s.insert(u, p), s.setSelection(xt.create(s.doc, u + 1)));
            }
            s.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      HO({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), k8e = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, E8e = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, R8e = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, O8e = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, _8e = Sr.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (e) => e.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (e) => e.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["em", _n(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: e }) => e.setMark(this.name),
      toggleItalic: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetItalic: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      ql({
        find: k8e,
        type: this.type
      }),
      ql({
        find: R8e,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      _a({
        find: E8e,
        type: this.type
      }),
      _a({
        find: O8e,
        type: this.type
      })
    ];
  }
}), P8e = mo.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["li", _n(this.options.HTMLAttributes, e), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), L8e = "listItem", ay = "textStyle", ly = /^(\d+)\.\s$/, I8e = mo.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (e) => e.hasAttribute("start") ? parseInt(e.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: void 0,
        parseHTML: (e) => e.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    const { start: t, ...n } = e;
    return t === 1 ? ["ol", _n(this.options.HTMLAttributes, n), 0] : ["ol", _n(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: e, chain: t }) => this.options.keepAttributes ? t().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(L8e, this.editor.getAttributes(ay)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let e = d0({
      find: ly,
      type: this.type,
      getAttributes: (t) => ({ start: +t[1] }),
      joinPredicate: (t, n) => n.childCount + n.attrs.start === +t[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = d0({
      find: ly,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (t) => ({ start: +t[1], ...this.editor.getAttributes(ay) }),
      joinPredicate: (t, n) => n.childCount + n.attrs.start === +t[1],
      editor: this.editor
    })), [
      e
    ];
  }
}), j8e = mo.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["p", _n(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: e }) => e.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), V8e = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, D8e = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, A8e = Sr.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["s", _n(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: e }) => e.setMark(this.name),
      toggleStrike: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetStrike: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      ql({
        find: V8e,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      _a({
        find: D8e,
        type: this.type
      })
    ];
  }
}), H8e = mo.create({
  name: "text",
  group: "inline"
}), F8e = Rn.create({
  name: "starterKit",
  addExtensions() {
    var e, t, n, o, r, i, s, a, c, d, u, p, h, g, m, b, C, x;
    const v = [];
    return this.options.bold !== !1 && v.push(Ghe.configure((e = this.options) === null || e === void 0 ? void 0 : e.bold)), this.options.blockquote !== !1 && v.push(Bhe.configure((t = this.options) === null || t === void 0 ? void 0 : t.blockquote)), this.options.bulletList !== !1 && v.push(Khe.configure((n = this.options) === null || n === void 0 ? void 0 : n.bulletList)), this.options.code !== !1 && v.push(Jhe.configure((o = this.options) === null || o === void 0 ? void 0 : o.code)), this.options.codeBlock !== !1 && v.push(t8e.configure((r = this.options) === null || r === void 0 ? void 0 : r.codeBlock)), this.options.document !== !1 && v.push(n8e.configure((i = this.options) === null || i === void 0 ? void 0 : i.document)), this.options.dropcursor !== !1 && v.push(i8e.configure((s = this.options) === null || s === void 0 ? void 0 : s.dropcursor)), this.options.gapcursor !== !1 && v.push(p8e.configure((a = this.options) === null || a === void 0 ? void 0 : a.gapcursor)), this.options.hardBreak !== !1 && v.push(h8e.configure((c = this.options) === null || c === void 0 ? void 0 : c.hardBreak)), this.options.heading !== !1 && v.push(g8e.configure((d = this.options) === null || d === void 0 ? void 0 : d.heading)), this.options.history !== !1 && v.push(T8e.configure((u = this.options) === null || u === void 0 ? void 0 : u.history)), this.options.horizontalRule !== !1 && v.push(zO.configure((p = this.options) === null || p === void 0 ? void 0 : p.horizontalRule)), this.options.italic !== !1 && v.push(_8e.configure((h = this.options) === null || h === void 0 ? void 0 : h.italic)), this.options.listItem !== !1 && v.push(P8e.configure((g = this.options) === null || g === void 0 ? void 0 : g.listItem)), this.options.orderedList !== !1 && v.push(I8e.configure((m = this.options) === null || m === void 0 ? void 0 : m.orderedList)), this.options.paragraph !== !1 && v.push(j8e.configure((b = this.options) === null || b === void 0 ? void 0 : b.paragraph)), this.options.strike !== !1 && v.push(A8e.configure((C = this.options) === null || C === void 0 ? void 0 : C.strike)), this.options.text !== !1 && v.push(H8e.configure((x = this.options) === null || x === void 0 ? void 0 : x.text)), v;
  }
}), N8e = Rn.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (e) => {
              const t = e.style.textAlign;
              return this.options.alignments.includes(t) ? t : this.options.defaultAlignment;
            },
            renderHTML: (e) => e.textAlign ? { style: `text-align: ${e.textAlign}` } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (e) => ({ commands: t }) => this.options.alignments.includes(e) ? this.options.types.map((n) => t.updateAttributes(n, { textAlign: e })).every((n) => n) : !1,
      unsetTextAlign: () => ({ commands: e }) => this.options.types.map((t) => e.resetAttributes(t, "textAlign")).every((t) => t)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), $8e = (e) => {
  if (!e.children.length)
    return;
  const t = e.querySelectorAll("span");
  t && t.forEach((n) => {
    var o, r;
    const i = n.getAttribute("style"), s = (r = (o = n.parentElement) === null || o === void 0 ? void 0 : o.closest("span")) === null || r === void 0 ? void 0 : r.getAttribute("style");
    n.setAttribute("style", `${s};${i}`);
  });
}, B8e = Sr.create({
  name: "textStyle",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      mergeNestedSpanStyles: !1
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (e) => e.hasAttribute("style") ? (this.options.mergeNestedSpanStyles && $8e(e), {}) : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", _n(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ tr: e }) => {
        const { selection: t } = e;
        return e.doc.nodesBetween(t.from, t.to, (n, o) => {
          if (n.isTextblock)
            return !0;
          n.marks.filter((r) => r.type === this.type).some((r) => Object.values(r.attrs).some((i) => !!i)) || e.removeMark(o, o + n.nodeSize, this.type);
        }), !0;
      }
    };
  }
}), z8e = Rn.create({
  name: "fontFamily",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            parseHTML: (e) => e.style.fontFamily,
            renderHTML: (e) => e.fontFamily ? {
              style: `font-family: ${e.fontFamily}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontFamily: (e) => ({ chain: t }) => t().setMark("textStyle", { fontFamily: e }).run(),
      unsetFontFamily: () => ({ chain: e }) => e().setMark("textStyle", { fontFamily: null }).removeEmptyTextStyle().run()
    };
  }
}), Z8e = Sr.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["u", _n(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: e }) => e.setMark(this.name),
      toggleUnderline: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetUnderline: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
}), W8e = Rn.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    return [
      new Kn({
        key: new No("placeholder"),
        props: {
          decorations: ({ doc: e, selection: t }) => {
            const n = this.editor.isEditable || !this.options.showOnlyWhenEditable, { anchor: o } = t, r = [];
            if (!n)
              return null;
            const i = this.editor.isEmpty;
            return e.descendants((s, a) => {
              const c = o >= a && o <= a + s.nodeSize, d = !s.isLeaf && Mf(s);
              if ((c || !this.options.showOnlyCurrent) && d) {
                const u = [this.options.emptyNodeClass];
                i && u.push(this.options.emptyEditorClass);
                const p = Yo.node(a, a + s.nodeSize, {
                  class: u.join(" "),
                  "data-placeholder": typeof this.options.placeholder == "function" ? this.options.placeholder({
                    editor: this.editor,
                    node: s,
                    pos: a,
                    hasAnchor: c
                  }) : this.options.placeholder
                });
                r.push(p);
              }
              return this.options.includeChildren;
            }), jn.create(e, r);
          }
        }
      })
    ];
  }
}), U8e = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, G8e = mo.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {}
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["img", _n(this.options.HTMLAttributes, e)];
  },
  addCommands() {
    return {
      setImage: (e) => ({ commands: t }) => t.insertContent({
        type: this.name,
        attrs: e
      })
    };
  },
  addInputRules() {
    return [
      HO({
        find: U8e,
        type: this.type,
        getAttributes: (e) => {
          const [, , t, n, o] = e;
          return { src: n, alt: t, title: o };
        }
      })
    ];
  }
}), q8e = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2ntley5rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6logistics9properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3ncaster6d0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2psy3ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0america6xi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", K8e = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", Kl = (e, t) => {
  for (const n in t)
    e[n] = t[n];
  return e;
}, G5 = "numeric", q5 = "ascii", K5 = "alpha", Sc = "asciinumeric", Q2 = "alphanumeric", Y5 = "domain", ZO = "emoji", Y8e = "scheme", X8e = "slashscheme", fp = "whitespace";
function J8e(e, t) {
  return e in t || (t[e] = []), t[e];
}
function oa(e, t, n) {
  t[G5] && (t[Sc] = !0, t[Q2] = !0), t[q5] && (t[Sc] = !0, t[K5] = !0), t[Sc] && (t[Q2] = !0), t[K5] && (t[Q2] = !0), t[Q2] && (t[Y5] = !0), t[ZO] && (t[Y5] = !0);
  for (const o in t) {
    const r = J8e(o, n);
    r.indexOf(e) < 0 && r.push(e);
  }
}
function Q8e(e, t) {
  const n = {};
  for (const o in t)
    t[o].indexOf(e) >= 0 && (n[o] = !0);
  return n;
}
function _o(e = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = e;
}
_o.groups = {};
_o.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(e) {
    const t = this, n = t.j[e];
    if (n)
      return n;
    for (let o = 0; o < t.jr.length; o++) {
      const r = t.jr[o][0], i = t.jr[o][1];
      if (i && r.test(e))
        return i;
    }
    return t.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(e, t = !1) {
    return t ? e in this.j : !!this.go(e);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(e, t, n, o) {
    for (let r = 0; r < e.length; r++)
      this.tt(e[r], t, n, o);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(e, t, n, o) {
    o = o || _o.groups;
    let r;
    return t && t.j ? r = t : (r = new _o(t), n && o && oa(t, n, o)), this.jr.push([e, r]), r;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(e, t, n, o) {
    let r = this;
    const i = e.length;
    if (!i)
      return r;
    for (let s = 0; s < i - 1; s++)
      r = r.tt(e[s]);
    return r.tt(e[i - 1], t, n, o);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(e, t, n, o) {
    o = o || _o.groups;
    const r = this;
    if (t && t.j)
      return r.j[e] = t, t;
    const i = t;
    let s, a = r.go(e);
    if (a ? (s = new _o(), Kl(s.j, a.j), s.jr.push.apply(s.jr, a.jr), s.jd = a.jd, s.t = a.t) : s = new _o(), i) {
      if (o)
        if (s.t && typeof s.t == "string") {
          const c = Kl(Q8e(s.t, o), n);
          oa(i, c, o);
        } else n && oa(i, n, o);
      s.t = i;
    }
    return r.j[e] = s, s;
  }
};
const Et = (e, t, n, o, r) => e.ta(t, n, o, r), wn = (e, t, n, o, r) => e.tr(t, n, o, r), cy = (e, t, n, o, r) => e.ts(t, n, o, r), $e = (e, t, n, o, r) => e.tt(t, n, o, r), xi = "WORD", X5 = "UWORD", WO = "ASCIINUMERICAL", UO = "ALPHANUMERICAL", u0 = "LOCALHOST", J5 = "TLD", Q5 = "UTLD", Ad = "SCHEME", cl = "SLASH_SCHEME", L8 = "NUM", e4 = "WS", I8 = "NL", Mc = "OPENBRACE", Tc = "CLOSEBRACE", Ou = "OPENBRACKET", _u = "CLOSEBRACKET", Pu = "OPENPAREN", Lu = "CLOSEPAREN", Iu = "OPENANGLEBRACKET", ju = "CLOSEANGLEBRACKET", Vu = "FULLWIDTHLEFTPAREN", Du = "FULLWIDTHRIGHTPAREN", Au = "LEFTCORNERBRACKET", Hu = "RIGHTCORNERBRACKET", Fu = "LEFTWHITECORNERBRACKET", Nu = "RIGHTWHITECORNERBRACKET", $u = "FULLWIDTHLESSTHAN", Bu = "FULLWIDTHGREATERTHAN", zu = "AMPERSAND", j8 = "APOSTROPHE", Zu = "ASTERISK", Ui = "AT", Wu = "BACKSLASH", Uu = "BACKTICK", Gu = "CARET", Yi = "COLON", V8 = "COMMA", qu = "DOLLAR", Zr = "DOT", Ku = "EQUALS", D8 = "EXCLAMATION", ar = "HYPHEN", kc = "PERCENT", Yu = "PIPE", Xu = "PLUS", Ju = "POUND", Ec = "QUERY", A8 = "QUOTE", GO = "FULLWIDTHMIDDLEDOT", H8 = "SEMI", Wr = "SLASH", Rc = "TILDE", Qu = "UNDERSCORE", qO = "EMOJI", e3 = "SYM";
var KO = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  WORD: xi,
  UWORD: X5,
  ASCIINUMERICAL: WO,
  ALPHANUMERICAL: UO,
  LOCALHOST: u0,
  TLD: J5,
  UTLD: Q5,
  SCHEME: Ad,
  SLASH_SCHEME: cl,
  NUM: L8,
  WS: e4,
  NL: I8,
  OPENBRACE: Mc,
  CLOSEBRACE: Tc,
  OPENBRACKET: Ou,
  CLOSEBRACKET: _u,
  OPENPAREN: Pu,
  CLOSEPAREN: Lu,
  OPENANGLEBRACKET: Iu,
  CLOSEANGLEBRACKET: ju,
  FULLWIDTHLEFTPAREN: Vu,
  FULLWIDTHRIGHTPAREN: Du,
  LEFTCORNERBRACKET: Au,
  RIGHTCORNERBRACKET: Hu,
  LEFTWHITECORNERBRACKET: Fu,
  RIGHTWHITECORNERBRACKET: Nu,
  FULLWIDTHLESSTHAN: $u,
  FULLWIDTHGREATERTHAN: Bu,
  AMPERSAND: zu,
  APOSTROPHE: j8,
  ASTERISK: Zu,
  AT: Ui,
  BACKSLASH: Wu,
  BACKTICK: Uu,
  CARET: Gu,
  COLON: Yi,
  COMMA: V8,
  DOLLAR: qu,
  DOT: Zr,
  EQUALS: Ku,
  EXCLAMATION: D8,
  HYPHEN: ar,
  PERCENT: kc,
  PIPE: Yu,
  PLUS: Xu,
  POUND: Ju,
  QUERY: Ec,
  QUOTE: A8,
  FULLWIDTHMIDDLEDOT: GO,
  SEMI: H8,
  SLASH: Wr,
  TILDE: Rc,
  UNDERSCORE: Qu,
  EMOJI: qO,
  SYM: e3
});
const gi = /[a-z]/, N2 = new RegExp("\\p{L}", "u"), pp = new RegExp("\\p{Emoji}", "u"), mi = /\d/, hp = /\s/, dy = "\r", gp = `
`, e9e = "️", t9e = "‍", mp = "￼";
let ed = null, td = null;
function n9e(e = []) {
  const t = {};
  _o.groups = t;
  const n = new _o();
  ed == null && (ed = uy(q8e)), td == null && (td = uy(K8e)), $e(n, "'", j8), $e(n, "{", Mc), $e(n, "}", Tc), $e(n, "[", Ou), $e(n, "]", _u), $e(n, "(", Pu), $e(n, ")", Lu), $e(n, "<", Iu), $e(n, ">", ju), $e(n, "（", Vu), $e(n, "）", Du), $e(n, "「", Au), $e(n, "」", Hu), $e(n, "『", Fu), $e(n, "』", Nu), $e(n, "＜", $u), $e(n, "＞", Bu), $e(n, "&", zu), $e(n, "*", Zu), $e(n, "@", Ui), $e(n, "`", Uu), $e(n, "^", Gu), $e(n, ":", Yi), $e(n, ",", V8), $e(n, "$", qu), $e(n, ".", Zr), $e(n, "=", Ku), $e(n, "!", D8), $e(n, "-", ar), $e(n, "%", kc), $e(n, "|", Yu), $e(n, "+", Xu), $e(n, "#", Ju), $e(n, "?", Ec), $e(n, '"', A8), $e(n, "/", Wr), $e(n, ";", H8), $e(n, "~", Rc), $e(n, "_", Qu), $e(n, "\\", Wu), $e(n, "・", GO);
  const o = wn(n, mi, L8, {
    [G5]: !0
  });
  wn(o, mi, o);
  const r = wn(o, gi, WO, {
    [Sc]: !0
  }), i = wn(o, N2, UO, {
    [Q2]: !0
  }), s = wn(n, gi, xi, {
    [q5]: !0
  });
  wn(s, mi, r), wn(s, gi, s), wn(r, mi, r), wn(r, gi, r);
  const a = wn(n, N2, X5, {
    [K5]: !0
  });
  wn(a, gi), wn(a, mi, i), wn(a, N2, a), wn(i, mi, i), wn(i, gi), wn(i, N2, i);
  const c = $e(n, gp, I8, {
    [fp]: !0
  }), d = $e(n, dy, e4, {
    [fp]: !0
  }), u = wn(n, hp, e4, {
    [fp]: !0
  });
  $e(n, mp, u), $e(d, gp, c), $e(d, mp, u), wn(d, hp, u), $e(u, dy), $e(u, gp), wn(u, hp, u), $e(u, mp, u);
  const p = wn(n, pp, qO, {
    [ZO]: !0
  });
  $e(p, "#"), wn(p, pp, p), $e(p, e9e, p);
  const h = $e(p, t9e);
  $e(h, "#"), wn(h, pp, p);
  const g = [[gi, s], [mi, r]], m = [[gi, null], [N2, a], [mi, i]];
  for (let b = 0; b < ed.length; b++)
    Ni(n, ed[b], J5, xi, g);
  for (let b = 0; b < td.length; b++)
    Ni(n, td[b], Q5, X5, m);
  oa(J5, {
    tld: !0,
    ascii: !0
  }, t), oa(Q5, {
    utld: !0,
    alpha: !0
  }, t), Ni(n, "file", Ad, xi, g), Ni(n, "mailto", Ad, xi, g), Ni(n, "http", cl, xi, g), Ni(n, "https", cl, xi, g), Ni(n, "ftp", cl, xi, g), Ni(n, "ftps", cl, xi, g), oa(Ad, {
    scheme: !0,
    ascii: !0
  }, t), oa(cl, {
    slashscheme: !0,
    ascii: !0
  }, t), e = e.sort((b, C) => b[0] > C[0] ? 1 : -1);
  for (let b = 0; b < e.length; b++) {
    const C = e[b][0], v = e[b][1] ? {
      [Y8e]: !0
    } : {
      [X8e]: !0
    };
    C.indexOf("-") >= 0 ? v[Y5] = !0 : gi.test(C) ? mi.test(C) ? v[Sc] = !0 : v[q5] = !0 : v[G5] = !0, cy(n, C, C, v);
  }
  return cy(n, "localhost", u0, {
    ascii: !0
  }), n.jd = new _o(e3), {
    start: n,
    tokens: Kl({
      groups: t
    }, KO)
  };
}
function YO(e, t) {
  const n = o9e(t.replace(/[A-Z]/g, (a) => a.toLowerCase())), o = n.length, r = [];
  let i = 0, s = 0;
  for (; s < o; ) {
    let a = e, c = null, d = 0, u = null, p = -1, h = -1;
    for (; s < o && (c = a.go(n[s])); )
      a = c, a.accepts() ? (p = 0, h = 0, u = a) : p >= 0 && (p += n[s].length, h++), d += n[s].length, i += n[s].length, s++;
    i -= p, s -= h, d -= p, r.push({
      t: u.t,
      // token type/name
      v: t.slice(i - d, i),
      // string value
      s: i - d,
      // start index
      e: i
      // end index (excluding)
    });
  }
  return r;
}
function o9e(e) {
  const t = [], n = e.length;
  let o = 0;
  for (; o < n; ) {
    let r = e.charCodeAt(o), i, s = r < 55296 || r > 56319 || o + 1 === n || (i = e.charCodeAt(o + 1)) < 56320 || i > 57343 ? e[o] : e.slice(o, o + 2);
    t.push(s), o += s.length;
  }
  return t;
}
function Ni(e, t, n, o, r) {
  let i;
  const s = t.length;
  for (let a = 0; a < s - 1; a++) {
    const c = t[a];
    e.j[c] ? i = e.j[c] : (i = new _o(o), i.jr = r.slice(), e.j[c] = i), e = i;
  }
  return i = new _o(n), i.jr = r.slice(), e.j[t[s - 1]] = i, i;
}
function uy(e) {
  const t = [], n = [];
  let o = 0, r = "0123456789";
  for (; o < e.length; ) {
    let i = 0;
    for (; r.indexOf(e[o + i]) >= 0; )
      i++;
    if (i > 0) {
      t.push(n.join(""));
      for (let s = parseInt(e.substring(o, o + i), 10); s > 0; s--)
        n.pop();
      o += i;
    } else
      n.push(e[o]), o++;
  }
  return t;
}
const f0 = {
  defaultProtocol: "http",
  events: null,
  format: fy,
  formatHref: fy,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function F8(e, t = null) {
  let n = Kl({}, f0);
  e && (n = Kl(n, e instanceof F8 ? e.o : e));
  const o = n.ignoreTags, r = [];
  for (let i = 0; i < o.length; i++)
    r.push(o[i].toUpperCase());
  this.o = n, t && (this.defaultRender = t), this.ignoreTags = r;
}
F8.prototype = {
  o: f0,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(e) {
    return e;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(e) {
    return this.get("validate", e.toString(), e);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(e, t, n) {
    const o = t != null;
    let r = this.o[e];
    return r && (typeof r == "object" ? (r = n.t in r ? r[n.t] : f0[e], typeof r == "function" && o && (r = r(t, n))) : typeof r == "function" && o && (r = r(t, n.t, n)), r);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(e, t, n) {
    let o = this.o[e];
    return typeof o == "function" && t != null && (o = o(t, n.t, n)), o;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(e) {
    const t = e.render(this);
    return (this.get("render", null, e) || this.defaultRender)(t, e.t, e);
  }
};
function fy(e) {
  return e;
}
function XO(e, t) {
  this.t = "token", this.v = e, this.tk = t;
}
XO.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(e) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(e) {
    const t = this.toString(), n = e.get("truncate", t, this), o = e.get("format", t, this);
    return n && o.length > n ? o.substring(0, n) + "…" : o;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(e) {
    return e.get("formatHref", this.toHref(e.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(e = f0.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(e) {
    return {
      type: this.t,
      value: this.toFormattedString(e),
      isLink: this.isLink,
      href: this.toFormattedHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(e) {
    return e.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(e) {
    const t = this, n = this.toHref(e.get("defaultProtocol")), o = e.get("formatHref", n, this), r = e.get("tagName", n, t), i = this.toFormattedString(e), s = {}, a = e.get("className", n, t), c = e.get("target", n, t), d = e.get("rel", n, t), u = e.getObj("attributes", n, t), p = e.getObj("events", n, t);
    return s.href = o, a && (s.class = a), c && (s.target = c), d && (s.rel = d), u && Kl(s, u), {
      tagName: r,
      attributes: s,
      content: i,
      eventListeners: p
    };
  }
};
function kf(e, t) {
  class n extends XO {
    constructor(r, i) {
      super(r, i), this.t = e;
    }
  }
  for (const o in t)
    n.prototype[o] = t[o];
  return n.t = e, n;
}
const py = kf("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), hy = kf("text"), r9e = kf("nl"), nd = kf("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(e = f0.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${e}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const e = this.tk;
    return e.length >= 2 && e[0].t !== u0 && e[1].t === Yi;
  }
}), ir = (e) => new _o(e);
function i9e({
  groups: e
}) {
  const t = e.domain.concat([zu, Zu, Ui, Wu, Uu, Gu, qu, Ku, ar, L8, kc, Yu, Xu, Ju, Wr, e3, Rc, Qu]), n = [Yi, V8, Zr, D8, kc, Ec, A8, H8, Iu, ju, Mc, Tc, _u, Ou, Pu, Lu, Vu, Du, Au, Hu, Fu, Nu, $u, Bu], o = [zu, j8, Zu, Wu, Uu, Gu, qu, Ku, ar, Mc, Tc, kc, Yu, Xu, Ju, Ec, Wr, e3, Rc, Qu], r = ir(), i = $e(r, Rc);
  Et(i, o, i), Et(i, e.domain, i);
  const s = ir(), a = ir(), c = ir();
  Et(r, e.domain, s), Et(r, e.scheme, a), Et(r, e.slashscheme, c), Et(s, o, i), Et(s, e.domain, s);
  const d = $e(s, Ui);
  $e(i, Ui, d), $e(a, Ui, d), $e(c, Ui, d);
  const u = $e(i, Zr);
  Et(u, o, i), Et(u, e.domain, i);
  const p = ir();
  Et(d, e.domain, p), Et(p, e.domain, p);
  const h = $e(p, Zr);
  Et(h, e.domain, p);
  const g = ir(py);
  Et(h, e.tld, g), Et(h, e.utld, g), $e(d, u0, g);
  const m = $e(p, ar);
  $e(m, ar, m), Et(m, e.domain, p), Et(g, e.domain, p), $e(g, Zr, h), $e(g, ar, m);
  const b = $e(g, Yi);
  Et(b, e.numeric, py);
  const C = $e(s, ar), x = $e(s, Zr);
  $e(C, ar, C), Et(C, e.domain, s), Et(x, o, i), Et(x, e.domain, s);
  const v = ir(nd);
  Et(x, e.tld, v), Et(x, e.utld, v), Et(v, e.domain, s), Et(v, o, i), $e(v, Zr, x), $e(v, ar, C), $e(v, Ui, d);
  const S = $e(v, Yi), M = ir(nd);
  Et(S, e.numeric, M);
  const w = ir(nd), k = ir();
  Et(w, t, w), Et(w, n, k), Et(k, t, w), Et(k, n, k), $e(v, Wr, w), $e(M, Wr, w);
  const E = $e(a, Yi), R = $e(c, Yi), O = $e(R, Wr), P = $e(O, Wr);
  Et(a, e.domain, s), $e(a, Zr, x), $e(a, ar, C), Et(c, e.domain, s), $e(c, Zr, x), $e(c, ar, C), Et(E, e.domain, w), $e(E, Wr, w), $e(E, Ec, w), Et(P, e.domain, w), Et(P, t, w), $e(P, Wr, w);
  const _ = [
    [Mc, Tc],
    // {}
    [Ou, _u],
    // []
    [Pu, Lu],
    // ()
    [Iu, ju],
    // <>
    [Vu, Du],
    // （）
    [Au, Hu],
    // 「」
    [Fu, Nu],
    // 『』
    [$u, Bu]
    // ＜＞
  ];
  for (let L = 0; L < _.length; L++) {
    const [V, j] = _[L], I = $e(w, V);
    $e(k, V, I), $e(I, j, w);
    const F = ir(nd);
    Et(I, t, F);
    const $ = ir();
    Et(I, n), Et(F, t, F), Et(F, n, $), Et($, t, F), Et($, n, $), $e(F, j, w), $e($, j, w);
  }
  return $e(r, u0, v), $e(r, I8, r9e), {
    start: r,
    tokens: KO
  };
}
function s9e(e, t, n) {
  let o = n.length, r = 0, i = [], s = [];
  for (; r < o; ) {
    let a = e, c = null, d = null, u = 0, p = null, h = -1;
    for (; r < o && !(c = a.go(n[r].t)); )
      s.push(n[r++]);
    for (; r < o && (d = c || a.go(n[r].t)); )
      c = null, a = d, a.accepts() ? (h = 0, p = a) : h >= 0 && h++, r++, u++;
    if (h < 0)
      r -= u, r < o && (s.push(n[r]), r++);
    else {
      s.length > 0 && (i.push(bp(hy, t, s)), s = []), r -= h, u -= h;
      const g = p.t, m = n.slice(r - u, r);
      i.push(bp(g, t, m));
    }
  }
  return s.length > 0 && i.push(bp(hy, t, s)), i;
}
function bp(e, t, n) {
  const o = n[0].s, r = n[n.length - 1].e, i = t.slice(o, r);
  return new e(i, n);
}
const a9e = typeof console < "u" && console && console.warn || (() => {
}), l9e = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", un = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function c9e() {
  return _o.groups = {}, un.scanner = null, un.parser = null, un.tokenQueue = [], un.pluginQueue = [], un.customSchemes = [], un.initialized = !1, un;
}
function gy(e, t = !1) {
  if (un.initialized && a9e(`linkifyjs: already initialized - will not register custom scheme "${e}" ${l9e}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(e))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  un.customSchemes.push([e, t]);
}
function d9e() {
  un.scanner = n9e(un.customSchemes);
  for (let e = 0; e < un.tokenQueue.length; e++)
    un.tokenQueue[e][1]({
      scanner: un.scanner
    });
  un.parser = i9e(un.scanner.tokens);
  for (let e = 0; e < un.pluginQueue.length; e++)
    un.pluginQueue[e][1]({
      scanner: un.scanner,
      parser: un.parser
    });
  return un.initialized = !0, un;
}
function N8(e) {
  return un.initialized || d9e(), s9e(un.parser.start, e, YO(un.scanner.start, e));
}
N8.scan = YO;
function JO(e, t = null, n = null) {
  if (t && typeof t == "object") {
    if (n)
      throw Error(`linkifyjs: Invalid link type ${t}; must be a string`);
    n = t, t = null;
  }
  const o = new F8(n), r = N8(e), i = [];
  for (let s = 0; s < r.length; s++) {
    const a = r[s];
    a.isLink && (!t || a.t === t) && o.check(a) && i.push(a.toFormattedObject(o));
  }
  return i;
}
function u9e(e) {
  return e.length === 1 ? e[0].isLink : e.length === 3 && e[1].isLink ? ["()", "[]"].includes(e[0].value + e[2].value) : !1;
}
function f9e(e) {
  return new Kn({
    key: new No("autolink"),
    appendTransaction: (t, n, o) => {
      const r = t.some((d) => d.docChanged) && !n.doc.eq(o.doc), i = t.some((d) => d.getMeta("preventAutolink"));
      if (!r || i)
        return;
      const { tr: s } = o, a = P7e(n.doc, [...t]);
      if (F7e(a).forEach(({ newRange: d }) => {
        const u = I7e(o.doc, d, (g) => g.isTextblock);
        let p, h;
        if (u.length > 1 ? (p = u[0], h = o.doc.textBetween(p.pos, p.pos + p.node.nodeSize, void 0, " ")) : u.length && o.doc.textBetween(d.from, d.to, " ", " ").endsWith(" ") && (p = u[0], h = o.doc.textBetween(p.pos, d.to, void 0, " ")), p && h) {
          const g = h.split(" ").filter((x) => x !== "");
          if (g.length <= 0)
            return !1;
          const m = g[g.length - 1], b = p.pos + h.lastIndexOf(m);
          if (!m)
            return !1;
          const C = N8(m).map((x) => x.toObject(e.defaultProtocol));
          if (!u9e(C))
            return !1;
          C.filter((x) => x.isLink).map((x) => ({
            ...x,
            from: b + x.start + 1,
            to: b + x.end + 1
          })).filter((x) => o.schema.marks.code ? !o.doc.rangeHasMark(x.from, x.to, o.schema.marks.code) : !0).filter((x) => e.validate(x.value)).filter((x) => e.shouldAutoLink(x.value)).forEach((x) => {
            _8(x.from, x.to, o.doc).some((v) => v.mark.type === e.type) || s.addMark(x.from, x.to, e.type.create({
              href: x.href
            }));
          });
        }
      }), !!s.steps.length)
        return s;
    }
  });
}
function p9e(e) {
  return new Kn({
    key: new No("handleClickLink"),
    props: {
      handleClick: (t, n, o) => {
        var r, i;
        if (o.button !== 0 || !t.editable)
          return !1;
        let s = o.target;
        const a = [];
        for (; s.nodeName !== "DIV"; )
          a.push(s), s = s.parentNode;
        if (!a.find((h) => h.nodeName === "A"))
          return !1;
        const c = AO(t.state, e.type.name), d = o.target, u = (r = d == null ? void 0 : d.href) !== null && r !== void 0 ? r : c.href, p = (i = d == null ? void 0 : d.target) !== null && i !== void 0 ? i : c.target;
        return d && u ? (window.open(u, p), !0) : !1;
      }
    }
  });
}
function h9e(e) {
  return new Kn({
    key: new No("handlePasteLink"),
    props: {
      handlePaste: (t, n, o) => {
        const { state: r } = t, { selection: i } = r, { empty: s } = i;
        if (s)
          return !1;
        let a = "";
        o.content.forEach((d) => {
          a += d.textContent;
        });
        const c = JO(a, { defaultProtocol: e.defaultProtocol }).find((d) => d.isLink && d.value === a);
        return !a || !c ? !1 : e.editor.commands.setMark(e.type, {
          href: c.href
        });
      }
    }
  });
}
const g9e = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g;
function $s(e, t) {
  const n = [
    "http",
    "https",
    "ftp",
    "ftps",
    "mailto",
    "tel",
    "callto",
    "sms",
    "cid",
    "xmpp"
  ];
  return t && t.forEach((o) => {
    const r = typeof o == "string" ? o : o.scheme;
    r && n.push(r);
  }), !e || e.replace(g9e, "").match(new RegExp(
    // eslint-disable-next-line no-useless-escape
    `^(?:(?:${n.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
    "i"
  ));
}
const m9e = Sr.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((e) => {
      if (typeof e == "string") {
        gy(e);
        return;
      }
      gy(e.scheme, e.optionalSlashes);
    });
  },
  onDestroy() {
    c9e();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (e, t) => !!$s(e, t.protocols),
      validate: (e) => !!e,
      shouldAutoLink: (e) => !!e
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(e) {
          return e.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (e) => {
          const t = e.getAttribute("href");
          return !t || !this.options.isAllowedUri(t, {
            defaultValidate: (n) => !!$s(n, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return this.options.isAllowedUri(e.href, {
      defaultValidate: (t) => !!$s(t, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", _n(this.options.HTMLAttributes, e), 0] : [
      "a",
      _n(this.options.HTMLAttributes, { ...e, href: "" }),
      0
    ];
  },
  addCommands() {
    return {
      setLink: (e) => ({ chain: t }) => {
        const { href: n } = e;
        return this.options.isAllowedUri(n, {
          defaultValidate: (o) => !!$s(o, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? t().setMark(this.name, e).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (e) => ({ chain: t }) => {
        const { href: n } = e;
        return this.options.isAllowedUri(n, {
          defaultValidate: (o) => !!$s(o, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? t().toggleMark(this.name, e, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run() : !1;
      },
      unsetLink: () => ({ chain: e }) => e().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      _a({
        find: (e) => {
          const t = [];
          if (e) {
            const { protocols: n, defaultProtocol: o } = this.options, r = JO(e).filter((i) => i.isLink && this.options.isAllowedUri(i.value, {
              defaultValidate: (s) => !!$s(s, n),
              protocols: n,
              defaultProtocol: o
            }));
            r.length && r.forEach((i) => t.push({
              text: i.value,
              data: {
                href: i.href
              },
              index: i.start
            }));
          }
          return t;
        },
        type: this.type,
        getAttributes: (e) => {
          var t;
          return {
            href: (t = e.data) === null || t === void 0 ? void 0 : t.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const e = [], { protocols: t, defaultProtocol: n } = this.options;
    return this.options.autolink && e.push(f9e({
      type: this.type,
      defaultProtocol: this.options.defaultProtocol,
      validate: (o) => this.options.isAllowedUri(o, {
        defaultValidate: (r) => !!$s(r, t),
        protocols: t,
        defaultProtocol: n
      }),
      shouldAutoLink: this.options.shouldAutoLink
    })), this.options.openOnClick === !0 && e.push(p9e({
      type: this.type
    })), this.options.linkOnPaste && e.push(h9e({
      editor: this.editor,
      defaultProtocol: this.options.defaultProtocol,
      type: this.type
    })), e;
  }
}), b9e = Rn.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (e) => {
              var t;
              return (t = e.style.color) === null || t === void 0 ? void 0 : t.replace(/['"]+/g, "");
            },
            renderHTML: (e) => e.color ? {
              style: `color: ${e.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (e) => ({ chain: t }) => t().setMark("textStyle", { color: e }).run(),
      unsetColor: () => ({ chain: e }) => e().setMark("textStyle", { color: null }).removeEmptyTextStyle().run()
    };
  }
}), C9e = Rn.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"],
      HTMLAttributes: {}
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (e) => e.style.fontSize || null,
            renderHTML: (e) => e.fontSize ? {
              style: `font-size: ${e.fontSize}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (e) => ({ chain: t }) => t().setMark("textStyle", { fontSize: e }).run()
    };
  }
}), x9e = Rn.create({
  name: "backgroundColor",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          backgroundColor: {
            default: null,
            parseHTML: (e) => e.style.backgroundColor || null,
            renderHTML: (e) => e.backgroundColor ? {
              style: `background-color: ${e.backgroundColor}; border-radius: 2rem; padding: 0.25rem 0.5rem`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setBackgroundColor: (e) => ({ commands: t }) => t.setMark("textStyle", { backgroundColor: e }),
      unsetBackgroundColor: () => ({ commands: e }) => e.setMark("textStyle", { backgroundColor: null })
    };
  }
}), y9e = Rn.create({
  name: "borderRadius",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          borderRadius: {
            default: null,
            parseHTML: (e) => e.style.borderRadius || null,
            renderHTML: (e) => e.borderRadius ? {
              style: `border-radius: ${e.borderRadius}px`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setBorderRadius: (e) => ({ commands: t }) => t.setMark("textStyle", { borderRadius: `${e}` }),
      unsetBorderRadius: () => ({ commands: e }) => e.setMark("textStyle", { borderRadius: null })
    };
  }
});
var $8 = {}, v9e = ht;
Object.defineProperty($8, "__esModule", {
  value: !0
});
var QO = $8.default = void 0, w9e = v9e(bt()), S9e = f;
QO = $8.default = (0, w9e.default)(/* @__PURE__ */ (0, S9e.jsx)("path", {
  d: "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42M10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5"
}), "FormatBold");
var B8 = {}, M9e = ht;
Object.defineProperty(B8, "__esModule", {
  value: !0
});
var e_ = B8.default = void 0, T9e = M9e(bt()), k9e = f;
e_ = B8.default = (0, T9e.default)(/* @__PURE__ */ (0, k9e.jsx)("path", {
  d: "M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z"
}), "FormatItalic");
var z8 = {}, E9e = ht;
Object.defineProperty(z8, "__esModule", {
  value: !0
});
var t_ = z8.default = void 0, R9e = E9e(bt()), O9e = f;
t_ = z8.default = (0, R9e.default)(/* @__PURE__ */ (0, O9e.jsx)("path", {
  d: "M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6m-7 2v2h14v-2z"
}), "FormatUnderlined");
var Z8 = {}, _9e = ht;
Object.defineProperty(Z8, "__esModule", {
  value: !0
});
var n_ = Z8.default = void 0, P9e = _9e(bt()), L9e = f;
n_ = Z8.default = (0, P9e.default)(/* @__PURE__ */ (0, L9e.jsx)("path", {
  d: "M6.85 7.08C6.85 4.37 9.45 3 12.24 3c1.64 0 3 .49 3.9 1.28.77.65 1.46 1.73 1.46 3.24h-3.01c0-.31-.05-.59-.15-.85-.29-.86-1.2-1.28-2.25-1.28-1.86 0-2.34 1.02-2.34 1.7 0 .48.25.88.74 1.21.38.25.77.48 1.41.7H7.39c-.21-.34-.54-.89-.54-1.92M21 12v-2H3v2h9.62c1.15.45 1.96.75 1.96 1.97 0 1-.81 1.67-2.28 1.67-1.54 0-2.93-.54-2.93-2.51H6.4c0 .55.08 1.13.24 1.58.81 2.29 3.29 3.3 5.67 3.3 2.27 0 5.3-.89 5.3-4.05 0-.3-.01-1.16-.48-1.94H21z"
}), "StrikethroughS");
const Lo = B(at)(({ theme: e }) => ({
  minWidth: e.spacing(4),
  height: e.spacing(4),
  padding: e.spacing(0.5),
  borderRadius: e.shape.borderRadius,
  color: e.palette.text.secondary,
  boxShadow: "none",
  "&.MuiButton-contained": {
    color: e.palette.primary[800],
    backgroundColor: e.palette.primary[100],
    boxShadow: "none"
  },
  "&:hover": {
    backgroundColor: e.palette.action.hover,
    color: e.palette.primary[800],
    boxShadow: "none",
    textDecoration: "none"
  },
  "& .MuiSvgIcon-root": {
    fontSize: "1.25rem"
  }
})), I9e = B(J)(({ theme: e }) => ({
  padding: e.spacing(0.5),
  display: "flex",
  alignItems: "center"
}));
B(J)(({ theme: e }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: e.spacing(1),
  padding: e.spacing(1),
  borderBottom: `1px solid ${e.palette.divider}`,
  backgroundColor: e.palette.background.default
}));
B(J)(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(1),
  alignItems: "center"
}));
const Cp = B(L0)(({ width: e, theme: t }) => ({
  width: e || 140,
  height: 32,
  fontSize: 14,
  fontWeight: t.typography.fontWeightMedium,
  textTransform: "capitalize",
  background: "white"
})), xp = {
  PaperProps: {
    style: {
      maxHeight: 250,
      boxShadow: "none",
      borderRadius: "5px",
      border: "1px solid rgba(0, 0, 0, 0.12)",
      marginTop: "4px"
    }
  }
}, yp = {
  fontSize: 14,
  borderRadius: 0,
  fontWeight: 500,
  maxWidth: 140,
  maxHeight: 32
};
function j9e(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var o_ = j9e, V9e = typeof J0 == "object" && J0 && J0.Object === Object && J0, D9e = V9e, A9e = D9e, H9e = typeof self == "object" && self && self.Object === Object && self, F9e = A9e || H9e || Function("return this")(), r_ = F9e, N9e = r_, $9e = function() {
  return N9e.Date.now();
}, B9e = $9e, z9e = /\s/;
function Z9e(e) {
  for (var t = e.length; t-- && z9e.test(e.charAt(t)); )
    ;
  return t;
}
var W9e = Z9e, U9e = W9e, G9e = /^\s+/;
function q9e(e) {
  return e && e.slice(0, U9e(e) + 1).replace(G9e, "");
}
var K9e = q9e, Y9e = r_, X9e = Y9e.Symbol, i_ = X9e, my = i_, s_ = Object.prototype, J9e = s_.hasOwnProperty, Q9e = s_.toString, $2 = my ? my.toStringTag : void 0;
function ege(e) {
  var t = J9e.call(e, $2), n = e[$2];
  try {
    e[$2] = void 0;
    var o = !0;
  } catch {
  }
  var r = Q9e.call(e);
  return o && (t ? e[$2] = n : delete e[$2]), r;
}
var tge = ege, nge = Object.prototype, oge = nge.toString;
function rge(e) {
  return oge.call(e);
}
var ige = rge, by = i_, sge = tge, age = ige, lge = "[object Null]", cge = "[object Undefined]", Cy = by ? by.toStringTag : void 0;
function dge(e) {
  return e == null ? e === void 0 ? cge : lge : Cy && Cy in Object(e) ? sge(e) : age(e);
}
var uge = dge;
function fge(e) {
  return e != null && typeof e == "object";
}
var pge = fge, hge = uge, gge = pge, mge = "[object Symbol]";
function bge(e) {
  return typeof e == "symbol" || gge(e) && hge(e) == mge;
}
var Cge = bge, xge = K9e, xy = o_, yge = Cge, yy = NaN, vge = /^[-+]0x[0-9a-f]+$/i, wge = /^0b[01]+$/i, Sge = /^0o[0-7]+$/i, Mge = parseInt;
function Tge(e) {
  if (typeof e == "number")
    return e;
  if (yge(e))
    return yy;
  if (xy(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = xy(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = xge(e);
  var n = wge.test(e);
  return n || Sge.test(e) ? Mge(e.slice(2), n ? 2 : 8) : vge.test(e) ? yy : +e;
}
var kge = Tge, Ege = o_, vp = B9e, vy = kge, Rge = "Expected a function", Oge = Math.max, _ge = Math.min;
function Pge(e, t, n) {
  var o, r, i, s, a, c, d = 0, u = !1, p = !1, h = !0;
  if (typeof e != "function")
    throw new TypeError(Rge);
  t = vy(t) || 0, Ege(n) && (u = !!n.leading, p = "maxWait" in n, i = p ? Oge(vy(n.maxWait) || 0, t) : i, h = "trailing" in n ? !!n.trailing : h);
  function g(k) {
    var E = o, R = r;
    return o = r = void 0, d = k, s = e.apply(R, E), s;
  }
  function m(k) {
    return d = k, a = setTimeout(x, t), u ? g(k) : s;
  }
  function b(k) {
    var E = k - c, R = k - d, O = t - E;
    return p ? _ge(O, i - R) : O;
  }
  function C(k) {
    var E = k - c, R = k - d;
    return c === void 0 || E >= t || E < 0 || p && R >= i;
  }
  function x() {
    var k = vp();
    if (C(k))
      return v(k);
    a = setTimeout(x, b(k));
  }
  function v(k) {
    return a = void 0, h && o ? g(k) : (o = r = void 0, s);
  }
  function S() {
    a !== void 0 && clearTimeout(a), d = 0, o = c = r = a = void 0;
  }
  function M() {
    return a === void 0 ? s : v(vp());
  }
  function w() {
    var k = vp(), E = C(k);
    if (o = arguments, r = this, c = k, E) {
      if (a === void 0)
        return m(c);
      if (p)
        return clearTimeout(a), a = setTimeout(x, t), g(c);
    }
    return a === void 0 && (a = setTimeout(x, t)), s;
  }
  return w.cancel = S, w.flush = M, w;
}
var Lge = Pge;
const W8 = /* @__PURE__ */ ky(Lge), a_ = B(J)({
  display: "inline-flex",
  alignItems: "center",
  position: "relative"
}), Ige = B(at, {
  shouldForwardProp: (e) => e !== "currentColor"
})(({ theme: e, currentColor: t }) => ({
  minWidth: "32px",
  height: "2rem",
  padding: e.spacing(0.5),
  borderRadius: e.shape.borderRadius,
  boxShadow: "none",
  color: e.palette.text.secondary,
  fontSize: "1rem",
  fontWeight: "bold",
  backgroundColor: "transparent",
  position: "relative",
  "&::after": {
    content: '"A"',
    position: "absolute",
    width: "75%",
    textAlign: "center",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderBottom: `4px solid ${t || e.palette.text.primary}`,
    lineHeight: "1rem"
  },
  "&:hover": {
    backgroundColor: e.palette.action.hover,
    boxShadow: "none"
  }
})), jge = B(at, {
  shouldForwardProp: (e) => e !== "currentColor"
})(({ theme: e, currentColor: t }) => ({
  minWidth: "32px",
  height: "2rem",
  padding: e.spacing(0.5),
  borderRadius: e.shape.borderRadius,
  boxShadow: "none",
  color: e.palette.text.secondary,
  fontSize: "0.75rem",
  fontWeight: "bold",
  backgroundColor: "transparent",
  position: "relative",
  "&::after": {
    content: '" "',
    position: "absolute",
    width: "75%",
    textAlign: "center",
    top: "75%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderBottom: `4px solid ${t || "#ffffff"}`,
    lineHeight: "1rem"
  },
  "&:hover": {
    backgroundColor: e.palette.action.hover,
    boxShadow: "none"
  }
})), l_ = B("input")({
  position: "absolute",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  opacity: 0,
  cursor: "pointer"
}), wy = {
  DEBOUNCE: {
    DELAY: 100,
    MAX_WAIT: 300
  },
  COLOR: {
    DEFAULT: "#000000",
    PICKER_ID: "fp-color-picker"
  },
  BUTTON: {
    SIZE: {
      SMALL: "small",
      MEDIUM: "medium",
      LARGE: "large"
    },
    VARIANT: {
      TEXT: "text",
      CONTAINED: "contained"
    }
  }
}, Vge = {
  PRESETS: [
    {
      label: "Normal",
      value: "paragraph",
      htmllabel: /* @__PURE__ */ f.jsx("p", { children: "Paragraph" })
    },
    {
      label: "Title",
      value: "h1",
      htmllabel: /* @__PURE__ */ f.jsx("h1", { children: "h1" })
    },
    {
      label: "Subtitle",
      value: "h2",
      htmllabel: /* @__PURE__ */ f.jsx("h2", { children: "h2" })
    },
    {
      label: "Heading 3",
      value: "h3",
      htmllabel: /* @__PURE__ */ f.jsx("h3", { children: "h3" })
    },
    {
      label: "Heading 4",
      value: "h4",
      htmllabel: /* @__PURE__ */ f.jsx("h4", { children: "h4" })
    },
    {
      label: "Heading 5",
      value: "h5",
      htmllabel: /* @__PURE__ */ f.jsx("h5", { children: "h5" })
    },
    {
      label: "Heading 6",
      value: "h6",
      htmllabel: /* @__PURE__ */ f.jsx("h6", { children: "h6" })
    },
    {
      label: "Code",
      value: "code",
      htmllabel: /* @__PURE__ */ f.jsx("code", { children: "Code" })
    }
  ]
}, co = {
  HEADING: {
    H1: "h1",
    H2: "h2",
    H3: "h3",
    H4: "h4",
    H5: "h5",
    H6: "h6"
  },
  SPACING: {
    HEADING_MARGIN: 1,
    PARAGRAPH_MARGIN: 1,
    LIST_PADDING: 3
  },
  SIZES: [
    "8px",
    "10px",
    "12px",
    "14px",
    "16px",
    "18px",
    "20px",
    "24px",
    "28px",
    "32px",
    "36px",
    "40px",
    "48px",
    "56px",
    "64px",
    "72px",
    "80px",
    "96px"
  ],
  FAMILIES: ["Montserrat", "Arial", "Courier New", "Georgia", "Verdana"],
  DEFAULTS: {
    SIZE: "16px",
    FAMILY: "Montserrat",
    COLOR: "#000000"
  }
}, Dge = (e) => {
  if (e.startsWith("#"))
    return e;
  const t = e.match(/\d+/g);
  if (!t || t.length !== 3)
    return "#000000";
  const n = parseInt(t[0]).toString(16).padStart(2, "0"), o = parseInt(t[1]).toString(16).padStart(2, "0"), r = parseInt(t[2]).toString(16).padStart(2, "0");
  return `#${n}${o}${r}`;
}, Age = W8((e, t) => {
  t(e);
}, 100), Hge = ({ onChange: e, size: t, variant: n, currentColor: o }) => /* @__PURE__ */ f.jsx(a_, { children: /* @__PURE__ */ f.jsx(
  Ige,
  {
    size: t,
    variant: n,
    currentColor: o,
    onClick: () => {
      var r;
      return (r = document.getElementById(wy.COLOR.PICKER_ID)) == null ? void 0 : r.click();
    },
    children: /* @__PURE__ */ f.jsx(
      l_,
      {
        id: wy.COLOR.PICKER_ID,
        type: "color",
        value: o ? Dge(o) : "#000000",
        onChange: (r) => Age(r.target.value, e)
      }
    )
  }
) });
var U8 = {}, Fge = ht;
Object.defineProperty(U8, "__esModule", {
  value: !0
});
var c_ = U8.default = void 0, Nge = Fge(bt()), $ge = f;
c_ = U8.default = (0, Nge.default)(/* @__PURE__ */ (0, $ge.jsx)("path", {
  d: "M16.56 8.94 7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12M5.21 10 10 5.21 14.79 10zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5M2 20h20v4H2z"
}), "FormatColorFill");
var G8 = {}, Bge = ht;
Object.defineProperty(G8, "__esModule", {
  value: !0
});
var d_ = G8.default = void 0, zge = Bge(bt()), Zge = f;
d_ = G8.default = (0, zge.default)(/* @__PURE__ */ (0, Zge.jsx)("path", {
  d: "M18 14c0-4-6-10.8-6-10.8s-1.33 1.51-2.73 3.52l8.59 8.59c.09-.42.14-.86.14-1.31m-.88 3.12L12.5 12.5 5.27 5.27 4 6.55l3.32 3.32C6.55 11.32 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.96-1.5l2.63 2.63 1.27-1.27z"
}), "FormatColorReset");
const Wge = (e) => {
  if (!e || e === "transparent") return "#ffffff";
  if (e.startsWith("#"))
    return e;
  const t = e.match(/\d+/g);
  if (!t || t.length !== 3)
    return "#ffffff";
  const n = parseInt(t[0]).toString(16).padStart(2, "0"), o = parseInt(t[1]).toString(16).padStart(2, "0"), r = parseInt(t[2]).toString(16).padStart(2, "0");
  return `#${n}${o}${r}`;
}, Uge = W8((e, t) => {
  t(e);
}, 100), Sy = "bg-color-picker", Gge = ({ onChange: e, size: t, currentColor: n, onRemove: o }) => {
  const r = ge();
  return /* @__PURE__ */ f.jsxs(J, { sx: { display: "flex", alignItems: "center" }, children: [
    /* @__PURE__ */ f.jsx(a_, { children: /* @__PURE__ */ f.jsxs(
      jge,
      {
        size: t,
        title: "Background Color",
        currentColor: n,
        onClick: () => {
          var i;
          return (i = document.getElementById(Sy)) == null ? void 0 : i.click();
        },
        children: [
          /* @__PURE__ */ f.jsx(c_, { fontSize: "small" }),
          /* @__PURE__ */ f.jsx(
            l_,
            {
              id: Sy,
              type: "color",
              value: n ? Wge(n) : "#ffffff",
              onChange: (i) => Uge(i.target.value, e)
            }
          )
        ]
      }
    ) }),
    o && /* @__PURE__ */ f.jsx(J, { sx: { marginLeft: r.spacing(0.5) }, children: /* @__PURE__ */ f.jsx(
      Bt,
      {
        size: "small",
        title: "Remove Background Color",
        onClick: o,
        sx: {
          borderRadius: r.spacing(0.5),
          color: r.palette.text.secondary,
          height: "2rem",
          width: "2rem",
          "&:hover": {
            backgroundColor: r.palette.action.hover,
            boxShadow: "none"
          }
        },
        children: /* @__PURE__ */ f.jsx(d_, { fontSize: "small" })
      }
    ) })
  ] });
}, qge = B(J)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  padding: e.spacing(1.5, 2),
  minWidth: "200px",
  gap: e.spacing(0.5)
})), Kge = B(oe)(({ theme: e }) => ({
  color: e.palette.text.secondary,
  fontSize: e.typography.body2.fontSize,
  backgroundColor: e.palette.grey[400],
  borderRadius: e.spacing(2),
  padding: e.spacing(0.25, 1.25),
  marginRight: e.spacing(1),
  fontWeight: e.typography.fontWeightMedium,
  width: "fit-content",
  textAlign: "center",
  minWidth: e.spacing(7)
})), Yge = W8((e, t) => {
  t(e);
}, 100), Xge = ({ onChange: e, size: t, variant: n, currentRadius: o = 0 }) => {
  const r = ge(), [i, s] = Ae(null), [a, c] = Ae(o || 0), d = (m) => {
    s(m.currentTarget);
  }, u = () => {
    s(null);
  }, p = (m, b) => {
    const C = Array.isArray(b) ? b[0] : b;
    c(C), Yge(C, e);
  }, h = !!i, g = h ? "border-radius-popover" : void 0;
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(
      Lo,
      {
        onClick: d,
        variant: n,
        size: t,
        title: "Border Radius",
        sx: {
          position: "relative"
        },
        children: /* @__PURE__ */ f.jsx(bK, { fontSize: "small" })
      }
    ),
    /* @__PURE__ */ f.jsx(
      Ar,
      {
        id: g,
        open: h,
        anchorEl: i,
        onClose: u,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        elevation: 0,
        sx: {
          "& .MuiPaper-root": {
            borderRadius: r.spacing(1),
            border: "1px solid rgba(0, 0, 0, 0.12)"
          }
        },
        children: /* @__PURE__ */ f.jsx(qge, { children: /* @__PURE__ */ f.jsxs(be, { direction: "column", spacing: 1, justifyContent: "space-between", children: [
          /* @__PURE__ */ f.jsx(be, { width: "100%", children: /* @__PURE__ */ f.jsx(oe, { variant: "body-medium", fontSize: 14, children: "Border Radius:" }) }),
          /* @__PURE__ */ f.jsxs(be, { width: "100%", direction: "row", alignItems: "center", gap: 1, children: [
            /* @__PURE__ */ f.jsx(Kge, { children: `${a}px` }),
            /* @__PURE__ */ f.jsx(
              c7,
              {
                size: "small",
                value: a,
                min: 0,
                max: 40,
                step: 1,
                "aria-label": "Border Radius",
                valueLabelDisplay: "off",
                onChange: p
              }
            )
          ] })
        ] }) })
      }
    )
  ] });
}, od = (e, t) => {
  const n = e.isActive("label");
  e.chain().focus().toggleMark(t).run(), n && !e.isActive("label") && e.chain().focus().toggleLabel().run();
};
function Jge({ editor: e }) {
  var n, o, r, i, s, a, c;
  const t = ge();
  return e ? /* @__PURE__ */ f.jsx(I9e, { children: /* @__PURE__ */ f.jsxs(be, { direction: "row", spacing: 1, children: [
    /* @__PURE__ */ f.jsx(
      Lo,
      {
        onClick: () => od(e, "bold"),
        variant: e.isActive("bold") ? "contained" : "text",
        size: "small",
        children: /* @__PURE__ */ f.jsx(QO, { fontSize: "small" })
      }
    ),
    /* @__PURE__ */ f.jsx(
      Lo,
      {
        onClick: () => od(e, "italic"),
        variant: e.isActive("italic") ? "contained" : "text",
        size: "small",
        children: /* @__PURE__ */ f.jsx(e_, { fontSize: "small" })
      }
    ),
    /* @__PURE__ */ f.jsx(
      Lo,
      {
        onClick: () => od(e, "underline"),
        variant: e.isActive("underline") ? "contained" : "text",
        size: "small",
        children: /* @__PURE__ */ f.jsx(t_, { fontSize: "small" })
      }
    ),
    /* @__PURE__ */ f.jsx(
      Lo,
      {
        onClick: () => od(e, "strike"),
        variant: e.isActive("strike") ? "contained" : "text",
        size: "small",
        children: /* @__PURE__ */ f.jsx(n_, { fontSize: "small" })
      }
    ),
    /* @__PURE__ */ f.jsx(
      Lo,
      {
        onClick: () => e.chain().focus().toggleLabel().run(),
        variant: e.isActive("label") ? "contained" : "text",
        size: "small",
        title: "Label",
        sx: {
          padding: 0
        },
        children: /* @__PURE__ */ f.jsx(J, { sx: {
          border: `1px solid ${t.custom.grey[500]}`,
          background: "#FEFCFBCC",
          borderRadius: t.spacing(1),
          padding: t.spacing(0.125, 0.75),
          margin: t.spacing(0.5)
        }, children: /* @__PURE__ */ f.jsx(oe, { fontSize: t.spacing(2), variant: "body-medium", color: "currentColor", fontWeight: t.typography.fontWeightBold, children: "L" }) })
      }
    ),
    /* @__PURE__ */ f.jsx(
      Hge,
      {
        size: "small",
        variant: e.isActive("textStyle") && ((n = e.getAttributes("textStyle")) != null && n.color) ? "contained" : "text",
        onChange: (d) => {
          const u = e.isActive("label");
          e.chain().focus().setColor(d).run(), u && !e.isActive("label") && e.chain().focus().toggleLabel().run();
        },
        currentColor: (o = e.getAttributes("textStyle")) == null ? void 0 : o.color
      }
    ),
    /* @__PURE__ */ f.jsx(
      Gge,
      {
        size: "small",
        variant: e.isActive("textStyle") && ((r = e.getAttributes("textStyle")) != null && r.backgroundColor) ? "contained" : "text",
        onChange: (d) => {
          const u = e.isActive("label");
          e.chain().focus().setBackgroundColor(d).run(), u && !e.isActive("label") && e.chain().focus().toggleLabel().run();
        },
        currentColor: (i = e.getAttributes("textStyle")) == null ? void 0 : i.backgroundColor,
        onRemove: () => {
          const d = e.isActive("label");
          e.chain().focus().unsetBackgroundColor().run(), d && !e.isActive("label") && e.chain().focus().toggleLabel().run();
        }
      }
    ),
    /* @__PURE__ */ f.jsx(
      Xge,
      {
        size: "small",
        variant: e.isActive("textStyle") && ((s = e.getAttributes("textStyle")) != null && s.borderRadius) ? "contained" : "text",
        onChange: (d) => {
          const u = e.isActive("label");
          e.chain().focus().setBorderRadius(d).run(), u && !e.isActive("label") && e.chain().focus().toggleLabel().run();
        },
        currentRadius: (a = e.getAttributes("textStyle")) != null && a.borderRadius ? parseInt((c = e.getAttributes("textStyle")) == null ? void 0 : c.borderRadius, 10) : 0
      }
    )
  ] }) }) : null;
}
var q8 = {}, Qge = ht;
Object.defineProperty(q8, "__esModule", {
  value: !0
});
var u_ = q8.default = void 0, eme = Qge(bt()), tme = f;
u_ = q8.default = (0, eme.default)(/* @__PURE__ */ (0, tme.jsx)("path", {
  d: "M15 15H3v2h12zm0-8H3v2h12zM3 13h18v-2H3zm0 8h18v-2H3zM3 3v2h18V3z"
}), "FormatAlignLeft");
var K8 = {}, nme = ht;
Object.defineProperty(K8, "__esModule", {
  value: !0
});
var f_ = K8.default = void 0, ome = nme(bt()), rme = f;
f_ = K8.default = (0, ome.default)(/* @__PURE__ */ (0, rme.jsx)("path", {
  d: "M7 15v2h10v-2zm-4 6h18v-2H3zm0-8h18v-2H3zm4-6v2h10V7zM3 3v2h18V3z"
}), "FormatAlignCenter");
var Y8 = {}, ime = ht;
Object.defineProperty(Y8, "__esModule", {
  value: !0
});
var p_ = Y8.default = void 0, sme = ime(bt()), ame = f;
p_ = Y8.default = (0, sme.default)(/* @__PURE__ */ (0, ame.jsx)("path", {
  d: "M3 21h18v-2H3zm6-4h12v-2H9zm-6-4h18v-2H3zm6-4h12V7H9zM3 3v2h18V3z"
}), "FormatAlignRight");
function lme({ editor: e }) {
  return /* @__PURE__ */ f.jsxs(be, { direction: "row", gap: 1, p: 0.5, children: [
    /* @__PURE__ */ f.jsx(
      Lo,
      {
        size: "small",
        variant: e.isActive({ textAlign: "left" }) ? "contained" : "text",
        onClick: () => e.chain().focus().setTextAlign("left").run(),
        children: /* @__PURE__ */ f.jsx(u_, {})
      }
    ),
    /* @__PURE__ */ f.jsx(
      Lo,
      {
        size: "small",
        variant: e.isActive({ textAlign: "center" }) ? "contained" : "text",
        onClick: () => e.chain().focus().setTextAlign("center").run(),
        children: /* @__PURE__ */ f.jsx(f_, {})
      }
    ),
    /* @__PURE__ */ f.jsx(
      Lo,
      {
        size: "small",
        variant: e.isActive({ textAlign: "right" }) ? "contained" : "text",
        onClick: () => e.chain().focus().setTextAlign("right").run(),
        children: /* @__PURE__ */ f.jsx(p_, {})
      }
    )
  ] });
}
function cme({ editor: e }) {
  const [t, n] = Ae(co.DEFAULTS.SIZE), [o, r] = Ae(co.DEFAULTS.FAMILY), i = pr(() => {
    if (!e) return "paragraph";
    if (e.isActive("code")) return "code";
    for (let p = 1; p <= 6; p++)
      if (e.isActive("heading", { level: p }))
        return `h${p}`;
    return "paragraph";
  }, [e]), [s, a] = Ae(i());
  mt(() => {
    if (!e) return;
    const p = () => {
      const h = e.getAttributes("textStyle");
      n(h.fontSize || co.DEFAULTS.SIZE), r(h.fontFamily || co.DEFAULTS.FAMILY);
      const g = i();
      a(g);
    };
    return p(), e.on("selectionUpdate", p), e.on("transaction", p), () => {
      e.off("selectionUpdate", p), e.off("transaction", p);
    };
  }, [e, i]);
  const c = pr((p) => {
    e.chain().focus().setFontSize(p).run(), n(p);
  }, [e]), d = pr((p) => {
    const h = p === co.DEFAULTS.FAMILY ? "" : p;
    e.chain().focus().setFontFamily(h).run(), r(p);
  }, [e]), u = (p) => {
    if (e) {
      if (e.chain().focus().unsetAllMarks().clearNodes().run(), String(p) === "paragraph")
        e.chain().focus().setParagraph().run();
      else if (String(p) === "code")
        e.chain().focus().setCode().run();
      else {
        const h = parseInt(String(p).charAt(1));
        ((m) => m >= 1 && m <= 6)(h) && e.chain().focus().toggleHeading({ level: h }).run();
      }
      a(String(p));
    }
  };
  return /* @__PURE__ */ f.jsxs(be, { direction: "row", gap: 1, alignItems: "center", pl: 1.5, children: [
    /* @__PURE__ */ f.jsx(
      Cp,
      {
        size: "small",
        value: s,
        onChange: (p) => u(p.target.value),
        MenuProps: xp,
        renderValue: (p) => typeof p == "string" ? p : "",
        children: Vge.PRESETS.map((p) => /* @__PURE__ */ f.jsx(
          Jo,
          {
            value: p.value,
            sx: yp,
            children: /* @__PURE__ */ f.jsx(J, { sx: { fontFamily: o }, children: p.htmllabel })
          },
          p.value
        ))
      }
    ),
    /* @__PURE__ */ f.jsx(
      Cp,
      {
        value: o,
        onChange: (p) => d(p.target.value),
        MenuProps: xp,
        children: co.FAMILIES.map((p) => /* @__PURE__ */ f.jsx(Jo, { value: p, sx: { ...yp, fontFamily: p }, children: p }, p))
      }
    ),
    /* @__PURE__ */ f.jsx(
      Cp,
      {
        value: t,
        width: 90,
        onChange: (p) => c(p.target.value),
        MenuProps: xp,
        children: co.SIZES.map((p) => /* @__PURE__ */ f.jsx(Jo, { value: p, sx: yp, children: p }, p))
      }
    )
  ] });
}
function dme({ editor: e }) {
  return /* @__PURE__ */ f.jsxs(be, { direction: "row", gap: 1, p: 0.5, children: [
    /* @__PURE__ */ f.jsx(
      Lo,
      {
        size: "small",
        variant: e.isActive("bulletList") ? "contained" : "text",
        onClick: () => e.chain().focus().toggleBulletList().run(),
        children: /* @__PURE__ */ f.jsx(pK, {})
      }
    ),
    /* @__PURE__ */ f.jsx(
      Lo,
      {
        size: "small",
        variant: e.isActive("orderedList") ? "contained" : "text",
        onClick: () => e.chain().focus().toggleOrderedList().run(),
        children: /* @__PURE__ */ f.jsx(hK, {})
      }
    )
  ] });
}
const ume = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4.9443%2016.3611V13.5833H12.0554C12.8269%2013.5833%2013.4874%2013.8542%2014.0368%2014.3958C14.5863%2014.9375%2014.9073%2015.5926%2014.9998%2016.3611H4.9443ZM9.7188%2031.8889C11.1839%2031.8889%2012.4304%2031.3761%2013.4582%2030.3505C14.4859%2029.3249%2014.9998%2028.0795%2014.9998%2026.6144C14.9998%2025.1492%2014.487%2023.9028%2013.4614%2022.875C12.4358%2021.8472%2011.1905%2021.3333%209.72534%2021.3333C8.26017%2021.3333%207.0137%2021.8461%205.98592%2022.8717C4.95814%2023.8973%204.44425%2025.1427%204.44425%2026.6078C4.44425%2028.073%204.95706%2029.3195%205.98267%2030.3472C7.00828%2031.375%208.25366%2031.8889%209.7188%2031.8889ZM32.6338%2031.8889C33.4427%2031.8889%2034.1318%2031.6058%2034.7013%2031.0396C35.2707%2030.4735%2035.5554%2029.786%2035.5554%2028.9771C35.5554%2028.1683%2035.2723%2027.4792%2034.7061%2026.9097C34.14%2026.3403%2033.4525%2026.0555%2032.6436%2026.0555C31.8348%2026.0555%2031.1457%2026.3386%2030.5762%2026.9048C30.0068%2027.471%2029.722%2028.1585%2029.722%2028.9673C29.722%2029.7762%2030.0051%2030.4653%2030.5713%2031.0347C31.1375%2031.6042%2031.825%2031.8889%2032.6338%2031.8889ZM9.72534%2029.3889C8.95462%2029.3889%208.29842%2029.1192%207.75675%2028.5797C7.21509%2028.0402%206.94425%2027.3851%206.94425%2026.6144C6.94425%2025.8437%207.214%2025.1875%207.7535%2024.6458C8.293%2024.1042%208.9481%2023.8333%209.7188%2023.8333C10.4895%2023.8333%2011.1457%2024.1031%2011.6873%2024.6426C12.229%2025.1821%2012.4998%2025.8371%2012.4998%2026.6078C12.4998%2027.3786%2012.2301%2028.0347%2011.6906%2028.5764C11.1511%2029.1181%2010.496%2029.3889%209.72534%2029.3889ZM33.611%2023.3473C34.2035%2023.4861%2034.6943%2023.6505%2035.0832%2023.8403C35.4721%2024.0301%2035.9072%2024.3241%2036.3887%2024.7222V11.3611H22.5554L20.6109%209.38888L23.1109%206.88888L22.222%206L16.3332%2011.8889L17.2498%2012.8055L19.722%2010.3333L21.6665%2012.24V16.4167C21.6665%2017.4938%2021.2938%2018.4158%2020.5485%2019.1828C19.8031%2019.9498%2018.8887%2020.3333%2017.8054%2020.3333H14.7637C15.2915%2020.75%2015.7082%2021.162%2016.0137%2021.5695C16.3193%2021.9769%2016.648%2022.4908%2016.9998%2023.1111H17.8054C19.6202%2023.1111%2021.1804%2022.4491%2022.4859%2021.125C23.7915%2019.8009%2024.4443%2018.2315%2024.4443%2016.4167V14.1389H33.611V23.3473ZM27.0415%2028C27.2082%2027.3426%2027.391%2026.8218%2027.5901%2026.4375C27.7892%2026.0532%2028.0832%2025.6389%2028.472%2025.1945H17.6665C17.7406%2025.7408%2017.7776%2026.2084%2017.7776%2026.5973C17.7776%2026.9861%2017.7406%2027.4537%2017.6665%2028H27.0415ZM32.6526%2034.6667C31.0693%2034.6667%2029.7221%2034.1189%2028.611%2033.0234C27.4999%2031.9279%2026.9443%2030.6053%2026.9443%2029.0555C26.9443%2027.4598%2027.5083%2026.0979%2028.6363%2024.9698C29.7644%2023.8418%2031.1263%2023.2778%2032.722%2023.2778C34.2718%2023.2778%2035.5944%2023.8337%2036.6899%2024.9455C37.7854%2026.0572%2038.3332%2027.3995%2038.3332%2028.9722C38.3332%2030.5648%2037.7822%2031.912%2036.6804%2033.0139C35.5785%2034.1157%2034.236%2034.6667%2032.6526%2034.6667ZM9.6665%2034.6667C7.43503%2034.6667%205.54382%2033.8813%203.99288%2032.3104C2.44196%2030.7396%201.6665%2028.8398%201.6665%2026.6111C1.6665%2024.3824%202.45123%2022.4827%204.02067%2020.9118C5.59012%2019.341%207.48959%2018.5556%209.71909%2018.5556C11.9486%2018.5556%2013.8491%2019.3413%2015.4205%2020.9127C16.9919%2022.4841%2017.7776%2024.3846%2017.7776%2026.6141C17.7776%2028.8436%2016.9929%2030.7431%2015.4234%2032.3125C13.854%2033.8819%2011.935%2034.6667%209.6665%2034.6667Z'%20fill='currentColor'/%3e%3c/svg%3e", fme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M20.5555%207.2222C20.5555%208.06478%2020.2569%208.78469%2019.6597%209.38191C19.0625%209.97913%2018.3426%2010.2777%2017.5%2010.2777C17.1389%2010.2777%2016.8009%2010.2199%2016.4861%2010.1042C16.1713%209.98841%2015.8704%209.81942%2015.5833%209.5972C14.8611%209.96756%2014.2662%2010.4814%2013.7986%2011.1389C13.331%2011.7963%2013.0879%2012.5278%2013.0694%2013.3333H35L33.3333%2025H25.7778V22.2222H31.0139C31.1713%2021.2037%2031.3171%2020.1852%2031.4514%2019.1667C31.5857%2018.1481%2031.7315%2017.1296%2031.8889%2016.1111H8.11108C8.2685%2017.1296%208.41433%2018.1481%208.54858%2019.1667C8.68286%2020.1852%208.82869%2021.2037%208.98608%2022.2222H14.2222V25H6.66667L5%2013.3333H10.2778C10.2963%2011.9722%2010.6852%2010.7361%2011.4445%209.62499C12.2037%208.51388%2013.2037%207.65739%2014.4445%207.05553C14.4907%206.23148%2014.8055%205.54398%2015.3889%204.99303C15.9722%204.44212%2016.6759%204.16666%2017.5%204.16666C18.3426%204.16666%2019.0625%204.46527%2019.6597%205.06249C20.2569%205.65971%2020.5555%206.37962%2020.5555%207.2222ZM15.8194%2032.2222H24.1806L25.2778%2021.1111H14.7222L15.8194%2032.2222ZM13.3333%2035L12%2021.3889C11.9259%2020.5833%2012.1667%2019.8727%2012.7222%2019.2569C13.2778%2018.6412%2013.9583%2018.3333%2014.7639%2018.3333H25.2361C26.0417%2018.3333%2026.7222%2018.6412%2027.2778%2019.2569C27.8333%2019.8727%2028.0741%2020.5833%2028%2021.3889L26.6667%2035H13.3333Z'%20fill='currentColor'/%3e%3c/svg%3e", pme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M19.7642%205.27954H11.2622C7.24731%205.27954%204%208.31194%204%2012.0611V28.3258C4%2030.3657%205.00371%2032.2402%206.59785%2033.5083L19.7642%205.27954Z'%20fill='currentColor'/%3e%3cpath%20d='M17.9346%2021.3236L25.4328%205.27954H28.6802C32.695%205.27954%2035.9424%208.36707%2035.9424%2012.0611V21.3236H17.9346Z'%20fill='currentColor'/%3e%3cpath%20d='M15.6895%2026.1746H36V28.3248C36%2032.074%2032.6936%2035.1063%2028.7378%2035.1063H11.4976L15.6895%2026.1746Z'%20fill='currentColor'/%3e%3c/svg%3e", hme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M15.1252%2027.0834L20.0002%2024.125L24.8752%2027.0834L23.5835%2021.5417L27.9169%2017.7917L22.2085%2017.3334L20.0002%2012.0834L17.7919%2017.3334L12.0835%2017.7917L16.4169%2021.5417L15.1252%2027.0834ZM20.028%2038.8056L14.4169%2033.3334H6.66687V25.5834L1.11133%2020L6.66687%2014.4167V6.66669H14.4169L20.028%201.11115L25.5835%206.66669H33.3335V14.4167L38.8891%2020L33.3335%2025.5834V33.3334H25.5835L20.028%2038.8056ZM20.028%2034.9167L24.4146%2030.5556H30.5558V24.4167L34.9725%2020L30.5558%2015.5834V9.44444H24.4169L20.028%205.02777L15.5835%209.44444H9.44462V15.5834L5.02795%2020L9.44462%2024.4167V30.5556H15.5557L20.028%2034.9167Z'%20fill='currentColor'/%3e%3c/svg%3e", gme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M6.11125%2035C5.36125%2035%204.71079%2034.7246%204.15987%2034.1737C3.60895%2033.6227%203.3335%2032.9723%203.3335%2032.2223V12.7778C3.3335%2012.0278%203.60895%2011.3773%204.15987%2010.8264C4.71079%2010.2755%205.36125%2010%206.11125%2010H13.3335V6.11112C13.3335%205.36112%2013.609%204.71067%2014.1599%204.15975C14.7108%203.60883%2015.3612%203.33337%2016.1112%203.33337H23.8891C24.6391%203.33337%2025.2895%203.60883%2025.8405%204.15975C26.3914%204.71067%2026.6668%205.36112%2026.6668%206.11112V10H33.8891C34.6391%2010%2035.2895%2010.2755%2035.8405%2010.8264C36.3914%2011.3773%2036.6668%2012.0278%2036.6668%2012.7778V32.2223C36.6668%2032.9723%2036.3914%2033.6227%2035.8405%2034.1737C35.2895%2034.7246%2034.6391%2035%2033.8891%2035H6.11125ZM16.1112%2010H23.8891V6.11112H16.1112V10ZM33.8891%2024.6945H24.1946V27.4722H15.8613V24.6945H6.11125V32.2223H33.8891V24.6945ZM18.6391%2024.6945H21.4168V21.9167H18.6391V24.6945ZM6.11125%2021.9167H15.8613V19.139H24.1946V21.9167H33.8891V12.7778H6.11125V21.9167Z'%20fill='currentColor'/%3e%3c/svg%3e", mme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M16.8332%2024.8333V15.1667H24.8332V24.8333H16.8332ZM18.9998%2022.6667H22.6665V17.3333H18.9998V22.6667ZM5.1665%2024.8333V15.1667H13.1665V18.1667H10.9998V17.3333H7.33317V22.6667H10.9998V21.8333H13.1665V24.8333H5.1665ZM28.4998%2029.8333V24.3333H33.4998V22.3333H28.4998V20.1667H35.6665V25.6667H30.6665V27.6667H35.6665V29.8333H28.4998Z'%20fill='currentColor'/%3e%3c/svg%3e", bme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18.6111%2034.7222V21.7083H18.0555C16.2778%2021.7083%2014.5926%2021.3681%2013%2020.6875C11.4074%2020.0069%209.99537%2019.0417%208.76387%2017.7917C7.5324%2016.5417%206.59722%2015.0972%205.95833%2013.4583C5.31944%2011.8194%205%2010.1111%205%208.33333V5H8.28671C10.0122%205%2011.6759%205.34028%2013.2778%206.02083C14.8796%206.70139%2016.3055%207.66667%2017.5555%208.91667C18.4537%209.83333%2019.1968%2010.8518%2019.7847%2011.9722C20.3727%2013.0926%2020.8009%2014.2824%2021.0695%2015.5417C21.2573%2015.2565%2021.464%2014.9815%2021.6895%2014.7167C21.915%2014.4519%2022.1528%2014.1852%2022.4028%2013.9167C23.6528%2012.6667%2025.0787%2011.7014%2026.6805%2011.0208C28.2824%2010.3403%2029.9599%2010%2031.713%2010H35V13.3333C35%2015.1111%2034.6646%2016.8194%2033.9937%2018.4583C33.3228%2020.0972%2032.3712%2021.5417%2031.1389%2022.7917C29.8889%2024.0417%2028.4693%2025%2026.8802%2025.6667C25.2912%2026.3333%2023.6274%2026.6667%2021.8889%2026.6667H21.3889V34.7222H18.6111ZM18.6389%2018.8889C18.6389%2017.3148%2018.3681%2015.8403%2017.8264%2014.4653C17.2847%2013.0903%2016.5324%2011.9074%2015.5695%2010.9167C14.6065%209.92592%2013.4514%209.15508%2012.1042%208.60417C10.7569%208.05322%209.31481%207.77775%207.77775%207.77775C7.77775%209.38889%208.03239%2010.8843%208.54167%2012.2639C9.05092%2013.6435%209.78703%2014.8333%2010.75%2015.8333C11.8426%2016.9815%2013.0417%2017.7778%2014.3472%2018.2222C15.6528%2018.6667%2017.0833%2018.8889%2018.6389%2018.8889ZM21.3889%2023.8889C22.9444%2023.8889%2024.3958%2023.625%2025.743%2023.0973C27.0903%2022.5695%2028.2454%2021.8102%2029.2083%2020.8195C30.1713%2019.8287%2030.9144%2018.6435%2031.4375%2017.2639C31.9607%2015.8843%2032.2222%2014.3889%2032.2222%2012.7778C30.6667%2012.7778%2029.213%2013.0532%2027.8611%2013.6042C26.5093%2014.1551%2025.3518%2014.9213%2024.3889%2015.9028C23.2778%2017.0509%2022.5%2018.2801%2022.0555%2019.5903C21.6111%2020.9005%2021.3889%2022.3333%2021.3889%2023.8889Z'%20fill='currentColor'/%3e%3c/svg%3e", Cme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.83333%2038.3333C8.49075%2038.3333%207.34954%2037.8634%206.40971%2036.9236C5.4699%2035.9838%205%2034.8426%205%2033.5C5%2032.1574%205.4699%2031.0162%206.40971%2030.0764C7.34954%2029.1366%208.49075%2028.6667%209.83333%2028.6667C10.2222%2028.6667%2010.5694%2028.7037%2010.875%2028.7778C11.1806%2028.8519%2011.4861%2028.9584%2011.7917%2029.0972L14.9445%2025.1667C14.3333%2024.4537%2013.8843%2023.6435%2013.5973%2022.7361C13.3102%2021.8287%2013.2408%2020.8982%2013.3889%2019.9445L8.90275%2018.4305C8.46758%2019.125%207.90278%2019.6713%207.20833%2020.0695C6.51389%2020.4676%205.72222%2020.6667%204.83333%2020.6667C3.49075%2020.6667%202.34954%2020.1968%201.40971%2019.257C0.469903%2018.3171%200%2017.1759%200%2015.8333C0%2014.4908%200.469903%2013.3495%201.40971%2012.4097C2.34954%2011.4699%203.49075%2011%204.83333%2011C6.17592%2011%207.31711%2011.4699%208.25692%2012.4097C9.19675%2013.3495%209.66667%2014.4908%209.66667%2015.8333V16.0555L14.1806%2017.6111C14.6991%2016.6852%2015.3496%2015.9491%2016.132%2015.4028C16.9144%2014.8565%2017.7871%2014.4862%2018.75%2014.2917V9.5C17.6667%209.19444%2016.7986%208.59953%2016.1458%207.71525C15.4931%206.831%2015.1667%205.87036%2015.1667%204.83333C15.1667%203.49075%2015.6366%202.34954%2016.5764%201.40971C17.5162%200.469903%2018.6574%200%2020%200C21.3426%200%2022.4838%200.469903%2023.4236%201.40971C24.3634%202.34954%2024.8333%203.49075%2024.8333%204.83333C24.8333%205.87036%2024.5%206.831%2023.8333%207.71525C23.1667%208.59953%2022.3056%209.19444%2021.25%209.5V14.2917C22.2129%2014.4862%2023.0903%2014.8565%2023.8819%2015.4028C24.6736%2015.9491%2025.3287%2016.6852%2025.8472%2017.6111L30.3333%2016.0555V15.8333C30.3333%2014.4908%2030.8033%2013.3495%2031.7431%2012.4097C32.6829%2011.4699%2033.8241%2011%2035.1667%2011C36.5093%2011%2037.6505%2011.4699%2038.5903%2012.4097C39.5301%2013.3495%2040%2014.4908%2040%2015.8333C40%2017.1759%2039.5301%2018.3171%2038.5903%2019.257C37.6505%2020.1968%2036.5093%2020.6667%2035.1667%2020.6667C34.2778%2020.6667%2033.4792%2020.4676%2032.7708%2020.0695C32.0625%2019.6713%2031.5046%2019.125%2031.0972%2018.4305L26.6111%2019.9445C26.7592%2020.8982%2026.6944%2021.8264%2026.4166%2022.7292C26.1388%2023.6319%2025.6852%2024.4444%2025.0555%2025.1667L28.2083%2029.0833C28.5139%2028.9444%2028.8194%2028.8403%2029.125%2028.7708C29.4306%2028.7014%2029.7737%2028.6667%2030.1545%2028.6667C31.5145%2028.6667%2032.662%2029.1366%2033.5972%2030.0764C34.5324%2031.0162%2035%2032.1574%2035%2033.5C35%2034.8426%2034.5301%2035.9838%2033.5903%2036.9236C32.6505%2037.8634%2031.5093%2038.3333%2030.1667%2038.3333C28.8241%2038.3333%2027.6829%2037.8634%2026.7431%2036.9236C25.8033%2035.9838%2025.3333%2034.8426%2025.3333%2033.5C25.3333%2032.9444%2025.4144%2032.4329%2025.5764%2031.9653C25.7384%2031.4977%2025.963%2031.0556%2026.25%2030.6389L23.0972%2026.7083C22.1227%2027.2361%2021.0827%2027.5%2019.9774%2027.5C18.8721%2027.5%2017.8333%2027.2361%2016.8611%2026.7083L13.75%2030.6667C14.037%2031.0833%2014.2616%2031.5208%2014.4236%2031.9792C14.5856%2032.4375%2014.6667%2032.9444%2014.6667%2033.5C14.6667%2034.8426%2014.1967%2035.9838%2013.2569%2036.9236C12.3171%2037.8634%2011.1759%2038.3333%209.83333%2038.3333ZM4.83429%2017.8889C5.41699%2017.8889%205.9051%2017.6918%206.29863%2017.2976C6.69213%2016.9035%206.88888%2016.415%206.88888%2015.8324C6.88888%2015.2497%206.69179%2014.7616%206.29763%2014.368C5.90346%2013.9745%205.41503%2013.7778%204.83233%2013.7778C4.24967%2013.7778%203.76157%2013.9748%203.36804%2014.369C2.97451%2014.7632%202.77775%2015.2516%202.77775%2015.8343C2.77775%2016.417%202.97483%2016.9051%203.369%2017.2986C3.76317%2017.6922%204.2516%2017.8889%204.83429%2017.8889ZM9.83429%2035.5556C10.417%2035.5556%2010.9051%2035.3585%2011.2986%2034.9643C11.6921%2034.5701%2011.8889%2034.0817%2011.8889%2033.499C11.8889%2032.9163%2011.6918%2032.4282%2011.2976%2032.0347C10.9035%2031.6412%2010.415%2031.4445%209.83233%2031.4445C9.24967%2031.4445%208.76157%2031.6415%208.36804%2032.0357C7.97451%2032.4299%207.77775%2032.9183%207.77775%2033.501C7.77775%2034.0837%207.97483%2034.5718%208.369%2034.9653C8.7632%2035.3588%209.25163%2035.5556%209.83429%2035.5556ZM20.001%206.88888C20.5837%206.88888%2021.0718%206.69179%2021.4653%206.29763C21.8588%205.90346%2022.0556%205.41504%2022.0556%204.83237C22.0556%204.24968%2021.8585%203.76157%2021.4643%203.36804C21.0701%202.97451%2020.5817%202.77775%2019.999%202.77775C19.4163%202.77775%2018.9282%202.97483%2018.5347%203.369C18.1412%203.7632%2017.9444%204.25163%2017.9444%204.83429C17.9444%205.41699%2018.1415%205.9051%2018.5357%206.29862C18.9299%206.69212%2019.4183%206.88888%2020.001%206.88888ZM20.0139%2024.7222C21.0972%2024.7222%2022.0139%2024.3426%2022.7639%2023.5833C23.5139%2022.8241%2023.8889%2021.9028%2023.8889%2020.8195C23.8889%2019.7361%2023.5129%2018.8195%2022.7611%2018.0695C22.0093%2017.3195%2021.0889%2016.9445%2020%2016.9445C18.9259%2016.9445%2018.0093%2017.3204%2017.25%2018.0722C16.4907%2018.8241%2016.1111%2019.7444%2016.1111%2020.8333C16.1111%2021.9074%2016.4907%2022.8241%2017.25%2023.5833C18.0093%2024.3426%2018.9305%2024.7222%2020.0139%2024.7222ZM30.1676%2035.5556C30.7503%2035.5556%2031.2384%2035.3585%2031.632%2034.9643C32.0255%2034.5701%2032.2223%2034.0817%2032.2223%2033.499C32.2223%2032.9163%2032.0252%2032.4282%2031.631%2032.0347C31.2368%2031.6412%2030.7484%2031.4445%2030.1657%2031.4445C29.583%2031.4445%2029.0949%2031.6415%2028.7014%2032.0357C28.3079%2032.4299%2028.1111%2032.9183%2028.1111%2033.501C28.1111%2034.0837%2028.3082%2034.5718%2028.7024%2034.9653C29.0965%2035.3588%2029.585%2035.5556%2030.1676%2035.5556ZM35.1676%2017.8889C35.7503%2017.8889%2036.2384%2017.6918%2036.632%2017.2976C37.0255%2016.9035%2037.2223%2016.415%2037.2223%2015.8324C37.2223%2015.2497%2037.0252%2014.7616%2036.631%2014.368C36.2368%2013.9745%2035.7484%2013.7778%2035.1657%2013.7778C34.583%2013.7778%2034.0949%2013.9748%2033.7014%2014.369C33.3079%2014.7632%2033.1111%2015.2516%2033.1111%2015.8343C33.1111%2016.417%2033.3082%2016.9051%2033.7024%2017.2986C34.0965%2017.6922%2034.585%2017.8889%2035.1676%2017.8889Z'%20fill='currentColor'/%3e%3c/svg%3e", xme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M30.278%2021.3889V18.6111H36.6668V21.3889H30.278ZM32.3335%2033.3333L27.1946%2029.5L28.8613%2027.2778L34.0002%2031.1111L32.3335%2033.3333ZM28.9446%2012.6944L27.278%2010.4722L32.3335%206.66666L34.0002%208.88887L28.9446%2012.6944ZM8.61129%2031.6667V25H6.11125C5.34736%2025%204.69343%2024.728%204.14945%2024.184C3.60548%2023.6401%203.3335%2022.9861%203.3335%2022.2222V17.7777C3.3335%2017.0139%203.60548%2016.3599%204.14945%2015.8159C4.69343%2015.272%205.34736%2015%206.11125%2015H13.3335L21.6668%209.99999V30L13.3335%2025H11.389V31.6667H8.61129ZM18.8891%2025.0834V14.9166L14.0835%2017.7777H6.11125V22.2222H14.0835L18.8891%2025.0834ZM23.3335%2025.5833V14.4167C24.0835%2015.0833%2024.6877%2015.8958%2025.146%2016.8542C25.6043%2017.8125%2025.8335%2018.8611%2025.8335%2020C25.8335%2021.1389%2025.6043%2022.1875%2025.146%2023.1458C24.6877%2024.1042%2024.0835%2024.9167%2023.3335%2025.5833Z'%20fill='currentColor'/%3e%3c/svg%3e", yme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.8054%2036.6667V21.3612C10.3702%2021.0278%209.15493%2020.2825%208.15955%2019.125C7.16418%2017.9676%206.6665%2016.5926%206.6665%2015V3.33337H9.44425V15H11.8054V3.33337H14.5832V15H16.9443V3.33337H19.722V15C19.722%2016.5926%2019.2244%2017.9676%2018.229%2019.125C17.2336%2020.2825%2016.0183%2021.0278%2014.5832%2021.3612V36.6667H11.8054ZM28.8888%2036.6667V23.3334H24.0276V10.9723C24.0276%208.74078%2024.7429%206.90976%2026.1735%205.47921C27.604%204.04865%2029.435%203.33337%2031.6665%203.33337V36.6667H28.8888Z'%20fill='currentColor'/%3e%3c/svg%3e", vme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M3.3335%2035V5H19.7224V11.8055H36.6668V35H3.3335ZM6.11125%2032.2222H16.9446V28.1945H6.11125V32.2222ZM6.11125%2025.4167H16.9446V21.3889H6.11125V25.4167ZM6.11125%2018.6111H16.9446V14.5833H6.11125V18.6111ZM6.11125%2011.8055H16.9446V7.77775H6.11125V11.8055ZM19.7224%2032.2222H33.8891V14.5833H19.7224V32.2222ZM23.0557%2021.3889V18.6111H29.8613V21.3889H23.0557ZM23.0557%2028.1945V25.4167H29.8613V28.1945H23.0557Z'%20fill='currentColor'/%3e%3c/svg%3e", wme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M36.3888%2038.3333L31.5554%2033.5C30.9629%2033.9353%2030.3194%2034.2478%2029.625%2034.4375C28.9306%2034.6272%2028.2222%2034.7221%2027.5%2034.7221C25.4939%2034.7221%2023.7886%2034.0196%2022.3842%2032.6146C20.98%2031.2099%2020.2779%2029.5039%2020.2779%2027.4967C20.2779%2025.4897%2020.9804%2023.7849%2022.3854%2022.3821C23.7901%2020.9793%2025.4961%2020.2779%2027.5033%2020.2779C29.5103%2020.2779%2031.2151%2020.98%2032.6179%2022.3842C34.0207%2023.7886%2034.7221%2025.4939%2034.7221%2027.5C34.7221%2028.2222%2034.6272%2028.9351%2034.4375%2029.6387C34.2478%2030.3426%2033.9353%2030.9815%2033.5%2031.5554L38.3333%2036.3887L36.3888%2038.3333ZM27.4963%2031.9446C28.7396%2031.9446%2029.7918%2031.5153%2030.6529%2030.6567C31.514%2029.798%2031.9446%2028.7471%2031.9446%2027.5037C31.9446%2026.2604%2031.5153%2025.2082%2030.6567%2024.3471C29.7981%2023.486%2028.7471%2023.0554%2027.5038%2023.0554C26.2604%2023.0554%2025.2082%2023.4847%2024.3471%2024.3433C23.486%2025.2019%2023.0554%2026.2529%2023.0554%2027.4962C23.0554%2028.7396%2023.4847%2029.7918%2024.3433%2030.6529C25.2019%2031.514%2026.2529%2031.9446%2027.4963%2031.9446ZM35%2016.3054H32.2221V7.77791H29.4446V11.9446H10.5554V7.77791H7.77792V32.2221H17.5V35H5V4.99999H15.7083C15.9397%204.02777%2016.4582%203.22916%2017.2638%202.60416C18.0693%201.97916%2018.9814%201.66666%2020%201.66666C21.0369%201.66666%2021.956%201.97916%2022.7571%202.60416C23.5579%203.22916%2024.074%204.02777%2024.3054%204.99999H35V16.3054ZM20%207.77791C20.4722%207.77791%2020.8681%207.61818%2021.1875%207.29874C21.5069%206.97929%2021.6667%206.58346%2021.6667%206.11124C21.6667%205.63902%2021.5069%205.24318%2021.1875%204.92374C20.8681%204.60429%2020.4722%204.44457%2020%204.44457C19.5278%204.44457%2019.1319%204.60429%2018.8125%204.92374C18.4931%205.24318%2018.3333%205.63902%2018.3333%206.11124C18.3333%206.58346%2018.4931%206.97929%2018.8125%207.29874C19.1319%207.61818%2019.5278%207.77791%2020%207.77791Z'%20fill='currentColor'/%3e%3c/svg%3e", Sme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M35.2285%2018.3889V35H4.74716V18.3889C4.00461%2017.75%203.49001%2016.9537%203.20335%2016C2.91667%2015.0463%202.93311%2014.0648%203.25267%2013.0555L5.83273%205H34.1147L36.7512%2013.0555C37.0707%2014.0648%2037.0825%2015.0417%2036.7864%2015.9861C36.4904%2016.9306%2035.971%2017.7315%2035.2285%2018.3889ZM23.7804%2016.9445C24.5793%2016.9445%2025.2325%2016.6829%2025.7401%2016.1597C26.2476%2015.6366%2026.4497%2015.0185%2026.3464%2014.3055L25.3313%207.77775H21.4118V14.4167C21.4118%2015.0926%2021.6374%2015.6829%2022.0885%2016.1875C22.5397%2016.6921%2023.1037%2016.9445%2023.7804%2016.9445ZM15.9697%2016.9445C16.7122%2016.9445%2017.3349%2016.6968%2017.8378%2016.2014C18.3406%2015.706%2018.5921%2015.1111%2018.5921%2014.4167V7.77775H14.6726L13.6575%2014.3055C13.5447%2015.0093%2013.7256%2015.625%2014.2003%2016.1528C14.675%2016.6806%2015.2648%2016.9445%2015.9697%2016.9445ZM8.3282%2016.9445C8.94854%2016.9445%209.48664%2016.7315%209.94251%2016.3055C10.3984%2015.8796%2010.6686%2015.3518%2010.7532%2014.7222L11.7965%207.77775H7.87702L6.016%2013.6945C5.77164%2014.4537%205.87738%2015.1852%206.33322%2015.8889C6.78909%2016.5926%207.45408%2016.9445%208.3282%2016.9445ZM31.6475%2016.9445C32.5216%2016.9445%2033.1936%2016.5972%2033.6636%2015.9028C34.1335%2015.2083%2034.2416%2014.4722%2033.9878%2013.6945L32.0986%207.77775H28.2073L29.2507%2014.7222C29.3353%2015.3518%2029.6055%2015.8796%2030.0614%2016.3055C30.5172%2016.7315%2031.0459%2016.9445%2031.6475%2016.9445ZM7.56687%2032.2222H32.4088V19.6667C32.3806%2019.7037%2032.2889%2019.7222%2032.1339%2019.7222H31.6475C30.9237%2019.7222%2030.254%2019.5833%2029.6384%2019.3055C29.0227%2019.0278%2028.4141%2018.5926%2027.8126%2018C27.3426%2018.537%2026.774%2018.9583%2026.1067%2019.2639C25.4393%2019.5694%2024.7109%2019.7222%2023.9214%2019.7222C23.1036%2019.7222%2022.3822%2019.5972%2021.7572%2019.3472C21.1322%2019.0972%2020.5471%2018.7037%2020.0019%2018.1667C19.5602%2018.6667%2019.0174%2019.0509%2018.3735%2019.3194C17.7297%2019.5879%2017.013%2019.7222%2016.2235%2019.7222C15.3682%2019.7222%2014.6045%2019.5741%2013.9324%2019.2778C13.2604%2018.9815%2012.68%2018.5556%2012.1913%2018C11.5427%2018.5833%2010.9059%2019.0162%2010.2809%2019.2986C9.65583%2019.581%209.00493%2019.7222%208.3282%2019.7222H7.88409C7.73839%2019.7222%207.63265%2019.7037%207.56687%2019.6667V32.2222Z'%20fill='currentColor'/%3e%3c/svg%3e", Mme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M19.9998%2036.6667C19.2591%2036.6667%2018.6017%2036.4885%2018.0276%2036.132C17.4535%2035.7755%2017.0554%2035.2871%2016.8332%2034.6667H13.6665V25.9445C11.898%2024.7871%2010.4975%2023.2917%209.46513%2021.4584C8.43271%2019.625%207.9165%2017.6112%207.9165%2015.4167C7.9165%2012.0556%209.09012%209.20143%2011.4373%206.85421C13.7846%204.50699%2016.6387%203.33337%2019.9998%203.33337C23.3609%203.33337%2026.2151%204.50699%2028.5623%206.85421C30.9096%209.20143%2032.0832%2012.0556%2032.0832%2015.4167C32.0832%2017.6297%2031.567%2019.6482%2030.5345%2021.4723C29.5022%2023.2963%2028.1017%2024.7871%2026.3332%2025.9445V34.6667H23.1665C22.9443%2035.2871%2022.5461%2035.7755%2021.972%2036.132C21.398%2036.4885%2020.7406%2036.6667%2019.9998%2036.6667ZM16.4443%2031.889H23.5554V30.1667H16.4443V31.889ZM16.4443%2028.5H23.5554V26.8612H16.4443V28.5ZM16.0832%2024.0834H18.9443V18.7778L15.1665%2015L16.611%2013.5556L19.9998%2016.9445L23.3887%2013.5556L24.8332%2015L21.0554%2018.7778V24.0834H23.9165C25.5276%2023.3241%2026.8285%2022.1644%2027.8193%2020.6042C28.81%2019.044%2029.3054%2017.3148%2029.3054%2015.4167C29.3054%2012.8056%2028.4073%2010.6019%2026.611%208.80558C24.8147%207.00928%2022.6109%206.11112%2019.9998%206.11112C17.3887%206.11112%2015.185%207.00928%2013.3887%208.80558C11.5924%2010.6019%2010.6943%2012.8056%2010.6943%2015.4167C10.6943%2017.3148%2011.1896%2019.044%2012.1804%2020.6042C13.1711%2022.1644%2014.4721%2023.3241%2016.0832%2024.0834Z'%20fill='currentColor'/%3e%3c/svg%3e", Tme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.1665%2028.3334C8.47206%2028.3334%207.88178%2028.0903%207.39567%2027.6042C6.90956%2027.1181%206.6665%2026.5278%206.6665%2025.8334C6.6665%2025.1389%206.90956%2024.5486%207.39567%2024.0625C7.88178%2023.5764%208.47206%2023.3334%209.1665%2023.3334H30.8332C31.5276%2023.3334%2032.1179%2023.5764%2032.604%2024.0625C33.0901%2024.5486%2033.3332%2025.1389%2033.3332%2025.8334C33.3332%2026.5278%2033.0901%2027.1181%2032.604%2027.6042C32.1179%2028.0903%2031.5276%2028.3334%2030.8332%2028.3334H9.1665ZM9.1665%2016.6667C8.47206%2016.6667%207.88178%2016.4236%207.39567%2015.9375C6.90956%2015.4514%206.6665%2014.8611%206.6665%2014.1667C6.6665%2013.4722%206.90956%2012.882%207.39567%2012.3959C7.88178%2011.9097%208.47206%2011.6667%209.1665%2011.6667H30.8332C31.5276%2011.6667%2032.1179%2011.9097%2032.604%2012.3959C33.0901%2012.882%2033.3332%2013.4722%2033.3332%2014.1667C33.3332%2014.8611%2033.0901%2015.4514%2032.604%2015.9375C32.1179%2016.4236%2031.5276%2016.6667%2030.8332%2016.6667H9.1665Z'%20fill='currentColor'/%3e%3c/svg%3e", kme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M24.8905%2035.279C21.6528%2035.279%2018.6958%2034.3566%2016.0195%2032.5116C13.3433%2030.6667%2011.4975%2028.1632%2010.482%2025.0012H4.76758V21.8448H9.86541C9.77019%2021.1683%209.72843%2020.543%209.74012%2019.9691C9.75179%2019.3951%209.79355%2018.7905%209.86541%2018.1552H4.76758V14.9922H10.482C11.513%2011.8811%2013.3627%209.39032%2016.0312%207.51993C18.6997%205.64957%2021.6528%204.71439%2024.8905%204.71439C26.8802%204.71439%2028.7432%205.06257%2030.4795%205.75893C32.2159%206.45529%2033.8002%207.44689%2035.2326%208.73372L32.9708%2010.9538C31.8446%209.96869%2030.5918%209.20968%2029.2123%208.67676C27.8329%208.14387%2026.3923%207.87743%2024.8905%207.87743C22.4668%207.87743%2020.2542%208.5369%2018.2529%209.85584C16.2516%2011.1748%2014.8128%2012.8869%2013.9364%2014.9922H25.1529V18.1552H13.0535C12.9372%2018.8454%2012.8814%2019.4801%2012.8862%2020.0593C12.8911%2020.6385%2012.9468%2021.2337%2013.0535%2021.8448H25.1529V25.0012H13.8998C14.7984%2027.1508%2016.2488%2028.8751%2018.2513%2030.1741C20.2537%2031.4731%2022.4668%2032.1226%2024.8905%2032.1226C26.3694%2032.1226%2027.7996%2031.8648%2029.1812%2031.3493C30.5629%2030.8338%2031.8353%2030.0661%2032.9986%2029.0462L35.2326%2031.2563C33.9113%2032.4921%2032.3594%2033.4714%2030.5768%2034.1945C28.7942%2034.9175%2026.8987%2035.279%2024.8905%2035.279Z'%20fill='currentColor'/%3e%3c/svg%3e", Eme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M14.8005%2027.2222C13.6557%2027.2222%2012.6898%2026.827%2011.9028%2026.0366C11.1157%2025.2462%2010.7222%2024.2786%2010.7222%2023.1338C10.7222%2021.9891%2011.1174%2021.0232%2011.9079%2020.2361C12.6983%2019.4491%2013.6659%2019.0556%2014.8106%2019.0556C15.9554%2019.0556%2016.9213%2019.4508%2017.7083%2020.2412C18.4954%2021.0316%2018.8889%2021.9992%2018.8889%2023.144C18.8889%2024.2887%2018.4937%2025.2547%2017.7032%2026.0417C16.9128%2026.8287%2015.9452%2027.2222%2014.8005%2027.2222ZM7.77775%2036.6667C7.02775%2036.6667%206.37729%2036.3912%205.82637%2035.8403C5.27546%2035.2894%205%2034.6389%205%2033.8889V8.88889C5%208.13889%205.27546%207.48843%205.82637%206.93751C6.37729%206.38657%207.02775%206.11109%207.77775%206.11109H10.1389V3.33334H13.0555V6.11109H26.9445V3.33334H29.8611V6.11109H32.2222C32.9722%206.11109%2033.6227%206.38657%2034.1736%206.93751C34.7245%207.48843%2035%208.13889%2035%208.88889V33.8889C35%2034.6389%2034.7245%2035.2894%2034.1736%2035.8403C33.6227%2036.3912%2032.9722%2036.6667%2032.2222%2036.6667H7.77775ZM7.77775%2033.8889H32.2222V16.3889H7.77775V33.8889ZM7.77775%2013.6111H32.2222V8.88889H7.77775V13.6111Z'%20fill='currentColor'/%3e%3c/svg%3e", Rme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12.3056%2036.6667V30.3056H0L7.38892%2019.3611H3.72225L15%203.33337L20%2010.4445L25%203.33337L36.2778%2019.3611H32.6389L40%2030.3056H27.7222V36.6667H22.3056V30.3056H17.7222V36.6667H12.3056ZM28.1806%2027.5278H34.7778L27.375%2016.5834H30.7778L25%208.36113L21.7917%2012.9584L26.2778%2019.3611H22.6389L28.1806%2027.5278ZM5.24996%2027.5278H24.7778L17.375%2016.5834H20.7778L15%208.36113L9.22221%2016.5834H12.6528L5.24996%2027.5278ZM5.24996%2027.5278H12.6528H9.22221H20.7778H17.375H24.7778H5.24996ZM28.1806%2027.5278H22.6389H26.2778H21.7917H30.7778H27.375H34.7778H28.1806Z'%20fill='currentColor'/%3e%3c/svg%3e", Ome = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.61113%2033.3333V26.3888H5V23.6111H8.61113V19.7222H5V16.9444H8.61113V11.3888L13.3333%206.66663L16.6667%209.99996L20.0417%206.66663L23.375%209.99996L26.7083%206.66663L31.4305%2011.3888V16.9444H35V19.7222H31.4305V23.6111H35V26.3888H31.4305V33.3333H8.61113ZM11.3889%2016.9444H15.2778V12.5416L13.3333%2010.5972L11.3889%2012.5416V16.9444ZM18.0555%2016.9444H21.9445V12.5416L20%2010.5972L18.0555%2012.5416V16.9444ZM24.7639%2016.9444H28.6111V12.5416L26.6667%2010.5972L24.7639%2012.5V16.9444ZM11.3889%2023.6111H15.2778V19.7222H11.3889V23.6111ZM18.0555%2023.6111H21.9445V19.7222H18.0555V23.6111ZM24.7639%2023.6111H28.6111V19.7222H24.7639V23.6111ZM11.3889%2030.5555H15.2778V26.3888H11.3889V30.5555ZM18.0555%2030.5555H21.9445V26.3888H18.0555V30.5555ZM24.7639%2030.5555H28.6111V26.3888H24.7639V30.5555Z'%20fill='currentColor'/%3e%3c/svg%3e", _me = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M26.8335%2036.6667C24.0557%2036.6667%2021.7224%2035.7222%2019.8335%2033.8333C17.9446%2031.9445%2017.0002%2029.6111%2017.0002%2026.8333C17.0002%2024.0556%2017.9446%2021.7222%2019.8335%2019.8333C21.7224%2017.9445%2024.0557%2017%2026.8335%2017C29.6113%2017%2031.9446%2017.9445%2033.8335%2019.8333C35.7224%2021.7222%2036.6668%2024.0556%2036.6668%2026.8333C36.6668%2029.6111%2035.7224%2031.9445%2033.8335%2033.8333C31.9446%2035.7222%2029.6113%2036.6667%2026.8335%2036.6667ZM26.8335%2033.8889C28.7779%2033.8889%2030.44%2033.1991%2031.8196%2031.8195C33.1993%2030.4398%2033.8891%2028.7778%2033.8891%2026.8333C33.8891%2024.8889%2033.1993%2023.2269%2031.8196%2021.8472C30.44%2020.4676%2028.7779%2019.7778%2026.8335%2019.7778C24.8891%2019.7778%2023.227%2020.4676%2021.8474%2021.8472C20.4678%2023.2269%2019.778%2024.8889%2019.778%2026.8333C19.778%2028.7778%2020.4678%2030.4398%2021.8474%2031.8195C23.227%2033.1991%2024.8891%2033.8889%2026.8335%2033.8889ZM3.3335%2033.3333V16.2778L7.30575%207.49997H5.11129V3.33334H19.2501V7.49997H17.0557L20.639%2015.7778C20.2409%2015.9815%2019.8428%2016.2176%2019.4446%2016.4861C19.0465%2016.7547%2018.6761%2017.0371%2018.3335%2017.3334L13.9724%207.49997H10.3613L6.11125%2016.9167V30.5556H14.6946C14.7965%2031.0278%2014.9516%2031.507%2015.1599%2031.9931C15.3682%2032.4792%2015.602%2032.9259%2015.8613%2033.3333H3.3335ZM26.8335%2015.0556C25.7779%2015.0556%2024.8937%2014.6991%2024.1807%2013.9861C23.4678%2013.2732%2023.1113%2012.3889%2023.1113%2011.3333C23.1113%2010.2778%2023.4678%209.39354%2024.1807%208.68059C24.8937%207.96762%2025.7779%207.61114%2026.8335%207.61114V15.0556C26.8335%2014%2027.19%2013.1157%2027.903%2012.4028C28.6159%2011.6898%2029.5002%2011.3333%2030.5557%2011.3333C31.6113%2011.3333%2032.4955%2011.6898%2033.2085%2012.4028C33.9214%2013.1157%2034.2779%2014%2034.2779%2015.0556H26.8335Z'%20fill='currentColor'/%3e%3c/svg%3e", Pme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M7.79101%2035C6.58373%2035%205.74635%2034.4005%205.27886%2033.2014C4.81139%2032.0023%204.93166%2030.9815%205.63967%2030.1389L15.416%2018.6111V7.77775H12.0937V5H27.8883V7.77775H24.566V18.6111L34.3423%2030.1389C35.0685%2031%2035.1933%2032.0255%2034.7168%2033.2153C34.2402%2034.4051%2033.3983%2035%2032.191%2035H7.79101ZM7.46423%2032.2222H32.5178L21.8428%2019.6111V7.77775H18.1392V19.6111L7.46423%2032.2222Z'%20fill='currentColor'/%3e%3c/svg%3e", Lme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.3335%2035V7.6389C8.3335%206.8889%208.60895%206.23844%209.15987%205.68752C9.71079%205.1366%2010.3612%204.86115%2011.1112%204.86115H28.8891C29.6391%204.86115%2030.2895%205.1366%2030.8405%205.68752C31.3914%206.23844%2031.6668%206.8889%2031.6668%207.6389V35L20.0002%2030L8.3335%2035ZM11.1112%2030.7778L20.0002%2027L28.8891%2030.7778V7.6389H11.1112V30.7778Z'%20fill='currentColor'/%3e%3c/svg%3e", Ime = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M6.66646%209.44444V6.66669H33.3887V9.44444H6.66646ZM6.80534%2033.3334V22.8334H4.88867V20.0556L6.66646%2011.6667H33.3609L35.1387%2020.0556V22.8334H33.222V33.3334H30.4443V22.8334H22.972V33.3334H6.80534ZM9.58313%2030.5556H20.1943V22.8334H9.58313V30.5556ZM7.66642%2020.0556H32.3609L31.1665%2014.4444H8.86088L7.66642%2020.0556Z'%20fill='currentColor'/%3e%3c/svg%3e", jme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M16.1111%2016.8611L20%2014.9167L23.8889%2016.8611V7.77775H16.1111V16.8611ZM11.6667%2028.3333V25H20V28.3333H11.6667ZM7.77775%2035C7.02775%2035%206.37729%2034.7245%205.82637%2034.1736C5.27546%2033.6227%205%2032.9722%205%2032.2222V7.77775C5%207.02775%205.27546%206.37729%205.82637%205.82638C6.37729%205.27546%207.02775%205%207.77775%205H32.2222C32.9722%205%2033.6227%205.27546%2034.1736%205.82638C34.7245%206.37729%2035%207.02775%2035%207.77775V32.2222C35%2032.9722%2034.7245%2033.6227%2034.1736%2034.1736C33.6227%2034.7245%2032.9722%2035%2032.2222%2035H7.77775ZM7.77775%2032.2222H32.2222V7.77775H26.6667V21.3611L20%2018.0278L13.3333%2021.3611V7.77775H7.77775V32.2222Z'%20fill='currentColor'/%3e%3c/svg%3e", Vme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4.13135%2035.8334V17.186L14.1243%2012.9329V16.2342L22.4519%2012.9008V17.5001H35.776V35.8334H4.13135ZM6.62957%2033.3334H33.2777V20.0001H19.9537V16.5834L11.6261%2019.9167V16.6667L6.62957%2018.8751V33.3334ZM18.4803%2029.6154H21.427V23.718H18.4803V29.6154ZM11.8183%2029.6154H14.7649V23.718H11.8183V29.6154ZM25.1424%2029.6154H28.089V23.718H25.1424V29.6154ZM35.776%2017.5001H29.0179L30.6835%204.80786H34.2065L35.776%2017.5001Z'%20fill='currentColor'/%3e%3c/svg%3e", Dme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M6.81962%2035V30.7222H12.0696L7.7085%2016.0278C6.86591%2015.6111%206.19693%2015.0324%205.70154%2014.2917C5.20618%2013.5509%204.9585%2012.6389%204.9585%2011.5555C4.9585%2010.2222%205.43998%209.07407%206.40295%208.11112C7.3659%207.14815%208.51404%206.66666%209.84737%206.66666C11.0233%206.66666%2012.021%206.98843%2012.8405%207.63196C13.6599%208.27546%2014.2178%209.12036%2014.514%2010.1667H20.3474V7.97221C20.3474%207.5926%2020.484%207.26621%2020.7571%206.99304C21.0303%206.7199%2021.3566%206.58333%2021.7363%206.58333C22.0233%206.58333%2022.2756%206.68055%2022.4932%206.875C22.7108%207.06944%2022.8474%207.30555%2022.903%207.58333L25.9307%204.69446C26.1622%204.46296%2026.4516%204.31248%2026.7988%204.24304C27.146%204.1736%2027.4955%204.22221%2027.8474%204.38887L34.403%207.5C34.6807%207.64814%2034.8729%207.85879%2034.9793%208.13196C35.0858%208.40509%2035.0696%208.68518%2034.9307%208.97221C34.7826%209.26851%2034.5673%209.45139%2034.2849%209.52083C34.0025%209.59028%2033.727%209.55555%2033.4585%209.41666L27.153%206.41666L23.1252%2010.3889V12.6111L27.153%2016.6667L33.4585%2013.6389C33.7455%2013.5%2034.0279%2013.4722%2034.3057%2013.5555C34.5835%2013.6389%2034.7918%2013.8241%2034.9307%2014.1111C35.0789%2014.4074%2035.0974%2014.6991%2034.9863%2014.9861C34.8752%2015.2731%2034.6715%2015.4907%2034.3752%2015.6389L27.9585%2018.6667C27.5881%2018.8518%2027.2247%2018.9282%2026.8682%2018.8958C26.5117%2018.8634%2026.1992%2018.713%2025.9307%2018.4445L22.903%2015.5555C22.8474%2015.8704%2022.7108%2016.1157%2022.4932%2016.2917C22.2756%2016.4676%2022.0233%2016.5555%2021.7363%2016.5555C21.3566%2016.5555%2021.0303%2016.419%2020.7571%2016.1458C20.484%2015.8727%2020.3474%2015.5463%2020.3474%2015.1667V12.9444H14.4585C14.4307%2013.2407%2014.3404%2013.537%2014.1877%2013.8333C14.0349%2014.1296%2013.8474%2014.3889%2013.6252%2014.6111L22.0974%2030.7222H28.4863V35H6.81962ZM9.84737%2013.6667C10.4492%2013.6667%2010.9516%2013.4653%2011.3543%2013.0625C11.7571%2012.6597%2011.9585%2012.1574%2011.9585%2011.5555C11.9585%2010.9537%2011.7571%2010.4514%2011.3543%2010.0486C10.9516%209.6458%2010.4492%209.44442%209.84737%209.44442C9.24551%209.44442%208.74319%209.6458%208.34041%2010.0486C7.93763%2010.4514%207.73625%2010.9537%207.73625%2011.5555C7.73625%2012.1574%207.93763%2012.6597%208.34041%2013.0625C8.74319%2013.4653%209.24551%2013.6667%209.84737%2013.6667ZM15.0418%2030.7222H18.9585L11.3196%2016.0833C11.2641%2016.1204%2011.1622%2016.1574%2011.014%2016.1944L10.6807%2016.2777L15.0418%2030.7222Z'%20fill='currentColor'/%3e%3c/svg%3e", Ame = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M7.33333%2027.8889V6.77775H4V4H10.1111V25.1111H35.6667V27.8889H7.33333ZM10.0865%2035.6667C9.31586%2035.6667%208.66435%2035.3942%208.13196%2034.8493C7.59954%2034.3043%207.33333%2033.6492%207.33333%2032.884C7.33333%2032.1188%207.59954%2031.4653%208.13196%2030.9236C8.66435%2030.382%209.31586%2030.1111%2010.0865%2030.1111C10.8571%2030.1111%2011.5169%2030.3836%2012.0657%2030.9285C12.6145%2031.4735%2012.8889%2032.1286%2012.8889%2032.8938C12.8889%2033.6591%2012.6145%2034.3125%2012.0657%2034.8542C11.5169%2035.3958%2010.8571%2035.6667%2010.0865%2035.6667ZM12.6111%2022.6111V13.1667H22.0555V22.6111H12.6111ZM15.3889%2019.8334H19.2778V15.9445H15.3889V19.8334ZM24.2778%2022.6111V13.1667H33.7222V22.6111H24.2778ZM27.0555%2019.8334H30.9445V15.9445H27.0555V19.8334ZM32.884%2035.6667C32.1188%2035.6667%2031.4653%2035.3942%2030.9236%2034.8493C30.382%2034.3043%2030.1111%2033.6492%2030.1111%2032.884C30.1111%2032.1188%2030.3836%2031.4653%2030.9285%2030.9236C31.4735%2030.382%2032.1286%2030.1111%2032.8938%2030.1111C33.6591%2030.1111%2034.3125%2030.3836%2034.8542%2030.9285C35.3958%2031.4735%2035.6667%2032.1286%2035.6667%2032.8938C35.6667%2033.6591%2035.3942%2034.3125%2034.8493%2034.8542C34.3043%2035.3958%2033.6492%2035.6667%2032.884%2035.6667Z'%20fill='currentColor'/%3e%3c/svg%3e", Hme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M20%2023.2175C21.733%2023.2175%2023.1379%2021.7789%2023.1379%2020.0044C23.1379%2018.2299%2021.733%2016.7914%2020%2016.7914C18.267%2016.7914%2016.8621%2018.2299%2016.8621%2020.0044C16.8621%2021.7789%2018.267%2023.2175%2020%2023.2175Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M7%205H33V7.61123H32.1034V32.3976H33V35H7V32.3976H7.89655V7.61123H7V5ZM29.5931%2032.3976H10.4069V28.7256H29.5931V32.3976ZM29.5931%207.61123H10.4069V11.2833H29.5931V7.61123ZM10.4069%2026.1551V13.8537H29.5931V26.1551H10.4069Z'%20fill='currentColor'/%3e%3c/svg%3e", Fme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18.3335%2035V32.2222H32.2224V19.8333C32.2224%2016.4595%2031.0366%2013.5976%2028.6649%2011.2474C26.2932%208.89728%2023.4049%207.72221%2020.0002%207.72221C16.5954%207.72221%2013.7071%208.89728%2011.3355%2011.2474C8.96376%2013.5976%207.77791%2016.4595%207.77791%2019.8333V30H6.66683C5.75016%2030%204.96544%2029.6736%204.31266%2029.0208C3.65989%2028.3681%203.3335%2027.5833%203.3335%2026.6667V23.3333C3.3335%2022.75%203.47933%2022.2014%203.771%2021.6875C4.06266%2021.1736%204.47239%2020.7639%205.00016%2020.4583L5.12516%2018.25C5.34739%2016.3611%205.896%2014.6111%206.771%2013C7.646%2011.3889%208.74322%209.98611%2010.0627%208.79167C11.3821%207.59722%2012.896%206.66667%2014.6043%206C16.3127%205.33333%2018.1113%205%2020.0002%205C21.8891%205%2023.6807%205.33333%2025.3752%206C27.0696%206.66667%2028.5835%207.59028%2029.9168%208.77083C31.2502%209.95139%2032.3474%2011.3472%2033.2085%2012.9583C34.0696%2014.5694%2034.6252%2016.3194%2034.8752%2018.2083L35.0002%2020.375C35.5279%2020.625%2035.9377%2021%2036.2293%2021.5C36.521%2022%2036.6668%2022.5278%2036.6668%2023.0833V26.9167C36.6668%2027.4722%2036.521%2028%2036.2293%2028.5C35.9377%2029%2035.5279%2029.375%2035.0002%2029.625V32.2222C35.0002%2032.9861%2034.7282%2033.6401%2034.1842%2034.184C33.6402%2034.728%2032.9863%2035%2032.2224%2035H18.3335ZM14.9953%2023.0555C14.6004%2023.0555%2014.271%2022.922%2014.0071%2022.6548C13.7432%2022.3877%2013.6113%2022.0567%2013.6113%2021.6618C13.6113%2021.2669%2013.7449%2020.9375%2014.012%2020.6736C14.2791%2020.4097%2014.6102%2020.2778%2015.005%2020.2778C15.3999%2020.2778%2015.7293%2020.4114%2015.9932%2020.6785C16.2571%2020.9456%2016.389%2021.2767%2016.389%2021.6715C16.389%2022.0664%2016.2555%2022.3958%2015.9883%2022.6597C15.7212%2022.9236%2015.3902%2023.0555%2014.9953%2023.0555ZM24.9953%2023.0555C24.6004%2023.0555%2024.271%2022.922%2024.0071%2022.6548C23.7432%2022.3877%2023.6113%2022.0567%2023.6113%2021.6618C23.6113%2021.2669%2023.7449%2020.9375%2024.012%2020.6736C24.2791%2020.4097%2024.6102%2020.2778%2025.005%2020.2778C25.3999%2020.2778%2025.7293%2020.4114%2025.9932%2020.6785C26.2571%2020.9456%2026.389%2021.2767%2026.389%2021.6715C26.389%2022.0664%2026.2555%2022.3958%2025.9883%2022.6597C25.7212%2022.9236%2025.3902%2023.0555%2024.9953%2023.0555ZM10.0418%2020.75C9.84739%2017.8056%2010.7363%2015.2778%2012.7085%2013.1667C14.6807%2011.0556%2017.1391%2010%2020.0835%2010C22.5187%2010%2024.6414%2010.794%2026.4515%2012.382C28.2617%2013.9699%2029.3613%2015.9676%2029.7502%2018.375C27.2594%2018.3472%2024.9793%2017.6574%2022.9099%2016.3055C20.8404%2014.9537%2019.2429%2013.1574%2018.1174%2010.9167C17.6781%2013.1389%2016.7432%2015.1181%2015.3127%2016.8542C13.8821%2018.5903%2012.1252%2019.8889%2010.0418%2020.75Z'%20fill='currentColor'/%3e%3c/svg%3e", Nme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M7.17934%2034.1666C6.33745%2034.1666%205.62484%2033.8749%205.0415%2033.2916C4.45817%2032.7083%204.1665%2031.9957%204.1665%2031.1538V12.5H6.66646V31.1538C6.66646%2031.282%206.71988%2031.3995%206.82671%2031.5064C6.93357%2031.6132%207.05112%2031.6666%207.17934%2031.6666H30.8331V34.1666H7.17934ZM13.846%2027.4999C13.0041%2027.4999%2012.2915%2027.2083%2011.7082%2026.6249C11.1248%2026.0416%2010.8332%2025.329%2010.8332%2024.4871V5.83334H37.4998V24.4871C37.4998%2025.329%2037.2081%2026.0416%2036.6248%2026.6249C36.0414%2027.2083%2035.3288%2027.4999%2034.4869%2027.4999H13.846ZM13.846%2025H34.4869C34.6151%2025%2034.7327%2024.9466%2034.8396%2024.8397C34.9464%2024.7329%2034.9998%2024.6153%2034.9998%2024.4871V8.3333H13.3331V24.4871C13.3331%2024.6153%2013.3865%2024.7329%2013.4934%2024.8397C13.6002%2024.9466%2013.7178%2025%2013.846%2025ZM16.6665%2020H23.3331V11.6666H16.6665V20ZM24.9998%2020H31.6665V16.6666H24.9998V20ZM24.9998%2015H31.6665V11.6666H24.9998V15Z'%20fill='currentColor'/%3e%3c/svg%3e", $me = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M10.8611%2018.1666L20.0278%203.33331L29.1945%2018.1666H10.8611ZM29.3333%2036.6666C27.2685%2036.6666%2025.5301%2035.9606%2024.118%2034.5486C22.706%2033.1366%2022%2031.3981%2022%2029.3333C22%2027.2685%2022.706%2025.5301%2024.118%2024.1181C25.5301%2022.706%2027.2685%2022%2029.3333%2022C31.3981%2022%2033.1366%2022.706%2034.5486%2024.1181C35.9607%2025.5301%2036.6667%2027.2685%2036.6667%2029.3333C36.6667%2031.3981%2035.9607%2033.1366%2034.5486%2034.5486C33.1366%2035.9606%2031.3981%2036.6666%2029.3333%2036.6666ZM5%2035.6944V22.8056H17.8889V35.6944H5ZM29.3357%2033.8889C30.6119%2033.8889%2031.6898%2033.4483%2032.5695%2032.5671C33.4491%2031.6859%2033.8889%2030.6072%2033.8889%2029.331C33.8889%2028.0548%2033.4483%2026.9768%2032.5671%2026.0972C31.6859%2025.2176%2030.6072%2024.7778%2029.331%2024.7778C28.0548%2024.7778%2026.9768%2025.2184%2026.0972%2026.0996C25.2176%2026.9808%2024.7778%2028.0595%2024.7778%2029.3357C24.7778%2030.6119%2025.2184%2031.6898%2026.0996%2032.5694C26.9808%2033.4491%2028.0595%2033.8889%2029.3357%2033.8889ZM7.77775%2032.9167H15.1111V25.5833H7.77775V32.9167ZM15.8333%2015.3889H24.2222L20.0278%208.61106L15.8333%2015.3889Z'%20fill='currentColor'/%3e%3c/svg%3e", Bme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M5%2012.8055H35V29.1667C35%2030.3241%2034.5949%2031.3079%2033.7847%2032.1181C32.9745%2032.9283%2031.9908%2033.3333%2030.8334%2033.3333H9.16663C8.00924%2033.3333%207.02544%2032.9283%206.21525%2032.1181C5.40508%2031.3079%205%2030.3241%205%2029.1667V12.8055ZM7.77775%2015.5833V29.1667C7.77775%2029.5602%207.91086%2029.8901%208.17708%2030.1562C8.44328%2030.4225%208.77312%2030.5556%209.16663%2030.5556H30.8334C31.2269%2030.5556%2031.5567%2030.4225%2031.8229%2030.1562C32.0891%2029.8901%2032.2222%2029.5602%2032.2222%2029.1667V15.5833H7.77775ZM5%2011.1389V8.33333H15.2778V6.38888C15.2778%205.99538%2015.4109%205.66551%2015.6771%205.39929C15.9433%205.1331%2016.2731%205%2016.6667%205H23.3333C23.7269%205%2024.0567%205.1331%2024.3229%205.39929C24.5891%205.66551%2024.7222%205.99538%2024.7222%206.38888V8.33333H35V11.1389H5Z'%20fill='currentColor'/%3e%3c/svg%3e", zme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M28.1412%2033.9743C26.537%2033.9743%2025.1638%2033.4032%2024.0214%2032.2608C22.8791%2031.1185%2022.3079%2029.7452%2022.3079%2028.1411C22.3079%2026.5369%2022.8791%2025.1637%2024.0214%2024.0213C25.1638%2022.879%2026.537%2022.3078%2028.1412%2022.3078C29.7453%2022.3078%2031.1186%2022.879%2032.2609%2024.0213C33.4033%2025.1637%2033.9745%2026.5369%2033.9745%2028.1411C33.9745%2029.7452%2033.4033%2031.1185%2032.2609%2032.2608C31.1186%2033.4032%2029.7453%2033.9743%2028.1412%2033.9743ZM28.1412%2031.4744C29.0578%2031.4744%2029.8426%2031.148%2030.4953%2030.4952C31.1481%2029.8424%2031.4745%2029.0577%2031.4745%2028.1411C31.4745%2027.2244%2031.1481%2026.4397%2030.4953%2025.7869C29.8426%2025.1341%2029.0578%2024.8077%2028.1412%2024.8077C27.2245%2024.8077%2026.4398%2025.1341%2025.787%2025.7869C25.1342%2026.4397%2024.8078%2027.2244%2024.8078%2028.1411C24.8078%2029.0577%2025.1342%2029.8424%2025.787%2030.4952C26.4398%2031.148%2027.2245%2031.4744%2028.1412%2031.4744ZM11.8592%2028.9743C10.255%2028.9743%208.88175%2028.4032%207.73942%2027.2608C6.59706%2026.1185%206.02588%2024.7452%206.02588%2023.1411C6.02588%2021.5369%206.59706%2020.1637%207.73942%2019.0213C8.88175%2017.879%2010.255%2017.3078%2011.8592%2017.3078C13.4633%2017.3078%2014.8366%2017.879%2015.9789%2019.0213C17.1213%2020.1637%2017.6924%2021.5369%2017.6924%2023.1411C17.6924%2024.7452%2017.1213%2026.1185%2015.9789%2027.2608C14.8366%2028.4032%2013.4633%2028.9743%2011.8592%2028.9743ZM11.8592%2026.4744C12.7758%2026.4744%2013.5606%2026.148%2014.2133%2025.4952C14.8661%2024.8424%2015.1925%2024.0577%2015.1925%2023.1411C15.1925%2022.2244%2014.8661%2021.4397%2014.2133%2020.7869C13.5606%2020.1341%2012.7758%2019.8077%2011.8592%2019.8077C10.9425%2019.8077%2010.1578%2020.1341%209.505%2020.7869C8.85223%2021.4397%208.52584%2022.2244%208.52584%2023.1411C8.52584%2024.0577%208.85223%2024.8424%209.505%2025.4952C10.1578%2026.148%2010.9425%2026.4744%2011.8592%2026.4744ZM18.3335%2016.1538C16.7294%2016.1538%2015.3561%2015.5827%2014.2138%2014.4403C13.0714%2013.298%2012.5002%2011.9247%2012.5002%2010.3206C12.5002%208.71643%2013.0714%207.34318%2014.2138%206.20085C15.3561%205.05849%2016.7294%204.4873%2018.3335%204.4873C19.9376%204.4873%2021.3109%205.05849%2022.4533%206.20085C23.5956%207.34318%2024.1668%208.71643%2024.1668%2010.3206C24.1668%2011.9247%2023.5956%2013.298%2022.4533%2014.4403C21.3109%2015.5827%2019.9376%2016.1538%2018.3335%2016.1538ZM18.3335%2013.6539C19.2502%2013.6539%2020.0349%2013.3275%2020.6877%2012.6748C21.3404%2012.022%2021.6668%2011.2373%2021.6668%2010.3206C21.6668%209.40393%2021.3404%208.61921%2020.6877%207.96643C20.0349%207.31365%2019.2502%206.98726%2018.3335%206.98726C17.4168%206.98726%2016.6321%207.31365%2015.9793%207.96643C15.3266%208.61921%2015.0002%209.40393%2015.0002%2010.3206C15.0002%2011.2373%2015.3266%2012.022%2015.9793%2012.6748C16.6321%2013.3275%2017.4168%2013.6539%2018.3335%2013.6539Z'%20fill='currentColor'/%3e%3c/svg%3e", Zme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M30.1945%2036.6667C28.8518%2036.6667%2027.7106%2036.1959%2026.7708%2035.2543C25.831%2034.3127%2025.3611%2033.1693%2025.3611%2031.8242C25.3611%2031.6358%2025.3796%2031.4177%2025.4167%2031.1697C25.4537%2030.9217%2025.5093%2030.6984%2025.5833%2030.5L13.25%2023.3333C12.8148%2023.787%2012.2963%2024.1505%2011.6945%2024.4236C11.0926%2024.6968%2010.4722%2024.8333%209.83333%2024.8333C8.49075%2024.8333%207.34954%2024.3634%206.40971%2023.4236C5.4699%2022.4838%205%2021.3426%205%2020C5%2018.6574%205.4699%2017.5162%206.40971%2016.5764C7.34954%2015.6366%208.49075%2015.1667%209.83333%2015.1667C10.4722%2015.1667%2011.0833%2015.2894%2011.6667%2015.5347C12.25%2015.7801%2012.7778%2016.1297%2013.25%2016.5833L25.5833%209.47222C25.5093%209.28572%2025.4537%209.0759%2025.4167%208.84276C25.3796%208.60962%2025.3611%208.38426%2025.3611%208.16668C25.3611%206.82409%2025.831%205.68289%2026.7708%204.74305C27.7106%203.80325%2028.8518%203.33334%2030.1945%203.33334C31.537%203.33334%2032.6782%203.80325%2033.618%204.74305C34.5579%205.68289%2035.0278%206.82409%2035.0278%208.16668C35.0278%209.50926%2034.5579%2010.6505%2033.618%2011.5903C32.6782%2012.5301%2031.537%2013%2030.1945%2013C29.549%2013%2028.9316%2012.8912%2028.3423%2012.6736C27.753%2012.456%2027.2407%2012.1204%2026.8055%2011.6667L14.4722%2018.6111C14.5278%2018.8148%2014.5741%2019.0486%2014.6111%2019.3125C14.6481%2019.5764%2014.6667%2019.8078%2014.6667%2020.0067C14.6667%2020.2056%2014.6481%2020.4116%2014.6111%2020.6248C14.5741%2020.8379%2014.5278%2021.0463%2014.4722%2021.25L26.8055%2028.3056C27.2407%2027.9074%2027.7407%2027.5903%2028.3055%2027.3542C28.8704%2027.1181%2029.5%2027%2030.1945%2027C31.537%2027%2032.6782%2027.4699%2033.618%2028.4098C34.5579%2029.3496%2035.0278%2030.4908%2035.0278%2031.8333C35.0278%2033.1759%2034.5579%2034.3171%2033.618%2035.257C32.6782%2036.1968%2031.537%2036.6667%2030.1945%2036.6667ZM30.1954%2010.2222C30.7781%2010.2222%2031.2662%2010.0251%2031.6597%209.63097C32.0532%209.2368%2032.25%208.74839%2032.25%208.16572C32.25%207.58302%2032.0529%207.09491%2031.6588%206.70139C31.2646%206.30786%2030.7762%206.11109%2030.1935%206.11109C29.6108%206.11109%2029.1227%206.30818%2028.7292%206.70234C28.3356%207.09654%2028.1389%207.58497%2028.1389%208.16764C28.1389%208.75033%2028.336%209.23844%2028.7301%209.63197C29.1243%2010.0255%2029.6128%2010.2222%2030.1954%2010.2222ZM9.83429%2022.0556C10.417%2022.0556%2010.9051%2021.8585%2011.2986%2021.4643C11.6921%2021.0701%2011.8889%2020.5817%2011.8889%2019.9991C11.8889%2019.4164%2011.6918%2018.9282%2011.2976%2018.5347C10.9035%2018.1412%2010.415%2017.9444%209.83233%2017.9444C9.24967%2017.9444%208.76157%2018.1415%208.36804%2018.5357C7.97451%2018.9299%207.77775%2019.4183%207.77775%2020.001C7.77775%2020.5837%207.97483%2021.0718%208.369%2021.4653C8.76319%2021.8588%209.25162%2022.0556%209.83429%2022.0556ZM30.1954%2033.8889C30.7781%2033.8889%2031.2662%2033.6918%2031.6597%2033.2977C32.0532%2032.9035%2032.25%2032.4151%2032.25%2031.8324C32.25%2031.2497%2032.0529%2030.7616%2031.6588%2030.3681C31.2646%2029.9746%2030.7762%2029.7778%2030.1935%2029.7778C29.6108%2029.7778%2029.1227%2029.9749%2028.7292%2030.3691C28.3356%2030.7632%2028.1389%2031.2517%2028.1389%2031.8343C28.1389%2032.417%2028.336%2032.9051%2028.7301%2033.2986C29.1243%2033.6922%2029.6128%2033.8889%2030.1954%2033.8889Z'%20fill='currentColor'/%3e%3c/svg%3e", Wme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.97457%2032.6922H31.0257V29.9199C31.0257%2029.7703%2030.9777%2029.6474%2030.8815%2029.5512C30.7853%2029.4551%2030.6625%2029.407%2030.5129%2029.407H9.4874C9.33782%2029.407%209.21496%2029.4551%209.11882%2029.5512C9.02265%2029.6474%208.97457%2029.7703%208.97457%2029.9199V32.6922ZM13.9617%2026.9071H26.0386L24.9841%2019.5833H15.0162L13.9617%2026.9071ZM6.47461%2035.1922V29.9199C6.47461%2029.0913%206.76961%2028.3821%207.35961%2027.7921C7.94964%2027.2021%208.6589%2026.9071%209.4874%2026.9071H11.4618L12.4906%2019.5833H8.14128V17.0834H31.859V19.5833H27.5097L28.5385%2026.9071H30.5091C31.3428%2026.9071%2032.054%2027.2021%2032.6427%2027.7921C33.2314%2028.3821%2033.5257%2029.0913%2033.5257%2029.9199V35.1922H6.47461ZM12.3977%2017.0834L9.67973%204.80778C10.5323%205.40606%2011.3729%205.92795%2012.2016%206.37345C13.0302%206.81895%2013.9417%207.04169%2014.9361%207.04169C15.9511%207.04169%2016.8784%206.82376%2017.7181%206.3879C18.5579%205.95201%2019.3185%205.41997%2020.0002%204.79178C20.6818%205.41997%2021.4427%205.95201%2022.2829%206.3879C23.1232%206.82376%2024.0449%207.04169%2025.0482%207.04169C26.0119%207.04169%2026.9023%206.82163%2027.7196%206.38149C28.5369%205.94132%2029.4092%205.41675%2030.3366%204.80778L27.6027%2017.0834H25.0354L26.7886%209.31407C26.6283%209.36749%2026.4013%209.41878%2026.1075%209.46795C25.8137%209.51709%2025.4392%209.54165%2024.9841%209.54165C24.0976%209.54165%2023.2297%209.41558%2022.3802%209.16344C21.5307%208.91131%2020.7373%208.55021%2020.0002%208.08015C19.2801%208.55021%2018.5021%208.91131%2017.6663%209.16344C16.8305%209.41558%2015.976%209.54165%2015.1028%209.54165C14.6241%209.54165%2014.232%209.52242%2013.9265%209.48394C13.6209%209.4455%2013.388%209.39956%2013.2277%209.34611L14.9649%2017.0834H12.3977Z'%20fill='currentColor'/%3e%3c/svg%3e", Ume = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M7.43119%2034.5812C6.16071%2034.5812%205.07973%2034.1352%204.18827%2033.2431C3.29681%2032.351%202.85107%2031.2693%202.85107%2029.9979C2.85107%2029.3078%202.99253%2028.655%203.27545%2028.0396C3.55839%2027.4242%203.9721%2026.8964%204.51658%2026.4563V18.748H8.08785V9.16463H19.8264L27.366%2026.8858C27.5219%2027.2533%2027.6441%2027.6235%2027.7327%2027.9963C27.8213%2028.3692%2027.8656%2028.7586%2027.8656%2029.1646C27.8656%2030.6689%2027.3393%2031.9477%2026.2866%2033.0011C25.2339%2034.0545%2023.956%2034.5812%2022.4528%2034.5812C21.3467%2034.5812%2020.3388%2034.2799%2019.4292%2033.6774C18.5196%2033.0748%2017.8609%2032.265%2017.4531%2031.2479H11.8159C11.5405%2032.2372%2010.9965%2033.0401%2010.1841%2033.6566C9.3716%2034.273%208.45397%2034.5812%207.43119%2034.5812ZM29.5311%2032.9146V7.0813H32.0294V30.4146H37.0579V32.9146H29.5311ZM7.43119%2032.0813C8.00987%2032.0813%208.50153%2031.8788%208.90616%2031.4739C9.3108%2031.069%209.51311%2030.577%209.51311%2029.9979C9.51311%2029.4189%209.3108%2028.9269%208.90616%2028.5219C8.50153%2028.117%208.00987%2027.9146%207.43119%2027.9146C6.85253%2027.9146%206.36089%2028.117%205.95625%2028.5219C5.55159%2028.9269%205.34926%2029.4189%205.34926%2029.9979C5.34926%2030.577%205.55159%2031.069%205.95625%2031.4739C6.36089%2031.8788%206.85253%2032.0813%207.43119%2032.0813ZM22.4528%2032.0813C23.2535%2032.0813%2023.9394%2031.7955%2024.5107%2031.2239C25.0818%2030.6523%2025.3674%2029.9659%2025.3674%2029.1646C25.3674%2028.3633%2025.0818%2027.6769%2024.5107%2027.1053C23.9394%2026.5337%2023.2535%2026.2479%2022.4528%2026.2479C21.652%2026.2479%2020.9661%2026.5337%2020.3948%2027.1053C19.8237%2027.6769%2019.5381%2028.3633%2019.5381%2029.1646C19.5381%2029.9659%2019.8237%2030.6523%2020.3948%2031.2239C20.9661%2031.7955%2021.652%2032.0813%2022.4528%2032.0813ZM11.8159%2028.748H17.0655C17.0783%2028.2821%2017.1621%2027.8371%2017.3169%2027.413C17.4718%2026.9888%2017.6986%2026.6005%2017.9976%2026.2479H14.3943L9.52269%2021.2479H7.01477V25.4787C7.07883%2025.4574%207.14556%2025.4413%207.21496%2025.4306C7.28438%2025.42%207.35646%2025.4146%207.43119%2025.4146C8.45397%2025.4146%209.3716%2025.7229%2010.1841%2026.3393C10.9965%2026.9557%2011.5405%2027.7586%2011.8159%2028.748ZM15.4577%2023.748H22.6065C22.7453%2023.748%2022.8814%2023.764%2023.0149%2023.7961C23.1484%2023.8281%2023.2792%2023.8762%2023.4073%2023.9403L18.1801%2011.6646H10.586V18.748L15.4577%2023.748ZM14.3943%2026.2479L13.624%2025.4562C13.1105%2024.9284%2012.5553%2024.3521%2011.9585%2023.7271C11.3617%2023.1021%2010.8065%2022.5326%2010.293%2022.0187L9.52269%2021.2479L14.3943%2026.2479Z'%20fill='currentColor'/%3e%3c/svg%3e", Gme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M25.3333%2035L14.6944%2031.25L5%2035.0694V8.3611L14.6944%204.99998L25.3333%208.72219L35%204.90277V31.6111L25.3333%2035ZM23.8333%2031.5556V11.0277L16.1667%208.41665V28.9444L23.8333%2031.5556ZM26.6111%2031.5556L32.2222%2029.6944V8.88885L26.6111%2011.0277V31.5556ZM7.77775%2031.0833L13.3889%2028.9444V8.41665L7.77775%2010.2777V31.0833Z'%20fill='currentColor'/%3e%3c/svg%3e", qme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M27.8286%2035.1083L25.8842%2033.1639L28.5092%2030.4972L25.8842%2027.8722L27.8286%2025.8861L30.4953%2028.5527L33.1203%2025.8861L35.1064%2027.8722L32.4397%2030.4972L35.1064%2033.1639L33.1203%2035.1083L30.4953%2032.4833L27.8286%2035.1083ZM9.79595%2032.3305C10.3455%2032.3305%2010.8078%2032.1447%2011.1828%2031.7729C11.5578%2031.4012%2011.7453%2030.9405%2011.7453%2030.391C11.7453%2029.8414%2011.5594%2029.3791%2011.1877%2029.0041C10.8159%2028.6291%2010.3553%2028.4416%209.8057%2028.4416C9.25614%2028.4416%208.79386%2028.6275%208.41886%2028.9992C8.04386%2029.371%207.85636%2029.8316%207.85636%2030.3812C7.85636%2030.9308%208.04224%2031.393%208.41399%2031.768C8.78574%2032.143%209.24639%2032.3305%209.79595%2032.3305ZM9.81145%2035.1083C8.48956%2035.1083%207.37028%2034.6489%206.45361%2033.73C5.53695%2032.8112%205.07861%2031.6954%205.07861%2030.3828C5.07861%2029.0702%205.53771%2027.9555%206.4559%2027.0389C7.37413%2026.1222%208.4891%2025.6639%209.80082%2025.6639C10.8471%2025.6639%2011.78%2025.9671%2012.5994%2026.5736C13.4189%2027.18%2013.986%2027.9787%2014.3008%2028.9694C15.5508%2028.8305%2016.5948%2028.2889%2017.4328%2027.3444C18.2708%2026.4%2018.6897%2025.2935%2018.6897%2024.025V16.775C18.6897%2014.5463%2019.4752%2012.6465%2021.046%2011.0757C22.6168%209.50483%2024.5166%208.71941%2026.7453%208.71941H29.7175L26.8147%205.81662L28.8009%203.83054L35.0786%2010.1083L28.8009%2016.386L26.8147%2014.4416L29.7175%2011.4972H26.7453C25.2792%2011.4972%2024.0331%2012.0103%2023.0069%2013.0365C21.9806%2014.0628%2021.4675%2015.3089%2021.4675%2016.775V24.025C21.4675%2026.0527%2020.7823%2027.8097%2019.4119%2029.2958C18.0416%2030.7819%2016.3471%2031.6037%2014.3286%2031.7611C14.0138%2032.7518%2013.44%2033.5574%2012.6072%2034.1777C11.7744%2034.7981%2010.8425%2035.1083%209.81145%2035.1083ZM7.02303%2014.3305L5.07861%2012.386L7.70361%209.71937L5.07861%207.09437L7.02303%205.10829L9.6897%207.77495L12.3147%205.10829L14.3008%207.09437L11.6342%209.71937L14.3008%2012.386L12.3147%2014.3305L9.6897%2011.7055L7.02303%2014.3305Z'%20fill='currentColor'/%3e%3c/svg%3e", Kme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M15.9168%2036.6667L15.139%2031.3889C14.6668%2031.213%2014.183%2030.9815%2013.6876%2030.6945C13.1922%2030.4074%2012.7455%2030.1065%2012.3473%2029.7917L7.41679%2031.9861L3.30566%2024.7917L7.73625%2021.514C7.68994%2021.2825%207.66216%2021.0301%207.65291%2020.757C7.64364%2020.4838%207.639%2020.2315%207.639%2020C7.639%2019.7686%207.64364%2019.5163%207.65291%2019.2431C7.66216%2018.9699%207.68994%2018.7176%207.73625%2018.4861L3.30566%2015.2084L7.41679%208.01396L12.3473%2010.2084C12.7455%209.89357%2013.1946%209.59264%2013.6946%209.30558C14.1946%209.01856%2014.6761%208.79633%2015.139%208.63892L15.9168%203.33337H24.0835L24.8612%208.61117C25.3335%208.78708%2025.8219%209.01393%2026.3265%209.29171C26.8311%209.56949%2027.2733%209.87504%2027.6529%2010.2084L32.5835%208.01396L36.6946%2015.2084L32.264%2018.4306C32.3103%2018.6806%2032.3381%2018.9422%2032.3473%2019.2153C32.3566%2019.4885%2032.3612%2019.75%2032.3612%2020C32.3612%2020.25%2032.3566%2020.507%2032.3473%2020.7709C32.3381%2021.0348%2032.3057%2021.2917%2032.2501%2021.5417L36.6807%2024.7917L32.5696%2031.9861L27.6529%2029.7917C27.2548%2030.1065%2026.8103%2030.4121%2026.3196%2030.7084C25.8288%2031.0047%2025.3427%2031.2315%2024.8612%2031.3889L24.0835%2036.6667H15.9168ZM20.0279%2025.5556C21.5649%2025.5556%2022.8751%2025.0139%2023.9585%2023.9306C25.0418%2022.8473%2025.5835%2021.5371%2025.5835%2020C25.5835%2018.463%2025.0418%2017.1528%2023.9585%2016.0695C22.8751%2014.9862%2021.5649%2014.4445%2020.0279%2014.4445C18.4816%2014.4445%2017.1691%2014.9862%2016.0904%2016.0695C15.0117%2017.1528%2014.4723%2018.463%2014.4723%2020C14.4723%2021.5371%2015.0117%2022.8473%2016.0904%2023.9306C17.1691%2025.0139%2018.4816%2025.5556%2020.0279%2025.5556ZM20.0279%2022.7778C19.2594%2022.7778%2018.6043%2022.507%2018.0626%2021.9653C17.521%2021.4237%2017.2501%2020.7686%2017.2501%2020C17.2501%2019.2315%2017.521%2018.5764%2018.0626%2018.0348C18.6043%2017.4931%2019.2594%2017.2223%2020.0279%2017.2223C20.7964%2017.2223%2021.4515%2017.4931%2021.9932%2018.0348C22.5348%2018.5764%2022.8057%2019.2315%2022.8057%2020C22.8057%2020.7686%2022.5348%2021.4237%2021.9932%2021.9653C21.4515%2022.507%2020.7964%2022.7778%2020.0279%2022.7778ZM18.2223%2033.889H21.764L22.3473%2029.3056C23.2455%2029.0834%2024.0904%2028.7431%2024.8821%2028.2848C25.6737%2027.8265%2026.3937%2027.2732%2027.0418%2026.625L31.3612%2028.4723L33.014%2025.5278L29.2085%2022.7084C29.3288%2022.2639%2029.4214%2021.8172%2029.4862%2021.3681C29.5511%2020.919%2029.5835%2020.463%2029.5835%2020C29.5835%2019.5371%2029.5557%2019.0811%2029.5001%2018.632C29.4446%2018.1829%2029.3473%2017.7362%2029.2085%2017.2917L33.014%2014.4723L31.3612%2011.5278L27.0418%2013.3889C26.4122%2012.6945%2025.7062%2012.1135%2024.9237%2011.6459C24.1413%2011.1783%2023.2825%2010.8611%2022.3473%2010.6945L21.7779%206.11112H18.2362L17.6529%2010.6945C16.7362%2010.8982%2015.8821%2011.2292%2015.0904%2011.6875C14.2987%2012.1459%2013.5881%2012.7084%2012.9585%2013.375L8.639%2011.5278L6.98621%2014.4723L10.7918%2017.2778C10.6714%2017.7315%2010.5788%2018.1806%2010.514%2018.625C10.4492%2019.0695%2010.4168%2019.5278%2010.4168%2020C10.4168%2020.463%2010.4492%2020.9167%2010.514%2021.3612C10.5788%2021.8056%2010.6714%2022.2547%2010.7918%2022.7084L6.98621%2025.5278L8.639%2028.4723L12.9585%2026.6112C13.6066%2027.2686%2014.3265%2027.8265%2015.1182%2028.2848C15.9098%2028.7431%2016.7547%2029.0834%2017.6529%2029.3056L18.2223%2033.889Z'%20fill='currentColor'/%3e%3c/svg%3e", Yme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.55863%2033.3055C8.1861%2033.3055%207.01835%2032.8248%206.05538%2031.8634C5.09241%2030.902%204.61092%2029.7345%204.61092%2028.3611H1.6665V6.66663H28.3054V13.5278H32.8887L38.3332%2020.7778V28.3611H35.2498C35.2498%2029.7345%2034.7694%2030.902%2033.8087%2031.8634C32.8479%2032.8248%2031.6812%2033.3055%2030.3087%2033.3055C28.9361%2033.3055%2027.7684%2032.8248%2026.8054%2031.8634C25.8424%2030.902%2025.361%2029.7345%2025.361%2028.3611H14.4998C14.4998%2029.7314%2014.0194%2030.8981%2013.0586%2031.8611C12.0979%2032.824%2010.9312%2033.3055%209.55863%2033.3055ZM9.55538%2030.5278C10.1572%2030.5278%2010.6688%2030.3171%2011.0901%2029.8958C11.5114%2029.4745%2011.722%2028.9629%2011.722%2028.3611C11.722%2027.7592%2011.5114%2027.2476%2011.0901%2026.8263C10.6688%2026.405%2010.1572%2026.1944%209.55538%2026.1944C8.95352%2026.1944%208.44193%2026.405%208.02063%2026.8263C7.59935%2027.2476%207.38871%2027.7592%207.38871%2028.3611C7.38871%2028.9629%207.59935%2029.4745%208.02063%2029.8958C8.44193%2030.3171%208.95352%2030.5278%209.55538%2030.5278ZM4.44425%2025.5833H5.4998C5.97202%2024.9166%206.5511%2024.3842%207.23705%2023.9861C7.92299%2023.5879%208.68689%2023.3888%209.52875%2023.3888C10.3706%2023.3888%2011.1387%2023.5925%2011.8332%2024C12.5276%2024.4074%2013.1109%2024.9352%2013.5832%2025.5833H25.5276V9.44438H4.44425V25.5833ZM30.3054%2030.5278C30.9073%2030.5278%2031.4188%2030.3171%2031.8401%2029.8958C32.2614%2029.4745%2032.4721%2028.9629%2032.4721%2028.3611C32.4721%2027.7592%2032.2614%2027.2476%2031.8401%2026.8263C31.4188%2026.405%2030.9073%2026.1944%2030.3054%2026.1944C29.7036%2026.1944%2029.192%2026.405%2028.7707%2026.8263C28.3494%2027.2476%2028.1387%2027.7592%2028.1387%2028.3611C28.1387%2028.9629%2028.3494%2029.4745%2028.7707%2029.8958C29.192%2030.3171%2029.7036%2030.5278%2030.3054%2030.5278ZM28.3054%2022.0833H35.8332L31.4998%2016.3055H28.3054V22.0833Z'%20fill='currentColor'/%3e%3c/svg%3e", Xme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M1.61133%2033.3333V29.1667C1.61133%2028.2037%201.85901%2027.3264%202.35437%2026.5348C2.84973%2025.7431%203.52797%2025.1482%204.38908%2024.75C6.31502%2023.8704%208.11595%2023.2292%209.79187%2022.8264C11.4678%2022.4236%2013.1854%2022.2223%2014.9447%2022.2223C16.7039%2022.2223%2018.4169%2022.4236%2020.0835%2022.8264C21.7502%2023.2292%2023.5465%2023.8704%2025.4724%2024.75C26.3335%2025.1482%2027.0164%2025.7431%2027.521%2026.5348C28.0257%2027.3264%2028.278%2028.2037%2028.278%2029.1667V33.3333H1.61133ZM31.0557%2033.3333V29.0556C31.0557%2027.4815%2030.646%2026.132%2029.8266%2025.007C29.0071%2023.882%2027.9076%2022.9537%2026.528%2022.2223C28.278%2022.4259%2029.9261%2022.7384%2031.4724%2023.1598C33.0187%2023.581%2034.3243%2024.0741%2035.3891%2024.6389C36.3335%2025.1759%2037.0696%2025.8171%2037.5974%2026.5625C38.1252%2027.3079%2038.3891%2028.1389%2038.3891%2029.0556V33.3333H31.0557ZM14.9447%2019.9722C13.1113%2019.9722%2011.5882%2019.3657%2010.3752%2018.1528C9.16223%2016.9398%208.55574%2015.4167%208.55574%2013.5833C8.55574%2011.75%209.16223%2010.2269%2010.3752%209.01392C11.5882%207.80094%2013.1113%207.19446%2014.9447%207.19446C16.778%207.19446%2018.3011%207.80094%2019.5141%209.01392C20.7271%2010.2269%2021.3335%2011.75%2021.3335%2013.5833C21.3335%2015.4167%2020.7271%2016.9398%2019.5141%2018.1528C18.3011%2019.3657%2016.778%2019.9722%2014.9447%2019.9722ZM30.5002%2013.5833C30.5002%2015.4167%2029.8937%2016.9398%2028.6807%2018.1528C27.4678%2019.3657%2025.9446%2019.9722%2024.1113%2019.9722C23.8057%2019.9722%2023.4492%2019.9468%2023.0418%2019.8958C22.6344%2019.8449%2022.278%2019.7685%2021.9724%2019.6667C22.6669%2018.9074%2023.1969%2018.0093%2023.5627%2016.9722C23.9284%2015.9352%2024.1113%2014.8056%2024.1113%2013.5833C24.1113%2012.3611%2023.9284%2011.25%2023.5627%2010.25C23.1969%209.25%2022.6669%208.33333%2021.9724%207.5C22.3057%207.39817%2022.6622%207.32178%2023.0418%207.27083C23.4215%207.21992%2023.778%207.19446%2024.1113%207.19446C25.9446%207.19446%2027.4678%207.80094%2028.6807%209.01392C29.8937%2010.2269%2030.5002%2011.75%2030.5002%2013.5833ZM4.38908%2030.5556H25.5002V29.1667C25.5002%2028.7685%2025.3868%2028.3889%2025.16%2028.0278C24.9331%2027.6667%2024.6484%2027.4074%2024.3057%2027.25C22.4724%2026.4074%2020.8474%2025.8218%2019.4307%2025.493C18.0141%2025.1643%2016.5187%2025%2014.9447%2025C13.3706%2025%2011.8706%2025.1643%2010.4447%2025.493C9.01872%2025.8218%207.38908%2026.4074%205.55574%2027.25C5.21316%2027.4074%204.93306%2027.6667%204.71545%2028.0278C4.49787%2028.3889%204.38908%2028.7685%204.38908%2029.1667V30.5556ZM14.9447%2017.1945C15.9724%2017.1945%2016.8312%2016.8496%2017.521%2016.1597C18.2108%2015.4699%2018.5557%2014.6111%2018.5557%2013.5833C18.5557%2012.5556%2018.2108%2011.6968%2017.521%2011.007C16.8312%2010.3171%2015.9724%209.97221%2014.9447%209.97221C13.9169%209.97221%2013.0581%2010.3171%2012.3682%2011.007C11.6784%2011.6968%2011.3335%2012.5556%2011.3335%2013.5833C11.3335%2014.6111%2011.6784%2015.4699%2012.3682%2016.1597C13.0581%2016.8496%2013.9169%2017.1945%2014.9447%2017.1945Z'%20fill='currentColor'/%3e%3c/svg%3e", Jme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M21.25%202H18.75V11H21.25V2Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M23.64%2017.6521C23.64%2017.1663%2023.5454%2016.7026%2023.3737%2016.2786C22.8327%2014.9423%2021.5259%2014%2019.9999%2014C18.474%2014%2017.1673%2014.942%2016.6262%2016.2782C16.4544%2016.7023%2016.3598%2017.1661%2016.3598%2017.6521C16.3598%2018.1381%2016.4544%2018.6019%2016.6262%2019.026C16.8065%2019.4714%2017.072%2019.873%2017.4023%2020.2105C17.8781%2020.6967%2018.4885%2021.0499%2019.1729%2021.2094C19.4386%2021.2714%2019.7154%2021.3041%2019.9999%2021.3041C20.2844%2021.3041%2020.5614%2021.2713%2020.8271%2021.2094C21.5114%2021.0498%2022.1216%2020.6967%2022.5973%2020.2106C22.9278%2019.873%2023.1933%2019.4712%2023.3737%2019.0256C23.5454%2018.6016%2023.64%2018.138%2023.64%2017.6521Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M25.72%2017.6521C25.72%2017.1663%2025.8145%2016.7026%2025.9862%2016.2785C26.5272%2014.9422%2027.8339%2014%2029.3599%2014C31.3704%2014%2033%2015.6351%2033%2017.6521C33%2019.669%2031.3703%2021.3041%2029.3599%2021.3041C29.0754%2021.3041%2028.7985%2021.2713%2028.5327%2021.2094C27.8485%2021.0498%2027.2383%2020.6967%2026.7625%2020.2106C26.4321%2019.873%2026.1666%2019.4712%2025.9862%2019.0256C25.8145%2018.6016%2025.72%2018.138%2025.72%2017.6521Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M25.5072%2022.4427C26.1915%2022.6022%2026.8017%2022.9554%2027.2774%2023.4415C27.9223%2024.1004%2028.32%2025.0036%2028.32%2026.0001C28.32%2028.017%2026.6903%2029.652%2024.6799%2029.652C24.3954%2029.652%2024.1186%2029.6193%2023.8529%2029.5574C23.1685%2029.3979%2022.5581%2029.0446%2022.0823%2028.5584C21.7521%2028.221%2021.4867%2027.8195%2021.3063%2027.3742C21.1345%2026.9501%2021.0398%2026.4862%2021.0398%2026.0001C21.0398%2025.514%2021.1345%2025.05%2021.3063%2024.6258C21.4867%2024.1805%2021.7522%2023.7789%2022.0824%2023.4414C22.5582%2022.9554%2023.1684%2022.6022%2023.8526%2022.4427C24.1184%2022.3807%2024.3953%2022.348%2024.6799%2022.348C24.9645%2022.348%2025.2415%2022.3807%2025.5072%2022.4427Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M20.8271%2030.7906C21.5115%2030.9501%2022.1219%2031.3033%2022.5977%2031.7895C23.2425%2032.4484%2023.6402%2033.3516%2023.6402%2034.3479C23.6402%2036.365%2022.0104%2038%2020.0001%2038C17.9899%2038%2016.36%2036.3649%2016.36%2034.3479C16.36%2033.3515%2016.7578%2032.4483%2017.4027%2031.7894C17.8784%2031.3033%2018.4886%2030.9502%2019.1728%2030.7906C19.4386%2030.7287%2019.7156%2030.6959%2020.0001%2030.6959C20.2846%2030.6959%2020.5614%2030.7286%2020.8271%2030.7906Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M17.9176%2028.5585C17.4418%2029.0446%2016.8316%2029.3978%2016.1474%2029.5573C15.8816%2029.6193%2015.6047%2029.652%2015.3201%2029.652C13.3096%2029.652%2011.68%2028.017%2011.68%2026.0001C11.68%2025.0036%2012.0777%2024.1004%2012.7226%2023.4415C13.1983%2022.9554%2013.8085%2022.6022%2014.4928%2022.4427C14.7586%2022.3807%2015.0355%2022.348%2015.3201%2022.348C15.6046%2022.348%2015.8814%2022.3807%2016.147%2022.4426C16.8315%2022.6021%2017.4418%2022.9553%2017.9177%2023.4416C18.2479%2023.779%2018.5133%2024.1805%2018.6937%2024.6258C18.8655%2025.05%2018.9602%2025.514%2018.9602%2026.0001C18.9602%2026.4862%2018.8655%2026.9501%2018.6937%2027.3742C18.5133%2027.8196%2018.2478%2028.2211%2017.9176%2028.5585Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M10.6401%2021.3041C10.9246%2021.3041%2011.2015%2021.2713%2011.4673%2021.2094C12.1515%2021.0498%2012.7617%2020.6967%2013.2375%2020.2106C13.5678%2019.8731%2013.8332%2019.4715%2014.0136%2019.026C14.1854%2018.6019%2014.28%2018.1381%2014.28%2017.6521C14.28%2017.1661%2014.1854%2016.7023%2014.0136%2016.2781C13.4726%2014.942%2012.166%2014%2010.6401%2014C8.62967%2014%207%2015.635%207%2017.6521C7%2019.669%208.62961%2021.3041%2010.6401%2021.3041Z'%20fill='currentColor'/%3e%3c/svg%3e", Qme = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M15.0974%2032.2222H24.903L23.9307%2028.3333H16.0696L15.0974%2032.2222ZM15.0002%2025.5556H25.0002C27.4594%2025.5556%2029.5557%2024.6895%2031.2891%2022.9573C33.0224%2021.2251%2033.8891%2019.1302%2033.8891%2016.6725C33.8891%2014.2149%2033.0224%2012.1181%2031.2891%2010.3819C29.5557%208.64581%2027.4594%207.77775%2025.0002%207.77775H15.0002C12.5409%207.77775%2010.4446%208.64385%208.71125%2010.376C6.97791%2012.1082%206.11125%2014.2032%206.11125%2016.6608C6.11125%2019.1184%206.97791%2021.2153%208.71125%2022.9514C10.4446%2024.6875%2012.5409%2025.5556%2015.0002%2025.5556ZM20.0002%2020.5556C18.9168%2020.5556%2017.9978%2020.1783%2017.2432%2019.4236C16.4886%2018.669%2016.1112%2017.75%2016.1112%2016.6667C16.1112%2015.5833%2016.4886%2014.6643%2017.2432%2013.9097C17.9978%2013.1551%2018.9168%2012.7778%2020.0002%2012.7778C21.0835%2012.7778%2022.0025%2013.1551%2022.7571%2013.9097C23.5118%2014.6643%2023.8891%2015.5833%2023.8891%2016.6667C23.8891%2017.75%2023.5118%2018.669%2022.7571%2019.4236C22.0025%2020.1783%2021.0835%2020.5556%2020.0002%2020.5556ZM10.7502%2014.6389C11.1298%2014.6389%2011.4562%2014.5023%2011.7293%2014.2292C12.0025%2013.956%2012.139%2013.625%2012.139%2013.2361C12.139%2012.8472%2012.0025%2012.5208%2011.7293%2012.257C11.4562%2011.9931%2011.1252%2011.8611%2010.7363%2011.8611C10.3474%2011.8611%2010.021%2011.9942%209.75712%2012.2604C9.49323%2012.5266%209.36129%2012.8565%209.36129%2013.25C9.36129%2013.6296%209.49439%2013.956%209.76058%2014.2292C10.0268%2014.5023%2010.3566%2014.6389%2010.7502%2014.6389ZM6.66683%2035V32.2222H12.264L13.278%2028.2222C10.4539%2027.8055%208.09044%2026.5116%206.18766%2024.3403C4.28489%2022.169%203.3335%2019.6111%203.3335%2016.6667C3.3335%2013.4167%204.46544%2010.6597%206.72933%208.39583C8.99322%206.13194%2011.7502%205%2015.0002%205H25.0002C28.2502%205%2031.0071%206.13194%2033.271%208.39583C35.5349%2010.6597%2036.6668%2013.4167%2036.6668%2016.6667C36.6668%2019.6111%2035.7154%2022.169%2033.8127%2024.3403C31.9099%2026.5116%2029.5465%2027.8055%2026.7224%2028.2222L27.7363%2032.2222H33.3335V35H6.66683ZM20.0002%2023.3333C21.8335%2023.3333%2023.4029%2022.6806%2024.7085%2021.375C26.0141%2020.0694%2026.6668%2018.5%2026.6668%2016.6667C26.6668%2014.8333%2026.0141%2013.2639%2024.7085%2011.9583C23.4029%2010.6528%2021.8335%2010%2020.0002%2010C18.1668%2010%2016.5974%2010.6528%2015.2918%2011.9583C13.9863%2013.2639%2013.3335%2014.8333%2013.3335%2016.6667C13.3335%2018.5%2013.9863%2020.0694%2015.2918%2021.375C16.5974%2022.6806%2018.1668%2023.3333%2020.0002%2023.3333Z'%20fill='currentColor'/%3e%3c/svg%3e", ebe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4%2036.6667V33.889H7.27779V28.1945C6.30557%2027.8982%205.51621%2027.345%204.90971%2026.5348C4.30324%2025.7246%204%2024.7871%204%2023.7223V10H13.3333V23.7223C13.3333%2024.7315%2013.0301%2025.6552%2012.4236%2026.4931C11.8171%2027.3311%2011.0278%2027.8982%2010.0555%2028.1945V33.889H13.3333V36.6667H4ZM6.77775%2018.9167H10.5555V12.7778H6.77775V18.9167ZM8.66667%2025.6112C9.17592%2025.6112%209.61804%2025.4237%209.99304%2025.0487C10.368%2024.6737%2010.5555%2024.2315%2010.5555%2023.7223V21.6945H6.77775V23.7223C6.77775%2024.2315%206.96525%2024.6737%207.34025%2025.0487C7.71525%2025.4237%208.15739%2025.6112%208.66667%2025.6112ZM17.8889%2036.6667V15.5278L23.0556%2013.3334V3.33337H30.3889V13.2778L35.6667%2015.5V36.6667H17.8889ZM25.8333%207.88892H27.6111V6.11112H25.8333V7.88892ZM20.6667%2020.4167H32.8889V17.25L27.6111%2015V10.6667H25.8333V15L20.6667%2017.2485V20.4167ZM20.6667%2033.889H32.8889V29.9167H20.6667V33.889ZM20.6667%2027.139H32.8889V23.1945H20.6667V27.139Z'%20fill='currentColor'/%3e%3c/svg%3e", tbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M6.66683%2033.3333C5.75016%2033.3333%204.96544%2033.0069%204.31266%2032.3541C3.65988%2031.7013%203.3335%2030.9166%203.3335%2030V13.3333C3.3335%2012.4166%203.65988%2011.6319%204.31266%2010.9791C4.96544%2010.3263%205.75016%209.99996%206.66683%209.99996H16.6668L20.0002%206.66663H33.3335C34.2502%206.66663%2035.0349%206.99301%2035.6877%207.64579C36.3404%208.29857%2036.6668%209.08329%2036.6668%209.99996V30C36.6668%2030.9166%2036.3404%2031.7013%2035.6877%2032.3541C35.0349%2033.0069%2034.2502%2033.3333%2033.3335%2033.3333H6.66683ZM9.7085%2021.6666H18.3335V13.0416L9.7085%2021.6666ZM6.66683%2020L13.3335%2013.3333H6.66683V20ZM6.66683%2025V30H33.3335V9.99996H21.6668V21.6666C21.6668%2022.5833%2021.3404%2023.368%2020.6877%2024.0208C20.0349%2024.6736%2019.2502%2025%2018.3335%2025H6.66683Z'%20fill='currentColor'/%3e%3c/svg%3e", nbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M17.0209%2030.8333L16.5875%2027.3666C16.3528%2027.2763%2016.1316%2027.168%2015.924%2027.0416C15.7164%2026.9152%2015.5132%2026.7798%2015.3146%2026.6354L12.0917%2027.9895L9.11255%2022.8437L11.9021%2020.7312C11.8841%2020.6048%2011.875%2020.4829%2011.875%2020.3656V19.6343C11.875%2019.517%2011.8841%2019.3951%2011.9021%2019.2687L9.11255%2017.1562L12.0917%2012.0104L15.3146%2013.3645C15.5132%2013.2201%2015.7209%2013.0847%2015.9375%2012.9583C16.1542%2012.8319%2016.3709%2012.7236%2016.5875%2012.6333L17.0209%209.16663H22.9792L23.4125%2012.6333C23.6473%2012.7236%2023.8685%2012.8319%2024.0761%2012.9583C24.2837%2013.0847%2024.4869%2013.2201%2024.6855%2013.3645L27.9084%2012.0104L30.8875%2017.1562L28.098%2019.2687C28.116%2019.3951%2028.125%2019.517%2028.125%2019.6343V20.3656C28.125%2020.4829%2028.107%2020.6048%2028.0709%2020.7312L30.8605%2022.8437L27.8813%2027.9895L24.6855%2026.6354C24.4869%2026.7798%2024.2792%2026.9152%2024.0625%2027.0416C23.8459%2027.168%2023.6292%2027.2763%2023.4125%2027.3666L22.9792%2030.8333H17.0209ZM18.9167%2028.6666H21.0563L21.4355%2025.7958C21.9952%2025.6513%2022.5143%2025.4392%2022.9928%2025.1593C23.4712%2024.8795%2023.9091%2024.5409%2024.3063%2024.1437L26.9875%2025.2541L28.0438%2023.4125L25.7146%2021.652C25.8049%2021.3993%2025.8681%2021.1329%2025.9042%2020.8531C25.9403%2020.5732%2025.9584%2020.2888%2025.9584%2020C25.9584%2019.7111%2025.9403%2019.4267%2025.9042%2019.1468C25.8681%2018.867%2025.8049%2018.6007%2025.7146%2018.3479L28.0438%2016.5875L26.9875%2014.7458L24.3063%2015.8833C23.9091%2015.468%2023.4712%2015.1204%2022.9928%2014.8406C22.5143%2014.5607%2021.9952%2014.3486%2021.4355%2014.2041L21.0834%2011.3333H18.9438L18.5646%2014.2041C18.0049%2014.3486%2017.4858%2014.5607%2017.0073%2014.8406C16.5289%2015.1204%2016.091%2015.459%2015.6938%2015.8562L13.0125%2014.7458L11.9563%2016.5875L14.2855%2018.3208C14.1952%2018.5916%2014.132%2018.8625%2014.0959%2019.1333C14.0598%2019.4041%2014.0417%2019.693%2014.0417%2020C14.0417%2020.2888%2014.0598%2020.5687%2014.0959%2020.8395C14.132%2021.1104%2014.1952%2021.3812%2014.2855%2021.652L11.9563%2023.4125L13.0125%2025.2541L15.6938%2024.1166C16.091%2024.5319%2016.5289%2024.8795%2017.0073%2025.1593C17.4858%2025.4392%2018.0049%2025.6513%2018.5646%2025.7958L18.9167%2028.6666ZM20.0542%2023.7916C21.1014%2023.7916%2021.9952%2023.4215%2022.7355%2022.6812C23.4757%2021.9409%2023.8459%2021.0472%2023.8459%2020C23.8459%2018.9527%2023.4757%2018.059%2022.7355%2017.3187C21.9952%2016.5784%2021.1014%2016.2083%2020.0542%2016.2083C18.9889%2016.2083%2018.0907%2016.5784%2017.3594%2017.3187C16.6282%2018.059%2016.2625%2018.9527%2016.2625%2020C16.2625%2021.0472%2016.6282%2021.9409%2017.3594%2022.6812C18.0907%2023.4215%2018.9889%2023.7916%2020.0542%2023.7916Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M5.5%203C4.11929%203%203%204.11929%203%205.5C3%206.88071%204.11929%208%205.5%208C6.88071%208%208%206.88071%208%205.5C8%204.11929%206.88071%203%205.5%203ZM1%205.5C1%203.01472%203.01472%201%205.5%201C7.98528%201%2010%203.01472%2010%205.5C10%207.98528%207.98528%2010%205.5%2010C3.01472%2010%201%207.98528%201%205.5Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M2%2029H11V38H2V29ZM4%2031V36H9V31H4Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M30%204C30%202.34315%2031.3431%201%2033%201H36C37.6569%201%2039%202.34315%2039%204V7C39%208.65685%2037.6569%2010%2036%2010H33C31.3431%2010%2030%208.65685%2030%207V4ZM33%203C32.4477%203%2032%203.44772%2032%204V7C32%207.55228%2032.4477%208%2033%208H36C36.5523%208%2037%207.55228%2037%207V4C37%203.44772%2036.5523%203%2036%203H33Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M32.5001%2027L38.9953%2038.25H26.0049L32.5001%2027ZM29.469%2036.25H35.5312L32.5001%2031L29.469%2036.25Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M12.793%2014.7071L7.29297%209.20706L8.70718%207.79285L14.2072%2013.2928L12.793%2014.7071Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M29.793%2033.2071L23.293%2026.7071L24.7072%2025.2928L31.2072%2031.7928L29.793%2033.2071Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M15.7072%2026.7072L10.7072%2031.7072L9.29297%2030.2929L14.293%2025.2929L15.7072%2026.7072Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M32.2475%209.66431L28.2475%2014.1643L26.7527%2012.8356L30.7527%208.33558L32.2475%209.66431Z'%20fill='currentColor'/%3e%3c/svg%3e", obe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18.6665%2031.6113H21.4444V23.7084L24.6111%2026.875L26.5553%2024.9167L19.9998%2018.4721L13.4998%2024.9721L15.4582%2026.9167L18.6665%2023.7084V31.6113ZM9.44442%2036.6667C8.69442%2036.6667%208.04387%2036.3913%207.49275%2035.8405C6.94192%2035.2894%206.6665%2034.6388%206.6665%2033.8888V6.11129C6.6665%205.36129%206.94192%204.71074%207.49275%204.15962C8.04387%203.60879%208.69442%203.33337%209.44442%203.33337H23.9165L33.3332%2012.75V33.8888C33.3332%2034.6388%2033.0578%2035.2894%2032.5069%2035.8405C31.9558%2036.3913%2031.3053%2036.6667%2030.5553%2036.6667H9.44442ZM22.5278%2014.0555V6.11129H9.44442V33.8888H30.5553V14.0555H22.5278Z'%20fill='currentColor'/%3e%3c/svg%3e", rbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M5%2018.3333V5H18.3333V18.3333H5ZM5%2035V21.6667H18.3333V35H5ZM21.6667%2018.3333V5H35V18.3333H21.6667ZM21.6667%2035V21.6667H35V35H21.6667ZM8.33333%2015H15V8.33333H8.33333V15ZM25%2015H31.6667V8.33333H25V15ZM25%2031.6667H31.6667V25H25V31.6667ZM8.33333%2031.6667H15V25H8.33333V31.6667Z'%20fill='currentColor'/%3e%3c/svg%3e", ibe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.33333%2035C7.41667%2035%206.63194%2034.6736%205.97917%2034.0208C5.32639%2033.3681%205%2032.5833%205%2031.6667V8.33333C5%207.41667%205.32639%206.63194%205.97917%205.97917C6.63194%205.32639%207.41667%205%208.33333%205H31.6667C32.5833%205%2033.3681%205.32639%2034.0208%205.97917C34.6736%206.63194%2035%207.41667%2035%208.33333V31.6667C35%2032.5833%2034.6736%2033.3681%2034.0208%2034.0208C33.3681%2034.6736%2032.5833%2035%2031.6667%2035H8.33333ZM18.3333%2025H8.33333V31.6667H18.3333V25ZM21.6667%2025V31.6667H31.6667V25H21.6667ZM18.3333%2021.6667V15H8.33333V21.6667H18.3333ZM21.6667%2021.6667H31.6667V15H21.6667V21.6667ZM8.33333%2011.6667H31.6667V8.33333H8.33333V11.6667Z'%20fill='currentColor'/%3e%3c/svg%3e", sbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.25016%2031.2778L3.3335%2025.3611L5.27791%2023.4167L9.23629%2027.3473L16.5696%2020.0139L18.514%2022L9.25016%2031.2778ZM9.25016%2017.9444L3.3335%2012.0278L5.27791%2010.0833L9.23629%2014.0139L16.5696%206.68054L18.514%208.66667L9.25016%2017.9444ZM21.6668%2028.0555V25.2778H36.6668V28.0555H21.6668ZM21.6668%2014.7222V11.9445H36.6668V14.7222H21.6668Z'%20fill='currentColor'/%3e%3c/svg%3e", abe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.107%2022.4444C8.4337%2022.4444%207.85862%2022.2046%207.38175%2021.7252C6.90492%2021.2457%206.6665%2020.6693%206.6665%2019.996C6.6665%2019.3227%206.90624%2018.7477%207.38571%2018.2708C7.86518%2017.794%208.44156%2017.5555%209.11484%2017.5555C9.78814%2017.5555%2010.3632%2017.7953%2010.8401%2018.2747C11.3169%2018.7542%2011.5553%2019.3306%2011.5553%2020.0039C11.5553%2020.6772%2011.3156%2021.2523%2010.8361%2021.7291C10.3567%2022.206%209.78028%2022.4444%209.107%2022.4444ZM19.9959%2022.4444C19.3226%2022.4444%2018.7475%2022.2046%2018.2707%2021.7252C17.7938%2021.2457%2017.5554%2020.6693%2017.5554%2019.996C17.5554%2019.3227%2017.7952%2018.7477%2018.2746%2018.2708C18.7541%2017.794%2019.3305%2017.5555%2020.0038%2017.5555C20.6771%2017.5555%2021.2521%2017.7953%2021.729%2018.2747C22.2058%2018.7542%2022.4443%2019.3306%2022.4443%2020.0039C22.4443%2020.6772%2022.2045%2021.2523%2021.725%2021.7291C21.2456%2022.206%2020.6692%2022.4444%2019.9959%2022.4444ZM30.8848%2022.4444C30.2115%2022.4444%2029.6364%2022.2046%2029.1596%2021.7252C28.6828%2021.2457%2028.4443%2020.6693%2028.4443%2019.996C28.4443%2019.3227%2028.6841%2018.7477%2029.1635%2018.2708C29.643%2017.794%2030.2194%2017.5555%2030.8927%2017.5555C31.566%2017.5555%2032.141%2017.7953%2032.6179%2018.2747C33.0947%2018.7542%2033.3332%2019.3306%2033.3332%2020.0039C33.3332%2020.6772%2033.0934%2021.2523%2032.614%2021.7291C32.1345%2022.206%2031.5581%2022.4444%2030.8848%2022.4444Z'%20fill='currentColor'/%3e%3c/svg%3e", lbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M14.7385%2034.7045C11.6092%2033.5409%209.04042%2031.5818%207.03203%2028.8273C5.02363%2026.0728%204.01943%2022.9227%204.01943%2019.3773C4.01943%2018.5591%204.0789%2017.7454%204.19784%2016.9363C4.31681%2016.1273%204.50438%2015.3318%204.76057%2014.55L2.37246%2015.9273L1%2013.5955L8.37015%209.3682L12.6248%2016.65L10.2367%2018.0136L7.90352%2014.0318C7.54668%2014.8772%207.27448%2015.75%207.08691%2016.65C6.89932%2017.55%206.80553%2018.4682%206.80553%2019.4045C6.80553%2022.3955%207.67477%2025.0614%209.41326%2027.4023C11.1517%2029.7432%2013.3935%2031.3773%2016.1384%2032.3046L14.7385%2034.7045ZM26.8437%2013.9091V11.1818H31.4964C30.1971%209.46364%2028.5867%208.125%2026.6653%207.1659C24.7438%206.2068%2022.6988%205.72725%2020.5303%205.72725C18.7644%205.72725%2017.1128%206.0318%2015.5756%206.64091C14.0385%207.24999%2012.6614%208.09545%2011.4445%209.17727L10.0446%206.75001C11.4902%205.57729%2013.0937%204.6591%2014.8551%203.99544C16.6164%203.33181%2018.4945%203%2020.4891%203C22.8223%203%2025.0343%203.45682%2027.1251%204.37045C29.2158%205.28409%2031.0435%206.58636%2032.6081%208.27727V5.45455H35.353V13.9091H26.8437ZM25.2516%2039L17.8814%2034.7727L22.1361%2027.4909L24.483%2028.8545L22.1086%2032.9455C25.5673%2032.5546%2028.4563%2031.075%2030.7759%2028.5068C33.0953%2025.9387%2034.2551%2022.9046%2034.2551%2019.4045C34.2551%2018.9227%2034.2299%2018.4545%2034.1796%2018C34.1293%2017.5454%2034.0492%2017.0909%2033.9394%2016.6364H36.753C36.8353%2017.0909%2036.8971%2017.5432%2036.9382%2017.9932C36.9794%2018.4432%2037%2018.9%2037%2019.3636C37%2023.1909%2035.8128%2026.5886%2033.4384%2029.5568C31.064%2032.525%2028.0149%2034.4409%2024.2909%2035.3046L26.6241%2036.6682L25.2516%2039Z'%20fill='currentColor'/%3e%3c/svg%3e", cbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M23.6388%2026.4446H26.4167V21.3334H31.5V18.5554H26.4167V13.4721H23.6388V18.5554H18.5279V21.3334H23.6388V26.4446ZM9.80542%2034.0554C6.85181%2032.926%204.47917%2031.0834%202.6875%2028.5275C0.895833%2025.972%200%2023.1224%200%2019.9788C0%2016.8354%200.900417%2013.9884%202.70125%2011.4375C4.50236%208.88669%206.87042%207.04641%209.80542%205.91669V9.02794C7.65736%2010.0185%205.94903%2011.5018%204.68042%2013.4779C3.41208%2015.4538%202.77792%2017.6185%202.77792%2019.9721C2.77792%2022.3518%203.41208%2024.5232%204.68042%2026.4863C5.94903%2028.4491%207.65736%2029.9352%209.80542%2030.9446V34.0554ZM25%2034.9721C22.9167%2034.9721%2020.9653%2034.5763%2019.1458%2033.7846C17.3264%2032.9929%2015.7431%2031.9235%2014.3958%2030.5763C13.0486%2029.2291%2011.9792%2027.6457%2011.1875%2025.8263C10.3958%2024.0068%2010%2022.0554%2010%2019.9721C10%2017.8888%2010.3958%2015.9374%2011.1875%2014.1179C11.9792%2012.2985%2013.0486%2010.7152%2014.3958%209.36794C15.7431%208.02072%2017.3264%206.95127%2019.1458%206.15961C20.9653%205.36794%2022.9167%204.97211%2025%204.97211C27.0833%204.97211%2029.0347%205.36794%2030.8542%206.15961C32.6736%206.95127%2034.2569%208.02072%2035.6042%209.36794C36.9514%2010.7152%2038.0208%2012.2985%2038.8125%2014.1179C39.6042%2015.9374%2040%2017.8888%2040%2019.9721C40%2022.0554%2039.6042%2024.0068%2038.8125%2025.8263C38.0208%2027.6457%2036.9514%2029.2291%2035.6042%2030.5763C34.2569%2031.9235%2032.6736%2032.9929%2030.8542%2033.7846C29.0347%2034.5763%2027.0833%2034.9721%2025%2034.9721ZM25.0138%2032.1946C28.4026%2032.1946%2031.2846%2031.0088%2033.6596%2028.6371C36.0346%2026.2652%2037.2221%2023.3768%2037.2221%2019.9721C37.2221%2016.5927%2036.0363%2013.7107%2033.6646%2011.3263C31.2929%208.94211%2028.4047%207.75002%2025%207.75002C21.6203%207.75002%2018.7383%208.94211%2016.3542%2011.3263C13.97%2013.7107%2012.7779%2016.5927%2012.7779%2019.9721C12.7779%2023.3768%2013.97%2026.2652%2016.3542%2028.6371C18.7383%2031.0088%2021.6249%2032.1946%2025.0138%2032.1946Z'%20fill='currentColor'/%3e%3c/svg%3e", dbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M30.2776%2023.3333V18.0555H24.9998V15.2778H30.2776V10H33.0554V15.2778H38.3332V18.0555H33.0554V23.3333H30.2776ZM14.9998%2019.9722C13.1665%2019.9722%2011.6434%2019.3657%2010.4304%2018.1528C9.21743%2016.9398%208.61096%2015.4167%208.61096%2013.5833C8.61096%2011.75%209.21743%2010.2269%2010.4304%209.01392C11.6434%207.80094%2013.1665%207.19446%2014.9998%207.19446C16.8332%207.19446%2018.3563%207.80094%2019.5693%209.01392C20.7822%2010.2269%2021.3887%2011.75%2021.3887%2013.5833C21.3887%2015.4167%2020.7822%2016.9398%2019.5693%2018.1528C18.3563%2019.3657%2016.8332%2019.9722%2014.9998%2019.9722ZM1.6665%2033.3333V29.1667C1.6665%2028.2037%201.90956%2027.3264%202.39567%2026.5348C2.88178%2025.7431%203.56466%2025.1482%204.4443%2024.75C6.40727%2023.8519%208.22521%2023.206%209.89813%2022.8125C11.5711%2022.419%2013.2701%2022.2223%2014.9953%2022.2223C16.7206%2022.2223%2018.4165%2022.419%2020.0832%2022.8125C21.7498%2023.206%2023.5647%2023.8519%2025.5276%2024.75C26.4072%2025.1667%2027.0947%2025.7662%2027.5901%2026.5486C28.0855%2027.331%2028.3332%2028.2037%2028.3332%2029.1667V33.3333H1.6665ZM4.44425%2030.5556H25.5554V29.1667C25.5554%2028.7685%2025.4466%2028.3935%2025.229%2028.0417C25.0114%2027.6898%2024.7221%2027.4259%2024.361%2027.25C22.5461%2026.3889%2020.9304%2025.7986%2019.5137%2025.4792C18.097%2025.1597%2016.5924%2025%2014.9998%2025C13.4073%2025%2011.898%2025.1597%2010.472%2025.4792C9.04613%2025.7986%207.42577%2026.3889%205.61096%2027.25C5.24982%2027.4259%204.96509%2027.6898%204.75675%2028.0417C4.54842%2028.3935%204.44425%2028.7685%204.44425%2029.1667V30.5556ZM14.9998%2017.1945C16.0276%2017.1945%2016.8864%2016.8496%2017.5762%2016.1597C18.266%2015.4699%2018.611%2014.6111%2018.611%2013.5833C18.611%2012.5556%2018.266%2011.6968%2017.5762%2011.007C16.8864%2010.3171%2016.0276%209.97221%2014.9998%209.97221C13.9721%209.97221%2013.1133%2010.3171%2012.4235%2011.007C11.7336%2011.6968%2011.3887%2012.5556%2011.3887%2013.5833C11.3887%2014.6111%2011.7336%2015.4699%2012.4235%2016.1597C13.1133%2016.8496%2013.9721%2017.1945%2014.9998%2017.1945Z'%20fill='currentColor'/%3e%3c/svg%3e", ube = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18.6946%2028.3333H21.4724V21.5H28.3335V18.7222H21.4724V11.6666H18.6946V18.7222H11.6668V21.5H18.6946V28.3333ZM20.0075%2036.6666C17.7069%2036.6666%2015.5449%2036.2291%2013.5215%2035.3541C11.498%2034.4791%209.73165%2033.287%208.22237%2031.7778C6.71312%2030.2685%205.521%2028.5015%204.646%2026.4766C3.771%2024.4518%203.3335%2022.2883%203.3335%2019.9861C3.3335%2017.6839%203.771%2015.5204%204.646%2013.4956C5.521%2011.4707%206.71312%209.70831%208.22237%208.20831C9.73165%206.70831%2011.4987%205.52081%2013.5235%204.64581C15.5483%203.77081%2017.7118%203.33331%2020.014%203.33331C22.3163%203.33331%2024.4798%203.77081%2026.5046%204.64581C28.5294%205.52081%2030.2918%206.70831%2031.7918%208.20831C33.2918%209.70831%2034.4793%2011.4722%2035.3543%2013.5C36.2293%2015.5278%2036.6668%2017.692%2036.6668%2019.9926C36.6668%2022.2932%2036.2293%2024.4552%2035.3543%2026.4787C34.4793%2028.5021%2033.2918%2030.2668%2031.7918%2031.7726C30.2918%2033.2785%2028.5279%2034.4706%2026.5002%2035.349C24.4724%2036.2274%2022.3082%2036.6666%2020.0075%2036.6666ZM20.014%2033.8889C23.8752%2033.8889%2027.1529%2032.537%2029.8474%2029.8333C32.5419%2027.1296%2033.8891%2023.8472%2033.8891%2019.9861C33.8891%2016.125%2032.5436%2012.8472%2029.8526%2010.1527C27.1616%207.45829%2023.8775%206.11106%2020.0002%206.11106C16.1483%206.11106%2012.8705%207.45655%2010.1668%2010.1475C7.46311%2012.8385%206.11125%2016.1227%206.11125%2020C6.11125%2023.8518%207.46311%2027.1296%2010.1668%2029.8333C12.8705%2032.537%2016.1529%2033.8889%2020.014%2033.8889Z'%20fill='currentColor'/%3e%3c/svg%3e", fbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M5%2035V31.7778L7.77775%2029V35H5ZM11.8055%2035V25.1111L14.5833%2022.3333V35H11.8055ZM18.6111%2035V22.3333L21.3889%2025.1528V35H18.6111ZM25.4167%2035V25.1528L28.1945%2022.375V35H25.4167ZM32.2222%2035V18.4445L35%2015.6667V35H32.2222ZM5%2025.5694V21.6389L16.6667%2010.0278L23.3333%2016.6945L35%205V8.93054L23.3333%2020.625L16.6667%2013.9583L5%2025.5694Z'%20fill='currentColor'/%3e%3c/svg%3e", pbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M24.9977%2031.6666L22.6227%2029.3333L30.2894%2021.6666H3.33105V18.3333H30.2894L22.6644%2010.6666L24.9977%208.33325L36.6644%2019.9999L24.9977%2031.6666Z'%20fill='currentColor'/%3e%3c/svg%3e", hbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M20%2027L10%2016.9768L11.9722%2015L20%2023.0743L28.0278%2015.0279L30%2017.0046L20%2027Z'%20fill='currentColor'/%3e%3c/svg%3e", gbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18.611%206.66663V28.0417L8.61092%2018.0416L6.6665%2020L19.9998%2033.3333L33.3332%2020L31.3888%2018.0416L21.3887%2028.0417V6.66663H18.611Z'%20fill='currentColor'/%3e%3c/svg%3e", mbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M23.3614%2030L13.3335%2019.9721L23.3614%209.94458L25.3335%2011.9167L17.2781%2019.9721L25.3335%2028.0279L23.3614%2030Z'%20fill='currentColor'/%3e%3c/svg%3e", bbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.9581%2021.3888L21.9582%2031.3889L19.9998%2033.3333L6.6665%2020L19.9998%206.66663L21.9582%208.61104L11.9581%2018.6111H33.3332V21.3888H11.9581Z'%20fill='currentColor'/%3e%3c/svg%3e", Cbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M21.7219%2019.9721L13.6665%2011.9167L15.6386%209.94458L25.6665%2019.9721L15.6386%2030L13.6665%2028.0279L21.7219%2019.9721Z'%20fill='currentColor'/%3e%3c/svg%3e", xbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M28.0415%2021.3888H6.6665V18.6111H28.0415L18.0415%208.61104L19.9998%206.66663L33.3332%2020L19.9998%2033.3333L18.0415%2031.3889L28.0415%2021.3888Z'%20fill='currentColor'/%3e%3c/svg%3e", ybe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.9722%2025L10%2023.0232L20%2013L30%2022.9954L28.0278%2024.9721L20%2016.9257L11.9722%2025Z'%20fill='currentColor'/%3e%3c/svg%3e", vbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18.611%2033.3333V11.9583L8.61092%2021.9583L6.6665%2020L19.9998%206.66663L33.3332%2020L31.3888%2021.9583L21.3887%2011.9583V33.3333H18.611Z'%20fill='currentColor'/%3e%3c/svg%3e", wbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M5%2036.6666V6.11106H10.1389V3.33331H13.0555V6.11106H26.9445V3.33331H29.8611V6.11106H35V36.6666H5ZM7.77775%2033.8889H32.2222V16.3889H7.77775V33.8889ZM7.77775%2013.6111H32.2222V8.88886H7.77775V13.6111Z'%20fill='currentColor'/%3e%3c/svg%3e", Sbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M32.75%2035C29.5926%2035%2026.3634%2034.2268%2023.0625%2032.6805C19.7616%2031.1342%2016.7037%2028.9537%2013.8889%2026.1389C11.0555%2023.324%208.86574%2020.2685%207.31946%2016.9722C5.77315%2013.6759%205%2010.4352%205%207.24998V4.99998H14.25L15.875%2013.0416L11.0417%2017.9444C11.7639%2019.1389%2012.5231%2020.2546%2013.3194%2021.2916C14.1157%2022.3287%2014.9537%2023.2824%2015.8333%2024.1528C16.7685%2025.088%2017.7755%2025.9699%2018.8542%2026.7986C19.9329%2027.6273%2021.0926%2028.3889%2022.3333%2029.0834L27.1945%2024.1111L35%2025.7639V35H32.75ZM9.70833%2015.3333L12.875%2012.1389L12%207.77773H7.79167C7.83794%208.89809%208.01386%2010.0763%208.31942%2011.3125C8.62497%2012.5486%209.08794%2013.8889%209.70833%2015.3333ZM24.9305%2030.3889C26.0602%2030.8981%2027.2569%2031.3102%2028.5208%2031.625C29.7847%2031.9398%2031.0185%2032.1296%2032.2222%2032.1944V28L28.0556%2027.1528L24.9305%2030.3889ZM21.5278%2018.4166V8.49998H24.3055V13.6944L33.6667%204.33331L35.6389%206.30552L26.3055%2015.6389H31.4445V18.4166H21.5278Z'%20fill='currentColor'/%3e%3c/svg%3e", Mbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13.8335%2028.1111L20.0002%2021.9444L26.1668%2028.1111L28.1113%2026.1666L21.9446%2020L28.1113%2013.8333L26.1668%2011.8889L20.0002%2018.0556L13.8335%2011.8889L11.889%2013.8333L18.0557%2020L11.889%2026.1666L13.8335%2028.1111ZM20.0002%2036.6666C17.7131%2036.6666%2015.5557%2036.2291%2013.528%2035.3541C11.5002%2034.4791%209.73165%2033.287%208.22237%2031.7778C6.71312%2030.2685%205.521%2028.5%204.646%2026.4722C3.771%2024.4444%203.3335%2022.287%203.3335%2020C3.3335%2017.6944%203.771%2015.5278%204.646%2013.5C5.521%2011.4722%206.71312%209.70831%208.22237%208.20831C9.73165%206.70831%2011.5002%205.52081%2013.528%204.64581C15.5557%203.77081%2017.7131%203.33331%2020.0002%203.33331C22.3057%203.33331%2024.4724%203.77081%2026.5002%204.64581C28.5279%205.52081%2030.2918%206.70831%2031.7918%208.20831C33.2918%209.70831%2034.4793%2011.4722%2035.3543%2013.5C36.2293%2015.5278%2036.6668%2017.6944%2036.6668%2020C36.6668%2022.287%2036.2293%2024.4444%2035.3543%2026.4722C34.4793%2028.5%2033.2918%2030.2685%2031.7918%2031.7778C30.2918%2033.287%2028.5279%2034.4791%2026.5002%2035.3541C24.4724%2036.2291%2022.3057%2036.6666%2020.0002%2036.6666ZM20.0002%2033.8889C23.8705%2033.8889%2027.1529%2032.537%2029.8474%2029.8333C32.5419%2027.1296%2033.8891%2023.8518%2033.8891%2020C33.8891%2016.1296%2032.5419%2012.8472%2029.8474%2010.1527C27.1529%207.45829%2023.8705%206.11106%2020.0002%206.11106C16.1483%206.11106%2012.8705%207.45829%2010.1668%2010.1527C7.46311%2012.8472%206.11125%2016.1296%206.11125%2020C6.11125%2023.8518%207.46311%2027.1296%2010.1668%2029.8333C12.8705%2032.537%2016.1483%2033.8889%2020.0002%2033.8889Z'%20fill='currentColor'/%3e%3c/svg%3e", Tbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M15.8054%2029.8333L6.4165%2020.4444L8.40259%2018.4583L15.8054%2025.8611L31.5693%2010.0972L33.5554%2012.0833L15.8054%2029.8333Z'%20fill='currentColor'/%3e%3c/svg%3e", kbe = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M7.85995%2013.3202C10.8754%2013.3202%2013.32%2010.8757%2013.32%207.8602C13.32%204.84472%2010.8754%202.4002%207.85995%202.4002C4.84448%202.4002%202.39995%204.84472%202.39995%207.8602C2.39995%2010.8757%204.84448%2013.3202%207.85995%2013.3202ZM7.85995%2014.5202C11.5382%2014.5202%2014.52%2011.5384%2014.52%207.8602C14.52%204.18198%2011.5382%201.2002%207.85995%201.2002C4.18173%201.2002%201.19995%204.18198%201.19995%207.8602C1.19995%2011.5384%204.18173%2014.5202%207.85995%2014.5202Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M11.6486%206.04872L7.01376%2010.6835L4.40002%208.06978L5.24855%207.22125L7.01376%208.98646L10.8%205.2002L11.6486%206.04872Z'%20fill='currentColor'/%3e%3c/svg%3e", Ebe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4.47217%2020.1945V17.4167H9.63883V20.1945H4.47217ZM9.52771%2029.6945L7.63883%2027.7778L11.25%2024.1667L13.1666%2026.0556L9.52771%2029.6945ZM11.25%2013.3611L7.63883%209.75L9.52771%207.83333L13.1666%2011.4722L11.25%2013.3611ZM30.5555%2033.3611L22.6944%2025.5L20.7777%2031.3611L16.2222%2015.8056L31.5555%2020.5556L25.6666%2022.6389L33.4721%2030.4445L30.5555%2033.3611ZM17.6944%2010.1667V5H20.4722V10.1667H17.6944ZM26.9166%2013.3611L25%2011.4722L28.6388%207.83333L30.5277%209.72221L26.9166%2013.3611Z'%20fill='currentColor'/%3e%3c/svg%3e", Rbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M27.5833%2026V14L21.5834%2020L27.5833%2026ZM7.77775%2032.2222H13.5278V7.77775H7.77775V32.2222ZM16.3055%2032.2222H32.2222V7.77775H16.3055V32.2222ZM5%2035V5H35V35H5Z'%20fill='currentColor'/%3e%3c/svg%3e", Obe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M10.4722%2031.4722L8.52783%2029.5278L18.0556%2020L8.52783%2010.4722L10.4722%208.52783L20%2018.0556L29.5278%208.52783L31.4722%2010.4722L21.9445%2020L31.4722%2029.5278L29.5278%2031.4722L20%2021.9445L10.4722%2031.4722Z'%20fill='currentColor'/%3e%3c/svg%3e", _be = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M5.01367%2031.6666V8.33331H34.9998V31.6666H5.01367ZM7.77755%2028.8889H14.0693V11.1111H7.77755V28.8889ZM16.847%2028.8889H23.1387V11.1111H16.847V28.8889ZM25.9165%2028.8889H32.2081V11.1111H25.9165V28.8889Z'%20fill='currentColor'/%3e%3c/svg%3e", Pbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13.2502%2033.3334L11.3057%2031.375L16.0974%2026.5834H3.3335V23.8056H16.0974L11.3057%2019.0139L13.2502%2017.0556L21.389%2025.1945L13.2502%2033.3334ZM26.7502%2022.9444L18.6113%2014.8056L26.7502%206.66669L28.6946%208.62502L23.9029%2013.4167H36.6668V16.1944H23.9029L28.6946%2020.9861L26.7502%2022.9444Z'%20fill='currentColor'/%3e%3c/svg%3e", Lbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M20.0002%2036.6666C17.6946%2036.6666%2015.5279%2036.2291%2013.5002%2035.3541C11.4724%2034.4791%209.7085%2033.2916%208.2085%2031.7916C6.7085%2030.2916%205.521%2028.5278%204.646%2026.5C3.771%2024.4722%203.3335%2022.3055%203.3335%2020C3.3335%2017.6944%203.771%2015.5278%204.646%2013.5C5.521%2011.4722%206.7085%209.70831%208.2085%208.20831C9.7085%206.70831%2011.4724%205.52081%2013.5002%204.64581C15.5279%203.77081%2017.6946%203.33331%2020.0002%203.33331C22.3057%203.33331%2024.4724%203.77081%2026.5002%204.64581C28.5279%205.52081%2030.2918%206.70831%2031.7918%208.20831C33.2918%209.70831%2034.4793%2011.4722%2035.3543%2013.5C36.2293%2015.5278%2036.6668%2017.6944%2036.6668%2020C36.6668%2022.3055%2036.2293%2024.4722%2035.3543%2026.5C34.4793%2028.5278%2033.2918%2030.2916%2031.7918%2031.7916C30.2918%2033.2916%2028.5279%2034.4791%2026.5002%2035.3541C24.4724%2036.2291%2022.3057%2036.6666%2020.0002%2036.6666ZM18.6114%2033.8333V6.16665C15.0464%206.5647%2012.0718%208.07859%209.68766%2010.7083C7.3035%2013.338%206.11141%2016.4353%206.11141%2020C6.11141%2023.5647%207.3035%2026.6573%209.68766%2029.2779C12.0718%2031.8982%2015.0464%2033.4167%2018.6114%2033.8333ZM21.3889%2033.8333C22.3706%2033.713%2023.3289%2033.5023%2024.2639%2033.2012C25.1992%2032.9004%2026.102%2032.5%2026.9722%2032H21.3889V33.8333ZM21.3889%2029.2221H30.3889C30.7222%2028.824%2031.0417%2028.4212%2031.3472%2028.0137C31.6528%2027.6065%2031.9353%2027.1668%2032.1947%2026.6946H21.3889V29.2221ZM21.3889%2023.9166H33.3056C33.4722%2023.5091%2033.5834%2023.0925%2033.6389%2022.6666C33.6945%2022.2408%2033.7409%2021.8148%2033.7781%2021.3887H21.3889V23.9166ZM21.3889%2018.6112H33.7781C33.7409%2018.1851%2033.6945%2017.7591%2033.6389%2017.3333C33.5834%2016.9075%2033.4722%2016.4908%2033.3056%2016.0833H21.3889V18.6112ZM21.3889%2013.3054H32.1947C31.9539%2012.8332%2031.6761%2012.3935%2031.3614%2011.9862C31.0464%2011.5787%2030.7222%2011.176%2030.3889%2010.7779H21.3889V13.3054ZM21.3889%207.99998H26.9722C26.102%207.49998%2025.1992%207.09484%2024.2639%206.78456C23.3289%206.47456%2022.3706%206.26859%2021.3889%206.16665V7.99998Z'%20fill='currentColor'/%3e%3c/svg%3e", Ibe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.4446%2035V13.5556L23.0557%201.66669L25.6945%203.97223L23.5279%2013.5556H38.1946V20.75L32.0557%2035H11.4446ZM14.2223%2032.2223H30.2501L35.4168%2020.0278V16.3334H20.0557L22.2779%206.3611L14.2223%2014.7222V32.2223ZM3.30566%2035V13.5556H11.4446V16.3334H6.08346V32.2223H11.4446V35H3.30566Z'%20fill='currentColor'/%3e%3c/svg%3e", jbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M5%2035V5H35V35H5ZM7.77775%2032.2222H18.6111V7.77775H7.77775V32.2222ZM21.3889%2032.2222H32.2222V19.9722H21.3889V32.2222ZM21.3889%2017.1945H32.2222V7.77775H21.3889V17.1945Z'%20fill='currentColor'/%3e%3c/svg%3e", Vbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.36096%2035V9.16663H6.6665V6.38888H14.6665V5H25.3332V6.38888H33.3332V9.16663H31.6387V35H8.36096ZM11.1387%2032.2222H28.861V9.16663H11.1387V32.2222ZM15.1943%2028.7222H17.972V12.6389H15.1943V28.7222ZM22.0276%2028.7222H24.8054V12.6389H22.0276V28.7222Z'%20fill='currentColor'/%3e%3c/svg%3e", Dbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M10%2036.6667C8.61111%2036.6667%207.43056%2036.1806%206.45833%2035.2083C5.48611%2034.2361%205%2033.0556%205%2031.6667V8.33334C5%206.94446%205.48611%205.7639%206.45833%204.79168C7.43056%203.81945%208.61111%203.33334%2010%203.33334H27.7778V29.4444H10C9.37036%2029.4444%208.84258%2029.6574%208.41667%2030.0833C7.99072%2030.5093%207.77775%2031.037%207.77775%2031.6667C7.77775%2032.2963%207.99072%2032.8241%208.41667%2033.25C8.84258%2033.676%209.37036%2033.8889%2010%2033.8889H32.2222V6.66668H35V36.6667H10ZM14.4444%2026.6667H25V6.11109H14.4444V26.6667ZM11.6667%2026.6667V6.11109H10C9.36111%206.11109%208.83101%206.32407%208.40971%206.75001C7.9884%207.17593%207.77775%207.7037%207.77775%208.33334V27.2361C8.11108%2027.0602%208.45954%2026.9213%208.82313%2026.8195C9.18671%2026.7176%209.579%2026.6667%2010%2026.6667H11.6667Z'%20fill='currentColor'/%3e%3c/svg%3e", Abe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M14.7196%2033.3334C13.8786%2033.3334%2013.1596%2033.0339%2012.5623%2032.4351C11.9651%2031.8362%2011.6665%2031.1163%2011.6665%2030.2754C11.6665%2029.4344%2011.9659%2028.7153%2012.5648%2028.1181C13.1637%2027.5209%2013.8836%2027.2223%2014.7245%2027.2223C15.5654%2027.2223%2016.2845%2027.5217%2016.8818%2028.1206C17.479%2028.7194%2017.7776%2029.4393%2017.7776%2030.2803C17.7776%2031.1212%2017.4782%2031.8403%2016.8793%2032.4375C16.2804%2033.0347%2015.5605%2033.3334%2014.7196%2033.3334ZM25.2752%2033.3334C24.4342%2033.3334%2023.7151%2033.0339%2023.1179%2032.4351C22.5207%2031.8362%2022.2221%2031.1163%2022.2221%2030.2754C22.2221%2029.4344%2022.5215%2028.7153%2023.1204%2028.1181C23.7192%2027.5209%2024.4391%2027.2223%2025.2801%2027.2223C26.121%2027.2223%2026.8401%2027.5217%2027.4373%2028.1206C28.0346%2028.7194%2028.3332%2029.4393%2028.3332%2030.2803C28.3332%2031.1212%2028.0337%2031.8403%2027.4349%2032.4375C26.836%2033.0347%2026.1161%2033.3334%2025.2752%2033.3334ZM14.7196%2023.0556C13.8786%2023.0556%2013.1596%2022.7561%2012.5623%2022.1573C11.9651%2021.5584%2011.6665%2020.8385%2011.6665%2019.9976C11.6665%2019.1566%2011.9659%2018.4375%2012.5648%2017.8403C13.1637%2017.2431%2013.8836%2016.9445%2014.7245%2016.9445C15.5654%2016.9445%2016.2845%2017.2439%2016.8818%2017.8428C17.479%2018.4416%2017.7776%2019.1615%2017.7776%2020.0025C17.7776%2020.8434%2017.4782%2021.5625%2016.8793%2022.1597C16.2804%2022.757%2015.5605%2023.0556%2014.7196%2023.0556ZM25.2752%2023.0556C24.4342%2023.0556%2023.7151%2022.7561%2023.1179%2022.1573C22.5207%2021.5584%2022.2221%2020.8385%2022.2221%2019.9976C22.2221%2019.1566%2022.5215%2018.4375%2023.1204%2017.8403C23.7192%2017.2431%2024.4391%2016.9445%2025.2801%2016.9445C26.121%2016.9445%2026.8401%2017.2439%2027.4373%2017.8428C28.0346%2018.4416%2028.3332%2019.1615%2028.3332%2020.0025C28.3332%2020.8434%2028.0337%2021.5625%2027.4349%2022.1597C26.836%2022.757%2026.1161%2023.0556%2025.2752%2023.0556ZM14.7196%2012.7778C13.8786%2012.7778%2013.1596%2012.4783%2012.5623%2011.8795C11.9651%2011.2806%2011.6665%2010.5607%2011.6665%209.71977C11.6665%208.87883%2011.9659%208.15974%2012.5648%207.56252C13.1637%206.9653%2013.8836%206.66669%2014.7245%206.66669C15.5654%206.66669%2016.2845%206.96612%2016.8818%207.56498C17.479%208.16384%2017.7776%208.88374%2017.7776%209.72469C17.7776%2010.5656%2017.4782%2011.2847%2016.8793%2011.8819C16.2804%2012.4792%2015.5605%2012.7778%2014.7196%2012.7778ZM25.2752%2012.7778C24.4342%2012.7778%2023.7151%2012.4783%2023.1179%2011.8795C22.5207%2011.2806%2022.2221%2010.5607%2022.2221%209.71977C22.2221%208.87883%2022.5215%208.15974%2023.1204%207.56252C23.7192%206.9653%2024.4391%206.66669%2025.2801%206.66669C26.121%206.66669%2026.8401%206.96612%2027.4373%207.56498C28.0346%208.16384%2028.3332%208.88374%2028.3332%209.72469C28.3332%2010.5656%2028.0337%2011.2847%2027.4349%2011.8819C26.836%2012.4792%2026.1161%2012.7778%2025.2752%2012.7778Z'%20fill='currentColor'/%3e%3c/svg%3e", Hbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M10.5555%2031.1111V3.33331H33.3333V31.1111H10.5555ZM13.3333%2028.3334H30.5556V6.11106H13.3333V28.3334ZM5%2036.6666V8.88886H7.77775V33.8889H27.7778V36.6666H5Z'%20fill='currentColor'/%3e%3c/svg%3e", Fbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M7.77775%2032.2222H9.79163L28.3334%2013.7083L26.3195%2011.6944L7.77775%2030.2084V32.2222ZM5%2035V29.0834L30.2639%203.875L36.1389%209.80554L10.9166%2035H5ZM27.3195%2012.7083L26.3195%2011.6944L28.3334%2013.7083L27.3195%2012.7083Z'%20fill='currentColor'/%3e%3c/svg%3e", Nbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M32.5393%209.46856L37%205.00786L34.9921%203L30.5315%207.46069C27.6845%205.06705%2024.0106%203.62518%2020%203.62518C10.9565%203.62518%203.62533%2010.9564%203.62533%2019.9999C3.62533%2024.0105%205.06719%2027.6843%207.46083%2030.5313L3%2034.9921L5.00786%2037L9.4687%2032.5392C12.3157%2034.9327%2015.9895%2036.3745%2020%2036.3745C29.0435%2036.3745%2036.3747%2029.0433%2036.3747%2019.9999C36.3747%2015.9893%2034.9329%2012.3155%2032.5393%209.46856ZM28.5145%209.47769C26.1889%207.59351%2023.2263%206.46472%2020%206.46472C12.5248%206.46472%206.46487%2012.5246%206.46487%2019.9999C6.46487%2023.2261%207.59365%2026.1887%209.47783%2028.5143L28.5145%209.47769ZM11.4857%2030.5222L30.5223%2011.4856C32.4064%2013.8111%2033.5351%2016.7737%2033.5351%2019.9999C33.5351%2027.4751%2027.4753%2033.535%2020%2033.535C16.7738%2033.535%2013.8113%2032.4063%2011.4857%2030.5222Z'%20fill='currentColor'/%3e%3c/svg%3e", $be = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M5.30558%2030L3.3335%2028.0279L15.5556%2015.8054L22.4168%2022.6666L32.0002%2013.1112H27.0281V10.3333H36.6668V19.9721H33.9168V15.1112L22.3889%2026.6387L15.5281%2019.7779L5.30558%2030Z'%20fill='currentColor'/%3e%3c/svg%3e", Bbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M19.9998%2026.8611L11.861%2018.7223L13.8332%2016.7223L18.611%2021.5001V6.66669H21.3887V21.5001L26.1665%2016.7223L28.1387%2018.7223L19.9998%2026.8611ZM6.6665%2033.3334V24.9167H9.44425V30.5556H30.5554V24.9167H33.3332V33.3334H6.6665Z'%20fill='currentColor'/%3e%3c/svg%3e", zbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.7085%2035.6667L12.4168%2023.9583L3.3335%2016.0833L15.3335%2015.0417L20.0002%204L24.6668%2015.0417L36.6668%2016.0833L27.5835%2023.9583L30.2918%2035.6667L20.0002%2029.4583L9.7085%2035.6667Z'%20fill='currentColor'/%3e%3c/svg%3e", Zbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13.889%2029.875L20.0002%2026.2083L26.1113%2029.9167L24.4863%2022.9722L29.8613%2018.3055L22.778%2017.6805L20.0002%2011.125L17.2224%2017.6389L10.139%2018.2639L15.514%2022.9445L13.889%2029.875ZM9.7085%2035.6667L12.4168%2023.9583L3.3335%2016.0833L15.3335%2015.0417L20.0002%204L24.6668%2015.0417L36.6668%2016.0833L27.5835%2023.9583L30.2918%2035.6667L20.0002%2029.4583L9.7085%2035.6667Z'%20fill='currentColor'/%3e%3c/svg%3e", Wbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M16.6667%2030V27.2223H23.3333V30H16.6667ZM10%2021.3889V18.6111H30V21.3889H10ZM5%2012.7778V10H35V12.7778H5Z'%20fill='currentColor'/%3e%3c/svg%3e", Ube = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M5%2030V27.2223H35V30H5ZM5%2021.3889V18.6111H35V21.3889H5ZM5%2012.7778V10H35V12.7778H5Z'%20fill='currentColor'/%3e%3c/svg%3e", Gbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M26.4165%2022.4166L24.3887%2020.3889C24.9535%2018.6389%2024.5785%2017.1389%2023.2637%2015.8889C21.9489%2014.6389%2020.4535%2014.2685%2018.7776%2014.7778L16.7498%2012.75C17.2221%2012.4722%2017.7336%2012.2685%2018.2845%2012.1389C18.8355%2012.0093%2019.4073%2011.9444%2019.9998%2011.9444C22.0091%2011.9444%2023.7151%2012.6458%2025.1179%2014.0486C26.5207%2015.4514%2027.222%2017.1574%2027.222%2019.1666C27.222%2019.7592%2027.1526%2020.3356%2027.0137%2020.8958C26.8748%2021.456%2026.6758%2021.963%2026.4165%2022.4166ZM31.7776%2027.75L29.861%2025.8611C31.1202%2024.9259%2032.2244%2023.8866%2033.1735%2022.7431C34.1225%2021.5995%2034.8517%2020.4074%2035.361%2019.1666C33.9721%2016.1759%2031.9188%2013.8078%2029.2013%2012.0625C26.4836%2010.3171%2023.5091%209.4444%2020.2776%209.4444C19.2313%209.4444%2018.1711%209.53699%2017.097%209.72219C16.023%209.90738%2015.1294%2010.1389%2014.4165%2010.4166L12.2776%208.24998C13.3054%207.79629%2014.523%207.41897%2015.9304%207.11802C17.3378%206.81711%2018.7406%206.66665%2020.1387%206.66665C24.185%206.66665%2027.8517%207.80785%2031.1387%2010.0903C34.4258%2012.3727%2036.8239%2015.3981%2038.3332%2019.1666C37.6387%2020.8981%2036.7383%2022.4884%2035.6318%2023.9375C34.5253%2025.3866%2033.2406%2026.6574%2031.7776%2027.75ZM33.6665%2037.4444L26.6665%2030.5555C25.6943%2030.9166%2024.6364%2031.1921%2023.4929%2031.3819C22.3494%2031.5717%2021.185%2031.6666%2019.9998%2031.6666C15.898%2031.6666%2012.1989%2030.5254%208.90263%2028.243C5.60632%2025.9606%203.19428%2022.9352%201.6665%2019.1666C2.23131%2017.713%202.99057%2016.3171%203.9443%2014.9791C4.89799%2013.6412%206.03688%2012.3889%207.36096%2011.2222L2.33317%206.16661L4.27759%204.1944L35.5276%2035.4444L33.6665%2037.4444ZM9.27763%2013.1666C8.32391%2013.9074%207.41649%2014.8287%206.55538%2015.9306C5.69427%2017.0324%205.04612%2018.1111%204.61092%2019.1666C6.01834%2022.1574%208.10399%2024.5255%2010.8679%2026.2708C13.6318%2028.0162%2016.7498%2028.8889%2020.222%2028.8889C21.0184%2028.8889%2021.8008%2028.8403%2022.5693%2028.7431C23.3378%2028.6458%2023.9628%2028.5093%2024.4443%2028.3333L22.1665%2026.0277C21.8609%2026.1481%2021.5137%2026.2384%2021.1248%2026.2986C20.7359%2026.3588%2020.3609%2026.3889%2019.9998%2026.3889C18.0091%2026.3889%2016.3077%2025.6921%2014.8957%2024.2986C13.4836%2022.9051%2012.7776%2021.1944%2012.7776%2019.1666C12.7776%2018.787%2012.8077%2018.412%2012.8679%2018.0416C12.9281%2017.6713%2013.0184%2017.324%2013.1388%2017L9.27763%2013.1666Z'%20fill='currentColor'/%3e%3c/svg%3e", qbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cmask%20id='mask0_3026_2741'%20style='mask-type:alpha'%20maskUnits='userSpaceOnUse'%20x='0'%20y='0'%20width='40'%20height='40'%3e%3crect%20width='40'%20height='40'%20fill='%23D9D9D9'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_3026_2741)'%3e%3cpath%20d='M9.59996%2032.3364H15.4V21.7843H24.6V32.3364H30.4V16.3545L20%208.32947L9.59996%2016.3545V32.3364ZM7%2035V15.0228L20%205L33%2015.0228V35H22V24.4478H18V35H7Z'%20fill='currentColor'/%3e%3c/g%3e%3c/svg%3e", Kbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18.611%2026.8611V12.0278L13.8332%2016.8056L11.861%2014.8056L19.9998%206.66669L28.1387%2014.8056L26.1665%2016.8056L21.3887%2012.0278V26.8611H18.611ZM6.6665%2033.3334V24.9167H9.44425V30.5556H30.5554V24.9167H33.3332V33.3334H6.6665Z'%20fill='currentColor'/%3e%3c/svg%3e", Ybe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18.6946%2028.3333H21.4724V18.3333H18.6946V28.3333ZM19.9997%2015.1666C20.4167%2015.1666%2020.7664%2015.0282%2021.0488%2014.7514C21.3312%2014.4745%2021.4724%2014.1315%2021.4724%2013.7222C21.4724%2013.2972%2021.3313%2012.941%2021.0492%2012.6535C20.7672%2012.366%2020.4176%2012.2222%2020.0007%2012.2222C19.5837%2012.2222%2019.234%2012.366%2018.9515%2012.6535C18.6692%2012.941%2018.528%2013.2972%2018.528%2013.7222C18.528%2014.1315%2018.669%2014.4745%2018.9511%2014.7514C19.2332%2015.0282%2019.5827%2015.1666%2019.9997%2015.1666ZM20.0075%2036.6666C17.7069%2036.6666%2015.5449%2036.2291%2013.5215%2035.3541C11.498%2034.4791%209.73165%2033.287%208.22237%2031.7778C6.71312%2030.2685%205.521%2028.5015%204.646%2026.4766C3.771%2024.4518%203.3335%2022.2883%203.3335%2019.9861C3.3335%2017.6839%203.771%2015.5204%204.646%2013.4956C5.521%2011.4707%206.71312%209.70831%208.22237%208.20831C9.73165%206.70831%2011.4987%205.52081%2013.5235%204.64581C15.5483%203.77081%2017.7118%203.33331%2020.014%203.33331C22.3163%203.33331%2024.4798%203.77081%2026.5046%204.64581C28.5294%205.52081%2030.2918%206.70831%2031.7918%208.20831C33.2918%209.70831%2034.4793%2011.4722%2035.3543%2013.5C36.2293%2015.5278%2036.6668%2017.692%2036.6668%2019.9926C36.6668%2022.2932%2036.2293%2024.4552%2035.3543%2026.4787C34.4793%2028.5021%2033.2918%2030.2668%2031.7918%2031.7726C30.2918%2033.2785%2028.5279%2034.4706%2026.5002%2035.349C24.4724%2036.2274%2022.3082%2036.6666%2020.0075%2036.6666ZM20.014%2033.8889C23.8752%2033.8889%2027.1529%2032.537%2029.8474%2029.8333C32.5419%2027.1296%2033.8891%2023.8472%2033.8891%2019.9861C33.8891%2016.125%2032.5436%2012.8472%2029.8526%2010.1527C27.1616%207.45829%2023.8775%206.11106%2020.0002%206.11106C16.1483%206.11106%2012.8705%207.45655%2010.1668%2010.1475C7.46311%2012.8385%206.11125%2016.1227%206.11125%2020C6.11125%2023.8518%207.46311%2027.1296%2010.1668%2029.8333C12.8705%2032.537%2016.1529%2033.8889%2020.014%2033.8889Z'%20fill='currentColor'/%3e%3c/svg%3e", Xbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13.3054%2029.7222H26.6943V26.9445H13.3054V29.7222ZM13.3054%2022.7778H26.6943V20H13.3054V22.7778ZM6.6665%2036.6667V3.33334H23.9165L33.3332%2012.75V36.6667H6.6665ZM22.5276%2014.0556V6.11109H9.44425V33.8889H30.5554V14.0556H22.5276Z'%20fill='currentColor'/%3e%3c/svg%3e", Jbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12.2117%2015.0961V12.5962H34.1667V15.0961H12.2117ZM12.2117%2021.2499V18.75H34.1667V21.2499H12.2117ZM12.2117%2027.4038V24.9038H34.1667V27.4038H12.2117ZM7.17966%2015.1923C6.79825%2015.1923%206.47854%2015.0617%206.22054%2014.8007C5.96251%2014.5396%205.8335%2014.2161%205.8335%2013.8301C5.8335%2013.4533%205.96251%2013.1374%206.22054%2012.8824C6.47854%2012.6275%206.79825%2012.5%207.17966%2012.5C7.56105%2012.5%207.88075%2012.6275%208.13875%2012.8824C8.39677%2013.1374%208.52579%2013.4533%208.52579%2013.8301C8.52579%2014.2161%208.39677%2014.5396%208.13875%2014.8007C7.88075%2015.0617%207.56105%2015.1923%207.17966%2015.1923ZM7.17966%2021.33C6.79825%2021.33%206.47854%2021.2026%206.22054%2020.9477C5.96251%2020.6927%205.8335%2020.3768%205.8335%2020C5.8335%2019.6025%205.96251%2019.2762%206.22054%2019.0208C6.47854%2018.7655%206.79825%2018.6378%207.17966%2018.6378C7.56105%2018.6378%207.88075%2018.7655%208.13875%2019.0208C8.39677%2019.2762%208.52579%2019.6025%208.52579%2020C8.52579%2020.3768%208.39677%2020.6927%208.13875%2020.9477C7.88075%2021.2026%207.56105%2021.33%207.17966%2021.33ZM7.17966%2027.4999C6.79825%2027.4999%206.47854%2027.3694%206.22054%2027.1083C5.96251%2026.8472%205.8335%2026.5237%205.8335%2026.1378C5.8335%2025.7609%205.96251%2025.445%206.22054%2025.19C6.47854%2024.9351%206.79825%2024.8076%207.17966%2024.8076C7.56105%2024.8076%207.88075%2024.9351%208.13875%2025.19C8.39677%2025.445%208.52579%2025.7609%208.52579%2026.1378C8.52579%2026.5237%208.39677%2026.8472%208.13875%2027.1083C7.88075%2027.3694%207.56105%2027.4999%207.17966%2027.4999Z'%20fill='currentColor'/%3e%3c/svg%3e", Qbe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M5%2035V5H19.9722V7.77775H7.77775V32.2222H19.9722V35H5ZM27.3889%2027.6389L25.4306%2025.6389L29.6806%2021.3889H15V18.6111H29.625L25.375%2014.3611L27.3333%2012.3611L35%2020.0278L27.3889%2027.6389Z'%20fill='currentColor'/%3e%3c/svg%3e", eCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M3.3335%2033.3333V6.66666H36.6668V33.3333H3.3335ZM20.0002%2021.0555L6.11125%2012.0833V30.5556H33.8891V12.0833L20.0002%2021.0555ZM20.0002%2018.2778L33.778%209.44441H6.25016L20.0002%2018.2778ZM6.11125%2012.0833V9.44441V30.5556V12.0833Z'%20fill='currentColor'/%3e%3c/svg%3e", tCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.3335%2021.3889V18.6111H31.6668V21.3889H8.3335Z'%20fill='currentColor'/%3e%3c/svg%3e", nCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M5%2035V5H19.4167V7.77775H7.77775V32.2222H32.2222V20.5833H35V35H5ZM16%2025.9722L14.0555%2024L30.2778%207.77775H22.1944V5H35V17.8056H32.2222V9.74996L16%2025.9722Z'%20fill='currentColor'/%3e%3c/svg%3e", oCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M21.5834%2014V26L27.5833%2020L21.5834%2014ZM7.77775%2032.2222H13.5278V7.77775H7.77775V32.2222ZM16.3055%2032.2222H32.2222V7.77775H16.3055V32.2222ZM5%2035V5H35V35H5Z'%20fill='currentColor'/%3e%3c/svg%3e", rCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18.6113%2021.3889H8.3335V18.6112H18.6113V8.33337H21.389V18.6112H31.6668V21.3889H21.389V31.6667H18.6113V21.3889Z'%20fill='currentColor'/%3e%3c/svg%3e", iCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M5%205.00002V35H20.6529C20.4407%2034.5806%2020.2581%2034.1378%2020.105%2033.6717C19.9517%2033.2053%2019.824%2032.7221%2019.7221%2032.2221H7.77792V7.77794H32.2221V19.7084C32.6943%2019.7917%2033.1665%2019.9097%2033.6388%2020.0625C34.111%2020.2153%2034.5647%2020.4074%2035%2020.6388V5.00002H24.1946C23.9815%204.01863%2023.4838%203.21766%2022.7013%202.5971C21.919%201.97683%2021.0186%201.66669%2020%201.66669C18.9814%201.66669%2018.081%201.97683%2017.2988%202.5971C16.5163%203.21766%2016.0185%204.01863%2015.8054%205.00002H5ZM20.9792%206.47919C20.7061%206.75224%2020.3797%206.88877%2020%206.88877C19.6203%206.88877%2019.2939%206.75224%2019.0208%206.47919C18.7478%206.20613%2018.6113%205.87974%2018.6113%205.50002C18.6113%205.1203%2018.7478%204.79391%2019.0208%204.52085C19.2939%204.2478%2019.6203%204.11127%2020%204.11127C20.3797%204.11127%2020.7061%204.2478%2020.9792%204.52085C21.2522%204.79391%2021.3888%205.1203%2021.3888%205.50002C21.3888%205.87974%2021.2522%206.20613%2020.9792%206.47919Z'%20fill='currentColor'/%3e%3cpath%20d='M19.7917%2028.3334H11.6667V25.5554H20.7363C20.514%2025.9907%2020.3265%2026.4399%2020.1738%2026.9029C20.021%2027.3657%2019.8936%2027.8425%2019.7917%2028.3334Z'%20fill='currentColor'/%3e%3cpath%20d='M24.6113%2021.3888H11.6667V18.6113H28.3333V19.7638C27.6203%2019.9027%2026.9606%2020.1064%2026.3542%2020.375C25.7478%2020.6436%2025.1668%2020.9815%2024.6113%2021.3888Z'%20fill='currentColor'/%3e%3cpath%20d='M28.3333%2014.4446H11.6667V11.6667H28.3333V14.4446Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M24.7273%2035.9715C26.2929%2037.5368%2028.1861%2038.3194%2030.4069%2038.3194C32.628%2038.3194%2034.5213%2037.5368%2036.0869%2035.9715C37.6522%2034.4059%2038.4348%2032.5126%2038.4348%2030.2915C38.4348%2028.0706%2037.6522%2026.1774%2036.0869%2024.6119C34.5213%2023.0466%2032.628%2022.264%2030.4069%2022.264C28.1861%2022.264%2026.2929%2023.0466%2024.7273%2024.6119C23.162%2026.1774%2022.3794%2028.0706%2022.3794%2030.2915C22.3794%2032.5126%2023.162%2034.4059%2024.7273%2035.9715ZM34.1153%2033.2498L32.9557%2034.4165L29.3516%2030.736V25.4581H30.9903V30.1248L34.1153%2033.2498Z'%20fill='currentColor'/%3e%3c/svg%3e", sCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18.4167%2026.0791C18.428%2024.3162%2018.6586%2022.9498%2019.1084%2021.9797C19.5582%2021.0096%2020.4469%2019.9352%2021.7746%2018.7564C22.8679%2017.7764%2023.6975%2016.8556%2024.2634%2015.9941C24.8292%2015.1327%2025.1122%2014.1877%2025.1122%2013.1592C25.1122%2011.7895%2024.6483%2010.652%2023.7206%209.74676C22.7929%208.84148%2021.5149%208.38884%2019.8867%208.38884C18.4408%208.38884%2017.3119%208.76099%2016.4999%209.5053C15.688%2010.2496%2015.0608%2011.0929%2014.6185%2012.0352L11.9658%2010.8397C12.6247%209.3148%2013.6158%208.05645%2014.9391%207.06467C16.2624%206.07287%2017.9116%205.57697%2019.8867%205.57697C22.5078%205.57697%2024.5282%206.3154%2025.9481%207.79226C27.3679%209.26909%2028.0779%2011.0239%2028.0779%2013.0566C28.0779%2014.3372%2027.801%2015.4977%2027.2472%2016.5379C26.6935%2017.5782%2025.851%2018.6264%2024.72%2019.6827C23.2734%2021.0096%2022.3804%2022.0589%2022.041%2022.8306C21.7016%2023.6024%2021.5262%2024.6852%2021.5149%2026.0791H18.4167ZM19.8867%2035.8333C19.2578%2035.8333%2018.7177%2035.6077%2018.2665%2035.1565C17.8153%2034.7053%2017.5897%2034.1652%2017.5897%2033.5363C17.5897%2032.9074%2017.8153%2032.3674%2018.2665%2031.9162C18.7177%2031.465%2019.2578%2031.2394%2019.8867%2031.2394C20.5156%2031.2394%2021.0556%2031.465%2021.5068%2031.9162C21.958%2032.3674%2022.1837%2032.9074%2022.1837%2033.5363C22.1837%2034.1652%2021.958%2034.7053%2021.5068%2035.1565C21.0556%2035.6077%2020.5156%2035.8333%2019.8867%2035.8333Z'%20fill='currentColor'/%3e%3c/svg%3e", aCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M5%2035V4.99999H15.8056C16.0185%204.01852%2016.5162%203.21759%2017.2986%202.5972C18.081%201.97684%2018.9815%201.66666%2020%201.66666C21.0185%201.66666%2021.919%201.97684%2022.7014%202.5972C23.4838%203.21759%2023.9815%204.01852%2024.1944%204.99999H35V35H5ZM7.77775%2032.2222H32.2222V7.77774H7.77775V32.2222ZM11.6667%2028.3333H23.1389V25.5556H11.6667V28.3333ZM11.6667%2021.3889H28.3333V18.6111H11.6667V21.3889ZM11.6667%2014.4444H28.3333V11.6667H11.6667V14.4444ZM20%206.88887C20.3796%206.88887%2020.706%206.7523%2020.9792%206.47916C21.2523%206.20599%2021.3889%205.8796%2021.3889%205.49999C21.3889%205.12035%2021.2523%204.79396%2020.9792%204.52082C20.706%204.24766%2020.3796%204.11107%2020%204.11107C19.6204%204.11107%2019.294%204.24766%2019.0208%204.52082C18.7477%204.79396%2018.6111%205.12035%2018.6111%205.49999C18.6111%205.8796%2018.7477%206.20599%2019.0208%206.47916C19.294%206.7523%2019.6204%206.88887%2020%206.88887Z'%20fill='currentColor'/%3e%3c/svg%3e", lCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4.44434%2016.5C4.44434%2013.9074%205.02073%2011.5301%206.1735%209.36806C7.32628%207.20601%208.87027%205.4074%2010.8055%203.97223L12.4582%206.19444C10.8656%207.3796%209.59479%208.86108%208.64571%2010.6389C7.69666%2012.4166%207.22213%2014.3703%207.22213%2016.5H4.44434ZM32.7776%2016.5C32.7776%2014.3703%2032.3031%2012.4166%2031.354%2010.6389C30.405%208.86108%2029.1341%207.3796%2027.5415%206.19444L29.1943%203.97223C31.1295%205.4074%2032.6735%207.20601%2033.8263%209.36806C34.979%2011.5301%2035.5554%2013.9074%2035.5554%2016.5H32.7776ZM6.66654%2031.6666V28.8889H9.99988V16.5555C9.99988%2014.2315%2010.6897%2012.1551%2012.0693%2010.3264C13.4489%208.49766%2015.2591%207.33331%2017.4999%206.83331V5.83331C17.4999%205.13887%2017.7429%204.54859%2018.229%204.06248C18.7152%203.57637%2019.3054%203.33331%2019.9999%203.33331C20.6943%203.33331%2021.2846%203.57637%2021.7707%204.06248C22.2568%204.54859%2022.4999%205.13887%2022.4999%205.83331V6.83331C24.7406%207.33331%2026.5508%208.49766%2027.9304%2010.3264C29.3101%2012.1551%2029.9999%2014.2315%2029.9999%2016.5555V28.8889H33.3332V31.6666H6.66654ZM19.9999%2036.6666C19.0832%2036.6666%2018.2985%2036.3403%2017.6457%2035.6875C16.9929%2035.0347%2016.6665%2034.25%2016.6665%2033.3333H23.3332C23.3332%2034.25%2023.0068%2035.0347%2022.354%2035.6875C21.7013%2036.3403%2020.9165%2036.6666%2019.9999%2036.6666ZM12.7776%2028.8889H27.2221V16.5555C27.2221%2014.5555%2026.5184%2012.8518%2025.111%2011.4444C23.7036%2010.037%2021.9999%209.33331%2019.9999%209.33331C17.9999%209.33331%2016.2962%2010.037%2014.8888%2011.4444C13.4813%2012.8518%2012.7776%2014.5555%2012.7776%2016.5555V28.8889Z'%20fill='currentColor'/%3e%3c/svg%3e", cCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M26.8887%2017.7222V14.9445H36.6665V17.7222H26.8887ZM14.9998%2019.9722C13.1665%2019.9722%2011.6434%2019.3657%2010.4304%2018.1528C9.21743%2016.9398%208.61096%2015.4167%208.61096%2013.5833C8.61096%2011.75%209.21743%2010.2269%2010.4304%209.01392C11.6434%207.80094%2013.1665%207.19446%2014.9998%207.19446C16.8332%207.19446%2018.3563%207.80094%2019.5693%209.01392C20.7822%2010.2269%2021.3887%2011.75%2021.3887%2013.5833C21.3887%2015.4167%2020.7822%2016.9398%2019.5693%2018.1528C18.3563%2019.3657%2016.8332%2019.9722%2014.9998%2019.9722ZM1.6665%2033.3333V29.1667C1.6665%2028.2037%201.90956%2027.3264%202.39567%2026.5348C2.88178%2025.7431%203.56466%2025.1482%204.4443%2024.75C6.40727%2023.8519%208.22521%2023.206%209.89813%2022.8125C11.5711%2022.419%2013.2701%2022.2223%2014.9953%2022.2223C16.7206%2022.2223%2018.4165%2022.419%2020.0832%2022.8125C21.7498%2023.206%2023.5647%2023.8519%2025.5276%2024.75C26.4072%2025.1667%2027.0947%2025.7662%2027.5901%2026.5486C28.0855%2027.331%2028.3332%2028.2037%2028.3332%2029.1667V33.3333H1.6665ZM4.44425%2030.5556H25.5554V29.1667C25.5554%2028.7685%2025.4466%2028.3935%2025.229%2028.0417C25.0114%2027.6898%2024.7221%2027.4259%2024.361%2027.25C22.5461%2026.3889%2020.9304%2025.7986%2019.5137%2025.4792C18.097%2025.1597%2016.5924%2025%2014.9998%2025C13.4073%2025%2011.898%2025.1597%2010.472%2025.4792C9.04613%2025.7986%207.42577%2026.3889%205.61096%2027.25C5.24982%2027.4259%204.96509%2027.6898%204.75675%2028.0417C4.54842%2028.3935%204.44425%2028.7685%204.44425%2029.1667V30.5556ZM14.9998%2017.1945C16.0276%2017.1945%2016.8864%2016.8496%2017.5762%2016.1597C18.266%2015.4699%2018.611%2014.6111%2018.611%2013.5833C18.611%2012.5556%2018.266%2011.6968%2017.5762%2011.007C16.8864%2010.3171%2016.0276%209.97221%2014.9998%209.97221C13.9721%209.97221%2013.1133%2010.3171%2012.4235%2011.007C11.7336%2011.6968%2011.3887%2012.5556%2011.3887%2013.5833C11.3887%2014.6111%2011.7336%2015.4699%2012.4235%2016.1597C13.1133%2016.8496%2013.9721%2017.1945%2014.9998%2017.1945Z'%20fill='currentColor'/%3e%3c/svg%3e", dCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.6668%2021.3056H28.3335V18.5278H11.6668V21.3056ZM20.0002%2036.6667C17.7131%2036.6667%2015.5557%2036.2292%2013.528%2035.3542C11.5002%2034.4792%209.73165%2033.2871%208.22237%2031.7778C6.71312%2030.2686%205.521%2028.5%204.646%2026.4723C3.771%2024.4445%203.3335%2022.2871%203.3335%2020C3.3335%2017.6945%203.771%2015.5278%204.646%2013.5C5.521%2011.4723%206.71312%209.70837%208.22237%208.20837C9.73165%206.70837%2011.5002%205.52087%2013.528%204.64587C15.5557%203.77087%2017.7131%203.33337%2020.0002%203.33337C22.3057%203.33337%2024.4724%203.77087%2026.5002%204.64587C28.5279%205.52087%2030.2918%206.70837%2031.7918%208.20837C33.2918%209.70837%2034.4793%2011.4723%2035.3543%2013.5C36.2293%2015.5278%2036.6668%2017.6945%2036.6668%2020C36.6668%2022.2871%2036.2293%2024.4445%2035.3543%2026.4723C34.4793%2028.5%2033.2918%2030.2686%2031.7918%2031.7778C30.2918%2033.2871%2028.5279%2034.4792%2026.5002%2035.3542C24.4724%2036.2292%2022.3057%2036.6667%2020.0002%2036.6667ZM20.0002%2033.889C23.8705%2033.889%2027.1529%2032.5371%2029.8474%2029.8334C32.5419%2027.1297%2033.8891%2023.8519%2033.8891%2020C33.8891%2016.1297%2032.5419%2012.8473%2029.8474%2010.1528C27.1529%207.45835%2023.8705%206.11112%2020.0002%206.11112C16.1483%206.11112%2012.8705%207.45835%2010.1668%2010.1528C7.46311%2012.8473%206.11125%2016.1297%206.11125%2020C6.11125%2023.8519%207.46311%2027.1297%2010.1668%2029.8334C12.8705%2032.5371%2016.1483%2033.889%2020.0002%2033.889Z'%20fill='currentColor'/%3e%3c/svg%3e", uCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18.6804%2036.5554C14.3287%2036.1943%2010.6899%2034.4352%207.76375%2031.2779C4.83792%2028.1204%203.375%2024.3611%203.375%2020C3.375%2015.6389%204.83792%2011.8796%207.76375%208.7221C10.6899%205.56488%2014.3287%203.80571%2018.6804%203.4446V7.9446C15.5879%208.27794%2013.0093%209.59266%2010.9446%2011.8888C8.87958%2014.1852%207.85639%2016.8889%207.875%2020C7.89361%2023.1111%208.92597%2025.8149%2010.9721%2028.1113C13.0185%2030.4074%2015.5879%2031.7221%2018.6804%2032.0554V36.5554ZM21.4583%2036.5554V32.0554C24.2917%2031.7777%2026.6851%2030.6388%2028.6388%2028.6388C30.5926%2026.6388%2031.7547%2024.2221%2032.125%2021.3888H36.625C36.2917%2025.4721%2034.7014%2028.9421%2031.8542%2031.7988C29.0069%2034.6552%2025.5417%2036.2407%2021.4583%2036.5554ZM32.125%2018.6113C31.7731%2015.7779%2030.6157%2013.3613%2028.6529%2011.3613C26.6899%209.36127%2024.2917%208.21308%2021.4583%207.91669V3.41669C25.5231%203.75002%2028.9837%205.34488%2031.8404%208.20127C34.6968%2011.0579%2036.2917%2014.5279%2036.625%2018.6113H32.125Z'%20fill='currentColor'/%3e%3c/svg%3e", fCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M3.3335%2033.3333V6.66666H17.2502L20.028%209.44441H36.6668V12.2222H18.8474L16.0696%209.44441H6.11125V30.5556L10.2779%2014.9999H39.1668L34.1946%2033.3333H3.3335ZM9.02791%2030.5556H32.0835L35.4169%2017.7777H12.3612L9.02791%2030.5556Z'%20fill='currentColor'/%3e%3c/svg%3e", pCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.0832%2031.6667V28.8889H23.6387C25.5184%2028.8889%2027.141%2028.2732%2028.5068%2027.0417C29.8725%2025.8102%2030.5554%2024.2778%2030.5554%2022.4445C30.5554%2020.6111%2029.8725%2019.0787%2028.5068%2017.8472C27.141%2016.6158%2025.5184%2016%2023.6387%2016H11.9443L16.5554%2020.6111L14.6109%2022.5556L6.6665%2014.6111L14.6109%206.66669L16.5554%208.6111L11.9443%2013.2222H23.611C26.2684%2013.2222%2028.5531%2014.1065%2030.4651%2015.875C32.3772%2017.6435%2033.3332%2019.8334%2033.3332%2022.4445C33.3332%2025.0556%2032.3772%2027.2454%2030.4651%2029.0139C28.5531%2030.7824%2026.2684%2031.6667%2023.611%2031.6667H11.0832Z'%20fill='currentColor'/%3e%3c/svg%3e", hCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M35%2011.5833V35H5V5H28.4167L35%2011.5833ZM32.2222%2012.8055L27.1945%207.77775H7.77775V32.2222H32.2222V12.8055ZM19.9935%2029.8611C21.2571%2029.8611%2022.3333%2029.4189%2023.2222%2028.5343C24.1111%2027.6498%2024.5555%2026.5757%2024.5555%2025.3121C24.5555%2024.0485%2024.1133%2022.9722%2023.2288%2022.0833C22.3442%2021.1945%2021.2702%2020.75%2020.0065%2020.75C18.7429%2020.75%2017.6667%2021.1923%2016.7778%2022.0768C15.8889%2022.9614%2015.4445%2024.0354%2015.4445%2025.299C15.4445%2026.5627%2015.8867%2027.6389%2016.7713%2028.5278C17.6558%2029.4167%2018.7298%2029.8611%2019.9935%2029.8611ZM9.80554%2016H24.75V9.80554H9.80554V16Z'%20fill='currentColor'/%3e%3c/svg%3e", gCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M17.1943%2028.3611L26.722%2018.8333L24.8054%2016.9167L17.2082%2024.5139L13.2637%2020.5695L11.3332%2022.5L17.1943%2028.3611ZM10.5832%2033.3333C8.11095%2033.3333%206.00678%2032.4722%204.27067%2030.75C2.53456%2029.0278%201.6665%2026.9306%201.6665%2024.4583C1.6665%2022.2917%202.34706%2020.3796%203.70817%2018.7222C5.06928%2017.0648%206.81466%2016.0463%208.9443%2015.6667C9.54613%2013.0185%2010.8795%2010.8611%2012.9443%209.19446C15.0091%207.52779%2017.3795%206.69446%2020.0554%206.69446C23.2128%206.69446%2025.8818%207.8264%2028.0623%2010.0903C30.2429%2012.3542%2031.3332%2015.0833%2031.3332%2018.2778V18.9445C33.3054%2018.9815%2034.9651%2019.6875%2036.3123%2021.0625C37.6596%2022.4375%2038.3332%2024.1296%2038.3332%2026.1389C38.3332%2028.1111%2037.6272%2029.8032%2036.2151%2031.2153C34.8031%2032.6273%2033.1109%2033.3333%2031.1388%2033.3333H10.5832ZM10.5832%2030.5556H31.1388C32.361%2030.5556%2033.4026%2030.125%2034.2638%2029.2639C35.1249%2028.4028%2035.5554%2027.3611%2035.5554%2026.1389C35.5554%2024.9167%2035.1249%2023.875%2034.2638%2023.0139C33.4026%2022.1528%2032.361%2021.7222%2031.1388%2021.7222H28.5554V18.2778C28.5554%2015.8241%2027.7197%2013.743%2026.0485%2012.0347C24.3772%2010.3264%2022.3424%209.47221%2019.9443%209.47221C17.5461%209.47221%2015.5068%2010.3264%2013.8262%2012.0347C12.1457%2013.743%2011.3054%2015.8241%2011.3054%2018.2778H10.4998C8.81464%2018.2778%207.38409%2018.8704%206.20817%2020.0555C5.03223%2021.2407%204.44425%2022.6944%204.44425%2024.4167C4.44425%2026.1204%205.04148%2027.5695%206.23592%2028.7639C7.43037%2029.9584%208.87945%2030.5556%2010.5832%2030.5556Z'%20fill='currentColor'/%3e%3c/svg%3e", mCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M17.1112%2026.25C17.7594%2026.8982%2018.6622%2027.206%2019.8196%2027.1736C20.977%2027.1412%2021.8242%2026.713%2022.3613%2025.8889L31.4724%2011.8055L17.5002%2021C16.6946%2021.537%2016.2664%2022.3843%2016.2154%2023.5417C16.1645%2024.6991%2016.4631%2025.6019%2017.1112%2026.25ZM19.9446%206.69446C21.5465%206.69446%2023.1738%206.94214%2024.8265%207.4375C26.4793%207.93286%2028.0557%208.75%2029.5557%209.88892L27.0557%2011.5833C25.9169%2010.8704%2024.7062%2010.3403%2023.4238%209.99304C22.1414%209.64582%2020.9814%209.47221%2019.944%209.47221C16.1112%209.47221%2012.8475%2010.833%2010.153%2013.5546C7.4585%2016.2762%206.11125%2019.5726%206.11125%2023.444C6.11125%2024.6665%206.28023%2025.8935%206.6182%2027.125C6.95618%2028.3565%207.43534%2029.5%208.0557%2030.5556H31.8057C32.4261%2029.5371%2032.9053%2028.3935%2033.2432%2027.125C33.5812%2025.8565%2033.7502%2024.5926%2033.7502%2023.3333C33.7502%2022.2222%2033.5951%2021.0602%2033.2849%2019.8472C32.9747%2018.6342%2032.4446%2017.5%2031.6946%2016.4444L33.4446%2013.9444C34.4261%2015.4167%2035.1738%2016.9213%2035.6877%2018.4583C36.2016%2019.9954%2036.4817%2021.5555%2036.528%2023.1389C36.5742%2024.7778%2036.4029%2026.3287%2036.014%2027.7917C35.6252%2029.2546%2035.0557%2030.6204%2034.3057%2031.8889C33.9817%2032.4815%2033.6067%2032.8704%2033.1807%2033.0555C32.7548%2033.2407%2032.2594%2033.3333%2031.6946%2033.3333H8.16683C7.65758%2033.3333%207.1622%2033.2083%206.6807%2032.9583C6.19923%2032.7083%205.8335%2032.3518%205.5835%2031.8889C4.86127%2030.5833%204.30572%2029.2384%203.91683%2027.8542C3.52794%2026.4699%203.3335%2025%203.3335%2023.4445C3.3335%2021.1389%203.771%2018.9699%204.646%2016.9375C5.521%2014.9051%206.71082%2013.1319%208.21546%2011.618C9.72007%2010.1042%2011.4833%208.90508%2013.5052%208.02083C15.527%207.13658%2017.6735%206.69446%2019.9446%206.69446Z'%20fill='currentColor'/%3e%3c/svg%3e", bCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M33%2035L22.1945%2024.1945C21.3611%2024.8982%2020.3939%2025.4491%2019.2928%2025.8472C18.1917%2026.2454%2017.02%2026.4445%2015.7778%2026.4445C12.7655%2026.4445%2010.2162%2025.4005%208.12971%2023.3125C6.04324%2021.2246%205%2018.6945%205%2015.7222C5%2012.75%206.04399%2010.2199%208.13196%208.13196C10.2199%206.04399%2012.7546%205%2015.7361%205C18.7176%205%2021.2477%206.04399%2023.3264%208.13196C25.4051%2010.2199%2026.4445%2012.7514%2026.4445%2015.7264C26.4445%2016.9273%2026.25%2018.0787%2025.8611%2019.1806C25.4722%2020.2824%2024.9074%2021.2963%2024.1667%2022.2222L35%2033L33%2035ZM15.75%2023.6667C17.9491%2023.6667%2019.8183%2022.8912%2021.3576%2021.3403C22.897%2019.7894%2023.6667%2017.9167%2023.6667%2015.7222C23.6667%2013.5278%2022.897%2011.6551%2021.3576%2010.1042C19.8183%208.55325%2017.9491%207.77779%2015.75%207.77779C13.5355%207.77779%2011.6532%208.55325%2010.103%2010.1042C8.55283%2011.6551%207.77775%2013.5278%207.77775%2015.7222C7.77775%2017.9167%208.55283%2019.7894%2010.103%2021.3403C11.6532%2022.8912%2013.5355%2023.6667%2015.75%2023.6667Z'%20fill='currentColor'/%3e%3c/svg%3e", CCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M5%2033.3333V6.66666L36.6667%2020L5%2033.3333ZM7.77775%2029.0834L29.4722%2020L7.77775%2010.8333V17.4444L17.8333%2020L7.77775%2022.5V29.0834Z'%20fill='currentColor'/%3e%3c/svg%3e", xCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M17.9722%2035V25.4167H20.75V28.8333H35V31.6111H20.75V35H17.9722ZM5%2031.6111V28.8333H15.1945V31.6111H5ZM12.4167%2024.7778V21.3889H5V18.6111H12.4167V15.1667H15.1945V24.7778H12.4167ZM17.9722%2021.3889V18.6111H35V21.3889H17.9722ZM24.8055%2014.5833V5H27.5833V8.38888H35V11.1667H27.5833V14.5833H24.8055ZM5%2011.1667V8.38888H22.0278V11.1667H5Z'%20fill='currentColor'/%3e%3c/svg%3e", yCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18.6849%2032V13.3333L13.9452%2018.1388L12%2016.1666L20.0548%208L28%2016.0555L26.0548%2018.0278L21.4247%2013.3333V32H18.6849Z'%20fill='currentColor'/%3e%3c/svg%3e", vCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M20.0548%2032L12%2023.8334L13.9452%2021.8612L18.6849%2026.6667V8H21.4247V26.6667L26.0548%2021.9723L28%2023.9445L20.0548%2032Z'%20fill='currentColor'/%3e%3c/svg%3e", wCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13.4165%2021.3889L13.4165%208.62494L8.62484%2013.4166L6.6665%2011.4722L14.8054%203.33331L22.9443%2011.4722L20.986%2013.4166L16.1943%208.62494L16.1943%2021.3889H13.4165ZM25.1943%2036.6666L17.0554%2028.5278L19.0137%2026.5833L23.8054%2031.375L23.8054%2018.6111H26.5832L26.5832%2031.375L31.3748%2026.5833L33.3332%2028.5278L25.1943%2036.6666Z'%20fill='currentColor'/%3e%3c/svg%3e", SCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M19.9998%2036.6666C19.259%2036.6666%2018.6016%2036.4885%2018.0278%2036.1321C17.4536%2035.7754%2017.0554%2035.2869%2016.8332%2034.6667H13.6665V25.9446C11.8979%2024.7871%2010.4975%2023.2916%209.46525%2021.4583C8.43275%2019.625%207.9165%2017.6111%207.9165%2015.4166C7.9165%2012.0555%209.09012%209.20137%2011.4373%206.85415C13.7846%204.50692%2016.6387%203.33331%2019.9998%203.33331C23.3609%203.33331%2026.2151%204.50692%2028.5623%206.85415C30.9096%209.20137%2032.0832%2012.0555%2032.0832%2015.4166C32.0832%2017.6297%2031.5669%2019.6482%2030.5344%2021.4721C29.5022%2023.2962%2028.1018%2024.7871%2026.3332%2025.9446V34.6667H23.1665C22.9443%2035.2869%2022.5461%2035.7754%2021.9719%2036.1321C21.398%2036.4885%2020.7407%2036.6666%2019.9998%2036.6666ZM16.4444%2031.8887H23.5553V30.1666H16.4444V31.8887ZM16.4444%2028.5H23.5553V26.8612H16.4444V28.5ZM16.0832%2024.0833H18.9444V18.7779L15.1665%2015L16.6111%2013.5554L19.9998%2016.9446L23.3886%2013.5554L24.8332%2015L21.0553%2018.7779V24.0833H23.9165C25.5276%2023.3241%2026.8286%2022.1644%2027.8194%2020.6041C28.81%2019.0439%2029.3053%2017.3147%2029.3053%2015.4166C29.3053%2012.8055%2028.4072%2010.6018%2026.6111%208.8054C24.8147%207.00929%2022.6109%206.11123%2019.9998%206.11123C17.3887%206.11123%2015.185%207.00929%2013.3886%208.8054C11.5925%2010.6018%2010.6944%2012.8055%2010.6944%2015.4166C10.6944%2017.3147%2011.1897%2019.0439%2012.1803%2020.6041C13.1711%2022.1644%2014.4721%2023.3241%2016.0832%2024.0833Z'%20fill='currentColor'/%3e%3c/svg%3e", MCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M6.86096%2033.3333V30.5555H11.9999L11.361%2030.0278C9.6943%2028.6574%208.49521%2027.1435%207.76371%2025.4861C7.03224%2023.8287%206.6665%2022.037%206.6665%2020.1111C6.6665%2017.1203%207.55307%2014.4421%209.32621%2012.0763C11.0994%209.71061%2013.4258%208.10182%2016.3054%207.24996V10.1388C14.2498%2010.9166%2012.5924%2012.2199%2011.3332%2014.0486C10.0739%2015.8773%209.44425%2017.8981%209.44425%2020.1111C9.44425%2021.6944%209.74056%2023.1134%2010.3332%2024.368C10.9258%2025.6227%2011.7591%2026.7315%2012.8332%2027.6944L13.8054%2028.4167V23.6111H16.5832V33.3333H6.86096ZM23.7221%2032.7778V29.8611C25.7961%2029.0833%2027.4535%2027.7801%2028.6943%2025.9513C29.935%2024.1226%2030.5554%2022.1018%2030.5554%2019.8888C30.5554%2018.5833%2030.2591%2017.2754%2029.6665%2015.9652C29.0739%2014.655%2028.2591%2013.4814%2027.222%2012.4444L26.2776%2011.5833V16.3888H23.4998V6.66663H33.222V9.44438H28.0554L28.6943%2010.0277C30.2591%2011.5185%2031.4234%2013.1226%2032.1873%2014.8403C32.9512%2016.5578%2033.3332%2018.2407%2033.3332%2019.8888C33.3332%2022.8796%2032.4512%2025.5625%2030.6873%2027.9375C28.9234%2030.3125%2026.6017%2031.9259%2023.7221%2032.7778Z'%20fill='currentColor'/%3e%3c/svg%3e", TCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M15%205.27775V2.5H25V5.27775H15ZM18.6111%2023.8055H21.3889V14.0833H18.6111V23.8055ZM20%2037.4722C17.9444%2037.4722%2016.0069%2037.0764%2014.1875%2036.2847C12.3681%2035.493%2010.7778%2034.4167%209.41667%2033.0555C8.05556%2031.6944%206.97917%2030.1042%206.1875%2028.2847C5.39583%2026.4653%205%2024.5278%205%2022.4722C5%2020.4167%205.39583%2018.4792%206.1875%2016.6597C6.97917%2014.8403%208.05556%2013.25%209.41667%2011.8889C10.7778%2010.5278%2012.3681%209.45138%2014.1875%208.65971C16.0069%207.86804%2017.9444%207.47221%2020%207.47221C21.8148%207.47221%2023.5324%207.77314%2025.1528%208.375C26.7732%208.97686%2028.2407%209.82408%2029.5555%2010.9167L31.75%208.72225L33.6944%2010.6667L31.5%2012.8611C32.5185%2014.0648%2033.3565%2015.4583%2034.0139%2017.0417C34.6713%2018.625%2035%2020.4352%2035%2022.4722C35%2024.5278%2034.6042%2026.4653%2033.8125%2028.2847C33.0208%2030.1042%2031.9444%2031.6944%2030.5833%2033.0555C29.2222%2034.4167%2027.6319%2035.493%2025.8125%2036.2847C23.9931%2037.0764%2022.0556%2037.4722%2020%2037.4722ZM20%2034.6945C23.3889%2034.6945%2026.2732%2033.5046%2028.6528%2031.125C31.0324%2028.7454%2032.2222%2025.8611%2032.2222%2022.4722C32.2222%2019.0833%2031.0324%2016.1991%2028.6528%2013.8194C26.2732%2011.4398%2023.3889%2010.25%2020%2010.25C16.6111%2010.25%2013.7268%2011.4398%2011.3472%2013.8194C8.96757%2016.1991%207.77775%2019.0833%207.77775%2022.4722C7.77775%2025.8611%208.96757%2028.7454%2011.3472%2031.125C13.7268%2033.5046%2016.6111%2034.6945%2020%2034.6945Z'%20fill='currentColor'/%3e%3c/svg%3e", kCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.41683%2029.0833C11.0557%2027.9074%2012.7409%2026.9977%2014.4724%2026.3542C16.2039%2025.7107%2018.0465%2025.3889%2020.0002%2025.3889C21.9539%2025.3889%2023.8011%2025.7107%2025.5418%2026.3542C27.2826%2026.9977%2028.9724%2027.9074%2030.6113%2029.0833C31.7502%2027.7037%2032.5812%2026.2639%2033.1043%2024.7639C33.6275%2023.2639%2033.8891%2021.6759%2033.8891%2020C33.8891%2016.0833%2032.5534%2012.7894%2029.8821%2010.1181C27.2108%207.44675%2023.9168%206.11109%2020.0002%206.11109C16.0835%206.11109%2012.7895%207.44675%2010.1182%2010.1181C7.4469%2012.7894%206.11125%2016.0833%206.11125%2020C6.11125%2021.6759%206.37745%2023.2639%206.90987%2024.7639C7.44229%2026.2639%208.27794%2027.7037%209.41683%2029.0833ZM19.995%2021.3889C18.3781%2021.3889%2017.0164%2020.8339%2015.9099%2019.724C14.8034%2018.6141%2014.2502%2017.2507%2014.2502%2015.6337C14.2502%2014.0168%2014.8051%2012.6551%2015.915%2011.5486C17.025%2010.4421%2018.3884%209.88889%2020.0053%209.88889C21.6222%209.88889%2022.984%2010.4439%2024.0905%2011.5538C25.1969%2012.6637%2025.7502%2014.0271%2025.7502%2015.6441C25.7502%2017.261%2025.1952%2018.6227%2024.0853%2019.7292C22.9753%2020.8357%2021.6119%2021.3889%2019.995%2021.3889ZM20.0132%2036.6667C17.7175%2036.6667%2015.5557%2036.2292%2013.528%2035.3542C11.5002%2034.4792%209.73165%2033.2871%208.22237%2031.7778C6.71312%2030.2685%205.521%2028.5022%204.646%2026.4787C3.771%2024.4553%203.3335%2022.2932%203.3335%2019.9926C3.3335%2017.692%203.771%2015.5324%204.646%2013.5139C5.521%2011.4954%206.71312%209.7315%208.22237%208.22222C9.73165%206.71297%2011.498%205.52084%2013.5215%204.64584C15.5449%203.77084%2017.7069%203.33334%2020.0075%203.33334C22.3082%203.33334%2024.4678%203.77084%2026.4863%204.64584C28.5048%205.52084%2030.2687%206.71297%2031.778%208.22222C33.2872%209.7315%2034.4793%2011.4957%2035.3543%2013.5148C36.2293%2015.5339%2036.6668%2017.6913%2036.6668%2019.987C36.6668%2022.2827%2036.2293%2024.4444%2035.3543%2026.4722C34.4793%2028.5%2033.2872%2030.2685%2031.778%2031.7778C30.2687%2033.2871%2028.5045%2034.4792%2026.4854%2035.3542C24.4663%2036.2292%2022.3089%2036.6667%2020.0132%2036.6667ZM20.0002%2033.8889C21.5094%2033.8889%2022.9677%2033.669%2024.3752%2033.2292C25.7826%2032.7894%2027.1391%2032.0648%2028.4446%2031.0556C27.1391%2030.1204%2025.778%2029.4051%2024.3613%2028.9097C22.9446%2028.4144%2021.4909%2028.1667%2020.0002%2028.1667C18.5094%2028.1667%2017.0557%2028.4144%2015.639%2028.9097C14.2224%2029.4051%2012.8613%2030.1204%2011.5557%2031.0556C12.8613%2032.0648%2014.2177%2032.7894%2015.6252%2033.2292C17.0326%2033.669%2018.4909%2033.8889%2020.0002%2033.8889ZM20.0002%2018.6111C20.8705%2018.6111%2021.5835%2018.3334%2022.1391%2017.7778C22.6946%2017.2222%2022.9724%2016.5093%2022.9724%2015.6389C22.9724%2014.7685%2022.6946%2014.0556%2022.1391%2013.5C21.5835%2012.9445%2020.8705%2012.6667%2020.0002%2012.6667C19.1298%2012.6667%2018.4168%2012.9445%2017.8612%2013.5C17.3057%2014.0556%2017.0279%2014.7685%2017.0279%2015.6389C17.0279%2016.5093%2017.3057%2017.2222%2017.8612%2017.7778C18.4168%2018.3334%2019.1298%2018.6111%2020.0002%2018.6111Z'%20fill='currentColor'/%3e%3c/svg%3e", ECe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M20.0031%2027.2222C22.0102%2027.2222%2023.7151%2026.5197%2025.1179%2025.1148C26.5207%2023.7098%2027.222%2022.0038%2027.222%2019.9967C27.222%2017.9897%2026.5196%2016.2847%2025.1146%2014.882C23.7097%2013.4792%2022.0036%2012.7778%2019.9966%2012.7778C17.9895%2012.7778%2016.2846%2013.4803%2014.8818%2014.8852C13.479%2016.2902%2012.7776%2017.9962%2012.7776%2020.0033C12.7776%2022.0103%2013.4801%2023.7153%2014.885%2025.118C16.29%2026.5208%2017.996%2027.2222%2020.0031%2027.2222ZM19.9933%2024.6111C18.7106%2024.6111%2017.6225%2024.1622%2016.729%2023.2643C15.8355%2022.3664%2015.3887%2021.2762%2015.3887%2019.9935C15.3887%2018.7108%2015.8377%2017.6227%2016.7355%2016.7292C17.6334%2015.8356%2018.7237%2015.3889%2020.0064%2015.3889C21.289%2015.3889%2022.3771%2015.8378%2023.2707%2016.7357C24.1642%2017.6336%2024.611%2018.7238%2024.611%2020.0065C24.611%2021.2892%2024.162%2022.3773%2023.2641%2023.2708C22.3663%2024.1644%2021.276%2024.6111%2019.9933%2024.6111ZM19.9998%2032.5C15.9443%2032.5%2012.2684%2031.3542%208.97205%2029.0625C5.67577%2026.7708%203.24059%2023.75%201.6665%2020C3.24059%2016.25%205.67577%2013.2292%208.97205%2010.9375C12.2684%208.64583%2015.9443%207.5%2019.9998%207.5C24.0554%207.5%2027.7313%208.64583%2031.0276%2010.9375C34.3239%2013.2292%2036.7591%2016.25%2038.3332%2020C36.7591%2023.75%2034.3239%2026.7708%2031.0276%2029.0625C27.7313%2031.3542%2024.0554%2032.5%2019.9998%2032.5ZM19.9952%2029.7222C23.2853%2029.7222%2026.3077%2028.8403%2029.0623%2027.0764C31.817%2025.3125%2033.9165%2022.9537%2035.361%2020C33.9165%2017.0463%2031.8185%2014.6875%2029.067%2012.9236C26.3155%2011.1597%2023.2947%2010.2778%2020.0045%2010.2778C16.7144%2010.2778%2013.692%2011.1597%2010.9373%2012.9236C8.1827%2014.6875%206.07389%2017.0463%204.61092%2020C6.07389%2022.9537%208.18113%2025.3125%2010.9326%2027.0764C13.6842%2028.8403%2016.705%2029.7222%2019.9952%2029.7222Z'%20fill='currentColor'/%3e%3c/svg%3e", RCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M3.3335%2033.3334V6.66669H30.0002V17.9167L36.6668%2011.25V28.75L30.0002%2022.0834V33.3334H3.3335ZM6.11125%2030.5556H27.2224V9.44444H6.11125V30.5556Z'%20fill='currentColor'/%3e%3c/svg%3e", OCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M1.6665%2035L19.9998%203.33334L38.3332%2035H1.6665ZM6.47205%2032.2223H33.5276L19.9998%208.88889L6.47205%2032.2223ZM20.1158%2030.0833C20.5107%2030.0833%2020.8401%2029.9498%2021.104%2029.6826C21.3679%2029.4155%2021.4998%2029.0845%2021.4998%2028.6896C21.4998%2028.2947%2021.3663%2027.9653%2021.0991%2027.7014C20.832%2027.4375%2020.501%2027.3056%2020.1061%2027.3056C19.7112%2027.3056%2019.3818%2027.4392%2019.1179%2027.7063C18.854%2027.9734%2018.7221%2028.3045%2018.7221%2028.6993C18.7221%2029.0942%2018.8557%2029.4236%2019.1228%2029.6875C19.3899%2029.9514%2019.7209%2030.0833%2020.1158%2030.0833ZM18.7221%2025.3333H21.4998V16.3333H18.7221V25.3333Z'%20fill='currentColor'/%3e%3c/svg%3e", _Ce = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.33333%2035C7.41667%2035%206.63194%2034.6736%205.97917%2034.0208C5.32639%2033.3681%205%2032.5833%205%2031.6667V8.33333C5%207.41667%205.32639%206.63194%205.97917%205.97917C6.63194%205.32639%207.41667%205%208.33333%205H31.6667C32.5833%205%2033.3681%205.32639%2034.0208%205.97917C34.6736%206.63194%2035%207.41667%2035%208.33333V19.5C34.4722%2019.25%2033.9306%2019.0347%2033.375%2018.8542C32.8194%2018.6736%2032.25%2018.5417%2031.6667%2018.4583V8.33333H8.33333V31.6667H18.4167C18.5%2032.2778%2018.6319%2032.8611%2018.8125%2033.4167C18.9931%2033.9722%2019.2083%2034.5%2019.4583%2035H8.33333ZM8.33333%2030V31.6667V8.33333V18.4583V18.3333V30ZM11.6667%2028.3333H18.4583C18.5417%2027.75%2018.6736%2027.1806%2018.8542%2026.625C19.0347%2026.0694%2019.2361%2025.5278%2019.4583%2025H11.6667V28.3333ZM11.6667%2021.6667H21.8333C22.7222%2020.8333%2023.7153%2020.1389%2024.8125%2019.5833C25.9097%2019.0278%2027.0833%2018.6528%2028.3333%2018.4583V18.3333H11.6667V21.6667ZM11.6667%2015H28.3333V11.6667H11.6667V15ZM30%2038.3333C27.6944%2038.3333%2025.7292%2037.5208%2024.1042%2035.8958C22.4792%2034.2708%2021.6667%2032.3056%2021.6667%2030C21.6667%2027.6944%2022.4792%2025.7292%2024.1042%2024.1042C25.7292%2022.4792%2027.6944%2021.6667%2030%2021.6667C32.3056%2021.6667%2034.2708%2022.4792%2035.8958%2024.1042C37.5208%2025.7292%2038.3333%2027.6944%2038.3333%2030C38.3333%2032.3056%2037.5208%2034.2708%2035.8958%2035.8958C34.2708%2037.5208%2032.3056%2038.3333%2030%2038.3333ZM29.1667%2035H30.8333V30.8333H35V29.1667H30.8333V25H29.1667V29.1667H25V30.8333H29.1667V35Z'%20fill='currentColor'/%3e%3c/svg%3e", PCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cmask%20id='mask0_9411_108'%20style='mask-type:alpha'%20maskUnits='userSpaceOnUse'%20x='0'%20y='0'%20width='40'%20height='40'%3e%3crect%20width='40'%20height='40'%20fill='%23D9D9D9'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_9411_108)'%3e%3cpath%20d='M11.6665%2033.8888V14.4305C11.6665%2013.6608%2011.9397%2013.0077%2012.4861%2012.4713C13.0322%2011.9349%2013.6896%2011.6667%2014.4582%2011.6667H33.8886C34.6525%2011.6667%2035.3065%2011.9387%2035.8507%2012.4826C36.3946%2013.0267%2036.6665%2013.6808%2036.6665%2014.4447V28.3334L28.3332%2036.6667H14.4444C13.6805%2036.6667%2013.0265%2036.3948%2012.4823%2035.8509C11.9384%2035.3067%2011.6665%2034.6527%2011.6665%2033.8888ZM3.37483%2010.0001C3.22678%209.23146%203.37497%208.54396%203.81941%207.93757C4.26386%207.33118%204.87025%206.95382%205.63858%206.80549L24.8052%203.40299C25.5739%203.25465%2026.2614%203.39813%2026.8677%203.8334C27.4744%204.26868%2027.8518%204.87049%2027.9998%205.63882L28.5832%208.88882H25.7777L25.2915%206.13882L6.13858%209.51382L8.88858%2025.153V31.3334C8.37025%2031.2131%207.91886%2030.9631%207.53441%2030.5834C7.15025%2030.2037%206.90719%2029.7315%206.80525%2029.1667L3.37483%2010.0001ZM14.4444%2014.4447V33.8888H26.8886L33.8886%2026.8888V14.4447H14.4444ZM22.7777%2030.5555H25.5552V25.5555H30.5552V22.778H25.5552V17.778H22.7777V22.778H17.7777V25.5555H22.7777V30.5555Z'%20fill='currentColor'/%3e%3c/g%3e%3c/svg%3e", LCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cmask%20id='mask0_9391_9969'%20style='mask-type:alpha'%20maskUnits='userSpaceOnUse'%20x='0'%20y='0'%20width='40'%20height='40'%3e%3crect%20width='40'%20height='40'%20fill='%23D9D9D9'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_9391_9969)'%3e%3cpath%20d='M18.6111%2030.1666H21.3886V24.9166H26.6665V22.1387H21.3886V16.8612H18.6111V22.1387H13.3332V24.9166H18.6111V30.1666ZM9.44442%2036.6666C8.69442%2036.6666%208.04387%2036.3912%207.49275%2035.8403C6.94192%2035.2892%206.6665%2034.6387%206.6665%2033.8887V6.11117C6.6665%205.36117%206.94192%204.71061%207.49275%204.1595C8.04387%203.60867%208.69442%203.33325%209.44442%203.33325H23.9165L33.3332%2012.7499V33.8887C33.3332%2034.6387%2033.0578%2035.2892%2032.5069%2035.8403C31.9558%2036.3912%2031.3053%2036.6666%2030.5553%2036.6666H9.44442ZM22.5278%2014.0553V6.11117H9.44442V33.8887H30.5553V14.0553H22.5278Z'%20fill='currentColor'/%3e%3c/g%3e%3c/svg%3e", ICe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.61133%2033.3334C8.78716%2033.3334%208.09036%2033.0487%207.52091%2032.4792C6.95147%2031.9098%206.66675%2031.213%206.66675%2030.3888C6.66675%2029.5649%206.95147%2028.8683%207.52091%2028.2988C8.09036%2027.7294%208.78716%2027.4447%209.61133%2027.4447C10.4352%2027.4447%2011.1319%2027.7294%2011.7013%2028.2988C12.2708%2028.8683%2012.5555%2029.5649%2012.5555%2030.3888C12.5555%2031.213%2012.2708%2031.9098%2011.7013%2032.4792C11.1319%2033.0487%2010.4352%2033.3334%209.61133%2033.3334ZM20.0001%2033.3334C19.1759%2033.3334%2018.4791%2033.0487%2017.9097%2032.4792C17.3402%2031.9098%2017.0555%2031.213%2017.0555%2030.3888C17.0555%2029.5649%2017.3402%2028.8683%2017.9097%2028.2988C18.4791%2027.7294%2019.1759%2027.4447%2020.0001%2027.4447C20.8242%2027.4447%2021.5211%2027.7294%2022.0905%2028.2988C22.6599%2028.8683%2022.9447%2029.5649%2022.9447%2030.3888C22.9447%2031.213%2022.6599%2031.9098%2022.0905%2032.4792C21.5211%2033.0487%2020.8242%2033.3334%2020.0001%2033.3334ZM30.3888%2033.3334C29.5649%2033.3334%2028.8683%2033.0487%2028.2988%2032.4792C27.7294%2031.9098%2027.4447%2031.213%2027.4447%2030.3888C27.4447%2029.5649%2027.7294%2028.8683%2028.2988%2028.2988C28.8683%2027.7294%2029.5649%2027.4447%2030.3888%2027.4447C31.213%2027.4447%2031.9098%2027.7294%2032.4792%2028.2988C33.0487%2028.8683%2033.3334%2029.5649%2033.3334%2030.3888C33.3334%2031.213%2033.0487%2031.9098%2032.4792%2032.4792C31.9098%2033.0487%2031.213%2033.3334%2030.3888%2033.3334ZM9.61133%2022.9447C8.78716%2022.9447%208.09036%2022.6599%207.52091%2022.0905C6.95147%2021.5211%206.66675%2020.8242%206.66675%2020.0001C6.66675%2019.1759%206.95147%2018.4791%207.52091%2017.9097C8.09036%2017.3402%208.78716%2017.0555%209.61133%2017.0555C10.4352%2017.0555%2011.1319%2017.3402%2011.7013%2017.9097C12.2708%2018.4791%2012.5555%2019.1759%2012.5555%2020.0001C12.5555%2020.8242%2012.2708%2021.5211%2011.7013%2022.0905C11.1319%2022.6599%2010.4352%2022.9447%209.61133%2022.9447ZM20.0001%2022.9447C19.1759%2022.9447%2018.4791%2022.6599%2017.9097%2022.0905C17.3402%2021.5211%2017.0555%2020.8242%2017.0555%2020.0001C17.0555%2019.1759%2017.3402%2018.4791%2017.9097%2017.9097C18.4791%2017.3402%2019.1759%2017.0555%2020.0001%2017.0555C20.8242%2017.0555%2021.5211%2017.3402%2022.0905%2017.9097C22.6599%2018.4791%2022.9447%2019.1759%2022.9447%2020.0001C22.9447%2020.8242%2022.6599%2021.5211%2022.0905%2022.0905C21.5211%2022.6599%2020.8242%2022.9447%2020.0001%2022.9447ZM30.3888%2022.9447C29.5649%2022.9447%2028.8683%2022.6599%2028.2988%2022.0905C27.7294%2021.5211%2027.4447%2020.8242%2027.4447%2020.0001C27.4447%2019.1759%2027.7294%2018.4791%2028.2988%2017.9097C28.8683%2017.3402%2029.5649%2017.0555%2030.3888%2017.0555C31.213%2017.0555%2031.9098%2017.3402%2032.4792%2017.9097C33.0487%2018.4791%2033.3334%2019.1759%2033.3334%2020.0001C33.3334%2020.8242%2033.0487%2021.5211%2032.4792%2022.0905C31.9098%2022.6599%2031.213%2022.9447%2030.3888%2022.9447ZM9.61133%2012.5555C8.78716%2012.5555%208.09036%2012.2708%207.52091%2011.7013C6.95147%2011.1319%206.66675%2010.4352%206.66675%209.61133C6.66675%208.78716%206.95147%208.09036%207.52091%207.52091C8.09036%206.95147%208.78716%206.66675%209.61133%206.66675C10.4352%206.66675%2011.1319%206.95147%2011.7013%207.52091C12.2708%208.09036%2012.5555%208.78716%2012.5555%209.61133C12.5555%2010.4352%2012.2708%2011.1319%2011.7013%2011.7013C11.1319%2012.2708%2010.4352%2012.5555%209.61133%2012.5555ZM20.0001%2012.5555C19.1759%2012.5555%2018.4791%2012.2708%2017.9097%2011.7013C17.3402%2011.1319%2017.0555%2010.4352%2017.0555%209.61133C17.0555%208.78716%2017.3402%208.09036%2017.9097%207.52091C18.4791%206.95147%2019.1759%206.66675%2020.0001%206.66675C20.8242%206.66675%2021.5211%206.95147%2022.0905%207.52091C22.6599%208.09036%2022.9447%208.78716%2022.9447%209.61133C22.9447%2010.4352%2022.6599%2011.1319%2022.0905%2011.7013C21.5211%2012.2708%2020.8242%2012.5555%2020.0001%2012.5555ZM30.3888%2012.5555C29.5649%2012.5555%2028.8683%2012.2708%2028.2988%2011.7013C27.7294%2011.1319%2027.4447%2010.4352%2027.4447%209.61133C27.4447%208.78716%2027.7294%208.09036%2028.2988%207.52091C28.8683%206.95147%2029.5649%206.66675%2030.3888%206.66675C31.213%206.66675%2031.9098%206.95147%2032.4792%207.52091C33.0487%208.09036%2033.3334%208.78716%2033.3334%209.61133C33.3334%2010.4352%2033.0487%2011.1319%2032.4792%2011.7013C31.9098%2012.2708%2031.213%2012.5555%2030.3888%2012.5555Z'%20fill='currentColor'/%3e%3c/svg%3e", jCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M32.5%2015.8333H29.1667V26.8167L9.85%207.5L7.5%209.85L26.8167%2029.1667H15.8333V32.5H32.5V15.8333Z'%20fill='currentColor'/%3e%3c/svg%3e", VCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M15.8333%207.5V10.8333H26.8167L7.5%2030.15L9.85%2032.5L29.1667%2013.1833V24.1667H32.5V7.5H15.8333Z'%20fill='currentColor'%20/%3e%3c/svg%3e", DCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M27.5%2033.3333H29.1667V26.6666H27.5V33.3333ZM28.3333%2024.9999C28.5556%2024.9999%2028.75%2024.9166%2028.9167%2024.7499C29.0833%2024.5833%2029.1667%2024.3888%2029.1667%2024.1666C29.1667%2023.9444%2029.0833%2023.7499%2028.9167%2023.5833C28.75%2023.4166%2028.5556%2023.3333%2028.3333%2023.3333C28.1111%2023.3333%2027.9167%2023.4166%2027.75%2023.5833C27.5833%2023.7499%2027.5%2023.9444%2027.5%2024.1666C27.5%2024.3888%2027.5833%2024.5833%2027.75%2024.7499C27.9167%2024.9166%2028.1111%2024.9999%2028.3333%2024.9999ZM11.6667%2023.3333H17.7917C18.0972%2022.6944%2018.4514%2022.0971%2018.8542%2021.5416C19.2569%2020.986%2019.7083%2020.4721%2020.2083%2019.9999H11.6667V23.3333ZM11.6667%2029.9999H16.7917C16.7083%2029.4444%2016.6667%2028.8888%2016.6667%2028.3333C16.6667%2027.7777%2016.7083%2027.2221%2016.7917%2026.6666H11.6667V29.9999ZM8.33333%2036.6666C7.41667%2036.6666%206.63194%2036.3402%205.97917%2035.6874C5.32639%2035.0346%205%2034.2499%205%2033.3333V6.66658C5%205.74992%205.32639%204.9652%205.97917%204.31242C6.63194%203.65964%207.41667%203.33325%208.33333%203.33325H21.6667L31.6667%2013.3333V17.1666C31.1389%2016.9999%2030.5972%2016.8749%2030.0417%2016.7916C29.4861%2016.7083%2028.9167%2016.6666%2028.3333%2016.6666V14.9999H20V6.66658H8.33333V33.3333H17.7917C18.0972%2033.9721%2018.4514%2034.5694%2018.8542%2035.1249C19.2569%2035.6805%2019.7083%2036.1944%2020.2083%2036.6666H8.33333ZM28.3333%2019.9999C30.6389%2019.9999%2032.6042%2020.8124%2034.2292%2022.4374C35.8542%2024.0624%2036.6667%2026.0277%2036.6667%2028.3333C36.6667%2030.6388%2035.8542%2032.6041%2034.2292%2034.2291C32.6042%2035.8541%2030.6389%2036.6666%2028.3333%2036.6666C26.0278%2036.6666%2024.0625%2035.8541%2022.4375%2034.2291C20.8125%2032.6041%2020%2030.6388%2020%2028.3333C20%2026.0277%2020.8125%2024.0624%2022.4375%2022.4374C24.0625%2020.8124%2026.0278%2019.9999%2028.3333%2019.9999Z'%20fill='currentColor'/%3e%3c/svg%3e", ACe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M19.65%2033.3C27.1887%2033.3%2033.3%2027.1887%2033.3%2019.65C33.3%2012.1113%2027.1887%206%2019.65%206C12.1113%206%206%2012.1113%206%2019.65C6%2027.1887%2012.1113%2033.3%2019.65%2033.3ZM19.65%2036.3C28.8455%2036.3%2036.3%2028.8455%2036.3%2019.65C36.3%2010.4545%2028.8455%203%2019.65%203C10.4545%203%203%2010.4545%203%2019.65C3%2028.8455%2010.4545%2036.3%2019.65%2036.3Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M29.1213%2015.1213L17.5343%2026.7083L11%2020.174L13.1213%2018.0526L17.5343%2022.4657L27%2013L29.1213%2015.1213Z'%20fill='currentColor'/%3e%3c/svg%3e", HCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.3835%2032.8166C11.8502%2034.8333%2014.9002%2036.1666%2018.2502%2036.5V33.1333C15.8168%2032.8333%2013.6002%2031.8666%2011.7502%2030.4333L9.3835%2032.8166ZM6.70016%2021.5833H3.3335C3.66683%2024.9333%205.00016%2027.9833%207.01683%2030.45L9.40016%2028.0833C7.96683%2026.2333%207.00016%2024.0166%206.70016%2021.5833ZM9.40016%2011.75L7.01683%209.36665C5.00016%2011.8333%203.66683%2014.9%203.3335%2018.2333H6.70016C7.00016%2015.8166%207.96683%2013.6%209.40016%2011.75ZM18.2502%206.69998L18.2502%203.33331C14.9002%203.66664%2011.8502%204.99998%209.3835%207.01665L11.7668%209.39998C13.6002%207.96665%2015.8168%206.99998%2018.2502%206.69998ZM21.5835%206.69998V3.33331C30.0002%204.16665%2036.5835%2011.2667%2036.5835%2019.9167C36.5835%2028.5667%2030.0002%2035.6666%2021.5835%2036.5V33.1333C28.1668%2032.3166%2033.2502%2026.7167%2033.2502%2019.9167C33.2502%2013.1166%2028.1668%207.51665%2021.5835%206.69998Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M29.0611%2015.0606L17.4742%2026.6476L10.9398%2020.1133L13.0611%2017.992L17.4742%2022.405L26.9398%2012.9393L29.0611%2015.0606Z'%20fill='currentColor'/%3e%3c/svg%3e", FCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cmask%20id='mask0_9411_150'%20style='mask-type:alpha'%20maskUnits='userSpaceOnUse'%20x='0'%20y='0'%20width='40'%20height='40'%3e%3crect%20width='40'%20height='40'%20fill='currentColor'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_9411_150)'%3e%3cpath%20d='M11.6665%2033.8888V14.4305C11.6665%2013.6608%2011.9397%2013.0077%2012.4861%2012.4713C13.0322%2011.9349%2013.6896%2011.6667%2014.4582%2011.6667H33.8886C34.6525%2011.6667%2035.3065%2011.9387%2035.8507%2012.4826C36.3946%2013.0267%2036.6665%2013.6808%2036.6665%2014.4447V28.3334L28.3332%2036.6667H14.4444C13.6805%2036.6667%2013.0265%2036.3948%2012.4823%2035.8509C11.9384%2035.3067%2011.6665%2034.6527%2011.6665%2033.8888ZM3.37483%2010.0001C3.22678%209.23146%203.37497%208.54396%203.81941%207.93757C4.26386%207.33118%204.87025%206.95382%205.63858%206.80549L24.8052%203.40299C25.5739%203.25465%2026.2614%203.39813%2026.8677%203.8334C27.4744%204.26868%2027.8518%204.87049%2027.9998%205.63882L28.5832%208.88882H25.7777L25.2915%206.13882L6.13858%209.51382L8.88858%2025.153V31.3334C8.37025%2031.2131%207.91886%2030.9631%207.53441%2030.5834C7.15025%2030.2037%206.90719%2029.7315%206.80525%2029.1667L3.37483%2010.0001ZM14.4444%2014.4447V33.8888H26.8886V26.8888H33.8886V14.4447H14.4444Z'%20fill='currentColor'/%3e%3c/g%3e%3c/svg%3e", NCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M7.66667%2033.3333H24.1667V24.1667H33.3333V7.66667H7.66667V33.3333ZM7.66667%2037C6.65833%2037%205.79483%2036.6413%205.07617%2035.9238C4.35872%2035.2052%204%2034.3417%204%2033.3333V7.66667C4%206.65833%204.35872%205.79483%205.07617%205.07617C5.79483%204.35872%206.65833%204%207.66667%204H33.3333C34.3417%204%2035.2052%204.35872%2035.9238%205.07617C36.6413%205.79483%2037%206.65833%2037%207.66667V26L26%2037H7.66667ZM11.3333%2024.1667V20.5H20.5V24.1667H11.3333ZM11.3333%2016.8333V13.1667H29.6667V16.8333H11.3333Z'%20fill='currentColor'/%3e%3c/svg%3e", $Ce = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M%2032.222656%2016%20L%2035%2016%20L%2035%205.300781%20L%2024.304688%205.300781%20C%2024.074219%204.335938%2023.558594%203.546875%2022.757812%202.925781%20C%2021.957031%202.308594%2021.035156%202%2020%202%20C%2018.980469%202%2018.070312%202.308594%2017.265625%202.925781%20C%2016.457031%203.546875%2015.941406%204.335938%2015.707031%205.300781%20L%205%205.300781%20L%205%2035%20L%2017%2035%20L%2017%2032.25%20L%207.777344%2032.25%20L%207.777344%208.050781%20L%2010.554688%208.050781%20L%2010.554688%2012.175781%20L%2029.445312%2012.175781%20L%2029.445312%208.050781%20L%2032.222656%208.050781%20Z%20M%2021.1875%207.574219%20C%2020.867188%207.890625%2020.472656%208.050781%2020%208.050781%20C%2019.527344%208.050781%2019.132812%207.890625%2018.8125%207.574219%20C%2018.492188%207.257812%2018.332031%206.867188%2018.332031%206.398438%20C%2018.332031%205.933594%2018.492188%205.539062%2018.8125%205.222656%20C%2019.132812%204.90625%2019.527344%204.75%2020%204.75%20C%2020.472656%204.75%2020.867188%204.90625%2021.1875%205.222656%20C%2021.507812%205.539062%2021.667969%205.933594%2021.667969%206.398438%20C%2021.667969%206.867188%2021.507812%207.257812%2021.1875%207.574219%20Z%20M%2021.1875%207.574219%20'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M%2021%2032.25%20L%2021%2038%20L%2026.746094%2038%20L%2039%2025.703125%20L%2033.285156%2020%20Z%20M%2025.59375%2035.234375%20L%2023.8125%2035.234375%20L%2023.8125%2033.453125%20L%2029.53125%2027.78125%20L%2030.421875%2028.625%20L%2031.265625%2029.515625%20Z%20M%2025.59375%2035.234375%20'/%3e%3c/svg%3e", BCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M6.6665%2035V32.2221H26.6665V35H6.6665ZM15.9719%2026.4167L6.6665%2017.1113L9.77775%2013.9167L19.1665%2023.2221L15.9719%2026.4167ZM26.5553%2015.8333L17.2498%206.44459L20.4444%203.33334L29.7498%2012.6388L26.5553%2015.8333ZM34.7219%2033.3333L12.5832%2011.1946L14.5278%209.25L36.6665%2031.3888L34.7219%2033.3333Z'%20fill='currentColor'/%3e%3c/svg%3e", zCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M19.9998%2036.6666C19.259%2036.6666%2018.6016%2036.4885%2018.0278%2036.1321C17.4536%2035.7754%2017.0554%2035.2869%2016.8332%2034.6667H13.6665V25.9446C11.8979%2024.7871%2010.4975%2023.2916%209.46525%2021.4583C8.43275%2019.625%207.9165%2017.6111%207.9165%2015.4166C7.9165%2012.0555%209.09012%209.20137%2011.4373%206.85415C13.7846%204.50692%2016.6387%203.33331%2019.9998%203.33331C23.3609%203.33331%2026.2151%204.50692%2028.5623%206.85415C30.9096%209.20137%2032.0832%2012.0555%2032.0832%2015.4166C32.0832%2017.6297%2031.5669%2019.6482%2030.5344%2021.4721C29.5022%2023.2962%2028.1018%2024.7871%2026.3332%2025.9446V34.6667H23.1665C22.9443%2035.2869%2022.5461%2035.7754%2021.9719%2036.1321C21.398%2036.4885%2020.7407%2036.6666%2019.9998%2036.6666ZM16.4444%2031.8887H23.5553V30.1666H16.4444V31.8887ZM16.4444%2028.5H23.5553V26.8612H16.4444V28.5ZM16.0832%2024.0833H18.9444V18.7779L15.1665%2015L16.6111%2013.5554L19.9998%2016.9446L23.3886%2013.5554L24.8332%2015L21.0553%2018.7779V24.0833H23.9165C25.5276%2023.3241%2026.8286%2022.1644%2027.8194%2020.6041C28.81%2019.0439%2029.3053%2017.3147%2029.3053%2015.4166C29.3053%2012.8055%2028.4072%2010.6018%2026.6111%208.8054C24.8147%207.00929%2022.6109%206.11123%2019.9998%206.11123C17.3887%206.11123%2015.185%207.00929%2013.3886%208.8054C11.5925%2010.6018%2010.6944%2012.8055%2010.6944%2015.4166C10.6944%2017.3147%2011.1897%2019.0439%2012.1803%2020.6041C13.1711%2022.1644%2014.4721%2023.3241%2016.0832%2024.0833Z'%20fill='currentColor'/%3e%3c/svg%3e", ZCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M27.0003%202.92986L9%202.92986V15.8988H11.6V5.52986H24.4003V19.0482L27.0003%2020.0125V13.0193H31.6871V24.0723H34.2871V10.4193H27.0003V2.92986Z'%20fill='currentColor'/%3e%3cpath%20d='M13.8726%209.37341H15.5392V7.70674H13.8726V9.37341Z'%20fill='currentColor'/%3e%3cpath%20d='M17.2059%209.37341H18.8726V7.70674H17.2059V9.37341Z'%20fill='currentColor'/%3e%3cpath%20d='M18.8726%2012.7067H17.2059V11.0401H18.8726V12.7067Z'%20fill='currentColor'/%3e%3cpath%20d='M13.8726%2012.7067H15.5392V11.0401H13.8726V12.7067Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M11.8054%2033.1986L24.3333%2036.7541L37.5%2032.6986V26.6707H28.8333V23.532L15.5%2018.532H2.5V35.5874H11.8054V33.1986ZM9%2032.8095H5.27792V21.3095H9V32.8095ZM34.6113%2030.6707L24.1946%2033.8653L11.8054%2030.3095V21.3095H15.0279L25.9446%2025.4207V26.6707H22.8196L18%2025.0874L17.0554%2027.7541L22.375%2029.4486H34.6113V30.6707Z'%20fill='currentColor'/%3e%3cpath%20d='M20.5717%209.37341H22.2384V7.70674H20.5717V9.37341Z'%20fill='currentColor'/%3e%3cpath%20d='M22.2384%2012.7067H20.5717V11.0401H22.2384V12.7067Z'%20fill='currentColor'/%3e%3cpath%20d='M18.8726%2015.8988H17.2059V14.2321H18.8726V15.8988Z'%20fill='currentColor'/%3e%3cpath%20d='M13.8726%2015.8988H15.5392V14.2321H13.8726V15.8988Z'%20fill='currentColor'/%3e%3cpath%20d='M22.2384%2015.8988H20.5717V14.2321H22.2384V15.8988Z'%20fill='currentColor'/%3e%3c/svg%3e", WCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M19.0311%2038C16.8135%2038%2014.7295%2037.5792%2012.779%2036.7376C10.8285%2035.8959%209.13191%2034.7537%207.68911%2033.3109C6.24631%2031.8681%205.10409%2030.1715%204.26245%2028.221C3.42082%2026.2706%203%2024.1865%203%2021.9689C3%2019.7512%203.42082%2017.6672%204.26245%2015.7167C5.10409%2013.7663%206.24631%2012.0697%207.68911%2010.6269C9.13191%209.18405%2010.8285%208.04183%2012.779%207.2002C14.7295%206.35856%2016.8135%205.93774%2019.0311%205.93774C21.2488%205.93774%2023.3328%206.35856%2025.2833%207.2002C27.2337%208.04183%2028.9304%209.18405%2030.3732%2010.6269C31.816%2012.0697%2032.9582%2013.7663%2033.7998%2015.7167C34.6415%2017.6672%2035.0623%2019.7512%2035.0623%2021.9689C35.0623%2024.1865%2034.6415%2026.2706%2033.7998%2028.221C32.9582%2030.1715%2031.816%2031.8681%2030.3732%2033.3109C28.9304%2034.7537%2027.2337%2035.8959%2025.2833%2036.7376C23.3328%2037.5792%2021.2488%2038%2019.0311%2038ZM19.0311%2034.7938C22.6114%2034.7938%2025.644%2033.5514%2028.1288%2031.0666C30.6136%2028.5817%2031.8561%2025.5492%2031.8561%2021.9689C31.8561%2018.3886%2030.6136%2015.356%2028.1288%2012.8712C25.644%2010.3864%2022.6114%209.14397%2019.0311%209.14397C15.4509%209.14397%2012.4183%2010.3864%209.93347%2012.8712C7.44864%2015.356%206.20623%2018.3886%206.20623%2021.9689C6.20623%2025.5492%207.44864%2028.5817%209.93347%2031.0666C12.4183%2033.5514%2015.4509%2034.7938%2019.0311%2034.7938ZM19.0311%2031.5876C16.3593%2031.5876%2014.0882%2030.6524%2012.2179%2028.7821C10.3476%2026.9118%209.41246%2024.6407%209.41246%2021.9689C9.41246%2019.297%2010.3476%2017.026%2012.2179%2015.1557C14.0882%2013.2854%2016.3593%2012.3502%2019.0311%2012.3502C21.703%2012.3502%2023.9741%2013.2854%2025.8444%2015.1557C27.7147%2017.026%2028.6498%2019.297%2028.6498%2021.9689C28.6498%2024.6407%2027.7147%2026.9118%2025.8444%2028.7821C23.9741%2030.6524%2021.703%2031.5876%2019.0311%2031.5876ZM19.0311%2028.3813C20.7946%2028.3813%2022.3042%2027.7535%2023.5599%2026.4977C24.8157%2025.2419%2025.4436%2023.7323%2025.4436%2021.9689C25.4436%2020.2055%2024.8157%2018.6959%2023.5599%2017.4401C22.3042%2016.1843%2020.7946%2015.5564%2019.0311%2015.5564C17.2677%2015.5564%2015.7581%2016.1843%2014.5023%2017.4401C13.2466%2018.6959%2012.6187%2020.2055%2012.6187%2021.9689C12.6187%2023.7323%2013.2466%2025.2419%2014.5023%2026.4977C15.7581%2027.7535%2017.2677%2028.3813%2019.0311%2028.3813ZM19.0311%2025.1751C18.1494%2025.1751%2017.3946%2024.8612%2016.7667%2024.2333C16.1389%2023.6054%2015.8249%2022.8506%2015.8249%2021.9689C15.8249%2021.0872%2016.1389%2020.3324%2016.7667%2019.7045C17.3946%2019.0766%2018.1494%2018.7627%2019.0311%2018.7627C19.9129%2018.7627%2020.6677%2019.0766%2021.2955%2019.7045C21.9234%2020.3324%2022.2374%2021.0872%2022.2374%2021.9689C22.2374%2022.8506%2021.9234%2023.6054%2021.2955%2024.2333C20.6677%2024.8612%2019.9129%2025.1751%2019.0311%2025.1751Z'%20fill='currentColor'/%3e%3cline%20x1='19.2474'%20y1='21.4734'%20x2='32.0723'%20y2='5.90033'%20stroke='currentColor'%20stroke-width='3'/%3e%3cpath%20d='M31.3671%201.00008L32.8145%205.10599L28.7231%2010.0436L27.2758%205.93772L31.3671%201.00008Z'%20fill='currentColor'/%3e%3cpath%20d='M32.7721%2010.5182L28.7233%2010.0438L32.8147%205.10617L36.8635%205.58054L32.7721%2010.5182Z'%20fill='currentColor'/%3e%3c/svg%3e", UCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M5%205.00008V35.0001H20.6529C20.4407%2034.5806%2020.2581%2034.1379%2020.105%2033.6717C19.9517%2033.2054%2019.824%2032.7222%2019.7221%2032.2222H7.77792V7.778H32.2221V19.7084C32.6943%2019.7917%2033.1665%2019.9098%2033.6388%2020.0626C34.111%2020.2154%2034.5647%2020.4074%2035%2020.6388V5.00008H24.1946C23.9815%204.01869%2023.4838%203.21772%2022.7013%202.59717C21.919%201.97689%2021.0186%201.66675%2020%201.66675C18.9814%201.66675%2018.081%201.97689%2017.2988%202.59717C16.5163%203.21772%2016.0185%204.01869%2015.8054%205.00008H5ZM20.9792%206.47925C20.7061%206.7523%2020.3797%206.88883%2020%206.88883C19.6203%206.88883%2019.2939%206.7523%2019.0208%206.47925C18.7478%206.20619%2018.6113%205.8798%2018.6113%205.50008C18.6113%205.12036%2018.7478%204.79397%2019.0208%204.52091C19.2939%204.24786%2019.6203%204.11133%2020%204.11133C20.3797%204.11133%2020.7061%204.24786%2020.9792%204.52091C21.2522%204.79397%2021.3888%205.12036%2021.3888%205.50008C21.3888%205.8798%2021.2522%206.20619%2020.9792%206.47925Z'%20fill='currentColor'/%3e%3cpath%20d='M19.7917%2028.3334H11.6667V25.5555H20.7363C20.514%2025.9908%2020.3265%2026.4399%2020.1738%2026.903C20.021%2027.3658%2019.8936%2027.8426%2019.7917%2028.3334Z'%20fill='currentColor'/%3e%3cpath%20d='M24.6113%2021.3888H11.6667V18.6113H28.3333V19.7638C27.6203%2019.9027%2026.9606%2020.1065%2026.3542%2020.3751C25.7478%2020.6437%2025.1668%2020.9816%2024.6113%2021.3888Z'%20fill='currentColor'/%3e%3cpath%20d='M28.3333%2014.4447H11.6667V11.6667H28.3333V14.4447Z'%20fill='currentColor'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M24.7013%2035.9513C26.2616%2037.5208%2028.1436%2038.3055%2030.3472%2038.3055C32.5511%2038.3055%2034.4377%2037.5208%2036.0072%2035.9513C37.5766%2034.3819%2038.3613%2032.5092%2038.3613%2030.3334C38.3613%2028.1123%2037.5766%2026.2191%2036.0072%2024.6538C34.4377%2023.0883%2032.5558%2022.3055%2030.3613%2022.3055C28.148%2022.3055%2026.2613%2023.0883%2024.7013%2024.6538C23.1413%2026.2191%2022.3613%2028.1123%2022.3613%2030.3334C22.3613%2032.5092%2023.1413%2034.3819%2024.7013%2035.9513ZM27.26%2034.5311L26.2191%2033.4902L29.3619%2030.3474L26.2191%2027.2046L27.26%2026.1637L30.4028%2029.3065L33.5456%2026.1637L34.5865%2027.2046L31.4438%2030.3474L34.5865%2033.4902L33.5456%2034.5311L30.4028%2031.3883L27.26%2034.5311Z'%20fill='currentColor'/%3e%3c/svg%3e", GCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M5%2037V24.625H11.1875V37H5ZM17.375%2037V14.3125H23.5625V37H17.375ZM29.75%2037V4H35.9375V37H29.75Z'%20fill='currentColor'/%3e%3c/svg%3e", qCe = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M5%2038V3H13.0162V38H5ZM28.798%2038V16.5484H36V38H28.798Z'%20fill='currentColor'/%3e%3cpath%20d='M17.3374%2016.5484V3H25.5414V16.5484H17.3374Z'%20fill='currentColor'/%3e%3c/svg%3e";
var X8 = {}, KCe = ht;
Object.defineProperty(X8, "__esModule", {
  value: !0
});
var h_ = X8.default = void 0, YCe = KCe(bt()), XCe = f;
h_ = X8.default = (0, YCe.default)(/* @__PURE__ */ (0, XCe.jsx)("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8m3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5m-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11m3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5"
}), "InsertEmoticon");
function JCe({ editor: e }) {
  const [t, n] = Ae(null), [o, r] = Ae([]), i = !!t, s = ge();
  mt(() => {
    const p = Object.entries(/* @__PURE__ */ Object.assign({
      "../../../assets/objects_concepts/ Agriculture.svg": ume,
      "../../../assets/objects_concepts/ Animation.svg": fme,
      "../../../assets/objects_concepts/ Askor.svg": pme,
      "../../../assets/objects_concepts/ Brand.svg": hme,
      "../../../assets/objects_concepts/ Business trips.svg": gme,
      "../../../assets/objects_concepts/ Carbon emissions.svg": mme,
      "../../../assets/objects_concepts/ Carbon neutrality.svg": bme,
      "../../../assets/objects_concepts/ Collective.svg": Cme,
      "../../../assets/objects_concepts/ Communication.svg": xme,
      "../../../assets/objects_concepts/ Consumption.svg": yme,
      "../../../assets/objects_concepts/ Corporate.svg": vme,
      "../../../assets/objects_concepts/ Diagnostic.svg": wme,
      "../../../assets/objects_concepts/ Distribution.svg": Sme,
      "../../../assets/objects_concepts/ Energy.svg": Mme,
      "../../../assets/objects_concepts/ Equal.svg": Tme,
      "../../../assets/objects_concepts/ Euros.svg": kme,
      "../../../assets/objects_concepts/ Events.svg": Eme,
      "../../../assets/objects_concepts/ Forests & woods.svg": Rme,
      "../../../assets/objects_concepts/ Hedges & plant covers.svg": Ome,
      "../../../assets/objects_concepts/ Ingredients.svg": _me,
      "../../../assets/objects_concepts/ Inputs & chimicals.svg": Pme,
      "../../../assets/objects_concepts/ Labels.svg": Lme,
      "../../../assets/objects_concepts/ Organization.svg": Ime,
      "../../../assets/objects_concepts/ Packaging.svg": jme,
      "../../../assets/objects_concepts/ Production sites.svg": Vme,
      "../../../assets/objects_concepts/ Production.svg": Dme,
      "../../../assets/objects_concepts/ Products bying.svg": Ame,
      "../../../assets/objects_concepts/ Products.svg": Hme,
      "../../../assets/objects_concepts/ Project manager.svg": Fme,
      "../../../assets/objects_concepts/ Publications.svg": Nme,
      "../../../assets/objects_concepts/ Ranges & sectors.svg": $me,
      "../../../assets/objects_concepts/ Recipe.svg": Bme,
      "../../../assets/objects_concepts/ Sectors.svg": zme,
      "../../../assets/objects_concepts/ Social media.svg": Zme,
      "../../../assets/objects_concepts/ Strategy.svg": Wme,
      "../../../assets/objects_concepts/ Suppliers.svg": Ume,
      "../../../assets/objects_concepts/ Territories.svg": Gme,
      "../../../assets/objects_concepts/ Trajectory.svg": qme,
      "../../../assets/objects_concepts/ Transformation steps.svg": Kme,
      "../../../assets/objects_concepts/ Transportation.svg": Yme,
      "../../../assets/objects_concepts/ Users.svg": Xme,
      "../../../assets/objects_concepts/ Vineyard.svg": Jme,
      "../../../assets/objects_concepts/ Webinars.svg": Qme,
      "../../../assets/objects_concepts/ Wine tourism.svg": ebe,
      "../../../assets/objects_concepts/Document space.svg": tbe,
      "../../../assets/objects_concepts/Simulation.svg": nbe,
      "../../../assets/objects_concepts/Upload file.svg": obe,
      "../../../assets/objects_concepts/grid view.svg": rbe,
      "../../../assets/objects_concepts/table view.svg": ibe,
      "../../../assets/pages_functions/ Actions plan.svg": sbe,
      "../../../assets/pages_functions/ Actions.svg": abe,
      "../../../assets/pages_functions/ Activity data.svg": lbe,
      "../../../assets/pages_functions/ Add or remove.svg": cbe,
      "../../../assets/pages_functions/ Add users.svg": dbe,
      "../../../assets/pages_functions/ Add.svg": ube,
      "../../../assets/pages_functions/ Analytics.svg": fbe,
      "../../../assets/pages_functions/ Arrow (trajectory).svg": pbe,
      "../../../assets/pages_functions/ Arrow down (small).svg": hbe,
      "../../../assets/pages_functions/ Arrow down.svg": gbe,
      "../../../assets/pages_functions/ Arrow left (small).svg": mbe,
      "../../../assets/pages_functions/ Arrow left.svg": bbe,
      "../../../assets/pages_functions/ Arrow right (small).svg": Cbe,
      "../../../assets/pages_functions/ Arrow right.svg": xbe,
      "../../../assets/pages_functions/ Arrow up (small).svg": ybe,
      "../../../assets/pages_functions/ Arrow up.svg": vbe,
      "../../../assets/pages_functions/ Calendar.svg": wbe,
      "../../../assets/pages_functions/ Callback.svg": Sbe,
      "../../../assets/pages_functions/ Cancel.svg": Mbe,
      "../../../assets/pages_functions/ Check.svg": Tbe,
      "../../../assets/pages_functions/ Circle check.svg": kbe,
      "../../../assets/pages_functions/ Click indicator.svg": Ebe,
      "../../../assets/pages_functions/ Close panel.svg": Rbe,
      "../../../assets/pages_functions/ Close.svg": Obe,
      "../../../assets/pages_functions/ Columns.svg": _be,
      "../../../assets/pages_functions/ Compare.svg": Pbe,
      "../../../assets/pages_functions/ Comparison.svg": Lbe,
      "../../../assets/pages_functions/ Congrats.svg": Ibe,
      "../../../assets/pages_functions/ Dashboard.svg": jbe,
      "../../../assets/pages_functions/ Delete.svg": Vbe,
      "../../../assets/pages_functions/ Documentation.svg": Dbe,
      "../../../assets/pages_functions/ Drag.svg": Abe,
      "../../../assets/pages_functions/ Duplicate.svg": Hbe,
      "../../../assets/pages_functions/ Edit.svg": Fbe,
      "../../../assets/pages_functions/ Empty.svg": Nbe,
      "../../../assets/pages_functions/ Evolution.svg": $be,
      "../../../assets/pages_functions/ Export & download.svg": Bbe,
      "../../../assets/pages_functions/ Fav - added.svg": zbe,
      "../../../assets/pages_functions/ Fav - non-added.svg": Zbe,
      "../../../assets/pages_functions/ Filter.svg": Wbe,
      "../../../assets/pages_functions/ Hamburger menu.svg": Ube,
      "../../../assets/pages_functions/ Hide pwd.svg": Gbe,
      "../../../assets/pages_functions/ Home.svg": qbe,
      "../../../assets/pages_functions/ Import & upload.svg": Kbe,
      "../../../assets/pages_functions/ Information.svg": Ybe,
      "../../../assets/pages_functions/ Informations.svg": Xbe,
      "../../../assets/pages_functions/ List.svg": Jbe,
      "../../../assets/pages_functions/ Logout.svg": Qbe,
      "../../../assets/pages_functions/ Mail.svg": eCe,
      "../../../assets/pages_functions/ Minus.svg": tCe,
      "../../../assets/pages_functions/ Open in new tab.svg": nCe,
      "../../../assets/pages_functions/ Open panel.svg": oCe,
      "../../../assets/pages_functions/ Plus.svg": rCe,
      "../../../assets/pages_functions/ Previous campaign.svg": iCe,
      "../../../assets/pages_functions/ Question mark.svg": sCe,
      "../../../assets/pages_functions/ Questionnaires.svg": aCe,
      "../../../assets/pages_functions/ Reminder.svg": lCe,
      "../../../assets/pages_functions/ Remove users.svg": cCe,
      "../../../assets/pages_functions/ Remove.svg": dCe,
      "../../../assets/pages_functions/ Repartition.svg": uCe,
      "../../../assets/pages_functions/ Repositories.svg": fCe,
      "../../../assets/pages_functions/ Reset.svg": pCe,
      "../../../assets/pages_functions/ Save.svg": hCe,
      "../../../assets/pages_functions/ Saved online.svg": gCe,
      "../../../assets/pages_functions/ Scores & indicators.svg": mCe,
      "../../../assets/pages_functions/ Search.svg": bCe,
      "../../../assets/pages_functions/ Send message.svg": CCe,
      "../../../assets/pages_functions/ Settings.svg": xCe,
      "../../../assets/pages_functions/ Sort - Ascending.svg": yCe,
      "../../../assets/pages_functions/ Sort - Descending.svg": vCe,
      "../../../assets/pages_functions/ Sort - No sorting.svg": wCe,
      "../../../assets/pages_functions/ Suggestions.svg": SCe,
      "../../../assets/pages_functions/ Sync.svg": MCe,
      "../../../assets/pages_functions/ Timer.svg": TCe,
      "../../../assets/pages_functions/ User account.svg": kCe,
      "../../../assets/pages_functions/ View pwd.svg": ECe,
      "../../../assets/pages_functions/ Visio.svg": RCe,
      "../../../assets/pages_functions/ Warning.svg": OCe,
      "../../../assets/pages_functions/Add Notes.svg": _Ce,
      "../../../assets/pages_functions/Add a note.svg": PCe,
      "../../../assets/pages_functions/Add file.svg": LCe,
      "../../../assets/pages_functions/All features.svg": ICe,
      "../../../assets/pages_functions/Arrow down right.svg": jCe,
      "../../../assets/pages_functions/Arrow up right.svg": VCe,
      "../../../assets/pages_functions/Details.svg": DCe,
      "../../../assets/pages_functions/Done.svg": ACe,
      "../../../assets/pages_functions/In progress.svg": HCe,
      "../../../assets/pages_functions/Note.svg": FCe,
      "../../../assets/pages_functions/Notes.svg": NCe,
      "../../../assets/pages_functions/Questionnaire answer.svg": $Ce,
      "../../../assets/pages_functions/Rules.svg": BCe,
      "../../../assets/pages_functions/Suggestions.svg": zCe,
      "../../../assets/pages_functions/Support.svg": ZCe,
      "../../../assets/pages_functions/Target.svg": WCe,
      "../../../assets/pages_functions/Uncomplete questionnaire.svg": UCe,
      "../../../assets/pages_functions/graph.svg": GCe,
      "../../../assets/pages_functions/waterfall graph.svg": qCe
    })).map(([h, g]) => {
      var m;
      return {
        name: ((m = h.split("/").pop()) == null ? void 0 : m.replace(".svg", "")) || "",
        path: g
      };
    }).sort((h, g) => h.name.localeCompare(g.name));
    r(p);
  }, []);
  const a = (u) => {
    n(u.currentTarget);
  }, c = () => {
    n(null);
  }, d = (u) => {
    e && e.chain().focus().setSvgIcon({ src: u }).run(), c();
  };
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(
      Lo,
      {
        onClick: a,
        size: "small",
        children: /* @__PURE__ */ f.jsx(h_, {})
      }
    ),
    /* @__PURE__ */ f.jsx(
      p2,
      {
        id: "icon-menu",
        anchorEl: t,
        open: i,
        onClose: c,
        elevation: 0,
        sx: {
          "& .MuiMenu-paper": {
            border: `1px solid ${s.palette.divider}`,
            borderRadius: s.spacing(1.5),
            boxShadow: s.custom.shadows.grey,
            maxHeight: s.spacing(40),
            overflow: "auto",
            padding: 0
          }
        },
        children: /* @__PURE__ */ f.jsx(P0, { sx: { padding: 0 }, children: o.length === 0 ? /* @__PURE__ */ f.jsx(Jo, { disabled: !0, children: /* @__PURE__ */ f.jsx(Bp, { children: "Loading icons..." }) }) : o.map((u) => /* @__PURE__ */ f.jsxs(
          Jo,
          {
            onClick: () => d(u.path),
            sx: { gap: 0, borderRadius: "0px" },
            children: [
              /* @__PURE__ */ f.jsx(r7, { children: /* @__PURE__ */ f.jsx(
                "img",
                {
                  src: u.path,
                  alt: u.name,
                  width: 24,
                  height: 24
                }
              ) }),
              /* @__PURE__ */ f.jsx(Bp, { children: /* @__PURE__ */ f.jsx(oe, { variant: "body-medium", fontSize: 14, children: u.name }) })
            ]
          },
          u.name
        )) })
      }
    )
  ] });
}
var J8 = {}, QCe = ht;
Object.defineProperty(J8, "__esModule", {
  value: !0
});
var g_ = J8.default = void 0, exe = QCe(bt()), txe = f;
g_ = J8.default = (0, exe.default)(/* @__PURE__ */ (0, txe.jsx)("path", {
  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2M8.5 13.5l2.5 3.01L14.5 12l4.5 6H5z"
}), "Image");
function nxe({ editor: e }) {
  const t = St(null), n = (r) => {
    var s;
    const i = (s = r.target.files) == null ? void 0 : s[0];
    if (i && e) {
      const a = new FileReader();
      a.onload = (c) => {
        var u;
        const d = (u = c.target) == null ? void 0 : u.result;
        d && e.chain().focus().setImage({ src: d }).run();
      }, a.readAsDataURL(i);
    }
    r.target.value = "";
  }, o = () => {
    var r;
    (r = t.current) == null || r.click();
  };
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(
      Lo,
      {
        onClick: o,
        size: "small",
        children: /* @__PURE__ */ f.jsx(g_, {})
      }
    ),
    /* @__PURE__ */ f.jsx(
      "input",
      {
        type: "file",
        ref: t,
        style: { display: "none" },
        accept: "image/*",
        onChange: n
      }
    )
  ] });
}
const Bs = {
  TITLE: "Insert link:",
  CANCEL: "Cancel",
  INSERT: "Insert",
  UPDATE: "Update",
  URL_LABEL: "URL",
  URL_PLACEHOLDER: "https://example.com",
  TEXT_LABEL: "Text",
  TEXT_PLACEHOLDER: "Link text"
}, My = (e) => {
  let t = e.trim();
  if (!t)
    return { isValid: !1, parsedUrl: t };
  const n = /\.pdf$/i.test(t);
  !/^(?:f|ht)tps?:\/\//i.test(t) && !t.startsWith("file://") && (t = `http://${t}`);
  const o = /^(https?:\/\/|file:\/\/)(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9@:%_+~#?&//=.]*)$/;
  return n && !o.test(t) ? {
    isValid: /^(https?:\/\/|file:\/\/).+\.pdf$/i.test(t),
    parsedUrl: t
  } : {
    isValid: o.test(t),
    parsedUrl: t
  };
}, oxe = (e) => {
  const t = ge(), { editor: n, open: o, onClose: r } = e, [i, s] = Ae(""), [a, c] = Ae(""), [d, u] = Ae("");
  mt(() => {
    if (o) {
      const m = n.state.doc.textBetween(
        n.state.selection.from,
        n.state.selection.to,
        " "
      );
      c(m || ""), s(""), u("");
    }
  }, [o, n]);
  const p = (m) => {
    if (!m) {
      u("");
      return;
    }
    const { isValid: b } = My(m);
    u(b ? "" : "Please enter a valid URL");
  }, h = (m) => {
    const b = m.target.value;
    s(b), p(b);
  }, g = () => {
    if (a && i)
      try {
        const { isValid: m, parsedUrl: b } = My(i);
        if (!m) {
          u("Please enter a valid URL");
          return;
        }
        const C = `<a href="${b}">${a}</a> `;
        n.commands.deleteSelection(), n.commands.insertContent(C), n.commands.focus();
      } catch (m) {
        console.error("Error inserting link:", m);
      }
    r();
  };
  return /* @__PURE__ */ f.jsxs(
    d2,
    {
      open: o,
      onClose: r,
      maxWidth: "sm",
      fullWidth: !0,
      sx: {
        "& .MuiDialog-paper": {
          borderRadius: t.spacing(1.5),
          border: `1px solid ${t.palette.divider}`,
          boxShadow: "none"
        }
      },
      children: [
        /* @__PURE__ */ f.jsx(_0, { children: /* @__PURE__ */ f.jsx(oe, { variant: "body-medium", fontSize: t.spacing(2), children: Bs.TITLE }) }),
        /* @__PURE__ */ f.jsx(Y4, { children: /* @__PURE__ */ f.jsx(J, { children: /* @__PURE__ */ f.jsxs(be, { spacing: t.spacing(2), sx: { pt: t.spacing(2) }, children: [
          /* @__PURE__ */ f.jsx(
            Ir,
            {
              label: Bs.TEXT_LABEL,
              type: "text",
              fullWidth: !0,
              variant: "outlined",
              value: a,
              onChange: (m) => c(m.target.value),
              placeholder: Bs.TEXT_PLACEHOLDER
            }
          ),
          /* @__PURE__ */ f.jsx(
            Ir,
            {
              label: Bs.URL_LABEL,
              type: "url",
              fullWidth: !0,
              variant: "outlined",
              value: i,
              onChange: h,
              placeholder: Bs.URL_PLACEHOLDER,
              error: !!d,
              helperText: d,
              InputProps: {
                onKeyDown: (m) => {
                  m.key === "Enter" && (m.preventDefault(), g());
                }
              }
            }
          )
        ] }) }) }),
        /* @__PURE__ */ f.jsxs(k3, { sx: { p: t.spacing(2) }, children: [
          /* @__PURE__ */ f.jsx(at, { onClick: r, variant: "ternary", children: /* @__PURE__ */ f.jsx(oe, { variant: "button", children: Bs.CANCEL }) }),
          /* @__PURE__ */ f.jsx(
            at,
            {
              onClick: g,
              variant: "validate",
              color: "primary",
              disabled: !a || !i || !!d,
              children: /* @__PURE__ */ f.jsx(oe, { variant: "button", children: Bs.INSERT })
            }
          )
        ] })
      ]
    }
  );
};
function rxe({ editor: e }) {
  const [t, n] = Ae(!1);
  return e ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(
      oxe,
      {
        editor: e,
        open: t,
        onClose: () => {
          n(!1);
        }
      }
    ),
    /* @__PURE__ */ f.jsx(
      Lo,
      {
        onClick: () => n(!0),
        variant: "text",
        size: "small",
        children: /* @__PURE__ */ f.jsx(gK, { fontSize: "small" })
      }
    )
  ] }) : null;
}
function ixe({ editor: e }) {
  const t = ge();
  if (!e)
    return null;
  const n = () => /* @__PURE__ */ f.jsx(
    ho,
    {
      orientation: "vertical",
      variant: "middle",
      flexItem: !0
    }
  );
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(J, { sx: {
      p: 0,
      display: "flex",
      flexDirection: "column",
      overflowX: "auto",
      overflowY: "hidden",
      backgroundColor: t.custom.grey[400]
    }, children: /* @__PURE__ */ f.jsxs(
      be,
      {
        direction: "row",
        spacing: t.spacing(1),
        borderRadius: t.spacing(1),
        alignItems: "center",
        children: [
          /* @__PURE__ */ f.jsx(cme, { editor: e }),
          /* @__PURE__ */ f.jsx(n, {}),
          /* @__PURE__ */ f.jsx(Jge, { editor: e }),
          /* @__PURE__ */ f.jsx(n, {}),
          /* @__PURE__ */ f.jsx(rxe, { editor: e }),
          /* @__PURE__ */ f.jsx(n, {}),
          /* @__PURE__ */ f.jsx(lme, { editor: e }),
          /* @__PURE__ */ f.jsx(n, {}),
          /* @__PURE__ */ f.jsx(dme, { editor: e }),
          /* @__PURE__ */ f.jsx(n, {}),
          /* @__PURE__ */ f.jsx(JCe, { editor: e }),
          /* @__PURE__ */ f.jsx(nxe, { editor: e })
        ]
      }
    ) }),
    /* @__PURE__ */ f.jsx(ho, { sx: { p: 0, m: 0, width: "100%" } })
  ] });
}
const sxe = B(J)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  border: `1px solid ${e.palette.divider}`,
  borderRadius: e.spacing(1.2),
  background: e.palette.background.paper,
  overflow: "hidden"
})), axe = B(khe)(({ theme: e }) => ({
  ".ProseMirror": {
    padding: e.spacing(2),
    minHeight: 150,
    outline: "none",
    "&:focus": {
      outline: "none"
    },
    "p.is-editor-empty:first-of-type::before": {
      color: e.palette.text.disabled,
      content: "attr(data-placeholder)",
      float: "left",
      height: 0,
      pointerEvents: "none"
    },
    "h1, h2, h3, h4, h5, h6": {
      margin: e.spacing(co.SPACING.HEADING_MARGIN),
      fontWeight: e.typography.fontWeightBold
    },
    [co.HEADING.H1]: { fontSize: e.typography.h1.fontSize },
    [co.HEADING.H2]: { fontSize: e.typography.h2.fontSize },
    [co.HEADING.H3]: { fontSize: e.typography.h3.fontSize },
    [co.HEADING.H4]: { fontSize: e.typography.h4.fontSize },
    [co.HEADING.H5]: { fontSize: e.typography.h5.fontSize },
    [co.HEADING.H6]: { fontSize: e.typography.h6.fontSize },
    p: {
      margin: e.spacing(co.SPACING.PARAGRAPH_MARGIN)
    },
    "ul, ol": {
      paddingLeft: e.spacing(co.SPACING.LIST_PADDING)
    },
    "& span.label": {
      border: `1px solid ${e.custom.grey[500]}`,
      background: e.custom.grey[200],
      borderRadius: e.spacing(0.75),
      padding: e.spacing(0.5, 1),
      margin: e.spacing(0.5)
    },
    hr: {
      backgroundColor: e.custom.grey[500],
      height: 1,
      width: `calc(100% + ${e.spacing(4)})`,
      color: "transparent",
      border: "none",
      marginLeft: e.spacing(-2)
    },
    a: {
      color: e.palette.primary.main,
      "&:hover": {
        textDecoration: "underline"
      }
    }
  }
})), lxe = mo.create({
  name: "svgIcon",
  addOptions() {
    return {
      HTMLAttributes: {
        class: "inline-svg-icon"
      }
    };
  },
  group: "inline",
  inline: !0,
  draggable: !0,
  selectable: !0,
  atom: !0,
  addAttributes() {
    return {
      src: {
        default: null,
        parseHTML: (e) => e.getAttribute("src"),
        renderHTML: (e) => e.src ? { src: e.src } : {}
      },
      color: {
        default: "currentColor",
        parseHTML: (e) => e.getAttribute("data-color"),
        renderHTML: (e) => e.color ? { "data-color": e.color } : {}
      },
      filter: {
        default: "",
        parseHTML: (e) => e.getAttribute("data-filter"),
        renderHTML: (e) => e.filter ? { "data-filter": e.filter } : {}
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "img.inline-svg-icon"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["img", _n(
      this.options.HTMLAttributes,
      {
        class: "inline-svg-icon",
        style: "height: 1em; vertical-align: text-bottom; display: inline-block; cursor: pointer; user-select: all;",
        contenteditable: "false"
      },
      e
    )];
  },
  addCommands() {
    return {
      setSvgIcon: (e) => ({ commands: t }) => t.insertContent({
        type: this.name,
        attrs: e
      })
    };
  }
}), cxe = Sr.create({
  name: "label",
  priority: 1e3,
  inclusive: !0,
  excludes: "",
  addOptions() {
    return {
      HTMLAttributes: {
        class: "label"
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "span.label"
      }
    ];
  },
  renderHTML() {
    return ["span", { class: "label" }, 0];
  },
  addCommands() {
    return {
      setLabel: () => ({ commands: e }) => e.setMark(this.name),
      toggleLabel: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetLabel: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleLabel()
    };
  }
}), dxe = (e) => ({
  "& .label": {
    border: `1px solid ${e.custom.grey[500]}`,
    background: e.custom.grey[200],
    borderRadius: e.spacing(0.75),
    padding: e.spacing(0.5, 1),
    margin: e.spacing(0.5)
  },
  "& a": {
    color: e.palette.primary.main,
    "&:hover": {
      textDecoration: "underline"
    }
  },
  "& .inline-svg-icon": {
    height: "1em",
    verticalAlign: "text-bottom",
    display: "inline-block",
    color: "attr(data-color)",
    userSelect: "all"
  },
  "& div": {
    whiteSpace: "pre-wrap",
    wordWrap: "break-word"
  },
  "& hr": {
    color: e.custom.grey[500]
  }
}), uxe = ({ editor: e, displayOutput: t }) => {
  const n = ge(), o = St(null), r = e.getHTML();
  return mt(() => {
    if (!t || !o.current) return;
    o.current.querySelectorAll(".inline-svg-icon").forEach((s) => {
      const a = s.getAttribute("data-filter"), c = s.getAttribute("data-color");
      a && s instanceof HTMLElement && (s.style.filter = a, s.style.color = c || "currentColor");
    });
  }, [t, r]), t ? /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx(J, { children: !e.isEmpty && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(ho, {}),
    /* @__PURE__ */ f.jsxs(J, { p: 2, sx: dxe(n), children: [
      /* @__PURE__ */ f.jsx(hs, { label: "Output", size: "small", sx: { px: 1 } }),
      /* @__PURE__ */ f.jsx(
        "div",
        {
          ref: o,
          dangerouslySetInnerHTML: { __html: r }
        }
      )
    ] })
  ] }) }) }) : /* @__PURE__ */ f.jsx(f.Fragment, {});
}, Yye = ({
  onChange: e,
  displayOutput: t = !1,
  placeholder: n = "",
  initialContent: o = "",
  value: r = ""
}) => {
  const i = Ahe({
    extensions: [
      F8e,
      N8e.configure({
        types: ["heading", "paragraph"]
      }),
      B8e,
      z8e,
      Z8e,
      C9e,
      b9e.configure({
        types: ["textStyle"]
      }),
      x9e.configure({
        types: ["textStyle"]
      }),
      y9e.configure({
        types: ["textStyle"]
      }),
      lxe,
      cxe,
      W8e.configure({
        placeholder: n
      }),
      m9e.configure({
        openOnClick: !1,
        linkOnPaste: !0,
        autolink: !0,
        HTMLAttributes: {
          rel: "noopener noreferrer nofollow",
          target: "_blank"
        },
        validate: (s) => !!s
      }),
      G8e.configure({
        inline: !0
      }),
      zO
    ],
    content: o,
    onUpdate: ({ editor: s }) => {
      e == null || e(s.getHTML());
    }
  });
  return mt(() => {
    if (!i) return;
    const s = () => {
      i.isActive("link") && i.getAttributes("link").href === "" && i.commands.unsetLink();
    }, a = (d) => {
      (d.key === "Backspace" || d.key === "Delete") && setTimeout(s, 10);
    }, c = i.view.dom;
    return c.addEventListener("keydown", a), () => {
      c.removeEventListener("keydown", a);
    };
  }, [i]), i ? /* @__PURE__ */ f.jsxs(sxe, { children: [
    /* @__PURE__ */ f.jsx(ixe, { editor: i }),
    /* @__PURE__ */ f.jsx(axe, { editor: i, value: r }),
    /* @__PURE__ */ f.jsx(uxe, { editor: i, displayOutput: t })
  ] }) : null;
};
export {
  bxe as AccordionProduct,
  xxe as AdditionalContentBox,
  g7 as AnchoredPopover,
  iC as Article,
  nye as ArticlesBox,
  p7 as Badge,
  Dxe as BigPopoverLayout,
  Tye as BlockItemContainer,
  U0 as BlockItemInner,
  Mye as BlockListContainer,
  ofe as BoxStyled,
  UK as BredTheme,
  $w as BredThemeOptions,
  at as Button,
  zye as ButtonTabs,
  jxe as CardImage,
  yxe as CategoryBox,
  Rye as CheckboxBlock,
  zw as CollectiveTheme,
  Bw as CollectiveThemeOptions,
  FK as ComingSoonBadge,
  Kw as ComparisonBlock,
  zK as ContextualContentBox,
  Hxe as CoordinatePopover,
  Nw as CustomToggleButton,
  JK as CustomToggleButtonNodeTitle,
  iye as CustomTypography,
  $ye as DefaultUserAction,
  vxe as DottedBox,
  Wxe as DoughnutChart,
  yye as EcoScoreCell,
  Aye as EditHeader,
  kye as EmptyForm,
  Gxe as EvolutionChart,
  fye as FixedMultiValueFilter,
  GK as FoodPilotTheme,
  Zw as FoodpilotThemeOptions,
  V0 as FoodsBadge,
  Bre as FoodsCheckbox,
  bye as FoodsFormBase,
  _t as FoodsIcon,
  nY as FoodsIconButton,
  Pw as FoodsIllustrations,
  Nye as FoodsNavbar,
  u3e as FoodsRadioList,
  w3e as FoodsSearch,
  O3e as FoodsSelect,
  Iye as FoodsSelectServerPagination,
  Vre as FoodsTags,
  Cye as FoodsTextInput,
  _xe as FoodsThemeOptionsProvider,
  Oxe as FoodsThemeProvider,
  Ixe as FoodsToggleButton,
  Ma as FoodsTooltip,
  Kye as FoodsTreeview,
  Yxe as FoodsUserTags,
  mxe as FormAccordion,
  hye as FormBase,
  Cie as FormBaseContextProvider,
  gye as FormBox,
  mye as FormPropertyBox,
  fie as FormTopBar,
  u7 as FormUnit,
  Cxe as GenericAccordion,
  vye as GreyTextCell,
  V3e as HeaderNav,
  Cm as HeadlessPopover,
  WK as HelperBox,
  tye as HeroBlock,
  Kxe as HorizontalGaugeChart,
  uie as IconThread,
  oye as IndicatorBlock,
  wxe as InfoBox,
  Sye as InfoHeaderWithIllustration,
  Hye as InitHeader,
  n3e as LeftComparisonPart,
  rye as LightIndicatorBlock,
  Sxe as LineGroupBox,
  _3e as LinearProgress,
  Dye as ListHeader,
  xye as MRTGrid,
  pye as MultiValueFilter,
  w5 as NavBarLink,
  Fye as Navbar,
  lye as NumberField,
  ms as NumberWithUnit,
  Oye as NumericalBlock,
  MY as OptionsPopover,
  wye as PointsCell,
  Jxe as PrimaryCheckbox,
  aye as PrimaryDialog,
  Mxe as QuoteBox,
  Lye as RadioBlock,
  Pye as RadioBoolean,
  _ye as RadioList,
  Yye as RichTextEditor,
  N0 as RoundInput,
  cye as RoundNumberInput,
  Uxe as ScatterPlot,
  gxe as Score,
  Fxe as ScoreCard,
  _Y as ScoreCardHeader,
  NK as ScoreContainer,
  dye as SearchBox,
  Wye as SecondaryTabs,
  Txe as SectionBox,
  Zye as SectionTabs,
  Nxe as SeeMoreCard,
  jye as SelectBlock,
  kxe as SolidGreyBox,
  Bye as SsqCard,
  rK as StyledAccordion,
  Kq as StyledFormAccordion,
  Xq as StyledFormAccordionDetails,
  Yq as StyledFormAccordionSummary,
  j3e as SubMenu,
  Eye as SuggestionBlock,
  Rxe as TertiaryToggleButton,
  Lxe as TertiaryToggleButtonNodeTitle,
  Uye as TextArrowList,
  Vye as TextBlock,
  uye as TextField,
  WM as TextTitle,
  Gye as TextTitleGreyIcon,
  qye as Textarea,
  wY as ThemedPopover,
  Vxe as TrajectoryCards,
  Xxe as TrajectoryChart,
  oe as Typography,
  sye as TypographyList,
  D3e as UserNav,
  NC as ValueDisplay,
  tS as ValueSwitcher,
  Exe as WarningBox,
  qxe as WaterfallChart,
  Hr as WhiteBox,
  F3 as WhitePopover,
  Axe as WhitePopoverOnIcon,
  qK as WinePilotTheme,
  Ww as WinepilotThemeOptions,
  jw as allColors,
  oK as allMainColors,
  eye as anyToCheckbox,
  Qxe as checkboxToAny,
  V3 as components,
  _w as computeSize,
  H3 as custom,
  Lw as dataVisualizationColors,
  Iw as extraColors,
  Qq as greenTheme,
  Ee as greyTheme,
  Tq as iconMapping,
  qq as illustationsMapping,
  Pxe as isTheme,
  eK as orangeTheme,
  Qo as redTheme,
  nK as shadows,
  A3 as spacing,
  XK as themeOptions,
  YK as themes,
  D3 as typographyConfig,
  m2 as useFormBaseContext,
  tK as yellowTheme
};
